import * as Apollo from "@apollo/client";
import { gql } from "@apollo/client";
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
const defaultOptions = {};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. BigInt can represent values between -(2^53) + 1 and 2^53 - 1. */
  BigInt: any;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** The DateTime scalar type represents date time strings complying to ISO-8601. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};

export type AccountingGetter = {
  __typename?: "AccountingGetter";
  getDealerReports?: Maybe<GetDealerReportsList>;
  getReportsStatistics?: Maybe<GetReportsStatistics>;
  getPeriods?: Maybe<GetPeriodsListList>;
  getPeriod?: Maybe<ReportPeriod>;
  getDealerReport?: Maybe<DealerReport>;
  getFileDealerReport?: Maybe<ReportFile>;
  getFileDealerMonitoring?: Maybe<ReportFile>;
  getFileDealerConditions?: Maybe<ReportFile>;
  getFileReportFileColumns?: Maybe<ReportFile>;
};

export type AccountingGetterGetDealerReportsArgs = {
  DealerId?: Maybe<Scalars["ID"]>;
  ReportPeriodId?: Maybe<Scalars["ID"]>;
  status?: Maybe<DealerReportStatus>;
  dealerName?: Maybe<Scalars["String"]>;
  sortBy?: Maybe<GetDealerReportsSort>;
  sortType?: Maybe<SortType>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

export type AccountingGetterGetReportsStatisticsArgs = {
  ReportPeriodId: Scalars["ID"];
};

export type AccountingGetterGetPeriodsArgs = {
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

export type AccountingGetterGetPeriodArgs = {
  Year: Scalars["Int"];
  Quarter: Scalars["Int"];
};

export type AccountingGetterGetDealerReportArgs = {
  ReportId: Scalars["ID"];
};

export type AccountingGetterGetFileDealerReportArgs = {
  DealerId: Scalars["ID"];
  repType?: Maybe<GetFileDealerReportRepType>;
  firstPartPeriodId?: Maybe<Scalars["ID"]>;
  secondPartPeriodId?: Maybe<Scalars["ID"]>;
};

export type AccountingGetterGetFileDealerMonitoringArgs = {
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  toYear?: Maybe<Scalars["Int"]>;
  fromYear?: Maybe<Scalars["Int"]>;
  fromQuarter?: Maybe<Scalars["Int"]>;
  toQuarter?: Maybe<Scalars["Int"]>;
};

export type AccountingGetterGetFileDealerConditionsArgs = {
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  toYear?: Maybe<Scalars["Int"]>;
  fromYear?: Maybe<Scalars["Int"]>;
  fromQuarter?: Maybe<Scalars["Int"]>;
  toQuarter?: Maybe<Scalars["Int"]>;
};

export type AccountingGetterGetFileReportFileColumnsArgs = {
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  columns?: Maybe<Array<Maybe<AccountingReportColumn>>>;
  PeriodId?: Maybe<Scalars["ID"]>;
};

export enum AccountingReportColumn {
  MtExMa = "_MTExMA__",
  MtEyMa = "_MTEyMA__",
  MtEzMa = "_MTEzMA__",
  Mte0Ma = "_MTE0MA__",
  Mte1Ma = "_MTE1MA__",
  Mte1Mq = "_MTE1MQ__",
  Mte1Ms8x = "_MTE1MS8x",
  Mte1Ms8y = "_MTE1MS8y",
  Mte1Mg = "_MTE1Mg__",
  Mte1Mi8x = "_MTE1Mi8x",
  Mte1Mi8y = "_MTE1Mi8y",
  Mte1Mw = "_MTE1Mw__",
  Mte1My8x = "_MTE1My8x",
  Mte1My8y = "_MTE1My8y",
  Mte1Na = "_MTE1NA__",
  Mte1Nc8x = "_MTE1NC8x",
  Mte1Nc8y = "_MTE1NC8y",
  Mte2Ma = "_MTE2MA__",
  Mte3Ma = "_MTE3MA__",
  Mte3Mq = "_MTE3MQ__",
  Mte4Ma = "_MTE4MA__",
  Mte5Ma = "_MTE5MA__",
  Mte5Mq = "_MTE5MQ__",
  MtEwMa = "_MTEwMA__",
  MtIxMa = "_MTIxMA__",
  MtIxMq = "_MTIxMQ__",
  MtIxMg = "_MTIxMg__",
  MtIxMw = "_MTIxMw__",
  MtIxNa = "_MTIxNA__",
  MtIyMa = "_MTIyMA__",
  MtIzMa = "_MTIzMA__",
  MtIzMq = "_MTIzMQ__",
  MtIzMg = "_MTIzMg__",
  MtIzMw = "_MTIzMw__",
  MtIzNa = "_MTIzNA__",
  Mti0Ma = "_MTI0MA__",
  Mti1Ma = "_MTI1MA__",
  Mti2Ma = "_MTI2MA__",
  MtIwMa = "_MTIwMA__",
  MtYwMa = "_MTYwMA__",
  MtMxMa = "_MTMxMA__",
  MtMyMa = "_MTMyMA__",
  Mtm0Ma = "_MTM0MA__",
  Mtm1Ma = "_MTM1MA__",
  Mtm2Ma = "_MTM2MA__",
  Mtm3Ma = "_MTM3MA__",
  MtMwMa = "_MTMwMA__",
  MtQxMa = "_MTQxMA__",
  MtQyMa = "_MTQyMA__",
  MtQzMa = "_MTQzMA__",
  Mtq1Ma = "_MTQ1MA__",
  MtQwMa = "_MTQwMA__",
  MtUxMa = "_MTUxMA__",
  MtUyMa = "_MTUyMA__",
  MtUyMq = "_MTUyMQ__",
  MtUyMg = "_MTUyMg__",
  MtUyMw = "_MTUyMw__",
  MtUzMa = "_MTUzMA__",
  Mtu0Ma = "_MTU0MA__",
  Mtu1Ma = "_MTU1MA__",
  MtUwMa = "_MTUwMA__",
  MjAwMa = "_MjAwMA__",
  MjExMa = "_MjExMA__",
  MjExMq = "_MjExMQ__",
  MjExMg = "_MjExMg__",
  MjExMw = "_MjExMw__",
  MjExNa = "_MjExNA__",
  MjExNq = "_MjExNQ__",
  MjExNg = "_MjExNg__",
  MjExNw = "_MjExNw__",
  MjExOa = "_MjExOA__",
  MjEyMa = "_MjEyMA__",
  MjEyMq = "_MjEyMQ__",
  MjEyMg = "_MjEyMg__",
  MjEyMw = "_MjEyMw__",
  MjEyNa = "_MjEyNA__",
  MjEyNq = "_MjEyNQ__",
  MjEyNg = "_MjEyNg__",
  MjEyNw = "_MjEyNw__",
  MjEwMa = "_MjEwMA__",
  MjIxMa = "_MjIxMA__",
  MjIxMq = "_MjIxMQ__",
  MjIxMs8x = "_MjIxMS8x",
  MjIxMs8y = "_MjIxMS8y",
  MjIxMs8z = "_MjIxMS8z",
  MjIxMs80 = "_MjIxMS80",
  MjIxMs81 = "_MjIxMS81",
  MjIxMs82 = "_MjIxMS82",
  MjIxMs83 = "_MjIxMS83",
  MjIxMs84 = "_MjIxMS84",
  MjIxMg = "_MjIxMg__",
  MjIxMw = "_MjIxMw__",
  MjIyMa = "_MjIyMA__",
  MjIyMc8x = "_MjIyMC8x",
  MjIyMc8y = "_MjIyMC8y",
  MjIyMc8z = "_MjIyMC8z",
  MjIyMc80 = "_MjIyMC80",
  MjIyMc81 = "_MjIyMC81",
  MjIyMc82 = "_MjIyMC82",
  MjIyMc83 = "_MjIyMC83",
  MjIyMc84 = "_MjIyMC84",
  MjIyMc85 = "_MjIyMC85",
  MjIyMc8xMa = "_MjIyMC8xMA__",
  MjIyMc8xMq = "_MjIyMC8xMQ__",
  MjIwMa = "_MjIwMA__",
  MjMxMa = "_MjMxMA__",
  MjMyMa = "_MjMyMA__",
  MjMzMa = "_MjMzMA__",
  MjM0Ma = "_MjM0MA__",
  MjM0Mq = "_MjM0MQ__",
  MjM0Mg = "_MjM0Mg__",
  MjM0Mw = "_MjM0Mw__",
  MjM1Ma = "_MjM1MA__",
  MjMwMa = "_MjMwMA__",
  MjQxMa = "_MjQxMA__",
  MjQxMq = "_MjQxMQ__",
  MjQxMg = "_MjQxMg__",
  MjQ2Ma = "_MjQ2MA__",
  MjQwMa = "_MjQwMA__",
  MjUxMa = "_MjUxMA__",
  MjUyMa = "_MjUyMA__",
  MjUwMa = "_MjUwMA__",
  MjkxMa = "_MjkxMA__",
  MjkwMa = "_MjkwMA__",
}

export type AccountingSetter = {
  __typename?: "AccountingSetter";
  create?: Maybe<ReportPeriod>;
  changePeriod?: Maybe<ReportPeriod>;
  setDealerReport?: Maybe<DealerReport>;
  deletePeriod?: Maybe<Scalars["Boolean"]>;
};

export type AccountingSetterCreateArgs = {
  Year: Scalars["Int"];
  Quarter: Scalars["Int"];
  lastDate: Scalars["DateTime"];
  reportDate?: Maybe<Scalars["DateTime"]>;
};

export type AccountingSetterChangePeriodArgs = {
  PeriodId: Scalars["ID"];
  lastDate?: Maybe<Scalars["DateTime"]>;
  reportDate?: Maybe<Scalars["DateTime"]>;
};

export type AccountingSetterSetDealerReportArgs = {
  ReportId: Scalars["ID"];
  status?: Maybe<DealerReportStatus>;
  note?: Maybe<Scalars["String"]>;
  FileIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  _MTExMA__?: Maybe<Scalars["BigInt"]>;
  _MTEyMA__?: Maybe<Scalars["BigInt"]>;
  _MTEzMA__?: Maybe<Scalars["BigInt"]>;
  _MTE0MA__?: Maybe<Scalars["BigInt"]>;
  _MTE1MA__?: Maybe<Scalars["BigInt"]>;
  _MTE1MS8x?: Maybe<Scalars["BigInt"]>;
  _MTE1MS8y?: Maybe<Scalars["BigInt"]>;
  _MTE1Mi8x?: Maybe<Scalars["BigInt"]>;
  _MTE1Mi8y?: Maybe<Scalars["BigInt"]>;
  _MTE1My8x?: Maybe<Scalars["BigInt"]>;
  _MTE1My8y?: Maybe<Scalars["BigInt"]>;
  _MTE1NC8x?: Maybe<Scalars["BigInt"]>;
  _MTE1NC8y?: Maybe<Scalars["BigInt"]>;
  _MTE2MA__?: Maybe<Scalars["BigInt"]>;
  _MTE3MA__?: Maybe<Scalars["BigInt"]>;
  _MTE3MQ__?: Maybe<Scalars["BigInt"]>;
  _MTE4MA__?: Maybe<Scalars["BigInt"]>;
  _MTE5MA__?: Maybe<Scalars["BigInt"]>;
  _MTE5MQ__?: Maybe<Scalars["BigInt"]>;
  _MTIxMA__?: Maybe<Scalars["BigInt"]>;
  _MTIxMQ__?: Maybe<Scalars["BigInt"]>;
  _MTIxMg__?: Maybe<Scalars["BigInt"]>;
  _MTIxMw__?: Maybe<Scalars["BigInt"]>;
  _MTIxNA__?: Maybe<Scalars["BigInt"]>;
  _MTIyMA__?: Maybe<Scalars["BigInt"]>;
  _MTIzMA__?: Maybe<Scalars["BigInt"]>;
  _MTIzMQ__?: Maybe<Scalars["BigInt"]>;
  _MTIzMg__?: Maybe<Scalars["BigInt"]>;
  _MTIzMw__?: Maybe<Scalars["BigInt"]>;
  _MTIzNA__?: Maybe<Scalars["BigInt"]>;
  _MTI0MA__?: Maybe<Scalars["BigInt"]>;
  _MTI1MA__?: Maybe<Scalars["BigInt"]>;
  _MTI2MA__?: Maybe<Scalars["BigInt"]>;
  _MTMxMA__?: Maybe<Scalars["BigInt"]>;
  _MTMyMA__?: Maybe<Scalars["BigInt"]>;
  _MTM0MA__?: Maybe<Scalars["BigInt"]>;
  _MTM1MA__?: Maybe<Scalars["BigInt"]>;
  _MTM2MA__?: Maybe<Scalars["BigInt"]>;
  _MTM3MA__?: Maybe<Scalars["BigInt"]>;
  _MTQxMA__?: Maybe<Scalars["BigInt"]>;
  _MTQyMA__?: Maybe<Scalars["BigInt"]>;
  _MTQzMA__?: Maybe<Scalars["BigInt"]>;
  _MTQ1MA__?: Maybe<Scalars["BigInt"]>;
  _MTUxMA__?: Maybe<Scalars["BigInt"]>;
  _MTUyMA__?: Maybe<Scalars["BigInt"]>;
  _MTUyMQ__?: Maybe<Scalars["BigInt"]>;
  _MTUyMg__?: Maybe<Scalars["BigInt"]>;
  _MTUyMw__?: Maybe<Scalars["BigInt"]>;
  _MTUzMA__?: Maybe<Scalars["BigInt"]>;
  _MTU0MA__?: Maybe<Scalars["BigInt"]>;
  _MTU1MA__?: Maybe<Scalars["BigInt"]>;
  _MjExMQ__?: Maybe<Scalars["BigInt"]>;
  _MjExMg__?: Maybe<Scalars["BigInt"]>;
  _MjExMw__?: Maybe<Scalars["BigInt"]>;
  _MjExNA__?: Maybe<Scalars["BigInt"]>;
  _MjExNQ__?: Maybe<Scalars["BigInt"]>;
  _MjExNg__?: Maybe<Scalars["BigInt"]>;
  _MjExNw__?: Maybe<Scalars["BigInt"]>;
  _MjExOA__?: Maybe<Scalars["BigInt"]>;
  _MjEyMQ__?: Maybe<Scalars["BigInt"]>;
  _MjEyMg__?: Maybe<Scalars["BigInt"]>;
  _MjEyMw__?: Maybe<Scalars["BigInt"]>;
  _MjEyNA__?: Maybe<Scalars["BigInt"]>;
  _MjEyNQ__?: Maybe<Scalars["BigInt"]>;
  _MjEyNg__?: Maybe<Scalars["BigInt"]>;
  _MjEyNw__?: Maybe<Scalars["BigInt"]>;
  _MjIxMS8x?: Maybe<Scalars["BigInt"]>;
  _MjIxMS8y?: Maybe<Scalars["BigInt"]>;
  _MjIxMS8z?: Maybe<Scalars["BigInt"]>;
  _MjIxMS80?: Maybe<Scalars["BigInt"]>;
  _MjIxMS81?: Maybe<Scalars["BigInt"]>;
  _MjIxMS82?: Maybe<Scalars["BigInt"]>;
  _MjIxMS83?: Maybe<Scalars["BigInt"]>;
  _MjIxMS84?: Maybe<Scalars["BigInt"]>;
  _MjIxMg__?: Maybe<Scalars["BigInt"]>;
  _MjIxMw__?: Maybe<Scalars["BigInt"]>;
  _MjIyMC8x?: Maybe<Scalars["BigInt"]>;
  _MjIyMC8y?: Maybe<Scalars["BigInt"]>;
  _MjIyMC8z?: Maybe<Scalars["BigInt"]>;
  _MjIyMC80?: Maybe<Scalars["BigInt"]>;
  _MjIyMC81?: Maybe<Scalars["BigInt"]>;
  _MjIyMC82?: Maybe<Scalars["BigInt"]>;
  _MjIyMC83?: Maybe<Scalars["BigInt"]>;
  _MjIyMC84?: Maybe<Scalars["BigInt"]>;
  _MjIyMC85?: Maybe<Scalars["BigInt"]>;
  _MjIyMC8xMA__?: Maybe<Scalars["BigInt"]>;
  _MjIyMC8xMQ__?: Maybe<Scalars["BigInt"]>;
  _MjMxMA__?: Maybe<Scalars["BigInt"]>;
  _MjMyMA__?: Maybe<Scalars["BigInt"]>;
  _MjMzMA__?: Maybe<Scalars["BigInt"]>;
  _MjM0MA__?: Maybe<Scalars["BigInt"]>;
  _MjM0MQ__?: Maybe<Scalars["BigInt"]>;
  _MjM0Mg__?: Maybe<Scalars["BigInt"]>;
  _MjM0Mw__?: Maybe<Scalars["BigInt"]>;
  _MjM1MA__?: Maybe<Scalars["BigInt"]>;
  _MjQxMQ__?: Maybe<Scalars["BigInt"]>;
  _MjQxMg__?: Maybe<Scalars["BigInt"]>;
  _MjQ2MA__?: Maybe<Scalars["BigInt"]>;
  _MjUxMA__?: Maybe<Scalars["BigInt"]>;
  _MjUyMA__?: Maybe<Scalars["BigInt"]>;
  _MjUwMA__?: Maybe<Scalars["BigInt"]>;
  _MjkxMA__?: Maybe<Scalars["BigInt"]>;
  _MjkwMA__?: Maybe<Scalars["BigInt"]>;
};

export type AccountingSetterDeletePeriodArgs = {
  PeriodId: Scalars["ID"];
};

/** Данные для AfterSales */
export type AfterSales = {
  __typename?: "AfterSales";
  i300?: Maybe<Array<Maybe<IndicatorValue>>>;
  i301?: Maybe<Array<Maybe<IndicatorValue>>>;
  i302?: Maybe<Array<Maybe<IndicatorValue>>>;
  i303?: Maybe<Array<Maybe<IndicatorValue>>>;
  i400?: Maybe<Array<Maybe<IndicatorValue>>>;
  i401?: Maybe<Array<Maybe<IndicatorValue>>>;
  i502?: Maybe<Array<Maybe<IndicatorValue>>>;
};

export type Announcement = {
  __typename?: "Announcement";
  id?: Maybe<Scalars["ID"]>;
  importance?: Maybe<Scalars["String"]>;
  status?: Maybe<AnnouncementStatus>;
  date?: Maybe<Scalars["DateTime"]>;
  title?: Maybe<Scalars["String"]>;
  text?: Maybe<Scalars["String"]>;
  singedBy?: Maybe<Scalars["String"]>;
  canceledReason?: Maybe<Scalars["String"]>;
  SubdivisionId?: Maybe<Scalars["ID"]>;
  Documents?: Maybe<Array<Maybe<File>>>;
  createdBy?: Maybe<Scalars["ID"]>;
  createdByUser?: Maybe<Profile>;
  createdAt?: Maybe<Scalars["DateTime"]>;
};

export type AnnouncementGetter = {
  __typename?: "AnnouncementGetter";
  get?: Maybe<AnnouncementList>;
  getOne?: Maybe<Announcement>;
};

export type AnnouncementGetterGetArgs = {
  singedBy?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
  text?: Maybe<Scalars["String"]>;
  createdAtFrom?: Maybe<Scalars["DateTime"]>;
  createdAtTo?: Maybe<Scalars["DateTime"]>;
  importance?: Maybe<Scalars["String"]>;
  status?: Maybe<AnnouncementStatus>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

export type AnnouncementGetterGetOneArgs = {
  id: Scalars["ID"];
};

export type AnnouncementList = {
  __typename?: "AnnouncementList";
  items?: Maybe<Array<Maybe<Announcement>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type AnnouncementLog = {
  __typename?: "AnnouncementLog";
  id?: Maybe<Scalars["ID"]>;
  importance?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  date?: Maybe<Scalars["DateTime"]>;
  title?: Maybe<Scalars["String"]>;
  canceledReason?: Maybe<Scalars["String"]>;
  text?: Maybe<Scalars["String"]>;
  singedBy?: Maybe<Scalars["String"]>;
  SubdivisionId?: Maybe<Scalars["ID"]>;
  createdBy?: Maybe<Scalars["ID"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  Documents?: Maybe<Array<Maybe<File>>>;
};

export type AnnouncementSetter = {
  __typename?: "AnnouncementSetter";
  create?: Maybe<Announcement>;
  setStatus?: Maybe<Announcement>;
  edit?: Maybe<Announcement>;
};

export type AnnouncementSetterCreateArgs = {
  importance?: Maybe<Scalars["String"]>;
  date?: Maybe<Scalars["DateTime"]>;
  title: Scalars["String"];
  text: Scalars["String"];
  singedBy: Scalars["String"];
  SubdivisionId?: Maybe<Scalars["ID"]>;
  Documents?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

export type AnnouncementSetterSetStatusArgs = {
  id: Scalars["ID"];
  status?: Maybe<AnnouncementStatus>;
  canceledReason?: Maybe<Scalars["String"]>;
};

export type AnnouncementSetterEditArgs = {
  id: Scalars["ID"];
  importance?: Maybe<Scalars["String"]>;
  date?: Maybe<Scalars["DateTime"]>;
  title: Scalars["String"];
  text: Scalars["String"];
  singedBy: Scalars["String"];
  SubdivisionId?: Maybe<Scalars["ID"]>;
  Documents?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

export enum AnnouncementStatus {
  Draft = "draft",
  Active = "active",
  Revoked = "revoked",
  Renewed = "renewed",
  Canceled = "canceled",
}

export type ArchivePeriod = {
  __typename?: "ArchivePeriod";
  id: Scalars["ID"];
  isCreatedByUser: Scalars["Boolean"];
  dateStart: Scalars["DateTime"];
  dateEnd: Scalars["DateTime"];
  createdAt: Scalars["DateTime"];
};

export type AreaDealerBsaType = {
  __typename?: "AreaDealerBSAType";
  area?: Maybe<Scalars["String"]>;
  /** Все ли поля заполнены */
  filled?: Maybe<Scalars["Boolean"]>;
};

export type AreaDealerSaType = {
  __typename?: "AreaDealerSAType";
  area?: Maybe<Scalars["String"]>;
  /** Все ли поля заполнены */
  filled?: Maybe<Scalars["Boolean"]>;
};

export type AreaDealerStoaType = {
  __typename?: "AreaDealerSTOAType";
  area?: Maybe<Scalars["String"]>;
  /** Все ли поля заполнены */
  filled?: Maybe<Scalars["Boolean"]>;
};

export type AreaDealerTpType = {
  __typename?: "AreaDealerTPType";
  area?: Maybe<Scalars["String"]>;
  /** Все ли поля заполнены */
  filled?: Maybe<Scalars["Boolean"]>;
};

export type AreaDealerWaType = {
  __typename?: "AreaDealerWAType";
  area?: Maybe<Scalars["String"]>;
  /** Все ли поля заполнены */
  filled?: Maybe<Scalars["Boolean"]>;
};

export type Camera = {
  __typename?: "Camera";
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  cameraZoneId?: Maybe<Scalars["ID"]>;
  cameraUrl?: Maybe<Scalars["String"]>;
  dealerId?: Maybe<Scalars["ID"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  createdBy?: Maybe<Scalars["String"]>;
  updatedBy?: Maybe<Scalars["String"]>;
  CameraZone?: Maybe<CameraZone>;
  status?: Maybe<CameraStatus>;
};

export type CameraCheck = {
  __typename?: "CameraCheck";
  id?: Maybe<Scalars["ID"]>;
  cameraId?: Maybe<Scalars["ID"]>;
  status?: Maybe<CameraCheckStatus>;
  comments?: Maybe<Array<Maybe<Comment>>>;
  name?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  createdBy?: Maybe<Scalars["String"]>;
  updatedBy?: Maybe<Scalars["String"]>;
};

export type CameraCheckLog = {
  __typename?: "CameraCheckLog";
  id?: Maybe<Scalars["ID"]>;
  cameraId?: Maybe<Scalars["ID"]>;
  status?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  createdBy?: Maybe<Scalars["ID"]>;
  updatedBy?: Maybe<Scalars["ID"]>;
};

export enum CameraCheckStatus {
  NotVerified = "notVerified",
  Compliant = "compliant",
  NotCompliant = "notCompliant",
}

export type CameraChecksList = {
  __typename?: "CameraChecksList";
  items?: Maybe<Array<Maybe<CameraCheck>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type CameraGetter = {
  __typename?: "CameraGetter";
  getCameraChecks?: Maybe<CameraChecksList>;
  getCameraZones?: Maybe<CameraZonesList>;
  getCameraZone?: Maybe<CameraZone>;
  getCameraCheck?: Maybe<CameraCheck>;
  getCameras?: Maybe<CamerasList>;
  getCamera?: Maybe<Camera>;
  getCameraVideo?: Maybe<CameraVideo>;
};

export type CameraGetterGetCameraChecksArgs = {
  cameraId?: Maybe<Scalars["ID"]>;
  status?: Maybe<CameraCheckStatus>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

export type CameraGetterGetCameraZonesArgs = {
  dealerId?: Maybe<Scalars["ID"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

export type CameraGetterGetCameraZoneArgs = {
  id?: Maybe<Scalars["ID"]>;
};

export type CameraGetterGetCameraCheckArgs = {
  id?: Maybe<Scalars["ID"]>;
};

export type CameraGetterGetCamerasArgs = {
  dialerId?: Maybe<Scalars["ID"]>;
  cameraZoneId?: Maybe<Scalars["ID"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

export type CameraGetterGetCameraArgs = {
  id?: Maybe<Scalars["ID"]>;
};

export type CameraGetterGetCameraVideoArgs = {
  cameraId?: Maybe<Scalars["ID"]>;
};

export type CameraLog = {
  __typename?: "CameraLog";
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  cameraZoneId?: Maybe<Scalars["ID"]>;
  cameraUrl?: Maybe<Scalars["String"]>;
  dealerId?: Maybe<Scalars["ID"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  createdBy?: Maybe<Scalars["ID"]>;
  updatedBy?: Maybe<Scalars["ID"]>;
  CameraZone?: Maybe<Scalars["String"]>;
};

export type CameraSetter = {
  __typename?: "CameraSetter";
  createCameraZone?: Maybe<CameraZone>;
  createCameraCheck?: Maybe<CameraCheck>;
  addComment?: Maybe<Comment>;
  setCameraCheckStatus?: Maybe<CameraCheck>;
  deleteCameraZone?: Maybe<CameraZone>;
  createCamera?: Maybe<Camera>;
  deleteCamera?: Maybe<Camera>;
  editCamera?: Maybe<Camera>;
  editCameraZone?: Maybe<CameraZone>;
  closeCameraVideo?: Maybe<Scalars["Boolean"]>;
};

export type CameraSetterCreateCameraZoneArgs = {
  name?: Maybe<Scalars["String"]>;
};

export type CameraSetterCreateCameraCheckArgs = {
  cameraId?: Maybe<Scalars["ID"]>;
  comment?: Maybe<Scalars["String"]>;
  status?: Maybe<CameraCheckStatus>;
};

export type CameraSetterAddCommentArgs = {
  cameraCheckId?: Maybe<Scalars["ID"]>;
  comment?: Maybe<Scalars["String"]>;
};

export type CameraSetterSetCameraCheckStatusArgs = {
  cameraCheckId?: Maybe<Scalars["ID"]>;
  status?: Maybe<CameraCheckStatus>;
};

export type CameraSetterDeleteCameraZoneArgs = {
  id?: Maybe<Scalars["ID"]>;
};

export type CameraSetterCreateCameraArgs = {
  name?: Maybe<Scalars["String"]>;
  cameraZoneId?: Maybe<Scalars["ID"]>;
  cameraUrl?: Maybe<Scalars["String"]>;
  dealerId?: Maybe<Scalars["ID"]>;
};

export type CameraSetterDeleteCameraArgs = {
  id?: Maybe<Scalars["ID"]>;
};

export type CameraSetterEditCameraArgs = {
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  cameraZoneId?: Maybe<Scalars["ID"]>;
  cameraUrl?: Maybe<Scalars["String"]>;
  dealerId?: Maybe<Scalars["ID"]>;
};

export type CameraSetterEditCameraZoneArgs = {
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
};

export type CameraSetterCloseCameraVideoArgs = {
  pid?: Maybe<Scalars["ID"]>;
};

export enum CameraStatus {
  NotVerified = "notVerified",
  Compliant = "compliant",
  NotCompliant = "notCompliant",
}

export type CameraVideo = {
  __typename?: "CameraVideo";
  cameraId?: Maybe<Scalars["ID"]>;
  url?: Maybe<Scalars["String"]>;
  pid?: Maybe<Scalars["String"]>;
  port?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
};

export type CameraZone = {
  __typename?: "CameraZone";
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  createdBy?: Maybe<Scalars["String"]>;
  updatedBy?: Maybe<Scalars["String"]>;
};

export type CameraZoneLog = {
  __typename?: "CameraZoneLog";
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  createdBy?: Maybe<Scalars["ID"]>;
  updatedBy?: Maybe<Scalars["ID"]>;
};

export type CameraZonesList = {
  __typename?: "CameraZonesList";
  items?: Maybe<Array<Maybe<CameraZone>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type CamerasList = {
  __typename?: "CamerasList";
  items?: Maybe<Array<Maybe<Camera>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type Car = {
  __typename?: "Car";
  vin?: Maybe<Scalars["String"]>;
  /** model */
  collection?: Maybe<Scalars["String"]>;
  engine?: Maybe<Scalars["String"]>;
  eqFamilyCode?: Maybe<Scalars["String"]>;
  eqNumber?: Maybe<Scalars["String"]>;
  eqVariant?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** Возвращение автомобилей на ТО (свой) по месяцу контроля */
export type CarForAgoByMonth = {
  __typename?: "CarForAGOByMonth";
  dealer?: Maybe<Array<Maybe<DealerForAgoByMonth>>>;
  city?: Maybe<Array<Maybe<CityForAgoByMonth>>>;
  FO?: Maybe<Array<Maybe<FoForAgoByMonth>>>;
  country?: Maybe<Array<Maybe<CountryForAgoByMonth>>>;
  region?: Maybe<Array<Maybe<RegionForAgoByMonth>>>;
};

/** SRR3 по дилерам LADA за период */
export type CarForSrr3ByPeriod = {
  __typename?: "CarForSRR3ByPeriod";
  period?: Maybe<Scalars["String"]>;
  TO1?: Maybe<ToForSrr>;
  TO2?: Maybe<ToForSrr>;
  TO3?: Maybe<ToForSrr>;
  SRR?: Maybe<ToForSrr>;
};

/** SRR3 по дилерам GIBDD LADA за период */
export type CarForSrr3GibddByPeriod = {
  __typename?: "CarForSRR3GIBDDByPeriod";
  period?: Maybe<Scalars["String"]>;
  TO1?: Maybe<ToForServiceGibddByPeriod>;
  TO2?: Maybe<ToForServiceGibddByPeriod>;
  TO3?: Maybe<ToForServiceGibddByPeriod>;
  SRR?: Maybe<ToForServiceGibddByPeriod>;
};

/** SRR5 по дилерам LADA за период */
export type CarForSrr5ByPeriod = {
  __typename?: "CarForSRR5ByPeriod";
  period?: Maybe<Scalars["String"]>;
  TO1?: Maybe<ToForSrr>;
  TO2?: Maybe<ToForSrr>;
  TO3?: Maybe<ToForSrr>;
  TO4?: Maybe<ToForSrr>;
  TO5?: Maybe<ToForSrr>;
  SRR?: Maybe<ToForSrr>;
};

/** SRR5 по дилерам GIBDD LADA за период */
export type CarForSrr5GibddByPeriod = {
  __typename?: "CarForSRR5GIBDDByPeriod";
  period?: Maybe<Scalars["String"]>;
  TO1?: Maybe<ToForServiceGibddByPeriod>;
  TO2?: Maybe<ToForServiceGibddByPeriod>;
  TO3?: Maybe<ToForServiceGibddByPeriod>;
  TO4?: Maybe<ToForServiceGibddByPeriod>;
  TO5?: Maybe<ToForServiceGibddByPeriod>;
  SRR?: Maybe<ToForServiceGibddByPeriod>;
};

/** Машинозаезды по дилерам */
export type CarForServiceByDealer = {
  __typename?: "CarForServiceByDealer";
  dealer?: Maybe<Array<Maybe<DealerForServiceByDealer>>>;
  city?: Maybe<Array<Maybe<CityForServiceByDealer>>>;
  FO?: Maybe<Array<Maybe<FoForServiceByDealer>>>;
  country?: Maybe<Array<Maybe<CountryForServiceByDealer>>>;
  region?: Maybe<Array<Maybe<RegionForServiceByDealer>>>;
};

/** Возвращение автомобилей на ТО (свой) по месяцу контроля */
export type CarForServiceByMonth = {
  __typename?: "CarForServiceByMonth";
  dealer?: Maybe<Array<Maybe<DealerForServiceByMonth>>>;
  city?: Maybe<Array<Maybe<CityForServiceByMonth>>>;
  FO?: Maybe<Array<Maybe<FoForServiceByMonth>>>;
  country?: Maybe<Array<Maybe<CountryForServiceByMonth>>>;
  region?: Maybe<Array<Maybe<RegionForServiceByMonth>>>;
};

/** Возвращение автомобилей на ТО к дилерам LADA. Сводный отчет. */
export type CarForServiceByPeriodConsolidated = {
  __typename?: "CarForServiceByPeriodConsolidated";
  cars?: Maybe<CarsConsolidated>;
  client?: Maybe<ClientConsolidated>;
  dealer?: Maybe<DealerConsolidated>;
  TO0?: Maybe<ToConsolidated>;
  TO1?: Maybe<ToConsolidated>;
  TO2?: Maybe<ToConsolidated>;
  TO3?: Maybe<ToConsolidated>;
  TO4?: Maybe<ToConsolidated>;
  TO5?: Maybe<ToConsolidated>;
  TO6?: Maybe<ToConsolidated>;
  TO7?: Maybe<ToConsolidated>;
  TO8?: Maybe<ToConsolidated>;
};

/** Машинозаезды в динамике */
export type CarForServiceDynamics = {
  __typename?: "CarForServiceDynamics";
  data?: Maybe<Array<Maybe<DealerForServiceDynamics>>>;
};

/** Автомобили */
export type CarsConsolidated = {
  __typename?: "CarsConsolidated";
  vin?: Maybe<Scalars["String"]>;
  eqFamilyCode?: Maybe<Scalars["String"]>;
  eqNumber?: Maybe<Scalars["String"]>;
  eqVariant?: Maybe<Scalars["String"]>;
  familyCar?: Maybe<Scalars["String"]>;
  dateSales?: Maybe<Scalars["DateTime"]>;
};

/** Строки для отчета Среднесуточный пробег (семейство автомобиля-регион) */
export type CarsForAverageDailyMileageByMonth = {
  __typename?: "CarsForAverageDailyMileageByMonth";
  model?: Maybe<FamilyCar>;
  TO0?: Maybe<ToForAverageDailyMileageByMonth>;
  TO1?: Maybe<ToForAverageDailyMileageByMonth>;
  TO2?: Maybe<ToForAverageDailyMileageByMonth>;
  TO3?: Maybe<ToForAverageDailyMileageByMonth>;
  TO4?: Maybe<ToForAverageDailyMileageByMonth>;
  TO5?: Maybe<ToForAverageDailyMileageByMonth>;
  TO6?: Maybe<ToForAverageDailyMileageByMonth>;
  TO7?: Maybe<ToForAverageDailyMileageByMonth>;
  TO8?: Maybe<ToForAverageDailyMileageByMonth>;
};

/** Строки для отчета Возвращение автомобилей на ТО (семейство автомобиля - регион) */
export type CarsForServiceByMonth = {
  __typename?: "CarsForServiceByMonth";
  model?: Maybe<FamilyCar>;
  TO0?: Maybe<ToForServiceByMonthByCarModelRegion>;
  TO1?: Maybe<ToForServiceByMonthByCarModelRegion>;
  TO2?: Maybe<ToForServiceByMonthByCarModelRegion>;
  TO3?: Maybe<ToForServiceByMonthByCarModelRegion>;
  TO4?: Maybe<ToForServiceByMonthByCarModelRegion>;
  TO5?: Maybe<ToForServiceByMonthByCarModelRegion>;
  TO6?: Maybe<ToForServiceByMonthByCarModelRegion>;
  TO7?: Maybe<ToForServiceByMonthByCarModelRegion>;
  TO8?: Maybe<ToForServiceByMonthByCarModelRegion>;
};

/** Возвращение автомобилей на ТО (свой) по месяцу контроля */
export type CarsForServiceByMonthRegion = {
  __typename?: "CarsForServiceByMonthRegion";
  cars?: Maybe<Array<Maybe<CarsForServiceByMonth>>>;
  models?: Maybe<Array<Maybe<FamilyCar>>>;
};

/** Возвращение автомобилей на ТО к дилерам LADA. Сводный отчет. */
export type CarsForServiceByPeriodConsolidated = {
  __typename?: "CarsForServiceByPeriodConsolidated";
  sales?: Maybe<Array<Maybe<CarForServiceByPeriodConsolidated>>>;
};

/** Строка таблицы CatalogCurriculum */
export type CatalogCurriculum = {
  __typename?: "CatalogCurriculum";
  id?: Maybe<Scalars["ID"]>;
  GroupId?: Maybe<Scalars["ID"]>;
  LevelId?: Maybe<Scalars["ID"]>;
  CourseId?: Maybe<Scalars["ID"]>;
  Group?: Maybe<GroupCurriculum>;
  Level?: Maybe<LevelCurriculum>;
  Course?: Maybe<CourseCurriculum>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  /** С какого времени актуально */
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  /** До какого времени актуально */
  ActualTo?: Maybe<Scalars["DateTime"]>;
};

export type CheckList = {
  __typename?: "CheckList";
  id: Scalars["ID"];
  externalCode?: Maybe<Scalars["String"]>;
  isDeleted: Scalars["Boolean"];
  name: Scalars["String"];
  overdueTasks: Scalars["Int"];
  inWorkTasks: Scalars["Int"];
  completedTasks: Scalars["Int"];
  actualPoints: Scalars["Int"];
  maxPoints: Scalars["Int"];
  DealerAutoCRMID: Scalars["ID"];
  DepartmentId: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  actionPlanId: Scalars["ID"];
  actionPlanDate?: Maybe<Scalars["DateTime"]>;
  DealerName: Scalars["String"];
  Indicators?: Maybe<Array<CheckListIndicator>>;
  Comments?: Maybe<Array<CheckListComment>>;
};

export type CheckListComment = {
  __typename?: "CheckListComment";
  id: Scalars["ID"];
  text: Scalars["String"];
  author: Scalars["String"];
  createdAt: Scalars["DateTime"];
  CheckListId: Scalars["ID"];
};

export type CheckListCommentGetter = {
  __typename?: "CheckListCommentGetter";
  getCheckListComments: Array<Maybe<CheckListComment>>;
};

export type CheckListCommentGetterGetCheckListCommentsArgs = {
  CheckListId: Scalars["ID"];
};

export type CheckListCommentSetter = {
  __typename?: "CheckListCommentSetter";
  createCheckListComment: Ok;
};

export type CheckListCommentSetterCreateCheckListCommentArgs = {
  CheckListId: Scalars["ID"];
  text: Scalars["String"];
};

/** Получение данных о чек листах */
export type CheckListGetter = {
  __typename?: "CheckListGetter";
  /** Получение чек листов у дилера */
  getCheckLists: CheckListWithResultList;
  /** Получение чек листа дилера */
  getCheckList?: Maybe<CheckList>;
};

/** Получение данных о чек листах */
export type CheckListGetterGetCheckListsArgs = {
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Array<Maybe<SortInputType>>>;
  DealerAutoCRMID: Scalars["ID"];
  DepartmentIds?: Maybe<Array<Scalars["ID"]>>;
  isDeleted?: Scalars["Boolean"];
};

/** Получение данных о чек листах */
export type CheckListGetterGetCheckListArgs = {
  id: Scalars["ID"];
};

export type CheckListIndicator = {
  __typename?: "CheckListIndicator";
  name: Scalars["String"];
  actualPoints: Scalars["Int"];
  maxPoints: Scalars["Int"];
  CheckListId: Scalars["ID"];
};

/** Получение показателей чек листов */
export type CheckListIndicatorGetter = {
  __typename?: "CheckListIndicatorGetter";
  /** Получение всех показателей дилера, по не удаленным чек листам, в текущем квартале */
  getCheckListIndicatorStats?: Maybe<Array<Maybe<CheckListIndicatorStats>>>;
};

/** Получение показателей чек листов */
export type CheckListIndicatorGetterGetCheckListIndicatorStatsArgs = {
  DealerAutoCRMID: Scalars["ID"];
  DepartmentIds?: Maybe<Array<Scalars["ID"]>>;
};

export type CheckListIndicatorStats = {
  __typename?: "CheckListIndicatorStats";
  name: Scalars["String"];
  value: Scalars["Float"];
};

export type CheckListWithResult = {
  __typename?: "CheckListWithResult";
  id: Scalars["ID"];
  externalCode?: Maybe<Scalars["String"]>;
  isDeleted: Scalars["Boolean"];
  name: Scalars["String"];
  overdueTasks: Scalars["Int"];
  inWorkTasks: Scalars["Int"];
  completedTasks: Scalars["Int"];
  actualPoints: Scalars["Int"];
  maxPoints: Scalars["Int"];
  DealerAutoCRMID: Scalars["ID"];
  DepartmentId: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  actionPlanId: Scalars["ID"];
  actionPlanDate?: Maybe<Scalars["DateTime"]>;
  DealerName: Scalars["String"];
  Indicators?: Maybe<Array<CheckListIndicator>>;
  Comments?: Maybe<Array<CheckListComment>>;
  result: Scalars["Float"];
};

export type CheckListWithResultList = {
  __typename?: "CheckListWithResultList";
  total: Scalars["Int"];
  pages: Scalars["Int"];
  items: Array<Maybe<CheckListWithResult>>;
};

/** Город */
export type City = {
  __typename?: "City";
  name: Scalars["String"];
  dealers: Array<Maybe<ThreeDealer>>;
};

export type Client = {
  __typename?: "Client";
  type?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** Клиенты */
export type ClientConsolidated = {
  __typename?: "ClientConsolidated";
  name?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
};

/** Строки для отчета Клиенты не обращавшиеся на гарантийный ремонт */
export type ClientsWithoutService = {
  __typename?: "ClientsWithoutService";
  period?: Maybe<Scalars["String"]>;
  monthSale?: Maybe<Scalars["String"]>;
  countCar?: Maybe<Scalars["Int"]>;
  withoutServices?: Maybe<Scalars["Int"]>;
  percent?: Maybe<Scalars["Float"]>;
};

export type Comment = {
  __typename?: "Comment";
  id?: Maybe<Scalars["ID"]>;
  cameraCheckId?: Maybe<Scalars["ID"]>;
  comment?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  createdBy?: Maybe<Scalars["String"]>;
  fullName?: Maybe<Scalars["String"]>;
};

export type Consent = {
  fileId?: Maybe<Scalars["ID"]>;
  systemId?: Maybe<Scalars["ID"]>;
  personalInfoId?: Maybe<Scalars["ID"]>;
};

/** Шаблон договора */
export type ContractTemplate = {
  __typename?: "ContractTemplate";
  id: Scalars["ID"];
  name: Scalars["String"];
  active: Scalars["Boolean"];
  FileId: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
  File: File;
};

/** Поля, которые разрешено передавать для создания шаблона договора */
export type ContractTemplateAllowFields = {
  __typename?: "ContractTemplateAllowFields";
  field: Scalars["String"];
  comment: Scalars["String"];
};

export type ContractTemplateGetter = {
  __typename?: "ContractTemplateGetter";
  /** Получение всех шаблонов */
  getContractTemplates: ContractTemplateList;
  /** Получить поля, которые разрешено передавать для создания шаблона договора */
  getContractTemplateAllowFields?: Maybe<Array<ContractTemplateAllowFields>>;
};

export type ContractTemplateGetterGetContractTemplatesArgs = {
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Array<Maybe<SortInputType>>>;
  isActive?: Maybe<Scalars["Boolean"]>;
  search?: Maybe<Scalars["String"]>;
};

export type ContractTemplateList = {
  __typename?: "ContractTemplateList";
  total: Scalars["Int"];
  pages: Scalars["Int"];
  items: Array<Maybe<ContractTemplate>>;
};

export type ContractTemplateSetter = {
  __typename?: "ContractTemplateSetter";
  /** Создать шаблон договора */
  createContractTemplate?: Maybe<ContractTemplate>;
  /** Обновить шаблон договора */
  updateContractTemplate?: Maybe<ContractTemplate>;
};

export type ContractTemplateSetterCreateContractTemplateArgs = {
  name: Scalars["String"];
  active?: Maybe<Scalars["Boolean"]>;
  FileId: Scalars["String"];
};

export type ContractTemplateSetterUpdateContractTemplateArgs = {
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  FileId?: Maybe<Scalars["String"]>;
  active?: Maybe<Scalars["Boolean"]>;
};

export enum ContractType {
  Custom = "Custom",
  Contract = "Contract",
}

/** Строка таблицы CurriculumCourse */
export type CourseCurriculum = {
  __typename?: "CourseCurriculum";
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  /** Для миграции */
  codeIS?: Maybe<Scalars["String"]>;
  /** Срок сертификации в месяцах */
  certificateValidityPeriod?: Maybe<Scalars["ID"]>;
  LevelId?: Maybe<Scalars["ID"]>;
  status?: Maybe<CurriculumCourseStatus>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  Level?: Maybe<LevelCurriculum>;
  /** Определяет принадлежность к родителю */
  InstanceId?: Maybe<Scalars["ID"]>;
  /** С какого времени актуально */
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  /** До какого времени актуально */
  ActualTo?: Maybe<Scalars["DateTime"]>;
};

export enum CourseOrderBy {
  InstanceId = "InstanceId",
  Code = "code",
  CodeIs = "codeIS",
  CertificateValidityPeriod = "certificateValidityPeriod",
  Name = "name",
  Status = "status",
  LevelId = "LevelId",
  CreatedAt = "createdAt",
  UpdatedAt = "updatedAt",
  ActualFrom = "ActualFrom",
  ActualTo = "ActualTo",
  Recid = "recid",
}

export type CreateEmployee = {
  __typename?: "CreateEmployee";
  id?: Maybe<Scalars["ID"]>;
  surname?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  middleName?: Maybe<Scalars["String"]>;
  gender: GenderType;
  birthDay?: Maybe<Scalars["DateTime"]>;
  personalPhone?: Maybe<Scalars["String"]>;
  workPhone?: Maybe<Scalars["String"]>;
  DataConsent?: Maybe<File>;
  Photo?: Maybe<File>;
  photoId?: Maybe<Scalars["ID"]>;
  ResourcesControlUserId?: Maybe<Scalars["String"]>;
  HiredDate?: Maybe<Scalars["DateTime"]>;
  FiredDate?: Maybe<Scalars["DateTime"]>;
  ladaAcademiaId?: Maybe<Scalars["String"]>;
  Dealers?: Maybe<Array<Maybe<Dealer>>>;
  importDate?: Maybe<Scalars["DateTime"]>;
  /** Если тру, то создан. Если фолс, то сотрудник уже имеется и нужен редирект на страницу редактирования. */
  isCreated?: Maybe<Scalars["Boolean"]>;
};

export enum CurriculumCourseStatus {
  Active = "active",
  Inactive = "inactive",
}

export enum CurriculumGroupStatus {
  Active = "active",
  Inactive = "inactive",
}

export enum CurriculumGroupTypeEnum {
  Education = "EDUCATION",
  Certification = "CERTIFICATION",
}

export enum CurriculumLevelStatus {
  Active = "active",
  Inactive = "inactive",
}

export enum CurriculumPositionsStudyProgramsStatus {
  Active = "active",
  Inactive = "inactive",
}

export type CurriculumStudyProgramGroupPosition = {
  __typename?: "CurriculumStudyProgramGroupPosition";
  InstanceId?: Maybe<Scalars["ID"]>;
  PositionGroupId?: Maybe<Scalars["ID"]>;
  PositionId?: Maybe<Scalars["ID"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Position?: Maybe<Position>;
};

/** Строка таблицы CurriculumPositionsStudyPrograms */
export type CurriculumStudyPrograms = {
  __typename?: "CurriculumStudyPrograms";
  id?: Maybe<Scalars["ID"]>;
  PositionGroupId?: Maybe<Scalars["ID"]>;
  LevelId?: Maybe<Scalars["ID"]>;
  CourseId?: Maybe<Scalars["ID"]>;
  status?: Maybe<CurriculumPositionsStudyProgramsStatus>;
  dateActiveStatus?: Maybe<Scalars["DateTime"]>;
  dateInactiveStatus?: Maybe<Scalars["DateTime"]>;
  Positions?: Maybe<Array<Maybe<Position>>>;
  Level?: Maybe<LevelCurriculum>;
  Course?: Maybe<CourseCurriculum>;
  /** С какого времени актуально */
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  /** До какого времени актуально */
  ActualTo?: Maybe<Scalars["DateTime"]>;
};

/** дилер */
export type Dealer = {
  __typename?: "Dealer";
  PhotoDealerCenter?: Maybe<File>;
  PhotoOwner?: Maybe<File>;
  PhotoBoss?: Maybe<File>;
  ProjectDocumentation?: Maybe<DealerProjectDocumentation>;
  /** История прикрепления проектных документаций */
  ProjectDocumentations?: Maybe<Array<Maybe<DealerProjectDocumentation>>>;
  ScanOwnerPersonData?: Maybe<File>;
  ScanBossPersonData?: Maybe<File>;
  ScanLadaPersonData?: Maybe<File>;
  ScanAccountantPersonData?: Maybe<File>;
  Users?: Maybe<Array<Maybe<User>>>;
  HeadCompanyDealer?: Maybe<Dealer>;
  Contract?: Maybe<DealerContract>;
  Successor?: Maybe<Dealer>;
  ArchivePeriodId?: Maybe<Scalars["ID"]>;
  Period?: Maybe<ArchivePeriod>;
  Domains?: Maybe<Array<Maybe<DealerDomainType>>>;
  IsIvideonAuthorized?: Maybe<Scalars["Boolean"]>;
  Area?: Maybe<DealerArea>;
  id: Scalars["ID"];
  autoCRMID?: Maybe<Scalars["ID"]>;
  type?: Maybe<Scalars["String"]>;
  typeEn?: Maybe<Scalars["String"]>;
  ent_id?: Maybe<Scalars["ID"]>;
  DealerName?: Maybe<Scalars["String"]>;
  DealerNameEn?: Maybe<Scalars["String"]>;
  tradeDealerName?: Maybe<Scalars["String"]>;
  tradeDealerNameEn?: Maybe<Scalars["String"]>;
  legalDealerName?: Maybe<Scalars["String"]>;
  legalDealerNameEn?: Maybe<Scalars["String"]>;
  INN?: Maybe<Scalars["String"]>;
  KPP?: Maybe<Scalars["String"]>;
  ContractEndDate?: Maybe<Scalars["DateTime"]>;
  IS_Id?: Maybe<Scalars["String"]>;
  Main?: Maybe<Scalars["Int"]>;
  newDealer?: Maybe<Scalars["Int"]>;
  temporaryDecision?: Maybe<Scalars["Int"]>;
  protocolOfIntentions?: Maybe<Scalars["Int"]>;
  logicalType?: Maybe<Scalars["Int"]>;
  extendedForNextYear?: Maybe<Scalars["Int"]>;
  terminated?: Maybe<Scalars["Int"]>;
  hideOnLadaRu?: Maybe<Scalars["Int"]>;
  DealerLADASERV?: Maybe<Scalars["Int"]>;
  OGRN?: Maybe<Scalars["String"]>;
  termOfAuthority?: Maybe<Scalars["DateTime"]>;
  consumerCode?: Maybe<Scalars["String"]>;
  corporateEmail?: Maybe<Scalars["String"]>;
  EGR_Number?: Maybe<Scalars["String"]>;
  EGR_Series?: Maybe<Scalars["String"]>;
  EGR_Date?: Maybe<Scalars["DateTime"]>;
  settlementAccount?: Maybe<Scalars["String"]>;
  correspondentAccount?: Maybe<Scalars["String"]>;
  BIK?: Maybe<Scalars["String"]>;
  bankName?: Maybe<Scalars["String"]>;
  responsibleForLadaEmail?: Maybe<Scalars["String"]>;
  responsibleForLadaFax?: Maybe<Scalars["String"]>;
  responsibleForLadaPhone?: Maybe<Scalars["String"]>;
  responsibleForLadaCode?: Maybe<Scalars["String"]>;
  responsibleForLadaName?: Maybe<Scalars["String"]>;
  accountantEmail?: Maybe<Scalars["String"]>;
  accountantFax?: Maybe<Scalars["String"]>;
  accountantPhone?: Maybe<Scalars["String"]>;
  accountantCode?: Maybe<Scalars["String"]>;
  accountantName?: Maybe<Scalars["String"]>;
  protocolOfTermination?: Maybe<Scalars["String"]>;
  protocolOfConclusion?: Maybe<Scalars["String"]>;
  successorCode?: Maybe<Scalars["String"]>;
  entfCode?: Maybe<Scalars["String"]>;
  entfSuccessorNo?: Maybe<Scalars["String"]>;
  entfSuccessorCode?: Maybe<Scalars["String"]>;
  category?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  legalAddress?: Maybe<Scalars["String"]>;
  reestrLegalAddress?: Maybe<Scalars["String"]>;
  legalCityId?: Maybe<Scalars["Int"]>;
  legalHouseId?: Maybe<Scalars["Int"]>;
  postalAddress?: Maybe<Scalars["String"]>;
  reestrPostAddress?: Maybe<Scalars["String"]>;
  postalCityId?: Maybe<Scalars["Int"]>;
  postalHouseId?: Maybe<Scalars["Int"]>;
  address?: Maybe<Scalars["String"]>;
  reestrAddress?: Maybe<Scalars["String"]>;
  addressEn?: Maybe<Scalars["String"]>;
  regionCode?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  countryEn?: Maybe<Scalars["String"]>;
  FO?: Maybe<Scalars["String"]>;
  FOEn?: Maybe<Scalars["String"]>;
  subject?: Maybe<Scalars["String"]>;
  subjectEn?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  cityEn?: Maybe<Scalars["String"]>;
  CityId?: Maybe<Scalars["Int"]>;
  HouseId?: Maybe<Scalars["Int"]>;
  headFax?: Maybe<Scalars["String"]>;
  headCode?: Maybe<Scalars["String"]>;
  headNameGenitive?: Maybe<Scalars["String"]>;
  headPositionGenitive?: Maybe<Scalars["String"]>;
  headNameImported?: Maybe<Scalars["String"]>;
  headFullNameGenitive?: Maybe<Scalars["String"]>;
  headPositionImported?: Maybe<Scalars["String"]>;
  headEmailImported?: Maybe<Scalars["String"]>;
  headPhoneImported?: Maybe<Scalars["String"]>;
  EP?: Maybe<Scalars["String"]>;
  EPEn?: Maybe<Scalars["String"]>;
  headName?: Maybe<Scalars["String"]>;
  headNameEn?: Maybe<Scalars["String"]>;
  headPhone?: Maybe<Scalars["String"]>;
  headMobilePhone?: Maybe<Scalars["String"]>;
  headEmail?: Maybe<Scalars["String"]>;
  ownerName?: Maybe<Scalars["String"]>;
  ownerNameEn?: Maybe<Scalars["String"]>;
  ownerPhone?: Maybe<Scalars["String"]>;
  ownerMobilePhone?: Maybe<Scalars["String"]>;
  ownerEmail?: Maybe<Scalars["String"]>;
  birCode?: Maybe<Scalars["String"]>;
  beginWorkingDate?: Maybe<Scalars["DateTime"]>;
  ivideonSublicenseStartAt?: Maybe<Scalars["DateTime"]>;
  isIvideonActFormed: Scalars["Boolean"];
  contractId?: Maybe<Scalars["ID"]>;
  headCompanyId?: Maybe<Scalars["ID"]>;
  PhotoDealerCenterId?: Maybe<Scalars["ID"]>;
  PhotoOwnerId?: Maybe<Scalars["ID"]>;
  PhotoBossId?: Maybe<Scalars["ID"]>;
  ScanOwnerPersonDataId?: Maybe<Scalars["ID"]>;
  ScanBossPersonDataId?: Maybe<Scalars["ID"]>;
  ScanLadaPersonDataId?: Maybe<Scalars["ID"]>;
  ScanAccountantPersonDataId?: Maybe<Scalars["ID"]>;
  OrganizationalLegalForm?: Maybe<Scalars["String"]>;
  X_SHOP_FLAG?: Maybe<Scalars["Boolean"]>;
  X_STO_PHCODE?: Maybe<Scalars["String"]>;
  X_STO_PHONE?: Maybe<Scalars["String"]>;
  X_STO_EMAIL?: Maybe<Scalars["String"]>;
  X_SHOP_PHCODE?: Maybe<Scalars["String"]>;
  X_SHOP_PHONE?: Maybe<Scalars["String"]>;
  X_SHOP_EMAIL?: Maybe<Scalars["String"]>;
  X_SHOP_NAME?: Maybe<Scalars["String"]>;
  stoPhCode?: Maybe<Scalars["String"]>;
  stoPhone?: Maybe<Scalars["String"]>;
  stoEmail?: Maybe<Scalars["String"]>;
  shopPhCode?: Maybe<Scalars["String"]>;
  shopPhone?: Maybe<Scalars["String"]>;
  shopEmail?: Maybe<Scalars["String"]>;
  KGA_CODE?: Maybe<Scalars["String"]>;
  ONEC_CODE?: Maybe<Scalars["String"]>;
  autoCrmLastUpdate?: Maybe<Scalars["DateTime"]>;
  autoCrmDisabledAt?: Maybe<Scalars["String"]>;
  latitude?: Maybe<Scalars["String"]>;
  longitude?: Maybe<Scalars["String"]>;
  status?: Maybe<DealerStatus>;
  ProjectDocumentationId?: Maybe<Scalars["ID"]>;
  ladaBusiness?: Maybe<Scalars["Boolean"]>;
  ladaSport?: Maybe<Scalars["Boolean"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
};

/** Дилер и пользователь */
export type DealerAndUser = {
  __typename?: "DealerAndUser";
  UserId?: Maybe<Scalars["ID"]>;
  DealerId?: Maybe<Scalars["ID"]>;
};

export type DealerArea = {
  __typename?: "DealerArea";
  /** Площадь шоурума */
  SA?: Maybe<AreaDealerSaType>;
  /** Площадь сто */
  STOA?: Maybe<AreaDealerStoaType>;
  /** Площадь склада */
  WA?: Maybe<AreaDealerWaType>;
  /** Площадь цеха ВР */
  BSA?: Maybe<AreaDealerBsaType>;
  /** Площадь торговых площадей */
  TP?: Maybe<AreaDealerTpType>;
};

/** Дилеры */
export type DealerConsolidated = {
  __typename?: "DealerConsolidated";
  name?: Maybe<Scalars["String"]>;
  inn?: Maybe<Scalars["String"]>;
  dealerId?: Maybe<Scalars["ID"]>;
  city?: Maybe<Scalars["String"]>;
};

export type DealerContract = {
  __typename?: "DealerContract";
  DealerId: Scalars["ID"];
  ArchiveDealerId: Scalars["ID"];
  TemplateId: Scalars["ID"];
  number: Scalars["String"];
  date: Scalars["String"];
  createdAt: Scalars["DateTime"];
};

export type DealerContractTemplate = {
  __typename?: "DealerContractTemplate";
  id: Scalars["ID"];
  type: Scalars["String"];
  html: Scalars["String"];
  name: Scalars["String"];
  createdAt: Scalars["DateTime"];
};

export type DealerData = {
  __typename?: "DealerData";
  id?: Maybe<Scalars["ID"]>;
  autoCRMID?: Maybe<Scalars["ID"]>;
  type?: Maybe<Scalars["String"]>;
  typeEn?: Maybe<Scalars["String"]>;
  ent_id?: Maybe<Scalars["ID"]>;
  DealerName?: Maybe<Scalars["String"]>;
  DealerNameEn?: Maybe<Scalars["String"]>;
  tradeDealerName?: Maybe<Scalars["String"]>;
  tradeDealerNameEn?: Maybe<Scalars["String"]>;
  legalDealerName?: Maybe<Scalars["String"]>;
  legalDealerNameEn?: Maybe<Scalars["String"]>;
  INN?: Maybe<Scalars["String"]>;
  KPP?: Maybe<Scalars["String"]>;
  ContractEndDate?: Maybe<Scalars["DateTime"]>;
  IS_Id?: Maybe<Scalars["String"]>;
  Main?: Maybe<Scalars["Int"]>;
  newDealer?: Maybe<Scalars["Int"]>;
  temporaryDecision?: Maybe<Scalars["Int"]>;
  protocolOfIntentions?: Maybe<Scalars["Int"]>;
  logicalType?: Maybe<Scalars["Int"]>;
  extendedForNextYear?: Maybe<Scalars["Int"]>;
  terminated?: Maybe<Scalars["Int"]>;
  hideOnLadaRu?: Maybe<Scalars["Int"]>;
  DealerLADASERV?: Maybe<Scalars["Int"]>;
  OGRN?: Maybe<Scalars["String"]>;
  termOfAuthority?: Maybe<Scalars["DateTime"]>;
  consumerCode?: Maybe<Scalars["String"]>;
  corporateEmail?: Maybe<Scalars["String"]>;
  EGR_Number?: Maybe<Scalars["String"]>;
  EGR_Series?: Maybe<Scalars["String"]>;
  EGR_Date?: Maybe<Scalars["DateTime"]>;
  settlementAccount?: Maybe<Scalars["String"]>;
  correspondentAccount?: Maybe<Scalars["String"]>;
  BIK?: Maybe<Scalars["String"]>;
  bankName?: Maybe<Scalars["String"]>;
  responsibleForLadaEmail?: Maybe<Scalars["String"]>;
  responsibleForLadaFax?: Maybe<Scalars["String"]>;
  responsibleForLadaPhone?: Maybe<Scalars["String"]>;
  responsibleForLadaCode?: Maybe<Scalars["String"]>;
  responsibleForLadaName?: Maybe<Scalars["String"]>;
  accountantEmail?: Maybe<Scalars["String"]>;
  accountantFax?: Maybe<Scalars["String"]>;
  accountantPhone?: Maybe<Scalars["String"]>;
  accountantCode?: Maybe<Scalars["String"]>;
  accountantName?: Maybe<Scalars["String"]>;
  protocolOfTermination?: Maybe<Scalars["String"]>;
  protocolOfConclusion?: Maybe<Scalars["String"]>;
  successorCode?: Maybe<Scalars["String"]>;
  entfCode?: Maybe<Scalars["String"]>;
  entfSuccessorNo?: Maybe<Scalars["String"]>;
  entfSuccessorCode?: Maybe<Scalars["String"]>;
  category?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  legalAddress?: Maybe<Scalars["String"]>;
  reestrLegalAddress?: Maybe<Scalars["String"]>;
  legalCityId?: Maybe<Scalars["Int"]>;
  legalHouseId?: Maybe<Scalars["Int"]>;
  postalAddress?: Maybe<Scalars["String"]>;
  reestrPostAddress?: Maybe<Scalars["String"]>;
  postalCityId?: Maybe<Scalars["Int"]>;
  postalHouseId?: Maybe<Scalars["Int"]>;
  address?: Maybe<Scalars["String"]>;
  reestrAddress?: Maybe<Scalars["String"]>;
  addressEn?: Maybe<Scalars["String"]>;
  regionCode?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  countryEn?: Maybe<Scalars["String"]>;
  FO?: Maybe<Scalars["String"]>;
  FOEn?: Maybe<Scalars["String"]>;
  subject?: Maybe<Scalars["String"]>;
  subjectEn?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  cityEn?: Maybe<Scalars["String"]>;
  CityId?: Maybe<Scalars["Int"]>;
  HouseId?: Maybe<Scalars["Int"]>;
  headFax?: Maybe<Scalars["String"]>;
  headCode?: Maybe<Scalars["String"]>;
  headNameGenitive?: Maybe<Scalars["String"]>;
  headPositionGenitive?: Maybe<Scalars["String"]>;
  headNameImported?: Maybe<Scalars["String"]>;
  headFullNameGenitive?: Maybe<Scalars["String"]>;
  headPositionImported?: Maybe<Scalars["String"]>;
  headEmailImported?: Maybe<Scalars["String"]>;
  headPhoneImported?: Maybe<Scalars["String"]>;
  EP?: Maybe<Scalars["String"]>;
  EPEn?: Maybe<Scalars["String"]>;
  headName?: Maybe<Scalars["String"]>;
  headNameEn?: Maybe<Scalars["String"]>;
  headPhone?: Maybe<Scalars["String"]>;
  headMobilePhone?: Maybe<Scalars["String"]>;
  headEmail?: Maybe<Scalars["String"]>;
  ownerName?: Maybe<Scalars["String"]>;
  ownerNameEn?: Maybe<Scalars["String"]>;
  ownerPhone?: Maybe<Scalars["String"]>;
  ownerMobilePhone?: Maybe<Scalars["String"]>;
  ownerEmail?: Maybe<Scalars["String"]>;
  birCode?: Maybe<Scalars["String"]>;
  beginWorkingDate?: Maybe<Scalars["DateTime"]>;
  ivideonSublicenseStartAt?: Maybe<Scalars["DateTime"]>;
  isIvideonActFormed?: Maybe<Scalars["Boolean"]>;
  contractId?: Maybe<Scalars["ID"]>;
  headCompanyId?: Maybe<Scalars["ID"]>;
  PhotoDealerCenterId?: Maybe<Scalars["ID"]>;
  PhotoOwnerId?: Maybe<Scalars["ID"]>;
  PhotoBossId?: Maybe<Scalars["ID"]>;
  ScanOwnerPersonDataId?: Maybe<Scalars["ID"]>;
  ScanBossPersonDataId?: Maybe<Scalars["ID"]>;
  ScanLadaPersonDataId?: Maybe<Scalars["ID"]>;
  ScanAccountantPersonDataId?: Maybe<Scalars["ID"]>;
  OrganizationalLegalForm?: Maybe<Scalars["String"]>;
  X_SHOP_FLAG?: Maybe<Scalars["Boolean"]>;
  X_STO_PHCODE?: Maybe<Scalars["String"]>;
  X_STO_PHONE?: Maybe<Scalars["String"]>;
  X_STO_EMAIL?: Maybe<Scalars["String"]>;
  X_SHOP_PHCODE?: Maybe<Scalars["String"]>;
  X_SHOP_PHONE?: Maybe<Scalars["String"]>;
  X_SHOP_EMAIL?: Maybe<Scalars["String"]>;
  X_SHOP_NAME?: Maybe<Scalars["String"]>;
  stoPhCode?: Maybe<Scalars["String"]>;
  stoPhone?: Maybe<Scalars["String"]>;
  stoEmail?: Maybe<Scalars["String"]>;
  shopPhCode?: Maybe<Scalars["String"]>;
  shopPhone?: Maybe<Scalars["String"]>;
  shopEmail?: Maybe<Scalars["String"]>;
  KGA_CODE?: Maybe<Scalars["String"]>;
  ONEC_CODE?: Maybe<Scalars["String"]>;
  autoCrmLastUpdate?: Maybe<Scalars["DateTime"]>;
  autoCrmDisabledAt?: Maybe<Scalars["String"]>;
  latitude?: Maybe<Scalars["String"]>;
  longitude?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  ProjectDocumentationId?: Maybe<Scalars["ID"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
};

/** Список почтовых доменов дилера */
export type DealerDomainType = {
  __typename?: "DealerDomainType";
  id?: Maybe<Scalars["ID"]>;
  domain?: Maybe<Scalars["String"]>;
  DealerId?: Maybe<Scalars["ID"]>;
};

/** Список почтовых доменов дилера */
export type DealerDomainsList = {
  __typename?: "DealerDomainsList";
  items?: Maybe<Array<Maybe<DealerDomainType>>>;
  total?: Maybe<Scalars["Int"]>;
};

/** Поле дилера */
export type DealerField = {
  __typename?: "DealerField";
  id?: Maybe<Scalars["ID"]>;
  fieldName?: Maybe<Scalars["String"]>;
  fieldEnName?: Maybe<Scalars["String"]>;
  fieldRu?: Maybe<Scalars["String"]>;
  fieldEn?: Maybe<Scalars["String"]>;
  fieldRuDescription?: Maybe<Scalars["String"]>;
  fieldEnDescription?: Maybe<Scalars["String"]>;
};

/** Получение данных о дилерах */
export type DealerGetter = {
  __typename?: "DealerGetter";
  /** Пользователь получит список дилеров своих */
  getMyDealers?: Maybe<DealerList>;
  /** пользователь получит список дилеров */
  getDealers?: Maybe<DealerList>;
  /** Пользователь получит инфу о дилере */
  getDealer?: Maybe<Dealer>;
  /** Администратор получит список дилеров для пользователя */
  getDealersForUser?: Maybe<DealerList>;
  /** администратор получит список дилеров для установки пользователей */
  getDealerListToAssign?: Maybe<DealerListToAssign>;
  /** Получение актуальной проектной документации дилера */
  getProjectDocumentationDealer?: Maybe<DealerProjectDocumentation>;
  /** Получение проектной документации дилера (все загруженные) */
  getProjectDocumentationsDealer?: Maybe<DealerProjectDocumentationList>;
  /** Пользователь получит список федеральные округа  */
  getDealersFederalArea?: Maybe<FieldList>;
  /** Пользователь получит список городов */
  getDealersCities?: Maybe<FieldList>;
  /** Пользователь получит список регионов */
  getDealersRegions?: Maybe<FieldList>;
  /** Попросить выгрузку значений дилеров, type ['full': выгрузка полных данных, 'upload': выгрузка для подготовки загрузки] */
  downloadDealers?: Maybe<ReportFile>;
  getDealersLocationItem?: Maybe<FieldList>;
  /** Пользователь получит список холдингов своих */
  getMyHoldings?: Maybe<DealerList>;
  /** получить не занятый id */
  getFreeId?: Maybe<Scalars["ID"]>;
  /** Получение площади дилера */
  getAreaDealer?: Maybe<DealerArea>;
  /** пользователь получит список доменов дилеров */
  getDealersDomains?: Maybe<DealerDomainsList>;
  /** пользователь получит список доменов дилера */
  getDealerDomains?: Maybe<DealerDomainsList>;
  /** Проверка доступности доменного имени */
  checkAvailableDomain?: Maybe<Scalars["Boolean"]>;
  /** Проверка доступности почтового адреса */
  checkAvailableEmail?: Maybe<Scalars["Boolean"]>;
  /** Получить список дилеров с некорректным почтовым адресом */
  getReportDealersWithEmailMismatch?: Maybe<ReportFile>;
  /** Получение полей дилера */
  getDealerFields?: Maybe<Array<Maybe<DealerField>>>;
};

/** Получение данных о дилерах */
export type DealerGetterGetMyDealersArgs = {
  Region?: Maybe<Scalars["String"]>;
  RegionEn?: Maybe<Scalars["String"]>;
  FederalArea?: Maybe<Scalars["String"]>;
  FederalAreaEn?: Maybe<Scalars["String"]>;
  partName?: Maybe<Scalars["String"]>;
  statuses?: Maybe<Array<Maybe<DealerStatus>>>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

/** Получение данных о дилерах */
export type DealerGetterGetDealersArgs = {
  search?: Maybe<DealerSearch>;
  sortField?: Maybe<Scalars["String"]>;
  sortType?: Maybe<Scalars["String"]>;
  getAll?: Maybe<Scalars["Boolean"]>;
  doSearchArchive?: Maybe<Scalars["Boolean"]>;
  archivePeriodId?: Maybe<Scalars["ID"]>;
  dealerPeriodToDate?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

/** Получение данных о дилерах */
export type DealerGetterGetDealerArgs = {
  DealerId: Scalars["ID"];
  ArchivePeriodId?: Maybe<Scalars["ID"]>;
  getAllUser?: Maybe<Scalars["Boolean"]>;
};

/** Получение данных о дилерах */
export type DealerGetterGetDealersForUserArgs = {
  UserId: Scalars["ID"];
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

/** Получение данных о дилерах */
export type DealerGetterGetDealerListToAssignArgs = {
  UserId: Scalars["ID"];
  status?: Maybe<DealerStatus>;
};

/** Получение данных о дилерах */
export type DealerGetterGetProjectDocumentationDealerArgs = {
  DealerId: Scalars["ID"];
};

/** Получение данных о дилерах */
export type DealerGetterGetProjectDocumentationsDealerArgs = {
  DealerId: Scalars["ID"];
};

/** Получение данных о дилерах */
export type DealerGetterGetDealersFederalAreaArgs = {
  city?: Maybe<Scalars["String"]>;
  cityEn?: Maybe<Scalars["String"]>;
  status?: Maybe<DealerStatus>;
};

/** Получение данных о дилерах */
export type DealerGetterGetDealersCitiesArgs = {
  FOEn?: Maybe<Scalars["String"]>;
  FO?: Maybe<Scalars["String"]>;
  status?: Maybe<DealerStatus>;
};

/** Получение данных о дилерах */
export type DealerGetterGetDealersRegionsArgs = {
  status?: Maybe<DealerStatus>;
};

/** Получение данных о дилерах */
export type DealerGetterDownloadDealersArgs = {
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  type?: Maybe<Scalars["String"]>;
};

/** Получение данных о дилерах */
export type DealerGetterGetDealersLocationItemArgs = {
  item?: Maybe<DealersLocationItem>;
  city?: Maybe<Scalars["String"]>;
  cityEn?: Maybe<Scalars["String"]>;
  FOEn?: Maybe<Scalars["String"]>;
  FO?: Maybe<Scalars["String"]>;
  subject?: Maybe<Scalars["String"]>;
  subjectEn?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  countryEn?: Maybe<Scalars["String"]>;
};

/** Получение данных о дилерах */
export type DealerGetterGetMyHoldingsArgs = {
  Region?: Maybe<Scalars["String"]>;
  RegionEn?: Maybe<Scalars["String"]>;
  FederalArea?: Maybe<Scalars["String"]>;
  FederalAreaEn?: Maybe<Scalars["String"]>;
  partName?: Maybe<Scalars["String"]>;
  status?: Maybe<DealerStatus>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

/** Получение данных о дилерах */
export type DealerGetterGetAreaDealerArgs = {
  DealerId: Scalars["ID"];
  ActualOn?: Maybe<Scalars["DateTime"]>;
};

/** Получение данных о дилерах */
export type DealerGetterGetDealersDomainsArgs = {
  DealersId?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение данных о дилерах */
export type DealerGetterGetDealerDomainsArgs = {
  dealerId?: Maybe<Scalars["ID"]>;
};

/** Получение данных о дилерах */
export type DealerGetterCheckAvailableDomainArgs = {
  domain: Scalars["String"];
};

/** Получение данных о дилерах */
export type DealerGetterCheckAvailableEmailArgs = {
  email: Scalars["String"];
  dealerId?: Maybe<Scalars["ID"]>;
};

/** Значения показателей по дилерам для блока Отчёты */
export type DealerIndicatorValues = {
  __typename?: "DealerIndicatorValues";
  Dealer?: Maybe<Dealer>;
  RegMen?: Maybe<DealersRegMen>;
  Values?: Maybe<Array<Maybe<IndicatorValue>>>;
};

/** Список значений показателей по дилерам для блока Отчёты */
export type DealerIndicatorValuesReport = {
  __typename?: "DealerIndicatorValuesReport";
  items?: Maybe<Array<Maybe<DealerIndicatorValues>>>;
  total?: Maybe<Scalars["Int"]>;
  IndicatorReport?: Maybe<IndicatorReport>;
  RegMen?: Maybe<Array<Maybe<RegMenInfo>>>;
};

/** Список дилеров */
export type DealerList = {
  __typename?: "DealerList";
  items?: Maybe<Array<Maybe<Dealer>>>;
  total?: Maybe<Scalars["Int"]>;
};

/** Список дилеров для установки пользователей */
export type DealerListToAssign = {
  __typename?: "DealerListToAssign";
  items?: Maybe<Array<Maybe<DealerToAssign>>>;
};

/** Фотогалерея дилера */
export type DealerPhoto = {
  __typename?: "DealerPhoto";
  id: Scalars["ID"];
  originalUrl: Scalars["String"];
  previewUrl: Scalars["String"];
  DealerId: Scalars["ID"];
  PhotoGallerySectionId: Scalars["ID"];
  createdAt: Scalars["DateTime"];
  PhotoGallerySection: PhotoGallerySection;
};

/** Получение данных о галереи диллера */
export type DealerPhotoGetter = {
  __typename?: "DealerPhotoGetter";
  /** Получение всех фотографий в фотогалереи дилера */
  getDealerPhotos: DealerPhotoList;
  /** Получение фотографии в фотогалереи дилера */
  getDealerPhoto: DealerPhoto;
  /** Миграция фотогалереи */
  migratePhotos: Ok;
};

/** Получение данных о галереи диллера */
export type DealerPhotoGetterGetDealerPhotosArgs = {
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  DealerId: Scalars["ID"];
};

/** Получение данных о галереи диллера */
export type DealerPhotoGetterGetDealerPhotoArgs = {
  id: Scalars["ID"];
};

export type DealerPhotoList = {
  __typename?: "DealerPhotoList";
  total: Scalars["Int"];
  pages: Scalars["Int"];
  items: Array<Maybe<DealerPhoto>>;
};

/** проектная документация */
export type DealerProjectDocumentation = {
  __typename?: "DealerProjectDocumentation";
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  File?: Maybe<File>;
  status?: Maybe<DealerProjectDocumentationStatus>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

export type DealerProjectDocumentationList = {
  __typename?: "DealerProjectDocumentationList";
  items?: Maybe<Array<Maybe<DealerProjectDocumentation>>>;
  total?: Maybe<Scalars["Int"]>;
};

export enum DealerProjectDocumentationStatus {
  Active = "active",
  Inactive = "inactive",
}

/** Регмен дилера для блока Отчёты */
export type DealerRegMan = {
  __typename?: "DealerRegMan";
  fullname?: Maybe<Scalars["String"]>;
  fullnameEn?: Maybe<Scalars["String"]>;
  roleRu?: Maybe<Scalars["String"]>;
  roleEn?: Maybe<Scalars["String"]>;
};

/** Получение данных о дилерах */
export type DealerRegistryGetter = {
  __typename?: "DealerRegistryGetter";
  getArchivePeriods?: Maybe<GetArchivePeriodsList>;
  getArchivePeriod?: Maybe<ArchivePeriod>;
  getArchiveDealersInheritance?: Maybe<GetArchiveDealersInheritanceList>;
  getTemplates?: Maybe<GetTemplatesList>;
  getContracts?: Maybe<Array<Maybe<GetContracts>>>;
  downloadContract?: Maybe<ReportFile>;
  downloadPeriodInfo?: Maybe<ReportFile>;
};

/** Получение данных о дилерах */
export type DealerRegistryGetterGetArchivePeriodsArgs = {
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  fromDate?: Maybe<Scalars["DateTime"]>;
  toDate?: Maybe<Scalars["DateTime"]>;
  insideDate?: Maybe<Scalars["DateTime"]>;
};

/** Получение данных о дилерах */
export type DealerRegistryGetterGetArchivePeriodArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** Получение данных о дилерах */
export type DealerRegistryGetterGetArchiveDealersInheritanceArgs = {
  DealerId?: Maybe<Scalars["ID"]>;
};

/** Получение данных о дилерах */
export type DealerRegistryGetterGetTemplatesArgs = {
  getAll?: Scalars["Boolean"];
  type?: ContractType;
  page?: Scalars["Int"];
  count?: Scalars["Int"];
};

/** Получение данных о дилерах */
export type DealerRegistryGetterGetContractsArgs = {
  DealerId: Scalars["ID"];
  type?: ContractType;
};

/** Получение данных о дилерах */
export type DealerRegistryGetterDownloadContractArgs = {
  contractId: Scalars["ID"];
  dealerId: Scalars["ID"];
};

/** Получение данных о дилерах */
export type DealerRegistryGetterDownloadPeriodInfoArgs = {
  periodId?: Maybe<Scalars["ID"]>;
};

/** Изменение данных о дилерах */
export type DealerRegistrySetter = {
  __typename?: "DealerRegistrySetter";
  createTemplate?: Maybe<DealerContractTemplate>;
  modifyTemplate?: Maybe<Scalars["Boolean"]>;
  deleteTemplate?: Maybe<Scalars["Boolean"]>;
  createPeriod?: Maybe<ArchivePeriod>;
  createContract?: Maybe<DealerContract>;
  modifyContract?: Maybe<DealerContract>;
  deleteContract?: Maybe<Scalars["Boolean"]>;
};

/** Изменение данных о дилерах */
export type DealerRegistrySetterCreateTemplateArgs = {
  name: Scalars["String"];
  html: Scalars["String"];
  type?: ContractType;
};

/** Изменение данных о дилерах */
export type DealerRegistrySetterModifyTemplateArgs = {
  id: Scalars["ID"];
  name: Scalars["String"];
  html: Scalars["String"];
};

/** Изменение данных о дилерах */
export type DealerRegistrySetterDeleteTemplateArgs = {
  id: Scalars["ID"];
};

/** Изменение данных о дилерах */
export type DealerRegistrySetterCreateContractArgs = {
  dealerId: Scalars["ID"];
  templateId: Scalars["ID"];
  number: Scalars["String"];
  date: Scalars["String"];
};

/** Изменение данных о дилерах */
export type DealerRegistrySetterModifyContractArgs = {
  contractId: Scalars["ID"];
  number: Scalars["String"];
  date: Scalars["String"];
};

/** Изменение данных о дилерах */
export type DealerRegistrySetterDeleteContractArgs = {
  contractId: Scalars["ID"];
};

export type DealerReport = {
  __typename?: "DealerReport";
  id?: Maybe<Scalars["ID"]>;
  ReportsPeriodId?: Maybe<Scalars["ID"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  status?: Maybe<DealerReportStatus>;
  note?: Maybe<Scalars["String"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  Dealer?: Maybe<Dealer>;
  Files?: Maybe<Array<Maybe<File>>>;
  ReportPeriod?: Maybe<ReportPeriod>;
  state?: Maybe<ReportState>;
  _MTExMA__?: Maybe<Scalars["BigInt"]>;
  _MTEyMA__?: Maybe<Scalars["BigInt"]>;
  _MTEzMA__?: Maybe<Scalars["BigInt"]>;
  _MTE0MA__?: Maybe<Scalars["BigInt"]>;
  _MTE1MA__?: Maybe<Scalars["BigInt"]>;
  _MTE1MQ__?: Maybe<Scalars["BigInt"]>;
  _MTE1MS8x?: Maybe<Scalars["BigInt"]>;
  _MTE1MS8y?: Maybe<Scalars["BigInt"]>;
  _MTE1Mg__?: Maybe<Scalars["BigInt"]>;
  _MTE1Mi8x?: Maybe<Scalars["BigInt"]>;
  _MTE1Mi8y?: Maybe<Scalars["BigInt"]>;
  _MTE1Mw__?: Maybe<Scalars["BigInt"]>;
  _MTE1My8x?: Maybe<Scalars["BigInt"]>;
  _MTE1My8y?: Maybe<Scalars["BigInt"]>;
  _MTE1NA__?: Maybe<Scalars["BigInt"]>;
  _MTE1NC8x?: Maybe<Scalars["BigInt"]>;
  _MTE1NC8y?: Maybe<Scalars["BigInt"]>;
  _MTE2MA__?: Maybe<Scalars["BigInt"]>;
  _MTE3MA__?: Maybe<Scalars["BigInt"]>;
  _MTE3MQ__?: Maybe<Scalars["BigInt"]>;
  _MTE4MA__?: Maybe<Scalars["BigInt"]>;
  _MTE5MA__?: Maybe<Scalars["BigInt"]>;
  _MTE5MQ__?: Maybe<Scalars["BigInt"]>;
  _MTEwMA__?: Maybe<Scalars["BigInt"]>;
  _MTIxMA__?: Maybe<Scalars["BigInt"]>;
  _MTIxMQ__?: Maybe<Scalars["BigInt"]>;
  _MTIxMg__?: Maybe<Scalars["BigInt"]>;
  _MTIxMw__?: Maybe<Scalars["BigInt"]>;
  _MTIxNA__?: Maybe<Scalars["BigInt"]>;
  _MTIyMA__?: Maybe<Scalars["BigInt"]>;
  _MTIzMA__?: Maybe<Scalars["BigInt"]>;
  _MTIzMQ__?: Maybe<Scalars["BigInt"]>;
  _MTIzMg__?: Maybe<Scalars["BigInt"]>;
  _MTIzMw__?: Maybe<Scalars["BigInt"]>;
  _MTIzNA__?: Maybe<Scalars["BigInt"]>;
  _MTI0MA__?: Maybe<Scalars["BigInt"]>;
  _MTI1MA__?: Maybe<Scalars["BigInt"]>;
  _MTI2MA__?: Maybe<Scalars["BigInt"]>;
  _MTIwMA__?: Maybe<Scalars["BigInt"]>;
  _MTYwMA__?: Maybe<Scalars["BigInt"]>;
  _MTMxMA__?: Maybe<Scalars["BigInt"]>;
  _MTMyMA__?: Maybe<Scalars["BigInt"]>;
  _MTM0MA__?: Maybe<Scalars["BigInt"]>;
  _MTM1MA__?: Maybe<Scalars["BigInt"]>;
  _MTM2MA__?: Maybe<Scalars["BigInt"]>;
  _MTM3MA__?: Maybe<Scalars["BigInt"]>;
  _MTMwMA__?: Maybe<Scalars["BigInt"]>;
  _MTQxMA__?: Maybe<Scalars["BigInt"]>;
  _MTQyMA__?: Maybe<Scalars["BigInt"]>;
  _MTQzMA__?: Maybe<Scalars["BigInt"]>;
  _MTQ1MA__?: Maybe<Scalars["BigInt"]>;
  _MTQwMA__?: Maybe<Scalars["BigInt"]>;
  _MTUxMA__?: Maybe<Scalars["BigInt"]>;
  _MTUyMA__?: Maybe<Scalars["BigInt"]>;
  _MTUyMQ__?: Maybe<Scalars["BigInt"]>;
  _MTUyMg__?: Maybe<Scalars["BigInt"]>;
  _MTUyMw__?: Maybe<Scalars["BigInt"]>;
  _MTUzMA__?: Maybe<Scalars["BigInt"]>;
  _MTU0MA__?: Maybe<Scalars["BigInt"]>;
  _MTU1MA__?: Maybe<Scalars["BigInt"]>;
  _MTUwMA__?: Maybe<Scalars["BigInt"]>;
  _MjAwMA__?: Maybe<Scalars["BigInt"]>;
  _MjExMA__?: Maybe<Scalars["BigInt"]>;
  _MjExMQ__?: Maybe<Scalars["BigInt"]>;
  _MjExMg__?: Maybe<Scalars["BigInt"]>;
  _MjExMw__?: Maybe<Scalars["BigInt"]>;
  _MjExNA__?: Maybe<Scalars["BigInt"]>;
  _MjExNQ__?: Maybe<Scalars["BigInt"]>;
  _MjExNg__?: Maybe<Scalars["BigInt"]>;
  _MjExNw__?: Maybe<Scalars["BigInt"]>;
  _MjExOA__?: Maybe<Scalars["BigInt"]>;
  _MjEyMA__?: Maybe<Scalars["BigInt"]>;
  _MjEyMQ__?: Maybe<Scalars["BigInt"]>;
  _MjEyMg__?: Maybe<Scalars["BigInt"]>;
  _MjEyMw__?: Maybe<Scalars["BigInt"]>;
  _MjEyNA__?: Maybe<Scalars["BigInt"]>;
  _MjEyNQ__?: Maybe<Scalars["BigInt"]>;
  _MjEyNg__?: Maybe<Scalars["BigInt"]>;
  _MjEyNw__?: Maybe<Scalars["BigInt"]>;
  _MjEwMA__?: Maybe<Scalars["BigInt"]>;
  _MjIxMA__?: Maybe<Scalars["BigInt"]>;
  _MjIxMQ__?: Maybe<Scalars["BigInt"]>;
  _MjIxMS8x?: Maybe<Scalars["BigInt"]>;
  _MjIxMS8y?: Maybe<Scalars["BigInt"]>;
  _MjIxMS8z?: Maybe<Scalars["BigInt"]>;
  _MjIxMS80?: Maybe<Scalars["BigInt"]>;
  _MjIxMS81?: Maybe<Scalars["BigInt"]>;
  _MjIxMS82?: Maybe<Scalars["BigInt"]>;
  _MjIxMS83?: Maybe<Scalars["BigInt"]>;
  _MjIxMS84?: Maybe<Scalars["BigInt"]>;
  _MjIxMg__?: Maybe<Scalars["BigInt"]>;
  _MjIxMw__?: Maybe<Scalars["BigInt"]>;
  _MjIyMA__?: Maybe<Scalars["BigInt"]>;
  _MjIyMC8x?: Maybe<Scalars["BigInt"]>;
  _MjIyMC8y?: Maybe<Scalars["BigInt"]>;
  _MjIyMC8z?: Maybe<Scalars["BigInt"]>;
  _MjIyMC80?: Maybe<Scalars["BigInt"]>;
  _MjIyMC81?: Maybe<Scalars["BigInt"]>;
  _MjIyMC82?: Maybe<Scalars["BigInt"]>;
  _MjIyMC83?: Maybe<Scalars["BigInt"]>;
  _MjIyMC84?: Maybe<Scalars["BigInt"]>;
  _MjIyMC85?: Maybe<Scalars["BigInt"]>;
  _MjIyMC8xMA__?: Maybe<Scalars["BigInt"]>;
  _MjIyMC8xMQ__?: Maybe<Scalars["BigInt"]>;
  _MjIwMA__?: Maybe<Scalars["BigInt"]>;
  _MjMxMA__?: Maybe<Scalars["BigInt"]>;
  _MjMyMA__?: Maybe<Scalars["BigInt"]>;
  _MjMzMA__?: Maybe<Scalars["BigInt"]>;
  _MjM0MA__?: Maybe<Scalars["BigInt"]>;
  _MjM0MQ__?: Maybe<Scalars["BigInt"]>;
  _MjM0Mg__?: Maybe<Scalars["BigInt"]>;
  _MjM0Mw__?: Maybe<Scalars["BigInt"]>;
  _MjM1MA__?: Maybe<Scalars["BigInt"]>;
  _MjMwMA__?: Maybe<Scalars["BigInt"]>;
  _MjQxMA__?: Maybe<Scalars["BigInt"]>;
  _MjQxMQ__?: Maybe<Scalars["BigInt"]>;
  _MjQxMg__?: Maybe<Scalars["BigInt"]>;
  _MjQ2MA__?: Maybe<Scalars["BigInt"]>;
  _MjQwMA__?: Maybe<Scalars["BigInt"]>;
  _MjUxMA__?: Maybe<Scalars["BigInt"]>;
  _MjUyMA__?: Maybe<Scalars["BigInt"]>;
  _MjUwMA__?: Maybe<Scalars["BigInt"]>;
  _MjkxMA__?: Maybe<Scalars["BigInt"]>;
  _MjkwMA__?: Maybe<Scalars["BigInt"]>;
};

export enum DealerReportStatus {
  Draft = "draft",
  Checking = "checking",
  Verified = "verified",
  Fixing = "fixing",
}

export type DealerSearch = {
  /** список полей которые нужно учесть при поиске */
  SearchFields?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerName?: Maybe<Scalars["String"]>;
  DealerNameEn?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  INN?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  subject?: Maybe<Scalars["String"]>;
  subjectEn?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  cityEn?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  typeEn?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  countryEn?: Maybe<Scalars["String"]>;
  FO?: Maybe<Scalars["String"]>;
  FOEn?: Maybe<Scalars["String"]>;
  address?: Maybe<Scalars["String"]>;
  addressEn?: Maybe<Scalars["String"]>;
  birCode?: Maybe<Scalars["String"]>;
  category?: Maybe<Scalars["String"]>;
  candidate?: Maybe<Scalars["String"]>;
  regionalServiceManager?: Maybe<Scalars["String"]>;
  regionalSalesManager?: Maybe<Scalars["String"]>;
  OrganizationalLegalForm?: Maybe<Scalars["String"]>;
  ContractEndDate?: Maybe<Scalars["DateTime"]>;
  EP?: Maybe<Scalars["String"]>;
  headName?: Maybe<Scalars["String"]>;
  headNameEn?: Maybe<Scalars["String"]>;
  headCompanyName?: Maybe<Scalars["String"]>;
  DealerLADASERV?: Maybe<Scalars["Int"]>;
  extendedForNextYear?: Maybe<Scalars["Int"]>;
  Main?: Maybe<Scalars["Int"]>;
  IvideonGroupCheckStatus?: Maybe<Scalars["Boolean"]>;
  IsIvideonAuthorized?: Maybe<Scalars["Boolean"]>;
  CamerasCount?: Maybe<Scalars["Int"]>;
};

/** Изменение данных о дилерах */
export type DealerSetter = {
  __typename?: "DealerSetter";
  /** Администратор уберёт дилера от этого человека */
  deleteDealerFromUser?: Maybe<Scalars["Boolean"]>;
  /** Разрешить загрузить черновик */
  acceptUploadDealer?: Maybe<Scalars["Boolean"]>;
  /** Администратор присвоит дилера этому человеку */
  addDealerToUser?: Maybe<Scalars["Boolean"]>;
  /** Загрузка дилеров через csv */
  uploadDealers?: Maybe<Scalars["Boolean"]>;
  /** Редактирование дилера */
  changeDealer?: Maybe<Scalars["Boolean"]>;
  /** Создание дилера */
  createDealer?: Maybe<Dealer>;
  /** получить не занятый id */
  getFreeId?: Maybe<Scalars["ID"]>;
  /** Создание почтового домена дилера */
  createDealerDomain?: Maybe<DealerDomainType>;
  /** Удалить почтовый домен у дилера */
  deleteDealerDomain?: Maybe<Scalars["Boolean"]>;
  /** Установить проектную документацию дилеру, старая будет обнулена. */
  setProjectDocumentationDealer?: Maybe<DealerProjectDocumentation>;
  /** Редактирование поля дилера */
  changeDealerField?: Maybe<Scalars["Boolean"]>;
};

/** Изменение данных о дилерах */
export type DealerSetterDeleteDealerFromUserArgs = {
  UserId: Scalars["ID"];
  DealerId: Scalars["ID"];
};

/** Изменение данных о дилерах */
export type DealerSetterAcceptUploadDealerArgs = {
  IndicatorUploadId: Scalars["ID"];
};

/** Изменение данных о дилерах */
export type DealerSetterAddDealerToUserArgs = {
  UserId: Scalars["ID"];
  DealerId: Scalars["ID"];
};

/** Изменение данных о дилерах */
export type DealerSetterUploadDealersArgs = {
  fileId: Scalars["ID"];
  description?: Maybe<Scalars["String"]>;
};

/** Изменение данных о дилерах */
export type DealerSetterChangeDealerArgs = {
  id: Scalars["ID"];
  successorId: Scalars["ID"];
  autoCRMID?: Maybe<Scalars["ID"]>;
  tradeDealerNameEn?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  typeEn?: Maybe<Scalars["String"]>;
  DealerName?: Maybe<Scalars["String"]>;
  DealerNameEn?: Maybe<Scalars["String"]>;
  tradeDealerName?: Maybe<Scalars["String"]>;
  legalDealerName?: Maybe<Scalars["String"]>;
  legalDealerNameEn?: Maybe<Scalars["String"]>;
  INN?: Maybe<Scalars["String"]>;
  KPP?: Maybe<Scalars["String"]>;
  ContractEndDate?: Maybe<Scalars["DateTime"]>;
  IS_Id?: Maybe<Scalars["String"]>;
  protocolOfIntentions?: Maybe<Scalars["Int"]>;
  Main?: Maybe<Scalars["Int"]>;
  newDealer?: Maybe<Scalars["Int"]>;
  temporaryDecision?: Maybe<Scalars["Int"]>;
  logicalType?: Maybe<Scalars["Int"]>;
  extendedForNextYear?: Maybe<Scalars["Int"]>;
  terminated?: Maybe<Scalars["Int"]>;
  hideOnLadaRu?: Maybe<Scalars["Int"]>;
  DealerLADASERV?: Maybe<Scalars["Int"]>;
  OGRN?: Maybe<Scalars["String"]>;
  termOfAuthority?: Maybe<Scalars["DateTime"]>;
  responsibleForLadaEmail?: Maybe<Scalars["String"]>;
  consumerCode?: Maybe<Scalars["String"]>;
  corporateEmail?: Maybe<Scalars["String"]>;
  EGR_Number?: Maybe<Scalars["String"]>;
  EGR_Series?: Maybe<Scalars["String"]>;
  EGR_Date?: Maybe<Scalars["DateTime"]>;
  settlementAccount?: Maybe<Scalars["String"]>;
  correspondentAccount?: Maybe<Scalars["String"]>;
  BIK?: Maybe<Scalars["String"]>;
  bankName?: Maybe<Scalars["String"]>;
  responsibleForLadaFax?: Maybe<Scalars["String"]>;
  responsibleForLadaPhone?: Maybe<Scalars["String"]>;
  responsibleForLadaCode?: Maybe<Scalars["String"]>;
  responsibleForLadaName?: Maybe<Scalars["String"]>;
  accountantEmail?: Maybe<Scalars["String"]>;
  accountantFax?: Maybe<Scalars["String"]>;
  accountantPhone?: Maybe<Scalars["String"]>;
  accountantCode?: Maybe<Scalars["String"]>;
  accountantName?: Maybe<Scalars["String"]>;
  protocolOfTermination?: Maybe<Scalars["String"]>;
  protocolOfConclusion?: Maybe<Scalars["String"]>;
  category?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  regionCode?: Maybe<Scalars["String"]>;
  address?: Maybe<Scalars["String"]>;
  addressEn?: Maybe<Scalars["String"]>;
  legalAddress?: Maybe<Scalars["String"]>;
  postalAddress?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  countryEn?: Maybe<Scalars["String"]>;
  FO?: Maybe<Scalars["String"]>;
  FOEn?: Maybe<Scalars["String"]>;
  subject?: Maybe<Scalars["String"]>;
  subjectEn?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  cityEn?: Maybe<Scalars["String"]>;
  headFax?: Maybe<Scalars["String"]>;
  headCode?: Maybe<Scalars["String"]>;
  headNameGenitive?: Maybe<Scalars["String"]>;
  headPositionGenitive?: Maybe<Scalars["String"]>;
  headFullNameGenitive?: Maybe<Scalars["String"]>;
  EP?: Maybe<Scalars["String"]>;
  EPEn?: Maybe<Scalars["String"]>;
  headName?: Maybe<Scalars["String"]>;
  headNameEn?: Maybe<Scalars["String"]>;
  headPhone?: Maybe<Scalars["String"]>;
  headMobilePhone?: Maybe<Scalars["String"]>;
  headEmail?: Maybe<Scalars["String"]>;
  ownerName?: Maybe<Scalars["String"]>;
  ownerNameEn?: Maybe<Scalars["String"]>;
  ownerPhone?: Maybe<Scalars["String"]>;
  ownerMobilePhone?: Maybe<Scalars["String"]>;
  ownerEmail?: Maybe<Scalars["String"]>;
  birCode?: Maybe<Scalars["String"]>;
  beginWorkingDate?: Maybe<Scalars["DateTime"]>;
  contractId?: Maybe<Scalars["ID"]>;
  headCompanyId?: Maybe<Scalars["ID"]>;
  PhotoDealerCenterId?: Maybe<Scalars["ID"]>;
  PhotoOwnerId?: Maybe<Scalars["ID"]>;
  PhotoBossId?: Maybe<Scalars["ID"]>;
  ScanOwnerPersonDataId?: Maybe<Scalars["ID"]>;
  ScanBossPersonDataId?: Maybe<Scalars["ID"]>;
  ScanLadaPersonDataId?: Maybe<Scalars["ID"]>;
  ScanAccountantPersonDataId?: Maybe<Scalars["ID"]>;
  OrganizationalLegalForm?: Maybe<Scalars["String"]>;
  CityId?: Maybe<Scalars["ID"]>;
  legalCityId?: Maybe<Scalars["ID"]>;
  postalCityId?: Maybe<Scalars["ID"]>;
  HouseId?: Maybe<Scalars["ID"]>;
  legalHouseId?: Maybe<Scalars["ID"]>;
  postalHouseId?: Maybe<Scalars["ID"]>;
  X_SHOP_FLAG?: Maybe<Scalars["Boolean"]>;
  X_STO_PHCODE?: Maybe<Scalars["String"]>;
  X_SHOP_PHCODE?: Maybe<Scalars["String"]>;
  X_STO_PHONE?: Maybe<Scalars["String"]>;
  X_STO_EMAIL?: Maybe<Scalars["String"]>;
  X_SHOP_PHONE?: Maybe<Scalars["String"]>;
  X_SHOP_EMAIL?: Maybe<Scalars["String"]>;
  X_SHOP_NAME?: Maybe<Scalars["String"]>;
  stoPhCode?: Maybe<Scalars["String"]>;
  stoPhone?: Maybe<Scalars["String"]>;
  stoEmail?: Maybe<Scalars["String"]>;
  shopPhCode?: Maybe<Scalars["String"]>;
  shopPhone?: Maybe<Scalars["String"]>;
  shopEmail?: Maybe<Scalars["String"]>;
  status?: Maybe<DealerStatus>;
  ProjectDocumentationId?: Maybe<Scalars["ID"]>;
};

/** Изменение данных о дилерах */
export type DealerSetterCreateDealerArgs = {
  id: Scalars["ID"];
  type?: Maybe<Scalars["String"]>;
  typeEn?: Maybe<Scalars["String"]>;
  DealerName?: Maybe<Scalars["String"]>;
  DealerNameEn?: Maybe<Scalars["String"]>;
  tradeDealerName?: Maybe<Scalars["String"]>;
  tradeDealerNameEn?: Maybe<Scalars["String"]>;
  legalDealerName?: Maybe<Scalars["String"]>;
  legalDealerNameEn?: Maybe<Scalars["String"]>;
  INN?: Maybe<Scalars["String"]>;
  KPP: Scalars["String"];
  ContractEndDate?: Maybe<Scalars["DateTime"]>;
  IS_Id?: Maybe<Scalars["String"]>;
  Main?: Maybe<Scalars["Int"]>;
  newDealer?: Maybe<Scalars["Int"]>;
  temporaryDecision?: Maybe<Scalars["Int"]>;
  protocolOfIntentions?: Maybe<Scalars["Int"]>;
  logicalType?: Maybe<Scalars["Int"]>;
  extendedForNextYear?: Maybe<Scalars["Int"]>;
  terminated?: Maybe<Scalars["Int"]>;
  hideOnLadaRu?: Maybe<Scalars["Int"]>;
  DealerLADASERV?: Maybe<Scalars["Int"]>;
  OGRN?: Maybe<Scalars["String"]>;
  termOfAuthority?: Maybe<Scalars["DateTime"]>;
  consumerCode?: Maybe<Scalars["String"]>;
  corporateEmail?: Maybe<Scalars["String"]>;
  EGR_Number?: Maybe<Scalars["String"]>;
  EGR_Series?: Maybe<Scalars["String"]>;
  EGR_Date?: Maybe<Scalars["DateTime"]>;
  settlementAccount?: Maybe<Scalars["String"]>;
  correspondentAccount?: Maybe<Scalars["String"]>;
  BIK?: Maybe<Scalars["String"]>;
  bankName?: Maybe<Scalars["String"]>;
  responsibleForLadaEmail?: Maybe<Scalars["String"]>;
  responsibleForLadaFax?: Maybe<Scalars["String"]>;
  responsibleForLadaPhone?: Maybe<Scalars["String"]>;
  responsibleForLadaCode?: Maybe<Scalars["String"]>;
  responsibleForLadaName?: Maybe<Scalars["String"]>;
  accountantEmail?: Maybe<Scalars["String"]>;
  accountantFax?: Maybe<Scalars["String"]>;
  accountantPhone?: Maybe<Scalars["String"]>;
  accountantCode?: Maybe<Scalars["String"]>;
  accountantName?: Maybe<Scalars["String"]>;
  protocolOfTermination?: Maybe<Scalars["String"]>;
  protocolOfConclusion?: Maybe<Scalars["String"]>;
  category?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  reestrLegalAddress?: Maybe<Scalars["String"]>;
  legalCityId?: Maybe<Scalars["Int"]>;
  legalHouseId?: Maybe<Scalars["Int"]>;
  reestrPostAddress?: Maybe<Scalars["String"]>;
  postalCityId?: Maybe<Scalars["Int"]>;
  postalHouseId?: Maybe<Scalars["Int"]>;
  reestrAddress?: Maybe<Scalars["String"]>;
  regionCode?: Maybe<Scalars["String"]>;
  CityId?: Maybe<Scalars["Int"]>;
  HouseId?: Maybe<Scalars["Int"]>;
  headFax?: Maybe<Scalars["String"]>;
  headCode?: Maybe<Scalars["String"]>;
  headNameGenitive?: Maybe<Scalars["String"]>;
  headPositionGenitive?: Maybe<Scalars["String"]>;
  headNameImported?: Maybe<Scalars["String"]>;
  headFullNameGenitive?: Maybe<Scalars["String"]>;
  headPositionImported?: Maybe<Scalars["String"]>;
  headEmailImported?: Maybe<Scalars["String"]>;
  headPhoneImported?: Maybe<Scalars["String"]>;
  EP?: Maybe<Scalars["String"]>;
  EPEn?: Maybe<Scalars["String"]>;
  headName?: Maybe<Scalars["String"]>;
  headNameEn?: Maybe<Scalars["String"]>;
  headPhone?: Maybe<Scalars["String"]>;
  headMobilePhone?: Maybe<Scalars["String"]>;
  headEmail?: Maybe<Scalars["String"]>;
  ownerName?: Maybe<Scalars["String"]>;
  ownerNameEn?: Maybe<Scalars["String"]>;
  ownerPhone?: Maybe<Scalars["String"]>;
  ownerMobilePhone?: Maybe<Scalars["String"]>;
  ownerEmail?: Maybe<Scalars["String"]>;
  birCode?: Maybe<Scalars["String"]>;
  beginWorkingDate?: Maybe<Scalars["DateTime"]>;
  ivideonSublicenseStartAt?: Maybe<Scalars["DateTime"]>;
  isIvideonActFormed?: Scalars["Boolean"];
  contractId?: Maybe<Scalars["ID"]>;
  headCompanyId?: Maybe<Scalars["ID"]>;
  PhotoDealerCenterId?: Maybe<Scalars["ID"]>;
  PhotoOwnerId?: Maybe<Scalars["ID"]>;
  PhotoBossId?: Maybe<Scalars["ID"]>;
  ScanOwnerPersonDataId?: Maybe<Scalars["ID"]>;
  ScanBossPersonDataId?: Maybe<Scalars["ID"]>;
  ScanLadaPersonDataId?: Maybe<Scalars["ID"]>;
  ScanAccountantPersonDataId?: Maybe<Scalars["ID"]>;
  OrganizationalLegalForm?: Maybe<Scalars["String"]>;
  X_SHOP_FLAG?: Maybe<Scalars["Boolean"]>;
  X_STO_PHCODE?: Maybe<Scalars["String"]>;
  X_STO_PHONE?: Maybe<Scalars["String"]>;
  X_STO_EMAIL?: Maybe<Scalars["String"]>;
  X_SHOP_PHCODE?: Maybe<Scalars["String"]>;
  X_SHOP_PHONE?: Maybe<Scalars["String"]>;
  X_SHOP_EMAIL?: Maybe<Scalars["String"]>;
  X_SHOP_NAME?: Maybe<Scalars["String"]>;
  stoPhCode?: Maybe<Scalars["String"]>;
  stoPhone?: Maybe<Scalars["String"]>;
  stoEmail?: Maybe<Scalars["String"]>;
  shopPhCode?: Maybe<Scalars["String"]>;
  shopPhone?: Maybe<Scalars["String"]>;
  shopEmail?: Maybe<Scalars["String"]>;
  autoCrmLastUpdate?: Maybe<Scalars["DateTime"]>;
  autoCrmDisabledAt?: Maybe<Scalars["String"]>;
  latitude?: Maybe<Scalars["String"]>;
  longitude?: Maybe<Scalars["String"]>;
  status?: Maybe<DealerStatus>;
  successorId: Scalars["ID"];
  ProjectDocumentationFileId?: Maybe<Scalars["ID"]>;
  ProjectDocumentationName?: Maybe<Scalars["String"]>;
};

/** Изменение данных о дилерах */
export type DealerSetterCreateDealerDomainArgs = {
  domain: Scalars["String"];
  dealerId: Scalars["ID"];
};

/** Изменение данных о дилерах */
export type DealerSetterDeleteDealerDomainArgs = {
  domainId: Scalars["ID"];
};

/** Изменение данных о дилерах */
export type DealerSetterSetProjectDocumentationDealerArgs = {
  FileId: Scalars["ID"];
  DealerId: Scalars["ID"];
  name: Scalars["String"];
};

/** Изменение данных о дилерах */
export type DealerSetterChangeDealerFieldArgs = {
  id: Scalars["ID"];
  fieldRu?: Maybe<Scalars["String"]>;
  fieldEn?: Maybe<Scalars["String"]>;
  fieldRuDescription?: Maybe<Scalars["String"]>;
  fieldEnDescription?: Maybe<Scalars["String"]>;
};

/** Данные для DealerShip */
export type DealerShip = {
  __typename?: "DealerShip";
  Indicator800?: Maybe<Array<Maybe<IndicatorValue>>>;
  dealer?: Maybe<Dealer>;
};

export enum DealerStatus {
  Active = "active",
  Removed = "removed",
  Candidate = "candidate",
}

export type DealerTablesStatusesListItem = {
  __typename?: "DealerTablesStatusesListItem";
  tableIndex: ZdTableIndex;
  lastChangeByDealer?: Maybe<Scalars["DateTime"]>;
  lastChangeByDealerChecker?: Maybe<Scalars["DateTime"]>;
};

/** дилер */
export type DealerTarget = {
  DealerId: Scalars["ID"];
  Month: Scalars["DateTime"];
  Target: Scalars["Int"];
  isSRR3: Scalars["Boolean"];
};

/** дилер */
export type DealerTargetOut = {
  __typename?: "DealerTargetOut";
  DealerId: Scalars["ID"];
  Dealer: Dealer;
  Month: Scalars["DateTime"];
  Target: Scalars["Int"];
};

/** дилер */
export type DealerToAssign = {
  __typename?: "DealerToAssign";
  id?: Maybe<Scalars["ID"]>;
  DealerName?: Maybe<Scalars["String"]>;
  DealerNameEn?: Maybe<Scalars["String"]>;
  INN?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  isMy?: Maybe<Scalars["Boolean"]>;
  status?: Maybe<DealerStatus>;
};

/** DealerWithPeriods */
export type DealerWithPeriods = {
  __typename?: "DealerWithPeriods";
  id: Scalars["ID"];
  autoCRMID?: Maybe<Scalars["ID"]>;
  type?: Maybe<Scalars["String"]>;
  typeEn?: Maybe<Scalars["String"]>;
  ent_id?: Maybe<Scalars["ID"]>;
  DealerName?: Maybe<Scalars["String"]>;
  DealerNameEn?: Maybe<Scalars["String"]>;
  tradeDealerName?: Maybe<Scalars["String"]>;
  tradeDealerNameEn?: Maybe<Scalars["String"]>;
  legalDealerName?: Maybe<Scalars["String"]>;
  legalDealerNameEn?: Maybe<Scalars["String"]>;
  INN?: Maybe<Scalars["String"]>;
  KPP?: Maybe<Scalars["String"]>;
  ContractEndDate?: Maybe<Scalars["DateTime"]>;
  IS_Id?: Maybe<Scalars["String"]>;
  Main?: Maybe<Scalars["Int"]>;
  newDealer?: Maybe<Scalars["Int"]>;
  temporaryDecision?: Maybe<Scalars["Int"]>;
  protocolOfIntentions?: Maybe<Scalars["Int"]>;
  logicalType?: Maybe<Scalars["Int"]>;
  extendedForNextYear?: Maybe<Scalars["Int"]>;
  terminated?: Maybe<Scalars["Int"]>;
  hideOnLadaRu?: Maybe<Scalars["Int"]>;
  DealerLADASERV?: Maybe<Scalars["Int"]>;
  OGRN?: Maybe<Scalars["String"]>;
  termOfAuthority?: Maybe<Scalars["DateTime"]>;
  consumerCode?: Maybe<Scalars["String"]>;
  corporateEmail?: Maybe<Scalars["String"]>;
  EGR_Number?: Maybe<Scalars["String"]>;
  EGR_Series?: Maybe<Scalars["String"]>;
  EGR_Date?: Maybe<Scalars["DateTime"]>;
  settlementAccount?: Maybe<Scalars["String"]>;
  correspondentAccount?: Maybe<Scalars["String"]>;
  BIK?: Maybe<Scalars["String"]>;
  bankName?: Maybe<Scalars["String"]>;
  responsibleForLadaEmail?: Maybe<Scalars["String"]>;
  responsibleForLadaFax?: Maybe<Scalars["String"]>;
  responsibleForLadaPhone?: Maybe<Scalars["String"]>;
  responsibleForLadaCode?: Maybe<Scalars["String"]>;
  responsibleForLadaName?: Maybe<Scalars["String"]>;
  accountantEmail?: Maybe<Scalars["String"]>;
  accountantFax?: Maybe<Scalars["String"]>;
  accountantPhone?: Maybe<Scalars["String"]>;
  accountantCode?: Maybe<Scalars["String"]>;
  accountantName?: Maybe<Scalars["String"]>;
  protocolOfTermination?: Maybe<Scalars["String"]>;
  protocolOfConclusion?: Maybe<Scalars["String"]>;
  successorCode?: Maybe<Scalars["String"]>;
  entfCode?: Maybe<Scalars["String"]>;
  entfSuccessorNo?: Maybe<Scalars["String"]>;
  entfSuccessorCode?: Maybe<Scalars["String"]>;
  category?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  legalAddress?: Maybe<Scalars["String"]>;
  reestrLegalAddress?: Maybe<Scalars["String"]>;
  legalCityId?: Maybe<Scalars["Int"]>;
  legalHouseId?: Maybe<Scalars["Int"]>;
  postalAddress?: Maybe<Scalars["String"]>;
  reestrPostAddress?: Maybe<Scalars["String"]>;
  postalCityId?: Maybe<Scalars["Int"]>;
  postalHouseId?: Maybe<Scalars["Int"]>;
  address?: Maybe<Scalars["String"]>;
  reestrAddress?: Maybe<Scalars["String"]>;
  addressEn?: Maybe<Scalars["String"]>;
  regionCode?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  countryEn?: Maybe<Scalars["String"]>;
  FO?: Maybe<Scalars["String"]>;
  FOEn?: Maybe<Scalars["String"]>;
  subject?: Maybe<Scalars["String"]>;
  subjectEn?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  cityEn?: Maybe<Scalars["String"]>;
  CityId?: Maybe<Scalars["Int"]>;
  HouseId?: Maybe<Scalars["Int"]>;
  headFax?: Maybe<Scalars["String"]>;
  headCode?: Maybe<Scalars["String"]>;
  headNameGenitive?: Maybe<Scalars["String"]>;
  headPositionGenitive?: Maybe<Scalars["String"]>;
  headNameImported?: Maybe<Scalars["String"]>;
  headFullNameGenitive?: Maybe<Scalars["String"]>;
  headPositionImported?: Maybe<Scalars["String"]>;
  headEmailImported?: Maybe<Scalars["String"]>;
  headPhoneImported?: Maybe<Scalars["String"]>;
  EP?: Maybe<Scalars["String"]>;
  EPEn?: Maybe<Scalars["String"]>;
  headName?: Maybe<Scalars["String"]>;
  headNameEn?: Maybe<Scalars["String"]>;
  headPhone?: Maybe<Scalars["String"]>;
  headMobilePhone?: Maybe<Scalars["String"]>;
  headEmail?: Maybe<Scalars["String"]>;
  ownerName?: Maybe<Scalars["String"]>;
  ownerNameEn?: Maybe<Scalars["String"]>;
  ownerPhone?: Maybe<Scalars["String"]>;
  ownerMobilePhone?: Maybe<Scalars["String"]>;
  ownerEmail?: Maybe<Scalars["String"]>;
  birCode?: Maybe<Scalars["String"]>;
  beginWorkingDate?: Maybe<Scalars["DateTime"]>;
  ivideonSublicenseStartAt?: Maybe<Scalars["DateTime"]>;
  isIvideonActFormed: Scalars["Boolean"];
  contractId?: Maybe<Scalars["ID"]>;
  headCompanyId?: Maybe<Scalars["ID"]>;
  PhotoDealerCenterId?: Maybe<Scalars["ID"]>;
  PhotoOwnerId?: Maybe<Scalars["ID"]>;
  PhotoBossId?: Maybe<Scalars["ID"]>;
  ScanOwnerPersonDataId?: Maybe<Scalars["ID"]>;
  ScanBossPersonDataId?: Maybe<Scalars["ID"]>;
  ScanLadaPersonDataId?: Maybe<Scalars["ID"]>;
  ScanAccountantPersonDataId?: Maybe<Scalars["ID"]>;
  OrganizationalLegalForm?: Maybe<Scalars["String"]>;
  X_SHOP_FLAG?: Maybe<Scalars["Boolean"]>;
  X_STO_PHCODE?: Maybe<Scalars["String"]>;
  X_STO_PHONE?: Maybe<Scalars["String"]>;
  X_STO_EMAIL?: Maybe<Scalars["String"]>;
  X_SHOP_PHCODE?: Maybe<Scalars["String"]>;
  X_SHOP_PHONE?: Maybe<Scalars["String"]>;
  X_SHOP_EMAIL?: Maybe<Scalars["String"]>;
  X_SHOP_NAME?: Maybe<Scalars["String"]>;
  stoPhCode?: Maybe<Scalars["String"]>;
  stoPhone?: Maybe<Scalars["String"]>;
  stoEmail?: Maybe<Scalars["String"]>;
  shopPhCode?: Maybe<Scalars["String"]>;
  shopPhone?: Maybe<Scalars["String"]>;
  shopEmail?: Maybe<Scalars["String"]>;
  KGA_CODE?: Maybe<Scalars["String"]>;
  ONEC_CODE?: Maybe<Scalars["String"]>;
  autoCrmLastUpdate?: Maybe<Scalars["DateTime"]>;
  autoCrmDisabledAt?: Maybe<Scalars["String"]>;
  latitude?: Maybe<Scalars["String"]>;
  longitude?: Maybe<Scalars["String"]>;
  status?: Maybe<DealerStatus>;
  ProjectDocumentationId?: Maybe<Scalars["ID"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  periods?: Maybe<Array<Maybe<ArchivePeriod>>>;
};

export enum DealersLocationItem {
  City = "city",
  Fo = "FO",
  Subject = "subject",
  Country = "country",
}

/** Регмены дилеров для блока Отчёты */
export type DealersRegMen = {
  __typename?: "DealersRegMen";
  leaderRegionalSalesManager?: Maybe<DealerRegMan>;
  regionalSalesManager?: Maybe<DealerRegMan>;
  leaderRegionalServiceManager?: Maybe<DealerRegMan>;
  regionalServiceManager?: Maybe<DealerRegMan>;
};

export type Document = {
  __typename?: "Document";
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  canceledReason?: Maybe<Scalars["String"]>;
  importance?: Maybe<Scalars["String"]>;
  signedBy?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  createdBy?: Maybe<Scalars["ID"]>;
  updatedBy?: Maybe<Scalars["ID"]>;
  sectionId?: Maybe<Scalars["ID"]>;
  subSectionId?: Maybe<Scalars["ID"]>;
  Section?: Maybe<Section>;
  SubSection?: Maybe<Section>;
  Files?: Maybe<Array<Maybe<File>>>;
  Subdivision?: Maybe<Subdivision>;
};

export type DocumentGetter = {
  __typename?: "DocumentGetter";
  getList?: Maybe<DocumentsList>;
  getOne?: Maybe<Document>;
  getSections?: Maybe<SectionsList>;
  getOneSection?: Maybe<Section>;
  getFolder?: Maybe<FolderContentList>;
};

export type DocumentGetterGetListArgs = {
  sectionId?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  importance?: Maybe<Scalars["String"]>;
  signedBy?: Maybe<Scalars["String"]>;
  createdAtFrom?: Maybe<Scalars["DateTime"]>;
  createdAtTo?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

export type DocumentGetterGetOneArgs = {
  id?: Maybe<Scalars["ID"]>;
};

export type DocumentGetterGetSectionsArgs = {
  parentId?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

export type DocumentGetterGetOneSectionArgs = {
  id?: Maybe<Scalars["ID"]>;
};

export type DocumentGetterGetFolderArgs = {
  id?: Maybe<Scalars["ID"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

export type DocumentLog = {
  __typename?: "DocumentLog";
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  canceledReason?: Maybe<Scalars["String"]>;
  importance?: Maybe<Scalars["String"]>;
  signedBy?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  createdBy?: Maybe<Scalars["ID"]>;
  updatedBy?: Maybe<Scalars["ID"]>;
  sectionId?: Maybe<Scalars["ID"]>;
  subSectionId?: Maybe<Scalars["ID"]>;
  Section?: Maybe<Section>;
  SubSection?: Maybe<Section>;
  Files?: Maybe<Array<Maybe<File>>>;
  Subdivision?: Maybe<Subdivision>;
};

export type DocumentSetter = {
  __typename?: "DocumentSetter";
  create?: Maybe<Document>;
  edit?: Maybe<Document>;
  setStatus?: Maybe<Document>;
  createSection?: Maybe<Section>;
  editSection?: Maybe<Section>;
  deleteSection?: Maybe<Section>;
};

export type DocumentSetterCreateArgs = {
  name?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  importance?: Maybe<Scalars["String"]>;
  signedBy?: Maybe<Scalars["String"]>;
  sectionId?: Maybe<Scalars["ID"]>;
  subSectionId?: Maybe<Scalars["ID"]>;
  SubdivisionId?: Maybe<Scalars["ID"]>;
  status?: Maybe<Scalars["String"]>;
  filesIds: Array<Maybe<Scalars["ID"]>>;
};

export type DocumentSetterEditArgs = {
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  importance?: Maybe<Scalars["String"]>;
  signedBy?: Maybe<Scalars["String"]>;
  SubdivisionId?: Maybe<Scalars["ID"]>;
  status?: Maybe<Scalars["String"]>;
  sectionId?: Maybe<Scalars["ID"]>;
  subSectionId?: Maybe<Scalars["ID"]>;
  filesId?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

export type DocumentSetterSetStatusArgs = {
  id?: Maybe<Scalars["ID"]>;
  status?: Maybe<Scalars["String"]>;
  canceledReason?: Maybe<Scalars["String"]>;
};

export type DocumentSetterCreateSectionArgs = {
  name?: Maybe<Scalars["String"]>;
  parentId?: Maybe<Scalars["ID"]>;
};

export type DocumentSetterEditSectionArgs = {
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  parentId?: Maybe<Scalars["ID"]>;
};

export type DocumentSetterDeleteSectionArgs = {
  id?: Maybe<Scalars["ID"]>;
};

export type DocumentsList = {
  __typename?: "DocumentsList";
  items?: Maybe<Array<Maybe<Document>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type EditEmployeePositionInput = {
  number: EmployeePositionNumber;
  startDate: Scalars["DateTime"];
  startOrderNumber?: Maybe<Scalars["String"]>;
  endDate?: Maybe<Scalars["DateTime"]>;
  endOrderNumber?: Maybe<Scalars["String"]>;
  dealerId: Scalars["ID"];
  positionId: Scalars["ID"];
  dataConsentId: Scalars["ID"];
  positionOrderId?: Maybe<Scalars["ID"]>;
  jobDescriptionId?: Maybe<Scalars["ID"]>;
};

/** Получение данных о Education */
export type EducationGetter = {
  __typename?: "EducationGetter";
  /** Получить курс по айди */
  getCourseCurriculumById?: Maybe<CourseCurriculum>;
  /** Получить группу по айди */
  getGroupCurriculumById?: Maybe<GroupCurriculum>;
  /** Получить уровень по айди */
  getLevelCurriculumById?: Maybe<LevelCurriculum>;
  /** Получить курс по айди */
  getListCurriculumCatalog?: Maybe<GetListCurriculumCatalog>;
  /** Получить курсы по параметрам */
  getListCourseCurriculum?: Maybe<GetCourseCurriculumByParams>;
  /** Получение списка уровней с пагинацией */
  getListLevelCurriculum?: Maybe<GetListLevelCurriculum>;
  /** Получение списка групп с пагинацией */
  getListGroupCurriculum?: Maybe<GetListGroupCurriculum>;
  /** Получить курсы по параметрам */
  getListCourseBySortLevelId?: Maybe<GetCourseCurriculumByParams>;
  /** Получение списка каталога для построения таблицы. С группировкой по уровням. Не относится к приложению 2. */
  getListCatalogGroupByLevel?: Maybe<Array<Maybe<LevelCurriculumIsGroup>>>;
  /** Получение должностей где есть учебная программа */
  getPositionIsTheEducationPrograms?: Maybe<GetPositionIsTheEducationPrograms>;
  /** Получение должностей где нет учебной программы */
  getPositionsInNotEducationPrograms?: Maybe<GetPositionsInNotEducationPrograms>;
  /** Получение состава учебной программы */
  getCompositionPositionPrograms?: Maybe<GetCompositionPositionPrograms>;
  /** Таблица c обучением сотрудников */
  getTableEducationDealerGroupByPositions?: Maybe<ReportFile>;
};

/** Получение данных о Education */
export type EducationGetterGetCourseCurriculumByIdArgs = {
  id: Scalars["ID"];
};

/** Получение данных о Education */
export type EducationGetterGetGroupCurriculumByIdArgs = {
  id: Scalars["ID"];
};

/** Получение данных о Education */
export type EducationGetterGetLevelCurriculumByIdArgs = {
  id: Scalars["ID"];
};

/** Получение данных о Education */
export type EducationGetterGetListCurriculumCatalogArgs = {
  id?: Maybe<Scalars["ID"]>;
  GroupId?: Maybe<Scalars["ID"]>;
  LevelId?: Maybe<Scalars["ID"]>;
  CourseId?: Maybe<Scalars["ID"]>;
  ActualOn?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

/** Получение данных о Education */
export type EducationGetterGetListCourseCurriculumArgs = {
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["ID"]>;
  status?: Maybe<CurriculumCourseStatus>;
  name?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  codeIS?: Maybe<Scalars["String"]>;
  ids?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  certificateValidityPeriod?: Maybe<Scalars["Int"]>;
  orderBy?: Maybe<CourseOrderBy>;
  order?: Maybe<SortType>;
  LevelIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  ActualOn?: Maybe<Scalars["DateTime"]>;
};

/** Получение данных о Education */
export type EducationGetterGetListLevelCurriculumArgs = {
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  status?: Maybe<CurriculumLevelStatus>;
  name?: Maybe<Scalars["String"]>;
  order?: Maybe<SortType>;
  orderBy?: Maybe<LevelsOrderBy>;
  ActualOn?: Maybe<Scalars["DateTime"]>;
};

/** Получение данных о Education */
export type EducationGetterGetListGroupCurriculumArgs = {
  id?: Maybe<Scalars["ID"]>;
  ids?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  name?: Maybe<Scalars["String"]>;
  status?: Maybe<CurriculumGroupStatus>;
  order?: Maybe<SortType>;
  orderBy?: Maybe<GroupOrderBy>;
  ActualOn?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

/** Получение данных о Education */
export type EducationGetterGetListCourseBySortLevelIdArgs = {
  status?: Maybe<CurriculumCourseStatus>;
  name?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  codeIS?: Maybe<Scalars["String"]>;
  certificateValidityPeriod?: Maybe<Scalars["Int"]>;
  order?: Maybe<SortType>;
  LevelId: Scalars["ID"];
  orderBy?: Maybe<CourseOrderBy>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  ActualOn?: Maybe<Scalars["DateTime"]>;
};

/** Получение данных о Education */
export type EducationGetterGetListCatalogGroupByLevelArgs = {
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  ActualOn?: Maybe<Scalars["DateTime"]>;
};

/** Получение данных о Education */
export type EducationGetterGetPositionIsTheEducationProgramsArgs = {
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
};

/** Получение данных о Education */
export type EducationGetterGetPositionsInNotEducationProgramsArgs = {
  name?: Maybe<Scalars["String"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

/** Получение данных о Education */
export type EducationGetterGetCompositionPositionProgramsArgs = {
  PositionGroupId: Scalars["ID"];
  ActualOn?: Maybe<Scalars["DateTime"]>;
};

/** Получение данных о Education */
export type EducationGetterGetTableEducationDealerGroupByPositionsArgs = {
  dealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Изменение данных о Education */
export type EducationSetter = {
  __typename?: "EducationSetter";
  /** Создание каталога */
  createCurriculumCatalog?: Maybe<CatalogCurriculum>;
  /** Создание группы */
  createCurriculumGroup?: Maybe<GroupCurriculum>;
  /** Создание уровней */
  createCurriculumLevel?: Maybe<LevelCurriculum>;
  /** Создание курса */
  createCurriculumCourse?: Maybe<CourseCurriculum>;
  /** Создание */
  createCurriculumPositionStudyPrograms?: Maybe<
    Array<Maybe<CurriculumStudyPrograms>>
  >;
  /** Редактирование уровня */
  editCurriculumLevel?: Maybe<LevelCurriculum>;
  /** Редактирование группы */
  editCurriculumGroup?: Maybe<GroupCurriculum>;
  /** Редактирование курса */
  editCurriculumCourse?: Maybe<CourseCurriculum>;
  /** Изменение учебной программы для должности пачкой из уровней и курсов */
  editCurriculumPositionStudyPrograms?: Maybe<
    Array<Maybe<ReturnEditCurriculumPositionStudyPrograms>>
  >;
  /** Изменение учебной программы для должности */
  editCurriculumPositionStudyProgram?: Maybe<CurriculumStudyPrograms>;
  /** Удаление курса */
  deleteCurriculumCourse?: Maybe<Scalars["Boolean"]>;
  /** Удаление группы */
  deleteCurriculumGroup?: Maybe<Scalars["Boolean"]>;
  /** Удаление уровня */
  deleteCurriculumLevel?: Maybe<Scalars["Boolean"]>;
  /** Удаление каталога */
  deleteCurriculumCatalog?: Maybe<Scalars["Boolean"]>;
};

/** Изменение данных о Education */
export type EducationSetterCreateCurriculumCatalogArgs = {
  GroupId: Scalars["ID"];
  LevelId: Scalars["ID"];
  CourseId: Scalars["ID"];
};

/** Изменение данных о Education */
export type EducationSetterCreateCurriculumGroupArgs = {
  name: Scalars["String"];
  status: CurriculumGroupStatus;
  sequenceNumber?: Maybe<Scalars["Int"]>;
};

/** Изменение данных о Education */
export type EducationSetterCreateCurriculumLevelArgs = {
  name: Scalars["String"];
  status: CurriculumLevelStatus;
  GroupId: Scalars["ID"];
  sequenceNumber?: Maybe<Scalars["Int"]>;
  isCertification?: Maybe<Scalars["Boolean"]>;
};

/** Изменение данных о Education */
export type EducationSetterCreateCurriculumCourseArgs = {
  code: Scalars["String"];
  codeIS?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  LevelId?: Maybe<Scalars["ID"]>;
  status?: Maybe<CurriculumCourseStatus>;
  certificateValidityPeriod?: Maybe<Scalars["ID"]>;
};

/** Изменение данных о Education */
export type EducationSetterCreateCurriculumPositionStudyProgramsArgs = {
  levels?: Maybe<Array<Maybe<CreateCurriculumPositionStudyProgramsLevels>>>;
  PositionIds: Array<Maybe<Scalars["ID"]>>;
};

/** Изменение данных о Education */
export type EducationSetterEditCurriculumLevelArgs = {
  id: Scalars["ID"];
  GroupId?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  status?: Maybe<CurriculumLevelStatus>;
  sequenceNumber?: Maybe<Scalars["Int"]>;
  isCertification?: Maybe<Scalars["Boolean"]>;
  dateActiveStatus?: Maybe<Scalars["DateTime"]>;
  dateInactiveStatus?: Maybe<Scalars["DateTime"]>;
};

/** Изменение данных о Education */
export type EducationSetterEditCurriculumGroupArgs = {
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  status?: Maybe<CurriculumGroupStatus>;
  dateActiveStatus?: Maybe<Scalars["DateTime"]>;
  dateInactiveStatus?: Maybe<Scalars["DateTime"]>;
  sequenceNumber?: Maybe<Scalars["Int"]>;
};

/** Изменение данных о Education */
export type EducationSetterEditCurriculumCourseArgs = {
  id: Scalars["ID"];
  code?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  status?: Maybe<CurriculumCourseStatus>;
  codeIS?: Maybe<Scalars["String"]>;
  LevelId?: Maybe<Scalars["ID"]>;
  certificateValidityPeriod?: Maybe<Scalars["ID"]>;
};

/** Изменение данных о Education */
export type EducationSetterEditCurriculumPositionStudyProgramsArgs = {
  levels?: Maybe<Array<Maybe<CreateCurriculumPositionStudyProgramsLevels>>>;
  PositionGroupId?: Maybe<Scalars["ID"]>;
  PositionIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Изменение данных о Education */
export type EducationSetterEditCurriculumPositionStudyProgramArgs = {
  PositionGroupId: Scalars["ID"];
  LevelId?: Maybe<Scalars["ID"]>;
  CourseId: Scalars["ID"];
  dateActiveStatus?: Maybe<Scalars["DateTime"]>;
  dateInactiveStatus?: Maybe<Scalars["DateTime"]>;
  status?: Maybe<CurriculumPositionsStudyProgramsStatus>;
};

/** Изменение данных о Education */
export type EducationSetterDeleteCurriculumCourseArgs = {
  id: Scalars["ID"];
};

/** Изменение данных о Education */
export type EducationSetterDeleteCurriculumGroupArgs = {
  id: Scalars["ID"];
};

/** Изменение данных о Education */
export type EducationSetterDeleteCurriculumLevelArgs = {
  id: Scalars["ID"];
};

/** Изменение данных о Education */
export type EducationSetterDeleteCurriculumCatalogArgs = {
  id: Scalars["ID"];
};

export type EmailLogListItem = {
  __typename?: "EmailLogListItem";
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  subject?: Maybe<Scalars["String"]>;
  customs?: Maybe<Scalars["String"]>;
  sent?: Maybe<Scalars["Boolean"]>;
  decidedToSend?: Maybe<Scalars["Boolean"]>;
  error?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  dealers?: Maybe<Array<Maybe<Dealer>>>;
  users?: Maybe<Array<Maybe<Profile>>>;
};

/** Список */
export type EmailLogListList = {
  __typename?: "EmailLogListList";
  items: Array<Maybe<EmailLogListItem>>;
  total: Scalars["Int"];
};

/** Вывод email сторудника */
export type EmoloyeeEmailList = {
  __typename?: "EmoloyeeEmailList";
  items?: Maybe<Array<Maybe<EmployeeEmailType>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type Employee = {
  __typename?: "Employee";
  id?: Maybe<Scalars["ID"]>;
  surname?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  middleName?: Maybe<Scalars["String"]>;
  gender: GenderType;
  birthDay?: Maybe<Scalars["DateTime"]>;
  personalPhone?: Maybe<Scalars["String"]>;
  workPhone?: Maybe<Scalars["String"]>;
  DataConsent?: Maybe<File>;
  Photo?: Maybe<File>;
  photoId?: Maybe<Scalars["ID"]>;
  ResourcesControlUserId?: Maybe<Scalars["String"]>;
  HiredDate?: Maybe<Scalars["DateTime"]>;
  FiredDate?: Maybe<Scalars["DateTime"]>;
  ladaAcademiaId?: Maybe<Scalars["String"]>;
  Dealers?: Maybe<Array<Maybe<Dealer>>>;
  importDate?: Maybe<Scalars["DateTime"]>;
  Positions?: Maybe<Array<Maybe<EmployeePositionsGroupByNumber>>>;
  /** Основная должность сотрудника */
  MainActivePosition?: Maybe<EmployeePositions>;
  /** @deprecated используйте Positions */
  PositionsNew?: Maybe<Array<Maybe<EmployeePositionsGroupByNumber>>>;
  lastEditDate?: Maybe<Scalars["DateTime"]>;
  lastEditBy?: Maybe<Scalars["ID"]>;
  createdBy?: Maybe<Scalars["ID"]>;
  firedAt?: Maybe<Scalars["DateTime"]>;
  firedBy?: Maybe<Scalars["ID"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  statusEmployee?: Maybe<EmployeeStatus>;
  lastStatusUpdateAt?: Maybe<Scalars["DateTime"]>;
  lastStatusUpdateBy?: Maybe<Scalars["ID"]>;
  lastStatusUpdateByUser?: Maybe<Profile>;
  verifiedAt?: Maybe<Scalars["DateTime"]>;
  verifiedBy?: Maybe<Scalars["ID"]>;
  CreatedByUser?: Maybe<Profile>;
  LastEditByUser?: Maybe<Profile>;
  FiredByUser?: Maybe<Profile>;
  VerifiedByUser?: Maybe<Profile>;
  Consents?: Maybe<Array<Maybe<EmployeeConsent>>>;
  shouldShowUpdateStatusDate?: Maybe<Scalars["Boolean"]>;
};

export type EmployeeConsent = {
  __typename?: "EmployeeConsent";
  id?: Maybe<Scalars["ID"]>;
  fileId?: Maybe<Scalars["ID"]>;
  employeeId?: Maybe<Scalars["ID"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  File?: Maybe<File>;
  systemId?: Maybe<Scalars["ID"]>;
  personalInfoId?: Maybe<Scalars["ID"]>;
  PersonalInfo?: Maybe<PersonalInformation>;
};

export enum EmployeeEducationCertificateStatus {
  PassedCertification = "passedCertification",
  NotCertified = "notCertified",
  NotProvided = "notProvided",
  ExpiredCertification = "expiredCertification",
}

export enum EmployeeEducationTrainingStatus {
  IsNotTrained = "isNotTrained",
  ProcessLearning = "processLearning",
  Trained = "trained",
  NotProvided = "notProvided",
}

/** Вывод почты связанной с должностью пользователя */
export type EmployeeEmailType = {
  __typename?: "EmployeeEmailType";
  id?: Maybe<Scalars["ID"]>;
  email?: Maybe<Scalars["String"]>;
  EmployeesId: Scalars["ID"];
};

/** Строка таблицы EmployeeExpectation */
export type EmployeeExpectation = {
  __typename?: "EmployeeExpectation";
  id?: Maybe<Scalars["ID"]>;
  /** @deprecated Не используется */
  name?: Maybe<Scalars["String"]>;
  method?: Maybe<Scalars["String"]>;
  methodEn?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  combineCertification?: Maybe<Scalars["Boolean"]>;
  combineTraining?: Maybe<Scalars["Boolean"]>;
  isCombining?: Maybe<Scalars["Boolean"]>;
  Positions?: Maybe<Array<Maybe<Position>>>;
  /** @deprecated больше не будет поддерживаться такая структура */
  GroupTrainingId?: Maybe<Scalars["ID"]>;
  /** @deprecated больше не будет поддерживаться такая структура */
  GroupCertificateId?: Maybe<Scalars["ID"]>;
  /** @deprecated больше не будет поддерживаться такая структура */
  GroupCertificationId?: Maybe<Scalars["ID"]>;
  number?: Maybe<number>;
  training?: Maybe<Training>;
  certificationProgress?: Maybe<Certification>;
};

export type EmployeeExpectationGroupScheme = {
  __typename?: "EmployeeExpectationGroupScheme";
  GroupTrainingId?: Maybe<Scalars["ID"]>;
  GroupCertificationId?: Maybe<Scalars["ID"]>;
  GroupTraining?: Maybe<GroupCurriculum>;
  GroupCertification?: Maybe<GroupCurriculum>;
};

export type EmployeeForProfile = {
  __typename?: "EmployeeForProfile";
  id?: Maybe<Scalars["ID"]>;
  surname?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  middleName?: Maybe<Scalars["String"]>;
};

/** Получение данных о Employees */
export type EmployeeGetter = {
  __typename?: "EmployeeGetter";
  /** Получить сотрудника */
  get?: Maybe<Employee>;
  getList?: Maybe<GetEmployeeList>;
  getEmployeeReport?: Maybe<ReportFile>;
  /** Проверка доступности почтового адреса. Уникальный емаил не требуется */
  checkValidEmailDomain?: Maybe<Scalars["Boolean"]>;
  /** Получить список email сторудника */
  GetEmployeeEmails?: Maybe<EmoloyeeEmailList>;
  /** Проверка почты сотрудника. Проверка уникальности емаил */
  CheckEmployeeEmail?: Maybe<Scalars["Boolean"]>;
  /** Получить должности сотрудника */
  getEmployeePositions?: Maybe<Array<Maybe<EmployeePositionsGroupByNumber>>>;
  /** Получить закрепленные группы обучения для показателей */
  getGroupEducationEmployeeExpectation?: Maybe<EmployeeExpectationGroupScheme>;
};

/** Получение данных о Employees */
export type EmployeeGetterGetArgs = {
  id: Scalars["ID"];
};

/** Получение данных о Employees */
export type EmployeeGetterGetListArgs = {
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  PositionIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  ladaAcademiaIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  id?: Maybe<Scalars["ID"]>;
  surname?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  middleName?: Maybe<Scalars["String"]>;
  personalPhone?: Maybe<Scalars["String"]>;
  workPhone?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  creationFrom?: Maybe<Scalars["DateTime"]>;
  creationTo?: Maybe<Scalars["DateTime"]>;
  lastEditFrom?: Maybe<Scalars["DateTime"]>;
  lastEditTo?: Maybe<Scalars["DateTime"]>;
  emailVerification?: Maybe<Scalars["Boolean"]>;
  statuses?: Maybe<Array<Maybe<EmployeePositionStatus>>>;
  order?: Maybe<SortType>;
  orderBy?: Maybe<OrderByColumnInEmployees>;
  ActualOn?: Maybe<Scalars["DateTime"]>;
  searchText?: Maybe<Scalars["String"]>;
};

/** Получение данных о Employees */
export type EmployeeGetterGetEmployeeReportArgs = {
  PositionsIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  PositionIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  ladaAcademiaIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  id?: Maybe<Scalars["ID"]>;
  surname?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  middleName?: Maybe<Scalars["String"]>;
  personalPhone?: Maybe<Scalars["String"]>;
  workPhone?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  creationFrom?: Maybe<Scalars["DateTime"]>;
  creationTo?: Maybe<Scalars["DateTime"]>;
  lastEditFrom?: Maybe<Scalars["DateTime"]>;
  lastEditTo?: Maybe<Scalars["DateTime"]>;
  statuses?: Maybe<Array<Maybe<EmployeePositionStatus>>>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  emailVerification?: Maybe<Scalars["Boolean"]>;
  isNotPosition?: Maybe<Scalars["Boolean"]>;
  order?: Maybe<SortType>;
  orderBy?: Maybe<OrderByColumnInEmployees>;
  ActualOn?: Maybe<Scalars["DateTime"]>;
};

/** Получение данных о Employees */
export type EmployeeGetterCheckValidEmailDomainArgs = {
  email: Scalars["String"];
  dealersId?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  employeesId?: Maybe<Scalars["ID"]>;
};

/** Получение данных о Employees */
export type EmployeeGetterGetEmployeeEmailsArgs = {
  EmployeeId?: Maybe<Scalars["ID"]>;
};

/** Получение данных о Employees */
export type EmployeeGetterCheckEmployeeEmailArgs = {
  email: Scalars["String"];
  EmployeesId?: Maybe<Scalars["ID"]>;
  DealersId?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение данных о Employees */
export type EmployeeGetterGetEmployeePositionsArgs = {
  id: Scalars["ID"];
};

export type EmployeeLog = {
  __typename?: "EmployeeLog";
  id?: Maybe<Scalars["ID"]>;
  surname?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  middleName?: Maybe<Scalars["String"]>;
  gender?: Maybe<GenderTypeLog>;
  birthDay?: Maybe<Scalars["DateTime"]>;
  email?: Maybe<Scalars["String"]>;
  personalPhone?: Maybe<Scalars["String"]>;
  workPhone?: Maybe<Scalars["String"]>;
  DataConsent?: Maybe<File>;
  Photo?: Maybe<File>;
  DataConsentId?: Maybe<Scalars["ID"]>;
  photoId?: Maybe<Scalars["ID"]>;
  ResourcesControlUserId?: Maybe<Scalars["String"]>;
  HiredDate?: Maybe<Scalars["DateTime"]>;
  FiredDate?: Maybe<Scalars["DateTime"]>;
  positions?: Maybe<Array<Maybe<EmployeePositionLog>>>;
  lastEditDate?: Maybe<Scalars["DateTime"]>;
  createdBy?: Maybe<Scalars["ID"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
};

/** Статистика обученности для должности сотрудника.notProvided - не предусмотрена */
export type EmployeePositionEducation = {
  __typename?: "EmployeePositionEducation";
  /** Статус обучения по всей группе с обучения: trained - пройдена; processLearning - в процессе прохождения; isNotTrained - не пройдена; */
  training?: Maybe<EmployeeEducationTrainingStatus>;
  /** Статус сертификации по всей группе сертификации: passedCertification - пройдена; notCertified - не пройдена; */
  certificate?: Maybe<EmployeeEducationCertificateStatus>;
};

export type EmployeePositionInput = {
  number: EmployeePositionNumber;
  PositionsId?: Maybe<Scalars["ID"]>;
  Positions?: Maybe<Array<Maybe<EmployeePositionInputPositions>>>;
};

export type EmployeePositionInputPositions = {
  id?: Maybe<Scalars["ID"]>;
  InstanceId?: Maybe<Scalars["ID"]>;
  email?: Maybe<Scalars["String"]>;
  /** согласие на обработку персональных данных */
  DataConsentId: Scalars["ID"];
  positionOrderId: Scalars["ID"];
  startDate: Scalars["DateTime"];
  startOrderNumber: Scalars["String"];
  endDate?: Maybe<Scalars["DateTime"]>;
  endOrderNumber?: Maybe<Scalars["String"]>;
  createdBy?: Maybe<Scalars["ID"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  PositionsId?: Maybe<Scalars["ID"]>;
  DealerId: Scalars["ID"];
};

export type EmployeePositionLog = {
  __typename?: "EmployeePositionLog";
  id?: Maybe<Scalars["ID"]>;
  EmployeesId?: Maybe<Scalars["ID"]>;
  number?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  startDate?: Maybe<Scalars["DateTime"]>;
  startOrderNumber?: Maybe<Scalars["String"]>;
  endDate?: Maybe<Scalars["DateTime"]>;
  endOrderNumber?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  createdBy?: Maybe<Scalars["ID"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  Dealer?: Maybe<DealerData>;
};

export enum EmployeePositionNumber {
  One = "one",
  Two = "two",
  Three = "three",
  Four = "four",
}

export enum EmployeePositionStatus {
  Unverified = "unverified",
  Verified = "verified",
  Fired = "fired",
  TemporaryUnavailable = "temporaryUnavailable",
  Archive = "archive",
  SendCheck = "sendCheck",
  Rejected = "rejected",
}

export type EmployeePositions = {
  __typename?: "EmployeePositions";
  id?: Maybe<Scalars["ID"]>;
  InstanceId?: Maybe<Scalars["ID"]>;
  selectedDomainId?: Maybe<Scalars["ID"]>;
  email?: Maybe<Scalars["String"]>;
  /** согласие на обработку персональных данных */
  DataConsentId?: Maybe<Scalars["ID"]>;
  positionOrderId?: Maybe<Scalars["ID"]>;
  startDate?: Maybe<Scalars["DateTime"]>;
  startOrderNumber?: Maybe<Scalars["String"]>;
  endDate?: Maybe<Scalars["DateTime"]>;
  endOrderNumber?: Maybe<Scalars["String"]>;
  createdBy?: Maybe<Scalars["ID"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  PositionsId?: Maybe<Scalars["ID"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  createdByUser?: Maybe<Profile>;
  Dealer?: Maybe<Dealer>;
  hireByUser?: Maybe<Profile>;
  fireByUser?: Maybe<Profile>;
  verifyByUser?: Maybe<Profile>;
  lastModifiedByUser?: Maybe<Profile>;
  status?: Maybe<EmployeePositionStatus>;
  lastStatusUpdateAt?: Maybe<Scalars["DateTime"]>;
  lastModifiedBy?: Maybe<Scalars["ID"]>;
  lastModifiedAt?: Maybe<Scalars["DateTime"]>;
  hireBy?: Maybe<Scalars["ID"]>;
  verifyBy?: Maybe<Scalars["ID"]>;
  verifyDate?: Maybe<Scalars["DateTime"]>;
  fireBy?: Maybe<Scalars["ID"]>;
  lastStatusUpdateByUser?: Maybe<Profile>;
  lastStatusUpdateBy?: Maybe<Scalars["ID"]>;
  /** Согласие на обработку персональных данных */
  DataConsent?: Maybe<File>;
  positionOrder?: Maybe<File>;
  /** Файл должностной инструкции */
  jobDescriptionId?: Maybe<Scalars["ID"]>;
  /** Файл должностной инструкции */
  jobDescription?: Maybe<File>;
  Position?: Maybe<Position>;
  emailVerificarion?: Maybe<Scalars["Boolean"]>;
  number?: Maybe<Scalars["Int"]>;
};

export type EmployeePositionsField = {
  __typename?: "EmployeePositionsField";
  PositionsId?: Maybe<Scalars["ID"]>;
  Position?: Maybe<Position>;
  Education?: Maybe<EmployeePositionEducation>;
  /** Информация о должности сотрудника */
  Positions?: Maybe<Array<Maybe<EmployeePositions>>>;
};

/** Группировка по признаку номер должности с историей должностей */
export type EmployeePositionsGroupByNumber = {
  __typename?: "EmployeePositionsGroupByNumber";
  number: EmployeePositionNumber;
  ActivePosition?: Maybe<EmployeePositionsField>;
  InactivePositions?: Maybe<Array<Maybe<EmployeePositionsField>>>;
};

/** Изменение данных о Employees */
export type EmployeeSetter = {
  __typename?: "EmployeeSetter";
  /** Создание сотрудника */
  create?: Maybe<CreateEmployee>;
  edit?: Maybe<Scalars["Boolean"]>;
  changeStatus?: Maybe<ChangeStatus>;
  /** продлить действие статуса */
  updateLastStatusDatePositionDealer?: Maybe<Scalars["Boolean"]>;
  /** Добавление почты сотрудника по должности */
  SetEmployeeEmail?: Maybe<EmployeeEmailType>;
  setGroupEducationEmployeeExpectationIndicator?: Maybe<Scalars["Boolean"]>;
  /** восстановить должность сотруднику в карточке сотрудника: админ, админ данных */
  restorePositionEmployee?: Maybe<Scalars["Boolean"]>;
};

/** Изменение данных о Employees */
export type EmployeeSetterCreateArgs = {
  surname: Scalars["String"];
  name: Scalars["String"];
  middleName?: Maybe<Scalars["String"]>;
  gender: GenderType;
  birthDay: Scalars["DateTime"];
  personalPhone?: Maybe<Scalars["String"]>;
  workPhone: Scalars["String"];
  photoId?: Maybe<Scalars["ID"]>;
  ResourcesControlUserId?: Maybe<Scalars["String"]>;
  HiredDate: Scalars["DateTime"];
  ladaAcademiaId: Scalars["String"];
  DataConsentIds?: Maybe<Array<Maybe<Consent>>>;
  positions?: Maybe<Array<EmployeePositionInput>>;
  ignore?: Maybe<Scalars["Boolean"]>;
};

/** Изменение данных о Employees */
export type EmployeeSetterEditArgs = {
  id: Scalars["ID"];
  photoId: Scalars["ID"];
  firedDate?: Maybe<Scalars["DateTime"]>;
  positions: Array<EditEmployeePositionInput>;
};

/** Изменение данных о Employees */
export type EmployeeSetterUpdateLastStatusDatePositionDealerArgs = {
  EmployeeId: Scalars["ID"];
  EmployeePositionId: Scalars["ID"];
};

/** Изменение данных о Employees */
export type EmployeeSetterSetEmployeeEmailArgs = {
  email: Scalars["String"];
  EmployeesId: Scalars["ID"];
  DealerId: Scalars["ID"];
  PositionsId: Scalars["ID"];
};

/** Изменение данных о Employees */
export type EmployeeSetterSetGroupEducationEmployeeExpectationIndicatorArgs = {
  GroupTrainingId?: Maybe<Scalars["ID"]>;
  GroupCertificateId?: Maybe<Scalars["ID"]>;
  GroupCertificationId?: Maybe<Scalars["ID"]>;
};

/** Изменение данных о Employees */
export type EmployeeSetterRestorePositionEmployeeArgs = {
  EmployeeId: Scalars["ID"];
  PositionId: Scalars["ID"];
  DealerId: Scalars["ID"];
  number: EmployeePositionNumber;
};

export enum EmployeeStatus {
  Unverified = "unverified",
  Verified = "verified",
  Fired = "fired",
  TemporaryUnavailable = "temporaryUnavailable",
  Archive = "archive",
}

export type EmployeeWithPosition = {
  __typename?: "EmployeeWithPosition";
  Employee?: Maybe<PureEmployee>;
  EmployeePosition?: Maybe<PureEmployeePosition>;
  Position?: Maybe<PurePosition>;
  Direction?: Maybe<PurePositionDirection>;
  Dealer?: Maybe<PureDealer>;
};

/** федеральные округ */
export type Fo = {
  __typename?: "FO";
  name: Scalars["String"];
  subjects: Array<Maybe<Subject>>;
};

/** Строки для отчета возвращение автомобилей на ТО (свой) по месяцу контроля */
export type FoForAgoByMonth = {
  __typename?: "FOForAGOByMonth";
  FO?: Maybe<Scalars["String"]>;
  FOEn?: Maybe<Scalars["String"]>;
  counts?: Maybe<Scalars["String"]>;
  GO1?: Maybe<ToForServiceByMonth>;
  GO2?: Maybe<ToForServiceByMonth>;
  GO3?: Maybe<ToForServiceByMonth>;
};

/** Строки для отчета Машинозаезды по дилерам */
export type FoForServiceByDealer = {
  __typename?: "FOForServiceByDealer";
  FO?: Maybe<Scalars["String"]>;
  FOEn?: Maybe<Scalars["String"]>;
  periods?: Maybe<Array<Maybe<ToPeriod>>>;
};

/** Строки для отчета возвращение автомобилей на ТО (свой) по месяцу контроля */
export type FoForServiceByMonth = {
  __typename?: "FOForServiceByMonth";
  FO?: Maybe<Scalars["String"]>;
  FOEn?: Maybe<Scalars["String"]>;
  counts?: Maybe<Scalars["String"]>;
  family?: Maybe<Scalars["String"]>;
  TO0?: Maybe<ToForServiceByMonth>;
  TO1?: Maybe<ToForServiceByMonth>;
  TO2?: Maybe<ToForServiceByMonth>;
  TO3?: Maybe<ToForServiceByMonth>;
  TO4?: Maybe<ToForServiceByMonth>;
  TO5?: Maybe<ToForServiceByMonth>;
  TO6?: Maybe<ToForServiceByMonth>;
  TO7?: Maybe<ToForServiceByMonth>;
  TO8?: Maybe<ToForServiceByMonth>;
};

/** Список семейств автомобиля */
export type FamilyCarList = {
  __typename?: "FamilyCarList";
  items?: Maybe<Array<Maybe<FamilyCar>>>;
  total?: Maybe<Scalars["Int"]>;
};

/** Список объектов для выпадающего списка */
export type FieldList = {
  __typename?: "FieldList";
  items?: Maybe<Array<Maybe<Scalars["String"]>>>;
  itemsEn?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

/** файл */
export type File = {
  __typename?: "File";
  id?: Maybe<Scalars["ID"]>;
  User?: Maybe<Profile>;
  name?: Maybe<Scalars["String"]>;
  link?: Maybe<Scalars["String"]>;
  mimeType?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  type?: Maybe<Scalars["String"]>;
  hash?: Maybe<Scalars["String"]>;
};

/** Получение данных о файлах */
export type FileCatalogGetter = {
  __typename?: "FileCatalogGetter";
  /** Получить структуру из дилеров */
  getThree?: Maybe<Array<Maybe<Fo>>>;
  /** Получить файлы дилера */
  getFiles?: Maybe<FileList>;
};

/** Получение данных о файлах */
export type FileCatalogGetterGetFilesArgs = {
  catalog?: Maybe<Scalars["String"]>;
  DealerId: Scalars["ID"];
  dateBegin?: Maybe<Scalars["DateTime"]>;
  dateEnd?: Maybe<Scalars["DateTime"]>;
  UserId?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  sortField?: Maybe<Scalars["String"]>;
  sortType?: Maybe<Scalars["String"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

/** Изменение данных о файлах */
export type FileCatalogSetter = {
  __typename?: "FileCatalogSetter";
  /** Загрузить файл */
  uploadFile?: Maybe<File>;
  /** Удалить файл */
  deleteFile?: Maybe<Scalars["Boolean"]>;
  /** редактировать файл */
  editFile?: Maybe<File>;
};

/** Изменение данных о файлах */
export type FileCatalogSetterUploadFileArgs = {
  fileId: Scalars["ID"];
  catalog: Scalars["String"];
  DealerId?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
};

/** Изменение данных о файлах */
export type FileCatalogSetterDeleteFileArgs = {
  FileId: Scalars["ID"];
};

/** Изменение данных о файлах */
export type FileCatalogSetterEditFileArgs = {
  FileId: Scalars["ID"];
  catalog?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

/** Получение данных о файлах */
export type FileGetter = {
  __typename?: "FileGetter";
  /** Получить файлы загруженные мной */
  getFiles?: Maybe<FileList>;
  /** Получить файл по id */
  getFile?: Maybe<File>;
  /** Получить файл по id */
  getFileByHash?: Maybe<File>;
};

/** Получение данных о файлах */
export type FileGetterGetFilesArgs = {
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  isAll?: Maybe<Scalars["Boolean"]>;
};

/** Получение данных о файлах */
export type FileGetterGetFileArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** Получение данных о файлах */
export type FileGetterGetFileByHashArgs = {
  hash?: Maybe<Scalars["String"]>;
};

/** Список файлов */
export type FileList = {
  __typename?: "FileList";
  items?: Maybe<Array<Maybe<File>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type FolderContent = {
  __typename?: "FolderContent";
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  updatedBy?: Maybe<Scalars["ID"]>;
  type?: Maybe<Scalars["String"]>;
  createdBy?: Maybe<Scalars["String"]>;
};

export type FolderContentList = {
  __typename?: "FolderContentList";
  items?: Maybe<Array<Maybe<FolderContent>>>;
  total?: Maybe<Scalars["Int"]>;
};

/** Список данные по ГИБДД */
export type GibddList = {
  __typename?: "GIBDDList";
  items?: Maybe<Array<Maybe<GibddType>>>;
  total?: Maybe<Scalars["Int"]>;
};

/** данные по ГИБДД */
export type GibddType = {
  __typename?: "GIBDDType";
  id: Scalars["ID"];
  vin: Scalars["String"];
  dateRegistration: Scalars["DateTime"];
  city: Scalars["String"];
  district: Scalars["String"];
  region: Scalars["String"];
  federalArea: Scalars["String"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
};

export enum GenderType {
  Male = "male",
  Female = "female",
}

export enum GenderTypeLog {
  Male = "male",
  Female = "female",
}

export type GeoGetter = {
  __typename?: "GeoGetter";
  getGeoPlaces?: Maybe<GetGeoPlacesList>;
  getGeoPlacesByParentId?: Maybe<Array<Maybe<GeoPlace>>>;
  getLocationsById?: Maybe<Locations>;
};

export type GeoGetterGetGeoPlacesArgs = {
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  cladrCode?: Maybe<Scalars["String"]>;
  okatoCode?: Maybe<Scalars["String"]>;
  type?: Maybe<GeoPlaceType>;
  parentId?: Maybe<Scalars["ID"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

export type GeoGetterGetGeoPlacesByParentIdArgs = {
  parentId: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  type?: Maybe<GeoPlaceType>;
};

export type GeoGetterGetLocationsByIdArgs = {
  id: Scalars["ID"];
};

/** Географский объект */
export type GeoPlace = {
  __typename?: "GeoPlace";
  id?: Maybe<Scalars["ID"]>;
  parentId?: Maybe<Scalars["ID"]>;
  type?: Maybe<GeoPlaceType>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  socr?: Maybe<Scalars["String"]>;
  cladrCode?: Maybe<Scalars["String"]>;
  okatoCode?: Maybe<Scalars["String"]>;
  active?: Maybe<Scalars["Boolean"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

export enum GeoPlaceType {
  Country = "country",
  Fo = "FO",
  Subject = "subject",
  District = "district",
  City = "city",
  Street = "street",
  House = "house",
}

export type GeoSetter = {
  __typename?: "GeoSetter";
  createGeoPlace?: Maybe<GeoPlace>;
  changeGeoPlace?: Maybe<Scalars["Boolean"]>;
};

export type GeoSetterCreateGeoPlaceArgs = {
  name: Scalars["String"];
  socr: Scalars["String"];
  cladrCode: Scalars["String"];
  okatoCode: Scalars["String"];
  type: GeoPlaceType;
  parentId?: Maybe<Scalars["ID"]>;
  active: Scalars["Boolean"];
};

export type GeoSetterChangeGeoPlaceArgs = {
  id: Scalars["ID"];
  name: Scalars["String"];
  socr: Scalars["String"];
  cladrCode: Scalars["String"];
  okatoCode: Scalars["String"];
  type: GeoPlaceType;
  parentId?: Maybe<Scalars["ID"]>;
  active: Scalars["Boolean"];
};

/** Строчка рейтинга со значениями */
export type GlobalRating = {
  __typename?: "GlobalRating";
  id?: Maybe<Scalars["ID"]>;
  number?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  quarter1?: Maybe<Scalars["ID"]>;
  quarter2?: Maybe<Scalars["ID"]>;
  quarter1_2?: Maybe<Scalars["ID"]>;
  quarter3?: Maybe<Scalars["ID"]>;
  quarter2_3?: Maybe<Scalars["ID"]>;
  quarter4?: Maybe<Scalars["ID"]>;
  quarter3_4?: Maybe<Scalars["ID"]>;
  yearValue?: Maybe<Scalars["ID"]>;
  yearPercent?: Maybe<Scalars["ID"]>;
  type?: Maybe<Scalars["String"]>;
  sort?: Maybe<Scalars["Int"]>;
  round?: Maybe<Scalars["Int"]>;
  format?: Maybe<Scalars["Int"]>;
  ParentId?: Maybe<Scalars["ID"]>;
  PrevElementId?: Maybe<Scalars["ID"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  RatingsVersionId?: Maybe<Scalars["ID"]>;
  IndicatorQuarter1?: Maybe<Indicator>;
  IndicatorQuarter1_2?: Maybe<Indicator>;
  IndicatorQuarter2?: Maybe<Indicator>;
  IndicatorQuarter2_3?: Maybe<Indicator>;
  IndicatorQuarter3?: Maybe<Indicator>;
  IndicatorQuarter3_4?: Maybe<Indicator>;
  IndicatorQuarter4?: Maybe<Indicator>;
  IndicatorYearValue?: Maybe<Indicator>;
  IndicatorYearPercent?: Maybe<Indicator>;
  Parent?: Maybe<GlobalRating>;
  PrevElement?: Maybe<GlobalRating>;
  Version?: Maybe<GlobalRatingVersion>;
};

/** Строчка рейтинга */
export type GlobalRatingData = {
  __typename?: "GlobalRatingData";
  quarter1?: Maybe<Array<Maybe<GlobalRating>>>;
  quarter2?: Maybe<Array<Maybe<GlobalRating>>>;
  quarter3?: Maybe<Array<Maybe<GlobalRating>>>;
  quarter4?: Maybe<Array<Maybe<GlobalRating>>>;
};

/** Получение данных о рейтингах */
export type GlobalRatingGetter = {
  __typename?: "GlobalRatingGetter";
  /** Получить список версий рейтингов */
  getVersions?: Maybe<Array<Maybe<GlobalRatingVersion>>>;
  /** Получить список строк версии рейтингов */
  getRatings?: Maybe<Array<Maybe<GlobalRating>>>;
  /** Получить версию рейтинга со значениями */
  getRatingData?: Maybe<GlobalRatingData>;
  /** Запрос полного отчёта */
  getFullReports?: Maybe<ReportFile>;
  /** Получить список строк версии рейтинга без значений индикатора, только имя */
  getRatingsListName?: Maybe<Array<Maybe<GlobalRatingName>>>;
};

/** Получение данных о рейтингах */
export type GlobalRatingGetterGetRatingsArgs = {
  onlyParent: Scalars["Boolean"];
  RatingsVersionId: Scalars["ID"];
};

/** Получение данных о рейтингах */
export type GlobalRatingGetterGetRatingDataArgs = {
  DealerId: Scalars["ID"];
  year: Scalars["Int"];
  isFull: Scalars["Boolean"];
};

/** Получение данных о рейтингах */
export type GlobalRatingGetterGetFullReportsArgs = {
  DealerId: Scalars["ID"];
  year: Scalars["Int"];
  isFull: Scalars["Boolean"];
  lang?: Maybe<Scalars["String"]>;
};

/** Получение данных о рейтингах */
export type GlobalRatingGetterGetRatingsListNameArgs = {
  onlyParent: Scalars["Boolean"];
  RatingsVersionId?: Maybe<Scalars["ID"]>;
  RatingsId?: Maybe<Scalars["ID"]>;
};

/** Строчка рейтинга только имена */
export type GlobalRatingName = {
  __typename?: "GlobalRatingName";
  id?: Maybe<Scalars["ID"]>;
  number?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  ParentId?: Maybe<Scalars["ID"]>;
  PrevElementId?: Maybe<Scalars["ID"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  RatingsVersionId?: Maybe<Scalars["ID"]>;
};

/** Изменение данных в рейтингах */
export type GlobalRatingSetter = {
  __typename?: "GlobalRatingSetter";
  /** создать/редактировать строчку в рейтинге */
  setRating?: Maybe<GlobalRating>;
  /** создать/редактировать версию в рейтинге */
  setVersion?: Maybe<GlobalRatingVersion>;
  /** удалить строчку в версии рейтинга */
  deleteList?: Maybe<Scalars["Boolean"]>;
  /** удалить версию в рейтинге */
  deleteVersion?: Maybe<Scalars["Boolean"]>;
};

/** Изменение данных в рейтингах */
export type GlobalRatingSetterSetRatingArgs = {
  id?: Maybe<Scalars["ID"]>;
  number?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  quarter1?: Maybe<Scalars["ID"]>;
  quarter2?: Maybe<Scalars["ID"]>;
  quarter1_2?: Maybe<Scalars["ID"]>;
  quarter3?: Maybe<Scalars["ID"]>;
  quarter2_3?: Maybe<Scalars["ID"]>;
  quarter4?: Maybe<Scalars["ID"]>;
  quarter3_4?: Maybe<Scalars["ID"]>;
  yearValue?: Maybe<Scalars["ID"]>;
  yearPercent?: Maybe<Scalars["ID"]>;
  type: Scalars["String"];
  sort: Scalars["Int"];
  round?: Maybe<Scalars["Int"]>;
  format?: Maybe<Scalars["Int"]>;
  ParentId?: Maybe<Scalars["ID"]>;
  PrevElementId?: Maybe<Scalars["ID"]>;
  RatingsVersionId: Scalars["ID"];
};

/** Изменение данных в рейтингах */
export type GlobalRatingSetterSetVersionArgs = {
  id?: Maybe<Scalars["ID"]>;
  quarter?: Maybe<Scalars["Int"]>;
  year?: Maybe<Scalars["Int"]>;
  dateBegin?: Maybe<Scalars["DateTime"]>;
  IndicatorId?: Maybe<Scalars["ID"]>;
};

/** Изменение данных в рейтингах */
export type GlobalRatingSetterDeleteListArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** Изменение данных в рейтингах */
export type GlobalRatingSetterDeleteVersionArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** Версия рейтинга */
export type GlobalRatingVersion = {
  __typename?: "GlobalRatingVersion";
  id?: Maybe<Scalars["ID"]>;
  quarter?: Maybe<Scalars["Int"]>;
  year?: Maybe<Scalars["Int"]>;
  IndicatorId?: Maybe<Scalars["ID"]>;
  dateBegin?: Maybe<Scalars["DateTime"]>;
  Indicator?: Maybe<Indicator>;
  Lines?: Maybe<Array<Maybe<GlobalRating>>>;
  createdAt?: Maybe<Scalars["DateTime"]>;
};

/** Строка таблицы CurriculumGroup */
export type GroupCurriculum = {
  __typename?: "GroupCurriculum";
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  status?: Maybe<CurriculumGroupStatus>;
  dateActiveStatus?: Maybe<Scalars["DateTime"]>;
  dateInactiveStatus?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  /** Порядковый номер */
  sequenceNumber?: Maybe<Scalars["Int"]>;
  type?: Maybe<CurriculumGroupTypeEnum>;
  /** Определяет принадлежность к родителю */
  InstanceId?: Maybe<Scalars["ID"]>;
  /** С какого времени актуально */
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  /** До какого времени актуально */
  ActualTo?: Maybe<Scalars["DateTime"]>;
};

/** Группа и внутри курсы, закрепленные за группой */
export type GroupCurriculumIsCourse = {
  __typename?: "GroupCurriculumIsCourse";
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  status?: Maybe<CurriculumGroupStatus>;
  dateActiveStatus?: Maybe<Scalars["DateTime"]>;
  dateInactiveStatus?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  /** Порядковый номер */
  sequenceNumber?: Maybe<Scalars["Int"]>;
  type?: Maybe<CurriculumGroupTypeEnum>;
  /** Определяет принадлежность к родителю */
  InstanceId?: Maybe<Scalars["ID"]>;
  /** С какого времени актуально */
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  /** До какого времени актуально */
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Courses?: Maybe<Array<Maybe<CourseCurriculum>>>;
};

export enum GroupOrderBy {
  Name = "name",
  SequenceNumber = "sequenceNumber",
  CreatedAt = "createdAt",
  UpdatedAt = "updatedAt",
  Status = "status",
  InstanceId = "InstanceId",
  DateActiveStatus = "dateActiveStatus",
  DateInactiveStatus = "dateInactiveStatus",
  ActualFrom = "ActualFrom",
}

export type ImportDealerPhotosLogType = {
  __typename?: "ImportDealerPhotosLogType";
  ok?: Maybe<Scalars["Boolean"]>;
};

/** Индикатор */
export type Indicator = {
  __typename?: "Indicator";
  id?: Maybe<Scalars["ID"]>;
  nameRu?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  shortNameRu?: Maybe<Scalars["String"]>;
  shortNameEn?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  format?: Maybe<Scalars["String"]>;
  unit?: Maybe<Scalars["String"]>;
  period?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  Values?: Maybe<Array<Maybe<IndicatorValue>>>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  enum?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

/** Индикатор и отчёт */
export type IndicatorAndReport = {
  __typename?: "IndicatorAndReport";
  IndicatorId: Scalars["ID"];
  ReportId: Scalars["ID"];
  createdAt: Scalars["DateTime"];
};

/** Получение данных о индикаторах */
export type IndicatorGetter = {
  __typename?: "IndicatorGetter";
  /** получение списка загрузок для значений индикаторов */
  getUploadLogById?: Maybe<UploadList>;
  /** получение индикаторов */
  getIndicators?: Maybe<IndicatorList>;
  /** получение списка загрузок для значений индикаторов */
  getUploadValuesList?: Maybe<UploadValuesList>;
  /** получение индикатора */
  getIndicator?: Maybe<Indicator>;
  /** Попросить выгрузку значений индикаторов */
  downloadIndicatorsValue?: Maybe<ReportFile>;
};

/** Получение данных о индикаторах */
export type IndicatorGetterGetUploadLogByIdArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** Получение данных о индикаторах */
export type IndicatorGetterGetIndicatorsArgs = {
  searchField?: Maybe<Scalars["String"]>;
  searchText?: Maybe<Scalars["String"]>;
  sortField?: Maybe<Scalars["String"]>;
  sortType?: Maybe<Scalars["String"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

/** Получение данных о индикаторах */
export type IndicatorGetterGetUploadValuesListArgs = {
  searchField?: Maybe<Scalars["String"]>;
  searchText?: Maybe<Scalars["String"]>;
  sortField?: Maybe<Scalars["String"]>;
  sortType?: Maybe<Scalars["String"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

/** Получение данных о индикаторах */
export type IndicatorGetterGetIndicatorArgs = {
  id: Scalars["ID"];
};

/** Получение данных о индикаторах */
export type IndicatorGetterDownloadIndicatorsValueArgs = {
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  IndicatorIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  year?: Maybe<Scalars["Int"]>;
  dateBegin?: Maybe<Scalars["DateTime"]>;
  dateEnd?: Maybe<Scalars["DateTime"]>;
};

/** Группа индикаторов для блока Отчёты */
export type IndicatorGroup = {
  __typename?: "IndicatorGroup";
  id?: Maybe<Scalars["ID"]>;
  nameRu?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  Indicators?: Maybe<Array<Maybe<Indicator>>>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  createdBy?: Maybe<Scalars["ID"]>;
  createdByUser?: Maybe<Profile>;
  writtenBy?: Maybe<Scalars["ID"]>;
  writtenByUser?: Maybe<Profile>;
};

/** Список групп индикаторов */
export type IndicatorGroupList = {
  __typename?: "IndicatorGroupList";
  items?: Maybe<Array<Maybe<IndicatorGroup>>>;
  total?: Maybe<Scalars["Int"]>;
};

/** Получение данных для отчета по индикаторам */
export type IndicatorGroupReportGetter = {
  __typename?: "IndicatorGroupReportGetter";
  /** Получение групп отчетов */
  getIndicatorGroups?: Maybe<IndicatorGroupList>;
  /** Получение группы отчетов по id */
  getIndicatorGroup?: Maybe<IndicatorGroup>;
  /** Получение шаблонов отчётов по id группы */
  getIndicatorReports?: Maybe<IndicatorReportList>;
  /** Получение шаблона отчёта по id */
  getIndicatorReport?: Maybe<IndicatorReport>;
  /** Получить данные для отчета по индикаторам привязанным к шаблону. Поле group обязательное при группировке */
  getDealerIndicatorValuesReport?: Maybe<DealerIndicatorValuesReport>;
  /** Получить файл отчета по индикаторам привязанным к шаблону. Поле group обязательное при группировке */
  getDealerIndicatorValuesTableHash?: Maybe<ReportFile>;
};

/** Получение данных для отчета по индикаторам */
export type IndicatorGroupReportGetterGetIndicatorGroupsArgs = {
  sortField?: Maybe<Scalars["String"]>;
  sortType?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

/** Получение данных для отчета по индикаторам */
export type IndicatorGroupReportGetterGetIndicatorGroupArgs = {
  GroupId: Scalars["ID"];
};

/** Получение данных для отчета по индикаторам */
export type IndicatorGroupReportGetterGetIndicatorReportsArgs = {
  GroupId: Scalars["ID"];
  sortField?: Maybe<Scalars["String"]>;
  sortType?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

/** Получение данных для отчета по индикаторам */
export type IndicatorGroupReportGetterGetIndicatorReportArgs = {
  ReportId: Scalars["ID"];
};

/** Получение данных для отчета по индикаторам */
export type IndicatorGroupReportGetterGetDealerIndicatorValuesReportArgs = {
  ReportId: Scalars["ID"];
  group?: Maybe<TypeGroupDealerIndicatorValues>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  HoldingIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  RegMenIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  Country?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  quarter?: Maybe<Scalars["Int"]>;
  year?: Maybe<Scalars["Int"]>;
  dateBegin?: Maybe<Scalars["DateTime"]>;
  dateEnd?: Maybe<Scalars["DateTime"]>;
  lang?: Maybe<Scalars["String"]>;
  isFull?: Maybe<Scalars["Boolean"]>;
  status?: Maybe<DealerStatus>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

/** Получение данных для отчета по индикаторам */
export type IndicatorGroupReportGetterGetDealerIndicatorValuesTableHashArgs = {
  ReportId: Scalars["ID"];
  group?: Maybe<TypeGroupDealerIndicatorValues>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  HoldingIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  RegMenIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  Country?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  quarter?: Maybe<Scalars["Int"]>;
  year?: Maybe<Scalars["Int"]>;
  dateBegin?: Maybe<Scalars["DateTime"]>;
  dateEnd?: Maybe<Scalars["DateTime"]>;
  lang?: Maybe<Scalars["String"]>;
  isFull?: Maybe<Scalars["Boolean"]>;
  status?: Maybe<DealerStatus>;
};

/** Изменение данных для отчета по индикаторам */
export type IndicatorGroupReportSetter = {
  __typename?: "IndicatorGroupReportSetter";
  /** Создание группы для отчетов */
  createIndicatorGroup?: Maybe<IndicatorGroup>;
  /** Редактирование группы отчетов по id */
  changeIndicatorGroup?: Maybe<IndicatorGroup>;
  /** Логическое удаление группы отчетов по id */
  deleteIndicatorGroup?: Maybe<Scalars["Boolean"]>;
  /** Восстановить удаленную группу отчетов */
  restoreIndicatorGroup?: Maybe<Scalars["Boolean"]>;
  /** Создание шаблона отчета */
  createIndicatorReport?: Maybe<IndicatorReport>;
  /** Редактировать шаблон отчёта */
  changeIndicatorReport?: Maybe<IndicatorReport>;
  /** Логическое удаление шаблона отчёта */
  deleteIndicatorReport?: Maybe<Scalars["Boolean"]>;
  /** Восстановить шаблон отчёта */
  restoreIndicatorReport?: Maybe<Scalars["Boolean"]>;
  /** Присвоить индикаторы шаблону отчёта */
  addIndicatorsToReport?: Maybe<Scalars["Boolean"]>;
  /** Удалить все индикаторы присвоенные шаблону */
  deleteIndicatorsFromReport?: Maybe<Scalars["Boolean"]>;
  /** Обновить поля дилера в шаблоне отчёта */
  upsertDealerFieldsToReport?: Maybe<Scalars["Boolean"]>;
};

/** Изменение данных для отчета по индикаторам */
export type IndicatorGroupReportSetterCreateIndicatorGroupArgs = {
  nameRu: Scalars["String"];
  nameEn?: Maybe<Scalars["String"]>;
};

/** Изменение данных для отчета по индикаторам */
export type IndicatorGroupReportSetterChangeIndicatorGroupArgs = {
  id: Scalars["ID"];
  nameRu: Scalars["String"];
  nameEn?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
};

/** Изменение данных для отчета по индикаторам */
export type IndicatorGroupReportSetterDeleteIndicatorGroupArgs = {
  id: Scalars["ID"];
};

/** Изменение данных для отчета по индикаторам */
export type IndicatorGroupReportSetterRestoreIndicatorGroupArgs = {
  id: Scalars["ID"];
};

/** Изменение данных для отчета по индикаторам */
export type IndicatorGroupReportSetterCreateIndicatorReportArgs = {
  GroupId: Scalars["ID"];
  nameRu: Scalars["String"];
  nameEn?: Maybe<Scalars["String"]>;
};

/** Изменение данных для отчета по индикаторам */
export type IndicatorGroupReportSetterChangeIndicatorReportArgs = {
  id: Scalars["ID"];
  nameRu: Scalars["String"];
  nameEn?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
};

/** Изменение данных для отчета по индикаторам */
export type IndicatorGroupReportSetterDeleteIndicatorReportArgs = {
  id: Scalars["ID"];
};

/** Изменение данных для отчета по индикаторам */
export type IndicatorGroupReportSetterRestoreIndicatorReportArgs = {
  id: Scalars["ID"];
  GroupId: Scalars["ID"];
};

/** Изменение данных для отчета по индикаторам */
export type IndicatorGroupReportSetterAddIndicatorsToReportArgs = {
  IndicatorIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  ReportId: Scalars["ID"];
};

/** Изменение данных для отчета по индикаторам */
export type IndicatorGroupReportSetterDeleteIndicatorsFromReportArgs = {
  ReportId: Scalars["ID"];
};

/** Изменение данных для отчета по индикаторам */
export type IndicatorGroupReportSetterUpsertDealerFieldsToReportArgs = {
  DealerFieldsIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  ReportId: Scalars["ID"];
};

/** Список индикаторов */
export type IndicatorList = {
  __typename?: "IndicatorList";
  items?: Maybe<Array<Maybe<Indicator>>>;
  total?: Maybe<Scalars["Int"]>;
};

/** Отчёт группы индикаторов для блока Отчёты */
export type IndicatorReport = {
  __typename?: "IndicatorReport";
  id?: Maybe<Scalars["ID"]>;
  nameRu?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  createdBy?: Maybe<Scalars["ID"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  GroupId?: Maybe<Scalars["ID"]>;
  Group?: Maybe<IndicatorGroup>;
  Indicators?: Maybe<Array<Maybe<Indicator>>>;
  createdByUser?: Maybe<Profile>;
  writtenBy?: Maybe<Scalars["ID"]>;
  writtenByUser?: Maybe<Profile>;
  dealerFields?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  Fields?: Maybe<Array<Maybe<DealerField>>>;
};

/** Список отчётов в группе индикаторов */
export type IndicatorReportList = {
  __typename?: "IndicatorReportList";
  items?: Maybe<Array<Maybe<IndicatorReport>>>;
  total?: Maybe<Scalars["Int"]>;
};

/** Изменение данных о индикаторах */
export type IndicatorSetter = {
  __typename?: "IndicatorSetter";
  /** Создание/редактирование индикатора */
  setIndicator?: Maybe<Indicator>;
  /** Загрузка показателей */
  uploadIndicatorValues?: Maybe<Scalars["Boolean"]>;
  /** Разрешить загрузить черновик */
  acceptUploadIndicatorValues?: Maybe<Scalars["Boolean"]>;
  /** Отклонить загрузить черновик */
  rejectUploadIndicatorValues?: Maybe<Scalars["Boolean"]>;
  /** Удаление индикатора */
  deleteIndicator?: Maybe<Scalars["Boolean"]>;
  /** Восстановление удаленного индикатора */
  restoreIndicator?: Maybe<Scalars["Boolean"]>;
};

/** Изменение данных о индикаторах */
export type IndicatorSetterSetIndicatorArgs = {
  id: Scalars["ID"];
  oldId?: Maybe<Scalars["ID"]>;
  nameRu?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  shortNameRu?: Maybe<Scalars["String"]>;
  shortNameEn?: Maybe<Scalars["String"]>;
  type: Scalars["String"];
  format: Scalars["String"];
  unit: Scalars["String"];
  period: Scalars["String"];
  status: Scalars["String"];
  enum?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

/** Изменение данных о индикаторах */
export type IndicatorSetterUploadIndicatorValuesArgs = {
  fileId: Scalars["ID"];
  description?: Maybe<Scalars["String"]>;
};

/** Изменение данных о индикаторах */
export type IndicatorSetterAcceptUploadIndicatorValuesArgs = {
  IndicatorUploadId: Scalars["ID"];
};

/** Изменение данных о индикаторах */
export type IndicatorSetterRejectUploadIndicatorValuesArgs = {
  IndicatorUploadId: Scalars["ID"];
};

/** Изменение данных о индикаторах */
export type IndicatorSetterDeleteIndicatorArgs = {
  id: Scalars["ID"];
};

/** Изменение данных о индикаторах */
export type IndicatorSetterRestoreIndicatorArgs = {
  id: Scalars["ID"];
};

/** Значение индикатора */
export type IndicatorValue = {
  __typename?: "IndicatorValue";
  id?: Maybe<Scalars["ID"]>;
  doubleValue?: Maybe<Scalars["Float"]>;
  stringValue?: Maybe<Scalars["String"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  IndicatorId?: Maybe<Scalars["ID"]>;
  Indicator?: Maybe<Indicator>;
  createdAt?: Maybe<Scalars["DateTime"]>;
};

export type InformationSystem = {
  __typename?: "InformationSystem";
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  Positions?: Maybe<Array<Maybe<InformationSystemPositions>>>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  createdBy?: Maybe<Scalars["String"]>;
  UpdatedBy?: Maybe<Scalars["String"]>;
  CreatedByUser?: Maybe<Profile>;
};

export type InformationSystemPositions = {
  __typename?: "InformationSystemPositions";
  id?: Maybe<Scalars["ID"]>;
  informationSystemId?: Maybe<Scalars["ID"]>;
  positionId?: Maybe<Scalars["ID"]>;
  createdAt?: Maybe<Scalars["String"]>;
  Position?: Maybe<Position>;
};

export type IvideonCameraTariffGetter = {
  __typename?: "IvideonCameraTariffGetter";
  getIvideonCameraTariffs: Array<Maybe<IvideonCameraTariffType>>;
  getIvideonCameraCountByTariff?: Maybe<
    Array<Maybe<IvideonCameraCountByTariffType>>
  >;
};

export type IvideonCameraTariffGetterGetIvideonCameraCountByTariffArgs = {
  DealerId: Scalars["ID"];
};

export type IvideonCameraTariffSetter = {
  __typename?: "IvideonCameraTariffSetter";
  createIvideonCameraTariff?: Maybe<IvideonCameraTariffType>;
  updateIvideonCameraTariff?: Maybe<IvideonCameraTariffType>;
  deleteIvideonCameraTariff: Ok;
};

export type IvideonCameraTariffSetterCreateIvideonCameraTariffArgs = {
  name: Scalars["String"];
  price: Scalars["Float"];
};

export type IvideonCameraTariffSetterUpdateIvideonCameraTariffArgs = {
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  price?: Maybe<Scalars["Float"]>;
};

export type IvideonCameraTariffSetterDeleteIvideonCameraTariffArgs = {
  id: Scalars["ID"];
};

export type IvideonCamerasIntegrationGetter = {
  __typename?: "IvideonCamerasIntegrationGetter";
  getToken?: Maybe<IvideonToken>;
};

export type IvideonCamerasIntegrationGetterGetTokenArgs = {
  DealerId: Scalars["ID"];
  force?: Maybe<Scalars["Boolean"]>;
};

export type IvideonCamerasIntegrationSetter = {
  __typename?: "IvideonCamerasIntegrationSetter";
  createToken: Ok;
};

export type IvideonCamerasIntegrationSetterCreateTokenArgs = {
  DealerId: Scalars["ID"];
  access_token: Scalars["String"];
  expires_in: Scalars["DateTime"];
  refresh_token: Scalars["String"];
  api_host: Scalars["String"];
  open_api_host: Scalars["String"];
};

/** Ivideon Token */
export type IvideonToken = {
  __typename?: "IvideonToken";
  DealerId?: Maybe<Scalars["ID"]>;
  access_token?: Maybe<Scalars["String"]>;
  expires?: Maybe<Scalars["DateTime"]>;
  api_host?: Maybe<Scalars["String"]>;
  open_api_host?: Maybe<Scalars["String"]>;
  camerasCount?: Maybe<Scalars["Int"]>;
};

/** Вид ремонта */
export enum KindRepair {
  Ago = "ago",
  Ato = "ato",
  Ako = "ako",
  Aso = "aso",
  Ano = "ano",
  Aku = "aku",
}

export enum LangType {
  Ru = "ru",
  En = "en",
}

/** Строка таблицы CurriculumLevel */
export type LevelCurriculum = {
  __typename?: "LevelCurriculum";
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  status?: Maybe<CurriculumLevelStatus>;
  dateActiveStatus?: Maybe<Scalars["DateTime"]>;
  dateInactiveStatus?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  /** Порядковый номер */
  sequenceNumber?: Maybe<Scalars["Int"]>;
  GroupId?: Maybe<Scalars["ID"]>;
  Group?: Maybe<GroupCurriculum>;
  /** Определяет принадлежность к родителю */
  InstanceId?: Maybe<Scalars["ID"]>;
  /** С какого времени актуально */
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  /** До какого времени актуально */
  ActualTo?: Maybe<Scalars["DateTime"]>;
};

/** Уровень и внутри группы. */
export type LevelCurriculumIsGroup = {
  __typename?: "LevelCurriculumIsGroup";
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  status?: Maybe<CurriculumLevelStatus>;
  dateActiveStatus?: Maybe<Scalars["DateTime"]>;
  dateInactiveStatus?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  /** Порядковый номер */
  sequenceNumber?: Maybe<Scalars["Int"]>;
  GroupId?: Maybe<Scalars["ID"]>;
  Group?: Maybe<GroupCurriculum>;
  /** Определяет принадлежность к родителю */
  InstanceId?: Maybe<Scalars["ID"]>;
  /** С какого времени актуально */
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  /** До какого времени актуально */
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Groups?: Maybe<Array<Maybe<GroupCurriculumIsCourse>>>;
};

export enum LevelsOrderBy {
  InstanceId = "InstanceId",
  Name = "name",
  Status = "status",
  DateActiveStatus = "dateActiveStatus",
  DateInactiveStatus = "dateInactiveStatus",
  GroupId = "GroupId",
  SequenceNumber = "sequenceNumber",
  CreatedAt = "createdAt",
  UpdatedAt = "updatedAt",
  ActualFrom = "ActualFrom",
  ActualTo = "ActualTo",
}

export type Locations = {
  __typename?: "Locations";
  countryId?: Maybe<Scalars["ID"]>;
  country?: Maybe<Scalars["String"]>;
  countryEn?: Maybe<Scalars["String"]>;
  FOId?: Maybe<Scalars["ID"]>;
  FO?: Maybe<Scalars["String"]>;
  FOEn?: Maybe<Scalars["String"]>;
  subjectId?: Maybe<Scalars["ID"]>;
  subject?: Maybe<Scalars["String"]>;
  subjectEn?: Maybe<Scalars["String"]>;
  districtId?: Maybe<Scalars["ID"]>;
  district?: Maybe<Scalars["String"]>;
  districtEn?: Maybe<Scalars["String"]>;
  cityId?: Maybe<Scalars["ID"]>;
  city?: Maybe<Scalars["String"]>;
  cityEn?: Maybe<Scalars["String"]>;
  streetId?: Maybe<Scalars["ID"]>;
  street?: Maybe<Scalars["String"]>;
  streetEn?: Maybe<Scalars["String"]>;
  houseId?: Maybe<Scalars["ID"]>;
  house?: Maybe<Scalars["String"]>;
  houseEn?: Maybe<Scalars["String"]>;
};

/**
 * Лог   delete_user: "Удаление пользователя",
 *     restore_user: "Восстановление пользователя",
 *     import_dealer_photos: "Импорт фотографий дилера",
 *     import_dealer_check_lists: "Импорт чек-листов дилера",
 *     edit_user: "Редактирование пользователя",
 *     upload_dealer_csv: "Загрузка дилера файлом (csv)",
 *     edit_dealer: "Редактирование дилеров",
 *     add_dealer_to_user: "Добавление дилера к пользователю",
 *     delete_dealer_from_user: "Удаления дилера у пользователя",
 *     upload_indicator_values: "Загрузка индикаторов (csv)",
 *     upload_dealer_to_user_csv: "Загрузка прикрепления дилеров к регменам (csv)",
 *     add_indicator: "Добавление индикатора",
 *     edit_indicator: "Редактирование индикатора",
 *     delete_indicator: "Удаление индикатора",
 *     restore_indicator: "Восстановление индикатора",
 *     set_staff_data: "Установка значений блока персонал",
 *     add_staff: "Добавление строчки в блок персонал",
 *     edit_staff: "Удаление строчки в блоке персонал",
 *     add_q_version: "Добавление версии рейтинга квартили",
 *     edit_q_version: "Редактирование версии рейтинга квартили",
 *     delete_q_version: "Удаление версии рейтинга квартили",
 *     add_q_row: "Добавление строчки  версии рейтинга квартиля",
 *     edit_q_row: "Редактирование строчки  версии рейтинга квартиля",
 *     delete_q_row: "Удаление строчки  версии рейтинга квартиля",
 *     add_gr_version: "Добавление версии глобального рейтинга",
 *     edit_gr_version: "Редактирование версии глобального рейтинга",
 *     delete_gr_version: "Удаление версии глобального рейтинга",
 *     add_gr_row: "Добавление строчки версии глобального рейтинга  ",
 *     edit_gr_row: "Редактирование строчки версии глобального рейтинга",
 *     create_announcement: "Создание объявления",
 *     modify_announcement: "Редактирование объявления",
 *     delete_file: "удаление файла",
 *     edit_file: "Редактирование названия файла",
 *     edit_employee: "Редактирование данных сотрудника",
 *     edit_employee_positions: "Редактирование должности сотрудника",
 *     delete_gr_row: "Удаление  строчки версии глобального рейтинга",
 *     add_indicator_group: "Создание группы для отчетов",
 *     edit_indicator_group: "Редактирование группы отчетов",
 *     delete_indicator_group: "Удаление группы отчетов",
 *     restore_indicator_group: "Восстановление группы отчетов",
 *     add_indicator_report: "Создание шаблона отчета",
 *     edit_indicator_report: "Редактирование шаблона отчета",
 *     change_dealer_fields_report: "Редактирование полей дилера в шаблоне отчета",
 *     delete_indicator_report: "Удаление шаблона отчета",
 *     restore_indicator_report: "Восстановление шаблона отчета",
 *     add_indicators_to_report: "Удаление шаблона отчета",
 *     delete_indicators_from_report: "Восстановление шаблона отчета"    add_employee_positions: "Добавление должности сотруднику",
 *     delete_gr_row: "Удаление  строчки версии глобального рейтинга",
 *     create_document: "создание документа",
 *     modify_document: "изменение документа",
 *     create_section: "создание раздела",
 *     modify_section: "изменение раздела",
 *     delete_section: "Удаление раздела"create_position: "создание должности", edit_position: "редактирование должности", delete_position: "удаление должности", create_position_direction: "создание направления должности", edit_position_direction: "редактирование направления должности", delete_position_direction: "удаление направления должности", edit_education_course: "редактирование обучающего курса", create_education_course: "создание обучающего курса",delete_education_course: "удаление обучающего курса", edit_education_level: "редактирование уровня обучения", create_education_level: "создание уровня обучения", delete_education_level: "удаление уровня обучения", edit_education_group: "редактирование группы обучения", create_education_group: "создание группы обучения", delete_education_group: "удаление группы обучения", create_education_catalog: "создание каталога обучения", delete_education_catalog: "удаление каталога обучения", create_education_program: "создание программы обучения", delete_education_program: "удаление программы обучения"edit_education_program: "изменение учебной программы"edit_staff_education_group_all: "изменение группы обучения в персонале"create_document: "создание документа"modify_document: "изменение документа"create_section: "создание раздела"modify_section: "изменение раздела" edit_education_program: "изменение учебной программы"delete_position_group_education_program: "удаление должности из учебной программы"add_position_group_education_program: "добавление должности в учебную группу"edit_staff_education_group_all: "изменение группы обучения в персонале"add_position_group_education_program: "добавление должности в учебную группу"create_camera: "Создание камеры"modify_camera: "Редактирование камеры"delete_camera: "Удаление камеры"create_camera: "Создание проверки для камеры"modify_camera: "Редактирование проверки для камеры"create_camera_zone: "Создание зоны расположения камеры"modify_camera_zone: "Редактирование зоны расположения камеры"delete_camera_zone: "Удаление зоны расположения камеры"
 */
export type Log = {
  __typename?: "Log";
  id?: Maybe<Scalars["ID"]>;
  User?: Maybe<Profile>;
  data?: Maybe<LogElement>;
  description?: Maybe<Scalars["String"]>;
  event?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
};

/** Элемент логов системы */
export type LogElement =
  | LogForDealer
  | LogForEditStaffEducationGroup
  | LogForImportDealerPhotos
  | LogForImportDealerCheckLists
  | LogForEditValueStaff
  | LogForEditStaff
  | LogAddDealerToUser
  | LogForEditGrVersion
  | LogForEditGrRow
  | LogForEditIndicator
  | LogForEditQVersion
  | LogForEditQRow
  | LogForEditUser
  | LogForEditFile
  | LogForDeleteFile
  | LogDefault
  | LogForUploadFileToCatalog
  | LogForEditEmployee
  | LogForEditEmployeePosition
  | LogForCreateAnnouncement
  | LogForEditAnnouncement
  | LogForViolation
  | LogForAccountingPeriod
  | LogForZdNotes
  | LogForZdPersonal
  | LogForZdPlacePosts
  | LogForZdPlaces
  | LogForZdTradePremises
  | LogForZdRequiredTools
  | LogForZdServiceZs
  | LogForZdToolsInsuranceZs
  | LogForZdToolsMetrologicalZs
  | LogForZdToolsZs
  | LogForZdWarehousesZs
  | LogForCreatedEducationCatalog
  | LogForDeleteEducationCatalog
  | LogForCreatedEducationCourse
  | LogForEditEducationCourse
  | LogForDeleteEducationCourse
  | LogForCreatedEducationLevel
  | LogForEditEducationLevel
  | LogForDeleteEducationLevel
  | LogForCreatedEducationGroup
  | LogForEditEducationGroup
  | LogForDeleteEducationGroup
  | LogForCreatedEducationProgram
  | LogForDeleteEducationProgram
  | LogForEditEducationProgram
  | LogForDeletePositionGroupEducationProgram
  | LogForAddPositionGroupEducationProgram
  | LogForCreatedPosition
  | LogForEditPosition
  | LogForDeletePosition
  | LogForEditPositionDirection
  | LogForDeletePositionDirection
  | LogForCreatedPositionDirection
  | LogForZdDefinitionServices
  | LogForZdDefinitionPlaces
  | LogForZdDefinitionPlacePosts
  | LogForZdDefinitionWarehouses
  | LogForZdDefinitionTools
  | LogForZdDefinitionRequiredTools
  | LogForZdDefinitionPersonal
  | LogForZdDefinitionToolsInsurance
  | LogForZdDefinitionToolsMetrological
  | LogForZdDefinitionNotes
  | LogForZdDefinitionTradePremises
  | LogForCreateDocument
  | LogForEditDocument
  | LogForCreateSection
  | LogForEditSection
  | LogForDeleteSection
  | LogForCreateCamera
  | LogForEditCamera
  | LogForDeleteCamera
  | LogForCreateCameraCheck
  | LogForEditCameraCheck
  | LogForCreateCameraZone
  | LogForEditCameraZone
  | LogForDeleteCameraZone
  | LogForAddIndicatorGroup
  | LogForEditIndicatorGroup
  | LogForAddIndicatorReport
  | LogForChangeIndicatorReport
  | LogForAddIndicatorToReport
  | LogForDeleteIndicatorToReport;

/** Получение данных о логах */
export type LogGetter = {
  __typename?: "LogGetter";
  /** Получить список логов */
  getLogs?: Maybe<LogList>;
  getEmailLogs?: Maybe<EmailLogListList>;
  getEmailLogsReport?: Maybe<ReportFile>;
  getEmailNames?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

/** Получение данных о логах */
export type LogGetterGetLogsArgs = {
  UserId?: Maybe<Scalars["ID"]>;
  event?: Maybe<Scalars["String"]>;
  dateEnd?: Maybe<Scalars["DateTime"]>;
  dateBegin?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

/** Получение данных о логах */
export type LogGetterGetEmailLogsArgs = {
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  dealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  userIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  name?: Maybe<Scalars["String"]>;
  fromDate?: Maybe<Scalars["DateTime"]>;
  toDate?: Maybe<Scalars["DateTime"]>;
};

/** Получение данных о логах */
export type LogGetterGetEmailLogsReportArgs = {
  dealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  userIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  name?: Maybe<Scalars["String"]>;
  fromDate: Scalars["DateTime"];
  toDate: Scalars["DateTime"];
};

/** Список логов */
export type LogList = {
  __typename?: "LogList";
  items?: Maybe<Array<Maybe<Log>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type LogStaffEducationGroup = {
  __typename?: "LogStaffEducationGroup";
  GroupTrainingId?: Maybe<Scalars["ID"]>;
  /** @deprecated ошибка */
  GroupCertificateId?: Maybe<Scalars["ID"]>;
  GroupCertificationId?: Maybe<Scalars["ID"]>;
  GroupTraining?: Maybe<GroupCurriculum>;
  GroupCertificate?: Maybe<GroupCurriculum>;
};

export enum LoyaltyType {
  Our = "our",
  All = "all",
}

/** Изменение данных */
export type Mutation = {
  __typename?: "Mutation";
  AccountingSetter?: Maybe<AccountingSetter>;
  AnnouncementSetter?: Maybe<AnnouncementSetter>;
  CameraSetter?: Maybe<CameraSetter>;
  /** Модификация коментариев у чек листа */
  CheckListCommentSetter?: Maybe<CheckListCommentSetter>;
  ContractTemplateSetter?: Maybe<ContractTemplateSetter>;
  /** Изменение данных о дилерах */
  DealerRegistrySetter?: Maybe<DealerRegistrySetter>;
  /** Изменение данных о дилерах */
  DealerSetter?: Maybe<DealerSetter>;
  DocumentSetter?: Maybe<DocumentSetter>;
  /** Изменение данных о Education */
  EducationSetter?: Maybe<EducationSetter>;
  /** Изменение данных о Employees */
  EmployeeSetter?: Maybe<EmployeeSetter>;
  /** Изменение данных о файлах */
  FileCatalogSetter?: Maybe<FileCatalogSetter>;
  GeoSetter?: Maybe<GeoSetter>;
  /** Изменение данных в рейтингах */
  GlobalRatingSetter?: Maybe<GlobalRatingSetter>;
  /** Изменение данных для отчета по индикаторам */
  IndicatorGroupReportSetter?: Maybe<IndicatorGroupReportSetter>;
  /** Изменение данных о индикаторах */
  IndicatorSetter?: Maybe<IndicatorSetter>;
  IvideonCameraTariffSetter?: Maybe<IvideonCameraTariffSetter>;
  IvideonCamerasIntegrationSetter?: Maybe<IvideonCamerasIntegrationSetter>;
  /** Изменение данных Наличие обязательных приложений */
  NotesSetter?: Maybe<NotesSetter>;
  /** Изменение данных Численность персонала СЦP */
  PersonalSetter?: Maybe<PersonalSetter>;
  /** Изменение разделов фотогалереи */
  PhotoGallerySectionSetter?: Maybe<PhotoGallerySectionSetter>;
  /** Изменение данных Рабочие посты */
  PlacePostsSetter?: Maybe<PlacePostsSetter>;
  /** Изменение данных Производственные участки */
  PlacesSetter?: Maybe<PlacesSetter>;
  PlanReportSetter?: Maybe<PlanReportSetter>;
  /** Изменение данных о Position */
  PositionSetter?: Maybe<PositionSetter>;
  /** Изменение данных в рейтингах */
  QuartilesRatingSetter?: Maybe<QuartilesRatingSetter>;
  /** Изменение данных Оборудование для выполнения требований ГОСТ */
  RequiredToolsSetter?: Maybe<RequiredToolsSetter>;
  /** Изменение данных для SRR */
  SRRSetter?: Maybe<SrrSetter>;
  /** Изменение данных Предоставляемые услуги */
  ServicesSetter?: Maybe<ServicesSetter>;
  /** установить настройки */
  SettingsSetter?: Maybe<SettingsSetter>;
  SubdivisionSetter?: Maybe<SubdivisionSetter>;
  SystemSettingSettter?: Maybe<SystemSettingsSetter>;
  /** Изменение данных специального инструменты и приспособления обязательные для гарантийного обслуживания */
  ToolsInsuranceSetter?: Maybe<ToolsInsuranceSetter>;
  /** Изменение данных Метрологическое оборудование */
  ToolsMetrologicalSetter?: Maybe<ToolsMetrologicalSetter>;
  /** Изменение данных технологическое оборудование */
  ToolsSetter?: Maybe<ToolsSetter>;
  /** Изменение данных Торговые площади */
  TradePremisesSetter?: Maybe<TradePremisesSetter>;
  TrustedPersonSetter?: Maybe<TrustedPersonSetter>;
  /** Изменение данных о руководствах пользователя */
  UserGuideSetter?: Maybe<UserGuideSetter>;
  /** Изменение данных о пользователях */
  UserSetter?: Maybe<UserSetter>;
  ViolationSetter?: Maybe<ViolationSetter>;
  ViolationTypesSetter?: Maybe<ViolationTypesSetter>;
  /** Изменение данных Складские помещения */
  WarehousesSetter?: Maybe<WarehousesSetter>;
  ZdCommonSetter?: Maybe<ZdCommonSetter>;
  addNotification?: Maybe<Notification>;
  updateNotification?: Maybe<Notification>;
};

/** Изменение данных */
export type MutationAddNotificationArgs = {
  id?: Maybe<Scalars["ID"]>;
  type?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  content?: Maybe<Scalars["String"]>;
  label?: Maybe<Scalars["String"]>;
  duration?: Maybe<Scalars["Int"]>;
};

/** Изменение данных */
export type MutationUpdateNotificationArgs = {
  id: Scalars["ID"];
  isOpen?: Maybe<Scalars["Boolean"]>;
  type?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  content?: Maybe<Scalars["String"]>;
  label?: Maybe<Scalars["String"]>;
  duration?: Maybe<Scalars["Int"]>;
};

export type NsByAverageCarAgeData = {
  __typename?: "NSByAverageCarAgeData";
  rows?: Maybe<Array<Maybe<NsByAverageCarAgeDataRows>>>;
  average?: Maybe<NsByAverageCarAgeDataAverage>;
};

export type NsByAverageCarAgeDataAverage = {
  __typename?: "NSByAverageCarAgeDataAverage";
  carOwnershipByChange?: Maybe<
    Array<Maybe<NsByAverageCarAgeDataAverageCarOwnershipByChange>>
  >;
  carOwnershipByEPlatform?: Maybe<
    Array<Maybe<NsByAverageCarAgeDataAverageCarOwnershipByEPlatform>>
  >;
};

export type NsByAverageCarAgeDataAverageCarOwnershipByChange = {
  __typename?: "NSByAverageCarAgeDataAverageCarOwnershipByChange";
  /** Срок владения автомобилем, мес */
  ownershipPeriodFrom?: Maybe<Scalars["Int"]>;
  /** Срок владения автомобилем, мес */
  ownershipPeriodTo?: Maybe<Scalars["Int"]>;
  /** Количество проданных автомобилей */
  carsTotal?: Maybe<Scalars["Int"]>;
};

export type NsByAverageCarAgeDataAverageCarOwnershipByEPlatform = {
  __typename?: "NSByAverageCarAgeDataAverageCarOwnershipByEPlatform";
  /** Срок владения автомобилем, мес */
  ownershipPeriodFrom?: Maybe<Scalars["Int"]>;
  /** Срок владения автомобилем, мес */
  ownershipPeriodTo?: Maybe<Scalars["Int"]>;
  /** Количество проданных автомобилей */
  carsTotal?: Maybe<Scalars["Int"]>;
};

export type NsByAverageCarAgeDataRows = {
  __typename?: "NSByAverageCarAgeDataRows";
  dealer?: Maybe<Dealer>;
  client?: Maybe<Client>;
  vin?: Maybe<Scalars["String"]>;
  MKB?: Maybe<Scalars["String"]>;
  carPurchaseDate?: Maybe<Scalars["DateTime"]>;
  TO1?: Maybe<Scalars["DateTime"]>;
  TO2?: Maybe<Scalars["DateTime"]>;
  TO3?: Maybe<Scalars["DateTime"]>;
  TO4?: Maybe<Scalars["DateTime"]>;
  TO5?: Maybe<Scalars["DateTime"]>;
  /** пробег, км */
  mileage?: Maybe<Scalars["Int"]>;
  /** Признак смены собственника да/нет */
  ownerChange?: Maybe<Scalars["Boolean"]>;
  /** Срок владения автомобиля, мес */
  ownershipPeriodByChange?: Maybe<Scalars["Int"]>;
  /** Дата предполагаемой продажи */
  carPresumedSaleDate?: Maybe<Scalars["DateTime"]>;
  /** Срок владения автомобиля, мес */
  ownershipPeriodByEPlatform?: Maybe<Scalars["Int"]>;
};

export type NsByClientCarSaleData = {
  __typename?: "NSByClientCarSaleData";
  dealer?: Maybe<Dealer>;
  /** Количество VIN, выставленных на эл.площадках */
  carsOnEPlatform?: Maybe<Scalars["Int"]>;
  /** Количество клиентов купивших Lada */
  clientsLada?: Maybe<Scalars["Int"]>;
  /** Процент соотношения VIN к клиентам Lada */
  percentCarsOnEPlatform?: Maybe<Scalars["Float"]>;
};

export type NsByClientData = {
  __typename?: "NSByClientData";
  dealer?: Maybe<Dealer>;
  clientId?: Maybe<Scalars["ID"]>;
  soldCars?: Maybe<Array<Maybe<SalesCar>>>;
};

export type NsByConsultantData = {
  __typename?: "NSByConsultantData";
  dealer?: Maybe<Dealer>;
  consultant?: Maybe<Scalars["String"]>;
  periodsData?: Maybe<Array<Maybe<NsDealerDataPeriodsData>>>;
};

export type NsByOldClientsData = {
  __typename?: "NSByOldClientsData";
  dealer?: Maybe<Dealer>;
  /** Количество проданных автомобилей */
  carsTotal?: Maybe<Scalars["Int"]>;
  car?: Maybe<Car>;
  carModel?: Maybe<Scalars["String"]>;
  /** Дата продажи автомобиля */
  sellDate?: Maybe<Scalars["DateTime"]>;
  /** Срок владения (мес) */
  ownershipPeriod?: Maybe<Scalars["Int"]>;
  /** Дата смены собственника (Лада гарантия) */
  ownerChangeDate?: Maybe<Scalars["DateTime"]>;
  /** Дата выставления авто на продажу */
  carSaleDate?: Maybe<Scalars["DateTime"]>;
  /** Дата приобретения нового авто */
  newCarDate?: Maybe<Scalars["DateTime"]>;
};

export type NsByWarmClientsData = {
  __typename?: "NSByWarmClientsData";
  dealer?: Maybe<Dealer>;
  /** Начальник отдела продаж */
  NOP?: Maybe<Scalars["String"]>;
  /** Региональный менеджер продаж */
  RMP?: Maybe<Scalars["String"]>;
  client?: Maybe<Client>;
  vin?: Maybe<Scalars["String"]>;
  goldenId?: Maybe<Scalars["String"]>;
  /** Дата продажи автомобиля */
  soldDate?: Maybe<Scalars["DateTime"]>;
  /** Дата оформления кредита */
  creditDate?: Maybe<Scalars["DateTime"]>;
  /** Дата окончания кредитования */
  creditEndDate?: Maybe<Scalars["DateTime"]>;
  /** Дата окончания гарантии */
  warrantyEndDate?: Maybe<Scalars["DateTime"]>;
  /** Проверка появления VIN на электронных площадках */
  ePlatformDate?: Maybe<Scalars["DateTime"]>;
};

/** 4.5.1.1. NS по дилерам LADA */
export type NsDealerData = {
  __typename?: "NSDealerData";
  dealer?: Maybe<Dealer>;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Region?: Maybe<Scalars["String"]>;
  Country?: Maybe<Scalars["String"]>;
  /** Начальник отдела продаж */
  NOP?: Maybe<Scalars["String"]>;
  /** Региональный менеджер продаж */
  RMP?: Maybe<Scalars["String"]>;
  periodsData?: Maybe<Array<Maybe<NsDealerDataPeriodsData>>>;
  bonusCarCount?: Maybe<Scalars["Int"]>;
  bonusCarMoney?: Maybe<Scalars["Float"]>;
  coefficientAward?: Maybe<Scalars["Int"]>;
};

export type NsDealerDataPeriodsData = {
  __typename?: "NSDealerDataPeriodsData";
  periodStart?: Maybe<Scalars["DateTime"]>;
  periodEnd?: Maybe<Scalars["DateTime"]>;
  periodStr?: Maybe<Scalars["String"]>;
  soldCars?: Maybe<Scalars["Int"]>;
  soldCarsToNewClients?: Maybe<Scalars["Int"]>;
  percentNewClients?: Maybe<Scalars["Float"]>;
  soldCarsToLoyalClients?: Maybe<Scalars["Int"]>;
  soldCarsToLoyalClientsMoney?: Maybe<Scalars["Float"]>;
  percentLoyalClients?: Maybe<Scalars["Int"]>;
  twoCars?: Maybe<Scalars["Int"]>;
  percentTwoCars?: Maybe<Scalars["Float"]>;
  threeCars?: Maybe<Scalars["Int"]>;
  percentThreeCars?: Maybe<Scalars["Float"]>;
  fourOrMoreCars?: Maybe<Scalars["Int"]>;
  percentFourOrMoreCars?: Maybe<Scalars["Float"]>;
};

/** Notes */
export type Notes = {
  __typename?: "Notes";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  ImageIndicator?: Maybe<Scalars["ID"]>;
};

/** Notes */
export type NotesDealerStatuses = {
  __typename?: "NotesDealerStatuses";
  DealerId?: Maybe<Scalars["ID"]>;
  Dealer?: Maybe<Dealer>;
  ZD_UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  status?: Maybe<ZdStatusType>;
  /** последнее обновление заявки дилером */
  lastUpdatedAt?: Maybe<Scalars["DateTime"]>;
  /** последнее обновление статуса заявки */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** Получение данных */
export type NotesGetter = {
  __typename?: "NotesGetter";
  /** Получение значений по дилеру и дате */
  getValues?: Maybe<NotesValues>;
  getDealerStatuses?: Maybe<Array<Maybe<NotesDealerStatuses>>>;
  getById?: Maybe<NotesIndicatorTypes>;
  /** Получить все актуальные на данные момент записи с индикаторами */
  getAll?: Maybe<Array<Maybe<NotesIndicatorTypes>>>;
};

/** Получение данных */
export type NotesGetterGetValuesArgs = {
  DealerId: Scalars["ID"];
  sortBy?: Maybe<NotesSortBy>;
  dateUpTo?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
};

/** Получение данных */
export type NotesGetterGetDealerStatusesArgs = {
  UUID?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

/** Получение данных */
export type NotesGetterGetByIdArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** Notes */
export type NotesIndicatorTypes = {
  __typename?: "NotesIndicatorTypes";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  ComplianceIndicator?: Maybe<Indicator>;
  Number?: Maybe<Scalars["String"]>;
  ImageIndicator?: Maybe<Indicator>;
  isParent?: Maybe<Scalars["Boolean"]>;
};

/** Notes */
export type NotesItemInZdForUuiDemptyList = {
  __typename?: "NotesItemInZdForUUIDemptyList";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Number?: Maybe<Scalars["String"]>;
  Image?: Maybe<Array<Maybe<File>>>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
};

/** Notes */
export type NotesItemInZdForUuiDlist = {
  __typename?: "NotesItemInZdForUUIDlist";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Number?: Maybe<Scalars["String"]>;
  Image?: Maybe<Array<Maybe<File>>>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
};

/** Notes */
export type NotesOneValuesItem = {
  __typename?: "NotesOneValuesItem";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Number?: Maybe<Scalars["String"]>;
  Image?: Maybe<Array<Maybe<File>>>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
  list?: Maybe<Array<Maybe<NotesItemInZdForUuiDlist>>>;
  emptyList?: Maybe<Array<Maybe<NotesItemInZdForUuiDemptyList>>>;
};

/** Изменение данных */
export type NotesSetter = {
  __typename?: "NotesSetter";
  /** Создание */
  create?: Maybe<Notes>;
  /** Редактирование с сохранением истории */
  change?: Maybe<Notes>;
  /** изменить место в сортировке. отрицательные значения и 0 не смещают другие элементы */
  setSort?: Maybe<Scalars["Boolean"]>;
  /** Редактирование текущего состояния (eg исправление опечатки) */
  blindChange?: Maybe<Notes>;
  /** Добавить значения или обновить значения сущности */
  addValues?: Maybe<Scalars["Boolean"]>;
  /** Сделать неактуальным (удалить) */
  delete?: Maybe<Scalars["Boolean"]>;
};

/** Изменение данных */
export type NotesSetterCreateArgs = {
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  ImageIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type NotesSetterChangeArgs = {
  id?: Maybe<Scalars["ID"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  ImageIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type NotesSetterSetSortArgs = {
  sort?: Maybe<Scalars["Int"]>;
  UUID: Scalars["String"];
};

/** Изменение данных */
export type NotesSetterBlindChangeArgs = {
  id?: Maybe<Scalars["ID"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  ImageIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type NotesSetterAddValuesArgs = {
  Compliance?: Maybe<Scalars["Int"]>;
  Image?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  DealerId?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
};

/** Изменение данных */
export type NotesSetterDeleteArgs = {
  id?: Maybe<Scalars["ID"]>;
};

export enum NotesSortBy {
  Number = "number",
  Name = "name",
  NameEn = "nameEn",
  Sort = "sort",
  GroupOne = "GroupOne",
  SortGroup = "sortGroup",
}

/** Notes */
export type NotesValues = {
  __typename?: "NotesValues";
  items?: Maybe<Array<Maybe<NotesOneValuesItem>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type Notification = {
  __typename?: "Notification";
  id: Scalars["ID"];
  isOpen: Scalars["Boolean"];
  type?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  content?: Maybe<Scalars["String"]>;
  label?: Maybe<Scalars["String"]>;
  duration?: Maybe<Scalars["Int"]>;
};

export enum OrderByColumnInEmployees {
  Id = "id",
  CreatedAt = "createdAt",
  Status = "status",
  Name = "name",
}

export enum OrderByColumnInViolation {
  Id = "id",
  CreatedAt = "createdAt",
  Of = "OF",
  Region = "region",
  DealerName = "dealerName",
  InnCode = "INNCode",
  Deadline = "deadline",
  Answer = "answer",
}

export enum OrderByColumnInViolationTypes {
  Id = "id",
  IntroducedAt = "introducedAt",
  DeletedAt = "deletedAt",
}

/** Период для отчета SRR3 по дилерам LADA для расчета премий */
export type PeriodByCar = {
  __typename?: "PeriodByCar";
  period?: Maybe<Scalars["String"]>;
  /** @deprecated DO NOT USE ANYMORE */
  countSale?: Maybe<Scalars["Int"]>;
  /** @deprecated DO NOT USE ANYMORE */
  countService?: Maybe<Scalars["Int"]>;
  /** @deprecated DO NOT USE ANYMORE */
  percent?: Maybe<Scalars["Float"]>;
  TO1?: Maybe<ToDealerByCarByDealerData>;
  TO2?: Maybe<ToDealerByCarByDealerData>;
  TO3?: Maybe<ToDealerByCarByDealerData>;
  TO4?: Maybe<ToDealerByCarByDealerData>;
  TO5?: Maybe<ToDealerByCarByDealerData>;
};

/** Период для отчета SRR3 по дилерам LADA для расчета премий */
export type PeriodForPayments = {
  __typename?: "PeriodForPayments";
  period?: Maybe<Scalars["String"]>;
  target?: Maybe<Scalars["Float"]>;
  countSale?: Maybe<Scalars["Int"]>;
  countService?: Maybe<Scalars["Int"]>;
  percent?: Maybe<Scalars["Float"]>;
  percentTarget?: Maybe<Scalars["Float"]>;
};

/** Personal */
export type Personal = {
  __typename?: "Personal";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  DocName?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  PersonNameIndicator?: Maybe<Scalars["ID"]>;
  ImageIndicator?: Maybe<Scalars["ID"]>;
  PositionIndicator?: Maybe<Scalars["ID"]>;
  PositionStartIndicator?: Maybe<Scalars["ID"]>;
  StudyCertificateDateIndicator?: Maybe<Scalars["ID"]>;
};

/** Personal */
export type PersonalDealerStatuses = {
  __typename?: "PersonalDealerStatuses";
  DealerId?: Maybe<Scalars["ID"]>;
  Dealer?: Maybe<Dealer>;
  ZD_UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  status?: Maybe<ZdStatusType>;
  /** последнее обновление заявки дилером */
  lastUpdatedAt?: Maybe<Scalars["DateTime"]>;
  /** последнее обновление статуса заявки */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** Получение данных */
export type PersonalGetter = {
  __typename?: "PersonalGetter";
  /** Получение значений по дилеру и дате */
  getValues?: Maybe<PersonalValues>;
  getDealerStatuses?: Maybe<Array<Maybe<PersonalDealerStatuses>>>;
  getById?: Maybe<PersonalIndicatorTypes>;
  /** Получить все актуальные на данные момент записи с индикаторами */
  getAll?: Maybe<Array<Maybe<PersonalIndicatorTypes>>>;
  getGroups?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

/** Получение данных */
export type PersonalGetterGetValuesArgs = {
  DealerId: Scalars["ID"];
  sortBy?: Maybe<PersonalSortBy>;
  dateUpTo?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
};

/** Получение данных */
export type PersonalGetterGetDealerStatusesArgs = {
  UUID?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

/** Получение данных */
export type PersonalGetterGetByIdArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** Получение данных */
export type PersonalGetterGetGroupsArgs = {
  groupType?: Maybe<ZdGroupType>;
};

/** Personal */
export type PersonalIndicatorTypes = {
  __typename?: "PersonalIndicatorTypes";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  ComplianceIndicator?: Maybe<Indicator>;
  Number?: Maybe<Scalars["String"]>;
  DocName?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  PersonNameIndicator?: Maybe<Indicator>;
  ImageIndicator?: Maybe<Indicator>;
  PositionIndicator?: Maybe<Indicator>;
  PositionStartIndicator?: Maybe<Indicator>;
  StudyCertificateDateIndicator?: Maybe<Indicator>;
  isParent?: Maybe<Scalars["Boolean"]>;
};

export type PersonalInformation = {
  __typename?: "PersonalInformation";
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  File?: Maybe<File>;
  InformationSystem?: Maybe<InformationSystem>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  informationSystemId?: Maybe<Scalars["ID"]>;
  createdBy?: Maybe<Scalars["String"]>;
  UpdatedBy?: Maybe<Scalars["String"]>;
};

/** Personal */
export type PersonalItemInZdForUuiDemptyList = {
  __typename?: "PersonalItemInZdForUUIDemptyList";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Number?: Maybe<Scalars["String"]>;
  DocName?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  PersonName?: Maybe<Scalars["String"]>;
  Image?: Maybe<Array<Maybe<File>>>;
  Position?: Maybe<Scalars["String"]>;
  PositionStart?: Maybe<Scalars["String"]>;
  StudyCertificateDate?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
};

/** Personal */
export type PersonalItemInZdForUuiDlist = {
  __typename?: "PersonalItemInZdForUUIDlist";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Number?: Maybe<Scalars["String"]>;
  DocName?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  PersonName?: Maybe<Scalars["String"]>;
  Image?: Maybe<Array<Maybe<File>>>;
  Position?: Maybe<Scalars["String"]>;
  PositionStart?: Maybe<Scalars["String"]>;
  StudyCertificateDate?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
};

/** Personal */
export type PersonalOneValuesItem = {
  __typename?: "PersonalOneValuesItem";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Number?: Maybe<Scalars["String"]>;
  DocName?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  PersonName?: Maybe<Scalars["String"]>;
  Image?: Maybe<Array<Maybe<File>>>;
  Position?: Maybe<Scalars["String"]>;
  PositionStart?: Maybe<Scalars["String"]>;
  StudyCertificateDate?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
  list?: Maybe<Array<Maybe<PersonalItemInZdForUuiDlist>>>;
  emptyList?: Maybe<Array<Maybe<PersonalItemInZdForUuiDemptyList>>>;
};

/** Изменение данных */
export type PersonalSetter = {
  __typename?: "PersonalSetter";
  /** Создание */
  create?: Maybe<Personal>;
  /** Редактирование с сохранением истории */
  change?: Maybe<Personal>;
  /** изменить место в сортировке. отрицательные значения и 0 не смещают другие элементы */
  setSort?: Maybe<Scalars["Boolean"]>;
  /** Редактирование текущего состояния (eg исправление опечатки) */
  blindChange?: Maybe<Personal>;
  /** Добавить значения или обновить значения сущности */
  addValues?: Maybe<Scalars["Boolean"]>;
  /** Сделать неактуальным (удалить) */
  delete?: Maybe<Scalars["Boolean"]>;
  /** Необходимо предусмотреть формирование дополнительных строк со стороны пользователя дилера */
  duplicate?: Maybe<PersonalIndicatorTypes>;
  renameGroup?: Maybe<Scalars["Boolean"]>;
  /** изменить место в сортировке */
  setSortGroup?: Maybe<Scalars["Boolean"]>;
};

/** Изменение данных */
export type PersonalSetterCreateArgs = {
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  DocName?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  PersonNameIndicator?: Maybe<Scalars["ID"]>;
  ImageIndicator?: Maybe<Scalars["ID"]>;
  PositionIndicator?: Maybe<Scalars["ID"]>;
  PositionStartIndicator?: Maybe<Scalars["ID"]>;
  StudyCertificateDateIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type PersonalSetterChangeArgs = {
  id?: Maybe<Scalars["ID"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  DocName?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  PersonNameIndicator?: Maybe<Scalars["ID"]>;
  ImageIndicator?: Maybe<Scalars["ID"]>;
  PositionIndicator?: Maybe<Scalars["ID"]>;
  PositionStartIndicator?: Maybe<Scalars["ID"]>;
  StudyCertificateDateIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type PersonalSetterSetSortArgs = {
  sort?: Maybe<Scalars["Int"]>;
  UUID: Scalars["String"];
};

/** Изменение данных */
export type PersonalSetterBlindChangeArgs = {
  id?: Maybe<Scalars["ID"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  DocName?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  PersonNameIndicator?: Maybe<Scalars["ID"]>;
  ImageIndicator?: Maybe<Scalars["ID"]>;
  PositionIndicator?: Maybe<Scalars["ID"]>;
  PositionStartIndicator?: Maybe<Scalars["ID"]>;
  StudyCertificateDateIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type PersonalSetterAddValuesArgs = {
  Compliance?: Maybe<Scalars["Int"]>;
  PersonName?: Maybe<Scalars["String"]>;
  Image?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  Position?: Maybe<Scalars["String"]>;
  PositionStart?: Maybe<Scalars["String"]>;
  StudyCertificateDate?: Maybe<Scalars["String"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
};

/** Изменение данных */
export type PersonalSetterDeleteArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type PersonalSetterDuplicateArgs = {
  uuid?: Maybe<Scalars["String"]>;
};

/** Изменение данных */
export type PersonalSetterRenameGroupArgs = {
  groupType?: Maybe<ZdGroupType>;
  newGroup?: Maybe<Scalars["String"]>;
  oldGroup?: Maybe<Scalars["String"]>;
};

/** Изменение данных */
export type PersonalSetterSetSortGroupArgs = {
  sort?: Maybe<Scalars["Int"]>;
  group: Scalars["String"];
};

export enum PersonalSortBy {
  Number = "number",
  Name = "name",
  NameEn = "nameEn",
  Sort = "sort",
  GroupOne = "GroupOne",
  SortGroup = "sortGroup",
}

/** Personal */
export type PersonalValues = {
  __typename?: "PersonalValues";
  items?: Maybe<Array<Maybe<PersonalOneValuesItem>>>;
  total?: Maybe<Scalars["Int"]>;
};

/** Раздел фото галереи дилера */
export type PhotoGallerySection = {
  __typename?: "PhotoGallerySection";
  id: Scalars["ID"];
  title: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
  createdAt: Scalars["DateTime"];
};

/** Получение разделов фотогалереи */
export type PhotoGallerySectionGetter = {
  __typename?: "PhotoGallerySectionGetter";
  /** Возвращает разделы фотогалереи */
  getPhotoGallerySectionList: PhotoGallerySectionList;
  /** Возвращает раздел фотогалереи */
  getPhotoGallerySection: PhotoGallerySection;
};

/** Получение разделов фотогалереи */
export type PhotoGallerySectionGetterGetPhotoGallerySectionListArgs = {
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

/** Получение разделов фотогалереи */
export type PhotoGallerySectionGetterGetPhotoGallerySectionArgs = {
  id: Scalars["ID"];
};

export type PhotoGallerySectionList = {
  __typename?: "PhotoGallerySectionList";
  total: Scalars["Int"];
  pages: Scalars["Int"];
  items: Array<Maybe<PhotoGallerySection>>;
};

/** Изменение разделов фотогалереи */
export type PhotoGallerySectionSetter = {
  __typename?: "PhotoGallerySectionSetter";
  /** Создает раздел фотогалереи */
  createPhotoGallerySection: PhotoGallerySection;
  /** Обновляет раздел фотогалереи */
  updatePhotoGallerySection: PhotoGallerySection;
  /** Удаляет раздел фотогалереи */
  deletePhotoGallerySection: Ok;
};

/** Изменение разделов фотогалереи */
export type PhotoGallerySectionSetterCreatePhotoGallerySectionArgs = {
  title: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
};

/** Изменение разделов фотогалереи */
export type PhotoGallerySectionSetterUpdatePhotoGallerySectionArgs = {
  id?: Maybe<Scalars["ID"]>;
  title?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
};

/** Изменение разделов фотогалереи */
export type PhotoGallerySectionSetterDeletePhotoGallerySectionArgs = {
  id: Scalars["ID"];
};

/** PlacePosts */
export type PlacePosts = {
  __typename?: "PlacePosts";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  ZD_PlacesId?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
};

/** PlacePosts */
export type PlacePostsDealerStatuses = {
  __typename?: "PlacePostsDealerStatuses";
  DealerId?: Maybe<Scalars["ID"]>;
  Dealer?: Maybe<Dealer>;
  ZD_UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  status?: Maybe<ZdStatusType>;
  /** последнее обновление заявки дилером */
  lastUpdatedAt?: Maybe<Scalars["DateTime"]>;
  /** последнее обновление статуса заявки */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** Получение данных */
export type PlacePostsGetter = {
  __typename?: "PlacePostsGetter";
  /** Получение значений по дилеру и дате */
  getValues?: Maybe<PlacePostsValues>;
  getDealerStatuses?: Maybe<Array<Maybe<PlacePostsDealerStatuses>>>;
  getById?: Maybe<PlacePostsIndicatorTypes>;
  /** Получить все актуальные на данные момент записи с индикаторами */
  getAll?: Maybe<Array<Maybe<PlacePostsIndicatorTypes>>>;
};

/** Получение данных */
export type PlacePostsGetterGetValuesArgs = {
  DealerId: Scalars["ID"];
  sortBy?: Maybe<PlacePostsSortBy>;
  dateUpTo?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
};

/** Получение данных */
export type PlacePostsGetterGetDealerStatusesArgs = {
  UUID?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

/** Получение данных */
export type PlacePostsGetterGetByIdArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** PlacePosts */
export type PlacePostsIndicatorTypes = {
  __typename?: "PlacePostsIndicatorTypes";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  ComplianceIndicator?: Maybe<Indicator>;
  ZD_PlacesId?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Indicator>;
  isParent?: Maybe<Scalars["Boolean"]>;
};

/** PlacePosts */
export type PlacePostsItemInZdForUuiDemptyList = {
  __typename?: "PlacePostsItemInZdForUUIDemptyList";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  ZD_PlacesId?: Maybe<Scalars["ID"]>;
  Total?: Maybe<Scalars["Float"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
};

/** PlacePosts */
export type PlacePostsItemInZdForUuiDlist = {
  __typename?: "PlacePostsItemInZdForUUIDlist";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  ZD_PlacesId?: Maybe<Scalars["ID"]>;
  Total?: Maybe<Scalars["Float"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
};

/** PlacePosts */
export type PlacePostsOneValuesItem = {
  __typename?: "PlacePostsOneValuesItem";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  ZD_PlacesId?: Maybe<Scalars["ID"]>;
  Total?: Maybe<Scalars["Float"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
  list?: Maybe<Array<Maybe<PlacePostsItemInZdForUuiDlist>>>;
  emptyList?: Maybe<Array<Maybe<PlacePostsItemInZdForUuiDemptyList>>>;
};

/** Изменение данных */
export type PlacePostsSetter = {
  __typename?: "PlacePostsSetter";
  /** Создание */
  create?: Maybe<PlacePosts>;
  /** Редактирование с сохранением истории */
  change?: Maybe<PlacePosts>;
  /** изменить место в сортировке. отрицательные значения и 0 не смещают другие элементы */
  setSort?: Maybe<Scalars["Boolean"]>;
  /** Редактирование текущего состояния (eg исправление опечатки) */
  blindChange?: Maybe<PlacePosts>;
  /** Добавить значения или обновить значения сущности */
  addValues?: Maybe<Scalars["Boolean"]>;
  /** Сделать неактуальным (удалить) */
  delete?: Maybe<Scalars["Boolean"]>;
};

/** Изменение данных */
export type PlacePostsSetterCreateArgs = {
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  ZD_PlacesId?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type PlacePostsSetterChangeArgs = {
  id?: Maybe<Scalars["ID"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  ZD_PlacesId?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type PlacePostsSetterSetSortArgs = {
  sort?: Maybe<Scalars["Int"]>;
  UUID: Scalars["String"];
};

/** Изменение данных */
export type PlacePostsSetterBlindChangeArgs = {
  id?: Maybe<Scalars["ID"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  ZD_PlacesId?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type PlacePostsSetterAddValuesArgs = {
  Compliance?: Maybe<Scalars["Int"]>;
  Total?: Maybe<Scalars["Float"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
};

/** Изменение данных */
export type PlacePostsSetterDeleteArgs = {
  id?: Maybe<Scalars["ID"]>;
};

export enum PlacePostsSortBy {
  Number = "number",
  Name = "name",
  NameEn = "nameEn",
  Sort = "sort",
  GroupOne = "GroupOne",
  SortGroup = "sortGroup",
}

/** PlacePosts */
export type PlacePostsValues = {
  __typename?: "PlacePostsValues";
  items?: Maybe<Array<Maybe<PlacePostsOneValuesItem>>>;
  total?: Maybe<Scalars["Int"]>;
};

/** Places */
export type Places = {
  __typename?: "Places";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  /** Допустимые значения: service,workshopVR */
  GroupOne?: Maybe<Scalars["String"]>;
  AreaIndicator?: Maybe<Scalars["ID"]>;
  /** Название участка с которым идёт совмещение, передавать uuid */
  PlacesCombineIndicator?: Maybe<Scalars["ID"]>;
};

/** Places */
export type PlacesDealerStatuses = {
  __typename?: "PlacesDealerStatuses";
  DealerId?: Maybe<Scalars["ID"]>;
  Dealer?: Maybe<Dealer>;
  ZD_UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  status?: Maybe<ZdStatusType>;
  /** последнее обновление заявки дилером */
  lastUpdatedAt?: Maybe<Scalars["DateTime"]>;
  /** последнее обновление статуса заявки */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** Получение данных */
export type PlacesGetter = {
  __typename?: "PlacesGetter";
  /** Получение значений по дилеру и дате */
  getValues?: Maybe<PlacesValues>;
  getDealerStatuses?: Maybe<Array<Maybe<PlacesDealerStatuses>>>;
  getById?: Maybe<PlacesIndicatorTypes>;
  /** Получить все актуальные на данные момент записи с индикаторами */
  getAll?: Maybe<Array<Maybe<PlacesIndicatorTypes>>>;
  getGroups?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

/** Получение данных */
export type PlacesGetterGetValuesArgs = {
  DealerId: Scalars["ID"];
  sortBy?: Maybe<PlacesSortBy>;
  dateUpTo?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
};

/** Получение данных */
export type PlacesGetterGetDealerStatusesArgs = {
  UUID?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

/** Получение данных */
export type PlacesGetterGetByIdArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** Получение данных */
export type PlacesGetterGetGroupsArgs = {
  groupType?: Maybe<ZdGroupType>;
};

/** Places */
export type PlacesIndicatorTypes = {
  __typename?: "PlacesIndicatorTypes";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  ComplianceIndicator?: Maybe<Indicator>;
  Number?: Maybe<Scalars["String"]>;
  /** Допустимые значения: service,workshopVR */
  GroupOne?: Maybe<Scalars["String"]>;
  AreaIndicator?: Maybe<Indicator>;
  /** Название участка с которым идёт совмещение, передавать uuid */
  PlacesCombineIndicator?: Maybe<Indicator>;
  isParent?: Maybe<Scalars["Boolean"]>;
};

/** Places */
export type PlacesItemInZdForUuiDemptyList = {
  __typename?: "PlacesItemInZdForUUIDemptyList";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Number?: Maybe<Scalars["String"]>;
  /** Допустимые значения: service,workshopVR */
  GroupOne?: Maybe<Scalars["String"]>;
  Area?: Maybe<Scalars["Float"]>;
  /** Название участка с которым идёт совмещение, передавать uuid */
  PlacesCombine?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
};

/** Places */
export type PlacesItemInZdForUuiDlist = {
  __typename?: "PlacesItemInZdForUUIDlist";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Number?: Maybe<Scalars["String"]>;
  /** Допустимые значения: service,workshopVR */
  GroupOne?: Maybe<Scalars["String"]>;
  Area?: Maybe<Scalars["Float"]>;
  /** Название участка с которым идёт совмещение, передавать uuid */
  PlacesCombine?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
};

/** Places */
export type PlacesOneValuesItem = {
  __typename?: "PlacesOneValuesItem";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Number?: Maybe<Scalars["String"]>;
  /** Допустимые значения: service,workshopVR */
  GroupOne?: Maybe<Scalars["String"]>;
  Area?: Maybe<Scalars["Float"]>;
  /** Название участка с которым идёт совмещение, передавать uuid */
  PlacesCombine?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
  list?: Maybe<Array<Maybe<PlacesItemInZdForUuiDlist>>>;
  emptyList?: Maybe<Array<Maybe<PlacesItemInZdForUuiDemptyList>>>;
};

/** Изменение данных */
export type PlacesSetter = {
  __typename?: "PlacesSetter";
  /** Создание */
  create?: Maybe<Places>;
  /** Редактирование с сохранением истории */
  change?: Maybe<Places>;
  /** изменить место в сортировке. отрицательные значения и 0 не смещают другие элементы */
  setSort?: Maybe<Scalars["Boolean"]>;
  /** Редактирование текущего состояния (eg исправление опечатки) */
  blindChange?: Maybe<Places>;
  /** Добавить значения или обновить значения сущности */
  addValues?: Maybe<Scalars["Boolean"]>;
  /** Сделать неактуальным (удалить) */
  delete?: Maybe<Scalars["Boolean"]>;
  renameGroup?: Maybe<Scalars["Boolean"]>;
  /** изменить место в сортировке */
  setSortGroup?: Maybe<Scalars["Boolean"]>;
};

/** Изменение данных */
export type PlacesSetterCreateArgs = {
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  AreaIndicator?: Maybe<Scalars["ID"]>;
  PlacesCombineIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type PlacesSetterChangeArgs = {
  id?: Maybe<Scalars["ID"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  AreaIndicator?: Maybe<Scalars["ID"]>;
  PlacesCombineIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type PlacesSetterSetSortArgs = {
  sort?: Maybe<Scalars["Int"]>;
  UUID: Scalars["String"];
};

/** Изменение данных */
export type PlacesSetterBlindChangeArgs = {
  id?: Maybe<Scalars["ID"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  AreaIndicator?: Maybe<Scalars["ID"]>;
  PlacesCombineIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type PlacesSetterAddValuesArgs = {
  Compliance?: Maybe<Scalars["Int"]>;
  Area?: Maybe<Scalars["Float"]>;
  PlacesCombine?: Maybe<Scalars["String"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
};

/** Изменение данных */
export type PlacesSetterDeleteArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type PlacesSetterRenameGroupArgs = {
  groupType?: Maybe<ZdGroupType>;
  newGroup?: Maybe<Scalars["String"]>;
  oldGroup?: Maybe<Scalars["String"]>;
};

/** Изменение данных */
export type PlacesSetterSetSortGroupArgs = {
  sort?: Maybe<Scalars["Int"]>;
  group: Scalars["String"];
};

export enum PlacesSortBy {
  Number = "number",
  Name = "name",
  NameEn = "nameEn",
  Sort = "sort",
  GroupOne = "GroupOne",
  SortGroup = "sortGroup",
}

/** Places */
export type PlacesValues = {
  __typename?: "PlacesValues";
  items?: Maybe<Array<Maybe<PlacesOneValuesItem>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type PlanReportGetter = {
  __typename?: "PlanReportGetter";
  getPlanReportRows?: Maybe<GetPlanReportRowsReturn>;
};

export type PlanReportGetterGetPlanReportRowsArgs = {
  PlanReportId?: Maybe<Scalars["ID"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  ZD_UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

export type PlanReportRow = {
  __typename?: "PlanReportRow";
  id?: Maybe<Scalars["ID"]>;
  DealerId: Scalars["ID"];
  DeclinedBy: Scalars["ID"];
  tableIndex: ZdTableIndex;
  ZD_UUID: Scalars["String"];
  responsiblePersonContact?: Maybe<Scalars["String"]>;
  isResolved?: Maybe<Scalars["Boolean"]>;
  reason?: Maybe<Scalars["String"]>;
  fixExplanation?: Maybe<Scalars["String"]>;
  planToFixAt?: Maybe<Scalars["DateTime"]>;
  fixedAt?: Maybe<Scalars["DateTime"]>;
  resolvedAt?: Maybe<Scalars["DateTime"]>;
  Files?: Maybe<Array<Maybe<File>>>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  fio?: Maybe<Scalars["String"]>;
};

export type PlanReportSetter = {
  __typename?: "PlanReportSetter";
  /** что бы сделать строчку плана-отчёта видимой для дилера нужно добавить причину */
  makeVisible?: Maybe<Scalars["Boolean"]>;
  dealerFixPlan?: Maybe<Scalars["Boolean"]>;
  dealerStateFixDone?: Maybe<Scalars["Boolean"]>;
  checkDealersFix?: Maybe<Scalars["Boolean"]>;
  dealerFixPlanAddDocument?: Maybe<Scalars["Boolean"]>;
  dealerFixPlanRemoveDocument?: Maybe<Scalars["Boolean"]>;
};

export type PlanReportSetterMakeVisibleArgs = {
  PlanReportId: Scalars["ID"];
  reason: Scalars["String"];
};

export type PlanReportSetterDealerFixPlanArgs = {
  PlanReportId: Scalars["ID"];
  DealerId: Scalars["ID"];
  fixExplanation?: Maybe<Scalars["String"]>;
  planToFixAt?: Maybe<Scalars["DateTime"]>;
  responsiblePersonContact?: Maybe<Scalars["String"]>;
};

export type PlanReportSetterDealerStateFixDoneArgs = {
  PlanReportId: Scalars["ID"];
  DealerId: Scalars["ID"];
};

export type PlanReportSetterCheckDealersFixArgs = {
  PlanReportId: Scalars["ID"];
  isGood: Scalars["Boolean"];
};

export type PlanReportSetterDealerFixPlanAddDocumentArgs = {
  PlanReportId: Scalars["ID"];
  DealerId: Scalars["ID"];
  fileIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

export type PlanReportSetterDealerFixPlanRemoveDocumentArgs = {
  PlanReportId: Scalars["ID"];
  DealerId: Scalars["ID"];
  fileId: Scalars["ID"];
};

export enum PlanReportTypeDoc {
  Docx = "docx",
  Pdf = "pdf",
}

export type Position = {
  __typename?: "Position";
  id?: Maybe<Scalars["ID"]>;
  code?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  /** @deprecated не используется */
  nameEn?: Maybe<Scalars["String"]>;
  status?: Maybe<PositionStatus>;
  /** Айди направления */
  DirectionId?: Maybe<Scalars["ID"]>;
  /** Информация о направление */
  Direction?: Maybe<PositionDirections>;
  ExpectationId?: Maybe<Scalars["ID"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  showInZd?: Maybe<Scalars["Boolean"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  RequiredEmail?: Maybe<Scalars["Boolean"]>;
  /** Признак, что должностная инструкция обязательна к загрузке */
  jobDescriptionIsRequired?: Maybe<Scalars["Boolean"]>;
  /** Определяет принадлежность к родителю */
  InstanceId?: Maybe<Scalars["ID"]>;
  /** С какого времени актуально */
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  /** До какого времени актуально */
  ActualTo?: Maybe<Scalars["DateTime"]>;
};

export type PositionConsents = {
  __typename?: "PositionConsents";
  name?: Maybe<Scalars["String"]>;
  File?: Maybe<File>;
};

/** Направления должностей */
export type PositionDirections = {
  __typename?: "PositionDirections";
  id?: Maybe<Scalars["ID"]>;
  /** Определяет принадлежность к родителю */
  InstanceId?: Maybe<Scalars["ID"]>;
  /** С какого времени актуально */
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  /** До какого времени актуально */
  ActualTo?: Maybe<Scalars["DateTime"]>;
  name?: Maybe<Scalars["String"]>;
  status?: Maybe<PositionDirectionsStatus>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  role?: Maybe<Array<Maybe<PositionDirectionsRole>>>;
};

export enum PositionDirectionsOrderBy {
  InstanceId = "InstanceId",
  Name = "name",
  Status = "status",
  CreatedAt = "createdAt",
  UpdatedAt = "updatedAt",
  ActualFrom = "ActualFrom",
  ActualTo = "ActualTo",
  Role = "role",
}

export enum PositionDirectionsRole {
  AdminData = "adminData",
  Admin = "admin",
  Leader = "leader",
  Holding = "holding",
  Dealer = "dealer",
  LeaderRegionalSalesManager = "leaderRegionalSalesManager",
  LeaderRegionalServiceManager = "leaderRegionalServiceManager",
  RegionalSalesManager = "regionalSalesManager",
  RegionalServiceManager = "regionalServiceManager",
  Checker = "checker",
  Autovaz = "autovaz",
  Bank = "bank",
}

export enum PositionDirectionsStatus {
  Active = "active",
  Inactive = "inactive",
}

/** Получение данных о Position */
export type PositionGetter = {
  __typename?: "PositionGetter";
  /** Получить должность */
  getPositionById?: Maybe<Position>;
  /** Получить направление */
  getDirectionById?: Maybe<PositionDirections>;
  /** Получить должности */
  getPositions?: Maybe<GetPositionListNew>;
  /** Получить направления */
  getDirections?: Maybe<GetDirections>;
  /** Получить роли для назначения позициям */
  getPositionDirectionRoles?: Maybe<Array<Maybe<PositionDirectionsRole>>>;
  /** Получить получение статусов для направлений */
  getPositionDirectionStatuses?: Maybe<Array<Maybe<PositionDirectionsStatus>>>;
  /** Получение справочников информационных систем */
  getInformationSystems?: Maybe<GetInformationSystems>;
  /** Получение справочника персональных данных */
  getPersonalInformation?: Maybe<GetPersonalInformation>;
  getInformationSystemById?: Maybe<InformationSystem>;
  getPersonalInformationById?: Maybe<PersonalInformation>;
  /** Получение согласий на обработку персональныx данных */
  getTemplateConsentsDataProcessing?: Maybe<GetTemplateConsentsDataProcessing>;
};

/** Получение данных о Position */
export type PositionGetterGetPositionByIdArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** Получение данных о Position */
export type PositionGetterGetDirectionByIdArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** Получение данных о Position */
export type PositionGetterGetPositionsArgs = {
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["ID"]>;
  ids?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  nameEn?: Maybe<Scalars["String"]>;
  InstanceId?: Maybe<Scalars["ID"]>;
  code?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  DirectionId?: Maybe<Scalars["ID"]>;
  status?: Maybe<PositionStatus>;
  showInZd?: Maybe<Scalars["Boolean"]>;
  searchText?: Maybe<Scalars["String"]>;
  createdAtTo?: Maybe<Scalars["DateTime"]>;
  updatedAtTo?: Maybe<Scalars["DateTime"]>;
  ActualOn?: Maybe<Scalars["DateTime"]>;
  createdAtFrom?: Maybe<Scalars["DateTime"]>;
  updatedAtFrom?: Maybe<Scalars["DateTime"]>;
  order?: Maybe<SortType>;
  orderBy?: Maybe<GetPositionsOrderBy>;
};

/** Получение данных о Position */
export type PositionGetterGetDirectionsArgs = {
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  status?: Maybe<PositionDirectionsStatus>;
  ids?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  ActualOn?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  order?: Maybe<SortType>;
  orderBy?: Maybe<PositionDirectionsOrderBy>;
};

/** Получение данных о Position */
export type PositionGetterGetInformationSystemsArgs = {
  name?: Maybe<Scalars["String"]>;
  positions?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

/** Получение данных о Position */
export type PositionGetterGetPersonalInformationArgs = {
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

/** Получение данных о Position */
export type PositionGetterGetInformationSystemByIdArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** Получение данных о Position */
export type PositionGetterGetPersonalInformationByIdArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** Получение данных о Position */
export type PositionGetterGetTemplateConsentsDataProcessingArgs = {
  positionIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

export type PositionIsThePrograms = {
  __typename?: "PositionIsThePrograms";
  PositionGroupId?: Maybe<Scalars["ID"]>;
  Positions?: Maybe<Array<Maybe<Position>>>;
};

export enum PositionProgramsActionEnum {
  Create = "create",
  Edit = "edit",
  Delete = "delete",
}

/** Изменение данных о Position */
export type PositionSetter = {
  __typename?: "PositionSetter";
  /** Создание позиции */
  createPosition?: Maybe<Position>;
  /** Изменение информации о должности */
  editPosition?: Maybe<Position>;
  /** Удаление должности. */
  deletePosition?: Maybe<Scalars["Boolean"]>;
  /** Редактирование позиции */
  editDirection?: Maybe<PositionDirections>;
  /** Создание направления для должностей. */
  createDirection?: Maybe<PositionDirections>;
  createInformationSystem?: Maybe<InformationSystem>;
  editInformationSystem?: Maybe<InformationSystem>;
  /** Создание справочника персональных данных */
  createPersonalInformation?: Maybe<PersonalInformation>;
  /** Изменение справочника персональных данных */
  editPersonalInformation?: Maybe<PersonalInformation>;
};

/** Изменение данных о Position */
export type PositionSetterCreatePositionArgs = {
  code: Scalars["String"];
  name: Scalars["String"];
  nameEn?: Maybe<Scalars["String"]>;
  status: PositionStatus;
  DirectionId: Scalars["ID"];
  RequiredEmail?: Maybe<Scalars["Boolean"]>;
  jobDescriptionIsRequired?: Maybe<Scalars["Boolean"]>;
};

/** Изменение данных о Position */
export type PositionSetterEditPositionArgs = {
  id: Scalars["ID"];
  code?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  status?: Maybe<PositionStatus>;
  DirectionId?: Maybe<Scalars["ID"]>;
  RequiredEmail?: Maybe<Scalars["Boolean"]>;
  jobDescriptionIsRequired?: Maybe<Scalars["Boolean"]>;
  showInZd?: Maybe<Scalars["Boolean"]>;
};

/** Изменение данных о Position */
export type PositionSetterDeletePositionArgs = {
  id: Scalars["ID"];
};

/** Изменение данных о Position */
export type PositionSetterEditDirectionArgs = {
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  status?: Maybe<PositionDirectionsStatus>;
  role?: Maybe<Array<Maybe<PositionDirectionsRole>>>;
};

/** Изменение данных о Position */
export type PositionSetterCreateDirectionArgs = {
  name: Scalars["String"];
  status: PositionDirectionsStatus;
  role: Array<Maybe<PositionDirectionsRole>>;
};

/** Изменение данных о Position */
export type PositionSetterCreateInformationSystemArgs = {
  name: Scalars["String"];
  positions?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Изменение данных о Position */
export type PositionSetterEditInformationSystemArgs = {
  id: Scalars["ID"];
  name: Scalars["String"];
  positions?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Изменение данных о Position */
export type PositionSetterCreatePersonalInformationArgs = {
  name: Scalars["String"];
  personalDataTemplateId?: Maybe<Scalars["ID"]>;
  informationSystemId?: Maybe<Scalars["ID"]>;
};

/** Изменение данных о Position */
export type PositionSetterEditPersonalInformationArgs = {
  id: Scalars["ID"];
  name: Scalars["String"];
  personalDataTemplate?: Maybe<Scalars["String"]>;
  informationSystemId?: Maybe<Scalars["ID"]>;
};

export enum PositionStatus {
  Active = "active",
  Inactive = "inactive",
}

/** Пользователь */
export type Profile = {
  __typename?: "Profile";
  id?: Maybe<Scalars["ID"]>;
  login?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  fullname?: Maybe<Scalars["String"]>;
  fullnameEn?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  position?: Maybe<Scalars["String"]>;
  positionEn?: Maybe<Scalars["String"]>;
  role?: Maybe<Scalars["String"]>;
  roleRu?: Maybe<Scalars["String"]>;
  roleEn?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  countDC?: Maybe<Scalars["Int"]>;
  lastOnlineDate?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  isViolationAccess?: Maybe<Scalars["Boolean"]>;
  isEmployeeAccess?: Maybe<Scalars["Boolean"]>;
  isCandidateAccess?: Maybe<Scalars["Boolean"]>;
  isZdAccess?: Maybe<Scalars["Boolean"]>;
  isAnnouncementsAccess?: Maybe<Scalars["Boolean"]>;
  isAccountingAccess?: Maybe<Scalars["Boolean"]>;
  isAnnouncementsSend?: Maybe<Scalars["Boolean"]>;
  isDocumentsAccess?: Maybe<Scalars["Boolean"]>;
  isCameraAccess?: Maybe<Scalars["Boolean"]>;
  ivideon_access?: Maybe<Scalars["Boolean"]>;
  dnm_access?: Maybe<Scalars["Boolean"]>;
  isTrustedPersonAccess: Scalars["Boolean"];
  /** Временный доступ ко всем ДЦ, актуально для региональных менеджеровhttp://task.sotl.group:8080/browse/PASDILER-94 */
  isTemporaryAccessToAllDealers?: Maybe<Scalars["Boolean"]>;
  SubdivisionId?: Maybe<Scalars["ID"]>;
  Subdivision?: Maybe<Subdivision>;
  lockDate?: Maybe<Scalars["DateTime"]>;
  Employee?: Maybe<EmployeeForProfile>;
};

/** Данные для AfterSales */
export type Profitability = {
  __typename?: "Profitability";
  i600?: Maybe<IndicatorValue>;
  i601?: Maybe<IndicatorValue>;
  i602?: Maybe<IndicatorValue>;
  i603?: Maybe<IndicatorValue>;
  i604?: Maybe<IndicatorValue>;
  i605?: Maybe<IndicatorValue>;
};

/** дилер */
export type PureDealer = {
  __typename?: "PureDealer";
  id: Scalars["ID"];
  autoCRMID?: Maybe<Scalars["ID"]>;
  type?: Maybe<Scalars["String"]>;
  typeEn?: Maybe<Scalars["String"]>;
  ent_id?: Maybe<Scalars["ID"]>;
  dealerName?: Maybe<Scalars["String"]>;
  dealerNameEn?: Maybe<Scalars["String"]>;
  tradeDealerName?: Maybe<Scalars["String"]>;
  tradeDealerNameEn?: Maybe<Scalars["String"]>;
  legalDealerName?: Maybe<Scalars["String"]>;
  legalDealerNameEn?: Maybe<Scalars["String"]>;
  kPP?: Maybe<Scalars["String"]>;
  contractEndDate?: Maybe<Scalars["DateTime"]>;
  iS_Id?: Maybe<Scalars["String"]>;
  main?: Maybe<Scalars["Int"]>;
  newDealer?: Maybe<Scalars["Int"]>;
  temporaryDecision?: Maybe<Scalars["Int"]>;
  protocolOfIntentions?: Maybe<Scalars["Int"]>;
  logicalType?: Maybe<Scalars["Int"]>;
  extendedForNextYear?: Maybe<Scalars["Int"]>;
  terminated?: Maybe<Scalars["Int"]>;
  hideOnLadaRu?: Maybe<Scalars["Int"]>;
  termOfAuthority?: Maybe<Scalars["DateTime"]>;
  consumerCode?: Maybe<Scalars["String"]>;
  corporateEmail?: Maybe<Scalars["String"]>;
  settlementAccount?: Maybe<Scalars["String"]>;
  correspondentAccount?: Maybe<Scalars["String"]>;
  bankName?: Maybe<Scalars["String"]>;
  responsibleForLadaEmail?: Maybe<Scalars["String"]>;
  responsibleForLadaFax?: Maybe<Scalars["String"]>;
  responsibleForLadaPhone?: Maybe<Scalars["String"]>;
  responsibleForLadaCode?: Maybe<Scalars["String"]>;
  responsibleForLadaName?: Maybe<Scalars["String"]>;
  accountantEmail?: Maybe<Scalars["String"]>;
  accountantFax?: Maybe<Scalars["String"]>;
  accountantPhone?: Maybe<Scalars["String"]>;
  accountantCode?: Maybe<Scalars["String"]>;
  accountantName?: Maybe<Scalars["String"]>;
  protocolOfTermination?: Maybe<Scalars["String"]>;
  protocolOfConclusion?: Maybe<Scalars["String"]>;
  successorCode?: Maybe<Scalars["String"]>;
  entfCode?: Maybe<Scalars["String"]>;
  entfSuccessorNo?: Maybe<Scalars["String"]>;
  entfSuccessorCode?: Maybe<Scalars["String"]>;
  category?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  legalAddress?: Maybe<Scalars["String"]>;
  reestrLegalAddress?: Maybe<Scalars["String"]>;
  legalCityId?: Maybe<Scalars["Int"]>;
  legalHouseId?: Maybe<Scalars["Int"]>;
  postalAddress?: Maybe<Scalars["String"]>;
  reestrPostAddress?: Maybe<Scalars["String"]>;
  postalCityId?: Maybe<Scalars["Int"]>;
  postalHouseId?: Maybe<Scalars["Int"]>;
  address?: Maybe<Scalars["String"]>;
  reestrAddress?: Maybe<Scalars["String"]>;
  addressEn?: Maybe<Scalars["String"]>;
  regionCode?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  countryEn?: Maybe<Scalars["String"]>;
  fO?: Maybe<Scalars["String"]>;
  fOEn?: Maybe<Scalars["String"]>;
  subject?: Maybe<Scalars["String"]>;
  subjectEn?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  cityEn?: Maybe<Scalars["String"]>;
  cityId?: Maybe<Scalars["Int"]>;
  houseId?: Maybe<Scalars["Int"]>;
  headFax?: Maybe<Scalars["String"]>;
  headCode?: Maybe<Scalars["String"]>;
  headNameGenitive?: Maybe<Scalars["String"]>;
  headPositionGenitive?: Maybe<Scalars["String"]>;
  headNameImported?: Maybe<Scalars["String"]>;
  headFullNameGenitive?: Maybe<Scalars["String"]>;
  headPositionImported?: Maybe<Scalars["String"]>;
  headEmailImported?: Maybe<Scalars["String"]>;
  headPhoneImported?: Maybe<Scalars["String"]>;
  ePEn?: Maybe<Scalars["String"]>;
  headName?: Maybe<Scalars["String"]>;
  headNameEn?: Maybe<Scalars["String"]>;
  headPhone?: Maybe<Scalars["String"]>;
  headMobilePhone?: Maybe<Scalars["String"]>;
  headEmail?: Maybe<Scalars["String"]>;
  ownerName?: Maybe<Scalars["String"]>;
  ownerNameEn?: Maybe<Scalars["String"]>;
  ownerPhone?: Maybe<Scalars["String"]>;
  ownerMobilePhone?: Maybe<Scalars["String"]>;
  ownerEmail?: Maybe<Scalars["String"]>;
  birCode?: Maybe<Scalars["String"]>;
  beginWorkingDate?: Maybe<Scalars["DateTime"]>;
  ivideonSublicenseStartAt?: Maybe<Scalars["DateTime"]>;
  isIvideonActFormed: Scalars["Boolean"];
  contractId?: Maybe<Scalars["ID"]>;
  headCompanyId?: Maybe<Scalars["ID"]>;
  photoDealerCenterId?: Maybe<Scalars["ID"]>;
  photoOwnerId?: Maybe<Scalars["ID"]>;
  photoBossId?: Maybe<Scalars["ID"]>;
  scanOwnerPersonDataId?: Maybe<Scalars["ID"]>;
  scanBossPersonDataId?: Maybe<Scalars["ID"]>;
  scanLadaPersonDataId?: Maybe<Scalars["ID"]>;
  scanAccountantPersonDataId?: Maybe<Scalars["ID"]>;
  organizationalLegalForm?: Maybe<Scalars["String"]>;
  stoPhCode?: Maybe<Scalars["String"]>;
  stoPhone?: Maybe<Scalars["String"]>;
  stoEmail?: Maybe<Scalars["String"]>;
  shopPhCode?: Maybe<Scalars["String"]>;
  shopPhone?: Maybe<Scalars["String"]>;
  shopEmail?: Maybe<Scalars["String"]>;
  autoCrmLastUpdate?: Maybe<Scalars["DateTime"]>;
  autoCrmDisabledAt?: Maybe<Scalars["String"]>;
  latitude?: Maybe<Scalars["String"]>;
  longitude?: Maybe<Scalars["String"]>;
  status?: Maybe<DealerStatus>;
  projectDocumentationId?: Maybe<Scalars["ID"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  inn?: Maybe<Scalars["String"]>;
  ep?: Maybe<Scalars["String"]>;
  ogrn?: Maybe<Scalars["String"]>;
  egrNumber?: Maybe<Scalars["String"]>;
  egrSeries?: Maybe<Scalars["String"]>;
  egrDate?: Maybe<Scalars["DateTime"]>;
  bik?: Maybe<Scalars["String"]>;
  xStoPhcode?: Maybe<Scalars["String"]>;
  xStoPhone?: Maybe<Scalars["String"]>;
  xStoEmail?: Maybe<Scalars["String"]>;
  xShopPhcode?: Maybe<Scalars["String"]>;
  xShopPhone?: Maybe<Scalars["String"]>;
  xShopEmail?: Maybe<Scalars["String"]>;
  xShopName?: Maybe<Scalars["String"]>;
  xShopFlag?: Maybe<Scalars["Boolean"]>;
  kgaCode?: Maybe<Scalars["String"]>;
  onecCode?: Maybe<Scalars["String"]>;
  dealerLadaserv?: Maybe<Scalars["Int"]>;
};

export type PureEmployee = {
  __typename?: "PureEmployee";
  id?: Maybe<Scalars["ID"]>;
  surname?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  middleName?: Maybe<Scalars["String"]>;
  gender: GenderType;
  email?: Maybe<Scalars["String"]>;
  personalPhone?: Maybe<Scalars["String"]>;
  workPhone?: Maybe<Scalars["String"]>;
  hiredDate?: Maybe<Scalars["DateTime"]>;
  firedDate?: Maybe<Scalars["DateTime"]>;
  lastEditDate?: Maybe<Scalars["DateTime"]>;
  createdBy?: Maybe<Scalars["ID"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  ladaAcademiaId?: Maybe<Scalars["String"]>;
  firedAt?: Maybe<Scalars["DateTime"]>;
  firedBy?: Maybe<Scalars["ID"]>;
  lastEditBy?: Maybe<Scalars["ID"]>;
  verifiedAt?: Maybe<Scalars["DateTime"]>;
  verifiedBy?: Maybe<Scalars["ID"]>;
  status?: Maybe<EmployeeStatus>;
  lastStatusUpdateAt?: Maybe<Scalars["DateTime"]>;
  lastStatusUpdateBy?: Maybe<Scalars["ID"]>;
  importDate?: Maybe<Scalars["DateTime"]>;
  verifiedInDnm?: Maybe<Scalars["Boolean"]>;
};

export type PureEmployeePosition = {
  __typename?: "PureEmployeePosition";
  id?: Maybe<Scalars["ID"]>;
  employeesId?: Maybe<Scalars["ID"]>;
  number?: Maybe<Scalars["Int"]>;
  startDate?: Maybe<Scalars["DateTime"]>;
  startOrderNumber?: Maybe<Scalars["String"]>;
  endDate?: Maybe<Scalars["DateTime"]>;
  endOrderNumber?: Maybe<Scalars["String"]>;
  createdBy?: Maybe<Scalars["ID"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  dealerId?: Maybe<Scalars["ID"]>;
  positionsId?: Maybe<Scalars["ID"]>;
  instanceId?: Maybe<Scalars["ID"]>;
  actualFrom?: Maybe<Scalars["DateTime"]>;
  actualTo?: Maybe<Scalars["DateTime"]>;
  email?: Maybe<Scalars["String"]>;
  emailVerification?: Maybe<Scalars["Boolean"]>;
  status?: Maybe<EmployeePositionStatus>;
  lastStatusUpdateAt?: Maybe<Scalars["DateTime"]>;
  lastModifiedAt?: Maybe<Scalars["DateTime"]>;
  lastModifiedBy?: Maybe<Scalars["ID"]>;
  hireBy?: Maybe<Scalars["ID"]>;
  verifyBy?: Maybe<Scalars["ID"]>;
  verifyDate?: Maybe<Scalars["DateTime"]>;
  fireBy?: Maybe<Scalars["ID"]>;
  recheckRequiredNotified?: Maybe<Scalars["Boolean"]>;
  lastStatusUpdateBy?: Maybe<Scalars["ID"]>;
  dataConsentId?: Maybe<Scalars["ID"]>;
  recid?: Maybe<Scalars["ID"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  emailVerificationDate?: Maybe<Scalars["DateTime"]>;
  positionOrderId?: Maybe<Scalars["ID"]>;
  rejectReason?: Maybe<Scalars["String"]>;
};

export type PurePosition = {
  __typename?: "PurePosition";
  id?: Maybe<Scalars["ID"]>;
  code?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  /** @deprecated не используется */
  nameEn?: Maybe<Scalars["String"]>;
  status?: Maybe<PositionStatus>;
  /** Айди направления */
  directionId?: Maybe<Scalars["ID"]>;
  expectationId?: Maybe<Scalars["ID"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  requiredEmail?: Maybe<Scalars["Boolean"]>;
  instanceId?: Maybe<Scalars["ID"]>;
  /** С какого времени актуально */
  actualFrom?: Maybe<Scalars["DateTime"]>;
  /** До какого времени актуально */
  actualTo?: Maybe<Scalars["DateTime"]>;
};

/** Направления должностей */
export type PurePositionDirection = {
  __typename?: "PurePositionDirection";
  id?: Maybe<Scalars["ID"]>;
  /** Определяет принадлежность к родителю */
  instanceId?: Maybe<Scalars["ID"]>;
  /** С какого времени актуально */
  actualFrom?: Maybe<Scalars["DateTime"]>;
  /** До какого времени актуально */
  actualTo?: Maybe<Scalars["DateTime"]>;
  name?: Maybe<Scalars["String"]>;
  status?: Maybe<PositionDirectionsStatus>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  role?: Maybe<Array<Maybe<PositionDirectionsRole>>>;
};

/** Данные для Quality */
export type Quality = {
  __typename?: "Quality";
  GlobalRatingVersion?: Maybe<WorkSpaceGlobalRatingVersion>;
};

/** Строчка рейтинга */
export type QuartilesAvailable = {
  __typename?: "QuartilesAvailable";
  year?: Maybe<Scalars["Int"]>;
  month?: Maybe<Scalars["Int"]>;
};

/** Строчка рейтинга */
export type QuartilesRating = {
  __typename?: "QuartilesRating";
  id?: Maybe<Scalars["ID"]>;
  number?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  KPIen?: Maybe<Scalars["String"]>;
  KPIru?: Maybe<Scalars["String"]>;
  LastPeriodIndicatorId?: Maybe<Scalars["ID"]>;
  ValueIndicatorId?: Maybe<Scalars["ID"]>;
  GroupIndicatorId?: Maybe<Scalars["ID"]>;
  AverageIndicatorId?: Maybe<Scalars["ID"]>;
  DifferenceIndicatorId?: Maybe<Scalars["ID"]>;
  GroupAverageIndicatorId?: Maybe<Scalars["ID"]>;
  type: Scalars["String"];
  sort: Scalars["Int"];
  round?: Maybe<Scalars["Int"]>;
  format?: Maybe<Scalars["Int"]>;
  ParentId?: Maybe<Scalars["ID"]>;
  PrevElementId?: Maybe<Scalars["ID"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  RatingsVersionId?: Maybe<Scalars["ID"]>;
  Version?: Maybe<QuartilesRatingVersion>;
  LastPeriodIndicator?: Maybe<Indicator>;
  ValueIndicator?: Maybe<Indicator>;
  GroupIndicator?: Maybe<Indicator>;
  AverageIndicator?: Maybe<Indicator>;
  DifferenceIndicator?: Maybe<Indicator>;
  GroupAverageIndicator?: Maybe<Indicator>;
  Parent?: Maybe<QuartilesRating>;
  PrevElement?: Maybe<QuartilesRating>;
};

/** Получение данных о рейтингах */
export type QuartilesRatingGetter = {
  __typename?: "QuartilesRatingGetter";
  /** Запрос полного отчёта по всем данным */
  getFullReports?: Maybe<ReportFile>;
  /** Получить отчёт по даннм о главном показателе */
  getReportDetailingMainIndicator?: Maybe<ReportFile>;
  /** Запрос на красивый отчёт */
  getBeautifulReports?: Maybe<ReportFile>;
  /** Получить информацию по главному показателю */
  getDetailingMainIndicator?: Maybe<QuartilesRatingVersion>;
  /** Получить детализацию по показателю */
  getRatingDataByLine?: Maybe<QuartilesRating>;
  /** Получить список версий рейтингов */
  getVersions?: Maybe<Array<Maybe<QuartilesRatingVersion>>>;
  /** Получить список версий рейтингов */
  getRatings?: Maybe<Array<Maybe<QuartilesRating>>>;
  /** Запрос полного отчёта по одному показателю */
  getReports?: Maybe<ReportFile>;
  /** Получить версию рейтинга со значениями */
  getRatingData?: Maybe<QuartilesRatingVersion>;
  /** Получить список строк версии рейтинга без значений индикатора, только имя */
  getRatingsListName?: Maybe<Array<Maybe<QuartilesRatingName>>>;
  /** Получить месяца для дилера у которых есть данные */
  getAllowedMonthsForDealer?: Maybe<GetAllowedMonthsForDealerList>;
};

/** Получение данных о рейтингах */
export type QuartilesRatingGetterGetFullReportsArgs = {
  DealerId: Scalars["ID"];
  date: Scalars["DateTime"];
  lang?: Maybe<Scalars["String"]>;
};

/** Получение данных о рейтингах */
export type QuartilesRatingGetterGetReportDetailingMainIndicatorArgs = {
  DealerId: Scalars["ID"];
  date: Scalars["DateTime"];
  lang?: Maybe<Scalars["String"]>;
};

/** Получение данных о рейтингах */
export type QuartilesRatingGetterGetBeautifulReportsArgs = {
  DealerId: Scalars["ID"];
  date: Scalars["DateTime"];
  lang?: Maybe<Scalars["String"]>;
};

/** Получение данных о рейтингах */
export type QuartilesRatingGetterGetDetailingMainIndicatorArgs = {
  DealerId: Scalars["ID"];
  date: Scalars["DateTime"];
};

/** Получение данных о рейтингах */
export type QuartilesRatingGetterGetRatingDataByLineArgs = {
  DealerId: Scalars["ID"];
  QuartilesRatingId: Scalars["ID"];
  date: Scalars["DateTime"];
};

/** Получение данных о рейтингах */
export type QuartilesRatingGetterGetRatingsArgs = {
  onlyParent: Scalars["Boolean"];
  RatingsVersionId: Scalars["ID"];
};

/** Получение данных о рейтингах */
export type QuartilesRatingGetterGetReportsArgs = {
  DealerId: Scalars["ID"];
  QuartilesRatingId: Scalars["ID"];
  date: Scalars["DateTime"];
  count?: Maybe<Scalars["Int"]>;
  lang?: Maybe<Scalars["String"]>;
};

/** Получение данных о рейтингах */
export type QuartilesRatingGetterGetRatingDataArgs = {
  DealerId: Scalars["ID"];
  date: Scalars["DateTime"];
};

/** Получение данных о рейтингах */
export type QuartilesRatingGetterGetRatingsListNameArgs = {
  onlyParent: Scalars["Boolean"];
  RatingsVersionId?: Maybe<Scalars["ID"]>;
  RatingsId?: Maybe<Scalars["ID"]>;
};

/** Получение данных о рейтингах */
export type QuartilesRatingGetterGetAllowedMonthsForDealerArgs = {
  DealerId: Scalars["ID"];
};

/** Строчка рейтинга только имена */
export type QuartilesRatingName = {
  __typename?: "QuartilesRatingName";
  id?: Maybe<Scalars["ID"]>;
  number?: Maybe<Scalars["String"]>;
  KPIru?: Maybe<Scalars["String"]>;
  KPIen?: Maybe<Scalars["String"]>;
  ParentId?: Maybe<Scalars["ID"]>;
  PrevElementId?: Maybe<Scalars["ID"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  RatingsVersionId?: Maybe<Scalars["ID"]>;
};

/** Изменение данных в рейтингах */
export type QuartilesRatingSetter = {
  __typename?: "QuartilesRatingSetter";
  /** создать/редактировать строчку в рейтинге */
  setRating?: Maybe<QuartilesRating>;
  /** создать/редактировать версию в рейтинге */
  setVersion?: Maybe<QuartilesRatingVersion>;
  /** удалить версию в рейтинге */
  deleteVersion?: Maybe<Scalars["Boolean"]>;
  /** удалить строчку в версии рейтинга */
  deleteList?: Maybe<Scalars["Boolean"]>;
};

/** Изменение данных в рейтингах */
export type QuartilesRatingSetterSetRatingArgs = {
  id?: Maybe<Scalars["ID"]>;
  number?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  KPIen?: Maybe<Scalars["String"]>;
  KPIru?: Maybe<Scalars["String"]>;
  LastPeriodIndicatorId?: Maybe<Scalars["ID"]>;
  ValueIndicatorId?: Maybe<Scalars["ID"]>;
  GroupIndicatorId?: Maybe<Scalars["ID"]>;
  AverageIndicatorId?: Maybe<Scalars["ID"]>;
  DifferenceIndicatorId?: Maybe<Scalars["ID"]>;
  GroupAverageIndicatorId?: Maybe<Scalars["ID"]>;
  type: Scalars["String"];
  sort: Scalars["Int"];
  round?: Maybe<Scalars["Int"]>;
  format?: Maybe<Scalars["Int"]>;
  ParentId?: Maybe<Scalars["ID"]>;
  PrevElementId?: Maybe<Scalars["ID"]>;
  RatingsVersionId: Scalars["ID"];
};

/** Изменение данных в рейтингах */
export type QuartilesRatingSetterSetVersionArgs = {
  id?: Maybe<Scalars["ID"]>;
  quarter?: Maybe<Scalars["Int"]>;
  year?: Maybe<Scalars["Int"]>;
  dateBegin?: Maybe<Scalars["DateTime"]>;
  IndicatorId?: Maybe<Scalars["ID"]>;
  IndicatorGroupId?: Maybe<Scalars["ID"]>;
};

/** Изменение данных в рейтингах */
export type QuartilesRatingSetterDeleteVersionArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** Изменение данных в рейтингах */
export type QuartilesRatingSetterDeleteListArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** Версия рейтинга */
export type QuartilesRatingVersion = {
  __typename?: "QuartilesRatingVersion";
  id?: Maybe<Scalars["ID"]>;
  quarter?: Maybe<Scalars["Int"]>;
  year?: Maybe<Scalars["Int"]>;
  IndicatorId?: Maybe<Scalars["ID"]>;
  IndicatorGroupId?: Maybe<Scalars["ID"]>;
  dateBegin?: Maybe<Scalars["DateTime"]>;
  Indicator?: Maybe<Indicator>;
  IndicatorGroup?: Maybe<Indicator>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  Ratings?: Maybe<Array<Maybe<QuartilesRating>>>;
};

/** Получение данных */
export type Query = {
  __typename?: "Query";
  AccountingGetter?: Maybe<AccountingGetter>;
  AnnouncementGetter?: Maybe<AnnouncementGetter>;
  CameraGetter?: Maybe<CameraGetter>;
  /** Получени коментариев чек листа */
  CheckListCommentGetter?: Maybe<CheckListCommentGetter>;
  CheckListGetter?: Maybe<CheckListGetter>;
  CheckListIndicatorGetter?: Maybe<CheckListIndicatorGetter>;
  ContractTemplateGetter?: Maybe<ContractTemplateGetter>;
  /** Получение данных о дилерах */
  DealerGetter?: Maybe<DealerGetter>;
  /** Получение данных о галереи дилера */
  DealerPhotoGetter?: Maybe<DealerPhotoGetter>;
  /** Получение данных о дилерах */
  DealerRegistryGetter?: Maybe<DealerRegistryGetter>;
  DocumentGetter?: Maybe<DocumentGetter>;
  /** Получение данных о Education */
  EducationGetter?: Maybe<EducationGetter>;
  /** Получение данных о Employees */
  EmployeeGetter?: Maybe<EmployeeGetter>;
  /** Получение данных о файлах */
  FileCatalogGetter?: Maybe<FileCatalogGetter>;
  /** Получение данных о файлах */
  FileGetter?: Maybe<FileGetter>;
  GeoGetter?: Maybe<GeoGetter>;
  /** Получение данных о рейтингах */
  GlobalRatingGetter?: Maybe<GlobalRatingGetter>;
  /** Получение данных о индикаторах */
  IndicatorGetter?: Maybe<IndicatorGetter>;
  /** Получение данных для отчета по индикаторам */
  IndicatorGroupReportGetter?: Maybe<IndicatorGroupReportGetter>;
  IvideonCameraTariffGetter?: Maybe<IvideonCameraTariffGetter>;
  IvideonCamerasIntegrationGetter?: Maybe<IvideonCamerasIntegrationGetter>;
  /** Получение данных о логах */
  LogGetter?: Maybe<LogGetter>;
  /** Получение данных Наличие обязательных приложений */
  NotesGetter?: Maybe<NotesGetter>;
  /** Получение данных Численность персонала СЦP */
  PersonalGetter?: Maybe<PersonalGetter>;
  /** Получение разделов фотогалереи */
  PhotoGallerySectionGetter?: Maybe<PhotoGallerySectionGetter>;
  /** Получение данных Рабочие посты */
  PlacePostsGetter?: Maybe<PlacePostsGetter>;
  /** Получение данных Производственные участки */
  PlacesGetter?: Maybe<PlacesGetter>;
  PlanReportGetter?: Maybe<PlanReportGetter>;
  /** Получение данных о Position */
  PositionGetter?: Maybe<PositionGetter>;
  /** Получение данных о рейтингах */
  QuartilesRatingGetter?: Maybe<QuartilesRatingGetter>;
  /** Получение данных Оборудование для выполнения требований ГОСТ */
  RequiredToolsGetter?: Maybe<RequiredToolsGetter>;
  /** Получение отчетов по SRR */
  SRRGetter?: Maybe<SrrGetter>;
  /** Получение данных Предоставляемые услуги */
  ServicesGetter?: Maybe<ServicesGetter>;
  /** получить настройки */
  SettingsGetter?: Maybe<SettingsGetter>;
  SubdivisionGetter?: Maybe<SubdivisionGetter>;
  SystemSettingGettter?: Maybe<SystemSettingsGetter>;
  /** Получение данных технологическое оборудование */
  ToolsGetter?: Maybe<ToolsGetter>;
  /** Получение данных специального инструменты и приспособления обязательные для гарантийного обслуживания */
  ToolsInsuranceGetter?: Maybe<ToolsInsuranceGetter>;
  /** Получение данных Метрологическое оборудование */
  ToolsMetrologicalGetter?: Maybe<ToolsMetrologicalGetter>;
  /** Получение данных Торговые площади */
  TradePremisesGetter?: Maybe<TradePremisesGetter>;
  TrustedPersonGetter?: Maybe<TrustedPersonGetter>;
  /** Получение данных о пользователях */
  UserGetter?: Maybe<UserGetter>;
  /** Получение данных о руководствах пользователя */
  UserGuideGetter?: Maybe<UserGuideGetter>;
  ViolationGetter?: Maybe<ViolationGetter>;
  ViolationTypesGetter?: Maybe<ViolationTypesGetter>;
  /** Получение данных Складские помещения */
  WarehousesGetter?: Maybe<WarehousesGetter>;
  /** Получение данных для главного экрана */
  WorkSpaceGetter?: Maybe<WorkSpaceGetter>;
  ZdCommonGetter?: Maybe<ZdCommonGetter>;
  /** получить отчёты по ZD */
  ZdReportsGetter?: Maybe<ZdReportsGetter>;
  getNotifications?: Maybe<Array<Maybe<Notification>>>;
};

/** Роль регмена с аббревиатурой для блока Отчёты */
export type RegMenInfo = {
  __typename?: "RegMenInfo";
  role?: Maybe<Scalars["String"]>;
  roleRu?: Maybe<Scalars["String"]>;
  roleEn?: Maybe<Scalars["String"]>;
  roleRuAbbr?: Maybe<Scalars["String"]>;
  roleEnAbbr?: Maybe<Scalars["String"]>;
};

/** Региональные менеджеры */
export type RegMens = {
  __typename?: "RegMens";
  id?: Maybe<Scalars["ID"]>;
  fullname?: Maybe<Scalars["String"]>;
  fullnameEn?: Maybe<Scalars["String"]>;
  roleRu?: Maybe<Scalars["String"]>;
  roleEn?: Maybe<Scalars["String"]>;
};

/** Список пользователей */
export type RegMensList = {
  __typename?: "RegMensList";
  items?: Maybe<Array<Maybe<RegMens>>>;
  total?: Maybe<Scalars["Int"]>;
};

/** Строковый идентификатор файла */
export type ReportFile = {
  __typename?: "ReportFile";
  fileHash?: Maybe<Scalars["String"]>;
};

export type ReportPeriod = {
  __typename?: "ReportPeriod";
  id?: Maybe<Scalars["ID"]>;
  Year?: Maybe<Scalars["Int"]>;
  Quarter?: Maybe<Scalars["Int"]>;
  lastDate?: Maybe<Scalars["DateTime"]>;
  reportDate?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
};

/** Отчет по дилеру */
export type ReportRegMenByDealerByDealer = {
  __typename?: "ReportRegMenByDealerByDealer";
  quarter?: Maybe<Scalars["Int"]>;
  year?: Maybe<Scalars["Int"]>;
  leaderRegionalSalesManager?: Maybe<Scalars["String"]>;
  regionalSalesManager?: Maybe<Scalars["String"]>;
  leaderRegionalServiceManager?: Maybe<Scalars["String"]>;
  regionalServiceManager?: Maybe<Scalars["String"]>;
};

/** Отчет по периоду */
export type ReportRegMenByDealerByPeriod = {
  __typename?: "ReportRegMenByDealerByPeriod";
  dealerId?: Maybe<Scalars["String"]>;
  INN?: Maybe<Scalars["String"]>;
  filial?: Maybe<Scalars["String"]>;
  DealerName?: Maybe<Scalars["String"]>;
  FO?: Maybe<Scalars["String"]>;
  subject?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  entfCode?: Maybe<Scalars["String"]>;
  successorCode?: Maybe<Scalars["String"]>;
  entfSuccessorNo?: Maybe<Scalars["String"]>;
  entfSuccessorCode?: Maybe<Scalars["String"]>;
  leaderRegionalSalesManager?: Maybe<Scalars["String"]>;
  regionalSalesManager?: Maybe<Scalars["String"]>;
  leaderRegionalServiceManager?: Maybe<Scalars["String"]>;
  regionalServiceManager?: Maybe<Scalars["String"]>;
};

/** Отчет по региональному менеджеру */
export type ReportRegMenByDealerByRegMen = {
  __typename?: "ReportRegMenByDealerByRegMen";
  quarter?: Maybe<Scalars["Int"]>;
  year?: Maybe<Scalars["Int"]>;
  INN?: Maybe<Scalars["String"]>;
  filial?: Maybe<Scalars["String"]>;
  DealerName?: Maybe<Scalars["String"]>;
  FO?: Maybe<Scalars["String"]>;
  subject?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  entfCode?: Maybe<Scalars["String"]>;
  successorCode?: Maybe<Scalars["String"]>;
  entfSuccessorNo?: Maybe<Scalars["String"]>;
  entfSuccessorCode?: Maybe<Scalars["String"]>;
};

/** Сводный отчет по региональным менеджерам */
export type ReportRegMenByDealerConsolidate = {
  __typename?: "ReportRegMenByDealerConsolidate";
  regionalManager?: Maybe<Scalars["String"]>;
  role?: Maybe<Scalars["String"]>;
  statistic?: Maybe<Array<Maybe<Statistic>>>;
  periods?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export enum ReportState {
  FormOneZero = "formOneZero",
  FormTwoZero = "formTwoZero",
  NoFile = "noFile",
  AccountingBad = "accountingBad",
  Good = "good",
}

export enum ReportType {
  Excel = "excel",
  Pdf = "pdf",
}

/** RequiredTools */
export type RequiredTools = {
  __typename?: "RequiredTools";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  ModelIndicator?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
  CheckedDateIndicator?: Maybe<Scalars["ID"]>;
};

/** RequiredTools */
export type RequiredToolsDealerStatuses = {
  __typename?: "RequiredToolsDealerStatuses";
  DealerId?: Maybe<Scalars["ID"]>;
  Dealer?: Maybe<Dealer>;
  ZD_UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  status?: Maybe<ZdStatusType>;
  /** последнее обновление заявки дилером */
  lastUpdatedAt?: Maybe<Scalars["DateTime"]>;
  /** последнее обновление статуса заявки */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** Получение данных */
export type RequiredToolsGetter = {
  __typename?: "RequiredToolsGetter";
  /** Получение значений по дилеру и дате */
  getValues?: Maybe<RequiredToolsValues>;
  getDealerStatuses?: Maybe<Array<Maybe<RequiredToolsDealerStatuses>>>;
  getById?: Maybe<RequiredToolsIndicatorTypes>;
  /** Получить все актуальные на данные момент записи с индикаторами */
  getAll?: Maybe<Array<Maybe<RequiredToolsIndicatorTypes>>>;
  getGroups?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

/** Получение данных */
export type RequiredToolsGetterGetValuesArgs = {
  DealerId: Scalars["ID"];
  sortBy?: Maybe<RequiredToolsSortBy>;
  dateUpTo?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
};

/** Получение данных */
export type RequiredToolsGetterGetDealerStatusesArgs = {
  UUID?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

/** Получение данных */
export type RequiredToolsGetterGetByIdArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** Получение данных */
export type RequiredToolsGetterGetGroupsArgs = {
  groupType?: Maybe<ZdGroupType>;
};

/** RequiredTools */
export type RequiredToolsIndicatorTypes = {
  __typename?: "RequiredToolsIndicatorTypes";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  ComplianceIndicator?: Maybe<Indicator>;
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  ModelIndicator?: Maybe<Indicator>;
  TotalIndicator?: Maybe<Indicator>;
  CheckedDateIndicator?: Maybe<Indicator>;
  isParent?: Maybe<Scalars["Boolean"]>;
};

/** RequiredTools */
export type RequiredToolsItemInZdForUuiDemptyList = {
  __typename?: "RequiredToolsItemInZdForUUIDemptyList";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  Model?: Maybe<Scalars["String"]>;
  Total?: Maybe<Scalars["Float"]>;
  CheckedDate?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
};

/** RequiredTools */
export type RequiredToolsItemInZdForUuiDlist = {
  __typename?: "RequiredToolsItemInZdForUUIDlist";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  Model?: Maybe<Scalars["String"]>;
  Total?: Maybe<Scalars["Float"]>;
  CheckedDate?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
};

/** RequiredTools */
export type RequiredToolsOneValuesItem = {
  __typename?: "RequiredToolsOneValuesItem";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  Model?: Maybe<Scalars["String"]>;
  Total?: Maybe<Scalars["Float"]>;
  CheckedDate?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
  list?: Maybe<Array<Maybe<RequiredToolsItemInZdForUuiDlist>>>;
  emptyList?: Maybe<Array<Maybe<RequiredToolsItemInZdForUuiDemptyList>>>;
};

/** Изменение данных */
export type RequiredToolsSetter = {
  __typename?: "RequiredToolsSetter";
  /** Создание */
  create?: Maybe<RequiredTools>;
  /** Редактирование с сохранением истории */
  change?: Maybe<RequiredTools>;
  /** изменить место в сортировке. отрицательные значения и 0 не смещают другие элементы */
  setSort?: Maybe<Scalars["Boolean"]>;
  /** Редактирование текущего состояния (eg исправление опечатки) */
  blindChange?: Maybe<RequiredTools>;
  /** Добавить значения или обновить значения сущности */
  addValues?: Maybe<Scalars["Boolean"]>;
  /** Сделать неактуальным (удалить) */
  delete?: Maybe<Scalars["Boolean"]>;
  /** Необходимо предусмотреть формирование дополнительных строк со стороны пользователя дилера */
  duplicate?: Maybe<RequiredToolsIndicatorTypes>;
  renameGroup?: Maybe<Scalars["Boolean"]>;
  /** изменить место в сортировке */
  setSortGroup?: Maybe<Scalars["Boolean"]>;
};

/** Изменение данных */
export type RequiredToolsSetterCreateArgs = {
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  ModelIndicator?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
  CheckedDateIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type RequiredToolsSetterChangeArgs = {
  id?: Maybe<Scalars["ID"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  ModelIndicator?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
  CheckedDateIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type RequiredToolsSetterSetSortArgs = {
  sort?: Maybe<Scalars["Int"]>;
  UUID: Scalars["String"];
};

/** Изменение данных */
export type RequiredToolsSetterBlindChangeArgs = {
  id?: Maybe<Scalars["ID"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  ModelIndicator?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
  CheckedDateIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type RequiredToolsSetterAddValuesArgs = {
  Compliance?: Maybe<Scalars["Int"]>;
  Model?: Maybe<Scalars["String"]>;
  Total?: Maybe<Scalars["Float"]>;
  CheckedDate?: Maybe<Scalars["String"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
};

/** Изменение данных */
export type RequiredToolsSetterDeleteArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type RequiredToolsSetterDuplicateArgs = {
  uuid?: Maybe<Scalars["String"]>;
};

/** Изменение данных */
export type RequiredToolsSetterRenameGroupArgs = {
  groupType?: Maybe<ZdGroupType>;
  newGroup?: Maybe<Scalars["String"]>;
  oldGroup?: Maybe<Scalars["String"]>;
};

/** Изменение данных */
export type RequiredToolsSetterSetSortGroupArgs = {
  sort?: Maybe<Scalars["Int"]>;
  group: Scalars["String"];
};

export enum RequiredToolsSortBy {
  Number = "number",
  Name = "name",
  NameEn = "nameEn",
  Sort = "sort",
  GroupOne = "GroupOne",
  SortGroup = "sortGroup",
}

/** RequiredTools */
export type RequiredToolsValues = {
  __typename?: "RequiredToolsValues";
  items?: Maybe<Array<Maybe<RequiredToolsOneValuesItem>>>;
  total?: Maybe<Scalars["Int"]>;
};

/** ResetDate это дата когда дилеру было сказано перезаполнять значения. внесённые значения до этой даты не будут отображаться как текущие. */
export type ResetDate = {
  __typename?: "ResetDate";
  id?: Maybe<Scalars["ID"]>;
  DealerId: Scalars["ID"];
  ZD_UUID?: Maybe<Scalars["String"]>;
  tableIndex: ZdTableIndex;
  createdAt?: Maybe<Scalars["DateTime"]>;
};

export type ResetDateList = {
  __typename?: "ResetDateList";
  items?: Maybe<Array<Maybe<ResetDate>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type ReturnEditCurriculumPositionStudyPrograms = {
  __typename?: "ReturnEditCurriculumPositionStudyPrograms";
  type?: Maybe<PositionProgramsActionEnum>;
  levelId?: Maybe<Scalars["Int"]>;
  result?: Maybe<Scalars["Boolean"]>;
  message?: Maybe<Scalars["String"]>;
};

/** Получение отчетов по SRR */
export type SrrGetter = {
  __typename?: "SRRGetter";
  /** получить цель */
  getTargetDealerByMonth?: Maybe<GetTargetDealerByMonth>;
  /** Получить данные по ГИБДД */
  getGIBDD?: Maybe<GibddList>;
  getFamilyCar?: Maybe<FamilyCarList>;
  /** Получить отчет 'Возвращение автомобилей на ТО (свой) по периоду продаж' */
  reportReturnCarForServiceByPeriod?: Maybe<ReportFile>;
  /** Получить данные 'Возвращение автомобилей на ТО (свой) по периоду продаж' */
  getCarForServiceByPeriod?: Maybe<CarForServiceByMonth>;
  /** Получить отчет 'Возвращение автомобилей на ТО (свой) регистрация ГИБДД по периоду продаж' */
  reportReturnCarForServiceGIBDDByPeriod?: Maybe<ReportFile>;
  /** Получить данные 'Возвращение автомобилей на ТО (свой) регистрация ГИБДД по периоду продаж' */
  getCarForServiceGIBDDByPeriod?: Maybe<CarForServiceByMonth>;
  /** Получить отчет 'Возвращение автомобилей на ТО (свой-чужой) по периоду продаж' */
  reportReturnCarForeignForServiceByPeriod?: Maybe<ReportFile>;
  /** Получить данные 'Возвращение автомобилей на ТО (свой-чужой) по периоду продаж' */
  getCarForeignForServiceByPeriod?: Maybe<CarForServiceByMonth>;
  /** Получить отчет 'Возвращение автомобилей на ТО (свой-чужой) регистрация ГИБДД по периоду продаж' */
  reportReturnCarForeignForServiceGIBDDByPeriod?: Maybe<ReportFile>;
  /** Получить данные 'Возвращение автомобилей на ТО (свой-чужой) регистрация ГИБДД по периоду продаж' */
  getCarForeignForServiceGIBDDByPeriod?: Maybe<CarForServiceByMonth>;
  /** Получить отчет 'Возвращение автомобилей на гарантийный ремонт к дилеру LADA по месяцу контроля' */
  reportReturnCarForAGOByMonth?: Maybe<ReportFile>;
  /** Получить данные 'Возвращение автомобилей на гарантийный ремонт к дилеру LADA по месяцу контроля' */
  getCarForAGOByMonth?: Maybe<CarForAgoByMonth>;
  /** Получить отчет 'Возвращение автомобилей на гарантийный ремонт (свой-чужой) по месяцу контроля' */
  reportReturnCarForeignForAGOByMonth?: Maybe<ReportFile>;
  /** Получить данные 'Возвращение автомобилей на гарантийный ремонт (свой-чужой) по месяцу контроля' */
  getCarForeignForAGOByMonth?: Maybe<CarForAgoByMonth>;
  /** Получить отчет 'Возвращение автомобилей на ТО (свой) по месяцу контроля' */
  reportReturnCarForServiceByMonth?: Maybe<ReportFile>;
  /** Получить данные 'Возвращение автомобилей на ТО (свой) по месяцу контроля' */
  getCarForServiceByMonth?: Maybe<CarForServiceByMonth>;
  /** Получить отчет 'Возвращение автомобилей на ТО (свой) регистрация ГИБДД по месяцу контроля' */
  reportReturnCarForServiceGIBDDByMonth?: Maybe<ReportFile>;
  /** Получить данные 'Возвращение автомобилей на ТО (свой) регистрация ГИБДД по месяцу контроля' */
  getCarForServiceGIBDDByMonth?: Maybe<CarForServiceByMonth>;
  /** Получить отчет 'Возвращение автомобилей на ТО (свой-чужой) по месяцу контроля' */
  reportReturnCarForeignForServiceByMonth?: Maybe<ReportFile>;
  /** Получить данные 'Возвращение автомобилей на ТО (свой-чужой) по месяцу контроля' */
  getCarForeignForServiceByMonth?: Maybe<CarForServiceByMonth>;
  /** Получить отчет 'Возвращение автомобилей на ТО (свой-чужой) регистрация ГИБДД по месяцу контроля' */
  reportReturnCarForeignForServiceGIBDDByMonth?: Maybe<ReportFile>;
  /** Получить данные 'Возвращение автомобилей на ТО (свой-чужой) регистрация ГИБДД по месяцу контроля' */
  getCarForeignForServiceGIBDDByMonth?: Maybe<CarForServiceByMonth>;
  /** Получить отчет 'Возвращение автомобилей на ТО (свой-чужой) по месяцу контроля по семейству автомобиля' */
  reportReturnCarForeignForServiceByMonthByCarModel?: Maybe<ReportFile>;
  /** Получить данные 'Возвращение автомобилей на ТО (свой-чужой) по месяцу контроля по семейству автомобиля' */
  getCarForeignForServiceByMonthByCarModel?: Maybe<CarForServiceByMonth>;
  /** Получить отчет 'Возвращение автомобилей на ТО (свой-чужой) по периоду по семейству автомобиля' */
  reportReturnCarForeignForServiceByPeriodByCarModel?: Maybe<ReportFile>;
  /** Получить данные 'Возвращение автомобилей на ТО (свой-чужой) по периоду по семейству автомобиля' */
  getCarForeignForServiceByPeriodByCarModel?: Maybe<CarForServiceByMonth>;
  /** Получить отчет 'Возвращение автомобилей на ТО (семейство автомобиля - регион)' */
  reportReturnCarForServiceByMonthByCarModelRegion?: Maybe<ReportFile>;
  /** Получить данные 'Возвращение автомобилей на ТО (семейство автомобиля - регион)' */
  getCarForServiceByMonthByCarModelRegion?: Maybe<CarsForServiceByMonthRegion>;
  /** Получить отчет 'Возвращение автомобилей на ТО к дилерам LADA. Сводный отчет.' */
  reportReturnCarForServiceByPeriodConsolidated?: Maybe<ReportFile>;
  /** Получить данные 'Возвращение автомобилей на ТО к дилерам LADA. Сводный отчет.' */
  getCarForServiceByPeriodConsolidated?: Maybe<CarsForServiceByPeriodConsolidated>;
  /** Получить данные 'Среднесуточный пробег (семейство автомобиля-регион)' */
  getCarAverageDailyMileageByMonth?: Maybe<
    Array<Maybe<CarsForAverageDailyMileageByMonth>>
  >;
  /** Получить отчет 'Среднесуточный пробег (семейство автомобиля-регион)' */
  reportReturnCarAverageDailyMileageByMonth?: Maybe<ReportFile>;
  /** Получить данные 'Клиенты не обращавшиеся на гарантийный ремонт' */
  getClientsWithoutService?: Maybe<Array<Maybe<ClientsWithoutService>>>;
  /** Получить отчет 'Клиенты не обращавшиеся на гарантийный ремонт' */
  reportReturnClientsWithoutService?: Maybe<ReportFile>;
  /** Получить данные 'Приглашение клиентов на ТО' */
  getInviteClientToService?: Maybe<Array<Maybe<InviteClientToService>>>;
  /** Получить отчет 'Приглашение клиентов на ТО' */
  reportInviteClientToService?: Maybe<ReportFile>;
  /** Получить данные 'SRR3 по дилерам LADA' */
  getSRR3ByDealer?: Maybe<Array<Maybe<DealerForServiceByMonth>>>;
  /** Получить данные 'SRR5 по дилерам LADA' */
  getSRR5ByDealer?: Maybe<Array<Maybe<DealerForServiceByMonth>>>;
  /** Получить данные 'SRR3 регистрация ГИБДД по дилерам LADA' */
  getSRR3GIBDDByDealer?: Maybe<Array<Maybe<DealerForServiceByMonth>>>;
  /** Получить данные 'SRR5 регистрация ГИБДД по дилерам LADA' */
  getSRR5GIBDDByDealer?: Maybe<Array<Maybe<DealerForServiceByMonth>>>;
  /** Получить отчет 'SRR3 по дилерам LADA' */
  reportReturnSRR3ByDealer?: Maybe<ReportFile>;
  /** Получить отчет 'SRR5 по дилерам LADA' */
  reportReturnSRR5ByDealer?: Maybe<ReportFile>;
  /** Получить отчет 'SRR3 регистрация ГИБДД по дилерам LADA' */
  reportReturnSRR3GIBDDByDealer?: Maybe<ReportFile>;
  /** Получить отчет 'SRR5 регистрация ГИБДД по дилерам LADA' */
  reportReturnSRR5GIBDDByDealer?: Maybe<ReportFile>;
  /** Получить данные 'SRR3 по дилерам LADA за период' */
  getSRR3ByPeriod?: Maybe<Array<Maybe<CarForSrr3ByPeriod>>>;
  /** Получить данные 'SRR5 по дилерам LADA за период' */
  getSRR5ByPeriod?: Maybe<Array<Maybe<CarForSrr5ByPeriod>>>;
  /** Получить данные 'SRR3 регистрация ГИБДД по дилерам LADA за период' */
  getSRR3GIBDDByPeriod?: Maybe<Array<Maybe<CarForSrr3GibddByPeriod>>>;
  /** Получить данные 'SRR5 регистрация ГИБДД по дилерам LADA за период' */
  getSRR5GIBDDByPeriod?: Maybe<Array<Maybe<CarForSrr5GibddByPeriod>>>;
  /** Получить отчет 'SRR3 по дилерам LADA за период' */
  reportReturnSRR3ByPeriod?: Maybe<ReportFile>;
  /** Получить отчет 'SRR5 по дилерам LADA за период' */
  reportReturnSRR5ByPeriod?: Maybe<ReportFile>;
  /** Получить отчет 'SRR3 регистрация ГИБДД по дилерам LADA за период' */
  reportReturnSRR3GIBDDByPeriod?: Maybe<ReportFile>;
  /** Получить отчет 'SRR5 регистрация ГИБДД по дилерам LADA за период' */
  reportReturnSRR5GIBDDByPeriod?: Maybe<ReportFile>;
  /** Получить данные 'SRR3 по дилерам LADA для расчета премий' */
  getSRR3ForPayments?: Maybe<Array<Maybe<DealerForPaymentsByDealer>>>;
  /** Получить данные 'SRR5 по дилерам LADA для расчета премий' */
  getSRR5ForPayments?: Maybe<Array<Maybe<DealerForPaymentsByDealer>>>;
  /** Получить отчет 'SRR3 по дилерам LADA для расчета премий' */
  reportReturnSRR3ForPayments?: Maybe<ReportFile>;
  /** Получить отчет 'SRR5 по дилерам LADA для расчета премий' */
  reportReturnSRR5ForPayments?: Maybe<ReportFile>;
  /** Получить данные 'SRR3 по дилерам LADA по семействам автомобиля' */
  getSRR3ByCar?: Maybe<Array<Maybe<DealerByCarByDealer>>>;
  /** Получить данные 'SRR5 по дилерам LADA по семействам автомобиля' */
  getSRR5ByCar?: Maybe<Array<Maybe<DealerByCarByDealer>>>;
  /** Получить отчет 'SRR3 по дилерам LADA по семействам автомобиля' */
  reportReturnSRR3ByCar?: Maybe<ReportFile>;
  /** Получить отчет 'SRR5 по дилерам LADA по семействам автомобиля' */
  reportReturnSRR5ByCar?: Maybe<ReportFile>;
  /** Получить данные 'SRR3 по дилерам LADA — Расшифровка по VIN' */
  getSRR3ByVIN?: Maybe<Array<Maybe<DealerByCarByVin>>>;
  /** Получить данные 'SRR5 по дилерам LADA — Расшифровка по VIN' */
  getSRR5ByVIN?: Maybe<Array<Maybe<DealerByCarByVin>>>;
  /** Получить отчет 'SRR3 по дилерам LADA — Расшифровка по VIN' */
  reportReturnSRR3ByVIN?: Maybe<ReportFile>;
  /** Получить отчет 'SRR5 по дилерам LADA — Расшифровка по VIN' */
  reportReturnSRR5ByVIN?: Maybe<ReportFile>;
  /** Получить данные 'UVIN: уникальные обращения в сервис' */
  getUniqueService?: Maybe<Array<Maybe<UniqueService>>>;
  /** Получить отчет 'UVIN: уникальные обращения в сервис' */
  reportReturnUniqueService?: Maybe<ReportFile>;
  /** Получить данные 'UVIN – лояльность' */
  getLoyaltyService?: Maybe<LoyaltyService>;
  /** Получить отчет 'UVIN – лояльность' */
  reportReturnLoyaltyService?: Maybe<ReportFile>;
  /** Получить данные 'UVIN – лояльность сводный по дилерам' */
  getLoyaltyServiceByDealer?: Maybe<Array<Maybe<LoyaltyServiceByDealer>>>;
  /** Получить отчет 'UVIN – лояльность сводный по дилерам' */
  reportReturnLoyaltyServiceByDealer?: Maybe<ReportFile>;
  /** Получить данные 'NS по дилерам LADA' */
  getNSByDealer?: Maybe<Array<Maybe<NsDealerData>>>;
  /** Получить отчет 'NS по дилерам LADA' */
  reportNSByDealer?: Maybe<ReportFile>;
  /** Получить данные 'NS по продавцам-консультантам LADA' */
  getNSByConsultant?: Maybe<Array<Maybe<NsByConsultantData>>>;
  /** Получить отчет 'NS по продавцам-консультантам LADA' */
  reportNSByConsultant?: Maybe<ReportFile>;
  /** Получить данные 'NS по клиентам' */
  getNSByClient?: Maybe<Array<Maybe<NsByClientData>>>;
  /** Получить отчет 'NS по клиентам' */
  reportNSByClient?: Maybe<ReportFile>;
  importCreditData?: Maybe<Scalars["Boolean"]>;
  importCarEPlatformData?: Maybe<Scalars["Boolean"]>;
  /** Получить данные 'NS по теплые клиентам' */
  getNSByWarmClients?: Maybe<Array<Maybe<NsByWarmClientsData>>>;
  /** Получить отчет 'NS по теплые клиентам' */
  reportNSByWarmClients?: Maybe<ReportFile>;
  /** Получить данные 'Количество и список клиентов, купивших последний а/м > 3х, 4х и 5лет' */
  getNSByOldClients?: Maybe<Array<Maybe<NsByOldClientsData>>>;
  /** Количество и список клиентов, купивших последний а/м > 3х, 4х и 5лет */
  reportNSByOldClients?: Maybe<ReportFile>;
  /** Получить данные 'Средний срок владения автомобилем' */
  getNSByAverageCarAge?: Maybe<NsByAverageCarAgeData>;
  /** Средний срок владения автомобилем */
  reportNSByAverageCarAge?: Maybe<ReportFile>;
  /** Получить данные 'Работа с клиентами, продающими свой автомобиль' */
  getNSByClientCarSale?: Maybe<Array<Maybe<NsByClientCarSaleData>>>;
  /** Работа с клиентами, продающими свой автомобиль */
  reportNSByClientCarSale?: Maybe<ReportFile>;
  /** Получить данные 'Машинозаезды в динамике' */
  getCarServiceDynamics?: Maybe<CarForServiceDynamics>;
  /** Получить отчет 'Машинозаезды в динамике' */
  reportReturnCarServiceDynamics?: Maybe<ReportFile>;
  /** Получить данные 'Машинозаезды по дилерам' */
  getCarServiceByDealer?: Maybe<CarForServiceByDealer>;
  /** Получить отчет 'Машинозаезды по дилерам' */
  reportReturnCarServiceByDealer?: Maybe<ReportFile>;
  getAverageReceiptTO?: Maybe<Array<Maybe<GetAverageReceiptTo>>>;
  reportAverageReceiptTO?: Maybe<ReportFile>;
  getAverageReceiptAKC?: Maybe<Array<Maybe<GetAverageReceiptAkc>>>;
  reportAverageReceiptAKC?: Maybe<ReportFile>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetTargetDealerByMonthArgs = {
  DealerId?: Maybe<Scalars["ID"]>;
  Month?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetGibddArgs = {
  id?: Maybe<Scalars["ID"]>;
  vin?: Maybe<Scalars["String"]>;
  dateRegistrationStart?: Maybe<Scalars["DateTime"]>;
  dateRegistrationEnd?: Maybe<Scalars["DateTime"]>;
  city?: Maybe<Array<Maybe<Scalars["String"]>>>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetFamilyCarArgs = {
  name?: Maybe<Scalars["String"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnCarForServiceByPeriodArgs = {
  groupReport?: Maybe<TypeGroupReportSrr>;
  group?: Maybe<TypeGroupReportSrr>;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  salePeriodStart: Scalars["DateTime"];
  salePeriodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetCarForServiceByPeriodArgs = {
  groupReport?: Maybe<TypeGroupReportSrr>;
  group?: Maybe<TypeGroupReportSrr>;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  salePeriodStart: Scalars["DateTime"];
  salePeriodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnCarForServiceGibddByPeriodArgs = {
  groupReport?: Maybe<TypeGroupReportSrr>;
  group?: Maybe<TypeGroupReportSrr>;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  salePeriodStart: Scalars["DateTime"];
  salePeriodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetCarForServiceGibddByPeriodArgs = {
  groupReport?: Maybe<TypeGroupReportSrr>;
  group?: Maybe<TypeGroupReportSrr>;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  salePeriodStart: Scalars["DateTime"];
  salePeriodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnCarForeignForServiceByPeriodArgs = {
  groupReport?: Maybe<TypeGroupReportSrr>;
  group?: Maybe<TypeGroupReportSrr>;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  salePeriodStart: Scalars["DateTime"];
  salePeriodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetCarForeignForServiceByPeriodArgs = {
  groupReport?: Maybe<TypeGroupReportSrr>;
  group?: Maybe<TypeGroupReportSrr>;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  salePeriodStart: Scalars["DateTime"];
  salePeriodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnCarForeignForServiceGibddByPeriodArgs = {
  groupReport?: Maybe<TypeGroupReportSrr>;
  group?: Maybe<TypeGroupReportSrr>;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  salePeriodStart: Scalars["DateTime"];
  salePeriodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetCarForeignForServiceGibddByPeriodArgs = {
  groupReport?: Maybe<TypeGroupReportSrr>;
  group?: Maybe<TypeGroupReportSrr>;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  salePeriodStart: Scalars["DateTime"];
  salePeriodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnCarForAgoByMonthArgs = {
  groupReport?: Maybe<TypeGroupReportSrr>;
  group?: Maybe<TypeGroupReportSrr>;
  numberGO?: Maybe<Array<Maybe<TypeGoReportSrr>>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  lifetime?: Maybe<Scalars["Int"]>;
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  CarModel?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetCarForAgoByMonthArgs = {
  groupReport?: Maybe<TypeGroupReportSrr>;
  group?: Maybe<TypeGroupReportSrr>;
  numberGO?: Maybe<Array<Maybe<TypeGoReportSrr>>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  lifetime?: Maybe<Scalars["Int"]>;
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  CarModel?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnCarForeignForAgoByMonthArgs = {
  groupReport?: Maybe<TypeGroupReportSrr>;
  group?: Maybe<TypeGroupReportSrr>;
  numberGO?: Maybe<Array<Maybe<TypeGoReportSrr>>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  lifetime?: Maybe<Scalars["Int"]>;
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  CarModel?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetCarForeignForAgoByMonthArgs = {
  groupReport?: Maybe<TypeGroupReportSrr>;
  group?: Maybe<TypeGroupReportSrr>;
  numberGO?: Maybe<Array<Maybe<TypeGoReportSrr>>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  lifetime?: Maybe<Scalars["Int"]>;
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  CarModel?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnCarForServiceByMonthArgs = {
  groupReport?: Maybe<TypeGroupReportSrr>;
  group?: Maybe<TypeGroupReportSrr>;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetCarForServiceByMonthArgs = {
  groupReport?: Maybe<TypeGroupReportSrr>;
  group?: Maybe<TypeGroupReportSrr>;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnCarForServiceGibddByMonthArgs = {
  groupReport?: Maybe<TypeGroupReportSrr>;
  group?: Maybe<TypeGroupReportSrr>;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetCarForServiceGibddByMonthArgs = {
  groupReport?: Maybe<TypeGroupReportSrr>;
  group?: Maybe<TypeGroupReportSrr>;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnCarForeignForServiceByMonthArgs = {
  groupReport?: Maybe<TypeGroupReportSrr>;
  group?: Maybe<TypeGroupReportSrr>;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetCarForeignForServiceByMonthArgs = {
  groupReport?: Maybe<TypeGroupReportSrr>;
  group?: Maybe<TypeGroupReportSrr>;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnCarForeignForServiceGibddByMonthArgs = {
  groupReport?: Maybe<TypeGroupReportSrr>;
  group?: Maybe<TypeGroupReportSrr>;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetCarForeignForServiceGibddByMonthArgs = {
  groupReport?: Maybe<TypeGroupReportSrr>;
  group?: Maybe<TypeGroupReportSrr>;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnCarForeignForServiceByMonthByCarModelArgs = {
  CarModel?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  groupReport?: Maybe<TypeGroupReportSrr>;
  group?: Maybe<TypeGroupReportSrr>;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetCarForeignForServiceByMonthByCarModelArgs = {
  CarModel?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  groupReport?: Maybe<TypeGroupReportSrr>;
  group?: Maybe<TypeGroupReportSrr>;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnCarForeignForServiceByPeriodByCarModelArgs = {
  CarModel?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  groupReport?: Maybe<TypeGroupReportSrr>;
  group?: Maybe<TypeGroupReportSrr>;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  salePeriodStart: Scalars["DateTime"];
  salePeriodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetCarForeignForServiceByPeriodByCarModelArgs = {
  CarModel?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  groupReport?: Maybe<TypeGroupReportSrr>;
  group?: Maybe<TypeGroupReportSrr>;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  salePeriodStart: Scalars["DateTime"];
  salePeriodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnCarForServiceByMonthByCarModelRegionArgs = {
  groupReport: TypeGroupReportSrr;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  CarModel?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetCarForServiceByMonthByCarModelRegionArgs = {
  groupReport: TypeGroupReportSrr;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  CarModel?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnCarForServiceByPeriodConsolidatedArgs = {
  group: TypeGroupReportSrr;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  salePeriodStart: Scalars["DateTime"];
  salePeriodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  CarModel?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetCarForServiceByPeriodConsolidatedArgs = {
  group: TypeGroupReportSrr;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  salePeriodStart: Scalars["DateTime"];
  salePeriodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  CarModel?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetCarAverageDailyMileageByMonthArgs = {
  groupReport?: Maybe<TypeGroupReportSrr>;
  group?: Maybe<TypeGroupReportSrr>;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnCarAverageDailyMileageByMonthArgs = {
  groupReport?: Maybe<TypeGroupReportSrr>;
  group?: Maybe<TypeGroupReportSrr>;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetClientsWithoutServiceArgs = {
  group: TypeGroupReportSrr;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnClientsWithoutServiceArgs = {
  group: TypeGroupReportSrr;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetInviteClientToServiceArgs = {
  dealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  monthControl?: Maybe<Scalars["DateTime"]>;
  runStart?: Maybe<Scalars["Int"]>;
  runEnd?: Maybe<Scalars["Int"]>;
  method: Scalars["String"];
  numberTO?: Maybe<TypeToReportSrr>;
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportInviteClientToServiceArgs = {
  dealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  monthControl?: Maybe<Scalars["DateTime"]>;
  runStart?: Maybe<Scalars["Int"]>;
  runEnd?: Maybe<Scalars["Int"]>;
  method: Scalars["String"];
  numberTO?: Maybe<TypeToReportSrr>;
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetSrr3ByDealerArgs = {
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetSrr5ByDealerArgs = {
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetSrr3GibddByDealerArgs = {
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetSrr5GibddByDealerArgs = {
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnSrr3ByDealerArgs = {
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnSrr5ByDealerArgs = {
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnSrr3GibddByDealerArgs = {
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnSrr5GibddByDealerArgs = {
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetSrr3ByPeriodArgs = {
  group: TypeGroupReportSrr;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  country?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetSrr5ByPeriodArgs = {
  group: TypeGroupReportSrr;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  country?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetSrr3GibddByPeriodArgs = {
  group: TypeGroupReportSrr;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  country?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetSrr5GibddByPeriodArgs = {
  group: TypeGroupReportSrr;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  country?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnSrr3ByPeriodArgs = {
  group: TypeGroupReportSrr;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  country?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnSrr5ByPeriodArgs = {
  group: TypeGroupReportSrr;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  country?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnSrr3GibddByPeriodArgs = {
  group: TypeGroupReportSrr;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  country?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnSrr5GibddByPeriodArgs = {
  group: TypeGroupReportSrr;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  country?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetSrr3ForPaymentsArgs = {
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetSrr5ForPaymentsArgs = {
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnSrr3ForPaymentsArgs = {
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnSrr5ForPaymentsArgs = {
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetSrr3ByCarArgs = {
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetSrr5ByCarArgs = {
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnSrr3ByCarArgs = {
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnSrr5ByCarArgs = {
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetSrr3ByVinArgs = {
  dealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetSrr5ByVinArgs = {
  dealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnSrr3ByVinArgs = {
  dealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnSrr5ByVinArgs = {
  dealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetUniqueServiceArgs = {
  group: TypeGroupReportSrr;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  kindReport: TypeKindReport;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  kinds?: Maybe<Array<Maybe<KindRepair>>>;
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnUniqueServiceArgs = {
  group: TypeGroupReportSrr;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  kindReport: TypeKindReport;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  kinds?: Maybe<Array<Maybe<KindRepair>>>;
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetLoyaltyServiceArgs = {
  group: TypeGroupReportSrr;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  kindReport: TypeKindReport;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  kinds?: Maybe<Array<Maybe<KindRepair>>>;
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnLoyaltyServiceArgs = {
  group: TypeGroupReportSrr;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  kindReport: TypeKindReport;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  kinds?: Maybe<Array<Maybe<KindRepair>>>;
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetLoyaltyServiceByDealerArgs = {
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  kinds?: Maybe<Array<Maybe<KindRepair>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnLoyaltyServiceByDealerArgs = {
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  kinds?: Maybe<Array<Maybe<KindRepair>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetNsByDealerArgs = {
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  group: TypeGroupReportSrr;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  NOP?: Maybe<Scalars["String"]>;
  RMP?: Maybe<Scalars["String"]>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  loyaltyType?: Maybe<LoyaltyType>;
  bonus?: Maybe<Scalars["Int"]>;
  monthControl?: Maybe<Scalars["Int"]>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportNsByDealerArgs = {
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  group: TypeGroupReportSrr;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  NOP?: Maybe<Scalars["String"]>;
  RMP?: Maybe<Scalars["String"]>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  loyaltyType?: Maybe<LoyaltyType>;
  bonus?: Maybe<Scalars["Int"]>;
  monthControl?: Maybe<Scalars["Int"]>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetNsByConsultantArgs = {
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  NOP?: Maybe<Scalars["String"]>;
  RMP?: Maybe<Scalars["String"]>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  loyaltyType?: Maybe<LoyaltyType>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportNsByConsultantArgs = {
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  NOP?: Maybe<Scalars["String"]>;
  RMP?: Maybe<Scalars["String"]>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  loyaltyType?: Maybe<LoyaltyType>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetNsByClientArgs = {
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  NOP?: Maybe<Scalars["String"]>;
  RMP?: Maybe<Scalars["String"]>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  loyaltyType?: Maybe<LoyaltyType>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportNsByClientArgs = {
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  NOP?: Maybe<Scalars["String"]>;
  RMP?: Maybe<Scalars["String"]>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  loyaltyType?: Maybe<LoyaltyType>;
};

/** Получение отчетов по SRR */
export type SrrGetterImportCreditDataArgs = {
  fileId: Scalars["ID"];
};

/** Получение отчетов по SRR */
export type SrrGetterImportCarEPlatformDataArgs = {
  fileId: Scalars["ID"];
};

/** Получение отчетов по SRR */
export type SrrGetterGetNsByWarmClientsArgs = {
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  NOP?: Maybe<Scalars["String"]>;
  RMP?: Maybe<Scalars["String"]>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  loyaltyType?: Maybe<LoyaltyType>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportNsByWarmClientsArgs = {
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  NOP?: Maybe<Scalars["String"]>;
  RMP?: Maybe<Scalars["String"]>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  loyaltyType?: Maybe<LoyaltyType>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetNsByOldClientsArgs = {
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  NOP?: Maybe<Scalars["String"]>;
  RMP?: Maybe<Scalars["String"]>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  loyaltyType?: Maybe<LoyaltyType>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportNsByOldClientsArgs = {
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  NOP?: Maybe<Scalars["String"]>;
  RMP?: Maybe<Scalars["String"]>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  loyaltyType?: Maybe<LoyaltyType>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetNsByAverageCarAgeArgs = {
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportNsByAverageCarAgeArgs = {
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetNsByClientCarSaleArgs = {
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  NOP?: Maybe<Scalars["String"]>;
  RMP?: Maybe<Scalars["String"]>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  loyaltyType?: Maybe<LoyaltyType>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportNsByClientCarSaleArgs = {
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  NOP?: Maybe<Scalars["String"]>;
  RMP?: Maybe<Scalars["String"]>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  loyaltyType?: Maybe<LoyaltyType>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetCarServiceDynamicsArgs = {
  group: TypeGroupReportSrr;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnCarServiceDynamicsArgs = {
  group: TypeGroupReportSrr;
  periodStart: Scalars["DateTime"];
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetCarServiceByDealerArgs = {
  group: TypeGroupReportSrr;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportReturnCarServiceByDealerArgs = {
  group: TypeGroupReportSrr;
  periodStart: Scalars["DateTime"];
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>>>;
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<Array<Maybe<TypeClientReportSrr>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetAverageReceiptToArgs = {
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  group?: Maybe<TypeGroupReportSrr>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportAverageReceiptToArgs = {
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  group?: Maybe<TypeGroupReportSrr>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterGetAverageReceiptAkcArgs = {
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  group?: Maybe<TypeGroupReportSrr>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

/** Получение отчетов по SRR */
export type SrrGetterReportAverageReceiptAkcArgs = {
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  group?: Maybe<TypeGroupReportSrr>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

/** Изменение данных для SRR */
export type SrrSetter = {
  __typename?: "SRRSetter";
  /** Загрузка целей через csv */
  uploadTarget?: Maybe<Scalars["Boolean"]>;
  /** Разрешить загрузить черновик */
  acceptUploadTarget?: Maybe<Scalars["Boolean"]>;
  importTargetDealerByMonth?: Maybe<Scalars["Boolean"]>;
  /** Установить цель для дилера на месяц */
  setTargetDealerByMonth?: Maybe<Scalars["Boolean"]>;
  /** Загрузить данные по ГИБДД */
  uploadGIBDD?: Maybe<Scalars["Boolean"]>;
  /** Установить данные по ГИБДД по id */
  setGIBDD?: Maybe<GibddType>;
};

/** Изменение данных для SRR */
export type SrrSetterUploadTargetArgs = {
  fileId: Scalars["ID"];
  description?: Maybe<Scalars["String"]>;
};

/** Изменение данных для SRR */
export type SrrSetterAcceptUploadTargetArgs = {
  IndicatorUploadId: Scalars["ID"];
};

/** Изменение данных для SRR */
export type SrrSetterImportTargetDealerByMonthArgs = {
  fileId: Scalars["ID"];
};

/** Изменение данных для SRR */
export type SrrSetterSetTargetDealerByMonthArgs = {
  data?: Maybe<Array<Maybe<DealerTarget>>>;
};

/** Изменение данных для SRR */
export type SrrSetterUploadGibddArgs = {
  fileId: Scalars["ID"];
};

/** Изменение данных для SRR */
export type SrrSetterSetGibddArgs = {
  id: Scalars["ID"];
  vin: Scalars["String"];
  dateRegistration: Scalars["DateTime"];
  city: Scalars["String"];
  district: Scalars["String"];
  region: Scalars["String"];
  federalArea: Scalars["String"];
};

export type SalesCar = {
  __typename?: "SalesCar";
  dateSales?: Maybe<Scalars["DateTime"]>;
  price?: Maybe<Scalars["Float"]>;
  sellerName?: Maybe<Scalars["String"]>;
  sellerPosition?: Maybe<Scalars["String"]>;
  carId?: Maybe<Scalars["ID"]>;
  clientId?: Maybe<Scalars["ID"]>;
  dealerId?: Maybe<Scalars["ID"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  Car?: Maybe<Car>;
};

export type Section = {
  __typename?: "Section";
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  parentId?: Maybe<Scalars["ID"]>;
  parentName?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  createdBy?: Maybe<Scalars["ID"]>;
  updatedBy?: Maybe<Scalars["ID"]>;
  subcatalogCount?: Maybe<Scalars["Int"]>;
  childCount?: Maybe<Scalars["Int"]>;
  DocumentsWithSectionId?: Maybe<Array<Maybe<Document>>>;
  DocumentsWithSubSectionId?: Maybe<Array<Maybe<Document>>>;
};

export type SectionLog = {
  __typename?: "SectionLog";
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  parentId?: Maybe<Scalars["ID"]>;
  parentName?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  createdBy?: Maybe<Scalars["ID"]>;
  updatedBy?: Maybe<Scalars["ID"]>;
};

export type SectionsList = {
  __typename?: "SectionsList";
  items?: Maybe<Array<Maybe<Section>>>;
  total?: Maybe<Scalars["Int"]>;
};

/** Services */
export type Services = {
  __typename?: "Services";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Code?: Maybe<Scalars["String"]>;
  FactIndicator?: Maybe<Scalars["ID"]>;
  CertificationDateIndicator?: Maybe<Scalars["ID"]>;
  FactContractIndicator?: Maybe<Scalars["ID"]>;
};

/** Services */
export type ServicesDealerStatuses = {
  __typename?: "ServicesDealerStatuses";
  DealerId?: Maybe<Scalars["ID"]>;
  Dealer?: Maybe<Dealer>;
  ZD_UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  status?: Maybe<ZdStatusType>;
  /** последнее обновление заявки дилером */
  lastUpdatedAt?: Maybe<Scalars["DateTime"]>;
  /** последнее обновление статуса заявки */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** Получение данных */
export type ServicesGetter = {
  __typename?: "ServicesGetter";
  /** Получение значений по дилеру и дате */
  getValues?: Maybe<ServicesValues>;
  getDealerStatuses?: Maybe<Array<Maybe<ServicesDealerStatuses>>>;
  getById?: Maybe<ServicesIndicatorTypes>;
  /** Получить все актуальные на данные момент записи с индикаторами */
  getAll?: Maybe<Array<Maybe<ServicesIndicatorTypes>>>;
};

/** Получение данных */
export type ServicesGetterGetValuesArgs = {
  DealerId: Scalars["ID"];
  sortBy?: Maybe<ServicesSortBy>;
  dateUpTo?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
};

/** Получение данных */
export type ServicesGetterGetDealerStatusesArgs = {
  UUID?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

/** Получение данных */
export type ServicesGetterGetByIdArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** Services */
export type ServicesIndicatorTypes = {
  __typename?: "ServicesIndicatorTypes";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  ComplianceIndicator?: Maybe<Indicator>;
  Code?: Maybe<Scalars["String"]>;
  FactIndicator?: Maybe<Indicator>;
  CertificationDateIndicator?: Maybe<Indicator>;
  FactContractIndicator?: Maybe<Indicator>;
  isParent?: Maybe<Scalars["Boolean"]>;
};

/** Services */
export type ServicesItemInZdForUuiDemptyList = {
  __typename?: "ServicesItemInZdForUUIDemptyList";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Code?: Maybe<Scalars["String"]>;
  Fact?: Maybe<Scalars["Int"]>;
  CertificationDate?: Maybe<Scalars["String"]>;
  FactContract?: Maybe<Scalars["Int"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
};

/** Services */
export type ServicesItemInZdForUuiDlist = {
  __typename?: "ServicesItemInZdForUUIDlist";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Code?: Maybe<Scalars["String"]>;
  Fact?: Maybe<Scalars["Int"]>;
  CertificationDate?: Maybe<Scalars["String"]>;
  FactContract?: Maybe<Scalars["Int"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
};

/** Services */
export type ServicesOneValuesItem = {
  __typename?: "ServicesOneValuesItem";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Code?: Maybe<Scalars["String"]>;
  Fact?: Maybe<Scalars["Int"]>;
  CertificationDate?: Maybe<Scalars["String"]>;
  FactContract?: Maybe<Scalars["Int"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
  list?: Maybe<Array<Maybe<ServicesItemInZdForUuiDlist>>>;
  emptyList?: Maybe<Array<Maybe<ServicesItemInZdForUuiDemptyList>>>;
};

/** Изменение данных */
export type ServicesSetter = {
  __typename?: "ServicesSetter";
  /** Создание */
  create?: Maybe<Services>;
  /** Редактирование с сохранением истории */
  change?: Maybe<Services>;
  /** изменить место в сортировке. отрицательные значения и 0 не смещают другие элементы */
  setSort?: Maybe<Scalars["Boolean"]>;
  /** Редактирование текущего состояния (eg исправление опечатки) */
  blindChange?: Maybe<Services>;
  /** Добавить значения или обновить значения сущности */
  addValues?: Maybe<Scalars["Boolean"]>;
  /** Сделать неактуальным (удалить) */
  delete?: Maybe<Scalars["Boolean"]>;
};

/** Изменение данных */
export type ServicesSetterCreateArgs = {
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Code?: Maybe<Scalars["String"]>;
  FactIndicator?: Maybe<Scalars["ID"]>;
  CertificationDateIndicator?: Maybe<Scalars["ID"]>;
  FactContractIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type ServicesSetterChangeArgs = {
  id?: Maybe<Scalars["ID"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Code?: Maybe<Scalars["String"]>;
  FactIndicator?: Maybe<Scalars["ID"]>;
  CertificationDateIndicator?: Maybe<Scalars["ID"]>;
  FactContractIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type ServicesSetterSetSortArgs = {
  sort?: Maybe<Scalars["Int"]>;
  UUID: Scalars["String"];
};

/** Изменение данных */
export type ServicesSetterBlindChangeArgs = {
  id?: Maybe<Scalars["ID"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Code?: Maybe<Scalars["String"]>;
  FactIndicator?: Maybe<Scalars["ID"]>;
  CertificationDateIndicator?: Maybe<Scalars["ID"]>;
  FactContractIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type ServicesSetterAddValuesArgs = {
  Compliance?: Maybe<Scalars["Int"]>;
  Fact?: Maybe<Scalars["Int"]>;
  CertificationDate?: Maybe<Scalars["String"]>;
  FactContract?: Maybe<Scalars["Int"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
};

/** Изменение данных */
export type ServicesSetterDeleteArgs = {
  id?: Maybe<Scalars["ID"]>;
};

export enum ServicesSortBy {
  Number = "number",
  Name = "name",
  NameEn = "nameEn",
  Sort = "sort",
  GroupOne = "GroupOne",
  SortGroup = "sortGroup",
}

/** Services */
export type ServicesValues = {
  __typename?: "ServicesValues";
  items?: Maybe<Array<Maybe<ServicesOneValuesItem>>>;
  total?: Maybe<Scalars["Int"]>;
};

/** Настройки */
export type Settings = {
  __typename?: "Settings";
  StaffFile?: Maybe<File>;
};

/** получить настройки */
export type SettingsGetter = {
  __typename?: "SettingsGetter";
  /** Получить настройки */
  getSettings?: Maybe<Settings>;
};

/** получить настройки */
export type SettingsGetterGetSettingsArgs = {
  StaffFile: Scalars["Boolean"];
};

/** установить настройки */
export type SettingsSetter = {
  __typename?: "SettingsSetter";
  /** Админ загрузит файл */
  setStaffFile?: Maybe<Scalars["Boolean"]>;
};

/** установить настройки */
export type SettingsSetterSetStaffFileArgs = {
  fileId: Scalars["ID"];
};

export enum SortInputOrder {
  Asc = "asc",
  Desc = "desc",
}

/** Сводный отчет по региональным менеджерам - статистика */
export type Statistic = {
  __typename?: "Statistic";
  quarter?: Maybe<Scalars["Int"]>;
  year?: Maybe<Scalars["Int"]>;
  counts?: Maybe<Scalars["Int"]>;
};

export enum StatusSetResponseToDealer {
  HasComments = "hasComments",
  Fixed = "fixed",
  ToFix = "toFix",
}

export type Subdivision = {
  __typename?: "Subdivision";
  id?: Maybe<Scalars["ID"]>;
  code?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  status?: Maybe<SubdivisionStatus>;
  parentId?: Maybe<Scalars["ID"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  Parent?: Maybe<SubdivisionParent>;
};

export type SubdivisionGetter = {
  __typename?: "SubdivisionGetter";
  get?: Maybe<SubdivisionList>;
};

export type SubdivisionGetterGetArgs = {
  code?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  parentId?: Maybe<Scalars["ID"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

export type SubdivisionList = {
  __typename?: "SubdivisionList";
  items?: Maybe<Array<Maybe<Subdivision>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type SubdivisionParent = {
  __typename?: "SubdivisionParent";
  id?: Maybe<Scalars["ID"]>;
  code?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  status?: Maybe<SubdivisionStatus>;
  parentId?: Maybe<Scalars["ID"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
};

export type SubdivisionSetter = {
  __typename?: "SubdivisionSetter";
  create?: Maybe<Subdivision>;
  edit?: Maybe<Subdivision>;
  delete?: Maybe<Scalars["Boolean"]>;
};

export type SubdivisionSetterCreateArgs = {
  code: Scalars["String"];
  name: Scalars["String"];
  status: SubdivisionStatus;
  parentId?: Maybe<Scalars["ID"]>;
};

export type SubdivisionSetterEditArgs = {
  id: Scalars["ID"];
  name: Scalars["String"];
  status: SubdivisionStatus;
  parentId?: Maybe<Scalars["ID"]>;
};

export type SubdivisionSetterDeleteArgs = {
  id: Scalars["ID"];
};

export enum SubdivisionStatus {
  Working = "working",
  Archive = "archive",
}

/** Регион */
export type Subject = {
  __typename?: "Subject";
  name: Scalars["String"];
  cities: Array<Maybe<City>>;
};

export type SystemSetting = {
  __typename?: "SystemSetting";
  id?: Maybe<Scalars["ID"]>;
  key?: Maybe<Scalars["String"]>;
  value?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  createdBy?: Maybe<Scalars["ID"]>;
  lastEditBy?: Maybe<Scalars["ID"]>;
};

export type SystemSettingsGetter = {
  __typename?: "SystemSettingsGetter";
  getOne?: Maybe<SystemSetting>;
  getList?: Maybe<SystemSettingsList>;
};

export type SystemSettingsGetterGetOneArgs = {
  key?: Maybe<Scalars["String"]>;
};

export type SystemSettingsList = {
  __typename?: "SystemSettingsList";
  items?: Maybe<Array<Maybe<SystemSetting>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type SystemSettingsSetter = {
  __typename?: "SystemSettingsSetter";
  edit?: Maybe<SystemSetting>;
};

export type SystemSettingsSetterEditArgs = {
  key?: Maybe<Scalars["String"]>;
  value?: Maybe<Scalars["String"]>;
};

/** ТО для сводного отчета */
export type ToConsolidated = {
  __typename?: "TOConsolidated";
  name?: Maybe<Scalars["String"]>;
  inn?: Maybe<Scalars["String"]>;
  dealerId?: Maybe<Scalars["ID"]>;
  dateVisit?: Maybe<Scalars["DateTime"]>;
  countDay?: Maybe<Scalars["Int"]>;
};

/** ТО для отчета Машинозаезды по дилерам */
export type ToData = {
  __typename?: "TOData";
  TO0?: Maybe<Scalars["Int"]>;
  TO1?: Maybe<Scalars["Int"]>;
  TO2?: Maybe<Scalars["Int"]>;
  TO3?: Maybe<Scalars["Int"]>;
  TO4?: Maybe<Scalars["Int"]>;
  TO5?: Maybe<Scalars["Int"]>;
  TO6?: Maybe<Scalars["Int"]>;
  TO7?: Maybe<Scalars["Int"]>;
  TO8?: Maybe<Scalars["Int"]>;
  AllTO?: Maybe<Scalars["Int"]>;
  Warranty?: Maybe<Scalars["Int"]>;
  /** Предписание */
  writ?: Maybe<Scalars["Int"]>;
};

export type ToDealerByCarByDealerData = {
  __typename?: "TODealerByCarByDealerData";
  countSale?: Maybe<Scalars["Int"]>;
  countService?: Maybe<Scalars["Int"]>;
  percent?: Maybe<Scalars["Float"]>;
};

/** ТО для отчета Среднесуточный пробег (семейство автомобиля-регион) */
export type ToForAverageDailyMileageByMonth = {
  __typename?: "TOForAverageDailyMileageByMonth";
  countCar?: Maybe<Scalars["Int"]>;
  averageDay?: Maybe<Scalars["Int"]>;
  mileage?: Maybe<Scalars["Int"]>;
};

/** ТО (свой/(свой-чужой)) по месяцу контроля */
export type ToForSrr = {
  __typename?: "TOForSRR";
  serviceCount?: Maybe<Scalars["Int"]>;
  saleCount?: Maybe<Scalars["Int"]>;
};

/** ТО (свой/(свой-чужой)) по месяцу контроля */
export type ToForServiceByMonth = {
  __typename?: "TOForServiceByMonth";
  cars?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /** Для отчета (свой-чужой) */
  carsForeign?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /** Для отчета Гибдд */
  carsCityGIBDD?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /** Для отчета Гибдд  */
  serviceCount?: Maybe<Scalars["Int"]>;
  /** Для отчета Гибдд */
  carsRegionGIBDD?: Maybe<Array<Maybe<Scalars["String"]>>>;
  /** Для отчета Гибдд. Количество а/м, зарегистрированных в регионе дилера  в  период продаж */
  carsAllRegionGIBDD?: Maybe<Scalars["Int"]>;
  saleCount?: Maybe<Scalars["String"]>;
};

/** ТО (свой/(свой-чужой)) по месяцу контроля */
export type ToForServiceByMonthByCarModelRegion = {
  __typename?: "TOForServiceByMonthByCarModelRegion";
  salesCount?: Maybe<Scalars["Int"]>;
  servicesCount?: Maybe<Scalars["Int"]>;
};

/** SRR5 по дилерам GIBDD LADA за период */
export type ToForServiceGibddByPeriod = {
  __typename?: "TOForServiceGIBDDByPeriod";
  /** Для отчета Гибдд  */
  serviceCount?: Maybe<Scalars["Int"]>;
  saleCount?: Maybe<Scalars["Int"]>;
  /** Для отчета Гибдд */
  carsCityGIBDD?: Maybe<Scalars["Int"]>;
  /** Для отчета Гибдд */
  carsRegionGIBDD?: Maybe<Scalars["Int"]>;
  /** Для отчета Гибдд. Количество а/м, зарегистрированных в регионе дилера  в  период продаж */
  carsAllRegionGIBDD?: Maybe<Scalars["Int"]>;
};

/** TO для отчета SRR3 по дилерам LADA расшифровка по VIN */
export type ToForVin = {
  __typename?: "TOForVIN";
  dateVisit?: Maybe<Scalars["DateTime"]>;
  dealerName?: Maybe<Scalars["String"]>;
};

/** Период для отчета Машинозаезды по дилерам */
export type ToPeriod = {
  __typename?: "TOPeriod";
  period?: Maybe<Scalars["String"]>;
  TO?: Maybe<ToData>;
};

/** Диллер в городе */
export type ThreeDealer = {
  __typename?: "ThreeDealer";
  DealerName: Scalars["String"];
  id: Scalars["ID"];
};

/** Tools */
export type Tools = {
  __typename?: "Tools";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  ModelIndicator?: Maybe<Scalars["ID"]>;
  CountryIndicator?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
  YearIndicator?: Maybe<Scalars["ID"]>;
  NoteIndicator?: Maybe<Scalars["ID"]>;
};

/** Tools */
export type ToolsDealerStatuses = {
  __typename?: "ToolsDealerStatuses";
  DealerId?: Maybe<Scalars["ID"]>;
  Dealer?: Maybe<Dealer>;
  ZD_UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  status?: Maybe<ZdStatusType>;
  /** последнее обновление заявки дилером */
  lastUpdatedAt?: Maybe<Scalars["DateTime"]>;
  /** последнее обновление статуса заявки */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** Получение данных */
export type ToolsGetter = {
  __typename?: "ToolsGetter";
  /** Получение значений по дилеру и дате */
  getValues?: Maybe<ToolsValues>;
  getDealerStatuses?: Maybe<Array<Maybe<ToolsDealerStatuses>>>;
  getById?: Maybe<ToolsIndicatorTypes>;
  /** Получить все актуальные на данные момент записи с индикаторами */
  getAll?: Maybe<Array<Maybe<ToolsIndicatorTypes>>>;
  getGroups?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

/** Получение данных */
export type ToolsGetterGetValuesArgs = {
  DealerId: Scalars["ID"];
  sortBy?: Maybe<ToolsSortBy>;
  dateUpTo?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
};

/** Получение данных */
export type ToolsGetterGetDealerStatusesArgs = {
  UUID?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

/** Получение данных */
export type ToolsGetterGetByIdArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** Получение данных */
export type ToolsGetterGetGroupsArgs = {
  groupType?: Maybe<ZdGroupType>;
};

/** Tools */
export type ToolsIndicatorTypes = {
  __typename?: "ToolsIndicatorTypes";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  ComplianceIndicator?: Maybe<Indicator>;
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  ModelIndicator?: Maybe<Indicator>;
  CountryIndicator?: Maybe<Indicator>;
  TotalIndicator?: Maybe<Indicator>;
  YearIndicator?: Maybe<Indicator>;
  NoteIndicator?: Maybe<Indicator>;
  isParent?: Maybe<Scalars["Boolean"]>;
};

/** ToolsInsurance */
export type ToolsInsurance = {
  __typename?: "ToolsInsurance";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  NumberList?: Maybe<Scalars["String"]>;
  NumberDetail?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
};

/** ToolsInsurance */
export type ToolsInsuranceDealerStatuses = {
  __typename?: "ToolsInsuranceDealerStatuses";
  DealerId?: Maybe<Scalars["ID"]>;
  Dealer?: Maybe<Dealer>;
  ZD_UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  status?: Maybe<ZdStatusType>;
  /** последнее обновление заявки дилером */
  lastUpdatedAt?: Maybe<Scalars["DateTime"]>;
  /** последнее обновление статуса заявки */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** Получение данных */
export type ToolsInsuranceGetter = {
  __typename?: "ToolsInsuranceGetter";
  /** Получение значений по дилеру и дате */
  getValues?: Maybe<ToolsInsuranceValues>;
  getDealerStatuses?: Maybe<Array<Maybe<ToolsInsuranceDealerStatuses>>>;
  getById?: Maybe<ToolsInsuranceIndicatorTypes>;
  /** Получить все актуальные на данные момент записи с индикаторами */
  getAll?: Maybe<Array<Maybe<ToolsInsuranceIndicatorTypes>>>;
  getGroups?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

/** Получение данных */
export type ToolsInsuranceGetterGetValuesArgs = {
  DealerId: Scalars["ID"];
  sortBy?: Maybe<ToolsInsuranceSortBy>;
  dateUpTo?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
};

/** Получение данных */
export type ToolsInsuranceGetterGetDealerStatusesArgs = {
  UUID?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

/** Получение данных */
export type ToolsInsuranceGetterGetByIdArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** Получение данных */
export type ToolsInsuranceGetterGetGroupsArgs = {
  groupType?: Maybe<ZdGroupType>;
};

/** ToolsInsurance */
export type ToolsInsuranceIndicatorTypes = {
  __typename?: "ToolsInsuranceIndicatorTypes";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  ComplianceIndicator?: Maybe<Indicator>;
  Number?: Maybe<Scalars["String"]>;
  NumberList?: Maybe<Scalars["String"]>;
  NumberDetail?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  TotalIndicator?: Maybe<Indicator>;
  isParent?: Maybe<Scalars["Boolean"]>;
};

/** ToolsInsurance */
export type ToolsInsuranceItemInZdForUuiDemptyList = {
  __typename?: "ToolsInsuranceItemInZdForUUIDemptyList";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Number?: Maybe<Scalars["String"]>;
  NumberList?: Maybe<Scalars["String"]>;
  NumberDetail?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  Total?: Maybe<Scalars["Float"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
};

/** ToolsInsurance */
export type ToolsInsuranceItemInZdForUuiDlist = {
  __typename?: "ToolsInsuranceItemInZdForUUIDlist";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Number?: Maybe<Scalars["String"]>;
  NumberList?: Maybe<Scalars["String"]>;
  NumberDetail?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  Total?: Maybe<Scalars["Float"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
};

/** ToolsInsurance */
export type ToolsInsuranceOneValuesItem = {
  __typename?: "ToolsInsuranceOneValuesItem";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Number?: Maybe<Scalars["String"]>;
  NumberList?: Maybe<Scalars["String"]>;
  NumberDetail?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  Total?: Maybe<Scalars["Float"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
  list?: Maybe<Array<Maybe<ToolsInsuranceItemInZdForUuiDlist>>>;
  emptyList?: Maybe<Array<Maybe<ToolsInsuranceItemInZdForUuiDemptyList>>>;
};

/** Изменение данных */
export type ToolsInsuranceSetter = {
  __typename?: "ToolsInsuranceSetter";
  /** Создание */
  create?: Maybe<ToolsInsurance>;
  /** Редактирование с сохранением истории */
  change?: Maybe<ToolsInsurance>;
  /** изменить место в сортировке. отрицательные значения и 0 не смещают другие элементы */
  setSort?: Maybe<Scalars["Boolean"]>;
  /** Редактирование текущего состояния (eg исправление опечатки) */
  blindChange?: Maybe<ToolsInsurance>;
  /** Добавить значения или обновить значения сущности */
  addValues?: Maybe<Scalars["Boolean"]>;
  /** Сделать неактуальным (удалить) */
  delete?: Maybe<Scalars["Boolean"]>;
  renameGroup?: Maybe<Scalars["Boolean"]>;
  /** изменить место в сортировке */
  setSortGroup?: Maybe<Scalars["Boolean"]>;
};

/** Изменение данных */
export type ToolsInsuranceSetterCreateArgs = {
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  NumberList?: Maybe<Scalars["String"]>;
  NumberDetail?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type ToolsInsuranceSetterChangeArgs = {
  id?: Maybe<Scalars["ID"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  NumberList?: Maybe<Scalars["String"]>;
  NumberDetail?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type ToolsInsuranceSetterSetSortArgs = {
  sort?: Maybe<Scalars["Int"]>;
  UUID: Scalars["String"];
};

/** Изменение данных */
export type ToolsInsuranceSetterBlindChangeArgs = {
  id?: Maybe<Scalars["ID"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  NumberList?: Maybe<Scalars["String"]>;
  NumberDetail?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type ToolsInsuranceSetterAddValuesArgs = {
  Compliance?: Maybe<Scalars["Int"]>;
  Total?: Maybe<Scalars["Float"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
};

/** Изменение данных */
export type ToolsInsuranceSetterDeleteArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type ToolsInsuranceSetterRenameGroupArgs = {
  groupType?: Maybe<ZdGroupType>;
  newGroup?: Maybe<Scalars["String"]>;
  oldGroup?: Maybe<Scalars["String"]>;
};

/** Изменение данных */
export type ToolsInsuranceSetterSetSortGroupArgs = {
  sort?: Maybe<Scalars["Int"]>;
  group: Scalars["String"];
};

export enum ToolsInsuranceSortBy {
  Number = "number",
  Name = "name",
  NameEn = "nameEn",
  Sort = "sort",
  GroupOne = "GroupOne",
  SortGroup = "sortGroup",
}

/** ToolsInsurance */
export type ToolsInsuranceValues = {
  __typename?: "ToolsInsuranceValues";
  items?: Maybe<Array<Maybe<ToolsInsuranceOneValuesItem>>>;
  total?: Maybe<Scalars["Int"]>;
};

/** Tools */
export type ToolsItemInZdForUuiDemptyList = {
  __typename?: "ToolsItemInZdForUUIDemptyList";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  Model?: Maybe<Scalars["String"]>;
  Country?: Maybe<Scalars["String"]>;
  Total?: Maybe<Scalars["Float"]>;
  Year?: Maybe<Scalars["Int"]>;
  Note?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
};

/** Tools */
export type ToolsItemInZdForUuiDlist = {
  __typename?: "ToolsItemInZdForUUIDlist";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  Model?: Maybe<Scalars["String"]>;
  Country?: Maybe<Scalars["String"]>;
  Total?: Maybe<Scalars["Float"]>;
  Year?: Maybe<Scalars["Int"]>;
  Note?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
};

/** ToolsMetrological */
export type ToolsMetrological = {
  __typename?: "ToolsMetrological";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
};

/** ToolsMetrological */
export type ToolsMetrologicalDealerStatuses = {
  __typename?: "ToolsMetrologicalDealerStatuses";
  DealerId?: Maybe<Scalars["ID"]>;
  Dealer?: Maybe<Dealer>;
  ZD_UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  status?: Maybe<ZdStatusType>;
  /** последнее обновление заявки дилером */
  lastUpdatedAt?: Maybe<Scalars["DateTime"]>;
  /** последнее обновление статуса заявки */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** Получение данных */
export type ToolsMetrologicalGetter = {
  __typename?: "ToolsMetrologicalGetter";
  /** Получение значений по дилеру и дате */
  getValues?: Maybe<ToolsMetrologicalValues>;
  getDealerStatuses?: Maybe<Array<Maybe<ToolsMetrologicalDealerStatuses>>>;
  getById?: Maybe<ToolsMetrologicalIndicatorTypes>;
  /** Получить все актуальные на данные момент записи с индикаторами */
  getAll?: Maybe<Array<Maybe<ToolsMetrologicalIndicatorTypes>>>;
};

/** Получение данных */
export type ToolsMetrologicalGetterGetValuesArgs = {
  DealerId: Scalars["ID"];
  sortBy?: Maybe<ToolsMetrologicalSortBy>;
  dateUpTo?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
};

/** Получение данных */
export type ToolsMetrologicalGetterGetDealerStatusesArgs = {
  UUID?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

/** Получение данных */
export type ToolsMetrologicalGetterGetByIdArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** ToolsMetrological */
export type ToolsMetrologicalIndicatorTypes = {
  __typename?: "ToolsMetrologicalIndicatorTypes";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  ComplianceIndicator?: Maybe<Indicator>;
  Number?: Maybe<Scalars["String"]>;
  TotalIndicator?: Maybe<Indicator>;
  isParent?: Maybe<Scalars["Boolean"]>;
};

/** ToolsMetrological */
export type ToolsMetrologicalItemInZdForUuiDemptyList = {
  __typename?: "ToolsMetrologicalItemInZdForUUIDemptyList";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Number?: Maybe<Scalars["String"]>;
  Total?: Maybe<Scalars["Float"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
};

/** ToolsMetrological */
export type ToolsMetrologicalItemInZdForUuiDlist = {
  __typename?: "ToolsMetrologicalItemInZdForUUIDlist";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Number?: Maybe<Scalars["String"]>;
  Total?: Maybe<Scalars["Float"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
};

/** ToolsMetrological */
export type ToolsMetrologicalOneValuesItem = {
  __typename?: "ToolsMetrologicalOneValuesItem";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Number?: Maybe<Scalars["String"]>;
  Total?: Maybe<Scalars["Float"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
  list?: Maybe<Array<Maybe<ToolsMetrologicalItemInZdForUuiDlist>>>;
  emptyList?: Maybe<Array<Maybe<ToolsMetrologicalItemInZdForUuiDemptyList>>>;
};

/** Изменение данных */
export type ToolsMetrologicalSetter = {
  __typename?: "ToolsMetrologicalSetter";
  /** Создание */
  create?: Maybe<ToolsMetrological>;
  /** Редактирование с сохранением истории */
  change?: Maybe<ToolsMetrological>;
  /** изменить место в сортировке. отрицательные значения и 0 не смещают другие элементы */
  setSort?: Maybe<Scalars["Boolean"]>;
  /** Редактирование текущего состояния (eg исправление опечатки) */
  blindChange?: Maybe<ToolsMetrological>;
  /** Добавить значения или обновить значения сущности */
  addValues?: Maybe<Scalars["Boolean"]>;
  /** Сделать неактуальным (удалить) */
  delete?: Maybe<Scalars["Boolean"]>;
};

/** Изменение данных */
export type ToolsMetrologicalSetterCreateArgs = {
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type ToolsMetrologicalSetterChangeArgs = {
  id?: Maybe<Scalars["ID"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type ToolsMetrologicalSetterSetSortArgs = {
  sort?: Maybe<Scalars["Int"]>;
  UUID: Scalars["String"];
};

/** Изменение данных */
export type ToolsMetrologicalSetterBlindChangeArgs = {
  id?: Maybe<Scalars["ID"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type ToolsMetrologicalSetterAddValuesArgs = {
  Compliance?: Maybe<Scalars["Int"]>;
  Total?: Maybe<Scalars["Float"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
};

/** Изменение данных */
export type ToolsMetrologicalSetterDeleteArgs = {
  id?: Maybe<Scalars["ID"]>;
};

export enum ToolsMetrologicalSortBy {
  Number = "number",
  Name = "name",
  NameEn = "nameEn",
  Sort = "sort",
  GroupOne = "GroupOne",
  SortGroup = "sortGroup",
}

/** ToolsMetrological */
export type ToolsMetrologicalValues = {
  __typename?: "ToolsMetrologicalValues";
  items?: Maybe<Array<Maybe<ToolsMetrologicalOneValuesItem>>>;
  total?: Maybe<Scalars["Int"]>;
};

/** Tools */
export type ToolsOneValuesItem = {
  __typename?: "ToolsOneValuesItem";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  Model?: Maybe<Scalars["String"]>;
  Country?: Maybe<Scalars["String"]>;
  Total?: Maybe<Scalars["Float"]>;
  Year?: Maybe<Scalars["Int"]>;
  Note?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
  list?: Maybe<Array<Maybe<ToolsItemInZdForUuiDlist>>>;
  emptyList?: Maybe<Array<Maybe<ToolsItemInZdForUuiDemptyList>>>;
};

/** Изменение данных */
export type ToolsSetter = {
  __typename?: "ToolsSetter";
  /** Создание */
  create?: Maybe<Tools>;
  /** Редактирование с сохранением истории */
  change?: Maybe<Tools>;
  /** изменить место в сортировке. отрицательные значения и 0 не смещают другие элементы */
  setSort?: Maybe<Scalars["Boolean"]>;
  /** Редактирование текущего состояния (eg исправление опечатки) */
  blindChange?: Maybe<Tools>;
  /** Добавить значения или обновить значения сущности */
  addValues?: Maybe<Scalars["Boolean"]>;
  /** Сделать неактуальным (удалить) */
  delete?: Maybe<Scalars["Boolean"]>;
  /** Необходимо предусмотреть формирование дополнительных строк со стороны пользователя дилера */
  duplicate?: Maybe<ToolsIndicatorTypes>;
  renameGroup?: Maybe<Scalars["Boolean"]>;
  /** изменить место в сортировке */
  setSortGroup?: Maybe<Scalars["Boolean"]>;
};

/** Изменение данных */
export type ToolsSetterCreateArgs = {
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  ModelIndicator?: Maybe<Scalars["ID"]>;
  CountryIndicator?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
  YearIndicator?: Maybe<Scalars["ID"]>;
  NoteIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type ToolsSetterChangeArgs = {
  id?: Maybe<Scalars["ID"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  ModelIndicator?: Maybe<Scalars["ID"]>;
  CountryIndicator?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
  YearIndicator?: Maybe<Scalars["ID"]>;
  NoteIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type ToolsSetterSetSortArgs = {
  sort?: Maybe<Scalars["Int"]>;
  UUID: Scalars["String"];
};

/** Изменение данных */
export type ToolsSetterBlindChangeArgs = {
  id?: Maybe<Scalars["ID"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  ModelIndicator?: Maybe<Scalars["ID"]>;
  CountryIndicator?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
  YearIndicator?: Maybe<Scalars["ID"]>;
  NoteIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type ToolsSetterAddValuesArgs = {
  Compliance?: Maybe<Scalars["Int"]>;
  Model?: Maybe<Scalars["String"]>;
  Country?: Maybe<Scalars["String"]>;
  Total?: Maybe<Scalars["Float"]>;
  Year?: Maybe<Scalars["Int"]>;
  Note?: Maybe<Scalars["String"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
};

/** Изменение данных */
export type ToolsSetterDeleteArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type ToolsSetterDuplicateArgs = {
  uuid?: Maybe<Scalars["String"]>;
};

/** Изменение данных */
export type ToolsSetterRenameGroupArgs = {
  groupType?: Maybe<ZdGroupType>;
  newGroup?: Maybe<Scalars["String"]>;
  oldGroup?: Maybe<Scalars["String"]>;
};

/** Изменение данных */
export type ToolsSetterSetSortGroupArgs = {
  sort?: Maybe<Scalars["Int"]>;
  group: Scalars["String"];
};

export enum ToolsSortBy {
  Number = "number",
  Name = "name",
  NameEn = "nameEn",
  Sort = "sort",
  GroupOne = "GroupOne",
  SortGroup = "sortGroup",
}

/** Tools */
export type ToolsValues = {
  __typename?: "ToolsValues";
  items?: Maybe<Array<Maybe<ToolsOneValuesItem>>>;
  total?: Maybe<Scalars["Int"]>;
};

/** TradePremises */
export type TradePremises = {
  __typename?: "TradePremises";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  /** Доступны значения: showroom,issuanceZones,storageSites */
  GroupOne?: Maybe<Scalars["String"]>;
  AreaIndicator?: Maybe<Scalars["ID"]>;
  /** Название участка с которым идёт совмещение, передавать uuid */
  PlacesCombineIndicator?: Maybe<Scalars["ID"]>;
  /** Адрес */
  AddressIndicator?: Maybe<Scalars["ID"]>;
};

/** TradePremises */
export type TradePremisesDealerStatuses = {
  __typename?: "TradePremisesDealerStatuses";
  DealerId?: Maybe<Scalars["ID"]>;
  Dealer?: Maybe<Dealer>;
  ZD_UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  status?: Maybe<ZdStatusType>;
  /** последнее обновление заявки дилером */
  lastUpdatedAt?: Maybe<Scalars["DateTime"]>;
  /** последнее обновление статуса заявки */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** Получение данных */
export type TradePremisesGetter = {
  __typename?: "TradePremisesGetter";
  /** Получение значений по дилеру и дате */
  getValues?: Maybe<TradePremisesValues>;
  getDealerStatuses?: Maybe<Array<Maybe<TradePremisesDealerStatuses>>>;
  getById?: Maybe<TradePremisesIndicatorTypes>;
  /** Получить все актуальные на данные момент записи с индикаторами */
  getAll?: Maybe<Array<Maybe<TradePremisesIndicatorTypes>>>;
  getGroups?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

/** Получение данных */
export type TradePremisesGetterGetValuesArgs = {
  DealerId: Scalars["ID"];
  sortBy?: Maybe<TradePremisesSortBy>;
  dateUpTo?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
};

/** Получение данных */
export type TradePremisesGetterGetDealerStatusesArgs = {
  UUID?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

/** Получение данных */
export type TradePremisesGetterGetByIdArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** Получение данных */
export type TradePremisesGetterGetGroupsArgs = {
  groupType?: Maybe<ZdGroupType>;
};

/** TradePremises */
export type TradePremisesIndicatorTypes = {
  __typename?: "TradePremisesIndicatorTypes";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  ComplianceIndicator?: Maybe<Indicator>;
  Number?: Maybe<Scalars["String"]>;
  /** Доступны значения: showroom,issuanceZones,storageSites */
  GroupOne?: Maybe<Scalars["String"]>;
  AreaIndicator?: Maybe<Indicator>;
  /** Название участка с которым идёт совмещение, передавать uuid */
  PlacesCombineIndicator?: Maybe<Indicator>;
  /** Адрес */
  AddressIndicator?: Maybe<Indicator>;
  isParent?: Maybe<Scalars["Boolean"]>;
};

/** TradePremises */
export type TradePremisesItemInZdForUuiDemptyList = {
  __typename?: "TradePremisesItemInZdForUUIDemptyList";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Number?: Maybe<Scalars["String"]>;
  /** Доступны значения: showroom,issuanceZones,storageSites */
  GroupOne?: Maybe<Scalars["String"]>;
  Area?: Maybe<Scalars["Float"]>;
  /** Название участка с которым идёт совмещение, передавать uuid */
  PlacesCombine?: Maybe<Scalars["String"]>;
  /** Адрес */
  Address?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
};

/** TradePremises */
export type TradePremisesItemInZdForUuiDlist = {
  __typename?: "TradePremisesItemInZdForUUIDlist";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Number?: Maybe<Scalars["String"]>;
  /** Доступны значения: showroom,issuanceZones,storageSites */
  GroupOne?: Maybe<Scalars["String"]>;
  Area?: Maybe<Scalars["Float"]>;
  /** Название участка с которым идёт совмещение, передавать uuid */
  PlacesCombine?: Maybe<Scalars["String"]>;
  /** Адрес */
  Address?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
};

/** TradePremises */
export type TradePremisesOneValuesItem = {
  __typename?: "TradePremisesOneValuesItem";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Number?: Maybe<Scalars["String"]>;
  /** Доступны значения: showroom,issuanceZones,storageSites */
  GroupOne?: Maybe<Scalars["String"]>;
  Area?: Maybe<Scalars["Float"]>;
  /** Название участка с которым идёт совмещение, передавать uuid */
  PlacesCombine?: Maybe<Scalars["String"]>;
  /** Адрес */
  Address?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
  list?: Maybe<Array<Maybe<TradePremisesItemInZdForUuiDlist>>>;
  emptyList?: Maybe<Array<Maybe<TradePremisesItemInZdForUuiDemptyList>>>;
};

/** Изменение данных */
export type TradePremisesSetter = {
  __typename?: "TradePremisesSetter";
  /** Создание */
  create?: Maybe<TradePremises>;
  /** Редактирование с сохранением истории */
  change?: Maybe<TradePremises>;
  /** изменить место в сортировке. отрицательные значения и 0 не смещают другие элементы */
  setSort?: Maybe<Scalars["Boolean"]>;
  /** Редактирование текущего состояния (eg исправление опечатки) */
  blindChange?: Maybe<TradePremises>;
  /** Добавить значения или обновить значения сущности */
  addValues?: Maybe<Scalars["Boolean"]>;
  /** Сделать неактуальным (удалить) */
  delete?: Maybe<Scalars["Boolean"]>;
  renameGroup?: Maybe<Scalars["Boolean"]>;
  /** изменить место в сортировке */
  setSortGroup?: Maybe<Scalars["Boolean"]>;
};

/** Изменение данных */
export type TradePremisesSetterCreateArgs = {
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  AreaIndicator?: Maybe<Scalars["ID"]>;
  PlacesCombineIndicator?: Maybe<Scalars["ID"]>;
  AddressIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type TradePremisesSetterChangeArgs = {
  id?: Maybe<Scalars["ID"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  AreaIndicator?: Maybe<Scalars["ID"]>;
  PlacesCombineIndicator?: Maybe<Scalars["ID"]>;
  AddressIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type TradePremisesSetterSetSortArgs = {
  sort?: Maybe<Scalars["Int"]>;
  UUID: Scalars["String"];
};

/** Изменение данных */
export type TradePremisesSetterBlindChangeArgs = {
  id?: Maybe<Scalars["ID"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  AreaIndicator?: Maybe<Scalars["ID"]>;
  PlacesCombineIndicator?: Maybe<Scalars["ID"]>;
  AddressIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type TradePremisesSetterAddValuesArgs = {
  Compliance?: Maybe<Scalars["Int"]>;
  Area?: Maybe<Scalars["Float"]>;
  PlacesCombine?: Maybe<Scalars["String"]>;
  Address?: Maybe<Scalars["String"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
};

/** Изменение данных */
export type TradePremisesSetterDeleteArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type TradePremisesSetterRenameGroupArgs = {
  groupType?: Maybe<ZdGroupType>;
  newGroup?: Maybe<Scalars["String"]>;
  oldGroup?: Maybe<Scalars["String"]>;
};

/** Изменение данных */
export type TradePremisesSetterSetSortGroupArgs = {
  sort?: Maybe<Scalars["Int"]>;
  group: Scalars["String"];
};

export enum TradePremisesSortBy {
  Number = "number",
  Name = "name",
  NameEn = "nameEn",
  Sort = "sort",
  GroupOne = "GroupOne",
  SortGroup = "sortGroup",
}

/** TradePremises */
export type TradePremisesValues = {
  __typename?: "TradePremisesValues";
  items?: Maybe<Array<Maybe<TradePremisesOneValuesItem>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type TrustedPerson = {
  __typename?: "TrustedPerson";
  id: Scalars["ID"];
  powerOfAttorney: Scalars["String"];
  fio: Scalars["String"];
  shortFio: Scalars["String"];
  descriptionContract: Scalars["String"];
  date: Scalars["Date"];
  endDate: Scalars["Date"];
  active: Scalars["Boolean"];
};

/** Получение доверенных лиц */
export type TrustedPersonGetter = {
  __typename?: "TrustedPersonGetter";
  getTrustedPersons: Array<Maybe<TrustedPerson>>;
  getTrustedPersonById: TrustedPerson;
};

/** Получение доверенных лиц */
export type TrustedPersonGetterGetTrustedPersonByIdArgs = {
  id: Scalars["ID"];
};

/** Изменение доверенных лиц */
export type TrustedPersonSetter = {
  __typename?: "TrustedPersonSetter";
  createTrustedPerson: TrustedPerson;
  updateTrustedPerson: TrustedPerson;
};

/** Изменение доверенных лиц */
export type TrustedPersonSetterCreateTrustedPersonArgs = {
  powerOfAttorney: Scalars["String"];
  fio: Scalars["String"];
  shortFio: Scalars["String"];
  descriptionContract: Scalars["String"];
  date: Scalars["Date"];
  endDate: Scalars["Date"];
  active: Scalars["Boolean"];
};

/** Изменение доверенных лиц */
export type TrustedPersonSetterUpdateTrustedPersonArgs = {
  id: Scalars["ID"];
  powerOfAttorney?: Maybe<Scalars["String"]>;
  fio?: Maybe<Scalars["String"]>;
  shortFio?: Maybe<Scalars["String"]>;
  descriptionContract?: Maybe<Scalars["String"]>;
  date?: Maybe<Scalars["Date"]>;
  endDate?: Maybe<Scalars["Date"]>;
  active?: Maybe<Scalars["Boolean"]>;
};

/** Получение списка загрузок */
export type UploadList = {
  __typename?: "UploadList";
  id?: Maybe<Scalars["ID"]>;
  UserId?: Maybe<Scalars["ID"]>;
  User?: Maybe<Profile>;
  FileId?: Maybe<Scalars["ID"]>;
  File?: Maybe<File>;
  errors?: Maybe<Scalars["JSON"]>;
  description?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
};

/** Список загрузок значений индикаторов */
export type UploadValuesList = {
  __typename?: "UploadValuesList";
  items?: Maybe<Array<Maybe<UploadList>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type UsedCarSales = {
  __typename?: "UsedCarSales";
  doubleValue: Scalars["Float"];
  avgSales?: Maybe<Scalars["Float"]>;
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
};

/** Пользователь */
export type User = {
  __typename?: "User";
  User?: Maybe<Profile>;
};

/** Получение данных о пользователях */
export type UserGetter = {
  __typename?: "UserGetter";
  /** администратор получит список пользователей */
  getUsers?: Maybe<UserList>;
  /** Получить список региональных менеджеров */
  getRegMens?: Maybe<RegMensList>;
  /** Получить профиль пользователя. (админ может получить любого пользователя по id) */
  getProfile?: Maybe<Profile>;
  /** Отчет о прикреплении региональных менеджеров к дилеру по периоду */
  getReportRegMenByDealerByPeriod?: Maybe<
    Array<Maybe<ReportRegMenByDealerByPeriod>>
  >;
  /** Получить отчет о прикреплении региональных менеджеров по периоду */
  getReportFileRegMenByDealerByPeriod?: Maybe<ReportFile>;
  /** Отчет о прикреплении региональных менеджеров к дилеру по дилеру */
  getReportRegMenByDealerByDealer?: Maybe<
    Array<Maybe<ReportRegMenByDealerByDealer>>
  >;
  /** Получить отчет о прикреплении региональных менеджеров по дилеру */
  getReportFileRegMenByDealerByDealer?: Maybe<ReportFile>;
  /** Отчет о прикреплении региональных менеджеров к дилеру сводный */
  getReportRegMenByDealerConsolidate?: Maybe<
    Array<Maybe<ReportRegMenByDealerConsolidate>>
  >;
  /** Получить отчет о прикреплении региональных менеджеров сводный */
  getReportFileRegMenByDealerConsolidate?: Maybe<ReportFile>;
  /** Отчет о прикреплении региональных менеджеров к дилеру по региональному менеджеру */
  getReportRegMenByDealerByRegMen?: Maybe<
    Array<Maybe<ReportRegMenByDealerByRegMen>>
  >;
  /** Получить отчет о прикреплении региональных менеджеров по региональному менеджеру */
  getReportFileRegMenByDealerByRegMen?: Maybe<ReportFile>;
};

/** Получение данных о пользователях */
export type UserGetterGetUsersArgs = {
  searchField?: Maybe<Scalars["String"]>;
  searchText?: Maybe<Scalars["String"]>;
  sortField?: Maybe<Scalars["String"]>;
  sortType?: Maybe<Scalars["String"]>;
  catalog?: Maybe<Scalars["String"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  SubdivisionId?: Maybe<Scalars["ID"]>;
  ViolationAccess?: Maybe<Scalars["Boolean"]>;
  EmployeeAccess?: Maybe<Scalars["Boolean"]>;
  AnnouncementsAccess?: Maybe<Scalars["Boolean"]>;
  AnnouncementsSend?: Maybe<Scalars["Boolean"]>;
  ZdAccess?: Maybe<Scalars["Boolean"]>;
  CandidateAccess?: Maybe<Scalars["Boolean"]>;
  ivideon_access?: Maybe<Scalars["Boolean"]>;
  dnm_access?: Maybe<Scalars["Boolean"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

/** Получение данных о пользователях */
export type UserGetterGetRegMensArgs = {
  searchField?: Maybe<Scalars["String"]>;
  searchText?: Maybe<Scalars["String"]>;
  sortField?: Maybe<Scalars["String"]>;
  sortType?: Maybe<Scalars["String"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

/** Получение данных о пользователях */
export type UserGetterGetProfileArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** Получение данных о пользователях */
export type UserGetterGetReportRegMenByDealerByPeriodArgs = {
  quarter?: Maybe<Scalars["Int"]>;
  year?: Maybe<Scalars["Int"]>;
};

/** Получение данных о пользователях */
export type UserGetterGetReportFileRegMenByDealerByPeriodArgs = {
  quarter?: Maybe<Scalars["Int"]>;
  year?: Maybe<Scalars["Int"]>;
};

/** Получение данных о пользователях */
export type UserGetterGetReportRegMenByDealerByDealerArgs = {
  dealerId?: Maybe<Scalars["ID"]>;
};

/** Получение данных о пользователях */
export type UserGetterGetReportFileRegMenByDealerByDealerArgs = {
  dealerId?: Maybe<Scalars["ID"]>;
};

/** Получение данных о пользователях */
export type UserGetterGetReportRegMenByDealerByRegMenArgs = {
  userId?: Maybe<Scalars["ID"]>;
};

/** Получение данных о пользователях */
export type UserGetterGetReportFileRegMenByDealerByRegMenArgs = {
  userId?: Maybe<Scalars["ID"]>;
};

export type UserGuide = {
  __typename?: "UserGuide";
  AdminFileId?: Maybe<Scalars["ID"]>;
  AdminFile?: Maybe<File>;
  UserFileId?: Maybe<Scalars["ID"]>;
  UserFile?: Maybe<File>;
};

/** Получение данных о пользователях */
export type UserGuideGetter = {
  __typename?: "UserGuideGetter";
  /** Получение гайдов */
  getGuideFile?: Maybe<UserGuide>;
};

/** Изменение данных о пользователях */
export type UserGuideSetter = {
  __typename?: "UserGuideSetter";
  /** Загрузка файлов */
  setGuideFile?: Maybe<UserGuide>;
};

/** Изменение данных о пользователях */
export type UserGuideSetterSetGuideFileArgs = {
  AdminFileId?: Maybe<Scalars["ID"]>;
  UserFileId?: Maybe<Scalars["ID"]>;
};

/** Список пользователей */
export type UserList = {
  __typename?: "UserList";
  items?: Maybe<Array<Maybe<Profile>>>;
  total?: Maybe<Scalars["Int"]>;
};

/** Изменение данных о пользователях */
export type UserSetter = {
  __typename?: "UserSetter";
  /** Администратор редактирует пользователя */
  changeUser?: Maybe<Profile>;
  /** Администратор удалит пользователя */
  deleteUser?: Maybe<Scalars["Boolean"]>;
  /** Администратор импортирует пользователей */
  importUser?: Maybe<Scalars["Boolean"]>;
  /** Администратор восстановит удаленного пользователя */
  restoreUser?: Maybe<Scalars["Boolean"]>;
  /** Загрузка прикрепление региональных менеджеров к дилеру через csv */
  uploadUserToDealer?: Maybe<Scalars["Boolean"]>;
  /** Разрешить загрузить черновик */
  acceptUploadUserToDealer?: Maybe<Scalars["Boolean"]>;
};

/** Изменение данных о пользователях */
export type UserSetterChangeUserArgs = {
  id: Scalars["ID"];
  role: Scalars["String"];
  login: Scalars["String"];
  fullname: Scalars["String"];
  email: Scalars["String"];
  position?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  isViolationAccess?: Maybe<Scalars["Boolean"]>;
  isEmployeeAccess?: Maybe<Scalars["Boolean"]>;
  isZdAccess?: Maybe<Scalars["Boolean"]>;
  isAnnouncementsAccess?: Maybe<Scalars["Boolean"]>;
  isAccountingAccess?: Maybe<Scalars["Boolean"]>;
  isAnnouncementsSend?: Maybe<Scalars["Boolean"]>;
  SubdivisionId?: Maybe<Scalars["ID"]>;
  isCameraAccess?: Maybe<Scalars["Boolean"]>;
  isCandidateAccess?: Maybe<Scalars["Boolean"]>;
  isDocumentsAccess?: Maybe<Scalars["Boolean"]>;
  isTrustedPersonAccess?: Maybe<Scalars["Boolean"]>;
  ivideon_access?: Maybe<Scalars["Boolean"]>;
  dnm_access?: Maybe<Scalars["Boolean"]>;
  isTemporaryAccessToAllDealers?: Maybe<Scalars["Boolean"]>;
};

/** Изменение данных о пользователях */
export type UserSetterDeleteUserArgs = {
  id: Scalars["ID"];
};

/** Изменение данных о пользователях */
export type UserSetterRestoreUserArgs = {
  id: Scalars["ID"];
};

/** Изменение данных о пользователях */
export type UserSetterUploadUserToDealerArgs = {
  fileId: Scalars["ID"];
  quarter?: Maybe<Scalars["Int"]>;
  year?: Maybe<Scalars["Int"]>;
};

/** Изменение данных о пользователях */
export type UserSetterAcceptUploadUserToDealerArgs = {
  IndicatorUploadId: Scalars["ID"];
};

/** Данные для Vehicle */
export type Vehicle = {
  __typename?: "Vehicle";
  i101?: Maybe<Array<Maybe<IndicatorValue>>>;
  i103?: Maybe<Array<Maybe<IndicatorValue>>>;
  i104?: Maybe<Array<Maybe<IndicatorValue>>>;
  i105?: Maybe<Array<Maybe<IndicatorValue>>>;
  i106?: Maybe<Array<Maybe<IndicatorValue>>>;
};

export type Violation = {
  __typename?: "Violation";
  id?: Maybe<Scalars["ID"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  ViolationTypesId?: Maybe<Scalars["ID"]>;
  DocId?: Maybe<Scalars["ID"]>;
  DocNum?: Maybe<Scalars["String"]>;
  DocDate?: Maybe<Scalars["DateTime"]>;
  description?: Maybe<Scalars["String"]>;
  fixDeadline?: Maybe<Scalars["DateTime"]>;
  punishment?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  reportedBy?: Maybe<Scalars["ID"]>;
  responsibleChecker?: Maybe<Scalars["ID"]>;
  fixDateAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
};

export type ViolationComment = {
  __typename?: "ViolationComment";
  id?: Maybe<Scalars["ID"]>;
  ViolationId?: Maybe<Scalars["ID"]>;
  Files?: Maybe<Array<Maybe<File>>>;
  UserId?: Maybe<Scalars["ID"]>;
  User?: Maybe<Profile>;
  comment?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
};

export type ViolationGetter = {
  __typename?: "ViolationGetter";
  /** Получить сводный отчет о нарушениях */
  getReportByDealer?: Maybe<ReportFile>;
  /** Получить отчет о нарушениях */
  getAllReport?: Maybe<ReportFile>;
  getAll?: Maybe<GetAllViolationResponse>;
  getById?: Maybe<ViolationInclude>;
  getComments?: Maybe<GetCommentsResponse>;
};

export type ViolationGetterGetReportByDealerArgs = {
  dateBegin?: Maybe<Scalars["DateTime"]>;
  dateEnd?: Maybe<Scalars["DateTime"]>;
  dealerCandidate?: Maybe<Scalars["String"]>;
};

export type ViolationGetterGetAllReportArgs = {
  documentFilter?: Maybe<FilterExistenceType>;
  statusFilter?: Maybe<ViolationStatus>;
  FoFilter?: Maybe<Scalars["String"]>;
  regionFilter?: Maybe<Scalars["String"]>;
  dealerIdFilter?: Maybe<Scalars["ID"]>;
  dealerCandidate?: Maybe<Scalars["String"]>;
  fromFilter?: Maybe<Scalars["DateTime"]>;
  toFilter?: Maybe<Scalars["DateTime"]>;
  fromCreatedAt?: Maybe<Scalars["DateTime"]>;
  toCreatedAt?: Maybe<Scalars["DateTime"]>;
  violationTypesIdFilter?: Maybe<Scalars["ID"]>;
  subdivisionIdFilter?: Maybe<Scalars["ID"]>;
  categoryFilter?: Maybe<ViolationTypeCategory>;
};

export type ViolationGetterGetAllArgs = {
  order?: Maybe<SortType>;
  orderBy?: Maybe<OrderByColumnInViolation>;
  documentFilter?: Maybe<FilterExistenceType>;
  statusFilter?: Maybe<ViolationStatus>;
  FoFilter?: Maybe<Scalars["String"]>;
  regionFilter?: Maybe<Scalars["String"]>;
  dealerIdFilter?: Maybe<Scalars["ID"]>;
  dealerCandidate?: Maybe<Scalars["String"]>;
  fromFilter?: Maybe<Scalars["DateTime"]>;
  toFilter?: Maybe<Scalars["DateTime"]>;
  fromCreatedAt?: Maybe<Scalars["DateTime"]>;
  toCreatedAt?: Maybe<Scalars["DateTime"]>;
  violationTypesIdFilter?: Maybe<Scalars["ID"]>;
  subdivisionIdFilter?: Maybe<Scalars["ID"]>;
  categoryFilter?: Maybe<ViolationTypeCategory>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

export type ViolationGetterGetByIdArgs = {
  id?: Maybe<Scalars["ID"]>;
};

export type ViolationGetterGetCommentsArgs = {
  id?: Maybe<Scalars["ID"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

export type ViolationInclude = {
  __typename?: "ViolationInclude";
  id?: Maybe<Scalars["ID"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  ViolationTypesId?: Maybe<Scalars["ID"]>;
  DocId?: Maybe<Scalars["ID"]>;
  DocNum?: Maybe<Scalars["String"]>;
  DocDate?: Maybe<Scalars["DateTime"]>;
  description?: Maybe<Scalars["String"]>;
  fixDeadline?: Maybe<Scalars["DateTime"]>;
  punishment?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  reportedBy?: Maybe<Scalars["ID"]>;
  responsibleChecker?: Maybe<Scalars["ID"]>;
  fixDateAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  File?: Maybe<File>;
  reportedByUser?: Maybe<Profile>;
  responsibleByUser?: Maybe<Profile>;
  Dealer?: Maybe<Dealer>;
  ViolationComments?: Maybe<Array<Maybe<ViolationComment>>>;
  ViolationType?: Maybe<ViolationTypeInclude>;
};

export type ViolationSetter = {
  __typename?: "ViolationSetter";
  create?: Maybe<Scalars["Boolean"]>;
  dealerFix?: Maybe<Scalars["Boolean"]>;
  giveResponseToDealer?: Maybe<Scalars["Boolean"]>;
  addComment?: Maybe<Scalars["Boolean"]>;
  edit?: Maybe<Scalars["Boolean"]>;
  delete?: Maybe<Scalars["Boolean"]>;
  reject?: Maybe<Scalars["Boolean"]>;
  unDelete?: Maybe<Scalars["Boolean"]>;
};

export type ViolationSetterCreateArgs = {
  DealerIds: Array<Maybe<Scalars["ID"]>>;
  ViolationTypesId: Scalars["ID"];
  fixDeadline: Scalars["DateTime"];
  description: Scalars["String"];
  DocNum?: Maybe<Scalars["String"]>;
  DocDate?: Maybe<Scalars["DateTime"]>;
  FileId?: Maybe<Scalars["ID"]>;
  responsibleChecker?: Maybe<Scalars["ID"]>;
};

export type ViolationSetterDealerFixArgs = {
  id: Scalars["ID"];
};

export type ViolationSetterGiveResponseToDealerArgs = {
  id: Scalars["ID"];
  punishment?: Maybe<Scalars["String"]>;
  status?: Maybe<StatusSetResponseToDealer>;
};

export type ViolationSetterAddCommentArgs = {
  id: Scalars["ID"];
  comment: Scalars["String"];
  files?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

export type ViolationSetterEditArgs = {
  id: Scalars["ID"];
  fixDeadline: Scalars["DateTime"];
  responsibleChecker?: Maybe<Scalars["ID"]>;
  description: Scalars["String"];
  DocId?: Maybe<Scalars["ID"]>;
  DocNum?: Maybe<Scalars["String"]>;
  DocDate?: Maybe<Scalars["DateTime"]>;
};

export type ViolationSetterDeleteArgs = {
  id: Scalars["ID"];
};

export type ViolationSetterRejectArgs = {
  id: Scalars["ID"];
  punishment: Scalars["String"];
};

export type ViolationSetterUnDeleteArgs = {
  id: Scalars["ID"];
};

export enum ViolationStatus {
  ToFix = "toFix",
  GotDealerResponse = "gotDealerResponse",
  Fixed = "fixed",
  HasComments = "hasComments",
  Deleted = "deleted",
  Reject = "reject",
}

export enum ViolationStatusType {
  Draft = "draft",
  Active = "active",
  Archive = "archive",
  Deleted = "deleted",
}

export type ViolationType = {
  __typename?: "ViolationType";
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  howToFixDescription?: Maybe<Scalars["String"]>;
  category?: Maybe<ViolationTypeCategory>;
  SubdivisionId?: Maybe<Scalars["ID"]>;
  Subdivision?: Maybe<Subdivision>;
  AvgCorrectionDays?: Maybe<Scalars["Int"]>;
  status?: Maybe<ViolationStatusType>;
  deletedAt?: Maybe<Scalars["DateTime"]>;
  introducedAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
};

export enum ViolationTypeCategory {
  Critical = "critical",
  Operational = "operational",
  Minor = "minor",
}

export type ViolationTypeInclude = {
  __typename?: "ViolationTypeInclude";
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  howToFixDescription?: Maybe<Scalars["String"]>;
  category?: Maybe<ViolationTypeCategory>;
  SubdivisionId?: Maybe<Scalars["ID"]>;
  Subdivision?: Maybe<Subdivision>;
  AvgCorrectionDays?: Maybe<Scalars["Int"]>;
  status?: Maybe<ViolationStatusType>;
  deletedAt?: Maybe<Scalars["DateTime"]>;
  introducedAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
};

export type ViolationTypeList = {
  __typename?: "ViolationTypeList";
  items?: Maybe<Array<Maybe<ViolationType>>>;
  total?: Maybe<Scalars["Int"]>;
};

export enum ViolationTypeStatusChange {
  Active = "active",
  Archive = "archive",
}

export type ViolationTypesGetter = {
  __typename?: "ViolationTypesGetter";
  get?: Maybe<ViolationTypeList>;
  delete?: Maybe<Scalars["Boolean"]>;
};

export type ViolationTypesGetterGetArgs = {
  order?: Maybe<SortType>;
  orderBy?: Maybe<OrderByColumnInViolationTypes>;
  status?: Maybe<ViolationStatusType>;
  name?: Maybe<Scalars["String"]>;
  SubdivisionId?: Maybe<Scalars["ID"]>;
  category?: Maybe<ViolationTypeCategory>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

export type ViolationTypesGetterDeleteArgs = {
  id?: Maybe<Scalars["ID"]>;
};

export type ViolationTypesSetter = {
  __typename?: "ViolationTypesSetter";
  create?: Maybe<ViolationType>;
  edit?: Maybe<ViolationType>;
  changeStatus?: Maybe<ViolationType>;
};

export type ViolationTypesSetterCreateArgs = {
  name: Scalars["String"];
  description: Scalars["String"];
  howToFixDescription: Scalars["String"];
  category: ViolationTypeCategory;
  SubdivisionId: Scalars["ID"];
  AvgCorrectionDays: Scalars["Int"];
};

export type ViolationTypesSetterEditArgs = {
  id: Scalars["ID"];
  name: Scalars["String"];
  description: Scalars["String"];
  howToFixDescription: Scalars["String"];
  category: ViolationTypeCategory;
  SubdivisionId: Scalars["ID"];
  AvgCorrectionDays: Scalars["Int"];
};

export type ViolationTypesSetterChangeStatusArgs = {
  id: Scalars["ID"];
  status: ViolationTypeStatusChange;
};

/** Warehouses */
export type Warehouses = {
  __typename?: "Warehouses";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  AreaIndicator?: Maybe<Scalars["ID"]>;
  CombineIndicator?: Maybe<Scalars["ID"]>;
};

/** Warehouses */
export type WarehousesDealerStatuses = {
  __typename?: "WarehousesDealerStatuses";
  DealerId?: Maybe<Scalars["ID"]>;
  Dealer?: Maybe<Dealer>;
  ZD_UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  status?: Maybe<ZdStatusType>;
  /** последнее обновление заявки дилером */
  lastUpdatedAt?: Maybe<Scalars["DateTime"]>;
  /** последнее обновление статуса заявки */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** Получение данных */
export type WarehousesGetter = {
  __typename?: "WarehousesGetter";
  /** Получение значений по дилеру и дате */
  getValues?: Maybe<WarehousesValues>;
  getDealerStatuses?: Maybe<Array<Maybe<WarehousesDealerStatuses>>>;
  getById?: Maybe<WarehousesIndicatorTypes>;
  /** Получить все актуальные на данные момент записи с индикаторами */
  getAll?: Maybe<Array<Maybe<WarehousesIndicatorTypes>>>;
};

/** Получение данных */
export type WarehousesGetterGetValuesArgs = {
  DealerId: Scalars["ID"];
  sortBy?: Maybe<WarehousesSortBy>;
  dateUpTo?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
};

/** Получение данных */
export type WarehousesGetterGetDealerStatusesArgs = {
  UUID?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

/** Получение данных */
export type WarehousesGetterGetByIdArgs = {
  id?: Maybe<Scalars["ID"]>;
};

/** Warehouses */
export type WarehousesIndicatorTypes = {
  __typename?: "WarehousesIndicatorTypes";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  ComplianceIndicator?: Maybe<Indicator>;
  Number?: Maybe<Scalars["String"]>;
  AreaIndicator?: Maybe<Indicator>;
  CombineIndicator?: Maybe<Indicator>;
  isParent?: Maybe<Scalars["Boolean"]>;
};

/** Warehouses */
export type WarehousesItemInZdForUuiDemptyList = {
  __typename?: "WarehousesItemInZdForUUIDemptyList";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Number?: Maybe<Scalars["String"]>;
  Area?: Maybe<Scalars["Float"]>;
  Combine?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
};

/** Warehouses */
export type WarehousesItemInZdForUuiDlist = {
  __typename?: "WarehousesItemInZdForUUIDlist";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Number?: Maybe<Scalars["String"]>;
  Area?: Maybe<Scalars["Float"]>;
  Combine?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
};

/** Warehouses */
export type WarehousesOneValuesItem = {
  __typename?: "WarehousesOneValuesItem";
  id?: Maybe<Scalars["ID"]>;
  /** this is UUID. no need to thank me */
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  /** к какому UUID относится если это список одинковых сущностей. если нулл значит родитель. */
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  Number?: Maybe<Scalars["String"]>;
  Area?: Maybe<Scalars["Float"]>;
  Combine?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  statusUpdatedAt?: Maybe<Scalars["DateTime"]>;
  dealerValuesUpdatedAt?: Maybe<Scalars["DateTime"]>;
  planReportId?: Maybe<Scalars["ID"]>;
  list?: Maybe<Array<Maybe<WarehousesItemInZdForUuiDlist>>>;
  emptyList?: Maybe<Array<Maybe<WarehousesItemInZdForUuiDemptyList>>>;
};

/** Изменение данных */
export type WarehousesSetter = {
  __typename?: "WarehousesSetter";
  /** Создание */
  create?: Maybe<Warehouses>;
  /** Редактирование с сохранением истории */
  change?: Maybe<Warehouses>;
  /** изменить место в сортировке. отрицательные значения и 0 не смещают другие элементы */
  setSort?: Maybe<Scalars["Boolean"]>;
  /** Редактирование текущего состояния (eg исправление опечатки) */
  blindChange?: Maybe<Warehouses>;
  /** Добавить значения или обновить значения сущности */
  addValues?: Maybe<Scalars["Boolean"]>;
  /** Сделать неактуальным (удалить) */
  delete?: Maybe<Scalars["Boolean"]>;
};

/** Изменение данных */
export type WarehousesSetterCreateArgs = {
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  AreaIndicator?: Maybe<Scalars["ID"]>;
  CombineIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type WarehousesSetterChangeArgs = {
  id?: Maybe<Scalars["ID"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  AreaIndicator?: Maybe<Scalars["ID"]>;
  CombineIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type WarehousesSetterSetSortArgs = {
  sort?: Maybe<Scalars["Int"]>;
  UUID: Scalars["String"];
};

/** Изменение данных */
export type WarehousesSetterBlindChangeArgs = {
  id?: Maybe<Scalars["ID"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  DealerId?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  AreaIndicator?: Maybe<Scalars["ID"]>;
  CombineIndicator?: Maybe<Scalars["ID"]>;
};

/** Изменение данных */
export type WarehousesSetterAddValuesArgs = {
  Compliance?: Maybe<Scalars["Int"]>;
  Area?: Maybe<Scalars["Float"]>;
  Combine?: Maybe<Scalars["String"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
};

/** Изменение данных */
export type WarehousesSetterDeleteArgs = {
  id?: Maybe<Scalars["ID"]>;
};

export enum WarehousesSortBy {
  Number = "number",
  Name = "name",
  NameEn = "nameEn",
  Sort = "sort",
  GroupOne = "GroupOne",
  SortGroup = "sortGroup",
}

/** Warehouses */
export type WarehousesValues = {
  __typename?: "WarehousesValues";
  items?: Maybe<Array<Maybe<WarehousesOneValuesItem>>>;
  total?: Maybe<Scalars["Int"]>;
};

/** Получение данных для главного экрана */
export type WorkSpaceGetter = {
  __typename?: "WorkSpaceGetter";
  /** Получить DealerShip */
  getDealerShip?: Maybe<DealerShip>;
  /** Получить Q */
  getQ?: Maybe<QuartilesRatingVersion>;
  /** Получить RnBankRating  */
  getRnBankRating?: Maybe<Array<Maybe<IndicatorValue>>>;
  /** Получить NewVehicle */
  getNewVehicle?: Maybe<Vehicle>;
  /** Получить AfterSales */
  getAfterSales?: Maybe<AfterSales>;
  /** Получить Profitability */
  getProfitability?: Maybe<Profitability>;
  /** Получить Quality */
  getQuality?: Maybe<Quality>;
  /** Получить продажи по АСП (б/у) автомобилям */
  getSalesUsedCar?: Maybe<Array<Maybe<UsedCarSales>>>;
};

/** Получение данных для главного экрана */
export type WorkSpaceGetterGetDealerShipArgs = {
  DealerId?: Maybe<Scalars["ID"]>;
};

/** Получение данных для главного экрана */
export type WorkSpaceGetterGetQArgs = {
  DealerId?: Maybe<Scalars["ID"]>;
  date?: Maybe<Scalars["DateTime"]>;
};

/** Получение данных для главного экрана */
export type WorkSpaceGetterGetRnBankRatingArgs = {
  DealerId?: Maybe<Scalars["ID"]>;
};

/** Получение данных для главного экрана */
export type WorkSpaceGetterGetNewVehicleArgs = {
  DealerId?: Maybe<Scalars["ID"]>;
};

/** Получение данных для главного экрана */
export type WorkSpaceGetterGetAfterSalesArgs = {
  DealerId?: Maybe<Scalars["ID"]>;
};

/** Получение данных для главного экрана */
export type WorkSpaceGetterGetProfitabilityArgs = {
  DealerId?: Maybe<Scalars["ID"]>;
};

/** Получение данных для главного экрана */
export type WorkSpaceGetterGetQualityArgs = {
  DealerId?: Maybe<Scalars["ID"]>;
};

/** Получение данных для главного экрана */
export type WorkSpaceGetterGetSalesUsedCarArgs = {
  DealerId: Scalars["ID"];
};

/** Глобальный рейтинг для рабочего стола */
export type WorkSpaceGlobalRatingVersion = {
  __typename?: "WorkSpaceGlobalRatingVersion";
  id?: Maybe<Scalars["ID"]>;
  quarter?: Maybe<Scalars["Int"]>;
  year?: Maybe<Scalars["Int"]>;
  IndicatorId?: Maybe<Scalars["ID"]>;
  dateBegin?: Maybe<Scalars["DateTime"]>;
  Indicator?: Maybe<Indicator>;
  Lines?: Maybe<Array<Maybe<GlobalRating>>>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  dataForGraph?: Maybe<Array<Maybe<DataForGraph>>>;
};

export type ZdCommonGetter = {
  __typename?: "ZdCommonGetter";
  getResetDates?: Maybe<ResetDateList>;
  getForDealerTablesStatuses?: Maybe<
    Array<Maybe<DealerTablesStatusesListItem>>
  >;
  getZdGlobalInfoForDealers?: Maybe<ZdGlobalInfoForDealerResponse>;
  getZdGlobalInfoForDealer?: Maybe<ZdGlobalInformationForDealerResponse>;
};

export type ZdCommonGetterGetResetDatesArgs = {
  DealerId?: Maybe<Scalars["ID"]>;
  ZD_UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

export type ZdCommonGetterGetForDealerTablesStatusesArgs = {
  DealerId: Scalars["ID"];
};

export type ZdCommonGetterGetZdGlobalInfoForDealersArgs = {
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
  sortType?: Maybe<SortType>;
  sortBy?: Maybe<ZdGlobalInfoForDealerSortBy>;
};

export type ZdCommonGetterGetZdGlobalInfoForDealerArgs = {
  DealerId: Scalars["ID"];
};

export type ZdCommonSetter = {
  __typename?: "ZdCommonSetter";
  deleteResetDate?: Maybe<Scalars["Boolean"]>;
  /** создать ResetDate */
  createResetDate?: Maybe<Scalars["Boolean"]>;
  changeStatusZdGlobalForDealer?: Maybe<Scalars["Boolean"]>;
  /** удалить строчку значений дилеров */
  deleteLineValueDealer?: Maybe<Scalars["Boolean"]>;
};

export type ZdCommonSetterDeleteResetDateArgs = {
  id: Scalars["ID"];
};

export type ZdCommonSetterCreateResetDateArgs = {
  DealerId?: Maybe<Scalars["ID"]>;
  ZD_UUID?: Maybe<Scalars["String"]>;
  tableIndex: ZdTableIndex;
};

export type ZdCommonSetterChangeStatusZdGlobalForDealerArgs = {
  DealerId?: Maybe<Scalars["ID"]>;
  status?: Maybe<ZdGlobalInfoForDealerStatus>;
  isPremises?: Maybe<Scalars["Boolean"]>;
};

export type ZdCommonSetterDeleteLineValueDealerArgs = {
  DealerId?: Maybe<Scalars["ID"]>;
  ZD_UUID?: Maybe<Scalars["String"]>;
  tableIndex: ZdTableIndex;
};

export type ZdGlobalInfoForDealer = {
  __typename?: "ZdGlobalInfoForDealer";
  DealerId?: Maybe<Scalars["ID"]>;
  Dealer?: Maybe<Dealer>;
  lastAcceptDate?: Maybe<Scalars["DateTime"]>;
  lastRejectDate?: Maybe<Scalars["DateTime"]>;
  lastChange?: Maybe<Scalars["DateTime"]>;
  lastCheckedChange?: Maybe<Scalars["DateTime"]>;
  lastPlanReportDate?: Maybe<Scalars["DateTime"]>;
  /** Статус проверки ак */
  status?: Maybe<ZdGlobalInfoForDealerStatus>;
  /** Статус проверки ак */
  statusPremises?: Maybe<ZdGlobalInfoForDealerStatus>;
};

export type ZdGlobalInfoForDealerResponse = {
  __typename?: "ZdGlobalInfoForDealerResponse";
  items?: Maybe<Array<Maybe<ZdGlobalInfoForDealer>>>;
  total?: Maybe<Scalars["Int"]>;
};

export enum ZdGlobalInfoForDealerSortBy {
  DealerName = "DealerName",
  LastAcceptDate = "lastAcceptDate",
  LastRejectDate = "lastRejectDate",
  LastChange = "lastChange",
  LastCheckedChange = "lastCheckedChange",
  LastPlanReportDate = "lastPlanReportDate",
  Status = "status",
}

export enum ZdGlobalInfoForDealerStatus {
  Draft = "draft",
  Processing = "processing",
  Rejected = "rejected",
  Confirmed = "confirmed",
}

export type ZdGlobalInformationForDealerResponse = {
  __typename?: "ZdGlobalInformationForDealerResponse";
  DealerId?: Maybe<Scalars["ID"]>;
  Dealer?: Maybe<Dealer>;
  lastAcceptDate?: Maybe<Scalars["DateTime"]>;
  lastRejectDate?: Maybe<Scalars["DateTime"]>;
  lastChange?: Maybe<Scalars["DateTime"]>;
  lastCheckedChange?: Maybe<Scalars["DateTime"]>;
  lastPlanReportDate?: Maybe<Scalars["DateTime"]>;
  /** Статус проверки ак */
  status?: Maybe<ZdGlobalInfoForDealerStatus>;
  /** Статус проверки ак */
  statusPremises?: Maybe<ZdGlobalInfoForDealerStatus>;
};

export enum ZdGroupType {
  GroupOne = "GroupOne",
  GroupTwo = "GroupTwo",
}

export type ZdNotesDefinitionType = {
  __typename?: "ZdNotesDefinitionType";
  Number?: Maybe<Scalars["String"]>;
  ImageIndicator?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  sort?: Maybe<Scalars["Int"]>;
  isListed?: Maybe<Scalars["Boolean"]>;
  forUUID?: Maybe<Scalars["String"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
};

export type ZdNotesType = {
  __typename?: "ZdNotesType";
  Image?: Maybe<Scalars["String"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
};

export type ZdPersonalDefinitionType = {
  __typename?: "ZdPersonalDefinitionType";
  Number?: Maybe<Scalars["String"]>;
  DocName?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  idIndicator?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  InstanceIdIndicator?: Maybe<Scalars["ID"]>;
  commentIndicator?: Maybe<Scalars["ID"]>;
  planReportIdIndicator?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  sort?: Maybe<Scalars["Int"]>;
  isListed?: Maybe<Scalars["Boolean"]>;
  forUUID?: Maybe<Scalars["String"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
};

export type ZdPersonalType = {
  __typename?: "ZdPersonalType";
  PersonName?: Maybe<Scalars["String"]>;
  Position?: Maybe<Scalars["String"]>;
  PositionStart?: Maybe<Scalars["String"]>;
  StudyCertificateDate?: Maybe<Scalars["String"]>;
  DocName?: Maybe<Scalars["String"]>;
  Image?: Maybe<Scalars["String"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
};

export type ZdPlacePostsDefinitionType = {
  __typename?: "ZdPlacePostsDefinitionType";
  ZD_PlacesId?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  sort?: Maybe<Scalars["Int"]>;
  isListed?: Maybe<Scalars["Boolean"]>;
  forUUID?: Maybe<Scalars["String"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
};

export type ZdPlacePostsType = {
  __typename?: "ZdPlacePostsType";
  Total?: Maybe<Scalars["Float"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
};

export type ZdPlacesDefinitionType = {
  __typename?: "ZdPlacesDefinitionType";
  Number?: Maybe<Scalars["String"]>;
  /** Допустимые значения: service,workshopVR */
  GroupOne?: Maybe<Scalars["String"]>;
  AreaIndicator?: Maybe<Scalars["ID"]>;
  PlacesCombineIndicator?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  sort?: Maybe<Scalars["Int"]>;
  isListed?: Maybe<Scalars["Boolean"]>;
  forUUID?: Maybe<Scalars["String"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
};

export type ZdPlacesType = {
  __typename?: "ZdPlacesType";
  Area?: Maybe<Scalars["Float"]>;
  PlacesCombine?: Maybe<Scalars["String"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  GroupOne?: Maybe<ZdPlacesTypeGroupOneEnum>;
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
};

export enum ZdPlacesTypeGroupOneEnum {
  Service = "service",
  WorkshopVr = "workshopVR",
}

/** получить отчёты по ZD */
export type ZdReportsGetter = {
  __typename?: "ZdReportsGetter";
  ServiceById?: Maybe<ReportFile>;
  PlaceById?: Maybe<ReportFile>;
  TradePremisesById?: Maybe<ReportFile>;
  PlaceByLocation?: Maybe<ReportFile>;
  WarehouseById?: Maybe<ReportFile>;
  RequiredToolsById?: Maybe<ReportFile>;
  RequiredToolsByIds?: Maybe<ReportFile>;
  Posts?: Maybe<ReportFile>;
  PostByPlaceIds?: Maybe<ReportFile>;
  ToolsById?: Maybe<ReportFile>;
  ToolsInsuranceById?: Maybe<ReportFile>;
  ToolsInsuranceByPlace?: Maybe<ReportFile>;
  ToolsMetrologicalById?: Maybe<ReportFile>;
  Personal?: Maybe<ReportFile>;
  PlanReport?: Maybe<ReportFile>;
  ZdStatus?: Maybe<ReportFile>;
  ZdStatusJson?: Maybe<Array<Maybe<Array<Maybe<Scalars["String"]>>>>>;
  ZdDealersActual?: Maybe<ReportFile>;
};

/** получить отчёты по ZD */
export type ZdReportsGetterServiceByIdArgs = {
  UUIDs?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Name?: Maybe<Scalars["String"]>;
  Type: ReportType;
  lang: LangType;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Russia?: Maybe<Scalars["Boolean"]>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** получить отчёты по ZD */
export type ZdReportsGetterPlaceByIdArgs = {
  UUIDs?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Name?: Maybe<Scalars["String"]>;
  Type: ReportType;
  lang: LangType;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Russia?: Maybe<Scalars["Boolean"]>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** получить отчёты по ZD */
export type ZdReportsGetterTradePremisesByIdArgs = {
  UUIDs?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Name?: Maybe<Scalars["String"]>;
  Type: ReportType;
  lang: LangType;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Russia?: Maybe<Scalars["Boolean"]>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** получить отчёты по ZD */
export type ZdReportsGetterPlaceByLocationArgs = {
  UUIDs?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Name?: Maybe<Scalars["String"]>;
  Type: ReportType;
  lang: LangType;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Russia?: Maybe<Scalars["Boolean"]>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** получить отчёты по ZD */
export type ZdReportsGetterWarehouseByIdArgs = {
  UUIDs?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Name?: Maybe<Scalars["String"]>;
  Type: ReportType;
  lang: LangType;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Russia?: Maybe<Scalars["Boolean"]>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** получить отчёты по ZD */
export type ZdReportsGetterRequiredToolsByIdArgs = {
  UUIDs?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Name?: Maybe<Scalars["String"]>;
  Type: ReportType;
  lang: LangType;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Russia?: Maybe<Scalars["Boolean"]>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** получить отчёты по ZD */
export type ZdReportsGetterRequiredToolsByIdsArgs = {
  UUIDs?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Name?: Maybe<Scalars["String"]>;
  Type: ReportType;
  lang: LangType;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Russia?: Maybe<Scalars["Boolean"]>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** получить отчёты по ZD */
export type ZdReportsGetterPostsArgs = {
  UUIDs?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Name?: Maybe<Scalars["String"]>;
  Type: ReportType;
  lang: LangType;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Russia?: Maybe<Scalars["Boolean"]>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** получить отчёты по ZD */
export type ZdReportsGetterPostByPlaceIdsArgs = {
  UUIDs?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Name?: Maybe<Scalars["String"]>;
  Type: ReportType;
  lang: LangType;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Russia?: Maybe<Scalars["Boolean"]>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** получить отчёты по ZD */
export type ZdReportsGetterToolsByIdArgs = {
  UUIDs?: Maybe<Array<Maybe<Scalars["String"]>>>;
  groupOne?: Maybe<Scalars["String"]>;
  groupTwo?: Maybe<Scalars["String"]>;
  Type: ReportType;
  lang: LangType;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Russia?: Maybe<Scalars["Boolean"]>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** получить отчёты по ZD */
export type ZdReportsGetterToolsInsuranceByIdArgs = {
  UUIDs?: Maybe<Array<Maybe<Scalars["String"]>>>;
  groupOne?: Maybe<Scalars["String"]>;
  groupTwo?: Maybe<Scalars["String"]>;
  Type: ReportType;
  lang: LangType;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Russia?: Maybe<Scalars["Boolean"]>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** получить отчёты по ZD */
export type ZdReportsGetterToolsInsuranceByPlaceArgs = {
  UUIDs?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Name?: Maybe<Scalars["String"]>;
  Type: ReportType;
  lang: LangType;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Russia?: Maybe<Scalars["Boolean"]>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** получить отчёты по ZD */
export type ZdReportsGetterToolsMetrologicalByIdArgs = {
  UUIDs?: Maybe<Array<Maybe<Scalars["String"]>>>;
  Name?: Maybe<Scalars["String"]>;
  Type: ReportType;
  lang: LangType;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Russia?: Maybe<Scalars["Boolean"]>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** получить отчёты по ZD */
export type ZdReportsGetterPersonalArgs = {
  UUIDs?: Maybe<Array<Maybe<Scalars["String"]>>>;
  groupOne?: Maybe<Scalars["String"]>;
  Type: ReportType;
  lang: LangType;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Russia?: Maybe<Scalars["Boolean"]>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>>>;
};

/** получить отчёты по ZD */
export type ZdReportsGetterPlanReportArgs = {
  DealerId: Scalars["ID"];
  Type?: Maybe<PlanReportTypeDoc>;
  isTemplate?: Maybe<Scalars["Boolean"]>;
};

/** получить отчёты по ZD */
export type ZdReportsGetterZdStatusArgs = {
  Type: ReportType;
};

export type ZdRequiredToolsDefinitionType = {
  __typename?: "ZdRequiredToolsDefinitionType";
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  ModelIndicator?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
  CheckedDateIndicator?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  sort?: Maybe<Scalars["Int"]>;
  isListed?: Maybe<Scalars["Boolean"]>;
  forUUID?: Maybe<Scalars["String"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
};

export type ZdRequiredToolsType = {
  __typename?: "ZdRequiredToolsType";
  Model?: Maybe<Scalars["String"]>;
  Total?: Maybe<Scalars["Float"]>;
  CheckedDate?: Maybe<Scalars["String"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
};

export type ZdServicesDefinitionType = {
  __typename?: "ZdServicesDefinitionType";
  Code?: Maybe<Scalars["String"]>;
  FactIndicator?: Maybe<Scalars["ID"]>;
  CertificationDateIndicator?: Maybe<Scalars["ID"]>;
  FactContractIndicator?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  sort?: Maybe<Scalars["Int"]>;
  isListed?: Maybe<Scalars["Boolean"]>;
  forUUID?: Maybe<Scalars["String"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
};

export type ZdServicesType = {
  __typename?: "ZdServicesType";
  CertificationDate?: Maybe<Scalars["String"]>;
  Fact?: Maybe<Scalars["Int"]>;
  FactContract?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
};

export enum ZdStatusType {
  Draft = "draft",
  Processing = "processing",
  Revision = "revision",
  Confirmed = "confirmed",
}

export enum ZdTableIndex {
  Services = "Services",
  Places = "Places",
  PlacePosts = "PlacePosts",
  Warehouses = "Warehouses",
  Tools = "Tools",
  RequiredTools = "RequiredTools",
  Personal = "Personal",
  ToolsInsurance = "ToolsInsurance",
  ToolsMetrological = "ToolsMetrological",
  Notes = "Notes",
  TradePremises = "TradePremises",
}

export type ZdToolsDefinitionType = {
  __typename?: "ZdToolsDefinitionType";
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
  ModelIndicator?: Maybe<Scalars["ID"]>;
  CountryIndicator?: Maybe<Scalars["ID"]>;
  YearIndicator?: Maybe<Scalars["ID"]>;
  NoteIndicator?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  sort?: Maybe<Scalars["Int"]>;
  isListed?: Maybe<Scalars["Boolean"]>;
  forUUID?: Maybe<Scalars["String"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
};

export type ZdToolsInsuranceDefinitionType = {
  __typename?: "ZdToolsInsuranceDefinitionType";
  Number?: Maybe<Scalars["String"]>;
  NumberList?: Maybe<Scalars["String"]>;
  NumberDetail?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  sort?: Maybe<Scalars["Int"]>;
  isListed?: Maybe<Scalars["Boolean"]>;
  forUUID?: Maybe<Scalars["String"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
};

export type ZdToolsInsuranceType = {
  __typename?: "ZdToolsInsuranceType";
  Total?: Maybe<Scalars["Float"]>;
  Standard?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
};

export type ZdToolsMetrologicalDefinitionType = {
  __typename?: "ZdToolsMetrologicalDefinitionType";
  Number?: Maybe<Scalars["String"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  sort?: Maybe<Scalars["Int"]>;
  isListed?: Maybe<Scalars["Boolean"]>;
  forUUID?: Maybe<Scalars["String"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
};

export type ZdToolsMetrologicalType = {
  __typename?: "ZdToolsMetrologicalType";
  Total?: Maybe<Scalars["Float"]>;
  Standard?: Maybe<Scalars["Int"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
};

export type ZdToolsType = {
  __typename?: "ZdToolsType";
  Total?: Maybe<Scalars["Float"]>;
  Model?: Maybe<Scalars["String"]>;
  Country?: Maybe<Scalars["String"]>;
  Year?: Maybe<Scalars["Int"]>;
  Note?: Maybe<Scalars["String"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
};

export type ZdTradePremisesDefinitionType = {
  __typename?: "ZdTradePremisesDefinitionType";
  Number?: Maybe<Scalars["String"]>;
  /** Доступны значения: showroom,issuanceZones,storageSites */
  GroupOne?: Maybe<Scalars["String"]>;
  AreaIndicator?: Maybe<Scalars["ID"]>;
  CombineIndicator?: Maybe<Scalars["ID"]>;
  AddressIndicator?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  sort?: Maybe<Scalars["Int"]>;
  isListed?: Maybe<Scalars["Boolean"]>;
  forUUID?: Maybe<Scalars["String"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
};

export type ZdTradePremisesType = {
  __typename?: "ZdTradePremisesType";
  Area?: Maybe<Scalars["Float"]>;
  PlacesCombine?: Maybe<Scalars["String"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  GroupOne?: Maybe<ZdTradePremisesTypeGroupOneEnum>;
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
};

export enum ZdTradePremisesTypeGroupOneEnum {
  Showroom = "showroom",
  IssuanceZones = "issuanceZones",
  StorageSites = "storageSites",
}

export type ZdWarehousesDefinitionType = {
  __typename?: "ZdWarehousesDefinitionType";
  Number?: Maybe<Scalars["String"]>;
  AreaIndicator?: Maybe<Scalars["ID"]>;
  CombineIndicator?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  sort?: Maybe<Scalars["Int"]>;
  isListed?: Maybe<Scalars["Boolean"]>;
  forUUID?: Maybe<Scalars["String"]>;
  ActualTo?: Maybe<Scalars["DateTime"]>;
  ActualFrom?: Maybe<Scalars["DateTime"]>;
};

export type ZdWarehousesType = {
  __typename?: "ZdWarehousesType";
  Area?: Maybe<Scalars["Float"]>;
  Combine?: Maybe<Scalars["String"]>;
  Compliance?: Maybe<Scalars["Int"]>;
  UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
};

/** данные о удалении */
export type AboutDelete = {
  __typename?: "aboutDelete";
  FileId?: Maybe<Scalars["ID"]>;
  FileName?: Maybe<Scalars["String"]>;
  catalog?: Maybe<Scalars["String"]>;
  UserId?: Maybe<Scalars["ID"]>;
  date?: Maybe<Scalars["DateTime"]>;
};

/** данные о загрузке */
export type AboutUpload = {
  __typename?: "aboutUpload";
  mimeType?: Maybe<Scalars["String"]>;
  UserId?: Maybe<Scalars["ID"]>;
  fileName?: Maybe<Scalars["String"]>;
  uploadDate?: Maybe<Scalars["DateTime"]>;
  catalog?: Maybe<Scalars["String"]>;
  Dealer?: Maybe<DealerData>;
};

/** Сертифицировано */
export type Certificated = {
  __typename?: "certificated";
  people?: Maybe<Scalars["Float"]>;
  percent?: Maybe<Scalars["Float"]>;
};

/** Сертификация */
export type Certification = {
  __typename?: "certification";
  required?: Maybe<Required>;
  certificated?: Maybe<Certificated>;
};

export type ChangeStatus = {
  __typename?: "changeStatus";
  sendCheck: Ok;
  markVerified: Ok;
  markReject: Ok;
};

export type ChangeStatusSendCheckArgs = {
  employeeId: Scalars["ID"];
};

export type ChangeStatusMarkVerifiedArgs = {
  positionId: Scalars["ID"];
};

export type ChangeStatusMarkRejectArgs = {
  positionId: Scalars["ID"];
  rejectReason?: Maybe<Scalars["String"]>;
};

/** Строки для отчета возвращение автомобилей на ТО (свой) по месяцу контроля */
export type CityForAgoByMonth = {
  __typename?: "cityForAGOByMonth";
  city?: Maybe<Scalars["String"]>;
  cityEn?: Maybe<Scalars["String"]>;
  subjectEn?: Maybe<Scalars["String"]>;
  subject?: Maybe<Scalars["String"]>;
  FO?: Maybe<Scalars["String"]>;
  counts?: Maybe<Scalars["String"]>;
  GO1?: Maybe<ToForServiceByMonth>;
  GO2?: Maybe<ToForServiceByMonth>;
  GO3?: Maybe<ToForServiceByMonth>;
};

/** Строки для отчета для отчета Машинозаезды в дилерам */
export type CityForServiceByDealer = {
  __typename?: "cityForServiceByDealer";
  city?: Maybe<Scalars["String"]>;
  cityEn?: Maybe<Scalars["String"]>;
  subjectEn?: Maybe<Scalars["String"]>;
  subject?: Maybe<Scalars["String"]>;
  FO?: Maybe<Scalars["String"]>;
  periods?: Maybe<Array<Maybe<ToPeriod>>>;
};

/** Строки для отчета возвращение автомобилей на ТО (свой) по месяцу контроля */
export type CityForServiceByMonth = {
  __typename?: "cityForServiceByMonth";
  city?: Maybe<Scalars["String"]>;
  cityEn?: Maybe<Scalars["String"]>;
  subjectEn?: Maybe<Scalars["String"]>;
  subject?: Maybe<Scalars["String"]>;
  FO?: Maybe<Scalars["String"]>;
  counts?: Maybe<Scalars["String"]>;
  family?: Maybe<Scalars["String"]>;
  TO0?: Maybe<ToForServiceByMonth>;
  TO1?: Maybe<ToForServiceByMonth>;
  TO2?: Maybe<ToForServiceByMonth>;
  TO3?: Maybe<ToForServiceByMonth>;
  TO4?: Maybe<ToForServiceByMonth>;
  TO5?: Maybe<ToForServiceByMonth>;
  TO6?: Maybe<ToForServiceByMonth>;
  TO7?: Maybe<ToForServiceByMonth>;
  TO8?: Maybe<ToForServiceByMonth>;
};

/** Строки для отчета возвращение автомобилей на ТО (свой) по месяцу контроля */
export type CountryForAgoByMonth = {
  __typename?: "countryForAGOByMonth";
  country?: Maybe<Scalars["String"]>;
  countryEn?: Maybe<Scalars["String"]>;
  counts?: Maybe<Scalars["String"]>;
  GO1?: Maybe<ToForServiceByMonth>;
  GO2?: Maybe<ToForServiceByMonth>;
  GO3?: Maybe<ToForServiceByMonth>;
};

/** Строки для отчета Машинозаезды по дилерам */
export type CountryForServiceByDealer = {
  __typename?: "countryForServiceByDealer";
  country?: Maybe<Scalars["String"]>;
  countryEn?: Maybe<Scalars["String"]>;
  periods?: Maybe<Array<Maybe<ToPeriod>>>;
};

/** Строки для отчета возвращение автомобилей на ТО (свой) по месяцу контроля */
export type CountryForServiceByMonth = {
  __typename?: "countryForServiceByMonth";
  country?: Maybe<Scalars["String"]>;
  countryEn?: Maybe<Scalars["String"]>;
  counts?: Maybe<Scalars["String"]>;
  family?: Maybe<Scalars["String"]>;
  TO0?: Maybe<ToForServiceByMonth>;
  TO1?: Maybe<ToForServiceByMonth>;
  TO2?: Maybe<ToForServiceByMonth>;
  TO3?: Maybe<ToForServiceByMonth>;
  TO4?: Maybe<ToForServiceByMonth>;
  TO5?: Maybe<ToForServiceByMonth>;
  TO6?: Maybe<ToForServiceByMonth>;
  TO7?: Maybe<ToForServiceByMonth>;
  TO8?: Maybe<ToForServiceByMonth>;
};

export type CreateCurriculumPositionStudyProgramsLevels = {
  id: Scalars["ID"];
  /** delete - В случае если пользователь удаляет удаляет все курсы из уровня. edit - Если изменяется состав курсов, но не удаляются все. create - Если создается совершенно новая учебная программа. */
  action?: Maybe<PositionProgramsActionEnum>;
  courses?: Maybe<
    Array<Maybe<CreateCurriculumPositionStudyProgramsLevelsCourses>>
  >;
};

export type CreateCurriculumPositionStudyProgramsLevelsCourses = {
  id: Scalars["ID"];
  status: CurriculumPositionsStudyProgramsStatus;
  dateActiveStatus?: Maybe<Scalars["DateTime"]>;
  dateInactiveStatus?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** Данные для создания рейтинга паутинки Версия рейтинга */
export type DataForGraph = {
  __typename?: "dataForGraph";
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  sort?: Maybe<Scalars["Int"]>;
  round?: Maybe<Scalars["Int"]>;
  yearPercent?: Maybe<Scalars["ID"]>;
  IndicatorYearPercent?: Maybe<Indicator>;
};

/** столбцы UVIN: уникальные обращения в сервис */
export type DataUniqueService = {
  __typename?: "dataUniqueService";
  year?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
};

/** Строки для отчета SRR3 по дилерам LADA для расчета премий */
export type DealerByCarByDealer = {
  __typename?: "dealerByCarByDealer";
  id?: Maybe<Scalars["ID"]>;
  code?: Maybe<Scalars["String"]>;
  INN?: Maybe<Scalars["String"]>;
  ent_id?: Maybe<Scalars["String"]>;
  birCode?: Maybe<Scalars["String"]>;
  entfSuccessorCode?: Maybe<Scalars["String"]>;
  entfSuccessorNo?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  FO?: Maybe<Scalars["String"]>;
  DealerName?: Maybe<Scalars["String"]>;
  subject?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  family?: Maybe<Scalars["String"]>;
  periods?: Maybe<Array<Maybe<PeriodByCar>>>;
};

/** Строки для отчета SRR3 по дилерам LADA расшифровка по VIN */
export type DealerByCarByVin = {
  __typename?: "dealerByCarByVIN";
  id?: Maybe<Scalars["ID"]>;
  DealerName?: Maybe<Scalars["String"]>;
  ent_id?: Maybe<Scalars["String"]>;
  INN?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  dateSales?: Maybe<Scalars["DateTime"]>;
  VIN?: Maybe<Scalars["String"]>;
  eqFamilyCode?: Maybe<Scalars["String"]>;
  eqNumber?: Maybe<Scalars["String"]>;
  eqVariant?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  model?: Maybe<Scalars["String"]>;
  family?: Maybe<Scalars["String"]>;
  TO1?: Maybe<ToForVin>;
  TO2?: Maybe<ToForVin>;
  TO3?: Maybe<ToForVin>;
  TO4?: Maybe<ToForVin>;
  TO5?: Maybe<ToForVin>;
};

/** Строки для отчета возвращение автомобилей на ТО (свой) по месяцу контроля */
export type DealerForAgoByMonth = {
  __typename?: "dealerForAGOByMonth";
  id?: Maybe<Scalars["ID"]>;
  code?: Maybe<Scalars["String"]>;
  INN?: Maybe<Scalars["String"]>;
  ent_id?: Maybe<Scalars["String"]>;
  birCode?: Maybe<Scalars["String"]>;
  entfSuccessorCode?: Maybe<Scalars["String"]>;
  entfSuccessorNo?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  FO?: Maybe<Scalars["String"]>;
  DealerName?: Maybe<Scalars["String"]>;
  subject?: Maybe<Scalars["String"]>;
  counts?: Maybe<Scalars["String"]>;
  GO1?: Maybe<ToForServiceByMonth>;
  GO2?: Maybe<ToForServiceByMonth>;
  GO3?: Maybe<ToForServiceByMonth>;
};

/** Строки для отчета SRR3 по дилерам LADA для расчета премий */
export type DealerForPaymentsByDealer = {
  __typename?: "dealerForPaymentsByDealer";
  id?: Maybe<Scalars["ID"]>;
  code?: Maybe<Scalars["String"]>;
  INN?: Maybe<Scalars["String"]>;
  ent_id?: Maybe<Scalars["String"]>;
  birCode?: Maybe<Scalars["String"]>;
  entfSuccessorCode?: Maybe<Scalars["String"]>;
  entfSuccessorNo?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  FO?: Maybe<Scalars["String"]>;
  DealerName?: Maybe<Scalars["String"]>;
  subject?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  periods?: Maybe<Array<Maybe<PeriodForPayments>>>;
};

/** Строки для отчета Машинозаезды по дилерам */
export type DealerForServiceByDealer = {
  __typename?: "dealerForServiceByDealer";
  id?: Maybe<Scalars["ID"]>;
  code?: Maybe<Scalars["String"]>;
  INN?: Maybe<Scalars["String"]>;
  ent_id?: Maybe<Scalars["String"]>;
  birCode?: Maybe<Scalars["String"]>;
  entfSuccessorCode?: Maybe<Scalars["String"]>;
  entfSuccessorNo?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  FO?: Maybe<Scalars["String"]>;
  DealerName?: Maybe<Scalars["String"]>;
  subject?: Maybe<Scalars["String"]>;
  periods?: Maybe<Array<Maybe<ToPeriod>>>;
};

/** Строки для отчета возвращение автомобилей на ТО (свой) по месяцу контроля */
export type DealerForServiceByMonth = {
  __typename?: "dealerForServiceByMonth";
  id?: Maybe<Scalars["ID"]>;
  code?: Maybe<Scalars["String"]>;
  ent_id?: Maybe<Scalars["String"]>;
  INN?: Maybe<Scalars["String"]>;
  birCode?: Maybe<Scalars["String"]>;
  entfSuccessorCode?: Maybe<Scalars["String"]>;
  entfSuccessorNo?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  FO?: Maybe<Scalars["String"]>;
  DealerName?: Maybe<Scalars["String"]>;
  subject?: Maybe<Scalars["String"]>;
  counts?: Maybe<Scalars["String"]>;
  family?: Maybe<Scalars["String"]>;
  TO0?: Maybe<ToForServiceByMonth>;
  TO1?: Maybe<ToForServiceByMonth>;
  TO2?: Maybe<ToForServiceByMonth>;
  TO3?: Maybe<ToForServiceByMonth>;
  TO4?: Maybe<ToForServiceByMonth>;
  TO5?: Maybe<ToForServiceByMonth>;
  TO6?: Maybe<ToForServiceByMonth>;
  TO7?: Maybe<ToForServiceByMonth>;
  TO8?: Maybe<ToForServiceByMonth>;
};

/** Строки для отчета Машинозаезды в динамике */
export type DealerForServiceDynamics = {
  __typename?: "dealerForServiceDynamics";
  period?: Maybe<Scalars["String"]>;
  TO0?: Maybe<Scalars["Int"]>;
  TO1?: Maybe<Scalars["Int"]>;
  TO2?: Maybe<Scalars["Int"]>;
  TO3?: Maybe<Scalars["Int"]>;
  TO4?: Maybe<Scalars["Int"]>;
  TO5?: Maybe<Scalars["Int"]>;
  TO6?: Maybe<Scalars["Int"]>;
  TO7?: Maybe<Scalars["Int"]>;
  TO8?: Maybe<Scalars["Int"]>;
  AllTO?: Maybe<Scalars["Int"]>;
  Warranty?: Maybe<Scalars["Int"]>;
  /** Предписание */
  writ?: Maybe<Scalars["Int"]>;
};

/** семейство автомобиля */
export type FamilyCar = {
  __typename?: "familyCar";
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["Int"]>;
  actual?: Maybe<Scalars["Int"]>;
};

export enum FilterExistenceType {
  Exist = "exist",
  NotExist = "notExist",
}

export type GetAllViolationResponse = {
  __typename?: "getAllViolationResponse";
  total?: Maybe<Scalars["Int"]>;
  items?: Maybe<Array<Maybe<ViolationInclude>>>;
};

/** Список */
export type GetAllowedMonthsForDealerList = {
  __typename?: "getAllowedMonthsForDealerList";
  items: Array<Maybe<QuartilesAvailable>>;
  total: Scalars["Int"];
};

/** Список */
export type GetArchiveDealersInheritanceList = {
  __typename?: "getArchiveDealersInheritanceList";
  items: Array<Maybe<DealerWithPeriods>>;
  total: Scalars["Int"];
};

/** Список */
export type GetArchivePeriodsList = {
  __typename?: "getArchivePeriodsList";
  items: Array<Maybe<ArchivePeriod>>;
  total: Scalars["Int"];
};

export type GetAverageReceiptAkc = {
  __typename?: "getAverageReceiptAKC";
  dealer?: Maybe<Dealer>;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Region?: Maybe<Scalars["String"]>;
  Country?: Maybe<Scalars["String"]>;
  carsTotal?: Maybe<Scalars["Int"]>;
  moneyTotal?: Maybe<Scalars["Float"]>;
  averageReceipt?: Maybe<Scalars["Float"]>;
};

export type GetAverageReceiptTo = {
  __typename?: "getAverageReceiptTO";
  dealer?: Maybe<Dealer>;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Region?: Maybe<Scalars["String"]>;
  Country?: Maybe<Scalars["String"]>;
  carsTotal?: Maybe<Scalars["Int"]>;
  moneyTotal?: Maybe<Scalars["Float"]>;
  averageReceipt?: Maybe<Scalars["Float"]>;
};

export type GetCommentsResponse = {
  __typename?: "getCommentsResponse";
  total?: Maybe<Scalars["Int"]>;
  items?: Maybe<Array<Maybe<ViolationComment>>>;
};

export type GetCompositionPositionPrograms = {
  __typename?: "getCompositionPositionPrograms";
  Positions?: Maybe<Array<Maybe<Position>>>;
  levels?: Maybe<Array<Maybe<GetCompositionPositionProgramsLevels>>>;
};

export type GetCompositionPositionProgramsLevels = {
  __typename?: "getCompositionPositionProgramsLevels";
  id?: Maybe<Scalars["ID"]>;
  sequenceNumber?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
  status?: Maybe<CurriculumLevelStatus>;
  courses?: Maybe<Array<Maybe<GetCompositionPositionProgramsLevelsCourses>>>;
};

export type GetCompositionPositionProgramsLevelsCourses = {
  __typename?: "getCompositionPositionProgramsLevelsCourses";
  id?: Maybe<Scalars["ID"]>;
  code?: Maybe<Scalars["String"]>;
  codeIS?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  status?: Maybe<CurriculumPositionsStudyProgramsStatus>;
  certificateValidityPeriod?: Maybe<Scalars["Int"]>;
  dateActiveStatus?: Maybe<Scalars["DateTime"]>;
  dateInactiveStatus?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

export type GetContracts = {
  __typename?: "getContracts";
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
};

export type GetCourseCurriculumByParams = {
  __typename?: "getCourseCurriculumByParams";
  items?: Maybe<Array<Maybe<CourseCurriculum>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type GetDealerReportsList = {
  __typename?: "getDealerReportsList";
  items?: Maybe<Array<Maybe<DealerReport>>>;
  total?: Maybe<Scalars["Int"]>;
};

export enum GetDealerReportsSort {
  FirstCheckingAt = "firstCheckingAt",
  LastCheckingAt = "lastCheckingAt",
  FirstFixingAt = "firstFixingAt",
  LastFixingAt = "lastFixingAt",
  VerifiedAt = "verifiedAt",
  LastValueChangeAt = "lastValueChangeAt",
  Status = "status",
  UpdatedAt = "updatedAt",
  DealerName = "DealerName",
  PeriodLastDate = "PeriodLastDate",
  PeriodReportDate = "PeriodReportDate",
}

export type GetDirections = {
  __typename?: "getDirections";
  items?: Maybe<Array<Maybe<PositionDirections>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type GetEmployeeList = {
  __typename?: "getEmployeeList";
  items?: Maybe<Array<Maybe<EmployeeWithPosition>>>;
  total?: Maybe<Scalars["Int"]>;
};

export enum GetFileDealerReportRepType {
  Both = "both",
  First = "first",
  Second = "second",
}

/** Список */
export type GetGeoPlacesList = {
  __typename?: "getGeoPlacesList";
  items: Array<Maybe<GeoPlace>>;
  total: Scalars["Int"];
};

export type GetInformationSystems = {
  __typename?: "getInformationSystems";
  items?: Maybe<Array<Maybe<InformationSystem>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type GetListCurriculumCatalog = {
  __typename?: "getListCurriculumCatalog";
  items?: Maybe<Array<Maybe<CatalogCurriculum>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type GetListGroupCurriculum = {
  __typename?: "getListGroupCurriculum";
  items?: Maybe<Array<Maybe<GroupCurriculum>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type GetListLevelCurriculum = {
  __typename?: "getListLevelCurriculum";
  items?: Maybe<Array<Maybe<LevelCurriculum>>>;
  total?: Maybe<Scalars["Int"]>;
};

/** Список */
export type GetPeriodsListList = {
  __typename?: "getPeriodsListList";
  items: Array<Maybe<ReportPeriod>>;
  total: Scalars["Int"];
};

export type GetPersonalInformation = {
  __typename?: "getPersonalInformation";
  items?: Maybe<Array<Maybe<PersonalInformation>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type GetPlanReportRowsReturn = {
  __typename?: "getPlanReportRowsReturn";
  items?: Maybe<Array<Maybe<PlanReportRow>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type GetPositionIsTheEducationPrograms = {
  __typename?: "getPositionIsTheEducationPrograms";
  items?: Maybe<Array<Maybe<PositionIsThePrograms>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type GetPositionListNew = {
  __typename?: "getPositionListNew";
  items?: Maybe<Array<Maybe<Position>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type GetPositionsInNotEducationPrograms = {
  __typename?: "getPositionsInNotEducationPrograms";
  items?: Maybe<Array<Maybe<Position>>>;
  total?: Maybe<Scalars["Int"]>;
};

export enum GetPositionsOrderBy {
  InstanceId = "InstanceId",
  Code = "code",
  Name = "name",
  Status = "status",
  DirectionId = "DirectionId",
  CreatedAt = "createdAt",
  UpdatedAt = "updatedAt",
  ActualFrom = "ActualFrom",
  ActualTo = "ActualTo",
  ExpectationId = "ExpectationId",
  RequiredEmail = "RequiredEmail",
  JobDescriptionIsRequired = "jobDescriptionIsRequired",
  Recid = "recid",
  ShowInZd = "showInZd",
}

export type GetReportsStatistics = {
  __typename?: "getReportsStatistics";
  draft?: Maybe<Scalars["Int"]>;
  checking?: Maybe<Scalars["Int"]>;
  verified?: Maybe<Scalars["Int"]>;
  fixing?: Maybe<Scalars["Int"]>;
};

export type GetTargetDealerByMonth = {
  __typename?: "getTargetDealerByMonth";
  items?: Maybe<Array<Maybe<DealerTargetOut>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type GetTemplateConsentsDataProcessing = {
  __typename?: "getTemplateConsentsDataProcessing";
  items?: Maybe<Array<Maybe<PositionConsents>>>;
  total?: Maybe<Scalars["Int"]>;
};

/** Список */
export type GetTemplatesList = {
  __typename?: "getTemplatesList";
  items: Array<Maybe<DealerContractTemplate>>;
  total: Scalars["Int"];
};

/** Строки для отчета Приглашение клиента на ТО */
export type InviteClientToService = {
  __typename?: "inviteClientToService";
  id?: Maybe<Scalars["ID"]>;
  car?: Maybe<Scalars["String"]>;
  fio?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  agree?: Maybe<Scalars["Boolean"]>;
  dateSales?: Maybe<Scalars["DateTime"]>;
  vin?: Maybe<Scalars["String"]>;
  maxDateVisit?: Maybe<Scalars["DateTime"]>;
  avgRun?: Maybe<Scalars["Float"]>;
  lastComment?: Maybe<Scalars["String"]>;
  prevTODealer?: Maybe<Scalars["String"]>;
  prevToText?: Maybe<Scalars["String"]>;
  nextToDate?: Maybe<Scalars["String"]>;
};

/** Количество камер IVIDEON у дилера по тарифу */
export type IvideonCameraCountByTariffType = {
  __typename?: "ivideonCameraCountByTariffType";
  tariffName: Scalars["String"];
  count: Scalars["Int"];
};

/** Тарифы для камер в IVIDEON */
export type IvideonCameraTariffType = {
  __typename?: "ivideonCameraTariffType";
  id: Scalars["ID"];
  name: Scalars["String"];
  price: Scalars["Float"];
};

/** Добавление дилера к пользователю */
export type LogAddDealerToUser = {
  __typename?: "logAddDealerToUser";
  nextValue?: Maybe<DealerAndUser>;
  prevValue?: Maybe<DealerAndUser>;
  event?: Maybe<Scalars["String"]>;
};

/** Значения по умолчанию */
export type LogDefault = {
  __typename?: "logDefault";
  nextValue?: Maybe<Scalars["JSON"]>;
  prevValue?: Maybe<Scalars["JSON"]>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForAccountingPeriod = {
  __typename?: "logForAccountingPeriod";
  nextValue?: Maybe<ReportPeriod>;
  prevValue?: Maybe<ReportPeriod>;
  event?: Maybe<Scalars["String"]>;
};

/** Создание группы для отчетов */
export type LogForAddIndicatorGroup = {
  __typename?: "logForAddIndicatorGroup";
  nextValue?: Maybe<IndicatorGroup>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForAddIndicatorReport = {
  __typename?: "logForAddIndicatorReport";
  nextValue?: Maybe<IndicatorReport>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForAddIndicatorToReport = {
  __typename?: "logForAddIndicatorToReport";
  prevValue?: Maybe<Array<Maybe<IndicatorAndReport>>>;
  nextValue?: Maybe<Array<Maybe<IndicatorAndReport>>>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForAddPositionGroupEducationProgram = {
  __typename?: "logForAddPositionGroupEducationProgram";
  nextValue?: Maybe<CurriculumStudyProgramGroupPosition>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForChangeIndicatorReport = {
  __typename?: "logForChangeIndicatorReport";
  nextValue?: Maybe<IndicatorReport>;
  prevValue?: Maybe<IndicatorReport>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForCreateAnnouncement = {
  __typename?: "logForCreateAnnouncement";
  nextValue?: Maybe<AnnouncementLog>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForCreateCamera = {
  __typename?: "logForCreateCamera";
  nextValue?: Maybe<CameraLog>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForCreateCameraCheck = {
  __typename?: "logForCreateCameraCheck";
  nextValue?: Maybe<CameraCheckLog>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForCreateCameraZone = {
  __typename?: "logForCreateCameraZone";
  nextValue?: Maybe<CameraZoneLog>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForCreateDocument = {
  __typename?: "logForCreateDocument";
  nextValue?: Maybe<DocumentLog>;
  prevValue?: Maybe<DocumentLog>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForCreateSection = {
  __typename?: "logForCreateSection";
  nextValue?: Maybe<SectionLog>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForCreatedEducationCatalog = {
  __typename?: "logForCreatedEducationCatalog";
  nextValue?: Maybe<CatalogCurriculum>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForCreatedEducationCourse = {
  __typename?: "logForCreatedEducationCourse";
  nextValue?: Maybe<CourseCurriculum>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForCreatedEducationGroup = {
  __typename?: "logForCreatedEducationGroup";
  nextValue?: Maybe<GroupCurriculum>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForCreatedEducationLevel = {
  __typename?: "logForCreatedEducationLevel";
  nextValue?: Maybe<LevelCurriculum>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForCreatedEducationProgram = {
  __typename?: "logForCreatedEducationProgram";
  nextValue?: Maybe<CurriculumStudyPrograms>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForCreatedPosition = {
  __typename?: "logForCreatedPosition";
  nextValue?: Maybe<Position>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForCreatedPositionDirection = {
  __typename?: "logForCreatedPositionDirection";
  nextValue?: Maybe<PositionDirections>;
  event?: Maybe<Scalars["String"]>;
};

/** Логирование действия с дилерами */
export type LogForDealer = {
  __typename?: "logForDealer";
  nextValue?: Maybe<DealerData>;
  prevValue?: Maybe<DealerData>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForDeleteCamera = {
  __typename?: "logForDeleteCamera";
  prevValue?: Maybe<CameraLog>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForDeleteCameraZone = {
  __typename?: "logForDeleteCameraZone";
  prevValue?: Maybe<CameraZoneLog>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForDeleteEducationCatalog = {
  __typename?: "logForDeleteEducationCatalog";
  nextValue?: Maybe<CatalogCurriculum>;
  prevValue?: Maybe<CatalogCurriculum>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForDeleteEducationCourse = {
  __typename?: "logForDeleteEducationCourse";
  nextValue?: Maybe<CourseCurriculum>;
  prevValue?: Maybe<CourseCurriculum>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForDeleteEducationGroup = {
  __typename?: "logForDeleteEducationGroup";
  nextValue?: Maybe<GroupCurriculum>;
  prevValue?: Maybe<GroupCurriculum>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForDeleteEducationLevel = {
  __typename?: "logForDeleteEducationLevel";
  nextValue?: Maybe<LevelCurriculum>;
  prevValue?: Maybe<LevelCurriculum>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForDeleteEducationProgram = {
  __typename?: "logForDeleteEducationProgram";
  nextValue?: Maybe<CurriculumStudyPrograms>;
  prevValue?: Maybe<CurriculumStudyPrograms>;
  event?: Maybe<Scalars["String"]>;
};

/** удаление файла */
export type LogForDeleteFile = {
  __typename?: "logForDeleteFile";
  event?: Maybe<Scalars["String"]>;
  prevValue?: Maybe<AboutDelete>;
};

export type LogForDeleteIndicatorToReport = {
  __typename?: "logForDeleteIndicatorToReport";
  prevValue?: Maybe<IndicatorAndReport>;
  nextValue?: Maybe<IndicatorAndReport>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForDeletePosition = {
  __typename?: "logForDeletePosition";
  nextValue?: Maybe<Position>;
  prevValue?: Maybe<Position>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForDeletePositionDirection = {
  __typename?: "logForDeletePositionDirection";
  nextValue?: Maybe<PositionDirections>;
  prevValue?: Maybe<PositionDirections>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForDeletePositionGroupEducationProgram = {
  __typename?: "logForDeletePositionGroupEducationProgram";
  nextValue?: Maybe<CurriculumStudyProgramGroupPosition>;
  prevValue?: Maybe<CurriculumStudyProgramGroupPosition>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForDeleteSection = {
  __typename?: "logForDeleteSection";
  prevValue?: Maybe<SectionLog>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForEditAnnouncement = {
  __typename?: "logForEditAnnouncement";
  nextValue?: Maybe<AnnouncementLog>;
  prevValue?: Maybe<AnnouncementLog>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForEditCamera = {
  __typename?: "logForEditCamera";
  nextValue?: Maybe<CameraLog>;
  prevValue?: Maybe<CameraLog>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForEditCameraCheck = {
  __typename?: "logForEditCameraCheck";
  nextValue?: Maybe<CameraCheckLog>;
  prevValue?: Maybe<CameraCheckLog>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForEditCameraZone = {
  __typename?: "logForEditCameraZone";
  nextValue?: Maybe<CameraZoneLog>;
  prevValue?: Maybe<CameraZoneLog>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForEditDocument = {
  __typename?: "logForEditDocument";
  nextValue?: Maybe<DocumentLog>;
  prevValue?: Maybe<DocumentLog>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForEditEducationCourse = {
  __typename?: "logForEditEducationCourse";
  nextValue?: Maybe<CourseCurriculum>;
  prevValue?: Maybe<CourseCurriculum>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForEditEducationGroup = {
  __typename?: "logForEditEducationGroup";
  nextValue?: Maybe<GroupCurriculum>;
  prevValue?: Maybe<GroupCurriculum>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForEditEducationLevel = {
  __typename?: "logForEditEducationLevel";
  nextValue?: Maybe<LevelCurriculum>;
  prevValue?: Maybe<LevelCurriculum>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForEditEducationProgram = {
  __typename?: "logForEditEducationProgram";
  nextValue?: Maybe<CurriculumStudyPrograms>;
  prevValue?: Maybe<CurriculumStudyPrograms>;
  event?: Maybe<Scalars["String"]>;
};

/** редактирование сотрудников */
export type LogForEditEmployee = {
  __typename?: "logForEditEmployee";
  nextValue?: Maybe<EmployeeLog>;
  prevValue?: Maybe<EmployeeLog>;
  event?: Maybe<Scalars["String"]>;
};

/** добавление/редактирование должности сотрудника */
export type LogForEditEmployeePosition = {
  __typename?: "logForEditEmployeePosition";
  nextValue?: Maybe<EmployeePositionLog>;
  prevValue?: Maybe<EmployeePositionLog>;
  event?: Maybe<Scalars["String"]>;
};

/** редактирование файла */
export type LogForEditFile = {
  __typename?: "logForEditFile";
  nextValue?: Maybe<File>;
  prevValue?: Maybe<File>;
  event?: Maybe<Scalars["String"]>;
};

/** редактирование строчки глобального рейтинга */
export type LogForEditGrRow = {
  __typename?: "logForEditGRRow";
  nextValue?: Maybe<GlobalRating>;
  prevValue?: Maybe<GlobalRating>;
  event?: Maybe<Scalars["String"]>;
};

/** редактирование версии глобального рейтинга */
export type LogForEditGrVersion = {
  __typename?: "logForEditGRVersion";
  nextValue?: Maybe<GlobalRatingVersion>;
  prevValue?: Maybe<GlobalRatingVersion>;
  event?: Maybe<Scalars["String"]>;
};

/** редактирование индикатора */
export type LogForEditIndicator = {
  __typename?: "logForEditIndicator";
  nextValue?: Maybe<Indicator>;
  prevValue?: Maybe<Indicator>;
  event?: Maybe<Scalars["String"]>;
};

/** Изменение группы для отчетов */
export type LogForEditIndicatorGroup = {
  __typename?: "logForEditIndicatorGroup";
  nextValue?: Maybe<IndicatorGroup>;
  prevValue?: Maybe<IndicatorGroup>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForEditPosition = {
  __typename?: "logForEditPosition";
  nextValue?: Maybe<Position>;
  prevValue?: Maybe<Position>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForEditPositionDirection = {
  __typename?: "logForEditPositionDirection";
  nextValue?: Maybe<PositionDirections>;
  prevValue?: Maybe<PositionDirections>;
  event?: Maybe<Scalars["String"]>;
};

/** редактирование строчки рейтинга квартили */
export type LogForEditQRow = {
  __typename?: "logForEditQRow";
  nextValue?: Maybe<QuartilesRating>;
  prevValue?: Maybe<QuartilesRating>;
  event?: Maybe<Scalars["String"]>;
};

/** редактирование версии рейтинга квартили */
export type LogForEditQVersion = {
  __typename?: "logForEditQVersion";
  nextValue?: Maybe<QuartilesRatingVersion>;
  prevValue?: Maybe<QuartilesRatingVersion>;
  event?: Maybe<Scalars["String"]>;
};

export type LogForEditSection = {
  __typename?: "logForEditSection";
  nextValue?: Maybe<SectionLog>;
  prevValue?: Maybe<SectionLog>;
  event?: Maybe<Scalars["String"]>;
};

/** Редактирование блока Персонал */
export type LogForEditStaff = {
  __typename?: "logForEditStaff";
  nextValue?: Maybe<EmployeeExpectation>;
  prevValue?: Maybe<EmployeeExpectation>;
  event?: Maybe<Scalars["String"]>;
};

/** Изменение группы обучения для сотрудников. Обучение и сертификация. */
export type LogForEditStaffEducationGroup = {
  __typename?: "logForEditStaffEducationGroup";
  nextValue?: Maybe<LogStaffEducationGroup>;
  prevValue?: Maybe<LogStaffEducationGroup>;
  event?: Maybe<Scalars["String"]>;
};

/** редактирование пользователя */
export type LogForEditUser = {
  __typename?: "logForEditUser";
  nextValue?: Maybe<Profile>;
  prevValue?: Maybe<Profile>;
  event?: Maybe<Scalars["String"]>;
};

/** Редактирование значения блока персонал */
export type LogForEditValueStaff = {
  __typename?: "logForEditValueStaff";
  nextValue?: Maybe<IndicatorValue>;
  event?: Maybe<Scalars["String"]>;
};

/** Импорт чек-листов дилера */
export type LogForImportDealerCheckLists = {
  __typename?: "logForImportDealerCheckLists";
  nextValue: Ok;
  event?: Maybe<Scalars["String"]>;
};

/** Импорт фотографий дилера */
export type LogForImportDealerPhotos = {
  __typename?: "logForImportDealerPhotos";
  nextValue?: Maybe<ImportDealerPhotosLogType>;
  event?: Maybe<Scalars["String"]>;
};

/** загрузка файла */
export type LogForUploadFileToCatalog = {
  __typename?: "logForUploadFileToCatalog";
  event?: Maybe<Scalars["String"]>;
  nextValue?: Maybe<AboutUpload>;
};

export type LogForViolation = {
  __typename?: "logForViolation";
  nextValue?: Maybe<Violation>;
  prevValue?: Maybe<Violation>;
  event?: Maybe<Scalars["String"]>;
};

/** добавление или изменение данных строчки zd */
export type LogForZdDefinitionNotes = {
  __typename?: "logForZdDefinitionNotes";
  nextValue?: Maybe<ZdNotesDefinitionType>;
  prevValue?: Maybe<ZdNotesDefinitionType>;
  event?: Maybe<Scalars["String"]>;
};

/** добавление или изменение данных строчки zd */
export type LogForZdDefinitionPersonal = {
  __typename?: "logForZdDefinitionPersonal";
  nextValue?: Maybe<ZdPersonalDefinitionType>;
  prevValue?: Maybe<ZdPersonalDefinitionType>;
  event?: Maybe<Scalars["String"]>;
};

/** добавление или изменение данных строчки zd */
export type LogForZdDefinitionPlacePosts = {
  __typename?: "logForZdDefinitionPlacePosts";
  nextValue?: Maybe<ZdPlacePostsDefinitionType>;
  prevValue?: Maybe<ZdPlacePostsDefinitionType>;
  event?: Maybe<Scalars["String"]>;
};

/** добавление или изменение данных строчки zd */
export type LogForZdDefinitionPlaces = {
  __typename?: "logForZdDefinitionPlaces";
  nextValue?: Maybe<ZdPlacesDefinitionType>;
  prevValue?: Maybe<ZdPlacesDefinitionType>;
  event?: Maybe<Scalars["String"]>;
};

/** добавление или изменение данных строчки zd */
export type LogForZdDefinitionRequiredTools = {
  __typename?: "logForZdDefinitionRequiredTools";
  nextValue?: Maybe<ZdRequiredToolsDefinitionType>;
  prevValue?: Maybe<ZdRequiredToolsDefinitionType>;
  event?: Maybe<Scalars["String"]>;
};

/** добавление или изменение данных строчки zd */
export type LogForZdDefinitionServices = {
  __typename?: "logForZdDefinitionServices";
  nextValue?: Maybe<ZdServicesDefinitionType>;
  prevValue?: Maybe<ZdServicesDefinitionType>;
  event?: Maybe<Scalars["String"]>;
};

/** добавление или изменение данных строчки zd */
export type LogForZdDefinitionTools = {
  __typename?: "logForZdDefinitionTools";
  nextValue?: Maybe<ZdToolsDefinitionType>;
  prevValue?: Maybe<ZdToolsDefinitionType>;
  event?: Maybe<Scalars["String"]>;
};

/** добавление или изменение данных строчки zd */
export type LogForZdDefinitionToolsInsurance = {
  __typename?: "logForZdDefinitionToolsInsurance";
  nextValue?: Maybe<ZdToolsInsuranceDefinitionType>;
  prevValue?: Maybe<ZdToolsInsuranceDefinitionType>;
  event?: Maybe<Scalars["String"]>;
};

/** добавление или изменение данных строчки zd */
export type LogForZdDefinitionToolsMetrological = {
  __typename?: "logForZdDefinitionToolsMetrological";
  nextValue?: Maybe<ZdToolsMetrologicalDefinitionType>;
  prevValue?: Maybe<ZdToolsMetrologicalDefinitionType>;
  event?: Maybe<Scalars["String"]>;
};

/** добавление или изменение данных строчки zd */
export type LogForZdDefinitionTradePremises = {
  __typename?: "logForZdDefinitionTradePremises";
  nextValue?: Maybe<ZdTradePremisesDefinitionType>;
  prevValue?: Maybe<ZdTradePremisesDefinitionType>;
  event?: Maybe<Scalars["String"]>;
};

/** добавление или изменение данных строчки zd */
export type LogForZdDefinitionWarehouses = {
  __typename?: "logForZdDefinitionWarehouses";
  nextValue?: Maybe<ZdWarehousesDefinitionType>;
  prevValue?: Maybe<ZdWarehousesDefinitionType>;
  event?: Maybe<Scalars["String"]>;
};

/** добавление или изменение данных строчки zd */
export type LogForZdNotes = {
  __typename?: "logForZdNotes";
  nextValue?: Maybe<ZdNotesType>;
  prevValue?: Maybe<ZdNotesType>;
  event?: Maybe<Scalars["String"]>;
};

/** добавление или изменение данных строчки zd */
export type LogForZdPersonal = {
  __typename?: "logForZdPersonal";
  nextValue?: Maybe<ZdPersonalType>;
  prevValue?: Maybe<ZdPersonalType>;
  event?: Maybe<Scalars["String"]>;
};

/** добавление или изменение данных строчки zd */
export type LogForZdPlacePosts = {
  __typename?: "logForZdPlacePosts";
  nextValue?: Maybe<ZdPlacePostsType>;
  prevValue?: Maybe<ZdPlacePostsType>;
  event?: Maybe<Scalars["String"]>;
};

/** добавление или изменение данных строчки zd */
export type LogForZdPlaces = {
  __typename?: "logForZdPlaces";
  nextValue?: Maybe<ZdPlacesType>;
  prevValue?: Maybe<ZdPlacesType>;
  event?: Maybe<Scalars["String"]>;
};

/** добавление или изменение данных строчки zd */
export type LogForZdRequiredTools = {
  __typename?: "logForZdRequiredTools";
  nextValue?: Maybe<ZdRequiredToolsType>;
  prevValue?: Maybe<ZdRequiredToolsType>;
  event?: Maybe<Scalars["String"]>;
};

/** добавление или изменение данных строчки zd */
export type LogForZdServiceZs = {
  __typename?: "logForZdServiceZs";
  nextValue?: Maybe<ZdServicesType>;
  prevValue?: Maybe<ZdServicesType>;
  event?: Maybe<Scalars["String"]>;
};

/** добавление или изменение данных строчки zd */
export type LogForZdToolsInsuranceZs = {
  __typename?: "logForZdToolsInsuranceZs";
  nextValue?: Maybe<ZdToolsInsuranceType>;
  prevValue?: Maybe<ZdToolsInsuranceType>;
  event?: Maybe<Scalars["String"]>;
};

/** добавление или изменение данных строчки zd */
export type LogForZdToolsMetrologicalZs = {
  __typename?: "logForZdToolsMetrologicalZs";
  nextValue?: Maybe<ZdToolsMetrologicalType>;
  prevValue?: Maybe<ZdToolsMetrologicalType>;
  event?: Maybe<Scalars["String"]>;
};

/** добавление или изменение данных строчки zd */
export type LogForZdToolsZs = {
  __typename?: "logForZdToolsZs";
  nextValue?: Maybe<ZdToolsType>;
  prevValue?: Maybe<ZdToolsType>;
  event?: Maybe<Scalars["String"]>;
};

/** добавление или изменение данных строчки zd */
export type LogForZdTradePremises = {
  __typename?: "logForZdTradePremises";
  nextValue?: Maybe<ZdTradePremisesType>;
  prevValue?: Maybe<ZdTradePremisesType>;
  event?: Maybe<Scalars["String"]>;
};

/** добавление или изменение данных строчки zd */
export type LogForZdWarehousesZs = {
  __typename?: "logForZdWarehousesZs";
  nextValue?: Maybe<ZdWarehousesType>;
  prevValue?: Maybe<ZdWarehousesType>;
  event?: Maybe<Scalars["String"]>;
};

/** UVIN: лояльность */
export type LoyaltyService = {
  __typename?: "loyaltyService";
  tableUnique?: Maybe<Array<Maybe<UniqueService>>>;
  tableLoyalty?: Maybe<Array<Maybe<UniqueService>>>;
};

/** UVIN: лояльность сводный по дилерам */
export type LoyaltyServiceByDealer = {
  __typename?: "loyaltyServiceByDealer";
  dealer?: Maybe<Dealer>;
  periods?: Maybe<Array<Maybe<LoyaltyServicePeriod>>>;
};

/** UVIN: лояльность сводный по дилерам. Периоды */
export type LoyaltyServicePeriod = {
  __typename?: "loyaltyServicePeriod";
  period?: Maybe<Scalars["String"]>;
  sale5?: Maybe<Scalars["Float"]>;
  serviceCars5?: Maybe<Scalars["Int"]>;
  Loyalty5?: Maybe<Scalars["Float"]>;
  sale10?: Maybe<Scalars["Float"]>;
  serviceCars10?: Maybe<Scalars["Float"]>;
  Loyalty10?: Maybe<Scalars["Float"]>;
};

/** Численность */
export type Number = {
  __typename?: "number";
  standard?: Maybe<Scalars["Float"]>;
  fact?: Maybe<Scalars["Float"]>;
  futureStandard?: Maybe<Scalars["Float"]>;
  fromDate?: Maybe<Scalars["DateTime"]>;
};

export type Ok = {
  __typename?: "ok";
  ok: Scalars["Boolean"];
};

/** Строки для отчета возвращение автомобилей на ТО (свой) по месяцу контроля */
export type RegionForAgoByMonth = {
  __typename?: "regionForAGOByMonth";
  subjectEn?: Maybe<Scalars["String"]>;
  subject?: Maybe<Scalars["String"]>;
  FO?: Maybe<Scalars["String"]>;
  counts?: Maybe<Scalars["String"]>;
  GO1?: Maybe<ToForServiceByMonth>;
  GO2?: Maybe<ToForServiceByMonth>;
  GO3?: Maybe<ToForServiceByMonth>;
};

/** Строки для отчета Машинозаезды по дилерам */
export type RegionForServiceByDealer = {
  __typename?: "regionForServiceByDealer";
  subjectEn?: Maybe<Scalars["String"]>;
  subject?: Maybe<Scalars["String"]>;
  FO?: Maybe<Scalars["String"]>;
  periods?: Maybe<Array<Maybe<ToPeriod>>>;
};

/** Строки для отчета возвращение автомобилей на ТО (свой) по месяцу контроля */
export type RegionForServiceByMonth = {
  __typename?: "regionForServiceByMonth";
  subjectEn?: Maybe<Scalars["String"]>;
  subject?: Maybe<Scalars["String"]>;
  FO?: Maybe<Scalars["String"]>;
  counts?: Maybe<Scalars["String"]>;
  family?: Maybe<Scalars["String"]>;
  TO0?: Maybe<ToForServiceByMonth>;
  TO1?: Maybe<ToForServiceByMonth>;
  TO2?: Maybe<ToForServiceByMonth>;
  TO3?: Maybe<ToForServiceByMonth>;
  TO4?: Maybe<ToForServiceByMonth>;
  TO5?: Maybe<ToForServiceByMonth>;
  TO6?: Maybe<ToForServiceByMonth>;
  TO7?: Maybe<ToForServiceByMonth>;
  TO8?: Maybe<ToForServiceByMonth>;
};

/** Требования */
export type Required = {
  __typename?: "required";
  people?: Maybe<Scalars["Float"]>;
  percent?: Maybe<Scalars["Float"]>;
};

export type SortInputType = {
  column: Scalars["String"];
  order: SortInputOrder;
};

/** по возрастанию или по убыванию */
export enum SortType {
  /** По возрастанию */
  Asc = "ASC",
  /** По убыванию */
  Desc = "DESC",
}

/** Обучение */
export type Training = {
  __typename?: "training";
  required?: Maybe<TrainingRequired>;
  trained?: Maybe<TrainingTrained>;
};

/** Требования */
export type TrainingRequired = {
  __typename?: "trainingRequired";
  fact?: Maybe<Scalars["Float"]>;
  percent?: Maybe<Scalars["Float"]>;
};

/** Обучено */
export type TrainingTrained = {
  __typename?: "trainingTrained";
  fact?: Maybe<Scalars["Float"]>;
  percent?: Maybe<Scalars["Float"]>;
};

/** Тип клиента Юридическое лицо (legal)/Физическое лицо (person) */
export enum TypeClientReportSrr {
  Legal = "legal",
  Person = "person",
}

/** Номера ГО */
export enum TypeGoReportSrr {
  Go1 = "GO1",
  Go2 = "GO2",
  Go3 = "GO3",
}

/** Группировка возвращаемых данных  */
export enum TypeGroupDealerIndicatorValues {
  Dealer = "dealer",
  City = "city",
  Region = "region",
  Fo = "FO",
  Country = "country",
  Regmen = "regmen",
  Holding = "holding",
}

/** Группировка  возвращаемых данных  */
export enum TypeGroupReportSrr {
  Dealer = "dealer",
  City = "city",
  Region = "region",
  Fo = "FO",
  Country = "country",
}

/** Вид отчета */
export enum TypeKindReport {
  Period = "period",
  Kind = "kind",
  FamilyCar = "familyCar",
}

/** Номера ТО */
export enum TypeToReportSrr {
  To0 = "TO0",
  To1 = "TO1",
  To2 = "TO2",
  To3 = "TO3",
  To4 = "TO4",
  To5 = "TO5",
  To6 = "TO6",
  To7 = "TO7",
  To8 = "TO8",
}

/** UVIN: уникальные обращения в сервис */
export type UniqueService = {
  __typename?: "uniqueService";
  name?: Maybe<Scalars["String"]>;
  five_year?: Maybe<Scalars["Int"]>;
  ten_year?: Maybe<Scalars["Int"]>;
  data?: Maybe<Array<Maybe<DataUniqueService>>>;
};

export type EmployeeCardSupplementUserFragment = {
  __typename?: "Profile";
} & Pick<
  Profile,
  "id" | "login" | "email" | "phone" | "fullname" | "role" | "roleRu"
> & {
    Employee?: Maybe<
      { __typename?: "EmployeeForProfile" } & Pick<EmployeeForProfile, "id">
    >;
  };

export type GetEmployeeCardSupplementQueryVariables = Exact<{
  id: Scalars["ID"];
}>;

export type GetEmployeeCardSupplementQuery = { __typename?: "Query" } & {
  EmployeeGetter?: Maybe<
    { __typename?: "EmployeeGetter" } & {
      get?: Maybe<
        { __typename?: "Employee" } & {
          Positions?: Maybe<
            Array<
              Maybe<
                { __typename?: "EmployeePositionsGroupByNumber" } & Pick<
                  EmployeePositionsGroupByNumber,
                  "number"
                > & {
                    ActivePosition?: Maybe<
                      { __typename?: "EmployeePositionsField" } & Pick<
                        EmployeePositionsField,
                        "PositionsId"
                      > & {
                          Education?: Maybe<
                            { __typename?: "EmployeePositionEducation" } & Pick<
                              EmployeePositionEducation,
                              "training" | "certificate"
                            >
                          >;
                          Position?: Maybe<
                            { __typename?: "Position" } & Pick<
                              Position,
                              "id" | "DirectionId"
                            > & {
                                Direction?: Maybe<
                                  { __typename?: "PositionDirections" } & Pick<
                                    PositionDirections,
                                    "id" | "InstanceId" | "role"
                                  >
                                >;
                              }
                          >;
                          Positions?: Maybe<
                            Array<
                              Maybe<
                                { __typename?: "EmployeePositions" } & Pick<
                                  EmployeePositions,
                                  | "DealerId"
                                  | "InstanceId"
                                  | "DataConsentId"
                                  | "emailVerificarion"
                                > & {
                                    DataConsent?: Maybe<
                                      { __typename?: "File" } & Pick<
                                        File,
                                        "id" | "name" | "link"
                                      >
                                    >;
                                    hireByUser?: Maybe<
                                      {
                                        __typename?: "Profile";
                                      } & EmployeeCardSupplementUserFragment
                                    >;
                                    lastStatusUpdateByUser?: Maybe<
                                      {
                                        __typename?: "Profile";
                                      } & EmployeeCardSupplementUserFragment
                                    >;
                                    fireByUser?: Maybe<
                                      {
                                        __typename?: "Profile";
                                      } & EmployeeCardSupplementUserFragment
                                    >;
                                  }
                              >
                            >
                          >;
                        }
                    >;
                    InactivePositions?: Maybe<
                      Array<
                        Maybe<
                          { __typename?: "EmployeePositionsField" } & Pick<
                            EmployeePositionsField,
                            "PositionsId"
                          > & {
                              Education?: Maybe<
                                {
                                  __typename?: "EmployeePositionEducation";
                                } & Pick<
                                  EmployeePositionEducation,
                                  "training" | "certificate"
                                >
                              >;
                              Position?: Maybe<
                                { __typename?: "Position" } & Pick<
                                  Position,
                                  "id" | "code" | "name"
                                >
                              >;
                              Positions?: Maybe<
                                Array<
                                  Maybe<
                                    { __typename?: "EmployeePositions" } & Pick<
                                      EmployeePositions,
                                      | "DealerId"
                                      | "InstanceId"
                                      | "DataConsentId"
                                      | "emailVerificarion"
                                    > & {
                                        DataConsent?: Maybe<
                                          { __typename?: "File" } & Pick<
                                            File,
                                            "id" | "name" | "link"
                                          >
                                        >;
                                        hireByUser?: Maybe<
                                          {
                                            __typename?: "Profile";
                                          } & EmployeeCardSupplementUserFragment
                                        >;
                                        lastStatusUpdateByUser?: Maybe<
                                          {
                                            __typename?: "Profile";
                                          } & EmployeeCardSupplementUserFragment
                                        >;
                                        fireByUser?: Maybe<
                                          {
                                            __typename?: "Profile";
                                          } & EmployeeCardSupplementUserFragment
                                        >;
                                      }
                                  >
                                >
                              >;
                            }
                        >
                      >
                    >;
                  }
              >
            >
          >;
        }
      >;
    }
  >;
};

export type GetEmployeeListSupplementQueryVariables = Exact<{
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  PositionIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  id?: Maybe<Scalars["ID"]>;
  surname?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  middleName?: Maybe<Scalars["String"]>;
  personalPhone?: Maybe<Scalars["String"]>;
  workPhone?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  emailVerification?: Maybe<Scalars["Boolean"]>;
  creationFrom?: Maybe<Scalars["DateTime"]>;
  creationTo?: Maybe<Scalars["DateTime"]>;
  lastEditFrom?: Maybe<Scalars["DateTime"]>;
  lastEditTo?: Maybe<Scalars["DateTime"]>;
  statuses?: Maybe<
    Array<Maybe<EmployeePositionStatus>> | Maybe<EmployeePositionStatus>
  >;
  ladaAcademiaIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  order?: Maybe<SortType>;
  orderBy?: Maybe<OrderByColumnInEmployees>;
  searchText?: Maybe<Scalars["String"]>;
}>;

export type GetEmployeeListSupplementQuery = { __typename?: "Query" } & {
  EmployeeGetter?: Maybe<
    { __typename?: "EmployeeGetter" } & {
      getList?: Maybe<
        { __typename?: "getEmployeeList" } & {
          items?: Maybe<
            Array<
              Maybe<
                { __typename?: "EmployeeWithPosition" } & {
                  EmployeePosition?: Maybe<
                    { __typename?: "PureEmployeePosition" } & Pick<
                      PureEmployeePosition,
                      "id" | "instanceId" | "rejectReason"
                    >
                  >;
                  Employee?: Maybe<
                    { __typename?: "PureEmployee" } & Pick<
                      PureEmployee,
                      "id" | "verifiedInDnm"
                    >
                  >;
                  Direction?: Maybe<
                    { __typename?: "PurePositionDirection" } & Pick<
                      PurePositionDirection,
                      "id" | "instanceId" | "role"
                    >
                  >;
                  Position?: Maybe<
                    { __typename?: "PurePosition" } & Pick<
                      PurePosition,
                      "directionId"
                    >
                  >;
                }
              >
            >
          >;
        }
      >;
    }
  >;
};

export type FragmentAccountingFragment = { __typename?: "DealerReport" } & Pick<
  DealerReport,
  | "id"
  | "ReportsPeriodId"
  | "DealerId"
  | "status"
  | "note"
  | "updatedAt"
  | "createdAt"
  | "state"
  | "_MTExMA__"
  | "_MTEyMA__"
  | "_MTEzMA__"
  | "_MTE0MA__"
  | "_MTE1MA__"
  | "_MTE1MQ__"
  | "_MTE1MS8x"
  | "_MTE1MS8y"
  | "_MTE1Mg__"
  | "_MTE1Mi8x"
  | "_MTE1Mi8y"
  | "_MTE1Mw__"
  | "_MTE1My8x"
  | "_MTE1My8y"
  | "_MTE1NA__"
  | "_MTE1NC8x"
  | "_MTE1NC8y"
  | "_MTE2MA__"
  | "_MTE3MA__"
  | "_MTE3MQ__"
  | "_MTE4MA__"
  | "_MTE5MA__"
  | "_MTE5MQ__"
  | "_MTEwMA__"
  | "_MTIxMA__"
  | "_MTIxMQ__"
  | "_MTIxMg__"
  | "_MTIxMw__"
  | "_MTIxNA__"
  | "_MTIyMA__"
  | "_MTIzMA__"
  | "_MTIzMQ__"
  | "_MTIzMg__"
  | "_MTIzMw__"
  | "_MTIzNA__"
  | "_MTI0MA__"
  | "_MTI1MA__"
  | "_MTI2MA__"
  | "_MTIwMA__"
  | "_MTYwMA__"
  | "_MTMxMA__"
  | "_MTMyMA__"
  | "_MTM0MA__"
  | "_MTM1MA__"
  | "_MTM2MA__"
  | "_MTM3MA__"
  | "_MTMwMA__"
  | "_MTQxMA__"
  | "_MTQyMA__"
  | "_MTQzMA__"
  | "_MTQ1MA__"
  | "_MTQwMA__"
  | "_MTUxMA__"
  | "_MTUyMA__"
  | "_MTUyMQ__"
  | "_MTUyMg__"
  | "_MTUyMw__"
  | "_MTUzMA__"
  | "_MTU0MA__"
  | "_MTU1MA__"
  | "_MTUwMA__"
  | "_MjAwMA__"
  | "_MjExMA__"
  | "_MjExMQ__"
  | "_MjExMg__"
  | "_MjExMw__"
  | "_MjExNA__"
  | "_MjExNQ__"
  | "_MjExNg__"
  | "_MjExNw__"
  | "_MjExOA__"
  | "_MjEyMA__"
  | "_MjEyMQ__"
  | "_MjEyMg__"
  | "_MjEyMw__"
  | "_MjEyNA__"
  | "_MjEyNQ__"
  | "_MjEyNg__"
  | "_MjEyNw__"
  | "_MjEwMA__"
  | "_MjIxMA__"
  | "_MjIxMQ__"
  | "_MjIxMS8x"
  | "_MjIxMS8y"
  | "_MjIxMS8z"
  | "_MjIxMS80"
  | "_MjIxMS81"
  | "_MjIxMS82"
  | "_MjIxMS83"
  | "_MjIxMS84"
  | "_MjIxMg__"
  | "_MjIxMw__"
  | "_MjIyMA__"
  | "_MjIyMC8x"
  | "_MjIyMC8y"
  | "_MjIyMC8z"
  | "_MjIyMC80"
  | "_MjIyMC81"
  | "_MjIyMC82"
  | "_MjIyMC83"
  | "_MjIyMC84"
  | "_MjIyMC85"
  | "_MjIyMC8xMA__"
  | "_MjIyMC8xMQ__"
  | "_MjIwMA__"
  | "_MjMxMA__"
  | "_MjMyMA__"
  | "_MjMzMA__"
  | "_MjM0MA__"
  | "_MjM0MQ__"
  | "_MjM0Mg__"
  | "_MjM0Mw__"
  | "_MjM1MA__"
  | "_MjMwMA__"
  | "_MjQxMA__"
  | "_MjQxMQ__"
  | "_MjQxMg__"
  | "_MjQ2MA__"
  | "_MjQwMA__"
  | "_MjUxMA__"
  | "_MjUyMA__"
  | "_MjUwMA__"
  | "_MjkxMA__"
  | "_MjkwMA__"
> & {
    Dealer?: Maybe<
      { __typename?: "Dealer" } & Pick<
        Dealer,
        "id" | "DealerName" | "DealerNameEn" | "city" | "cityEn" | "FO" | "FOEn"
      >
    >;
    Files?: Maybe<
      Array<
        Maybe<
          { __typename?: "File" } & Pick<
            File,
            "id" | "name" | "link" | "mimeType" | "type" | "hash" | "createdAt"
          > & {
              User?: Maybe<
                { __typename?: "Profile" } & Pick<
                  Profile,
                  "id" | "login" | "role" | "roleEn" | "roleRu" | "status"
                >
              >;
            }
        >
      >
    >;
    ReportPeriod?: Maybe<
      { __typename?: "ReportPeriod" } & Pick<
        ReportPeriod,
        "id" | "Year" | "Quarter" | "lastDate" | "reportDate" | "createdAt"
      >
    >;
  };

export type FragmentAccountingPeriodFragment = {
  __typename?: "ReportPeriod";
} & Pick<
  ReportPeriod,
  "id" | "Year" | "Quarter" | "lastDate" | "reportDate" | "createdAt"
>;

export type FragmentAnnouncementFragment = {
  __typename?: "Announcement";
} & Pick<
  Announcement,
  | "id"
  | "importance"
  | "status"
  | "date"
  | "title"
  | "text"
  | "singedBy"
  | "canceledReason"
  | "SubdivisionId"
  | "createdAt"
  | "createdBy"
> & {
    Documents?: Maybe<
      Array<
        Maybe<
          { __typename?: "File" } & Pick<
            File,
            "id" | "name" | "link" | "mimeType" | "type" | "createdAt" | "hash"
          > & {
              User?: Maybe<
                { __typename?: "Profile" } & Pick<
                  Profile,
                  | "id"
                  | "login"
                  | "email"
                  | "fullname"
                  | "fullnameEn"
                  | "role"
                  | "roleEn"
                  | "roleRu"
                >
              >;
            }
        >
      >
    >;
    createdByUser?: Maybe<
      { __typename?: "Profile" } & Pick<
        Profile,
        "id" | "fullname" | "fullnameEn"
      >
    >;
  };

export type CameraFragment = { __typename?: "Camera" } & Pick<
  Camera,
  | "id"
  | "name"
  | "cameraZoneId"
  | "cameraUrl"
  | "dealerId"
  | "createdAt"
  | "updatedAt"
  | "createdBy"
  | "updatedBy"
  | "status"
> & { CameraZone?: Maybe<{ __typename?: "CameraZone" } & CameraZoneFragment> };

export type CameraChatMessageFragment = { __typename?: "Comment" } & Pick<
  Comment,
  "id" | "cameraCheckId" | "comment" | "createdAt" | "createdBy" | "fullName"
>;

export type CameraCheckFragment = { __typename?: "CameraCheck" } & Pick<
  CameraCheck,
  | "id"
  | "cameraId"
  | "status"
  | "name"
  | "createdAt"
  | "updatedAt"
  | "createdBy"
  | "updatedBy"
> & {
    comments?: Maybe<
      Array<Maybe<{ __typename?: "Comment" } & CameraChatMessageFragment>>
    >;
  };

export type CameraZoneFragment = { __typename?: "CameraZone" } & Pick<
  CameraZone,
  "id" | "name" | "createdAt" | "updatedAt" | "createdBy" | "updatedBy"
>;

export type CameraZonesListFragment = { __typename?: "CameraZonesList" } & Pick<
  CameraZonesList,
  "total"
> & {
    items?: Maybe<
      Array<Maybe<{ __typename?: "CameraZone" } & CameraZoneFragment>>
    >;
  };

export type FragmentDealerFragment = { __typename?: "Dealer" } & Pick<
  Dealer,
  | "id"
  | "ArchivePeriodId"
  | "reestrAddress"
  | "reestrPostAddress"
  | "reestrLegalAddress"
  | "KGA_CODE"
  | "ONEC_CODE"
  | "INN"
  | "DealerName"
  | "DealerNameEn"
  | "status"
  | "createdAt"
  | "type"
  | "typeEn"
  | "tradeDealerName"
  | "tradeDealerNameEn"
  | "legalDealerName"
  | "legalDealerNameEn"
  | "OrganizationalLegalForm"
  | "code"
  | "X_SHOP_FLAG"
  | "X_STO_PHCODE"
  | "X_STO_PHONE"
  | "X_STO_EMAIL"
  | "X_SHOP_PHCODE"
  | "X_SHOP_PHONE"
  | "X_SHOP_EMAIL"
  | "X_SHOP_NAME"
  | "stoPhCode"
  | "stoPhone"
  | "stoEmail"
  | "shopPhCode"
  | "shopPhone"
  | "shopEmail"
  | "contractId"
  | "successorCode"
  | "ScanAccountantPersonDataId"
  | "ScanLadaPersonDataId"
  | "legalAddress"
  | "postalAddress"
  | "headName"
  | "headNameEn"
  | "headPhone"
  | "headMobilePhone"
  | "headEmail"
  | "ownerName"
  | "ownerNameEn"
  | "ownerPhone"
  | "ownerMobilePhone"
  | "ownerEmail"
  | "EP"
  | "EPEn"
  | "category"
  | "address"
  | "addressEn"
  | "country"
  | "countryEn"
  | "FO"
  | "FOEn"
  | "subject"
  | "subjectEn"
  | "city"
  | "cityEn"
  | "birCode"
  | "beginWorkingDate"
  | "ent_id"
  | "newDealer"
  | "temporaryDecision"
  | "protocolOfIntentions"
  | "logicalType"
  | "extendedForNextYear"
  | "terminated"
  | "hideOnLadaRu"
  | "DealerLADASERV"
  | "OGRN"
  | "termOfAuthority"
  | "corporateEmail"
  | "EGR_Number"
  | "EGR_Series"
  | "EGR_Date"
  | "settlementAccount"
  | "correspondentAccount"
  | "BIK"
  | "bankName"
  | "responsibleForLadaEmail"
  | "responsibleForLadaFax"
  | "responsibleForLadaPhone"
  | "responsibleForLadaCode"
  | "responsibleForLadaName"
  | "accountantEmail"
  | "accountantFax"
  | "accountantPhone"
  | "accountantCode"
  | "accountantName"
  | "protocolOfTermination"
  | "protocolOfConclusion"
  | "entfCode"
  | "entfSuccessorNo"
  | "entfSuccessorCode"
  | "headFax"
  | "headCode"
  | "headNameGenitive"
  | "headPositionGenitive"
  | "headNameImported"
  | "headPositionImported"
  | "headEmailImported"
  | "headPhoneImported"
  | "headCompanyId"
  | "PhotoDealerCenterId"
  | "PhotoOwnerId"
  | "PhotoBossId"
  | "ScanOwnerPersonDataId"
  | "ScanBossPersonDataId"
  | "IS_Id"
  | "Main"
  | "KPP"
  | "ContractEndDate"
  | "regionCode"
  | "consumerCode"
  | "updatedAt"
  | "legalCityId"
  | "postalCityId"
  | "CityId"
  | "legalHouseId"
  | "postalHouseId"
  | "HouseId"
  | "isIvideonActFormed"
  | "ivideonSublicenseStartAt"
  | "ladaBusiness"
  | "ladaSport"
> & {
    Period?: Maybe<
      { __typename?: "ArchivePeriod" } & Pick<
        ArchivePeriod,
        "id" | "dateStart" | "dateEnd"
      >
    >;
    Contract?: Maybe<
      { __typename?: "DealerContract" } & Pick<
        DealerContract,
        | "DealerId"
        | "ArchiveDealerId"
        | "TemplateId"
        | "number"
        | "date"
        | "createdAt"
      >
    >;
    HeadCompanyDealer?: Maybe<
      { __typename?: "Dealer" } & Pick<
        Dealer,
        "id" | "DealerName" | "DealerNameEn"
      >
    >;
    Successor?: Maybe<
      { __typename?: "Dealer" } & Pick<
        Dealer,
        "id" | "DealerName" | "DealerNameEn"
      >
    >;
    PhotoDealerCenter?: Maybe<
      { __typename?: "File" } & Pick<File, "id" | "link">
    >;
    PhotoOwner?: Maybe<{ __typename?: "File" } & Pick<File, "id" | "link">>;
    PhotoBoss?: Maybe<{ __typename?: "File" } & Pick<File, "id" | "link">>;
    ScanOwnerPersonData?: Maybe<
      { __typename?: "File" } & Pick<File, "id" | "link">
    >;
    ScanBossPersonData?: Maybe<
      { __typename?: "File" } & Pick<File, "id" | "link">
    >;
    ScanLadaPersonData?: Maybe<
      { __typename?: "File" } & Pick<File, "id" | "link">
    >;
    ScanAccountantPersonData?: Maybe<
      { __typename?: "File" } & Pick<File, "id" | "link">
    >;
    Users?: Maybe<
      Array<
        Maybe<
          { __typename?: "User" } & {
            User?: Maybe<
              { __typename?: "Profile" } & Pick<
                Profile,
                | "id"
                | "fullname"
                | "fullnameEn"
                | "role"
                | "roleEn"
                | "roleRu"
                | "email"
                | "phone"
                | "status"
              >
            >;
          }
        >
      >
    >;
  };

export type FragmentDealerForReportReturnLoyaltyServiceByDealerFragment = {
  __typename?: "Dealer";
} & Pick<
  Dealer,
  "DealerName" | "city" | "INN" | "FO" | "subject" | "entfCode" | "status"
>;

export type FragmentDealershipsForSelectFragment = {
  __typename?: "Dealer";
} & Pick<
  Dealer,
  "DealerName" | "DealerNameEn" | "status" | "id" | "isIvideonActFormed"
>;

export type FragmentDealerToAssignFragment = {
  __typename?: "DealerToAssign";
} & Pick<
  DealerToAssign,
  "id" | "code" | "INN" | "DealerName" | "DealerNameEn" | "isMy" | "status"
>;

export type FragmentDealerPanelFragment = { __typename?: "Dealer" } & Pick<
  Dealer,
  | "id"
  | "code"
  | "INN"
  | "DealerName"
  | "DealerNameEn"
  | "FO"
  | "FOEn"
  | "city"
  | "cityEn"
  | "subject"
  | "subjectEn"
  | "DealerLADASERV"
> & {
    Successor?: Maybe<
      { __typename?: "Dealer" } & Pick<
        Dealer,
        "id" | "DealerName" | "DealerNameEn"
      >
    >;
  };

export type FragmentDealerShipSquareDealerFragment = {
  __typename?: "Dealer";
} & Pick<Dealer, "id" | "DealerLADASERV" | "DealerName" | "DealerNameEn"> & {
    Successor?: Maybe<
      { __typename?: "Dealer" } & Pick<
        Dealer,
        "id" | "DealerName" | "DealerNameEn"
      >
    >;
  };

export type FragmentDealerAreaFragment = { __typename?: "DealerArea" } & {
  SA?: Maybe<
    { __typename?: "AreaDealerSAType" } & Pick<
      AreaDealerSaType,
      "area" | "filled"
    >
  >;
  STOA?: Maybe<
    { __typename?: "AreaDealerSTOAType" } & Pick<
      AreaDealerStoaType,
      "area" | "filled"
    >
  >;
  WA?: Maybe<
    { __typename?: "AreaDealerWAType" } & Pick<
      AreaDealerWaType,
      "area" | "filled"
    >
  >;
  BSA?: Maybe<
    { __typename?: "AreaDealerBSAType" } & Pick<
      AreaDealerBsaType,
      "area" | "filled"
    >
  >;
  TP?: Maybe<
    { __typename?: "AreaDealerTPType" } & Pick<
      AreaDealerTpType,
      "area" | "filled"
    >
  >;
};

export type FragmentGetDealersDomainsFragment = {
  __typename?: "DealerDomainsList";
} & Pick<DealerDomainsList, "total"> & {
    items?: Maybe<
      Array<
        Maybe<
          { __typename?: "DealerDomainType" } & Pick<
            DealerDomainType,
            "id" | "domain"
          >
        >
      >
    >;
  };

export type FragmentDealerWithPeriodsFragment = {
  __typename?: "DealerWithPeriods";
} & Pick<
  DealerWithPeriods,
  | "id"
  | "INN"
  | "DealerName"
  | "DealerNameEn"
  | "status"
  | "createdAt"
  | "type"
  | "typeEn"
  | "tradeDealerName"
  | "tradeDealerNameEn"
  | "legalDealerName"
  | "legalDealerNameEn"
  | "OrganizationalLegalForm"
  | "code"
  | "contractId"
  | "successorCode"
  | "ScanAccountantPersonDataId"
  | "ScanLadaPersonDataId"
  | "legalAddress"
  | "postalAddress"
  | "headName"
  | "headNameEn"
  | "headPhone"
  | "headMobilePhone"
  | "headEmail"
  | "ownerName"
  | "ownerNameEn"
  | "ownerPhone"
  | "ownerMobilePhone"
  | "ownerEmail"
  | "EP"
  | "EPEn"
  | "category"
  | "address"
  | "addressEn"
  | "country"
  | "countryEn"
  | "FO"
  | "FOEn"
  | "subject"
  | "subjectEn"
  | "city"
  | "cityEn"
  | "birCode"
  | "beginWorkingDate"
  | "ent_id"
  | "newDealer"
  | "temporaryDecision"
  | "protocolOfIntentions"
  | "logicalType"
  | "extendedForNextYear"
  | "terminated"
  | "hideOnLadaRu"
  | "DealerLADASERV"
  | "OGRN"
  | "termOfAuthority"
  | "corporateEmail"
  | "EGR_Number"
  | "EGR_Series"
  | "EGR_Date"
  | "settlementAccount"
  | "correspondentAccount"
  | "BIK"
  | "bankName"
  | "responsibleForLadaEmail"
  | "responsibleForLadaFax"
  | "responsibleForLadaPhone"
  | "responsibleForLadaCode"
  | "responsibleForLadaName"
  | "accountantEmail"
  | "accountantFax"
  | "accountantPhone"
  | "accountantCode"
  | "accountantName"
  | "protocolOfTermination"
  | "protocolOfConclusion"
  | "entfCode"
  | "entfSuccessorNo"
  | "entfSuccessorCode"
  | "headFax"
  | "headCode"
  | "headNameGenitive"
  | "headPositionGenitive"
  | "headNameImported"
  | "headPositionImported"
  | "headEmailImported"
  | "headPhoneImported"
  | "headCompanyId"
  | "PhotoDealerCenterId"
  | "PhotoOwnerId"
  | "PhotoBossId"
  | "ScanOwnerPersonDataId"
  | "ScanBossPersonDataId"
  | "IS_Id"
  | "Main"
  | "KPP"
  | "ContractEndDate"
  | "regionCode"
  | "consumerCode"
  | "updatedAt"
> & {
    periods?: Maybe<
      Array<
        Maybe<
          { __typename?: "ArchivePeriod" } & Pick<
            ArchivePeriod,
            "id" | "isCreatedByUser" | "dateStart" | "dateEnd" | "createdAt"
          >
        >
      >
    >;
  };

export type FragmentGetArchivePeriodsFragment = {
  __typename?: "ArchivePeriod";
} & Pick<
  ArchivePeriod,
  "isCreatedByUser" | "dateStart" | "dateEnd" | "createdAt" | "id"
>;

export type FragmentGetTemplatesFragment = {
  __typename?: "DealerContractTemplate";
} & Pick<DealerContractTemplate, "type" | "html" | "name" | "createdAt" | "id">;

export type DocumentFragment = { __typename?: "Document" } & Pick<
  Document,
  | "id"
  | "name"
  | "description"
  | "status"
  | "importance"
  | "signedBy"
  | "createdAt"
  | "updatedAt"
  | "createdBy"
  | "updatedBy"
  | "canceledReason"
> & {
    Section?: Maybe<
      { __typename?: "Section" } & Pick<
        Section,
        | "id"
        | "name"
        | "parentId"
        | "createdAt"
        | "updatedAt"
        | "createdBy"
        | "updatedBy"
      >
    >;
    Files?: Maybe<Array<Maybe<{ __typename?: "File" } & FragmentFileFragment>>>;
    Subdivision?: Maybe<
      { __typename?: "Subdivision" } & FragmentSubdivisionFragment
    >;
  };

export type CatalogFragment = { __typename?: "Section" } & Pick<
  Section,
  | "id"
  | "name"
  | "parentId"
  | "parentName"
  | "createdAt"
  | "updatedAt"
  | "createdBy"
  | "updatedBy"
  | "childCount"
  | "subcatalogCount"
>;

export type FolderListFragment = { __typename?: "FolderContent" } & Pick<
  FolderContent,
  "id" | "name" | "createdAt" | "updatedAt" | "updatedBy" | "type" | "createdBy"
>;

export type FragmentGroupsFragment = {
  __typename?: "getListGroupCurriculum";
} & {
  items?: Maybe<
    Array<
      Maybe<
        { __typename?: "GroupCurriculum" } & Pick<
          GroupCurriculum,
          | "id"
          | "name"
          | "status"
          | "dateActiveStatus"
          | "dateInactiveStatus"
          | "createdAt"
          | "updatedAt"
          | "sequenceNumber"
          | "InstanceId"
          | "ActualFrom"
          | "ActualTo"
        >
      >
    >
  >;
};

export type FragmentCoursesFragment = {
  __typename?: "CourseCurriculum";
} & Pick<
  CourseCurriculum,
  | "id"
  | "name"
  | "code"
  | "codeIS"
  | "certificateValidityPeriod"
  | "LevelId"
  | "status"
  | "createdAt"
  | "updatedAt"
  | "InstanceId"
  | "ActualFrom"
  | "ActualTo"
> & {
    Level?: Maybe<
      { __typename?: "LevelCurriculum" } & Pick<
        LevelCurriculum,
        | "id"
        | "name"
        | "status"
        | "dateActiveStatus"
        | "dateInactiveStatus"
        | "createdAt"
        | "updatedAt"
        | "sequenceNumber"
        | "GroupId"
        | "InstanceId"
        | "ActualFrom"
        | "ActualTo"
      > & {
          Group?: Maybe<
            { __typename?: "GroupCurriculum" } & Pick<
              GroupCurriculum,
              | "id"
              | "name"
              | "status"
              | "dateActiveStatus"
              | "dateInactiveStatus"
              | "createdAt"
              | "updatedAt"
              | "sequenceNumber"
              | "InstanceId"
              | "ActualFrom"
              | "ActualTo"
            >
          >;
        }
    >;
  };

export type FragmentLevelsFragment = {
  __typename?: "getListLevelCurriculum";
} & {
  items?: Maybe<
    Array<
      Maybe<
        { __typename?: "LevelCurriculum" } & Pick<
          LevelCurriculum,
          | "id"
          | "name"
          | "status"
          | "dateActiveStatus"
          | "dateInactiveStatus"
          | "createdAt"
          | "updatedAt"
          | "InstanceId"
          | "ActualFrom"
          | "ActualTo"
          | "sequenceNumber"
          | "GroupId"
        > & {
            Group?: Maybe<
              { __typename?: "GroupCurriculum" } & Pick<
                GroupCurriculum,
                "id" | "name" | "sequenceNumber"
              >
            >;
          }
      >
    >
  >;
};

export type FragmentGroupFragment = { __typename?: "GroupCurriculum" } & Pick<
  GroupCurriculum,
  | "id"
  | "name"
  | "status"
  | "dateActiveStatus"
  | "dateInactiveStatus"
  | "InstanceId"
  | "ActualFrom"
  | "ActualTo"
  | "sequenceNumber"
>;

export type FragmentLevelFragment = { __typename?: "LevelCurriculum" } & Pick<
  LevelCurriculum,
  | "id"
  | "name"
  | "status"
  | "dateActiveStatus"
  | "dateInactiveStatus"
  | "createdAt"
  | "updatedAt"
  | "InstanceId"
  | "ActualFrom"
  | "ActualTo"
  | "sequenceNumber"
  | "GroupId"
> & {
    Group?: Maybe<
      { __typename?: "GroupCurriculum" } & Pick<
        GroupCurriculum,
        | "id"
        | "name"
        | "status"
        | "dateActiveStatus"
        | "dateInactiveStatus"
        | "createdAt"
        | "updatedAt"
        | "sequenceNumber"
        | "InstanceId"
        | "ActualFrom"
        | "ActualTo"
      >
    >;
  };

export type FragmentCourseFragment = { __typename?: "CourseCurriculum" } & Pick<
  CourseCurriculum,
  | "id"
  | "name"
  | "code"
  | "codeIS"
  | "certificateValidityPeriod"
  | "LevelId"
  | "status"
  | "createdAt"
  | "updatedAt"
  | "InstanceId"
  | "ActualFrom"
  | "ActualTo"
> & {
    Level?: Maybe<
      { __typename?: "LevelCurriculum" } & Pick<LevelCurriculum, "id" | "name">
    >;
  };

export type FragmentPositionIsTheEducationProgramsFragment = {
  __typename?: "getPositionIsTheEducationPrograms";
} & Pick<GetPositionIsTheEducationPrograms, "total"> & {
    items?: Maybe<
      Array<
        Maybe<
          { __typename?: "PositionIsThePrograms" } & Pick<
            PositionIsThePrograms,
            "PositionGroupId"
          > & {
              Positions?: Maybe<
                Array<
                  Maybe<
                    { __typename?: "Position" } & Pick<
                      Position,
                      | "id"
                      | "code"
                      | "name"
                      | "nameEn"
                      | "status"
                      | "DirectionId"
                      | "createdAt"
                      | "updatedAt"
                      | "InstanceId"
                      | "ActualFrom"
                      | "ActualTo"
                    > & {
                        Direction?: Maybe<
                          { __typename?: "PositionDirections" } & Pick<
                            PositionDirections,
                            | "id"
                            | "name"
                            | "status"
                            | "createdAt"
                            | "updatedAt"
                            | "role"
                          >
                        >;
                      }
                  >
                >
              >;
            }
        >
      >
    >;
  };

export type FragmentCompositionsPositionsProgramFragment = {
  __typename?: "getCompositionPositionPrograms";
} & {
  Positions?: Maybe<
    Array<
      Maybe<
        { __typename?: "Position" } & Pick<
          Position,
          | "id"
          | "code"
          | "name"
          | "nameEn"
          | "status"
          | "DirectionId"
          | "createdAt"
          | "updatedAt"
          | "InstanceId"
          | "ActualFrom"
          | "ActualTo"
        > & {
            Direction?: Maybe<
              { __typename?: "PositionDirections" } & Pick<
                PositionDirections,
                "id" | "name" | "status" | "createdAt" | "updatedAt" | "role"
              >
            >;
          }
      >
    >
  >;
  levels?: Maybe<
    Array<
      Maybe<
        { __typename?: "getCompositionPositionProgramsLevels" } & Pick<
          GetCompositionPositionProgramsLevels,
          "id" | "name" | "status"
        > & {
            courses?: Maybe<
              Array<
                Maybe<
                  {
                    __typename?: "getCompositionPositionProgramsLevelsCourses";
                  } & Pick<
                    GetCompositionPositionProgramsLevelsCourses,
                    | "id"
                    | "name"
                    | "status"
                    | "certificateValidityPeriod"
                    | "dateActiveStatus"
                    | "dateInactiveStatus"
                    | "createdAt"
                    | "updatedAt"
                  >
                >
              >
            >;
          }
      >
    >
  >;
};

export type FragmentPositionsInNotEducationProgramsFragment = {
  __typename?: "getPositionsInNotEducationPrograms";
} & Pick<GetPositionsInNotEducationPrograms, "total"> & {
    items?: Maybe<
      Array<
        Maybe<
          { __typename?: "Position" } & Pick<
            Position,
            | "id"
            | "code"
            | "name"
            | "nameEn"
            | "status"
            | "DirectionId"
            | "createdAt"
            | "updatedAt"
            | "InstanceId"
            | "ActualFrom"
            | "ActualTo"
          > & {
              Direction?: Maybe<
                { __typename?: "PositionDirections" } & Pick<
                  PositionDirections,
                  "id" | "name" | "status" | "createdAt" | "updatedAt" | "role"
                >
              >;
            }
        >
      >
    >;
  };

export type FragmentGetListCoursesBySortLevelIdFragment = {
  __typename?: "CourseCurriculum";
} & Pick<
  CourseCurriculum,
  | "id"
  | "name"
  | "code"
  | "codeIS"
  | "certificateValidityPeriod"
  | "LevelId"
  | "status"
  | "createdAt"
  | "updatedAt"
  | "InstanceId"
  | "ActualFrom"
  | "ActualTo"
> & {
    Level?: Maybe<
      { __typename?: "LevelCurriculum" } & Pick<LevelCurriculum, "id" | "name">
    >;
  };

export type FragmentGetListFragment = { __typename?: "Employee" } & Pick<
  Employee,
  | "id"
  | "surname"
  | "name"
  | "middleName"
  | "gender"
  | "birthDay"
  | "personalPhone"
  | "workPhone"
  | "photoId"
  | "ResourcesControlUserId"
  | "HiredDate"
  | "FiredDate"
  | "ladaAcademiaId"
  | "lastEditDate"
  | "createdBy"
  | "firedAt"
  | "firedBy"
  | "lastEditBy"
  | "createdAt"
  | "statusEmployee"
  | "lastStatusUpdateAt"
  | "verifiedBy"
  | "verifiedAt"
  | "shouldShowUpdateStatusDate"
> & {
    MainActivePosition?: Maybe<
      {
        __typename?: "EmployeePositions";
      } & EachDealerInEmployeePositionFragment
    >;
    Positions?: Maybe<
      Array<
        Maybe<
          { __typename?: "EmployeePositionsGroupByNumber" } & Pick<
            EmployeePositionsGroupByNumber,
            "number"
          > & {
              ActivePosition?: Maybe<
                {
                  __typename?: "EmployeePositionsField";
                } & FragmentPositionFragment
              >;
              InactivePositions?: Maybe<
                Array<
                  Maybe<
                    {
                      __typename?: "EmployeePositionsField";
                    } & FragmentPositionsFragment
                  >
                >
              >;
            }
        >
      >
    >;
    CreatedByUser?: Maybe<
      { __typename?: "Profile" } & Pick<
        Profile,
        | "id"
        | "login"
        | "email"
        | "phone"
        | "fullname"
        | "fullnameEn"
        | "role"
        | "roleEn"
        | "roleRu"
      > & {
          Employee?: Maybe<
            { __typename?: "EmployeeForProfile" } & Pick<
              EmployeeForProfile,
              "id"
            >
          >;
        }
    >;
    LastEditByUser?: Maybe<
      { __typename?: "Profile" } & Pick<
        Profile,
        | "id"
        | "login"
        | "email"
        | "phone"
        | "fullname"
        | "fullnameEn"
        | "role"
        | "roleEn"
        | "roleRu"
      > & {
          Employee?: Maybe<
            { __typename?: "EmployeeForProfile" } & Pick<
              EmployeeForProfile,
              "id"
            >
          >;
        }
    >;
    FiredByUser?: Maybe<
      { __typename?: "Profile" } & Pick<
        Profile,
        | "id"
        | "login"
        | "email"
        | "phone"
        | "fullname"
        | "fullnameEn"
        | "role"
        | "roleEn"
        | "roleRu"
      > & {
          Employee?: Maybe<
            { __typename?: "EmployeeForProfile" } & Pick<
              EmployeeForProfile,
              "id"
            >
          >;
        }
    >;
    VerifiedByUser?: Maybe<
      { __typename?: "Profile" } & Pick<
        Profile,
        | "id"
        | "login"
        | "email"
        | "phone"
        | "fullname"
        | "fullnameEn"
        | "role"
        | "roleEn"
        | "roleRu"
      > & {
          Employee?: Maybe<
            { __typename?: "EmployeeForProfile" } & Pick<
              EmployeeForProfile,
              "id"
            >
          >;
        }
    >;
    lastStatusUpdateByUser?: Maybe<
      { __typename?: "Profile" } & Pick<
        Profile,
        | "id"
        | "login"
        | "email"
        | "phone"
        | "fullname"
        | "fullnameEn"
        | "role"
        | "roleEn"
        | "roleRu"
      > & {
          Employee?: Maybe<
            { __typename?: "EmployeeForProfile" } & Pick<
              EmployeeForProfile,
              "id"
            >
          >;
        }
    >;
  };

export type FragmentProfilePositionFragment = { __typename?: "Profile" } & Pick<
  Profile,
  | "id"
  | "login"
  | "email"
  | "fullname"
  | "fullnameEn"
  | "phone"
  | "position"
  | "positionEn"
  | "role"
  | "roleRu"
  | "roleEn"
  | "status"
  | "countDC"
  | "lastOnlineDate"
  | "createdAt"
  | "isViolationAccess"
  | "isEmployeeAccess"
  | "isZdAccess"
  | "isAnnouncementsAccess"
  | "isAccountingAccess"
  | "isAnnouncementsSend"
  | "SubdivisionId"
  | "lockDate"
> & {
    Employee?: Maybe<
      { __typename?: "EmployeeForProfile" } & Pick<
        EmployeeForProfile,
        "id" | "name"
      >
    >;
  };

export type EachDealerInEmployeePositionFragment = {
  __typename?: "EmployeePositions";
} & Pick<
  EmployeePositions,
  | "id"
  | "InstanceId"
  | "startDate"
  | "startOrderNumber"
  | "endDate"
  | "endOrderNumber"
  | "createdBy"
  | "createdAt"
  | "PositionsId"
  | "DealerId"
  | "email"
  | "emailVerificarion"
  | "DataConsentId"
  | "status"
  | "lastStatusUpdateAt"
  | "lastModifiedBy"
  | "lastModifiedAt"
  | "hireBy"
  | "verifyBy"
  | "verifyDate"
  | "fireBy"
  | "lastStatusUpdateBy"
  | "positionOrderId"
  | "jobDescriptionId"
> & {
    DataConsent?: Maybe<
      { __typename?: "File" } & Pick<File, "id" | "link" | "name">
    >;
    Dealer?: Maybe<
      { __typename?: "Dealer" } & Pick<
        Dealer,
        "id" | "code" | "DealerName" | "DealerNameEn"
      >
    >;
    hireByUser?: Maybe<
      { __typename?: "Profile" } & FragmentProfilePositionFragment
    >;
    fireByUser?: Maybe<
      { __typename?: "Profile" } & FragmentProfilePositionFragment
    >;
    verifyByUser?: Maybe<
      { __typename?: "Profile" } & FragmentProfilePositionFragment
    >;
    lastModifiedByUser?: Maybe<
      { __typename?: "Profile" } & FragmentProfilePositionFragment
    >;
    lastStatusUpdateByUser?: Maybe<
      { __typename?: "Profile" } & FragmentProfilePositionFragment
    >;
    Position?: Maybe<{ __typename?: "Position" } & PositionsFragmentFragment>;
    positionOrder?: Maybe<
      { __typename?: "File" } & Pick<
        File,
        "id" | "name" | "link" | "mimeType" | "createdAt" | "type" | "hash"
      >
    >;
    jobDescription?: Maybe<
      { __typename?: "File" } & Pick<
        File,
        "id" | "name" | "link" | "mimeType" | "createdAt" | "type" | "hash"
      >
    >;
  };

export type FragmentConsentsFragment = {
  __typename?: "EmployeeConsent";
} & Pick<
  EmployeeConsent,
  "id" | "fileId" | "employeeId" | "createdAt" | "systemId" | "personalInfoId"
> & {
    PersonalInfo?: Maybe<
      { __typename?: "PersonalInformation" } & Pick<
        PersonalInformation,
        | "id"
        | "name"
        | "createdAt"
        | "updatedAt"
        | "informationSystemId"
        | "createdBy"
        | "UpdatedBy"
      > & {
          File?: Maybe<
            { __typename?: "File" } & Pick<
              File,
              "id" | "name" | "link" | "mimeType" | "createdAt" | "type"
            >
          >;
          InformationSystem?: Maybe<
            { __typename?: "InformationSystem" } & Pick<
              InformationSystem,
              "id" | "name"
            >
          >;
        }
    >;
    File?: Maybe<
      { __typename?: "File" } & Pick<
        File,
        "id" | "name" | "link" | "mimeType" | "createdAt" | "type"
      >
    >;
  };

export type FragmentGetFragment = { __typename?: "Employee" } & Pick<
  Employee,
  | "id"
  | "surname"
  | "name"
  | "middleName"
  | "gender"
  | "birthDay"
  | "personalPhone"
  | "workPhone"
  | "firedAt"
  | "firedBy"
  | "lastEditBy"
  | "photoId"
  | "lastStatusUpdateAt"
  | "shouldShowUpdateStatusDate"
  | "ResourcesControlUserId"
  | "HiredDate"
  | "FiredDate"
  | "ladaAcademiaId"
  | "lastEditDate"
  | "createdBy"
  | "createdAt"
  | "statusEmployee"
  | "verifiedBy"
  | "verifiedAt"
> & {
    Positions?: Maybe<
      Array<
        Maybe<
          { __typename?: "EmployeePositionsGroupByNumber" } & Pick<
            EmployeePositionsGroupByNumber,
            "number"
          > & {
              ActivePosition?: Maybe<
                {
                  __typename?: "EmployeePositionsField";
                } & FragmentPositionFragment
              >;
              InactivePositions?: Maybe<
                Array<
                  Maybe<
                    {
                      __typename?: "EmployeePositionsField";
                    } & FragmentPositionsFragment
                  >
                >
              >;
            }
        >
      >
    >;
    LastEditByUser?: Maybe<
      { __typename?: "Profile" } & Pick<
        Profile,
        | "id"
        | "login"
        | "email"
        | "phone"
        | "fullname"
        | "fullnameEn"
        | "role"
        | "roleEn"
        | "roleRu"
      > & {
          Employee?: Maybe<
            { __typename?: "EmployeeForProfile" } & Pick<
              EmployeeForProfile,
              "id"
            >
          >;
        }
    >;
    FiredByUser?: Maybe<
      { __typename?: "Profile" } & Pick<
        Profile,
        | "id"
        | "login"
        | "email"
        | "phone"
        | "fullname"
        | "fullnameEn"
        | "role"
        | "roleEn"
        | "roleRu"
      > & {
          Employee?: Maybe<
            { __typename?: "EmployeeForProfile" } & Pick<
              EmployeeForProfile,
              "id"
            >
          >;
        }
    >;
    DataConsent?: Maybe<
      { __typename?: "File" } & Pick<File, "id" | "name" | "link">
    >;
    Consents?: Maybe<
      Array<
        Maybe<{ __typename?: "EmployeeConsent" } & FragmentConsentsFragment>
      >
    >;
    Photo?: Maybe<{ __typename?: "File" } & Pick<File, "id" | "name" | "link">>;
    lastStatusUpdateByUser?: Maybe<
      { __typename?: "Profile" } & Pick<
        Profile,
        | "id"
        | "login"
        | "email"
        | "phone"
        | "fullname"
        | "fullnameEn"
        | "role"
        | "roleEn"
        | "roleRu"
      > & {
          Employee?: Maybe<
            { __typename?: "EmployeeForProfile" } & Pick<
              EmployeeForProfile,
              "id"
            >
          >;
        }
    >;
    CreatedByUser?: Maybe<
      { __typename?: "Profile" } & Pick<
        Profile,
        | "id"
        | "login"
        | "email"
        | "phone"
        | "fullname"
        | "fullnameEn"
        | "role"
        | "roleEn"
        | "roleRu"
      > & {
          Employee?: Maybe<
            { __typename?: "EmployeeForProfile" } & Pick<
              EmployeeForProfile,
              "id"
            >
          >;
        }
    >;
    VerifiedByUser?: Maybe<
      { __typename?: "Profile" } & Pick<
        Profile,
        | "id"
        | "login"
        | "email"
        | "phone"
        | "fullname"
        | "fullnameEn"
        | "role"
        | "roleEn"
        | "roleRu"
      > & {
          Employee?: Maybe<
            { __typename?: "EmployeeForProfile" } & Pick<
              EmployeeForProfile,
              "id"
            >
          >;
        }
    >;
  };

export type FragmentEmployeeLogFragment = { __typename?: "EmployeeLog" } & Pick<
  EmployeeLog,
  | "id"
  | "surname"
  | "name"
  | "middleName"
  | "gender"
  | "birthDay"
  | "email"
  | "personalPhone"
  | "workPhone"
  | "DataConsentId"
  | "photoId"
  | "ResourcesControlUserId"
  | "HiredDate"
  | "FiredDate"
  | "lastEditDate"
  | "createdBy"
  | "createdAt"
> & {
    DataConsent?: Maybe<
      { __typename?: "File" } & Pick<File, "id" | "name" | "link">
    >;
    Photo?: Maybe<{ __typename?: "File" } & Pick<File, "id" | "name" | "link">>;
    positions?: Maybe<
      Array<
        Maybe<
          { __typename?: "EmployeePositionLog" } & Pick<
            EmployeePositionLog,
            | "id"
            | "number"
            | "startDate"
            | "startOrderNumber"
            | "endDate"
            | "endOrderNumber"
            | "createdBy"
            | "createdAt"
            | "DealerId"
          >
        >
      >
    >;
  };

export type FragmentEmployeePositionLogFragment = {
  __typename?: "EmployeePositionLog";
} & Pick<
  EmployeePositionLog,
  | "id"
  | "code"
  | "name"
  | "number"
  | "startDate"
  | "startOrderNumber"
  | "endDate"
  | "endOrderNumber"
  | "DealerId"
  | "EmployeesId"
  | "createdBy"
  | "createdAt"
> & {
    Dealer?: Maybe<
      { __typename?: "DealerData" } & Pick<
        DealerData,
        | "DealerName"
        | "DealerNameEn"
        | "INN"
        | "city"
        | "cityEn"
        | "country"
        | "countryEn"
        | "FO"
        | "FOEn"
        | "id"
      >
    >;
  };

export type PositionsFragmentFragment = { __typename?: "Position" } & Pick<
  Position,
  "id" | "code" | "name" | "DirectionId"
> & {
    Direction?: Maybe<
      { __typename?: "PositionDirections" } & Pick<
        PositionDirections,
        "id" | "role"
      >
    >;
  };

export type FragmentPositionFragment = {
  __typename?: "EmployeePositionsField";
} & Pick<EmployeePositionsField, "PositionsId"> & {
    Position?: Maybe<{ __typename?: "Position" } & PositionsFragmentFragment>;
    Education?: Maybe<
      { __typename?: "EmployeePositionEducation" } & Pick<
        EmployeePositionEducation,
        "training" | "certificate"
      >
    >;
    Positions?: Maybe<
      Array<
        Maybe<
          {
            __typename?: "EmployeePositions";
          } & EachDealerInEmployeePositionFragment
        >
      >
    >;
  };

export type FragmentPositionsFragment = {
  __typename?: "EmployeePositionsField";
} & Pick<EmployeePositionsField, "PositionsId"> & {
    Position?: Maybe<{ __typename?: "Position" } & PositionsFragmentFragment>;
    Education?: Maybe<
      { __typename?: "EmployeePositionEducation" } & Pick<
        EmployeePositionEducation,
        "training" | "certificate"
      >
    >;
    Positions?: Maybe<
      Array<
        Maybe<
          {
            __typename?: "EmployeePositions";
          } & EachDealerInEmployeePositionFragment
        >
      >
    >;
  };

export type FragmentFileFragment = { __typename?: "File" } & Pick<
  File,
  "id" | "name" | "link" | "mimeType" | "createdAt" | "hash"
> & { User?: Maybe<{ __typename?: "Profile" } & Pick<Profile, "id">> };

export type FragmentFileLinkFragment = { __typename?: "File" } & Pick<
  File,
  "id" | "link" | "hash"
>;

export type FragmentFileCatalogFragment = { __typename?: "File" } & Pick<
  File,
  "id" | "name" | "link" | "mimeType" | "createdAt" | "type" | "hash"
> & {
    User?: Maybe<
      { __typename?: "Profile" } & Pick<
        Profile,
        "id" | "fullname" | "fullnameEn"
      >
    >;
  };

export type FragmentIndicatorForGrFragment = {
  __typename?: "Indicator";
} & Pick<Indicator, "format"> & {
    Values?: Maybe<
      Array<
        Maybe<
          { __typename?: "IndicatorValue" } & Pick<
            IndicatorValue,
            "doubleValue" | "stringValue"
          >
        >
      >
    >;
  };

export type FragmentGlobalRatingVersionForTableFragment = {
  __typename?: "GlobalRatingVersion";
} & Pick<
  GlobalRatingVersion,
  "id" | "quarter" | "year" | "dateBegin" | "IndicatorId"
>;

export type FragmentGrRatingForTableFragment = {
  __typename?: "GlobalRating";
} & Pick<
  GlobalRating,
  | "id"
  | "number"
  | "name"
  | "nameEn"
  | "quarter1"
  | "quarter2"
  | "quarter1_2"
  | "quarter3"
  | "quarter2_3"
  | "quarter4"
  | "quarter3_4"
  | "yearValue"
  | "yearPercent"
  | "type"
  | "sort"
  | "round"
  | "format"
  | "ParentId"
  | "PrevElementId"
  | "updatedAt"
  | "createdAt"
  | "RatingsVersionId"
> & {
    IndicatorQuarter1?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    IndicatorQuarter2?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    IndicatorQuarter1_2?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    IndicatorQuarter3?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    IndicatorQuarter2_3?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    IndicatorQuarter4?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    IndicatorQuarter3_4?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    IndicatorYearPercent?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    IndicatorYearValue?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    Parent?: Maybe<
      { __typename?: "GlobalRating" } & Pick<GlobalRating, "name">
    >;
  };

export type FragmentGlobalRatingQuarer1Fragment = {
  __typename?: "GlobalRating";
} & Pick<
  GlobalRating,
  | "id"
  | "number"
  | "name"
  | "nameEn"
  | "quarter1"
  | "yearPercent"
  | "PrevElementId"
  | "sort"
  | "yearValue"
  | "ParentId"
  | "type"
  | "round"
  | "format"
> & {
    IndicatorQuarter1?: Maybe<
      { __typename?: "Indicator" } & FragmentIndicatorForGrFragment
    >;
    IndicatorYearPercent?: Maybe<
      { __typename?: "Indicator" } & Pick<Indicator, "unit"> &
        FragmentIndicatorForGrFragment
    >;
    IndicatorYearValue?: Maybe<
      { __typename?: "Indicator" } & FragmentIndicatorForGrFragment
    >;
  };

export type FragmentGlobalRatingQuarer2Fragment = {
  __typename?: "GlobalRating";
} & Pick<
  GlobalRating,
  | "id"
  | "number"
  | "name"
  | "nameEn"
  | "quarter2"
  | "quarter1_2"
  | "PrevElementId"
  | "sort"
  | "yearPercent"
  | "yearValue"
  | "ParentId"
  | "type"
  | "round"
  | "format"
> & {
    IndicatorQuarter2?: Maybe<
      { __typename?: "Indicator" } & FragmentIndicatorForGrFragment
    >;
    IndicatorQuarter1_2?: Maybe<
      { __typename?: "Indicator" } & FragmentIndicatorForGrFragment
    >;
    IndicatorYearPercent?: Maybe<
      { __typename?: "Indicator" } & Pick<Indicator, "unit"> &
        FragmentIndicatorForGrFragment
    >;
    IndicatorYearValue?: Maybe<
      { __typename?: "Indicator" } & FragmentIndicatorForGrFragment
    >;
  };

export type FragmentGlobalRatingQuarer3Fragment = {
  __typename?: "GlobalRating";
} & Pick<
  GlobalRating,
  | "id"
  | "number"
  | "name"
  | "nameEn"
  | "quarter3"
  | "quarter2_3"
  | "sort"
  | "yearPercent"
  | "PrevElementId"
  | "yearValue"
  | "ParentId"
  | "type"
  | "round"
  | "format"
> & {
    IndicatorQuarter3?: Maybe<
      { __typename?: "Indicator" } & FragmentIndicatorForGrFragment
    >;
    IndicatorQuarter2_3?: Maybe<
      { __typename?: "Indicator" } & FragmentIndicatorForGrFragment
    >;
    IndicatorYearPercent?: Maybe<
      { __typename?: "Indicator" } & Pick<Indicator, "unit"> &
        FragmentIndicatorForGrFragment
    >;
    IndicatorYearValue?: Maybe<
      { __typename?: "Indicator" } & FragmentIndicatorForGrFragment
    >;
  };

export type FragmentGlobalRatingQuarer4Fragment = {
  __typename?: "GlobalRating";
} & Pick<
  GlobalRating,
  | "id"
  | "number"
  | "name"
  | "nameEn"
  | "quarter4"
  | "quarter3_4"
  | "sort"
  | "PrevElementId"
  | "yearPercent"
  | "yearValue"
  | "ParentId"
  | "type"
  | "round"
  | "format"
> & {
    IndicatorQuarter4?: Maybe<
      { __typename?: "Indicator" } & FragmentIndicatorForGrFragment
    >;
    IndicatorQuarter3_4?: Maybe<
      { __typename?: "Indicator" } & FragmentIndicatorForGrFragment
    >;
    IndicatorYearPercent?: Maybe<
      { __typename?: "Indicator" } & Pick<Indicator, "unit"> &
        FragmentIndicatorForGrFragment
    >;
    IndicatorYearValue?: Maybe<
      { __typename?: "Indicator" } & FragmentIndicatorForGrFragment
    >;
  };

export type FragmentGrRatingsListNameFragment = {
  __typename?: "GlobalRatingName";
} & Pick<
  GlobalRatingName,
  | "id"
  | "name"
  | "nameEn"
  | "number"
  | "ParentId"
  | "PrevElementId"
  | "RatingsVersionId"
>;

export type FragmentGrRatingForChartFragment = {
  __typename?: "GlobalRating";
} & Pick<GlobalRating, "id" | "name" | "nameEn" | "type"> & {
    IndicatorYearPercent?: Maybe<
      { __typename?: "Indicator" } & Pick<Indicator, "format"> & {
          Values?: Maybe<
            Array<
              Maybe<
                { __typename?: "IndicatorValue" } & Pick<
                  IndicatorValue,
                  "doubleValue"
                >
              >
            >
          >;
        }
    >;
  };

export type FragmentIndicatorFragment = { __typename?: "Indicator" } & Pick<
  Indicator,
  | "id"
  | "nameRu"
  | "nameEn"
  | "shortNameRu"
  | "shortNameEn"
  | "type"
  | "format"
  | "unit"
  | "period"
  | "status"
  | "createdAt"
> & {
    Values?: Maybe<
      Array<
        Maybe<
          { __typename?: "IndicatorValue" } & Pick<
            IndicatorValue,
            "DealerId" | "doubleValue" | "stringValue" | "createdAt"
          >
        >
      >
    >;
  };

export type FragmentIndicatorForTableFragment = {
  __typename?: "Indicator";
} & Pick<
  Indicator,
  | "id"
  | "type"
  | "nameRu"
  | "nameEn"
  | "shortNameRu"
  | "shortNameEn"
  | "unit"
  | "period"
  | "format"
  | "status"
  | "enum"
  | "createdAt"
>;

export type FragmentIndicatorForSelectFragment = {
  __typename?: "Indicator";
} & Pick<
  Indicator,
  "id" | "nameRu" | "nameEn" | "shortNameRu" | "shortNameEn" | "enum"
>;

export type FragmentUploadListFragment = { __typename?: "UploadList" } & Pick<
  UploadList,
  | "id"
  | "UserId"
  | "FileId"
  | "description"
  | "status"
  | "createdAt"
  | "type"
  | "errors"
> & {
    User?: Maybe<{ __typename?: "Profile" } & Pick<Profile, "fullname">>;
    File?: Maybe<{ __typename?: "File" } & Pick<File, "name">>;
  };

export type FragmentUploadListForTableFragment = {
  __typename?: "UploadList";
} & Pick<
  UploadList,
  "id" | "description" | "status" | "createdAt" | "type" | "errors"
> & {
    User?: Maybe<{ __typename?: "Profile" } & Pick<Profile, "fullname">>;
    File?: Maybe<{ __typename?: "File" } & Pick<File, "link">>;
  };

export type FragmentUploadListForErrorsFragment = {
  __typename?: "UploadList";
} & Pick<UploadList, "id" | "errors">;

export type FragmentIndicatorForRatingFragment = {
  __typename?: "Indicator";
} & Pick<Indicator, "format" | "unit"> & {
    Values?: Maybe<
      Array<
        Maybe<
          { __typename?: "IndicatorValue" } & Pick<
            IndicatorValue,
            "doubleValue" | "stringValue"
          >
        >
      >
    >;
  };

export type FragmentIndicatorValueFragment = {
  __typename?: "IndicatorValue";
} & Pick<
  IndicatorValue,
  | "id"
  | "doubleValue"
  | "stringValue"
  | "DealerId"
  | "IndicatorId"
  | "createdAt"
> & {
    Indicator?: Maybe<
      { __typename?: "Indicator" } & FragmentIndicatorForRatingFragment
    >;
  };

export type FragmentIndicatorGroupsItemsFragment = {
  __typename?: "IndicatorGroup";
} & Pick<
  IndicatorGroup,
  | "id"
  | "nameRu"
  | "nameEn"
  | "status"
  | "createdAt"
  | "updatedAt"
  | "createdBy"
> & {
    createdByUser?: Maybe<
      { __typename?: "Profile" } & Pick<Profile, "fullname">
    >;
    writtenByUser?: Maybe<
      { __typename?: "Profile" } & Pick<Profile, "fullname">
    >;
  };

export type FragmentGetIndicatorReportsFragment = {
  __typename?: "IndicatorReport";
} & Pick<
  IndicatorReport,
  | "id"
  | "nameRu"
  | "status"
  | "createdBy"
  | "createdAt"
  | "updatedAt"
  | "GroupId"
  | "writtenBy"
> & {
    Fields?: Maybe<
      Array<
        Maybe<
          { __typename?: "DealerField" } & Pick<
            DealerField,
            | "id"
            | "fieldName"
            | "fieldEnName"
            | "fieldRu"
            | "fieldEn"
            | "fieldRuDescription"
            | "fieldEnDescription"
          >
        >
      >
    >;
    Indicators?: Maybe<
      Array<
        Maybe<{ __typename?: "Indicator" } & Pick<Indicator, "id" | "nameRu">>
      >
    >;
    Group?: Maybe<
      { __typename?: "IndicatorGroup" } & FragmentIndicatorGroupsItemsFragment
    >;
    createdByUser?: Maybe<
      { __typename?: "Profile" } & Pick<Profile, "fullname">
    >;
    writtenByUser?: Maybe<
      { __typename?: "Profile" } & Pick<Profile, "fullname">
    >;
  };

export type FragmentDealerRegManFragment = {
  __typename?: "DealerRegMan";
} & Pick<DealerRegMan, "fullname" | "fullnameEn" | "roleRu" | "roleEn">;

export type FragmentDealerRegManInfoFragment = {
  __typename?: "RegMenInfo";
} & Pick<
  RegMenInfo,
  "role" | "roleRu" | "roleEn" | "roleRuAbbr" | "roleEnAbbr"
>;

export type FragmentDealersRegMenFragment = { __typename?: "DealersRegMen" } & {
  leaderRegionalSalesManager?: Maybe<
    { __typename?: "DealerRegMan" } & FragmentDealerRegManFragment
  >;
  regionalSalesManager?: Maybe<
    { __typename?: "DealerRegMan" } & FragmentDealerRegManFragment
  >;
  leaderRegionalServiceManager?: Maybe<
    { __typename?: "DealerRegMan" } & FragmentDealerRegManFragment
  >;
  regionalServiceManager?: Maybe<
    { __typename?: "DealerRegMan" } & FragmentDealerRegManFragment
  >;
};

export type FragmentIndicatorReportToViewFragment = {
  __typename?: "DealerIndicatorValues";
} & {
  Dealer?: Maybe<{ __typename?: "Dealer" } & FragmentDealerFragment>;
  RegMen?: Maybe<
    { __typename?: "DealersRegMen" } & FragmentDealersRegMenFragment
  >;
  Values?: Maybe<
    Array<
      Maybe<{ __typename?: "IndicatorValue" } & FragmentIndicatorValueFragment>
    >
  >;
};

export type FragmentDealerForLogsFragment = {
  __typename?: "DealerData";
} & Pick<
  DealerData,
  | "id"
  | "DealerName"
  | "INN"
  | "code"
  | "headCompanyId"
  | "status"
  | "category"
  | "createdAt"
  | "updatedAt"
  | "type"
  | "tradeDealerName"
  | "legalDealerName"
  | "successorCode"
  | "PhotoDealerCenterId"
  | "PhotoOwnerId"
  | "PhotoBossId"
  | "ScanOwnerPersonDataId"
  | "ScanBossPersonDataId"
  | "headName"
  | "headPhone"
  | "headMobilePhone"
  | "headEmail"
  | "ownerName"
  | "ownerPhone"
  | "ownerMobilePhone"
  | "ownerEmail"
  | "EP"
  | "address"
  | "country"
  | "FO"
  | "subject"
  | "city"
  | "birCode"
  | "beginWorkingDate"
>;

export type FragmentIndicatorForLogsFragment = {
  __typename?: "Indicator";
} & Pick<
  Indicator,
  | "nameRu"
  | "nameEn"
  | "shortNameRu"
  | "shortNameEn"
  | "type"
  | "format"
  | "unit"
  | "period"
  | "status"
  | "createdAt"
> & {
    Values?: Maybe<
      Array<
        Maybe<
          { __typename?: "IndicatorValue" } & Pick<
            IndicatorValue,
            "DealerId" | "doubleValue" | "stringValue" | "createdAt"
          >
        >
      >
    >;
  };

export type FragmentPositionLogFragment = { __typename?: "Position" } & Pick<
  Position,
  | "id"
  | "code"
  | "name"
  | "nameEn"
  | "status"
  | "DirectionId"
  | "ExpectationId"
  | "createdAt"
  | "updatedAt"
  | "RequiredEmail"
  | "InstanceId"
  | "ActualFrom"
  | "ActualTo"
> & {
    Direction?: Maybe<
      { __typename?: "PositionDirections" } & FragmentPositionDirectionsFragment
    >;
  };

export type FragmentPositionDirectionsFragment = {
  __typename?: "PositionDirections";
} & Pick<
  PositionDirections,
  | "id"
  | "InstanceId"
  | "ActualFrom"
  | "ActualTo"
  | "name"
  | "status"
  | "createdAt"
  | "updatedAt"
  | "role"
>;

export type FragmentCurriculumStudyProgramsFragment = {
  __typename?: "CurriculumStudyPrograms";
} & Pick<
  CurriculumStudyPrograms,
  | "id"
  | "PositionGroupId"
  | "LevelId"
  | "CourseId"
  | "dateActiveStatus"
  | "dateInactiveStatus"
  | "ActualFrom"
  | "ActualTo"
> & { CurriculumStudyProgramsStatus: CurriculumStudyPrograms["status"] } & {
    Positions?: Maybe<
      Array<Maybe<{ __typename?: "Position" } & FragmentPositionLogFragment>>
    >;
    Level?: Maybe<
      { __typename?: "LevelCurriculum" } & FragmentLevelCurriculumFragment
    >;
    Course?: Maybe<
      { __typename?: "CourseCurriculum" } & FragmentCourseCurriculumFragment
    >;
  };

export type FragmentLevelCurriculumFragment = {
  __typename?: "LevelCurriculum";
} & Pick<
  LevelCurriculum,
  | "id"
  | "name"
  | "status"
  | "dateActiveStatus"
  | "dateInactiveStatus"
  | "createdAt"
  | "updatedAt"
  | "sequenceNumber"
  | "GroupId"
  | "InstanceId"
  | "ActualFrom"
  | "ActualTo"
> & {
    Group?: Maybe<
      { __typename?: "GroupCurriculum" } & FragmentGroupCurriculumFragment
    >;
  };

export type FragmentGroupCurriculumFragment = {
  __typename?: "GroupCurriculum";
} & Pick<
  GroupCurriculum,
  | "id"
  | "name"
  | "status"
  | "dateActiveStatus"
  | "dateInactiveStatus"
  | "createdAt"
  | "updatedAt"
  | "sequenceNumber"
  | "InstanceId"
  | "ActualFrom"
  | "ActualTo"
>;

export type FragmentEmailLogFragment = {
  __typename?: "EmailLogListItem";
} & Pick<
  EmailLogListItem,
  | "id"
  | "name"
  | "email"
  | "subject"
  | "customs"
  | "sent"
  | "decidedToSend"
  | "error"
  | "createdAt"
>;

export type FragmentStaffForLogsFragment = {
  __typename?: "EmployeeExpectation";
} & Pick<EmployeeExpectation, "method" | "isCombining" | "createdAt">;

export type FragmentGrRatingForLogsFragment = {
  __typename?: "GlobalRating";
} & Pick<
  GlobalRating,
  | "number"
  | "name"
  | "quarter1"
  | "quarter2"
  | "quarter1_2"
  | "quarter3"
  | "quarter2_3"
  | "quarter4"
  | "quarter3_4"
  | "type"
  | "sort"
  | "round"
  | "ParentId"
  | "PrevElementId"
  | "updatedAt"
  | "createdAt"
  | "RatingsVersionId"
> & {
    Parent?: Maybe<
      { __typename?: "GlobalRating" } & Pick<GlobalRating, "name">
    >;
  };

export type FragmentQDataForLogsFragment = {
  __typename?: "QuartilesRatingVersion";
} & Pick<QuartilesRatingVersion, "year" | "quarter" | "dateBegin"> & {
    Indicator?: Maybe<
      { __typename?: "Indicator" } & FragmentIndicatorForRatingFragment
    >;
    IndicatorGroup?: Maybe<
      { __typename?: "Indicator" } & FragmentIndicatorForRatingFragment
    >;
  };

export type FragmentQRatingForEditorLogsFragment = {
  __typename?: "QuartilesRating";
} & Pick<
  QuartilesRating,
  | "number"
  | "KPIru"
  | "KPIen"
  | "LastPeriodIndicatorId"
  | "ValueIndicatorId"
  | "GroupIndicatorId"
  | "AverageIndicatorId"
  | "DifferenceIndicatorId"
  | "GroupAverageIndicatorId"
  | "updatedAt"
> & {
    LastPeriodIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<Indicator, "period">
    >;
    ValueIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<Indicator, "period">
    >;
    GroupIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<Indicator, "period">
    >;
    AverageIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<Indicator, "period">
    >;
    DifferenceIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<Indicator, "period">
    >;
    GroupAverageIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<Indicator, "period">
    >;
  };

export type FragmentProfileForLogsFragment = { __typename?: "Profile" } & Pick<
  Profile,
  | "fullname"
  | "login"
  | "position"
  | "email"
  | "phone"
  | "role"
  | "countDC"
  | "lastOnlineDate"
  | "status"
  | "createdAt"
>;

export type FragmentAnnouncementForLogsFragment = {
  __typename?: "AnnouncementLog";
} & Pick<
  AnnouncementLog,
  | "id"
  | "importance"
  | "status"
  | "date"
  | "title"
  | "singedBy"
  | "canceledReason"
  | "SubdivisionId"
  | "createdBy"
  | "createdAt"
> & {
    Documents?: Maybe<
      Array<
        Maybe<
          { __typename?: "File" } & Pick<File, "link" | "name" | "mimeType">
        >
      >
    >;
  };

export type FragmentDocumentForLogsFragment = {
  __typename?: "DocumentLog";
} & Pick<
  DocumentLog,
  | "id"
  | "name"
  | "description"
  | "status"
  | "canceledReason"
  | "importance"
  | "signedBy"
  | "createdAt"
  | "updatedAt"
  | "createdBy"
  | "updatedBy"
  | "sectionId"
  | "subSectionId"
> & {
    Section?: Maybe<{ __typename?: "Section" } & CatalogFragment>;
    SubSection?: Maybe<{ __typename?: "Section" } & CatalogFragment>;
    Files?: Maybe<Array<Maybe<{ __typename?: "File" } & FragmentFileFragment>>>;
    Subdivision?: Maybe<
      { __typename?: "Subdivision" } & FragmentSubdivisionFragment
    >;
  };

export type FragmentSectionForLogsFragment = {
  __typename?: "SectionLog";
} & Pick<
  SectionLog,
  | "id"
  | "name"
  | "parentId"
  | "parentName"
  | "createdAt"
  | "updatedAt"
  | "createdBy"
  | "updatedBy"
>;

export type FragmentIndicatorReportForLogsFragment = {
  __typename?: "IndicatorReport";
} & Pick<
  IndicatorReport,
  | "id"
  | "nameRu"
  | "nameEn"
  | "status"
  | "createdBy"
  | "createdAt"
  | "updatedAt"
  | "GroupId"
  | "writtenBy"
> & {
    Group?: Maybe<
      { __typename?: "IndicatorGroup" } & FragmentIndicatorGroupsItemsFragment
    >;
    Indicators?: Maybe<
      Array<
        Maybe<{ __typename?: "Indicator" } & FragmentIndicatorForLogsFragment>
      >
    >;
    createdByUser?: Maybe<{ __typename?: "Profile" } & FragmentProfileFragment>;
    writtenByUser?: Maybe<{ __typename?: "Profile" } & FragmentProfileFragment>;
  };

export type FragmentIndicatorGroupForLogsFragment = {
  __typename?: "IndicatorGroup";
} & Pick<
  IndicatorGroup,
  | "id"
  | "nameRu"
  | "nameEn"
  | "status"
  | "createdAt"
  | "updatedAt"
  | "createdBy"
  | "writtenBy"
> & {
    Indicators?: Maybe<
      Array<
        Maybe<{ __typename?: "Indicator" } & FragmentIndicatorForLogsFragment>
      >
    >;
    createdByUser?: Maybe<{ __typename?: "Profile" } & FragmentProfileFragment>;
    writtenByUser?: Maybe<{ __typename?: "Profile" } & FragmentProfileFragment>;
  };

export type FragmentIndicatorAndReportFragment = {
  __typename?: "IndicatorAndReport";
} & Pick<IndicatorAndReport, "ReportId">;

export type FragmentCameraForLogsFragment = { __typename?: "CameraLog" } & Pick<
  CameraLog,
  | "id"
  | "name"
  | "cameraZoneId"
  | "cameraUrl"
  | "dealerId"
  | "createdAt"
  | "updatedAt"
  | "createdBy"
  | "updatedBy"
  | "CameraZone"
>;

export type FragmentCameraZoneForLogsFragment = {
  __typename?: "CameraZoneLog";
} & Pick<
  CameraZoneLog,
  "id" | "name" | "createdAt" | "updatedAt" | "createdBy" | "updatedBy"
>;

export type FragmentCameraCheckForLogsFragment = {
  __typename?: "CameraCheckLog";
} & Pick<
  CameraCheckLog,
  | "id"
  | "cameraId"
  | "status"
  | "name"
  | "createdAt"
  | "updatedAt"
  | "createdBy"
  | "updatedBy"
>;

export type FragmentCatalogCurriculumFragment = {
  __typename?: "CatalogCurriculum";
} & Pick<
  CatalogCurriculum,
  | "id"
  | "GroupId"
  | "LevelId"
  | "CourseId"
  | "createdAt"
  | "updatedAt"
  | "ActualFrom"
  | "ActualTo"
> & {
    Group?: Maybe<
      { __typename?: "GroupCurriculum" } & Pick<GroupCurriculum, "id" | "name">
    >;
    Level?: Maybe<
      { __typename?: "LevelCurriculum" } & Pick<LevelCurriculum, "id" | "name">
    >;
    Course?: Maybe<
      { __typename?: "CourseCurriculum" } & Pick<
        CourseCurriculum,
        "id" | "name"
      >
    >;
  };

export type FragmentCourseCurriculumFragment = {
  __typename?: "CourseCurriculum";
} & Pick<
  CourseCurriculum,
  | "id"
  | "name"
  | "code"
  | "codeIS"
  | "certificateValidityPeriod"
  | "LevelId"
  | "createdAt"
  | "updatedAt"
  | "InstanceId"
  | "ActualFrom"
  | "ActualTo"
> & { statusCourse: CourseCurriculum["status"] } & {
    Level?: Maybe<
      { __typename?: "LevelCurriculum" } & Pick<LevelCurriculum, "id" | "name">
    >;
  };

export type FragmentNotesFragment = {
  __typename?: "NotesIndicatorTypes";
} & Pick<
  NotesIndicatorTypes,
  "id" | "UUID" | "ActualFrom" | "ActualTo" | "Name" | "NameEn" | "Number"
> & {
    ComplianceIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    ImageIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
  };

export type FragmentNotesValuesFragment = {
  __typename?: "NotesOneValuesItem";
} & Pick<
  NotesOneValuesItem,
  | "id"
  | "UUID"
  | "ActualFrom"
  | "ActualTo"
  | "Compliance"
  | "Name"
  | "NameEn"
  | "Number"
  | "planReportId"
> & {
    Image?: Maybe<
      Array<
        Maybe<
          { __typename?: "File" } & Pick<
            File,
            "id" | "mimeType" | "name" | "hash" | "link" | "createdAt"
          >
        >
      >
    >;
  };

export type FragmentNotesDealerStatusesFragment = {
  __typename?: "NotesDealerStatuses";
} & Pick<
  NotesDealerStatuses,
  "DealerId" | "ZD_UUID" | "tableIndex" | "status" | "updatedAt"
> & {
    Dealer?: Maybe<
      { __typename?: "Dealer" } & Pick<
        Dealer,
        | "id"
        | "DealerName"
        | "DealerNameEn"
        | "city"
        | "cityEn"
        | "INN"
        | "code"
      >
    >;
  };

export type FragmentPersonalFragment = {
  __typename?: "PersonalIndicatorTypes";
} & Pick<
  PersonalIndicatorTypes,
  | "id"
  | "UUID"
  | "ActualFrom"
  | "ActualTo"
  | "Name"
  | "NameEn"
  | "Number"
  | "DocName"
> & {
    ComplianceIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    ImageIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    PersonNameIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    PositionIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    PositionStartIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    StudyCertificateDateIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
  };

export type FragmentPersonalValuesFragment = {
  __typename?: "PersonalOneValuesItem";
} & Pick<
  PersonalOneValuesItem,
  | "id"
  | "UUID"
  | "ActualFrom"
  | "ActualTo"
  | "Compliance"
  | "Name"
  | "NameEn"
  | "GroupOne"
  | "GroupTwo"
  | "Number"
  | "StudyCertificateDate"
  | "PersonName"
  | "Position"
  | "PositionStart"
  | "tableIndex"
  | "DealerId"
  | "planReportId"
  | "forUUID"
  | "isList"
  | "status"
  | "statusUpdatedAt"
  | "dealerValuesUpdatedAt"
  | "DocName"
> & {
    Image?: Maybe<
      Array<
        Maybe<
          { __typename?: "File" } & Pick<
            File,
            "id" | "name" | "link" | "mimeType" | "createdAt"
          > & {
              User?: Maybe<
                { __typename?: "Profile" } & Pick<
                  Profile,
                  "id" | "email" | "login" | "fullname" | "fullnameEn"
                >
              >;
            }
        >
      >
    >;
    list?: Maybe<
      Array<
        Maybe<
          { __typename?: "PersonalItemInZdForUUIDlist" } & Pick<
            PersonalItemInZdForUuiDlist,
            | "PersonName"
            | "Position"
            | "GroupOne"
            | "GroupTwo"
            | "PositionStart"
            | "id"
            | "UUID"
            | "ActualFrom"
            | "ActualTo"
            | "Compliance"
            | "Number"
            | "Name"
            | "NameEn"
            | "forUUID"
            | "StudyCertificateDate"
            | "planReportId"
            | "tableIndex"
            | "DealerId"
          > & {
              Image?: Maybe<
                Array<
                  Maybe<
                    { __typename?: "File" } & Pick<
                      File,
                      "id" | "name" | "link" | "mimeType"
                    > & {
                        User?: Maybe<
                          { __typename?: "Profile" } & Pick<
                            Profile,
                            "id" | "email" | "login" | "fullname" | "fullnameEn"
                          >
                        >;
                      }
                  >
                >
              >;
            }
        >
      >
    >;
    emptyList?: Maybe<
      Array<
        Maybe<
          { __typename?: "PersonalItemInZdForUUIDemptyList" } & Pick<
            PersonalItemInZdForUuiDemptyList,
            | "id"
            | "UUID"
            | "ActualFrom"
            | "GroupOne"
            | "GroupTwo"
            | "ActualTo"
            | "Compliance"
            | "Number"
            | "Name"
            | "forUUID"
            | "NameEn"
            | "PersonName"
            | "Position"
            | "PositionStart"
            | "StudyCertificateDate"
            | "planReportId"
            | "isList"
            | "status"
            | "statusUpdatedAt"
            | "dealerValuesUpdatedAt"
          > & {
              Image?: Maybe<
                Array<
                  Maybe<
                    { __typename?: "File" } & Pick<
                      File,
                      "id" | "name" | "link" | "mimeType"
                    > & {
                        User?: Maybe<
                          { __typename?: "Profile" } & Pick<
                            Profile,
                            "id" | "email" | "login" | "fullname" | "fullnameEn"
                          >
                        >;
                      }
                  >
                >
              >;
            }
        >
      >
    >;
  };

export type FragmentPersonalDealerStatusesFragment = {
  __typename?: "PersonalDealerStatuses";
} & Pick<
  PersonalDealerStatuses,
  "DealerId" | "ZD_UUID" | "tableIndex" | "status" | "updatedAt"
> & {
    Dealer?: Maybe<
      { __typename?: "Dealer" } & Pick<
        Dealer,
        | "id"
        | "DealerName"
        | "DealerNameEn"
        | "city"
        | "cityEn"
        | "INN"
        | "code"
      >
    >;
  };

export type FragmentPlacePostsFragment = {
  __typename?: "PlacePostsIndicatorTypes";
} & Pick<
  PlacePostsIndicatorTypes,
  "id" | "UUID" | "ActualFrom" | "ActualTo" | "Name" | "NameEn" | "ZD_PlacesId"
> & {
    ComplianceIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    TotalIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
  };

export type FragmentPlacePostsValuesFragment = {
  __typename?: "PlacePostsOneValuesItem";
} & Pick<
  PlacePostsOneValuesItem,
  | "id"
  | "UUID"
  | "ActualFrom"
  | "ActualTo"
  | "Compliance"
  | "Name"
  | "NameEn"
  | "ZD_PlacesId"
  | "Total"
  | "planReportId"
>;

export type FragmentPlacePostsDealerStatusesFragment = {
  __typename?: "PlacePostsDealerStatuses";
} & Pick<
  PlacePostsDealerStatuses,
  "DealerId" | "ZD_UUID" | "tableIndex" | "status" | "updatedAt"
> & {
    Dealer?: Maybe<
      { __typename?: "Dealer" } & Pick<
        Dealer,
        | "id"
        | "DealerName"
        | "DealerNameEn"
        | "city"
        | "cityEn"
        | "INN"
        | "code"
      >
    >;
  };

export type FragmentPlacesFragment = {
  __typename?: "PlacesIndicatorTypes";
} & Pick<
  PlacesIndicatorTypes,
  | "id"
  | "UUID"
  | "ActualFrom"
  | "ActualTo"
  | "Number"
  | "Name"
  | "NameEn"
  | "GroupOne"
> & {
    ComplianceIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    AreaIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    PlacesCombineIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
  };

export type FragmentPlacesValuesFragment = {
  __typename?: "PlacesOneValuesItem";
} & Pick<
  PlacesOneValuesItem,
  | "id"
  | "UUID"
  | "ActualFrom"
  | "ActualTo"
  | "Compliance"
  | "Number"
  | "GroupOne"
  | "Name"
  | "NameEn"
  | "Area"
  | "PlacesCombine"
  | "planReportId"
> & {
    list?: Maybe<
      Array<
        Maybe<
          { __typename?: "PlacesItemInZdForUUIDlist" } & Pick<
            PlacesItemInZdForUuiDlist,
            | "id"
            | "UUID"
            | "ActualFrom"
            | "ActualTo"
            | "Name"
            | "NameEn"
            | "forUUID"
            | "isList"
            | "sort"
            | "Compliance"
            | "Number"
            | "GroupOne"
            | "Area"
            | "PlacesCombine"
            | "status"
            | "statusUpdatedAt"
            | "dealerValuesUpdatedAt"
            | "planReportId"
          >
        >
      >
    >;
    emptyList?: Maybe<
      Array<
        Maybe<
          { __typename?: "PlacesItemInZdForUUIDemptyList" } & Pick<
            PlacesItemInZdForUuiDemptyList,
            | "id"
            | "UUID"
            | "ActualFrom"
            | "ActualTo"
            | "Name"
            | "NameEn"
            | "forUUID"
            | "isList"
            | "sort"
            | "Compliance"
            | "Number"
            | "GroupOne"
            | "Area"
            | "PlacesCombine"
            | "status"
            | "statusUpdatedAt"
            | "dealerValuesUpdatedAt"
            | "planReportId"
          >
        >
      >
    >;
  };

export type FragmentPlacesDealerStatusesFragment = {
  __typename?: "PlacesDealerStatuses";
} & Pick<
  PlacesDealerStatuses,
  "DealerId" | "ZD_UUID" | "tableIndex" | "status" | "updatedAt"
> & {
    Dealer?: Maybe<
      { __typename?: "Dealer" } & Pick<
        Dealer,
        | "id"
        | "DealerName"
        | "DealerNameEn"
        | "city"
        | "cityEn"
        | "INN"
        | "code"
      >
    >;
  };

export type FragmentPlanReportRowFragment = {
  __typename?: "PlanReportRow";
} & Pick<
  PlanReportRow,
  | "id"
  | "DealerId"
  | "DeclinedBy"
  | "tableIndex"
  | "ZD_UUID"
  | "isResolved"
  | "reason"
  | "fixExplanation"
  | "planToFixAt"
  | "fixedAt"
  | "resolvedAt"
  | "responsiblePersonContact"
  | "name"
  | "nameEn"
  | "fio"
  | "createdAt"
> & {
    Files?: Maybe<
      Array<
        Maybe<
          { __typename?: "File" } & Pick<
            File,
            "id" | "name" | "link" | "hash" | "mimeType" | "createdAt" | "type"
          > & {
              User?: Maybe<
                { __typename?: "Profile" } & Pick<
                  Profile,
                  | "id"
                  | "login"
                  | "fullname"
                  | "fullnameEn"
                  | "role"
                  | "roleEn"
                  | "roleRu"
                >
              >;
            }
        >
      >
    >;
  };

export type ListPositionsFragment = { __typename?: "getPositionListNew" } & {
  items?: Maybe<
    Array<
      Maybe<
        { __typename?: "Position" } & Pick<
          Position,
          | "id"
          | "code"
          | "name"
          | "nameEn"
          | "status"
          | "createdAt"
          | "updatedAt"
          | "InstanceId"
          | "ActualTo"
          | "ActualFrom"
          | "RequiredEmail"
          | "showInZd"
          | "jobDescriptionIsRequired"
        > & {
            Direction?: Maybe<
              { __typename?: "PositionDirections" } & Pick<
                PositionDirections,
                "id" | "name" | "status"
              >
            >;
          }
      >
    >
  >;
};

export type ListDirectionsFragment = { __typename?: "getDirections" } & {
  items?: Maybe<
    Array<
      Maybe<
        { __typename?: "PositionDirections" } & Pick<
          PositionDirections,
          "id" | "name" | "status" | "createdAt" | "updatedAt" | "role"
        >
      >
    >
  >;
};

export type FragmentGetPositionByIdFragment = {
  __typename?: "Position";
} & Pick<
  Position,
  | "id"
  | "code"
  | "name"
  | "nameEn"
  | "status"
  | "DirectionId"
  | "createdAt"
  | "updatedAt"
  | "InstanceId"
  | "ActualFrom"
  | "ActualTo"
  | "RequiredEmail"
  | "jobDescriptionIsRequired"
> & {
    Direction?: Maybe<
      { __typename?: "PositionDirections" } & Pick<
        PositionDirections,
        | "id"
        | "InstanceId"
        | "ActualFrom"
        | "ActualTo"
        | "name"
        | "status"
        | "createdAt"
        | "updatedAt"
        | "role"
      >
    >;
  };

export type FragmentPersonalInformationFragment = {
  __typename?: "PersonalInformation";
} & Pick<
  PersonalInformation,
  "id" | "name" | "createdAt" | "updatedAt" | "createdBy" | "UpdatedBy"
> & {
    File?: Maybe<
      { __typename?: "File" } & Pick<
        File,
        "id" | "name" | "link" | "mimeType" | "createdAt" | "type" | "hash"
      > & {
          User?: Maybe<
            { __typename?: "Profile" } & Pick<
              Profile,
              "id" | "login" | "email" | "fullname"
            >
          >;
        }
    >;
    InformationSystem?: Maybe<
      { __typename?: "InformationSystem" } & FragmentInformationSystemsFragment
    >;
  };

export type FragmentInformationSystemsFragment = {
  __typename?: "InformationSystem";
} & Pick<
  InformationSystem,
  "id" | "name" | "createdAt" | "updatedAt" | "createdBy" | "UpdatedBy"
> & {
    Positions?: Maybe<
      Array<
        Maybe<
          { __typename?: "InformationSystemPositions" } & Pick<
            InformationSystemPositions,
            "id" | "informationSystemId" | "positionId" | "createdAt"
          > & {
              Position?: Maybe<
                { __typename?: "Position" } & Pick<Position, "id" | "name">
              >;
            }
        >
      >
    >;
    CreatedByUser?: Maybe<
      { __typename?: "Profile" } & Pick<
        Profile,
        "id" | "login" | "email" | "fullname"
      >
    >;
  };

export type FragmentGetTemplateConsentsDataProcessingFragment = {
  __typename?: "PositionConsents";
} & Pick<PositionConsents, "name"> & {
    File?: Maybe<
      { __typename?: "File" } & Pick<
        File,
        "id" | "name" | "link" | "mimeType" | "createdAt" | "type" | "hash"
      > & {
          User?: Maybe<
            { __typename?: "Profile" } & Pick<
              Profile,
              "id" | "login" | "email" | "fullname"
            >
          >;
        }
    >;
  };

export type FragmentProfileFragment = { __typename?: "Profile" } & Pick<
  Profile,
  | "fullname"
  | "fullnameEn"
  | "login"
  | "position"
  | "email"
  | "phone"
  | "role"
  | "roleRu"
  | "roleEn"
  | "countDC"
  | "lastOnlineDate"
  | "id"
  | "status"
  | "createdAt"
  | "isEmployeeAccess"
  | "isViolationAccess"
  | "isAnnouncementsAccess"
  | "isCandidateAccess"
  | "ivideon_access"
  | "dnm_access"
  | "isZdAccess"
  | "isAnnouncementsSend"
  | "isAccountingAccess"
  | "SubdivisionId"
> & {
    Subdivision?: Maybe<
      { __typename?: "Subdivision" } & Pick<Subdivision, "id" | "name">
    >;
  };

export type FragmentProfileForTableFragment = { __typename?: "Profile" } & Pick<
  Profile,
  | "fullname"
  | "fullnameEn"
  | "login"
  | "position"
  | "positionEn"
  | "email"
  | "phone"
  | "role"
  | "roleEn"
  | "roleRu"
  | "countDC"
  | "status"
  | "lastOnlineDate"
  | "id"
  | "isEmployeeAccess"
  | "isViolationAccess"
  | "isAnnouncementsAccess"
  | "isTemporaryAccessToAllDealers"
  | "isZdAccess"
  | "isAnnouncementsSend"
  | "isAccountingAccess"
  | "ivideon_access"
  | "dnm_access"
  | "isDocumentsAccess"
  | "isCandidateAccess"
  | "isCameraAccess"
  | "isTrustedPersonAccess"
  | "SubdivisionId"
> & {
    Subdivision?: Maybe<
      { __typename?: "Subdivision" } & Pick<Subdivision, "id" | "name">
    >;
  };

export type FragmentProfileForHeaderFragment = {
  __typename?: "Profile";
} & Pick<
  Profile,
  | "fullname"
  | "fullnameEn"
  | "login"
  | "role"
  | "roleEn"
  | "roleRu"
  | "id"
  | "isEmployeeAccess"
  | "isViolationAccess"
  | "isZdAccess"
  | "isAnnouncementsAccess"
  | "isTemporaryAccessToAllDealers"
  | "isDocumentsAccess"
  | "isAccountingAccess"
  | "isAnnouncementsSend"
  | "isCameraAccess"
  | "isCandidateAccess"
  | "isTrustedPersonAccess"
  | "SubdivisionId"
  | "lockDate"
  | "email"
  | "ivideon_access"
  | "dnm_access"
>;

export type FragmentProfileForViolationFragment = {
  __typename?: "Profile";
} & Pick<Profile, "fullname" | "fullnameEn" | "roleEn" | "roleRu" | "id">;

export type FragmentReportRegMenByDealerByPeriodFragment = {
  __typename?: "ReportRegMenByDealerByPeriod";
} & Pick<
  ReportRegMenByDealerByPeriod,
  | "dealerId"
  | "INN"
  | "filial"
  | "DealerName"
  | "FO"
  | "subject"
  | "city"
  | "entfCode"
  | "successorCode"
  | "entfSuccessorCode"
  | "entfSuccessorNo"
  | "leaderRegionalSalesManager"
  | "regionalSalesManager"
  | "leaderRegionalServiceManager"
  | "regionalServiceManager"
>;

export type FragmentReportRegMenByDealerByRegMenFragment = {
  __typename?: "ReportRegMenByDealerByRegMen";
} & Pick<
  ReportRegMenByDealerByRegMen,
  | "quarter"
  | "year"
  | "DealerName"
  | "INN"
  | "filial"
  | "FO"
  | "subject"
  | "city"
  | "entfCode"
  | "successorCode"
  | "entfSuccessorNo"
  | "entfSuccessorCode"
>;

export type FragmentReportRegMenByDealerByDealerFragment = {
  __typename?: "ReportRegMenByDealerByDealer";
} & Pick<
  ReportRegMenByDealerByDealer,
  | "quarter"
  | "year"
  | "leaderRegionalSalesManager"
  | "regionalSalesManager"
  | "leaderRegionalServiceManager"
  | "regionalServiceManager"
>;

export type FragmentReportRegMenByDealerConsolidateFragment = {
  __typename?: "ReportRegMenByDealerConsolidate";
} & Pick<
  ReportRegMenByDealerConsolidate,
  "regionalManager" | "role" | "periods"
> & {
    statistic?: Maybe<
      Array<
        Maybe<
          { __typename?: "Statistic" } & Pick<
            Statistic,
            "quarter" | "year" | "counts"
          >
        >
      >
    >;
  };

export type FragmentQuartilesRatingVersionForTableFragment = {
  __typename?: "QuartilesRatingVersion";
} & Pick<
  QuartilesRatingVersion,
  "id" | "quarter" | "year" | "dateBegin" | "IndicatorId" | "IndicatorGroupId"
>;

export type FragmentQRatingForEditorTableFragment = {
  __typename?: "QuartilesRating";
} & Pick<
  QuartilesRating,
  | "id"
  | "number"
  | "KPIru"
  | "KPIen"
  | "LastPeriodIndicatorId"
  | "ValueIndicatorId"
  | "GroupIndicatorId"
  | "AverageIndicatorId"
  | "DifferenceIndicatorId"
  | "GroupAverageIndicatorId"
  | "updatedAt"
  | "sort"
  | "format"
  | "round"
  | "type"
  | "ParentId"
  | "PrevElementId"
> & {
    LastPeriodIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    ValueIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    GroupIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    AverageIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    DifferenceIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    GroupAverageIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    Parent?: Maybe<
      { __typename?: "QuartilesRating" } & Pick<
        QuartilesRating,
        "KPIen" | "KPIru"
      >
    >;
    PrevElement?: Maybe<
      { __typename?: "QuartilesRating" } & Pick<
        QuartilesRating,
        "KPIen" | "KPIru"
      >
    >;
  };

export type FragmentRatingsListNameFragment = {
  __typename?: "QuartilesRatingName";
} & Pick<
  QuartilesRatingName,
  | "id"
  | "KPIen"
  | "KPIru"
  | "number"
  | "ParentId"
  | "PrevElementId"
  | "RatingsVersionId"
>;

export type FragmentQRatingForTableFragment = {
  __typename?: "QuartilesRating";
} & Pick<
  QuartilesRating,
  "id" | "number" | "KPIru" | "KPIen" | "round" | "format" | "type" | "ParentId"
> & {
    LastPeriodIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<Indicator, "period"> & {
          Values?: Maybe<
            Array<
              Maybe<
                { __typename?: "IndicatorValue" } & Pick<
                  IndicatorValue,
                  "createdAt"
                >
              >
            >
          >;
        }
    >;
    ValueIndicator?: Maybe<
      { __typename?: "Indicator" } & FragmentIndicatorForRatingFragment
    >;
    GroupIndicator?: Maybe<
      { __typename?: "Indicator" } & FragmentIndicatorForRatingFragment
    >;
    AverageIndicator?: Maybe<
      { __typename?: "Indicator" } & FragmentIndicatorForRatingFragment
    >;
    DifferenceIndicator?: Maybe<
      { __typename?: "Indicator" } & FragmentIndicatorForRatingFragment
    >;
    GroupAverageIndicator?: Maybe<
      { __typename?: "Indicator" } & FragmentIndicatorForRatingFragment
    >;
  };

export type FragmentQRatingForChartFragment = {
  __typename?: "QuartilesRating";
} & Pick<QuartilesRating, "round" | "format" | "KPIen" | "KPIru"> & {
    LastPeriodIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<Indicator, "period"> & {
          Values?: Maybe<
            Array<
              Maybe<
                { __typename?: "IndicatorValue" } & Pick<
                  IndicatorValue,
                  "doubleValue" | "stringValue" | "createdAt"
                >
              >
            >
          >;
        }
    >;
    ValueIndicator?: Maybe<
      { __typename?: "Indicator" } & {
        Values?: Maybe<
          Array<
            Maybe<
              { __typename?: "IndicatorValue" } & Pick<
                IndicatorValue,
                "doubleValue" | "stringValue" | "createdAt"
              >
            >
          >
        >;
      }
    >;
    GroupIndicator?: Maybe<
      { __typename?: "Indicator" } & {
        Values?: Maybe<
          Array<
            Maybe<
              { __typename?: "IndicatorValue" } & Pick<
                IndicatorValue,
                "doubleValue" | "stringValue" | "createdAt"
              >
            >
          >
        >;
      }
    >;
    AverageIndicator?: Maybe<
      { __typename?: "Indicator" } & {
        Values?: Maybe<
          Array<
            Maybe<
              { __typename?: "IndicatorValue" } & Pick<
                IndicatorValue,
                "doubleValue" | "stringValue" | "createdAt"
              >
            >
          >
        >;
      }
    >;
    DifferenceIndicator?: Maybe<
      { __typename?: "Indicator" } & {
        Values?: Maybe<
          Array<
            Maybe<
              { __typename?: "IndicatorValue" } & Pick<
                IndicatorValue,
                "doubleValue" | "stringValue" | "createdAt"
              >
            >
          >
        >;
      }
    >;
    GroupAverageIndicator?: Maybe<
      { __typename?: "Indicator" } & {
        Values?: Maybe<
          Array<
            Maybe<
              { __typename?: "IndicatorValue" } & Pick<
                IndicatorValue,
                "doubleValue" | "stringValue" | "createdAt"
              >
            >
          >
        >;
      }
    >;
  };

export type FragmentQDataForTableFragment = {
  __typename?: "QuartilesRatingVersion";
} & Pick<QuartilesRatingVersion, "id" | "year" | "quarter" | "dateBegin"> & {
    Indicator?: Maybe<
      { __typename?: "Indicator" } & Pick<Indicator, "period"> & {
          Values?: Maybe<
            Array<
              Maybe<
                { __typename?: "IndicatorValue" } & Pick<
                  IndicatorValue,
                  "createdAt"
                >
              >
            >
          >;
        } & FragmentIndicatorForRatingFragment
    >;
    IndicatorGroup?: Maybe<
      { __typename?: "Indicator" } & {
        Values?: Maybe<
          Array<
            Maybe<
              { __typename?: "IndicatorValue" } & Pick<
                IndicatorValue,
                "createdAt"
              >
            >
          >
        >;
      } & FragmentIndicatorForRatingFragment
    >;
  };

export type FragmentRequiredToolsFragment = {
  __typename?: "RequiredToolsIndicatorTypes";
} & Pick<
  RequiredToolsIndicatorTypes,
  "id" | "UUID" | "ActualFrom" | "ActualTo" | "Number" | "Name" | "NameEn"
> & {
    ComplianceIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    ModelIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    TotalIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    CheckedDateIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
  };

export type FragmentRequiredToolsValuesFragment = {
  __typename?: "RequiredToolsOneValuesItem";
} & Pick<
  RequiredToolsOneValuesItem,
  | "id"
  | "UUID"
  | "ActualFrom"
  | "ActualTo"
  | "Compliance"
  | "Number"
  | "Name"
  | "NameEn"
  | "Total"
  | "Model"
  | "planReportId"
  | "forUUID"
  | "GroupOne"
  | "isList"
  | "status"
  | "sort"
  | "statusUpdatedAt"
  | "dealerValuesUpdatedAt"
  | "tableIndex"
  | "DealerId"
> & {
    list?: Maybe<
      Array<
        Maybe<
          { __typename?: "RequiredToolsItemInZdForUUIDlist" } & Pick<
            RequiredToolsItemInZdForUuiDlist,
            | "id"
            | "UUID"
            | "ActualFrom"
            | "ActualTo"
            | "Compliance"
            | "Number"
            | "Name"
            | "NameEn"
            | "Total"
            | "Model"
            | "planReportId"
            | "forUUID"
            | "isList"
            | "status"
            | "statusUpdatedAt"
            | "dealerValuesUpdatedAt"
            | "CheckedDate"
            | "tableIndex"
            | "DealerId"
          >
        >
      >
    >;
    emptyList?: Maybe<
      Array<
        Maybe<
          { __typename?: "RequiredToolsItemInZdForUUIDemptyList" } & Pick<
            RequiredToolsItemInZdForUuiDemptyList,
            | "id"
            | "UUID"
            | "ActualFrom"
            | "ActualTo"
            | "Compliance"
            | "Number"
            | "Name"
            | "NameEn"
            | "Total"
            | "Model"
            | "planReportId"
            | "forUUID"
            | "isList"
            | "status"
            | "statusUpdatedAt"
            | "dealerValuesUpdatedAt"
            | "tableIndex"
          >
        >
      >
    >;
  };

export type FragmentRequiredToolsDealerStatusesFragment = {
  __typename?: "RequiredToolsDealerStatuses";
} & Pick<
  RequiredToolsDealerStatuses,
  "DealerId" | "ZD_UUID" | "tableIndex" | "status" | "updatedAt"
> & {
    Dealer?: Maybe<
      { __typename?: "Dealer" } & Pick<
        Dealer,
        | "id"
        | "DealerName"
        | "DealerNameEn"
        | "city"
        | "cityEn"
        | "INN"
        | "code"
      >
    >;
  };

export type FragmentLogForZdRequiredToolsFragment = {
  __typename?: "ZdRequiredToolsType";
} & Pick<
  ZdRequiredToolsType,
  | "UUID"
  | "tableIndex"
  | "name"
  | "nameEn"
  | "Model"
  | "Total"
  | "CheckedDate"
  | "Compliance"
>;

export type FragmentCarForServiceByMonthFragment = {
  __typename?: "CarForServiceByMonth";
} & {
  dealer?: Maybe<
    Array<
      Maybe<
        { __typename?: "dealerForServiceByMonth" } & Pick<
          DealerForServiceByMonth,
          | "id"
          | "code"
          | "ent_id"
          | "INN"
          | "birCode"
          | "entfSuccessorCode"
          | "entfSuccessorNo"
          | "city"
          | "FO"
          | "DealerName"
          | "subject"
          | "counts"
          | "family"
        > & {
            TO0?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO1?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO2?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO3?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO4?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO5?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO6?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO7?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO8?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
          }
      >
    >
  >;
  city?: Maybe<
    Array<
      Maybe<
        { __typename?: "cityForServiceByMonth" } & Pick<
          CityForServiceByMonth,
          | "city"
          | "cityEn"
          | "subject"
          | "subjectEn"
          | "counts"
          | "FO"
          | "family"
        > & {
            TO0?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO1?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO2?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO3?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO4?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO5?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO6?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO7?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO8?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
          }
      >
    >
  >;
  FO?: Maybe<
    Array<
      Maybe<
        { __typename?: "FOForServiceByMonth" } & Pick<
          FoForServiceByMonth,
          "FO" | "FOEn" | "counts" | "family"
        > & {
            TO0?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO1?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO2?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO3?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO4?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO5?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO6?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO7?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO8?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
          }
      >
    >
  >;
  country?: Maybe<
    Array<
      Maybe<
        { __typename?: "countryForServiceByMonth" } & Pick<
          CountryForServiceByMonth,
          "country" | "countryEn" | "counts" | "family"
        > & {
            TO0?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO1?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO2?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO3?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO4?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO5?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO6?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO7?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO8?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
          }
      >
    >
  >;
  region?: Maybe<
    Array<
      Maybe<
        { __typename?: "regionForServiceByMonth" } & Pick<
          RegionForServiceByMonth,
          "subject" | "subjectEn" | "counts" | "FO" | "family"
        > & {
            TO0?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO1?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO2?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO3?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO4?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO5?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO6?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO7?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
            TO8?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                | "cars"
                | "carsForeign"
                | "saleCount"
                | "carsCityGIBDD"
                | "carsRegionGIBDD"
                | "carsAllRegionGIBDD"
              >
            >;
          }
      >
    >
  >;
};

export type FragmentFamilyCarFragment = { __typename?: "familyCar" } & Pick<
  FamilyCar,
  "id" | "name" | "code" | "actual"
>;

export type FragmentSalesCarFragment = { __typename?: "SalesCar" } & Pick<
  SalesCar,
  | "dateSales"
  | "price"
  | "sellerName"
  | "sellerPosition"
  | "carId"
  | "clientId"
  | "dealerId"
  | "createdAt"
  | "updatedAt"
> & {
    Car?: Maybe<
      { __typename?: "Car" } & Pick<
        Car,
        | "vin"
        | "collection"
        | "engine"
        | "eqFamilyCode"
        | "eqNumber"
        | "eqVariant"
        | "createdAt"
        | "updatedAt"
      >
    >;
  };

export type FragmentNsDealerDataPeriodsDataFragment = {
  __typename?: "NSDealerDataPeriodsData";
} & Pick<
  NsDealerDataPeriodsData,
  | "periodStart"
  | "periodEnd"
  | "periodStr"
  | "soldCars"
  | "soldCarsToNewClients"
  | "percentNewClients"
  | "soldCarsToLoyalClients"
  | "soldCarsToLoyalClientsMoney"
  | "percentLoyalClients"
  | "twoCars"
  | "percentTwoCars"
  | "threeCars"
  | "percentThreeCars"
  | "fourOrMoreCars"
  | "percentFourOrMoreCars"
>;

export type FragmentCarsForServiceByPeriodConsolidatedFragment = {
  __typename?: "CarsForServiceByPeriodConsolidated";
} & {
  sales?: Maybe<
    Array<
      Maybe<
        { __typename?: "CarForServiceByPeriodConsolidated" } & {
          cars?: Maybe<
            { __typename?: "CarsConsolidated" } & Pick<
              CarsConsolidated,
              | "vin"
              | "eqFamilyCode"
              | "eqNumber"
              | "eqVariant"
              | "dateSales"
              | "familyCar"
            >
          >;
          client?: Maybe<
            { __typename?: "ClientConsolidated" } & Pick<
              ClientConsolidated,
              "name" | "phone" | "email"
            >
          >;
          dealer?: Maybe<
            { __typename?: "DealerConsolidated" } & Pick<
              DealerConsolidated,
              "name" | "inn" | "dealerId" | "city"
            >
          >;
          TO0?: Maybe<
            { __typename?: "TOConsolidated" } & Pick<
              ToConsolidated,
              "name" | "inn" | "dealerId" | "dateVisit" | "countDay"
            >
          >;
          TO1?: Maybe<
            { __typename?: "TOConsolidated" } & Pick<
              ToConsolidated,
              "name" | "inn" | "dealerId" | "dateVisit" | "countDay"
            >
          >;
          TO2?: Maybe<
            { __typename?: "TOConsolidated" } & Pick<
              ToConsolidated,
              "name" | "inn" | "dealerId" | "dateVisit" | "countDay"
            >
          >;
          TO3?: Maybe<
            { __typename?: "TOConsolidated" } & Pick<
              ToConsolidated,
              "name" | "inn" | "dealerId" | "dateVisit" | "countDay"
            >
          >;
          TO4?: Maybe<
            { __typename?: "TOConsolidated" } & Pick<
              ToConsolidated,
              "name" | "inn" | "dealerId" | "dateVisit" | "countDay"
            >
          >;
          TO5?: Maybe<
            { __typename?: "TOConsolidated" } & Pick<
              ToConsolidated,
              "name" | "inn" | "dealerId" | "dateVisit" | "countDay"
            >
          >;
          TO6?: Maybe<
            { __typename?: "TOConsolidated" } & Pick<
              ToConsolidated,
              "name" | "inn" | "dealerId" | "dateVisit" | "countDay"
            >
          >;
          TO7?: Maybe<
            { __typename?: "TOConsolidated" } & Pick<
              ToConsolidated,
              "name" | "inn" | "dealerId" | "dateVisit" | "countDay"
            >
          >;
          TO8?: Maybe<
            { __typename?: "TOConsolidated" } & Pick<
              ToConsolidated,
              "name" | "inn" | "dealerId" | "dateVisit" | "countDay"
            >
          >;
        }
      >
    >
  >;
};

export type FragmentCarsForServiceByMonthRegionFragment = {
  __typename?: "CarsForServiceByMonthRegion";
} & {
  cars?: Maybe<
    Array<
      Maybe<
        { __typename?: "CarsForServiceByMonth" } & {
          model?: Maybe<
            { __typename?: "familyCar" } & Pick<
              FamilyCar,
              "id" | "name" | "code" | "actual"
            >
          >;
          TO0?: Maybe<
            { __typename?: "TOForServiceByMonthByCarModelRegion" } & Pick<
              ToForServiceByMonthByCarModelRegion,
              "salesCount" | "servicesCount"
            >
          >;
          TO1?: Maybe<
            { __typename?: "TOForServiceByMonthByCarModelRegion" } & Pick<
              ToForServiceByMonthByCarModelRegion,
              "salesCount" | "servicesCount"
            >
          >;
          TO2?: Maybe<
            { __typename?: "TOForServiceByMonthByCarModelRegion" } & Pick<
              ToForServiceByMonthByCarModelRegion,
              "salesCount" | "servicesCount"
            >
          >;
          TO3?: Maybe<
            { __typename?: "TOForServiceByMonthByCarModelRegion" } & Pick<
              ToForServiceByMonthByCarModelRegion,
              "salesCount" | "servicesCount"
            >
          >;
          TO4?: Maybe<
            { __typename?: "TOForServiceByMonthByCarModelRegion" } & Pick<
              ToForServiceByMonthByCarModelRegion,
              "salesCount" | "servicesCount"
            >
          >;
          TO5?: Maybe<
            { __typename?: "TOForServiceByMonthByCarModelRegion" } & Pick<
              ToForServiceByMonthByCarModelRegion,
              "salesCount" | "servicesCount"
            >
          >;
          TO6?: Maybe<
            { __typename?: "TOForServiceByMonthByCarModelRegion" } & Pick<
              ToForServiceByMonthByCarModelRegion,
              "salesCount" | "servicesCount"
            >
          >;
          TO7?: Maybe<
            { __typename?: "TOForServiceByMonthByCarModelRegion" } & Pick<
              ToForServiceByMonthByCarModelRegion,
              "salesCount" | "servicesCount"
            >
          >;
          TO8?: Maybe<
            { __typename?: "TOForServiceByMonthByCarModelRegion" } & Pick<
              ToForServiceByMonthByCarModelRegion,
              "salesCount" | "servicesCount"
            >
          >;
        }
      >
    >
  >;
  models?: Maybe<
    Array<
      Maybe<
        { __typename?: "familyCar" } & Pick<
          FamilyCar,
          "id" | "name" | "actual" | "code"
        >
      >
    >
  >;
};

export type FragmentCarForAgoByMonthFragment = {
  __typename?: "CarForAGOByMonth";
} & {
  dealer?: Maybe<
    Array<
      Maybe<
        { __typename?: "dealerForAGOByMonth" } & Pick<
          DealerForAgoByMonth,
          | "id"
          | "code"
          | "ent_id"
          | "INN"
          | "birCode"
          | "entfSuccessorCode"
          | "entfSuccessorNo"
          | "city"
          | "FO"
          | "DealerName"
          | "subject"
          | "counts"
        > & {
            GO1?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                "cars" | "carsForeign" | "saleCount"
              >
            >;
            GO2?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                "cars" | "carsForeign" | "saleCount"
              >
            >;
            GO3?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                "cars" | "carsForeign" | "saleCount"
              >
            >;
          }
      >
    >
  >;
  city?: Maybe<
    Array<
      Maybe<
        { __typename?: "cityForAGOByMonth" } & Pick<
          CityForAgoByMonth,
          "city" | "cityEn" | "subject" | "subjectEn" | "counts" | "FO"
        > & {
            GO1?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                "cars" | "carsForeign" | "saleCount"
              >
            >;
            GO2?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                "cars" | "carsForeign" | "saleCount"
              >
            >;
            GO3?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                "cars" | "carsForeign" | "saleCount"
              >
            >;
          }
      >
    >
  >;
  FO?: Maybe<
    Array<
      Maybe<
        { __typename?: "FOForAGOByMonth" } & Pick<
          FoForAgoByMonth,
          "FO" | "FOEn" | "counts"
        > & {
            GO1?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                "cars" | "carsForeign" | "saleCount"
              >
            >;
            GO2?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                "cars" | "carsForeign" | "saleCount"
              >
            >;
            GO3?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                "cars" | "carsForeign" | "saleCount"
              >
            >;
          }
      >
    >
  >;
  country?: Maybe<
    Array<
      Maybe<
        { __typename?: "countryForAGOByMonth" } & Pick<
          CountryForAgoByMonth,
          "country" | "countryEn" | "counts"
        > & {
            GO1?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                "cars" | "carsForeign" | "saleCount"
              >
            >;
            GO2?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                "cars" | "carsForeign" | "saleCount"
              >
            >;
            GO3?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                "cars" | "carsForeign" | "saleCount"
              >
            >;
          }
      >
    >
  >;
  region?: Maybe<
    Array<
      Maybe<
        { __typename?: "regionForAGOByMonth" } & Pick<
          RegionForAgoByMonth,
          "subject" | "subjectEn" | "counts" | "FO"
        > & {
            GO1?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                "cars" | "carsForeign" | "saleCount"
              >
            >;
            GO2?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                "cars" | "carsForeign" | "saleCount"
              >
            >;
            GO3?: Maybe<
              { __typename?: "TOForServiceByMonth" } & Pick<
                ToForServiceByMonth,
                "cars" | "carsForeign" | "saleCount"
              >
            >;
          }
      >
    >
  >;
};

export type FragmentCarForServiceDynamicsFragment = {
  __typename?: "CarForServiceDynamics";
} & {
  data?: Maybe<
    Array<
      Maybe<
        { __typename?: "dealerForServiceDynamics" } & Pick<
          DealerForServiceDynamics,
          | "period"
          | "TO0"
          | "TO1"
          | "TO2"
          | "TO3"
          | "TO4"
          | "TO5"
          | "TO6"
          | "TO7"
          | "TO8"
          | "AllTO"
          | "Warranty"
          | "writ"
        >
      >
    >
  >;
};

export type FragmentCarForSrr3ByPeriodFragment = {
  __typename?: "CarForSRR3ByPeriod";
} & Pick<CarForSrr3ByPeriod, "period"> & {
    TO1?: Maybe<
      { __typename?: "TOForSRR" } & Pick<ToForSrr, "saleCount" | "serviceCount">
    >;
    TO2?: Maybe<
      { __typename?: "TOForSRR" } & Pick<ToForSrr, "saleCount" | "serviceCount">
    >;
    TO3?: Maybe<
      { __typename?: "TOForSRR" } & Pick<ToForSrr, "saleCount" | "serviceCount">
    >;
    SRR?: Maybe<
      { __typename?: "TOForSRR" } & Pick<ToForSrr, "saleCount" | "serviceCount">
    >;
  };

export type FragmentCarForSrr5ByPeriodFragment = {
  __typename?: "CarForSRR5ByPeriod";
} & Pick<CarForSrr5ByPeriod, "period"> & {
    TO1?: Maybe<
      { __typename?: "TOForSRR" } & Pick<ToForSrr, "saleCount" | "serviceCount">
    >;
    TO2?: Maybe<
      { __typename?: "TOForSRR" } & Pick<ToForSrr, "saleCount" | "serviceCount">
    >;
    TO3?: Maybe<
      { __typename?: "TOForSRR" } & Pick<ToForSrr, "saleCount" | "serviceCount">
    >;
    TO4?: Maybe<
      { __typename?: "TOForSRR" } & Pick<ToForSrr, "saleCount" | "serviceCount">
    >;
    TO5?: Maybe<
      { __typename?: "TOForSRR" } & Pick<ToForSrr, "saleCount" | "serviceCount">
    >;
    SRR?: Maybe<
      { __typename?: "TOForSRR" } & Pick<ToForSrr, "saleCount" | "serviceCount">
    >;
  };

export type FragmentClientsWithoutServiceFragment = {
  __typename?: "ClientsWithoutService";
} & Pick<
  ClientsWithoutService,
  "percent" | "period" | "monthSale" | "countCar" | "withoutServices"
>;

export type FragmentdealerForServiceByMonthFragment = {
  __typename?: "dealerForServiceByMonth";
} & Pick<
  DealerForServiceByMonth,
  | "id"
  | "code"
  | "ent_id"
  | "INN"
  | "birCode"
  | "entfSuccessorCode"
  | "entfSuccessorNo"
  | "city"
  | "FO"
  | "DealerName"
  | "subject"
  | "counts"
> & {
    TO0?: Maybe<
      { __typename?: "TOForServiceByMonth" } & Pick<
        ToForServiceByMonth,
        | "cars"
        | "carsForeign"
        | "saleCount"
        | "carsCityGIBDD"
        | "carsRegionGIBDD"
        | "carsAllRegionGIBDD"
      >
    >;
    TO1?: Maybe<
      { __typename?: "TOForServiceByMonth" } & Pick<
        ToForServiceByMonth,
        | "cars"
        | "carsForeign"
        | "saleCount"
        | "carsCityGIBDD"
        | "carsRegionGIBDD"
        | "carsAllRegionGIBDD"
      >
    >;
    TO2?: Maybe<
      { __typename?: "TOForServiceByMonth" } & Pick<
        ToForServiceByMonth,
        | "cars"
        | "carsForeign"
        | "saleCount"
        | "carsCityGIBDD"
        | "carsRegionGIBDD"
        | "carsAllRegionGIBDD"
      >
    >;
    TO3?: Maybe<
      { __typename?: "TOForServiceByMonth" } & Pick<
        ToForServiceByMonth,
        | "cars"
        | "carsForeign"
        | "saleCount"
        | "carsCityGIBDD"
        | "carsRegionGIBDD"
        | "carsAllRegionGIBDD"
      >
    >;
    TO4?: Maybe<
      { __typename?: "TOForServiceByMonth" } & Pick<
        ToForServiceByMonth,
        | "cars"
        | "carsForeign"
        | "saleCount"
        | "carsCityGIBDD"
        | "carsRegionGIBDD"
        | "carsAllRegionGIBDD"
      >
    >;
    TO5?: Maybe<
      { __typename?: "TOForServiceByMonth" } & Pick<
        ToForServiceByMonth,
        | "cars"
        | "carsForeign"
        | "saleCount"
        | "carsCityGIBDD"
        | "carsRegionGIBDD"
        | "carsAllRegionGIBDD"
      >
    >;
    TO6?: Maybe<
      { __typename?: "TOForServiceByMonth" } & Pick<
        ToForServiceByMonth,
        | "cars"
        | "carsForeign"
        | "saleCount"
        | "carsCityGIBDD"
        | "carsRegionGIBDD"
        | "carsAllRegionGIBDD"
      >
    >;
    TO7?: Maybe<
      { __typename?: "TOForServiceByMonth" } & Pick<
        ToForServiceByMonth,
        | "cars"
        | "carsForeign"
        | "saleCount"
        | "carsCityGIBDD"
        | "carsRegionGIBDD"
        | "carsAllRegionGIBDD"
      >
    >;
    TO8?: Maybe<
      { __typename?: "TOForServiceByMonth" } & Pick<
        ToForServiceByMonth,
        | "cars"
        | "carsForeign"
        | "saleCount"
        | "carsCityGIBDD"
        | "carsRegionGIBDD"
        | "carsAllRegionGIBDD"
      >
    >;
  };

export type FragmentCarsForAverageDailyMileageByMonthFragment = {
  __typename?: "CarsForAverageDailyMileageByMonth";
} & {
  model?: Maybe<
    { __typename?: "familyCar" } & Pick<
      FamilyCar,
      "id" | "name" | "code" | "actual"
    >
  >;
  TO0?: Maybe<
    { __typename?: "TOForAverageDailyMileageByMonth" } & Pick<
      ToForAverageDailyMileageByMonth,
      "countCar" | "averageDay" | "mileage"
    >
  >;
  TO1?: Maybe<
    { __typename?: "TOForAverageDailyMileageByMonth" } & Pick<
      ToForAverageDailyMileageByMonth,
      "countCar" | "averageDay" | "mileage"
    >
  >;
  TO2?: Maybe<
    { __typename?: "TOForAverageDailyMileageByMonth" } & Pick<
      ToForAverageDailyMileageByMonth,
      "countCar" | "averageDay" | "mileage"
    >
  >;
  TO3?: Maybe<
    { __typename?: "TOForAverageDailyMileageByMonth" } & Pick<
      ToForAverageDailyMileageByMonth,
      "countCar" | "averageDay" | "mileage"
    >
  >;
  TO4?: Maybe<
    { __typename?: "TOForAverageDailyMileageByMonth" } & Pick<
      ToForAverageDailyMileageByMonth,
      "countCar" | "averageDay" | "mileage"
    >
  >;
  TO5?: Maybe<
    { __typename?: "TOForAverageDailyMileageByMonth" } & Pick<
      ToForAverageDailyMileageByMonth,
      "countCar" | "averageDay" | "mileage"
    >
  >;
  TO6?: Maybe<
    { __typename?: "TOForAverageDailyMileageByMonth" } & Pick<
      ToForAverageDailyMileageByMonth,
      "countCar" | "averageDay" | "mileage"
    >
  >;
  TO7?: Maybe<
    { __typename?: "TOForAverageDailyMileageByMonth" } & Pick<
      ToForAverageDailyMileageByMonth,
      "countCar" | "averageDay" | "mileage"
    >
  >;
  TO8?: Maybe<
    { __typename?: "TOForAverageDailyMileageByMonth" } & Pick<
      ToForAverageDailyMileageByMonth,
      "countCar" | "averageDay" | "mileage"
    >
  >;
};

export type FragmentCarForServiceByDealerFragment = {
  __typename?: "CarForServiceByDealer";
} & {
  dealer?: Maybe<
    Array<
      Maybe<
        { __typename?: "dealerForServiceByDealer" } & Pick<
          DealerForServiceByDealer,
          | "id"
          | "code"
          | "ent_id"
          | "INN"
          | "birCode"
          | "entfSuccessorCode"
          | "entfSuccessorNo"
          | "city"
          | "FO"
          | "DealerName"
          | "subject"
        > & {
            periods?: Maybe<
              Array<
                Maybe<
                  { __typename?: "TOPeriod" } & Pick<ToPeriod, "period"> & {
                      TO?: Maybe<
                        { __typename?: "TOData" } & Pick<
                          ToData,
                          | "TO0"
                          | "TO1"
                          | "TO2"
                          | "TO3"
                          | "TO4"
                          | "TO5"
                          | "TO6"
                          | "TO7"
                          | "TO8"
                          | "AllTO"
                          | "Warranty"
                          | "writ"
                        >
                      >;
                    }
                >
              >
            >;
          }
      >
    >
  >;
  city?: Maybe<
    Array<
      Maybe<
        { __typename?: "cityForServiceByDealer" } & Pick<
          CityForServiceByDealer,
          "city" | "FO" | "subject"
        > & {
            periods?: Maybe<
              Array<
                Maybe<
                  { __typename?: "TOPeriod" } & Pick<ToPeriod, "period"> & {
                      TO?: Maybe<
                        { __typename?: "TOData" } & Pick<
                          ToData,
                          | "TO0"
                          | "TO1"
                          | "TO2"
                          | "TO3"
                          | "TO4"
                          | "TO5"
                          | "TO6"
                          | "TO7"
                          | "TO8"
                          | "AllTO"
                          | "Warranty"
                          | "writ"
                        >
                      >;
                    }
                >
              >
            >;
          }
      >
    >
  >;
  country?: Maybe<
    Array<
      Maybe<
        { __typename?: "countryForServiceByDealer" } & {
          periods?: Maybe<
            Array<
              Maybe<
                { __typename?: "TOPeriod" } & Pick<ToPeriod, "period"> & {
                    TO?: Maybe<
                      { __typename?: "TOData" } & Pick<
                        ToData,
                        | "TO0"
                        | "TO1"
                        | "TO2"
                        | "TO3"
                        | "TO4"
                        | "TO5"
                        | "TO6"
                        | "TO7"
                        | "TO8"
                        | "AllTO"
                        | "Warranty"
                        | "writ"
                      >
                    >;
                  }
              >
            >
          >;
        }
      >
    >
  >;
  FO?: Maybe<
    Array<
      Maybe<
        { __typename?: "FOForServiceByDealer" } & Pick<
          FoForServiceByDealer,
          "FO"
        > & {
            periods?: Maybe<
              Array<
                Maybe<
                  { __typename?: "TOPeriod" } & Pick<ToPeriod, "period"> & {
                      TO?: Maybe<
                        { __typename?: "TOData" } & Pick<
                          ToData,
                          | "TO0"
                          | "TO1"
                          | "TO2"
                          | "TO3"
                          | "TO4"
                          | "TO5"
                          | "TO6"
                          | "TO7"
                          | "TO8"
                          | "AllTO"
                          | "Warranty"
                          | "writ"
                        >
                      >;
                    }
                >
              >
            >;
          }
      >
    >
  >;
  region?: Maybe<
    Array<
      Maybe<
        { __typename?: "regionForServiceByDealer" } & Pick<
          RegionForServiceByDealer,
          "FO" | "subject"
        > & {
            periods?: Maybe<
              Array<
                Maybe<
                  { __typename?: "TOPeriod" } & Pick<ToPeriod, "period"> & {
                      TO?: Maybe<
                        { __typename?: "TOData" } & Pick<
                          ToData,
                          | "TO0"
                          | "TO1"
                          | "TO2"
                          | "TO3"
                          | "TO4"
                          | "TO5"
                          | "TO6"
                          | "TO7"
                          | "TO8"
                          | "AllTO"
                          | "Warranty"
                          | "writ"
                        >
                      >;
                    }
                >
              >
            >;
          }
      >
    >
  >;
};

export type FragmentGibddTypeFragment = { __typename?: "GIBDDType" } & Pick<
  GibddType,
  | "id"
  | "vin"
  | "dateRegistration"
  | "city"
  | "district"
  | "region"
  | "federalArea"
  | "createdAt"
  | "updatedAt"
>;

export type FragmentDealerForPaymentsByDealerFragment = {
  __typename?: "dealerForPaymentsByDealer";
} & Pick<
  DealerForPaymentsByDealer,
  | "id"
  | "code"
  | "ent_id"
  | "INN"
  | "birCode"
  | "entfSuccessorCode"
  | "entfSuccessorNo"
  | "city"
  | "FO"
  | "DealerName"
  | "subject"
  | "country"
> & {
    periods?: Maybe<
      Array<
        Maybe<
          { __typename?: "PeriodForPayments" } & Pick<
            PeriodForPayments,
            | "period"
            | "target"
            | "countSale"
            | "countService"
            | "percent"
            | "percentTarget"
          >
        >
      >
    >;
  };

export type FragmentDealerByCarByDealerFragment = {
  __typename?: "dealerByCarByDealer";
} & Pick<
  DealerByCarByDealer,
  | "id"
  | "code"
  | "INN"
  | "birCode"
  | "entfSuccessorCode"
  | "entfSuccessorNo"
  | "city"
  | "ent_id"
  | "FO"
  | "DealerName"
  | "subject"
  | "country"
  | "family"
> & {
    periods?: Maybe<
      Array<
        Maybe<
          { __typename?: "PeriodByCar" } & Pick<PeriodByCar, "period"> & {
              TO1?: Maybe<
                { __typename?: "TODealerByCarByDealerData" } & Pick<
                  ToDealerByCarByDealerData,
                  "countSale" | "countService" | "percent"
                >
              >;
              TO2?: Maybe<
                { __typename?: "TODealerByCarByDealerData" } & Pick<
                  ToDealerByCarByDealerData,
                  "countSale" | "countService" | "percent"
                >
              >;
              TO3?: Maybe<
                { __typename?: "TODealerByCarByDealerData" } & Pick<
                  ToDealerByCarByDealerData,
                  "countSale" | "countService" | "percent"
                >
              >;
              TO4?: Maybe<
                { __typename?: "TODealerByCarByDealerData" } & Pick<
                  ToDealerByCarByDealerData,
                  "countSale" | "countService" | "percent"
                >
              >;
              TO5?: Maybe<
                { __typename?: "TODealerByCarByDealerData" } & Pick<
                  ToDealerByCarByDealerData,
                  "countSale" | "countService" | "percent"
                >
              >;
            }
        >
      >
    >;
  };

export type FragmentDealerByCarByVinFragment = {
  __typename?: "dealerByCarByVIN";
} & Pick<
  DealerByCarByVin,
  | "ent_id"
  | "id"
  | "DealerName"
  | "INN"
  | "code"
  | "phone"
  | "dateSales"
  | "VIN"
  | "eqFamilyCode"
  | "eqNumber"
  | "eqVariant"
  | "name"
  | "model"
> & {
    TO1?: Maybe<
      { __typename?: "TOForVIN" } & Pick<ToForVin, "dateVisit" | "dealerName">
    >;
    TO2?: Maybe<
      { __typename?: "TOForVIN" } & Pick<ToForVin, "dateVisit" | "dealerName">
    >;
    TO3?: Maybe<
      { __typename?: "TOForVIN" } & Pick<ToForVin, "dateVisit" | "dealerName">
    >;
  };

export type FragmentCarForSrr3GibddByPeriodFragment = {
  __typename?: "CarForSRR3GIBDDByPeriod";
} & Pick<CarForSrr3GibddByPeriod, "period"> & {
    TO1?: Maybe<
      { __typename?: "TOForServiceGIBDDByPeriod" } & Pick<
        ToForServiceGibddByPeriod,
        | "serviceCount"
        | "saleCount"
        | "carsCityGIBDD"
        | "carsRegionGIBDD"
        | "carsAllRegionGIBDD"
      >
    >;
    TO2?: Maybe<
      { __typename?: "TOForServiceGIBDDByPeriod" } & Pick<
        ToForServiceGibddByPeriod,
        | "serviceCount"
        | "saleCount"
        | "carsCityGIBDD"
        | "carsRegionGIBDD"
        | "carsAllRegionGIBDD"
      >
    >;
    TO3?: Maybe<
      { __typename?: "TOForServiceGIBDDByPeriod" } & Pick<
        ToForServiceGibddByPeriod,
        | "serviceCount"
        | "saleCount"
        | "carsCityGIBDD"
        | "carsRegionGIBDD"
        | "carsAllRegionGIBDD"
      >
    >;
    SRR?: Maybe<
      { __typename?: "TOForServiceGIBDDByPeriod" } & Pick<
        ToForServiceGibddByPeriod,
        | "serviceCount"
        | "saleCount"
        | "carsCityGIBDD"
        | "carsRegionGIBDD"
        | "carsAllRegionGIBDD"
      >
    >;
  };

export type FragmentCarForSrr5GibddByPeriodFragment = {
  __typename?: "CarForSRR5GIBDDByPeriod";
} & Pick<CarForSrr5GibddByPeriod, "period"> & {
    TO1?: Maybe<
      { __typename?: "TOForServiceGIBDDByPeriod" } & Pick<
        ToForServiceGibddByPeriod,
        | "serviceCount"
        | "saleCount"
        | "carsCityGIBDD"
        | "carsRegionGIBDD"
        | "carsAllRegionGIBDD"
      >
    >;
    TO2?: Maybe<
      { __typename?: "TOForServiceGIBDDByPeriod" } & Pick<
        ToForServiceGibddByPeriod,
        | "serviceCount"
        | "saleCount"
        | "carsCityGIBDD"
        | "carsRegionGIBDD"
        | "carsAllRegionGIBDD"
      >
    >;
    TO3?: Maybe<
      { __typename?: "TOForServiceGIBDDByPeriod" } & Pick<
        ToForServiceGibddByPeriod,
        | "serviceCount"
        | "saleCount"
        | "carsCityGIBDD"
        | "carsRegionGIBDD"
        | "carsAllRegionGIBDD"
      >
    >;
    TO4?: Maybe<
      { __typename?: "TOForServiceGIBDDByPeriod" } & Pick<
        ToForServiceGibddByPeriod,
        | "serviceCount"
        | "saleCount"
        | "carsCityGIBDD"
        | "carsRegionGIBDD"
        | "carsAllRegionGIBDD"
      >
    >;
    TO5?: Maybe<
      { __typename?: "TOForServiceGIBDDByPeriod" } & Pick<
        ToForServiceGibddByPeriod,
        | "serviceCount"
        | "saleCount"
        | "carsCityGIBDD"
        | "carsRegionGIBDD"
        | "carsAllRegionGIBDD"
      >
    >;
    SRR?: Maybe<
      { __typename?: "TOForServiceGIBDDByPeriod" } & Pick<
        ToForServiceGibddByPeriod,
        | "serviceCount"
        | "saleCount"
        | "carsCityGIBDD"
        | "carsRegionGIBDD"
        | "carsAllRegionGIBDD"
      >
    >;
  };

export type FragmentUniqueServiceFragment = {
  __typename?: "uniqueService";
} & Pick<UniqueService, "name" | "ten_year" | "five_year"> & {
    data?: Maybe<
      Array<
        Maybe<
          { __typename?: "dataUniqueService" } & Pick<
            DataUniqueService,
            "year" | "count"
          >
        >
      >
    >;
  };

export type FragmentLoyaltyServiceFragment = {
  __typename?: "loyaltyService";
} & {
  tableUnique?: Maybe<
    Array<
      Maybe<{ __typename?: "uniqueService" } & FragmentUniqueServiceFragment>
    >
  >;
  tableLoyalty?: Maybe<
    Array<
      Maybe<{ __typename?: "uniqueService" } & FragmentUniqueServiceFragment>
    >
  >;
};

export type FragmentLoyaltyServicePeriodFragment = {
  __typename?: "loyaltyServicePeriod";
} & Pick<
  LoyaltyServicePeriod,
  | "period"
  | "sale5"
  | "serviceCars5"
  | "Loyalty5"
  | "sale10"
  | "serviceCars10"
  | "Loyalty10"
>;

export type FragmentInviteClientToServiceFragment = {
  __typename?: "inviteClientToService";
} & Pick<
  InviteClientToService,
  | "id"
  | "car"
  | "fio"
  | "phone"
  | "email"
  | "agree"
  | "dateSales"
  | "vin"
  | "maxDateVisit"
  | "avgRun"
  | "lastComment"
  | "prevTODealer"
  | "prevToText"
  | "nextToDate"
>;

export type FragmentNsByOldClientsDataFragment = {
  __typename?: "NSByOldClientsData";
} & Pick<
  NsByOldClientsData,
  | "carsTotal"
  | "carModel"
  | "sellDate"
  | "ownerChangeDate"
  | "ownershipPeriod"
  | "carSaleDate"
  | "newCarDate"
> & {
    dealer?: Maybe<
      { __typename?: "Dealer" } & Pick<
        Dealer,
        | "DealerName"
        | "DealerNameEn"
        | "id"
        | "code"
        | "ent_id"
        | "INN"
        | "birCode"
        | "entfSuccessorCode"
        | "entfSuccessorNo"
        | "city"
        | "FO"
        | "subject"
        | "status"
      >
    >;
    car?: Maybe<
      { __typename?: "Car" } & Pick<
        Car,
        | "vin"
        | "collection"
        | "engine"
        | "eqFamilyCode"
        | "eqNumber"
        | "eqVariant"
        | "createdAt"
        | "updatedAt"
      >
    >;
  };

export type FragmentNsByAverageCarAgeDataFragment = {
  __typename?: "NSByAverageCarAgeData";
} & {
  rows?: Maybe<
    Array<
      Maybe<
        { __typename?: "NSByAverageCarAgeDataRows" } & Pick<
          NsByAverageCarAgeDataRows,
          | "vin"
          | "MKB"
          | "carPresumedSaleDate"
          | "carPurchaseDate"
          | "TO1"
          | "TO2"
          | "TO3"
          | "TO4"
          | "TO5"
          | "mileage"
          | "ownerChange"
          | "ownershipPeriodByChange"
          | "ownershipPeriodByEPlatform"
        > & {
            dealer?: Maybe<
              { __typename?: "Dealer" } & Pick<
                Dealer,
                | "DealerName"
                | "DealerNameEn"
                | "id"
                | "code"
                | "ent_id"
                | "INN"
                | "birCode"
                | "entfSuccessorCode"
                | "entfSuccessorNo"
                | "city"
                | "FO"
                | "subject"
                | "status"
              >
            >;
            client?: Maybe<
              { __typename?: "Client" } & Pick<
                Client,
                "type" | "name" | "phone" | "email" | "createdAt" | "updatedAt"
              >
            >;
          }
      >
    >
  >;
  average?: Maybe<
    { __typename?: "NSByAverageCarAgeDataAverage" } & {
      carOwnershipByChange?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "NSByAverageCarAgeDataAverageCarOwnershipByChange";
            } & Pick<
              NsByAverageCarAgeDataAverageCarOwnershipByChange,
              "ownershipPeriodFrom" | "ownershipPeriodTo" | "carsTotal"
            >
          >
        >
      >;
      carOwnershipByEPlatform?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "NSByAverageCarAgeDataAverageCarOwnershipByEPlatform";
            } & Pick<
              NsByAverageCarAgeDataAverageCarOwnershipByEPlatform,
              "ownershipPeriodFrom" | "ownershipPeriodTo" | "carsTotal"
            >
          >
        >
      >;
    }
  >;
};

export type FragmentNsByClientCarSaleDataFragment = {
  __typename?: "NSByClientCarSaleData";
} & Pick<
  NsByClientCarSaleData,
  "carsOnEPlatform" | "clientsLada" | "percentCarsOnEPlatform"
> & {
    dealer?: Maybe<
      { __typename?: "Dealer" } & Pick<
        Dealer,
        | "DealerName"
        | "DealerNameEn"
        | "id"
        | "code"
        | "ent_id"
        | "INN"
        | "birCode"
        | "entfSuccessorCode"
        | "entfSuccessorNo"
        | "city"
        | "FO"
        | "subject"
        | "status"
      >
    >;
  };

export type FragmentServicesFragment = {
  __typename?: "ServicesIndicatorTypes";
} & Pick<
  ServicesIndicatorTypes,
  "id" | "UUID" | "ActualFrom" | "ActualTo" | "Code" | "Name" | "NameEn"
> & {
    ComplianceIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    FactIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    CertificationDateIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    FactContractIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
  };

export type FragmentServicesValuesFragment = {
  __typename?: "ServicesOneValuesItem";
} & Pick<
  ServicesOneValuesItem,
  | "id"
  | "UUID"
  | "ActualFrom"
  | "ActualTo"
  | "Compliance"
  | "Code"
  | "Name"
  | "NameEn"
  | "Fact"
  | "CertificationDate"
  | "FactContract"
  | "planReportId"
>;

export type FragmentServicesDealerStatusesFragment = {
  __typename?: "ServicesDealerStatuses";
} & Pick<
  ServicesDealerStatuses,
  "DealerId" | "ZD_UUID" | "tableIndex" | "status" | "updatedAt"
> & {
    Dealer?: Maybe<
      { __typename?: "Dealer" } & Pick<
        Dealer,
        | "id"
        | "DealerName"
        | "DealerNameEn"
        | "city"
        | "cityEn"
        | "INN"
        | "code"
      >
    >;
  };

export type PositionFragment = { __typename?: "Position" } & Pick<
  Position,
  "id" | "code" | "name" | "nameEn"
>;

export type FragmentStaffFragment = {
  __typename?: "EmployeeExpectation";
} & Pick<
  EmployeeExpectation,
  | "id"
  | "methodEn"
  | "method"
  | "isCombining"
  | "createdAt"
  | "combineCertification"
  | "combineTraining"
> & {
    Positions?: Maybe<
      Array<Maybe<{ __typename?: "Position" } & PositionFragment>>
    >;
  };

export type FragmentStaffForTableFragment = {
  __typename?: "EmployeeExpectation";
} & Pick<
  EmployeeExpectation,
  | "id"
  | "name"
  | "method"
  | "methodEn"
  | "isCombining"
  | "combineCertification"
  | "combineTraining"
> & {
    Positions?: Maybe<
      Array<Maybe<{ __typename?: "Position" } & PositionFragment>>
    >;
    number?: Maybe<
      { __typename?: "number" } & Pick<
        number,
        "standard" | "fact" | "futureStandard" | "fromDate"
      >
    >;
    training?: Maybe<
      { __typename?: "training" } & {
        required?: Maybe<
          { __typename?: "trainingRequired" } & Pick<
            TrainingRequired,
            "fact" | "percent"
          >
        >;
        trained?: Maybe<
          { __typename?: "trainingTrained" } & Pick<
            TrainingTrained,
            "fact" | "percent"
          >
        >;
      }
    >;
    certificationProgress?: Maybe<
      { __typename?: "certification" } & {
        required?: Maybe<
          { __typename?: "required" } & Pick<Required, "people" | "percent">
        >;
        certificated?: Maybe<
          { __typename?: "certificated" } & Pick<
            Certificated,
            "people" | "percent"
          >
        >;
      }
    >;
  };

export type FragmentStaffForSpecTableFragment = {
  __typename?: "EmployeeExpectation";
} & Pick<
  EmployeeExpectation,
  "id" | "combineCertification" | "combineTraining" | "method" | "methodEn"
> & {
    Positions?: Maybe<
      Array<Maybe<{ __typename?: "Position" } & PositionFragment>>
    >;
    number?: Maybe<
      { __typename?: "number" } & Pick<number, "standard" | "fact">
    >;
    training?: Maybe<
      { __typename?: "training" } & {
        required?: Maybe<
          { __typename?: "trainingRequired" } & Pick<
            TrainingRequired,
            "fact" | "percent"
          >
        >;
        trained?: Maybe<
          { __typename?: "trainingTrained" } & Pick<
            TrainingTrained,
            "fact" | "percent"
          >
        >;
      }
    >;
    certificationProgress?: Maybe<
      { __typename?: "certification" } & {
        required?: Maybe<
          { __typename?: "required" } & Pick<Required, "people" | "percent">
        >;
        certificated?: Maybe<
          { __typename?: "certificated" } & Pick<
            Certificated,
            "people" | "percent"
          >
        >;
      }
    >;
  };

export type FragmentStaffIndicatorValueFragment = {
  __typename?: "IndicatorValue";
} & Pick<IndicatorValue, "doubleValue" | "IndicatorId" | "createdAt">;

export type FragmentSubdivisionFragment = { __typename?: "Subdivision" } & Pick<
  Subdivision,
  "id" | "code" | "name" | "status" | "parentId" | "createdAt"
> & {
    Parent?: Maybe<
      { __typename?: "SubdivisionParent" } & Pick<
        SubdivisionParent,
        "id" | "code" | "name" | "status" | "parentId" | "createdAt"
      >
    >;
  };

export type FragmentSubdivisionForSelectFragment = {
  __typename?: "Subdivision";
} & Pick<Subdivision, "id" | "name">;

export type FragmentToolsFragment = {
  __typename?: "ToolsIndicatorTypes";
} & Pick<
  ToolsIndicatorTypes,
  | "id"
  | "UUID"
  | "ActualFrom"
  | "ActualTo"
  | "Number"
  | "Name"
  | "NameEn"
  | "forUUID"
  | "isList"
  | "GroupOne"
  | "GroupTwo"
  | "isParent"
  | "sort"
> & {
    ComplianceIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    TotalIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    ModelIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    CountryIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    YearIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    NoteIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
  };

export type FragmentValuesToolsFragment = {
  __typename?: "ToolsOneValuesItem";
} & Pick<
  ToolsOneValuesItem,
  | "id"
  | "UUID"
  | "ActualFrom"
  | "ActualTo"
  | "Compliance"
  | "Number"
  | "Name"
  | "NameEn"
  | "Total"
  | "Model"
  | "Country"
  | "Year"
  | "Note"
  | "planReportId"
  | "forUUID"
  | "GroupOne"
  | "GroupTwo"
  | "isList"
  | "status"
  | "sort"
  | "statusUpdatedAt"
  | "dealerValuesUpdatedAt"
  | "tableIndex"
  | "DealerId"
> & {
    list?: Maybe<
      Array<
        Maybe<
          { __typename?: "ToolsItemInZdForUUIDlist" } & Pick<
            ToolsItemInZdForUuiDlist,
            | "id"
            | "UUID"
            | "ActualFrom"
            | "ActualTo"
            | "Compliance"
            | "Number"
            | "Name"
            | "NameEn"
            | "Total"
            | "Model"
            | "Country"
            | "Year"
            | "Note"
            | "planReportId"
            | "forUUID"
            | "isList"
            | "status"
            | "statusUpdatedAt"
            | "dealerValuesUpdatedAt"
            | "tableIndex"
            | "DealerId"
          >
        >
      >
    >;
    emptyList?: Maybe<
      Array<
        Maybe<
          { __typename?: "ToolsItemInZdForUUIDemptyList" } & Pick<
            ToolsItemInZdForUuiDemptyList,
            | "id"
            | "UUID"
            | "ActualFrom"
            | "ActualTo"
            | "Compliance"
            | "Number"
            | "Name"
            | "NameEn"
            | "Total"
            | "Model"
            | "Country"
            | "Year"
            | "Note"
            | "planReportId"
            | "forUUID"
            | "isList"
            | "status"
            | "statusUpdatedAt"
            | "dealerValuesUpdatedAt"
          >
        >
      >
    >;
  };

export type FragmentToolsDealerStatusesFragment = {
  __typename?: "ToolsDealerStatuses";
} & Pick<
  ToolsDealerStatuses,
  "DealerId" | "ZD_UUID" | "tableIndex" | "status" | "updatedAt"
> & {
    Dealer?: Maybe<
      { __typename?: "Dealer" } & Pick<
        Dealer,
        | "id"
        | "DealerName"
        | "DealerNameEn"
        | "city"
        | "cityEn"
        | "INN"
        | "code"
      >
    >;
  };

export type FragmentToolsInsuranceFragment = {
  __typename?: "ToolsInsuranceIndicatorTypes";
} & Pick<
  ToolsInsuranceIndicatorTypes,
  | "id"
  | "UUID"
  | "ActualFrom"
  | "ActualTo"
  | "Number"
  | "Name"
  | "NameEn"
  | "NumberList"
  | "NumberDetail"
  | "GroupOne"
  | "GroupTwo"
  | "isParent"
> & {
    ComplianceIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    TotalIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
  };

export type FragmentValuesToolsInsuranceFragment = {
  __typename?: "ToolsInsuranceOneValuesItem";
} & Pick<
  ToolsInsuranceOneValuesItem,
  | "id"
  | "UUID"
  | "ActualFrom"
  | "ActualTo"
  | "Compliance"
  | "GroupOne"
  | "GroupTwo"
  | "Number"
  | "Name"
  | "NameEn"
  | "NumberList"
  | "NumberDetail"
  | "Total"
  | "planReportId"
>;

export type FragmentToolsInsuranceDealerStatusesFragment = {
  __typename?: "ToolsInsuranceDealerStatuses";
} & Pick<
  ToolsInsuranceDealerStatuses,
  "DealerId" | "ZD_UUID" | "tableIndex" | "status" | "updatedAt"
> & {
    Dealer?: Maybe<
      { __typename?: "Dealer" } & Pick<
        Dealer,
        | "id"
        | "DealerName"
        | "DealerNameEn"
        | "city"
        | "cityEn"
        | "INN"
        | "code"
      >
    >;
  };

export type FragmentToolsMetrologicalFragment = {
  __typename?: "ToolsMetrologicalIndicatorTypes";
} & Pick<
  ToolsMetrologicalIndicatorTypes,
  "id" | "UUID" | "ActualFrom" | "ActualTo" | "Number" | "Name" | "NameEn"
> & {
    ComplianceIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    TotalIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
  };

export type FragmentValuesToolsMetrologicalFragment = {
  __typename?: "ToolsMetrologicalOneValuesItem";
} & Pick<
  ToolsMetrologicalOneValuesItem,
  | "id"
  | "UUID"
  | "ActualFrom"
  | "ActualTo"
  | "Compliance"
  | "Number"
  | "Name"
  | "NameEn"
  | "Total"
  | "planReportId"
>;

export type FragmentToolsMetrologicalDealerStatusesFragment = {
  __typename?: "ToolsMetrologicalDealerStatuses";
} & Pick<
  ToolsMetrologicalDealerStatuses,
  "DealerId" | "ZD_UUID" | "tableIndex" | "status" | "updatedAt"
> & {
    Dealer?: Maybe<
      { __typename?: "Dealer" } & Pick<
        Dealer,
        | "id"
        | "DealerName"
        | "DealerNameEn"
        | "city"
        | "cityEn"
        | "INN"
        | "code"
      >
    >;
  };

export type FragmentTradePremisesOneValuesItemFragment = {
  __typename?: "TradePremisesOneValuesItem";
} & Pick<
  TradePremisesOneValuesItem,
  | "id"
  | "UUID"
  | "ActualFrom"
  | "ActualTo"
  | "Compliance"
  | "Number"
  | "Name"
  | "NameEn"
  | "Area"
  | "Address"
  | "PlacesCombine"
  | "planReportId"
  | "isList"
  | "GroupOne"
  | "dealerValuesUpdatedAt"
  | "status"
  | "sort"
> & {
    list?: Maybe<
      Array<
        Maybe<
          { __typename?: "TradePremisesItemInZdForUUIDlist" } & Pick<
            TradePremisesItemInZdForUuiDlist,
            | "id"
            | "UUID"
            | "ActualFrom"
            | "ActualTo"
            | "Compliance"
            | "Number"
            | "Name"
            | "NameEn"
            | "Address"
            | "GroupOne"
            | "planReportId"
            | "forUUID"
            | "isList"
            | "status"
            | "statusUpdatedAt"
            | "dealerValuesUpdatedAt"
          >
        >
      >
    >;
    emptyList?: Maybe<
      Array<
        Maybe<
          { __typename?: "TradePremisesItemInZdForUUIDemptyList" } & Pick<
            TradePremisesItemInZdForUuiDemptyList,
            | "id"
            | "UUID"
            | "ActualFrom"
            | "ActualTo"
            | "Compliance"
            | "Number"
            | "Name"
            | "NameEn"
            | "Address"
            | "GroupOne"
            | "planReportId"
            | "forUUID"
            | "isList"
            | "status"
            | "statusUpdatedAt"
            | "dealerValuesUpdatedAt"
          >
        >
      >
    >;
  };

export type FragmentTradePremisesIndicatorTypesFragment = {
  __typename?: "TradePremisesIndicatorTypes";
} & Pick<
  TradePremisesIndicatorTypes,
  | "id"
  | "UUID"
  | "ActualFrom"
  | "ActualTo"
  | "Number"
  | "Name"
  | "NameEn"
  | "GroupOne"
  | "isParent"
> & {
    ComplianceIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    AreaIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    AddressIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
  };

export type FragmentTradePremisesDealerStatusesFragment = {
  __typename?: "TradePremisesDealerStatuses";
} & Pick<
  TradePremisesDealerStatuses,
  "DealerId" | "ZD_UUID" | "tableIndex" | "status" | "updatedAt"
> & {
    Dealer?: Maybe<
      { __typename?: "Dealer" } & Pick<
        Dealer,
        | "id"
        | "DealerName"
        | "DealerNameEn"
        | "city"
        | "cityEn"
        | "INN"
        | "code"
      >
    >;
  };

export type FragmentGetViolationFragment = {
  __typename?: "ViolationInclude";
} & Pick<
  ViolationInclude,
  | "id"
  | "DealerId"
  | "ViolationTypesId"
  | "description"
  | "fixDeadline"
  | "punishment"
  | "status"
  | "reportedBy"
  | "createdAt"
  | "DocDate"
  | "DocNum"
> & {
    File?: Maybe<{ __typename?: "File" } & Pick<File, "id" | "link" | "name">>;
    reportedByUser?: Maybe<
      { __typename?: "Profile" } & Pick<Profile, "fullname" | "fullnameEn">
    >;
    Dealer?: Maybe<
      { __typename?: "Dealer" } & Pick<
        Dealer,
        | "id"
        | "DealerName"
        | "DealerNameEn"
        | "category"
        | "address"
        | "addressEn"
        | "country"
        | "countryEn"
        | "FO"
        | "FOEn"
        | "subject"
        | "subjectEn"
        | "city"
        | "cityEn"
        | "code"
        | "INN"
      >
    >;
    ViolationType?: Maybe<
      { __typename?: "ViolationTypeInclude" } & Pick<
        ViolationTypeInclude,
        | "id"
        | "name"
        | "description"
        | "howToFixDescription"
        | "category"
        | "SubdivisionId"
        | "AvgCorrectionDays"
        | "status"
        | "deletedAt"
        | "introducedAt"
        | "createdAt"
      > & {
          Subdivision?: Maybe<
            { __typename?: "Subdivision" } & Pick<
              Subdivision,
              "id" | "code" | "name" | "status" | "parentId"
            >
          >;
        }
    >;
    ViolationComments?: Maybe<
      Array<
        Maybe<
          { __typename?: "ViolationComment" } & {
            User?: Maybe<{ __typename?: "Profile" } & Pick<Profile, "role">>;
          }
        >
      >
    >;
    responsibleByUser?: Maybe<
      { __typename?: "Profile" } & Pick<
        Profile,
        "id" | "fullname" | "fullnameEn"
      >
    >;
  };

export type FragmentGetViolationCommentFragment = {
  __typename?: "ViolationComment";
} & Pick<ViolationComment, "id" | "ViolationId" | "comment" | "createdAt"> & {
    User?: Maybe<
      { __typename?: "Profile" } & FragmentProfileForViolationFragment
    >;
    Files?: Maybe<
      Array<
        Maybe<
          { __typename?: "File" } & Pick<
            File,
            "id" | "name" | "link" | "mimeType" | "createdAt" | "type" | "hash"
          > & {
              User?: Maybe<
                { __typename?: "Profile" } & Pick<
                  Profile,
                  | "fullname"
                  | "fullnameEn"
                  | "login"
                  | "role"
                  | "roleEn"
                  | "roleRu"
                  | "id"
                >
              >;
            }
        >
      >
    >;
  };

export type FragmentViolationTypeFragment = {
  __typename?: "ViolationType";
} & Pick<
  ViolationType,
  | "id"
  | "name"
  | "description"
  | "howToFixDescription"
  | "category"
  | "SubdivisionId"
  | "AvgCorrectionDays"
  | "status"
  | "deletedAt"
  | "introducedAt"
  | "createdAt"
> & {
    Subdivision?: Maybe<
      { __typename?: "Subdivision" } & FragmentSubdivisionFragment
    >;
  };

export type FragmentViolationTypeForSelectFragment = {
  __typename?: "ViolationType";
} & Pick<ViolationType, "id" | "name" | "AvgCorrectionDays">;

export type FragmentWarehousesFragment = {
  __typename?: "WarehousesIndicatorTypes";
} & Pick<
  WarehousesIndicatorTypes,
  "id" | "UUID" | "ActualFrom" | "ActualTo" | "Number" | "Name" | "NameEn"
> & {
    ComplianceIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    AreaIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
    CombineIndicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "period" | "nameRu" | "nameEn" | "shortNameEn" | "shortNameRu"
      >
    >;
  };

export type FragmentWarehousesDealerStatusesFragment = {
  __typename?: "WarehousesDealerStatuses";
} & Pick<
  WarehousesDealerStatuses,
  "DealerId" | "ZD_UUID" | "tableIndex" | "status" | "updatedAt"
> & {
    Dealer?: Maybe<
      { __typename?: "Dealer" } & Pick<
        Dealer,
        | "id"
        | "DealerName"
        | "DealerNameEn"
        | "city"
        | "cityEn"
        | "INN"
        | "code"
      >
    >;
  };

export type FragmentValuesWarehousesFragment = {
  __typename?: "WarehousesOneValuesItem";
} & Pick<
  WarehousesOneValuesItem,
  | "id"
  | "UUID"
  | "ActualFrom"
  | "ActualTo"
  | "Name"
  | "NameEn"
  | "Combine"
  | "Compliance"
  | "Number"
  | "Area"
  | "status"
  | "statusUpdatedAt"
  | "planReportId"
>;

export type FragmentDealerShipFragment = { __typename?: "Dealer" } & Pick<
  Dealer,
  | "id"
  | "DealerName"
  | "DealerNameEn"
  | "type"
  | "typeEn"
  | "country"
  | "countryEn"
  | "city"
  | "cityEn"
  | "FO"
  | "FOEn"
  | "beginWorkingDate"
  | "address"
  | "addressEn"
> & {
    PhotoDealerCenter?: Maybe<
      { __typename?: "File" } & Pick<File, "id" | "link">
    >;
  };

export type FragmentDealerShipManagerFragment = {
  __typename?: "Dealer";
} & Pick<
  Dealer,
  | "id"
  | "headName"
  | "headNameEn"
  | "headMobilePhone"
  | "headPhone"
  | "headEmail"
  | "ownerName"
  | "ownerNameEn"
  | "ownerMobilePhone"
  | "ownerPhone"
  | "ownerEmail"
  | "EP"
  | "EPEn"
> & {
    PhotoBoss?: Maybe<{ __typename?: "File" } & Pick<File, "id" | "link">>;
    PhotoOwner?: Maybe<{ __typename?: "File" } & Pick<File, "id" | "link">>;
  };

export type FragmentRnBankRatingFragment = {
  __typename?: "IndicatorValue";
} & Pick<IndicatorValue, "stringValue" | "createdAt">;

export type FragmentNewVehicleFragment = {
  __typename?: "IndicatorValue";
} & Pick<IndicatorValue, "doubleValue" | "IndicatorId" | "createdAt"> & {
    Indicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "format" | "unit" | "nameEn" | "nameRu" | "shortNameEn" | "shortNameRu"
      >
    >;
  };

export type FragmentAfterSalesFragment = {
  __typename?: "IndicatorValue";
} & Pick<IndicatorValue, "doubleValue" | "IndicatorId" | "createdAt"> & {
    Indicator?: Maybe<
      { __typename?: "Indicator" } & Pick<Indicator, "format" | "unit">
    >;
  };

export type FragmentQualutyIndicatorFragment = {
  __typename?: "IndicatorValue";
} & Pick<IndicatorValue, "doubleValue" | "createdAt" | "IndicatorId"> & {
    Indicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "nameEn" | "nameRu" | "shortNameEn" | "shortNameRu" | "format" | "unit"
      >
    >;
  };

export type FragmentWorkSpaceQualityFragment = { __typename?: "Quality" } & {
  GlobalRatingVersion?: Maybe<
    { __typename?: "WorkSpaceGlobalRatingVersion" } & Pick<
      WorkSpaceGlobalRatingVersion,
      "IndicatorId"
    > & {
        Indicator?: Maybe<
          { __typename?: "Indicator" } & Pick<
            Indicator,
            | "nameEn"
            | "nameRu"
            | "shortNameEn"
            | "shortNameRu"
            | "format"
            | "unit"
          > & {
              Values?: Maybe<
                Array<
                  Maybe<
                    { __typename?: "IndicatorValue" } & Pick<
                      IndicatorValue,
                      "IndicatorId" | "doubleValue" | "createdAt"
                    >
                  >
                >
              >;
            }
        >;
        dataForGraph?: Maybe<
          Array<
            Maybe<
              { __typename?: "dataForGraph" } & Pick<
                DataForGraph,
                "name" | "nameEn"
              > & {
                  IndicatorYearPercent?: Maybe<
                    {
                      __typename?: "Indicator";
                    } & FragmentIndicatorForGrFragment
                  >;
                }
            >
          >
        >;
      }
  >;
};

export type FragmentProfitabilityFragment = {
  __typename?: "IndicatorValue";
} & Pick<IndicatorValue, "doubleValue" | "createdAt"> & {
    Indicator?: Maybe<
      { __typename?: "Indicator" } & Pick<
        Indicator,
        "id" | "nameEn" | "nameRu" | "period"
      >
    >;
  };

export type FragmentStaffInfoFragment = {
  __typename?: "IndicatorValue";
} & Pick<IndicatorValue, "doubleValue" | "createdAt"> & {
    Indicator?: Maybe<
      { __typename?: "Indicator" } & Pick<Indicator, "id" | "nameEn" | "nameRu">
    >;
  };

export type FragmentZdGlobalInfoForDealerFragment = {
  __typename?: "ZdGlobalInfoForDealer";
} & Pick<
  ZdGlobalInfoForDealer,
  | "DealerId"
  | "lastAcceptDate"
  | "lastRejectDate"
  | "lastChange"
  | "lastCheckedChange"
  | "lastPlanReportDate"
  | "status"
> & {
    Dealer?: Maybe<
      { __typename?: "Dealer" } & Pick<
        Dealer,
        | "id"
        | "DealerName"
        | "DealerNameEn"
        | "city"
        | "cityEn"
        | "INN"
        | "code"
      >
    >;
  };

export type FragmentZdGlobalInfoForDealerOneFragment = {
  __typename?: "ZdGlobalInformationForDealerResponse";
} & Pick<
  ZdGlobalInformationForDealerResponse,
  | "DealerId"
  | "lastAcceptDate"
  | "lastRejectDate"
  | "lastChange"
  | "lastCheckedChange"
  | "lastPlanReportDate"
  | "status"
  | "statusPremises"
> & {
    Dealer?: Maybe<
      { __typename?: "Dealer" } & Pick<
        Dealer,
        | "id"
        | "DealerName"
        | "DealerNameEn"
        | "city"
        | "cityEn"
        | "INN"
        | "code"
      >
    >;
  };

export type NotificationFragment = { __typename?: "Notification" } & Pick<
  Notification,
  "id" | "isOpen" | "type" | "status" | "content" | "label" | "duration"
>;

export type UpdateNotificationFragment = { __typename?: "Notification" } & Pick<
  Notification,
  "isOpen" | "type" | "status" | "content" | "label" | "duration"
>;

export type GetNotificationsQueryVariables = Exact<{ [key: string]: never }>;

export type GetNotificationsQuery = { __typename?: "Query" } & {
  getNotifications?: Maybe<
    Array<Maybe<{ __typename?: "Notification" } & NotificationFragment>>
  >;
};

export type AddNotificationMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  type: Scalars["String"];
  status?: Maybe<Scalars["String"]>;
  content?: Maybe<Scalars["String"]>;
  label?: Maybe<Scalars["String"]>;
  duration?: Maybe<Scalars["Int"]>;
}>;

export type AddNotificationMutation = { __typename?: "Mutation" } & {
  addNotification?: Maybe<
    { __typename?: "Notification" } & NotificationFragment
  >;
};

export type UpdateNotificationMutationVariables = Exact<{
  id: Scalars["ID"];
  isOpen?: Maybe<Scalars["Boolean"]>;
  type?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  content?: Maybe<Scalars["String"]>;
  label?: Maybe<Scalars["String"]>;
  duration?: Maybe<Scalars["Int"]>;
}>;

export type UpdateNotificationMutation = { __typename?: "Mutation" } & {
  updateNotification?: Maybe<
    { __typename?: "Notification" } & NotificationFragment
  >;
};

export type CreateAccountingMutationVariables = Exact<{
  Year: Scalars["Int"];
  Quarter: Scalars["Int"];
  lastDate: Scalars["DateTime"];
  reportDate?: Maybe<Scalars["DateTime"]>;
}>;

export type CreateAccountingMutation = { __typename?: "Mutation" } & {
  AccountingSetter?: Maybe<
    { __typename?: "AccountingSetter" } & {
      create?: Maybe<
        { __typename?: "ReportPeriod" } & Pick<
          ReportPeriod,
          "Year" | "Quarter" | "lastDate" | "reportDate" | "createdAt"
        >
      >;
    }
  >;
};

export type ChangePeriodMutationVariables = Exact<{
  PeriodId: Scalars["ID"];
  lastDate: Scalars["DateTime"];
  reportDate?: Maybe<Scalars["DateTime"]>;
}>;

export type ChangePeriodMutation = { __typename?: "Mutation" } & {
  AccountingSetter?: Maybe<
    { __typename?: "AccountingSetter" } & {
      changePeriod?: Maybe<
        { __typename?: "ReportPeriod" } & Pick<
          ReportPeriod,
          "id" | "Year" | "Quarter" | "lastDate" | "reportDate" | "createdAt"
        >
      >;
    }
  >;
};

export type SetDealerReportAccountingMutationVariables = Exact<{
  ReportId: Scalars["ID"];
  status?: Maybe<DealerReportStatus>;
  note?: Maybe<Scalars["String"]>;
  FileIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  _MTExMA__?: Maybe<Scalars["BigInt"]>;
  _MTEyMA__?: Maybe<Scalars["BigInt"]>;
  _MTEzMA__?: Maybe<Scalars["BigInt"]>;
  _MTE0MA__?: Maybe<Scalars["BigInt"]>;
  _MTE1MA__?: Maybe<Scalars["BigInt"]>;
  _MTE1MS8x?: Maybe<Scalars["BigInt"]>;
  _MTE1MS8y?: Maybe<Scalars["BigInt"]>;
  _MTE1Mi8x?: Maybe<Scalars["BigInt"]>;
  _MTE1Mi8y?: Maybe<Scalars["BigInt"]>;
  _MTE1My8x?: Maybe<Scalars["BigInt"]>;
  _MTE1My8y?: Maybe<Scalars["BigInt"]>;
  _MTE1NC8x?: Maybe<Scalars["BigInt"]>;
  _MTE1NC8y?: Maybe<Scalars["BigInt"]>;
  _MTE2MA__?: Maybe<Scalars["BigInt"]>;
  _MTE3MA__?: Maybe<Scalars["BigInt"]>;
  _MTE3MQ__?: Maybe<Scalars["BigInt"]>;
  _MTE4MA__?: Maybe<Scalars["BigInt"]>;
  _MTE5MA__?: Maybe<Scalars["BigInt"]>;
  _MTE5MQ__?: Maybe<Scalars["BigInt"]>;
  _MTIxMA__?: Maybe<Scalars["BigInt"]>;
  _MTIxMQ__?: Maybe<Scalars["BigInt"]>;
  _MTIxMg__?: Maybe<Scalars["BigInt"]>;
  _MTIxMw__?: Maybe<Scalars["BigInt"]>;
  _MTIxNA__?: Maybe<Scalars["BigInt"]>;
  _MTIyMA__?: Maybe<Scalars["BigInt"]>;
  _MTIzMA__?: Maybe<Scalars["BigInt"]>;
  _MTIzMQ__?: Maybe<Scalars["BigInt"]>;
  _MTIzMg__?: Maybe<Scalars["BigInt"]>;
  _MTIzMw__?: Maybe<Scalars["BigInt"]>;
  _MTIzNA__?: Maybe<Scalars["BigInt"]>;
  _MTI0MA__?: Maybe<Scalars["BigInt"]>;
  _MTI1MA__?: Maybe<Scalars["BigInt"]>;
  _MTI2MA__?: Maybe<Scalars["BigInt"]>;
  _MTMxMA__?: Maybe<Scalars["BigInt"]>;
  _MTMyMA__?: Maybe<Scalars["BigInt"]>;
  _MTM0MA__?: Maybe<Scalars["BigInt"]>;
  _MTM1MA__?: Maybe<Scalars["BigInt"]>;
  _MTM2MA__?: Maybe<Scalars["BigInt"]>;
  _MTM3MA__?: Maybe<Scalars["BigInt"]>;
  _MTQxMA__?: Maybe<Scalars["BigInt"]>;
  _MTQyMA__?: Maybe<Scalars["BigInt"]>;
  _MTQzMA__?: Maybe<Scalars["BigInt"]>;
  _MTQ1MA__?: Maybe<Scalars["BigInt"]>;
  _MTUxMA__?: Maybe<Scalars["BigInt"]>;
  _MTUyMA__?: Maybe<Scalars["BigInt"]>;
  _MTUyMQ__?: Maybe<Scalars["BigInt"]>;
  _MTUyMg__?: Maybe<Scalars["BigInt"]>;
  _MTUyMw__?: Maybe<Scalars["BigInt"]>;
  _MTUzMA__?: Maybe<Scalars["BigInt"]>;
  _MTU0MA__?: Maybe<Scalars["BigInt"]>;
  _MTU1MA__?: Maybe<Scalars["BigInt"]>;
  _MjExMg__?: Maybe<Scalars["BigInt"]>;
  _MjExMw__?: Maybe<Scalars["BigInt"]>;
  _MjExNA__?: Maybe<Scalars["BigInt"]>;
  _MjExNQ__?: Maybe<Scalars["BigInt"]>;
  _MjExNg__?: Maybe<Scalars["BigInt"]>;
  _MjExNw__?: Maybe<Scalars["BigInt"]>;
  _MjExOA__?: Maybe<Scalars["BigInt"]>;
  _MjEyMQ__?: Maybe<Scalars["BigInt"]>;
  _MjEyMg__?: Maybe<Scalars["BigInt"]>;
  _MjEyMw__?: Maybe<Scalars["BigInt"]>;
  _MjEyNA__?: Maybe<Scalars["BigInt"]>;
  _MjEyNQ__?: Maybe<Scalars["BigInt"]>;
  _MjEyNg__?: Maybe<Scalars["BigInt"]>;
  _MjEyNw__?: Maybe<Scalars["BigInt"]>;
  _MjIxMS8x?: Maybe<Scalars["BigInt"]>;
  _MjIxMS8y?: Maybe<Scalars["BigInt"]>;
  _MjIxMS8z?: Maybe<Scalars["BigInt"]>;
  _MjIxMS80?: Maybe<Scalars["BigInt"]>;
  _MjIxMS81?: Maybe<Scalars["BigInt"]>;
  _MjIxMS82?: Maybe<Scalars["BigInt"]>;
  _MjIxMS83?: Maybe<Scalars["BigInt"]>;
  _MjIxMS84?: Maybe<Scalars["BigInt"]>;
  _MjIxMg__?: Maybe<Scalars["BigInt"]>;
  _MjIxMw__?: Maybe<Scalars["BigInt"]>;
  _MjIyMC8x?: Maybe<Scalars["BigInt"]>;
  _MjIyMC8y?: Maybe<Scalars["BigInt"]>;
  _MjIyMC8z?: Maybe<Scalars["BigInt"]>;
  _MjIyMC80?: Maybe<Scalars["BigInt"]>;
  _MjIyMC81?: Maybe<Scalars["BigInt"]>;
  _MjIyMC82?: Maybe<Scalars["BigInt"]>;
  _MjIyMC83?: Maybe<Scalars["BigInt"]>;
  _MjIyMC84?: Maybe<Scalars["BigInt"]>;
  _MjIyMC85?: Maybe<Scalars["BigInt"]>;
  _MjIyMC8xMA__?: Maybe<Scalars["BigInt"]>;
  _MjIyMC8xMQ__?: Maybe<Scalars["BigInt"]>;
  _MjMxMA__?: Maybe<Scalars["BigInt"]>;
  _MjMyMA__?: Maybe<Scalars["BigInt"]>;
  _MjMzMA__?: Maybe<Scalars["BigInt"]>;
  _MjM0MA__?: Maybe<Scalars["BigInt"]>;
  _MjM0MQ__?: Maybe<Scalars["BigInt"]>;
  _MjM0Mg__?: Maybe<Scalars["BigInt"]>;
  _MjM0Mw__?: Maybe<Scalars["BigInt"]>;
  _MjM1MA__?: Maybe<Scalars["BigInt"]>;
  _MjQxMQ__?: Maybe<Scalars["BigInt"]>;
  _MjQxMg__?: Maybe<Scalars["BigInt"]>;
  _MjQ2MA__?: Maybe<Scalars["BigInt"]>;
  _MjUxMA__?: Maybe<Scalars["BigInt"]>;
  _MjUyMA__?: Maybe<Scalars["BigInt"]>;
  _MjUwMA__?: Maybe<Scalars["BigInt"]>;
  _MjkxMA__?: Maybe<Scalars["BigInt"]>;
  _MjkwMA__?: Maybe<Scalars["BigInt"]>;
  _MjExMQ__?: Maybe<Scalars["BigInt"]>;
}>;

export type SetDealerReportAccountingMutation = { __typename?: "Mutation" } & {
  AccountingSetter?: Maybe<
    { __typename?: "AccountingSetter" } & {
      setDealerReport?: Maybe<
        { __typename?: "DealerReport" } & Pick<DealerReport, "id">
      >;
    }
  >;
};

export type AnnouncementCreateMutationVariables = Exact<{
  importance?: Maybe<Scalars["String"]>;
  date?: Maybe<Scalars["DateTime"]>;
  title: Scalars["String"];
  text: Scalars["String"];
  singedBy: Scalars["String"];
  SubdivisionId?: Maybe<Scalars["ID"]>;
  Documents?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type AnnouncementCreateMutation = { __typename?: "Mutation" } & {
  AnnouncementSetter?: Maybe<
    { __typename?: "AnnouncementSetter" } & {
      create?: Maybe<
        { __typename?: "Announcement" } & Pick<Announcement, "id">
      >;
    }
  >;
};

export type AnnouncementEditMutationVariables = Exact<{
  id: Scalars["ID"];
  importance?: Maybe<Scalars["String"]>;
  date?: Maybe<Scalars["DateTime"]>;
  title: Scalars["String"];
  text: Scalars["String"];
  singedBy: Scalars["String"];
  SubdivisionId?: Maybe<Scalars["ID"]>;
  Documents?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type AnnouncementEditMutation = { __typename?: "Mutation" } & {
  AnnouncementSetter?: Maybe<
    { __typename?: "AnnouncementSetter" } & {
      edit?: Maybe<{ __typename?: "Announcement" } & Pick<Announcement, "id">>;
    }
  >;
};

export type AnnouncementStatusMutationVariables = Exact<{
  id: Scalars["ID"];
  status?: Maybe<AnnouncementStatus>;
  canceledReason?: Maybe<Scalars["String"]>;
}>;

export type AnnouncementStatusMutation = { __typename?: "Mutation" } & {
  AnnouncementSetter?: Maybe<
    { __typename?: "AnnouncementSetter" } & {
      setStatus?: Maybe<
        { __typename?: "Announcement" } & Pick<Announcement, "id">
      >;
    }
  >;
};

export type SetCameraZoneMutationVariables = Exact<{
  name?: Maybe<Scalars["String"]>;
}>;

export type SetCameraZoneMutation = { __typename?: "Mutation" } & {
  CameraSetter?: Maybe<
    { __typename?: "CameraSetter" } & {
      createCameraZone?: Maybe<
        { __typename?: "CameraZone" } & CameraZoneFragment
      >;
    }
  >;
};

export type EditCameraZoneMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
}>;

export type EditCameraZoneMutation = { __typename?: "Mutation" } & {
  CameraSetter?: Maybe<
    { __typename?: "CameraSetter" } & {
      editCameraZone?: Maybe<
        { __typename?: "CameraZone" } & CameraZoneFragment
      >;
    }
  >;
};

export type DeleteCameraZoneMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type DeleteCameraZoneMutation = { __typename?: "Mutation" } & {
  CameraSetter?: Maybe<
    { __typename?: "CameraSetter" } & {
      deleteCameraZone?: Maybe<
        { __typename?: "CameraZone" } & CameraZoneFragment
      >;
    }
  >;
};

export type SetCameraMutationVariables = Exact<{
  name?: Maybe<Scalars["String"]>;
  cameraZoneId?: Maybe<Scalars["ID"]>;
  cameraUrl?: Maybe<Scalars["String"]>;
  dealerId?: Maybe<Scalars["ID"]>;
}>;

export type SetCameraMutation = { __typename?: "Mutation" } & {
  CameraSetter?: Maybe<
    { __typename?: "CameraSetter" } & {
      createCamera?: Maybe<{ __typename?: "Camera" } & CameraFragment>;
    }
  >;
};

export type EditCameraMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  cameraZoneId?: Maybe<Scalars["ID"]>;
  cameraUrl?: Maybe<Scalars["String"]>;
  dealerId?: Maybe<Scalars["ID"]>;
}>;

export type EditCameraMutation = { __typename?: "Mutation" } & {
  CameraSetter?: Maybe<
    { __typename?: "CameraSetter" } & {
      editCamera?: Maybe<{ __typename?: "Camera" } & CameraFragment>;
    }
  >;
};

export type DeleteCameraMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type DeleteCameraMutation = { __typename?: "Mutation" } & {
  CameraSetter?: Maybe<
    { __typename?: "CameraSetter" } & {
      deleteCamera?: Maybe<{ __typename?: "Camera" } & CameraFragment>;
    }
  >;
};

export type SetCameraCheckMutationVariables = Exact<{
  cameraId?: Maybe<Scalars["ID"]>;
  comment?: Maybe<Scalars["String"]>;
  status?: Maybe<CameraCheckStatus>;
}>;

export type SetCameraCheckMutation = { __typename?: "Mutation" } & {
  CameraSetter?: Maybe<
    { __typename?: "CameraSetter" } & {
      createCameraCheck?: Maybe<
        { __typename?: "CameraCheck" } & Pick<
          CameraCheck,
          | "id"
          | "cameraId"
          | "status"
          | "name"
          | "createdAt"
          | "updatedAt"
          | "createdBy"
          | "updatedBy"
        > & {
            comments?: Maybe<
              Array<
                Maybe<{ __typename?: "Comment" } & CameraChatMessageFragment>
              >
            >;
          }
      >;
    }
  >;
};

export type SetNewCameraChatMessageMutationVariables = Exact<{
  cameraCheckId?: Maybe<Scalars["ID"]>;
  comment?: Maybe<Scalars["String"]>;
}>;

export type SetNewCameraChatMessageMutation = { __typename?: "Mutation" } & {
  CameraSetter?: Maybe<
    { __typename?: "CameraSetter" } & {
      addComment?: Maybe<
        { __typename?: "Comment" } & CameraChatMessageFragment
      >;
    }
  >;
};

export type SetCameraCheckStatusMutationVariables = Exact<{
  cameraCheckId?: Maybe<Scalars["ID"]>;
  status?: Maybe<CameraCheckStatus>;
}>;

export type SetCameraCheckStatusMutation = { __typename?: "Mutation" } & {
  CameraSetter?: Maybe<
    { __typename?: "CameraSetter" } & {
      setCameraCheckStatus?: Maybe<
        { __typename?: "CameraCheck" } & CameraCheckFragment
      >;
    }
  >;
};

export type SetCameraStreamCloseMutationVariables = Exact<{
  pid?: Maybe<Scalars["ID"]>;
}>;

export type SetCameraStreamCloseMutation = { __typename?: "Mutation" } & {
  CameraSetter?: Maybe<
    { __typename?: "CameraSetter" } & Pick<CameraSetter, "closeCameraVideo">
  >;
};

export type CheckListCommentSetterMutationVariables = Exact<{
  checkListId: Scalars["ID"];
  text: Scalars["String"];
}>;

export type CheckListCommentSetterMutation = { __typename?: "Mutation" } & {
  CheckListCommentSetter?: Maybe<
    { __typename?: "CheckListCommentSetter" } & {
      createCheckListComment: { __typename?: "ok" } & Pick<Ok, "ok">;
    }
  >;
};

export type CreateContractTemplateMutationVariables = Exact<{
  name: Scalars["String"];
  fileId: Scalars["String"];
  active?: Maybe<Scalars["Boolean"]>;
}>;

export type CreateContractTemplateMutation = { __typename?: "Mutation" } & {
  ContractTemplateSetter?: Maybe<
    { __typename?: "ContractTemplateSetter" } & {
      createContractTemplate?: Maybe<
        { __typename?: "ContractTemplate" } & Pick<
          ContractTemplate,
          "id" | "name" | "active" | "FileId" | "createdAt" | "updatedAt"
        > & {
            File: { __typename?: "File" } & Pick<
              File,
              | "id"
              | "name"
              | "link"
              | "mimeType"
              | "createdAt"
              | "type"
              | "hash"
            >;
          }
      >;
    }
  >;
};

export type UpdateContractTemplateMutationVariables = Exact<{
  updateContractTemplateId: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  fileId?: Maybe<Scalars["String"]>;
  active?: Maybe<Scalars["Boolean"]>;
}>;

export type UpdateContractTemplateMutation = { __typename?: "Mutation" } & {
  ContractTemplateSetter?: Maybe<
    { __typename?: "ContractTemplateSetter" } & {
      updateContractTemplate?: Maybe<
        { __typename?: "ContractTemplate" } & Pick<
          ContractTemplate,
          "id" | "name" | "active" | "FileId" | "createdAt" | "updatedAt"
        > & {
            File: { __typename?: "File" } & Pick<
              File,
              | "id"
              | "name"
              | "link"
              | "mimeType"
              | "createdAt"
              | "type"
              | "hash"
            >;
          }
      >;
    }
  >;
};

export type CreateTemplateRegisterMutationVariables = Exact<{
  name: Scalars["String"];
  html: Scalars["String"];
  type?: ContractType;
}>;

export type CreateTemplateRegisterMutation = { __typename?: "Mutation" } & {
  DealerRegistrySetter?: Maybe<
    { __typename?: "DealerRegistrySetter" } & {
      createTemplate?: Maybe<
        { __typename?: "DealerContractTemplate" } & Pick<
          DealerContractTemplate,
          "type" | "html" | "createdAt" | "name"
        >
      >;
    }
  >;
};

export type CreateContractRegisterMutationVariables = Exact<{
  dealerId: Scalars["ID"];
  templateId: Scalars["ID"];
  number: Scalars["String"];
  date: Scalars["String"];
}>;

export type CreateContractRegisterMutation = { __typename?: "Mutation" } & {
  DealerRegistrySetter?: Maybe<
    { __typename?: "DealerRegistrySetter" } & {
      createContract?: Maybe<
        { __typename?: "DealerContract" } & Pick<
          DealerContract,
          "DealerId" | "createdAt" | "date" | "ArchiveDealerId"
        >
      >;
    }
  >;
};

export type CreatePeriodRegisterMutationVariables = Exact<{
  [key: string]: never;
}>;

export type CreatePeriodRegisterMutation = { __typename?: "Mutation" } & {
  DealerRegistrySetter?: Maybe<
    { __typename?: "DealerRegistrySetter" } & {
      createPeriod?: Maybe<
        { __typename?: "ArchivePeriod" } & Pick<
          ArchivePeriod,
          "isCreatedByUser" | "dateEnd" | "dateStart" | "createdAt"
        >
      >;
    }
  >;
};

export type AddDealerToUserMutationVariables = Exact<{
  UserId: Scalars["ID"];
  DealerId: Scalars["ID"];
}>;

export type AddDealerToUserMutation = { __typename?: "Mutation" } & {
  DealerSetter?: Maybe<
    { __typename?: "DealerSetter" } & Pick<DealerSetter, "addDealerToUser">
  >;
};

export type DeleteDealerFromUserMutationVariables = Exact<{
  UserId: Scalars["ID"];
  DealerId: Scalars["ID"];
}>;

export type DeleteDealerFromUserMutation = { __typename?: "Mutation" } & {
  DealerSetter?: Maybe<
    { __typename?: "DealerSetter" } & Pick<DealerSetter, "deleteDealerFromUser">
  >;
};

export type ChangeDealerMutationVariables = Exact<{
  KPP?: Maybe<Scalars["String"]>;
  ContractEndDate?: Maybe<Scalars["DateTime"]>;
  IS_Id?: Maybe<Scalars["String"]>;
  Main?: Maybe<Scalars["Int"]>;
  ScanAccountantPersonDataId?: Maybe<Scalars["ID"]>;
  ScanLadaPersonDataId?: Maybe<Scalars["ID"]>;
  legalAddress?: Maybe<Scalars["String"]>;
  postalAddress?: Maybe<Scalars["String"]>;
  legalCityId?: Maybe<Scalars["ID"]>;
  postalCityId?: Maybe<Scalars["ID"]>;
  cityId?: Maybe<Scalars["ID"]>;
  egrDate?: Maybe<Scalars["DateTime"]>;
  type?: Maybe<Scalars["String"]>;
  typeEn?: Maybe<Scalars["String"]>;
  DealerName?: Maybe<Scalars["String"]>;
  DealerNameEn?: Maybe<Scalars["String"]>;
  tradeDealerName?: Maybe<Scalars["String"]>;
  tradeDealerNameEn?: Maybe<Scalars["String"]>;
  legalDealerName?: Maybe<Scalars["String"]>;
  legalDealerNameEn?: Maybe<Scalars["String"]>;
  INN?: Maybe<Scalars["String"]>;
  newDealer?: Maybe<Scalars["Int"]>;
  temporaryDecision?: Maybe<Scalars["Int"]>;
  protocolOfIntentions?: Maybe<Scalars["Int"]>;
  logicalType?: Maybe<Scalars["Int"]>;
  extendedForNextYear?: Maybe<Scalars["Int"]>;
  terminated?: Maybe<Scalars["Int"]>;
  hideOnLadaRu?: Maybe<Scalars["Int"]>;
  DealerLADASERV?: Maybe<Scalars["Int"]>;
  OGRN?: Maybe<Scalars["String"]>;
  termOfAuthority?: Maybe<Scalars["DateTime"]>;
  consumerCode?: Maybe<Scalars["String"]>;
  corporateEmail?: Maybe<Scalars["String"]>;
  EGR_Number?: Maybe<Scalars["String"]>;
  EGR_Series?: Maybe<Scalars["String"]>;
  settlementAccount?: Maybe<Scalars["String"]>;
  correspondentAccount?: Maybe<Scalars["String"]>;
  BIK?: Maybe<Scalars["String"]>;
  bankName?: Maybe<Scalars["String"]>;
  responsibleForLadaEmail?: Maybe<Scalars["String"]>;
  responsibleForLadaFax?: Maybe<Scalars["String"]>;
  responsibleForLadaPhone?: Maybe<Scalars["String"]>;
  responsibleForLadaCode?: Maybe<Scalars["String"]>;
  responsibleForLadaName?: Maybe<Scalars["String"]>;
  accountantEmail?: Maybe<Scalars["String"]>;
  accountantFax?: Maybe<Scalars["String"]>;
  accountantPhone?: Maybe<Scalars["String"]>;
  accountantCode?: Maybe<Scalars["String"]>;
  accountantName?: Maybe<Scalars["String"]>;
  protocolOfTermination?: Maybe<Scalars["String"]>;
  protocolOfConclusion?: Maybe<Scalars["String"]>;
  category?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  regionCode?: Maybe<Scalars["String"]>;
  address?: Maybe<Scalars["String"]>;
  addressEn?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  countryEn?: Maybe<Scalars["String"]>;
  FO?: Maybe<Scalars["String"]>;
  FOEn?: Maybe<Scalars["String"]>;
  subject?: Maybe<Scalars["String"]>;
  subjectEn?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  cityEn?: Maybe<Scalars["String"]>;
  headFax?: Maybe<Scalars["String"]>;
  headCode?: Maybe<Scalars["String"]>;
  headNameGenitive?: Maybe<Scalars["String"]>;
  headPositionGenitive?: Maybe<Scalars["String"]>;
  EP?: Maybe<Scalars["String"]>;
  EPEn?: Maybe<Scalars["String"]>;
  headName?: Maybe<Scalars["String"]>;
  headNameEn?: Maybe<Scalars["String"]>;
  headPhone?: Maybe<Scalars["String"]>;
  headMobilePhone?: Maybe<Scalars["String"]>;
  headEmail?: Maybe<Scalars["String"]>;
  ownerName?: Maybe<Scalars["String"]>;
  ownerNameEn?: Maybe<Scalars["String"]>;
  ownerPhone?: Maybe<Scalars["String"]>;
  ownerMobilePhone?: Maybe<Scalars["String"]>;
  ownerEmail?: Maybe<Scalars["String"]>;
  birCode?: Maybe<Scalars["String"]>;
  beginWorkingDate?: Maybe<Scalars["DateTime"]>;
  contractId?: Maybe<Scalars["ID"]>;
  headCompanyId?: Maybe<Scalars["ID"]>;
  PhotoDealerCenterId?: Maybe<Scalars["ID"]>;
  PhotoOwnerId?: Maybe<Scalars["ID"]>;
  PhotoBossId?: Maybe<Scalars["ID"]>;
  ScanOwnerPersonDataId?: Maybe<Scalars["ID"]>;
  ScanBossPersonDataId?: Maybe<Scalars["ID"]>;
  OrganizationalLegalForm?: Maybe<Scalars["String"]>;
  id: Scalars["ID"];
  successorId: Scalars["ID"];
  status?: Maybe<DealerStatus>;
  X_SHOP_FLAG?: Maybe<Scalars["Boolean"]>;
  X_STO_PHCODE?: Maybe<Scalars["String"]>;
  X_STO_PHONE?: Maybe<Scalars["String"]>;
  X_STO_EMAIL?: Maybe<Scalars["String"]>;
  X_SHOP_PHCODE?: Maybe<Scalars["String"]>;
  X_SHOP_PHONE?: Maybe<Scalars["String"]>;
  X_SHOP_EMAIL?: Maybe<Scalars["String"]>;
  X_SHOP_NAME?: Maybe<Scalars["String"]>;
  stoPhCode?: Maybe<Scalars["String"]>;
  stoPhone?: Maybe<Scalars["String"]>;
  stoEmail?: Maybe<Scalars["String"]>;
  houseId?: Maybe<Scalars["ID"]>;
  legalHouseId?: Maybe<Scalars["ID"]>;
  postalHouseId?: Maybe<Scalars["ID"]>;
}>;

export type ChangeDealerMutation = { __typename?: "Mutation" } & {
  DealerSetter?: Maybe<
    { __typename?: "DealerSetter" } & Pick<DealerSetter, "changeDealer">
  >;
};

export type UploadDealersMutationVariables = Exact<{
  fileId: Scalars["ID"];
  description?: Maybe<Scalars["String"]>;
}>;

export type UploadDealersMutation = { __typename?: "Mutation" } & {
  DealerSetter?: Maybe<
    { __typename?: "DealerSetter" } & Pick<DealerSetter, "uploadDealers">
  >;
};

export type SetProjectDocumentationDealerMutationVariables = Exact<{
  FileId: Scalars["ID"];
  DealerId: Scalars["ID"];
  name: Scalars["String"];
}>;

export type SetProjectDocumentationDealerMutation = {
  __typename?: "Mutation";
} & {
  DealerSetter?: Maybe<
    { __typename?: "DealerSetter" } & {
      setProjectDocumentationDealer?: Maybe<
        { __typename?: "DealerProjectDocumentation" } & Pick<
          DealerProjectDocumentation,
          "id"
        >
      >;
    }
  >;
};

export type AcceptUploadDealerValuesMutationVariables = Exact<{
  IndicatorUploadId: Scalars["ID"];
}>;

export type AcceptUploadDealerValuesMutation = { __typename?: "Mutation" } & {
  DealerSetter?: Maybe<
    { __typename?: "DealerSetter" } & Pick<DealerSetter, "acceptUploadDealer">
  >;
};

export type GetFreeIdMutationVariables = Exact<{ [key: string]: never }>;

export type GetFreeIdMutation = { __typename?: "Mutation" } & {
  DealerSetter?: Maybe<
    { __typename?: "DealerSetter" } & Pick<DealerSetter, "getFreeId">
  >;
};

export type CreateDealerMutationVariables = Exact<{
  KPP: Scalars["String"];
  ContractEndDate?: Maybe<Scalars["DateTime"]>;
  IS_Id?: Maybe<Scalars["String"]>;
  Main?: Maybe<Scalars["Int"]>;
  ScanAccountantPersonDataId?: Maybe<Scalars["ID"]>;
  ScanLadaPersonDataId?: Maybe<Scalars["ID"]>;
  reestrAddress?: Maybe<Scalars["String"]>;
  reestrPostAddress?: Maybe<Scalars["String"]>;
  reestrLegalAddress?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  typeEn?: Maybe<Scalars["String"]>;
  DealerName?: Maybe<Scalars["String"]>;
  DealerNameEn?: Maybe<Scalars["String"]>;
  tradeDealerName?: Maybe<Scalars["String"]>;
  tradeDealerNameEn?: Maybe<Scalars["String"]>;
  legalDealerName?: Maybe<Scalars["String"]>;
  legalDealerNameEn?: Maybe<Scalars["String"]>;
  INN?: Maybe<Scalars["String"]>;
  newDealer?: Maybe<Scalars["Int"]>;
  temporaryDecision?: Maybe<Scalars["Int"]>;
  protocolOfIntentions?: Maybe<Scalars["Int"]>;
  logicalType?: Maybe<Scalars["Int"]>;
  extendedForNextYear?: Maybe<Scalars["Int"]>;
  terminated?: Maybe<Scalars["Int"]>;
  hideOnLadaRu?: Maybe<Scalars["Int"]>;
  DealerLADASERV?: Maybe<Scalars["Int"]>;
  OGRN?: Maybe<Scalars["String"]>;
  termOfAuthority?: Maybe<Scalars["DateTime"]>;
  consumerCode?: Maybe<Scalars["String"]>;
  corporateEmail?: Maybe<Scalars["String"]>;
  EGR_Number?: Maybe<Scalars["String"]>;
  EGR_Series?: Maybe<Scalars["String"]>;
  EGR_Date?: Maybe<Scalars["DateTime"]>;
  settlementAccount?: Maybe<Scalars["String"]>;
  correspondentAccount?: Maybe<Scalars["String"]>;
  BIK?: Maybe<Scalars["String"]>;
  bankName?: Maybe<Scalars["String"]>;
  responsibleForLadaEmail?: Maybe<Scalars["String"]>;
  responsibleForLadaFax?: Maybe<Scalars["String"]>;
  responsibleForLadaPhone?: Maybe<Scalars["String"]>;
  responsibleForLadaCode?: Maybe<Scalars["String"]>;
  responsibleForLadaName?: Maybe<Scalars["String"]>;
  accountantEmail?: Maybe<Scalars["String"]>;
  accountantFax?: Maybe<Scalars["String"]>;
  accountantPhone?: Maybe<Scalars["String"]>;
  accountantCode?: Maybe<Scalars["String"]>;
  accountantName?: Maybe<Scalars["String"]>;
  protocolOfTermination?: Maybe<Scalars["String"]>;
  protocolOfConclusion?: Maybe<Scalars["String"]>;
  category?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  regionCode?: Maybe<Scalars["String"]>;
  headFax?: Maybe<Scalars["String"]>;
  headCode?: Maybe<Scalars["String"]>;
  headNameGenitive?: Maybe<Scalars["String"]>;
  headPositionGenitive?: Maybe<Scalars["String"]>;
  EP?: Maybe<Scalars["String"]>;
  EPEn?: Maybe<Scalars["String"]>;
  headName?: Maybe<Scalars["String"]>;
  headNameEn?: Maybe<Scalars["String"]>;
  headPhone?: Maybe<Scalars["String"]>;
  headMobilePhone?: Maybe<Scalars["String"]>;
  headEmail?: Maybe<Scalars["String"]>;
  ownerName?: Maybe<Scalars["String"]>;
  ownerNameEn?: Maybe<Scalars["String"]>;
  ownerPhone?: Maybe<Scalars["String"]>;
  ownerMobilePhone?: Maybe<Scalars["String"]>;
  ownerEmail?: Maybe<Scalars["String"]>;
  birCode?: Maybe<Scalars["String"]>;
  beginWorkingDate?: Maybe<Scalars["DateTime"]>;
  contractId?: Maybe<Scalars["ID"]>;
  headCompanyId?: Maybe<Scalars["ID"]>;
  PhotoDealerCenterId?: Maybe<Scalars["ID"]>;
  PhotoOwnerId?: Maybe<Scalars["ID"]>;
  PhotoBossId?: Maybe<Scalars["ID"]>;
  ScanOwnerPersonDataId?: Maybe<Scalars["ID"]>;
  ScanBossPersonDataId?: Maybe<Scalars["ID"]>;
  OrganizationalLegalForm?: Maybe<Scalars["String"]>;
  status?: Maybe<DealerStatus>;
  id: Scalars["ID"];
  successorId: Scalars["ID"];
  X_SHOP_FLAG?: Maybe<Scalars["Boolean"]>;
  X_STO_PHCODE?: Maybe<Scalars["String"]>;
  X_STO_PHONE?: Maybe<Scalars["String"]>;
  X_STO_EMAIL?: Maybe<Scalars["String"]>;
  X_SHOP_PHCODE?: Maybe<Scalars["String"]>;
  X_SHOP_PHONE?: Maybe<Scalars["String"]>;
  X_SHOP_EMAIL?: Maybe<Scalars["String"]>;
  X_SHOP_NAME?: Maybe<Scalars["String"]>;
  stoPhCode?: Maybe<Scalars["String"]>;
  stoPhone?: Maybe<Scalars["String"]>;
  stoEmail?: Maybe<Scalars["String"]>;
}>;

export type CreateDealerMutation = { __typename?: "Mutation" } & {
  DealerSetter?: Maybe<
    { __typename?: "DealerSetter" } & {
      createDealer?: Maybe<
        { __typename?: "Dealer" } & Pick<Dealer, "id" | "status">
      >;
    }
  >;
};

export type CreateDealerDomainMutationVariables = Exact<{
  domain: Scalars["String"];
  dealerId: Scalars["ID"];
}>;

export type CreateDealerDomainMutation = { __typename?: "Mutation" } & {
  DealerSetter?: Maybe<
    { __typename?: "DealerSetter" } & {
      createDealerDomain?: Maybe<
        { __typename?: "DealerDomainType" } & Pick<DealerDomainType, "id">
      >;
    }
  >;
};

export type DeleteDealerDomainMutationVariables = Exact<{
  domainId: Scalars["ID"];
}>;

export type DeleteDealerDomainMutation = { __typename?: "Mutation" } & {
  DealerSetter?: Maybe<
    { __typename?: "DealerSetter" } & Pick<DealerSetter, "deleteDealerDomain">
  >;
};

export type ChangeDealerFieldMutationVariables = Exact<{
  changeDealerFieldId: Scalars["ID"];
  fieldRu?: Maybe<Scalars["String"]>;
  fieldEn?: Maybe<Scalars["String"]>;
  fieldRuDescription?: Maybe<Scalars["String"]>;
  fieldEnDescription?: Maybe<Scalars["String"]>;
}>;

export type ChangeDealerFieldMutation = { __typename?: "Mutation" } & {
  DealerSetter?: Maybe<
    { __typename?: "DealerSetter" } & Pick<DealerSetter, "changeDealerField">
  >;
};

export type CreateCatalogMutationVariables = Exact<{
  name?: Maybe<Scalars["String"]>;
  parentId?: Maybe<Scalars["ID"]>;
}>;

export type CreateCatalogMutation = { __typename?: "Mutation" } & {
  DocumentSetter?: Maybe<
    { __typename?: "DocumentSetter" } & {
      createSection?: Maybe<{ __typename?: "Section" } & CatalogFragment>;
    }
  >;
};

export type EditCatalogMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  parentId?: Maybe<Scalars["ID"]>;
}>;

export type EditCatalogMutation = { __typename?: "Mutation" } & {
  DocumentSetter?: Maybe<
    { __typename?: "DocumentSetter" } & {
      editSection?: Maybe<{ __typename?: "Section" } & CatalogFragment>;
    }
  >;
};

export type DeleteCatalogMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type DeleteCatalogMutation = { __typename?: "Mutation" } & {
  DocumentSetter?: Maybe<
    { __typename?: "DocumentSetter" } & {
      deleteSection?: Maybe<{ __typename?: "Section" } & CatalogFragment>;
    }
  >;
};

export type CreateDocumentMutationVariables = Exact<{
  name?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  importance?: Maybe<Scalars["String"]>;
  signedBy?: Maybe<Scalars["String"]>;
  sectionId?: Maybe<Scalars["ID"]>;
  subSectionId?: Maybe<Scalars["ID"]>;
  SubdivisionId?: Maybe<Scalars["ID"]>;
  status?: Maybe<Scalars["String"]>;
  filesIds: Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>;
}>;

export type CreateDocumentMutation = { __typename?: "Mutation" } & {
  DocumentSetter?: Maybe<
    { __typename?: "DocumentSetter" } & {
      create?: Maybe<{ __typename?: "Document" } & DocumentFragment>;
    }
  >;
};

export type EditDocumentMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  importance?: Maybe<Scalars["String"]>;
  signedBy?: Maybe<Scalars["String"]>;
  sectionId?: Maybe<Scalars["ID"]>;
  subSectionId?: Maybe<Scalars["ID"]>;
  SubdivisionId?: Maybe<Scalars["ID"]>;
  status?: Maybe<Scalars["String"]>;
  filesIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type EditDocumentMutation = { __typename?: "Mutation" } & {
  DocumentSetter?: Maybe<
    { __typename?: "DocumentSetter" } & {
      edit?: Maybe<{ __typename?: "Document" } & DocumentFragment>;
    }
  >;
};

export type SetDocumentStatusMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  status?: Maybe<Scalars["String"]>;
  canceledReason?: Maybe<Scalars["String"]>;
}>;

export type SetDocumentStatusMutation = { __typename?: "Mutation" } & {
  DocumentSetter?: Maybe<
    { __typename?: "DocumentSetter" } & {
      setStatus?: Maybe<{ __typename?: "Document" } & DocumentFragment>;
    }
  >;
};

export type EditCurriculumGroupMutationVariables = Exact<{
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  status?: Maybe<CurriculumGroupStatus>;
  sequenceNumber?: Maybe<Scalars["Int"]>;
}>;

export type EditCurriculumGroupMutation = { __typename?: "Mutation" } & {
  EducationSetter?: Maybe<
    { __typename?: "EducationSetter" } & {
      editCurriculumGroup?: Maybe<
        { __typename?: "GroupCurriculum" } & Pick<GroupCurriculum, "id">
      >;
    }
  >;
};

export type CreateCurriculumGroupMutationVariables = Exact<{
  name: Scalars["String"];
  status: CurriculumGroupStatus;
  sequenceNumber?: Maybe<Scalars["Int"]>;
}>;

export type CreateCurriculumGroupMutation = { __typename?: "Mutation" } & {
  EducationSetter?: Maybe<
    { __typename?: "EducationSetter" } & {
      createCurriculumGroup?: Maybe<
        { __typename?: "GroupCurriculum" } & Pick<GroupCurriculum, "id">
      >;
    }
  >;
};

export type EditCurriculumLevelMutationVariables = Exact<{
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  status?: Maybe<CurriculumLevelStatus>;
  GroupId?: Maybe<Scalars["ID"]>;
  sequenceNumber?: Maybe<Scalars["Int"]>;
  isCertification?: Maybe<Scalars["Boolean"]>;
  dateActiveStatus?: Maybe<Scalars["DateTime"]>;
  dateInactiveStatus?: Maybe<Scalars["DateTime"]>;
}>;

export type EditCurriculumLevelMutation = { __typename?: "Mutation" } & {
  EducationSetter?: Maybe<
    { __typename?: "EducationSetter" } & {
      editCurriculumLevel?: Maybe<
        { __typename?: "LevelCurriculum" } & Pick<LevelCurriculum, "id">
      >;
    }
  >;
};

export type CreateCurriculumLevelMutationVariables = Exact<{
  name: Scalars["String"];
  status: CurriculumLevelStatus;
  GroupId: Scalars["ID"];
  sequenceNumber?: Maybe<Scalars["Int"]>;
  isCertification?: Maybe<Scalars["Boolean"]>;
}>;

export type CreateCurriculumLevelMutation = { __typename?: "Mutation" } & {
  EducationSetter?: Maybe<
    { __typename?: "EducationSetter" } & {
      createCurriculumLevel?: Maybe<
        { __typename?: "LevelCurriculum" } & Pick<LevelCurriculum, "id">
      >;
    }
  >;
};

export type EditCurriculumCourseMutationVariables = Exact<{
  id: Scalars["ID"];
  code?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  status?: Maybe<CurriculumCourseStatus>;
  codeIS?: Maybe<Scalars["String"]>;
  LevelId?: Maybe<Scalars["ID"]>;
  certificateValidityPeriod?: Maybe<Scalars["ID"]>;
}>;

export type EditCurriculumCourseMutation = { __typename?: "Mutation" } & {
  EducationSetter?: Maybe<
    { __typename?: "EducationSetter" } & {
      editCurriculumCourse?: Maybe<
        { __typename?: "CourseCurriculum" } & Pick<CourseCurriculum, "id">
      >;
    }
  >;
};

export type CreateCurriculumCourseMutationVariables = Exact<{
  code: Scalars["String"];
  codeIS?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  LevelId?: Maybe<Scalars["ID"]>;
  status?: Maybe<CurriculumCourseStatus>;
  certificateValidityPeriod?: Maybe<Scalars["ID"]>;
}>;

export type CreateCurriculumCourseMutation = { __typename?: "Mutation" } & {
  EducationSetter?: Maybe<
    { __typename?: "EducationSetter" } & {
      createCurriculumCourse?: Maybe<
        { __typename?: "CourseCurriculum" } & Pick<CourseCurriculum, "id">
      >;
    }
  >;
};

export type EditCurriculumPositionStudyProgramsMutationVariables = Exact<{
  levels?: Maybe<
    | Array<Maybe<CreateCurriculumPositionStudyProgramsLevels>>
    | Maybe<CreateCurriculumPositionStudyProgramsLevels>
  >;
  PositionGroupId?: Maybe<Scalars["ID"]>;
  PositionIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type EditCurriculumPositionStudyProgramsMutation = {
  __typename?: "Mutation";
} & {
  EducationSetter?: Maybe<
    { __typename?: "EducationSetter" } & {
      editCurriculumPositionStudyPrograms?: Maybe<
        Array<
          Maybe<
            { __typename?: "ReturnEditCurriculumPositionStudyPrograms" } & Pick<
              ReturnEditCurriculumPositionStudyPrograms,
              "type" | "levelId" | "result" | "message"
            >
          >
        >
      >;
    }
  >;
};

export type CreateCurriculumPositionStudyProgramsMutationVariables = Exact<{
  levels?: Maybe<
    | Array<Maybe<CreateCurriculumPositionStudyProgramsLevels>>
    | Maybe<CreateCurriculumPositionStudyProgramsLevels>
  >;
  PositionIds: Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>;
}>;

export type CreateCurriculumPositionStudyProgramsMutation = {
  __typename?: "Mutation";
} & {
  EducationSetter?: Maybe<
    { __typename?: "EducationSetter" } & {
      createCurriculumPositionStudyPrograms?: Maybe<
        Array<
          Maybe<
            { __typename?: "CurriculumStudyPrograms" } & Pick<
              CurriculumStudyPrograms,
              "id"
            >
          >
        >
      >;
    }
  >;
};

export type SetGroupEducationEmployeeExpectationIndicatorMutationVariables =
  Exact<{
    GroupTrainingId?: Maybe<Scalars["ID"]>;
    GroupCertificationId?: Maybe<Scalars["ID"]>;
  }>;

export type SetGroupEducationEmployeeExpectationIndicatorMutation = {
  __typename?: "Mutation";
} & {
  EmployeeSetter?: Maybe<
    { __typename?: "EmployeeSetter" } & Pick<
      EmployeeSetter,
      "setGroupEducationEmployeeExpectationIndicator"
    >
  >;
};

export type EditCurriculumPositionStudyProgramMutationVariables = Exact<{
  PositionGroupId: Scalars["ID"];
  LevelId?: Maybe<Scalars["ID"]>;
  CourseId: Scalars["ID"];
}>;

export type EditCurriculumPositionStudyProgramMutation = {
  __typename?: "Mutation";
} & {
  EducationSetter?: Maybe<
    { __typename?: "EducationSetter" } & {
      editCurriculumPositionStudyProgram?: Maybe<
        { __typename?: "CurriculumStudyPrograms" } & Pick<
          CurriculumStudyPrograms,
          "LevelId"
        >
      >;
    }
  >;
};

export type AddBaseStaffMutationVariables = Exact<{
  surname: Scalars["String"];
  name: Scalars["String"];
  middleName?: Maybe<Scalars["String"]>;
  gender: GenderType;
  birthDay: Scalars["DateTime"];
  personalPhone?: Maybe<Scalars["String"]>;
  workPhone: Scalars["String"];
  photoId?: Maybe<Scalars["ID"]>;
  ResourcesControlUserId?: Maybe<Scalars["String"]>;
  ladaAcademiaId: Scalars["String"];
  HiredDate: Scalars["DateTime"];
  positions?: Maybe<Array<EmployeePositionInput> | EmployeePositionInput>;
  ignore: Scalars["Boolean"];
  DataConsentIds?: Maybe<Array<Maybe<Consent>> | Maybe<Consent>>;
}>;

export type AddBaseStaffMutation = { __typename?: "Mutation" } & {
  EmployeeSetter?: Maybe<
    { __typename?: "EmployeeSetter" } & {
      create?: Maybe<
        { __typename?: "CreateEmployee" } & Pick<
          CreateEmployee,
          "id" | "isCreated"
        >
      >;
    }
  >;
};

export type EditBaseStaffMutationVariables = Exact<{
  id: Scalars["ID"];
  photoId: Scalars["ID"];
  positions: Array<EditEmployeePositionInput> | EditEmployeePositionInput;
}>;

export type EditBaseStaffMutation = { __typename?: "Mutation" } & {
  EmployeeSetter?: Maybe<
    { __typename?: "EmployeeSetter" } & Pick<EmployeeSetter, "edit">
  >;
};

export type UpdateLastStatusDatePositionDealerMutationVariables = Exact<{
  EmployeeId: Scalars["ID"];
  EmployeePositionId: Scalars["ID"];
}>;

export type UpdateLastStatusDatePositionDealerMutation = {
  __typename?: "Mutation";
} & {
  EmployeeSetter?: Maybe<
    { __typename?: "EmployeeSetter" } & Pick<
      EmployeeSetter,
      "updateLastStatusDatePositionDealer"
    >
  >;
};

export type RestorePositionEmployeeMutationVariables = Exact<{
  EmployeeId: Scalars["ID"];
  PositionId: Scalars["ID"];
  DealerId: Scalars["ID"];
  number: EmployeePositionNumber;
}>;

export type RestorePositionEmployeeMutation = { __typename?: "Mutation" } & {
  EmployeeSetter?: Maybe<
    { __typename?: "EmployeeSetter" } & Pick<
      EmployeeSetter,
      "restorePositionEmployee"
    >
  >;
};

export type SendCheckMutationVariables = Exact<{
  employeeId: Scalars["ID"];
}>;

export type SendCheckMutation = { __typename?: "Mutation" } & {
  EmployeeSetter?: Maybe<
    { __typename?: "EmployeeSetter" } & {
      changeStatus?: Maybe<
        { __typename?: "changeStatus" } & {
          sendCheck: { __typename?: "ok" } & Pick<Ok, "ok">;
        }
      >;
    }
  >;
};

export type MarkVerifiedMutationVariables = Exact<{
  positionId: Scalars["ID"];
}>;

export type MarkVerifiedMutation = { __typename?: "Mutation" } & {
  EmployeeSetter?: Maybe<
    { __typename?: "EmployeeSetter" } & {
      changeStatus?: Maybe<
        { __typename?: "changeStatus" } & {
          markVerified: { __typename?: "ok" } & Pick<Ok, "ok">;
        }
      >;
    }
  >;
};

export type MarkRejectMutationVariables = Exact<{
  positionId: Scalars["ID"];
  rejectReason?: Maybe<Scalars["String"]>;
}>;

export type MarkRejectMutation = { __typename?: "Mutation" } & {
  EmployeeSetter?: Maybe<
    { __typename?: "EmployeeSetter" } & {
      changeStatus?: Maybe<
        { __typename?: "changeStatus" } & {
          markReject: { __typename?: "ok" } & Pick<Ok, "ok">;
        }
      >;
    }
  >;
};

export type UploadFileCatalogMutationVariables = Exact<{
  fileId: Scalars["ID"];
  catalog: Scalars["String"];
  DealerId?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
}>;

export type UploadFileCatalogMutation = { __typename?: "Mutation" } & {
  FileCatalogSetter?: Maybe<
    { __typename?: "FileCatalogSetter" } & {
      uploadFile?: Maybe<
        { __typename?: "File" } & Pick<
          File,
          "id" | "name" | "link" | "mimeType" | "type" | "createdAt" | "hash"
        > & {
            User?: Maybe<
              { __typename?: "Profile" } & Pick<
                Profile,
                "fullname" | "fullnameEn"
              >
            >;
          }
      >;
    }
  >;
};

export type DeleteFileCatalogMutationVariables = Exact<{
  FileId: Scalars["ID"];
}>;

export type DeleteFileCatalogMutation = { __typename?: "Mutation" } & {
  FileCatalogSetter?: Maybe<
    { __typename?: "FileCatalogSetter" } & Pick<FileCatalogSetter, "deleteFile">
  >;
};

export type EditFileCatalogMutationVariables = Exact<{
  FileId: Scalars["ID"];
  catalog?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
}>;

export type EditFileCatalogMutation = { __typename?: "Mutation" } & {
  FileCatalogSetter?: Maybe<
    { __typename?: "FileCatalogSetter" } & {
      editFile?: Maybe<
        { __typename?: "File" } & Pick<File, "id" | "name" | "createdAt">
      >;
    }
  >;
};

export type CreateGeoPlaceMutationVariables = Exact<{
  name: Scalars["String"];
  socr: Scalars["String"];
  cladrCode: Scalars["String"];
  okatoCode: Scalars["String"];
  type: GeoPlaceType;
  active: Scalars["Boolean"];
  parentId?: Maybe<Scalars["ID"]>;
}>;

export type CreateGeoPlaceMutation = { __typename?: "Mutation" } & {
  GeoSetter?: Maybe<
    { __typename?: "GeoSetter" } & {
      createGeoPlace?: Maybe<
        { __typename?: "GeoPlace" } & Pick<
          GeoPlace,
          | "id"
          | "parentId"
          | "type"
          | "name"
          | "nameEn"
          | "socr"
          | "cladrCode"
          | "okatoCode"
          | "active"
          | "createdAt"
          | "updatedAt"
        >
      >;
    }
  >;
};

export type ChangeGeoPlaceMutationVariables = Exact<{
  changeGeoPlaceId: Scalars["ID"];
  name: Scalars["String"];
  socr: Scalars["String"];
  cladrCode: Scalars["String"];
  okatoCode: Scalars["String"];
  type: GeoPlaceType;
  active: Scalars["Boolean"];
  parentId?: Maybe<Scalars["ID"]>;
}>;

export type ChangeGeoPlaceMutation = { __typename?: "Mutation" } & {
  GeoSetter?: Maybe<
    { __typename?: "GeoSetter" } & Pick<GeoSetter, "changeGeoPlace">
  >;
};

export type SetGrVersionMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  quarter?: Maybe<Scalars["Int"]>;
  year?: Maybe<Scalars["Int"]>;
  dateBegin?: Maybe<Scalars["DateTime"]>;
  IndicatorId?: Maybe<Scalars["ID"]>;
}>;

export type SetGrVersionMutation = { __typename?: "Mutation" } & {
  GlobalRatingSetter?: Maybe<
    { __typename?: "GlobalRatingSetter" } & {
      setVersion?: Maybe<
        { __typename?: "GlobalRatingVersion" } & Pick<GlobalRatingVersion, "id">
      >;
    }
  >;
};

export type SetGrRatingMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  number?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  quarter1?: Maybe<Scalars["ID"]>;
  quarter2?: Maybe<Scalars["ID"]>;
  quarter1_2?: Maybe<Scalars["ID"]>;
  quarter3?: Maybe<Scalars["ID"]>;
  quarter2_3?: Maybe<Scalars["ID"]>;
  quarter4?: Maybe<Scalars["ID"]>;
  quarter3_4?: Maybe<Scalars["ID"]>;
  yearValue?: Maybe<Scalars["ID"]>;
  yearPercent?: Maybe<Scalars["ID"]>;
  type: Scalars["String"];
  sort: Scalars["Int"];
  round?: Maybe<Scalars["Int"]>;
  format?: Maybe<Scalars["Int"]>;
  ParentId?: Maybe<Scalars["ID"]>;
  PrevElementId?: Maybe<Scalars["ID"]>;
  RatingsVersionId: Scalars["ID"];
}>;

export type SetGrRatingMutation = { __typename?: "Mutation" } & {
  GlobalRatingSetter?: Maybe<
    { __typename?: "GlobalRatingSetter" } & {
      setRating?: Maybe<
        { __typename?: "GlobalRating" } & Pick<GlobalRating, "id" | "number">
      >;
    }
  >;
};

export type DeleteListRatingMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type DeleteListRatingMutation = { __typename?: "Mutation" } & {
  GlobalRatingSetter?: Maybe<
    { __typename?: "GlobalRatingSetter" } & Pick<
      GlobalRatingSetter,
      "deleteList"
    >
  >;
};

export type DeleteVersionRatingMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type DeleteVersionRatingMutation = { __typename?: "Mutation" } & {
  GlobalRatingSetter?: Maybe<
    { __typename?: "GlobalRatingSetter" } & Pick<
      GlobalRatingSetter,
      "deleteVersion"
    >
  >;
};

export type CreateIndicatorGroupMutationVariables = Exact<{
  nameRu: Scalars["String"];
  nameEn?: Maybe<Scalars["String"]>;
}>;

export type CreateIndicatorGroupMutation = { __typename?: "Mutation" } & {
  IndicatorGroupReportSetter?: Maybe<
    { __typename?: "IndicatorGroupReportSetter" } & {
      createIndicatorGroup?: Maybe<
        { __typename?: "IndicatorGroup" } & Pick<IndicatorGroup, "id">
      >;
    }
  >;
};

export type ChangeIndicatorGroupMutationVariables = Exact<{
  id: Scalars["ID"];
  nameRu: Scalars["String"];
  nameEn?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
}>;

export type ChangeIndicatorGroupMutation = { __typename?: "Mutation" } & {
  IndicatorGroupReportSetter?: Maybe<
    { __typename?: "IndicatorGroupReportSetter" } & {
      changeIndicatorGroup?: Maybe<
        { __typename?: "IndicatorGroup" } & Pick<IndicatorGroup, "id">
      >;
    }
  >;
};

export type DeleteIndicatorGroupMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type DeleteIndicatorGroupMutation = { __typename?: "Mutation" } & {
  IndicatorGroupReportSetter?: Maybe<
    { __typename?: "IndicatorGroupReportSetter" } & Pick<
      IndicatorGroupReportSetter,
      "deleteIndicatorGroup"
    >
  >;
};

export type RestoreIndicatorGroupMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type RestoreIndicatorGroupMutation = { __typename?: "Mutation" } & {
  IndicatorGroupReportSetter?: Maybe<
    { __typename?: "IndicatorGroupReportSetter" } & Pick<
      IndicatorGroupReportSetter,
      "restoreIndicatorGroup"
    >
  >;
};

export type CreateIndicatorReportMutationVariables = Exact<{
  GroupId: Scalars["ID"];
  nameRu: Scalars["String"];
}>;

export type CreateIndicatorReportMutation = { __typename?: "Mutation" } & {
  IndicatorGroupReportSetter?: Maybe<
    { __typename?: "IndicatorGroupReportSetter" } & {
      createIndicatorReport?: Maybe<
        { __typename?: "IndicatorReport" } & Pick<IndicatorReport, "id">
      >;
    }
  >;
};

export type ChangeIndicatorReportMutationVariables = Exact<{
  id: Scalars["ID"];
  nameRu: Scalars["String"];
}>;

export type ChangeIndicatorReportMutation = { __typename?: "Mutation" } & {
  IndicatorGroupReportSetter?: Maybe<
    { __typename?: "IndicatorGroupReportSetter" } & {
      changeIndicatorReport?: Maybe<
        { __typename?: "IndicatorReport" } & Pick<IndicatorReport, "id">
      >;
    }
  >;
};

export type DeleteIndicatorReportMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type DeleteIndicatorReportMutation = { __typename?: "Mutation" } & {
  IndicatorGroupReportSetter?: Maybe<
    { __typename?: "IndicatorGroupReportSetter" } & Pick<
      IndicatorGroupReportSetter,
      "deleteIndicatorReport"
    >
  >;
};

export type RestoreIndicatorReportMutationVariables = Exact<{
  id: Scalars["ID"];
  GroupId: Scalars["ID"];
}>;

export type RestoreIndicatorReportMutation = { __typename?: "Mutation" } & {
  IndicatorGroupReportSetter?: Maybe<
    { __typename?: "IndicatorGroupReportSetter" } & Pick<
      IndicatorGroupReportSetter,
      "restoreIndicatorReport"
    >
  >;
};

export type AddIndicatorsToReportMutationVariables = Exact<{
  IndicatorIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  ReportId: Scalars["ID"];
}>;

export type AddIndicatorsToReportMutation = { __typename?: "Mutation" } & {
  IndicatorGroupReportSetter?: Maybe<
    { __typename?: "IndicatorGroupReportSetter" } & Pick<
      IndicatorGroupReportSetter,
      "addIndicatorsToReport"
    >
  >;
};

export type DeleteIndicatorsFromReportMutationVariables = Exact<{
  ReportId: Scalars["ID"];
}>;

export type DeleteIndicatorsFromReportMutation = { __typename?: "Mutation" } & {
  IndicatorGroupReportSetter?: Maybe<
    { __typename?: "IndicatorGroupReportSetter" } & Pick<
      IndicatorGroupReportSetter,
      "deleteIndicatorsFromReport"
    >
  >;
};

export type UpsertDealerFieldsToReportMutationVariables = Exact<{
  reportId: Scalars["ID"];
  dealerFieldsIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type UpsertDealerFieldsToReportMutation = { __typename?: "Mutation" } & {
  IndicatorGroupReportSetter?: Maybe<
    { __typename?: "IndicatorGroupReportSetter" } & Pick<
      IndicatorGroupReportSetter,
      "upsertDealerFieldsToReport"
    >
  >;
};

export type SetIndicatorMutationVariables = Exact<{
  id: Scalars["ID"];
  oldId?: Maybe<Scalars["ID"]>;
  nameRu?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  shortNameRu?: Maybe<Scalars["String"]>;
  shortNameEn?: Maybe<Scalars["String"]>;
  type: Scalars["String"];
  format: Scalars["String"];
  unit: Scalars["String"];
  period: Scalars["String"];
  status: Scalars["String"];
  enum?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
}>;

export type SetIndicatorMutation = { __typename?: "Mutation" } & {
  IndicatorSetter?: Maybe<
    { __typename?: "IndicatorSetter" } & {
      setIndicator?: Maybe<
        { __typename?: "Indicator" } & Pick<Indicator, "id">
      >;
    }
  >;
};

export type DeleteIndicatorMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type DeleteIndicatorMutation = { __typename?: "Mutation" } & {
  IndicatorSetter?: Maybe<
    { __typename?: "IndicatorSetter" } & Pick<
      IndicatorSetter,
      "deleteIndicator"
    >
  >;
};

export type RestoreIndicatorMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type RestoreIndicatorMutation = { __typename?: "Mutation" } & {
  IndicatorSetter?: Maybe<
    { __typename?: "IndicatorSetter" } & Pick<
      IndicatorSetter,
      "restoreIndicator"
    >
  >;
};

export type UploadIndicatorValuesMutationVariables = Exact<{
  fileId: Scalars["ID"];
  description?: Maybe<Scalars["String"]>;
}>;

export type UploadIndicatorValuesMutation = { __typename?: "Mutation" } & {
  IndicatorSetter?: Maybe<
    { __typename?: "IndicatorSetter" } & Pick<
      IndicatorSetter,
      "uploadIndicatorValues"
    >
  >;
};

export type AcceptUploadIndicatorValuesMutationVariables = Exact<{
  IndicatorUploadId: Scalars["ID"];
}>;

export type AcceptUploadIndicatorValuesMutation = {
  __typename?: "Mutation";
} & {
  IndicatorSetter?: Maybe<
    { __typename?: "IndicatorSetter" } & Pick<
      IndicatorSetter,
      "acceptUploadIndicatorValues"
    >
  >;
};

export type RejectUploadIndicatorValuesMutationVariables = Exact<{
  IndicatorUploadId: Scalars["ID"];
}>;

export type RejectUploadIndicatorValuesMutation = {
  __typename?: "Mutation";
} & {
  IndicatorSetter?: Maybe<
    { __typename?: "IndicatorSetter" } & Pick<
      IndicatorSetter,
      "rejectUploadIndicatorValues"
    >
  >;
};

export type SetCreateNotesMutationVariables = Exact<{
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  ImageIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
}>;

export type SetCreateNotesMutation = { __typename?: "Mutation" } & {
  NotesSetter?: Maybe<
    { __typename?: "NotesSetter" } & {
      create?: Maybe<{ __typename?: "Notes" } & Pick<Notes, "id">>;
    }
  >;
};

export type SetChangeNotesMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  ImageIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
}>;

export type SetChangeNotesMutation = { __typename?: "Mutation" } & {
  NotesSetter?: Maybe<
    { __typename?: "NotesSetter" } & {
      change?: Maybe<{ __typename?: "Notes" } & Pick<Notes, "id">>;
    }
  >;
};

export type SetBlindChangeNotesMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  ImageIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
}>;

export type SetBlindChangeNotesMutation = { __typename?: "Mutation" } & {
  NotesSetter?: Maybe<
    { __typename?: "NotesSetter" } & {
      blindChange?: Maybe<{ __typename?: "Notes" } & Pick<Notes, "id">>;
    }
  >;
};

export type SetAddValuesNotesMutationVariables = Exact<{
  Compliance?: Maybe<Scalars["Int"]>;
  Image?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  DealerId?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
}>;

export type SetAddValuesNotesMutation = { __typename?: "Mutation" } & {
  NotesSetter?: Maybe<
    { __typename?: "NotesSetter" } & Pick<NotesSetter, "addValues">
  >;
};

export type SetDeleteNotesMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type SetDeleteNotesMutation = { __typename?: "Mutation" } & {
  NotesSetter?: Maybe<
    { __typename?: "NotesSetter" } & Pick<NotesSetter, "delete">
  >;
};

export type SetCreatePersonalMutationVariables = Exact<{
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  PersonNameIndicator?: Maybe<Scalars["ID"]>;
  PositionIndicator?: Maybe<Scalars["ID"]>;
  PositionStartIndicator?: Maybe<Scalars["ID"]>;
  StudyCertificateDateIndicator?: Maybe<Scalars["ID"]>;
  ImageIndicator?: Maybe<Scalars["ID"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  DocName?: Maybe<Scalars["String"]>;
  Number?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
}>;

export type SetCreatePersonalMutation = { __typename?: "Mutation" } & {
  PersonalSetter?: Maybe<
    { __typename?: "PersonalSetter" } & {
      create?: Maybe<{ __typename?: "Personal" } & Pick<Personal, "id">>;
    }
  >;
};

export type SetChangePersonalMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  PersonNameIndicator?: Maybe<Scalars["ID"]>;
  PositionIndicator?: Maybe<Scalars["ID"]>;
  PositionStartIndicator?: Maybe<Scalars["ID"]>;
  StudyCertificateDateIndicator?: Maybe<Scalars["ID"]>;
  ImageIndicator?: Maybe<Scalars["ID"]>;
  DocName?: Maybe<Scalars["String"]>;
  Number?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
}>;

export type SetChangePersonalMutation = { __typename?: "Mutation" } & {
  PersonalSetter?: Maybe<
    { __typename?: "PersonalSetter" } & {
      change?: Maybe<{ __typename?: "Personal" } & Pick<Personal, "id">>;
    }
  >;
};

export type SetBlindChangePersonalMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  PersonNameIndicator?: Maybe<Scalars["ID"]>;
  PositionIndicator?: Maybe<Scalars["ID"]>;
  PositionStartIndicator?: Maybe<Scalars["ID"]>;
  StudyCertificateDateIndicator?: Maybe<Scalars["ID"]>;
  ImageIndicator?: Maybe<Scalars["ID"]>;
  DocName?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  Number?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
}>;

export type SetBlindChangePersonalMutation = { __typename?: "Mutation" } & {
  PersonalSetter?: Maybe<
    { __typename?: "PersonalSetter" } & {
      blindChange?: Maybe<{ __typename?: "Personal" } & Pick<Personal, "id">>;
    }
  >;
};

export type SetAddValuesPersonalMutationVariables = Exact<{
  Compliance?: Maybe<Scalars["Int"]>;
  PersonName?: Maybe<Scalars["String"]>;
  Position?: Maybe<Scalars["String"]>;
  PositionStart?: Maybe<Scalars["String"]>;
  StudyCertificateDate?: Maybe<Scalars["String"]>;
  Image?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  DealerId?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
}>;

export type SetAddValuesPersonalMutation = { __typename?: "Mutation" } & {
  PersonalSetter?: Maybe<
    { __typename?: "PersonalSetter" } & Pick<PersonalSetter, "addValues">
  >;
};

export type SetDeletePersonalMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type SetDeletePersonalMutation = { __typename?: "Mutation" } & {
  PersonalSetter?: Maybe<
    { __typename?: "PersonalSetter" } & Pick<PersonalSetter, "delete">
  >;
};

export type SetDuplicatePersonalMutationVariables = Exact<{
  uuid?: Maybe<Scalars["String"]>;
}>;

export type SetDuplicatePersonalMutation = { __typename?: "Mutation" } & {
  PersonalSetter?: Maybe<
    { __typename?: "PersonalSetter" } & {
      duplicate?: Maybe<
        { __typename?: "PersonalIndicatorTypes" } & Pick<
          PersonalIndicatorTypes,
          "id"
        >
      >;
    }
  >;
};

export type SetDuplicateRequiredToolsMutationVariables = Exact<{
  uuid?: Maybe<Scalars["String"]>;
}>;

export type SetDuplicateRequiredToolsMutation = { __typename?: "Mutation" } & {
  RequiredToolsSetter?: Maybe<
    { __typename?: "RequiredToolsSetter" } & {
      duplicate?: Maybe<
        { __typename?: "RequiredToolsIndicatorTypes" } & Pick<
          RequiredToolsIndicatorTypes,
          "id"
        >
      >;
    }
  >;
};

export type SetRenameGroupPersonalMutationVariables = Exact<{
  groupType?: Maybe<ZdGroupType>;
  newGroup?: Maybe<Scalars["String"]>;
  oldGroup?: Maybe<Scalars["String"]>;
}>;

export type SetRenameGroupPersonalMutation = { __typename?: "Mutation" } & {
  PersonalSetter?: Maybe<
    { __typename?: "PersonalSetter" } & Pick<PersonalSetter, "renameGroup">
  >;
};

export type SetSortPersonalMutationVariables = Exact<{
  sort?: Maybe<Scalars["Int"]>;
  UUID: Scalars["String"];
}>;

export type SetSortPersonalMutation = { __typename?: "Mutation" } & {
  PersonalSetter?: Maybe<
    { __typename?: "PersonalSetter" } & Pick<PersonalSetter, "setSort">
  >;
};

export type SetSortGroupPersonalMutationVariables = Exact<{
  sort?: Maybe<Scalars["Int"]>;
  group: Scalars["String"];
}>;

export type SetSortGroupPersonalMutation = { __typename?: "Mutation" } & {
  PersonalSetter?: Maybe<
    { __typename?: "PersonalSetter" } & Pick<PersonalSetter, "setSortGroup">
  >;
};

export type CreatePhotoGallerySectionMutationVariables = Exact<{
  title: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
}>;

export type CreatePhotoGallerySectionMutation = { __typename?: "Mutation" } & {
  PhotoGallerySectionSetter?: Maybe<
    { __typename?: "PhotoGallerySectionSetter" } & {
      createPhotoGallerySection: { __typename?: "PhotoGallerySection" } & Pick<
        PhotoGallerySection,
        "id" | "title" | "description" | "createdAt"
      >;
    }
  >;
};

export type DeletePhotoGallerySectionMutationVariables = Exact<{
  deletePhotoGallerySectionId: Scalars["ID"];
}>;

export type DeletePhotoGallerySectionMutation = { __typename?: "Mutation" } & {
  PhotoGallerySectionSetter?: Maybe<
    { __typename?: "PhotoGallerySectionSetter" } & {
      deletePhotoGallerySection: { __typename?: "ok" } & Pick<Ok, "ok">;
    }
  >;
};

export type UpdatePhotoGallerySectionMutationVariables = Exact<{
  updatePhotoGallerySectionId?: Maybe<Scalars["ID"]>;
  title?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
}>;

export type UpdatePhotoGallerySectionMutation = { __typename?: "Mutation" } & {
  PhotoGallerySectionSetter?: Maybe<
    { __typename?: "PhotoGallerySectionSetter" } & {
      updatePhotoGallerySection: { __typename?: "PhotoGallerySection" } & Pick<
        PhotoGallerySection,
        "id" | "title" | "description" | "createdAt"
      >;
    }
  >;
};

export type SetCreatePlacePostsMutationVariables = Exact<{
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  ZD_PlacesId?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
}>;

export type SetCreatePlacePostsMutation = { __typename?: "Mutation" } & {
  PlacePostsSetter?: Maybe<
    { __typename?: "PlacePostsSetter" } & {
      create?: Maybe<{ __typename?: "PlacePosts" } & Pick<PlacePosts, "id">>;
    }
  >;
};

export type SetChangePlacePostsMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  ZD_PlacesId?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
}>;

export type SetChangePlacePostsMutation = { __typename?: "Mutation" } & {
  PlacePostsSetter?: Maybe<
    { __typename?: "PlacePostsSetter" } & {
      change?: Maybe<{ __typename?: "PlacePosts" } & Pick<PlacePosts, "id">>;
    }
  >;
};

export type SetBlindChangePlacePostsMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  ZD_PlacesId?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
}>;

export type SetBlindChangePlacePostsMutation = { __typename?: "Mutation" } & {
  PlacePostsSetter?: Maybe<
    { __typename?: "PlacePostsSetter" } & {
      blindChange?: Maybe<
        { __typename?: "PlacePosts" } & Pick<PlacePosts, "id">
      >;
    }
  >;
};

export type SetAddValuesPlacePostsMutationVariables = Exact<{
  Compliance?: Maybe<Scalars["Int"]>;
  Total?: Maybe<Scalars["Float"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
}>;

export type SetAddValuesPlacePostsMutation = { __typename?: "Mutation" } & {
  PlacePostsSetter?: Maybe<
    { __typename?: "PlacePostsSetter" } & Pick<PlacePostsSetter, "addValues">
  >;
};

export type SetDeletePlacePostsMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type SetDeletePlacePostsMutation = { __typename?: "Mutation" } & {
  PlacePostsSetter?: Maybe<
    { __typename?: "PlacePostsSetter" } & Pick<PlacePostsSetter, "delete">
  >;
};

export type SetCreatePlacesMutationVariables = Exact<{
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  AreaIndicator?: Maybe<Scalars["ID"]>;
  PlacesCombineIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
}>;

export type SetCreatePlacesMutation = { __typename?: "Mutation" } & {
  PlacesSetter?: Maybe<
    { __typename?: "PlacesSetter" } & {
      create?: Maybe<{ __typename?: "Places" } & Pick<Places, "id">>;
    }
  >;
};

export type SetChangePlacesMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  AreaIndicator?: Maybe<Scalars["ID"]>;
  PlacesCombineIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
}>;

export type SetChangePlacesMutation = { __typename?: "Mutation" } & {
  PlacesSetter?: Maybe<
    { __typename?: "PlacesSetter" } & {
      change?: Maybe<{ __typename?: "Places" } & Pick<Places, "id">>;
    }
  >;
};

export type SetBlindChangePlacesMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  AreaIndicator?: Maybe<Scalars["ID"]>;
  PlacesCombineIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
}>;

export type SetBlindChangePlacesMutation = { __typename?: "Mutation" } & {
  PlacesSetter?: Maybe<
    { __typename?: "PlacesSetter" } & {
      blindChange?: Maybe<{ __typename?: "Places" } & Pick<Places, "id">>;
    }
  >;
};

export type SetAddValuesPlacesMutationVariables = Exact<{
  Compliance?: Maybe<Scalars["Int"]>;
  PlacesCombine?: Maybe<Scalars["String"]>;
  Area?: Maybe<Scalars["Float"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
}>;

export type SetAddValuesPlacesMutation = { __typename?: "Mutation" } & {
  PlacesSetter?: Maybe<
    { __typename?: "PlacesSetter" } & Pick<PlacesSetter, "addValues">
  >;
};

export type SetDeletePlacesMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type SetDeletePlacesMutation = { __typename?: "Mutation" } & {
  PlacesSetter?: Maybe<
    { __typename?: "PlacesSetter" } & Pick<PlacesSetter, "delete">
  >;
};

export type SetMakeVisibleMutationVariables = Exact<{
  PlanReportId: Scalars["ID"];
  reason: Scalars["String"];
}>;

export type SetMakeVisibleMutation = { __typename?: "Mutation" } & {
  PlanReportSetter?: Maybe<
    { __typename?: "PlanReportSetter" } & Pick<PlanReportSetter, "makeVisible">
  >;
};

export type SetDealerFixPlanMutationVariables = Exact<{
  PlanReportId: Scalars["ID"];
  DealerId: Scalars["ID"];
  fixExplanation?: Maybe<Scalars["String"]>;
  planToFixAt?: Maybe<Scalars["DateTime"]>;
  responsiblePersonContact?: Maybe<Scalars["String"]>;
}>;

export type SetDealerFixPlanMutation = { __typename?: "Mutation" } & {
  PlanReportSetter?: Maybe<
    { __typename?: "PlanReportSetter" } & Pick<
      PlanReportSetter,
      "dealerFixPlan"
    >
  >;
};

export type SetDealerStateFixDoneMutationVariables = Exact<{
  PlanReportId: Scalars["ID"];
  DealerId: Scalars["ID"];
}>;

export type SetDealerStateFixDoneMutation = { __typename?: "Mutation" } & {
  PlanReportSetter?: Maybe<
    { __typename?: "PlanReportSetter" } & Pick<
      PlanReportSetter,
      "dealerStateFixDone"
    >
  >;
};

export type SetDealerFixPlanAddDocumentMutationVariables = Exact<{
  PlanReportId: Scalars["ID"];
  DealerId: Scalars["ID"];
  fileIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type SetDealerFixPlanAddDocumentMutation = {
  __typename?: "Mutation";
} & {
  PlanReportSetter?: Maybe<
    { __typename?: "PlanReportSetter" } & Pick<
      PlanReportSetter,
      "dealerFixPlanAddDocument"
    >
  >;
};

export type SetDealerFixPlanRemoveDocumentDocumentMutationVariables = Exact<{
  PlanReportId: Scalars["ID"];
  DealerId: Scalars["ID"];
  fileId: Scalars["ID"];
}>;

export type SetDealerFixPlanRemoveDocumentDocumentMutation = {
  __typename?: "Mutation";
} & {
  PlanReportSetter?: Maybe<
    { __typename?: "PlanReportSetter" } & Pick<
      PlanReportSetter,
      "dealerFixPlanRemoveDocument"
    >
  >;
};

export type SetCheckDealersFixMutationVariables = Exact<{
  PlanReportId: Scalars["ID"];
  isGood: Scalars["Boolean"];
}>;

export type SetCheckDealersFixMutation = { __typename?: "Mutation" } & {
  PlanReportSetter?: Maybe<
    { __typename?: "PlanReportSetter" } & Pick<
      PlanReportSetter,
      "checkDealersFix"
    >
  >;
};

export type SetAddPositionMutationVariables = Exact<{
  code: Scalars["String"];
  name: Scalars["String"];
  nameEn?: Maybe<Scalars["String"]>;
  status: PositionStatus;
  DirectionId: Scalars["ID"];
  RequiredEmail?: Maybe<Scalars["Boolean"]>;
  jobDescriptionIsRequired?: Maybe<Scalars["Boolean"]>;
}>;

export type SetAddPositionMutation = { __typename?: "Mutation" } & {
  PositionSetter?: Maybe<
    { __typename?: "PositionSetter" } & {
      createPosition?: Maybe<
        { __typename?: "Position" } & Pick<Position, "name">
      >;
    }
  >;
};

export type SetEditPositionMutationVariables = Exact<{
  id: Scalars["ID"];
  code?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  status?: Maybe<PositionStatus>;
  DirectionId?: Maybe<Scalars["ID"]>;
  RequiredEmail?: Maybe<Scalars["Boolean"]>;
  showInZD?: Maybe<Scalars["Boolean"]>;
  jobDescriptionIsRequired?: Maybe<Scalars["Boolean"]>;
}>;

export type SetEditPositionMutation = { __typename?: "Mutation" } & {
  PositionSetter?: Maybe<
    { __typename?: "PositionSetter" } & {
      editPosition?: Maybe<{ __typename?: "Position" } & Pick<Position, "id">>;
    }
  >;
};

export type CreateDirectionMutationVariables = Exact<{
  name: Scalars["String"];
  status: PositionDirectionsStatus;
  role: Array<Maybe<PositionDirectionsRole>> | Maybe<PositionDirectionsRole>;
}>;

export type CreateDirectionMutation = { __typename?: "Mutation" } & {
  PositionSetter?: Maybe<
    { __typename?: "PositionSetter" } & {
      createDirection?: Maybe<
        { __typename?: "PositionDirections" } & Pick<PositionDirections, "id">
      >;
    }
  >;
};

export type EditDirectionMutationVariables = Exact<{
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  status?: Maybe<PositionDirectionsStatus>;
  role?: Maybe<
    Array<Maybe<PositionDirectionsRole>> | Maybe<PositionDirectionsRole>
  >;
}>;

export type EditDirectionMutation = { __typename?: "Mutation" } & {
  PositionSetter?: Maybe<
    { __typename?: "PositionSetter" } & {
      editDirection?: Maybe<
        { __typename?: "PositionDirections" } & Pick<PositionDirections, "id">
      >;
    }
  >;
};

export type CreateInformationSystemMutationVariables = Exact<{
  name: Scalars["String"];
  positions?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type CreateInformationSystemMutation = { __typename?: "Mutation" } & {
  PositionSetter?: Maybe<
    { __typename?: "PositionSetter" } & {
      createInformationSystem?: Maybe<
        { __typename?: "InformationSystem" } & Pick<InformationSystem, "id">
      >;
    }
  >;
};

export type EditInformationSystemMutationVariables = Exact<{
  id: Scalars["ID"];
  name: Scalars["String"];
  positions?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type EditInformationSystemMutation = { __typename?: "Mutation" } & {
  PositionSetter?: Maybe<
    { __typename?: "PositionSetter" } & {
      editInformationSystem?: Maybe<
        { __typename?: "InformationSystem" } & Pick<InformationSystem, "id">
      >;
    }
  >;
};

export type CreatePersonalInformationMutationVariables = Exact<{
  name: Scalars["String"];
  personalDataTemplateId?: Maybe<Scalars["ID"]>;
  informationSystemId?: Maybe<Scalars["ID"]>;
}>;

export type CreatePersonalInformationMutation = { __typename?: "Mutation" } & {
  PositionSetter?: Maybe<
    { __typename?: "PositionSetter" } & {
      createPersonalInformation?: Maybe<
        { __typename?: "PersonalInformation" } & Pick<PersonalInformation, "id">
      >;
    }
  >;
};

export type EditPersonalInformationMutationVariables = Exact<{
  id: Scalars["ID"];
  name: Scalars["String"];
  personalDataTemplate?: Maybe<Scalars["String"]>;
  informationSystemId?: Maybe<Scalars["ID"]>;
}>;

export type EditPersonalInformationMutation = { __typename?: "Mutation" } & {
  PositionSetter?: Maybe<
    { __typename?: "PositionSetter" } & {
      editPersonalInformation?: Maybe<
        { __typename?: "PersonalInformation" } & Pick<PersonalInformation, "id">
      >;
    }
  >;
};

export type SetQVersionMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  quarter?: Maybe<Scalars["Int"]>;
  year?: Maybe<Scalars["Int"]>;
  dateBegin?: Maybe<Scalars["DateTime"]>;
  IndicatorId?: Maybe<Scalars["ID"]>;
  IndicatorGroupId?: Maybe<Scalars["ID"]>;
}>;

export type SetQVersionMutation = { __typename?: "Mutation" } & {
  QuartilesRatingSetter?: Maybe<
    { __typename?: "QuartilesRatingSetter" } & {
      setVersion?: Maybe<
        { __typename?: "QuartilesRatingVersion" } & Pick<
          QuartilesRatingVersion,
          "id"
        >
      >;
    }
  >;
};

export type SetQRatingMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  number?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  KPIen?: Maybe<Scalars["String"]>;
  KPIru?: Maybe<Scalars["String"]>;
  LastPeriodIndicatorId?: Maybe<Scalars["ID"]>;
  ValueIndicatorId?: Maybe<Scalars["ID"]>;
  GroupIndicatorId?: Maybe<Scalars["ID"]>;
  AverageIndicatorId?: Maybe<Scalars["ID"]>;
  DifferenceIndicatorId?: Maybe<Scalars["ID"]>;
  GroupAverageIndicatorId?: Maybe<Scalars["ID"]>;
  type: Scalars["String"];
  sort: Scalars["Int"];
  round?: Maybe<Scalars["Int"]>;
  format?: Maybe<Scalars["Int"]>;
  ParentId?: Maybe<Scalars["ID"]>;
  PrevElementId?: Maybe<Scalars["ID"]>;
  RatingsVersionId: Scalars["ID"];
}>;

export type SetQRatingMutation = { __typename?: "Mutation" } & {
  QuartilesRatingSetter?: Maybe<
    { __typename?: "QuartilesRatingSetter" } & {
      setRating?: Maybe<
        { __typename?: "QuartilesRating" } & Pick<
          QuartilesRating,
          "id" | "number"
        >
      >;
    }
  >;
};

export type DeleteQListRatingMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type DeleteQListRatingMutation = { __typename?: "Mutation" } & {
  QuartilesRatingSetter?: Maybe<
    { __typename?: "QuartilesRatingSetter" } & Pick<
      QuartilesRatingSetter,
      "deleteList"
    >
  >;
};

export type DeleteQVersionRatingMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type DeleteQVersionRatingMutation = { __typename?: "Mutation" } & {
  QuartilesRatingSetter?: Maybe<
    { __typename?: "QuartilesRatingSetter" } & Pick<
      QuartilesRatingSetter,
      "deleteVersion"
    >
  >;
};

export type SetCreateRequiredToolsMutationVariables = Exact<{
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  ModelIndicator?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
  CheckedDateIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
}>;

export type SetCreateRequiredToolsMutation = { __typename?: "Mutation" } & {
  RequiredToolsSetter?: Maybe<
    { __typename?: "RequiredToolsSetter" } & {
      create?: Maybe<
        { __typename?: "RequiredTools" } & Pick<RequiredTools, "id">
      >;
    }
  >;
};

export type SetChangeRequiredToolsMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  ModelIndicator?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
  CheckedDateIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
}>;

export type SetChangeRequiredToolsMutation = { __typename?: "Mutation" } & {
  RequiredToolsSetter?: Maybe<
    { __typename?: "RequiredToolsSetter" } & {
      change?: Maybe<
        { __typename?: "RequiredTools" } & Pick<RequiredTools, "id">
      >;
    }
  >;
};

export type SetBlindChangeRequiredToolsMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  ModelIndicator?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
  CheckedDateIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
}>;

export type SetBlindChangeRequiredToolsMutation = {
  __typename?: "Mutation";
} & {
  RequiredToolsSetter?: Maybe<
    { __typename?: "RequiredToolsSetter" } & {
      blindChange?: Maybe<
        { __typename?: "RequiredTools" } & Pick<RequiredTools, "id">
      >;
    }
  >;
};

export type SetAddValuesRequiredToolsMutationVariables = Exact<{
  Compliance?: Maybe<Scalars["Int"]>;
  Total?: Maybe<Scalars["Float"]>;
  CheckedDate?: Maybe<Scalars["String"]>;
  Model?: Maybe<Scalars["String"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
}>;

export type SetAddValuesRequiredToolsMutation = { __typename?: "Mutation" } & {
  RequiredToolsSetter?: Maybe<
    { __typename?: "RequiredToolsSetter" } & Pick<
      RequiredToolsSetter,
      "addValues"
    >
  >;
};

export type SetDeleteRequiredToolsMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type SetDeleteRequiredToolsMutation = { __typename?: "Mutation" } & {
  RequiredToolsSetter?: Maybe<
    { __typename?: "RequiredToolsSetter" } & Pick<RequiredToolsSetter, "delete">
  >;
};

export type GibddSetMutationVariables = Exact<{
  id: Scalars["ID"];
  vin: Scalars["String"];
  dateRegistration: Scalars["DateTime"];
  city: Scalars["String"];
  district: Scalars["String"];
  region: Scalars["String"];
  federalArea: Scalars["String"];
}>;

export type GibddSetMutation = { __typename?: "Mutation" } & {
  SRRSetter?: Maybe<
    { __typename?: "SRRSetter" } & {
      setGIBDD?: Maybe<{ __typename?: "GIBDDType" } & Pick<GibddType, "id">>;
    }
  >;
};

export type UploadGibddMutationVariables = Exact<{
  fileId: Scalars["ID"];
}>;

export type UploadGibddMutation = { __typename?: "Mutation" } & {
  SRRSetter?: Maybe<
    { __typename?: "SRRSetter" } & Pick<SrrSetter, "uploadGIBDD">
  >;
};

export type UploadSrrTargetMutationVariables = Exact<{
  fileId: Scalars["ID"];
  description?: Maybe<Scalars["String"]>;
}>;

export type UploadSrrTargetMutation = { __typename?: "Mutation" } & {
  SRRSetter?: Maybe<
    { __typename?: "SRRSetter" } & Pick<SrrSetter, "uploadTarget">
  >;
};

export type AcceptUploadSrrTargetMutationVariables = Exact<{
  IndicatorUploadId: Scalars["ID"];
}>;

export type AcceptUploadSrrTargetMutation = { __typename?: "Mutation" } & {
  SRRSetter?: Maybe<
    { __typename?: "SRRSetter" } & Pick<SrrSetter, "acceptUploadTarget">
  >;
};

export type ImportTargetDealerByMonthMutationVariables = Exact<{
  fileId: Scalars["ID"];
}>;

export type ImportTargetDealerByMonthMutation = { __typename?: "Mutation" } & {
  SRRSetter?: Maybe<
    { __typename?: "SRRSetter" } & Pick<SrrSetter, "importTargetDealerByMonth">
  >;
};

export type SetCreateSerivceMutationVariables = Exact<{
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  FactIndicator?: Maybe<Scalars["ID"]>;
  CertificationDateIndicator?: Maybe<Scalars["ID"]>;
  FactContractIndicator?: Maybe<Scalars["ID"]>;
  Code?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
}>;

export type SetCreateSerivceMutation = { __typename?: "Mutation" } & {
  ServicesSetter?: Maybe<
    { __typename?: "ServicesSetter" } & {
      create?: Maybe<{ __typename?: "Services" } & Pick<Services, "id">>;
    }
  >;
};

export type SetChangeSerivceMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  FactIndicator?: Maybe<Scalars["ID"]>;
  CertificationDateIndicator?: Maybe<Scalars["ID"]>;
  FactContractIndicator?: Maybe<Scalars["ID"]>;
  Code?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
}>;

export type SetChangeSerivceMutation = { __typename?: "Mutation" } & {
  ServicesSetter?: Maybe<
    { __typename?: "ServicesSetter" } & {
      change?: Maybe<{ __typename?: "Services" } & Pick<Services, "id">>;
    }
  >;
};

export type SetBlindChangeSerivceMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  FactIndicator?: Maybe<Scalars["ID"]>;
  CertificationDateIndicator?: Maybe<Scalars["ID"]>;
  FactContractIndicator?: Maybe<Scalars["ID"]>;
  Code?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
}>;

export type SetBlindChangeSerivceMutation = { __typename?: "Mutation" } & {
  ServicesSetter?: Maybe<
    { __typename?: "ServicesSetter" } & {
      blindChange?: Maybe<{ __typename?: "Services" } & Pick<Services, "id">>;
    }
  >;
};

export type SetAddValuesSerivceMutationVariables = Exact<{
  Compliance?: Maybe<Scalars["Int"]>;
  Fact?: Maybe<Scalars["Int"]>;
  FactContract?: Maybe<Scalars["Int"]>;
  CertificationDate?: Maybe<Scalars["String"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
}>;

export type SetAddValuesSerivceMutation = { __typename?: "Mutation" } & {
  ServicesSetter?: Maybe<
    { __typename?: "ServicesSetter" } & Pick<ServicesSetter, "addValues">
  >;
};

export type SetDeleteSerivceMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type SetDeleteSerivceMutation = { __typename?: "Mutation" } & {
  ServicesSetter?: Maybe<
    { __typename?: "ServicesSetter" } & Pick<ServicesSetter, "delete">
  >;
};

export type UploadStaffValuesMutationVariables = Exact<{
  fileId: Scalars["ID"];
}>;

export type UploadStaffValuesMutation = { __typename?: "Mutation" } & {
  SettingsSetter?: Maybe<
    { __typename?: "SettingsSetter" } & Pick<SettingsSetter, "setStaffFile">
  >;
};

export type SubdivisionCreateMutationVariables = Exact<{
  code: Scalars["String"];
  name: Scalars["String"];
  status: SubdivisionStatus;
  parentId?: Maybe<Scalars["ID"]>;
}>;

export type SubdivisionCreateMutation = { __typename?: "Mutation" } & {
  SubdivisionSetter?: Maybe<
    { __typename?: "SubdivisionSetter" } & {
      create?: Maybe<{ __typename?: "Subdivision" } & Pick<Subdivision, "id">>;
    }
  >;
};

export type SubdivisionEditMutationVariables = Exact<{
  id: Scalars["ID"];
  name: Scalars["String"];
  status: SubdivisionStatus;
  parentId?: Maybe<Scalars["ID"]>;
}>;

export type SubdivisionEditMutation = { __typename?: "Mutation" } & {
  SubdivisionSetter?: Maybe<
    { __typename?: "SubdivisionSetter" } & {
      edit?: Maybe<{ __typename?: "Subdivision" } & Pick<Subdivision, "id">>;
    }
  >;
};

export type SubdivisionDeleteMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type SubdivisionDeleteMutation = { __typename?: "Mutation" } & {
  SubdivisionSetter?: Maybe<
    { __typename?: "SubdivisionSetter" } & Pick<SubdivisionSetter, "delete">
  >;
};

export type SetCreateToolsInsuranceMutationVariables = Exact<{
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  Number?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  NumberList?: Maybe<Scalars["String"]>;
  NumberDetail?: Maybe<Scalars["String"]>;
}>;

export type SetCreateToolsInsuranceMutation = { __typename?: "Mutation" } & {
  ToolsInsuranceSetter?: Maybe<
    { __typename?: "ToolsInsuranceSetter" } & {
      create?: Maybe<
        { __typename?: "ToolsInsurance" } & Pick<ToolsInsurance, "id">
      >;
    }
  >;
};

export type SetChangeToolsInsuranceMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  Number?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  NumberList?: Maybe<Scalars["String"]>;
  NumberDetail?: Maybe<Scalars["String"]>;
}>;

export type SetChangeToolsInsuranceMutation = { __typename?: "Mutation" } & {
  ToolsInsuranceSetter?: Maybe<
    { __typename?: "ToolsInsuranceSetter" } & {
      change?: Maybe<
        { __typename?: "ToolsInsurance" } & Pick<ToolsInsurance, "id">
      >;
    }
  >;
};

export type SetBlindChangeToolsInsuranceMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  Number?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  NumberList?: Maybe<Scalars["String"]>;
  NumberDetail?: Maybe<Scalars["String"]>;
}>;

export type SetBlindChangeToolsInsuranceMutation = {
  __typename?: "Mutation";
} & {
  ToolsInsuranceSetter?: Maybe<
    { __typename?: "ToolsInsuranceSetter" } & {
      blindChange?: Maybe<
        { __typename?: "ToolsInsurance" } & Pick<ToolsInsurance, "id">
      >;
    }
  >;
};

export type SetAddValuesToolsInsuranceMutationVariables = Exact<{
  Compliance?: Maybe<Scalars["Int"]>;
  Total?: Maybe<Scalars["Float"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
}>;

export type SetAddValuesToolsInsuranceMutation = { __typename?: "Mutation" } & {
  ToolsInsuranceSetter?: Maybe<
    { __typename?: "ToolsInsuranceSetter" } & Pick<
      ToolsInsuranceSetter,
      "addValues"
    >
  >;
};

export type SetDeleteToolsInsuranceMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type SetDeleteToolsInsuranceMutation = { __typename?: "Mutation" } & {
  ToolsInsuranceSetter?: Maybe<
    { __typename?: "ToolsInsuranceSetter" } & Pick<
      ToolsInsuranceSetter,
      "delete"
    >
  >;
};

export type SetRenameGroupToolsInsuranceMutationVariables = Exact<{
  groupType?: Maybe<ZdGroupType>;
  newGroup?: Maybe<Scalars["String"]>;
  oldGroup?: Maybe<Scalars["String"]>;
}>;

export type SetRenameGroupToolsInsuranceMutation = {
  __typename?: "Mutation";
} & {
  ToolsInsuranceSetter?: Maybe<
    { __typename?: "ToolsInsuranceSetter" } & Pick<
      ToolsInsuranceSetter,
      "renameGroup"
    >
  >;
};

export type SetCreateToolsMetrologicalMutationVariables = Exact<{
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
}>;

export type SetCreateToolsMetrologicalMutation = { __typename?: "Mutation" } & {
  ToolsMetrologicalSetter?: Maybe<
    { __typename?: "ToolsMetrologicalSetter" } & {
      create?: Maybe<
        { __typename?: "ToolsMetrological" } & Pick<ToolsMetrological, "id">
      >;
    }
  >;
};

export type SetChangeToolsMetrologicalMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
}>;

export type SetChangeToolsMetrologicalMutation = { __typename?: "Mutation" } & {
  ToolsMetrologicalSetter?: Maybe<
    { __typename?: "ToolsMetrologicalSetter" } & {
      change?: Maybe<
        { __typename?: "ToolsMetrological" } & Pick<ToolsMetrological, "id">
      >;
    }
  >;
};

export type SetBlindChangeToolsMetrologicalMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
}>;

export type SetBlindChangeToolsMetrologicalMutation = {
  __typename?: "Mutation";
} & {
  ToolsMetrologicalSetter?: Maybe<
    { __typename?: "ToolsMetrologicalSetter" } & {
      blindChange?: Maybe<
        { __typename?: "ToolsMetrological" } & Pick<ToolsMetrological, "id">
      >;
    }
  >;
};

export type SetAddValuesToolsMetrologicalMutationVariables = Exact<{
  Compliance?: Maybe<Scalars["Int"]>;
  Total?: Maybe<Scalars["Float"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
}>;

export type SetAddValuesToolsMetrologicalMutation = {
  __typename?: "Mutation";
} & {
  ToolsMetrologicalSetter?: Maybe<
    { __typename?: "ToolsMetrologicalSetter" } & Pick<
      ToolsMetrologicalSetter,
      "addValues"
    >
  >;
};

export type SetDeleteToolsMetrologicalMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type SetDeleteToolsMetrologicalMutation = { __typename?: "Mutation" } & {
  ToolsMetrologicalSetter?: Maybe<
    { __typename?: "ToolsMetrologicalSetter" } & Pick<
      ToolsMetrologicalSetter,
      "delete"
    >
  >;
};

export type SetCreateToolsMutationVariables = Exact<{
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
  ModelIndicator?: Maybe<Scalars["ID"]>;
  CountryIndicator?: Maybe<Scalars["ID"]>;
  YearIndicator?: Maybe<Scalars["ID"]>;
  NoteIndicator?: Maybe<Scalars["ID"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  Number?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
}>;

export type SetCreateToolsMutation = { __typename?: "Mutation" } & {
  ToolsSetter?: Maybe<
    { __typename?: "ToolsSetter" } & {
      create?: Maybe<{ __typename?: "Tools" } & Pick<Tools, "id">>;
    }
  >;
};

export type SetChangeToolsMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
  ModelIndicator?: Maybe<Scalars["ID"]>;
  CountryIndicator?: Maybe<Scalars["ID"]>;
  YearIndicator?: Maybe<Scalars["ID"]>;
  NoteIndicator?: Maybe<Scalars["ID"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  Number?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
}>;

export type SetChangeToolsMutation = { __typename?: "Mutation" } & {
  ToolsSetter?: Maybe<
    { __typename?: "ToolsSetter" } & {
      change?: Maybe<{ __typename?: "Tools" } & Pick<Tools, "id">>;
    }
  >;
};

export type SetBlindChangeToolsMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  TotalIndicator?: Maybe<Scalars["ID"]>;
  ModelIndicator?: Maybe<Scalars["ID"]>;
  CountryIndicator?: Maybe<Scalars["ID"]>;
  YearIndicator?: Maybe<Scalars["ID"]>;
  NoteIndicator?: Maybe<Scalars["ID"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  GroupTwo?: Maybe<Scalars["String"]>;
  Number?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
}>;

export type SetBlindChangeToolsMutation = { __typename?: "Mutation" } & {
  ToolsSetter?: Maybe<
    { __typename?: "ToolsSetter" } & {
      blindChange?: Maybe<{ __typename?: "Tools" } & Pick<Tools, "id">>;
    }
  >;
};

export type SetAddValuesToolsMutationVariables = Exact<{
  Compliance?: Maybe<Scalars["Int"]>;
  Model?: Maybe<Scalars["String"]>;
  Country?: Maybe<Scalars["String"]>;
  Note?: Maybe<Scalars["String"]>;
  Total?: Maybe<Scalars["Float"]>;
  Year?: Maybe<Scalars["Int"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
}>;

export type SetAddValuesToolsMutation = { __typename?: "Mutation" } & {
  ToolsSetter?: Maybe<
    { __typename?: "ToolsSetter" } & Pick<ToolsSetter, "addValues">
  >;
};

export type SetDeleteToolsMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type SetDeleteToolsMutation = { __typename?: "Mutation" } & {
  ToolsSetter?: Maybe<
    { __typename?: "ToolsSetter" } & Pick<ToolsSetter, "delete">
  >;
};

export type SetDuplicateToolsMutationVariables = Exact<{
  uuid?: Maybe<Scalars["String"]>;
}>;

export type SetDuplicateToolsMutation = { __typename?: "Mutation" } & {
  ToolsSetter?: Maybe<
    { __typename?: "ToolsSetter" } & {
      duplicate?: Maybe<
        { __typename?: "ToolsIndicatorTypes" } & Pick<ToolsIndicatorTypes, "id">
      >;
    }
  >;
};

export type SetRenameGroupToolsMutationVariables = Exact<{
  groupType?: Maybe<ZdGroupType>;
  newGroup?: Maybe<Scalars["String"]>;
  oldGroup?: Maybe<Scalars["String"]>;
}>;

export type SetRenameGroupToolsMutation = { __typename?: "Mutation" } & {
  ToolsSetter?: Maybe<
    { __typename?: "ToolsSetter" } & Pick<ToolsSetter, "renameGroup">
  >;
};

export type SetSortMutationVariables = Exact<{
  sort?: Maybe<Scalars["Int"]>;
  UUID: Scalars["String"];
}>;

export type SetSortMutation = { __typename?: "Mutation" } & {
  ToolsSetter?: Maybe<
    { __typename?: "ToolsSetter" } & Pick<ToolsSetter, "setSort">
  >;
};

export type SetSortGroupMutationVariables = Exact<{
  sort?: Maybe<Scalars["Int"]>;
  group: Scalars["String"];
}>;

export type SetSortGroupMutation = { __typename?: "Mutation" } & {
  ToolsSetter?: Maybe<
    { __typename?: "ToolsSetter" } & Pick<ToolsSetter, "setSortGroup">
  >;
};

export type SetCreateTradePremisesMutationVariables = Exact<{
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  AreaIndicator?: Maybe<Scalars["ID"]>;
  AddressIndicator?: Maybe<Scalars["ID"]>;
}>;

export type SetCreateTradePremisesMutation = { __typename?: "Mutation" } & {
  TradePremisesSetter?: Maybe<
    { __typename?: "TradePremisesSetter" } & {
      create?: Maybe<
        { __typename?: "TradePremises" } & Pick<TradePremises, "id">
      >;
    }
  >;
};

export type SetChangeTradePremisesMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  AreaIndicator?: Maybe<Scalars["ID"]>;
  AddressIndicator?: Maybe<Scalars["ID"]>;
}>;

export type SetChangeTradePremisesMutation = { __typename?: "Mutation" } & {
  TradePremisesSetter?: Maybe<
    { __typename?: "TradePremisesSetter" } & {
      change?: Maybe<
        { __typename?: "TradePremises" } & Pick<TradePremises, "id">
      >;
    }
  >;
};

export type SetBlindChangeTradePremisesMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
  forUUID?: Maybe<Scalars["String"]>;
  isList?: Maybe<Scalars["Boolean"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  GroupOne?: Maybe<Scalars["String"]>;
  AreaIndicator?: Maybe<Scalars["ID"]>;
  AddressIndicator?: Maybe<Scalars["ID"]>;
}>;

export type SetBlindChangeTradePremisesMutation = {
  __typename?: "Mutation";
} & {
  TradePremisesSetter?: Maybe<
    { __typename?: "TradePremisesSetter" } & {
      blindChange?: Maybe<
        { __typename?: "TradePremises" } & Pick<TradePremises, "id">
      >;
    }
  >;
};

export type SetAddValuesTradePremisesMutationVariables = Exact<{
  Compliance?: Maybe<Scalars["Int"]>;
  Area?: Maybe<Scalars["Float"]>;
  Address?: Maybe<Scalars["String"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
}>;

export type SetAddValuesTradePremisesMutation = { __typename?: "Mutation" } & {
  TradePremisesSetter?: Maybe<
    { __typename?: "TradePremisesSetter" } & Pick<
      TradePremisesSetter,
      "addValues"
    >
  >;
};

export type SetDeleteTradePremisesMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type SetDeleteTradePremisesMutation = { __typename?: "Mutation" } & {
  TradePremisesSetter?: Maybe<
    { __typename?: "TradePremisesSetter" } & Pick<TradePremisesSetter, "delete">
  >;
};

export type UpdateTrustedPersonMutationVariables = Exact<{
  updateTrustedPersonId: Scalars["ID"];
  powerOfAttorney?: Maybe<Scalars["String"]>;
  fio?: Maybe<Scalars["String"]>;
  shortFio?: Maybe<Scalars["String"]>;
  descriptionContract?: Maybe<Scalars["String"]>;
  date?: Maybe<Scalars["Date"]>;
  endDate?: Maybe<Scalars["Date"]>;
  active?: Maybe<Scalars["Boolean"]>;
}>;

export type UpdateTrustedPersonMutation = { __typename?: "Mutation" } & {
  TrustedPersonSetter?: Maybe<
    { __typename?: "TrustedPersonSetter" } & {
      updateTrustedPerson: { __typename?: "TrustedPerson" } & Pick<
        TrustedPerson,
        | "id"
        | "powerOfAttorney"
        | "fio"
        | "shortFio"
        | "descriptionContract"
        | "date"
        | "endDate"
        | "active"
      >;
    }
  >;
};

export type CreateTrustedPersonMutationVariables = Exact<{
  powerOfAttorney: Scalars["String"];
  fio: Scalars["String"];
  shortFio: Scalars["String"];
  descriptionContract: Scalars["String"];
  date: Scalars["Date"];
  endDate: Scalars["Date"];
  active: Scalars["Boolean"];
}>;

export type CreateTrustedPersonMutation = { __typename?: "Mutation" } & {
  TrustedPersonSetter?: Maybe<
    { __typename?: "TrustedPersonSetter" } & {
      createTrustedPerson: { __typename?: "TrustedPerson" } & Pick<
        TrustedPerson,
        | "id"
        | "powerOfAttorney"
        | "fio"
        | "shortFio"
        | "descriptionContract"
        | "date"
        | "endDate"
        | "active"
      >;
    }
  >;
};

export type SetGuideFileMutationVariables = Exact<{
  AdminFileId?: Maybe<Scalars["ID"]>;
  UserFileId?: Maybe<Scalars["ID"]>;
}>;

export type SetGuideFileMutation = { __typename?: "Mutation" } & {
  UserGuideSetter?: Maybe<
    { __typename?: "UserGuideSetter" } & {
      setGuideFile?: Maybe<
        { __typename?: "UserGuide" } & Pick<
          UserGuide,
          "AdminFileId" | "UserFileId"
        >
      >;
    }
  >;
};

export type ChangeUserMutationVariables = Exact<{
  id: Scalars["ID"];
  role: Scalars["String"];
  login: Scalars["String"];
  fullname: Scalars["String"];
  email: Scalars["String"];
  position?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  isEmployeeAccess?: Maybe<Scalars["Boolean"]>;
  isViolationAccess?: Maybe<Scalars["Boolean"]>;
  isAnnouncementsAccess?: Maybe<Scalars["Boolean"]>;
  isTemporaryAccessToAllDealers?: Maybe<Scalars["Boolean"]>;
  isZdAccess?: Maybe<Scalars["Boolean"]>;
  isAnnouncementsSend?: Maybe<Scalars["Boolean"]>;
  isAccountingAccess?: Maybe<Scalars["Boolean"]>;
  isDocumentsAccess?: Maybe<Scalars["Boolean"]>;
  isCameraAccess?: Maybe<Scalars["Boolean"]>;
  isCandidateAccess?: Maybe<Scalars["Boolean"]>;
  isTrustedPersonAccess?: Maybe<Scalars["Boolean"]>;
  SubdivisionId?: Maybe<Scalars["ID"]>;
  ivideonAccess?: Maybe<Scalars["Boolean"]>;
  dnmAccess?: Maybe<Scalars["Boolean"]>;
}>;

export type ChangeUserMutation = { __typename?: "Mutation" } & {
  UserSetter?: Maybe<
    { __typename?: "UserSetter" } & {
      changeUser?: Maybe<{ __typename?: "Profile" } & FragmentProfileFragment>;
    }
  >;
};

export type DeleteUserMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type DeleteUserMutation = { __typename?: "Mutation" } & {
  UserSetter?: Maybe<
    { __typename?: "UserSetter" } & Pick<UserSetter, "deleteUser">
  >;
};

export type RestoreUserMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type RestoreUserMutation = { __typename?: "Mutation" } & {
  UserSetter?: Maybe<
    { __typename?: "UserSetter" } & Pick<UserSetter, "restoreUser">
  >;
};

export type ImportUserMutationVariables = Exact<{ [key: string]: never }>;

export type ImportUserMutation = { __typename?: "Mutation" } & {
  UserSetter?: Maybe<
    { __typename?: "UserSetter" } & Pick<UserSetter, "importUser">
  >;
};

export type SetUploadUserToDealerMutationVariables = Exact<{
  fileId: Scalars["ID"];
  quarter?: Maybe<Scalars["Int"]>;
  year?: Maybe<Scalars["Int"]>;
}>;

export type SetUploadUserToDealerMutation = { __typename?: "Mutation" } & {
  UserSetter?: Maybe<
    { __typename?: "UserSetter" } & Pick<UserSetter, "uploadUserToDealer">
  >;
};

export type AcceptUploadUserToDealerValuesMutationVariables = Exact<{
  IndicatorUploadId: Scalars["ID"];
}>;

export type AcceptUploadUserToDealerValuesMutation = {
  __typename?: "Mutation";
} & {
  UserSetter?: Maybe<
    { __typename?: "UserSetter" } & Pick<UserSetter, "acceptUploadUserToDealer">
  >;
};

export type CreateViolationMutationVariables = Exact<{
  DealerIds: Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>;
  ViolationTypesId: Scalars["ID"];
  fixDeadline: Scalars["DateTime"];
  description: Scalars["String"];
  DocNum?: Maybe<Scalars["String"]>;
  DocDate?: Maybe<Scalars["DateTime"]>;
  FileId?: Maybe<Scalars["ID"]>;
  responsibleChecker?: Maybe<Scalars["ID"]>;
}>;

export type CreateViolationMutation = { __typename?: "Mutation" } & {
  ViolationSetter?: Maybe<
    { __typename?: "ViolationSetter" } & Pick<ViolationSetter, "create">
  >;
};

export type EditViolationMutationVariables = Exact<{
  id: Scalars["ID"];
  fixDeadline: Scalars["DateTime"];
  responsibleChecker?: Maybe<Scalars["ID"]>;
  description: Scalars["String"];
  DocNum?: Maybe<Scalars["String"]>;
  DocDate?: Maybe<Scalars["DateTime"]>;
  DocId?: Maybe<Scalars["ID"]>;
}>;

export type EditViolationMutation = { __typename?: "Mutation" } & {
  ViolationSetter?: Maybe<
    { __typename?: "ViolationSetter" } & Pick<ViolationSetter, "edit">
  >;
};

export type DeleteViolationMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type DeleteViolationMutation = { __typename?: "Mutation" } & {
  ViolationSetter?: Maybe<
    { __typename?: "ViolationSetter" } & Pick<ViolationSetter, "delete">
  >;
};

export type UnDeleteViolationMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type UnDeleteViolationMutation = { __typename?: "Mutation" } & {
  ViolationSetter?: Maybe<
    { __typename?: "ViolationSetter" } & Pick<ViolationSetter, "unDelete">
  >;
};

export type RestoreViolationMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type RestoreViolationMutation = { __typename?: "Mutation" } & {
  ViolationSetter?: Maybe<
    { __typename?: "ViolationSetter" } & Pick<ViolationSetter, "unDelete">
  >;
};

export type RejectViolationMutationVariables = Exact<{
  id: Scalars["ID"];
  punishment: Scalars["String"];
}>;

export type RejectViolationMutation = { __typename?: "Mutation" } & {
  ViolationSetter?: Maybe<
    { __typename?: "ViolationSetter" } & Pick<ViolationSetter, "reject">
  >;
};

export type AddCommentMutationVariables = Exact<{
  id: Scalars["ID"];
  comment: Scalars["String"];
  files?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type AddCommentMutation = { __typename?: "Mutation" } & {
  ViolationSetter?: Maybe<
    { __typename?: "ViolationSetter" } & Pick<ViolationSetter, "addComment">
  >;
};

export type GiveResponseToDealerMutationVariables = Exact<{
  id: Scalars["ID"];
  status?: Maybe<StatusSetResponseToDealer>;
}>;

export type GiveResponseToDealerMutation = { __typename?: "Mutation" } & {
  ViolationSetter?: Maybe<
    { __typename?: "ViolationSetter" } & Pick<
      ViolationSetter,
      "giveResponseToDealer"
    >
  >;
};

export type DealerFixViolationMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type DealerFixViolationMutation = { __typename?: "Mutation" } & {
  ViolationSetter?: Maybe<
    { __typename?: "ViolationSetter" } & Pick<ViolationSetter, "dealerFix">
  >;
};

export type AddViolationTypeMutationVariables = Exact<{
  name: Scalars["String"];
  description: Scalars["String"];
  howToFixDescription: Scalars["String"];
  category: ViolationTypeCategory;
  SubdivisionId: Scalars["ID"];
  AvgCorrectionDays: Scalars["Int"];
}>;

export type AddViolationTypeMutation = { __typename?: "Mutation" } & {
  ViolationTypesSetter?: Maybe<
    { __typename?: "ViolationTypesSetter" } & {
      create?: Maybe<
        { __typename?: "ViolationType" } & Pick<ViolationType, "id">
      >;
    }
  >;
};

export type EditViolationTypeMutationVariables = Exact<{
  id: Scalars["ID"];
  name: Scalars["String"];
  description: Scalars["String"];
  howToFixDescription: Scalars["String"];
  category: ViolationTypeCategory;
  SubdivisionId: Scalars["ID"];
  AvgCorrectionDays: Scalars["Int"];
}>;

export type EditViolationTypeMutation = { __typename?: "Mutation" } & {
  ViolationTypesSetter?: Maybe<
    { __typename?: "ViolationTypesSetter" } & {
      edit?: Maybe<
        { __typename?: "ViolationType" } & Pick<ViolationType, "id">
      >;
    }
  >;
};

export type ChangeStatusViolationTypeMutationVariables = Exact<{
  id: Scalars["ID"];
  status: ViolationTypeStatusChange;
}>;

export type ChangeStatusViolationTypeMutation = { __typename?: "Mutation" } & {
  ViolationTypesSetter?: Maybe<
    { __typename?: "ViolationTypesSetter" } & {
      changeStatus?: Maybe<
        { __typename?: "ViolationType" } & Pick<ViolationType, "id">
      >;
    }
  >;
};

export type SetCreateWarehousesMutationVariables = Exact<{
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  AreaIndicator?: Maybe<Scalars["ID"]>;
  CombineIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
}>;

export type SetCreateWarehousesMutation = { __typename?: "Mutation" } & {
  WarehousesSetter?: Maybe<
    { __typename?: "WarehousesSetter" } & {
      create?: Maybe<{ __typename?: "Warehouses" } & Pick<Warehouses, "id">>;
    }
  >;
};

export type SetChangeWarehousesMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  AreaIndicator?: Maybe<Scalars["ID"]>;
  CombineIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
}>;

export type SetChangeWarehousesMutation = { __typename?: "Mutation" } & {
  WarehousesSetter?: Maybe<
    { __typename?: "WarehousesSetter" } & {
      change?: Maybe<{ __typename?: "Warehouses" } & Pick<Warehouses, "id">>;
    }
  >;
};

export type SetBlindChangeWarehousesMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  ComplianceIndicator?: Maybe<Scalars["ID"]>;
  AreaIndicator?: Maybe<Scalars["ID"]>;
  CombineIndicator?: Maybe<Scalars["ID"]>;
  Number?: Maybe<Scalars["String"]>;
  Name?: Maybe<Scalars["String"]>;
  NameEn?: Maybe<Scalars["String"]>;
}>;

export type SetBlindChangeWarehousesMutation = { __typename?: "Mutation" } & {
  WarehousesSetter?: Maybe<
    { __typename?: "WarehousesSetter" } & {
      blindChange?: Maybe<
        { __typename?: "Warehouses" } & Pick<Warehouses, "id">
      >;
    }
  >;
};

export type SetAddValuesWarehousesMutationVariables = Exact<{
  Compliance?: Maybe<Scalars["Int"]>;
  Area?: Maybe<Scalars["Float"]>;
  Combine?: Maybe<Scalars["String"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  UUID?: Maybe<Scalars["String"]>;
}>;

export type SetAddValuesWarehousesMutation = { __typename?: "Mutation" } & {
  WarehousesSetter?: Maybe<
    { __typename?: "WarehousesSetter" } & Pick<WarehousesSetter, "addValues">
  >;
};

export type SetDeleteWarehousesMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type SetDeleteWarehousesMutation = { __typename?: "Mutation" } & {
  WarehousesSetter?: Maybe<
    { __typename?: "WarehousesSetter" } & Pick<WarehousesSetter, "delete">
  >;
};

export type SetDeleteResetDateMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type SetDeleteResetDateMutation = { __typename?: "Mutation" } & {
  ZdCommonSetter?: Maybe<
    { __typename?: "ZdCommonSetter" } & Pick<ZdCommonSetter, "deleteResetDate">
  >;
};

export type SetChangeStatusZdGlobalForDealerMutationVariables = Exact<{
  DealerId?: Maybe<Scalars["ID"]>;
  status?: Maybe<ZdGlobalInfoForDealerStatus>;
  isPremises?: Maybe<Scalars["Boolean"]>;
}>;

export type SetChangeStatusZdGlobalForDealerMutation = {
  __typename?: "Mutation";
} & {
  ZdCommonSetter?: Maybe<
    { __typename?: "ZdCommonSetter" } & Pick<
      ZdCommonSetter,
      "changeStatusZdGlobalForDealer"
    >
  >;
};

export type SetCreateResetDateMutationVariables = Exact<{
  DealerId?: Maybe<Scalars["ID"]>;
  tableIndex: ZdTableIndex;
  ZD_UUID?: Maybe<Scalars["String"]>;
}>;

export type SetCreateResetDateMutation = { __typename?: "Mutation" } & {
  ZdCommonSetter?: Maybe<
    { __typename?: "ZdCommonSetter" } & Pick<ZdCommonSetter, "createResetDate">
  >;
};

export type DeleteLineValueDealerMutationVariables = Exact<{
  DealerId?: Maybe<Scalars["ID"]>;
  tableIndex: ZdTableIndex;
  ZD_UUID?: Maybe<Scalars["String"]>;
}>;

export type DeleteLineValueDealerMutation = { __typename?: "Mutation" } & {
  ZdCommonSetter?: Maybe<
    { __typename?: "ZdCommonSetter" } & Pick<
      ZdCommonSetter,
      "deleteLineValueDealer"
    >
  >;
};

export type GetAccountingsGettersQueryVariables = Exact<{
  DealerId?: Maybe<Scalars["ID"]>;
  ReportPeriodId?: Maybe<Scalars["ID"]>;
  status?: Maybe<DealerReportStatus>;
  dealerName?: Maybe<Scalars["String"]>;
  sortBy?: Maybe<GetDealerReportsSort>;
  sortType?: Maybe<SortType>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
}>;

export type GetAccountingsGettersQuery = { __typename?: "Query" } & {
  AccountingGetter?: Maybe<
    { __typename?: "AccountingGetter" } & {
      getDealerReports?: Maybe<
        { __typename?: "getDealerReportsList" } & Pick<
          GetDealerReportsList,
          "total"
        > & {
            items?: Maybe<
              Array<
                Maybe<
                  { __typename?: "DealerReport" } & FragmentAccountingFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetAccountingsDraftGettersQueryVariables = Exact<{
  ReportPeriodId?: Maybe<Scalars["ID"]>;
  status?: Maybe<DealerReportStatus>;
}>;

export type GetAccountingsDraftGettersQuery = { __typename?: "Query" } & {
  AccountingGetter?: Maybe<
    { __typename?: "AccountingGetter" } & {
      getDealerReports?: Maybe<
        { __typename?: "getDealerReportsList" } & Pick<
          GetDealerReportsList,
          "total"
        >
      >;
    }
  >;
};

export type GetAccountingsCheckingGettersQueryVariables = Exact<{
  ReportPeriodId?: Maybe<Scalars["ID"]>;
  status?: Maybe<DealerReportStatus>;
}>;

export type GetAccountingsCheckingGettersQuery = { __typename?: "Query" } & {
  AccountingGetter?: Maybe<
    { __typename?: "AccountingGetter" } & {
      getDealerReports?: Maybe<
        { __typename?: "getDealerReportsList" } & Pick<
          GetDealerReportsList,
          "total"
        >
      >;
    }
  >;
};

export type GetAccountingsVerifiedGettersQueryVariables = Exact<{
  ReportPeriodId?: Maybe<Scalars["ID"]>;
  status?: Maybe<DealerReportStatus>;
}>;

export type GetAccountingsVerifiedGettersQuery = { __typename?: "Query" } & {
  AccountingGetter?: Maybe<
    { __typename?: "AccountingGetter" } & {
      getDealerReports?: Maybe<
        { __typename?: "getDealerReportsList" } & Pick<
          GetDealerReportsList,
          "total"
        >
      >;
    }
  >;
};

export type GetAccountingsFixingGettersQueryVariables = Exact<{
  ReportPeriodId?: Maybe<Scalars["ID"]>;
  status?: Maybe<DealerReportStatus>;
}>;

export type GetAccountingsFixingGettersQuery = { __typename?: "Query" } & {
  AccountingGetter?: Maybe<
    { __typename?: "AccountingGetter" } & {
      getDealerReports?: Maybe<
        { __typename?: "getDealerReportsList" } & Pick<
          GetDealerReportsList,
          "total"
        >
      >;
    }
  >;
};

export type GetAccountingGetterQueryVariables = Exact<{
  ReportId: Scalars["ID"];
}>;

export type GetAccountingGetterQuery = { __typename?: "Query" } & {
  AccountingGetter?: Maybe<
    { __typename?: "AccountingGetter" } & {
      getDealerReport?: Maybe<
        { __typename?: "DealerReport" } & FragmentAccountingFragment
      >;
    }
  >;
};

export type GetAccountingPeriodsGetterQueryVariables = Exact<{
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
}>;

export type GetAccountingPeriodsGetterQuery = { __typename?: "Query" } & {
  AccountingGetter?: Maybe<
    { __typename?: "AccountingGetter" } & {
      getPeriods?: Maybe<
        { __typename?: "getPeriodsListList" } & Pick<
          GetPeriodsListList,
          "total"
        > & {
            items: Array<
              Maybe<
                {
                  __typename?: "ReportPeriod";
                } & FragmentAccountingPeriodFragment
              >
            >;
          }
      >;
    }
  >;
};

export type GetAccountingPeriodGetterQueryVariables = Exact<{
  Year: Scalars["Int"];
  Quarter: Scalars["Int"];
}>;

export type GetAccountingPeriodGetterQuery = { __typename?: "Query" } & {
  AccountingGetter?: Maybe<
    { __typename?: "AccountingGetter" } & {
      getPeriod?: Maybe<
        { __typename?: "ReportPeriod" } & FragmentAccountingPeriodFragment
      >;
    }
  >;
};

export type GetAccountingFileDealerReportQueryVariables = Exact<{
  DealerId: Scalars["ID"];
  repType?: Maybe<GetFileDealerReportRepType>;
  firstPartPeriodId?: Maybe<Scalars["ID"]>;
  secondPartPeriodId?: Maybe<Scalars["ID"]>;
}>;

export type GetAccountingFileDealerReportQuery = { __typename?: "Query" } & {
  AccountingGetter?: Maybe<
    { __typename?: "AccountingGetter" } & {
      getFileDealerReport?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetAccountingFileDealerMonitoringQueryVariables = Exact<{
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  toYear?: Maybe<Scalars["Int"]>;
  fromYear?: Maybe<Scalars["Int"]>;
  fromQuarter?: Maybe<Scalars["Int"]>;
  toQuarter?: Maybe<Scalars["Int"]>;
}>;

export type GetAccountingFileDealerMonitoringQuery = {
  __typename?: "Query";
} & {
  AccountingGetter?: Maybe<
    { __typename?: "AccountingGetter" } & {
      getFileDealerMonitoring?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetAccountingConditionsQueryVariables = Exact<{
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  toYear?: Maybe<Scalars["Int"]>;
  fromYear?: Maybe<Scalars["Int"]>;
  fromQuarter?: Maybe<Scalars["Int"]>;
  toQuarter?: Maybe<Scalars["Int"]>;
}>;

export type GetAccountingConditionsQuery = { __typename?: "Query" } & {
  AccountingGetter?: Maybe<
    { __typename?: "AccountingGetter" } & {
      getFileDealerConditions?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetAccountingFileDealerConditionsQueryVariables = Exact<{
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  columns?: Maybe<
    Array<Maybe<AccountingReportColumn>> | Maybe<AccountingReportColumn>
  >;
  PeriodId?: Maybe<Scalars["ID"]>;
}>;

export type GetAccountingFileDealerConditionsQuery = {
  __typename?: "Query";
} & {
  AccountingGetter?: Maybe<
    { __typename?: "AccountingGetter" } & {
      getFileReportFileColumns?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetAnnouncementListQueryVariables = Exact<{
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  singedBy?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
  text?: Maybe<Scalars["String"]>;
  createdAtFrom?: Maybe<Scalars["DateTime"]>;
  createdAtTo?: Maybe<Scalars["DateTime"]>;
  importance?: Maybe<Scalars["String"]>;
  status?: Maybe<AnnouncementStatus>;
}>;

export type GetAnnouncementListQuery = { __typename?: "Query" } & {
  AnnouncementGetter?: Maybe<
    { __typename?: "AnnouncementGetter" } & {
      get?: Maybe<
        { __typename?: "AnnouncementList" } & Pick<
          AnnouncementList,
          "total"
        > & {
            items?: Maybe<
              Array<
                Maybe<
                  { __typename?: "Announcement" } & FragmentAnnouncementFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetAnnouncementGetOneQueryVariables = Exact<{
  id: Scalars["ID"];
}>;

export type GetAnnouncementGetOneQuery = { __typename?: "Query" } & {
  AnnouncementGetter?: Maybe<
    { __typename?: "AnnouncementGetter" } & {
      getOne?: Maybe<
        { __typename?: "Announcement" } & FragmentAnnouncementFragment
      >;
    }
  >;
};

export type GetCameraZonesQueryVariables = Exact<{
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  dealerId?: Maybe<Scalars["ID"]>;
}>;

export type GetCameraZonesQuery = { __typename?: "Query" } & {
  CameraGetter?: Maybe<
    { __typename?: "CameraGetter" } & {
      getCameraZones?: Maybe<
        { __typename?: "CameraZonesList" } & CameraZonesListFragment
      >;
    }
  >;
};

export type GetCameraZoneByIdQueryVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type GetCameraZoneByIdQuery = { __typename?: "Query" } & {
  CameraGetter?: Maybe<
    { __typename?: "CameraGetter" } & {
      getCameraZone?: Maybe<{ __typename?: "CameraZone" } & CameraZoneFragment>;
    }
  >;
};

export type GetCameraByIdQueryVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type GetCameraByIdQuery = { __typename?: "Query" } & {
  CameraGetter?: Maybe<
    { __typename?: "CameraGetter" } & {
      getCamera?: Maybe<{ __typename?: "Camera" } & CameraFragment>;
    }
  >;
};

export type GetCameraListQueryVariables = Exact<{
  count?: Maybe<Scalars["Int"]>;
  page?: Maybe<Scalars["Int"]>;
  cameraZoneId?: Maybe<Scalars["ID"]>;
  dialerId?: Maybe<Scalars["ID"]>;
}>;

export type GetCameraListQuery = { __typename?: "Query" } & {
  CameraGetter?: Maybe<
    { __typename?: "CameraGetter" } & {
      getCameras?: Maybe<
        { __typename?: "CamerasList" } & Pick<CamerasList, "total"> & {
            items?: Maybe<
              Array<Maybe<{ __typename?: "Camera" } & CameraFragment>>
            >;
          }
      >;
    }
  >;
};

export type GetCameraVideoQueryVariables = Exact<{
  cameraId?: Maybe<Scalars["ID"]>;
}>;

export type GetCameraVideoQuery = { __typename?: "Query" } & {
  CameraGetter?: Maybe<
    { __typename?: "CameraGetter" } & {
      getCameraVideo?: Maybe<
        { __typename?: "CameraVideo" } & Pick<
          CameraVideo,
          "cameraId" | "pid" | "url" | "type"
        >
      >;
    }
  >;
};

export type GetCameraCheckListQueryVariables = Exact<{
  cameraId?: Maybe<Scalars["ID"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  status?: Maybe<CameraCheckStatus>;
}>;

export type GetCameraCheckListQuery = { __typename?: "Query" } & {
  CameraGetter?: Maybe<
    { __typename?: "CameraGetter" } & {
      getCameraChecks?: Maybe<
        { __typename?: "CameraChecksList" } & Pick<
          CameraChecksList,
          "total"
        > & {
            items?: Maybe<
              Array<Maybe<{ __typename?: "CameraCheck" } & CameraCheckFragment>>
            >;
          }
      >;
    }
  >;
};

export type GetCameraCheckByIdQueryVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type GetCameraCheckByIdQuery = { __typename?: "Query" } & {
  CameraGetter?: Maybe<
    { __typename?: "CameraGetter" } & {
      getCameraCheck?: Maybe<
        { __typename?: "CameraCheck" } & CameraCheckFragment
      >;
    }
  >;
};

export type CheckListCommentGetterQueryVariables = Exact<{
  checkListId: Scalars["ID"];
}>;

export type CheckListCommentGetterQuery = { __typename?: "Query" } & {
  CheckListCommentGetter?: Maybe<
    { __typename?: "CheckListCommentGetter" } & {
      getCheckListComments: Array<
        Maybe<
          { __typename?: "CheckListComment" } & Pick<
            CheckListComment,
            "id" | "text" | "author" | "createdAt" | "CheckListId"
          >
        >
      >;
    }
  >;
};

export type CheckListGetterQueryVariables = Exact<{
  dealerAutoCrmid: Scalars["ID"];
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Array<Maybe<SortInputType>> | Maybe<SortInputType>>;
  departmentIds?: Maybe<Array<Scalars["ID"]> | Scalars["ID"]>;
  isDeleted: Scalars["Boolean"];
}>;

export type CheckListGetterQuery = { __typename?: "Query" } & {
  CheckListGetter?: Maybe<
    { __typename?: "CheckListGetter" } & {
      getCheckLists: { __typename?: "CheckListWithResultList" } & Pick<
        CheckListWithResultList,
        "total" | "pages"
      > & {
          items: Array<
            Maybe<
              { __typename?: "CheckListWithResult" } & Pick<
                CheckListWithResult,
                | "id"
                | "externalCode"
                | "isDeleted"
                | "name"
                | "overdueTasks"
                | "inWorkTasks"
                | "completedTasks"
                | "actualPoints"
                | "maxPoints"
                | "DealerAutoCRMID"
                | "DepartmentId"
                | "createdAt"
                | "DealerName"
                | "result"
                | "actionPlanId"
                | "actionPlanDate"
              > & {
                  Indicators?: Maybe<
                    Array<
                      { __typename?: "CheckListIndicator" } & Pick<
                        CheckListIndicator,
                        "name" | "actualPoints" | "maxPoints" | "CheckListId"
                      >
                    >
                  >;
                  Comments?: Maybe<
                    Array<
                      { __typename?: "CheckListComment" } & Pick<
                        CheckListComment,
                        "id" | "text" | "author" | "createdAt" | "CheckListId"
                      >
                    >
                  >;
                }
            >
          >;
        };
    }
  >;
};

export type GetCheckListQueryVariables = Exact<{
  getCheckListId: Scalars["ID"];
}>;

export type GetCheckListQuery = { __typename?: "Query" } & {
  CheckListGetter?: Maybe<
    { __typename?: "CheckListGetter" } & {
      getCheckList?: Maybe<
        { __typename?: "CheckList" } & Pick<
          CheckList,
          | "id"
          | "externalCode"
          | "isDeleted"
          | "name"
          | "DepartmentId"
          | "overdueTasks"
          | "inWorkTasks"
          | "completedTasks"
          | "actualPoints"
          | "maxPoints"
          | "DealerAutoCRMID"
          | "createdAt"
          | "DealerName"
          | "actionPlanId"
        > & {
            Indicators?: Maybe<
              Array<
                { __typename?: "CheckListIndicator" } & Pick<
                  CheckListIndicator,
                  "name" | "actualPoints" | "maxPoints" | "CheckListId"
                >
              >
            >;
            Comments?: Maybe<
              Array<
                { __typename?: "CheckListComment" } & Pick<
                  CheckListComment,
                  "id" | "text" | "author" | "createdAt" | "CheckListId"
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetCheckListIndicatorStatsQueryVariables = Exact<{
  dealerAutoCrmid: Scalars["ID"];
  departmentIds?: Maybe<Array<Scalars["ID"]> | Scalars["ID"]>;
}>;

export type GetCheckListIndicatorStatsQuery = { __typename?: "Query" } & {
  CheckListIndicatorGetter?: Maybe<
    { __typename?: "CheckListIndicatorGetter" } & {
      getCheckListIndicatorStats?: Maybe<
        Array<
          Maybe<
            { __typename?: "CheckListIndicatorStats" } & Pick<
              CheckListIndicatorStats,
              "name" | "value"
            >
          >
        >
      >;
    }
  >;
};

export type GetContractTemplatesQueryVariables = Exact<{
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Array<Maybe<SortInputType>> | Maybe<SortInputType>>;
  isActive?: Maybe<Scalars["Boolean"]>;
}>;

export type GetContractTemplatesQuery = { __typename?: "Query" } & {
  ContractTemplateGetter?: Maybe<
    { __typename?: "ContractTemplateGetter" } & {
      getContractTemplates: { __typename?: "ContractTemplateList" } & Pick<
        ContractTemplateList,
        "pages" | "total"
      > & {
          items: Array<
            Maybe<
              { __typename?: "ContractTemplate" } & Pick<
                ContractTemplate,
                "id" | "name" | "active" | "FileId" | "createdAt" | "updatedAt"
              > & {
                  File: { __typename?: "File" } & Pick<
                    File,
                    | "id"
                    | "name"
                    | "link"
                    | "mimeType"
                    | "createdAt"
                    | "type"
                    | "hash"
                  >;
                }
            >
          >;
        };
    }
  >;
};

export type GetContractTemplateAllowFieldsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetContractTemplateAllowFieldsQuery = { __typename?: "Query" } & {
  ContractTemplateGetter?: Maybe<
    { __typename?: "ContractTemplateGetter" } & {
      getContractTemplateAllowFields?: Maybe<
        Array<
          { __typename?: "ContractTemplateAllowFields" } & Pick<
            ContractTemplateAllowFields,
            "field" | "comment"
          >
        >
      >;
    }
  >;
};

export type GetDealersQueryVariables = Exact<{
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  search?: Maybe<DealerSearch>;
  sortField?: Maybe<Scalars["String"]>;
  sortType?: Maybe<Scalars["String"]>;
  getAll?: Maybe<Scalars["Boolean"]>;
  archivePeriodId?: Maybe<Scalars["ID"]>;
  doSearchArchive?: Maybe<Scalars["Boolean"]>;
}>;

export type GetDealersQuery = { __typename?: "Query" } & {
  DealerGetter?: Maybe<
    { __typename?: "DealerGetter" } & {
      getDealers?: Maybe<
        { __typename?: "DealerList" } & Pick<DealerList, "total"> & {
            items?: Maybe<
              Array<Maybe<{ __typename?: "Dealer" } & FragmentDealerFragment>>
            >;
          }
      >;
    }
  >;
};

export type GetDealersForUserQueryVariables = Exact<{
  UserId: Scalars["ID"];
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
}>;

export type GetDealersForUserQuery = { __typename?: "Query" } & {
  DealerGetter?: Maybe<
    { __typename?: "DealerGetter" } & {
      getDealersForUser?: Maybe<
        { __typename?: "DealerList" } & Pick<DealerList, "total"> & {
            items?: Maybe<
              Array<Maybe<{ __typename?: "Dealer" } & FragmentDealerFragment>>
            >;
          }
      >;
    }
  >;
};

export type GetMyDealersQueryVariables = Exact<{
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  partName?: Maybe<Scalars["String"]>;
  FederalArea?: Maybe<Scalars["String"]>;
  FederalAreaEn?: Maybe<Scalars["String"]>;
  Region?: Maybe<Scalars["String"]>;
  RegionEn?: Maybe<Scalars["String"]>;
  statuses?: Maybe<Array<Maybe<DealerStatus>> | Maybe<DealerStatus>>;
}>;

export type GetMyDealersQuery = { __typename?: "Query" } & {
  DealerGetter?: Maybe<
    { __typename?: "DealerGetter" } & {
      getMyDealers?: Maybe<
        { __typename?: "DealerList" } & {
          items?: Maybe<
            Array<
              Maybe<
                { __typename?: "Dealer" } & FragmentDealershipsForSelectFragment
              >
            >
          >;
        }
      >;
    }
  >;
};

export type GetMyHoldingsQueryVariables = Exact<{
  Region?: Maybe<Scalars["String"]>;
  RegionEn?: Maybe<Scalars["String"]>;
  FederalArea?: Maybe<Scalars["String"]>;
  FederalAreaEn?: Maybe<Scalars["String"]>;
  partName?: Maybe<Scalars["String"]>;
  status?: Maybe<DealerStatus>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
}>;

export type GetMyHoldingsQuery = { __typename?: "Query" } & {
  DealerGetter?: Maybe<
    { __typename?: "DealerGetter" } & {
      getMyHoldings?: Maybe<
        { __typename?: "DealerList" } & {
          items?: Maybe<
            Array<
              Maybe<
                { __typename?: "Dealer" } & FragmentDealershipsForSelectFragment
              >
            >
          >;
        }
      >;
    }
  >;
};

export type GetDealershipsForSelectQueryVariables = Exact<{
  page?: Maybe<Scalars["Int"]>;
  search?: Maybe<DealerSearch>;
}>;

export type GetDealershipsForSelectQuery = { __typename?: "Query" } & {
  DealerGetter?: Maybe<
    { __typename?: "DealerGetter" } & {
      getDealers?: Maybe<
        { __typename?: "DealerList" } & {
          items?: Maybe<
            Array<
              Maybe<
                { __typename?: "Dealer" } & FragmentDealershipsForSelectFragment
              >
            >
          >;
        }
      >;
    }
  >;
};

export type GetDealerListToAssignQueryVariables = Exact<{
  UserId: Scalars["ID"];
  status?: Maybe<DealerStatus>;
}>;

export type GetDealerListToAssignQuery = { __typename?: "Query" } & {
  DealerGetter?: Maybe<
    { __typename?: "DealerGetter" } & {
      getDealerListToAssign?: Maybe<
        { __typename?: "DealerListToAssign" } & {
          items?: Maybe<
            Array<
              Maybe<
                {
                  __typename?: "DealerToAssign";
                } & FragmentDealerToAssignFragment
              >
            >
          >;
        }
      >;
    }
  >;
};

export type GetDealerQueryVariables = Exact<{
  DealerId: Scalars["ID"];
  ArchivePeriodId?: Maybe<Scalars["ID"]>;
}>;

export type GetDealerQuery = { __typename?: "Query" } & {
  DealerGetter?: Maybe<
    { __typename?: "DealerGetter" } & {
      getDealer?: Maybe<
        { __typename?: "Dealer" } & Pick<Dealer, "autoCRMID"> &
          FragmentDealerFragment
      >;
    }
  >;
};

export type GetDealersFederalAreaQueryVariables = Exact<{
  city?: Maybe<Scalars["String"]>;
  cityEn?: Maybe<Scalars["String"]>;
}>;

export type GetDealersFederalAreaQuery = { __typename?: "Query" } & {
  DealerGetter?: Maybe<
    { __typename?: "DealerGetter" } & {
      getDealersFederalArea?: Maybe<
        { __typename?: "FieldList" } & Pick<FieldList, "items" | "itemsEn">
      >;
    }
  >;
};

export type GetDealersRegionsQueryVariables = Exact<{
  status?: Maybe<DealerStatus>;
}>;

export type GetDealersRegionsQuery = { __typename?: "Query" } & {
  DealerGetter?: Maybe<
    { __typename?: "DealerGetter" } & {
      getDealersRegions?: Maybe<
        { __typename?: "FieldList" } & Pick<FieldList, "items" | "itemsEn">
      >;
    }
  >;
};

export type GetDealersCitiesQueryVariables = Exact<{
  FOEn?: Maybe<Scalars["String"]>;
  FO?: Maybe<Scalars["String"]>;
  status?: Maybe<DealerStatus>;
}>;

export type GetDealersCitiesQuery = { __typename?: "Query" } & {
  DealerGetter?: Maybe<
    { __typename?: "DealerGetter" } & {
      getDealersCities?: Maybe<
        { __typename?: "FieldList" } & Pick<FieldList, "items" | "itemsEn">
      >;
    }
  >;
};

export type GetDealersLocationItemQueryVariables = Exact<{
  item?: Maybe<DealersLocationItem>;
  city?: Maybe<Scalars["String"]>;
  cityEn?: Maybe<Scalars["String"]>;
  FOEn?: Maybe<Scalars["String"]>;
  FO?: Maybe<Scalars["String"]>;
  subject?: Maybe<Scalars["String"]>;
  subjectEn?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  countryEn?: Maybe<Scalars["String"]>;
}>;

export type GetDealersLocationItemQuery = { __typename?: "Query" } & {
  DealerGetter?: Maybe<
    { __typename?: "DealerGetter" } & {
      getDealersLocationItem?: Maybe<
        { __typename?: "FieldList" } & Pick<FieldList, "items" | "itemsEn">
      >;
    }
  >;
};

export type GetDealerPanelQueryVariables = Exact<{
  DealerId: Scalars["ID"];
}>;

export type GetDealerPanelQuery = { __typename?: "Query" } & {
  DealerGetter?: Maybe<
    { __typename?: "DealerGetter" } & {
      getDealer?: Maybe<
        { __typename?: "Dealer" } & FragmentDealerPanelFragment
      >;
    }
  >;
};

export type GetDealerInfoQueryVariables = Exact<{
  DealerId: Scalars["ID"];
  ActualOn?: Maybe<Scalars["DateTime"]>;
}>;

export type GetDealerInfoQuery = { __typename?: "Query" } & {
  DealerGetter?: Maybe<
    { __typename?: "DealerGetter" } & {
      getAreaDealer?: Maybe<
        { __typename?: "DealerArea" } & FragmentDealerAreaFragment
      >;
    }
  >;
};

export type GetProjectDocumentationDealerQueryVariables = Exact<{
  DealerId: Scalars["ID"];
}>;

export type GetProjectDocumentationDealerQuery = { __typename?: "Query" } & {
  DealerGetter?: Maybe<
    { __typename?: "DealerGetter" } & {
      getProjectDocumentationDealer?: Maybe<
        { __typename?: "DealerProjectDocumentation" } & Pick<
          DealerProjectDocumentation,
          | "id"
          | "name"
          | "ActualFrom"
          | "status"
          | "ActualTo"
          | "createdAt"
          | "updatedAt"
        > & {
            File?: Maybe<
              { __typename?: "File" } & Pick<
                File,
                "id" | "name" | "link" | "mimeType"
              >
            >;
          }
      >;
    }
  >;
};

export type GetProjectDocumentationsDealerQueryVariables = Exact<{
  DealerId: Scalars["ID"];
}>;

export type GetProjectDocumentationsDealerQuery = { __typename?: "Query" } & {
  DealerGetter?: Maybe<
    { __typename?: "DealerGetter" } & {
      getProjectDocumentationsDealer?: Maybe<
        { __typename?: "DealerProjectDocumentationList" } & Pick<
          DealerProjectDocumentationList,
          "total"
        > & {
            items?: Maybe<
              Array<
                Maybe<
                  { __typename?: "DealerProjectDocumentation" } & Pick<
                    DealerProjectDocumentation,
                    | "id"
                    | "name"
                    | "ActualFrom"
                    | "ActualTo"
                    | "status"
                    | "createdAt"
                    | "updatedAt"
                  > & {
                      File?: Maybe<
                        { __typename?: "File" } & Pick<
                          File,
                          "id" | "name" | "link" | "mimeType"
                        >
                      >;
                    }
                >
              >
            >;
          }
      >;
    }
  >;
};

export type DownloadDealersValueQueryVariables = Exact<{
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  type?: Maybe<Scalars["String"]>;
}>;

export type DownloadDealersValueQuery = { __typename?: "Query" } & {
  DealerGetter?: Maybe<
    { __typename?: "DealerGetter" } & {
      downloadDealers?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetDealersDomainsQueryVariables = Exact<{
  DealersId?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetDealersDomainsQuery = { __typename?: "Query" } & {
  DealerGetter?: Maybe<
    { __typename?: "DealerGetter" } & {
      getDealersDomains?: Maybe<
        { __typename?: "DealerDomainsList" } & FragmentGetDealersDomainsFragment
      >;
    }
  >;
};

export type GetDealerDomainsQueryVariables = Exact<{
  dealerId?: Maybe<Scalars["ID"]>;
}>;

export type GetDealerDomainsQuery = { __typename?: "Query" } & {
  DealerGetter?: Maybe<
    { __typename?: "DealerGetter" } & {
      getDealerDomains?: Maybe<
        { __typename?: "DealerDomainsList" } & FragmentGetDealersDomainsFragment
      >;
    }
  >;
};

export type CheckAvailableEmailQueryVariables = Exact<{
  email: Scalars["String"];
  dealerId?: Maybe<Scalars["ID"]>;
}>;

export type CheckAvailableEmailQuery = { __typename?: "Query" } & {
  DealerGetter?: Maybe<
    { __typename?: "DealerGetter" } & Pick<DealerGetter, "checkAvailableEmail">
  >;
};

export type GetDealerFieldsQueryVariables = Exact<{ [key: string]: never }>;

export type GetDealerFieldsQuery = { __typename?: "Query" } & {
  DealerGetter?: Maybe<
    { __typename?: "DealerGetter" } & {
      getDealerFields?: Maybe<
        Array<
          Maybe<
            { __typename?: "DealerField" } & Pick<
              DealerField,
              | "id"
              | "fieldName"
              | "fieldEnName"
              | "fieldRu"
              | "fieldEn"
              | "fieldRuDescription"
              | "fieldEnDescription"
            >
          >
        >
      >;
    }
  >;
};

export type DealerPhotoGetterQueryVariables = Exact<{
  dealerId: Scalars["ID"];
  count?: Maybe<Scalars["Int"]>;
  page?: Maybe<Scalars["Int"]>;
}>;

export type DealerPhotoGetterQuery = { __typename?: "Query" } & {
  DealerPhotoGetter?: Maybe<
    { __typename?: "DealerPhotoGetter" } & {
      getDealerPhotos: { __typename?: "DealerPhotoList" } & Pick<
        DealerPhotoList,
        "pages" | "total"
      > & {
          items: Array<
            Maybe<
              { __typename?: "DealerPhoto" } & Pick<
                DealerPhoto,
                | "id"
                | "originalUrl"
                | "previewUrl"
                | "DealerId"
                | "PhotoGallerySectionId"
                | "createdAt"
              > & {
                  PhotoGallerySection: {
                    __typename?: "PhotoGallerySection";
                  } & Pick<
                    PhotoGallerySection,
                    "description" | "createdAt" | "id" | "title"
                  >;
                }
            >
          >;
        };
    }
  >;
};

export type GetArchivePeriodsQueryVariables = Exact<{
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  fromDate?: Maybe<Scalars["DateTime"]>;
  toDate?: Maybe<Scalars["DateTime"]>;
  insideDate?: Maybe<Scalars["DateTime"]>;
}>;

export type GetArchivePeriodsQuery = { __typename?: "Query" } & {
  DealerRegistryGetter?: Maybe<
    { __typename?: "DealerRegistryGetter" } & {
      getArchivePeriods?: Maybe<
        { __typename?: "getArchivePeriodsList" } & Pick<
          GetArchivePeriodsList,
          "total"
        > & {
            items: Array<
              Maybe<
                {
                  __typename?: "ArchivePeriod";
                } & FragmentGetArchivePeriodsFragment
              >
            >;
          }
      >;
    }
  >;
};

export type GetArchiveDealersInheritanceQueryVariables = Exact<{
  DealerId?: Maybe<Scalars["ID"]>;
}>;

export type GetArchiveDealersInheritanceQuery = { __typename?: "Query" } & {
  DealerRegistryGetter?: Maybe<
    { __typename?: "DealerRegistryGetter" } & {
      getArchiveDealersInheritance?: Maybe<
        { __typename?: "getArchiveDealersInheritanceList" } & Pick<
          GetArchiveDealersInheritanceList,
          "total"
        > & {
            items: Array<
              Maybe<
                {
                  __typename?: "DealerWithPeriods";
                } & FragmentDealerWithPeriodsFragment
              >
            >;
          }
      >;
    }
  >;
};

export type GetTemplatesQueryVariables = Exact<{
  page?: Scalars["Int"];
  count?: Scalars["Int"];
  getAll?: Scalars["Boolean"];
  type?: ContractType;
}>;

export type GetTemplatesQuery = { __typename?: "Query" } & {
  DealerRegistryGetter?: Maybe<
    { __typename?: "DealerRegistryGetter" } & {
      getTemplates?: Maybe<
        { __typename?: "getTemplatesList" } & Pick<
          GetTemplatesList,
          "total"
        > & {
            items: Array<
              Maybe<
                {
                  __typename?: "DealerContractTemplate";
                } & FragmentGetTemplatesFragment
              >
            >;
          }
      >;
    }
  >;
};

export type GetContractsQueryVariables = Exact<{
  DealerId: Scalars["ID"];
  type?: ContractType;
}>;

export type GetContractsQuery = { __typename?: "Query" } & {
  DealerRegistryGetter?: Maybe<
    { __typename?: "DealerRegistryGetter" } & {
      getContracts?: Maybe<
        Array<
          Maybe<
            { __typename?: "getContracts" } & Pick<GetContracts, "id" | "name">
          >
        >
      >;
    }
  >;
};

export type DownloadContractQueryVariables = Exact<{
  contractId: Scalars["ID"];
  dealerId: Scalars["ID"];
}>;

export type DownloadContractQuery = { __typename?: "Query" } & {
  DealerRegistryGetter?: Maybe<
    { __typename?: "DealerRegistryGetter" } & {
      downloadContract?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type DownloadPeriodInfoQueryVariables = Exact<{
  periodId?: Maybe<Scalars["ID"]>;
}>;

export type DownloadPeriodInfoQuery = { __typename?: "Query" } & {
  DealerRegistryGetter?: Maybe<
    { __typename?: "DealerRegistryGetter" } & {
      downloadPeriodInfo?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetCatalogListQueryVariables = Exact<{
  parentId?: Maybe<Scalars["ID"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
}>;

export type GetCatalogListQuery = { __typename?: "Query" } & {
  DocumentGetter?: Maybe<
    { __typename?: "DocumentGetter" } & {
      getSections?: Maybe<
        { __typename?: "SectionsList" } & Pick<SectionsList, "total"> & {
            items?: Maybe<
              Array<Maybe<{ __typename?: "Section" } & CatalogFragment>>
            >;
          }
      >;
    }
  >;
};

export type GetCatalogQueryVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type GetCatalogQuery = { __typename?: "Query" } & {
  DocumentGetter?: Maybe<
    { __typename?: "DocumentGetter" } & {
      getOneSection?: Maybe<{ __typename?: "Section" } & CatalogFragment>;
    }
  >;
};

export type GetDocumentListQueryVariables = Exact<{
  sectionId?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  importance?: Maybe<Scalars["String"]>;
  signedBy?: Maybe<Scalars["String"]>;
  createdAtFrom?: Maybe<Scalars["DateTime"]>;
  createdAtTo?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
}>;

export type GetDocumentListQuery = { __typename?: "Query" } & {
  DocumentGetter?: Maybe<
    { __typename?: "DocumentGetter" } & {
      getList?: Maybe<
        { __typename?: "DocumentsList" } & Pick<DocumentsList, "total"> & {
            items?: Maybe<
              Array<Maybe<{ __typename?: "Document" } & DocumentFragment>>
            >;
          }
      >;
    }
  >;
};

export type GetDocumentQueryVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type GetDocumentQuery = { __typename?: "Query" } & {
  DocumentGetter?: Maybe<
    { __typename?: "DocumentGetter" } & {
      getOne?: Maybe<{ __typename?: "Document" } & DocumentFragment>;
    }
  >;
};

export type GetFolderQueryVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type GetFolderQuery = { __typename?: "Query" } & {
  DocumentGetter?: Maybe<
    { __typename?: "DocumentGetter" } & {
      getFolder?: Maybe<
        { __typename?: "FolderContentList" } & Pick<
          FolderContentList,
          "total"
        > & {
            items?: Maybe<
              Array<
                Maybe<{ __typename?: "FolderContent" } & FolderListFragment>
              >
            >;
          }
      >;
    }
  >;
};

export type GetCoursesQueryVariables = Exact<{
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["ID"]>;
  order?: Maybe<SortType>;
  status?: Maybe<CurriculumCourseStatus>;
  name?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  codeIS?: Maybe<Scalars["String"]>;
  certificateValidityPeriod?: Maybe<Scalars["Int"]>;
  level?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  orderBy?: Maybe<CourseOrderBy>;
  ActualOn?: Maybe<Scalars["DateTime"]>;
}>;

export type GetCoursesQuery = { __typename?: "Query" } & {
  EducationGetter?: Maybe<
    { __typename?: "EducationGetter" } & {
      getListCourseCurriculum?: Maybe<
        { __typename?: "getCourseCurriculumByParams" } & Pick<
          GetCourseCurriculumByParams,
          "total"
        > & {
            items?: Maybe<
              Array<
                Maybe<
                  { __typename?: "CourseCurriculum" } & FragmentCoursesFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetGroupsQueryVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  ids?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
  ActualOn?: Maybe<Scalars["DateTime"]>;
  status?: Maybe<CurriculumGroupStatus>;
}>;

export type GetGroupsQuery = { __typename?: "Query" } & {
  EducationGetter?: Maybe<
    { __typename?: "EducationGetter" } & {
      getListGroupCurriculum?: Maybe<
        { __typename?: "getListGroupCurriculum" } & Pick<
          GetListGroupCurriculum,
          "total"
        > &
          FragmentGroupsFragment
      >;
    }
  >;
};

export type GetLevelsQueryVariables = Exact<{
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  status?: Maybe<CurriculumLevelStatus>;
  name?: Maybe<Scalars["String"]>;
  ActualOn?: Maybe<Scalars["DateTime"]>;
}>;

export type GetLevelsQuery = { __typename?: "Query" } & {
  EducationGetter?: Maybe<
    { __typename?: "EducationGetter" } & {
      getListLevelCurriculum?: Maybe<
        { __typename?: "getListLevelCurriculum" } & Pick<
          GetListLevelCurriculum,
          "total"
        > &
          FragmentLevelsFragment
      >;
    }
  >;
};

export type GetGroupCurriculumByIdQueryVariables = Exact<{
  id: Scalars["ID"];
}>;

export type GetGroupCurriculumByIdQuery = { __typename?: "Query" } & {
  EducationGetter?: Maybe<
    { __typename?: "EducationGetter" } & {
      getGroupCurriculumById?: Maybe<
        { __typename?: "GroupCurriculum" } & FragmentGroupFragment
      >;
    }
  >;
};

export type GetLevelCurriculumByIdQueryVariables = Exact<{
  id: Scalars["ID"];
}>;

export type GetLevelCurriculumByIdQuery = { __typename?: "Query" } & {
  EducationGetter?: Maybe<
    { __typename?: "EducationGetter" } & {
      getLevelCurriculumById?: Maybe<
        { __typename?: "LevelCurriculum" } & FragmentLevelFragment
      >;
    }
  >;
};

export type GetCourseCurriculumByIdQueryVariables = Exact<{
  id: Scalars["ID"];
}>;

export type GetCourseCurriculumByIdQuery = { __typename?: "Query" } & {
  EducationGetter?: Maybe<
    { __typename?: "EducationGetter" } & {
      getCourseCurriculumById?: Maybe<
        { __typename?: "CourseCurriculum" } & FragmentCourseFragment
      >;
    }
  >;
};

export type GetPositionIsTheEducationProgramsQueryVariables = Exact<{
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
}>;

export type GetPositionIsTheEducationProgramsQuery = {
  __typename?: "Query";
} & {
  EducationGetter?: Maybe<
    { __typename?: "EducationGetter" } & {
      getPositionIsTheEducationPrograms?: Maybe<
        {
          __typename?: "getPositionIsTheEducationPrograms";
        } & FragmentPositionIsTheEducationProgramsFragment
      >;
    }
  >;
};

export type GetCompositionPositionProgramsQueryVariables = Exact<{
  PositionGroupId: Scalars["ID"];
  ActualOn?: Maybe<Scalars["DateTime"]>;
}>;

export type GetCompositionPositionProgramsQuery = { __typename?: "Query" } & {
  EducationGetter?: Maybe<
    { __typename?: "EducationGetter" } & {
      getCompositionPositionPrograms?: Maybe<
        {
          __typename?: "getCompositionPositionPrograms";
        } & FragmentCompositionsPositionsProgramFragment
      >;
    }
  >;
};

export type GetPositionsInNotEducationProgramsQueryVariables = Exact<{
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
}>;

export type GetPositionsInNotEducationProgramsQuery = {
  __typename?: "Query";
} & {
  EducationGetter?: Maybe<
    { __typename?: "EducationGetter" } & {
      getPositionsInNotEducationPrograms?: Maybe<
        {
          __typename?: "getPositionsInNotEducationPrograms";
        } & FragmentPositionsInNotEducationProgramsFragment
      >;
    }
  >;
};

export type GetListCourseBySortLevelIdQueryVariables = Exact<{
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  status?: Maybe<CurriculumCourseStatus>;
  name?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  certificateValidityPeriod?: Maybe<Scalars["Int"]>;
  order?: Maybe<SortType>;
  LevelId: Scalars["ID"];
  orderBy?: Maybe<CourseOrderBy>;
  ActualOn?: Maybe<Scalars["DateTime"]>;
}>;

export type GetListCourseBySortLevelIdQuery = { __typename?: "Query" } & {
  EducationGetter?: Maybe<
    { __typename?: "EducationGetter" } & {
      getListCourseBySortLevelId?: Maybe<
        { __typename?: "getCourseCurriculumByParams" } & Pick<
          GetCourseCurriculumByParams,
          "total"
        > & {
            items?: Maybe<
              Array<
                Maybe<
                  {
                    __typename?: "CourseCurriculum";
                  } & FragmentGetListCoursesBySortLevelIdFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetEmployeeGetListQueryVariables = Exact<{
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  PositionIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  id?: Maybe<Scalars["ID"]>;
  surname?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  middleName?: Maybe<Scalars["String"]>;
  personalPhone?: Maybe<Scalars["String"]>;
  workPhone?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  emailVerification?: Maybe<Scalars["Boolean"]>;
  creationFrom?: Maybe<Scalars["DateTime"]>;
  creationTo?: Maybe<Scalars["DateTime"]>;
  lastEditFrom?: Maybe<Scalars["DateTime"]>;
  lastEditTo?: Maybe<Scalars["DateTime"]>;
  statuses?: Maybe<
    Array<Maybe<EmployeePositionStatus>> | Maybe<EmployeePositionStatus>
  >;
  ladaAcademiaIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  order?: Maybe<SortType>;
  orderBy?: Maybe<OrderByColumnInEmployees>;
  searchText?: Maybe<Scalars["String"]>;
}>;

export type GetEmployeeGetListQuery = { __typename?: "Query" } & {
  EmployeeGetter?: Maybe<
    { __typename?: "EmployeeGetter" } & {
      getList?: Maybe<
        { __typename?: "getEmployeeList" } & Pick<GetEmployeeList, "total"> & {
            items?: Maybe<
              Array<
                Maybe<
                  { __typename?: "EmployeeWithPosition" } & {
                    EmployeePosition?: Maybe<
                      { __typename: "PureEmployeePosition" } & Pick<
                        PureEmployeePosition,
                        | "id"
                        | "employeesId"
                        | "number"
                        | "startDate"
                        | "startOrderNumber"
                        | "endDate"
                        | "endOrderNumber"
                        | "createdBy"
                        | "createdAt"
                        | "dealerId"
                        | "positionsId"
                        | "instanceId"
                        | "actualFrom"
                        | "actualTo"
                        | "email"
                        | "emailVerification"
                        | "status"
                        | "lastStatusUpdateAt"
                        | "lastModifiedAt"
                        | "lastModifiedBy"
                        | "hireBy"
                        | "verifyBy"
                        | "verifyDate"
                        | "fireBy"
                        | "recheckRequiredNotified"
                        | "lastStatusUpdateBy"
                        | "dataConsentId"
                        | "recid"
                        | "updatedAt"
                        | "emailVerificationDate"
                        | "positionOrderId"
                        | "rejectReason"
                      >
                    >;
                    Position?: Maybe<
                      { __typename: "PurePosition" } & Pick<
                        PurePosition,
                        | "id"
                        | "code"
                        | "name"
                        | "nameEn"
                        | "status"
                        | "directionId"
                        | "expectationId"
                        | "createdAt"
                        | "updatedAt"
                        | "requiredEmail"
                        | "instanceId"
                        | "actualFrom"
                        | "actualTo"
                      >
                    >;
                    Dealer?: Maybe<
                      { __typename: "PureDealer" } & Pick<
                        PureDealer,
                        | "id"
                        | "autoCRMID"
                        | "type"
                        | "typeEn"
                        | "ent_id"
                        | "dealerName"
                        | "dealerNameEn"
                        | "tradeDealerName"
                        | "tradeDealerNameEn"
                        | "legalDealerName"
                        | "legalDealerNameEn"
                        | "inn"
                        | "kPP"
                        | "contractEndDate"
                        | "iS_Id"
                        | "main"
                        | "newDealer"
                        | "temporaryDecision"
                        | "protocolOfIntentions"
                        | "logicalType"
                        | "extendedForNextYear"
                        | "terminated"
                        | "hideOnLadaRu"
                        | "termOfAuthority"
                        | "consumerCode"
                        | "corporateEmail"
                        | "settlementAccount"
                        | "correspondentAccount"
                        | "bankName"
                        | "responsibleForLadaEmail"
                        | "responsibleForLadaFax"
                        | "responsibleForLadaPhone"
                        | "responsibleForLadaCode"
                        | "responsibleForLadaName"
                        | "accountantEmail"
                        | "accountantFax"
                        | "accountantPhone"
                        | "accountantCode"
                        | "accountantName"
                        | "protocolOfTermination"
                        | "protocolOfConclusion"
                        | "successorCode"
                        | "entfCode"
                        | "entfSuccessorNo"
                        | "entfSuccessorCode"
                        | "category"
                        | "code"
                        | "legalAddress"
                        | "legalCityId"
                        | "legalHouseId"
                        | "postalAddress"
                        | "postalCityId"
                        | "postalHouseId"
                        | "address"
                        | "addressEn"
                        | "regionCode"
                        | "country"
                        | "countryEn"
                        | "fO"
                        | "fOEn"
                        | "subject"
                        | "subjectEn"
                        | "city"
                        | "cityEn"
                        | "cityId"
                        | "houseId"
                        | "headFax"
                        | "headCode"
                        | "headNameGenitive"
                        | "headPositionGenitive"
                        | "headNameImported"
                        | "headFullNameGenitive"
                        | "headPositionImported"
                        | "headEmailImported"
                        | "headPhoneImported"
                        | "ePEn"
                        | "headName"
                        | "headNameEn"
                        | "headPhone"
                        | "headMobilePhone"
                        | "headEmail"
                        | "ownerName"
                        | "ownerNameEn"
                        | "ownerPhone"
                        | "ownerMobilePhone"
                        | "ownerEmail"
                        | "birCode"
                        | "beginWorkingDate"
                        | "ivideonSublicenseStartAt"
                        | "isIvideonActFormed"
                        | "contractId"
                        | "headCompanyId"
                        | "photoDealerCenterId"
                        | "photoOwnerId"
                        | "photoBossId"
                        | "scanOwnerPersonDataId"
                        | "scanBossPersonDataId"
                        | "scanLadaPersonDataId"
                        | "scanAccountantPersonDataId"
                        | "organizationalLegalForm"
                        | "status"
                        | "projectDocumentationId"
                        | "updatedAt"
                        | "createdAt"
                        | "ep"
                        | "ogrn"
                        | "egrNumber"
                        | "egrSeries"
                        | "egrDate"
                        | "bik"
                        | "xStoPhcode"
                        | "xStoPhone"
                        | "xStoEmail"
                        | "xShopPhcode"
                        | "xShopPhone"
                        | "xShopEmail"
                        | "xShopName"
                        | "xShopFlag"
                        | "kgaCode"
                        | "onecCode"
                        | "dealerLadaserv"
                      >
                    >;
                    Employee?: Maybe<
                      { __typename: "PureEmployee" } & Pick<
                        PureEmployee,
                        | "id"
                        | "surname"
                        | "name"
                        | "middleName"
                        | "gender"
                        | "email"
                        | "personalPhone"
                        | "workPhone"
                        | "hiredDate"
                        | "firedDate"
                        | "lastEditDate"
                        | "createdBy"
                        | "createdAt"
                        | "ladaAcademiaId"
                        | "firedAt"
                        | "firedBy"
                        | "lastEditBy"
                        | "verifiedAt"
                        | "verifiedBy"
                        | "status"
                        | "lastStatusUpdateAt"
                        | "lastStatusUpdateBy"
                        | "verifiedInDnm"
                      >
                    >;
                    Direction?: Maybe<
                      { __typename?: "PurePositionDirection" } & Pick<
                        PurePositionDirection,
                        | "id"
                        | "instanceId"
                        | "actualFrom"
                        | "actualTo"
                        | "name"
                        | "status"
                        | "createdAt"
                        | "updatedAt"
                        | "role"
                      >
                    >;
                  }
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetEmployeeGetQueryVariables = Exact<{
  id: Scalars["ID"];
}>;

export type GetEmployeeGetQuery = { __typename?: "Query" } & {
  EmployeeGetter?: Maybe<
    { __typename?: "EmployeeGetter" } & {
      get?: Maybe<
        { __typename?: "Employee" } & {
          Positions?: Maybe<
            Array<
              Maybe<
                { __typename?: "EmployeePositionsGroupByNumber" } & {
                  ActivePosition?: Maybe<
                    { __typename?: "EmployeePositionsField" } & {
                      Positions?: Maybe<
                        Array<
                          Maybe<
                            { __typename?: "EmployeePositions" } & Pick<
                              EmployeePositions,
                              "positionOrderId"
                            > & {
                                positionOrder?: Maybe<
                                  { __typename?: "File" } & Pick<
                                    File,
                                    | "id"
                                    | "name"
                                    | "link"
                                    | "mimeType"
                                    | "createdAt"
                                    | "type"
                                    | "hash"
                                  >
                                >;
                              }
                          >
                        >
                      >;
                    }
                  >;
                }
              >
            >
          >;
        } & FragmentGetFragment
      >;
    }
  >;
};

export type GetEmployeeReportQueryVariables = Exact<{
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  PositionIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  ladaAcademiaIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  creationFrom?: Maybe<Scalars["DateTime"]>;
  creationTo?: Maybe<Scalars["DateTime"]>;
  lastEditFrom?: Maybe<Scalars["DateTime"]>;
  lastEditTo?: Maybe<Scalars["DateTime"]>;
  id?: Maybe<Scalars["ID"]>;
  surname?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  middleName?: Maybe<Scalars["String"]>;
  personalPhone?: Maybe<Scalars["String"]>;
  workPhone?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  statuses?: Maybe<
    Array<Maybe<EmployeePositionStatus>> | Maybe<EmployeePositionStatus>
  >;
  ActualOn?: Maybe<Scalars["DateTime"]>;
  emailVerification?: Maybe<Scalars["Boolean"]>;
}>;

export type GetEmployeeReportQuery = { __typename?: "Query" } & {
  EmployeeGetter?: Maybe<
    { __typename?: "EmployeeGetter" } & {
      getEmployeeReport?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetEmployeePositionsQueryVariables = Exact<{
  id: Scalars["ID"];
}>;

export type GetEmployeePositionsQuery = { __typename?: "Query" } & {
  EmployeeGetter?: Maybe<
    { __typename?: "EmployeeGetter" } & {
      getEmployeePositions?: Maybe<
        Array<
          Maybe<
            { __typename?: "EmployeePositionsGroupByNumber" } & Pick<
              EmployeePositionsGroupByNumber,
              "number"
            > & {
                ActivePosition?: Maybe<
                  { __typename?: "EmployeePositionsField" } & {
                    Position?: Maybe<
                      { __typename?: "Position" } & Pick<
                        Position,
                        "DirectionId"
                      >
                    >;
                  } & FragmentPositionFragment
                >;
                InactivePositions?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: "EmployeePositionsField" } & {
                        Position?: Maybe<
                          { __typename?: "Position" } & Pick<
                            Position,
                            "DirectionId"
                          >
                        >;
                      } & FragmentPositionsFragment
                    >
                  >
                >;
              }
          >
        >
      >;
    }
  >;
};

export type CheckEmployeeEmailQueryVariables = Exact<{
  email: Scalars["String"];
  EmployeesId?: Maybe<Scalars["ID"]>;
  DealersId?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type CheckEmployeeEmailQuery = { __typename?: "Query" } & {
  EmployeeGetter?: Maybe<
    { __typename?: "EmployeeGetter" } & Pick<
      EmployeeGetter,
      "CheckEmployeeEmail"
    >
  >;
};

export type CheckValidEmailDomainQueryVariables = Exact<{
  email: Scalars["String"];
  dealersId?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  employeesId?: Maybe<Scalars["ID"]>;
}>;

export type CheckValidEmailDomainQuery = { __typename?: "Query" } & {
  EmployeeGetter?: Maybe<
    { __typename?: "EmployeeGetter" } & Pick<
      EmployeeGetter,
      "checkValidEmailDomain"
    >
  >;
};

export type GetGroupEducationEmployeeExpectationQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetGroupEducationEmployeeExpectationQuery = {
  __typename?: "Query";
} & {
  EmployeeGetter?: Maybe<
    { __typename?: "EmployeeGetter" } & {
      getGroupEducationEmployeeExpectation?: Maybe<
        { __typename?: "EmployeeExpectationGroupScheme" } & Pick<
          EmployeeExpectationGroupScheme,
          "GroupCertificationId" | "GroupTrainingId"
        > & {
            GroupCertification?: Maybe<
              { __typename?: "GroupCurriculum" } & Pick<GroupCurriculum, "name">
            >;
            GroupTraining?: Maybe<
              { __typename?: "GroupCurriculum" } & Pick<GroupCurriculum, "name">
            >;
          }
      >;
    }
  >;
};

export type GetFileCatalogQueryVariables = Exact<{
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  DealerId: Scalars["ID"];
  catalog?: Maybe<Scalars["String"]>;
  sortField?: Maybe<Scalars["String"]>;
  sortType?: Maybe<Scalars["String"]>;
  UserId?: Maybe<Scalars["ID"]>;
  dateBegin?: Maybe<Scalars["DateTime"]>;
  dateEnd?: Maybe<Scalars["DateTime"]>;
  name?: Maybe<Scalars["String"]>;
}>;

export type GetFileCatalogQuery = { __typename?: "Query" } & {
  FileCatalogGetter?: Maybe<
    { __typename?: "FileCatalogGetter" } & {
      getFiles?: Maybe<
        { __typename?: "FileList" } & Pick<FileList, "total"> & {
            items?: Maybe<
              Array<
                Maybe<{ __typename?: "File" } & FragmentFileCatalogFragment>
              >
            >;
          }
      >;
    }
  >;
};

export type GetFilesQueryVariables = Exact<{
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
}>;

export type GetFilesQuery = { __typename?: "Query" } & {
  FileGetter?: Maybe<
    { __typename?: "FileGetter" } & {
      getFiles?: Maybe<
        { __typename?: "FileList" } & Pick<FileList, "total"> & {
            items?: Maybe<
              Array<Maybe<{ __typename?: "File" } & FragmentFileFragment>>
            >;
          }
      >;
    }
  >;
};

export type GetFileQueryVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type GetFileQuery = { __typename?: "Query" } & {
  FileGetter?: Maybe<
    { __typename?: "FileGetter" } & {
      getFile?: Maybe<
        { __typename?: "File" } & Pick<File, "id" | "link" | "name" | "hash">
      >;
    }
  >;
};

export type GetFileByHashQueryVariables = Exact<{
  hash?: Maybe<Scalars["String"]>;
}>;

export type GetFileByHashQuery = { __typename?: "Query" } & {
  FileGetter?: Maybe<
    { __typename?: "FileGetter" } & {
      getFileByHash?: Maybe<
        { __typename?: "File" } & Pick<File, "id" | "link" | "name" | "hash">
      >;
    }
  >;
};

export type GeoGetterQueryVariables = Exact<{
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  cladrCode?: Maybe<Scalars["String"]>;
  okatoCode?: Maybe<Scalars["String"]>;
  type?: Maybe<GeoPlaceType>;
  parentId?: Maybe<Scalars["ID"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
}>;

export type GeoGetterQuery = { __typename?: "Query" } & {
  GeoGetter?: Maybe<
    { __typename?: "GeoGetter" } & {
      getGeoPlaces?: Maybe<
        { __typename?: "getGeoPlacesList" } & Pick<
          GetGeoPlacesList,
          "total"
        > & {
            items: Array<
              Maybe<
                { __typename?: "GeoPlace" } & Pick<
                  GeoPlace,
                  | "id"
                  | "parentId"
                  | "type"
                  | "name"
                  | "nameEn"
                  | "socr"
                  | "cladrCode"
                  | "okatoCode"
                  | "active"
                  | "createdAt"
                  | "updatedAt"
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetLocationsByIdQueryVariables = Exact<{
  getLocationsByIdId: Scalars["ID"];
}>;

export type GetLocationsByIdQuery = { __typename?: "Query" } & {
  GeoGetter?: Maybe<
    { __typename?: "GeoGetter" } & {
      getLocationsById?: Maybe<
        { __typename?: "Locations" } & Pick<
          Locations,
          | "countryId"
          | "country"
          | "countryEn"
          | "FOId"
          | "FO"
          | "FOEn"
          | "subjectId"
          | "subject"
          | "subjectEn"
          | "districtId"
          | "district"
          | "districtEn"
          | "cityId"
          | "city"
          | "cityEn"
          | "house"
          | "houseEn"
          | "houseId"
          | "street"
          | "streetEn"
          | "streetId"
        >
      >;
    }
  >;
};

export type GetGeoPlacesByParentIdQueryVariables = Exact<{
  parentId: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  type?: Maybe<GeoPlaceType>;
}>;

export type GetGeoPlacesByParentIdQuery = { __typename?: "Query" } & {
  GeoGetter?: Maybe<
    { __typename?: "GeoGetter" } & {
      getGeoPlacesByParentId?: Maybe<
        Array<
          Maybe<
            { __typename?: "GeoPlace" } & Pick<
              GeoPlace,
              | "id"
              | "parentId"
              | "type"
              | "name"
              | "nameEn"
              | "socr"
              | "cladrCode"
              | "okatoCode"
              | "active"
              | "createdAt"
              | "updatedAt"
            >
          >
        >
      >;
    }
  >;
};

export type GetGrVersionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetGrVersionsQuery = { __typename?: "Query" } & {
  GlobalRatingGetter?: Maybe<
    { __typename?: "GlobalRatingGetter" } & {
      getVersions?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "GlobalRatingVersion";
            } & FragmentGlobalRatingVersionForTableFragment
          >
        >
      >;
    }
  >;
};

export type GetGrRatingsQueryVariables = Exact<{
  RatingsVersionId: Scalars["ID"];
}>;

export type GetGrRatingsQuery = { __typename?: "Query" } & {
  GlobalRatingGetter?: Maybe<
    { __typename?: "GlobalRatingGetter" } & {
      getRatings?: Maybe<
        Array<
          Maybe<
            { __typename?: "GlobalRating" } & FragmentGrRatingForTableFragment
          >
        >
      >;
    }
  >;
};

export type GetRatingDataQuarter1QueryVariables = Exact<{
  DealerId: Scalars["ID"];
  year: Scalars["Int"];
  isFull: Scalars["Boolean"];
}>;

export type GetRatingDataQuarter1Query = { __typename?: "Query" } & {
  GlobalRatingGetter?: Maybe<
    { __typename?: "GlobalRatingGetter" } & {
      getRatingData?: Maybe<
        { __typename?: "GlobalRatingData" } & {
          quarter1?: Maybe<
            Array<
              Maybe<
                {
                  __typename?: "GlobalRating";
                } & FragmentGlobalRatingQuarer1Fragment
              >
            >
          >;
        }
      >;
    }
  >;
};

export type GetRatingDataQuarter2QueryVariables = Exact<{
  DealerId: Scalars["ID"];
  year: Scalars["Int"];
  isFull: Scalars["Boolean"];
}>;

export type GetRatingDataQuarter2Query = { __typename?: "Query" } & {
  GlobalRatingGetter?: Maybe<
    { __typename?: "GlobalRatingGetter" } & {
      getRatingData?: Maybe<
        { __typename?: "GlobalRatingData" } & {
          quarter1?: Maybe<
            Array<
              Maybe<
                {
                  __typename?: "GlobalRating";
                } & FragmentGlobalRatingQuarer2Fragment
              >
            >
          >;
        }
      >;
    }
  >;
};

export type GetRatingDataQuarter3QueryVariables = Exact<{
  DealerId: Scalars["ID"];
  year: Scalars["Int"];
  isFull: Scalars["Boolean"];
}>;

export type GetRatingDataQuarter3Query = { __typename?: "Query" } & {
  GlobalRatingGetter?: Maybe<
    { __typename?: "GlobalRatingGetter" } & {
      getRatingData?: Maybe<
        { __typename?: "GlobalRatingData" } & {
          quarter1?: Maybe<
            Array<
              Maybe<
                {
                  __typename?: "GlobalRating";
                } & FragmentGlobalRatingQuarer3Fragment
              >
            >
          >;
        }
      >;
    }
  >;
};

export type GetRatingDataQueryVariables = Exact<{
  DealerId: Scalars["ID"];
  year: Scalars["Int"];
  isFull: Scalars["Boolean"];
}>;

export type GetRatingDataQuery = { __typename?: "Query" } & {
  GlobalRatingGetter?: Maybe<
    { __typename?: "GlobalRatingGetter" } & {
      getRatingData?: Maybe<
        { __typename?: "GlobalRatingData" } & {
          quarter1?: Maybe<
            Array<
              Maybe<
                {
                  __typename?: "GlobalRating";
                } & FragmentGlobalRatingQuarer1Fragment
              >
            >
          >;
          quarter2?: Maybe<
            Array<
              Maybe<
                {
                  __typename?: "GlobalRating";
                } & FragmentGlobalRatingQuarer2Fragment
              >
            >
          >;
          quarter3?: Maybe<
            Array<
              Maybe<
                {
                  __typename?: "GlobalRating";
                } & FragmentGlobalRatingQuarer3Fragment
              >
            >
          >;
          quarter4?: Maybe<
            Array<
              Maybe<
                {
                  __typename?: "GlobalRating";
                } & FragmentGlobalRatingQuarer4Fragment
              >
            >
          >;
        }
      >;
    }
  >;
};

export type GetGrFullReportsQueryVariables = Exact<{
  DealerId: Scalars["ID"];
  year: Scalars["Int"];
  lang?: Maybe<Scalars["String"]>;
  isFull: Scalars["Boolean"];
}>;

export type GetGrFullReportsQuery = { __typename?: "Query" } & {
  GlobalRatingGetter?: Maybe<
    { __typename?: "GlobalRatingGetter" } & {
      getFullReports?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetGrRatingsListNameQueryVariables = Exact<{
  RatingsVersionId?: Maybe<Scalars["ID"]>;
  RatingsId?: Maybe<Scalars["ID"]>;
  onlyParent: Scalars["Boolean"];
}>;

export type GetGrRatingsListNameQuery = { __typename?: "Query" } & {
  GlobalRatingGetter?: Maybe<
    { __typename?: "GlobalRatingGetter" } & {
      getRatingsListName?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "GlobalRatingName";
            } & FragmentGrRatingsListNameFragment
          >
        >
      >;
    }
  >;
};

export type GetGrRatingsForChartQueryVariables = Exact<{
  DealerId: Scalars["ID"];
  year: Scalars["Int"];
}>;

export type GetGrRatingsForChartQuery = { __typename?: "Query" } & {
  GlobalRatingGetter?: Maybe<
    { __typename?: "GlobalRatingGetter" } & {
      getRatingData?: Maybe<
        { __typename?: "GlobalRatingData" } & {
          quarter1?: Maybe<
            Array<
              Maybe<
                {
                  __typename?: "GlobalRating";
                } & FragmentGrRatingForChartFragment
              >
            >
          >;
          quarter2?: Maybe<
            Array<
              Maybe<
                {
                  __typename?: "GlobalRating";
                } & FragmentGrRatingForChartFragment
              >
            >
          >;
          quarter3?: Maybe<
            Array<
              Maybe<
                {
                  __typename?: "GlobalRating";
                } & FragmentGrRatingForChartFragment
              >
            >
          >;
          quarter4?: Maybe<
            Array<
              Maybe<
                {
                  __typename?: "GlobalRating";
                } & FragmentGrRatingForChartFragment
              >
            >
          >;
        }
      >;
    }
  >;
};

export type GetIndicatorsQueryVariables = Exact<{
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  searchText?: Maybe<Scalars["String"]>;
  searchField?: Maybe<Scalars["String"]>;
  sortField?: Maybe<Scalars["String"]>;
  sortType?: Maybe<Scalars["String"]>;
}>;

export type GetIndicatorsQuery = { __typename?: "Query" } & {
  IndicatorGetter?: Maybe<
    { __typename?: "IndicatorGetter" } & {
      getIndicators?: Maybe<
        { __typename?: "IndicatorList" } & Pick<IndicatorList, "total"> & {
            items?: Maybe<
              Array<
                Maybe<
                  {
                    __typename?: "Indicator";
                  } & FragmentIndicatorForTableFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetIndicatorsForSelectQueryVariables = Exact<{
  page?: Maybe<Scalars["Int"]>;
  searchText?: Maybe<Scalars["String"]>;
  searchField?: Maybe<Scalars["String"]>;
}>;

export type GetIndicatorsForSelectQuery = { __typename?: "Query" } & {
  IndicatorGetter?: Maybe<
    { __typename?: "IndicatorGetter" } & {
      getIndicators?: Maybe<
        { __typename?: "IndicatorList" } & {
          items?: Maybe<
            Array<
              Maybe<
                {
                  __typename?: "Indicator";
                } & FragmentIndicatorForSelectFragment
              >
            >
          >;
        }
      >;
    }
  >;
};

export type GetIndicatorQueryVariables = Exact<{
  id: Scalars["ID"];
}>;

export type GetIndicatorQuery = { __typename?: "Query" } & {
  IndicatorGetter?: Maybe<
    { __typename?: "IndicatorGetter" } & {
      getIndicator?: Maybe<
        { __typename?: "Indicator" } & FragmentIndicatorFragment
      >;
    }
  >;
};

export type GetUploadValuesListQueryVariables = Exact<{
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  searchText?: Maybe<Scalars["String"]>;
  searchField?: Maybe<Scalars["String"]>;
  sortField?: Maybe<Scalars["String"]>;
  sortType?: Maybe<Scalars["String"]>;
}>;

export type GetUploadValuesListQuery = { __typename?: "Query" } & {
  IndicatorGetter?: Maybe<
    { __typename?: "IndicatorGetter" } & {
      getUploadValuesList?: Maybe<
        { __typename?: "UploadValuesList" } & Pick<
          UploadValuesList,
          "total"
        > & {
            items?: Maybe<
              Array<
                Maybe<
                  {
                    __typename?: "UploadList";
                  } & FragmentUploadListForTableFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetUploadLogByIdQueryVariables = Exact<{
  id: Scalars["ID"];
}>;

export type GetUploadLogByIdQuery = { __typename?: "Query" } & {
  IndicatorGetter?: Maybe<
    { __typename?: "IndicatorGetter" } & {
      getUploadLogById?: Maybe<
        { __typename?: "UploadList" } & FragmentUploadListForTableFragment
      >;
    }
  >;
};

export type DownloadIndicatorsValueQueryVariables = Exact<{
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  IndicatorIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  year?: Maybe<Scalars["Int"]>;
  dateBegin?: Maybe<Scalars["DateTime"]>;
  dateEnd?: Maybe<Scalars["DateTime"]>;
}>;

export type DownloadIndicatorsValueQuery = { __typename?: "Query" } & {
  IndicatorGetter?: Maybe<
    { __typename?: "IndicatorGetter" } & {
      downloadIndicatorsValue?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetIndicatorReportsQueryVariables = Exact<{
  GroupId: Scalars["ID"];
  sortField?: Maybe<Scalars["String"]>;
  sortType?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
}>;

export type GetIndicatorReportsQuery = { __typename?: "Query" } & {
  IndicatorGroupReportGetter?: Maybe<
    { __typename?: "IndicatorGroupReportGetter" } & {
      getIndicatorReports?: Maybe<
        { __typename?: "IndicatorReportList" } & Pick<
          IndicatorReportList,
          "total"
        > & {
            items?: Maybe<
              Array<
                Maybe<
                  {
                    __typename?: "IndicatorReport";
                  } & FragmentGetIndicatorReportsFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetIndicatorReportQueryVariables = Exact<{
  ReportId: Scalars["ID"];
}>;

export type GetIndicatorReportQuery = { __typename?: "Query" } & {
  IndicatorGroupReportGetter?: Maybe<
    { __typename?: "IndicatorGroupReportGetter" } & {
      getIndicatorReport?: Maybe<
        { __typename?: "IndicatorReport" } & FragmentGetIndicatorReportsFragment
      >;
    }
  >;
};

export type GetIndicatorReportToViewQueryVariables = Exact<{
  ReportId: Scalars["ID"];
  group?: Maybe<TypeGroupDealerIndicatorValues>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  RegMenIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  HoldingIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  Country?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  quarter?: Maybe<Scalars["Int"]>;
  year?: Maybe<Scalars["Int"]>;
  dateBegin?: Maybe<Scalars["DateTime"]>;
  dateEnd?: Maybe<Scalars["DateTime"]>;
  lang?: Maybe<Scalars["String"]>;
  isFull?: Maybe<Scalars["Boolean"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
}>;

export type GetIndicatorReportToViewQuery = { __typename?: "Query" } & {
  IndicatorGroupReportGetter?: Maybe<
    { __typename?: "IndicatorGroupReportGetter" } & {
      getDealerIndicatorValuesReport?: Maybe<
        { __typename?: "DealerIndicatorValuesReport" } & Pick<
          DealerIndicatorValuesReport,
          "total"
        > & {
            items?: Maybe<
              Array<
                Maybe<
                  {
                    __typename?: "DealerIndicatorValues";
                  } & FragmentIndicatorReportToViewFragment
                >
              >
            >;
            IndicatorReport?: Maybe<
              {
                __typename?: "IndicatorReport";
              } & FragmentGetIndicatorReportsFragment
            >;
            RegMen?: Maybe<
              Array<
                Maybe<
                  {
                    __typename?: "RegMenInfo";
                  } & FragmentDealerRegManInfoFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetIndicatorReportHashQueryVariables = Exact<{
  ReportId: Scalars["ID"];
  group?: Maybe<TypeGroupDealerIndicatorValues>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  HoldingIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  RegMenIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  Country?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  quarter?: Maybe<Scalars["Int"]>;
  year?: Maybe<Scalars["Int"]>;
  dateBegin?: Maybe<Scalars["DateTime"]>;
  dateEnd?: Maybe<Scalars["DateTime"]>;
  lang?: Maybe<Scalars["String"]>;
  isFull?: Maybe<Scalars["Boolean"]>;
}>;

export type GetIndicatorReportHashQuery = { __typename?: "Query" } & {
  IndicatorGroupReportGetter?: Maybe<
    { __typename?: "IndicatorGroupReportGetter" } & {
      getDealerIndicatorValuesTableHash?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetIndicatorGroupsQueryVariables = Exact<{
  sortField?: Maybe<Scalars["String"]>;
  sortType?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
}>;

export type GetIndicatorGroupsQuery = { __typename?: "Query" } & {
  IndicatorGroupReportGetter?: Maybe<
    { __typename?: "IndicatorGroupReportGetter" } & {
      getIndicatorGroups?: Maybe<
        { __typename?: "IndicatorGroupList" } & Pick<
          IndicatorGroupList,
          "total"
        > & {
            items?: Maybe<
              Array<
                Maybe<
                  {
                    __typename?: "IndicatorGroup";
                  } & FragmentIndicatorGroupsItemsFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetIndicatorGroupByIdQueryVariables = Exact<{
  GroupId: Scalars["ID"];
}>;

export type GetIndicatorGroupByIdQuery = { __typename?: "Query" } & {
  IndicatorGroupReportGetter?: Maybe<
    { __typename?: "IndicatorGroupReportGetter" } & {
      getIndicatorGroup?: Maybe<
        { __typename?: "IndicatorGroup" } & FragmentIndicatorGroupsItemsFragment
      >;
    }
  >;
};

export type GetLogsQueryVariables = Exact<{
  UserId?: Maybe<Scalars["ID"]>;
  event?: Maybe<Scalars["String"]>;
  dateEnd?: Maybe<Scalars["DateTime"]>;
  dateBegin?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
}>;

export type GetLogsQuery = { __typename?: "Query" } & {
  LogGetter?: Maybe<
    { __typename?: "LogGetter" } & {
      getLogs?: Maybe<
        { __typename?: "LogList" } & Pick<LogList, "total"> & {
            items?: Maybe<
              Array<
                Maybe<
                  { __typename?: "Log" } & Pick<
                    Log,
                    "id" | "description" | "event" | "createdAt"
                  > & {
                      User?: Maybe<
                        { __typename?: "Profile" } & FragmentProfileFragment
                      >;
                      data?: Maybe<
                        | ({ __typename?: "logForDealer" } & Pick<
                            LogForDealer,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "DealerData";
                                } & FragmentDealerForLogsFragment
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "DealerData";
                                } & FragmentDealerForLogsFragment
                              >;
                            })
                        | { __typename?: "logForEditStaffEducationGroup" }
                        | { __typename?: "logForImportDealerPhotos" }
                        | { __typename?: "logForImportDealerCheckLists" }
                        | ({ __typename?: "logForEditValueStaff" } & Pick<
                            LogForEditValueStaff,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                { __typename?: "IndicatorValue" } & Pick<
                                  IndicatorValue,
                                  | "doubleValue"
                                  | "stringValue"
                                  | "DealerId"
                                  | "IndicatorId"
                                  | "createdAt"
                                > & {
                                    Indicator?: Maybe<
                                      {
                                        __typename?: "Indicator";
                                      } & FragmentIndicatorForLogsFragment
                                    >;
                                  }
                              >;
                            })
                        | ({ __typename?: "logForEditStaff" } & Pick<
                            LogForEditStaff,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "EmployeeExpectation";
                                } & FragmentStaffForLogsFragment
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "EmployeeExpectation";
                                } & FragmentStaffForLogsFragment
                              >;
                            })
                        | ({ __typename?: "logAddDealerToUser" } & Pick<
                            LogAddDealerToUser,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                { __typename?: "DealerAndUser" } & Pick<
                                  DealerAndUser,
                                  "UserId" | "DealerId"
                                >
                              >;
                              prevValue?: Maybe<
                                { __typename?: "DealerAndUser" } & Pick<
                                  DealerAndUser,
                                  "UserId" | "DealerId"
                                >
                              >;
                            })
                        | ({ __typename?: "logForEditGRVersion" } & Pick<
                            LogForEditGrVersion,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                { __typename?: "GlobalRatingVersion" } & Pick<
                                  GlobalRatingVersion,
                                  | "quarter"
                                  | "year"
                                  | "dateBegin"
                                  | "IndicatorId"
                                >
                              >;
                              prevValue?: Maybe<
                                { __typename?: "GlobalRatingVersion" } & Pick<
                                  GlobalRatingVersion,
                                  | "quarter"
                                  | "year"
                                  | "dateBegin"
                                  | "IndicatorId"
                                >
                              >;
                            })
                        | ({ __typename?: "logForEditGRRow" } & Pick<
                            LogForEditGrRow,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "GlobalRating";
                                } & FragmentGrRatingForLogsFragment
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "GlobalRating";
                                } & FragmentGrRatingForLogsFragment
                              >;
                            })
                        | ({ __typename?: "logForEditIndicator" } & Pick<
                            LogForEditIndicator,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "Indicator";
                                } & FragmentIndicatorForLogsFragment
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "Indicator";
                                } & FragmentIndicatorForLogsFragment
                              >;
                            })
                        | ({ __typename?: "logForEditQVersion" } & Pick<
                            LogForEditQVersion,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "QuartilesRatingVersion";
                                } & FragmentQDataForLogsFragment
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "QuartilesRatingVersion";
                                } & FragmentQDataForLogsFragment
                              >;
                            })
                        | ({ __typename?: "logForEditQRow" } & Pick<
                            LogForEditQRow,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "QuartilesRating";
                                } & FragmentQRatingForEditorLogsFragment
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "QuartilesRating";
                                } & FragmentQRatingForEditorLogsFragment
                              >;
                            })
                        | ({ __typename?: "logForEditUser" } & Pick<
                            LogForEditUser,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "Profile";
                                } & FragmentProfileForLogsFragment
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "Profile";
                                } & FragmentProfileForLogsFragment
                              >;
                            })
                        | ({ __typename?: "logForEditFile" } & Pick<
                            LogForEditFile,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                { __typename?: "File" } & Pick<
                                  File,
                                  "mimeType" | "name" | "createdAt"
                                > & {
                                    User?: Maybe<
                                      {
                                        __typename?: "Profile";
                                      } & FragmentProfileForLogsFragment
                                    >;
                                  }
                              >;
                              prevValue?: Maybe<
                                { __typename?: "File" } & Pick<
                                  File,
                                  "mimeType" | "name" | "createdAt"
                                > & {
                                    User?: Maybe<
                                      {
                                        __typename?: "Profile";
                                      } & FragmentProfileForLogsFragment
                                    >;
                                  }
                              >;
                            })
                        | ({ __typename?: "logForDeleteFile" } & Pick<
                            LogForDeleteFile,
                            "event"
                          > & {
                              prevValue?: Maybe<
                                { __typename?: "aboutDelete" } & Pick<
                                  AboutDelete,
                                  | "FileId"
                                  | "FileName"
                                  | "catalog"
                                  | "UserId"
                                  | "date"
                                >
                              >;
                            })
                        | ({ __typename?: "logDefault" } & Pick<
                            LogDefault,
                            "event"
                          >)
                        | ({ __typename?: "logForUploadFileToCatalog" } & Pick<
                            LogForUploadFileToCatalog,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                { __typename?: "aboutUpload" } & Pick<
                                  AboutUpload,
                                  | "fileName"
                                  | "catalog"
                                  | "UserId"
                                  | "uploadDate"
                                > & {
                                    Dealer?: Maybe<
                                      { __typename?: "DealerData" } & Pick<
                                        DealerData,
                                        "DealerName"
                                      >
                                    >;
                                  }
                              >;
                            })
                        | ({ __typename?: "logForEditEmployee" } & Pick<
                            LogForEditEmployee,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "EmployeeLog";
                                } & FragmentEmployeeLogFragment
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "EmployeeLog";
                                } & FragmentEmployeeLogFragment
                              >;
                            })
                        | ({ __typename?: "logForEditEmployeePosition" } & Pick<
                            LogForEditEmployeePosition,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "EmployeePositionLog";
                                } & FragmentEmployeePositionLogFragment
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "EmployeePositionLog";
                                } & FragmentEmployeePositionLogFragment
                              >;
                            })
                        | ({ __typename?: "logForCreateAnnouncement" } & Pick<
                            LogForCreateAnnouncement,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "AnnouncementLog";
                                } & FragmentAnnouncementForLogsFragment
                              >;
                            })
                        | ({ __typename?: "logForEditAnnouncement" } & Pick<
                            LogForEditAnnouncement,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "AnnouncementLog";
                                } & FragmentAnnouncementForLogsFragment
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "AnnouncementLog";
                                } & FragmentAnnouncementForLogsFragment
                              >;
                            })
                        | ({ __typename?: "logForViolation" } & Pick<
                            LogForViolation,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                { __typename?: "Violation" } & Pick<
                                  Violation,
                                  | "id"
                                  | "DealerId"
                                  | "ViolationTypesId"
                                  | "DocId"
                                  | "DocNum"
                                  | "DocDate"
                                  | "description"
                                  | "fixDeadline"
                                  | "punishment"
                                  | "status"
                                  | "reportedBy"
                                  | "responsibleChecker"
                                  | "fixDateAt"
                                  | "createdAt"
                                >
                              >;
                              prevValue?: Maybe<
                                { __typename?: "Violation" } & Pick<
                                  Violation,
                                  | "id"
                                  | "DealerId"
                                  | "ViolationTypesId"
                                  | "DocId"
                                  | "DocNum"
                                  | "DocDate"
                                  | "description"
                                  | "fixDeadline"
                                  | "punishment"
                                  | "status"
                                  | "reportedBy"
                                  | "responsibleChecker"
                                  | "fixDateAt"
                                  | "createdAt"
                                >
                              >;
                            })
                        | ({ __typename?: "logForAccountingPeriod" } & Pick<
                            LogForAccountingPeriod,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                { __typename?: "ReportPeriod" } & Pick<
                                  ReportPeriod,
                                  | "id"
                                  | "Year"
                                  | "Quarter"
                                  | "lastDate"
                                  | "reportDate"
                                  | "createdAt"
                                >
                              >;
                              prevValue?: Maybe<
                                { __typename?: "ReportPeriod" } & Pick<
                                  ReportPeriod,
                                  | "id"
                                  | "Year"
                                  | "Quarter"
                                  | "lastDate"
                                  | "reportDate"
                                  | "createdAt"
                                >
                              >;
                            })
                        | ({ __typename?: "logForZdNotes" } & Pick<
                            LogForZdNotes,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                { __typename?: "ZdNotesType" } & Pick<
                                  ZdNotesType,
                                  | "Image"
                                  | "Compliance"
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                >
                              >;
                              prevValue?: Maybe<
                                { __typename?: "ZdNotesType" } & Pick<
                                  ZdNotesType,
                                  | "Image"
                                  | "Compliance"
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                >
                              >;
                            })
                        | ({ __typename?: "logForZdPersonal" } & Pick<
                            LogForZdPersonal,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                { __typename?: "ZdPersonalType" } & Pick<
                                  ZdPersonalType,
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "PersonName"
                                  | "Position"
                                  | "PositionStart"
                                  | "StudyCertificateDate"
                                  | "DocName"
                                  | "Image"
                                  | "Compliance"
                                >
                              >;
                              prevValue?: Maybe<
                                { __typename?: "ZdPersonalType" } & Pick<
                                  ZdPersonalType,
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "PersonName"
                                  | "Position"
                                  | "PositionStart"
                                  | "StudyCertificateDate"
                                  | "DocName"
                                  | "Image"
                                  | "Compliance"
                                >
                              >;
                            })
                        | ({ __typename?: "logForZdPlacePosts" } & Pick<
                            LogForZdPlacePosts,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                { __typename?: "ZdPlacePostsType" } & Pick<
                                  ZdPlacePostsType,
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "Total"
                                  | "Compliance"
                                >
                              >;
                              prevValue?: Maybe<
                                { __typename?: "ZdPlacePostsType" } & Pick<
                                  ZdPlacePostsType,
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "Total"
                                  | "Compliance"
                                >
                              >;
                            })
                        | ({ __typename?: "logForZdPlaces" } & Pick<
                            LogForZdPlaces,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                { __typename?: "ZdPlacesType" } & Pick<
                                  ZdPlacesType,
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "Area"
                                  | "PlacesCombine"
                                  | "Compliance"
                                >
                              >;
                              prevValue?: Maybe<
                                { __typename?: "ZdPlacesType" } & Pick<
                                  ZdPlacesType,
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "Area"
                                  | "PlacesCombine"
                                  | "Compliance"
                                >
                              >;
                            })
                        | { __typename?: "logForZdTradePremises" }
                        | ({ __typename?: "logForZdRequiredTools" } & Pick<
                            LogForZdRequiredTools,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "ZdRequiredToolsType";
                                } & FragmentLogForZdRequiredToolsFragment
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "ZdRequiredToolsType";
                                } & FragmentLogForZdRequiredToolsFragment
                              >;
                            })
                        | ({ __typename?: "logForZdServiceZs" } & Pick<
                            LogForZdServiceZs,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                { __typename?: "ZdServicesType" } & Pick<
                                  ZdServicesType,
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "CertificationDate"
                                  | "Fact"
                                  | "FactContract"
                                  | "Compliance"
                                >
                              >;
                              prevValue?: Maybe<
                                { __typename?: "ZdServicesType" } & Pick<
                                  ZdServicesType,
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "CertificationDate"
                                  | "Fact"
                                  | "FactContract"
                                  | "Compliance"
                                >
                              >;
                            })
                        | ({ __typename?: "logForZdToolsInsuranceZs" } & Pick<
                            LogForZdToolsInsuranceZs,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                { __typename?: "ZdToolsInsuranceType" } & Pick<
                                  ZdToolsInsuranceType,
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "Standard"
                                  | "Total"
                                  | "Compliance"
                                >
                              >;
                              prevValue?: Maybe<
                                { __typename?: "ZdToolsInsuranceType" } & Pick<
                                  ZdToolsInsuranceType,
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "Standard"
                                  | "Total"
                                  | "Compliance"
                                >
                              >;
                            })
                        | ({
                            __typename?: "logForZdToolsMetrologicalZs";
                          } & Pick<LogForZdToolsMetrologicalZs, "event"> & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "ZdToolsMetrologicalType";
                                } & Pick<
                                  ZdToolsMetrologicalType,
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "Standard"
                                  | "Total"
                                  | "Compliance"
                                >
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "ZdToolsMetrologicalType";
                                } & Pick<
                                  ZdToolsMetrologicalType,
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "Standard"
                                  | "Total"
                                  | "Compliance"
                                >
                              >;
                            })
                        | ({ __typename?: "logForZdToolsZs" } & Pick<
                            LogForZdToolsZs,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                { __typename?: "ZdToolsType" } & Pick<
                                  ZdToolsType,
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "Model"
                                  | "Country"
                                  | "Year"
                                  | "Note"
                                  | "Total"
                                  | "Compliance"
                                >
                              >;
                              prevValue?: Maybe<
                                { __typename?: "ZdToolsType" } & Pick<
                                  ZdToolsType,
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "Model"
                                  | "Country"
                                  | "Year"
                                  | "Note"
                                  | "Total"
                                  | "Compliance"
                                >
                              >;
                            })
                        | ({ __typename?: "logForZdWarehousesZs" } & Pick<
                            LogForZdWarehousesZs,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                { __typename?: "ZdWarehousesType" } & Pick<
                                  ZdWarehousesType,
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "Area"
                                  | "Combine"
                                  | "Compliance"
                                >
                              >;
                              prevValue?: Maybe<
                                { __typename?: "ZdWarehousesType" } & Pick<
                                  ZdWarehousesType,
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "Area"
                                  | "Combine"
                                  | "Compliance"
                                >
                              >;
                            })
                        | ({
                            __typename?: "logForCreatedEducationCatalog";
                          } & Pick<LogForCreatedEducationCatalog, "event"> & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "CatalogCurriculum";
                                } & FragmentCatalogCurriculumFragment
                              >;
                            })
                        | ({
                            __typename?: "logForDeleteEducationCatalog";
                          } & Pick<LogForDeleteEducationCatalog, "event"> & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "CatalogCurriculum";
                                } & FragmentCatalogCurriculumFragment
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "CatalogCurriculum";
                                } & FragmentCatalogCurriculumFragment
                              >;
                            })
                        | ({
                            __typename?: "logForCreatedEducationCourse";
                          } & Pick<LogForCreatedEducationCourse, "event"> & {
                              nextValue?: Maybe<
                                { __typename?: "CourseCurriculum" } & Pick<
                                  CourseCurriculum,
                                  | "id"
                                  | "name"
                                  | "code"
                                  | "codeIS"
                                  | "certificateValidityPeriod"
                                  | "LevelId"
                                  | "createdAt"
                                  | "updatedAt"
                                  | "InstanceId"
                                  | "ActualFrom"
                                  | "ActualTo"
                                > & {
                                    statusCreatedCourse: CourseCurriculum["status"];
                                  } & {
                                    Level?: Maybe<
                                      { __typename?: "LevelCurriculum" } & Pick<
                                        LevelCurriculum,
                                        "id" | "name"
                                      >
                                    >;
                                  }
                              >;
                            })
                        | ({ __typename?: "logForEditEducationCourse" } & Pick<
                            LogForEditEducationCourse,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "CourseCurriculum";
                                } & FragmentCourseCurriculumFragment
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "CourseCurriculum";
                                } & FragmentCourseCurriculumFragment
                              >;
                            })
                        | ({
                            __typename?: "logForDeleteEducationCourse";
                          } & Pick<LogForDeleteEducationCourse, "event"> & {
                              nextValue?: Maybe<
                                { __typename?: "CourseCurriculum" } & Pick<
                                  CourseCurriculum,
                                  | "id"
                                  | "name"
                                  | "code"
                                  | "codeIS"
                                  | "certificateValidityPeriod"
                                  | "LevelId"
                                  | "createdAt"
                                  | "updatedAt"
                                  | "InstanceId"
                                  | "ActualFrom"
                                  | "ActualTo"
                                > & {
                                    statusDeleteEducationCourse: CourseCurriculum["status"];
                                  } & {
                                    Level?: Maybe<
                                      { __typename?: "LevelCurriculum" } & Pick<
                                        LevelCurriculum,
                                        "id" | "name"
                                      >
                                    >;
                                  }
                              >;
                              prevValue?: Maybe<
                                { __typename?: "CourseCurriculum" } & Pick<
                                  CourseCurriculum,
                                  | "id"
                                  | "name"
                                  | "code"
                                  | "codeIS"
                                  | "certificateValidityPeriod"
                                  | "LevelId"
                                  | "createdAt"
                                  | "updatedAt"
                                  | "InstanceId"
                                  | "ActualFrom"
                                  | "ActualTo"
                                > & {
                                    statusDeleteEducationCourse: CourseCurriculum["status"];
                                  } & {
                                    Level?: Maybe<
                                      { __typename?: "LevelCurriculum" } & Pick<
                                        LevelCurriculum,
                                        "id" | "name"
                                      >
                                    >;
                                  }
                              >;
                            })
                        | ({
                            __typename?: "logForCreatedEducationLevel";
                          } & Pick<LogForCreatedEducationLevel, "event"> & {
                              nextValue?: Maybe<
                                { __typename?: "LevelCurriculum" } & Pick<
                                  LevelCurriculum,
                                  | "id"
                                  | "name"
                                  | "dateActiveStatus"
                                  | "dateInactiveStatus"
                                  | "createdAt"
                                  | "updatedAt"
                                  | "sequenceNumber"
                                  | "GroupId"
                                  | "InstanceId"
                                  | "ActualFrom"
                                  | "ActualTo"
                                > & {
                                    statusCreatedEducationLevel: LevelCurriculum["status"];
                                  } & {
                                    Group?: Maybe<
                                      { __typename?: "GroupCurriculum" } & Pick<
                                        GroupCurriculum,
                                        "id" | "name"
                                      >
                                    >;
                                  }
                              >;
                            })
                        | ({ __typename?: "logForEditEducationLevel" } & Pick<
                            LogForEditEducationLevel,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                { __typename?: "LevelCurriculum" } & Pick<
                                  LevelCurriculum,
                                  | "id"
                                  | "name"
                                  | "dateActiveStatus"
                                  | "dateInactiveStatus"
                                  | "createdAt"
                                  | "updatedAt"
                                  | "sequenceNumber"
                                  | "GroupId"
                                  | "InstanceId"
                                  | "ActualFrom"
                                  | "ActualTo"
                                > & {
                                    statusEditEducationLevel: LevelCurriculum["status"];
                                  } & {
                                    Group?: Maybe<
                                      { __typename?: "GroupCurriculum" } & Pick<
                                        GroupCurriculum,
                                        "id" | "name"
                                      >
                                    >;
                                  }
                              >;
                              prevValue?: Maybe<
                                { __typename?: "LevelCurriculum" } & Pick<
                                  LevelCurriculum,
                                  | "id"
                                  | "name"
                                  | "dateActiveStatus"
                                  | "dateInactiveStatus"
                                  | "createdAt"
                                  | "updatedAt"
                                  | "sequenceNumber"
                                  | "GroupId"
                                  | "InstanceId"
                                  | "ActualFrom"
                                  | "ActualTo"
                                > & {
                                    statusEditEducationLevel: LevelCurriculum["status"];
                                  } & {
                                    Group?: Maybe<
                                      { __typename?: "GroupCurriculum" } & Pick<
                                        GroupCurriculum,
                                        "id" | "name"
                                      >
                                    >;
                                  }
                              >;
                            })
                        | ({ __typename?: "logForDeleteEducationLevel" } & Pick<
                            LogForDeleteEducationLevel,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                { __typename?: "LevelCurriculum" } & Pick<
                                  LevelCurriculum,
                                  | "id"
                                  | "name"
                                  | "dateActiveStatus"
                                  | "dateInactiveStatus"
                                  | "createdAt"
                                  | "updatedAt"
                                  | "sequenceNumber"
                                  | "GroupId"
                                  | "InstanceId"
                                  | "ActualFrom"
                                  | "ActualTo"
                                > & {
                                    statusDeleteEducationLevel: LevelCurriculum["status"];
                                  } & {
                                    Group?: Maybe<
                                      { __typename?: "GroupCurriculum" } & Pick<
                                        GroupCurriculum,
                                        "id" | "name"
                                      >
                                    >;
                                  }
                              >;
                              prevValue?: Maybe<
                                { __typename?: "LevelCurriculum" } & Pick<
                                  LevelCurriculum,
                                  | "id"
                                  | "name"
                                  | "dateActiveStatus"
                                  | "dateInactiveStatus"
                                  | "createdAt"
                                  | "updatedAt"
                                  | "sequenceNumber"
                                  | "GroupId"
                                  | "InstanceId"
                                  | "ActualFrom"
                                  | "ActualTo"
                                > & {
                                    statusDeleteEducationLevel: LevelCurriculum["status"];
                                  } & {
                                    Group?: Maybe<
                                      { __typename?: "GroupCurriculum" } & Pick<
                                        GroupCurriculum,
                                        "id" | "name"
                                      >
                                    >;
                                  }
                              >;
                            })
                        | ({
                            __typename?: "logForCreatedEducationGroup";
                          } & Pick<LogForCreatedEducationGroup, "event"> & {
                              nextValue?: Maybe<
                                { __typename?: "GroupCurriculum" } & Pick<
                                  GroupCurriculum,
                                  | "id"
                                  | "name"
                                  | "dateActiveStatus"
                                  | "dateInactiveStatus"
                                  | "createdAt"
                                  | "updatedAt"
                                  | "sequenceNumber"
                                  | "InstanceId"
                                  | "ActualFrom"
                                  | "ActualTo"
                                > & {
                                    statusCreatedEducationGroup: GroupCurriculum["status"];
                                  }
                              >;
                            })
                        | ({ __typename?: "logForEditEducationGroup" } & Pick<
                            LogForEditEducationGroup,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                { __typename?: "GroupCurriculum" } & Pick<
                                  GroupCurriculum,
                                  | "id"
                                  | "name"
                                  | "dateActiveStatus"
                                  | "dateInactiveStatus"
                                  | "createdAt"
                                  | "updatedAt"
                                  | "sequenceNumber"
                                  | "InstanceId"
                                  | "ActualFrom"
                                  | "ActualTo"
                                > & {
                                    statusEditEducationGroup: GroupCurriculum["status"];
                                  }
                              >;
                              prevValue?: Maybe<
                                { __typename?: "GroupCurriculum" } & Pick<
                                  GroupCurriculum,
                                  | "id"
                                  | "name"
                                  | "dateActiveStatus"
                                  | "dateInactiveStatus"
                                  | "createdAt"
                                  | "updatedAt"
                                  | "sequenceNumber"
                                  | "InstanceId"
                                  | "ActualFrom"
                                  | "ActualTo"
                                > & {
                                    statusEditEducationGroup: GroupCurriculum["status"];
                                  }
                              >;
                            })
                        | ({ __typename?: "logForDeleteEducationGroup" } & Pick<
                            LogForDeleteEducationGroup,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                { __typename?: "GroupCurriculum" } & Pick<
                                  GroupCurriculum,
                                  | "id"
                                  | "name"
                                  | "dateActiveStatus"
                                  | "dateInactiveStatus"
                                  | "createdAt"
                                  | "updatedAt"
                                  | "sequenceNumber"
                                  | "InstanceId"
                                  | "ActualFrom"
                                  | "ActualTo"
                                > & {
                                    statusDeleteEducationGroup: GroupCurriculum["status"];
                                  }
                              >;
                              prevValue?: Maybe<
                                { __typename?: "GroupCurriculum" } & Pick<
                                  GroupCurriculum,
                                  | "id"
                                  | "name"
                                  | "dateActiveStatus"
                                  | "dateInactiveStatus"
                                  | "createdAt"
                                  | "updatedAt"
                                  | "sequenceNumber"
                                  | "InstanceId"
                                  | "ActualFrom"
                                  | "ActualTo"
                                > & {
                                    statusDeleteEducationGroup: GroupCurriculum["status"];
                                  }
                              >;
                            })
                        | ({
                            __typename?: "logForCreatedEducationProgram";
                          } & Pick<LogForCreatedEducationProgram, "event"> & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "CurriculumStudyPrograms";
                                } & Pick<
                                  CurriculumStudyPrograms,
                                  | "id"
                                  | "PositionGroupId"
                                  | "LevelId"
                                  | "CourseId"
                                  | "dateActiveStatus"
                                  | "dateInactiveStatus"
                                  | "ActualFrom"
                                  | "ActualTo"
                                > & {
                                    statusCreatedEducationProgram: CurriculumStudyPrograms["status"];
                                  } & {
                                    Positions?: Maybe<
                                      Array<
                                        Maybe<
                                          { __typename?: "Position" } & Pick<
                                            Position,
                                            "id" | "name"
                                          >
                                        >
                                      >
                                    >;
                                    Level?: Maybe<
                                      { __typename?: "LevelCurriculum" } & Pick<
                                        LevelCurriculum,
                                        "id" | "name"
                                      >
                                    >;
                                    Course?: Maybe<
                                      {
                                        __typename?: "CourseCurriculum";
                                      } & Pick<CourseCurriculum, "id" | "name">
                                    >;
                                  }
                              >;
                            })
                        | ({
                            __typename?: "logForDeleteEducationProgram";
                          } & Pick<LogForDeleteEducationProgram, "event"> & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "CurriculumStudyPrograms";
                                } & Pick<
                                  CurriculumStudyPrograms,
                                  | "id"
                                  | "PositionGroupId"
                                  | "LevelId"
                                  | "CourseId"
                                  | "dateActiveStatus"
                                  | "dateInactiveStatus"
                                  | "ActualFrom"
                                  | "ActualTo"
                                > & {
                                    statusDeleteEducationProgram: CurriculumStudyPrograms["status"];
                                  } & {
                                    Positions?: Maybe<
                                      Array<
                                        Maybe<
                                          { __typename?: "Position" } & Pick<
                                            Position,
                                            "id" | "name"
                                          >
                                        >
                                      >
                                    >;
                                    Level?: Maybe<
                                      { __typename?: "LevelCurriculum" } & Pick<
                                        LevelCurriculum,
                                        "id" | "name"
                                      >
                                    >;
                                    Course?: Maybe<
                                      {
                                        __typename?: "CourseCurriculum";
                                      } & Pick<CourseCurriculum, "id" | "name">
                                    >;
                                  }
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "CurriculumStudyPrograms";
                                } & Pick<
                                  CurriculumStudyPrograms,
                                  | "id"
                                  | "PositionGroupId"
                                  | "LevelId"
                                  | "CourseId"
                                  | "dateActiveStatus"
                                  | "dateInactiveStatus"
                                  | "ActualFrom"
                                  | "ActualTo"
                                > & {
                                    statusDeleteEducationProgram: CurriculumStudyPrograms["status"];
                                  } & {
                                    Positions?: Maybe<
                                      Array<
                                        Maybe<
                                          { __typename?: "Position" } & Pick<
                                            Position,
                                            "id" | "name"
                                          >
                                        >
                                      >
                                    >;
                                    Level?: Maybe<
                                      { __typename?: "LevelCurriculum" } & Pick<
                                        LevelCurriculum,
                                        "id" | "name"
                                      >
                                    >;
                                    Course?: Maybe<
                                      {
                                        __typename?: "CourseCurriculum";
                                      } & Pick<CourseCurriculum, "id" | "name">
                                    >;
                                  }
                              >;
                            })
                        | ({ __typename?: "logForEditEducationProgram" } & Pick<
                            LogForEditEducationProgram,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "CurriculumStudyPrograms";
                                } & FragmentCurriculumStudyProgramsFragment
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "CurriculumStudyPrograms";
                                } & FragmentCurriculumStudyProgramsFragment
                              >;
                            })
                        | {
                            __typename?: "logForDeletePositionGroupEducationProgram";
                          }
                        | {
                            __typename?: "logForAddPositionGroupEducationProgram";
                          }
                        | ({ __typename?: "logForCreatedPosition" } & Pick<
                            LogForCreatedPosition,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                { __typename?: "Position" } & Pick<
                                  Position,
                                  | "id"
                                  | "code"
                                  | "name"
                                  | "DirectionId"
                                  | "createdAt"
                                  | "updatedAt"
                                  | "RequiredEmail"
                                  | "InstanceId"
                                  | "ActualFrom"
                                > & {
                                    statusCreatedPosition: Position["status"];
                                  } & {
                                    Direction?: Maybe<
                                      {
                                        __typename?: "PositionDirections";
                                      } & Pick<
                                        PositionDirections,
                                        "id" | "name"
                                      >
                                    >;
                                  }
                              >;
                            })
                        | ({ __typename?: "logForEditPosition" } & Pick<
                            LogForEditPosition,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                { __typename?: "Position" } & Pick<
                                  Position,
                                  | "id"
                                  | "code"
                                  | "name"
                                  | "nameEn"
                                  | "DirectionId"
                                  | "ExpectationId"
                                  | "createdAt"
                                  | "updatedAt"
                                  | "RequiredEmail"
                                  | "InstanceId"
                                  | "ActualFrom"
                                  | "ActualTo"
                                > & {
                                    statusEditPosition: Position["status"];
                                  } & {
                                    Direction?: Maybe<
                                      {
                                        __typename?: "PositionDirections";
                                      } & Pick<
                                        PositionDirections,
                                        "id" | "name"
                                      >
                                    >;
                                  }
                              >;
                              prevValue?: Maybe<
                                { __typename?: "Position" } & Pick<
                                  Position,
                                  | "id"
                                  | "code"
                                  | "name"
                                  | "nameEn"
                                  | "DirectionId"
                                  | "ExpectationId"
                                  | "createdAt"
                                  | "updatedAt"
                                  | "RequiredEmail"
                                  | "InstanceId"
                                  | "ActualFrom"
                                  | "ActualTo"
                                > & {
                                    statusEditPosition: Position["status"];
                                  } & {
                                    Direction?: Maybe<
                                      {
                                        __typename?: "PositionDirections";
                                      } & Pick<
                                        PositionDirections,
                                        "id" | "name"
                                      >
                                    >;
                                  }
                              >;
                            })
                        | ({ __typename?: "logForDeletePosition" } & Pick<
                            LogForDeletePosition,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                { __typename?: "Position" } & Pick<
                                  Position,
                                  | "id"
                                  | "code"
                                  | "name"
                                  | "nameEn"
                                  | "DirectionId"
                                  | "ExpectationId"
                                  | "createdAt"
                                  | "updatedAt"
                                  | "RequiredEmail"
                                  | "InstanceId"
                                  | "ActualFrom"
                                  | "ActualTo"
                                > & {
                                    statusDeletePosition: Position["status"];
                                  } & {
                                    Direction?: Maybe<
                                      {
                                        __typename?: "PositionDirections";
                                      } & Pick<
                                        PositionDirections,
                                        "id" | "name"
                                      >
                                    >;
                                  }
                              >;
                              prevValue?: Maybe<
                                { __typename?: "Position" } & Pick<
                                  Position,
                                  | "id"
                                  | "code"
                                  | "name"
                                  | "nameEn"
                                  | "DirectionId"
                                  | "ExpectationId"
                                  | "createdAt"
                                  | "updatedAt"
                                  | "RequiredEmail"
                                  | "InstanceId"
                                  | "ActualFrom"
                                  | "ActualTo"
                                > & {
                                    statusDeletePosition: Position["status"];
                                  } & {
                                    Direction?: Maybe<
                                      {
                                        __typename?: "PositionDirections";
                                      } & Pick<
                                        PositionDirections,
                                        "id" | "name"
                                      >
                                    >;
                                  }
                              >;
                            })
                        | ({
                            __typename?: "logForEditPositionDirection";
                          } & Pick<LogForEditPositionDirection, "event"> & {
                              nextValue?: Maybe<
                                { __typename?: "PositionDirections" } & Pick<
                                  PositionDirections,
                                  | "id"
                                  | "InstanceId"
                                  | "ActualFrom"
                                  | "ActualTo"
                                  | "name"
                                  | "createdAt"
                                  | "updatedAt"
                                > & {
                                    statusEditPositionDirection: PositionDirections["status"];
                                    roleEditPositionDirection: PositionDirections["role"];
                                  }
                              >;
                              prevValue?: Maybe<
                                { __typename?: "PositionDirections" } & Pick<
                                  PositionDirections,
                                  | "id"
                                  | "InstanceId"
                                  | "ActualFrom"
                                  | "ActualTo"
                                  | "name"
                                  | "createdAt"
                                  | "updatedAt"
                                > & {
                                    statusEditPositionDirection: PositionDirections["status"];
                                    roleEditPositionDirection: PositionDirections["role"];
                                  }
                              >;
                            })
                        | ({
                            __typename?: "logForDeletePositionDirection";
                          } & Pick<LogForDeletePositionDirection, "event"> & {
                              nextValue?: Maybe<
                                { __typename?: "PositionDirections" } & Pick<
                                  PositionDirections,
                                  | "id"
                                  | "InstanceId"
                                  | "ActualFrom"
                                  | "ActualTo"
                                  | "name"
                                  | "createdAt"
                                  | "updatedAt"
                                > & {
                                    statusDeletePositionDirection: PositionDirections["status"];
                                    roleDeletePositionDirection: PositionDirections["role"];
                                  }
                              >;
                              prevValue?: Maybe<
                                { __typename?: "PositionDirections" } & Pick<
                                  PositionDirections,
                                  | "id"
                                  | "InstanceId"
                                  | "ActualFrom"
                                  | "ActualTo"
                                  | "name"
                                  | "createdAt"
                                  | "updatedAt"
                                > & {
                                    statusDeletePositionDirection: PositionDirections["status"];
                                    roleDeletePositionDirection: PositionDirections["role"];
                                  }
                              >;
                            })
                        | ({
                            __typename?: "logForCreatedPositionDirection";
                          } & Pick<LogForCreatedPositionDirection, "event"> & {
                              nextValue?: Maybe<
                                { __typename?: "PositionDirections" } & Pick<
                                  PositionDirections,
                                  | "id"
                                  | "InstanceId"
                                  | "ActualFrom"
                                  | "ActualTo"
                                  | "name"
                                  | "createdAt"
                                  | "updatedAt"
                                > & {
                                    statusCreatedPositionDirection: PositionDirections["status"];
                                    roleCreatedPositionDirection: PositionDirections["role"];
                                  }
                              >;
                            })
                        | ({ __typename?: "logForZdDefinitionServices" } & Pick<
                            LogForZdDefinitionServices,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "ZdServicesDefinitionType";
                                } & Pick<
                                  ZdServicesDefinitionType,
                                  | "Code"
                                  | "FactIndicator"
                                  | "CertificationDateIndicator"
                                  | "FactContractIndicator"
                                  | "ComplianceIndicator"
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "sort"
                                  | "isListed"
                                  | "forUUID"
                                  | "ActualTo"
                                  | "ActualFrom"
                                >
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "ZdServicesDefinitionType";
                                } & Pick<
                                  ZdServicesDefinitionType,
                                  | "Code"
                                  | "FactIndicator"
                                  | "CertificationDateIndicator"
                                  | "FactContractIndicator"
                                  | "ComplianceIndicator"
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "sort"
                                  | "isListed"
                                  | "forUUID"
                                  | "ActualTo"
                                  | "ActualFrom"
                                >
                              >;
                            })
                        | ({ __typename?: "logForZdDefinitionPlaces" } & Pick<
                            LogForZdDefinitionPlaces,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "ZdPlacesDefinitionType";
                                } & Pick<
                                  ZdPlacesDefinitionType,
                                  | "Number"
                                  | "AreaIndicator"
                                  | "PlacesCombineIndicator"
                                  | "ComplianceIndicator"
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "sort"
                                  | "isListed"
                                  | "forUUID"
                                  | "ActualTo"
                                  | "ActualFrom"
                                >
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "ZdPlacesDefinitionType";
                                } & Pick<
                                  ZdPlacesDefinitionType,
                                  | "Number"
                                  | "AreaIndicator"
                                  | "PlacesCombineIndicator"
                                  | "ComplianceIndicator"
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "sort"
                                  | "isListed"
                                  | "forUUID"
                                  | "ActualTo"
                                  | "ActualFrom"
                                >
                              >;
                            })
                        | ({
                            __typename?: "logForZdDefinitionPlacePosts";
                          } & Pick<LogForZdDefinitionPlacePosts, "event"> & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "ZdPlacePostsDefinitionType";
                                } & Pick<
                                  ZdPlacePostsDefinitionType,
                                  | "ZD_PlacesId"
                                  | "TotalIndicator"
                                  | "ComplianceIndicator"
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "sort"
                                  | "isListed"
                                  | "forUUID"
                                  | "ActualTo"
                                  | "ActualFrom"
                                >
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "ZdPlacePostsDefinitionType";
                                } & Pick<
                                  ZdPlacePostsDefinitionType,
                                  | "ZD_PlacesId"
                                  | "TotalIndicator"
                                  | "ComplianceIndicator"
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "sort"
                                  | "isListed"
                                  | "forUUID"
                                  | "ActualTo"
                                  | "ActualFrom"
                                >
                              >;
                            })
                        | ({
                            __typename?: "logForZdDefinitionWarehouses";
                          } & Pick<LogForZdDefinitionWarehouses, "event"> & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "ZdWarehousesDefinitionType";
                                } & Pick<
                                  ZdWarehousesDefinitionType,
                                  | "Number"
                                  | "AreaIndicator"
                                  | "CombineIndicator"
                                  | "ComplianceIndicator"
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "sort"
                                  | "isListed"
                                  | "forUUID"
                                  | "ActualTo"
                                  | "ActualFrom"
                                >
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "ZdWarehousesDefinitionType";
                                } & Pick<
                                  ZdWarehousesDefinitionType,
                                  | "Number"
                                  | "AreaIndicator"
                                  | "CombineIndicator"
                                  | "ComplianceIndicator"
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "sort"
                                  | "isListed"
                                  | "forUUID"
                                  | "ActualTo"
                                  | "ActualFrom"
                                >
                              >;
                            })
                        | ({ __typename?: "logForZdDefinitionTools" } & Pick<
                            LogForZdDefinitionTools,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                { __typename?: "ZdToolsDefinitionType" } & Pick<
                                  ZdToolsDefinitionType,
                                  | "Number"
                                  | "GroupOne"
                                  | "GroupTwo"
                                  | "TotalIndicator"
                                  | "ModelIndicator"
                                  | "CountryIndicator"
                                  | "YearIndicator"
                                  | "NoteIndicator"
                                  | "ComplianceIndicator"
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "sort"
                                  | "isListed"
                                  | "forUUID"
                                  | "ActualTo"
                                  | "ActualFrom"
                                >
                              >;
                              prevValue?: Maybe<
                                { __typename?: "ZdToolsDefinitionType" } & Pick<
                                  ZdToolsDefinitionType,
                                  | "Number"
                                  | "GroupOne"
                                  | "GroupTwo"
                                  | "TotalIndicator"
                                  | "ModelIndicator"
                                  | "CountryIndicator"
                                  | "YearIndicator"
                                  | "NoteIndicator"
                                  | "ComplianceIndicator"
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "sort"
                                  | "isListed"
                                  | "forUUID"
                                  | "ActualTo"
                                  | "ActualFrom"
                                >
                              >;
                            })
                        | ({
                            __typename?: "logForZdDefinitionRequiredTools";
                          } & Pick<LogForZdDefinitionRequiredTools, "event"> & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "ZdRequiredToolsDefinitionType";
                                } & Pick<
                                  ZdRequiredToolsDefinitionType,
                                  | "Number"
                                  | "ModelIndicator"
                                  | "TotalIndicator"
                                  | "CheckedDateIndicator"
                                  | "ComplianceIndicator"
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "sort"
                                  | "isListed"
                                  | "forUUID"
                                  | "ActualTo"
                                  | "ActualFrom"
                                >
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "ZdRequiredToolsDefinitionType";
                                } & Pick<
                                  ZdRequiredToolsDefinitionType,
                                  | "Number"
                                  | "ModelIndicator"
                                  | "TotalIndicator"
                                  | "CheckedDateIndicator"
                                  | "ComplianceIndicator"
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "sort"
                                  | "isListed"
                                  | "forUUID"
                                  | "ActualTo"
                                  | "ActualFrom"
                                >
                              >;
                            })
                        | ({ __typename?: "logForZdDefinitionPersonal" } & Pick<
                            LogForZdDefinitionPersonal,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "ZdPersonalDefinitionType";
                                } & Pick<
                                  ZdPersonalDefinitionType,
                                  | "Number"
                                  | "DocName"
                                  | "ComplianceIndicator"
                                  | "InstanceIdIndicator"
                                  | "commentIndicator"
                                  | "planReportIdIndicator"
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "sort"
                                  | "isListed"
                                  | "forUUID"
                                  | "ActualTo"
                                  | "ActualFrom"
                                >
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "ZdPersonalDefinitionType";
                                } & Pick<
                                  ZdPersonalDefinitionType,
                                  | "Number"
                                  | "DocName"
                                  | "ComplianceIndicator"
                                  | "InstanceIdIndicator"
                                  | "commentIndicator"
                                  | "planReportIdIndicator"
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "sort"
                                  | "isListed"
                                  | "forUUID"
                                  | "ActualTo"
                                  | "ActualFrom"
                                >
                              >;
                            })
                        | ({
                            __typename?: "logForZdDefinitionToolsInsurance";
                          } & Pick<
                            LogForZdDefinitionToolsInsurance,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "ZdToolsInsuranceDefinitionType";
                                } & Pick<
                                  ZdToolsInsuranceDefinitionType,
                                  | "Number"
                                  | "GroupOne"
                                  | "GroupTwo"
                                  | "NumberList"
                                  | "NumberDetail"
                                  | "TotalIndicator"
                                  | "ComplianceIndicator"
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "sort"
                                  | "isListed"
                                  | "forUUID"
                                  | "ActualTo"
                                  | "ActualFrom"
                                >
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "ZdToolsInsuranceDefinitionType";
                                } & Pick<
                                  ZdToolsInsuranceDefinitionType,
                                  | "Number"
                                  | "GroupOne"
                                  | "GroupTwo"
                                  | "NumberList"
                                  | "NumberDetail"
                                  | "TotalIndicator"
                                  | "ComplianceIndicator"
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "sort"
                                  | "isListed"
                                  | "forUUID"
                                  | "ActualTo"
                                  | "ActualFrom"
                                >
                              >;
                            })
                        | ({
                            __typename?: "logForZdDefinitionToolsMetrological";
                          } & Pick<
                            LogForZdDefinitionToolsMetrological,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "ZdToolsMetrologicalDefinitionType";
                                } & Pick<
                                  ZdToolsMetrologicalDefinitionType,
                                  | "Number"
                                  | "TotalIndicator"
                                  | "ComplianceIndicator"
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "sort"
                                  | "isListed"
                                  | "forUUID"
                                  | "ActualTo"
                                  | "ActualFrom"
                                >
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "ZdToolsMetrologicalDefinitionType";
                                } & Pick<
                                  ZdToolsMetrologicalDefinitionType,
                                  | "Number"
                                  | "TotalIndicator"
                                  | "ComplianceIndicator"
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "sort"
                                  | "isListed"
                                  | "forUUID"
                                  | "ActualTo"
                                  | "ActualFrom"
                                >
                              >;
                            })
                        | ({ __typename?: "logForZdDefinitionNotes" } & Pick<
                            LogForZdDefinitionNotes,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                { __typename?: "ZdNotesDefinitionType" } & Pick<
                                  ZdNotesDefinitionType,
                                  | "Number"
                                  | "ImageIndicator"
                                  | "ComplianceIndicator"
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "sort"
                                  | "isListed"
                                  | "forUUID"
                                  | "ActualTo"
                                  | "ActualFrom"
                                >
                              >;
                              prevValue?: Maybe<
                                { __typename?: "ZdNotesDefinitionType" } & Pick<
                                  ZdNotesDefinitionType,
                                  | "Number"
                                  | "ImageIndicator"
                                  | "ComplianceIndicator"
                                  | "UUID"
                                  | "tableIndex"
                                  | "name"
                                  | "nameEn"
                                  | "sort"
                                  | "isListed"
                                  | "forUUID"
                                  | "ActualTo"
                                  | "ActualFrom"
                                >
                              >;
                            })
                        | { __typename?: "logForZdDefinitionTradePremises" }
                        | ({ __typename?: "logForCreateDocument" } & Pick<
                            LogForCreateDocument,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "DocumentLog";
                                } & FragmentDocumentForLogsFragment
                              >;
                            })
                        | ({ __typename?: "logForEditDocument" } & Pick<
                            LogForEditDocument,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "DocumentLog";
                                } & FragmentDocumentForLogsFragment
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "DocumentLog";
                                } & FragmentDocumentForLogsFragment
                              >;
                            })
                        | ({ __typename?: "logForCreateSection" } & Pick<
                            LogForCreateSection,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "SectionLog";
                                } & FragmentSectionForLogsFragment
                              >;
                            })
                        | ({ __typename?: "logForEditSection" } & Pick<
                            LogForEditSection,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "SectionLog";
                                } & FragmentSectionForLogsFragment
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "SectionLog";
                                } & FragmentSectionForLogsFragment
                              >;
                            })
                        | ({ __typename?: "logForDeleteSection" } & Pick<
                            LogForDeleteSection,
                            "event"
                          > & {
                              prevValue?: Maybe<
                                {
                                  __typename?: "SectionLog";
                                } & FragmentSectionForLogsFragment
                              >;
                            })
                        | ({ __typename?: "logForCreateCamera" } & Pick<
                            LogForCreateCamera,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "CameraLog";
                                } & FragmentCameraForLogsFragment
                              >;
                            })
                        | ({ __typename?: "logForEditCamera" } & Pick<
                            LogForEditCamera,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "CameraLog";
                                } & FragmentCameraForLogsFragment
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "CameraLog";
                                } & FragmentCameraForLogsFragment
                              >;
                            })
                        | ({ __typename?: "logForDeleteCamera" } & Pick<
                            LogForDeleteCamera,
                            "event"
                          > & {
                              prevValue?: Maybe<
                                {
                                  __typename?: "CameraLog";
                                } & FragmentCameraForLogsFragment
                              >;
                            })
                        | ({ __typename?: "logForCreateCameraCheck" } & Pick<
                            LogForCreateCameraCheck,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "CameraCheckLog";
                                } & FragmentCameraCheckForLogsFragment
                              >;
                            })
                        | ({ __typename?: "logForEditCameraCheck" } & Pick<
                            LogForEditCameraCheck,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "CameraCheckLog";
                                } & FragmentCameraCheckForLogsFragment
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "CameraCheckLog";
                                } & FragmentCameraCheckForLogsFragment
                              >;
                            })
                        | ({ __typename?: "logForCreateCameraZone" } & Pick<
                            LogForCreateCameraZone,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "CameraZoneLog";
                                } & FragmentCameraZoneForLogsFragment
                              >;
                            })
                        | ({ __typename?: "logForEditCameraZone" } & Pick<
                            LogForEditCameraZone,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "CameraZoneLog";
                                } & FragmentCameraZoneForLogsFragment
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "CameraZoneLog";
                                } & FragmentCameraZoneForLogsFragment
                              >;
                            })
                        | ({ __typename?: "logForDeleteCameraZone" } & Pick<
                            LogForDeleteCameraZone,
                            "event"
                          > & {
                              prevValue?: Maybe<
                                {
                                  __typename?: "CameraZoneLog";
                                } & FragmentCameraZoneForLogsFragment
                              >;
                            })
                        | ({ __typename?: "logForAddIndicatorGroup" } & Pick<
                            LogForAddIndicatorGroup,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "IndicatorGroup";
                                } & FragmentIndicatorGroupForLogsFragment
                              >;
                            })
                        | ({ __typename?: "logForEditIndicatorGroup" } & Pick<
                            LogForEditIndicatorGroup,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "IndicatorGroup";
                                } & FragmentIndicatorGroupForLogsFragment
                              >;
                              prevValue?: Maybe<
                                {
                                  __typename?: "IndicatorGroup";
                                } & FragmentIndicatorGroupForLogsFragment
                              >;
                            })
                        | ({ __typename?: "logForAddIndicatorReport" } & Pick<
                            LogForAddIndicatorReport,
                            "event"
                          > & {
                              nextValue?: Maybe<
                                {
                                  __typename?: "IndicatorReport";
                                } & FragmentIndicatorReportForLogsFragment
                              >;
                            })
                        | ({
                            __typename?: "logForChangeIndicatorReport";
                          } & Pick<LogForChangeIndicatorReport, "event"> & {
                              prevValue?: Maybe<
                                {
                                  __typename?: "IndicatorReport";
                                } & FragmentIndicatorReportForLogsFragment
                              >;
                              nextValue?: Maybe<
                                {
                                  __typename?: "IndicatorReport";
                                } & FragmentIndicatorReportForLogsFragment
                              >;
                            })
                        | ({ __typename?: "logForAddIndicatorToReport" } & Pick<
                            LogForAddIndicatorToReport,
                            "event"
                          >)
                        | ({
                            __typename?: "logForDeleteIndicatorToReport";
                          } & Pick<LogForDeleteIndicatorToReport, "event"> & {
                              prevValue?: Maybe<
                                {
                                  __typename?: "IndicatorAndReport";
                                } & FragmentIndicatorAndReportFragment
                              >;
                              nextValue?: Maybe<
                                {
                                  __typename?: "IndicatorAndReport";
                                } & FragmentIndicatorAndReportFragment
                              >;
                            })
                      >;
                    }
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetEmailLogsListQueryVariables = Exact<{
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  dealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  userIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  name?: Maybe<Scalars["String"]>;
  fromDate?: Maybe<Scalars["DateTime"]>;
  toDate?: Maybe<Scalars["DateTime"]>;
}>;

export type GetEmailLogsListQuery = { __typename?: "Query" } & {
  LogGetter?: Maybe<
    { __typename: "LogGetter" } & {
      getEmailLogs?: Maybe<
        { __typename: "EmailLogListList" } & Pick<EmailLogListList, "total"> & {
            items: Array<
              Maybe<
                { __typename: "EmailLogListItem" } & {
                  users?: Maybe<
                    Array<
                      Maybe<{ __typename: "Profile" } & UsersFragmentFragment>
                    >
                  >;
                  dealers?: Maybe<
                    Array<
                      Maybe<{ __typename: "Dealer" } & DealersFragmentFragment>
                    >
                  >;
                } & FragmentEmailLogFragment
              >
            >;
          }
      >;
    }
  >;
};

export type DealersFragmentFragment = { __typename?: "Dealer" } & Pick<
  Dealer,
  "DealerNameEn" | "DealerName" | "IS_Id"
>;

export type UsersFragmentFragment = { __typename?: "Profile" } & Pick<
  Profile,
  "id" | "fullname" | "fullnameEn" | "email"
>;

export type GetEmailLogsReportQueryVariables = Exact<{
  fromDate: Scalars["DateTime"];
  toDate: Scalars["DateTime"];
  dealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  userIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  name?: Maybe<Scalars["String"]>;
}>;

export type GetEmailLogsReportQuery = { __typename?: "Query" } & {
  LogGetter?: Maybe<
    { __typename?: "LogGetter" } & {
      getEmailLogsReport?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetLogsEmailNamesQueryVariables = Exact<{ [key: string]: never }>;

export type GetLogsEmailNamesQuery = { __typename?: "Query" } & {
  LogGetter?: Maybe<
    { __typename?: "LogGetter" } & Pick<LogGetter, "getEmailNames">
  >;
};

export type GetAllNotesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllNotesQuery = { __typename?: "Query" } & {
  NotesGetter?: Maybe<
    { __typename?: "NotesGetter" } & {
      getAll?: Maybe<
        Array<
          Maybe<{ __typename?: "NotesIndicatorTypes" } & FragmentNotesFragment>
        >
      >;
    }
  >;
};

export type GetNotesStatusesQueryVariables = Exact<{
  UUID?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
}>;

export type GetNotesStatusesQuery = { __typename?: "Query" } & {
  NotesGetter?: Maybe<
    { __typename?: "NotesGetter" } & {
      getDealerStatuses?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "NotesDealerStatuses";
            } & FragmentNotesDealerStatusesFragment
          >
        >
      >;
    }
  >;
};

export type GetValuesNotesQueryVariables = Exact<{
  DealerId: Scalars["ID"];
  dateUpTo?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
}>;

export type GetValuesNotesQuery = { __typename?: "Query" } & {
  NotesGetter?: Maybe<
    { __typename?: "NotesGetter" } & {
      getValues?: Maybe<
        { __typename?: "NotesValues" } & Pick<NotesValues, "total"> & {
            items?: Maybe<
              Array<
                Maybe<
                  {
                    __typename?: "NotesOneValuesItem";
                  } & FragmentNotesValuesFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetAllPersonalQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllPersonalQuery = { __typename?: "Query" } & {
  PersonalGetter?: Maybe<
    { __typename?: "PersonalGetter" } & {
      getAll?: Maybe<
        Array<
          Maybe<
            { __typename?: "PersonalIndicatorTypes" } & FragmentPersonalFragment
          >
        >
      >;
    }
  >;
};

export type GetPersonalStatusesQueryVariables = Exact<{
  UUID?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
}>;

export type GetPersonalStatusesQuery = { __typename?: "Query" } & {
  PersonalGetter?: Maybe<
    { __typename?: "PersonalGetter" } & {
      getDealerStatuses?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "PersonalDealerStatuses";
            } & FragmentPersonalDealerStatusesFragment
          >
        >
      >;
    }
  >;
};

export type GetValuesPersonalQueryVariables = Exact<{
  DealerId: Scalars["ID"];
  dateUpTo?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
}>;

export type GetValuesPersonalQuery = { __typename?: "Query" } & {
  PersonalGetter?: Maybe<
    { __typename?: "PersonalGetter" } & {
      getValues?: Maybe<
        { __typename?: "PersonalValues" } & Pick<PersonalValues, "total"> & {
            items?: Maybe<
              Array<
                Maybe<
                  {
                    __typename?: "PersonalOneValuesItem";
                  } & FragmentPersonalValuesFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetGroupsPersonalQueryVariables = Exact<{
  groupType?: Maybe<ZdGroupType>;
}>;

export type GetGroupsPersonalQuery = { __typename?: "Query" } & {
  PersonalGetter?: Maybe<
    { __typename?: "PersonalGetter" } & Pick<PersonalGetter, "getGroups">
  >;
};

export type GetPhotoGallerySectionListQueryVariables = Exact<{
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
}>;

export type GetPhotoGallerySectionListQuery = { __typename?: "Query" } & {
  PhotoGallerySectionGetter?: Maybe<
    { __typename?: "PhotoGallerySectionGetter" } & {
      getPhotoGallerySectionList: {
        __typename?: "PhotoGallerySectionList";
      } & Pick<PhotoGallerySectionList, "pages" | "total"> & {
          items: Array<
            Maybe<
              { __typename?: "PhotoGallerySection" } & Pick<
                PhotoGallerySection,
                "id" | "title" | "description" | "createdAt"
              >
            >
          >;
        };
    }
  >;
};

export type GetPhotoGallerySectionQueryVariables = Exact<{
  getPhotoGallerySectionId: Scalars["ID"];
}>;

export type GetPhotoGallerySectionQuery = { __typename?: "Query" } & {
  PhotoGallerySectionGetter?: Maybe<
    { __typename?: "PhotoGallerySectionGetter" } & {
      getPhotoGallerySection: { __typename?: "PhotoGallerySection" } & Pick<
        PhotoGallerySection,
        "id" | "title" | "description" | "createdAt"
      >;
    }
  >;
};

export type GetAllPlacePostsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllPlacePostsQuery = { __typename?: "Query" } & {
  PlacePostsGetter?: Maybe<
    { __typename?: "PlacePostsGetter" } & {
      getAll?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "PlacePostsIndicatorTypes";
            } & FragmentPlacePostsFragment
          >
        >
      >;
    }
  >;
};

export type GetPlacePostsStatusesQueryVariables = Exact<{
  UUID?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
}>;

export type GetPlacePostsStatusesQuery = { __typename?: "Query" } & {
  PlacePostsGetter?: Maybe<
    { __typename?: "PlacePostsGetter" } & {
      getDealerStatuses?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "PlacePostsDealerStatuses";
            } & FragmentPlacePostsDealerStatusesFragment
          >
        >
      >;
    }
  >;
};

export type GetValuesPlacePostsQueryVariables = Exact<{
  DealerId: Scalars["ID"];
  dateUpTo?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
}>;

export type GetValuesPlacePostsQuery = { __typename?: "Query" } & {
  PlacePostsGetter?: Maybe<
    { __typename?: "PlacePostsGetter" } & {
      getValues?: Maybe<
        { __typename?: "PlacePostsValues" } & Pick<
          PlacePostsValues,
          "total"
        > & {
            items?: Maybe<
              Array<
                Maybe<
                  {
                    __typename?: "PlacePostsOneValuesItem";
                  } & FragmentPlacePostsValuesFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetAllPlacesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllPlacesQuery = { __typename?: "Query" } & {
  PlacesGetter?: Maybe<
    { __typename?: "PlacesGetter" } & {
      getAll?: Maybe<
        Array<
          Maybe<
            { __typename?: "PlacesIndicatorTypes" } & FragmentPlacesFragment
          >
        >
      >;
    }
  >;
};

export type GetValuesPlacesQueryVariables = Exact<{
  DealerId: Scalars["ID"];
  dateUpTo?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
  sortBy?: Maybe<PlacesSortBy>;
}>;

export type GetValuesPlacesQuery = { __typename?: "Query" } & {
  PlacesGetter?: Maybe<
    { __typename?: "PlacesGetter" } & {
      getValues?: Maybe<
        { __typename?: "PlacesValues" } & Pick<PlacesValues, "total"> & {
            items?: Maybe<
              Array<
                Maybe<
                  {
                    __typename?: "PlacesOneValuesItem";
                  } & FragmentPlacesValuesFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetPlacesStatusesQueryVariables = Exact<{
  UUID?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
}>;

export type GetPlacesStatusesQuery = { __typename?: "Query" } & {
  PlacesGetter?: Maybe<
    { __typename?: "PlacesGetter" } & {
      getDealerStatuses?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "PlacesDealerStatuses";
            } & FragmentPlacesDealerStatusesFragment
          >
        >
      >;
    }
  >;
};

export type GetPlanReportQueryVariables = Exact<{
  DealerId?: Maybe<Scalars["ID"]>;
  PlanReportId?: Maybe<Scalars["ID"]>;
  ZD_UUID?: Maybe<Scalars["String"]>;
  tableIndex?: Maybe<ZdTableIndex>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
}>;

export type GetPlanReportQuery = { __typename?: "Query" } & {
  PlanReportGetter?: Maybe<
    { __typename?: "PlanReportGetter" } & {
      getPlanReportRows?: Maybe<
        { __typename?: "getPlanReportRowsReturn" } & Pick<
          GetPlanReportRowsReturn,
          "total"
        > & {
            items?: Maybe<
              Array<
                Maybe<
                  {
                    __typename?: "PlanReportRow";
                  } & FragmentPlanReportRowFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetPositionsGuideQueryVariables = Exact<{
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["ID"]>;
  code?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  nameEn?: Maybe<Scalars["String"]>;
  searchText?: Maybe<Scalars["String"]>;
  DirectionId?: Maybe<Scalars["ID"]>;
  status?: Maybe<PositionStatus>;
  createdAtTo?: Maybe<Scalars["DateTime"]>;
  updatedAtTo?: Maybe<Scalars["DateTime"]>;
  createdAtFrom?: Maybe<Scalars["DateTime"]>;
  updatedAtFrom?: Maybe<Scalars["DateTime"]>;
  order?: Maybe<SortType>;
  orderBy?: Maybe<GetPositionsOrderBy>;
  ActualOn?: Maybe<Scalars["DateTime"]>;
}>;

export type GetPositionsGuideQuery = { __typename?: "Query" } & {
  PositionGetter?: Maybe<
    { __typename?: "PositionGetter" } & {
      getPositions?: Maybe<
        { __typename?: "getPositionListNew" } & Pick<
          GetPositionListNew,
          "total"
        > &
          ListPositionsFragment
      >;
    }
  >;
};

export type GetDirectionsQueryVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  ids?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  ActualOn?: Maybe<Scalars["DateTime"]>;
  status?: Maybe<PositionDirectionsStatus>;
}>;

export type GetDirectionsQuery = { __typename?: "Query" } & {
  PositionGetter?: Maybe<
    { __typename?: "PositionGetter" } & {
      getDirections?: Maybe<
        { __typename?: "getDirections" } & Pick<GetDirections, "total"> &
          ListDirectionsFragment
      >;
    }
  >;
};

export type GetPositionDirectionRolesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetPositionDirectionRolesQuery = { __typename?: "Query" } & {
  PositionGetter?: Maybe<
    { __typename?: "PositionGetter" } & Pick<
      PositionGetter,
      "getPositionDirectionRoles"
    >
  >;
};

export type GetPositionByIdQueryVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type GetPositionByIdQuery = { __typename?: "Query" } & {
  PositionGetter?: Maybe<
    { __typename?: "PositionGetter" } & {
      getPositionById?: Maybe<
        { __typename?: "Position" } & FragmentGetPositionByIdFragment
      >;
    }
  >;
};

export type GetPersonalInformationQueryVariables = Exact<{
  name?: Maybe<Scalars["String"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
}>;

export type GetPersonalInformationQuery = { __typename?: "Query" } & {
  PositionGetter?: Maybe<
    { __typename?: "PositionGetter" } & {
      getPersonalInformation?: Maybe<
        { __typename?: "getPersonalInformation" } & Pick<
          GetPersonalInformation,
          "total"
        > & {
            items?: Maybe<
              Array<
                Maybe<
                  {
                    __typename?: "PersonalInformation";
                  } & FragmentPersonalInformationFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetInformationSystemsQueryVariables = Exact<{
  name?: Maybe<Scalars["String"]>;
  page?: Maybe<Scalars["Int"]>;
  positions?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  count?: Maybe<Scalars["Int"]>;
}>;

export type GetInformationSystemsQuery = { __typename?: "Query" } & {
  PositionGetter?: Maybe<
    { __typename?: "PositionGetter" } & {
      getInformationSystems?: Maybe<
        { __typename?: "getInformationSystems" } & Pick<
          GetInformationSystems,
          "total"
        > & {
            items?: Maybe<
              Array<
                Maybe<
                  {
                    __typename?: "InformationSystem";
                  } & FragmentInformationSystemsFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetInformationSystemByIdQueryVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type GetInformationSystemByIdQuery = { __typename?: "Query" } & {
  PositionGetter?: Maybe<
    { __typename?: "PositionGetter" } & {
      getInformationSystemById?: Maybe<
        {
          __typename?: "InformationSystem";
        } & FragmentInformationSystemsFragment
      >;
    }
  >;
};

export type GetPersonalInformationByIdQueryVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type GetPersonalInformationByIdQuery = { __typename?: "Query" } & {
  PositionGetter?: Maybe<
    { __typename?: "PositionGetter" } & {
      getPersonalInformationById?: Maybe<
        {
          __typename?: "PersonalInformation";
        } & FragmentPersonalInformationFragment
      >;
    }
  >;
};

export type GetTemplateConsentsDataProcessingQueryVariables = Exact<{
  positionIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetTemplateConsentsDataProcessingQuery = {
  __typename?: "Query";
} & {
  PositionGetter?: Maybe<
    { __typename?: "PositionGetter" } & {
      getTemplateConsentsDataProcessing?: Maybe<
        { __typename?: "getTemplateConsentsDataProcessing" } & {
          items?: Maybe<
            Array<
              Maybe<
                {
                  __typename?: "PositionConsents";
                } & FragmentGetTemplateConsentsDataProcessingFragment
              >
            >
          >;
        }
      >;
    }
  >;
};

export type GetQVersionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetQVersionsQuery = { __typename?: "Query" } & {
  QuartilesRatingGetter?: Maybe<
    { __typename?: "QuartilesRatingGetter" } & {
      getVersions?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "QuartilesRatingVersion";
            } & FragmentQuartilesRatingVersionForTableFragment
          >
        >
      >;
    }
  >;
};

export type GetQRatingsQueryVariables = Exact<{
  RatingsVersionId: Scalars["ID"];
}>;

export type GetQRatingsQuery = { __typename?: "Query" } & {
  QuartilesRatingGetter?: Maybe<
    { __typename?: "QuartilesRatingGetter" } & {
      getRatings?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "QuartilesRating";
            } & FragmentQRatingForEditorTableFragment
          >
        >
      >;
    }
  >;
};

export type GetQRatingDataQueryVariables = Exact<{
  DealerId: Scalars["ID"];
  date: Scalars["DateTime"];
}>;

export type GetQRatingDataQuery = { __typename?: "Query" } & {
  QuartilesRatingGetter?: Maybe<
    { __typename?: "QuartilesRatingGetter" } & {
      getRatingData?: Maybe<
        { __typename?: "QuartilesRatingVersion" } & {
          Ratings?: Maybe<
            Array<
              Maybe<
                {
                  __typename?: "QuartilesRating";
                } & FragmentQRatingForTableFragment
              >
            >
          >;
        }
      >;
    }
  >;
};

export type GetQDetailingMainIndicatorQueryVariables = Exact<{
  DealerId: Scalars["ID"];
  date: Scalars["DateTime"];
}>;

export type GetQDetailingMainIndicatorQuery = { __typename?: "Query" } & {
  QuartilesRatingGetter?: Maybe<
    { __typename?: "QuartilesRatingGetter" } & {
      getDetailingMainIndicator?: Maybe<
        {
          __typename?: "QuartilesRatingVersion";
        } & FragmentQDataForTableFragment
      >;
    }
  >;
};

export type GetQDataByLineQueryVariables = Exact<{
  DealerId: Scalars["ID"];
  QuartilesRatingId: Scalars["ID"];
  date: Scalars["DateTime"];
}>;

export type GetQDataByLineQuery = { __typename?: "Query" } & {
  QuartilesRatingGetter?: Maybe<
    { __typename?: "QuartilesRatingGetter" } & {
      getRatingDataByLine?: Maybe<
        { __typename?: "QuartilesRating" } & FragmentQRatingForChartFragment
      >;
    }
  >;
};

export type GetQFullReportsQueryVariables = Exact<{
  DealerId: Scalars["ID"];
  date: Scalars["DateTime"];
  lang?: Maybe<Scalars["String"]>;
}>;

export type GetQFullReportsQuery = { __typename?: "Query" } & {
  QuartilesRatingGetter?: Maybe<
    { __typename?: "QuartilesRatingGetter" } & {
      getFullReports?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetQBeautifulReportsQueryVariables = Exact<{
  DealerId: Scalars["ID"];
  date: Scalars["DateTime"];
  lang?: Maybe<Scalars["String"]>;
}>;

export type GetQBeautifulReportsQuery = { __typename?: "Query" } & {
  QuartilesRatingGetter?: Maybe<
    { __typename?: "QuartilesRatingGetter" } & {
      getBeautifulReports?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetQOneRatingReportsQueryVariables = Exact<{
  DealerId: Scalars["ID"];
  QuartilesRatingId: Scalars["ID"];
  date: Scalars["DateTime"];
  lang?: Maybe<Scalars["String"]>;
}>;

export type GetQOneRatingReportsQuery = { __typename?: "Query" } & {
  QuartilesRatingGetter?: Maybe<
    { __typename?: "QuartilesRatingGetter" } & {
      getReports?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetQReportDetailingMainIndicatorQueryVariables = Exact<{
  DealerId: Scalars["ID"];
  date: Scalars["DateTime"];
  lang?: Maybe<Scalars["String"]>;
}>;

export type GetQReportDetailingMainIndicatorQuery = { __typename?: "Query" } & {
  QuartilesRatingGetter?: Maybe<
    { __typename?: "QuartilesRatingGetter" } & {
      getReportDetailingMainIndicator?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetQRatingsListNameQueryVariables = Exact<{
  RatingsVersionId?: Maybe<Scalars["ID"]>;
  RatingsId?: Maybe<Scalars["ID"]>;
  onlyParent: Scalars["Boolean"];
}>;

export type GetQRatingsListNameQuery = { __typename?: "Query" } & {
  QuartilesRatingGetter?: Maybe<
    { __typename?: "QuartilesRatingGetter" } & {
      getRatingsListName?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "QuartilesRatingName";
            } & FragmentRatingsListNameFragment
          >
        >
      >;
    }
  >;
};

export type GetAllowedMonthsForDealerQueryVariables = Exact<{
  dealerId: Scalars["ID"];
}>;

export type GetAllowedMonthsForDealerQuery = { __typename?: "Query" } & {
  QuartilesRatingGetter?: Maybe<
    { __typename?: "QuartilesRatingGetter" } & {
      getAllowedMonthsForDealer?: Maybe<
        { __typename?: "getAllowedMonthsForDealerList" } & {
          items: Array<
            Maybe<
              { __typename?: "QuartilesAvailable" } & Pick<
                QuartilesAvailable,
                "month" | "year"
              >
            >
          >;
        }
      >;
    }
  >;
};

export type GetAllRequiredToolsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllRequiredToolsQuery = { __typename?: "Query" } & {
  RequiredToolsGetter?: Maybe<
    { __typename?: "RequiredToolsGetter" } & {
      getAll?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "RequiredToolsIndicatorTypes";
            } & FragmentRequiredToolsFragment
          >
        >
      >;
    }
  >;
};

export type GetRequiredToolsStatusesQueryVariables = Exact<{
  UUID?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
}>;

export type GetRequiredToolsStatusesQuery = { __typename?: "Query" } & {
  RequiredToolsGetter?: Maybe<
    { __typename?: "RequiredToolsGetter" } & {
      getDealerStatuses?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "RequiredToolsDealerStatuses";
            } & FragmentRequiredToolsDealerStatusesFragment
          >
        >
      >;
    }
  >;
};

export type GetValuesRequiredToolsQueryVariables = Exact<{
  DealerId: Scalars["ID"];
  dateUpTo?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
}>;

export type GetValuesRequiredToolsQuery = { __typename?: "Query" } & {
  RequiredToolsGetter?: Maybe<
    { __typename?: "RequiredToolsGetter" } & {
      getValues?: Maybe<
        { __typename?: "RequiredToolsValues" } & Pick<
          RequiredToolsValues,
          "total"
        > & {
            items?: Maybe<
              Array<
                Maybe<
                  {
                    __typename?: "RequiredToolsOneValuesItem";
                  } & FragmentRequiredToolsValuesFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetReportReturnCarForServiceByMonthQueryVariables = Exact<{
  groupReport: TypeGroupReportSrr;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetReportReturnCarForServiceByMonthQuery = {
  __typename?: "Query";
} & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnCarForServiceByMonth?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetCarForServiceByMonthQueryVariables = Exact<{
  group: TypeGroupReportSrr;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetCarForServiceByMonthQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getCarForServiceByMonth?: Maybe<
        {
          __typename?: "CarForServiceByMonth";
        } & FragmentCarForServiceByMonthFragment
      >;
    }
  >;
};

export type GetReportReturnCarForeignForServiceByMonthQueryVariables = Exact<{
  groupReport: TypeGroupReportSrr;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetReportReturnCarForeignForServiceByMonthQuery = {
  __typename?: "Query";
} & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnCarForeignForServiceByMonth?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetCarForeignForServiceByMonthQueryVariables = Exact<{
  group: TypeGroupReportSrr;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetCarForeignForServiceByMonthQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getCarForeignForServiceByMonth?: Maybe<
        {
          __typename?: "CarForServiceByMonth";
        } & FragmentCarForServiceByMonthFragment
      >;
    }
  >;
};

export type GetReportReturnCarForeignForServiceByMonthByCarModelQueryVariables =
  Exact<{
    groupReport: TypeGroupReportSrr;
    numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
    salePeriod?: Maybe<Scalars["Int"]>;
    monthControl: Scalars["DateTime"];
    typeClient?: Maybe<
      Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
    >;
    FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
    CarModel: Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>;
    City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
    Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
    DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  }>;

export type GetReportReturnCarForeignForServiceByMonthByCarModelQuery = {
  __typename?: "Query";
} & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnCarForeignForServiceByMonthByCarModel?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetCarForeignForServiceByMonthByCarModelQueryVariables = Exact<{
  groupReport: TypeGroupReportSrr;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  CarModel: Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetCarForeignForServiceByMonthByCarModelQuery = {
  __typename?: "Query";
} & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getCarForeignForServiceByMonthByCarModel?: Maybe<
        {
          __typename?: "CarForServiceByMonth";
        } & FragmentCarForServiceByMonthFragment
      >;
    }
  >;
};

export type GetReportReturnCarForServiceByMonthByCarModelRegionQueryVariables =
  Exact<{
    groupReport: TypeGroupReportSrr;
    numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
    salePeriod?: Maybe<Scalars["Int"]>;
    monthControl: Scalars["DateTime"];
    typeClient?: Maybe<
      Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
    >;
    FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
    City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
    Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
    DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
    CarModel?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  }>;

export type GetReportReturnCarForServiceByMonthByCarModelRegionQuery = {
  __typename?: "Query";
} & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnCarForServiceByMonthByCarModelRegion?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetCarForServiceByMonthByCarModelRegionQueryVariables = Exact<{
  groupReport: TypeGroupReportSrr;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  CarModel?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetCarForServiceByMonthByCarModelRegionQuery = {
  __typename?: "Query";
} & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getCarForServiceByMonthByCarModelRegion?: Maybe<
        {
          __typename?: "CarsForServiceByMonthRegion";
        } & FragmentCarsForServiceByMonthRegionFragment
      >;
    }
  >;
};

export type GetReportReturnCarForServiceByPeriodQueryVariables = Exact<{
  groupReport: TypeGroupReportSrr;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
  salePeriodStart: Scalars["DateTime"];
  salePeriodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetReportReturnCarForServiceByPeriodQuery = {
  __typename?: "Query";
} & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnCarForServiceByPeriod?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetCarForServiceByPeriodQueryVariables = Exact<{
  groupReport?: Maybe<TypeGroupReportSrr>;
  group?: Maybe<TypeGroupReportSrr>;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
  salePeriodStart: Scalars["DateTime"];
  salePeriodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetCarForServiceByPeriodQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getCarForServiceByPeriod?: Maybe<
        {
          __typename?: "CarForServiceByMonth";
        } & FragmentCarForServiceByMonthFragment
      >;
    }
  >;
};

export type GetReportReturnCarForeignForServiceByPeriodQueryVariables = Exact<{
  groupReport: TypeGroupReportSrr;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
  salePeriodStart: Scalars["DateTime"];
  salePeriodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetReportReturnCarForeignForServiceByPeriodQuery = {
  __typename?: "Query";
} & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnCarForeignForServiceByPeriod?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetCarForeignForServiceByPeriodQueryVariables = Exact<{
  group: TypeGroupReportSrr;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
  salePeriodStart: Scalars["DateTime"];
  salePeriodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetCarForeignForServiceByPeriodQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getCarForeignForServiceByPeriod?: Maybe<
        {
          __typename?: "CarForServiceByMonth";
        } & FragmentCarForServiceByMonthFragment
      >;
    }
  >;
};

export type GetReportReturnCarForeignForServiceByPeriodByCarModelQueryVariables =
  Exact<{
    groupReport: TypeGroupReportSrr;
    numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
    salePeriodStart: Scalars["DateTime"];
    salePeriodEnd: Scalars["DateTime"];
    typeClient?: Maybe<
      Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
    >;
    CarModel: Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>;
    FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
    City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
    Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
    DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  }>;

export type GetReportReturnCarForeignForServiceByPeriodByCarModelQuery = {
  __typename?: "Query";
} & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnCarForeignForServiceByPeriodByCarModel?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetCarForeignForServiceByPeriodByCarModelQueryVariables = Exact<{
  group: TypeGroupReportSrr;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
  salePeriodStart: Scalars["DateTime"];
  salePeriodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  CarModel: Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetCarForeignForServiceByPeriodByCarModelQuery = {
  __typename?: "Query";
} & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getCarForeignForServiceByPeriodByCarModel?: Maybe<
        {
          __typename?: "CarForServiceByMonth";
        } & FragmentCarForServiceByMonthFragment
      >;
    }
  >;
};

export type GetReportReturnCarForServiceByPeriodConsolidatedQueryVariables =
  Exact<{
    group: TypeGroupReportSrr;
    numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
    salePeriodStart: Scalars["DateTime"];
    salePeriodEnd: Scalars["DateTime"];
    typeClient?: Maybe<
      Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
    >;
    CarModel?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
    FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
    City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
    Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
    DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  }>;

export type GetReportReturnCarForServiceByPeriodConsolidatedQuery = {
  __typename?: "Query";
} & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnCarForServiceByPeriodConsolidated?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetCarForServiceByPeriodConsolidatedQueryVariables = Exact<{
  group: TypeGroupReportSrr;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
  salePeriodStart: Scalars["DateTime"];
  salePeriodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  CarModel?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetCarForServiceByPeriodConsolidatedQuery = {
  __typename?: "Query";
} & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getCarForServiceByPeriodConsolidated?: Maybe<
        {
          __typename?: "CarsForServiceByPeriodConsolidated";
        } & FragmentCarsForServiceByPeriodConsolidatedFragment
      >;
    }
  >;
};

export type GetReportReturnCarForAgoByMonthQueryVariables = Exact<{
  groupReport: TypeGroupReportSrr;
  numberGO?: Maybe<Array<Maybe<TypeGoReportSrr>> | Maybe<TypeGoReportSrr>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  lifetime?: Maybe<Scalars["Int"]>;
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  CarModel: Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetReportReturnCarForAgoByMonthQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnCarForAGOByMonth?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetReturnCarForAgoByMonthQueryVariables = Exact<{
  groupReport: TypeGroupReportSrr;
  numberGO?: Maybe<Array<Maybe<TypeGoReportSrr>> | Maybe<TypeGoReportSrr>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  lifetime?: Maybe<Scalars["Int"]>;
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  CarModel: Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetReturnCarForAgoByMonthQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getCarForAGOByMonth?: Maybe<
        { __typename?: "CarForAGOByMonth" } & FragmentCarForAgoByMonthFragment
      >;
    }
  >;
};

export type GetReportReturnCarForeignForAgoByMonthQueryVariables = Exact<{
  groupReport: TypeGroupReportSrr;
  numberGO?: Maybe<Array<Maybe<TypeGoReportSrr>> | Maybe<TypeGoReportSrr>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  lifetime?: Maybe<Scalars["Int"]>;
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  CarModel: Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetReportReturnCarForeignForAgoByMonthQuery = {
  __typename?: "Query";
} & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnCarForeignForAGOByMonth?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetReturnCarForeignForAgoByMonthQueryVariables = Exact<{
  groupReport: TypeGroupReportSrr;
  numberGO?: Maybe<Array<Maybe<TypeGoReportSrr>> | Maybe<TypeGoReportSrr>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  lifetime?: Maybe<Scalars["Int"]>;
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  CarModel: Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetReturnCarForeignForAgoByMonthQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getCarForeignForAGOByMonth?: Maybe<
        { __typename?: "CarForAGOByMonth" } & FragmentCarForAgoByMonthFragment
      >;
    }
  >;
};

export type GetReportReturnCarServiceDynamicsQueryVariables = Exact<{
  group: TypeGroupReportSrr;
  periodStart: Scalars["DateTime"];
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetReportReturnCarServiceDynamicsQuery = {
  __typename?: "Query";
} & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnCarServiceDynamics?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetCarServiceDynamicsQueryVariables = Exact<{
  group: TypeGroupReportSrr;
  periodStart: Scalars["DateTime"];
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetCarServiceDynamicsQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getCarServiceDynamics?: Maybe<
        {
          __typename?: "CarForServiceDynamics";
        } & FragmentCarForServiceDynamicsFragment
      >;
    }
  >;
};

export type GetReportReturnCarServiceByDealerQueryVariables = Exact<{
  group: TypeGroupReportSrr;
  periodStart: Scalars["DateTime"];
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetReportReturnCarServiceByDealerQuery = {
  __typename?: "Query";
} & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnCarServiceByDealer?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetCarServiceByDealerQueryVariables = Exact<{
  group: TypeGroupReportSrr;
  periodStart: Scalars["DateTime"];
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetCarServiceByDealerQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getCarServiceByDealer?: Maybe<
        {
          __typename?: "CarForServiceByDealer";
        } & FragmentCarForServiceByDealerFragment
      >;
    }
  >;
};

export type GetReportReturnCarAverageDailyMileageByMonthQueryVariables = Exact<{
  groupReport: TypeGroupReportSrr;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetReportReturnCarAverageDailyMileageByMonthQuery = {
  __typename?: "Query";
} & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnCarAverageDailyMileageByMonth?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetCarAverageDailyMileageByMonthQueryVariables = Exact<{
  group: TypeGroupReportSrr;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetCarAverageDailyMileageByMonthQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getCarAverageDailyMileageByMonth?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "CarsForAverageDailyMileageByMonth";
            } & FragmentCarsForAverageDailyMileageByMonthFragment
          >
        >
      >;
    }
  >;
};

export type GetReportReturnClientsWithoutServiceQueryVariables = Exact<{
  group: TypeGroupReportSrr;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetReportReturnClientsWithoutServiceQuery = {
  __typename?: "Query";
} & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnClientsWithoutService?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetClientsWithoutServiceQueryVariables = Exact<{
  group: TypeGroupReportSrr;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetClientsWithoutServiceQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getClientsWithoutService?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "ClientsWithoutService";
            } & FragmentClientsWithoutServiceFragment
          >
        >
      >;
    }
  >;
};

export type GetReportReturnSrr3ByDealerQueryVariables = Exact<{
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
}>;

export type GetReportReturnSrr3ByDealerQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnSRR3ByDealer?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetSrr3ByDealerQueryVariables = Exact<{
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
}>;

export type GetSrr3ByDealerQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getSRR3ByDealer?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "dealerForServiceByMonth";
            } & FragmentdealerForServiceByMonthFragment
          >
        >
      >;
    }
  >;
};

export type GetReportReturnSrr3ByPeriodQueryVariables = Exact<{
  group: TypeGroupReportSrr;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetReportReturnSrr3ByPeriodQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnSRR3ByPeriod?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetSrr3ByPeriodQueryVariables = Exact<{
  group: TypeGroupReportSrr;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetSrr3ByPeriodQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getSRR3ByPeriod?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "CarForSRR3ByPeriod";
            } & FragmentCarForSrr3ByPeriodFragment
          >
        >
      >;
    }
  >;
};

export type GetReportReturnSrr3ForPaymentsQueryVariables = Exact<{
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
}>;

export type GetReportReturnSrr3ForPaymentsQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnSRR3ForPayments?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetSrr3ForPaymentsQueryVariables = Exact<{
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
}>;

export type GetSrr3ForPaymentsQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getSRR3ForPayments?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "dealerForPaymentsByDealer";
            } & FragmentDealerForPaymentsByDealerFragment
          >
        >
      >;
    }
  >;
};

export type GetReportReturnSrr3ByCarQueryVariables = Exact<{
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
}>;

export type GetReportReturnSrr3ByCarQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnSRR3ByCar?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetSrr3ByCarQueryVariables = Exact<{
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
}>;

export type GetSrr3ByCarQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getSRR3ByCar?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "dealerByCarByDealer";
            } & FragmentDealerByCarByDealerFragment
          >
        >
      >;
    }
  >;
};

export type GetReportReturnSrr3ByVinQueryVariables = Exact<{
  dealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
}>;

export type GetReportReturnSrr3ByVinQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnSRR3ByVIN?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetReportReturnSrr5ByVinQueryVariables = Exact<{
  dealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
}>;

export type GetReportReturnSrr5ByVinQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnSRR5ByVIN?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetSrr3ByVinQueryVariables = Exact<{
  dealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
}>;

export type GetSrr3ByVinQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getSRR3ByVIN?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "dealerByCarByVIN";
            } & FragmentDealerByCarByVinFragment
          >
        >
      >;
    }
  >;
};

export type GetSrr5ByVinQueryVariables = Exact<{
  dealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
}>;

export type GetSrr5ByVinQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getSRR5ByVIN?: Maybe<
        Array<
          Maybe<
            { __typename?: "dealerByCarByVIN" } & {
              TO4?: Maybe<
                { __typename?: "TOForVIN" } & Pick<
                  ToForVin,
                  "dateVisit" | "dealerName"
                >
              >;
              TO5?: Maybe<
                { __typename?: "TOForVIN" } & Pick<
                  ToForVin,
                  "dateVisit" | "dealerName"
                >
              >;
            } & FragmentDealerByCarByVinFragment
          >
        >
      >;
    }
  >;
};

export type ReportReturnSrr5ByDealerQueryVariables = Exact<{
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
}>;

export type ReportReturnSrr5ByDealerQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnSRR5ByDealer?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetSrr5ByDealerQueryVariables = Exact<{
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
}>;

export type GetSrr5ByDealerQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getSRR5ByDealer?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "dealerForServiceByMonth";
            } & FragmentdealerForServiceByMonthFragment
          >
        >
      >;
    }
  >;
};

export type GetReportReturnSrr5ByPeriodQueryVariables = Exact<{
  group: TypeGroupReportSrr;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetReportReturnSrr5ByPeriodQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnSRR5ByPeriod?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetSrr5ByPeriodQueryVariables = Exact<{
  group: TypeGroupReportSrr;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetSrr5ByPeriodQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getSRR5ByPeriod?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "CarForSRR5ByPeriod";
            } & FragmentCarForSrr5ByPeriodFragment
          >
        >
      >;
    }
  >;
};

export type GetReportReturnSrr5ForPaymentsQueryVariables = Exact<{
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
}>;

export type GetReportReturnSrr5ForPaymentsQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnSRR5ForPayments?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetSrr5ForPaymentsQueryVariables = Exact<{
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
}>;

export type GetSrr5ForPaymentsQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getSRR5ForPayments?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "dealerForPaymentsByDealer";
            } & FragmentDealerForPaymentsByDealerFragment
          >
        >
      >;
    }
  >;
};

export type GetReportReturnSrr5ByCarQueryVariables = Exact<{
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
}>;

export type GetReportReturnSrr5ByCarQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnSRR5ByCar?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetSrr5ByCarQueryVariables = Exact<{
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
}>;

export type GetSrr5ByCarQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getSRR5ByCar?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "dealerByCarByDealer";
            } & FragmentDealerByCarByDealerFragment
          >
        >
      >;
    }
  >;
};

export type GetReportInviteClientToServiceQueryVariables = Exact<{
  dealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  monthControl?: Maybe<Scalars["DateTime"]>;
  runStart?: Maybe<Scalars["Int"]>;
  runEnd?: Maybe<Scalars["Int"]>;
  method: Scalars["String"];
  numberTO?: Maybe<TypeToReportSrr>;
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
}>;

export type GetReportInviteClientToServiceQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportInviteClientToService?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetInviteClientToServiceQueryVariables = Exact<{
  dealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  monthControl?: Maybe<Scalars["DateTime"]>;
  method: Scalars["String"];
  numberTO?: Maybe<TypeToReportSrr>;
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
}>;

export type GetInviteClientToServiceQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getInviteClientToService?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "inviteClientToService";
            } & FragmentInviteClientToServiceFragment
          >
        >
      >;
    }
  >;
};

export type GetReportReturnCarForServiceGibddByMonthQueryVariables = Exact<{
  groupReport: TypeGroupReportSrr;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetReportReturnCarForServiceGibddByMonthQuery = {
  __typename?: "Query";
} & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnCarForServiceGIBDDByMonth?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetCarForServiceGibddByMonthQueryVariables = Exact<{
  group: TypeGroupReportSrr;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetCarForServiceGibddByMonthQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getCarForServiceGIBDDByMonth?: Maybe<
        {
          __typename?: "CarForServiceByMonth";
        } & FragmentCarForServiceByMonthFragment
      >;
    }
  >;
};

export type GetReportReturnCarForServiceGibddByPeriodQueryVariables = Exact<{
  groupReport: TypeGroupReportSrr;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
  salePeriodStart: Scalars["DateTime"];
  salePeriodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetReportReturnCarForServiceGibddByPeriodQuery = {
  __typename?: "Query";
} & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnCarForServiceGIBDDByPeriod?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetCarForServiceGibddByPeriodQueryVariables = Exact<{
  group: TypeGroupReportSrr;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
  salePeriodStart: Scalars["DateTime"];
  salePeriodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetCarForServiceGibddByPeriodQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getCarForServiceGIBDDByPeriod?: Maybe<
        {
          __typename?: "CarForServiceByMonth";
        } & FragmentCarForServiceByMonthFragment
      >;
    }
  >;
};

export type GetReportReturnCarForeignForServiceGibddByMonthQueryVariables =
  Exact<{
    groupReport: TypeGroupReportSrr;
    numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
    salePeriod?: Maybe<Scalars["Int"]>;
    monthControl: Scalars["DateTime"];
    typeClient?: Maybe<
      Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
    >;
    FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
    City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
    Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
    DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  }>;

export type GetReportReturnCarForeignForServiceGibddByMonthQuery = {
  __typename?: "Query";
} & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnCarForeignForServiceGIBDDByMonth?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetCarForeignForServiceGibddByMonthQueryVariables = Exact<{
  group: TypeGroupReportSrr;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
  salePeriod?: Maybe<Scalars["Int"]>;
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetCarForeignForServiceGibddByMonthQuery = {
  __typename?: "Query";
} & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getCarForeignForServiceGIBDDByMonth?: Maybe<
        {
          __typename?: "CarForServiceByMonth";
        } & FragmentCarForServiceByMonthFragment
      >;
    }
  >;
};

export type GetReportReturnCarForeignForServiceGibddByPeriodQueryVariables =
  Exact<{
    groupReport: TypeGroupReportSrr;
    numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
    salePeriodStart: Scalars["DateTime"];
    salePeriodEnd: Scalars["DateTime"];
    typeClient?: Maybe<
      Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
    >;
    FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
    City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
    Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
    DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  }>;

export type GetReportReturnCarForeignForServiceGibddByPeriodQuery = {
  __typename?: "Query";
} & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnCarForeignForServiceGIBDDByPeriod?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetCarForeignForServiceGibddByPeriodQueryVariables = Exact<{
  group: TypeGroupReportSrr;
  numberTO?: Maybe<Array<Maybe<TypeToReportSrr>> | Maybe<TypeToReportSrr>>;
  salePeriodStart: Scalars["DateTime"];
  salePeriodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetCarForeignForServiceGibddByPeriodQuery = {
  __typename?: "Query";
} & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getCarForeignForServiceGIBDDByPeriod?: Maybe<
        {
          __typename?: "CarForServiceByMonth";
        } & FragmentCarForServiceByMonthFragment
      >;
    }
  >;
};

export type ReportReturnSrr3GibddByDealerQueryVariables = Exact<{
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
}>;

export type ReportReturnSrr3GibddByDealerQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnSRR3GIBDDByDealer?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetSrr3GibddByDealerQueryVariables = Exact<{
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
}>;

export type GetSrr3GibddByDealerQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getSRR3GIBDDByDealer?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "dealerForServiceByMonth";
            } & FragmentdealerForServiceByMonthFragment
          >
        >
      >;
    }
  >;
};

export type ReportReturnSrr3GibddByPeriodQueryVariables = Exact<{
  group: TypeGroupReportSrr;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type ReportReturnSrr3GibddByPeriodQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnSRR3GIBDDByPeriod?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetSrr3GibddByPeriodQueryVariables = Exact<{
  group: TypeGroupReportSrr;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetSrr3GibddByPeriodQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getSRR3GIBDDByPeriod?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "CarForSRR3GIBDDByPeriod";
            } & FragmentCarForSrr3GibddByPeriodFragment
          >
        >
      >;
    }
  >;
};

export type ReportReturnSrr5GibddByDealerQueryVariables = Exact<{
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
}>;

export type ReportReturnSrr5GibddByDealerQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnSRR5GIBDDByDealer?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetSrr5GibddByDealerQueryVariables = Exact<{
  monthControl: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
}>;

export type GetSrr5GibddByDealerQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getSRR5GIBDDByDealer?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "dealerForServiceByMonth";
            } & FragmentdealerForServiceByMonthFragment
          >
        >
      >;
    }
  >;
};

export type ReportReturnSrr5GibddByPeriodQueryVariables = Exact<{
  group: TypeGroupReportSrr;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type ReportReturnSrr5GibddByPeriodQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnSRR5GIBDDByPeriod?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetSrr5GibddByPeriodQueryVariables = Exact<{
  group: TypeGroupReportSrr;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetSrr5GibddByPeriodQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getSRR5GIBDDByPeriod?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "CarForSRR5GIBDDByPeriod";
            } & FragmentCarForSrr5GibddByPeriodFragment
          >
        >
      >;
    }
  >;
};

export type GetUniqueServiceQueryVariables = Exact<{
  group: TypeGroupReportSrr;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  kindReport: TypeKindReport;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  kinds?: Maybe<Array<Maybe<KindRepair>> | Maybe<KindRepair>>;
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
}>;

export type GetUniqueServiceQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getUniqueService?: Maybe<
        Array<
          Maybe<
            { __typename?: "uniqueService" } & FragmentUniqueServiceFragment
          >
        >
      >;
    }
  >;
};

export type GetLoyaltyServiceQueryVariables = Exact<{
  group: TypeGroupReportSrr;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  kindReport: TypeKindReport;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  kinds?: Maybe<Array<Maybe<KindRepair>> | Maybe<KindRepair>>;
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
}>;

export type GetLoyaltyServiceQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getLoyaltyService?: Maybe<
        { __typename?: "loyaltyService" } & FragmentLoyaltyServiceFragment
      >;
    }
  >;
};

export type GetLoyaltyServiceByDealerQueryVariables = Exact<{
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  kinds?: Maybe<Array<Maybe<KindRepair>> | Maybe<KindRepair>>;
}>;

export type GetLoyaltyServiceByDealerQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getLoyaltyServiceByDealer?: Maybe<
        Array<
          Maybe<
            { __typename?: "loyaltyServiceByDealer" } & {
              dealer?: Maybe<
                {
                  __typename?: "Dealer";
                } & FragmentDealerForReportReturnLoyaltyServiceByDealerFragment
              >;
              periods?: Maybe<
                Array<
                  Maybe<
                    {
                      __typename?: "loyaltyServicePeriod";
                    } & FragmentLoyaltyServicePeriodFragment
                  >
                >
              >;
            }
          >
        >
      >;
    }
  >;
};

export type ReportReturnUniqueServiceQueryVariables = Exact<{
  group: TypeGroupReportSrr;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  kindReport: TypeKindReport;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  kinds?: Maybe<Array<Maybe<KindRepair>> | Maybe<KindRepair>>;
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
}>;

export type ReportReturnUniqueServiceQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnUniqueService?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type ReportReturnLoyaltyServiceQueryVariables = Exact<{
  group: TypeGroupReportSrr;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  kindReport: TypeKindReport;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  kinds?: Maybe<Array<Maybe<KindRepair>> | Maybe<KindRepair>>;
  typeClient?: Maybe<
    Array<Maybe<TypeClientReportSrr>> | Maybe<TypeClientReportSrr>
  >;
}>;

export type ReportReturnLoyaltyServiceQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnLoyaltyService?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type ReportReturnLoyaltyServiceByDealerQueryVariables = Exact<{
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  kinds?: Maybe<Array<Maybe<KindRepair>> | Maybe<KindRepair>>;
}>;

export type ReportReturnLoyaltyServiceByDealerQuery = {
  __typename?: "Query";
} & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportReturnLoyaltyServiceByDealer?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type ReportNsByDealerQueryVariables = Exact<{
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  group: TypeGroupReportSrr;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  NOP?: Maybe<Scalars["String"]>;
  RMP?: Maybe<Scalars["String"]>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  loyaltyType?: Maybe<LoyaltyType>;
  bonus?: Maybe<Scalars["Int"]>;
  monthControl?: Maybe<Scalars["Int"]>;
}>;

export type ReportNsByDealerQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportNSByDealer?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetNsByDealerQueryVariables = Exact<{
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  group: TypeGroupReportSrr;
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  NOP?: Maybe<Scalars["String"]>;
  RMP?: Maybe<Scalars["String"]>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  loyaltyType?: Maybe<LoyaltyType>;
  bonus?: Maybe<Scalars["Int"]>;
  monthControl?: Maybe<Scalars["Int"]>;
}>;

export type GetNsByDealerQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getNSByDealer?: Maybe<
        Array<
          Maybe<
            { __typename?: "NSDealerData" } & Pick<
              NsDealerData,
              | "FO"
              | "City"
              | "Region"
              | "Country"
              | "NOP"
              | "RMP"
              | "bonusCarCount"
              | "bonusCarMoney"
              | "coefficientAward"
            > & {
                dealer?: Maybe<
                  { __typename?: "Dealer" } & FragmentDealerFragment
                >;
                periodsData?: Maybe<
                  Array<
                    Maybe<
                      {
                        __typename?: "NSDealerDataPeriodsData";
                      } & FragmentNsDealerDataPeriodsDataFragment
                    >
                  >
                >;
              }
          >
        >
      >;
    }
  >;
};

export type ReportNsByConsultantQueryVariables = Exact<{
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  NOP?: Maybe<Scalars["String"]>;
  RMP?: Maybe<Scalars["String"]>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  loyaltyType?: Maybe<LoyaltyType>;
}>;

export type ReportNsByConsultantQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportNSByConsultant?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetNsByConsultantQueryVariables = Exact<{
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  NOP?: Maybe<Scalars["String"]>;
  RMP?: Maybe<Scalars["String"]>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  loyaltyType?: Maybe<LoyaltyType>;
}>;

export type GetNsByConsultantQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getNSByConsultant?: Maybe<
        Array<
          Maybe<
            { __typename?: "NSByConsultantData" } & Pick<
              NsByConsultantData,
              "consultant"
            > & {
                dealer?: Maybe<
                  { __typename?: "Dealer" } & FragmentDealerFragment
                >;
                periodsData?: Maybe<
                  Array<
                    Maybe<
                      {
                        __typename?: "NSDealerDataPeriodsData";
                      } & FragmentNsDealerDataPeriodsDataFragment
                    >
                  >
                >;
              }
          >
        >
      >;
    }
  >;
};

export type ReportNsByClientQueryVariables = Exact<{
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  NOP?: Maybe<Scalars["String"]>;
  RMP?: Maybe<Scalars["String"]>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  loyaltyType?: Maybe<LoyaltyType>;
}>;

export type ReportNsByClientQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportNSByClient?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetNsByClientQueryVariables = Exact<{
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  NOP?: Maybe<Scalars["String"]>;
  RMP?: Maybe<Scalars["String"]>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  loyaltyType?: Maybe<LoyaltyType>;
}>;

export type GetNsByClientQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getNSByClient?: Maybe<
        Array<
          Maybe<
            { __typename?: "NSByClientData" } & Pick<
              NsByClientData,
              "clientId"
            > & {
                dealer?: Maybe<
                  { __typename?: "Dealer" } & FragmentDealerFragment
                >;
                soldCars?: Maybe<
                  Array<
                    Maybe<
                      { __typename?: "SalesCar" } & FragmentSalesCarFragment
                    >
                  >
                >;
              }
          >
        >
      >;
    }
  >;
};

export type ReportNsByWarmClientsQueryVariables = Exact<{
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  NOP?: Maybe<Scalars["String"]>;
  RMP?: Maybe<Scalars["String"]>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  loyaltyType?: Maybe<LoyaltyType>;
}>;

export type ReportNsByWarmClientsQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportNSByWarmClients?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetNsByWarmClientsQueryVariables = Exact<{
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  NOP?: Maybe<Scalars["String"]>;
  RMP?: Maybe<Scalars["String"]>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  loyaltyType?: Maybe<LoyaltyType>;
}>;

export type GetNsByWarmClientsQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getNSByWarmClients?: Maybe<
        Array<
          Maybe<
            { __typename?: "NSByWarmClientsData" } & Pick<
              NsByWarmClientsData,
              | "NOP"
              | "RMP"
              | "vin"
              | "goldenId"
              | "soldDate"
              | "creditDate"
              | "creditEndDate"
              | "warrantyEndDate"
              | "ePlatformDate"
            > & {
                dealer?: Maybe<
                  { __typename?: "Dealer" } & FragmentDealerFragment
                >;
                client?: Maybe<
                  { __typename?: "Client" } & Pick<
                    Client,
                    | "type"
                    | "name"
                    | "phone"
                    | "email"
                    | "createdAt"
                    | "updatedAt"
                  >
                >;
              }
          >
        >
      >;
    }
  >;
};

export type ReportNsByOldClientsQueryVariables = Exact<{
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  NOP?: Maybe<Scalars["String"]>;
  RMP?: Maybe<Scalars["String"]>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  loyaltyType?: Maybe<LoyaltyType>;
}>;

export type ReportNsByOldClientsQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportNSByOldClients?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetNsByOldClientsQueryVariables = Exact<{
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  NOP?: Maybe<Scalars["String"]>;
  RMP?: Maybe<Scalars["String"]>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  loyaltyType?: Maybe<LoyaltyType>;
}>;

export type GetNsByOldClientsQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getNSByOldClients?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "NSByOldClientsData";
            } & FragmentNsByOldClientsDataFragment
          >
        >
      >;
    }
  >;
};

export type ReportNsByAverageCarAgeQueryVariables = Exact<{
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type ReportNsByAverageCarAgeQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportNSByAverageCarAge?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetNsByAverageCarAgeQueryVariables = Exact<{
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
}>;

export type GetNsByAverageCarAgeQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getNSByAverageCarAge?: Maybe<
        {
          __typename?: "NSByAverageCarAgeData";
        } & FragmentNsByAverageCarAgeDataFragment
      >;
    }
  >;
};

export type ReportNsByClientCarSaleQueryVariables = Exact<{
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  NOP?: Maybe<Scalars["String"]>;
  RMP?: Maybe<Scalars["String"]>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  loyaltyType?: Maybe<LoyaltyType>;
}>;

export type ReportNsByClientCarSaleQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportNSByClientCarSale?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetNsByClientCarSaleQueryVariables = Exact<{
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  NOP?: Maybe<Scalars["String"]>;
  RMP?: Maybe<Scalars["String"]>;
  familyCar?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  loyaltyType?: Maybe<LoyaltyType>;
}>;

export type GetNsByClientCarSaleQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getNSByClientCarSale?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "NSByClientCarSaleData";
            } & FragmentNsByClientCarSaleDataFragment
          >
        >
      >;
    }
  >;
};

export type GetFamilyCarQueryVariables = Exact<{
  name?: Maybe<Scalars["String"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
}>;

export type GetFamilyCarQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getFamilyCar?: Maybe<
        { __typename?: "FamilyCarList" } & Pick<FamilyCarList, "total"> & {
            items?: Maybe<
              Array<
                Maybe<{ __typename?: "familyCar" } & FragmentFamilyCarFragment>
              >
            >;
          }
      >;
    }
  >;
};

export type ImportCreditDataQueryVariables = Exact<{
  fileId: Scalars["ID"];
}>;

export type ImportCreditDataQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & Pick<SrrGetter, "importCreditData">
  >;
};

export type ImportCarEPlatformDataQueryVariables = Exact<{
  fileId: Scalars["ID"];
}>;

export type ImportCarEPlatformDataQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & Pick<SrrGetter, "importCarEPlatformData">
  >;
};

export type GetGibddQueryVariables = Exact<{
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["ID"]>;
  vin?: Maybe<Scalars["String"]>;
  dateRegistrationStart?: Maybe<Scalars["DateTime"]>;
  dateRegistrationEnd?: Maybe<Scalars["DateTime"]>;
  city?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
}>;

export type GetGibddQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getGIBDD?: Maybe<
        { __typename?: "GIBDDList" } & Pick<GibddList, "total"> & {
            items?: Maybe<
              Array<
                Maybe<{ __typename?: "GIBDDType" } & FragmentGibddTypeFragment>
              >
            >;
          }
      >;
    }
  >;
};

export type ReportAverageReceiptToQueryVariables = Exact<{
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  group: TypeGroupReportSrr;
}>;

export type ReportAverageReceiptToQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportAverageReceiptTO?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetAverageReceiptToQueryVariables = Exact<{
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  group: TypeGroupReportSrr;
}>;

export type GetAverageReceiptToQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getAverageReceiptTO?: Maybe<
        Array<
          Maybe<
            { __typename?: "getAverageReceiptTO" } & Pick<
              GetAverageReceiptTo,
              | "FO"
              | "City"
              | "Region"
              | "Country"
              | "carsTotal"
              | "moneyTotal"
              | "averageReceipt"
            > & {
                dealer?: Maybe<
                  { __typename?: "Dealer" } & Pick<
                    Dealer,
                    "DealerName" | "INN"
                  > & { code: Dealer["entfCode"] }
                >;
              }
          >
        >
      >;
    }
  >;
};

export type ReportAverageReceiptAkcQueryVariables = Exact<{
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  group: TypeGroupReportSrr;
}>;

export type ReportAverageReceiptAkcQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      reportAverageReceiptAKC?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetAverageReceiptAkcQueryVariables = Exact<{
  FO?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  City?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  Region?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  periodStart: Scalars["DateTime"];
  periodEnd: Scalars["DateTime"];
  group: TypeGroupReportSrr;
}>;

export type GetAverageReceiptAkcQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getAverageReceiptAKC?: Maybe<
        Array<
          Maybe<
            { __typename?: "getAverageReceiptAKC" } & Pick<
              GetAverageReceiptAkc,
              | "FO"
              | "City"
              | "Region"
              | "Country"
              | "carsTotal"
              | "moneyTotal"
              | "averageReceipt"
            > & {
                dealer?: Maybe<
                  { __typename?: "Dealer" } & Pick<
                    Dealer,
                    "DealerName" | "INN"
                  > & { code: Dealer["entfCode"] }
                >;
              }
          >
        >
      >;
    }
  >;
};

export type GetTargetDealerByMonthQueryVariables = Exact<{
  DealerId?: Maybe<Scalars["ID"]>;
  Month?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
}>;

export type GetTargetDealerByMonthQuery = { __typename?: "Query" } & {
  SRRGetter?: Maybe<
    { __typename?: "SRRGetter" } & {
      getTargetDealerByMonth?: Maybe<
        { __typename?: "getTargetDealerByMonth" } & Pick<
          GetTargetDealerByMonth,
          "total"
        > & {
            items?: Maybe<
              Array<
                Maybe<
                  { __typename?: "DealerTargetOut" } & Pick<
                    DealerTargetOut,
                    "DealerId" | "Month" | "Target"
                  > & {
                      Dealer: { __typename?: "Dealer" } & Pick<
                        Dealer,
                        "DealerName" | "DealerNameEn"
                      >;
                    }
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetServiceQueryVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type GetServiceQuery = { __typename?: "Query" } & {
  ServicesGetter?: Maybe<
    { __typename?: "ServicesGetter" } & {
      getById?: Maybe<
        { __typename?: "ServicesIndicatorTypes" } & FragmentServicesFragment
      >;
    }
  >;
};

export type GetServiceStatusesQueryVariables = Exact<{
  UUID?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
}>;

export type GetServiceStatusesQuery = { __typename?: "Query" } & {
  ServicesGetter?: Maybe<
    { __typename?: "ServicesGetter" } & {
      getDealerStatuses?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "ServicesDealerStatuses";
            } & FragmentServicesDealerStatusesFragment
          >
        >
      >;
    }
  >;
};

export type GetAllServicesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllServicesQuery = { __typename?: "Query" } & {
  ServicesGetter?: Maybe<
    { __typename?: "ServicesGetter" } & {
      getAll?: Maybe<
        Array<
          Maybe<
            { __typename?: "ServicesIndicatorTypes" } & FragmentServicesFragment
          >
        >
      >;
    }
  >;
};

export type GetValuesServicesQueryVariables = Exact<{
  DealerId: Scalars["ID"];
  dateUpTo?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
}>;

export type GetValuesServicesQuery = { __typename?: "Query" } & {
  ServicesGetter?: Maybe<
    { __typename?: "ServicesGetter" } & {
      getValues?: Maybe<
        { __typename?: "ServicesValues" } & Pick<ServicesValues, "total"> & {
            items?: Maybe<
              Array<
                Maybe<
                  {
                    __typename?: "ServicesOneValuesItem";
                  } & FragmentServicesValuesFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetSettingsQueryVariables = Exact<{
  StaffFile: Scalars["Boolean"];
}>;

export type GetSettingsQuery = { __typename?: "Query" } & {
  SettingsGetter?: Maybe<
    { __typename?: "SettingsGetter" } & {
      getSettings?: Maybe<
        { __typename?: "Settings" } & {
          StaffFile?: Maybe<{ __typename?: "File" } & FragmentFileLinkFragment>;
        }
      >;
    }
  >;
};

export type GetSubdivisionQueryVariables = Exact<{
  code?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  parentId?: Maybe<Scalars["ID"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
}>;

export type GetSubdivisionQuery = { __typename?: "Query" } & {
  SubdivisionGetter?: Maybe<
    { __typename?: "SubdivisionGetter" } & {
      get?: Maybe<
        { __typename?: "SubdivisionList" } & Pick<SubdivisionList, "total"> & {
            items?: Maybe<
              Array<
                Maybe<
                  { __typename?: "Subdivision" } & FragmentSubdivisionFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetSubdivisionNamesForSelectQueryVariables = Exact<{
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
}>;

export type GetSubdivisionNamesForSelectQuery = { __typename?: "Query" } & {
  SubdivisionGetter?: Maybe<
    { __typename?: "SubdivisionGetter" } & {
      get?: Maybe<
        { __typename?: "SubdivisionList" } & {
          items?: Maybe<
            Array<
              Maybe<
                {
                  __typename?: "Subdivision";
                } & FragmentSubdivisionForSelectFragment
              >
            >
          >;
        }
      >;
    }
  >;
};

export type GetAllToolsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllToolsQuery = { __typename?: "Query" } & {
  ToolsGetter?: Maybe<
    { __typename?: "ToolsGetter" } & {
      getAll?: Maybe<
        Array<
          Maybe<{ __typename?: "ToolsIndicatorTypes" } & FragmentToolsFragment>
        >
      >;
    }
  >;
};

export type GetAllToolsParentQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllToolsParentQuery = { __typename?: "Query" } & {
  ToolsGetter?: Maybe<
    { __typename?: "ToolsGetter" } & {
      getAll?: Maybe<
        Array<
          Maybe<{ __typename?: "ToolsIndicatorTypes" } & FragmentToolsFragment>
        >
      >;
    }
  >;
};

export type GetToolsStatusesQueryVariables = Exact<{
  UUID?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
}>;

export type GetToolsStatusesQuery = { __typename?: "Query" } & {
  ToolsGetter?: Maybe<
    { __typename?: "ToolsGetter" } & {
      getDealerStatuses?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "ToolsDealerStatuses";
            } & FragmentToolsDealerStatusesFragment
          >
        >
      >;
    }
  >;
};

export type GetValuesToolsQueryVariables = Exact<{
  DealerId: Scalars["ID"];
  dateUpTo?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
}>;

export type GetValuesToolsQuery = { __typename?: "Query" } & {
  ToolsGetter?: Maybe<
    { __typename?: "ToolsGetter" } & {
      getValues?: Maybe<
        { __typename?: "ToolsValues" } & Pick<ToolsValues, "total"> & {
            items?: Maybe<
              Array<
                Maybe<
                  {
                    __typename?: "ToolsOneValuesItem";
                  } & FragmentValuesToolsFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetGroupsToolsQueryVariables = Exact<{
  groupType?: Maybe<ZdGroupType>;
}>;

export type GetGroupsToolsQuery = { __typename?: "Query" } & {
  ToolsGetter?: Maybe<
    { __typename?: "ToolsGetter" } & Pick<ToolsGetter, "getGroups">
  >;
};

export type GetAllToolsInsuranceQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetAllToolsInsuranceQuery = { __typename?: "Query" } & {
  ToolsInsuranceGetter?: Maybe<
    { __typename?: "ToolsInsuranceGetter" } & {
      getAll?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "ToolsInsuranceIndicatorTypes";
            } & FragmentToolsInsuranceFragment
          >
        >
      >;
    }
  >;
};

export type GetAllToolsInsuranceParentQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetAllToolsInsuranceParentQuery = { __typename?: "Query" } & {
  ToolsInsuranceGetter?: Maybe<
    { __typename?: "ToolsInsuranceGetter" } & {
      getAll?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "ToolsInsuranceIndicatorTypes";
            } & FragmentToolsInsuranceFragment
          >
        >
      >;
    }
  >;
};

export type GetGroupsToolsInsuranceQueryVariables = Exact<{
  groupType?: Maybe<ZdGroupType>;
}>;

export type GetGroupsToolsInsuranceQuery = { __typename?: "Query" } & {
  ToolsInsuranceGetter?: Maybe<
    { __typename?: "ToolsInsuranceGetter" } & Pick<
      ToolsInsuranceGetter,
      "getGroups"
    >
  >;
};

export type GetToolsInsuranceStatusesQueryVariables = Exact<{
  UUID?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
}>;

export type GetToolsInsuranceStatusesQuery = { __typename?: "Query" } & {
  ToolsInsuranceGetter?: Maybe<
    { __typename?: "ToolsInsuranceGetter" } & {
      getDealerStatuses?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "ToolsInsuranceDealerStatuses";
            } & FragmentToolsInsuranceDealerStatusesFragment
          >
        >
      >;
    }
  >;
};

export type GetValuesToolsInsuranceQueryVariables = Exact<{
  DealerId: Scalars["ID"];
  dateUpTo?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
}>;

export type GetValuesToolsInsuranceQuery = { __typename?: "Query" } & {
  ToolsInsuranceGetter?: Maybe<
    { __typename?: "ToolsInsuranceGetter" } & {
      getValues?: Maybe<
        { __typename?: "ToolsInsuranceValues" } & Pick<
          ToolsInsuranceValues,
          "total"
        > & {
            items?: Maybe<
              Array<
                Maybe<
                  {
                    __typename?: "ToolsInsuranceOneValuesItem";
                  } & FragmentValuesToolsInsuranceFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetAllToolsMetrologicalQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetAllToolsMetrologicalQuery = { __typename?: "Query" } & {
  ToolsMetrologicalGetter?: Maybe<
    { __typename?: "ToolsMetrologicalGetter" } & {
      getAll?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "ToolsMetrologicalIndicatorTypes";
            } & FragmentToolsMetrologicalFragment
          >
        >
      >;
    }
  >;
};

export type GetToolsMetrologicalStatusesQueryVariables = Exact<{
  UUID?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
}>;

export type GetToolsMetrologicalStatusesQuery = { __typename?: "Query" } & {
  ToolsMetrologicalGetter?: Maybe<
    { __typename?: "ToolsMetrologicalGetter" } & {
      getDealerStatuses?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "ToolsMetrologicalDealerStatuses";
            } & FragmentToolsMetrologicalDealerStatusesFragment
          >
        >
      >;
    }
  >;
};

export type GetValuesToolsMetrologicalQueryVariables = Exact<{
  DealerId: Scalars["ID"];
  dateUpTo?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
}>;

export type GetValuesToolsMetrologicalQuery = { __typename?: "Query" } & {
  ToolsMetrologicalGetter?: Maybe<
    { __typename?: "ToolsMetrologicalGetter" } & {
      getValues?: Maybe<
        { __typename?: "ToolsMetrologicalValues" } & Pick<
          ToolsMetrologicalValues,
          "total"
        > & {
            items?: Maybe<
              Array<
                Maybe<
                  {
                    __typename?: "ToolsMetrologicalOneValuesItem";
                  } & FragmentValuesToolsMetrologicalFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetAllTradePremisesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllTradePremisesQuery = { __typename?: "Query" } & {
  TradePremisesGetter?: Maybe<
    { __typename?: "TradePremisesGetter" } & {
      getAll?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "TradePremisesIndicatorTypes";
            } & FragmentTradePremisesIndicatorTypesFragment
          >
        >
      >;
    }
  >;
};

export type GetDealerStatusesTradePremisesQueryVariables = Exact<{
  UUID?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
}>;

export type GetDealerStatusesTradePremisesQuery = { __typename?: "Query" } & {
  TradePremisesGetter?: Maybe<
    { __typename?: "TradePremisesGetter" } & {
      getDealerStatuses?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "TradePremisesDealerStatuses";
            } & FragmentTradePremisesDealerStatusesFragment
          >
        >
      >;
    }
  >;
};

export type GetValuesTradePremisesQueryVariables = Exact<{
  DealerId: Scalars["ID"];
  dateUpTo?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
  sortBy?: Maybe<TradePremisesSortBy>;
}>;

export type GetValuesTradePremisesQuery = { __typename?: "Query" } & {
  TradePremisesGetter?: Maybe<
    { __typename?: "TradePremisesGetter" } & {
      getValues?: Maybe<
        { __typename?: "TradePremisesValues" } & Pick<
          TradePremisesValues,
          "total"
        > & {
            items?: Maybe<
              Array<
                Maybe<
                  {
                    __typename?: "TradePremisesOneValuesItem";
                  } & FragmentTradePremisesOneValuesItemFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetTrustedPersonsQueryVariables = Exact<{ [key: string]: never }>;

export type GetTrustedPersonsQuery = { __typename?: "Query" } & {
  TrustedPersonGetter?: Maybe<
    { __typename?: "TrustedPersonGetter" } & {
      getTrustedPersons: Array<
        Maybe<
          { __typename?: "TrustedPerson" } & Pick<
            TrustedPerson,
            | "id"
            | "powerOfAttorney"
            | "fio"
            | "shortFio"
            | "descriptionContract"
            | "date"
            | "endDate"
            | "active"
          >
        >
      >;
    }
  >;
};

export type GetTrustedPersonByIdQueryVariables = Exact<{
  getTrustedPersonByIdId: Scalars["ID"];
}>;

export type GetTrustedPersonByIdQuery = { __typename?: "Query" } & {
  TrustedPersonGetter?: Maybe<
    { __typename?: "TrustedPersonGetter" } & {
      getTrustedPersonById: { __typename?: "TrustedPerson" } & Pick<
        TrustedPerson,
        | "id"
        | "powerOfAttorney"
        | "fio"
        | "shortFio"
        | "descriptionContract"
        | "date"
        | "endDate"
        | "active"
      >;
    }
  >;
};

export type GetUsersQueryVariables = Exact<{
  searchField?: Maybe<Scalars["String"]>;
  searchText?: Maybe<Scalars["String"]>;
  sortField?: Maybe<Scalars["String"]>;
  sortType?: Maybe<Scalars["String"]>;
  catalog?: Maybe<Scalars["String"]>;
  DealerId?: Maybe<Scalars["ID"]>;
  SubdivisionId?: Maybe<Scalars["ID"]>;
  ViolationAccess?: Maybe<Scalars["Boolean"]>;
  EmployeeAccess?: Maybe<Scalars["Boolean"]>;
  AnnouncementsAccess?: Maybe<Scalars["Boolean"]>;
  AnnouncementsSend?: Maybe<Scalars["Boolean"]>;
  ZdAccess?: Maybe<Scalars["Boolean"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
}>;

export type GetUsersQuery = { __typename?: "Query" } & {
  UserGetter?: Maybe<
    { __typename?: "UserGetter" } & {
      getUsers?: Maybe<
        { __typename?: "UserList" } & Pick<UserList, "total"> & {
            items?: Maybe<
              Array<
                Maybe<
                  { __typename?: "Profile" } & FragmentProfileForTableFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetFileLinksQueryVariables = Exact<{
  DealerId?: Maybe<Scalars["ID"]>;
  catalog?: Maybe<Scalars["String"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  searchText?: Maybe<Scalars["String"]>;
  searchField?: Maybe<Scalars["String"]>;
  sortField?: Maybe<Scalars["String"]>;
  sortType?: Maybe<Scalars["String"]>;
}>;

export type GetFileLinksQuery = { __typename?: "Query" } & {
  UserGetter?: Maybe<
    { __typename?: "UserGetter" } & {
      getUsers?: Maybe<
        { __typename?: "UserList" } & {
          items?: Maybe<
            Array<
              Maybe<
                { __typename?: "Profile" } & Pick<Profile, "id" | "fullname">
              >
            >
          >;
        }
      >;
    }
  >;
};

export type GetProfileQueryVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type GetProfileQuery = { __typename?: "Query" } & {
  UserGetter?: Maybe<
    { __typename?: "UserGetter" } & {
      getProfile?: Maybe<
        { __typename?: "Profile" } & FragmentProfileForHeaderFragment
      >;
    }
  >;
};

export type GetReportRegMenByDealerByPeriodQueryVariables = Exact<{
  quarter?: Maybe<Scalars["Int"]>;
  year?: Maybe<Scalars["Int"]>;
}>;

export type GetReportRegMenByDealerByPeriodQuery = { __typename?: "Query" } & {
  UserGetter?: Maybe<
    { __typename?: "UserGetter" } & {
      getReportRegMenByDealerByPeriod?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "ReportRegMenByDealerByPeriod";
            } & FragmentReportRegMenByDealerByPeriodFragment
          >
        >
      >;
    }
  >;
};

export type GetReportFileRegMenByDealerByPeriodQueryVariables = Exact<{
  quarter?: Maybe<Scalars["Int"]>;
  year?: Maybe<Scalars["Int"]>;
}>;

export type GetReportFileRegMenByDealerByPeriodQuery = {
  __typename?: "Query";
} & {
  UserGetter?: Maybe<
    { __typename?: "UserGetter" } & {
      getReportFileRegMenByDealerByPeriod?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetReportRegMenByDealerByDealerQueryVariables = Exact<{
  dealerId?: Maybe<Scalars["ID"]>;
}>;

export type GetReportRegMenByDealerByDealerQuery = { __typename?: "Query" } & {
  UserGetter?: Maybe<
    { __typename?: "UserGetter" } & {
      getReportRegMenByDealerByDealer?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "ReportRegMenByDealerByDealer";
            } & FragmentReportRegMenByDealerByDealerFragment
          >
        >
      >;
    }
  >;
};

export type GetReportFileRegMenByDealerByDealerQueryVariables = Exact<{
  dealerId?: Maybe<Scalars["ID"]>;
}>;

export type GetReportFileRegMenByDealerByDealerQuery = {
  __typename?: "Query";
} & {
  UserGetter?: Maybe<
    { __typename?: "UserGetter" } & {
      getReportFileRegMenByDealerByDealer?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetReportRegMenByDealerConsolidateQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetReportRegMenByDealerConsolidateQuery = {
  __typename?: "Query";
} & {
  UserGetter?: Maybe<
    { __typename?: "UserGetter" } & {
      getReportRegMenByDealerConsolidate?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "ReportRegMenByDealerConsolidate";
            } & FragmentReportRegMenByDealerConsolidateFragment
          >
        >
      >;
    }
  >;
};

export type GetReportFileRegMenByDealerConsolidateQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetReportFileRegMenByDealerConsolidateQuery = {
  __typename?: "Query";
} & {
  UserGetter?: Maybe<
    { __typename?: "UserGetter" } & {
      getReportFileRegMenByDealerConsolidate?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetReportFileRegMenByDealerByRegMenQueryVariables = Exact<{
  userId?: Maybe<Scalars["ID"]>;
}>;

export type GetReportFileRegMenByDealerByRegMenQuery = {
  __typename?: "Query";
} & {
  UserGetter?: Maybe<
    { __typename?: "UserGetter" } & {
      getReportFileRegMenByDealerByRegMen?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetReportRegMenByDealerByRegMenQueryVariables = Exact<{
  userId?: Maybe<Scalars["ID"]>;
}>;

export type GetReportRegMenByDealerByRegMenQuery = { __typename?: "Query" } & {
  UserGetter?: Maybe<
    { __typename?: "UserGetter" } & {
      getReportRegMenByDealerByRegMen?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "ReportRegMenByDealerByRegMen";
            } & FragmentReportRegMenByDealerByRegMenFragment
          >
        >
      >;
    }
  >;
};

export type GetRegMensQueryVariables = Exact<{
  searchField?: Maybe<Scalars["String"]>;
  searchText?: Maybe<Scalars["String"]>;
  sortField?: Maybe<Scalars["String"]>;
  sortType?: Maybe<Scalars["String"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
}>;

export type GetRegMensQuery = { __typename?: "Query" } & {
  UserGetter?: Maybe<
    { __typename?: "UserGetter" } & {
      getRegMens?: Maybe<
        { __typename?: "RegMensList" } & {
          items?: Maybe<
            Array<
              Maybe<
                { __typename?: "RegMens" } & Pick<
                  RegMens,
                  "id" | "fullname" | "fullnameEn" | "roleRu" | "roleEn"
                >
              >
            >
          >;
        }
      >;
    }
  >;
};

export type GetDataProfileQueryVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type GetDataProfileQuery = { __typename?: "Query" } & {
  UserGetter?: Maybe<
    { __typename?: "UserGetter" } & {
      getProfile?: Maybe<
        { __typename?: "Profile" } & Pick<
          Profile,
          | "id"
          | "login"
          | "fullname"
          | "phone"
          | "position"
          | "email"
          | "role"
          | "roleRu"
        >
      >;
    }
  >;
};

export type GetGuideFileQueryVariables = Exact<{ [key: string]: never }>;

export type GetGuideFileQuery = { __typename?: "Query" } & {
  UserGuideGetter?: Maybe<
    { __typename?: "UserGuideGetter" } & {
      getGuideFile?: Maybe<
        { __typename?: "UserGuide" } & Pick<
          UserGuide,
          "AdminFileId" | "UserFileId"
        > & {
            AdminFile?: Maybe<
              { __typename?: "File" } & Pick<
                File,
                | "id"
                | "name"
                | "link"
                | "mimeType"
                | "createdAt"
                | "type"
                | "hash"
              > & {
                  User?: Maybe<
                    { __typename?: "Profile" } & Pick<
                      Profile,
                      "id" | "login" | "email" | "fullname" | "role"
                    >
                  >;
                }
            >;
            UserFile?: Maybe<
              { __typename?: "File" } & Pick<
                File,
                | "id"
                | "name"
                | "link"
                | "mimeType"
                | "createdAt"
                | "type"
                | "hash"
              > & {
                  User?: Maybe<
                    { __typename?: "Profile" } & Pick<
                      Profile,
                      "id" | "login" | "email" | "fullname" | "role"
                    >
                  >;
                }
            >;
          }
      >;
    }
  >;
};

export type GetViolationsAllQueryVariables = Exact<{
  order?: Maybe<SortType>;
  orderBy?: Maybe<OrderByColumnInViolation>;
  statusFilter?: Maybe<ViolationStatus>;
  FoFilter?: Maybe<Scalars["String"]>;
  regionFilter?: Maybe<Scalars["String"]>;
  documentFilter?: Maybe<FilterExistenceType>;
  dealerCandidate?: Maybe<Scalars["String"]>;
  dealerIdFilter?: Maybe<Scalars["ID"]>;
  fromFilter?: Maybe<Scalars["DateTime"]>;
  fromCreatedAt?: Maybe<Scalars["DateTime"]>;
  toFilter?: Maybe<Scalars["DateTime"]>;
  toCreatedAt?: Maybe<Scalars["DateTime"]>;
  violationTypesIdFilter?: Maybe<Scalars["ID"]>;
  subdivisionIdFilter?: Maybe<Scalars["ID"]>;
  categoryFilter?: Maybe<ViolationTypeCategory>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
}>;

export type GetViolationsAllQuery = { __typename?: "Query" } & {
  ViolationGetter?: Maybe<
    { __typename?: "ViolationGetter" } & {
      getAll?: Maybe<
        { __typename?: "getAllViolationResponse" } & Pick<
          GetAllViolationResponse,
          "total"
        > & {
            items?: Maybe<
              Array<
                Maybe<
                  {
                    __typename?: "ViolationInclude";
                  } & FragmentGetViolationFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetViolationByIdQueryVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type GetViolationByIdQuery = { __typename?: "Query" } & {
  ViolationGetter?: Maybe<
    { __typename?: "ViolationGetter" } & {
      getById?: Maybe<
        { __typename?: "ViolationInclude" } & FragmentGetViolationFragment
      >;
    }
  >;
};

export type GetViolationCommentsQueryVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
}>;

export type GetViolationCommentsQuery = { __typename?: "Query" } & {
  ViolationGetter?: Maybe<
    { __typename?: "ViolationGetter" } & {
      getComments?: Maybe<
        { __typename?: "getCommentsResponse" } & Pick<
          GetCommentsResponse,
          "total"
        > & {
            items?: Maybe<
              Array<
                Maybe<
                  {
                    __typename?: "ViolationComment";
                  } & FragmentGetViolationCommentFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetReportByDealerQueryVariables = Exact<{
  dateBegin?: Maybe<Scalars["DateTime"]>;
  dateEnd?: Maybe<Scalars["DateTime"]>;
  dealerCandidate?: Maybe<Scalars["String"]>;
}>;

export type GetReportByDealerQuery = { __typename?: "Query" } & {
  ViolationGetter?: Maybe<
    { __typename?: "ViolationGetter" } & {
      getReportByDealer?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetAllReportViolationsQueryVariables = Exact<{
  documentFilter?: Maybe<FilterExistenceType>;
  statusFilter?: Maybe<ViolationStatus>;
  FoFilter?: Maybe<Scalars["String"]>;
  regionFilter?: Maybe<Scalars["String"]>;
  dealerIdFilter?: Maybe<Scalars["ID"]>;
  dealerCandidate?: Maybe<Scalars["String"]>;
  fromFilter?: Maybe<Scalars["DateTime"]>;
  toFilter?: Maybe<Scalars["DateTime"]>;
  fromCreatedAt?: Maybe<Scalars["DateTime"]>;
  toCreatedAt?: Maybe<Scalars["DateTime"]>;
  violationTypesIdFilter?: Maybe<Scalars["ID"]>;
  subdivisionIdFilter?: Maybe<Scalars["ID"]>;
  categoryFilter?: Maybe<ViolationTypeCategory>;
}>;

export type GetAllReportViolationsQuery = { __typename?: "Query" } & {
  ViolationGetter?: Maybe<
    { __typename?: "ViolationGetter" } & {
      getAllReport?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetViolationTypesQueryVariables = Exact<{
  order?: Maybe<SortType>;
  orderBy?: Maybe<OrderByColumnInViolationTypes>;
  status?: Maybe<ViolationStatusType>;
  name?: Maybe<Scalars["String"]>;
  SubdivisionId?: Maybe<Scalars["ID"]>;
  category?: Maybe<ViolationTypeCategory>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
}>;

export type GetViolationTypesQuery = { __typename?: "Query" } & {
  ViolationTypesGetter?: Maybe<
    { __typename?: "ViolationTypesGetter" } & {
      get?: Maybe<
        { __typename?: "ViolationTypeList" } & Pick<
          ViolationTypeList,
          "total"
        > & {
            items?: Maybe<
              Array<
                Maybe<
                  {
                    __typename?: "ViolationType";
                  } & FragmentViolationTypeFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetViolationTypesDeleteQueryVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type GetViolationTypesDeleteQuery = { __typename?: "Query" } & {
  ViolationTypesGetter?: Maybe<
    { __typename?: "ViolationTypesGetter" } & Pick<
      ViolationTypesGetter,
      "delete"
    >
  >;
};

export type GetViolationTypesForSelectQueryVariables = Exact<{
  page?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
  count?: Maybe<Scalars["Int"]>;
  status?: Maybe<ViolationStatusType>;
}>;

export type GetViolationTypesForSelectQuery = { __typename?: "Query" } & {
  ViolationTypesGetter?: Maybe<
    { __typename?: "ViolationTypesGetter" } & {
      get?: Maybe<
        { __typename?: "ViolationTypeList" } & {
          items?: Maybe<
            Array<
              Maybe<
                {
                  __typename?: "ViolationType";
                } & FragmentViolationTypeForSelectFragment
              >
            >
          >;
        }
      >;
    }
  >;
};

export type GetAllWarehousesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllWarehousesQuery = { __typename?: "Query" } & {
  WarehousesGetter?: Maybe<
    { __typename?: "WarehousesGetter" } & {
      getAll?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "WarehousesIndicatorTypes";
            } & FragmentWarehousesFragment
          >
        >
      >;
    }
  >;
};

export type GetWarehousesStatusesQueryVariables = Exact<{
  UUID?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
}>;

export type GetWarehousesStatusesQuery = { __typename?: "Query" } & {
  WarehousesGetter?: Maybe<
    { __typename?: "WarehousesGetter" } & {
      getDealerStatuses?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "WarehousesDealerStatuses";
            } & FragmentWarehousesDealerStatusesFragment
          >
        >
      >;
    }
  >;
};

export type GetValuesWarehousesQueryVariables = Exact<{
  DealerId: Scalars["ID"];
  dateUpTo?: Maybe<Scalars["DateTime"]>;
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
}>;

export type GetValuesWarehousesQuery = { __typename?: "Query" } & {
  WarehousesGetter?: Maybe<
    { __typename?: "WarehousesGetter" } & {
      getValues?: Maybe<
        { __typename?: "WarehousesValues" } & Pick<
          WarehousesValues,
          "total"
        > & {
            items?: Maybe<
              Array<
                Maybe<
                  {
                    __typename?: "WarehousesOneValuesItem";
                  } & FragmentValuesWarehousesFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetWorkSpaceDealershipQueryVariables = Exact<{
  DealerId: Scalars["ID"];
}>;

export type GetWorkSpaceDealershipQuery = { __typename?: "Query" } & {
  WorkSpaceGetter?: Maybe<
    { __typename?: "WorkSpaceGetter" } & {
      getDealerShip?: Maybe<
        { __typename?: "DealerShip" } & {
          dealer?: Maybe<
            { __typename?: "Dealer" } & FragmentDealerShipFragment
          >;
        }
      >;
    }
  >;
};

export type GetWorkSpaceDealershipManagerQueryVariables = Exact<{
  DealerId: Scalars["ID"];
}>;

export type GetWorkSpaceDealershipManagerQuery = { __typename?: "Query" } & {
  WorkSpaceGetter?: Maybe<
    { __typename?: "WorkSpaceGetter" } & {
      getDealerShip?: Maybe<
        { __typename?: "DealerShip" } & {
          dealer?: Maybe<
            { __typename?: "Dealer" } & FragmentDealerShipManagerFragment
          >;
        }
      >;
    }
  >;
};

export type GetWorkSpaceDealerQQueryVariables = Exact<{
  DealerId: Scalars["ID"];
  date?: Maybe<Scalars["DateTime"]>;
}>;

export type GetWorkSpaceDealerQQuery = { __typename?: "Query" } & {
  WorkSpaceGetter?: Maybe<
    { __typename?: "WorkSpaceGetter" } & {
      getQ?: Maybe<
        { __typename?: "QuartilesRatingVersion" } & {
          Indicator?: Maybe<
            { __typename?: "Indicator" } & FragmentIndicatorForRatingFragment
          >;
          IndicatorGroup?: Maybe<
            { __typename?: "Indicator" } & FragmentIndicatorForRatingFragment
          >;
        }
      >;
    }
  >;
};

export type GetWorkSpaceRnBankRatingQueryVariables = Exact<{
  DealerId: Scalars["ID"];
}>;

export type GetWorkSpaceRnBankRatingQuery = { __typename?: "Query" } & {
  WorkSpaceGetter?: Maybe<
    { __typename?: "WorkSpaceGetter" } & {
      getRnBankRating?: Maybe<
        Array<
          Maybe<
            { __typename?: "IndicatorValue" } & FragmentRnBankRatingFragment
          >
        >
      >;
    }
  >;
};

export type GetWorkSpaceNewVehicleQueryVariables = Exact<{
  DealerId: Scalars["ID"];
}>;

export type GetWorkSpaceNewVehicleQuery = { __typename?: "Query" } & {
  WorkSpaceGetter?: Maybe<
    { __typename?: "WorkSpaceGetter" } & {
      getNewVehicle?: Maybe<
        { __typename?: "Vehicle" } & {
          i101?: Maybe<
            Array<
              Maybe<
                { __typename?: "IndicatorValue" } & FragmentNewVehicleFragment
              >
            >
          >;
          i103?: Maybe<
            Array<
              Maybe<
                { __typename?: "IndicatorValue" } & FragmentNewVehicleFragment
              >
            >
          >;
          i104?: Maybe<
            Array<
              Maybe<
                { __typename?: "IndicatorValue" } & FragmentNewVehicleFragment
              >
            >
          >;
          i105?: Maybe<
            Array<
              Maybe<
                { __typename?: "IndicatorValue" } & FragmentNewVehicleFragment
              >
            >
          >;
          i106?: Maybe<
            Array<
              Maybe<
                { __typename?: "IndicatorValue" } & FragmentNewVehicleFragment
              >
            >
          >;
        }
      >;
    }
  >;
};

export type GetWorkSpaceAfterSalesQueryVariables = Exact<{
  DealerId: Scalars["ID"];
}>;

export type GetWorkSpaceAfterSalesQuery = { __typename?: "Query" } & {
  WorkSpaceGetter?: Maybe<
    { __typename?: "WorkSpaceGetter" } & {
      getAfterSales?: Maybe<
        { __typename?: "AfterSales" } & {
          i300?: Maybe<
            Array<
              Maybe<
                { __typename?: "IndicatorValue" } & FragmentAfterSalesFragment
              >
            >
          >;
          i301?: Maybe<
            Array<
              Maybe<
                { __typename?: "IndicatorValue" } & FragmentAfterSalesFragment
              >
            >
          >;
          i302?: Maybe<
            Array<
              Maybe<
                { __typename?: "IndicatorValue" } & FragmentAfterSalesFragment
              >
            >
          >;
          i303?: Maybe<
            Array<
              Maybe<
                { __typename?: "IndicatorValue" } & FragmentAfterSalesFragment
              >
            >
          >;
          i400?: Maybe<
            Array<
              Maybe<
                { __typename?: "IndicatorValue" } & FragmentAfterSalesFragment
              >
            >
          >;
          i401?: Maybe<
            Array<
              Maybe<
                { __typename?: "IndicatorValue" } & FragmentAfterSalesFragment
              >
            >
          >;
          i502?: Maybe<
            Array<
              Maybe<
                { __typename?: "IndicatorValue" } & FragmentAfterSalesFragment
              >
            >
          >;
        }
      >;
    }
  >;
};

export type GetWorkSpaceQualityQueryVariables = Exact<{
  DealerId: Scalars["ID"];
}>;

export type GetWorkSpaceQualityQuery = { __typename?: "Query" } & {
  WorkSpaceGetter?: Maybe<
    { __typename?: "WorkSpaceGetter" } & {
      getQuality?: Maybe<
        { __typename?: "Quality" } & FragmentWorkSpaceQualityFragment
      >;
    }
  >;
};

export type GetWorkSpaceProfitabilityQueryVariables = Exact<{
  DealerId: Scalars["ID"];
}>;

export type GetWorkSpaceProfitabilityQuery = { __typename?: "Query" } & {
  WorkSpaceGetter?: Maybe<
    { __typename?: "WorkSpaceGetter" } & {
      getProfitability?: Maybe<
        { __typename?: "Profitability" } & {
          i600?: Maybe<
            { __typename?: "IndicatorValue" } & FragmentProfitabilityFragment
          >;
          i601?: Maybe<
            { __typename?: "IndicatorValue" } & FragmentProfitabilityFragment
          >;
          i602?: Maybe<
            { __typename?: "IndicatorValue" } & FragmentProfitabilityFragment
          >;
          i603?: Maybe<
            { __typename?: "IndicatorValue" } & FragmentProfitabilityFragment
          >;
          i604?: Maybe<
            { __typename?: "IndicatorValue" } & FragmentProfitabilityFragment
          >;
          i605?: Maybe<
            { __typename?: "IndicatorValue" } & FragmentProfitabilityFragment
          >;
        }
      >;
    }
  >;
};

export type GetSalesUsedCarQueryVariables = Exact<{
  dealerId: Scalars["ID"];
}>;

export type GetSalesUsedCarQuery = { __typename?: "Query" } & {
  WorkSpaceGetter?: Maybe<
    { __typename?: "WorkSpaceGetter" } & {
      getSalesUsedCar?: Maybe<
        Array<
          Maybe<
            { __typename?: "UsedCarSales" } & Pick<
              UsedCarSales,
              "doubleValue" | "avgSales" | "createdAt" | "updatedAt"
            >
          >
        >
      >;
    }
  >;
};

export type GetAllZdUsuoQueryVariables = Exact<{
  page?: Maybe<Scalars["Int"]>;
  count?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
}>;

export type GetAllZdUsuoQuery = { __typename?: "Query" } & {
  ZdCommonGetter?: Maybe<
    { __typename?: "ZdCommonGetter" } & {
      getZdGlobalInfoForDealers?: Maybe<
        { __typename?: "ZdGlobalInfoForDealerResponse" } & Pick<
          ZdGlobalInfoForDealerResponse,
          "total"
        > & {
            items?: Maybe<
              Array<
                Maybe<
                  {
                    __typename?: "ZdGlobalInfoForDealer";
                  } & FragmentZdGlobalInfoForDealerFragment
                >
              >
            >;
          }
      >;
    }
  >;
};

export type GetAllZdDealerQueryVariables = Exact<{
  DealerId: Scalars["ID"];
}>;

export type GetAllZdDealerQuery = { __typename?: "Query" } & {
  ZdCommonGetter?: Maybe<
    { __typename?: "ZdCommonGetter" } & {
      getForDealerTablesStatuses?: Maybe<
        Array<
          Maybe<
            { __typename?: "DealerTablesStatusesListItem" } & Pick<
              DealerTablesStatusesListItem,
              "tableIndex" | "lastChangeByDealer" | "lastChangeByDealerChecker"
            >
          >
        >
      >;
    }
  >;
};

export type GetZdDealerOneQueryVariables = Exact<{
  DealerId: Scalars["ID"];
}>;

export type GetZdDealerOneQuery = { __typename?: "Query" } & {
  ZdCommonGetter?: Maybe<
    { __typename?: "ZdCommonGetter" } & {
      getZdGlobalInfoForDealer?: Maybe<
        {
          __typename?: "ZdGlobalInformationForDealerResponse";
        } & FragmentZdGlobalInfoForDealerOneFragment
      >;
    }
  >;
};

export type GetReportServiceQueryVariables = Exact<{
  UUIDs?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  Name?: Maybe<Scalars["String"]>;
  Type: ReportType;
  lang: LangType;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Russia?: Maybe<Scalars["Boolean"]>;
}>;

export type GetReportServiceQuery = { __typename?: "Query" } & {
  ZdReportsGetter?: Maybe<
    { __typename?: "ZdReportsGetter" } & {
      ServiceById?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetReportTradePremisesByIdQueryVariables = Exact<{
  UUIDs?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  Name?: Maybe<Scalars["String"]>;
  Type: ReportType;
  lang: LangType;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Russia?: Maybe<Scalars["Boolean"]>;
}>;

export type GetReportTradePremisesByIdQuery = { __typename?: "Query" } & {
  ZdReportsGetter?: Maybe<
    { __typename?: "ZdReportsGetter" } & {
      TradePremisesById?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetReportPlaceQueryVariables = Exact<{
  UUIDs?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  Name?: Maybe<Scalars["String"]>;
  Type: ReportType;
  lang: LangType;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Russia?: Maybe<Scalars["Boolean"]>;
}>;

export type GetReportPlaceQuery = { __typename?: "Query" } & {
  ZdReportsGetter?: Maybe<
    { __typename?: "ZdReportsGetter" } & {
      PlaceById?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetReportPlaceByLocationQueryVariables = Exact<{
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Russia?: Maybe<Scalars["Boolean"]>;
  Type: ReportType;
  lang: LangType;
}>;

export type GetReportPlaceByLocationQuery = { __typename?: "Query" } & {
  ZdReportsGetter?: Maybe<
    { __typename?: "ZdReportsGetter" } & {
      PlaceByLocation?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetReportToolsQueryVariables = Exact<{
  UUIDs?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  groupOne?: Maybe<Scalars["String"]>;
  groupTwo?: Maybe<Scalars["String"]>;
  Type: ReportType;
  lang: LangType;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Russia?: Maybe<Scalars["Boolean"]>;
}>;

export type GetReportToolsQuery = { __typename?: "Query" } & {
  ZdReportsGetter?: Maybe<
    { __typename?: "ZdReportsGetter" } & {
      ToolsById?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetReportPostsByPlaceQueryVariables = Exact<{
  UUIDs?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  Name?: Maybe<Scalars["String"]>;
  Type: ReportType;
  lang: LangType;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Russia?: Maybe<Scalars["Boolean"]>;
}>;

export type GetReportPostsByPlaceQuery = { __typename?: "Query" } & {
  ZdReportsGetter?: Maybe<
    { __typename?: "ZdReportsGetter" } & {
      PostByPlaceIds?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetReportPostByPostQueryVariables = Exact<{
  UUIDs?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  Name?: Maybe<Scalars["String"]>;
  Type: ReportType;
  lang: LangType;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Russia?: Maybe<Scalars["Boolean"]>;
}>;

export type GetReportPostByPostQuery = { __typename?: "Query" } & {
  ZdReportsGetter?: Maybe<
    { __typename?: "ZdReportsGetter" } & {
      Posts?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetReportWarehouseQueryVariables = Exact<{
  UUIDs?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  Name?: Maybe<Scalars["String"]>;
  Type: ReportType;
  lang: LangType;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Russia?: Maybe<Scalars["Boolean"]>;
}>;

export type GetReportWarehouseQuery = { __typename?: "Query" } & {
  ZdReportsGetter?: Maybe<
    { __typename?: "ZdReportsGetter" } & {
      WarehouseById?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetReportRequiredToolsQueryVariables = Exact<{
  UUIDs?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  Name?: Maybe<Scalars["String"]>;
  Type: ReportType;
  lang: LangType;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Russia?: Maybe<Scalars["Boolean"]>;
}>;

export type GetReportRequiredToolsQuery = { __typename?: "Query" } & {
  ZdReportsGetter?: Maybe<
    { __typename?: "ZdReportsGetter" } & {
      RequiredToolsById?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetReportRequiredsToolsQueryVariables = Exact<{
  UUIDs?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  Name?: Maybe<Scalars["String"]>;
  Type: ReportType;
  lang: LangType;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Russia?: Maybe<Scalars["Boolean"]>;
}>;

export type GetReportRequiredsToolsQuery = { __typename?: "Query" } & {
  ZdReportsGetter?: Maybe<
    { __typename?: "ZdReportsGetter" } & {
      RequiredToolsByIds?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetReportToolsInsuranceByIdQueryVariables = Exact<{
  UUIDs?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  groupOne?: Maybe<Scalars["String"]>;
  groupTwo?: Maybe<Scalars["String"]>;
  Type: ReportType;
  lang: LangType;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Russia?: Maybe<Scalars["Boolean"]>;
}>;

export type GetReportToolsInsuranceByIdQuery = { __typename?: "Query" } & {
  ZdReportsGetter?: Maybe<
    { __typename?: "ZdReportsGetter" } & {
      ToolsInsuranceById?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetReportToolsInsuranceQueryVariables = Exact<{
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Russia?: Maybe<Scalars["Boolean"]>;
  Type: ReportType;
  lang: LangType;
}>;

export type GetReportToolsInsuranceQuery = { __typename?: "Query" } & {
  ZdReportsGetter?: Maybe<
    { __typename?: "ZdReportsGetter" } & {
      ToolsInsuranceByPlace?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetReportPersonalQueryVariables = Exact<{
  UUIDs?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  groupOne?: Maybe<Scalars["String"]>;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Russia?: Maybe<Scalars["Boolean"]>;
  Type: ReportType;
  lang: LangType;
}>;

export type GetReportPersonalQuery = { __typename?: "Query" } & {
  ZdReportsGetter?: Maybe<
    { __typename?: "ZdReportsGetter" } & {
      Personal?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetReportToolsMetrologicalQueryVariables = Exact<{
  UUIDs?: Maybe<Array<Maybe<Scalars["String"]>> | Maybe<Scalars["String"]>>;
  DealerIds?: Maybe<Array<Maybe<Scalars["ID"]>> | Maybe<Scalars["ID"]>>;
  Name?: Maybe<Scalars["String"]>;
  Type: ReportType;
  lang: LangType;
  FO?: Maybe<Scalars["String"]>;
  City?: Maybe<Scalars["String"]>;
  Russia?: Maybe<Scalars["Boolean"]>;
}>;

export type GetReportToolsMetrologicalQuery = { __typename?: "Query" } & {
  ZdReportsGetter?: Maybe<
    { __typename?: "ZdReportsGetter" } & {
      ToolsMetrologicalById?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetReportAllZdQueryVariables = Exact<{
  Type: ReportType;
}>;

export type GetReportAllZdQuery = { __typename?: "Query" } & {
  ZdReportsGetter?: Maybe<
    { __typename?: "ZdReportsGetter" } & {
      ZdStatus?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetDealerPlanReportQueryVariables = Exact<{
  DealerId: Scalars["ID"];
}>;

export type GetDealerPlanReportQuery = { __typename?: "Query" } & {
  ZdReportsGetter?: Maybe<
    { __typename?: "ZdReportsGetter" } & {
      PlanReport?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export type GetZdDealersActualQueryVariables = Exact<{ [key: string]: never }>;

export type GetZdDealersActualQuery = { __typename?: "Query" } & {
  ZdReportsGetter?: Maybe<
    { __typename?: "ZdReportsGetter" } & {
      ZdDealersActual?: Maybe<
        { __typename?: "ReportFile" } & Pick<ReportFile, "fileHash">
      >;
    }
  >;
};

export const EmployeeCardSupplementUserFragmentDoc = gql`
  fragment EmployeeCardSupplementUser on Profile {
    id
    login
    email
    phone
    fullname
    role
    roleRu
    Employee {
      id
    }
  }
`;
export const FragmentAccountingFragmentDoc = gql`
  fragment fragmentAccounting on DealerReport {
    id
    ReportsPeriodId
    DealerId
    status
    note
    updatedAt
    createdAt
    state
    Dealer {
      id
      DealerName
      DealerNameEn
      city
      cityEn
      FO
      FOEn
    }
    Files {
      id
      User {
        id
        login
        role
        roleEn
        roleRu
        status
      }
      name
      link
      mimeType
      type
      hash
      createdAt
    }
    ReportPeriod {
      id
      Year
      Quarter
      lastDate
      reportDate
      createdAt
    }
    _MTExMA__
    _MTEyMA__
    _MTEzMA__
    _MTE0MA__
    _MTE1MA__
    _MTE1MQ__
    _MTE1MS8x
    _MTE1MS8y
    _MTE1Mg__
    _MTE1Mi8x
    _MTE1Mi8y
    _MTE1Mw__
    _MTE1My8x
    _MTE1My8y
    _MTE1NA__
    _MTE1NC8x
    _MTE1NC8y
    _MTE2MA__
    _MTE3MA__
    _MTE3MQ__
    _MTE4MA__
    _MTE5MA__
    _MTE5MQ__
    _MTEwMA__
    _MTIxMA__
    _MTIxMQ__
    _MTIxMg__
    _MTIxMw__
    _MTIxNA__
    _MTIyMA__
    _MTIzMA__
    _MTIzMQ__
    _MTIzMg__
    _MTIzMw__
    _MTIzNA__
    _MTI0MA__
    _MTI1MA__
    _MTI2MA__
    _MTIwMA__
    _MTYwMA__
    _MTMxMA__
    _MTMyMA__
    _MTM0MA__
    _MTM1MA__
    _MTM2MA__
    _MTM3MA__
    _MTMwMA__
    _MTQxMA__
    _MTQyMA__
    _MTQzMA__
    _MTQ1MA__
    _MTQwMA__
    _MTUxMA__
    _MTUyMA__
    _MTUyMQ__
    _MTUyMg__
    _MTUyMw__
    _MTUzMA__
    _MTU0MA__
    _MTU1MA__
    _MTUwMA__
    _MjAwMA__
    _MjExMA__
    _MjExMQ__
    _MjExMg__
    _MjExMw__
    _MjExNA__
    _MjExNQ__
    _MjExNg__
    _MjExNw__
    _MjExOA__
    _MjEyMA__
    _MjEyMQ__
    _MjEyMg__
    _MjEyMw__
    _MjEyNA__
    _MjEyNQ__
    _MjEyNg__
    _MjEyNw__
    _MjEwMA__
    _MjIxMA__
    _MjIxMQ__
    _MjIxMS8x
    _MjIxMS8y
    _MjIxMS8z
    _MjIxMS80
    _MjIxMS81
    _MjIxMS82
    _MjIxMS83
    _MjIxMS84
    _MjIxMg__
    _MjIxMw__
    _MjIyMA__
    _MjIyMC8x
    _MjIyMC8y
    _MjIyMC8z
    _MjIyMC80
    _MjIyMC81
    _MjIyMC82
    _MjIyMC83
    _MjIyMC84
    _MjIyMC85
    _MjIyMC8xMA__
    _MjIyMC8xMQ__
    _MjIwMA__
    _MjMxMA__
    _MjMyMA__
    _MjMzMA__
    _MjM0MA__
    _MjM0MQ__
    _MjM0Mg__
    _MjM0Mw__
    _MjM1MA__
    _MjMwMA__
    _MjQxMA__
    _MjQxMQ__
    _MjQxMg__
    _MjQ2MA__
    _MjQwMA__
    _MjUxMA__
    _MjUyMA__
    _MjUwMA__
    _MjkxMA__
    _MjkwMA__
  }
`;
export const FragmentAccountingPeriodFragmentDoc = gql`
  fragment fragmentAccountingPeriod on ReportPeriod {
    id
    Year
    Quarter
    lastDate
    reportDate
    createdAt
  }
`;
export const FragmentAnnouncementFragmentDoc = gql`
  fragment fragmentAnnouncement on Announcement {
    id
    importance
    status
    date
    title
    text
    singedBy
    canceledReason
    SubdivisionId
    Documents {
      id
      User {
        id
        login
        email
        fullname
        fullnameEn
        role
        roleEn
        roleRu
      }
      name
      link
      mimeType
      type
      createdAt
      hash
    }
    createdAt
    createdBy
    createdByUser {
      id
      fullname
      fullnameEn
    }
  }
`;
export const CameraZoneFragmentDoc = gql`
  fragment CameraZone on CameraZone {
    id
    name
    createdAt
    updatedAt
    createdBy
    updatedBy
  }
`;
export const CameraFragmentDoc = gql`
  fragment Camera on Camera {
    id
    name
    cameraZoneId
    cameraUrl
    dealerId
    createdAt
    updatedAt
    createdBy
    updatedBy
    status
    CameraZone {
      ...CameraZone
    }
  }
  ${CameraZoneFragmentDoc}
`;
export const CameraChatMessageFragmentDoc = gql`
  fragment CameraChatMessage on Comment {
    id
    cameraCheckId
    comment
    createdAt
    createdBy
    fullName
  }
`;
export const CameraCheckFragmentDoc = gql`
  fragment CameraCheck on CameraCheck {
    id
    cameraId
    status
    comments {
      ...CameraChatMessage
    }
    name
    createdAt
    updatedAt
    createdBy
    updatedBy
  }
  ${CameraChatMessageFragmentDoc}
`;
export const CameraZonesListFragmentDoc = gql`
  fragment CameraZonesList on CameraZonesList {
    items {
      ...CameraZone
    }
    total
  }
  ${CameraZoneFragmentDoc}
`;
export const FragmentDealerForReportReturnLoyaltyServiceByDealerFragmentDoc = gql`
  fragment fragmentDealerForReportReturnLoyaltyServiceByDealer on Dealer {
    DealerName
    city
    INN
    FO
    subject
    entfCode
    status
  }
`;
export const FragmentDealershipsForSelectFragmentDoc = gql`
  fragment fragmentDealershipsForSelect on Dealer {
    DealerName
    DealerNameEn
    status
    id
    isIvideonActFormed
  }
`;
export const FragmentDealerToAssignFragmentDoc = gql`
  fragment fragmentDealerToAssign on DealerToAssign {
    id
    code
    INN
    DealerName
    DealerNameEn
    isMy
    status
  }
`;
export const FragmentDealerPanelFragmentDoc = gql`
  fragment fragmentDealerPanel on Dealer {
    id
    code
    INN
    DealerName
    DealerNameEn
    FO
    FOEn
    city
    cityEn
    subject
    subjectEn
    DealerLADASERV
    DealerName
    DealerNameEn
    Successor {
      id
      DealerName
      DealerNameEn
    }
  }
`;
export const FragmentDealerShipSquareDealerFragmentDoc = gql`
  fragment fragmentDealerShipSquareDealer on Dealer {
    id
    DealerLADASERV
    DealerName
    DealerNameEn
    Successor {
      id
      DealerName
      DealerNameEn
    }
  }
`;
export const FragmentDealerAreaFragmentDoc = gql`
  fragment fragmentDealerArea on DealerArea {
    SA {
      area
      filled
    }
    STOA {
      area
      filled
    }
    WA {
      area
      filled
    }
    BSA {
      area
      filled
    }
    TP {
      area
      filled
    }
  }
`;
export const FragmentGetDealersDomainsFragmentDoc = gql`
  fragment fragmentGetDealersDomains on DealerDomainsList {
    items {
      id
      domain
    }
    total
  }
`;
export const FragmentDealerWithPeriodsFragmentDoc = gql`
  fragment fragmentDealerWithPeriods on DealerWithPeriods {
    id
    INN
    DealerName
    DealerNameEn
    status
    createdAt
    type
    typeEn
    tradeDealerName
    tradeDealerNameEn
    legalDealerName
    legalDealerNameEn
    OrganizationalLegalForm
    code
    contractId
    successorCode
    ScanAccountantPersonDataId
    ScanLadaPersonDataId
    legalAddress
    postalAddress
    headName
    headNameEn
    headPhone
    headMobilePhone
    headEmail
    ownerName
    ownerNameEn
    ownerPhone
    ownerMobilePhone
    ownerEmail
    EP
    EPEn
    category
    address
    addressEn
    country
    countryEn
    FO
    FOEn
    subject
    subjectEn
    city
    cityEn
    birCode
    beginWorkingDate
    ent_id
    newDealer
    temporaryDecision
    protocolOfIntentions
    logicalType
    extendedForNextYear
    terminated
    hideOnLadaRu
    DealerLADASERV
    OGRN
    termOfAuthority
    corporateEmail
    EGR_Number
    EGR_Series
    EGR_Date
    settlementAccount
    correspondentAccount
    BIK
    bankName
    responsibleForLadaEmail
    responsibleForLadaFax
    responsibleForLadaPhone
    responsibleForLadaCode
    responsibleForLadaName
    accountantEmail
    accountantFax
    accountantPhone
    accountantCode
    accountantName
    protocolOfTermination
    protocolOfConclusion
    entfCode
    entfSuccessorNo
    entfSuccessorCode
    headFax
    headCode
    headNameGenitive
    headPositionGenitive
    headNameImported
    headPositionImported
    headEmailImported
    headPhoneImported
    headCompanyId
    PhotoDealerCenterId
    PhotoOwnerId
    PhotoBossId
    ScanOwnerPersonDataId
    ScanBossPersonDataId
    IS_Id
    Main
    KPP
    ContractEndDate
    regionCode
    consumerCode
    updatedAt
    periods {
      id
      isCreatedByUser
      dateStart
      dateEnd
      createdAt
    }
  }
`;
export const FragmentGetArchivePeriodsFragmentDoc = gql`
  fragment fragmentGetArchivePeriods on ArchivePeriod {
    isCreatedByUser
    dateStart
    dateEnd
    createdAt
    id
  }
`;
export const FragmentGetTemplatesFragmentDoc = gql`
  fragment fragmentGetTemplates on DealerContractTemplate {
    type
    html
    name
    createdAt
    id
  }
`;
export const FragmentFileFragmentDoc = gql`
  fragment fragmentFile on File {
    id
    User {
      id
    }
    name
    link
    mimeType
    createdAt
    hash
  }
`;
export const FragmentSubdivisionFragmentDoc = gql`
  fragment fragmentSubdivision on Subdivision {
    id
    code
    name
    status
    parentId
    createdAt
    Parent {
      id
      code
      name
      status
      parentId
      createdAt
    }
  }
`;
export const DocumentFragmentDoc = gql`
  fragment Document on Document {
    id
    name
    description
    status
    importance
    signedBy
    createdAt
    updatedAt
    createdBy
    updatedBy
    canceledReason
    Section {
      id
      name
      parentId
      createdAt
      updatedAt
      createdBy
      updatedBy
    }
    Files {
      ...fragmentFile
    }
    Subdivision {
      ...fragmentSubdivision
    }
  }
  ${FragmentFileFragmentDoc}
  ${FragmentSubdivisionFragmentDoc}
`;
export const FolderListFragmentDoc = gql`
  fragment FolderList on FolderContent {
    id
    name
    createdAt
    updatedAt
    updatedBy
    type
    createdBy
  }
`;
export const FragmentGroupsFragmentDoc = gql`
  fragment FragmentGroups on getListGroupCurriculum {
    items {
      id
      name
      status
      dateActiveStatus
      dateInactiveStatus
      createdAt
      updatedAt
      sequenceNumber
      InstanceId
      ActualFrom
      ActualTo
    }
  }
`;
export const FragmentCoursesFragmentDoc = gql`
  fragment FragmentCourses on CourseCurriculum {
    id
    name
    code
    codeIS
    certificateValidityPeriod
    LevelId
    status
    createdAt
    updatedAt
    Level {
      id
      name
      status
      dateActiveStatus
      dateInactiveStatus
      createdAt
      updatedAt
      sequenceNumber
      GroupId
      Group {
        id
        name
        status
        dateActiveStatus
        dateInactiveStatus
        createdAt
        updatedAt
        sequenceNumber
        InstanceId
        ActualFrom
        ActualTo
      }
      InstanceId
      ActualFrom
      ActualTo
    }
    InstanceId
    ActualFrom
    ActualTo
  }
`;
export const FragmentLevelsFragmentDoc = gql`
  fragment FragmentLevels on getListLevelCurriculum {
    items {
      id
      name
      status
      dateActiveStatus
      dateInactiveStatus
      createdAt
      updatedAt
      InstanceId
      ActualFrom
      ActualTo
      sequenceNumber
      GroupId
      Group {
        id
        name
        sequenceNumber
      }
    }
  }
`;
export const FragmentGroupFragmentDoc = gql`
  fragment FragmentGroup on GroupCurriculum {
    id
    name
    status
    dateActiveStatus
    dateInactiveStatus
    InstanceId
    ActualFrom
    ActualTo
    sequenceNumber
  }
`;
export const FragmentLevelFragmentDoc = gql`
  fragment FragmentLevel on LevelCurriculum {
    id
    name
    status
    dateActiveStatus
    dateInactiveStatus
    createdAt
    updatedAt
    InstanceId
    ActualFrom
    ActualTo
    sequenceNumber
    GroupId
    Group {
      id
      name
      status
      dateActiveStatus
      dateInactiveStatus
      createdAt
      updatedAt
      sequenceNumber
      InstanceId
      ActualFrom
      ActualTo
    }
    InstanceId
    ActualFrom
    ActualTo
  }
`;
export const FragmentCourseFragmentDoc = gql`
  fragment FragmentCourse on CourseCurriculum {
    id
    name
    code
    codeIS
    certificateValidityPeriod
    LevelId
    status
    createdAt
    updatedAt
    Level {
      id
      name
    }
    InstanceId
    ActualFrom
    ActualTo
  }
`;
export const FragmentPositionIsTheEducationProgramsFragmentDoc = gql`
  fragment FragmentPositionIsTheEducationPrograms on getPositionIsTheEducationPrograms {
    items {
      PositionGroupId
      Positions {
        id
        code
        name
        nameEn
        status
        DirectionId
        Direction {
          id
          name
          status
          createdAt
          updatedAt
          role
        }
        createdAt
        updatedAt
        InstanceId
        ActualFrom
        ActualTo
      }
    }
    total
  }
`;
export const FragmentCompositionsPositionsProgramFragmentDoc = gql`
  fragment FragmentCompositionsPositionsProgram on getCompositionPositionPrograms {
    Positions {
      id
      code
      name
      nameEn
      status
      DirectionId
      Direction {
        id
        name
        status
        createdAt
        updatedAt
        role
      }
      createdAt
      updatedAt
      InstanceId
      ActualFrom
      ActualTo
    }
    levels {
      id
      name
      status
      courses {
        id
        name
        status
        certificateValidityPeriod
        dateActiveStatus
        dateInactiveStatus
        createdAt
        updatedAt
      }
    }
  }
`;
export const FragmentPositionsInNotEducationProgramsFragmentDoc = gql`
  fragment FragmentPositionsInNotEducationPrograms on getPositionsInNotEducationPrograms {
    items {
      id
      code
      name
      nameEn
      status
      DirectionId
      Direction {
        id
        name
        status
        createdAt
        updatedAt
        role
      }
      createdAt
      updatedAt
      InstanceId
      ActualFrom
      ActualTo
    }
    total
  }
`;
export const FragmentGetListCoursesBySortLevelIdFragmentDoc = gql`
  fragment FragmentGetListCoursesBySortLevelId on CourseCurriculum {
    id
    name
    code
    codeIS
    certificateValidityPeriod
    LevelId
    status
    createdAt
    updatedAt
    Level {
      id
      name
    }
    InstanceId
    ActualFrom
    ActualTo
  }
`;
export const FragmentProfilePositionFragmentDoc = gql`
  fragment FragmentProfilePosition on Profile {
    id
    login
    email
    fullname
    fullnameEn
    phone
    position
    positionEn
    role
    roleRu
    roleEn
    status
    countDC
    lastOnlineDate
    createdAt
    isViolationAccess
    isEmployeeAccess
    isZdAccess
    isAnnouncementsAccess
    isAccountingAccess
    isAnnouncementsSend
    SubdivisionId
    lockDate
    Employee {
      id
      name
    }
  }
`;
export const PositionsFragmentFragmentDoc = gql`
  fragment PositionsFragment on Position {
    id
    code
    name
    DirectionId
    Direction {
      id
      role
    }
  }
`;
export const EachDealerInEmployeePositionFragmentDoc = gql`
  fragment EachDealerInEmployeePosition on EmployeePositions {
    id
    InstanceId
    startDate
    startOrderNumber
    endDate
    endOrderNumber
    createdBy
    createdAt
    PositionsId
    DealerId
    email
    emailVerificarion
    DataConsent {
      id
      link
      name
    }
    DataConsentId
    Dealer {
      id
      code
      DealerName
      DealerNameEn
    }
    hireByUser {
      ...FragmentProfilePosition
    }
    fireByUser {
      ...FragmentProfilePosition
    }
    verifyByUser {
      ...FragmentProfilePosition
    }
    lastModifiedByUser {
      ...FragmentProfilePosition
    }
    status
    lastStatusUpdateAt
    lastModifiedBy
    lastModifiedAt
    hireBy
    verifyBy
    verifyDate
    fireBy
    lastStatusUpdateByUser {
      ...FragmentProfilePosition
    }
    lastStatusUpdateBy
    Position {
      ...PositionsFragment
    }
    positionOrder {
      id
      name
      link
      mimeType
      createdAt
      type
      hash
    }
    positionOrderId
    jobDescription {
      id
      name
      link
      mimeType
      createdAt
      type
      hash
    }
    jobDescriptionId
  }
  ${FragmentProfilePositionFragmentDoc}
  ${PositionsFragmentFragmentDoc}
`;
export const FragmentPositionFragmentDoc = gql`
  fragment FragmentPosition on EmployeePositionsField {
    PositionsId
    Position {
      ...PositionsFragment
    }
    Education {
      training
      certificate
    }
    Positions {
      ...EachDealerInEmployeePosition
    }
  }
  ${PositionsFragmentFragmentDoc}
  ${EachDealerInEmployeePositionFragmentDoc}
`;
export const FragmentPositionsFragmentDoc = gql`
  fragment FragmentPositions on EmployeePositionsField {
    PositionsId
    Position {
      ...PositionsFragment
    }
    Education {
      training
      certificate
    }
    Positions {
      ...EachDealerInEmployeePosition
    }
  }
  ${PositionsFragmentFragmentDoc}
  ${EachDealerInEmployeePositionFragmentDoc}
`;
export const FragmentGetListFragmentDoc = gql`
  fragment fragmentGetList on Employee {
    id
    surname
    name
    middleName
    gender
    birthDay
    personalPhone
    workPhone
    photoId
    ResourcesControlUserId
    HiredDate
    FiredDate
    ladaAcademiaId
    MainActivePosition {
      ...EachDealerInEmployeePosition
    }
    Positions {
      number
      ActivePosition {
        ...FragmentPosition
      }
      InactivePositions {
        ...FragmentPositions
      }
    }
    lastEditDate
    createdBy
    CreatedByUser {
      id
      login
      email
      phone
      fullname
      fullnameEn
      role
      roleEn
      roleRu
      Employee {
        id
      }
    }
    firedAt
    firedBy
    lastEditBy
    LastEditByUser {
      id
      login
      email
      phone
      fullname
      fullnameEn
      role
      roleEn
      roleRu
      Employee {
        id
      }
    }
    FiredByUser {
      id
      login
      email
      phone
      fullname
      fullnameEn
      role
      roleEn
      roleRu
      Employee {
        id
      }
    }
    createdAt
    statusEmployee
    VerifiedByUser {
      id
      login
      email
      phone
      fullname
      fullnameEn
      role
      roleEn
      roleRu
      Employee {
        id
      }
    }
    lastStatusUpdateByUser {
      id
      login
      email
      phone
      fullname
      fullnameEn
      role
      roleEn
      roleRu
      Employee {
        id
      }
    }
    lastStatusUpdateAt
    verifiedBy
    verifiedAt
    shouldShowUpdateStatusDate
    firedBy
    firedAt
    FiredByUser {
      id
      login
      email
      phone
      fullname
      fullnameEn
      role
      roleEn
      roleRu
      Employee {
        id
      }
    }
    VerifiedByUser {
      id
      login
      email
      phone
      fullname
      fullnameEn
      role
      roleEn
      roleRu
      Employee {
        id
      }
    }
  }
  ${EachDealerInEmployeePositionFragmentDoc}
  ${FragmentPositionFragmentDoc}
  ${FragmentPositionsFragmentDoc}
`;
export const FragmentConsentsFragmentDoc = gql`
  fragment fragmentConsents on EmployeeConsent {
    id
    fileId
    employeeId
    createdAt
    systemId
    personalInfoId
    PersonalInfo {
      id
      name
      File {
        id
        name
        link
        mimeType
        createdAt
        type
      }
      InformationSystem {
        id
        name
      }
      createdAt
      updatedAt
      informationSystemId
      createdBy
      UpdatedBy
    }
    File {
      id
      name
      link
      mimeType
      createdAt
      type
    }
  }
`;
export const FragmentGetFragmentDoc = gql`
  fragment fragmentGet on Employee {
    id
    surname
    name
    middleName
    gender
    birthDay
    personalPhone
    workPhone
    firedAt
    firedBy
    lastEditBy
    Positions {
      number
      ActivePosition {
        ...FragmentPosition
      }
      InactivePositions {
        ...FragmentPositions
      }
    }
    LastEditByUser {
      id
      login
      email
      phone
      fullname
      fullnameEn
      role
      roleEn
      roleRu
      Employee {
        id
      }
    }
    FiredByUser {
      id
      login
      email
      phone
      fullname
      fullnameEn
      role
      roleEn
      roleRu
      Employee {
        id
      }
    }
    DataConsent {
      id
      name
      link
    }
    Consents {
      ...fragmentConsents
    }
    photoId
    Photo {
      id
      name
      link
    }
    lastStatusUpdateByUser {
      id
      login
      email
      phone
      fullname
      fullnameEn
      role
      roleEn
      roleRu
      Employee {
        id
      }
    }
    lastStatusUpdateAt
    shouldShowUpdateStatusDate
    ResourcesControlUserId
    HiredDate
    FiredDate
    ladaAcademiaId
    lastEditDate
    createdBy
    CreatedByUser {
      id
      login
      email
      phone
      fullname
      fullnameEn
      role
      roleEn
      roleRu
      Employee {
        id
      }
    }
    createdAt
    statusEmployee
    firedBy
    firedAt
    FiredByUser {
      id
      login
      email
      phone
      fullname
      fullnameEn
      role
      roleEn
      roleRu
      Employee {
        id
      }
    }
    VerifiedByUser {
      id
      login
      email
      phone
      fullname
      fullnameEn
      role
      roleEn
      roleRu
      Employee {
        id
      }
    }
    verifiedBy
    verifiedAt
  }
  ${FragmentPositionFragmentDoc}
  ${FragmentPositionsFragmentDoc}
  ${FragmentConsentsFragmentDoc}
`;
export const FragmentEmployeeLogFragmentDoc = gql`
  fragment fragmentEmployeeLog on EmployeeLog {
    id
    surname
    name
    middleName
    gender
    birthDay
    email
    personalPhone
    workPhone
    DataConsentId
    DataConsent {
      id
      name
      link
    }
    photoId
    Photo {
      id
      name
      link
    }
    ResourcesControlUserId
    HiredDate
    FiredDate
    positions {
      id
      number
      startDate
      startOrderNumber
      endDate
      endOrderNumber
      createdBy
      createdAt
      DealerId
    }
    lastEditDate
    createdBy
    createdAt
  }
`;
export const FragmentEmployeePositionLogFragmentDoc = gql`
  fragment fragmentEmployeePositionLog on EmployeePositionLog {
    id
    code
    name
    number
    startDate
    startOrderNumber
    endDate
    endOrderNumber
    DealerId
    EmployeesId
    createdBy
    createdAt
    Dealer {
      DealerName
      DealerNameEn
      INN
      city
      cityEn
      country
      countryEn
      FO
      FOEn
      id
    }
  }
`;
export const FragmentFileLinkFragmentDoc = gql`
  fragment fragmentFileLink on File {
    id
    link
    hash
  }
`;
export const FragmentFileCatalogFragmentDoc = gql`
  fragment fragmentFileCatalog on File {
    id
    User {
      id
      fullname
      fullnameEn
    }
    name
    link
    mimeType
    createdAt
    type
    hash
  }
`;
export const FragmentGlobalRatingVersionForTableFragmentDoc = gql`
  fragment fragmentGlobalRatingVersionForTable on GlobalRatingVersion {
    id
    quarter
    year
    dateBegin
    IndicatorId
  }
`;
export const FragmentGrRatingForTableFragmentDoc = gql`
  fragment fragmentGrRatingForTable on GlobalRating {
    id
    number
    name
    nameEn
    quarter1
    quarter2
    quarter1_2
    quarter3
    quarter2_3
    quarter4
    quarter3_4
    IndicatorQuarter1 {
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    IndicatorQuarter2 {
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    IndicatorQuarter1_2 {
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    IndicatorQuarter3 {
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    IndicatorQuarter2_3 {
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    IndicatorQuarter4 {
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    IndicatorQuarter3_4 {
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    yearValue
    yearPercent
    IndicatorYearPercent {
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    IndicatorYearValue {
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    type
    sort
    round
    format
    ParentId
    Parent {
      name
    }
    PrevElementId
    updatedAt
    createdAt
    RatingsVersionId
  }
`;
export const FragmentIndicatorForGrFragmentDoc = gql`
  fragment fragmentIndicatorForGr on Indicator {
    format
    Values {
      doubleValue
      stringValue
    }
  }
`;
export const FragmentGlobalRatingQuarer1FragmentDoc = gql`
  fragment fragmentGlobalRatingQuarer1 on GlobalRating {
    id
    number
    name
    nameEn
    quarter1
    yearPercent
    PrevElementId
    sort
    yearValue
    ParentId
    type
    round
    format
    IndicatorQuarter1 {
      ... on Indicator {
        ...fragmentIndicatorForGr
      }
    }
    IndicatorYearPercent {
      ... on Indicator {
        unit
        ...fragmentIndicatorForGr
      }
    }
    IndicatorYearValue {
      ... on Indicator {
        ...fragmentIndicatorForGr
      }
    }
  }
  ${FragmentIndicatorForGrFragmentDoc}
`;
export const FragmentGlobalRatingQuarer2FragmentDoc = gql`
  fragment fragmentGlobalRatingQuarer2 on GlobalRating {
    id
    number
    name
    nameEn
    quarter2
    quarter1_2
    PrevElementId
    sort
    yearPercent
    yearValue
    ParentId
    type
    round
    format
    IndicatorQuarter2 {
      ... on Indicator {
        ...fragmentIndicatorForGr
      }
    }
    IndicatorQuarter1_2 {
      ... on Indicator {
        ...fragmentIndicatorForGr
      }
    }
    IndicatorYearPercent {
      ... on Indicator {
        unit
        ...fragmentIndicatorForGr
      }
    }
    IndicatorYearValue {
      ... on Indicator {
        ...fragmentIndicatorForGr
      }
    }
  }
  ${FragmentIndicatorForGrFragmentDoc}
`;
export const FragmentGlobalRatingQuarer3FragmentDoc = gql`
  fragment fragmentGlobalRatingQuarer3 on GlobalRating {
    id
    number
    name
    nameEn
    quarter3
    quarter2_3
    sort
    yearPercent
    PrevElementId
    yearValue
    ParentId
    type
    round
    format
    IndicatorQuarter3 {
      ... on Indicator {
        ...fragmentIndicatorForGr
      }
    }
    IndicatorQuarter2_3 {
      ... on Indicator {
        ...fragmentIndicatorForGr
      }
    }
    IndicatorYearPercent {
      ... on Indicator {
        unit
        ...fragmentIndicatorForGr
      }
    }
    IndicatorYearValue {
      ... on Indicator {
        ...fragmentIndicatorForGr
      }
    }
  }
  ${FragmentIndicatorForGrFragmentDoc}
`;
export const FragmentGlobalRatingQuarer4FragmentDoc = gql`
  fragment fragmentGlobalRatingQuarer4 on GlobalRating {
    id
    number
    name
    nameEn
    quarter4
    quarter3_4
    sort
    PrevElementId
    yearPercent
    yearValue
    ParentId
    type
    round
    format
    IndicatorQuarter4 {
      ... on Indicator {
        ...fragmentIndicatorForGr
      }
    }
    IndicatorQuarter3_4 {
      ... on Indicator {
        ...fragmentIndicatorForGr
      }
    }
    IndicatorYearPercent {
      ... on Indicator {
        unit
        ...fragmentIndicatorForGr
      }
    }
    IndicatorYearValue {
      ... on Indicator {
        ...fragmentIndicatorForGr
      }
    }
  }
  ${FragmentIndicatorForGrFragmentDoc}
`;
export const FragmentGrRatingsListNameFragmentDoc = gql`
  fragment fragmentGrRatingsListName on GlobalRatingName {
    id
    name
    nameEn
    number
    ParentId
    PrevElementId
    RatingsVersionId
  }
`;
export const FragmentGrRatingForChartFragmentDoc = gql`
  fragment fragmentGrRatingForChart on GlobalRating {
    id
    name
    nameEn
    type
    IndicatorYearPercent {
      format
      Values {
        doubleValue
      }
    }
  }
`;
export const FragmentIndicatorFragmentDoc = gql`
  fragment fragmentIndicator on Indicator {
    id
    nameRu
    nameEn
    shortNameRu
    shortNameEn
    type
    format
    unit
    period
    status
    createdAt
    Values {
      DealerId
      doubleValue
      stringValue
      createdAt
    }
  }
`;
export const FragmentIndicatorForTableFragmentDoc = gql`
  fragment fragmentIndicatorForTable on Indicator {
    id
    type
    nameRu
    nameEn
    shortNameRu
    shortNameEn
    unit
    period
    format
    status
    enum
    createdAt
  }
`;
export const FragmentIndicatorForSelectFragmentDoc = gql`
  fragment fragmentIndicatorForSelect on Indicator {
    id
    nameRu
    nameEn
    shortNameRu
    shortNameEn
    enum
  }
`;
export const FragmentUploadListFragmentDoc = gql`
  fragment fragmentUploadList on UploadList {
    id
    UserId
    User {
      fullname
    }
    FileId
    File {
      name
    }
    description
    status
    createdAt
    type
    errors
  }
`;
export const FragmentUploadListForTableFragmentDoc = gql`
  fragment fragmentUploadListForTable on UploadList {
    id
    User {
      fullname
    }
    File {
      link
    }
    description
    status
    createdAt
    type
    errors
  }
`;
export const FragmentUploadListForErrorsFragmentDoc = gql`
  fragment fragmentUploadListForErrors on UploadList {
    id
    errors
  }
`;
export const FragmentIndicatorGroupsItemsFragmentDoc = gql`
  fragment fragmentIndicatorGroupsItems on IndicatorGroup {
    id
    nameRu
    nameEn
    status
    createdAt
    updatedAt
    createdBy
    createdByUser {
      fullname
    }
    writtenByUser {
      fullname
    }
  }
`;
export const FragmentGetIndicatorReportsFragmentDoc = gql`
  fragment fragmentGetIndicatorReports on IndicatorReport {
    id
    nameRu
    status
    createdBy
    createdAt
    updatedAt
    GroupId
    Fields {
      id
      fieldName
      fieldEnName
      fieldRu
      fieldEn
      fieldRuDescription
      fieldEnDescription
    }
    Indicators {
      id
      nameRu
    }
    Group {
      ...fragmentIndicatorGroupsItems
    }
    createdByUser {
      fullname
    }
    writtenBy
    writtenByUser {
      fullname
    }
  }
  ${FragmentIndicatorGroupsItemsFragmentDoc}
`;
export const FragmentDealerRegManInfoFragmentDoc = gql`
  fragment fragmentDealerRegManInfo on RegMenInfo {
    role
    roleRu
    roleEn
    roleRuAbbr
    roleEnAbbr
  }
`;
export const FragmentDealerFragmentDoc = gql`
  fragment fragmentDealer on Dealer {
    id
    ArchivePeriodId
    reestrAddress
    reestrPostAddress
    reestrLegalAddress
    KGA_CODE
    ONEC_CODE
    Period {
      id
      dateStart
      dateEnd
    }
    INN
    DealerName
    DealerNameEn
    status
    createdAt
    type
    typeEn
    tradeDealerName
    tradeDealerNameEn
    legalDealerName
    legalDealerNameEn
    OrganizationalLegalForm
    code
    X_SHOP_FLAG
    X_STO_PHCODE
    X_STO_PHONE
    X_STO_EMAIL
    X_SHOP_PHCODE
    X_SHOP_PHONE
    X_SHOP_EMAIL
    X_SHOP_NAME
    stoPhCode
    stoPhone
    stoEmail
    shopPhCode
    shopPhone
    shopEmail
    Contract {
      DealerId
      ArchiveDealerId
      TemplateId
      number
      date
      createdAt
    }
    contractId
    HeadCompanyDealer {
      id
      DealerName
      DealerNameEn
    }
    Successor {
      id
      DealerName
      DealerNameEn
    }
    successorCode
    PhotoDealerCenter {
      id
      link
    }
    PhotoOwner {
      id
      link
    }
    PhotoBoss {
      id
      link
    }
    ScanOwnerPersonData {
      id
      link
    }
    ScanBossPersonData {
      id
      link
    }
    ScanLadaPersonData {
      id
      link
    }
    ScanAccountantPersonData {
      id
      link
    }
    ScanAccountantPersonDataId
    ScanLadaPersonDataId
    legalAddress
    postalAddress
    headName
    headNameEn
    headPhone
    headMobilePhone
    headEmail
    ownerName
    ownerNameEn
    ownerPhone
    ownerMobilePhone
    ownerEmail
    EP
    EPEn
    category
    address
    addressEn
    country
    countryEn
    FO
    FOEn
    subject
    subjectEn
    city
    cityEn
    birCode
    beginWorkingDate
    Users {
      User {
        id
        fullname
        fullnameEn
        role
        roleEn
        roleRu
        email
        phone
        status
      }
    }
    ent_id
    newDealer
    temporaryDecision
    protocolOfIntentions
    logicalType
    extendedForNextYear
    terminated
    hideOnLadaRu
    DealerLADASERV
    OGRN
    termOfAuthority
    corporateEmail
    EGR_Number
    EGR_Series
    EGR_Date
    settlementAccount
    correspondentAccount
    BIK
    bankName
    responsibleForLadaEmail
    responsibleForLadaFax
    responsibleForLadaPhone
    responsibleForLadaCode
    responsibleForLadaName
    accountantEmail
    accountantFax
    accountantPhone
    accountantCode
    accountantName
    protocolOfTermination
    protocolOfConclusion
    entfCode
    entfSuccessorNo
    entfSuccessorCode
    headFax
    headCode
    headNameGenitive
    headPositionGenitive
    headNameImported
    headPositionImported
    headEmailImported
    headPhoneImported
    headCompanyId
    PhotoDealerCenterId
    PhotoOwnerId
    PhotoBossId
    ScanOwnerPersonDataId
    ScanBossPersonDataId
    IS_Id
    Main
    KPP
    ContractEndDate
    regionCode
    consumerCode
    updatedAt
    legalAddress
    legalCityId
    postalAddress
    postalCityId
    address
    addressEn
    CityId
    legalHouseId
    postalHouseId
    HouseId
    isIvideonActFormed
    ivideonSublicenseStartAt
    ladaBusiness
    ladaSport
  }
`;
export const FragmentDealerRegManFragmentDoc = gql`
  fragment fragmentDealerRegMan on DealerRegMan {
    fullname
    fullnameEn
    roleRu
    roleEn
  }
`;
export const FragmentDealersRegMenFragmentDoc = gql`
  fragment fragmentDealersRegMen on DealersRegMen {
    leaderRegionalSalesManager {
      ...fragmentDealerRegMan
    }
    regionalSalesManager {
      ...fragmentDealerRegMan
    }
    leaderRegionalServiceManager {
      ...fragmentDealerRegMan
    }
    regionalServiceManager {
      ...fragmentDealerRegMan
    }
  }
  ${FragmentDealerRegManFragmentDoc}
`;
export const FragmentIndicatorForRatingFragmentDoc = gql`
  fragment fragmentIndicatorForRating on Indicator {
    format
    unit
    Values {
      doubleValue
      stringValue
    }
  }
`;
export const FragmentIndicatorValueFragmentDoc = gql`
  fragment fragmentIndicatorValue on IndicatorValue {
    id
    doubleValue
    stringValue
    DealerId
    IndicatorId
    Indicator {
      ...fragmentIndicatorForRating
    }
    createdAt
  }
  ${FragmentIndicatorForRatingFragmentDoc}
`;
export const FragmentIndicatorReportToViewFragmentDoc = gql`
  fragment fragmentIndicatorReportToView on DealerIndicatorValues {
    Dealer {
      ...fragmentDealer
    }
    RegMen {
      ...fragmentDealersRegMen
    }
    Values {
      ...fragmentIndicatorValue
    }
  }
  ${FragmentDealerFragmentDoc}
  ${FragmentDealersRegMenFragmentDoc}
  ${FragmentIndicatorValueFragmentDoc}
`;
export const FragmentDealerForLogsFragmentDoc = gql`
  fragment fragmentDealerForLogs on DealerData {
    id
    DealerName
    INN
    code
    headCompanyId
    status
    category
    createdAt
    updatedAt
    type
    tradeDealerName
    legalDealerName
    code
    successorCode
    PhotoDealerCenterId
    PhotoOwnerId
    PhotoBossId
    ScanOwnerPersonDataId
    ScanBossPersonDataId
    headName
    headPhone
    headMobilePhone
    headEmail
    ownerName
    ownerPhone
    ownerMobilePhone
    ownerEmail
    EP
    category
    address
    country
    FO
    subject
    city
    birCode
    beginWorkingDate
  }
`;
export const FragmentPositionDirectionsFragmentDoc = gql`
  fragment fragmentPositionDirections on PositionDirections {
    id
    InstanceId
    ActualFrom
    ActualTo
    name
    status
    createdAt
    updatedAt
    role
  }
`;
export const FragmentPositionLogFragmentDoc = gql`
  fragment fragmentPositionLog on Position {
    id
    code
    name
    nameEn
    status
    DirectionId
    Direction {
      ...fragmentPositionDirections
    }
    ExpectationId
    createdAt
    updatedAt
    RequiredEmail
    InstanceId
    ActualFrom
    ActualTo
  }
  ${FragmentPositionDirectionsFragmentDoc}
`;
export const FragmentGroupCurriculumFragmentDoc = gql`
  fragment fragmentGroupCurriculum on GroupCurriculum {
    id
    name
    status
    dateActiveStatus
    dateInactiveStatus
    createdAt
    updatedAt
    sequenceNumber
    InstanceId
    ActualFrom
    ActualTo
  }
`;
export const FragmentLevelCurriculumFragmentDoc = gql`
  fragment fragmentLevelCurriculum on LevelCurriculum {
    id
    name
    status
    dateActiveStatus
    dateInactiveStatus
    createdAt
    updatedAt
    sequenceNumber
    GroupId
    Group {
      ...fragmentGroupCurriculum
    }
    InstanceId
    ActualFrom
    ActualTo
  }
  ${FragmentGroupCurriculumFragmentDoc}
`;
export const FragmentCourseCurriculumFragmentDoc = gql`
  fragment fragmentCourseCurriculum on CourseCurriculum {
    id
    name
    code
    codeIS
    certificateValidityPeriod
    LevelId
    statusCourse: status
    createdAt
    updatedAt
    Level {
      id
      name
    }
    InstanceId
    ActualFrom
    ActualTo
  }
`;
export const FragmentCurriculumStudyProgramsFragmentDoc = gql`
  fragment fragmentCurriculumStudyPrograms on CurriculumStudyPrograms {
    id
    PositionGroupId
    LevelId
    CourseId
    CurriculumStudyProgramsStatus: status
    dateActiveStatus
    dateInactiveStatus
    Positions {
      ...fragmentPositionLog
    }
    Level {
      ...fragmentLevelCurriculum
    }
    Course {
      ...fragmentCourseCurriculum
    }
    ActualFrom
    ActualTo
  }
  ${FragmentPositionLogFragmentDoc}
  ${FragmentLevelCurriculumFragmentDoc}
  ${FragmentCourseCurriculumFragmentDoc}
`;
export const FragmentEmailLogFragmentDoc = gql`
  fragment fragmentEmailLog on EmailLogListItem {
    id
    name
    email
    subject
    customs
    sent
    decidedToSend
    error
    createdAt
  }
`;
export const FragmentStaffForLogsFragmentDoc = gql`
  fragment fragmentStaffForLogs on EmployeeExpectation {
    method
    isCombining
    createdAt
  }
`;
export const FragmentGrRatingForLogsFragmentDoc = gql`
  fragment fragmentGrRatingForLogs on GlobalRating {
    number
    name
    quarter1
    quarter2
    quarter1_2
    quarter3
    quarter2_3
    quarter4
    quarter3_4
    type
    sort
    round
    ParentId
    Parent {
      name
    }
    PrevElementId
    updatedAt
    createdAt
    RatingsVersionId
  }
`;
export const FragmentQDataForLogsFragmentDoc = gql`
  fragment fragmentQDataForLogs on QuartilesRatingVersion {
    year
    quarter
    dateBegin
    Indicator {
      ... on Indicator {
        ...fragmentIndicatorForRating
      }
    }
    IndicatorGroup {
      ... on Indicator {
        ...fragmentIndicatorForRating
      }
    }
  }
  ${FragmentIndicatorForRatingFragmentDoc}
`;
export const FragmentQRatingForEditorLogsFragmentDoc = gql`
  fragment fragmentQRatingForEditorLogs on QuartilesRating {
    number
    KPIru
    KPIen
    LastPeriodIndicatorId
    ValueIndicatorId
    GroupIndicatorId
    AverageIndicatorId
    DifferenceIndicatorId
    GroupAverageIndicatorId
    updatedAt
    LastPeriodIndicator {
      period
    }
    ValueIndicator {
      period
    }
    GroupIndicator {
      period
    }
    AverageIndicator {
      period
    }
    DifferenceIndicator {
      period
    }
    GroupAverageIndicator {
      period
    }
  }
`;
export const FragmentProfileForLogsFragmentDoc = gql`
  fragment fragmentProfileForLogs on Profile {
    fullname
    login
    position
    email
    phone
    role
    countDC
    lastOnlineDate
    status
    createdAt
  }
`;
export const FragmentAnnouncementForLogsFragmentDoc = gql`
  fragment fragmentAnnouncementForLogs on AnnouncementLog {
    id
    importance
    status
    date
    title
    singedBy
    canceledReason
    SubdivisionId
    createdBy
    createdAt
    Documents {
      link
      name
      mimeType
    }
  }
`;
export const CatalogFragmentDoc = gql`
  fragment Catalog on Section {
    id
    name
    parentId
    parentName
    createdAt
    updatedAt
    createdBy
    updatedBy
    childCount
    subcatalogCount
  }
`;
export const FragmentDocumentForLogsFragmentDoc = gql`
  fragment fragmentDocumentForLogs on DocumentLog {
    id
    name
    description
    status
    canceledReason
    importance
    signedBy
    createdAt
    updatedAt
    createdBy
    updatedBy
    sectionId
    subSectionId
    Section {
      ...Catalog
    }
    SubSection {
      ...Catalog
    }
    Files {
      ...fragmentFile
    }
    Subdivision {
      ...fragmentSubdivision
    }
  }
  ${CatalogFragmentDoc}
  ${FragmentFileFragmentDoc}
  ${FragmentSubdivisionFragmentDoc}
`;
export const FragmentSectionForLogsFragmentDoc = gql`
  fragment fragmentSectionForLogs on SectionLog {
    id
    name
    parentId
    parentName
    createdAt
    updatedAt
    createdBy
    updatedBy
  }
`;
export const FragmentIndicatorForLogsFragmentDoc = gql`
  fragment fragmentIndicatorForLogs on Indicator {
    nameRu
    nameEn
    shortNameRu
    shortNameEn
    type
    format
    unit
    period
    status
    createdAt
    Values {
      DealerId
      doubleValue
      stringValue
      createdAt
    }
  }
`;
export const FragmentProfileFragmentDoc = gql`
  fragment fragmentProfile on Profile {
    fullname
    fullnameEn
    login
    position
    email
    phone
    role
    roleRu
    roleEn
    countDC
    lastOnlineDate
    id
    status
    createdAt
    isEmployeeAccess
    isViolationAccess
    isAnnouncementsAccess
    isCandidateAccess
    ivideon_access
    dnm_access
    isZdAccess
    isAnnouncementsSend
    isAccountingAccess
    SubdivisionId
    Subdivision {
      id
      name
    }
  }
`;
export const FragmentIndicatorReportForLogsFragmentDoc = gql`
  fragment fragmentIndicatorReportForLogs on IndicatorReport {
    id
    nameRu
    nameEn
    status
    createdBy
    createdAt
    updatedAt
    GroupId
    Group {
      ...fragmentIndicatorGroupsItems
    }
    Indicators {
      ...fragmentIndicatorForLogs
    }
    createdByUser {
      ...fragmentProfile
    }
    writtenBy
    writtenByUser {
      ...fragmentProfile
    }
  }
  ${FragmentIndicatorGroupsItemsFragmentDoc}
  ${FragmentIndicatorForLogsFragmentDoc}
  ${FragmentProfileFragmentDoc}
`;
export const FragmentIndicatorGroupForLogsFragmentDoc = gql`
  fragment fragmentIndicatorGroupForLogs on IndicatorGroup {
    id
    nameRu
    nameEn
    status
    Indicators {
      ...fragmentIndicatorForLogs
    }
    createdAt
    updatedAt
    createdBy
    createdByUser {
      ...fragmentProfile
    }
    writtenBy
    writtenByUser {
      ...fragmentProfile
    }
  }
  ${FragmentIndicatorForLogsFragmentDoc}
  ${FragmentProfileFragmentDoc}
`;
export const FragmentIndicatorAndReportFragmentDoc = gql`
  fragment fragmentIndicatorAndReport on IndicatorAndReport {
    ReportId
  }
`;
export const FragmentCameraForLogsFragmentDoc = gql`
  fragment fragmentCameraForLogs on CameraLog {
    id
    name
    cameraZoneId
    cameraUrl
    dealerId
    createdAt
    updatedAt
    createdBy
    updatedBy
    CameraZone
  }
`;
export const FragmentCameraZoneForLogsFragmentDoc = gql`
  fragment fragmentCameraZoneForLogs on CameraZoneLog {
    id
    name
    createdAt
    updatedAt
    createdBy
    updatedBy
  }
`;
export const FragmentCameraCheckForLogsFragmentDoc = gql`
  fragment fragmentCameraCheckForLogs on CameraCheckLog {
    id
    cameraId
    status
    name
    createdAt
    updatedAt
    createdBy
    updatedBy
  }
`;
export const FragmentCatalogCurriculumFragmentDoc = gql`
  fragment fragmentCatalogCurriculum on CatalogCurriculum {
    id
    GroupId
    LevelId
    CourseId
    Group {
      id
      name
    }
    Level {
      id
      name
    }
    Course {
      id
      name
    }
    createdAt
    updatedAt
    ActualFrom
    ActualTo
  }
`;
export const FragmentNotesFragmentDoc = gql`
  fragment fragmentNotes on NotesIndicatorTypes {
    id
    UUID
    ActualFrom
    ActualTo
    ComplianceIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    Name
    NameEn
    Number
    ImageIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
  }
`;
export const FragmentNotesValuesFragmentDoc = gql`
  fragment fragmentNotesValues on NotesOneValuesItem {
    id
    UUID
    ActualFrom
    ActualTo
    Compliance
    Name
    NameEn
    Number
    Image {
      id
      mimeType
      name
      hash
      link
      createdAt
    }
    planReportId
  }
`;
export const FragmentNotesDealerStatusesFragmentDoc = gql`
  fragment fragmentNotesDealerStatuses on NotesDealerStatuses {
    Dealer {
      id
      DealerName
      DealerNameEn
      city
      cityEn
      INN
      code
    }
    DealerId
    ZD_UUID
    tableIndex
    status
    updatedAt
  }
`;
export const FragmentPersonalFragmentDoc = gql`
  fragment fragmentPersonal on PersonalIndicatorTypes {
    id
    UUID
    ActualFrom
    ActualTo
    ComplianceIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    Name
    NameEn
    Number
    ImageIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    DocName
    PersonNameIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    PositionIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    PositionStartIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    StudyCertificateDateIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
  }
`;
export const FragmentPersonalValuesFragmentDoc = gql`
  fragment fragmentPersonalValues on PersonalOneValuesItem {
    id
    UUID
    ActualFrom
    ActualTo
    Compliance
    Name
    NameEn
    GroupOne
    GroupTwo
    Number
    StudyCertificateDate
    PersonName
    Position
    PositionStart
    tableIndex
    DealerId
    Image {
      id
      name
      link
      mimeType
      User {
        id
        email
        login
        fullname
        fullnameEn
      }
      createdAt
    }
    planReportId
    forUUID
    isList
    status
    statusUpdatedAt
    dealerValuesUpdatedAt
    list {
      PersonName
      Position
      GroupOne
      GroupTwo
      PositionStart
      id
      UUID
      ActualFrom
      ActualTo
      Compliance
      Number
      Name
      NameEn
      forUUID
      StudyCertificateDate
      planReportId
      tableIndex
      DealerId
      Image {
        id
        name
        link
        mimeType
        User {
          id
          email
          login
          fullname
          fullnameEn
        }
      }
    }
    emptyList {
      id
      UUID
      ActualFrom
      GroupOne
      GroupTwo
      ActualTo
      Compliance
      Number
      Name
      forUUID
      NameEn
      PersonName
      Position
      PositionStart
      StudyCertificateDate
      Image {
        id
        name
        link
        mimeType
        User {
          id
          email
          login
          fullname
          fullnameEn
        }
      }
      planReportId
      forUUID
      isList
      status
      statusUpdatedAt
      dealerValuesUpdatedAt
    }
    DocName
    status
    statusUpdatedAt
    PersonName
    Position
    PositionStart
    planReportId
  }
`;
export const FragmentPersonalDealerStatusesFragmentDoc = gql`
  fragment fragmentPersonalDealerStatuses on PersonalDealerStatuses {
    Dealer {
      id
      DealerName
      DealerNameEn
      city
      cityEn
      INN
      code
    }
    DealerId
    ZD_UUID
    tableIndex
    status
    updatedAt
  }
`;
export const FragmentPlacePostsFragmentDoc = gql`
  fragment fragmentPlacePosts on PlacePostsIndicatorTypes {
    id
    UUID
    ActualFrom
    ActualTo
    ComplianceIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    Name
    NameEn
    ZD_PlacesId
    TotalIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
  }
`;
export const FragmentPlacePostsValuesFragmentDoc = gql`
  fragment fragmentPlacePostsValues on PlacePostsOneValuesItem {
    id
    UUID
    ActualFrom
    ActualTo
    Compliance
    Name
    NameEn
    ZD_PlacesId
    Total
    planReportId
  }
`;
export const FragmentPlacePostsDealerStatusesFragmentDoc = gql`
  fragment fragmentPlacePostsDealerStatuses on PlacePostsDealerStatuses {
    Dealer {
      id
      DealerName
      DealerNameEn
      city
      cityEn
      INN
      code
    }
    DealerId
    ZD_UUID
    tableIndex
    status
    updatedAt
  }
`;
export const FragmentPlacesFragmentDoc = gql`
  fragment fragmentPlaces on PlacesIndicatorTypes {
    id
    UUID
    ActualFrom
    ActualTo
    ComplianceIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    Number
    Name
    NameEn
    GroupOne
    AreaIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    PlacesCombineIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
  }
`;
export const FragmentPlacesValuesFragmentDoc = gql`
  fragment fragmentPlacesValues on PlacesOneValuesItem {
    id
    UUID
    ActualFrom
    ActualTo
    Compliance
    Number
    GroupOne
    Name
    NameEn
    Area
    PlacesCombine
    planReportId
    list {
      id
      UUID
      ActualFrom
      ActualTo
      Name
      NameEn
      forUUID
      isList
      sort
      Compliance
      Number
      GroupOne
      Area
      PlacesCombine
      status
      statusUpdatedAt
      dealerValuesUpdatedAt
      planReportId
    }
    emptyList {
      id
      UUID
      ActualFrom
      ActualTo
      Name
      NameEn
      forUUID
      isList
      sort
      Compliance
      Number
      GroupOne
      Area
      PlacesCombine
      status
      statusUpdatedAt
      dealerValuesUpdatedAt
      planReportId
    }
  }
`;
export const FragmentPlacesDealerStatusesFragmentDoc = gql`
  fragment fragmentPlacesDealerStatuses on PlacesDealerStatuses {
    Dealer {
      id
      DealerName
      DealerNameEn
      city
      cityEn
      INN
      code
    }
    DealerId
    ZD_UUID
    tableIndex
    status
    updatedAt
  }
`;
export const FragmentPlanReportRowFragmentDoc = gql`
  fragment fragmentPlanReportRow on PlanReportRow {
    id
    DealerId
    DeclinedBy
    tableIndex
    ZD_UUID
    isResolved
    reason
    fixExplanation
    planToFixAt
    fixedAt
    resolvedAt
    responsiblePersonContact
    name
    nameEn
    fio
    createdAt
    Files {
      id
      User {
        id
        login
        fullname
        fullnameEn
        role
        roleEn
        roleRu
      }
      name
      link
      hash
      mimeType
      createdAt
      type
    }
  }
`;
export const ListPositionsFragmentDoc = gql`
  fragment ListPositions on getPositionListNew {
    items {
      id
      code
      name
      nameEn
      status
      Direction {
        id
        name
        status
      }
      createdAt
      updatedAt
      InstanceId
      ActualTo
      ActualFrom
      RequiredEmail
      showInZd
      jobDescriptionIsRequired
    }
  }
`;
export const ListDirectionsFragmentDoc = gql`
  fragment ListDirections on getDirections {
    items {
      id
      name
      status
      createdAt
      updatedAt
      role
    }
  }
`;
export const FragmentGetPositionByIdFragmentDoc = gql`
  fragment FragmentGetPositionById on Position {
    id
    code
    name
    nameEn
    status
    DirectionId
    Direction {
      id
      InstanceId
      ActualFrom
      ActualTo
      name
      status
      createdAt
      updatedAt
      role
    }
    createdAt
    updatedAt
    InstanceId
    ActualFrom
    ActualTo
    RequiredEmail
    jobDescriptionIsRequired
  }
`;
export const FragmentInformationSystemsFragmentDoc = gql`
  fragment FragmentInformationSystems on InformationSystem {
    id
    name
    Positions {
      id
      informationSystemId
      positionId
      createdAt
      Position {
        id
        name
      }
    }
    createdAt
    updatedAt
    createdBy
    UpdatedBy
    CreatedByUser {
      id
      login
      email
      fullname
    }
  }
`;
export const FragmentPersonalInformationFragmentDoc = gql`
  fragment FragmentPersonalInformation on PersonalInformation {
    id
    name
    File {
      id
      User {
        id
        login
        email
        fullname
      }
      name
      link
      mimeType
      createdAt
      type
      hash
    }
    InformationSystem {
      ...FragmentInformationSystems
    }
    createdAt
    updatedAt
    createdBy
    UpdatedBy
  }
  ${FragmentInformationSystemsFragmentDoc}
`;
export const FragmentGetTemplateConsentsDataProcessingFragmentDoc = gql`
  fragment FragmentGetTemplateConsentsDataProcessing on PositionConsents {
    name
    File {
      id
      User {
        id
        login
        email
        fullname
      }
      name
      link
      mimeType
      createdAt
      type
      hash
    }
  }
`;
export const FragmentProfileForTableFragmentDoc = gql`
  fragment fragmentProfileForTable on Profile {
    fullname
    fullnameEn
    login
    position
    positionEn
    email
    phone
    role
    roleEn
    roleRu
    countDC
    status
    lastOnlineDate
    id
    isEmployeeAccess
    isViolationAccess
    isAnnouncementsAccess
    isTemporaryAccessToAllDealers
    isZdAccess
    isAnnouncementsSend
    isAccountingAccess
    ivideon_access
    dnm_access
    isDocumentsAccess
    isCandidateAccess
    isCameraAccess
    isTrustedPersonAccess
    SubdivisionId
    Subdivision {
      id
      name
    }
  }
`;
export const FragmentProfileForHeaderFragmentDoc = gql`
  fragment fragmentProfileForHeader on Profile {
    fullname
    fullnameEn
    login
    role
    roleEn
    roleRu
    id
    isEmployeeAccess
    isViolationAccess
    isZdAccess
    isAnnouncementsAccess
    isTemporaryAccessToAllDealers
    isDocumentsAccess
    isAccountingAccess
    isAnnouncementsSend
    isCameraAccess
    isCandidateAccess
    isTrustedPersonAccess
    SubdivisionId
    lockDate
    email
    ivideon_access
    dnm_access
  }
`;
export const FragmentReportRegMenByDealerByPeriodFragmentDoc = gql`
  fragment fragmentReportRegMenByDealerByPeriod on ReportRegMenByDealerByPeriod {
    dealerId
    INN
    filial
    DealerName
    FO
    subject
    city
    entfCode
    successorCode
    entfSuccessorCode
    entfSuccessorNo
    leaderRegionalSalesManager
    regionalSalesManager
    leaderRegionalServiceManager
    regionalServiceManager
  }
`;
export const FragmentReportRegMenByDealerByRegMenFragmentDoc = gql`
  fragment fragmentReportRegMenByDealerByRegMen on ReportRegMenByDealerByRegMen {
    quarter
    year
    DealerName
    INN
    filial
    FO
    subject
    city
    entfCode
    successorCode
    entfSuccessorNo
    entfSuccessorCode
  }
`;
export const FragmentReportRegMenByDealerByDealerFragmentDoc = gql`
  fragment fragmentReportRegMenByDealerByDealer on ReportRegMenByDealerByDealer {
    quarter
    year
    leaderRegionalSalesManager
    regionalSalesManager
    leaderRegionalServiceManager
    regionalServiceManager
  }
`;
export const FragmentReportRegMenByDealerConsolidateFragmentDoc = gql`
  fragment fragmentReportRegMenByDealerConsolidate on ReportRegMenByDealerConsolidate {
    regionalManager
    role
    statistic {
      quarter
      year
      counts
    }
    periods
  }
`;
export const FragmentQuartilesRatingVersionForTableFragmentDoc = gql`
  fragment fragmentQuartilesRatingVersionForTable on QuartilesRatingVersion {
    id
    quarter
    year
    dateBegin
    IndicatorId
    IndicatorGroupId
  }
`;
export const FragmentQRatingForEditorTableFragmentDoc = gql`
  fragment fragmentQRatingForEditorTable on QuartilesRating {
    id
    number
    KPIru
    KPIen
    LastPeriodIndicatorId
    ValueIndicatorId
    GroupIndicatorId
    AverageIndicatorId
    DifferenceIndicatorId
    GroupAverageIndicatorId
    updatedAt
    sort
    format
    round
    type
    LastPeriodIndicator {
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    ValueIndicator {
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    GroupIndicator {
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    AverageIndicator {
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    DifferenceIndicator {
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    GroupAverageIndicator {
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    Parent {
      KPIen
      KPIru
    }
    ParentId
    PrevElement {
      KPIen
      KPIru
    }
    PrevElementId
  }
`;
export const FragmentRatingsListNameFragmentDoc = gql`
  fragment fragmentRatingsListName on QuartilesRatingName {
    id
    KPIen
    KPIru
    number
    ParentId
    PrevElementId
    RatingsVersionId
  }
`;
export const FragmentQRatingForTableFragmentDoc = gql`
  fragment fragmentQRatingForTable on QuartilesRating {
    id
    number
    KPIru
    KPIen
    round
    format
    LastPeriodIndicator {
      period
      Values {
        createdAt
      }
    }
    ValueIndicator {
      ... on Indicator {
        ...fragmentIndicatorForRating
      }
    }
    GroupIndicator {
      ... on Indicator {
        ...fragmentIndicatorForRating
      }
    }
    AverageIndicator {
      ... on Indicator {
        ...fragmentIndicatorForRating
      }
    }
    DifferenceIndicator {
      ... on Indicator {
        ...fragmentIndicatorForRating
      }
    }
    GroupAverageIndicator {
      ... on Indicator {
        ...fragmentIndicatorForRating
      }
    }
    type
    ParentId
  }
  ${FragmentIndicatorForRatingFragmentDoc}
`;
export const FragmentQRatingForChartFragmentDoc = gql`
  fragment fragmentQRatingForChart on QuartilesRating {
    LastPeriodIndicator {
      period
      Values {
        doubleValue
        stringValue
        createdAt
      }
    }
    ValueIndicator {
      Values {
        doubleValue
        stringValue
        createdAt
      }
    }
    GroupIndicator {
      Values {
        doubleValue
        stringValue
        createdAt
      }
    }
    AverageIndicator {
      Values {
        doubleValue
        stringValue
        createdAt
      }
    }
    DifferenceIndicator {
      Values {
        doubleValue
        stringValue
        createdAt
      }
    }
    GroupAverageIndicator {
      Values {
        doubleValue
        stringValue
        createdAt
      }
    }
    round
    format
    KPIen
    KPIru
  }
`;
export const FragmentQDataForTableFragmentDoc = gql`
  fragment fragmentQDataForTable on QuartilesRatingVersion {
    id
    year
    quarter
    dateBegin
    Indicator {
      ... on Indicator {
        ...fragmentIndicatorForRating
        period
        Values {
          createdAt
        }
      }
    }
    IndicatorGroup {
      ... on Indicator {
        ...fragmentIndicatorForRating
        Values {
          createdAt
        }
      }
    }
  }
  ${FragmentIndicatorForRatingFragmentDoc}
`;
export const FragmentRequiredToolsFragmentDoc = gql`
  fragment fragmentRequiredTools on RequiredToolsIndicatorTypes {
    id
    UUID
    ActualFrom
    ActualTo
    ComplianceIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    Number
    Name
    NameEn
    ModelIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    TotalIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    CheckedDateIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
  }
`;
export const FragmentRequiredToolsValuesFragmentDoc = gql`
  fragment fragmentRequiredToolsValues on RequiredToolsOneValuesItem {
    id
    UUID
    ActualFrom
    ActualTo
    Compliance
    Number
    Name
    NameEn
    Total
    Model
    planReportId
    forUUID
    GroupOne
    isList
    status
    sort
    statusUpdatedAt
    dealerValuesUpdatedAt
    tableIndex
    DealerId
    list {
      id
      UUID
      ActualFrom
      ActualTo
      Compliance
      Number
      Name
      NameEn
      Total
      Model
      planReportId
      forUUID
      isList
      status
      statusUpdatedAt
      dealerValuesUpdatedAt
      CheckedDate
      tableIndex
      DealerId
    }
    emptyList {
      id
      UUID
      ActualFrom
      ActualTo
      Compliance
      Number
      Name
      NameEn
      Total
      Model
      planReportId
      forUUID
      isList
      status
      statusUpdatedAt
      dealerValuesUpdatedAt
      tableIndex
    }
  }
`;
export const FragmentRequiredToolsDealerStatusesFragmentDoc = gql`
  fragment fragmentRequiredToolsDealerStatuses on RequiredToolsDealerStatuses {
    Dealer {
      id
      DealerName
      DealerNameEn
      city
      cityEn
      INN
      code
    }
    DealerId
    ZD_UUID
    tableIndex
    status
    updatedAt
  }
`;
export const FragmentLogForZdRequiredToolsFragmentDoc = gql`
  fragment fragmentLogForZdRequiredTools on ZdRequiredToolsType {
    UUID
    tableIndex
    name
    nameEn
    Model
    Total
    CheckedDate
    Compliance
  }
`;
export const FragmentCarForServiceByMonthFragmentDoc = gql`
  fragment fragmentCarForServiceByMonth on CarForServiceByMonth {
    dealer {
      id
      code
      ent_id
      INN
      birCode
      entfSuccessorCode
      entfSuccessorNo
      city
      FO
      DealerName
      subject
      counts
      family
      TO0 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO1 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO2 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO3 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO4 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO5 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO6 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO7 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO8 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
    }
    city {
      city
      cityEn
      subject
      subjectEn
      counts
      FO
      family
      TO0 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO1 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO2 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO3 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO4 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO5 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO6 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO7 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO8 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
    }
    FO {
      FO
      FOEn
      counts
      family
      TO0 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO1 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO2 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO3 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO4 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO5 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO6 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO7 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO8 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
    }
    country {
      country
      countryEn
      counts
      family
      TO0 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO1 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO2 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO3 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO4 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO5 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO6 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO7 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO8 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
    }
    region {
      subject
      subjectEn
      counts
      FO
      family
      TO0 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO1 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO2 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO3 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO4 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO5 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO6 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO7 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
      TO8 {
        cars
        carsForeign
        saleCount
        carsCityGIBDD
        carsRegionGIBDD
        carsAllRegionGIBDD
      }
    }
  }
`;
export const FragmentFamilyCarFragmentDoc = gql`
  fragment fragmentFamilyCar on familyCar {
    id
    name
    code
    actual
  }
`;
export const FragmentSalesCarFragmentDoc = gql`
  fragment fragmentSalesCar on SalesCar {
    dateSales
    price
    sellerName
    sellerPosition
    carId
    clientId
    dealerId
    createdAt
    updatedAt
    Car {
      vin
      collection
      engine
      eqFamilyCode
      eqNumber
      eqVariant
      createdAt
      updatedAt
    }
  }
`;
export const FragmentNsDealerDataPeriodsDataFragmentDoc = gql`
  fragment fragmentNSDealerDataPeriodsData on NSDealerDataPeriodsData {
    periodStart
    periodEnd
    periodStr
    soldCars
    soldCarsToNewClients
    percentNewClients
    soldCarsToLoyalClients
    soldCarsToLoyalClientsMoney
    percentLoyalClients
    twoCars
    percentTwoCars
    threeCars
    percentThreeCars
    fourOrMoreCars
    percentFourOrMoreCars
  }
`;
export const FragmentCarsForServiceByPeriodConsolidatedFragmentDoc = gql`
  fragment fragmentCarsForServiceByPeriodConsolidated on CarsForServiceByPeriodConsolidated {
    sales {
      cars {
        vin
        eqFamilyCode
        eqNumber
        eqVariant
        dateSales
        familyCar
      }
      client {
        name
        phone
        email
      }
      dealer {
        name
        inn
        dealerId
        city
      }
      TO0 {
        name
        inn
        dealerId
        dateVisit
        countDay
      }
      TO1 {
        name
        inn
        dealerId
        dateVisit
        countDay
      }
      TO2 {
        name
        inn
        dealerId
        dateVisit
        countDay
      }
      TO3 {
        name
        inn
        dealerId
        dateVisit
        countDay
      }
      TO4 {
        name
        inn
        dealerId
        dateVisit
        countDay
      }
      TO5 {
        name
        inn
        dealerId
        dateVisit
        countDay
      }
      TO6 {
        name
        inn
        dealerId
        dateVisit
        countDay
      }
      TO7 {
        name
        inn
        dealerId
        dateVisit
        countDay
      }
      TO8 {
        name
        inn
        dealerId
        dateVisit
        countDay
      }
    }
  }
`;
export const FragmentCarsForServiceByMonthRegionFragmentDoc = gql`
  fragment fragmentCarsForServiceByMonthRegion on CarsForServiceByMonthRegion {
    cars {
      model {
        id
        name
        code
        actual
      }
      TO0 {
        salesCount
        servicesCount
      }
      TO1 {
        salesCount
        servicesCount
      }
      TO2 {
        salesCount
        servicesCount
      }
      TO3 {
        salesCount
        servicesCount
      }
      TO4 {
        salesCount
        servicesCount
      }
      TO5 {
        salesCount
        servicesCount
      }
      TO6 {
        salesCount
        servicesCount
      }
      TO7 {
        salesCount
        servicesCount
      }
      TO8 {
        salesCount
        servicesCount
      }
    }
    models {
      id
      name
      actual
      code
    }
  }
`;
export const FragmentCarForAgoByMonthFragmentDoc = gql`
  fragment fragmentCarForAGOByMonth on CarForAGOByMonth {
    dealer {
      id
      code
      ent_id
      INN
      birCode
      entfSuccessorCode
      entfSuccessorNo
      city
      FO
      DealerName
      subject
      counts
      GO1 {
        cars
        carsForeign
        saleCount
      }
      GO2 {
        cars
        carsForeign
        saleCount
      }
      GO3 {
        cars
        carsForeign
        saleCount
      }
    }
    city {
      city
      cityEn
      subject
      subjectEn
      counts
      FO
      GO1 {
        cars
        carsForeign
        saleCount
      }
      GO2 {
        cars
        carsForeign
        saleCount
      }
      GO3 {
        cars
        carsForeign
        saleCount
      }
    }
    FO {
      FO
      FOEn
      counts
      GO1 {
        cars
        carsForeign
        saleCount
      }
      GO2 {
        cars
        carsForeign
        saleCount
      }
      GO3 {
        cars
        carsForeign
        saleCount
      }
    }
    country {
      country
      countryEn
      counts
      GO1 {
        cars
        carsForeign
        saleCount
      }
      GO2 {
        cars
        carsForeign
        saleCount
      }
      GO3 {
        cars
        carsForeign
        saleCount
      }
    }
    region {
      subject
      subjectEn
      counts
      FO
      GO1 {
        cars
        carsForeign
        saleCount
      }
      GO2 {
        cars
        carsForeign
        saleCount
      }
      GO3 {
        cars
        carsForeign
        saleCount
      }
    }
  }
`;
export const FragmentCarForServiceDynamicsFragmentDoc = gql`
  fragment fragmentCarForServiceDynamics on CarForServiceDynamics {
    data {
      period
      TO0
      TO1
      TO2
      TO3
      TO4
      TO5
      TO6
      TO7
      TO8
      AllTO
      Warranty
      writ
    }
  }
`;
export const FragmentCarForSrr3ByPeriodFragmentDoc = gql`
  fragment fragmentCarForSRR3ByPeriod on CarForSRR3ByPeriod {
    period
    TO1 {
      saleCount
      serviceCount
    }
    TO2 {
      saleCount
      serviceCount
    }
    TO3 {
      saleCount
      serviceCount
    }
    SRR {
      saleCount
      serviceCount
    }
  }
`;
export const FragmentCarForSrr5ByPeriodFragmentDoc = gql`
  fragment fragmentCarForSRR5ByPeriod on CarForSRR5ByPeriod {
    period
    TO1 {
      saleCount
      serviceCount
    }
    TO2 {
      saleCount
      serviceCount
    }
    TO3 {
      saleCount
      serviceCount
    }
    TO4 {
      saleCount
      serviceCount
    }
    TO5 {
      saleCount
      serviceCount
    }
    SRR {
      saleCount
      serviceCount
    }
  }
`;
export const FragmentClientsWithoutServiceFragmentDoc = gql`
  fragment fragmentClientsWithoutService on ClientsWithoutService {
    percent
    period
    monthSale
    countCar
    withoutServices
  }
`;
export const FragmentdealerForServiceByMonthFragmentDoc = gql`
  fragment fragmentdealerForServiceByMonth on dealerForServiceByMonth {
    id
    code
    ent_id
    INN
    birCode
    entfSuccessorCode
    entfSuccessorNo
    city
    FO
    DealerName
    subject
    counts
    TO0 {
      cars
      carsForeign
      saleCount
      carsCityGIBDD
      carsRegionGIBDD
      carsAllRegionGIBDD
    }
    TO1 {
      cars
      carsForeign
      saleCount
      carsCityGIBDD
      carsRegionGIBDD
      carsAllRegionGIBDD
    }
    TO2 {
      cars
      carsForeign
      saleCount
      carsCityGIBDD
      carsRegionGIBDD
      carsAllRegionGIBDD
    }
    TO3 {
      cars
      carsForeign
      saleCount
      carsCityGIBDD
      carsRegionGIBDD
      carsAllRegionGIBDD
    }
    TO4 {
      cars
      carsForeign
      saleCount
      carsCityGIBDD
      carsRegionGIBDD
      carsAllRegionGIBDD
    }
    TO5 {
      cars
      carsForeign
      saleCount
      carsCityGIBDD
      carsRegionGIBDD
      carsAllRegionGIBDD
    }
    TO6 {
      cars
      carsForeign
      saleCount
      carsCityGIBDD
      carsRegionGIBDD
      carsAllRegionGIBDD
    }
    TO7 {
      cars
      carsForeign
      saleCount
      carsCityGIBDD
      carsRegionGIBDD
      carsAllRegionGIBDD
    }
    TO8 {
      cars
      carsForeign
      saleCount
      carsCityGIBDD
      carsRegionGIBDD
      carsAllRegionGIBDD
    }
  }
`;
export const FragmentCarsForAverageDailyMileageByMonthFragmentDoc = gql`
  fragment fragmentCarsForAverageDailyMileageByMonth on CarsForAverageDailyMileageByMonth {
    model {
      id
      name
      code
      actual
    }
    TO0 {
      countCar
      averageDay
      mileage
    }
    TO1 {
      countCar
      averageDay
      mileage
    }
    TO2 {
      countCar
      averageDay
      mileage
    }
    TO3 {
      countCar
      averageDay
      mileage
    }
    TO4 {
      countCar
      averageDay
      mileage
    }
    TO5 {
      countCar
      averageDay
      mileage
    }
    TO6 {
      countCar
      averageDay
      mileage
    }
    TO7 {
      countCar
      averageDay
      mileage
    }
    TO8 {
      countCar
      averageDay
      mileage
    }
  }
`;
export const FragmentCarForServiceByDealerFragmentDoc = gql`
  fragment fragmentCarForServiceByDealer on CarForServiceByDealer {
    dealer {
      id
      code
      ent_id
      INN
      birCode
      entfSuccessorCode
      entfSuccessorNo
      city
      FO
      DealerName
      subject
      periods {
        period
        TO {
          TO0
          TO1
          TO2
          TO3
          TO4
          TO5
          TO6
          TO7
          TO8
          AllTO
          Warranty
          writ
        }
      }
    }
    city {
      city
      FO
      subject
      periods {
        period
        TO {
          TO0
          TO1
          TO2
          TO3
          TO4
          TO5
          TO6
          TO7
          TO8
          AllTO
          Warranty
          writ
        }
      }
    }
    country {
      periods {
        period
        TO {
          TO0
          TO1
          TO2
          TO3
          TO4
          TO5
          TO6
          TO7
          TO8
          AllTO
          Warranty
          writ
        }
      }
    }
    FO {
      FO
      periods {
        period
        TO {
          TO0
          TO1
          TO2
          TO3
          TO4
          TO5
          TO6
          TO7
          TO8
          AllTO
          Warranty
          writ
        }
      }
    }
    region {
      FO
      subject
      periods {
        period
        TO {
          TO0
          TO1
          TO2
          TO3
          TO4
          TO5
          TO6
          TO7
          TO8
          AllTO
          Warranty
          writ
        }
      }
    }
  }
`;
export const FragmentGibddTypeFragmentDoc = gql`
  fragment fragmentGIBDDType on GIBDDType {
    id
    vin
    dateRegistration
    city
    district
    region
    federalArea
    createdAt
    updatedAt
  }
`;
export const FragmentDealerForPaymentsByDealerFragmentDoc = gql`
  fragment fragmentDealerForPaymentsByDealer on dealerForPaymentsByDealer {
    id
    code
    ent_id
    INN
    birCode
    entfSuccessorCode
    entfSuccessorNo
    city
    FO
    DealerName
    subject
    country
    periods {
      period
      target
      countSale
      countService
      percent
      percentTarget
    }
  }
`;
export const FragmentDealerByCarByDealerFragmentDoc = gql`
  fragment fragmentDealerByCarByDealer on dealerByCarByDealer {
    id
    code
    INN
    birCode
    entfSuccessorCode
    entfSuccessorNo
    city
    ent_id
    FO
    DealerName
    subject
    country
    family
    periods {
      TO1 {
        countSale
        countService
        percent
      }
      TO2 {
        countSale
        countService
        percent
      }
      TO3 {
        countSale
        countService
        percent
      }
      TO4 {
        countSale
        countService
        percent
      }
      TO5 {
        countSale
        countService
        percent
      }
      period
    }
  }
`;
export const FragmentDealerByCarByVinFragmentDoc = gql`
  fragment fragmentDealerByCarByVIN on dealerByCarByVIN {
    ent_id
    id
    DealerName
    INN
    code
    phone
    dateSales
    VIN
    eqFamilyCode
    eqNumber
    eqVariant
    name
    model
    TO1 {
      dateVisit
      dealerName
    }
    TO2 {
      dateVisit
      dealerName
    }
    TO3 {
      dateVisit
      dealerName
    }
  }
`;
export const FragmentCarForSrr3GibddByPeriodFragmentDoc = gql`
  fragment fragmentCarForSRR3GIBDDByPeriod on CarForSRR3GIBDDByPeriod {
    period
    TO1 {
      serviceCount
      saleCount
      carsCityGIBDD
      carsRegionGIBDD
      carsAllRegionGIBDD
    }
    TO2 {
      serviceCount
      saleCount
      carsCityGIBDD
      carsRegionGIBDD
      carsAllRegionGIBDD
    }
    TO3 {
      serviceCount
      saleCount
      carsCityGIBDD
      carsRegionGIBDD
      carsAllRegionGIBDD
    }
    SRR {
      serviceCount
      saleCount
      carsCityGIBDD
      carsRegionGIBDD
      carsAllRegionGIBDD
    }
  }
`;
export const FragmentCarForSrr5GibddByPeriodFragmentDoc = gql`
  fragment fragmentCarForSRR5GIBDDByPeriod on CarForSRR5GIBDDByPeriod {
    period
    TO1 {
      serviceCount
      saleCount
      carsCityGIBDD
      carsRegionGIBDD
      carsAllRegionGIBDD
    }
    TO2 {
      serviceCount
      saleCount
      carsCityGIBDD
      carsRegionGIBDD
      carsAllRegionGIBDD
    }
    TO3 {
      serviceCount
      saleCount
      carsCityGIBDD
      carsRegionGIBDD
      carsAllRegionGIBDD
    }
    TO4 {
      serviceCount
      saleCount
      carsCityGIBDD
      carsRegionGIBDD
      carsAllRegionGIBDD
    }
    TO5 {
      serviceCount
      saleCount
      carsCityGIBDD
      carsRegionGIBDD
      carsAllRegionGIBDD
    }
    SRR {
      serviceCount
      saleCount
      carsCityGIBDD
      carsRegionGIBDD
      carsAllRegionGIBDD
    }
  }
`;
export const FragmentUniqueServiceFragmentDoc = gql`
  fragment fragmentUniqueService on uniqueService {
    name
    ten_year
    five_year
    data {
      year
      count
    }
  }
`;
export const FragmentLoyaltyServiceFragmentDoc = gql`
  fragment fragmentLoyaltyService on loyaltyService {
    tableUnique {
      ... on uniqueService {
        ...fragmentUniqueService
      }
    }
    tableLoyalty {
      ... on uniqueService {
        ...fragmentUniqueService
      }
    }
  }
  ${FragmentUniqueServiceFragmentDoc}
`;
export const FragmentLoyaltyServicePeriodFragmentDoc = gql`
  fragment fragmentLoyaltyServicePeriod on loyaltyServicePeriod {
    period
    sale5
    serviceCars5
    Loyalty5
    sale10
    serviceCars10
    Loyalty10
  }
`;
export const FragmentInviteClientToServiceFragmentDoc = gql`
  fragment fragmentInviteClientToService on inviteClientToService {
    id
    car
    fio
    phone
    email
    agree
    dateSales
    vin
    maxDateVisit
    avgRun
    lastComment
    prevTODealer
    prevToText
    nextToDate
  }
`;
export const FragmentNsByOldClientsDataFragmentDoc = gql`
  fragment fragmentNSByOldClientsData on NSByOldClientsData {
    dealer {
      DealerName
      DealerNameEn
      id
      code
      ent_id
      INN
      birCode
      entfSuccessorCode
      entfSuccessorNo
      city
      FO
      subject
      status
    }
    carsTotal
    car {
      vin
      collection
      engine
      eqFamilyCode
      eqNumber
      eqVariant
      createdAt
      updatedAt
    }
    carModel
    sellDate
    ownerChangeDate
    ownershipPeriod
    carSaleDate
    newCarDate
  }
`;
export const FragmentNsByAverageCarAgeDataFragmentDoc = gql`
  fragment fragmentNSByAverageCarAgeData on NSByAverageCarAgeData {
    rows {
      dealer {
        DealerName
        DealerNameEn
        id
        code
        ent_id
        INN
        birCode
        entfSuccessorCode
        entfSuccessorNo
        city
        FO
        subject
        status
      }
      client {
        type
        name
        phone
        email
        createdAt
        updatedAt
      }
      vin
      MKB
      carPresumedSaleDate
      carPurchaseDate
      TO1
      TO2
      TO3
      TO4
      TO5
      mileage
      ownerChange
      ownershipPeriodByChange
      ownershipPeriodByEPlatform
    }
    average {
      carOwnershipByChange {
        ownershipPeriodFrom
        ownershipPeriodTo
        carsTotal
      }
      carOwnershipByEPlatform {
        ownershipPeriodFrom
        ownershipPeriodTo
        carsTotal
      }
    }
  }
`;
export const FragmentNsByClientCarSaleDataFragmentDoc = gql`
  fragment fragmentNSByClientCarSaleData on NSByClientCarSaleData {
    dealer {
      DealerName
      DealerNameEn
      id
      code
      ent_id
      INN
      birCode
      entfSuccessorCode
      entfSuccessorNo
      city
      FO
      subject
      status
    }
    carsOnEPlatform
    clientsLada
    percentCarsOnEPlatform
  }
`;
export const FragmentServicesFragmentDoc = gql`
  fragment fragmentServices on ServicesIndicatorTypes {
    id
    UUID
    ActualFrom
    ActualTo
    ComplianceIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    Code
    Name
    NameEn
    FactIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    CertificationDateIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    FactContractIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
  }
`;
export const FragmentServicesValuesFragmentDoc = gql`
  fragment fragmentServicesValues on ServicesOneValuesItem {
    id
    UUID
    ActualFrom
    ActualTo
    Compliance
    Code
    Name
    NameEn
    Fact
    CertificationDate
    FactContract
    planReportId
  }
`;
export const FragmentServicesDealerStatusesFragmentDoc = gql`
  fragment fragmentServicesDealerStatuses on ServicesDealerStatuses {
    Dealer {
      id
      DealerName
      DealerNameEn
      city
      cityEn
      INN
      code
    }
    DealerId
    ZD_UUID
    tableIndex
    status
    updatedAt
  }
`;
export const PositionFragmentDoc = gql`
  fragment position on Position {
    id
    code
    name
    nameEn
  }
`;
export const FragmentStaffFragmentDoc = gql`
  fragment fragmentStaff on EmployeeExpectation {
    id
    Positions {
      ...position
    }
    methodEn
    method
    isCombining
    createdAt
    combineCertification
    combineTraining
  }
  ${PositionFragmentDoc}
`;
export const FragmentStaffForTableFragmentDoc = gql`
  fragment fragmentStaffForTable on EmployeeExpectation {
    id
    name
    method
    methodEn
    isCombining
    combineCertification
    combineTraining
    Positions {
      ...position
    }
    number {
      standard
      fact
      futureStandard
      fromDate
    }
    training {
      required {
        fact
        percent
      }
      trained {
        fact
        percent
      }
    }
    certificationProgress {
      required {
        people
        percent
      }
      certificated {
        people
        percent
      }
    }
  }
  ${PositionFragmentDoc}
`;
export const FragmentStaffForSpecTableFragmentDoc = gql`
  fragment fragmentStaffForSpecTable on EmployeeExpectation {
    id
    Positions {
      ...position
    }
    combineCertification
    combineTraining
    method
    methodEn
    number {
      standard
      fact
    }
    training {
      required {
        fact
        percent
      }
      trained {
        fact
        percent
      }
    }
    certificationProgress {
      required {
        people
        percent
      }
      certificated {
        people
        percent
      }
    }
  }
  ${PositionFragmentDoc}
`;
export const FragmentStaffIndicatorValueFragmentDoc = gql`
  fragment fragmentStaffIndicatorValue on IndicatorValue {
    doubleValue
    IndicatorId
    createdAt
  }
`;
export const FragmentSubdivisionForSelectFragmentDoc = gql`
  fragment fragmentSubdivisionForSelect on Subdivision {
    id
    name
  }
`;
export const FragmentToolsFragmentDoc = gql`
  fragment fragmentTools on ToolsIndicatorTypes {
    id
    UUID
    ActualFrom
    ActualTo
    ComplianceIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    Number
    Name
    NameEn
    forUUID
    isList
    GroupOne
    GroupTwo
    isParent
    sort
    TotalIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    ModelIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    CountryIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    YearIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    NoteIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
  }
`;
export const FragmentValuesToolsFragmentDoc = gql`
  fragment fragmentValuesTools on ToolsOneValuesItem {
    id
    UUID
    ActualFrom
    ActualTo
    Compliance
    Number
    Name
    NameEn
    Total
    Model
    Country
    Year
    Note
    planReportId
    forUUID
    GroupOne
    GroupTwo
    isList
    status
    sort
    statusUpdatedAt
    dealerValuesUpdatedAt
    tableIndex
    DealerId
    list {
      id
      UUID
      ActualFrom
      ActualTo
      Compliance
      Number
      Name
      NameEn
      Total
      Model
      Country
      Year
      Note
      planReportId
      forUUID
      isList
      status
      statusUpdatedAt
      dealerValuesUpdatedAt
      tableIndex
      DealerId
    }
    emptyList {
      id
      UUID
      ActualFrom
      ActualTo
      Compliance
      Number
      Name
      NameEn
      Total
      Model
      Country
      Year
      Note
      planReportId
      forUUID
      isList
      status
      statusUpdatedAt
      dealerValuesUpdatedAt
    }
  }
`;
export const FragmentToolsDealerStatusesFragmentDoc = gql`
  fragment fragmentToolsDealerStatuses on ToolsDealerStatuses {
    Dealer {
      id
      DealerName
      DealerNameEn
      city
      cityEn
      INN
      code
    }
    DealerId
    ZD_UUID
    tableIndex
    status
    updatedAt
  }
`;
export const FragmentToolsInsuranceFragmentDoc = gql`
  fragment fragmentToolsInsurance on ToolsInsuranceIndicatorTypes {
    id
    UUID
    ActualFrom
    ActualTo
    ComplianceIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    Number
    Name
    NameEn
    NumberList
    NumberDetail
    GroupOne
    GroupTwo
    isParent
    TotalIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
  }
`;
export const FragmentValuesToolsInsuranceFragmentDoc = gql`
  fragment fragmentValuesToolsInsurance on ToolsInsuranceOneValuesItem {
    id
    UUID
    ActualFrom
    ActualTo
    Compliance
    GroupOne
    GroupTwo
    Number
    Name
    NameEn
    NumberList
    NumberDetail
    Total
    planReportId
  }
`;
export const FragmentToolsInsuranceDealerStatusesFragmentDoc = gql`
  fragment fragmentToolsInsuranceDealerStatuses on ToolsInsuranceDealerStatuses {
    Dealer {
      id
      DealerName
      DealerNameEn
      city
      cityEn
      INN
      code
    }
    DealerId
    ZD_UUID
    tableIndex
    status
    updatedAt
  }
`;
export const FragmentToolsMetrologicalFragmentDoc = gql`
  fragment fragmentToolsMetrological on ToolsMetrologicalIndicatorTypes {
    id
    UUID
    ActualFrom
    ActualTo
    ComplianceIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    Number
    Name
    NameEn
    TotalIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
  }
`;
export const FragmentValuesToolsMetrologicalFragmentDoc = gql`
  fragment fragmentValuesToolsMetrological on ToolsMetrologicalOneValuesItem {
    id
    UUID
    ActualFrom
    ActualTo
    Compliance
    Number
    Name
    NameEn
    Total
    planReportId
  }
`;
export const FragmentToolsMetrologicalDealerStatusesFragmentDoc = gql`
  fragment fragmentToolsMetrologicalDealerStatuses on ToolsMetrologicalDealerStatuses {
    Dealer {
      id
      DealerName
      DealerNameEn
      city
      cityEn
      INN
      code
    }
    DealerId
    ZD_UUID
    tableIndex
    status
    updatedAt
  }
`;
export const FragmentTradePremisesOneValuesItemFragmentDoc = gql`
  fragment fragmentTradePremisesOneValuesItem on TradePremisesOneValuesItem {
    id
    UUID
    ActualFrom
    ActualTo
    Compliance
    Number
    Name
    NameEn
    Area
    Address
    PlacesCombine
    planReportId
    isList
    GroupOne
    dealerValuesUpdatedAt
    status
    sort
    list {
      id
      UUID
      ActualFrom
      ActualTo
      Compliance
      Number
      Name
      NameEn
      Address
      GroupOne
      planReportId
      forUUID
      isList
      status
      statusUpdatedAt
      dealerValuesUpdatedAt
    }
    emptyList {
      id
      UUID
      ActualFrom
      ActualTo
      Compliance
      Number
      Name
      NameEn
      Address
      GroupOne
      planReportId
      forUUID
      isList
      status
      statusUpdatedAt
      dealerValuesUpdatedAt
    }
  }
`;
export const FragmentTradePremisesIndicatorTypesFragmentDoc = gql`
  fragment fragmentTradePremisesIndicatorTypes on TradePremisesIndicatorTypes {
    id
    UUID
    ActualFrom
    ActualTo
    ComplianceIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    Number
    Name
    NameEn
    GroupOne
    AreaIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    AddressIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    isParent
  }
`;
export const FragmentTradePremisesDealerStatusesFragmentDoc = gql`
  fragment fragmentTradePremisesDealerStatuses on TradePremisesDealerStatuses {
    Dealer {
      id
      DealerName
      DealerNameEn
      city
      cityEn
      INN
      code
    }
    DealerId
    ZD_UUID
    tableIndex
    status
    updatedAt
  }
`;
export const FragmentGetViolationFragmentDoc = gql`
  fragment fragmentGetViolation on ViolationInclude {
    id
    DealerId
    ViolationTypesId
    File {
      id
      link
      name
    }
    description
    fixDeadline
    reportedByUser {
      fullname
      fullnameEn
    }
    punishment
    status
    reportedBy
    createdAt
    Dealer {
      id
      DealerName
      DealerNameEn
      category
      address
      addressEn
      country
      countryEn
      FO
      FOEn
      subject
      subjectEn
      city
      cityEn
      code
      INN
    }
    ViolationType {
      id
      name
      description
      howToFixDescription
      category
      SubdivisionId
      AvgCorrectionDays
      status
      deletedAt
      introducedAt
      createdAt
      Subdivision {
        id
        code
        name
        status
        parentId
      }
    }
    ViolationComments {
      User {
        role
      }
    }
    responsibleByUser {
      id
      fullname
      fullnameEn
    }
    DocDate
    DocNum
  }
`;
export const FragmentProfileForViolationFragmentDoc = gql`
  fragment fragmentProfileForViolation on Profile {
    fullname
    fullnameEn
    roleEn
    roleRu
    id
  }
`;
export const FragmentGetViolationCommentFragmentDoc = gql`
  fragment fragmentGetViolationComment on ViolationComment {
    id
    ViolationId
    User {
      ... on Profile {
        ...fragmentProfileForViolation
      }
    }
    comment
    createdAt
    Files {
      id
      User {
        fullname
        fullnameEn
        login
        role
        roleEn
        roleRu
        id
      }
      name
      link
      mimeType
      createdAt
      type
      hash
    }
  }
  ${FragmentProfileForViolationFragmentDoc}
`;
export const FragmentViolationTypeFragmentDoc = gql`
  fragment fragmentViolationType on ViolationType {
    id
    name
    description
    howToFixDescription
    category
    SubdivisionId
    Subdivision {
      ... on Subdivision {
        ...fragmentSubdivision
      }
    }
    AvgCorrectionDays
    status
    deletedAt
    introducedAt
    createdAt
  }
  ${FragmentSubdivisionFragmentDoc}
`;
export const FragmentViolationTypeForSelectFragmentDoc = gql`
  fragment fragmentViolationTypeForSelect on ViolationType {
    id
    name
    AvgCorrectionDays
  }
`;
export const FragmentWarehousesFragmentDoc = gql`
  fragment fragmentWarehouses on WarehousesIndicatorTypes {
    id
    UUID
    ActualFrom
    ActualTo
    ComplianceIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    Number
    Name
    NameEn
    AreaIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
    CombineIndicator {
      id
      period
      nameRu
      nameEn
      shortNameEn
      shortNameRu
    }
  }
`;
export const FragmentWarehousesDealerStatusesFragmentDoc = gql`
  fragment fragmentWarehousesDealerStatuses on WarehousesDealerStatuses {
    Dealer {
      id
      DealerName
      DealerNameEn
      city
      cityEn
      INN
      code
    }
    DealerId
    ZD_UUID
    tableIndex
    status
    updatedAt
  }
`;
export const FragmentValuesWarehousesFragmentDoc = gql`
  fragment fragmentValuesWarehouses on WarehousesOneValuesItem {
    id
    UUID
    ActualFrom
    ActualTo
    Name
    NameEn
    Combine
    Compliance
    Number
    Area
    status
    statusUpdatedAt
    planReportId
  }
`;
export const FragmentDealerShipFragmentDoc = gql`
  fragment fragmentDealerShip on Dealer {
    id
    DealerName
    DealerNameEn
    type
    typeEn
    country
    countryEn
    city
    cityEn
    FO
    FOEn
    beginWorkingDate
    address
    addressEn
    PhotoDealerCenter {
      id
      link
    }
  }
`;
export const FragmentDealerShipManagerFragmentDoc = gql`
  fragment fragmentDealerShipManager on Dealer {
    id
    PhotoBoss {
      id
      link
    }
    PhotoOwner {
      id
      link
    }
    headName
    headNameEn
    headMobilePhone
    headPhone
    headEmail
    ownerName
    ownerNameEn
    ownerMobilePhone
    ownerPhone
    ownerEmail
    EP
    EPEn
  }
`;
export const FragmentRnBankRatingFragmentDoc = gql`
  fragment fragmentRnBankRating on IndicatorValue {
    stringValue
    createdAt
  }
`;
export const FragmentNewVehicleFragmentDoc = gql`
  fragment fragmentNewVehicle on IndicatorValue {
    doubleValue
    IndicatorId
    createdAt
    Indicator {
      format
      unit
      nameEn
      nameRu
      shortNameEn
      shortNameRu
    }
  }
`;
export const FragmentAfterSalesFragmentDoc = gql`
  fragment fragmentAfterSales on IndicatorValue {
    doubleValue
    IndicatorId
    createdAt
    Indicator {
      format
      unit
    }
  }
`;
export const FragmentQualutyIndicatorFragmentDoc = gql`
  fragment fragmentQualutyIndicator on IndicatorValue {
    doubleValue
    createdAt
    IndicatorId
    Indicator {
      nameEn
      nameRu
      shortNameEn
      shortNameRu
      format
      unit
    }
  }
`;
export const FragmentWorkSpaceQualityFragmentDoc = gql`
  fragment fragmentWorkSpaceQuality on Quality {
    GlobalRatingVersion {
      IndicatorId
      Indicator {
        nameEn
        nameRu
        shortNameEn
        shortNameRu
        format
        unit
        Values {
          IndicatorId
          doubleValue
          createdAt
        }
      }
      dataForGraph {
        name
        nameEn
        IndicatorYearPercent {
          ... on Indicator {
            ...fragmentIndicatorForGr
          }
        }
      }
    }
  }
  ${FragmentIndicatorForGrFragmentDoc}
`;
export const FragmentProfitabilityFragmentDoc = gql`
  fragment fragmentProfitability on IndicatorValue {
    doubleValue
    createdAt
    Indicator {
      id
      nameEn
      nameRu
      period
    }
  }
`;
export const FragmentStaffInfoFragmentDoc = gql`
  fragment fragmentStaffInfo on IndicatorValue {
    doubleValue
    createdAt
    Indicator {
      id
      nameEn
      nameRu
    }
  }
`;
export const FragmentZdGlobalInfoForDealerFragmentDoc = gql`
  fragment fragmentZdGlobalInfoForDealer on ZdGlobalInfoForDealer {
    Dealer {
      id
      DealerName
      DealerNameEn
      city
      cityEn
      INN
      code
    }
    DealerId
    lastAcceptDate
    lastRejectDate
    lastChange
    lastCheckedChange
    lastPlanReportDate
    status
  }
`;
export const FragmentZdGlobalInfoForDealerOneFragmentDoc = gql`
  fragment fragmentZdGlobalInfoForDealerOne on ZdGlobalInformationForDealerResponse {
    Dealer {
      id
      DealerName
      DealerNameEn
      city
      cityEn
      INN
      code
    }
    DealerId
    lastAcceptDate
    lastRejectDate
    lastChange
    lastCheckedChange
    lastPlanReportDate
    status
    statusPremises
  }
`;
export const NotificationFragmentDoc = gql`
  fragment notification on Notification {
    id
    isOpen
    type
    status
    content
    label
    duration
  }
`;
export const UpdateNotificationFragmentDoc = gql`
  fragment updateNotification on Notification {
    isOpen
    type
    status
    content
    label
    duration
  }
`;
export const DealersFragmentFragmentDoc = gql`
  fragment dealersFragment on Dealer {
    DealerNameEn
    DealerName
    IS_Id
  }
`;
export const UsersFragmentFragmentDoc = gql`
  fragment usersFragment on Profile {
    id
    fullname
    fullnameEn
    email
  }
`;
export const GetEmployeeCardSupplementDocument = gql`
  query GetEmployeeCardSupplement($id: ID!) {
    EmployeeGetter {
      get(id: $id) {
        ... on Employee {
          Positions {
            number
            ActivePosition {
              PositionsId
              Education {
                training
                certificate
              }
              Position {
                id
                DirectionId
                Direction {
                  id
                  InstanceId
                  role
                }
              }
              Positions {
                DealerId
                InstanceId
                DataConsentId
                DataConsent {
                  id
                  name
                  link
                }
                emailVerificarion
                hireByUser {
                  ...EmployeeCardSupplementUser
                }
                lastStatusUpdateByUser {
                  ...EmployeeCardSupplementUser
                }
                fireByUser {
                  ...EmployeeCardSupplementUser
                }
              }
            }
            InactivePositions {
              PositionsId
              Education {
                training
                certificate
              }
              Position {
                id
                code
                name
              }
              Positions {
                DealerId
                InstanceId
                DataConsentId
                DataConsent {
                  id
                  name
                  link
                }
                emailVerificarion
                hireByUser {
                  ...EmployeeCardSupplementUser
                }
                lastStatusUpdateByUser {
                  ...EmployeeCardSupplementUser
                }
                fireByUser {
                  ...EmployeeCardSupplementUser
                }
              }
            }
          }
        }
      }
    }
  }
  ${EmployeeCardSupplementUserFragmentDoc}
`;

/**
 * __useGetEmployeeCardSupplementQuery__
 *
 * To run a query within a React component, call `useGetEmployeeCardSupplementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeCardSupplementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeCardSupplementQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmployeeCardSupplementQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmployeeCardSupplementQuery,
    GetEmployeeCardSupplementQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmployeeCardSupplementQuery,
    GetEmployeeCardSupplementQueryVariables
  >(GetEmployeeCardSupplementDocument, options);
}
export function useGetEmployeeCardSupplementLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployeeCardSupplementQuery,
    GetEmployeeCardSupplementQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmployeeCardSupplementQuery,
    GetEmployeeCardSupplementQueryVariables
  >(GetEmployeeCardSupplementDocument, options);
}
export type GetEmployeeCardSupplementQueryHookResult = ReturnType<
  typeof useGetEmployeeCardSupplementQuery
>;
export type GetEmployeeCardSupplementLazyQueryHookResult = ReturnType<
  typeof useGetEmployeeCardSupplementLazyQuery
>;
export type GetEmployeeCardSupplementQueryResult = Apollo.QueryResult<
  GetEmployeeCardSupplementQuery,
  GetEmployeeCardSupplementQueryVariables
>;
export const GetEmployeeListSupplementDocument = gql`
  query GetEmployeeListSupplement(
    $page: Int
    $count: Int
    $DealerIds: [ID]
    $PositionIds: [ID]
    $id: ID
    $surname: String
    $name: String
    $middleName: String
    $personalPhone: String
    $workPhone: String
    $email: String
    $emailVerification: Boolean
    $creationFrom: DateTime
    $creationTo: DateTime
    $lastEditFrom: DateTime
    $lastEditTo: DateTime
    $statuses: [EmployeePositionStatus]
    $ladaAcademiaIds: [ID]
    $order: sortType = ASC
    $orderBy: OrderByColumnInEmployees = id
    $searchText: String
  ) {
    EmployeeGetter {
      getList(
        page: $page
        count: $count
        DealerIds: $DealerIds
        PositionIds: $PositionIds
        id: $id
        surname: $surname
        name: $name
        middleName: $middleName
        personalPhone: $personalPhone
        workPhone: $workPhone
        email: $email
        emailVerification: $emailVerification
        creationFrom: $creationFrom
        creationTo: $creationTo
        lastEditFrom: $lastEditFrom
        lastEditTo: $lastEditTo
        ladaAcademiaIds: $ladaAcademiaIds
        order: $order
        orderBy: $orderBy
        statuses: $statuses
        searchText: $searchText
      ) {
        items {
          EmployeePosition {
            id
            instanceId
            rejectReason
          }
          Employee {
            id
            verifiedInDnm
          }
          Direction {
            id
            instanceId
            role
          }
          Position {
            directionId
          }
        }
      }
    }
  }
`;

/**
 * __useGetEmployeeListSupplementQuery__
 *
 * To run a query within a React component, call `useGetEmployeeListSupplementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeListSupplementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeListSupplementQuery({
 *   variables: {
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      DealerIds: // value for 'DealerIds'
 *      PositionIds: // value for 'PositionIds'
 *      id: // value for 'id'
 *      surname: // value for 'surname'
 *      name: // value for 'name'
 *      middleName: // value for 'middleName'
 *      personalPhone: // value for 'personalPhone'
 *      workPhone: // value for 'workPhone'
 *      email: // value for 'email'
 *      emailVerification: // value for 'emailVerification'
 *      creationFrom: // value for 'creationFrom'
 *      creationTo: // value for 'creationTo'
 *      lastEditFrom: // value for 'lastEditFrom'
 *      lastEditTo: // value for 'lastEditTo'
 *      statuses: // value for 'statuses'
 *      ladaAcademiaIds: // value for 'ladaAcademiaIds'
 *      order: // value for 'order'
 *      orderBy: // value for 'orderBy'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useGetEmployeeListSupplementQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetEmployeeListSupplementQuery,
    GetEmployeeListSupplementQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmployeeListSupplementQuery,
    GetEmployeeListSupplementQueryVariables
  >(GetEmployeeListSupplementDocument, options);
}
export function useGetEmployeeListSupplementLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployeeListSupplementQuery,
    GetEmployeeListSupplementQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmployeeListSupplementQuery,
    GetEmployeeListSupplementQueryVariables
  >(GetEmployeeListSupplementDocument, options);
}
export type GetEmployeeListSupplementQueryHookResult = ReturnType<
  typeof useGetEmployeeListSupplementQuery
>;
export type GetEmployeeListSupplementLazyQueryHookResult = ReturnType<
  typeof useGetEmployeeListSupplementLazyQuery
>;
export type GetEmployeeListSupplementQueryResult = Apollo.QueryResult<
  GetEmployeeListSupplementQuery,
  GetEmployeeListSupplementQueryVariables
>;
export const GetNotificationsDocument = gql`
  query GetNotifications {
    getNotifications @client {
      ...notification
    }
  }
  ${NotificationFragmentDoc}
`;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetNotificationsQuery,
    GetNotificationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(
    GetNotificationsDocument,
    options,
  );
}
export function useGetNotificationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNotificationsQuery,
    GetNotificationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetNotificationsQuery,
    GetNotificationsQueryVariables
  >(GetNotificationsDocument, options);
}
export type GetNotificationsQueryHookResult = ReturnType<
  typeof useGetNotificationsQuery
>;
export type GetNotificationsLazyQueryHookResult = ReturnType<
  typeof useGetNotificationsLazyQuery
>;
export type GetNotificationsQueryResult = Apollo.QueryResult<
  GetNotificationsQuery,
  GetNotificationsQueryVariables
>;
export const AddNotificationDocument = gql`
  mutation AddNotification(
    $id: ID
    $type: String!
    $status: String
    $content: String
    $label: String
    $duration: Int
  ) {
    addNotification(
      id: $id
      type: $type
      status: $status
      content: $content
      label: $label
      duration: $duration
    ) @client {
      ...notification
    }
  }
  ${NotificationFragmentDoc}
`;
export type AddNotificationMutationFn = Apollo.MutationFunction<
  AddNotificationMutation,
  AddNotificationMutationVariables
>;

/**
 * __useAddNotificationMutation__
 *
 * To run a mutation, you first call `useAddNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNotificationMutation, { data, loading, error }] = useAddNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *      status: // value for 'status'
 *      content: // value for 'content'
 *      label: // value for 'label'
 *      duration: // value for 'duration'
 *   },
 * });
 */
export function useAddNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddNotificationMutation,
    AddNotificationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddNotificationMutation,
    AddNotificationMutationVariables
  >(AddNotificationDocument, options);
}
export type AddNotificationMutationHookResult = ReturnType<
  typeof useAddNotificationMutation
>;
export type AddNotificationMutationResult =
  Apollo.MutationResult<AddNotificationMutation>;
export type AddNotificationMutationOptions = Apollo.BaseMutationOptions<
  AddNotificationMutation,
  AddNotificationMutationVariables
>;
export const UpdateNotificationDocument = gql`
  mutation UpdateNotification(
    $id: ID!
    $isOpen: Boolean
    $type: String
    $status: String
    $content: String
    $label: String
    $duration: Int
  ) {
    updateNotification(
      id: $id
      isOpen: $isOpen
      type: $type
      status: $status
      content: $content
      label: $label
      duration: $duration
    ) @client {
      ...notification
    }
  }
  ${NotificationFragmentDoc}
`;
export type UpdateNotificationMutationFn = Apollo.MutationFunction<
  UpdateNotificationMutation,
  UpdateNotificationMutationVariables
>;

/**
 * __useUpdateNotificationMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationMutation, { data, loading, error }] = useUpdateNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isOpen: // value for 'isOpen'
 *      type: // value for 'type'
 *      status: // value for 'status'
 *      content: // value for 'content'
 *      label: // value for 'label'
 *      duration: // value for 'duration'
 *   },
 * });
 */
export function useUpdateNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateNotificationMutation,
    UpdateNotificationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateNotificationMutation,
    UpdateNotificationMutationVariables
  >(UpdateNotificationDocument, options);
}
export type UpdateNotificationMutationHookResult = ReturnType<
  typeof useUpdateNotificationMutation
>;
export type UpdateNotificationMutationResult =
  Apollo.MutationResult<UpdateNotificationMutation>;
export type UpdateNotificationMutationOptions = Apollo.BaseMutationOptions<
  UpdateNotificationMutation,
  UpdateNotificationMutationVariables
>;
export const CreateAccountingDocument = gql`
  mutation CreateAccounting(
    $Year: Int!
    $Quarter: Int!
    $lastDate: DateTime!
    $reportDate: DateTime
  ) {
    AccountingSetter {
      create(
        Year: $Year
        Quarter: $Quarter
        lastDate: $lastDate
        reportDate: $reportDate
      ) {
        Year
        Quarter
        lastDate
        reportDate
        createdAt
      }
    }
  }
`;
export type CreateAccountingMutationFn = Apollo.MutationFunction<
  CreateAccountingMutation,
  CreateAccountingMutationVariables
>;

/**
 * __useCreateAccountingMutation__
 *
 * To run a mutation, you first call `useCreateAccountingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountingMutation, { data, loading, error }] = useCreateAccountingMutation({
 *   variables: {
 *      Year: // value for 'Year'
 *      Quarter: // value for 'Quarter'
 *      lastDate: // value for 'lastDate'
 *      reportDate: // value for 'reportDate'
 *   },
 * });
 */
export function useCreateAccountingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAccountingMutation,
    CreateAccountingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAccountingMutation,
    CreateAccountingMutationVariables
  >(CreateAccountingDocument, options);
}
export type CreateAccountingMutationHookResult = ReturnType<
  typeof useCreateAccountingMutation
>;
export type CreateAccountingMutationResult =
  Apollo.MutationResult<CreateAccountingMutation>;
export type CreateAccountingMutationOptions = Apollo.BaseMutationOptions<
  CreateAccountingMutation,
  CreateAccountingMutationVariables
>;
export const ChangePeriodDocument = gql`
  mutation ChangePeriod(
    $PeriodId: ID!
    $lastDate: DateTime!
    $reportDate: DateTime
  ) {
    AccountingSetter {
      changePeriod(
        PeriodId: $PeriodId
        lastDate: $lastDate
        reportDate: $reportDate
      ) {
        id
        Year
        Quarter
        lastDate
        reportDate
        createdAt
      }
    }
  }
`;
export type ChangePeriodMutationFn = Apollo.MutationFunction<
  ChangePeriodMutation,
  ChangePeriodMutationVariables
>;

/**
 * __useChangePeriodMutation__
 *
 * To run a mutation, you first call `useChangePeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePeriodMutation, { data, loading, error }] = useChangePeriodMutation({
 *   variables: {
 *      PeriodId: // value for 'PeriodId'
 *      lastDate: // value for 'lastDate'
 *      reportDate: // value for 'reportDate'
 *   },
 * });
 */
export function useChangePeriodMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangePeriodMutation,
    ChangePeriodMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChangePeriodMutation,
    ChangePeriodMutationVariables
  >(ChangePeriodDocument, options);
}
export type ChangePeriodMutationHookResult = ReturnType<
  typeof useChangePeriodMutation
>;
export type ChangePeriodMutationResult =
  Apollo.MutationResult<ChangePeriodMutation>;
export type ChangePeriodMutationOptions = Apollo.BaseMutationOptions<
  ChangePeriodMutation,
  ChangePeriodMutationVariables
>;
export const SetDealerReportAccountingDocument = gql`
  mutation SetDealerReportAccounting(
    $ReportId: ID!
    $status: DealerReportStatus
    $note: String
    $FileIds: [ID]
    $_MTExMA__: BigInt
    $_MTEyMA__: BigInt
    $_MTEzMA__: BigInt
    $_MTE0MA__: BigInt
    $_MTE1MA__: BigInt
    $_MTE1MS8x: BigInt
    $_MTE1MS8y: BigInt
    $_MTE1Mi8x: BigInt
    $_MTE1Mi8y: BigInt
    $_MTE1My8x: BigInt
    $_MTE1My8y: BigInt
    $_MTE1NC8x: BigInt
    $_MTE1NC8y: BigInt
    $_MTE2MA__: BigInt
    $_MTE3MA__: BigInt
    $_MTE3MQ__: BigInt
    $_MTE4MA__: BigInt
    $_MTE5MA__: BigInt
    $_MTE5MQ__: BigInt
    $_MTIxMA__: BigInt
    $_MTIxMQ__: BigInt
    $_MTIxMg__: BigInt
    $_MTIxMw__: BigInt
    $_MTIxNA__: BigInt
    $_MTIyMA__: BigInt
    $_MTIzMA__: BigInt
    $_MTIzMQ__: BigInt
    $_MTIzMg__: BigInt
    $_MTIzMw__: BigInt
    $_MTIzNA__: BigInt
    $_MTI0MA__: BigInt
    $_MTI1MA__: BigInt
    $_MTI2MA__: BigInt
    $_MTMxMA__: BigInt
    $_MTMyMA__: BigInt
    $_MTM0MA__: BigInt
    $_MTM1MA__: BigInt
    $_MTM2MA__: BigInt
    $_MTM3MA__: BigInt
    $_MTQxMA__: BigInt
    $_MTQyMA__: BigInt
    $_MTQzMA__: BigInt
    $_MTQ1MA__: BigInt
    $_MTUxMA__: BigInt
    $_MTUyMA__: BigInt
    $_MTUyMQ__: BigInt
    $_MTUyMg__: BigInt
    $_MTUyMw__: BigInt
    $_MTUzMA__: BigInt
    $_MTU0MA__: BigInt
    $_MTU1MA__: BigInt
    $_MjExMg__: BigInt
    $_MjExMw__: BigInt
    $_MjExNA__: BigInt
    $_MjExNQ__: BigInt
    $_MjExNg__: BigInt
    $_MjExNw__: BigInt
    $_MjExOA__: BigInt
    $_MjEyMQ__: BigInt
    $_MjEyMg__: BigInt
    $_MjEyMw__: BigInt
    $_MjEyNA__: BigInt
    $_MjEyNQ__: BigInt
    $_MjEyNg__: BigInt
    $_MjEyNw__: BigInt
    $_MjIxMS8x: BigInt
    $_MjIxMS8y: BigInt
    $_MjIxMS8z: BigInt
    $_MjIxMS80: BigInt
    $_MjIxMS81: BigInt
    $_MjIxMS82: BigInt
    $_MjIxMS83: BigInt
    $_MjIxMS84: BigInt
    $_MjIxMg__: BigInt
    $_MjIxMw__: BigInt
    $_MjIyMC8x: BigInt
    $_MjIyMC8y: BigInt
    $_MjIyMC8z: BigInt
    $_MjIyMC80: BigInt
    $_MjIyMC81: BigInt
    $_MjIyMC82: BigInt
    $_MjIyMC83: BigInt
    $_MjIyMC84: BigInt
    $_MjIyMC85: BigInt
    $_MjIyMC8xMA__: BigInt
    $_MjIyMC8xMQ__: BigInt
    $_MjMxMA__: BigInt
    $_MjMyMA__: BigInt
    $_MjMzMA__: BigInt
    $_MjM0MA__: BigInt
    $_MjM0MQ__: BigInt
    $_MjM0Mg__: BigInt
    $_MjM0Mw__: BigInt
    $_MjM1MA__: BigInt
    $_MjQxMQ__: BigInt
    $_MjQxMg__: BigInt
    $_MjQ2MA__: BigInt
    $_MjUxMA__: BigInt
    $_MjUyMA__: BigInt
    $_MjUwMA__: BigInt
    $_MjkxMA__: BigInt
    $_MjkwMA__: BigInt
    $_MjExMQ__: BigInt
  ) {
    AccountingSetter {
      setDealerReport(
        ReportId: $ReportId
        status: $status
        note: $note
        FileIds: $FileIds
        _MTExMA__: $_MTExMA__
        _MTEyMA__: $_MTEyMA__
        _MTEzMA__: $_MTEzMA__
        _MTE0MA__: $_MTE0MA__
        _MTE1MA__: $_MTE1MA__
        _MTE1MS8x: $_MTE1MS8x
        _MTE1MS8y: $_MTE1MS8y
        _MTE1Mi8x: $_MTE1Mi8x
        _MTE1Mi8y: $_MTE1Mi8y
        _MTE1My8x: $_MTE1My8x
        _MTE1My8y: $_MTE1My8y
        _MTE1NC8x: $_MTE1NC8x
        _MTE1NC8y: $_MTE1NC8y
        _MTE2MA__: $_MTE2MA__
        _MTE3MA__: $_MTE3MA__
        _MTE3MQ__: $_MTE3MQ__
        _MTE4MA__: $_MTE4MA__
        _MTE5MA__: $_MTE5MA__
        _MTE5MQ__: $_MTE5MQ__
        _MTIxMA__: $_MTIxMA__
        _MTIxMQ__: $_MTIxMQ__
        _MTIxMg__: $_MTIxMg__
        _MTIxMw__: $_MTIxMw__
        _MTIxNA__: $_MTIxNA__
        _MTIyMA__: $_MTIyMA__
        _MTIzMA__: $_MTIzMA__
        _MTIzMQ__: $_MTIzMQ__
        _MTIzMg__: $_MTIzMg__
        _MTIzMw__: $_MTIzMw__
        _MTIzNA__: $_MTIzNA__
        _MTI0MA__: $_MTI0MA__
        _MTI1MA__: $_MTI1MA__
        _MTI2MA__: $_MTI2MA__
        _MTMxMA__: $_MTMxMA__
        _MTMyMA__: $_MTMyMA__
        _MTM0MA__: $_MTM0MA__
        _MTM1MA__: $_MTM1MA__
        _MTM2MA__: $_MTM2MA__
        _MTM3MA__: $_MTM3MA__
        _MTQxMA__: $_MTQxMA__
        _MTQyMA__: $_MTQyMA__
        _MTQzMA__: $_MTQzMA__
        _MTQ1MA__: $_MTQ1MA__
        _MTUxMA__: $_MTUxMA__
        _MTUyMA__: $_MTUyMA__
        _MTUyMQ__: $_MTUyMQ__
        _MTUyMg__: $_MTUyMg__
        _MTUyMw__: $_MTUyMw__
        _MTUzMA__: $_MTUzMA__
        _MTU0MA__: $_MTU0MA__
        _MTU1MA__: $_MTU1MA__
        _MjExMg__: $_MjExMg__
        _MjExMw__: $_MjExMw__
        _MjExNA__: $_MjExNA__
        _MjExNQ__: $_MjExNQ__
        _MjExNg__: $_MjExNg__
        _MjExNw__: $_MjExNw__
        _MjExOA__: $_MjExOA__
        _MjEyMQ__: $_MjEyMQ__
        _MjEyMg__: $_MjEyMg__
        _MjEyMw__: $_MjEyMw__
        _MjEyNA__: $_MjEyNA__
        _MjEyNQ__: $_MjEyNQ__
        _MjEyNg__: $_MjEyNg__
        _MjEyNw__: $_MjEyNw__
        _MjIxMS8x: $_MjIxMS8x
        _MjIxMS8y: $_MjIxMS8y
        _MjIxMS8z: $_MjIxMS8z
        _MjIxMS80: $_MjIxMS80
        _MjIxMS81: $_MjIxMS81
        _MjIxMS82: $_MjIxMS82
        _MjIxMS83: $_MjIxMS83
        _MjIxMS84: $_MjIxMS84
        _MjIxMg__: $_MjIxMg__
        _MjIxMw__: $_MjIxMw__
        _MjIyMC8x: $_MjIyMC8x
        _MjIyMC8y: $_MjIyMC8y
        _MjIyMC8z: $_MjIyMC8z
        _MjIyMC80: $_MjIyMC80
        _MjIyMC81: $_MjIyMC81
        _MjIyMC82: $_MjIyMC82
        _MjIyMC83: $_MjIyMC83
        _MjIyMC84: $_MjIyMC84
        _MjIyMC85: $_MjIyMC85
        _MjIyMC8xMA__: $_MjIyMC8xMA__
        _MjIyMC8xMQ__: $_MjIyMC8xMQ__
        _MjMxMA__: $_MjMxMA__
        _MjMyMA__: $_MjMyMA__
        _MjMzMA__: $_MjMzMA__
        _MjM0MA__: $_MjM0MA__
        _MjM0MQ__: $_MjM0MQ__
        _MjM0Mg__: $_MjM0Mg__
        _MjM0Mw__: $_MjM0Mw__
        _MjM1MA__: $_MjM1MA__
        _MjQxMQ__: $_MjQxMQ__
        _MjQxMg__: $_MjQxMg__
        _MjQ2MA__: $_MjQ2MA__
        _MjUxMA__: $_MjUxMA__
        _MjUyMA__: $_MjUyMA__
        _MjUwMA__: $_MjUwMA__
        _MjkxMA__: $_MjkxMA__
        _MjkwMA__: $_MjkwMA__
        _MjExMQ__: $_MjExMQ__
      ) {
        id
      }
    }
  }
`;
export type SetDealerReportAccountingMutationFn = Apollo.MutationFunction<
  SetDealerReportAccountingMutation,
  SetDealerReportAccountingMutationVariables
>;

/**
 * __useSetDealerReportAccountingMutation__
 *
 * To run a mutation, you first call `useSetDealerReportAccountingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDealerReportAccountingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDealerReportAccountingMutation, { data, loading, error }] = useSetDealerReportAccountingMutation({
 *   variables: {
 *      ReportId: // value for 'ReportId'
 *      status: // value for 'status'
 *      note: // value for 'note'
 *      FileIds: // value for 'FileIds'
 *      _MTExMA__: // value for '_MTExMA__'
 *      _MTEyMA__: // value for '_MTEyMA__'
 *      _MTEzMA__: // value for '_MTEzMA__'
 *      _MTE0MA__: // value for '_MTE0MA__'
 *      _MTE1MA__: // value for '_MTE1MA__'
 *      _MTE1MS8x: // value for '_MTE1MS8x'
 *      _MTE1MS8y: // value for '_MTE1MS8y'
 *      _MTE1Mi8x: // value for '_MTE1Mi8x'
 *      _MTE1Mi8y: // value for '_MTE1Mi8y'
 *      _MTE1My8x: // value for '_MTE1My8x'
 *      _MTE1My8y: // value for '_MTE1My8y'
 *      _MTE1NC8x: // value for '_MTE1NC8x'
 *      _MTE1NC8y: // value for '_MTE1NC8y'
 *      _MTE2MA__: // value for '_MTE2MA__'
 *      _MTE3MA__: // value for '_MTE3MA__'
 *      _MTE3MQ__: // value for '_MTE3MQ__'
 *      _MTE4MA__: // value for '_MTE4MA__'
 *      _MTE5MA__: // value for '_MTE5MA__'
 *      _MTE5MQ__: // value for '_MTE5MQ__'
 *      _MTIxMA__: // value for '_MTIxMA__'
 *      _MTIxMQ__: // value for '_MTIxMQ__'
 *      _MTIxMg__: // value for '_MTIxMg__'
 *      _MTIxMw__: // value for '_MTIxMw__'
 *      _MTIxNA__: // value for '_MTIxNA__'
 *      _MTIyMA__: // value for '_MTIyMA__'
 *      _MTIzMA__: // value for '_MTIzMA__'
 *      _MTIzMQ__: // value for '_MTIzMQ__'
 *      _MTIzMg__: // value for '_MTIzMg__'
 *      _MTIzMw__: // value for '_MTIzMw__'
 *      _MTIzNA__: // value for '_MTIzNA__'
 *      _MTI0MA__: // value for '_MTI0MA__'
 *      _MTI1MA__: // value for '_MTI1MA__'
 *      _MTI2MA__: // value for '_MTI2MA__'
 *      _MTMxMA__: // value for '_MTMxMA__'
 *      _MTMyMA__: // value for '_MTMyMA__'
 *      _MTM0MA__: // value for '_MTM0MA__'
 *      _MTM1MA__: // value for '_MTM1MA__'
 *      _MTM2MA__: // value for '_MTM2MA__'
 *      _MTM3MA__: // value for '_MTM3MA__'
 *      _MTQxMA__: // value for '_MTQxMA__'
 *      _MTQyMA__: // value for '_MTQyMA__'
 *      _MTQzMA__: // value for '_MTQzMA__'
 *      _MTQ1MA__: // value for '_MTQ1MA__'
 *      _MTUxMA__: // value for '_MTUxMA__'
 *      _MTUyMA__: // value for '_MTUyMA__'
 *      _MTUyMQ__: // value for '_MTUyMQ__'
 *      _MTUyMg__: // value for '_MTUyMg__'
 *      _MTUyMw__: // value for '_MTUyMw__'
 *      _MTUzMA__: // value for '_MTUzMA__'
 *      _MTU0MA__: // value for '_MTU0MA__'
 *      _MTU1MA__: // value for '_MTU1MA__'
 *      _MjExMg__: // value for '_MjExMg__'
 *      _MjExMw__: // value for '_MjExMw__'
 *      _MjExNA__: // value for '_MjExNA__'
 *      _MjExNQ__: // value for '_MjExNQ__'
 *      _MjExNg__: // value for '_MjExNg__'
 *      _MjExNw__: // value for '_MjExNw__'
 *      _MjExOA__: // value for '_MjExOA__'
 *      _MjEyMQ__: // value for '_MjEyMQ__'
 *      _MjEyMg__: // value for '_MjEyMg__'
 *      _MjEyMw__: // value for '_MjEyMw__'
 *      _MjEyNA__: // value for '_MjEyNA__'
 *      _MjEyNQ__: // value for '_MjEyNQ__'
 *      _MjEyNg__: // value for '_MjEyNg__'
 *      _MjEyNw__: // value for '_MjEyNw__'
 *      _MjIxMS8x: // value for '_MjIxMS8x'
 *      _MjIxMS8y: // value for '_MjIxMS8y'
 *      _MjIxMS8z: // value for '_MjIxMS8z'
 *      _MjIxMS80: // value for '_MjIxMS80'
 *      _MjIxMS81: // value for '_MjIxMS81'
 *      _MjIxMS82: // value for '_MjIxMS82'
 *      _MjIxMS83: // value for '_MjIxMS83'
 *      _MjIxMS84: // value for '_MjIxMS84'
 *      _MjIxMg__: // value for '_MjIxMg__'
 *      _MjIxMw__: // value for '_MjIxMw__'
 *      _MjIyMC8x: // value for '_MjIyMC8x'
 *      _MjIyMC8y: // value for '_MjIyMC8y'
 *      _MjIyMC8z: // value for '_MjIyMC8z'
 *      _MjIyMC80: // value for '_MjIyMC80'
 *      _MjIyMC81: // value for '_MjIyMC81'
 *      _MjIyMC82: // value for '_MjIyMC82'
 *      _MjIyMC83: // value for '_MjIyMC83'
 *      _MjIyMC84: // value for '_MjIyMC84'
 *      _MjIyMC85: // value for '_MjIyMC85'
 *      _MjIyMC8xMA__: // value for '_MjIyMC8xMA__'
 *      _MjIyMC8xMQ__: // value for '_MjIyMC8xMQ__'
 *      _MjMxMA__: // value for '_MjMxMA__'
 *      _MjMyMA__: // value for '_MjMyMA__'
 *      _MjMzMA__: // value for '_MjMzMA__'
 *      _MjM0MA__: // value for '_MjM0MA__'
 *      _MjM0MQ__: // value for '_MjM0MQ__'
 *      _MjM0Mg__: // value for '_MjM0Mg__'
 *      _MjM0Mw__: // value for '_MjM0Mw__'
 *      _MjM1MA__: // value for '_MjM1MA__'
 *      _MjQxMQ__: // value for '_MjQxMQ__'
 *      _MjQxMg__: // value for '_MjQxMg__'
 *      _MjQ2MA__: // value for '_MjQ2MA__'
 *      _MjUxMA__: // value for '_MjUxMA__'
 *      _MjUyMA__: // value for '_MjUyMA__'
 *      _MjUwMA__: // value for '_MjUwMA__'
 *      _MjkxMA__: // value for '_MjkxMA__'
 *      _MjkwMA__: // value for '_MjkwMA__'
 *      _MjExMQ__: // value for '_MjExMQ__'
 *   },
 * });
 */
export function useSetDealerReportAccountingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetDealerReportAccountingMutation,
    SetDealerReportAccountingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetDealerReportAccountingMutation,
    SetDealerReportAccountingMutationVariables
  >(SetDealerReportAccountingDocument, options);
}
export type SetDealerReportAccountingMutationHookResult = ReturnType<
  typeof useSetDealerReportAccountingMutation
>;
export type SetDealerReportAccountingMutationResult =
  Apollo.MutationResult<SetDealerReportAccountingMutation>;
export type SetDealerReportAccountingMutationOptions =
  Apollo.BaseMutationOptions<
    SetDealerReportAccountingMutation,
    SetDealerReportAccountingMutationVariables
  >;
export const AnnouncementCreateDocument = gql`
  mutation AnnouncementCreate(
    $importance: String
    $date: DateTime
    $title: String!
    $text: String!
    $singedBy: String!
    $SubdivisionId: ID
    $Documents: [ID]
  ) {
    AnnouncementSetter {
      create(
        importance: $importance
        date: $date
        title: $title
        text: $text
        singedBy: $singedBy
        SubdivisionId: $SubdivisionId
        Documents: $Documents
      ) {
        id
      }
    }
  }
`;
export type AnnouncementCreateMutationFn = Apollo.MutationFunction<
  AnnouncementCreateMutation,
  AnnouncementCreateMutationVariables
>;

/**
 * __useAnnouncementCreateMutation__
 *
 * To run a mutation, you first call `useAnnouncementCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [announcementCreateMutation, { data, loading, error }] = useAnnouncementCreateMutation({
 *   variables: {
 *      importance: // value for 'importance'
 *      date: // value for 'date'
 *      title: // value for 'title'
 *      text: // value for 'text'
 *      singedBy: // value for 'singedBy'
 *      SubdivisionId: // value for 'SubdivisionId'
 *      Documents: // value for 'Documents'
 *   },
 * });
 */
export function useAnnouncementCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AnnouncementCreateMutation,
    AnnouncementCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AnnouncementCreateMutation,
    AnnouncementCreateMutationVariables
  >(AnnouncementCreateDocument, options);
}
export type AnnouncementCreateMutationHookResult = ReturnType<
  typeof useAnnouncementCreateMutation
>;
export type AnnouncementCreateMutationResult =
  Apollo.MutationResult<AnnouncementCreateMutation>;
export type AnnouncementCreateMutationOptions = Apollo.BaseMutationOptions<
  AnnouncementCreateMutation,
  AnnouncementCreateMutationVariables
>;
export const AnnouncementEditDocument = gql`
  mutation AnnouncementEdit(
    $id: ID!
    $importance: String
    $date: DateTime
    $title: String!
    $text: String!
    $singedBy: String!
    $SubdivisionId: ID
    $Documents: [ID]
  ) {
    AnnouncementSetter {
      edit(
        id: $id
        importance: $importance
        date: $date
        title: $title
        text: $text
        singedBy: $singedBy
        SubdivisionId: $SubdivisionId
        Documents: $Documents
      ) {
        id
      }
    }
  }
`;
export type AnnouncementEditMutationFn = Apollo.MutationFunction<
  AnnouncementEditMutation,
  AnnouncementEditMutationVariables
>;

/**
 * __useAnnouncementEditMutation__
 *
 * To run a mutation, you first call `useAnnouncementEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [announcementEditMutation, { data, loading, error }] = useAnnouncementEditMutation({
 *   variables: {
 *      id: // value for 'id'
 *      importance: // value for 'importance'
 *      date: // value for 'date'
 *      title: // value for 'title'
 *      text: // value for 'text'
 *      singedBy: // value for 'singedBy'
 *      SubdivisionId: // value for 'SubdivisionId'
 *      Documents: // value for 'Documents'
 *   },
 * });
 */
export function useAnnouncementEditMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AnnouncementEditMutation,
    AnnouncementEditMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AnnouncementEditMutation,
    AnnouncementEditMutationVariables
  >(AnnouncementEditDocument, options);
}
export type AnnouncementEditMutationHookResult = ReturnType<
  typeof useAnnouncementEditMutation
>;
export type AnnouncementEditMutationResult =
  Apollo.MutationResult<AnnouncementEditMutation>;
export type AnnouncementEditMutationOptions = Apollo.BaseMutationOptions<
  AnnouncementEditMutation,
  AnnouncementEditMutationVariables
>;
export const AnnouncementStatusDocument = gql`
  mutation AnnouncementStatus(
    $id: ID!
    $status: AnnouncementStatus
    $canceledReason: String
  ) {
    AnnouncementSetter {
      setStatus(id: $id, status: $status, canceledReason: $canceledReason) {
        id
      }
    }
  }
`;
export type AnnouncementStatusMutationFn = Apollo.MutationFunction<
  AnnouncementStatusMutation,
  AnnouncementStatusMutationVariables
>;

/**
 * __useAnnouncementStatusMutation__
 *
 * To run a mutation, you first call `useAnnouncementStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [announcementStatusMutation, { data, loading, error }] = useAnnouncementStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      canceledReason: // value for 'canceledReason'
 *   },
 * });
 */
export function useAnnouncementStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AnnouncementStatusMutation,
    AnnouncementStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AnnouncementStatusMutation,
    AnnouncementStatusMutationVariables
  >(AnnouncementStatusDocument, options);
}
export type AnnouncementStatusMutationHookResult = ReturnType<
  typeof useAnnouncementStatusMutation
>;
export type AnnouncementStatusMutationResult =
  Apollo.MutationResult<AnnouncementStatusMutation>;
export type AnnouncementStatusMutationOptions = Apollo.BaseMutationOptions<
  AnnouncementStatusMutation,
  AnnouncementStatusMutationVariables
>;
export const SetCameraZoneDocument = gql`
  mutation SetCameraZone($name: String) {
    CameraSetter {
      createCameraZone(name: $name) {
        ...CameraZone
      }
    }
  }
  ${CameraZoneFragmentDoc}
`;
export type SetCameraZoneMutationFn = Apollo.MutationFunction<
  SetCameraZoneMutation,
  SetCameraZoneMutationVariables
>;

/**
 * __useSetCameraZoneMutation__
 *
 * To run a mutation, you first call `useSetCameraZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCameraZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCameraZoneMutation, { data, loading, error }] = useSetCameraZoneMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSetCameraZoneMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCameraZoneMutation,
    SetCameraZoneMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetCameraZoneMutation,
    SetCameraZoneMutationVariables
  >(SetCameraZoneDocument, options);
}
export type SetCameraZoneMutationHookResult = ReturnType<
  typeof useSetCameraZoneMutation
>;
export type SetCameraZoneMutationResult =
  Apollo.MutationResult<SetCameraZoneMutation>;
export type SetCameraZoneMutationOptions = Apollo.BaseMutationOptions<
  SetCameraZoneMutation,
  SetCameraZoneMutationVariables
>;
export const EditCameraZoneDocument = gql`
  mutation EditCameraZone($id: ID, $name: String) {
    CameraSetter {
      editCameraZone(id: $id, name: $name) {
        ...CameraZone
      }
    }
  }
  ${CameraZoneFragmentDoc}
`;
export type EditCameraZoneMutationFn = Apollo.MutationFunction<
  EditCameraZoneMutation,
  EditCameraZoneMutationVariables
>;

/**
 * __useEditCameraZoneMutation__
 *
 * To run a mutation, you first call `useEditCameraZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCameraZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCameraZoneMutation, { data, loading, error }] = useEditCameraZoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEditCameraZoneMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditCameraZoneMutation,
    EditCameraZoneMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditCameraZoneMutation,
    EditCameraZoneMutationVariables
  >(EditCameraZoneDocument, options);
}
export type EditCameraZoneMutationHookResult = ReturnType<
  typeof useEditCameraZoneMutation
>;
export type EditCameraZoneMutationResult =
  Apollo.MutationResult<EditCameraZoneMutation>;
export type EditCameraZoneMutationOptions = Apollo.BaseMutationOptions<
  EditCameraZoneMutation,
  EditCameraZoneMutationVariables
>;
export const DeleteCameraZoneDocument = gql`
  mutation DeleteCameraZone($id: ID) {
    CameraSetter {
      deleteCameraZone(id: $id) {
        ...CameraZone
      }
    }
  }
  ${CameraZoneFragmentDoc}
`;
export type DeleteCameraZoneMutationFn = Apollo.MutationFunction<
  DeleteCameraZoneMutation,
  DeleteCameraZoneMutationVariables
>;

/**
 * __useDeleteCameraZoneMutation__
 *
 * To run a mutation, you first call `useDeleteCameraZoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCameraZoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCameraZoneMutation, { data, loading, error }] = useDeleteCameraZoneMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCameraZoneMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCameraZoneMutation,
    DeleteCameraZoneMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCameraZoneMutation,
    DeleteCameraZoneMutationVariables
  >(DeleteCameraZoneDocument, options);
}
export type DeleteCameraZoneMutationHookResult = ReturnType<
  typeof useDeleteCameraZoneMutation
>;
export type DeleteCameraZoneMutationResult =
  Apollo.MutationResult<DeleteCameraZoneMutation>;
export type DeleteCameraZoneMutationOptions = Apollo.BaseMutationOptions<
  DeleteCameraZoneMutation,
  DeleteCameraZoneMutationVariables
>;
export const SetCameraDocument = gql`
  mutation SetCamera(
    $name: String
    $cameraZoneId: ID
    $cameraUrl: String
    $dealerId: ID
  ) {
    CameraSetter {
      createCamera(
        name: $name
        cameraZoneId: $cameraZoneId
        cameraUrl: $cameraUrl
        dealerId: $dealerId
      ) {
        ...Camera
      }
    }
  }
  ${CameraFragmentDoc}
`;
export type SetCameraMutationFn = Apollo.MutationFunction<
  SetCameraMutation,
  SetCameraMutationVariables
>;

/**
 * __useSetCameraMutation__
 *
 * To run a mutation, you first call `useSetCameraMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCameraMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCameraMutation, { data, loading, error }] = useSetCameraMutation({
 *   variables: {
 *      name: // value for 'name'
 *      cameraZoneId: // value for 'cameraZoneId'
 *      cameraUrl: // value for 'cameraUrl'
 *      dealerId: // value for 'dealerId'
 *   },
 * });
 */
export function useSetCameraMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCameraMutation,
    SetCameraMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetCameraMutation, SetCameraMutationVariables>(
    SetCameraDocument,
    options,
  );
}
export type SetCameraMutationHookResult = ReturnType<
  typeof useSetCameraMutation
>;
export type SetCameraMutationResult = Apollo.MutationResult<SetCameraMutation>;
export type SetCameraMutationOptions = Apollo.BaseMutationOptions<
  SetCameraMutation,
  SetCameraMutationVariables
>;
export const EditCameraDocument = gql`
  mutation EditCamera(
    $id: ID
    $name: String
    $cameraZoneId: ID
    $cameraUrl: String
    $dealerId: ID
  ) {
    CameraSetter {
      editCamera(
        id: $id
        name: $name
        cameraZoneId: $cameraZoneId
        cameraUrl: $cameraUrl
        dealerId: $dealerId
      ) {
        ...Camera
      }
    }
  }
  ${CameraFragmentDoc}
`;
export type EditCameraMutationFn = Apollo.MutationFunction<
  EditCameraMutation,
  EditCameraMutationVariables
>;

/**
 * __useEditCameraMutation__
 *
 * To run a mutation, you first call `useEditCameraMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCameraMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCameraMutation, { data, loading, error }] = useEditCameraMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      cameraZoneId: // value for 'cameraZoneId'
 *      cameraUrl: // value for 'cameraUrl'
 *      dealerId: // value for 'dealerId'
 *   },
 * });
 */
export function useEditCameraMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditCameraMutation,
    EditCameraMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EditCameraMutation, EditCameraMutationVariables>(
    EditCameraDocument,
    options,
  );
}
export type EditCameraMutationHookResult = ReturnType<
  typeof useEditCameraMutation
>;
export type EditCameraMutationResult =
  Apollo.MutationResult<EditCameraMutation>;
export type EditCameraMutationOptions = Apollo.BaseMutationOptions<
  EditCameraMutation,
  EditCameraMutationVariables
>;
export const DeleteCameraDocument = gql`
  mutation DeleteCamera($id: ID) {
    CameraSetter {
      deleteCamera(id: $id) {
        ...Camera
      }
    }
  }
  ${CameraFragmentDoc}
`;
export type DeleteCameraMutationFn = Apollo.MutationFunction<
  DeleteCameraMutation,
  DeleteCameraMutationVariables
>;

/**
 * __useDeleteCameraMutation__
 *
 * To run a mutation, you first call `useDeleteCameraMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCameraMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCameraMutation, { data, loading, error }] = useDeleteCameraMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCameraMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCameraMutation,
    DeleteCameraMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCameraMutation,
    DeleteCameraMutationVariables
  >(DeleteCameraDocument, options);
}
export type DeleteCameraMutationHookResult = ReturnType<
  typeof useDeleteCameraMutation
>;
export type DeleteCameraMutationResult =
  Apollo.MutationResult<DeleteCameraMutation>;
export type DeleteCameraMutationOptions = Apollo.BaseMutationOptions<
  DeleteCameraMutation,
  DeleteCameraMutationVariables
>;
export const SetCameraCheckDocument = gql`
  mutation SetCameraCheck(
    $cameraId: ID
    $comment: String
    $status: CameraCheckStatus
  ) {
    CameraSetter {
      createCameraCheck(
        cameraId: $cameraId
        comment: $comment
        status: $status
      ) {
        id
        cameraId
        status
        comments {
          ...CameraChatMessage
        }
        name
        createdAt
        updatedAt
        createdBy
        updatedBy
      }
    }
  }
  ${CameraChatMessageFragmentDoc}
`;
export type SetCameraCheckMutationFn = Apollo.MutationFunction<
  SetCameraCheckMutation,
  SetCameraCheckMutationVariables
>;

/**
 * __useSetCameraCheckMutation__
 *
 * To run a mutation, you first call `useSetCameraCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCameraCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCameraCheckMutation, { data, loading, error }] = useSetCameraCheckMutation({
 *   variables: {
 *      cameraId: // value for 'cameraId'
 *      comment: // value for 'comment'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetCameraCheckMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCameraCheckMutation,
    SetCameraCheckMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetCameraCheckMutation,
    SetCameraCheckMutationVariables
  >(SetCameraCheckDocument, options);
}
export type SetCameraCheckMutationHookResult = ReturnType<
  typeof useSetCameraCheckMutation
>;
export type SetCameraCheckMutationResult =
  Apollo.MutationResult<SetCameraCheckMutation>;
export type SetCameraCheckMutationOptions = Apollo.BaseMutationOptions<
  SetCameraCheckMutation,
  SetCameraCheckMutationVariables
>;
export const SetNewCameraChatMessageDocument = gql`
  mutation SetNewCameraChatMessage($cameraCheckId: ID, $comment: String) {
    CameraSetter {
      addComment(comment: $comment, cameraCheckId: $cameraCheckId) {
        ...CameraChatMessage
      }
    }
  }
  ${CameraChatMessageFragmentDoc}
`;
export type SetNewCameraChatMessageMutationFn = Apollo.MutationFunction<
  SetNewCameraChatMessageMutation,
  SetNewCameraChatMessageMutationVariables
>;

/**
 * __useSetNewCameraChatMessageMutation__
 *
 * To run a mutation, you first call `useSetNewCameraChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNewCameraChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNewCameraChatMessageMutation, { data, loading, error }] = useSetNewCameraChatMessageMutation({
 *   variables: {
 *      cameraCheckId: // value for 'cameraCheckId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useSetNewCameraChatMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetNewCameraChatMessageMutation,
    SetNewCameraChatMessageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetNewCameraChatMessageMutation,
    SetNewCameraChatMessageMutationVariables
  >(SetNewCameraChatMessageDocument, options);
}
export type SetNewCameraChatMessageMutationHookResult = ReturnType<
  typeof useSetNewCameraChatMessageMutation
>;
export type SetNewCameraChatMessageMutationResult =
  Apollo.MutationResult<SetNewCameraChatMessageMutation>;
export type SetNewCameraChatMessageMutationOptions = Apollo.BaseMutationOptions<
  SetNewCameraChatMessageMutation,
  SetNewCameraChatMessageMutationVariables
>;
export const SetCameraCheckStatusDocument = gql`
  mutation SetCameraCheckStatus(
    $cameraCheckId: ID
    $status: CameraCheckStatus
  ) {
    CameraSetter {
      setCameraCheckStatus(cameraCheckId: $cameraCheckId, status: $status) {
        ...CameraCheck
      }
    }
  }
  ${CameraCheckFragmentDoc}
`;
export type SetCameraCheckStatusMutationFn = Apollo.MutationFunction<
  SetCameraCheckStatusMutation,
  SetCameraCheckStatusMutationVariables
>;

/**
 * __useSetCameraCheckStatusMutation__
 *
 * To run a mutation, you first call `useSetCameraCheckStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCameraCheckStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCameraCheckStatusMutation, { data, loading, error }] = useSetCameraCheckStatusMutation({
 *   variables: {
 *      cameraCheckId: // value for 'cameraCheckId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetCameraCheckStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCameraCheckStatusMutation,
    SetCameraCheckStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetCameraCheckStatusMutation,
    SetCameraCheckStatusMutationVariables
  >(SetCameraCheckStatusDocument, options);
}
export type SetCameraCheckStatusMutationHookResult = ReturnType<
  typeof useSetCameraCheckStatusMutation
>;
export type SetCameraCheckStatusMutationResult =
  Apollo.MutationResult<SetCameraCheckStatusMutation>;
export type SetCameraCheckStatusMutationOptions = Apollo.BaseMutationOptions<
  SetCameraCheckStatusMutation,
  SetCameraCheckStatusMutationVariables
>;
export const SetCameraStreamCloseDocument = gql`
  mutation SetCameraStreamClose($pid: ID) {
    CameraSetter {
      closeCameraVideo(pid: $pid)
    }
  }
`;
export type SetCameraStreamCloseMutationFn = Apollo.MutationFunction<
  SetCameraStreamCloseMutation,
  SetCameraStreamCloseMutationVariables
>;

/**
 * __useSetCameraStreamCloseMutation__
 *
 * To run a mutation, you first call `useSetCameraStreamCloseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCameraStreamCloseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCameraStreamCloseMutation, { data, loading, error }] = useSetCameraStreamCloseMutation({
 *   variables: {
 *      pid: // value for 'pid'
 *   },
 * });
 */
export function useSetCameraStreamCloseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCameraStreamCloseMutation,
    SetCameraStreamCloseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetCameraStreamCloseMutation,
    SetCameraStreamCloseMutationVariables
  >(SetCameraStreamCloseDocument, options);
}
export type SetCameraStreamCloseMutationHookResult = ReturnType<
  typeof useSetCameraStreamCloseMutation
>;
export type SetCameraStreamCloseMutationResult =
  Apollo.MutationResult<SetCameraStreamCloseMutation>;
export type SetCameraStreamCloseMutationOptions = Apollo.BaseMutationOptions<
  SetCameraStreamCloseMutation,
  SetCameraStreamCloseMutationVariables
>;
export const CheckListCommentSetterDocument = gql`
  mutation CheckListCommentSetter($checkListId: ID!, $text: String!) {
    CheckListCommentSetter {
      createCheckListComment(CheckListId: $checkListId, text: $text) {
        ok
      }
    }
  }
`;
export type CheckListCommentSetterMutationFn = Apollo.MutationFunction<
  CheckListCommentSetterMutation,
  CheckListCommentSetterMutationVariables
>;

/**
 * __useCheckListCommentSetterMutation__
 *
 * To run a mutation, you first call `useCheckListCommentSetterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckListCommentSetterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkListCommentSetterMutation, { data, loading, error }] = useCheckListCommentSetterMutation({
 *   variables: {
 *      checkListId: // value for 'checkListId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useCheckListCommentSetterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CheckListCommentSetterMutation,
    CheckListCommentSetterMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CheckListCommentSetterMutation,
    CheckListCommentSetterMutationVariables
  >(CheckListCommentSetterDocument, options);
}
export type CheckListCommentSetterMutationHookResult = ReturnType<
  typeof useCheckListCommentSetterMutation
>;
export type CheckListCommentSetterMutationResult =
  Apollo.MutationResult<CheckListCommentSetterMutation>;
export type CheckListCommentSetterMutationOptions = Apollo.BaseMutationOptions<
  CheckListCommentSetterMutation,
  CheckListCommentSetterMutationVariables
>;
export const CreateContractTemplateDocument = gql`
  mutation CreateContractTemplate(
    $name: String!
    $fileId: String!
    $active: Boolean
  ) {
    ContractTemplateSetter {
      createContractTemplate(name: $name, FileId: $fileId, active: $active) {
        id
        name
        active
        FileId
        createdAt
        updatedAt
        File {
          id
          name
          link
          mimeType
          createdAt
          type
          hash
        }
      }
    }
  }
`;
export type CreateContractTemplateMutationFn = Apollo.MutationFunction<
  CreateContractTemplateMutation,
  CreateContractTemplateMutationVariables
>;

/**
 * __useCreateContractTemplateMutation__
 *
 * To run a mutation, you first call `useCreateContractTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractTemplateMutation, { data, loading, error }] = useCreateContractTemplateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      fileId: // value for 'fileId'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useCreateContractTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateContractTemplateMutation,
    CreateContractTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateContractTemplateMutation,
    CreateContractTemplateMutationVariables
  >(CreateContractTemplateDocument, options);
}
export type CreateContractTemplateMutationHookResult = ReturnType<
  typeof useCreateContractTemplateMutation
>;
export type CreateContractTemplateMutationResult =
  Apollo.MutationResult<CreateContractTemplateMutation>;
export type CreateContractTemplateMutationOptions = Apollo.BaseMutationOptions<
  CreateContractTemplateMutation,
  CreateContractTemplateMutationVariables
>;
export const UpdateContractTemplateDocument = gql`
  mutation UpdateContractTemplate(
    $updateContractTemplateId: ID!
    $name: String
    $fileId: String
    $active: Boolean
  ) {
    ContractTemplateSetter {
      updateContractTemplate(
        id: $updateContractTemplateId
        name: $name
        FileId: $fileId
        active: $active
      ) {
        id
        name
        active
        FileId
        createdAt
        updatedAt
        File {
          id
          name
          link
          mimeType
          createdAt
          type
          hash
        }
      }
    }
  }
`;
export type UpdateContractTemplateMutationFn = Apollo.MutationFunction<
  UpdateContractTemplateMutation,
  UpdateContractTemplateMutationVariables
>;

/**
 * __useUpdateContractTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateContractTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractTemplateMutation, { data, loading, error }] = useUpdateContractTemplateMutation({
 *   variables: {
 *      updateContractTemplateId: // value for 'updateContractTemplateId'
 *      name: // value for 'name'
 *      fileId: // value for 'fileId'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useUpdateContractTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateContractTemplateMutation,
    UpdateContractTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateContractTemplateMutation,
    UpdateContractTemplateMutationVariables
  >(UpdateContractTemplateDocument, options);
}
export type UpdateContractTemplateMutationHookResult = ReturnType<
  typeof useUpdateContractTemplateMutation
>;
export type UpdateContractTemplateMutationResult =
  Apollo.MutationResult<UpdateContractTemplateMutation>;
export type UpdateContractTemplateMutationOptions = Apollo.BaseMutationOptions<
  UpdateContractTemplateMutation,
  UpdateContractTemplateMutationVariables
>;
export const CreateTemplateRegisterDocument = gql`
  mutation createTemplateRegister(
    $name: String!
    $html: String!
    $type: ContractType! = Custom
  ) {
    DealerRegistrySetter {
      createTemplate(name: $name, html: $html, type: $type) {
        type
        html
        createdAt
        name
      }
    }
  }
`;
export type CreateTemplateRegisterMutationFn = Apollo.MutationFunction<
  CreateTemplateRegisterMutation,
  CreateTemplateRegisterMutationVariables
>;

/**
 * __useCreateTemplateRegisterMutation__
 *
 * To run a mutation, you first call `useCreateTemplateRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplateRegisterMutation, { data, loading, error }] = useCreateTemplateRegisterMutation({
 *   variables: {
 *      name: // value for 'name'
 *      html: // value for 'html'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateTemplateRegisterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTemplateRegisterMutation,
    CreateTemplateRegisterMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateTemplateRegisterMutation,
    CreateTemplateRegisterMutationVariables
  >(CreateTemplateRegisterDocument, options);
}
export type CreateTemplateRegisterMutationHookResult = ReturnType<
  typeof useCreateTemplateRegisterMutation
>;
export type CreateTemplateRegisterMutationResult =
  Apollo.MutationResult<CreateTemplateRegisterMutation>;
export type CreateTemplateRegisterMutationOptions = Apollo.BaseMutationOptions<
  CreateTemplateRegisterMutation,
  CreateTemplateRegisterMutationVariables
>;
export const CreateContractRegisterDocument = gql`
  mutation createContractRegister(
    $dealerId: ID!
    $templateId: ID!
    $number: String!
    $date: String!
  ) {
    DealerRegistrySetter {
      createContract(
        number: $number
        dealerId: $dealerId
        templateId: $templateId
        date: $date
      ) {
        DealerId
        createdAt
        date
        ArchiveDealerId
      }
    }
  }
`;
export type CreateContractRegisterMutationFn = Apollo.MutationFunction<
  CreateContractRegisterMutation,
  CreateContractRegisterMutationVariables
>;

/**
 * __useCreateContractRegisterMutation__
 *
 * To run a mutation, you first call `useCreateContractRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractRegisterMutation, { data, loading, error }] = useCreateContractRegisterMutation({
 *   variables: {
 *      dealerId: // value for 'dealerId'
 *      templateId: // value for 'templateId'
 *      number: // value for 'number'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useCreateContractRegisterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateContractRegisterMutation,
    CreateContractRegisterMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateContractRegisterMutation,
    CreateContractRegisterMutationVariables
  >(CreateContractRegisterDocument, options);
}
export type CreateContractRegisterMutationHookResult = ReturnType<
  typeof useCreateContractRegisterMutation
>;
export type CreateContractRegisterMutationResult =
  Apollo.MutationResult<CreateContractRegisterMutation>;
export type CreateContractRegisterMutationOptions = Apollo.BaseMutationOptions<
  CreateContractRegisterMutation,
  CreateContractRegisterMutationVariables
>;
export const CreatePeriodRegisterDocument = gql`
  mutation createPeriodRegister {
    DealerRegistrySetter {
      createPeriod {
        isCreatedByUser
        dateEnd
        dateStart
        createdAt
      }
    }
  }
`;
export type CreatePeriodRegisterMutationFn = Apollo.MutationFunction<
  CreatePeriodRegisterMutation,
  CreatePeriodRegisterMutationVariables
>;

/**
 * __useCreatePeriodRegisterMutation__
 *
 * To run a mutation, you first call `useCreatePeriodRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePeriodRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPeriodRegisterMutation, { data, loading, error }] = useCreatePeriodRegisterMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreatePeriodRegisterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePeriodRegisterMutation,
    CreatePeriodRegisterMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePeriodRegisterMutation,
    CreatePeriodRegisterMutationVariables
  >(CreatePeriodRegisterDocument, options);
}
export type CreatePeriodRegisterMutationHookResult = ReturnType<
  typeof useCreatePeriodRegisterMutation
>;
export type CreatePeriodRegisterMutationResult =
  Apollo.MutationResult<CreatePeriodRegisterMutation>;
export type CreatePeriodRegisterMutationOptions = Apollo.BaseMutationOptions<
  CreatePeriodRegisterMutation,
  CreatePeriodRegisterMutationVariables
>;
export const AddDealerToUserDocument = gql`
  mutation AddDealerToUser($UserId: ID!, $DealerId: ID!) {
    DealerSetter {
      addDealerToUser(UserId: $UserId, DealerId: $DealerId)
    }
  }
`;
export type AddDealerToUserMutationFn = Apollo.MutationFunction<
  AddDealerToUserMutation,
  AddDealerToUserMutationVariables
>;

/**
 * __useAddDealerToUserMutation__
 *
 * To run a mutation, you first call `useAddDealerToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDealerToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDealerToUserMutation, { data, loading, error }] = useAddDealerToUserMutation({
 *   variables: {
 *      UserId: // value for 'UserId'
 *      DealerId: // value for 'DealerId'
 *   },
 * });
 */
export function useAddDealerToUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddDealerToUserMutation,
    AddDealerToUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddDealerToUserMutation,
    AddDealerToUserMutationVariables
  >(AddDealerToUserDocument, options);
}
export type AddDealerToUserMutationHookResult = ReturnType<
  typeof useAddDealerToUserMutation
>;
export type AddDealerToUserMutationResult =
  Apollo.MutationResult<AddDealerToUserMutation>;
export type AddDealerToUserMutationOptions = Apollo.BaseMutationOptions<
  AddDealerToUserMutation,
  AddDealerToUserMutationVariables
>;
export const DeleteDealerFromUserDocument = gql`
  mutation DeleteDealerFromUser($UserId: ID!, $DealerId: ID!) {
    DealerSetter {
      deleteDealerFromUser(UserId: $UserId, DealerId: $DealerId)
    }
  }
`;
export type DeleteDealerFromUserMutationFn = Apollo.MutationFunction<
  DeleteDealerFromUserMutation,
  DeleteDealerFromUserMutationVariables
>;

/**
 * __useDeleteDealerFromUserMutation__
 *
 * To run a mutation, you first call `useDeleteDealerFromUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDealerFromUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDealerFromUserMutation, { data, loading, error }] = useDeleteDealerFromUserMutation({
 *   variables: {
 *      UserId: // value for 'UserId'
 *      DealerId: // value for 'DealerId'
 *   },
 * });
 */
export function useDeleteDealerFromUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDealerFromUserMutation,
    DeleteDealerFromUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteDealerFromUserMutation,
    DeleteDealerFromUserMutationVariables
  >(DeleteDealerFromUserDocument, options);
}
export type DeleteDealerFromUserMutationHookResult = ReturnType<
  typeof useDeleteDealerFromUserMutation
>;
export type DeleteDealerFromUserMutationResult =
  Apollo.MutationResult<DeleteDealerFromUserMutation>;
export type DeleteDealerFromUserMutationOptions = Apollo.BaseMutationOptions<
  DeleteDealerFromUserMutation,
  DeleteDealerFromUserMutationVariables
>;
export const ChangeDealerDocument = gql`
  mutation ChangeDealer(
    $KPP: String
    $ContractEndDate: DateTime
    $IS_Id: String
    $Main: Int
    $ScanAccountantPersonDataId: ID
    $ScanLadaPersonDataId: ID
    $legalAddress: String
    $postalAddress: String
    $legalCityId: ID
    $postalCityId: ID
    $cityId: ID
    $egrDate: DateTime
    $type: String
    $typeEn: String
    $DealerName: String
    $DealerNameEn: String
    $tradeDealerName: String
    $tradeDealerNameEn: String
    $legalDealerName: String
    $legalDealerNameEn: String
    $INN: String
    $newDealer: Int
    $temporaryDecision: Int
    $protocolOfIntentions: Int
    $logicalType: Int
    $extendedForNextYear: Int
    $terminated: Int
    $hideOnLadaRu: Int
    $DealerLADASERV: Int
    $OGRN: String
    $termOfAuthority: DateTime
    $consumerCode: String
    $corporateEmail: String
    $EGR_Number: String
    $EGR_Series: String
    $settlementAccount: String
    $correspondentAccount: String
    $BIK: String
    $bankName: String
    $responsibleForLadaEmail: String
    $responsibleForLadaFax: String
    $responsibleForLadaPhone: String
    $responsibleForLadaCode: String
    $responsibleForLadaName: String
    $accountantEmail: String
    $accountantFax: String
    $accountantPhone: String
    $accountantCode: String
    $accountantName: String
    $protocolOfTermination: String
    $protocolOfConclusion: String
    $category: String
    $code: String
    $regionCode: String
    $address: String
    $addressEn: String
    $country: String
    $countryEn: String
    $FO: String
    $FOEn: String
    $subject: String
    $subjectEn: String
    $city: String
    $cityEn: String
    $headFax: String
    $headCode: String
    $headNameGenitive: String
    $headPositionGenitive: String
    $EP: String
    $EPEn: String
    $headName: String
    $headNameEn: String
    $headPhone: String
    $headMobilePhone: String
    $headEmail: String
    $ownerName: String
    $ownerNameEn: String
    $ownerPhone: String
    $ownerMobilePhone: String
    $ownerEmail: String
    $birCode: String
    $beginWorkingDate: DateTime
    $contractId: ID
    $headCompanyId: ID
    $PhotoDealerCenterId: ID
    $PhotoOwnerId: ID
    $PhotoBossId: ID
    $ScanOwnerPersonDataId: ID
    $ScanBossPersonDataId: ID
    $OrganizationalLegalForm: String
    $id: ID!
    $successorId: ID!
    $status: DealerStatus
    $X_SHOP_FLAG: Boolean
    $X_STO_PHCODE: String
    $X_STO_PHONE: String
    $X_STO_EMAIL: String
    $X_SHOP_PHCODE: String
    $X_SHOP_PHONE: String
    $X_SHOP_EMAIL: String
    $X_SHOP_NAME: String
    $stoPhCode: String
    $stoPhone: String
    $stoEmail: String
    $houseId: ID
    $legalHouseId: ID
    $postalHouseId: ID
  ) {
    DealerSetter {
      changeDealer(
        type: $type
        typeEn: $typeEn
        DealerName: $DealerName
        postalAddress: $postalAddress
        legalAddress: $legalAddress
        ScanLadaPersonDataId: $ScanLadaPersonDataId
        ScanAccountantPersonDataId: $ScanAccountantPersonDataId
        legalCityId: $legalCityId
        postalCityId: $postalCityId
        CityId: $cityId
        DealerNameEn: $DealerNameEn
        tradeDealerName: $tradeDealerName
        tradeDealerNameEn: $tradeDealerNameEn
        legalDealerName: $legalDealerName
        legalDealerNameEn: $legalDealerNameEn
        INN: $INN
        KPP: $KPP
        ContractEndDate: $ContractEndDate
        IS_Id: $IS_Id
        Main: $Main
        newDealer: $newDealer
        temporaryDecision: $temporaryDecision
        protocolOfIntentions: $protocolOfIntentions
        logicalType: $logicalType
        extendedForNextYear: $extendedForNextYear
        terminated: $terminated
        hideOnLadaRu: $hideOnLadaRu
        DealerLADASERV: $DealerLADASERV
        OGRN: $OGRN
        termOfAuthority: $termOfAuthority
        consumerCode: $consumerCode
        corporateEmail: $corporateEmail
        EGR_Number: $EGR_Number
        EGR_Series: $EGR_Series
        EGR_Date: $egrDate
        settlementAccount: $settlementAccount
        correspondentAccount: $correspondentAccount
        BIK: $BIK
        bankName: $bankName
        responsibleForLadaEmail: $responsibleForLadaEmail
        responsibleForLadaFax: $responsibleForLadaFax
        responsibleForLadaPhone: $responsibleForLadaPhone
        responsibleForLadaCode: $responsibleForLadaCode
        responsibleForLadaName: $responsibleForLadaName
        accountantEmail: $accountantEmail
        accountantFax: $accountantFax
        accountantPhone: $accountantPhone
        accountantCode: $accountantCode
        accountantName: $accountantName
        protocolOfTermination: $protocolOfTermination
        protocolOfConclusion: $protocolOfConclusion
        successorId: $successorId
        category: $category
        code: $code
        regionCode: $regionCode
        address: $address
        addressEn: $addressEn
        country: $country
        countryEn: $countryEn
        FO: $FO
        FOEn: $FOEn
        subject: $subject
        subjectEn: $subjectEn
        city: $city
        cityEn: $cityEn
        headFax: $headFax
        headCode: $headCode
        headNameGenitive: $headNameGenitive
        headPositionGenitive: $headPositionGenitive
        EP: $EP
        EPEn: $EPEn
        headName: $headName
        headNameEn: $headNameEn
        headPhone: $headPhone
        headMobilePhone: $headMobilePhone
        headEmail: $headEmail
        ownerName: $ownerName
        ownerNameEn: $ownerNameEn
        ownerPhone: $ownerPhone
        ownerMobilePhone: $ownerMobilePhone
        ownerEmail: $ownerEmail
        birCode: $birCode
        beginWorkingDate: $beginWorkingDate
        contractId: $contractId
        headCompanyId: $headCompanyId
        PhotoDealerCenterId: $PhotoDealerCenterId
        PhotoOwnerId: $PhotoOwnerId
        PhotoBossId: $PhotoBossId
        ScanOwnerPersonDataId: $ScanOwnerPersonDataId
        ScanBossPersonDataId: $ScanBossPersonDataId
        OrganizationalLegalForm: $OrganizationalLegalForm
        id: $id
        X_SHOP_FLAG: $X_SHOP_FLAG
        X_STO_PHCODE: $X_STO_PHCODE
        X_STO_PHONE: $X_STO_PHONE
        X_STO_EMAIL: $X_STO_EMAIL
        X_SHOP_PHCODE: $X_SHOP_PHCODE
        X_SHOP_PHONE: $X_SHOP_PHONE
        X_SHOP_EMAIL: $X_SHOP_EMAIL
        X_SHOP_NAME: $X_SHOP_NAME
        stoPhCode: $stoPhCode
        stoPhone: $stoPhone
        stoEmail: $stoEmail
        status: $status
        HouseId: $houseId
        legalHouseId: $legalHouseId
        postalHouseId: $postalHouseId
      )
    }
  }
`;
export type ChangeDealerMutationFn = Apollo.MutationFunction<
  ChangeDealerMutation,
  ChangeDealerMutationVariables
>;

/**
 * __useChangeDealerMutation__
 *
 * To run a mutation, you first call `useChangeDealerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeDealerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeDealerMutation, { data, loading, error }] = useChangeDealerMutation({
 *   variables: {
 *      KPP: // value for 'KPP'
 *      ContractEndDate: // value for 'ContractEndDate'
 *      IS_Id: // value for 'IS_Id'
 *      Main: // value for 'Main'
 *      ScanAccountantPersonDataId: // value for 'ScanAccountantPersonDataId'
 *      ScanLadaPersonDataId: // value for 'ScanLadaPersonDataId'
 *      legalAddress: // value for 'legalAddress'
 *      postalAddress: // value for 'postalAddress'
 *      legalCityId: // value for 'legalCityId'
 *      postalCityId: // value for 'postalCityId'
 *      cityId: // value for 'cityId'
 *      egrDate: // value for 'egrDate'
 *      type: // value for 'type'
 *      typeEn: // value for 'typeEn'
 *      DealerName: // value for 'DealerName'
 *      DealerNameEn: // value for 'DealerNameEn'
 *      tradeDealerName: // value for 'tradeDealerName'
 *      tradeDealerNameEn: // value for 'tradeDealerNameEn'
 *      legalDealerName: // value for 'legalDealerName'
 *      legalDealerNameEn: // value for 'legalDealerNameEn'
 *      INN: // value for 'INN'
 *      newDealer: // value for 'newDealer'
 *      temporaryDecision: // value for 'temporaryDecision'
 *      protocolOfIntentions: // value for 'protocolOfIntentions'
 *      logicalType: // value for 'logicalType'
 *      extendedForNextYear: // value for 'extendedForNextYear'
 *      terminated: // value for 'terminated'
 *      hideOnLadaRu: // value for 'hideOnLadaRu'
 *      DealerLADASERV: // value for 'DealerLADASERV'
 *      OGRN: // value for 'OGRN'
 *      termOfAuthority: // value for 'termOfAuthority'
 *      consumerCode: // value for 'consumerCode'
 *      corporateEmail: // value for 'corporateEmail'
 *      EGR_Number: // value for 'EGR_Number'
 *      EGR_Series: // value for 'EGR_Series'
 *      settlementAccount: // value for 'settlementAccount'
 *      correspondentAccount: // value for 'correspondentAccount'
 *      BIK: // value for 'BIK'
 *      bankName: // value for 'bankName'
 *      responsibleForLadaEmail: // value for 'responsibleForLadaEmail'
 *      responsibleForLadaFax: // value for 'responsibleForLadaFax'
 *      responsibleForLadaPhone: // value for 'responsibleForLadaPhone'
 *      responsibleForLadaCode: // value for 'responsibleForLadaCode'
 *      responsibleForLadaName: // value for 'responsibleForLadaName'
 *      accountantEmail: // value for 'accountantEmail'
 *      accountantFax: // value for 'accountantFax'
 *      accountantPhone: // value for 'accountantPhone'
 *      accountantCode: // value for 'accountantCode'
 *      accountantName: // value for 'accountantName'
 *      protocolOfTermination: // value for 'protocolOfTermination'
 *      protocolOfConclusion: // value for 'protocolOfConclusion'
 *      category: // value for 'category'
 *      code: // value for 'code'
 *      regionCode: // value for 'regionCode'
 *      address: // value for 'address'
 *      addressEn: // value for 'addressEn'
 *      country: // value for 'country'
 *      countryEn: // value for 'countryEn'
 *      FO: // value for 'FO'
 *      FOEn: // value for 'FOEn'
 *      subject: // value for 'subject'
 *      subjectEn: // value for 'subjectEn'
 *      city: // value for 'city'
 *      cityEn: // value for 'cityEn'
 *      headFax: // value for 'headFax'
 *      headCode: // value for 'headCode'
 *      headNameGenitive: // value for 'headNameGenitive'
 *      headPositionGenitive: // value for 'headPositionGenitive'
 *      EP: // value for 'EP'
 *      EPEn: // value for 'EPEn'
 *      headName: // value for 'headName'
 *      headNameEn: // value for 'headNameEn'
 *      headPhone: // value for 'headPhone'
 *      headMobilePhone: // value for 'headMobilePhone'
 *      headEmail: // value for 'headEmail'
 *      ownerName: // value for 'ownerName'
 *      ownerNameEn: // value for 'ownerNameEn'
 *      ownerPhone: // value for 'ownerPhone'
 *      ownerMobilePhone: // value for 'ownerMobilePhone'
 *      ownerEmail: // value for 'ownerEmail'
 *      birCode: // value for 'birCode'
 *      beginWorkingDate: // value for 'beginWorkingDate'
 *      contractId: // value for 'contractId'
 *      headCompanyId: // value for 'headCompanyId'
 *      PhotoDealerCenterId: // value for 'PhotoDealerCenterId'
 *      PhotoOwnerId: // value for 'PhotoOwnerId'
 *      PhotoBossId: // value for 'PhotoBossId'
 *      ScanOwnerPersonDataId: // value for 'ScanOwnerPersonDataId'
 *      ScanBossPersonDataId: // value for 'ScanBossPersonDataId'
 *      OrganizationalLegalForm: // value for 'OrganizationalLegalForm'
 *      id: // value for 'id'
 *      successorId: // value for 'successorId'
 *      status: // value for 'status'
 *      X_SHOP_FLAG: // value for 'X_SHOP_FLAG'
 *      X_STO_PHCODE: // value for 'X_STO_PHCODE'
 *      X_STO_PHONE: // value for 'X_STO_PHONE'
 *      X_STO_EMAIL: // value for 'X_STO_EMAIL'
 *      X_SHOP_PHCODE: // value for 'X_SHOP_PHCODE'
 *      X_SHOP_PHONE: // value for 'X_SHOP_PHONE'
 *      X_SHOP_EMAIL: // value for 'X_SHOP_EMAIL'
 *      X_SHOP_NAME: // value for 'X_SHOP_NAME'
 *      stoPhCode: // value for 'stoPhCode'
 *      stoPhone: // value for 'stoPhone'
 *      stoEmail: // value for 'stoEmail'
 *      houseId: // value for 'houseId'
 *      legalHouseId: // value for 'legalHouseId'
 *      postalHouseId: // value for 'postalHouseId'
 *   },
 * });
 */
export function useChangeDealerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeDealerMutation,
    ChangeDealerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChangeDealerMutation,
    ChangeDealerMutationVariables
  >(ChangeDealerDocument, options);
}
export type ChangeDealerMutationHookResult = ReturnType<
  typeof useChangeDealerMutation
>;
export type ChangeDealerMutationResult =
  Apollo.MutationResult<ChangeDealerMutation>;
export type ChangeDealerMutationOptions = Apollo.BaseMutationOptions<
  ChangeDealerMutation,
  ChangeDealerMutationVariables
>;
export const UploadDealersDocument = gql`
  mutation uploadDealers($fileId: ID!, $description: String) {
    DealerSetter {
      uploadDealers(fileId: $fileId, description: $description)
    }
  }
`;
export type UploadDealersMutationFn = Apollo.MutationFunction<
  UploadDealersMutation,
  UploadDealersMutationVariables
>;

/**
 * __useUploadDealersMutation__
 *
 * To run a mutation, you first call `useUploadDealersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDealersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDealersMutation, { data, loading, error }] = useUploadDealersMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUploadDealersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadDealersMutation,
    UploadDealersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadDealersMutation,
    UploadDealersMutationVariables
  >(UploadDealersDocument, options);
}
export type UploadDealersMutationHookResult = ReturnType<
  typeof useUploadDealersMutation
>;
export type UploadDealersMutationResult =
  Apollo.MutationResult<UploadDealersMutation>;
export type UploadDealersMutationOptions = Apollo.BaseMutationOptions<
  UploadDealersMutation,
  UploadDealersMutationVariables
>;
export const SetProjectDocumentationDealerDocument = gql`
  mutation setProjectDocumentationDealer(
    $FileId: ID!
    $DealerId: ID!
    $name: String!
  ) {
    DealerSetter {
      setProjectDocumentationDealer(
        FileId: $FileId
        DealerId: $DealerId
        name: $name
      ) {
        id
      }
    }
  }
`;
export type SetProjectDocumentationDealerMutationFn = Apollo.MutationFunction<
  SetProjectDocumentationDealerMutation,
  SetProjectDocumentationDealerMutationVariables
>;

/**
 * __useSetProjectDocumentationDealerMutation__
 *
 * To run a mutation, you first call `useSetProjectDocumentationDealerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProjectDocumentationDealerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProjectDocumentationDealerMutation, { data, loading, error }] = useSetProjectDocumentationDealerMutation({
 *   variables: {
 *      FileId: // value for 'FileId'
 *      DealerId: // value for 'DealerId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSetProjectDocumentationDealerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetProjectDocumentationDealerMutation,
    SetProjectDocumentationDealerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetProjectDocumentationDealerMutation,
    SetProjectDocumentationDealerMutationVariables
  >(SetProjectDocumentationDealerDocument, options);
}
export type SetProjectDocumentationDealerMutationHookResult = ReturnType<
  typeof useSetProjectDocumentationDealerMutation
>;
export type SetProjectDocumentationDealerMutationResult =
  Apollo.MutationResult<SetProjectDocumentationDealerMutation>;
export type SetProjectDocumentationDealerMutationOptions =
  Apollo.BaseMutationOptions<
    SetProjectDocumentationDealerMutation,
    SetProjectDocumentationDealerMutationVariables
  >;
export const AcceptUploadDealerValuesDocument = gql`
  mutation acceptUploadDealerValues($IndicatorUploadId: ID!) {
    DealerSetter {
      acceptUploadDealer(IndicatorUploadId: $IndicatorUploadId)
    }
  }
`;
export type AcceptUploadDealerValuesMutationFn = Apollo.MutationFunction<
  AcceptUploadDealerValuesMutation,
  AcceptUploadDealerValuesMutationVariables
>;

/**
 * __useAcceptUploadDealerValuesMutation__
 *
 * To run a mutation, you first call `useAcceptUploadDealerValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptUploadDealerValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptUploadDealerValuesMutation, { data, loading, error }] = useAcceptUploadDealerValuesMutation({
 *   variables: {
 *      IndicatorUploadId: // value for 'IndicatorUploadId'
 *   },
 * });
 */
export function useAcceptUploadDealerValuesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptUploadDealerValuesMutation,
    AcceptUploadDealerValuesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AcceptUploadDealerValuesMutation,
    AcceptUploadDealerValuesMutationVariables
  >(AcceptUploadDealerValuesDocument, options);
}
export type AcceptUploadDealerValuesMutationHookResult = ReturnType<
  typeof useAcceptUploadDealerValuesMutation
>;
export type AcceptUploadDealerValuesMutationResult =
  Apollo.MutationResult<AcceptUploadDealerValuesMutation>;
export type AcceptUploadDealerValuesMutationOptions =
  Apollo.BaseMutationOptions<
    AcceptUploadDealerValuesMutation,
    AcceptUploadDealerValuesMutationVariables
  >;
export const GetFreeIdDocument = gql`
  mutation getFreeId {
    DealerSetter {
      getFreeId
    }
  }
`;
export type GetFreeIdMutationFn = Apollo.MutationFunction<
  GetFreeIdMutation,
  GetFreeIdMutationVariables
>;

/**
 * __useGetFreeIdMutation__
 *
 * To run a mutation, you first call `useGetFreeIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetFreeIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getFreeIdMutation, { data, loading, error }] = useGetFreeIdMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetFreeIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GetFreeIdMutation,
    GetFreeIdMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GetFreeIdMutation, GetFreeIdMutationVariables>(
    GetFreeIdDocument,
    options,
  );
}
export type GetFreeIdMutationHookResult = ReturnType<
  typeof useGetFreeIdMutation
>;
export type GetFreeIdMutationResult = Apollo.MutationResult<GetFreeIdMutation>;
export type GetFreeIdMutationOptions = Apollo.BaseMutationOptions<
  GetFreeIdMutation,
  GetFreeIdMutationVariables
>;
export const CreateDealerDocument = gql`
  mutation CreateDealer(
    $KPP: String!
    $ContractEndDate: DateTime
    $IS_Id: String
    $Main: Int
    $ScanAccountantPersonDataId: ID
    $ScanLadaPersonDataId: ID
    $reestrAddress: String
    $reestrPostAddress: String
    $reestrLegalAddress: String
    $type: String
    $typeEn: String
    $DealerName: String
    $DealerNameEn: String
    $tradeDealerName: String
    $tradeDealerNameEn: String
    $legalDealerName: String
    $legalDealerNameEn: String
    $INN: String
    $newDealer: Int
    $temporaryDecision: Int
    $protocolOfIntentions: Int
    $logicalType: Int
    $extendedForNextYear: Int
    $terminated: Int
    $hideOnLadaRu: Int
    $DealerLADASERV: Int
    $OGRN: String
    $termOfAuthority: DateTime
    $consumerCode: String
    $corporateEmail: String
    $EGR_Number: String
    $EGR_Series: String
    $EGR_Date: DateTime
    $settlementAccount: String
    $correspondentAccount: String
    $BIK: String
    $bankName: String
    $responsibleForLadaEmail: String
    $responsibleForLadaFax: String
    $responsibleForLadaPhone: String
    $responsibleForLadaCode: String
    $responsibleForLadaName: String
    $accountantEmail: String
    $accountantFax: String
    $accountantPhone: String
    $accountantCode: String
    $accountantName: String
    $protocolOfTermination: String
    $protocolOfConclusion: String
    $category: String
    $code: String
    $regionCode: String
    $headFax: String
    $headCode: String
    $headNameGenitive: String
    $headPositionGenitive: String
    $EP: String
    $EPEn: String
    $headName: String
    $headNameEn: String
    $headPhone: String
    $headMobilePhone: String
    $headEmail: String
    $ownerName: String
    $ownerNameEn: String
    $ownerPhone: String
    $ownerMobilePhone: String
    $ownerEmail: String
    $birCode: String
    $beginWorkingDate: DateTime
    $contractId: ID
    $headCompanyId: ID
    $PhotoDealerCenterId: ID
    $PhotoOwnerId: ID
    $PhotoBossId: ID
    $ScanOwnerPersonDataId: ID
    $ScanBossPersonDataId: ID
    $OrganizationalLegalForm: String
    $status: DealerStatus
    $id: ID!
    $successorId: ID!
    $X_SHOP_FLAG: Boolean
    $X_STO_PHCODE: String
    $X_STO_PHONE: String
    $X_STO_EMAIL: String
    $X_SHOP_PHCODE: String
    $X_SHOP_PHONE: String
    $X_SHOP_EMAIL: String
    $X_SHOP_NAME: String
    $stoPhCode: String
    $stoPhone: String
    $stoEmail: String
  ) {
    DealerSetter {
      createDealer(
        INN: $INN
        KPP: $KPP
        ContractEndDate: $ContractEndDate
        IS_Id: $IS_Id
        Main: $Main
        reestrAddress: $reestrAddress
        reestrPostAddress: $reestrPostAddress
        reestrLegalAddress: $reestrLegalAddress
        ScanLadaPersonDataId: $ScanLadaPersonDataId
        ScanAccountantPersonDataId: $ScanAccountantPersonDataId
        type: $type
        typeEn: $typeEn
        DealerName: $DealerName
        DealerNameEn: $DealerNameEn
        tradeDealerName: $tradeDealerName
        tradeDealerNameEn: $tradeDealerNameEn
        legalDealerName: $legalDealerName
        legalDealerNameEn: $legalDealerNameEn
        newDealer: $newDealer
        temporaryDecision: $temporaryDecision
        protocolOfIntentions: $protocolOfIntentions
        logicalType: $logicalType
        extendedForNextYear: $extendedForNextYear
        terminated: $terminated
        hideOnLadaRu: $hideOnLadaRu
        DealerLADASERV: $DealerLADASERV
        OGRN: $OGRN
        termOfAuthority: $termOfAuthority
        consumerCode: $consumerCode
        corporateEmail: $corporateEmail
        EGR_Number: $EGR_Number
        EGR_Series: $EGR_Series
        EGR_Date: $EGR_Date
        settlementAccount: $settlementAccount
        correspondentAccount: $correspondentAccount
        BIK: $BIK
        bankName: $bankName
        responsibleForLadaEmail: $responsibleForLadaEmail
        responsibleForLadaFax: $responsibleForLadaFax
        responsibleForLadaPhone: $responsibleForLadaPhone
        responsibleForLadaCode: $responsibleForLadaCode
        responsibleForLadaName: $responsibleForLadaName
        accountantEmail: $accountantEmail
        accountantFax: $accountantFax
        accountantPhone: $accountantPhone
        accountantCode: $accountantCode
        accountantName: $accountantName
        protocolOfTermination: $protocolOfTermination
        protocolOfConclusion: $protocolOfConclusion
        category: $category
        code: $code
        regionCode: $regionCode
        headFax: $headFax
        headCode: $headCode
        headNameGenitive: $headNameGenitive
        headPositionGenitive: $headPositionGenitive
        EP: $EP
        EPEn: $EPEn
        headName: $headName
        headNameEn: $headNameEn
        headPhone: $headPhone
        headMobilePhone: $headMobilePhone
        headEmail: $headEmail
        ownerName: $ownerName
        ownerNameEn: $ownerNameEn
        ownerPhone: $ownerPhone
        ownerMobilePhone: $ownerMobilePhone
        ownerEmail: $ownerEmail
        birCode: $birCode
        beginWorkingDate: $beginWorkingDate
        contractId: $contractId
        headCompanyId: $headCompanyId
        PhotoDealerCenterId: $PhotoDealerCenterId
        PhotoOwnerId: $PhotoOwnerId
        PhotoBossId: $PhotoBossId
        ScanOwnerPersonDataId: $ScanOwnerPersonDataId
        ScanBossPersonDataId: $ScanBossPersonDataId
        OrganizationalLegalForm: $OrganizationalLegalForm
        status: $status
        successorId: $successorId
        id: $id
        X_SHOP_FLAG: $X_SHOP_FLAG
        X_STO_PHCODE: $X_STO_PHCODE
        X_STO_PHONE: $X_STO_PHONE
        X_STO_EMAIL: $X_STO_EMAIL
        X_SHOP_PHCODE: $X_SHOP_PHCODE
        X_SHOP_PHONE: $X_SHOP_PHONE
        X_SHOP_EMAIL: $X_SHOP_EMAIL
        X_SHOP_NAME: $X_SHOP_NAME
        stoPhCode: $stoPhCode
        stoPhone: $stoPhone
        stoEmail: $stoEmail
      ) {
        id
        status
      }
    }
  }
`;
export type CreateDealerMutationFn = Apollo.MutationFunction<
  CreateDealerMutation,
  CreateDealerMutationVariables
>;

/**
 * __useCreateDealerMutation__
 *
 * To run a mutation, you first call `useCreateDealerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDealerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDealerMutation, { data, loading, error }] = useCreateDealerMutation({
 *   variables: {
 *      KPP: // value for 'KPP'
 *      ContractEndDate: // value for 'ContractEndDate'
 *      IS_Id: // value for 'IS_Id'
 *      Main: // value for 'Main'
 *      ScanAccountantPersonDataId: // value for 'ScanAccountantPersonDataId'
 *      ScanLadaPersonDataId: // value for 'ScanLadaPersonDataId'
 *      reestrAddress: // value for 'reestrAddress'
 *      reestrPostAddress: // value for 'reestrPostAddress'
 *      reestrLegalAddress: // value for 'reestrLegalAddress'
 *      type: // value for 'type'
 *      typeEn: // value for 'typeEn'
 *      DealerName: // value for 'DealerName'
 *      DealerNameEn: // value for 'DealerNameEn'
 *      tradeDealerName: // value for 'tradeDealerName'
 *      tradeDealerNameEn: // value for 'tradeDealerNameEn'
 *      legalDealerName: // value for 'legalDealerName'
 *      legalDealerNameEn: // value for 'legalDealerNameEn'
 *      INN: // value for 'INN'
 *      newDealer: // value for 'newDealer'
 *      temporaryDecision: // value for 'temporaryDecision'
 *      protocolOfIntentions: // value for 'protocolOfIntentions'
 *      logicalType: // value for 'logicalType'
 *      extendedForNextYear: // value for 'extendedForNextYear'
 *      terminated: // value for 'terminated'
 *      hideOnLadaRu: // value for 'hideOnLadaRu'
 *      DealerLADASERV: // value for 'DealerLADASERV'
 *      OGRN: // value for 'OGRN'
 *      termOfAuthority: // value for 'termOfAuthority'
 *      consumerCode: // value for 'consumerCode'
 *      corporateEmail: // value for 'corporateEmail'
 *      EGR_Number: // value for 'EGR_Number'
 *      EGR_Series: // value for 'EGR_Series'
 *      EGR_Date: // value for 'EGR_Date'
 *      settlementAccount: // value for 'settlementAccount'
 *      correspondentAccount: // value for 'correspondentAccount'
 *      BIK: // value for 'BIK'
 *      bankName: // value for 'bankName'
 *      responsibleForLadaEmail: // value for 'responsibleForLadaEmail'
 *      responsibleForLadaFax: // value for 'responsibleForLadaFax'
 *      responsibleForLadaPhone: // value for 'responsibleForLadaPhone'
 *      responsibleForLadaCode: // value for 'responsibleForLadaCode'
 *      responsibleForLadaName: // value for 'responsibleForLadaName'
 *      accountantEmail: // value for 'accountantEmail'
 *      accountantFax: // value for 'accountantFax'
 *      accountantPhone: // value for 'accountantPhone'
 *      accountantCode: // value for 'accountantCode'
 *      accountantName: // value for 'accountantName'
 *      protocolOfTermination: // value for 'protocolOfTermination'
 *      protocolOfConclusion: // value for 'protocolOfConclusion'
 *      category: // value for 'category'
 *      code: // value for 'code'
 *      regionCode: // value for 'regionCode'
 *      headFax: // value for 'headFax'
 *      headCode: // value for 'headCode'
 *      headNameGenitive: // value for 'headNameGenitive'
 *      headPositionGenitive: // value for 'headPositionGenitive'
 *      EP: // value for 'EP'
 *      EPEn: // value for 'EPEn'
 *      headName: // value for 'headName'
 *      headNameEn: // value for 'headNameEn'
 *      headPhone: // value for 'headPhone'
 *      headMobilePhone: // value for 'headMobilePhone'
 *      headEmail: // value for 'headEmail'
 *      ownerName: // value for 'ownerName'
 *      ownerNameEn: // value for 'ownerNameEn'
 *      ownerPhone: // value for 'ownerPhone'
 *      ownerMobilePhone: // value for 'ownerMobilePhone'
 *      ownerEmail: // value for 'ownerEmail'
 *      birCode: // value for 'birCode'
 *      beginWorkingDate: // value for 'beginWorkingDate'
 *      contractId: // value for 'contractId'
 *      headCompanyId: // value for 'headCompanyId'
 *      PhotoDealerCenterId: // value for 'PhotoDealerCenterId'
 *      PhotoOwnerId: // value for 'PhotoOwnerId'
 *      PhotoBossId: // value for 'PhotoBossId'
 *      ScanOwnerPersonDataId: // value for 'ScanOwnerPersonDataId'
 *      ScanBossPersonDataId: // value for 'ScanBossPersonDataId'
 *      OrganizationalLegalForm: // value for 'OrganizationalLegalForm'
 *      status: // value for 'status'
 *      id: // value for 'id'
 *      successorId: // value for 'successorId'
 *      X_SHOP_FLAG: // value for 'X_SHOP_FLAG'
 *      X_STO_PHCODE: // value for 'X_STO_PHCODE'
 *      X_STO_PHONE: // value for 'X_STO_PHONE'
 *      X_STO_EMAIL: // value for 'X_STO_EMAIL'
 *      X_SHOP_PHCODE: // value for 'X_SHOP_PHCODE'
 *      X_SHOP_PHONE: // value for 'X_SHOP_PHONE'
 *      X_SHOP_EMAIL: // value for 'X_SHOP_EMAIL'
 *      X_SHOP_NAME: // value for 'X_SHOP_NAME'
 *      stoPhCode: // value for 'stoPhCode'
 *      stoPhone: // value for 'stoPhone'
 *      stoEmail: // value for 'stoEmail'
 *   },
 * });
 */
export function useCreateDealerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDealerMutation,
    CreateDealerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDealerMutation,
    CreateDealerMutationVariables
  >(CreateDealerDocument, options);
}
export type CreateDealerMutationHookResult = ReturnType<
  typeof useCreateDealerMutation
>;
export type CreateDealerMutationResult =
  Apollo.MutationResult<CreateDealerMutation>;
export type CreateDealerMutationOptions = Apollo.BaseMutationOptions<
  CreateDealerMutation,
  CreateDealerMutationVariables
>;
export const CreateDealerDomainDocument = gql`
  mutation createDealerDomain($domain: String!, $dealerId: ID!) {
    DealerSetter {
      createDealerDomain(domain: $domain, dealerId: $dealerId) {
        id
      }
    }
  }
`;
export type CreateDealerDomainMutationFn = Apollo.MutationFunction<
  CreateDealerDomainMutation,
  CreateDealerDomainMutationVariables
>;

/**
 * __useCreateDealerDomainMutation__
 *
 * To run a mutation, you first call `useCreateDealerDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDealerDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDealerDomainMutation, { data, loading, error }] = useCreateDealerDomainMutation({
 *   variables: {
 *      domain: // value for 'domain'
 *      dealerId: // value for 'dealerId'
 *   },
 * });
 */
export function useCreateDealerDomainMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDealerDomainMutation,
    CreateDealerDomainMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDealerDomainMutation,
    CreateDealerDomainMutationVariables
  >(CreateDealerDomainDocument, options);
}
export type CreateDealerDomainMutationHookResult = ReturnType<
  typeof useCreateDealerDomainMutation
>;
export type CreateDealerDomainMutationResult =
  Apollo.MutationResult<CreateDealerDomainMutation>;
export type CreateDealerDomainMutationOptions = Apollo.BaseMutationOptions<
  CreateDealerDomainMutation,
  CreateDealerDomainMutationVariables
>;
export const DeleteDealerDomainDocument = gql`
  mutation deleteDealerDomain($domainId: ID!) {
    DealerSetter {
      deleteDealerDomain(domainId: $domainId)
    }
  }
`;
export type DeleteDealerDomainMutationFn = Apollo.MutationFunction<
  DeleteDealerDomainMutation,
  DeleteDealerDomainMutationVariables
>;

/**
 * __useDeleteDealerDomainMutation__
 *
 * To run a mutation, you first call `useDeleteDealerDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDealerDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDealerDomainMutation, { data, loading, error }] = useDeleteDealerDomainMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useDeleteDealerDomainMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDealerDomainMutation,
    DeleteDealerDomainMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteDealerDomainMutation,
    DeleteDealerDomainMutationVariables
  >(DeleteDealerDomainDocument, options);
}
export type DeleteDealerDomainMutationHookResult = ReturnType<
  typeof useDeleteDealerDomainMutation
>;
export type DeleteDealerDomainMutationResult =
  Apollo.MutationResult<DeleteDealerDomainMutation>;
export type DeleteDealerDomainMutationOptions = Apollo.BaseMutationOptions<
  DeleteDealerDomainMutation,
  DeleteDealerDomainMutationVariables
>;
export const ChangeDealerFieldDocument = gql`
  mutation changeDealerField(
    $changeDealerFieldId: ID!
    $fieldRu: String
    $fieldEn: String
    $fieldRuDescription: String
    $fieldEnDescription: String
  ) {
    DealerSetter {
      changeDealerField(
        id: $changeDealerFieldId
        fieldRu: $fieldRu
        fieldEn: $fieldEn
        fieldRuDescription: $fieldRuDescription
        fieldEnDescription: $fieldEnDescription
      )
    }
  }
`;
export type ChangeDealerFieldMutationFn = Apollo.MutationFunction<
  ChangeDealerFieldMutation,
  ChangeDealerFieldMutationVariables
>;

/**
 * __useChangeDealerFieldMutation__
 *
 * To run a mutation, you first call `useChangeDealerFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeDealerFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeDealerFieldMutation, { data, loading, error }] = useChangeDealerFieldMutation({
 *   variables: {
 *      changeDealerFieldId: // value for 'changeDealerFieldId'
 *      fieldRu: // value for 'fieldRu'
 *      fieldEn: // value for 'fieldEn'
 *      fieldRuDescription: // value for 'fieldRuDescription'
 *      fieldEnDescription: // value for 'fieldEnDescription'
 *   },
 * });
 */
export function useChangeDealerFieldMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeDealerFieldMutation,
    ChangeDealerFieldMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChangeDealerFieldMutation,
    ChangeDealerFieldMutationVariables
  >(ChangeDealerFieldDocument, options);
}
export type ChangeDealerFieldMutationHookResult = ReturnType<
  typeof useChangeDealerFieldMutation
>;
export type ChangeDealerFieldMutationResult =
  Apollo.MutationResult<ChangeDealerFieldMutation>;
export type ChangeDealerFieldMutationOptions = Apollo.BaseMutationOptions<
  ChangeDealerFieldMutation,
  ChangeDealerFieldMutationVariables
>;
export const CreateCatalogDocument = gql`
  mutation CreateCatalog($name: String, $parentId: ID) {
    DocumentSetter {
      createSection(name: $name, parentId: $parentId) {
        ... on Section {
          ...Catalog
        }
      }
    }
  }
  ${CatalogFragmentDoc}
`;
export type CreateCatalogMutationFn = Apollo.MutationFunction<
  CreateCatalogMutation,
  CreateCatalogMutationVariables
>;

/**
 * __useCreateCatalogMutation__
 *
 * To run a mutation, you first call `useCreateCatalogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCatalogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCatalogMutation, { data, loading, error }] = useCreateCatalogMutation({
 *   variables: {
 *      name: // value for 'name'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useCreateCatalogMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCatalogMutation,
    CreateCatalogMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCatalogMutation,
    CreateCatalogMutationVariables
  >(CreateCatalogDocument, options);
}
export type CreateCatalogMutationHookResult = ReturnType<
  typeof useCreateCatalogMutation
>;
export type CreateCatalogMutationResult =
  Apollo.MutationResult<CreateCatalogMutation>;
export type CreateCatalogMutationOptions = Apollo.BaseMutationOptions<
  CreateCatalogMutation,
  CreateCatalogMutationVariables
>;
export const EditCatalogDocument = gql`
  mutation EditCatalog($id: ID, $name: String, $parentId: ID) {
    DocumentSetter {
      editSection(id: $id, name: $name, parentId: $parentId) {
        ... on Section {
          ...Catalog
        }
      }
    }
  }
  ${CatalogFragmentDoc}
`;
export type EditCatalogMutationFn = Apollo.MutationFunction<
  EditCatalogMutation,
  EditCatalogMutationVariables
>;

/**
 * __useEditCatalogMutation__
 *
 * To run a mutation, you first call `useEditCatalogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCatalogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCatalogMutation, { data, loading, error }] = useEditCatalogMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useEditCatalogMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditCatalogMutation,
    EditCatalogMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EditCatalogMutation, EditCatalogMutationVariables>(
    EditCatalogDocument,
    options,
  );
}
export type EditCatalogMutationHookResult = ReturnType<
  typeof useEditCatalogMutation
>;
export type EditCatalogMutationResult =
  Apollo.MutationResult<EditCatalogMutation>;
export type EditCatalogMutationOptions = Apollo.BaseMutationOptions<
  EditCatalogMutation,
  EditCatalogMutationVariables
>;
export const DeleteCatalogDocument = gql`
  mutation DeleteCatalog($id: ID) {
    DocumentSetter {
      deleteSection(id: $id) {
        ... on Section {
          ...Catalog
        }
      }
    }
  }
  ${CatalogFragmentDoc}
`;
export type DeleteCatalogMutationFn = Apollo.MutationFunction<
  DeleteCatalogMutation,
  DeleteCatalogMutationVariables
>;

/**
 * __useDeleteCatalogMutation__
 *
 * To run a mutation, you first call `useDeleteCatalogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCatalogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCatalogMutation, { data, loading, error }] = useDeleteCatalogMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCatalogMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCatalogMutation,
    DeleteCatalogMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCatalogMutation,
    DeleteCatalogMutationVariables
  >(DeleteCatalogDocument, options);
}
export type DeleteCatalogMutationHookResult = ReturnType<
  typeof useDeleteCatalogMutation
>;
export type DeleteCatalogMutationResult =
  Apollo.MutationResult<DeleteCatalogMutation>;
export type DeleteCatalogMutationOptions = Apollo.BaseMutationOptions<
  DeleteCatalogMutation,
  DeleteCatalogMutationVariables
>;
export const CreateDocumentDocument = gql`
  mutation CreateDocument(
    $name: String
    $description: String
    $importance: String
    $signedBy: String
    $sectionId: ID
    $subSectionId: ID
    $SubdivisionId: ID
    $status: String
    $filesIds: [ID]!
  ) {
    DocumentSetter {
      create(
        name: $name
        description: $description
        importance: $importance
        signedBy: $signedBy
        sectionId: $sectionId
        subSectionId: $subSectionId
        SubdivisionId: $SubdivisionId
        status: $status
        filesIds: $filesIds
      ) {
        ... on Document {
          ...Document
        }
      }
    }
  }
  ${DocumentFragmentDoc}
`;
export type CreateDocumentMutationFn = Apollo.MutationFunction<
  CreateDocumentMutation,
  CreateDocumentMutationVariables
>;

/**
 * __useCreateDocumentMutation__
 *
 * To run a mutation, you first call `useCreateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentMutation, { data, loading, error }] = useCreateDocumentMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      importance: // value for 'importance'
 *      signedBy: // value for 'signedBy'
 *      sectionId: // value for 'sectionId'
 *      subSectionId: // value for 'subSectionId'
 *      SubdivisionId: // value for 'SubdivisionId'
 *      status: // value for 'status'
 *      filesIds: // value for 'filesIds'
 *   },
 * });
 */
export function useCreateDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDocumentMutation,
    CreateDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDocumentMutation,
    CreateDocumentMutationVariables
  >(CreateDocumentDocument, options);
}
export type CreateDocumentMutationHookResult = ReturnType<
  typeof useCreateDocumentMutation
>;
export type CreateDocumentMutationResult =
  Apollo.MutationResult<CreateDocumentMutation>;
export type CreateDocumentMutationOptions = Apollo.BaseMutationOptions<
  CreateDocumentMutation,
  CreateDocumentMutationVariables
>;
export const EditDocumentDocument = gql`
  mutation EditDocument(
    $id: ID
    $name: String
    $description: String
    $importance: String
    $signedBy: String
    $sectionId: ID
    $subSectionId: ID
    $SubdivisionId: ID
    $status: String
    $filesIds: [ID]
  ) {
    DocumentSetter {
      edit(
        id: $id
        name: $name
        description: $description
        importance: $importance
        signedBy: $signedBy
        sectionId: $sectionId
        subSectionId: $subSectionId
        SubdivisionId: $SubdivisionId
        status: $status
        filesId: $filesIds
      ) {
        ... on Document {
          ...Document
        }
      }
    }
  }
  ${DocumentFragmentDoc}
`;
export type EditDocumentMutationFn = Apollo.MutationFunction<
  EditDocumentMutation,
  EditDocumentMutationVariables
>;

/**
 * __useEditDocumentMutation__
 *
 * To run a mutation, you first call `useEditDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDocumentMutation, { data, loading, error }] = useEditDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      importance: // value for 'importance'
 *      signedBy: // value for 'signedBy'
 *      sectionId: // value for 'sectionId'
 *      subSectionId: // value for 'subSectionId'
 *      SubdivisionId: // value for 'SubdivisionId'
 *      status: // value for 'status'
 *      filesIds: // value for 'filesIds'
 *   },
 * });
 */
export function useEditDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditDocumentMutation,
    EditDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditDocumentMutation,
    EditDocumentMutationVariables
  >(EditDocumentDocument, options);
}
export type EditDocumentMutationHookResult = ReturnType<
  typeof useEditDocumentMutation
>;
export type EditDocumentMutationResult =
  Apollo.MutationResult<EditDocumentMutation>;
export type EditDocumentMutationOptions = Apollo.BaseMutationOptions<
  EditDocumentMutation,
  EditDocumentMutationVariables
>;
export const SetDocumentStatusDocument = gql`
  mutation SetDocumentStatus(
    $id: ID
    $status: String
    $canceledReason: String
  ) {
    DocumentSetter {
      setStatus(id: $id, status: $status, canceledReason: $canceledReason) {
        ... on Document {
          ...Document
        }
      }
    }
  }
  ${DocumentFragmentDoc}
`;
export type SetDocumentStatusMutationFn = Apollo.MutationFunction<
  SetDocumentStatusMutation,
  SetDocumentStatusMutationVariables
>;

/**
 * __useSetDocumentStatusMutation__
 *
 * To run a mutation, you first call `useSetDocumentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDocumentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDocumentStatusMutation, { data, loading, error }] = useSetDocumentStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      canceledReason: // value for 'canceledReason'
 *   },
 * });
 */
export function useSetDocumentStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetDocumentStatusMutation,
    SetDocumentStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetDocumentStatusMutation,
    SetDocumentStatusMutationVariables
  >(SetDocumentStatusDocument, options);
}
export type SetDocumentStatusMutationHookResult = ReturnType<
  typeof useSetDocumentStatusMutation
>;
export type SetDocumentStatusMutationResult =
  Apollo.MutationResult<SetDocumentStatusMutation>;
export type SetDocumentStatusMutationOptions = Apollo.BaseMutationOptions<
  SetDocumentStatusMutation,
  SetDocumentStatusMutationVariables
>;
export const EditCurriculumGroupDocument = gql`
  mutation EditCurriculumGroup(
    $id: ID!
    $name: String
    $status: CurriculumGroupStatus
    $sequenceNumber: Int
  ) {
    EducationSetter {
      editCurriculumGroup(
        id: $id
        name: $name
        status: $status
        sequenceNumber: $sequenceNumber
      ) {
        id
      }
    }
  }
`;
export type EditCurriculumGroupMutationFn = Apollo.MutationFunction<
  EditCurriculumGroupMutation,
  EditCurriculumGroupMutationVariables
>;

/**
 * __useEditCurriculumGroupMutation__
 *
 * To run a mutation, you first call `useEditCurriculumGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCurriculumGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCurriculumGroupMutation, { data, loading, error }] = useEditCurriculumGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      status: // value for 'status'
 *      sequenceNumber: // value for 'sequenceNumber'
 *   },
 * });
 */
export function useEditCurriculumGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditCurriculumGroupMutation,
    EditCurriculumGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditCurriculumGroupMutation,
    EditCurriculumGroupMutationVariables
  >(EditCurriculumGroupDocument, options);
}
export type EditCurriculumGroupMutationHookResult = ReturnType<
  typeof useEditCurriculumGroupMutation
>;
export type EditCurriculumGroupMutationResult =
  Apollo.MutationResult<EditCurriculumGroupMutation>;
export type EditCurriculumGroupMutationOptions = Apollo.BaseMutationOptions<
  EditCurriculumGroupMutation,
  EditCurriculumGroupMutationVariables
>;
export const CreateCurriculumGroupDocument = gql`
  mutation CreateCurriculumGroup(
    $name: String!
    $status: CurriculumGroupStatus!
    $sequenceNumber: Int
  ) {
    EducationSetter {
      createCurriculumGroup(
        name: $name
        status: $status
        sequenceNumber: $sequenceNumber
      ) {
        id
      }
    }
  }
`;
export type CreateCurriculumGroupMutationFn = Apollo.MutationFunction<
  CreateCurriculumGroupMutation,
  CreateCurriculumGroupMutationVariables
>;

/**
 * __useCreateCurriculumGroupMutation__
 *
 * To run a mutation, you first call `useCreateCurriculumGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCurriculumGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCurriculumGroupMutation, { data, loading, error }] = useCreateCurriculumGroupMutation({
 *   variables: {
 *      name: // value for 'name'
 *      status: // value for 'status'
 *      sequenceNumber: // value for 'sequenceNumber'
 *   },
 * });
 */
export function useCreateCurriculumGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCurriculumGroupMutation,
    CreateCurriculumGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCurriculumGroupMutation,
    CreateCurriculumGroupMutationVariables
  >(CreateCurriculumGroupDocument, options);
}
export type CreateCurriculumGroupMutationHookResult = ReturnType<
  typeof useCreateCurriculumGroupMutation
>;
export type CreateCurriculumGroupMutationResult =
  Apollo.MutationResult<CreateCurriculumGroupMutation>;
export type CreateCurriculumGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateCurriculumGroupMutation,
  CreateCurriculumGroupMutationVariables
>;
export const EditCurriculumLevelDocument = gql`
  mutation EditCurriculumLevel(
    $id: ID!
    $name: String
    $status: CurriculumLevelStatus
    $GroupId: ID
    $sequenceNumber: Int
    $isCertification: Boolean
    $dateActiveStatus: DateTime
    $dateInactiveStatus: DateTime
  ) {
    EducationSetter {
      editCurriculumLevel(
        id: $id
        name: $name
        status: $status
        GroupId: $GroupId
        sequenceNumber: $sequenceNumber
        isCertification: $isCertification
        dateActiveStatus: $dateActiveStatus
        dateInactiveStatus: $dateInactiveStatus
      ) {
        id
      }
    }
  }
`;
export type EditCurriculumLevelMutationFn = Apollo.MutationFunction<
  EditCurriculumLevelMutation,
  EditCurriculumLevelMutationVariables
>;

/**
 * __useEditCurriculumLevelMutation__
 *
 * To run a mutation, you first call `useEditCurriculumLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCurriculumLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCurriculumLevelMutation, { data, loading, error }] = useEditCurriculumLevelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      status: // value for 'status'
 *      GroupId: // value for 'GroupId'
 *      sequenceNumber: // value for 'sequenceNumber'
 *      isCertification: // value for 'isCertification'
 *      dateActiveStatus: // value for 'dateActiveStatus'
 *      dateInactiveStatus: // value for 'dateInactiveStatus'
 *   },
 * });
 */
export function useEditCurriculumLevelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditCurriculumLevelMutation,
    EditCurriculumLevelMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditCurriculumLevelMutation,
    EditCurriculumLevelMutationVariables
  >(EditCurriculumLevelDocument, options);
}
export type EditCurriculumLevelMutationHookResult = ReturnType<
  typeof useEditCurriculumLevelMutation
>;
export type EditCurriculumLevelMutationResult =
  Apollo.MutationResult<EditCurriculumLevelMutation>;
export type EditCurriculumLevelMutationOptions = Apollo.BaseMutationOptions<
  EditCurriculumLevelMutation,
  EditCurriculumLevelMutationVariables
>;
export const CreateCurriculumLevelDocument = gql`
  mutation CreateCurriculumLevel(
    $name: String!
    $status: CurriculumLevelStatus!
    $GroupId: ID!
    $sequenceNumber: Int
    $isCertification: Boolean
  ) {
    EducationSetter {
      createCurriculumLevel(
        name: $name
        status: $status
        GroupId: $GroupId
        sequenceNumber: $sequenceNumber
        isCertification: $isCertification
      ) {
        id
      }
    }
  }
`;
export type CreateCurriculumLevelMutationFn = Apollo.MutationFunction<
  CreateCurriculumLevelMutation,
  CreateCurriculumLevelMutationVariables
>;

/**
 * __useCreateCurriculumLevelMutation__
 *
 * To run a mutation, you first call `useCreateCurriculumLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCurriculumLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCurriculumLevelMutation, { data, loading, error }] = useCreateCurriculumLevelMutation({
 *   variables: {
 *      name: // value for 'name'
 *      status: // value for 'status'
 *      GroupId: // value for 'GroupId'
 *      sequenceNumber: // value for 'sequenceNumber'
 *      isCertification: // value for 'isCertification'
 *   },
 * });
 */
export function useCreateCurriculumLevelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCurriculumLevelMutation,
    CreateCurriculumLevelMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCurriculumLevelMutation,
    CreateCurriculumLevelMutationVariables
  >(CreateCurriculumLevelDocument, options);
}
export type CreateCurriculumLevelMutationHookResult = ReturnType<
  typeof useCreateCurriculumLevelMutation
>;
export type CreateCurriculumLevelMutationResult =
  Apollo.MutationResult<CreateCurriculumLevelMutation>;
export type CreateCurriculumLevelMutationOptions = Apollo.BaseMutationOptions<
  CreateCurriculumLevelMutation,
  CreateCurriculumLevelMutationVariables
>;
export const EditCurriculumCourseDocument = gql`
  mutation EditCurriculumCourse(
    $id: ID!
    $code: String
    $name: String
    $status: CurriculumCourseStatus
    $codeIS: String
    $LevelId: ID
    $certificateValidityPeriod: ID
  ) {
    EducationSetter {
      editCurriculumCourse(
        id: $id
        code: $code
        name: $name
        status: $status
        codeIS: $codeIS
        LevelId: $LevelId
        certificateValidityPeriod: $certificateValidityPeriod
      ) {
        id
      }
    }
  }
`;
export type EditCurriculumCourseMutationFn = Apollo.MutationFunction<
  EditCurriculumCourseMutation,
  EditCurriculumCourseMutationVariables
>;

/**
 * __useEditCurriculumCourseMutation__
 *
 * To run a mutation, you first call `useEditCurriculumCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCurriculumCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCurriculumCourseMutation, { data, loading, error }] = useEditCurriculumCourseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      code: // value for 'code'
 *      name: // value for 'name'
 *      status: // value for 'status'
 *      codeIS: // value for 'codeIS'
 *      LevelId: // value for 'LevelId'
 *      certificateValidityPeriod: // value for 'certificateValidityPeriod'
 *   },
 * });
 */
export function useEditCurriculumCourseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditCurriculumCourseMutation,
    EditCurriculumCourseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditCurriculumCourseMutation,
    EditCurriculumCourseMutationVariables
  >(EditCurriculumCourseDocument, options);
}
export type EditCurriculumCourseMutationHookResult = ReturnType<
  typeof useEditCurriculumCourseMutation
>;
export type EditCurriculumCourseMutationResult =
  Apollo.MutationResult<EditCurriculumCourseMutation>;
export type EditCurriculumCourseMutationOptions = Apollo.BaseMutationOptions<
  EditCurriculumCourseMutation,
  EditCurriculumCourseMutationVariables
>;
export const CreateCurriculumCourseDocument = gql`
  mutation CreateCurriculumCourse(
    $code: String!
    $codeIS: String
    $name: String!
    $LevelId: ID
    $status: CurriculumCourseStatus
    $certificateValidityPeriod: ID
  ) {
    EducationSetter {
      createCurriculumCourse(
        code: $code
        name: $name
        status: $status
        codeIS: $codeIS
        LevelId: $LevelId
        certificateValidityPeriod: $certificateValidityPeriod
      ) {
        id
      }
    }
  }
`;
export type CreateCurriculumCourseMutationFn = Apollo.MutationFunction<
  CreateCurriculumCourseMutation,
  CreateCurriculumCourseMutationVariables
>;

/**
 * __useCreateCurriculumCourseMutation__
 *
 * To run a mutation, you first call `useCreateCurriculumCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCurriculumCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCurriculumCourseMutation, { data, loading, error }] = useCreateCurriculumCourseMutation({
 *   variables: {
 *      code: // value for 'code'
 *      codeIS: // value for 'codeIS'
 *      name: // value for 'name'
 *      LevelId: // value for 'LevelId'
 *      status: // value for 'status'
 *      certificateValidityPeriod: // value for 'certificateValidityPeriod'
 *   },
 * });
 */
export function useCreateCurriculumCourseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCurriculumCourseMutation,
    CreateCurriculumCourseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCurriculumCourseMutation,
    CreateCurriculumCourseMutationVariables
  >(CreateCurriculumCourseDocument, options);
}
export type CreateCurriculumCourseMutationHookResult = ReturnType<
  typeof useCreateCurriculumCourseMutation
>;
export type CreateCurriculumCourseMutationResult =
  Apollo.MutationResult<CreateCurriculumCourseMutation>;
export type CreateCurriculumCourseMutationOptions = Apollo.BaseMutationOptions<
  CreateCurriculumCourseMutation,
  CreateCurriculumCourseMutationVariables
>;
export const EditCurriculumPositionStudyProgramsDocument = gql`
  mutation EditCurriculumPositionStudyPrograms(
    $levels: [createCurriculumPositionStudyProgramsLevels]
    $PositionGroupId: ID
    $PositionIds: [ID]
  ) {
    EducationSetter {
      editCurriculumPositionStudyPrograms(
        levels: $levels
        PositionGroupId: $PositionGroupId
        PositionIds: $PositionIds
      ) {
        type
        levelId
        result
        message
      }
    }
  }
`;
export type EditCurriculumPositionStudyProgramsMutationFn =
  Apollo.MutationFunction<
    EditCurriculumPositionStudyProgramsMutation,
    EditCurriculumPositionStudyProgramsMutationVariables
  >;

/**
 * __useEditCurriculumPositionStudyProgramsMutation__
 *
 * To run a mutation, you first call `useEditCurriculumPositionStudyProgramsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCurriculumPositionStudyProgramsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCurriculumPositionStudyProgramsMutation, { data, loading, error }] = useEditCurriculumPositionStudyProgramsMutation({
 *   variables: {
 *      levels: // value for 'levels'
 *      PositionGroupId: // value for 'PositionGroupId'
 *      PositionIds: // value for 'PositionIds'
 *   },
 * });
 */
export function useEditCurriculumPositionStudyProgramsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditCurriculumPositionStudyProgramsMutation,
    EditCurriculumPositionStudyProgramsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditCurriculumPositionStudyProgramsMutation,
    EditCurriculumPositionStudyProgramsMutationVariables
  >(EditCurriculumPositionStudyProgramsDocument, options);
}
export type EditCurriculumPositionStudyProgramsMutationHookResult = ReturnType<
  typeof useEditCurriculumPositionStudyProgramsMutation
>;
export type EditCurriculumPositionStudyProgramsMutationResult =
  Apollo.MutationResult<EditCurriculumPositionStudyProgramsMutation>;
export type EditCurriculumPositionStudyProgramsMutationOptions =
  Apollo.BaseMutationOptions<
    EditCurriculumPositionStudyProgramsMutation,
    EditCurriculumPositionStudyProgramsMutationVariables
  >;
export const CreateCurriculumPositionStudyProgramsDocument = gql`
  mutation CreateCurriculumPositionStudyPrograms(
    $levels: [createCurriculumPositionStudyProgramsLevels]
    $PositionIds: [ID]!
  ) {
    EducationSetter {
      createCurriculumPositionStudyPrograms(
        levels: $levels
        PositionIds: $PositionIds
      ) {
        id
      }
    }
  }
`;
export type CreateCurriculumPositionStudyProgramsMutationFn =
  Apollo.MutationFunction<
    CreateCurriculumPositionStudyProgramsMutation,
    CreateCurriculumPositionStudyProgramsMutationVariables
  >;

/**
 * __useCreateCurriculumPositionStudyProgramsMutation__
 *
 * To run a mutation, you first call `useCreateCurriculumPositionStudyProgramsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCurriculumPositionStudyProgramsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCurriculumPositionStudyProgramsMutation, { data, loading, error }] = useCreateCurriculumPositionStudyProgramsMutation({
 *   variables: {
 *      levels: // value for 'levels'
 *      PositionIds: // value for 'PositionIds'
 *   },
 * });
 */
export function useCreateCurriculumPositionStudyProgramsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCurriculumPositionStudyProgramsMutation,
    CreateCurriculumPositionStudyProgramsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCurriculumPositionStudyProgramsMutation,
    CreateCurriculumPositionStudyProgramsMutationVariables
  >(CreateCurriculumPositionStudyProgramsDocument, options);
}
export type CreateCurriculumPositionStudyProgramsMutationHookResult =
  ReturnType<typeof useCreateCurriculumPositionStudyProgramsMutation>;
export type CreateCurriculumPositionStudyProgramsMutationResult =
  Apollo.MutationResult<CreateCurriculumPositionStudyProgramsMutation>;
export type CreateCurriculumPositionStudyProgramsMutationOptions =
  Apollo.BaseMutationOptions<
    CreateCurriculumPositionStudyProgramsMutation,
    CreateCurriculumPositionStudyProgramsMutationVariables
  >;
export const SetGroupEducationEmployeeExpectationIndicatorDocument = gql`
  mutation SetGroupEducationEmployeeExpectationIndicator(
    $GroupTrainingId: ID
    $GroupCertificationId: ID
  ) {
    EmployeeSetter {
      setGroupEducationEmployeeExpectationIndicator(
        GroupTrainingId: $GroupTrainingId
        GroupCertificationId: $GroupCertificationId
      )
    }
  }
`;
export type SetGroupEducationEmployeeExpectationIndicatorMutationFn =
  Apollo.MutationFunction<
    SetGroupEducationEmployeeExpectationIndicatorMutation,
    SetGroupEducationEmployeeExpectationIndicatorMutationVariables
  >;

/**
 * __useSetGroupEducationEmployeeExpectationIndicatorMutation__
 *
 * To run a mutation, you first call `useSetGroupEducationEmployeeExpectationIndicatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGroupEducationEmployeeExpectationIndicatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGroupEducationEmployeeExpectationIndicatorMutation, { data, loading, error }] = useSetGroupEducationEmployeeExpectationIndicatorMutation({
 *   variables: {
 *      GroupTrainingId: // value for 'GroupTrainingId'
 *      GroupCertificationId: // value for 'GroupCertificationId'
 *   },
 * });
 */
export function useSetGroupEducationEmployeeExpectationIndicatorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetGroupEducationEmployeeExpectationIndicatorMutation,
    SetGroupEducationEmployeeExpectationIndicatorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetGroupEducationEmployeeExpectationIndicatorMutation,
    SetGroupEducationEmployeeExpectationIndicatorMutationVariables
  >(SetGroupEducationEmployeeExpectationIndicatorDocument, options);
}
export type SetGroupEducationEmployeeExpectationIndicatorMutationHookResult =
  ReturnType<typeof useSetGroupEducationEmployeeExpectationIndicatorMutation>;
export type SetGroupEducationEmployeeExpectationIndicatorMutationResult =
  Apollo.MutationResult<SetGroupEducationEmployeeExpectationIndicatorMutation>;
export type SetGroupEducationEmployeeExpectationIndicatorMutationOptions =
  Apollo.BaseMutationOptions<
    SetGroupEducationEmployeeExpectationIndicatorMutation,
    SetGroupEducationEmployeeExpectationIndicatorMutationVariables
  >;
export const EditCurriculumPositionStudyProgramDocument = gql`
  mutation EditCurriculumPositionStudyProgram(
    $PositionGroupId: ID!
    $LevelId: ID
    $CourseId: ID!
  ) {
    EducationSetter {
      editCurriculumPositionStudyProgram(
        PositionGroupId: $PositionGroupId
        LevelId: $LevelId
        CourseId: $CourseId
      ) {
        LevelId
      }
    }
  }
`;
export type EditCurriculumPositionStudyProgramMutationFn =
  Apollo.MutationFunction<
    EditCurriculumPositionStudyProgramMutation,
    EditCurriculumPositionStudyProgramMutationVariables
  >;

/**
 * __useEditCurriculumPositionStudyProgramMutation__
 *
 * To run a mutation, you first call `useEditCurriculumPositionStudyProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCurriculumPositionStudyProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCurriculumPositionStudyProgramMutation, { data, loading, error }] = useEditCurriculumPositionStudyProgramMutation({
 *   variables: {
 *      PositionGroupId: // value for 'PositionGroupId'
 *      LevelId: // value for 'LevelId'
 *      CourseId: // value for 'CourseId'
 *   },
 * });
 */
export function useEditCurriculumPositionStudyProgramMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditCurriculumPositionStudyProgramMutation,
    EditCurriculumPositionStudyProgramMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditCurriculumPositionStudyProgramMutation,
    EditCurriculumPositionStudyProgramMutationVariables
  >(EditCurriculumPositionStudyProgramDocument, options);
}
export type EditCurriculumPositionStudyProgramMutationHookResult = ReturnType<
  typeof useEditCurriculumPositionStudyProgramMutation
>;
export type EditCurriculumPositionStudyProgramMutationResult =
  Apollo.MutationResult<EditCurriculumPositionStudyProgramMutation>;
export type EditCurriculumPositionStudyProgramMutationOptions =
  Apollo.BaseMutationOptions<
    EditCurriculumPositionStudyProgramMutation,
    EditCurriculumPositionStudyProgramMutationVariables
  >;
export const AddBaseStaffDocument = gql`
  mutation AddBaseStaff(
    $surname: String!
    $name: String!
    $middleName: String
    $gender: GenderType!
    $birthDay: DateTime!
    $personalPhone: String
    $workPhone: String!
    $photoId: ID
    $ResourcesControlUserId: String
    $ladaAcademiaId: String!
    $HiredDate: DateTime!
    $positions: [EmployeePositionInput!]
    $ignore: Boolean!
    $DataConsentIds: [Consent]
  ) {
    EmployeeSetter {
      create(
        surname: $surname
        name: $name
        middleName: $middleName
        gender: $gender
        birthDay: $birthDay
        personalPhone: $personalPhone
        ladaAcademiaId: $ladaAcademiaId
        workPhone: $workPhone
        photoId: $photoId
        ResourcesControlUserId: $ResourcesControlUserId
        HiredDate: $HiredDate
        positions: $positions
        DataConsentIds: $DataConsentIds
      ) {
        id
        isCreated
      }
    }
  }
`;
export type AddBaseStaffMutationFn = Apollo.MutationFunction<
  AddBaseStaffMutation,
  AddBaseStaffMutationVariables
>;

/**
 * __useAddBaseStaffMutation__
 *
 * To run a mutation, you first call `useAddBaseStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBaseStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBaseStaffMutation, { data, loading, error }] = useAddBaseStaffMutation({
 *   variables: {
 *      surname: // value for 'surname'
 *      name: // value for 'name'
 *      middleName: // value for 'middleName'
 *      gender: // value for 'gender'
 *      birthDay: // value for 'birthDay'
 *      personalPhone: // value for 'personalPhone'
 *      workPhone: // value for 'workPhone'
 *      photoId: // value for 'photoId'
 *      ResourcesControlUserId: // value for 'ResourcesControlUserId'
 *      ladaAcademiaId: // value for 'ladaAcademiaId'
 *      HiredDate: // value for 'HiredDate'
 *      positions: // value for 'positions'
 *      ignore: // value for 'ignore'
 *      DataConsentIds: // value for 'DataConsentIds'
 *   },
 * });
 */
export function useAddBaseStaffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddBaseStaffMutation,
    AddBaseStaffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddBaseStaffMutation,
    AddBaseStaffMutationVariables
  >(AddBaseStaffDocument, options);
}
export type AddBaseStaffMutationHookResult = ReturnType<
  typeof useAddBaseStaffMutation
>;
export type AddBaseStaffMutationResult =
  Apollo.MutationResult<AddBaseStaffMutation>;
export type AddBaseStaffMutationOptions = Apollo.BaseMutationOptions<
  AddBaseStaffMutation,
  AddBaseStaffMutationVariables
>;
export const EditBaseStaffDocument = gql`
  mutation EditBaseStaff(
    $id: ID!
    $photoId: ID!
    $positions: [EditEmployeePositionInput!]!
  ) {
    EmployeeSetter {
      edit(id: $id, photoId: $photoId, positions: $positions)
    }
  }
`;
export type EditBaseStaffMutationFn = Apollo.MutationFunction<
  EditBaseStaffMutation,
  EditBaseStaffMutationVariables
>;

/**
 * __useEditBaseStaffMutation__
 *
 * To run a mutation, you first call `useEditBaseStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBaseStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBaseStaffMutation, { data, loading, error }] = useEditBaseStaffMutation({
 *   variables: {
 *      id: // value for 'id'
 *      photoId: // value for 'photoId'
 *      positions: // value for 'positions'
 *   },
 * });
 */
export function useEditBaseStaffMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditBaseStaffMutation,
    EditBaseStaffMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditBaseStaffMutation,
    EditBaseStaffMutationVariables
  >(EditBaseStaffDocument, options);
}
export type EditBaseStaffMutationHookResult = ReturnType<
  typeof useEditBaseStaffMutation
>;
export type EditBaseStaffMutationResult =
  Apollo.MutationResult<EditBaseStaffMutation>;
export type EditBaseStaffMutationOptions = Apollo.BaseMutationOptions<
  EditBaseStaffMutation,
  EditBaseStaffMutationVariables
>;
export const UpdateLastStatusDatePositionDealerDocument = gql`
  mutation updateLastStatusDatePositionDealer(
    $EmployeeId: ID!
    $EmployeePositionId: ID!
  ) {
    EmployeeSetter {
      updateLastStatusDatePositionDealer(
        EmployeeId: $EmployeeId
        EmployeePositionId: $EmployeePositionId
      )
    }
  }
`;
export type UpdateLastStatusDatePositionDealerMutationFn =
  Apollo.MutationFunction<
    UpdateLastStatusDatePositionDealerMutation,
    UpdateLastStatusDatePositionDealerMutationVariables
  >;

/**
 * __useUpdateLastStatusDatePositionDealerMutation__
 *
 * To run a mutation, you first call `useUpdateLastStatusDatePositionDealerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLastStatusDatePositionDealerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLastStatusDatePositionDealerMutation, { data, loading, error }] = useUpdateLastStatusDatePositionDealerMutation({
 *   variables: {
 *      EmployeeId: // value for 'EmployeeId'
 *      EmployeePositionId: // value for 'EmployeePositionId'
 *   },
 * });
 */
export function useUpdateLastStatusDatePositionDealerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateLastStatusDatePositionDealerMutation,
    UpdateLastStatusDatePositionDealerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateLastStatusDatePositionDealerMutation,
    UpdateLastStatusDatePositionDealerMutationVariables
  >(UpdateLastStatusDatePositionDealerDocument, options);
}
export type UpdateLastStatusDatePositionDealerMutationHookResult = ReturnType<
  typeof useUpdateLastStatusDatePositionDealerMutation
>;
export type UpdateLastStatusDatePositionDealerMutationResult =
  Apollo.MutationResult<UpdateLastStatusDatePositionDealerMutation>;
export type UpdateLastStatusDatePositionDealerMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateLastStatusDatePositionDealerMutation,
    UpdateLastStatusDatePositionDealerMutationVariables
  >;
export const RestorePositionEmployeeDocument = gql`
  mutation restorePositionEmployee(
    $EmployeeId: ID!
    $PositionId: ID!
    $DealerId: ID!
    $number: EmployeePositionNumber!
  ) {
    EmployeeSetter {
      restorePositionEmployee(
        EmployeeId: $EmployeeId
        PositionId: $PositionId
        DealerId: $DealerId
        number: $number
      )
    }
  }
`;
export type RestorePositionEmployeeMutationFn = Apollo.MutationFunction<
  RestorePositionEmployeeMutation,
  RestorePositionEmployeeMutationVariables
>;

/**
 * __useRestorePositionEmployeeMutation__
 *
 * To run a mutation, you first call `useRestorePositionEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestorePositionEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restorePositionEmployeeMutation, { data, loading, error }] = useRestorePositionEmployeeMutation({
 *   variables: {
 *      EmployeeId: // value for 'EmployeeId'
 *      PositionId: // value for 'PositionId'
 *      DealerId: // value for 'DealerId'
 *      number: // value for 'number'
 *   },
 * });
 */
export function useRestorePositionEmployeeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RestorePositionEmployeeMutation,
    RestorePositionEmployeeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RestorePositionEmployeeMutation,
    RestorePositionEmployeeMutationVariables
  >(RestorePositionEmployeeDocument, options);
}
export type RestorePositionEmployeeMutationHookResult = ReturnType<
  typeof useRestorePositionEmployeeMutation
>;
export type RestorePositionEmployeeMutationResult =
  Apollo.MutationResult<RestorePositionEmployeeMutation>;
export type RestorePositionEmployeeMutationOptions = Apollo.BaseMutationOptions<
  RestorePositionEmployeeMutation,
  RestorePositionEmployeeMutationVariables
>;
export const SendCheckDocument = gql`
  mutation SendCheck($employeeId: ID!) {
    EmployeeSetter {
      changeStatus {
        sendCheck(employeeId: $employeeId) {
          ok
        }
      }
    }
  }
`;
export type SendCheckMutationFn = Apollo.MutationFunction<
  SendCheckMutation,
  SendCheckMutationVariables
>;

/**
 * __useSendCheckMutation__
 *
 * To run a mutation, you first call `useSendCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCheckMutation, { data, loading, error }] = useSendCheckMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useSendCheckMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendCheckMutation,
    SendCheckMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SendCheckMutation, SendCheckMutationVariables>(
    SendCheckDocument,
    options,
  );
}
export type SendCheckMutationHookResult = ReturnType<
  typeof useSendCheckMutation
>;
export type SendCheckMutationResult = Apollo.MutationResult<SendCheckMutation>;
export type SendCheckMutationOptions = Apollo.BaseMutationOptions<
  SendCheckMutation,
  SendCheckMutationVariables
>;
export const MarkVerifiedDocument = gql`
  mutation MarkVerified($positionId: ID!) {
    EmployeeSetter {
      changeStatus {
        markVerified(positionId: $positionId) {
          ok
        }
      }
    }
  }
`;
export type MarkVerifiedMutationFn = Apollo.MutationFunction<
  MarkVerifiedMutation,
  MarkVerifiedMutationVariables
>;

/**
 * __useMarkVerifiedMutation__
 *
 * To run a mutation, you first call `useMarkVerifiedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkVerifiedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markVerifiedMutation, { data, loading, error }] = useMarkVerifiedMutation({
 *   variables: {
 *      positionId: // value for 'positionId'
 *   },
 * });
 */
export function useMarkVerifiedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkVerifiedMutation,
    MarkVerifiedMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkVerifiedMutation,
    MarkVerifiedMutationVariables
  >(MarkVerifiedDocument, options);
}
export type MarkVerifiedMutationHookResult = ReturnType<
  typeof useMarkVerifiedMutation
>;
export type MarkVerifiedMutationResult =
  Apollo.MutationResult<MarkVerifiedMutation>;
export type MarkVerifiedMutationOptions = Apollo.BaseMutationOptions<
  MarkVerifiedMutation,
  MarkVerifiedMutationVariables
>;
export const MarkRejectDocument = gql`
  mutation MarkReject($positionId: ID!, $rejectReason: String) {
    EmployeeSetter {
      changeStatus {
        markReject(positionId: $positionId, rejectReason: $rejectReason) {
          ok
        }
      }
    }
  }
`;
export type MarkRejectMutationFn = Apollo.MutationFunction<
  MarkRejectMutation,
  MarkRejectMutationVariables
>;

/**
 * __useMarkRejectMutation__
 *
 * To run a mutation, you first call `useMarkRejectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkRejectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markRejectMutation, { data, loading, error }] = useMarkRejectMutation({
 *   variables: {
 *      positionId: // value for 'positionId'
 *      rejectReason: // value for 'rejectReason'
 *   },
 * });
 */
export function useMarkRejectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkRejectMutation,
    MarkRejectMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MarkRejectMutation, MarkRejectMutationVariables>(
    MarkRejectDocument,
    options,
  );
}
export type MarkRejectMutationHookResult = ReturnType<
  typeof useMarkRejectMutation
>;
export type MarkRejectMutationResult =
  Apollo.MutationResult<MarkRejectMutation>;
export type MarkRejectMutationOptions = Apollo.BaseMutationOptions<
  MarkRejectMutation,
  MarkRejectMutationVariables
>;
export const UploadFileCatalogDocument = gql`
  mutation uploadFileCatalog(
    $fileId: ID!
    $catalog: String!
    $DealerId: ID
    $name: String
  ) {
    FileCatalogSetter {
      uploadFile(
        fileId: $fileId
        name: $name
        DealerId: $DealerId
        catalog: $catalog
      ) {
        id
        name
        link
        mimeType
        type
        createdAt
        hash
        User {
          fullname
          fullnameEn
        }
      }
    }
  }
`;
export type UploadFileCatalogMutationFn = Apollo.MutationFunction<
  UploadFileCatalogMutation,
  UploadFileCatalogMutationVariables
>;

/**
 * __useUploadFileCatalogMutation__
 *
 * To run a mutation, you first call `useUploadFileCatalogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileCatalogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileCatalogMutation, { data, loading, error }] = useUploadFileCatalogMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      catalog: // value for 'catalog'
 *      DealerId: // value for 'DealerId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUploadFileCatalogMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadFileCatalogMutation,
    UploadFileCatalogMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadFileCatalogMutation,
    UploadFileCatalogMutationVariables
  >(UploadFileCatalogDocument, options);
}
export type UploadFileCatalogMutationHookResult = ReturnType<
  typeof useUploadFileCatalogMutation
>;
export type UploadFileCatalogMutationResult =
  Apollo.MutationResult<UploadFileCatalogMutation>;
export type UploadFileCatalogMutationOptions = Apollo.BaseMutationOptions<
  UploadFileCatalogMutation,
  UploadFileCatalogMutationVariables
>;
export const DeleteFileCatalogDocument = gql`
  mutation deleteFileCatalog($FileId: ID!) {
    FileCatalogSetter {
      deleteFile(FileId: $FileId)
    }
  }
`;
export type DeleteFileCatalogMutationFn = Apollo.MutationFunction<
  DeleteFileCatalogMutation,
  DeleteFileCatalogMutationVariables
>;

/**
 * __useDeleteFileCatalogMutation__
 *
 * To run a mutation, you first call `useDeleteFileCatalogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileCatalogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileCatalogMutation, { data, loading, error }] = useDeleteFileCatalogMutation({
 *   variables: {
 *      FileId: // value for 'FileId'
 *   },
 * });
 */
export function useDeleteFileCatalogMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteFileCatalogMutation,
    DeleteFileCatalogMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteFileCatalogMutation,
    DeleteFileCatalogMutationVariables
  >(DeleteFileCatalogDocument, options);
}
export type DeleteFileCatalogMutationHookResult = ReturnType<
  typeof useDeleteFileCatalogMutation
>;
export type DeleteFileCatalogMutationResult =
  Apollo.MutationResult<DeleteFileCatalogMutation>;
export type DeleteFileCatalogMutationOptions = Apollo.BaseMutationOptions<
  DeleteFileCatalogMutation,
  DeleteFileCatalogMutationVariables
>;
export const EditFileCatalogDocument = gql`
  mutation editFileCatalog($FileId: ID!, $catalog: String, $name: String) {
    FileCatalogSetter {
      editFile(FileId: $FileId, catalog: $catalog, name: $name) {
        id
        name
        createdAt
      }
    }
  }
`;
export type EditFileCatalogMutationFn = Apollo.MutationFunction<
  EditFileCatalogMutation,
  EditFileCatalogMutationVariables
>;

/**
 * __useEditFileCatalogMutation__
 *
 * To run a mutation, you first call `useEditFileCatalogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditFileCatalogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editFileCatalogMutation, { data, loading, error }] = useEditFileCatalogMutation({
 *   variables: {
 *      FileId: // value for 'FileId'
 *      catalog: // value for 'catalog'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEditFileCatalogMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditFileCatalogMutation,
    EditFileCatalogMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditFileCatalogMutation,
    EditFileCatalogMutationVariables
  >(EditFileCatalogDocument, options);
}
export type EditFileCatalogMutationHookResult = ReturnType<
  typeof useEditFileCatalogMutation
>;
export type EditFileCatalogMutationResult =
  Apollo.MutationResult<EditFileCatalogMutation>;
export type EditFileCatalogMutationOptions = Apollo.BaseMutationOptions<
  EditFileCatalogMutation,
  EditFileCatalogMutationVariables
>;
export const CreateGeoPlaceDocument = gql`
  mutation CreateGeoPlace(
    $name: String!
    $socr: String!
    $cladrCode: String!
    $okatoCode: String!
    $type: GeoPlaceType!
    $active: Boolean!
    $parentId: ID
  ) {
    GeoSetter {
      createGeoPlace(
        name: $name
        socr: $socr
        cladrCode: $cladrCode
        okatoCode: $okatoCode
        type: $type
        active: $active
        parentId: $parentId
      ) {
        id
        parentId
        type
        name
        nameEn
        socr
        cladrCode
        okatoCode
        active
        createdAt
        updatedAt
      }
    }
  }
`;
export type CreateGeoPlaceMutationFn = Apollo.MutationFunction<
  CreateGeoPlaceMutation,
  CreateGeoPlaceMutationVariables
>;

/**
 * __useCreateGeoPlaceMutation__
 *
 * To run a mutation, you first call `useCreateGeoPlaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGeoPlaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGeoPlaceMutation, { data, loading, error }] = useCreateGeoPlaceMutation({
 *   variables: {
 *      name: // value for 'name'
 *      socr: // value for 'socr'
 *      cladrCode: // value for 'cladrCode'
 *      okatoCode: // value for 'okatoCode'
 *      type: // value for 'type'
 *      active: // value for 'active'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useCreateGeoPlaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateGeoPlaceMutation,
    CreateGeoPlaceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateGeoPlaceMutation,
    CreateGeoPlaceMutationVariables
  >(CreateGeoPlaceDocument, options);
}
export type CreateGeoPlaceMutationHookResult = ReturnType<
  typeof useCreateGeoPlaceMutation
>;
export type CreateGeoPlaceMutationResult =
  Apollo.MutationResult<CreateGeoPlaceMutation>;
export type CreateGeoPlaceMutationOptions = Apollo.BaseMutationOptions<
  CreateGeoPlaceMutation,
  CreateGeoPlaceMutationVariables
>;
export const ChangeGeoPlaceDocument = gql`
  mutation ChangeGeoPlace(
    $changeGeoPlaceId: ID!
    $name: String!
    $socr: String!
    $cladrCode: String!
    $okatoCode: String!
    $type: GeoPlaceType!
    $active: Boolean!
    $parentId: ID
  ) {
    GeoSetter {
      changeGeoPlace(
        id: $changeGeoPlaceId
        name: $name
        socr: $socr
        cladrCode: $cladrCode
        okatoCode: $okatoCode
        type: $type
        active: $active
        parentId: $parentId
      )
    }
  }
`;
export type ChangeGeoPlaceMutationFn = Apollo.MutationFunction<
  ChangeGeoPlaceMutation,
  ChangeGeoPlaceMutationVariables
>;

/**
 * __useChangeGeoPlaceMutation__
 *
 * To run a mutation, you first call `useChangeGeoPlaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeGeoPlaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeGeoPlaceMutation, { data, loading, error }] = useChangeGeoPlaceMutation({
 *   variables: {
 *      changeGeoPlaceId: // value for 'changeGeoPlaceId'
 *      name: // value for 'name'
 *      socr: // value for 'socr'
 *      cladrCode: // value for 'cladrCode'
 *      okatoCode: // value for 'okatoCode'
 *      type: // value for 'type'
 *      active: // value for 'active'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useChangeGeoPlaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeGeoPlaceMutation,
    ChangeGeoPlaceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChangeGeoPlaceMutation,
    ChangeGeoPlaceMutationVariables
  >(ChangeGeoPlaceDocument, options);
}
export type ChangeGeoPlaceMutationHookResult = ReturnType<
  typeof useChangeGeoPlaceMutation
>;
export type ChangeGeoPlaceMutationResult =
  Apollo.MutationResult<ChangeGeoPlaceMutation>;
export type ChangeGeoPlaceMutationOptions = Apollo.BaseMutationOptions<
  ChangeGeoPlaceMutation,
  ChangeGeoPlaceMutationVariables
>;
export const SetGrVersionDocument = gql`
  mutation setGrVersion(
    $id: ID
    $quarter: Int
    $year: Int
    $dateBegin: DateTime
    $IndicatorId: ID
  ) {
    GlobalRatingSetter {
      setVersion(
        id: $id
        quarter: $quarter
        year: $year
        dateBegin: $dateBegin
        IndicatorId: $IndicatorId
      ) {
        id
      }
    }
  }
`;
export type SetGrVersionMutationFn = Apollo.MutationFunction<
  SetGrVersionMutation,
  SetGrVersionMutationVariables
>;

/**
 * __useSetGrVersionMutation__
 *
 * To run a mutation, you first call `useSetGrVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGrVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGrVersionMutation, { data, loading, error }] = useSetGrVersionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      quarter: // value for 'quarter'
 *      year: // value for 'year'
 *      dateBegin: // value for 'dateBegin'
 *      IndicatorId: // value for 'IndicatorId'
 *   },
 * });
 */
export function useSetGrVersionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetGrVersionMutation,
    SetGrVersionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetGrVersionMutation,
    SetGrVersionMutationVariables
  >(SetGrVersionDocument, options);
}
export type SetGrVersionMutationHookResult = ReturnType<
  typeof useSetGrVersionMutation
>;
export type SetGrVersionMutationResult =
  Apollo.MutationResult<SetGrVersionMutation>;
export type SetGrVersionMutationOptions = Apollo.BaseMutationOptions<
  SetGrVersionMutation,
  SetGrVersionMutationVariables
>;
export const SetGrRatingDocument = gql`
  mutation setGrRating(
    $id: ID
    $number: String
    $name: String
    $nameEn: String
    $quarter1: ID
    $quarter2: ID
    $quarter1_2: ID
    $quarter3: ID
    $quarter2_3: ID
    $quarter4: ID
    $quarter3_4: ID
    $yearValue: ID
    $yearPercent: ID
    $type: String!
    $sort: Int!
    $round: Int
    $format: Int
    $ParentId: ID
    $PrevElementId: ID
    $RatingsVersionId: ID!
  ) {
    GlobalRatingSetter {
      setRating(
        id: $id
        number: $number
        name: $name
        nameEn: $nameEn
        quarter1: $quarter1
        quarter2: $quarter2
        quarter1_2: $quarter1_2
        quarter3: $quarter3
        quarter2_3: $quarter2_3
        quarter4: $quarter4
        quarter3_4: $quarter3_4
        yearValue: $yearValue
        yearPercent: $yearPercent
        type: $type
        sort: $sort
        round: $round
        format: $format
        ParentId: $ParentId
        PrevElementId: $PrevElementId
        RatingsVersionId: $RatingsVersionId
      ) {
        id
        number
      }
    }
  }
`;
export type SetGrRatingMutationFn = Apollo.MutationFunction<
  SetGrRatingMutation,
  SetGrRatingMutationVariables
>;

/**
 * __useSetGrRatingMutation__
 *
 * To run a mutation, you first call `useSetGrRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGrRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGrRatingMutation, { data, loading, error }] = useSetGrRatingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      number: // value for 'number'
 *      name: // value for 'name'
 *      nameEn: // value for 'nameEn'
 *      quarter1: // value for 'quarter1'
 *      quarter2: // value for 'quarter2'
 *      quarter1_2: // value for 'quarter1_2'
 *      quarter3: // value for 'quarter3'
 *      quarter2_3: // value for 'quarter2_3'
 *      quarter4: // value for 'quarter4'
 *      quarter3_4: // value for 'quarter3_4'
 *      yearValue: // value for 'yearValue'
 *      yearPercent: // value for 'yearPercent'
 *      type: // value for 'type'
 *      sort: // value for 'sort'
 *      round: // value for 'round'
 *      format: // value for 'format'
 *      ParentId: // value for 'ParentId'
 *      PrevElementId: // value for 'PrevElementId'
 *      RatingsVersionId: // value for 'RatingsVersionId'
 *   },
 * });
 */
export function useSetGrRatingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetGrRatingMutation,
    SetGrRatingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetGrRatingMutation, SetGrRatingMutationVariables>(
    SetGrRatingDocument,
    options,
  );
}
export type SetGrRatingMutationHookResult = ReturnType<
  typeof useSetGrRatingMutation
>;
export type SetGrRatingMutationResult =
  Apollo.MutationResult<SetGrRatingMutation>;
export type SetGrRatingMutationOptions = Apollo.BaseMutationOptions<
  SetGrRatingMutation,
  SetGrRatingMutationVariables
>;
export const DeleteListRatingDocument = gql`
  mutation deleteListRating($id: ID!) {
    GlobalRatingSetter {
      deleteList(id: $id)
    }
  }
`;
export type DeleteListRatingMutationFn = Apollo.MutationFunction<
  DeleteListRatingMutation,
  DeleteListRatingMutationVariables
>;

/**
 * __useDeleteListRatingMutation__
 *
 * To run a mutation, you first call `useDeleteListRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteListRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteListRatingMutation, { data, loading, error }] = useDeleteListRatingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteListRatingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteListRatingMutation,
    DeleteListRatingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteListRatingMutation,
    DeleteListRatingMutationVariables
  >(DeleteListRatingDocument, options);
}
export type DeleteListRatingMutationHookResult = ReturnType<
  typeof useDeleteListRatingMutation
>;
export type DeleteListRatingMutationResult =
  Apollo.MutationResult<DeleteListRatingMutation>;
export type DeleteListRatingMutationOptions = Apollo.BaseMutationOptions<
  DeleteListRatingMutation,
  DeleteListRatingMutationVariables
>;
export const DeleteVersionRatingDocument = gql`
  mutation deleteVersionRating($id: ID!) {
    GlobalRatingSetter {
      deleteVersion(id: $id)
    }
  }
`;
export type DeleteVersionRatingMutationFn = Apollo.MutationFunction<
  DeleteVersionRatingMutation,
  DeleteVersionRatingMutationVariables
>;

/**
 * __useDeleteVersionRatingMutation__
 *
 * To run a mutation, you first call `useDeleteVersionRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVersionRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVersionRatingMutation, { data, loading, error }] = useDeleteVersionRatingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVersionRatingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteVersionRatingMutation,
    DeleteVersionRatingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteVersionRatingMutation,
    DeleteVersionRatingMutationVariables
  >(DeleteVersionRatingDocument, options);
}
export type DeleteVersionRatingMutationHookResult = ReturnType<
  typeof useDeleteVersionRatingMutation
>;
export type DeleteVersionRatingMutationResult =
  Apollo.MutationResult<DeleteVersionRatingMutation>;
export type DeleteVersionRatingMutationOptions = Apollo.BaseMutationOptions<
  DeleteVersionRatingMutation,
  DeleteVersionRatingMutationVariables
>;
export const CreateIndicatorGroupDocument = gql`
  mutation createIndicatorGroup($nameRu: String!, $nameEn: String) {
    IndicatorGroupReportSetter {
      createIndicatorGroup(nameRu: $nameRu, nameEn: $nameEn) {
        id
      }
    }
  }
`;
export type CreateIndicatorGroupMutationFn = Apollo.MutationFunction<
  CreateIndicatorGroupMutation,
  CreateIndicatorGroupMutationVariables
>;

/**
 * __useCreateIndicatorGroupMutation__
 *
 * To run a mutation, you first call `useCreateIndicatorGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIndicatorGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIndicatorGroupMutation, { data, loading, error }] = useCreateIndicatorGroupMutation({
 *   variables: {
 *      nameRu: // value for 'nameRu'
 *      nameEn: // value for 'nameEn'
 *   },
 * });
 */
export function useCreateIndicatorGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateIndicatorGroupMutation,
    CreateIndicatorGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateIndicatorGroupMutation,
    CreateIndicatorGroupMutationVariables
  >(CreateIndicatorGroupDocument, options);
}
export type CreateIndicatorGroupMutationHookResult = ReturnType<
  typeof useCreateIndicatorGroupMutation
>;
export type CreateIndicatorGroupMutationResult =
  Apollo.MutationResult<CreateIndicatorGroupMutation>;
export type CreateIndicatorGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateIndicatorGroupMutation,
  CreateIndicatorGroupMutationVariables
>;
export const ChangeIndicatorGroupDocument = gql`
  mutation changeIndicatorGroup(
    $id: ID!
    $nameRu: String!
    $nameEn: String
    $status: String
  ) {
    IndicatorGroupReportSetter {
      changeIndicatorGroup(
        id: $id
        nameRu: $nameRu
        nameEn: $nameEn
        status: $status
      ) {
        id
      }
    }
  }
`;
export type ChangeIndicatorGroupMutationFn = Apollo.MutationFunction<
  ChangeIndicatorGroupMutation,
  ChangeIndicatorGroupMutationVariables
>;

/**
 * __useChangeIndicatorGroupMutation__
 *
 * To run a mutation, you first call `useChangeIndicatorGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeIndicatorGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeIndicatorGroupMutation, { data, loading, error }] = useChangeIndicatorGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      nameRu: // value for 'nameRu'
 *      nameEn: // value for 'nameEn'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useChangeIndicatorGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeIndicatorGroupMutation,
    ChangeIndicatorGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChangeIndicatorGroupMutation,
    ChangeIndicatorGroupMutationVariables
  >(ChangeIndicatorGroupDocument, options);
}
export type ChangeIndicatorGroupMutationHookResult = ReturnType<
  typeof useChangeIndicatorGroupMutation
>;
export type ChangeIndicatorGroupMutationResult =
  Apollo.MutationResult<ChangeIndicatorGroupMutation>;
export type ChangeIndicatorGroupMutationOptions = Apollo.BaseMutationOptions<
  ChangeIndicatorGroupMutation,
  ChangeIndicatorGroupMutationVariables
>;
export const DeleteIndicatorGroupDocument = gql`
  mutation deleteIndicatorGroup($id: ID!) {
    IndicatorGroupReportSetter {
      deleteIndicatorGroup(id: $id)
    }
  }
`;
export type DeleteIndicatorGroupMutationFn = Apollo.MutationFunction<
  DeleteIndicatorGroupMutation,
  DeleteIndicatorGroupMutationVariables
>;

/**
 * __useDeleteIndicatorGroupMutation__
 *
 * To run a mutation, you first call `useDeleteIndicatorGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIndicatorGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIndicatorGroupMutation, { data, loading, error }] = useDeleteIndicatorGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIndicatorGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteIndicatorGroupMutation,
    DeleteIndicatorGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteIndicatorGroupMutation,
    DeleteIndicatorGroupMutationVariables
  >(DeleteIndicatorGroupDocument, options);
}
export type DeleteIndicatorGroupMutationHookResult = ReturnType<
  typeof useDeleteIndicatorGroupMutation
>;
export type DeleteIndicatorGroupMutationResult =
  Apollo.MutationResult<DeleteIndicatorGroupMutation>;
export type DeleteIndicatorGroupMutationOptions = Apollo.BaseMutationOptions<
  DeleteIndicatorGroupMutation,
  DeleteIndicatorGroupMutationVariables
>;
export const RestoreIndicatorGroupDocument = gql`
  mutation restoreIndicatorGroup($id: ID!) {
    IndicatorGroupReportSetter {
      restoreIndicatorGroup(id: $id)
    }
  }
`;
export type RestoreIndicatorGroupMutationFn = Apollo.MutationFunction<
  RestoreIndicatorGroupMutation,
  RestoreIndicatorGroupMutationVariables
>;

/**
 * __useRestoreIndicatorGroupMutation__
 *
 * To run a mutation, you first call `useRestoreIndicatorGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreIndicatorGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreIndicatorGroupMutation, { data, loading, error }] = useRestoreIndicatorGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreIndicatorGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RestoreIndicatorGroupMutation,
    RestoreIndicatorGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RestoreIndicatorGroupMutation,
    RestoreIndicatorGroupMutationVariables
  >(RestoreIndicatorGroupDocument, options);
}
export type RestoreIndicatorGroupMutationHookResult = ReturnType<
  typeof useRestoreIndicatorGroupMutation
>;
export type RestoreIndicatorGroupMutationResult =
  Apollo.MutationResult<RestoreIndicatorGroupMutation>;
export type RestoreIndicatorGroupMutationOptions = Apollo.BaseMutationOptions<
  RestoreIndicatorGroupMutation,
  RestoreIndicatorGroupMutationVariables
>;
export const CreateIndicatorReportDocument = gql`
  mutation createIndicatorReport($GroupId: ID!, $nameRu: String!) {
    IndicatorGroupReportSetter {
      createIndicatorReport(GroupId: $GroupId, nameRu: $nameRu) {
        id
      }
    }
  }
`;
export type CreateIndicatorReportMutationFn = Apollo.MutationFunction<
  CreateIndicatorReportMutation,
  CreateIndicatorReportMutationVariables
>;

/**
 * __useCreateIndicatorReportMutation__
 *
 * To run a mutation, you first call `useCreateIndicatorReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIndicatorReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIndicatorReportMutation, { data, loading, error }] = useCreateIndicatorReportMutation({
 *   variables: {
 *      GroupId: // value for 'GroupId'
 *      nameRu: // value for 'nameRu'
 *   },
 * });
 */
export function useCreateIndicatorReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateIndicatorReportMutation,
    CreateIndicatorReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateIndicatorReportMutation,
    CreateIndicatorReportMutationVariables
  >(CreateIndicatorReportDocument, options);
}
export type CreateIndicatorReportMutationHookResult = ReturnType<
  typeof useCreateIndicatorReportMutation
>;
export type CreateIndicatorReportMutationResult =
  Apollo.MutationResult<CreateIndicatorReportMutation>;
export type CreateIndicatorReportMutationOptions = Apollo.BaseMutationOptions<
  CreateIndicatorReportMutation,
  CreateIndicatorReportMutationVariables
>;
export const ChangeIndicatorReportDocument = gql`
  mutation changeIndicatorReport($id: ID!, $nameRu: String!) {
    IndicatorGroupReportSetter {
      changeIndicatorReport(id: $id, nameRu: $nameRu) {
        id
      }
    }
  }
`;
export type ChangeIndicatorReportMutationFn = Apollo.MutationFunction<
  ChangeIndicatorReportMutation,
  ChangeIndicatorReportMutationVariables
>;

/**
 * __useChangeIndicatorReportMutation__
 *
 * To run a mutation, you first call `useChangeIndicatorReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeIndicatorReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeIndicatorReportMutation, { data, loading, error }] = useChangeIndicatorReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      nameRu: // value for 'nameRu'
 *   },
 * });
 */
export function useChangeIndicatorReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeIndicatorReportMutation,
    ChangeIndicatorReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChangeIndicatorReportMutation,
    ChangeIndicatorReportMutationVariables
  >(ChangeIndicatorReportDocument, options);
}
export type ChangeIndicatorReportMutationHookResult = ReturnType<
  typeof useChangeIndicatorReportMutation
>;
export type ChangeIndicatorReportMutationResult =
  Apollo.MutationResult<ChangeIndicatorReportMutation>;
export type ChangeIndicatorReportMutationOptions = Apollo.BaseMutationOptions<
  ChangeIndicatorReportMutation,
  ChangeIndicatorReportMutationVariables
>;
export const DeleteIndicatorReportDocument = gql`
  mutation deleteIndicatorReport($id: ID!) {
    IndicatorGroupReportSetter {
      deleteIndicatorReport(id: $id)
    }
  }
`;
export type DeleteIndicatorReportMutationFn = Apollo.MutationFunction<
  DeleteIndicatorReportMutation,
  DeleteIndicatorReportMutationVariables
>;

/**
 * __useDeleteIndicatorReportMutation__
 *
 * To run a mutation, you first call `useDeleteIndicatorReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIndicatorReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIndicatorReportMutation, { data, loading, error }] = useDeleteIndicatorReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIndicatorReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteIndicatorReportMutation,
    DeleteIndicatorReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteIndicatorReportMutation,
    DeleteIndicatorReportMutationVariables
  >(DeleteIndicatorReportDocument, options);
}
export type DeleteIndicatorReportMutationHookResult = ReturnType<
  typeof useDeleteIndicatorReportMutation
>;
export type DeleteIndicatorReportMutationResult =
  Apollo.MutationResult<DeleteIndicatorReportMutation>;
export type DeleteIndicatorReportMutationOptions = Apollo.BaseMutationOptions<
  DeleteIndicatorReportMutation,
  DeleteIndicatorReportMutationVariables
>;
export const RestoreIndicatorReportDocument = gql`
  mutation restoreIndicatorReport($id: ID!, $GroupId: ID!) {
    IndicatorGroupReportSetter {
      restoreIndicatorReport(id: $id, GroupId: $GroupId)
    }
  }
`;
export type RestoreIndicatorReportMutationFn = Apollo.MutationFunction<
  RestoreIndicatorReportMutation,
  RestoreIndicatorReportMutationVariables
>;

/**
 * __useRestoreIndicatorReportMutation__
 *
 * To run a mutation, you first call `useRestoreIndicatorReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreIndicatorReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreIndicatorReportMutation, { data, loading, error }] = useRestoreIndicatorReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      GroupId: // value for 'GroupId'
 *   },
 * });
 */
export function useRestoreIndicatorReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RestoreIndicatorReportMutation,
    RestoreIndicatorReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RestoreIndicatorReportMutation,
    RestoreIndicatorReportMutationVariables
  >(RestoreIndicatorReportDocument, options);
}
export type RestoreIndicatorReportMutationHookResult = ReturnType<
  typeof useRestoreIndicatorReportMutation
>;
export type RestoreIndicatorReportMutationResult =
  Apollo.MutationResult<RestoreIndicatorReportMutation>;
export type RestoreIndicatorReportMutationOptions = Apollo.BaseMutationOptions<
  RestoreIndicatorReportMutation,
  RestoreIndicatorReportMutationVariables
>;
export const AddIndicatorsToReportDocument = gql`
  mutation addIndicatorsToReport($IndicatorIds: [ID], $ReportId: ID!) {
    IndicatorGroupReportSetter {
      addIndicatorsToReport(IndicatorIds: $IndicatorIds, ReportId: $ReportId)
    }
  }
`;
export type AddIndicatorsToReportMutationFn = Apollo.MutationFunction<
  AddIndicatorsToReportMutation,
  AddIndicatorsToReportMutationVariables
>;

/**
 * __useAddIndicatorsToReportMutation__
 *
 * To run a mutation, you first call `useAddIndicatorsToReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddIndicatorsToReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addIndicatorsToReportMutation, { data, loading, error }] = useAddIndicatorsToReportMutation({
 *   variables: {
 *      IndicatorIds: // value for 'IndicatorIds'
 *      ReportId: // value for 'ReportId'
 *   },
 * });
 */
export function useAddIndicatorsToReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddIndicatorsToReportMutation,
    AddIndicatorsToReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddIndicatorsToReportMutation,
    AddIndicatorsToReportMutationVariables
  >(AddIndicatorsToReportDocument, options);
}
export type AddIndicatorsToReportMutationHookResult = ReturnType<
  typeof useAddIndicatorsToReportMutation
>;
export type AddIndicatorsToReportMutationResult =
  Apollo.MutationResult<AddIndicatorsToReportMutation>;
export type AddIndicatorsToReportMutationOptions = Apollo.BaseMutationOptions<
  AddIndicatorsToReportMutation,
  AddIndicatorsToReportMutationVariables
>;
export const DeleteIndicatorsFromReportDocument = gql`
  mutation deleteIndicatorsFromReport($ReportId: ID!) {
    IndicatorGroupReportSetter {
      deleteIndicatorsFromReport(ReportId: $ReportId)
    }
  }
`;
export type DeleteIndicatorsFromReportMutationFn = Apollo.MutationFunction<
  DeleteIndicatorsFromReportMutation,
  DeleteIndicatorsFromReportMutationVariables
>;

/**
 * __useDeleteIndicatorsFromReportMutation__
 *
 * To run a mutation, you first call `useDeleteIndicatorsFromReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIndicatorsFromReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIndicatorsFromReportMutation, { data, loading, error }] = useDeleteIndicatorsFromReportMutation({
 *   variables: {
 *      ReportId: // value for 'ReportId'
 *   },
 * });
 */
export function useDeleteIndicatorsFromReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteIndicatorsFromReportMutation,
    DeleteIndicatorsFromReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteIndicatorsFromReportMutation,
    DeleteIndicatorsFromReportMutationVariables
  >(DeleteIndicatorsFromReportDocument, options);
}
export type DeleteIndicatorsFromReportMutationHookResult = ReturnType<
  typeof useDeleteIndicatorsFromReportMutation
>;
export type DeleteIndicatorsFromReportMutationResult =
  Apollo.MutationResult<DeleteIndicatorsFromReportMutation>;
export type DeleteIndicatorsFromReportMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteIndicatorsFromReportMutation,
    DeleteIndicatorsFromReportMutationVariables
  >;
export const UpsertDealerFieldsToReportDocument = gql`
  mutation upsertDealerFieldsToReport($reportId: ID!, $dealerFieldsIds: [ID]) {
    IndicatorGroupReportSetter {
      upsertDealerFieldsToReport(
        ReportId: $reportId
        DealerFieldsIds: $dealerFieldsIds
      )
    }
  }
`;
export type UpsertDealerFieldsToReportMutationFn = Apollo.MutationFunction<
  UpsertDealerFieldsToReportMutation,
  UpsertDealerFieldsToReportMutationVariables
>;

/**
 * __useUpsertDealerFieldsToReportMutation__
 *
 * To run a mutation, you first call `useUpsertDealerFieldsToReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDealerFieldsToReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDealerFieldsToReportMutation, { data, loading, error }] = useUpsertDealerFieldsToReportMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      dealerFieldsIds: // value for 'dealerFieldsIds'
 *   },
 * });
 */
export function useUpsertDealerFieldsToReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertDealerFieldsToReportMutation,
    UpsertDealerFieldsToReportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertDealerFieldsToReportMutation,
    UpsertDealerFieldsToReportMutationVariables
  >(UpsertDealerFieldsToReportDocument, options);
}
export type UpsertDealerFieldsToReportMutationHookResult = ReturnType<
  typeof useUpsertDealerFieldsToReportMutation
>;
export type UpsertDealerFieldsToReportMutationResult =
  Apollo.MutationResult<UpsertDealerFieldsToReportMutation>;
export type UpsertDealerFieldsToReportMutationOptions =
  Apollo.BaseMutationOptions<
    UpsertDealerFieldsToReportMutation,
    UpsertDealerFieldsToReportMutationVariables
  >;
export const SetIndicatorDocument = gql`
  mutation setIndicator(
    $id: ID!
    $oldId: ID
    $nameRu: String
    $nameEn: String
    $shortNameRu: String
    $shortNameEn: String
    $type: String!
    $format: String!
    $unit: String!
    $period: String!
    $status: String!
    $enum: [String]
  ) {
    IndicatorSetter {
      setIndicator(
        id: $id
        oldId: $oldId
        nameRu: $nameRu
        nameEn: $nameEn
        shortNameRu: $shortNameRu
        shortNameEn: $shortNameEn
        type: $type
        format: $format
        unit: $unit
        period: $period
        status: $status
        enum: $enum
      ) {
        id
      }
    }
  }
`;
export type SetIndicatorMutationFn = Apollo.MutationFunction<
  SetIndicatorMutation,
  SetIndicatorMutationVariables
>;

/**
 * __useSetIndicatorMutation__
 *
 * To run a mutation, you first call `useSetIndicatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIndicatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIndicatorMutation, { data, loading, error }] = useSetIndicatorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      oldId: // value for 'oldId'
 *      nameRu: // value for 'nameRu'
 *      nameEn: // value for 'nameEn'
 *      shortNameRu: // value for 'shortNameRu'
 *      shortNameEn: // value for 'shortNameEn'
 *      type: // value for 'type'
 *      format: // value for 'format'
 *      unit: // value for 'unit'
 *      period: // value for 'period'
 *      status: // value for 'status'
 *      enum: // value for 'enum'
 *   },
 * });
 */
export function useSetIndicatorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetIndicatorMutation,
    SetIndicatorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetIndicatorMutation,
    SetIndicatorMutationVariables
  >(SetIndicatorDocument, options);
}
export type SetIndicatorMutationHookResult = ReturnType<
  typeof useSetIndicatorMutation
>;
export type SetIndicatorMutationResult =
  Apollo.MutationResult<SetIndicatorMutation>;
export type SetIndicatorMutationOptions = Apollo.BaseMutationOptions<
  SetIndicatorMutation,
  SetIndicatorMutationVariables
>;
export const DeleteIndicatorDocument = gql`
  mutation deleteIndicator($id: ID!) {
    IndicatorSetter {
      deleteIndicator(id: $id)
    }
  }
`;
export type DeleteIndicatorMutationFn = Apollo.MutationFunction<
  DeleteIndicatorMutation,
  DeleteIndicatorMutationVariables
>;

/**
 * __useDeleteIndicatorMutation__
 *
 * To run a mutation, you first call `useDeleteIndicatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIndicatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIndicatorMutation, { data, loading, error }] = useDeleteIndicatorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIndicatorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteIndicatorMutation,
    DeleteIndicatorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteIndicatorMutation,
    DeleteIndicatorMutationVariables
  >(DeleteIndicatorDocument, options);
}
export type DeleteIndicatorMutationHookResult = ReturnType<
  typeof useDeleteIndicatorMutation
>;
export type DeleteIndicatorMutationResult =
  Apollo.MutationResult<DeleteIndicatorMutation>;
export type DeleteIndicatorMutationOptions = Apollo.BaseMutationOptions<
  DeleteIndicatorMutation,
  DeleteIndicatorMutationVariables
>;
export const RestoreIndicatorDocument = gql`
  mutation restoreIndicator($id: ID!) {
    IndicatorSetter {
      restoreIndicator(id: $id)
    }
  }
`;
export type RestoreIndicatorMutationFn = Apollo.MutationFunction<
  RestoreIndicatorMutation,
  RestoreIndicatorMutationVariables
>;

/**
 * __useRestoreIndicatorMutation__
 *
 * To run a mutation, you first call `useRestoreIndicatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreIndicatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreIndicatorMutation, { data, loading, error }] = useRestoreIndicatorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreIndicatorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RestoreIndicatorMutation,
    RestoreIndicatorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RestoreIndicatorMutation,
    RestoreIndicatorMutationVariables
  >(RestoreIndicatorDocument, options);
}
export type RestoreIndicatorMutationHookResult = ReturnType<
  typeof useRestoreIndicatorMutation
>;
export type RestoreIndicatorMutationResult =
  Apollo.MutationResult<RestoreIndicatorMutation>;
export type RestoreIndicatorMutationOptions = Apollo.BaseMutationOptions<
  RestoreIndicatorMutation,
  RestoreIndicatorMutationVariables
>;
export const UploadIndicatorValuesDocument = gql`
  mutation uploadIndicatorValues($fileId: ID!, $description: String) {
    IndicatorSetter {
      uploadIndicatorValues(fileId: $fileId, description: $description)
    }
  }
`;
export type UploadIndicatorValuesMutationFn = Apollo.MutationFunction<
  UploadIndicatorValuesMutation,
  UploadIndicatorValuesMutationVariables
>;

/**
 * __useUploadIndicatorValuesMutation__
 *
 * To run a mutation, you first call `useUploadIndicatorValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadIndicatorValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadIndicatorValuesMutation, { data, loading, error }] = useUploadIndicatorValuesMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUploadIndicatorValuesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadIndicatorValuesMutation,
    UploadIndicatorValuesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadIndicatorValuesMutation,
    UploadIndicatorValuesMutationVariables
  >(UploadIndicatorValuesDocument, options);
}
export type UploadIndicatorValuesMutationHookResult = ReturnType<
  typeof useUploadIndicatorValuesMutation
>;
export type UploadIndicatorValuesMutationResult =
  Apollo.MutationResult<UploadIndicatorValuesMutation>;
export type UploadIndicatorValuesMutationOptions = Apollo.BaseMutationOptions<
  UploadIndicatorValuesMutation,
  UploadIndicatorValuesMutationVariables
>;
export const AcceptUploadIndicatorValuesDocument = gql`
  mutation acceptUploadIndicatorValues($IndicatorUploadId: ID!) {
    IndicatorSetter {
      acceptUploadIndicatorValues(IndicatorUploadId: $IndicatorUploadId)
    }
  }
`;
export type AcceptUploadIndicatorValuesMutationFn = Apollo.MutationFunction<
  AcceptUploadIndicatorValuesMutation,
  AcceptUploadIndicatorValuesMutationVariables
>;

/**
 * __useAcceptUploadIndicatorValuesMutation__
 *
 * To run a mutation, you first call `useAcceptUploadIndicatorValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptUploadIndicatorValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptUploadIndicatorValuesMutation, { data, loading, error }] = useAcceptUploadIndicatorValuesMutation({
 *   variables: {
 *      IndicatorUploadId: // value for 'IndicatorUploadId'
 *   },
 * });
 */
export function useAcceptUploadIndicatorValuesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptUploadIndicatorValuesMutation,
    AcceptUploadIndicatorValuesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AcceptUploadIndicatorValuesMutation,
    AcceptUploadIndicatorValuesMutationVariables
  >(AcceptUploadIndicatorValuesDocument, options);
}
export type AcceptUploadIndicatorValuesMutationHookResult = ReturnType<
  typeof useAcceptUploadIndicatorValuesMutation
>;
export type AcceptUploadIndicatorValuesMutationResult =
  Apollo.MutationResult<AcceptUploadIndicatorValuesMutation>;
export type AcceptUploadIndicatorValuesMutationOptions =
  Apollo.BaseMutationOptions<
    AcceptUploadIndicatorValuesMutation,
    AcceptUploadIndicatorValuesMutationVariables
  >;
export const RejectUploadIndicatorValuesDocument = gql`
  mutation rejectUploadIndicatorValues($IndicatorUploadId: ID!) {
    IndicatorSetter {
      rejectUploadIndicatorValues(IndicatorUploadId: $IndicatorUploadId)
    }
  }
`;
export type RejectUploadIndicatorValuesMutationFn = Apollo.MutationFunction<
  RejectUploadIndicatorValuesMutation,
  RejectUploadIndicatorValuesMutationVariables
>;

/**
 * __useRejectUploadIndicatorValuesMutation__
 *
 * To run a mutation, you first call `useRejectUploadIndicatorValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectUploadIndicatorValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectUploadIndicatorValuesMutation, { data, loading, error }] = useRejectUploadIndicatorValuesMutation({
 *   variables: {
 *      IndicatorUploadId: // value for 'IndicatorUploadId'
 *   },
 * });
 */
export function useRejectUploadIndicatorValuesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RejectUploadIndicatorValuesMutation,
    RejectUploadIndicatorValuesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RejectUploadIndicatorValuesMutation,
    RejectUploadIndicatorValuesMutationVariables
  >(RejectUploadIndicatorValuesDocument, options);
}
export type RejectUploadIndicatorValuesMutationHookResult = ReturnType<
  typeof useRejectUploadIndicatorValuesMutation
>;
export type RejectUploadIndicatorValuesMutationResult =
  Apollo.MutationResult<RejectUploadIndicatorValuesMutation>;
export type RejectUploadIndicatorValuesMutationOptions =
  Apollo.BaseMutationOptions<
    RejectUploadIndicatorValuesMutation,
    RejectUploadIndicatorValuesMutationVariables
  >;
export const SetCreateNotesDocument = gql`
  mutation setCreateNotes(
    $ComplianceIndicator: ID
    $ImageIndicator: ID
    $Number: String
    $Name: String
    $NameEn: String
  ) {
    NotesSetter {
      create(
        ComplianceIndicator: $ComplianceIndicator
        ImageIndicator: $ImageIndicator
        Number: $Number
        Name: $Name
        NameEn: $NameEn
      ) {
        id
      }
    }
  }
`;
export type SetCreateNotesMutationFn = Apollo.MutationFunction<
  SetCreateNotesMutation,
  SetCreateNotesMutationVariables
>;

/**
 * __useSetCreateNotesMutation__
 *
 * To run a mutation, you first call `useSetCreateNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCreateNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCreateNotesMutation, { data, loading, error }] = useSetCreateNotesMutation({
 *   variables: {
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      ImageIndicator: // value for 'ImageIndicator'
 *      Number: // value for 'Number'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *   },
 * });
 */
export function useSetCreateNotesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCreateNotesMutation,
    SetCreateNotesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetCreateNotesMutation,
    SetCreateNotesMutationVariables
  >(SetCreateNotesDocument, options);
}
export type SetCreateNotesMutationHookResult = ReturnType<
  typeof useSetCreateNotesMutation
>;
export type SetCreateNotesMutationResult =
  Apollo.MutationResult<SetCreateNotesMutation>;
export type SetCreateNotesMutationOptions = Apollo.BaseMutationOptions<
  SetCreateNotesMutation,
  SetCreateNotesMutationVariables
>;
export const SetChangeNotesDocument = gql`
  mutation setChangeNotes(
    $id: ID
    $ComplianceIndicator: ID
    $ImageIndicator: ID
    $Number: String
    $Name: String
    $NameEn: String
  ) {
    NotesSetter {
      change(
        id: $id
        ComplianceIndicator: $ComplianceIndicator
        ImageIndicator: $ImageIndicator
        Number: $Number
        Name: $Name
        NameEn: $NameEn
      ) {
        id
      }
    }
  }
`;
export type SetChangeNotesMutationFn = Apollo.MutationFunction<
  SetChangeNotesMutation,
  SetChangeNotesMutationVariables
>;

/**
 * __useSetChangeNotesMutation__
 *
 * To run a mutation, you first call `useSetChangeNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetChangeNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setChangeNotesMutation, { data, loading, error }] = useSetChangeNotesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      ImageIndicator: // value for 'ImageIndicator'
 *      Number: // value for 'Number'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *   },
 * });
 */
export function useSetChangeNotesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetChangeNotesMutation,
    SetChangeNotesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetChangeNotesMutation,
    SetChangeNotesMutationVariables
  >(SetChangeNotesDocument, options);
}
export type SetChangeNotesMutationHookResult = ReturnType<
  typeof useSetChangeNotesMutation
>;
export type SetChangeNotesMutationResult =
  Apollo.MutationResult<SetChangeNotesMutation>;
export type SetChangeNotesMutationOptions = Apollo.BaseMutationOptions<
  SetChangeNotesMutation,
  SetChangeNotesMutationVariables
>;
export const SetBlindChangeNotesDocument = gql`
  mutation setBlindChangeNotes(
    $id: ID
    $ComplianceIndicator: ID
    $ImageIndicator: ID
    $Number: String
    $Name: String
    $NameEn: String
  ) {
    NotesSetter {
      blindChange(
        id: $id
        ComplianceIndicator: $ComplianceIndicator
        ImageIndicator: $ImageIndicator
        Number: $Number
        Name: $Name
        NameEn: $NameEn
      ) {
        id
      }
    }
  }
`;
export type SetBlindChangeNotesMutationFn = Apollo.MutationFunction<
  SetBlindChangeNotesMutation,
  SetBlindChangeNotesMutationVariables
>;

/**
 * __useSetBlindChangeNotesMutation__
 *
 * To run a mutation, you first call `useSetBlindChangeNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBlindChangeNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBlindChangeNotesMutation, { data, loading, error }] = useSetBlindChangeNotesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      ImageIndicator: // value for 'ImageIndicator'
 *      Number: // value for 'Number'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *   },
 * });
 */
export function useSetBlindChangeNotesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetBlindChangeNotesMutation,
    SetBlindChangeNotesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetBlindChangeNotesMutation,
    SetBlindChangeNotesMutationVariables
  >(SetBlindChangeNotesDocument, options);
}
export type SetBlindChangeNotesMutationHookResult = ReturnType<
  typeof useSetBlindChangeNotesMutation
>;
export type SetBlindChangeNotesMutationResult =
  Apollo.MutationResult<SetBlindChangeNotesMutation>;
export type SetBlindChangeNotesMutationOptions = Apollo.BaseMutationOptions<
  SetBlindChangeNotesMutation,
  SetBlindChangeNotesMutationVariables
>;
export const SetAddValuesNotesDocument = gql`
  mutation setAddValuesNotes(
    $Compliance: Int
    $Image: [ID]
    $DealerId: ID
    $UUID: String
  ) {
    NotesSetter {
      addValues(
        Compliance: $Compliance
        Image: $Image
        DealerId: $DealerId
        UUID: $UUID
      )
    }
  }
`;
export type SetAddValuesNotesMutationFn = Apollo.MutationFunction<
  SetAddValuesNotesMutation,
  SetAddValuesNotesMutationVariables
>;

/**
 * __useSetAddValuesNotesMutation__
 *
 * To run a mutation, you first call `useSetAddValuesNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAddValuesNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAddValuesNotesMutation, { data, loading, error }] = useSetAddValuesNotesMutation({
 *   variables: {
 *      Compliance: // value for 'Compliance'
 *      Image: // value for 'Image'
 *      DealerId: // value for 'DealerId'
 *      UUID: // value for 'UUID'
 *   },
 * });
 */
export function useSetAddValuesNotesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetAddValuesNotesMutation,
    SetAddValuesNotesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetAddValuesNotesMutation,
    SetAddValuesNotesMutationVariables
  >(SetAddValuesNotesDocument, options);
}
export type SetAddValuesNotesMutationHookResult = ReturnType<
  typeof useSetAddValuesNotesMutation
>;
export type SetAddValuesNotesMutationResult =
  Apollo.MutationResult<SetAddValuesNotesMutation>;
export type SetAddValuesNotesMutationOptions = Apollo.BaseMutationOptions<
  SetAddValuesNotesMutation,
  SetAddValuesNotesMutationVariables
>;
export const SetDeleteNotesDocument = gql`
  mutation setDeleteNotes($id: ID) {
    NotesSetter {
      delete(id: $id)
    }
  }
`;
export type SetDeleteNotesMutationFn = Apollo.MutationFunction<
  SetDeleteNotesMutation,
  SetDeleteNotesMutationVariables
>;

/**
 * __useSetDeleteNotesMutation__
 *
 * To run a mutation, you first call `useSetDeleteNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDeleteNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDeleteNotesMutation, { data, loading, error }] = useSetDeleteNotesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetDeleteNotesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetDeleteNotesMutation,
    SetDeleteNotesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetDeleteNotesMutation,
    SetDeleteNotesMutationVariables
  >(SetDeleteNotesDocument, options);
}
export type SetDeleteNotesMutationHookResult = ReturnType<
  typeof useSetDeleteNotesMutation
>;
export type SetDeleteNotesMutationResult =
  Apollo.MutationResult<SetDeleteNotesMutation>;
export type SetDeleteNotesMutationOptions = Apollo.BaseMutationOptions<
  SetDeleteNotesMutation,
  SetDeleteNotesMutationVariables
>;
export const SetCreatePersonalDocument = gql`
  mutation setCreatePersonal(
    $ComplianceIndicator: ID
    $PersonNameIndicator: ID
    $PositionIndicator: ID
    $PositionStartIndicator: ID
    $StudyCertificateDateIndicator: ID
    $ImageIndicator: ID
    $GroupOne: String
    $GroupTwo: String
    $DocName: String
    $Number: String
    $Name: String
    $NameEn: String
  ) {
    PersonalSetter {
      create(
        ComplianceIndicator: $ComplianceIndicator
        PersonNameIndicator: $PersonNameIndicator
        PositionIndicator: $PositionIndicator
        PositionStartIndicator: $PositionStartIndicator
        StudyCertificateDateIndicator: $StudyCertificateDateIndicator
        ImageIndicator: $ImageIndicator
        GroupOne: $GroupOne
        GroupTwo: $GroupTwo
        DocName: $DocName
        Number: $Number
        Name: $Name
        NameEn: $NameEn
      ) {
        id
      }
    }
  }
`;
export type SetCreatePersonalMutationFn = Apollo.MutationFunction<
  SetCreatePersonalMutation,
  SetCreatePersonalMutationVariables
>;

/**
 * __useSetCreatePersonalMutation__
 *
 * To run a mutation, you first call `useSetCreatePersonalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCreatePersonalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCreatePersonalMutation, { data, loading, error }] = useSetCreatePersonalMutation({
 *   variables: {
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      PersonNameIndicator: // value for 'PersonNameIndicator'
 *      PositionIndicator: // value for 'PositionIndicator'
 *      PositionStartIndicator: // value for 'PositionStartIndicator'
 *      StudyCertificateDateIndicator: // value for 'StudyCertificateDateIndicator'
 *      ImageIndicator: // value for 'ImageIndicator'
 *      GroupOne: // value for 'GroupOne'
 *      GroupTwo: // value for 'GroupTwo'
 *      DocName: // value for 'DocName'
 *      Number: // value for 'Number'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *   },
 * });
 */
export function useSetCreatePersonalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCreatePersonalMutation,
    SetCreatePersonalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetCreatePersonalMutation,
    SetCreatePersonalMutationVariables
  >(SetCreatePersonalDocument, options);
}
export type SetCreatePersonalMutationHookResult = ReturnType<
  typeof useSetCreatePersonalMutation
>;
export type SetCreatePersonalMutationResult =
  Apollo.MutationResult<SetCreatePersonalMutation>;
export type SetCreatePersonalMutationOptions = Apollo.BaseMutationOptions<
  SetCreatePersonalMutation,
  SetCreatePersonalMutationVariables
>;
export const SetChangePersonalDocument = gql`
  mutation setChangePersonal(
    $id: ID
    $ComplianceIndicator: ID
    $PersonNameIndicator: ID
    $PositionIndicator: ID
    $PositionStartIndicator: ID
    $StudyCertificateDateIndicator: ID
    $ImageIndicator: ID
    $DocName: String
    $Number: String
    $Name: String
    $GroupOne: String
    $GroupTwo: String
    $NameEn: String
  ) {
    PersonalSetter {
      change(
        id: $id
        ComplianceIndicator: $ComplianceIndicator
        PersonNameIndicator: $PersonNameIndicator
        PositionIndicator: $PositionIndicator
        PositionStartIndicator: $PositionStartIndicator
        StudyCertificateDateIndicator: $StudyCertificateDateIndicator
        ImageIndicator: $ImageIndicator
        DocName: $DocName
        GroupOne: $GroupOne
        GroupTwo: $GroupTwo
        Number: $Number
        Name: $Name
        NameEn: $NameEn
      ) {
        id
      }
    }
  }
`;
export type SetChangePersonalMutationFn = Apollo.MutationFunction<
  SetChangePersonalMutation,
  SetChangePersonalMutationVariables
>;

/**
 * __useSetChangePersonalMutation__
 *
 * To run a mutation, you first call `useSetChangePersonalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetChangePersonalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setChangePersonalMutation, { data, loading, error }] = useSetChangePersonalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      PersonNameIndicator: // value for 'PersonNameIndicator'
 *      PositionIndicator: // value for 'PositionIndicator'
 *      PositionStartIndicator: // value for 'PositionStartIndicator'
 *      StudyCertificateDateIndicator: // value for 'StudyCertificateDateIndicator'
 *      ImageIndicator: // value for 'ImageIndicator'
 *      DocName: // value for 'DocName'
 *      Number: // value for 'Number'
 *      Name: // value for 'Name'
 *      GroupOne: // value for 'GroupOne'
 *      GroupTwo: // value for 'GroupTwo'
 *      NameEn: // value for 'NameEn'
 *   },
 * });
 */
export function useSetChangePersonalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetChangePersonalMutation,
    SetChangePersonalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetChangePersonalMutation,
    SetChangePersonalMutationVariables
  >(SetChangePersonalDocument, options);
}
export type SetChangePersonalMutationHookResult = ReturnType<
  typeof useSetChangePersonalMutation
>;
export type SetChangePersonalMutationResult =
  Apollo.MutationResult<SetChangePersonalMutation>;
export type SetChangePersonalMutationOptions = Apollo.BaseMutationOptions<
  SetChangePersonalMutation,
  SetChangePersonalMutationVariables
>;
export const SetBlindChangePersonalDocument = gql`
  mutation setBlindChangePersonal(
    $id: ID
    $ComplianceIndicator: ID
    $PersonNameIndicator: ID
    $PositionIndicator: ID
    $PositionStartIndicator: ID
    $StudyCertificateDateIndicator: ID
    $ImageIndicator: ID
    $DocName: String
    $GroupOne: String
    $GroupTwo: String
    $Number: String
    $Name: String
    $NameEn: String
  ) {
    PersonalSetter {
      blindChange(
        id: $id
        ComplianceIndicator: $ComplianceIndicator
        PersonNameIndicator: $PersonNameIndicator
        PositionIndicator: $PositionIndicator
        PositionStartIndicator: $PositionStartIndicator
        StudyCertificateDateIndicator: $StudyCertificateDateIndicator
        ImageIndicator: $ImageIndicator
        DocName: $DocName
        Number: $Number
        GroupOne: $GroupOne
        GroupTwo: $GroupTwo
        Name: $Name
        NameEn: $NameEn
      ) {
        id
      }
    }
  }
`;
export type SetBlindChangePersonalMutationFn = Apollo.MutationFunction<
  SetBlindChangePersonalMutation,
  SetBlindChangePersonalMutationVariables
>;

/**
 * __useSetBlindChangePersonalMutation__
 *
 * To run a mutation, you first call `useSetBlindChangePersonalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBlindChangePersonalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBlindChangePersonalMutation, { data, loading, error }] = useSetBlindChangePersonalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      PersonNameIndicator: // value for 'PersonNameIndicator'
 *      PositionIndicator: // value for 'PositionIndicator'
 *      PositionStartIndicator: // value for 'PositionStartIndicator'
 *      StudyCertificateDateIndicator: // value for 'StudyCertificateDateIndicator'
 *      ImageIndicator: // value for 'ImageIndicator'
 *      DocName: // value for 'DocName'
 *      GroupOne: // value for 'GroupOne'
 *      GroupTwo: // value for 'GroupTwo'
 *      Number: // value for 'Number'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *   },
 * });
 */
export function useSetBlindChangePersonalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetBlindChangePersonalMutation,
    SetBlindChangePersonalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetBlindChangePersonalMutation,
    SetBlindChangePersonalMutationVariables
  >(SetBlindChangePersonalDocument, options);
}
export type SetBlindChangePersonalMutationHookResult = ReturnType<
  typeof useSetBlindChangePersonalMutation
>;
export type SetBlindChangePersonalMutationResult =
  Apollo.MutationResult<SetBlindChangePersonalMutation>;
export type SetBlindChangePersonalMutationOptions = Apollo.BaseMutationOptions<
  SetBlindChangePersonalMutation,
  SetBlindChangePersonalMutationVariables
>;
export const SetAddValuesPersonalDocument = gql`
  mutation setAddValuesPersonal(
    $Compliance: Int
    $PersonName: String
    $Position: String
    $PositionStart: String
    $StudyCertificateDate: String
    $Image: [ID]
    $DealerId: ID
    $UUID: String
  ) {
    PersonalSetter {
      addValues(
        Compliance: $Compliance
        PersonName: $PersonName
        Position: $Position
        PositionStart: $PositionStart
        StudyCertificateDate: $StudyCertificateDate
        DealerId: $DealerId
        Image: $Image
        UUID: $UUID
      )
    }
  }
`;
export type SetAddValuesPersonalMutationFn = Apollo.MutationFunction<
  SetAddValuesPersonalMutation,
  SetAddValuesPersonalMutationVariables
>;

/**
 * __useSetAddValuesPersonalMutation__
 *
 * To run a mutation, you first call `useSetAddValuesPersonalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAddValuesPersonalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAddValuesPersonalMutation, { data, loading, error }] = useSetAddValuesPersonalMutation({
 *   variables: {
 *      Compliance: // value for 'Compliance'
 *      PersonName: // value for 'PersonName'
 *      Position: // value for 'Position'
 *      PositionStart: // value for 'PositionStart'
 *      StudyCertificateDate: // value for 'StudyCertificateDate'
 *      Image: // value for 'Image'
 *      DealerId: // value for 'DealerId'
 *      UUID: // value for 'UUID'
 *   },
 * });
 */
export function useSetAddValuesPersonalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetAddValuesPersonalMutation,
    SetAddValuesPersonalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetAddValuesPersonalMutation,
    SetAddValuesPersonalMutationVariables
  >(SetAddValuesPersonalDocument, options);
}
export type SetAddValuesPersonalMutationHookResult = ReturnType<
  typeof useSetAddValuesPersonalMutation
>;
export type SetAddValuesPersonalMutationResult =
  Apollo.MutationResult<SetAddValuesPersonalMutation>;
export type SetAddValuesPersonalMutationOptions = Apollo.BaseMutationOptions<
  SetAddValuesPersonalMutation,
  SetAddValuesPersonalMutationVariables
>;
export const SetDeletePersonalDocument = gql`
  mutation setDeletePersonal($id: ID) {
    PersonalSetter {
      delete(id: $id)
    }
  }
`;
export type SetDeletePersonalMutationFn = Apollo.MutationFunction<
  SetDeletePersonalMutation,
  SetDeletePersonalMutationVariables
>;

/**
 * __useSetDeletePersonalMutation__
 *
 * To run a mutation, you first call `useSetDeletePersonalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDeletePersonalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDeletePersonalMutation, { data, loading, error }] = useSetDeletePersonalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetDeletePersonalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetDeletePersonalMutation,
    SetDeletePersonalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetDeletePersonalMutation,
    SetDeletePersonalMutationVariables
  >(SetDeletePersonalDocument, options);
}
export type SetDeletePersonalMutationHookResult = ReturnType<
  typeof useSetDeletePersonalMutation
>;
export type SetDeletePersonalMutationResult =
  Apollo.MutationResult<SetDeletePersonalMutation>;
export type SetDeletePersonalMutationOptions = Apollo.BaseMutationOptions<
  SetDeletePersonalMutation,
  SetDeletePersonalMutationVariables
>;
export const SetDuplicatePersonalDocument = gql`
  mutation setDuplicatePersonal($uuid: String) {
    PersonalSetter {
      duplicate(uuid: $uuid) {
        id
      }
    }
  }
`;
export type SetDuplicatePersonalMutationFn = Apollo.MutationFunction<
  SetDuplicatePersonalMutation,
  SetDuplicatePersonalMutationVariables
>;

/**
 * __useSetDuplicatePersonalMutation__
 *
 * To run a mutation, you first call `useSetDuplicatePersonalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDuplicatePersonalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDuplicatePersonalMutation, { data, loading, error }] = useSetDuplicatePersonalMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useSetDuplicatePersonalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetDuplicatePersonalMutation,
    SetDuplicatePersonalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetDuplicatePersonalMutation,
    SetDuplicatePersonalMutationVariables
  >(SetDuplicatePersonalDocument, options);
}
export type SetDuplicatePersonalMutationHookResult = ReturnType<
  typeof useSetDuplicatePersonalMutation
>;
export type SetDuplicatePersonalMutationResult =
  Apollo.MutationResult<SetDuplicatePersonalMutation>;
export type SetDuplicatePersonalMutationOptions = Apollo.BaseMutationOptions<
  SetDuplicatePersonalMutation,
  SetDuplicatePersonalMutationVariables
>;
export const SetDuplicateRequiredToolsDocument = gql`
  mutation setDuplicateRequiredTools($uuid: String) {
    RequiredToolsSetter {
      duplicate(uuid: $uuid) {
        id
      }
    }
  }
`;
export type SetDuplicateRequiredToolsMutationFn = Apollo.MutationFunction<
  SetDuplicateRequiredToolsMutation,
  SetDuplicateRequiredToolsMutationVariables
>;

/**
 * __useSetDuplicateRequiredToolsMutation__
 *
 * To run a mutation, you first call `useSetDuplicateRequiredToolsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDuplicateRequiredToolsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDuplicateRequiredToolsMutation, { data, loading, error }] = useSetDuplicateRequiredToolsMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useSetDuplicateRequiredToolsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetDuplicateRequiredToolsMutation,
    SetDuplicateRequiredToolsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetDuplicateRequiredToolsMutation,
    SetDuplicateRequiredToolsMutationVariables
  >(SetDuplicateRequiredToolsDocument, options);
}
export type SetDuplicateRequiredToolsMutationHookResult = ReturnType<
  typeof useSetDuplicateRequiredToolsMutation
>;
export type SetDuplicateRequiredToolsMutationResult =
  Apollo.MutationResult<SetDuplicateRequiredToolsMutation>;
export type SetDuplicateRequiredToolsMutationOptions =
  Apollo.BaseMutationOptions<
    SetDuplicateRequiredToolsMutation,
    SetDuplicateRequiredToolsMutationVariables
  >;
export const SetRenameGroupPersonalDocument = gql`
  mutation setRenameGroupPersonal(
    $groupType: ZdGroupType
    $newGroup: String
    $oldGroup: String
  ) {
    PersonalSetter {
      renameGroup(
        groupType: $groupType
        newGroup: $newGroup
        oldGroup: $oldGroup
      )
    }
  }
`;
export type SetRenameGroupPersonalMutationFn = Apollo.MutationFunction<
  SetRenameGroupPersonalMutation,
  SetRenameGroupPersonalMutationVariables
>;

/**
 * __useSetRenameGroupPersonalMutation__
 *
 * To run a mutation, you first call `useSetRenameGroupPersonalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRenameGroupPersonalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRenameGroupPersonalMutation, { data, loading, error }] = useSetRenameGroupPersonalMutation({
 *   variables: {
 *      groupType: // value for 'groupType'
 *      newGroup: // value for 'newGroup'
 *      oldGroup: // value for 'oldGroup'
 *   },
 * });
 */
export function useSetRenameGroupPersonalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetRenameGroupPersonalMutation,
    SetRenameGroupPersonalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetRenameGroupPersonalMutation,
    SetRenameGroupPersonalMutationVariables
  >(SetRenameGroupPersonalDocument, options);
}
export type SetRenameGroupPersonalMutationHookResult = ReturnType<
  typeof useSetRenameGroupPersonalMutation
>;
export type SetRenameGroupPersonalMutationResult =
  Apollo.MutationResult<SetRenameGroupPersonalMutation>;
export type SetRenameGroupPersonalMutationOptions = Apollo.BaseMutationOptions<
  SetRenameGroupPersonalMutation,
  SetRenameGroupPersonalMutationVariables
>;
export const SetSortPersonalDocument = gql`
  mutation setSortPersonal($sort: Int, $UUID: String!) {
    PersonalSetter {
      setSort(sort: $sort, UUID: $UUID)
    }
  }
`;
export type SetSortPersonalMutationFn = Apollo.MutationFunction<
  SetSortPersonalMutation,
  SetSortPersonalMutationVariables
>;

/**
 * __useSetSortPersonalMutation__
 *
 * To run a mutation, you first call `useSetSortPersonalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSortPersonalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSortPersonalMutation, { data, loading, error }] = useSetSortPersonalMutation({
 *   variables: {
 *      sort: // value for 'sort'
 *      UUID: // value for 'UUID'
 *   },
 * });
 */
export function useSetSortPersonalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetSortPersonalMutation,
    SetSortPersonalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetSortPersonalMutation,
    SetSortPersonalMutationVariables
  >(SetSortPersonalDocument, options);
}
export type SetSortPersonalMutationHookResult = ReturnType<
  typeof useSetSortPersonalMutation
>;
export type SetSortPersonalMutationResult =
  Apollo.MutationResult<SetSortPersonalMutation>;
export type SetSortPersonalMutationOptions = Apollo.BaseMutationOptions<
  SetSortPersonalMutation,
  SetSortPersonalMutationVariables
>;
export const SetSortGroupPersonalDocument = gql`
  mutation setSortGroupPersonal($sort: Int, $group: String!) {
    PersonalSetter {
      setSortGroup(sort: $sort, group: $group)
    }
  }
`;
export type SetSortGroupPersonalMutationFn = Apollo.MutationFunction<
  SetSortGroupPersonalMutation,
  SetSortGroupPersonalMutationVariables
>;

/**
 * __useSetSortGroupPersonalMutation__
 *
 * To run a mutation, you first call `useSetSortGroupPersonalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSortGroupPersonalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSortGroupPersonalMutation, { data, loading, error }] = useSetSortGroupPersonalMutation({
 *   variables: {
 *      sort: // value for 'sort'
 *      group: // value for 'group'
 *   },
 * });
 */
export function useSetSortGroupPersonalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetSortGroupPersonalMutation,
    SetSortGroupPersonalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetSortGroupPersonalMutation,
    SetSortGroupPersonalMutationVariables
  >(SetSortGroupPersonalDocument, options);
}
export type SetSortGroupPersonalMutationHookResult = ReturnType<
  typeof useSetSortGroupPersonalMutation
>;
export type SetSortGroupPersonalMutationResult =
  Apollo.MutationResult<SetSortGroupPersonalMutation>;
export type SetSortGroupPersonalMutationOptions = Apollo.BaseMutationOptions<
  SetSortGroupPersonalMutation,
  SetSortGroupPersonalMutationVariables
>;
export const CreatePhotoGallerySectionDocument = gql`
  mutation CreatePhotoGallerySection($title: String!, $description: String) {
    PhotoGallerySectionSetter {
      createPhotoGallerySection(title: $title, description: $description) {
        id
        title
        description
        createdAt
      }
    }
  }
`;
export type CreatePhotoGallerySectionMutationFn = Apollo.MutationFunction<
  CreatePhotoGallerySectionMutation,
  CreatePhotoGallerySectionMutationVariables
>;

/**
 * __useCreatePhotoGallerySectionMutation__
 *
 * To run a mutation, you first call `useCreatePhotoGallerySectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePhotoGallerySectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPhotoGallerySectionMutation, { data, loading, error }] = useCreatePhotoGallerySectionMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreatePhotoGallerySectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePhotoGallerySectionMutation,
    CreatePhotoGallerySectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePhotoGallerySectionMutation,
    CreatePhotoGallerySectionMutationVariables
  >(CreatePhotoGallerySectionDocument, options);
}
export type CreatePhotoGallerySectionMutationHookResult = ReturnType<
  typeof useCreatePhotoGallerySectionMutation
>;
export type CreatePhotoGallerySectionMutationResult =
  Apollo.MutationResult<CreatePhotoGallerySectionMutation>;
export type CreatePhotoGallerySectionMutationOptions =
  Apollo.BaseMutationOptions<
    CreatePhotoGallerySectionMutation,
    CreatePhotoGallerySectionMutationVariables
  >;
export const DeletePhotoGallerySectionDocument = gql`
  mutation DeletePhotoGallerySection($deletePhotoGallerySectionId: ID!) {
    PhotoGallerySectionSetter {
      deletePhotoGallerySection(id: $deletePhotoGallerySectionId) {
        ok
      }
    }
  }
`;
export type DeletePhotoGallerySectionMutationFn = Apollo.MutationFunction<
  DeletePhotoGallerySectionMutation,
  DeletePhotoGallerySectionMutationVariables
>;

/**
 * __useDeletePhotoGallerySectionMutation__
 *
 * To run a mutation, you first call `useDeletePhotoGallerySectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePhotoGallerySectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePhotoGallerySectionMutation, { data, loading, error }] = useDeletePhotoGallerySectionMutation({
 *   variables: {
 *      deletePhotoGallerySectionId: // value for 'deletePhotoGallerySectionId'
 *   },
 * });
 */
export function useDeletePhotoGallerySectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeletePhotoGallerySectionMutation,
    DeletePhotoGallerySectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeletePhotoGallerySectionMutation,
    DeletePhotoGallerySectionMutationVariables
  >(DeletePhotoGallerySectionDocument, options);
}
export type DeletePhotoGallerySectionMutationHookResult = ReturnType<
  typeof useDeletePhotoGallerySectionMutation
>;
export type DeletePhotoGallerySectionMutationResult =
  Apollo.MutationResult<DeletePhotoGallerySectionMutation>;
export type DeletePhotoGallerySectionMutationOptions =
  Apollo.BaseMutationOptions<
    DeletePhotoGallerySectionMutation,
    DeletePhotoGallerySectionMutationVariables
  >;
export const UpdatePhotoGallerySectionDocument = gql`
  mutation UpdatePhotoGallerySection(
    $updatePhotoGallerySectionId: ID
    $title: String
    $description: String
  ) {
    PhotoGallerySectionSetter {
      updatePhotoGallerySection(
        id: $updatePhotoGallerySectionId
        title: $title
        description: $description
      ) {
        id
        title
        description
        createdAt
      }
    }
  }
`;
export type UpdatePhotoGallerySectionMutationFn = Apollo.MutationFunction<
  UpdatePhotoGallerySectionMutation,
  UpdatePhotoGallerySectionMutationVariables
>;

/**
 * __useUpdatePhotoGallerySectionMutation__
 *
 * To run a mutation, you first call `useUpdatePhotoGallerySectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhotoGallerySectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhotoGallerySectionMutation, { data, loading, error }] = useUpdatePhotoGallerySectionMutation({
 *   variables: {
 *      updatePhotoGallerySectionId: // value for 'updatePhotoGallerySectionId'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdatePhotoGallerySectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePhotoGallerySectionMutation,
    UpdatePhotoGallerySectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePhotoGallerySectionMutation,
    UpdatePhotoGallerySectionMutationVariables
  >(UpdatePhotoGallerySectionDocument, options);
}
export type UpdatePhotoGallerySectionMutationHookResult = ReturnType<
  typeof useUpdatePhotoGallerySectionMutation
>;
export type UpdatePhotoGallerySectionMutationResult =
  Apollo.MutationResult<UpdatePhotoGallerySectionMutation>;
export type UpdatePhotoGallerySectionMutationOptions =
  Apollo.BaseMutationOptions<
    UpdatePhotoGallerySectionMutation,
    UpdatePhotoGallerySectionMutationVariables
  >;
export const SetCreatePlacePostsDocument = gql`
  mutation setCreatePlacePosts(
    $ComplianceIndicator: ID
    $ZD_PlacesId: ID
    $TotalIndicator: ID
    $Name: String
    $NameEn: String
  ) {
    PlacePostsSetter {
      create(
        ComplianceIndicator: $ComplianceIndicator
        ZD_PlacesId: $ZD_PlacesId
        TotalIndicator: $TotalIndicator
        Name: $Name
        NameEn: $NameEn
      ) {
        id
      }
    }
  }
`;
export type SetCreatePlacePostsMutationFn = Apollo.MutationFunction<
  SetCreatePlacePostsMutation,
  SetCreatePlacePostsMutationVariables
>;

/**
 * __useSetCreatePlacePostsMutation__
 *
 * To run a mutation, you first call `useSetCreatePlacePostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCreatePlacePostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCreatePlacePostsMutation, { data, loading, error }] = useSetCreatePlacePostsMutation({
 *   variables: {
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      ZD_PlacesId: // value for 'ZD_PlacesId'
 *      TotalIndicator: // value for 'TotalIndicator'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *   },
 * });
 */
export function useSetCreatePlacePostsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCreatePlacePostsMutation,
    SetCreatePlacePostsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetCreatePlacePostsMutation,
    SetCreatePlacePostsMutationVariables
  >(SetCreatePlacePostsDocument, options);
}
export type SetCreatePlacePostsMutationHookResult = ReturnType<
  typeof useSetCreatePlacePostsMutation
>;
export type SetCreatePlacePostsMutationResult =
  Apollo.MutationResult<SetCreatePlacePostsMutation>;
export type SetCreatePlacePostsMutationOptions = Apollo.BaseMutationOptions<
  SetCreatePlacePostsMutation,
  SetCreatePlacePostsMutationVariables
>;
export const SetChangePlacePostsDocument = gql`
  mutation setChangePlacePosts(
    $id: ID
    $ComplianceIndicator: ID
    $ZD_PlacesId: ID
    $TotalIndicator: ID
    $Name: String
    $NameEn: String
  ) {
    PlacePostsSetter {
      change(
        id: $id
        ComplianceIndicator: $ComplianceIndicator
        ZD_PlacesId: $ZD_PlacesId
        TotalIndicator: $TotalIndicator
        Name: $Name
        NameEn: $NameEn
      ) {
        id
      }
    }
  }
`;
export type SetChangePlacePostsMutationFn = Apollo.MutationFunction<
  SetChangePlacePostsMutation,
  SetChangePlacePostsMutationVariables
>;

/**
 * __useSetChangePlacePostsMutation__
 *
 * To run a mutation, you first call `useSetChangePlacePostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetChangePlacePostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setChangePlacePostsMutation, { data, loading, error }] = useSetChangePlacePostsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      ZD_PlacesId: // value for 'ZD_PlacesId'
 *      TotalIndicator: // value for 'TotalIndicator'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *   },
 * });
 */
export function useSetChangePlacePostsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetChangePlacePostsMutation,
    SetChangePlacePostsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetChangePlacePostsMutation,
    SetChangePlacePostsMutationVariables
  >(SetChangePlacePostsDocument, options);
}
export type SetChangePlacePostsMutationHookResult = ReturnType<
  typeof useSetChangePlacePostsMutation
>;
export type SetChangePlacePostsMutationResult =
  Apollo.MutationResult<SetChangePlacePostsMutation>;
export type SetChangePlacePostsMutationOptions = Apollo.BaseMutationOptions<
  SetChangePlacePostsMutation,
  SetChangePlacePostsMutationVariables
>;
export const SetBlindChangePlacePostsDocument = gql`
  mutation setBlindChangePlacePosts(
    $id: ID
    $ComplianceIndicator: ID
    $ZD_PlacesId: ID
    $TotalIndicator: ID
    $Name: String
    $NameEn: String
  ) {
    PlacePostsSetter {
      blindChange(
        id: $id
        ComplianceIndicator: $ComplianceIndicator
        ZD_PlacesId: $ZD_PlacesId
        TotalIndicator: $TotalIndicator
        Name: $Name
        NameEn: $NameEn
      ) {
        id
      }
    }
  }
`;
export type SetBlindChangePlacePostsMutationFn = Apollo.MutationFunction<
  SetBlindChangePlacePostsMutation,
  SetBlindChangePlacePostsMutationVariables
>;

/**
 * __useSetBlindChangePlacePostsMutation__
 *
 * To run a mutation, you first call `useSetBlindChangePlacePostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBlindChangePlacePostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBlindChangePlacePostsMutation, { data, loading, error }] = useSetBlindChangePlacePostsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      ZD_PlacesId: // value for 'ZD_PlacesId'
 *      TotalIndicator: // value for 'TotalIndicator'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *   },
 * });
 */
export function useSetBlindChangePlacePostsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetBlindChangePlacePostsMutation,
    SetBlindChangePlacePostsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetBlindChangePlacePostsMutation,
    SetBlindChangePlacePostsMutationVariables
  >(SetBlindChangePlacePostsDocument, options);
}
export type SetBlindChangePlacePostsMutationHookResult = ReturnType<
  typeof useSetBlindChangePlacePostsMutation
>;
export type SetBlindChangePlacePostsMutationResult =
  Apollo.MutationResult<SetBlindChangePlacePostsMutation>;
export type SetBlindChangePlacePostsMutationOptions =
  Apollo.BaseMutationOptions<
    SetBlindChangePlacePostsMutation,
    SetBlindChangePlacePostsMutationVariables
  >;
export const SetAddValuesPlacePostsDocument = gql`
  mutation setAddValuesPlacePosts(
    $Compliance: Int
    $Total: Float
    $DealerId: ID
    $UUID: String
  ) {
    PlacePostsSetter {
      addValues(
        UUID: $UUID
        Compliance: $Compliance
        Total: $Total
        DealerId: $DealerId
      )
    }
  }
`;
export type SetAddValuesPlacePostsMutationFn = Apollo.MutationFunction<
  SetAddValuesPlacePostsMutation,
  SetAddValuesPlacePostsMutationVariables
>;

/**
 * __useSetAddValuesPlacePostsMutation__
 *
 * To run a mutation, you first call `useSetAddValuesPlacePostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAddValuesPlacePostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAddValuesPlacePostsMutation, { data, loading, error }] = useSetAddValuesPlacePostsMutation({
 *   variables: {
 *      Compliance: // value for 'Compliance'
 *      Total: // value for 'Total'
 *      DealerId: // value for 'DealerId'
 *      UUID: // value for 'UUID'
 *   },
 * });
 */
export function useSetAddValuesPlacePostsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetAddValuesPlacePostsMutation,
    SetAddValuesPlacePostsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetAddValuesPlacePostsMutation,
    SetAddValuesPlacePostsMutationVariables
  >(SetAddValuesPlacePostsDocument, options);
}
export type SetAddValuesPlacePostsMutationHookResult = ReturnType<
  typeof useSetAddValuesPlacePostsMutation
>;
export type SetAddValuesPlacePostsMutationResult =
  Apollo.MutationResult<SetAddValuesPlacePostsMutation>;
export type SetAddValuesPlacePostsMutationOptions = Apollo.BaseMutationOptions<
  SetAddValuesPlacePostsMutation,
  SetAddValuesPlacePostsMutationVariables
>;
export const SetDeletePlacePostsDocument = gql`
  mutation setDeletePlacePosts($id: ID) {
    PlacePostsSetter {
      delete(id: $id)
    }
  }
`;
export type SetDeletePlacePostsMutationFn = Apollo.MutationFunction<
  SetDeletePlacePostsMutation,
  SetDeletePlacePostsMutationVariables
>;

/**
 * __useSetDeletePlacePostsMutation__
 *
 * To run a mutation, you first call `useSetDeletePlacePostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDeletePlacePostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDeletePlacePostsMutation, { data, loading, error }] = useSetDeletePlacePostsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetDeletePlacePostsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetDeletePlacePostsMutation,
    SetDeletePlacePostsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetDeletePlacePostsMutation,
    SetDeletePlacePostsMutationVariables
  >(SetDeletePlacePostsDocument, options);
}
export type SetDeletePlacePostsMutationHookResult = ReturnType<
  typeof useSetDeletePlacePostsMutation
>;
export type SetDeletePlacePostsMutationResult =
  Apollo.MutationResult<SetDeletePlacePostsMutation>;
export type SetDeletePlacePostsMutationOptions = Apollo.BaseMutationOptions<
  SetDeletePlacePostsMutation,
  SetDeletePlacePostsMutationVariables
>;
export const SetCreatePlacesDocument = gql`
  mutation setCreatePlaces(
    $ComplianceIndicator: ID
    $AreaIndicator: ID
    $PlacesCombineIndicator: ID
    $Number: String
    $GroupOne: String
    $Name: String
    $NameEn: String
  ) {
    PlacesSetter {
      create(
        ComplianceIndicator: $ComplianceIndicator
        AreaIndicator: $AreaIndicator
        PlacesCombineIndicator: $PlacesCombineIndicator
        Number: $Number
        GroupOne: $GroupOne
        Name: $Name
        NameEn: $NameEn
      ) {
        id
      }
    }
  }
`;
export type SetCreatePlacesMutationFn = Apollo.MutationFunction<
  SetCreatePlacesMutation,
  SetCreatePlacesMutationVariables
>;

/**
 * __useSetCreatePlacesMutation__
 *
 * To run a mutation, you first call `useSetCreatePlacesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCreatePlacesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCreatePlacesMutation, { data, loading, error }] = useSetCreatePlacesMutation({
 *   variables: {
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      AreaIndicator: // value for 'AreaIndicator'
 *      PlacesCombineIndicator: // value for 'PlacesCombineIndicator'
 *      Number: // value for 'Number'
 *      GroupOne: // value for 'GroupOne'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *   },
 * });
 */
export function useSetCreatePlacesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCreatePlacesMutation,
    SetCreatePlacesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetCreatePlacesMutation,
    SetCreatePlacesMutationVariables
  >(SetCreatePlacesDocument, options);
}
export type SetCreatePlacesMutationHookResult = ReturnType<
  typeof useSetCreatePlacesMutation
>;
export type SetCreatePlacesMutationResult =
  Apollo.MutationResult<SetCreatePlacesMutation>;
export type SetCreatePlacesMutationOptions = Apollo.BaseMutationOptions<
  SetCreatePlacesMutation,
  SetCreatePlacesMutationVariables
>;
export const SetChangePlacesDocument = gql`
  mutation setChangePlaces(
    $id: ID
    $ComplianceIndicator: ID
    $AreaIndicator: ID
    $PlacesCombineIndicator: ID
    $Number: String
    $GroupOne: String
    $Name: String
    $NameEn: String
  ) {
    PlacesSetter {
      change(
        id: $id
        ComplianceIndicator: $ComplianceIndicator
        AreaIndicator: $AreaIndicator
        PlacesCombineIndicator: $PlacesCombineIndicator
        Number: $Number
        GroupOne: $GroupOne
        Name: $Name
        NameEn: $NameEn
      ) {
        id
      }
    }
  }
`;
export type SetChangePlacesMutationFn = Apollo.MutationFunction<
  SetChangePlacesMutation,
  SetChangePlacesMutationVariables
>;

/**
 * __useSetChangePlacesMutation__
 *
 * To run a mutation, you first call `useSetChangePlacesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetChangePlacesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setChangePlacesMutation, { data, loading, error }] = useSetChangePlacesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      AreaIndicator: // value for 'AreaIndicator'
 *      PlacesCombineIndicator: // value for 'PlacesCombineIndicator'
 *      Number: // value for 'Number'
 *      GroupOne: // value for 'GroupOne'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *   },
 * });
 */
export function useSetChangePlacesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetChangePlacesMutation,
    SetChangePlacesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetChangePlacesMutation,
    SetChangePlacesMutationVariables
  >(SetChangePlacesDocument, options);
}
export type SetChangePlacesMutationHookResult = ReturnType<
  typeof useSetChangePlacesMutation
>;
export type SetChangePlacesMutationResult =
  Apollo.MutationResult<SetChangePlacesMutation>;
export type SetChangePlacesMutationOptions = Apollo.BaseMutationOptions<
  SetChangePlacesMutation,
  SetChangePlacesMutationVariables
>;
export const SetBlindChangePlacesDocument = gql`
  mutation setBlindChangePlaces(
    $id: ID
    $ComplianceIndicator: ID
    $AreaIndicator: ID
    $PlacesCombineIndicator: ID
    $Number: String
    $GroupOne: String
    $Name: String
    $NameEn: String
  ) {
    PlacesSetter {
      blindChange(
        id: $id
        ComplianceIndicator: $ComplianceIndicator
        AreaIndicator: $AreaIndicator
        PlacesCombineIndicator: $PlacesCombineIndicator
        Number: $Number
        GroupOne: $GroupOne
        Name: $Name
        NameEn: $NameEn
      ) {
        id
      }
    }
  }
`;
export type SetBlindChangePlacesMutationFn = Apollo.MutationFunction<
  SetBlindChangePlacesMutation,
  SetBlindChangePlacesMutationVariables
>;

/**
 * __useSetBlindChangePlacesMutation__
 *
 * To run a mutation, you first call `useSetBlindChangePlacesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBlindChangePlacesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBlindChangePlacesMutation, { data, loading, error }] = useSetBlindChangePlacesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      AreaIndicator: // value for 'AreaIndicator'
 *      PlacesCombineIndicator: // value for 'PlacesCombineIndicator'
 *      Number: // value for 'Number'
 *      GroupOne: // value for 'GroupOne'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *   },
 * });
 */
export function useSetBlindChangePlacesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetBlindChangePlacesMutation,
    SetBlindChangePlacesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetBlindChangePlacesMutation,
    SetBlindChangePlacesMutationVariables
  >(SetBlindChangePlacesDocument, options);
}
export type SetBlindChangePlacesMutationHookResult = ReturnType<
  typeof useSetBlindChangePlacesMutation
>;
export type SetBlindChangePlacesMutationResult =
  Apollo.MutationResult<SetBlindChangePlacesMutation>;
export type SetBlindChangePlacesMutationOptions = Apollo.BaseMutationOptions<
  SetBlindChangePlacesMutation,
  SetBlindChangePlacesMutationVariables
>;
export const SetAddValuesPlacesDocument = gql`
  mutation setAddValuesPlaces(
    $Compliance: Int
    $PlacesCombine: String
    $Area: Float
    $DealerId: ID
    $UUID: String
  ) {
    PlacesSetter {
      addValues(
        UUID: $UUID
        Compliance: $Compliance
        PlacesCombine: $PlacesCombine
        Area: $Area
        DealerId: $DealerId
      )
    }
  }
`;
export type SetAddValuesPlacesMutationFn = Apollo.MutationFunction<
  SetAddValuesPlacesMutation,
  SetAddValuesPlacesMutationVariables
>;

/**
 * __useSetAddValuesPlacesMutation__
 *
 * To run a mutation, you first call `useSetAddValuesPlacesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAddValuesPlacesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAddValuesPlacesMutation, { data, loading, error }] = useSetAddValuesPlacesMutation({
 *   variables: {
 *      Compliance: // value for 'Compliance'
 *      PlacesCombine: // value for 'PlacesCombine'
 *      Area: // value for 'Area'
 *      DealerId: // value for 'DealerId'
 *      UUID: // value for 'UUID'
 *   },
 * });
 */
export function useSetAddValuesPlacesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetAddValuesPlacesMutation,
    SetAddValuesPlacesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetAddValuesPlacesMutation,
    SetAddValuesPlacesMutationVariables
  >(SetAddValuesPlacesDocument, options);
}
export type SetAddValuesPlacesMutationHookResult = ReturnType<
  typeof useSetAddValuesPlacesMutation
>;
export type SetAddValuesPlacesMutationResult =
  Apollo.MutationResult<SetAddValuesPlacesMutation>;
export type SetAddValuesPlacesMutationOptions = Apollo.BaseMutationOptions<
  SetAddValuesPlacesMutation,
  SetAddValuesPlacesMutationVariables
>;
export const SetDeletePlacesDocument = gql`
  mutation setDeletePlaces($id: ID) {
    PlacesSetter {
      delete(id: $id)
    }
  }
`;
export type SetDeletePlacesMutationFn = Apollo.MutationFunction<
  SetDeletePlacesMutation,
  SetDeletePlacesMutationVariables
>;

/**
 * __useSetDeletePlacesMutation__
 *
 * To run a mutation, you first call `useSetDeletePlacesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDeletePlacesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDeletePlacesMutation, { data, loading, error }] = useSetDeletePlacesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetDeletePlacesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetDeletePlacesMutation,
    SetDeletePlacesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetDeletePlacesMutation,
    SetDeletePlacesMutationVariables
  >(SetDeletePlacesDocument, options);
}
export type SetDeletePlacesMutationHookResult = ReturnType<
  typeof useSetDeletePlacesMutation
>;
export type SetDeletePlacesMutationResult =
  Apollo.MutationResult<SetDeletePlacesMutation>;
export type SetDeletePlacesMutationOptions = Apollo.BaseMutationOptions<
  SetDeletePlacesMutation,
  SetDeletePlacesMutationVariables
>;
export const SetMakeVisibleDocument = gql`
  mutation setMakeVisible($PlanReportId: ID!, $reason: String!) {
    PlanReportSetter {
      makeVisible(PlanReportId: $PlanReportId, reason: $reason)
    }
  }
`;
export type SetMakeVisibleMutationFn = Apollo.MutationFunction<
  SetMakeVisibleMutation,
  SetMakeVisibleMutationVariables
>;

/**
 * __useSetMakeVisibleMutation__
 *
 * To run a mutation, you first call `useSetMakeVisibleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMakeVisibleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMakeVisibleMutation, { data, loading, error }] = useSetMakeVisibleMutation({
 *   variables: {
 *      PlanReportId: // value for 'PlanReportId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useSetMakeVisibleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetMakeVisibleMutation,
    SetMakeVisibleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetMakeVisibleMutation,
    SetMakeVisibleMutationVariables
  >(SetMakeVisibleDocument, options);
}
export type SetMakeVisibleMutationHookResult = ReturnType<
  typeof useSetMakeVisibleMutation
>;
export type SetMakeVisibleMutationResult =
  Apollo.MutationResult<SetMakeVisibleMutation>;
export type SetMakeVisibleMutationOptions = Apollo.BaseMutationOptions<
  SetMakeVisibleMutation,
  SetMakeVisibleMutationVariables
>;
export const SetDealerFixPlanDocument = gql`
  mutation setDealerFixPlan(
    $PlanReportId: ID!
    $DealerId: ID!
    $fixExplanation: String
    $planToFixAt: DateTime
    $responsiblePersonContact: String
  ) {
    PlanReportSetter {
      dealerFixPlan(
        PlanReportId: $PlanReportId
        DealerId: $DealerId
        fixExplanation: $fixExplanation
        planToFixAt: $planToFixAt
        responsiblePersonContact: $responsiblePersonContact
      )
    }
  }
`;
export type SetDealerFixPlanMutationFn = Apollo.MutationFunction<
  SetDealerFixPlanMutation,
  SetDealerFixPlanMutationVariables
>;

/**
 * __useSetDealerFixPlanMutation__
 *
 * To run a mutation, you first call `useSetDealerFixPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDealerFixPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDealerFixPlanMutation, { data, loading, error }] = useSetDealerFixPlanMutation({
 *   variables: {
 *      PlanReportId: // value for 'PlanReportId'
 *      DealerId: // value for 'DealerId'
 *      fixExplanation: // value for 'fixExplanation'
 *      planToFixAt: // value for 'planToFixAt'
 *      responsiblePersonContact: // value for 'responsiblePersonContact'
 *   },
 * });
 */
export function useSetDealerFixPlanMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetDealerFixPlanMutation,
    SetDealerFixPlanMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetDealerFixPlanMutation,
    SetDealerFixPlanMutationVariables
  >(SetDealerFixPlanDocument, options);
}
export type SetDealerFixPlanMutationHookResult = ReturnType<
  typeof useSetDealerFixPlanMutation
>;
export type SetDealerFixPlanMutationResult =
  Apollo.MutationResult<SetDealerFixPlanMutation>;
export type SetDealerFixPlanMutationOptions = Apollo.BaseMutationOptions<
  SetDealerFixPlanMutation,
  SetDealerFixPlanMutationVariables
>;
export const SetDealerStateFixDoneDocument = gql`
  mutation setDealerStateFixDone($PlanReportId: ID!, $DealerId: ID!) {
    PlanReportSetter {
      dealerStateFixDone(PlanReportId: $PlanReportId, DealerId: $DealerId)
    }
  }
`;
export type SetDealerStateFixDoneMutationFn = Apollo.MutationFunction<
  SetDealerStateFixDoneMutation,
  SetDealerStateFixDoneMutationVariables
>;

/**
 * __useSetDealerStateFixDoneMutation__
 *
 * To run a mutation, you first call `useSetDealerStateFixDoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDealerStateFixDoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDealerStateFixDoneMutation, { data, loading, error }] = useSetDealerStateFixDoneMutation({
 *   variables: {
 *      PlanReportId: // value for 'PlanReportId'
 *      DealerId: // value for 'DealerId'
 *   },
 * });
 */
export function useSetDealerStateFixDoneMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetDealerStateFixDoneMutation,
    SetDealerStateFixDoneMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetDealerStateFixDoneMutation,
    SetDealerStateFixDoneMutationVariables
  >(SetDealerStateFixDoneDocument, options);
}
export type SetDealerStateFixDoneMutationHookResult = ReturnType<
  typeof useSetDealerStateFixDoneMutation
>;
export type SetDealerStateFixDoneMutationResult =
  Apollo.MutationResult<SetDealerStateFixDoneMutation>;
export type SetDealerStateFixDoneMutationOptions = Apollo.BaseMutationOptions<
  SetDealerStateFixDoneMutation,
  SetDealerStateFixDoneMutationVariables
>;
export const SetDealerFixPlanAddDocumentDocument = gql`
  mutation setDealerFixPlanAddDocument(
    $PlanReportId: ID!
    $DealerId: ID!
    $fileIds: [ID]
  ) {
    PlanReportSetter {
      dealerFixPlanAddDocument(
        PlanReportId: $PlanReportId
        DealerId: $DealerId
        fileIds: $fileIds
      )
    }
  }
`;
export type SetDealerFixPlanAddDocumentMutationFn = Apollo.MutationFunction<
  SetDealerFixPlanAddDocumentMutation,
  SetDealerFixPlanAddDocumentMutationVariables
>;

/**
 * __useSetDealerFixPlanAddDocumentMutation__
 *
 * To run a mutation, you first call `useSetDealerFixPlanAddDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDealerFixPlanAddDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDealerFixPlanAddDocumentMutation, { data, loading, error }] = useSetDealerFixPlanAddDocumentMutation({
 *   variables: {
 *      PlanReportId: // value for 'PlanReportId'
 *      DealerId: // value for 'DealerId'
 *      fileIds: // value for 'fileIds'
 *   },
 * });
 */
export function useSetDealerFixPlanAddDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetDealerFixPlanAddDocumentMutation,
    SetDealerFixPlanAddDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetDealerFixPlanAddDocumentMutation,
    SetDealerFixPlanAddDocumentMutationVariables
  >(SetDealerFixPlanAddDocumentDocument, options);
}
export type SetDealerFixPlanAddDocumentMutationHookResult = ReturnType<
  typeof useSetDealerFixPlanAddDocumentMutation
>;
export type SetDealerFixPlanAddDocumentMutationResult =
  Apollo.MutationResult<SetDealerFixPlanAddDocumentMutation>;
export type SetDealerFixPlanAddDocumentMutationOptions =
  Apollo.BaseMutationOptions<
    SetDealerFixPlanAddDocumentMutation,
    SetDealerFixPlanAddDocumentMutationVariables
  >;
export const SetDealerFixPlanRemoveDocumentDocumentDocument = gql`
  mutation setDealerFixPlanRemoveDocumentDocument(
    $PlanReportId: ID!
    $DealerId: ID!
    $fileId: ID!
  ) {
    PlanReportSetter {
      dealerFixPlanRemoveDocument(
        PlanReportId: $PlanReportId
        DealerId: $DealerId
        fileId: $fileId
      )
    }
  }
`;
export type SetDealerFixPlanRemoveDocumentDocumentMutationFn =
  Apollo.MutationFunction<
    SetDealerFixPlanRemoveDocumentDocumentMutation,
    SetDealerFixPlanRemoveDocumentDocumentMutationVariables
  >;

/**
 * __useSetDealerFixPlanRemoveDocumentDocumentMutation__
 *
 * To run a mutation, you first call `useSetDealerFixPlanRemoveDocumentDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDealerFixPlanRemoveDocumentDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDealerFixPlanRemoveDocumentDocumentMutation, { data, loading, error }] = useSetDealerFixPlanRemoveDocumentDocumentMutation({
 *   variables: {
 *      PlanReportId: // value for 'PlanReportId'
 *      DealerId: // value for 'DealerId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useSetDealerFixPlanRemoveDocumentDocumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetDealerFixPlanRemoveDocumentDocumentMutation,
    SetDealerFixPlanRemoveDocumentDocumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetDealerFixPlanRemoveDocumentDocumentMutation,
    SetDealerFixPlanRemoveDocumentDocumentMutationVariables
  >(SetDealerFixPlanRemoveDocumentDocumentDocument, options);
}
export type SetDealerFixPlanRemoveDocumentDocumentMutationHookResult =
  ReturnType<typeof useSetDealerFixPlanRemoveDocumentDocumentMutation>;
export type SetDealerFixPlanRemoveDocumentDocumentMutationResult =
  Apollo.MutationResult<SetDealerFixPlanRemoveDocumentDocumentMutation>;
export type SetDealerFixPlanRemoveDocumentDocumentMutationOptions =
  Apollo.BaseMutationOptions<
    SetDealerFixPlanRemoveDocumentDocumentMutation,
    SetDealerFixPlanRemoveDocumentDocumentMutationVariables
  >;
export const SetCheckDealersFixDocument = gql`
  mutation setCheckDealersFix($PlanReportId: ID!, $isGood: Boolean!) {
    PlanReportSetter {
      checkDealersFix(PlanReportId: $PlanReportId, isGood: $isGood)
    }
  }
`;
export type SetCheckDealersFixMutationFn = Apollo.MutationFunction<
  SetCheckDealersFixMutation,
  SetCheckDealersFixMutationVariables
>;

/**
 * __useSetCheckDealersFixMutation__
 *
 * To run a mutation, you first call `useSetCheckDealersFixMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCheckDealersFixMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCheckDealersFixMutation, { data, loading, error }] = useSetCheckDealersFixMutation({
 *   variables: {
 *      PlanReportId: // value for 'PlanReportId'
 *      isGood: // value for 'isGood'
 *   },
 * });
 */
export function useSetCheckDealersFixMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCheckDealersFixMutation,
    SetCheckDealersFixMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetCheckDealersFixMutation,
    SetCheckDealersFixMutationVariables
  >(SetCheckDealersFixDocument, options);
}
export type SetCheckDealersFixMutationHookResult = ReturnType<
  typeof useSetCheckDealersFixMutation
>;
export type SetCheckDealersFixMutationResult =
  Apollo.MutationResult<SetCheckDealersFixMutation>;
export type SetCheckDealersFixMutationOptions = Apollo.BaseMutationOptions<
  SetCheckDealersFixMutation,
  SetCheckDealersFixMutationVariables
>;
export const SetAddPositionDocument = gql`
  mutation setAddPosition(
    $code: String!
    $name: String!
    $nameEn: String
    $status: PositionStatus!
    $DirectionId: ID!
    $RequiredEmail: Boolean
    $jobDescriptionIsRequired: Boolean
  ) {
    PositionSetter {
      createPosition(
        code: $code
        name: $name
        nameEn: $nameEn
        status: $status
        DirectionId: $DirectionId
        RequiredEmail: $RequiredEmail
        jobDescriptionIsRequired: $jobDescriptionIsRequired
      ) {
        name
      }
    }
  }
`;
export type SetAddPositionMutationFn = Apollo.MutationFunction<
  SetAddPositionMutation,
  SetAddPositionMutationVariables
>;

/**
 * __useSetAddPositionMutation__
 *
 * To run a mutation, you first call `useSetAddPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAddPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAddPositionMutation, { data, loading, error }] = useSetAddPositionMutation({
 *   variables: {
 *      code: // value for 'code'
 *      name: // value for 'name'
 *      nameEn: // value for 'nameEn'
 *      status: // value for 'status'
 *      DirectionId: // value for 'DirectionId'
 *      RequiredEmail: // value for 'RequiredEmail'
 *      jobDescriptionIsRequired: // value for 'jobDescriptionIsRequired'
 *   },
 * });
 */
export function useSetAddPositionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetAddPositionMutation,
    SetAddPositionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetAddPositionMutation,
    SetAddPositionMutationVariables
  >(SetAddPositionDocument, options);
}
export type SetAddPositionMutationHookResult = ReturnType<
  typeof useSetAddPositionMutation
>;
export type SetAddPositionMutationResult =
  Apollo.MutationResult<SetAddPositionMutation>;
export type SetAddPositionMutationOptions = Apollo.BaseMutationOptions<
  SetAddPositionMutation,
  SetAddPositionMutationVariables
>;
export const SetEditPositionDocument = gql`
  mutation setEditPosition(
    $id: ID!
    $code: String
    $name: String
    $nameEn: String
    $status: PositionStatus
    $DirectionId: ID
    $RequiredEmail: Boolean
    $showInZD: Boolean
    $jobDescriptionIsRequired: Boolean
  ) {
    PositionSetter {
      editPosition(
        id: $id
        code: $code
        name: $name
        nameEn: $nameEn
        status: $status
        RequiredEmail: $RequiredEmail
        DirectionId: $DirectionId
        showInZd: $showInZD
        jobDescriptionIsRequired: $jobDescriptionIsRequired
      ) {
        id
      }
    }
  }
`;
export type SetEditPositionMutationFn = Apollo.MutationFunction<
  SetEditPositionMutation,
  SetEditPositionMutationVariables
>;

/**
 * __useSetEditPositionMutation__
 *
 * To run a mutation, you first call `useSetEditPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEditPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEditPositionMutation, { data, loading, error }] = useSetEditPositionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      code: // value for 'code'
 *      name: // value for 'name'
 *      nameEn: // value for 'nameEn'
 *      status: // value for 'status'
 *      DirectionId: // value for 'DirectionId'
 *      RequiredEmail: // value for 'RequiredEmail'
 *      showInZD: // value for 'showInZD'
 *      jobDescriptionIsRequired: // value for 'jobDescriptionIsRequired'
 *   },
 * });
 */
export function useSetEditPositionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetEditPositionMutation,
    SetEditPositionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetEditPositionMutation,
    SetEditPositionMutationVariables
  >(SetEditPositionDocument, options);
}
export type SetEditPositionMutationHookResult = ReturnType<
  typeof useSetEditPositionMutation
>;
export type SetEditPositionMutationResult =
  Apollo.MutationResult<SetEditPositionMutation>;
export type SetEditPositionMutationOptions = Apollo.BaseMutationOptions<
  SetEditPositionMutation,
  SetEditPositionMutationVariables
>;
export const CreateDirectionDocument = gql`
  mutation CreateDirection(
    $name: String!
    $status: PositionDirectionsStatus!
    $role: [PositionDirectionsRole]!
  ) {
    PositionSetter {
      createDirection(name: $name, status: $status, role: $role) {
        id
      }
    }
  }
`;
export type CreateDirectionMutationFn = Apollo.MutationFunction<
  CreateDirectionMutation,
  CreateDirectionMutationVariables
>;

/**
 * __useCreateDirectionMutation__
 *
 * To run a mutation, you first call `useCreateDirectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDirectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDirectionMutation, { data, loading, error }] = useCreateDirectionMutation({
 *   variables: {
 *      name: // value for 'name'
 *      status: // value for 'status'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useCreateDirectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDirectionMutation,
    CreateDirectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDirectionMutation,
    CreateDirectionMutationVariables
  >(CreateDirectionDocument, options);
}
export type CreateDirectionMutationHookResult = ReturnType<
  typeof useCreateDirectionMutation
>;
export type CreateDirectionMutationResult =
  Apollo.MutationResult<CreateDirectionMutation>;
export type CreateDirectionMutationOptions = Apollo.BaseMutationOptions<
  CreateDirectionMutation,
  CreateDirectionMutationVariables
>;
export const EditDirectionDocument = gql`
  mutation EditDirection(
    $id: ID!
    $name: String
    $status: PositionDirectionsStatus
    $role: [PositionDirectionsRole]
  ) {
    PositionSetter {
      editDirection(id: $id, name: $name, status: $status, role: $role) {
        id
      }
    }
  }
`;
export type EditDirectionMutationFn = Apollo.MutationFunction<
  EditDirectionMutation,
  EditDirectionMutationVariables
>;

/**
 * __useEditDirectionMutation__
 *
 * To run a mutation, you first call `useEditDirectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDirectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDirectionMutation, { data, loading, error }] = useEditDirectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      status: // value for 'status'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useEditDirectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditDirectionMutation,
    EditDirectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditDirectionMutation,
    EditDirectionMutationVariables
  >(EditDirectionDocument, options);
}
export type EditDirectionMutationHookResult = ReturnType<
  typeof useEditDirectionMutation
>;
export type EditDirectionMutationResult =
  Apollo.MutationResult<EditDirectionMutation>;
export type EditDirectionMutationOptions = Apollo.BaseMutationOptions<
  EditDirectionMutation,
  EditDirectionMutationVariables
>;
export const CreateInformationSystemDocument = gql`
  mutation CreateInformationSystem($name: String!, $positions: [ID]) {
    PositionSetter {
      createInformationSystem(name: $name, positions: $positions) {
        id
      }
    }
  }
`;
export type CreateInformationSystemMutationFn = Apollo.MutationFunction<
  CreateInformationSystemMutation,
  CreateInformationSystemMutationVariables
>;

/**
 * __useCreateInformationSystemMutation__
 *
 * To run a mutation, you first call `useCreateInformationSystemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInformationSystemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInformationSystemMutation, { data, loading, error }] = useCreateInformationSystemMutation({
 *   variables: {
 *      name: // value for 'name'
 *      positions: // value for 'positions'
 *   },
 * });
 */
export function useCreateInformationSystemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateInformationSystemMutation,
    CreateInformationSystemMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateInformationSystemMutation,
    CreateInformationSystemMutationVariables
  >(CreateInformationSystemDocument, options);
}
export type CreateInformationSystemMutationHookResult = ReturnType<
  typeof useCreateInformationSystemMutation
>;
export type CreateInformationSystemMutationResult =
  Apollo.MutationResult<CreateInformationSystemMutation>;
export type CreateInformationSystemMutationOptions = Apollo.BaseMutationOptions<
  CreateInformationSystemMutation,
  CreateInformationSystemMutationVariables
>;
export const EditInformationSystemDocument = gql`
  mutation EditInformationSystem($id: ID!, $name: String!, $positions: [ID]) {
    PositionSetter {
      editInformationSystem(name: $name, id: $id, positions: $positions) {
        id
      }
    }
  }
`;
export type EditInformationSystemMutationFn = Apollo.MutationFunction<
  EditInformationSystemMutation,
  EditInformationSystemMutationVariables
>;

/**
 * __useEditInformationSystemMutation__
 *
 * To run a mutation, you first call `useEditInformationSystemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditInformationSystemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editInformationSystemMutation, { data, loading, error }] = useEditInformationSystemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      positions: // value for 'positions'
 *   },
 * });
 */
export function useEditInformationSystemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditInformationSystemMutation,
    EditInformationSystemMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditInformationSystemMutation,
    EditInformationSystemMutationVariables
  >(EditInformationSystemDocument, options);
}
export type EditInformationSystemMutationHookResult = ReturnType<
  typeof useEditInformationSystemMutation
>;
export type EditInformationSystemMutationResult =
  Apollo.MutationResult<EditInformationSystemMutation>;
export type EditInformationSystemMutationOptions = Apollo.BaseMutationOptions<
  EditInformationSystemMutation,
  EditInformationSystemMutationVariables
>;
export const CreatePersonalInformationDocument = gql`
  mutation CreatePersonalInformation(
    $name: String!
    $personalDataTemplateId: ID
    $informationSystemId: ID
  ) {
    PositionSetter {
      createPersonalInformation(
        name: $name
        personalDataTemplateId: $personalDataTemplateId
        informationSystemId: $informationSystemId
      ) {
        id
      }
    }
  }
`;
export type CreatePersonalInformationMutationFn = Apollo.MutationFunction<
  CreatePersonalInformationMutation,
  CreatePersonalInformationMutationVariables
>;

/**
 * __useCreatePersonalInformationMutation__
 *
 * To run a mutation, you first call `useCreatePersonalInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePersonalInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPersonalInformationMutation, { data, loading, error }] = useCreatePersonalInformationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      personalDataTemplateId: // value for 'personalDataTemplateId'
 *      informationSystemId: // value for 'informationSystemId'
 *   },
 * });
 */
export function useCreatePersonalInformationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePersonalInformationMutation,
    CreatePersonalInformationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreatePersonalInformationMutation,
    CreatePersonalInformationMutationVariables
  >(CreatePersonalInformationDocument, options);
}
export type CreatePersonalInformationMutationHookResult = ReturnType<
  typeof useCreatePersonalInformationMutation
>;
export type CreatePersonalInformationMutationResult =
  Apollo.MutationResult<CreatePersonalInformationMutation>;
export type CreatePersonalInformationMutationOptions =
  Apollo.BaseMutationOptions<
    CreatePersonalInformationMutation,
    CreatePersonalInformationMutationVariables
  >;
export const EditPersonalInformationDocument = gql`
  mutation EditPersonalInformation(
    $id: ID!
    $name: String!
    $personalDataTemplate: String
    $informationSystemId: ID
  ) {
    PositionSetter {
      editPersonalInformation(
        id: $id
        name: $name
        personalDataTemplate: $personalDataTemplate
        informationSystemId: $informationSystemId
      ) {
        id
      }
    }
  }
`;
export type EditPersonalInformationMutationFn = Apollo.MutationFunction<
  EditPersonalInformationMutation,
  EditPersonalInformationMutationVariables
>;

/**
 * __useEditPersonalInformationMutation__
 *
 * To run a mutation, you first call `useEditPersonalInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPersonalInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPersonalInformationMutation, { data, loading, error }] = useEditPersonalInformationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      personalDataTemplate: // value for 'personalDataTemplate'
 *      informationSystemId: // value for 'informationSystemId'
 *   },
 * });
 */
export function useEditPersonalInformationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditPersonalInformationMutation,
    EditPersonalInformationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditPersonalInformationMutation,
    EditPersonalInformationMutationVariables
  >(EditPersonalInformationDocument, options);
}
export type EditPersonalInformationMutationHookResult = ReturnType<
  typeof useEditPersonalInformationMutation
>;
export type EditPersonalInformationMutationResult =
  Apollo.MutationResult<EditPersonalInformationMutation>;
export type EditPersonalInformationMutationOptions = Apollo.BaseMutationOptions<
  EditPersonalInformationMutation,
  EditPersonalInformationMutationVariables
>;
export const SetQVersionDocument = gql`
  mutation setQVersion(
    $id: ID
    $quarter: Int
    $year: Int
    $dateBegin: DateTime
    $IndicatorId: ID
    $IndicatorGroupId: ID
  ) {
    QuartilesRatingSetter {
      setVersion(
        id: $id
        quarter: $quarter
        year: $year
        dateBegin: $dateBegin
        IndicatorId: $IndicatorId
        IndicatorGroupId: $IndicatorGroupId
      ) {
        id
      }
    }
  }
`;
export type SetQVersionMutationFn = Apollo.MutationFunction<
  SetQVersionMutation,
  SetQVersionMutationVariables
>;

/**
 * __useSetQVersionMutation__
 *
 * To run a mutation, you first call `useSetQVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetQVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setQVersionMutation, { data, loading, error }] = useSetQVersionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      quarter: // value for 'quarter'
 *      year: // value for 'year'
 *      dateBegin: // value for 'dateBegin'
 *      IndicatorId: // value for 'IndicatorId'
 *      IndicatorGroupId: // value for 'IndicatorGroupId'
 *   },
 * });
 */
export function useSetQVersionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetQVersionMutation,
    SetQVersionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetQVersionMutation, SetQVersionMutationVariables>(
    SetQVersionDocument,
    options,
  );
}
export type SetQVersionMutationHookResult = ReturnType<
  typeof useSetQVersionMutation
>;
export type SetQVersionMutationResult =
  Apollo.MutationResult<SetQVersionMutation>;
export type SetQVersionMutationOptions = Apollo.BaseMutationOptions<
  SetQVersionMutation,
  SetQVersionMutationVariables
>;
export const SetQRatingDocument = gql`
  mutation setQRating(
    $id: ID
    $number: String
    $name: String
    $KPIen: String
    $KPIru: String
    $LastPeriodIndicatorId: ID
    $ValueIndicatorId: ID
    $GroupIndicatorId: ID
    $AverageIndicatorId: ID
    $DifferenceIndicatorId: ID
    $GroupAverageIndicatorId: ID
    $type: String!
    $sort: Int!
    $round: Int
    $format: Int
    $ParentId: ID
    $PrevElementId: ID
    $RatingsVersionId: ID!
  ) {
    QuartilesRatingSetter {
      setRating(
        id: $id
        number: $number
        name: $name
        KPIen: $KPIen
        KPIru: $KPIru
        LastPeriodIndicatorId: $LastPeriodIndicatorId
        ValueIndicatorId: $ValueIndicatorId
        GroupIndicatorId: $GroupIndicatorId
        AverageIndicatorId: $AverageIndicatorId
        DifferenceIndicatorId: $DifferenceIndicatorId
        GroupAverageIndicatorId: $GroupAverageIndicatorId
        type: $type
        sort: $sort
        round: $round
        format: $format
        ParentId: $ParentId
        PrevElementId: $PrevElementId
        RatingsVersionId: $RatingsVersionId
      ) {
        id
        number
      }
    }
  }
`;
export type SetQRatingMutationFn = Apollo.MutationFunction<
  SetQRatingMutation,
  SetQRatingMutationVariables
>;

/**
 * __useSetQRatingMutation__
 *
 * To run a mutation, you first call `useSetQRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetQRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setQRatingMutation, { data, loading, error }] = useSetQRatingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      number: // value for 'number'
 *      name: // value for 'name'
 *      KPIen: // value for 'KPIen'
 *      KPIru: // value for 'KPIru'
 *      LastPeriodIndicatorId: // value for 'LastPeriodIndicatorId'
 *      ValueIndicatorId: // value for 'ValueIndicatorId'
 *      GroupIndicatorId: // value for 'GroupIndicatorId'
 *      AverageIndicatorId: // value for 'AverageIndicatorId'
 *      DifferenceIndicatorId: // value for 'DifferenceIndicatorId'
 *      GroupAverageIndicatorId: // value for 'GroupAverageIndicatorId'
 *      type: // value for 'type'
 *      sort: // value for 'sort'
 *      round: // value for 'round'
 *      format: // value for 'format'
 *      ParentId: // value for 'ParentId'
 *      PrevElementId: // value for 'PrevElementId'
 *      RatingsVersionId: // value for 'RatingsVersionId'
 *   },
 * });
 */
export function useSetQRatingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetQRatingMutation,
    SetQRatingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetQRatingMutation, SetQRatingMutationVariables>(
    SetQRatingDocument,
    options,
  );
}
export type SetQRatingMutationHookResult = ReturnType<
  typeof useSetQRatingMutation
>;
export type SetQRatingMutationResult =
  Apollo.MutationResult<SetQRatingMutation>;
export type SetQRatingMutationOptions = Apollo.BaseMutationOptions<
  SetQRatingMutation,
  SetQRatingMutationVariables
>;
export const DeleteQListRatingDocument = gql`
  mutation deleteQListRating($id: ID!) {
    QuartilesRatingSetter {
      deleteList(id: $id)
    }
  }
`;
export type DeleteQListRatingMutationFn = Apollo.MutationFunction<
  DeleteQListRatingMutation,
  DeleteQListRatingMutationVariables
>;

/**
 * __useDeleteQListRatingMutation__
 *
 * To run a mutation, you first call `useDeleteQListRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQListRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQListRatingMutation, { data, loading, error }] = useDeleteQListRatingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteQListRatingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteQListRatingMutation,
    DeleteQListRatingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteQListRatingMutation,
    DeleteQListRatingMutationVariables
  >(DeleteQListRatingDocument, options);
}
export type DeleteQListRatingMutationHookResult = ReturnType<
  typeof useDeleteQListRatingMutation
>;
export type DeleteQListRatingMutationResult =
  Apollo.MutationResult<DeleteQListRatingMutation>;
export type DeleteQListRatingMutationOptions = Apollo.BaseMutationOptions<
  DeleteQListRatingMutation,
  DeleteQListRatingMutationVariables
>;
export const DeleteQVersionRatingDocument = gql`
  mutation deleteQVersionRating($id: ID!) {
    QuartilesRatingSetter {
      deleteVersion(id: $id)
    }
  }
`;
export type DeleteQVersionRatingMutationFn = Apollo.MutationFunction<
  DeleteQVersionRatingMutation,
  DeleteQVersionRatingMutationVariables
>;

/**
 * __useDeleteQVersionRatingMutation__
 *
 * To run a mutation, you first call `useDeleteQVersionRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQVersionRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQVersionRatingMutation, { data, loading, error }] = useDeleteQVersionRatingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteQVersionRatingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteQVersionRatingMutation,
    DeleteQVersionRatingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteQVersionRatingMutation,
    DeleteQVersionRatingMutationVariables
  >(DeleteQVersionRatingDocument, options);
}
export type DeleteQVersionRatingMutationHookResult = ReturnType<
  typeof useDeleteQVersionRatingMutation
>;
export type DeleteQVersionRatingMutationResult =
  Apollo.MutationResult<DeleteQVersionRatingMutation>;
export type DeleteQVersionRatingMutationOptions = Apollo.BaseMutationOptions<
  DeleteQVersionRatingMutation,
  DeleteQVersionRatingMutationVariables
>;
export const SetCreateRequiredToolsDocument = gql`
  mutation setCreateRequiredTools(
    $ComplianceIndicator: ID
    $ModelIndicator: ID
    $TotalIndicator: ID
    $CheckedDateIndicator: ID
    $Number: String
    $Name: String
    $NameEn: String
  ) {
    RequiredToolsSetter {
      create(
        ComplianceIndicator: $ComplianceIndicator
        ModelIndicator: $ModelIndicator
        TotalIndicator: $TotalIndicator
        CheckedDateIndicator: $CheckedDateIndicator
        Number: $Number
        Name: $Name
        NameEn: $NameEn
      ) {
        id
      }
    }
  }
`;
export type SetCreateRequiredToolsMutationFn = Apollo.MutationFunction<
  SetCreateRequiredToolsMutation,
  SetCreateRequiredToolsMutationVariables
>;

/**
 * __useSetCreateRequiredToolsMutation__
 *
 * To run a mutation, you first call `useSetCreateRequiredToolsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCreateRequiredToolsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCreateRequiredToolsMutation, { data, loading, error }] = useSetCreateRequiredToolsMutation({
 *   variables: {
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      ModelIndicator: // value for 'ModelIndicator'
 *      TotalIndicator: // value for 'TotalIndicator'
 *      CheckedDateIndicator: // value for 'CheckedDateIndicator'
 *      Number: // value for 'Number'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *   },
 * });
 */
export function useSetCreateRequiredToolsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCreateRequiredToolsMutation,
    SetCreateRequiredToolsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetCreateRequiredToolsMutation,
    SetCreateRequiredToolsMutationVariables
  >(SetCreateRequiredToolsDocument, options);
}
export type SetCreateRequiredToolsMutationHookResult = ReturnType<
  typeof useSetCreateRequiredToolsMutation
>;
export type SetCreateRequiredToolsMutationResult =
  Apollo.MutationResult<SetCreateRequiredToolsMutation>;
export type SetCreateRequiredToolsMutationOptions = Apollo.BaseMutationOptions<
  SetCreateRequiredToolsMutation,
  SetCreateRequiredToolsMutationVariables
>;
export const SetChangeRequiredToolsDocument = gql`
  mutation setChangeRequiredTools(
    $id: ID
    $ComplianceIndicator: ID
    $ModelIndicator: ID
    $TotalIndicator: ID
    $CheckedDateIndicator: ID
    $Number: String
    $Name: String
    $NameEn: String
  ) {
    RequiredToolsSetter {
      change(
        id: $id
        ComplianceIndicator: $ComplianceIndicator
        ModelIndicator: $ModelIndicator
        TotalIndicator: $TotalIndicator
        CheckedDateIndicator: $CheckedDateIndicator
        Number: $Number
        Name: $Name
        NameEn: $NameEn
      ) {
        id
      }
    }
  }
`;
export type SetChangeRequiredToolsMutationFn = Apollo.MutationFunction<
  SetChangeRequiredToolsMutation,
  SetChangeRequiredToolsMutationVariables
>;

/**
 * __useSetChangeRequiredToolsMutation__
 *
 * To run a mutation, you first call `useSetChangeRequiredToolsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetChangeRequiredToolsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setChangeRequiredToolsMutation, { data, loading, error }] = useSetChangeRequiredToolsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      ModelIndicator: // value for 'ModelIndicator'
 *      TotalIndicator: // value for 'TotalIndicator'
 *      CheckedDateIndicator: // value for 'CheckedDateIndicator'
 *      Number: // value for 'Number'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *   },
 * });
 */
export function useSetChangeRequiredToolsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetChangeRequiredToolsMutation,
    SetChangeRequiredToolsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetChangeRequiredToolsMutation,
    SetChangeRequiredToolsMutationVariables
  >(SetChangeRequiredToolsDocument, options);
}
export type SetChangeRequiredToolsMutationHookResult = ReturnType<
  typeof useSetChangeRequiredToolsMutation
>;
export type SetChangeRequiredToolsMutationResult =
  Apollo.MutationResult<SetChangeRequiredToolsMutation>;
export type SetChangeRequiredToolsMutationOptions = Apollo.BaseMutationOptions<
  SetChangeRequiredToolsMutation,
  SetChangeRequiredToolsMutationVariables
>;
export const SetBlindChangeRequiredToolsDocument = gql`
  mutation setBlindChangeRequiredTools(
    $id: ID
    $ComplianceIndicator: ID
    $ModelIndicator: ID
    $TotalIndicator: ID
    $CheckedDateIndicator: ID
    $Number: String
    $Name: String
    $NameEn: String
  ) {
    RequiredToolsSetter {
      blindChange(
        id: $id
        ComplianceIndicator: $ComplianceIndicator
        ModelIndicator: $ModelIndicator
        TotalIndicator: $TotalIndicator
        CheckedDateIndicator: $CheckedDateIndicator
        Number: $Number
        Name: $Name
        NameEn: $NameEn
      ) {
        id
      }
    }
  }
`;
export type SetBlindChangeRequiredToolsMutationFn = Apollo.MutationFunction<
  SetBlindChangeRequiredToolsMutation,
  SetBlindChangeRequiredToolsMutationVariables
>;

/**
 * __useSetBlindChangeRequiredToolsMutation__
 *
 * To run a mutation, you first call `useSetBlindChangeRequiredToolsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBlindChangeRequiredToolsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBlindChangeRequiredToolsMutation, { data, loading, error }] = useSetBlindChangeRequiredToolsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      ModelIndicator: // value for 'ModelIndicator'
 *      TotalIndicator: // value for 'TotalIndicator'
 *      CheckedDateIndicator: // value for 'CheckedDateIndicator'
 *      Number: // value for 'Number'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *   },
 * });
 */
export function useSetBlindChangeRequiredToolsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetBlindChangeRequiredToolsMutation,
    SetBlindChangeRequiredToolsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetBlindChangeRequiredToolsMutation,
    SetBlindChangeRequiredToolsMutationVariables
  >(SetBlindChangeRequiredToolsDocument, options);
}
export type SetBlindChangeRequiredToolsMutationHookResult = ReturnType<
  typeof useSetBlindChangeRequiredToolsMutation
>;
export type SetBlindChangeRequiredToolsMutationResult =
  Apollo.MutationResult<SetBlindChangeRequiredToolsMutation>;
export type SetBlindChangeRequiredToolsMutationOptions =
  Apollo.BaseMutationOptions<
    SetBlindChangeRequiredToolsMutation,
    SetBlindChangeRequiredToolsMutationVariables
  >;
export const SetAddValuesRequiredToolsDocument = gql`
  mutation setAddValuesRequiredTools(
    $Compliance: Int
    $Total: Float
    $CheckedDate: String
    $Model: String
    $DealerId: ID
    $UUID: String
  ) {
    RequiredToolsSetter {
      addValues(
        UUID: $UUID
        Compliance: $Compliance
        Total: $Total
        CheckedDate: $CheckedDate
        Model: $Model
        DealerId: $DealerId
      )
    }
  }
`;
export type SetAddValuesRequiredToolsMutationFn = Apollo.MutationFunction<
  SetAddValuesRequiredToolsMutation,
  SetAddValuesRequiredToolsMutationVariables
>;

/**
 * __useSetAddValuesRequiredToolsMutation__
 *
 * To run a mutation, you first call `useSetAddValuesRequiredToolsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAddValuesRequiredToolsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAddValuesRequiredToolsMutation, { data, loading, error }] = useSetAddValuesRequiredToolsMutation({
 *   variables: {
 *      Compliance: // value for 'Compliance'
 *      Total: // value for 'Total'
 *      CheckedDate: // value for 'CheckedDate'
 *      Model: // value for 'Model'
 *      DealerId: // value for 'DealerId'
 *      UUID: // value for 'UUID'
 *   },
 * });
 */
export function useSetAddValuesRequiredToolsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetAddValuesRequiredToolsMutation,
    SetAddValuesRequiredToolsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetAddValuesRequiredToolsMutation,
    SetAddValuesRequiredToolsMutationVariables
  >(SetAddValuesRequiredToolsDocument, options);
}
export type SetAddValuesRequiredToolsMutationHookResult = ReturnType<
  typeof useSetAddValuesRequiredToolsMutation
>;
export type SetAddValuesRequiredToolsMutationResult =
  Apollo.MutationResult<SetAddValuesRequiredToolsMutation>;
export type SetAddValuesRequiredToolsMutationOptions =
  Apollo.BaseMutationOptions<
    SetAddValuesRequiredToolsMutation,
    SetAddValuesRequiredToolsMutationVariables
  >;
export const SetDeleteRequiredToolsDocument = gql`
  mutation setDeleteRequiredTools($id: ID) {
    RequiredToolsSetter {
      delete(id: $id)
    }
  }
`;
export type SetDeleteRequiredToolsMutationFn = Apollo.MutationFunction<
  SetDeleteRequiredToolsMutation,
  SetDeleteRequiredToolsMutationVariables
>;

/**
 * __useSetDeleteRequiredToolsMutation__
 *
 * To run a mutation, you first call `useSetDeleteRequiredToolsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDeleteRequiredToolsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDeleteRequiredToolsMutation, { data, loading, error }] = useSetDeleteRequiredToolsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetDeleteRequiredToolsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetDeleteRequiredToolsMutation,
    SetDeleteRequiredToolsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetDeleteRequiredToolsMutation,
    SetDeleteRequiredToolsMutationVariables
  >(SetDeleteRequiredToolsDocument, options);
}
export type SetDeleteRequiredToolsMutationHookResult = ReturnType<
  typeof useSetDeleteRequiredToolsMutation
>;
export type SetDeleteRequiredToolsMutationResult =
  Apollo.MutationResult<SetDeleteRequiredToolsMutation>;
export type SetDeleteRequiredToolsMutationOptions = Apollo.BaseMutationOptions<
  SetDeleteRequiredToolsMutation,
  SetDeleteRequiredToolsMutationVariables
>;
export const GibddSetDocument = gql`
  mutation GIBDDSet(
    $id: ID!
    $vin: String!
    $dateRegistration: DateTime!
    $city: String!
    $district: String!
    $region: String!
    $federalArea: String!
  ) {
    SRRSetter {
      setGIBDD(
        id: $id
        vin: $vin
        dateRegistration: $dateRegistration
        city: $city
        district: $district
        region: $region
        federalArea: $federalArea
      ) {
        id
      }
    }
  }
`;
export type GibddSetMutationFn = Apollo.MutationFunction<
  GibddSetMutation,
  GibddSetMutationVariables
>;

/**
 * __useGibddSetMutation__
 *
 * To run a mutation, you first call `useGibddSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGibddSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gibddSetMutation, { data, loading, error }] = useGibddSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      vin: // value for 'vin'
 *      dateRegistration: // value for 'dateRegistration'
 *      city: // value for 'city'
 *      district: // value for 'district'
 *      region: // value for 'region'
 *      federalArea: // value for 'federalArea'
 *   },
 * });
 */
export function useGibddSetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GibddSetMutation,
    GibddSetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<GibddSetMutation, GibddSetMutationVariables>(
    GibddSetDocument,
    options,
  );
}
export type GibddSetMutationHookResult = ReturnType<typeof useGibddSetMutation>;
export type GibddSetMutationResult = Apollo.MutationResult<GibddSetMutation>;
export type GibddSetMutationOptions = Apollo.BaseMutationOptions<
  GibddSetMutation,
  GibddSetMutationVariables
>;
export const UploadGibddDocument = gql`
  mutation UploadGIBDD($fileId: ID!) {
    SRRSetter {
      uploadGIBDD(fileId: $fileId)
    }
  }
`;
export type UploadGibddMutationFn = Apollo.MutationFunction<
  UploadGibddMutation,
  UploadGibddMutationVariables
>;

/**
 * __useUploadGibddMutation__
 *
 * To run a mutation, you first call `useUploadGibddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadGibddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadGibddMutation, { data, loading, error }] = useUploadGibddMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useUploadGibddMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadGibddMutation,
    UploadGibddMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UploadGibddMutation, UploadGibddMutationVariables>(
    UploadGibddDocument,
    options,
  );
}
export type UploadGibddMutationHookResult = ReturnType<
  typeof useUploadGibddMutation
>;
export type UploadGibddMutationResult =
  Apollo.MutationResult<UploadGibddMutation>;
export type UploadGibddMutationOptions = Apollo.BaseMutationOptions<
  UploadGibddMutation,
  UploadGibddMutationVariables
>;
export const UploadSrrTargetDocument = gql`
  mutation UploadSRRTarget($fileId: ID!, $description: String) {
    SRRSetter {
      uploadTarget(fileId: $fileId, description: $description)
    }
  }
`;
export type UploadSrrTargetMutationFn = Apollo.MutationFunction<
  UploadSrrTargetMutation,
  UploadSrrTargetMutationVariables
>;

/**
 * __useUploadSrrTargetMutation__
 *
 * To run a mutation, you first call `useUploadSrrTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadSrrTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadSrrTargetMutation, { data, loading, error }] = useUploadSrrTargetMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUploadSrrTargetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadSrrTargetMutation,
    UploadSrrTargetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadSrrTargetMutation,
    UploadSrrTargetMutationVariables
  >(UploadSrrTargetDocument, options);
}
export type UploadSrrTargetMutationHookResult = ReturnType<
  typeof useUploadSrrTargetMutation
>;
export type UploadSrrTargetMutationResult =
  Apollo.MutationResult<UploadSrrTargetMutation>;
export type UploadSrrTargetMutationOptions = Apollo.BaseMutationOptions<
  UploadSrrTargetMutation,
  UploadSrrTargetMutationVariables
>;
export const AcceptUploadSrrTargetDocument = gql`
  mutation acceptUploadSRRTarget($IndicatorUploadId: ID!) {
    SRRSetter {
      acceptUploadTarget(IndicatorUploadId: $IndicatorUploadId)
    }
  }
`;
export type AcceptUploadSrrTargetMutationFn = Apollo.MutationFunction<
  AcceptUploadSrrTargetMutation,
  AcceptUploadSrrTargetMutationVariables
>;

/**
 * __useAcceptUploadSrrTargetMutation__
 *
 * To run a mutation, you first call `useAcceptUploadSrrTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptUploadSrrTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptUploadSrrTargetMutation, { data, loading, error }] = useAcceptUploadSrrTargetMutation({
 *   variables: {
 *      IndicatorUploadId: // value for 'IndicatorUploadId'
 *   },
 * });
 */
export function useAcceptUploadSrrTargetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptUploadSrrTargetMutation,
    AcceptUploadSrrTargetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AcceptUploadSrrTargetMutation,
    AcceptUploadSrrTargetMutationVariables
  >(AcceptUploadSrrTargetDocument, options);
}
export type AcceptUploadSrrTargetMutationHookResult = ReturnType<
  typeof useAcceptUploadSrrTargetMutation
>;
export type AcceptUploadSrrTargetMutationResult =
  Apollo.MutationResult<AcceptUploadSrrTargetMutation>;
export type AcceptUploadSrrTargetMutationOptions = Apollo.BaseMutationOptions<
  AcceptUploadSrrTargetMutation,
  AcceptUploadSrrTargetMutationVariables
>;
export const ImportTargetDealerByMonthDocument = gql`
  mutation ImportTargetDealerByMonth($fileId: ID!) {
    SRRSetter {
      importTargetDealerByMonth(fileId: $fileId)
    }
  }
`;
export type ImportTargetDealerByMonthMutationFn = Apollo.MutationFunction<
  ImportTargetDealerByMonthMutation,
  ImportTargetDealerByMonthMutationVariables
>;

/**
 * __useImportTargetDealerByMonthMutation__
 *
 * To run a mutation, you first call `useImportTargetDealerByMonthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportTargetDealerByMonthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importTargetDealerByMonthMutation, { data, loading, error }] = useImportTargetDealerByMonthMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useImportTargetDealerByMonthMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ImportTargetDealerByMonthMutation,
    ImportTargetDealerByMonthMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ImportTargetDealerByMonthMutation,
    ImportTargetDealerByMonthMutationVariables
  >(ImportTargetDealerByMonthDocument, options);
}
export type ImportTargetDealerByMonthMutationHookResult = ReturnType<
  typeof useImportTargetDealerByMonthMutation
>;
export type ImportTargetDealerByMonthMutationResult =
  Apollo.MutationResult<ImportTargetDealerByMonthMutation>;
export type ImportTargetDealerByMonthMutationOptions =
  Apollo.BaseMutationOptions<
    ImportTargetDealerByMonthMutation,
    ImportTargetDealerByMonthMutationVariables
  >;
export const SetCreateSerivceDocument = gql`
  mutation setCreateSerivce(
    $ComplianceIndicator: ID
    $FactIndicator: ID
    $CertificationDateIndicator: ID
    $FactContractIndicator: ID
    $Code: String
    $Name: String
    $NameEn: String
  ) {
    ServicesSetter {
      create(
        ComplianceIndicator: $ComplianceIndicator
        FactIndicator: $FactIndicator
        CertificationDateIndicator: $CertificationDateIndicator
        FactContractIndicator: $FactContractIndicator
        Code: $Code
        Name: $Name
        NameEn: $NameEn
      ) {
        id
      }
    }
  }
`;
export type SetCreateSerivceMutationFn = Apollo.MutationFunction<
  SetCreateSerivceMutation,
  SetCreateSerivceMutationVariables
>;

/**
 * __useSetCreateSerivceMutation__
 *
 * To run a mutation, you first call `useSetCreateSerivceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCreateSerivceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCreateSerivceMutation, { data, loading, error }] = useSetCreateSerivceMutation({
 *   variables: {
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      FactIndicator: // value for 'FactIndicator'
 *      CertificationDateIndicator: // value for 'CertificationDateIndicator'
 *      FactContractIndicator: // value for 'FactContractIndicator'
 *      Code: // value for 'Code'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *   },
 * });
 */
export function useSetCreateSerivceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCreateSerivceMutation,
    SetCreateSerivceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetCreateSerivceMutation,
    SetCreateSerivceMutationVariables
  >(SetCreateSerivceDocument, options);
}
export type SetCreateSerivceMutationHookResult = ReturnType<
  typeof useSetCreateSerivceMutation
>;
export type SetCreateSerivceMutationResult =
  Apollo.MutationResult<SetCreateSerivceMutation>;
export type SetCreateSerivceMutationOptions = Apollo.BaseMutationOptions<
  SetCreateSerivceMutation,
  SetCreateSerivceMutationVariables
>;
export const SetChangeSerivceDocument = gql`
  mutation setChangeSerivce(
    $id: ID
    $ComplianceIndicator: ID
    $FactIndicator: ID
    $CertificationDateIndicator: ID
    $FactContractIndicator: ID
    $Code: String
    $Name: String
    $NameEn: String
  ) {
    ServicesSetter {
      change(
        id: $id
        ComplianceIndicator: $ComplianceIndicator
        FactIndicator: $FactIndicator
        CertificationDateIndicator: $CertificationDateIndicator
        FactContractIndicator: $FactContractIndicator
        Code: $Code
        Name: $Name
        NameEn: $NameEn
      ) {
        id
      }
    }
  }
`;
export type SetChangeSerivceMutationFn = Apollo.MutationFunction<
  SetChangeSerivceMutation,
  SetChangeSerivceMutationVariables
>;

/**
 * __useSetChangeSerivceMutation__
 *
 * To run a mutation, you first call `useSetChangeSerivceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetChangeSerivceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setChangeSerivceMutation, { data, loading, error }] = useSetChangeSerivceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      FactIndicator: // value for 'FactIndicator'
 *      CertificationDateIndicator: // value for 'CertificationDateIndicator'
 *      FactContractIndicator: // value for 'FactContractIndicator'
 *      Code: // value for 'Code'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *   },
 * });
 */
export function useSetChangeSerivceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetChangeSerivceMutation,
    SetChangeSerivceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetChangeSerivceMutation,
    SetChangeSerivceMutationVariables
  >(SetChangeSerivceDocument, options);
}
export type SetChangeSerivceMutationHookResult = ReturnType<
  typeof useSetChangeSerivceMutation
>;
export type SetChangeSerivceMutationResult =
  Apollo.MutationResult<SetChangeSerivceMutation>;
export type SetChangeSerivceMutationOptions = Apollo.BaseMutationOptions<
  SetChangeSerivceMutation,
  SetChangeSerivceMutationVariables
>;
export const SetBlindChangeSerivceDocument = gql`
  mutation setBlindChangeSerivce(
    $id: ID
    $ComplianceIndicator: ID
    $FactIndicator: ID
    $CertificationDateIndicator: ID
    $FactContractIndicator: ID
    $Code: String
    $Name: String
    $NameEn: String
  ) {
    ServicesSetter {
      blindChange(
        id: $id
        ComplianceIndicator: $ComplianceIndicator
        FactIndicator: $FactIndicator
        CertificationDateIndicator: $CertificationDateIndicator
        FactContractIndicator: $FactContractIndicator
        Code: $Code
        Name: $Name
        NameEn: $NameEn
      ) {
        id
      }
    }
  }
`;
export type SetBlindChangeSerivceMutationFn = Apollo.MutationFunction<
  SetBlindChangeSerivceMutation,
  SetBlindChangeSerivceMutationVariables
>;

/**
 * __useSetBlindChangeSerivceMutation__
 *
 * To run a mutation, you first call `useSetBlindChangeSerivceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBlindChangeSerivceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBlindChangeSerivceMutation, { data, loading, error }] = useSetBlindChangeSerivceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      FactIndicator: // value for 'FactIndicator'
 *      CertificationDateIndicator: // value for 'CertificationDateIndicator'
 *      FactContractIndicator: // value for 'FactContractIndicator'
 *      Code: // value for 'Code'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *   },
 * });
 */
export function useSetBlindChangeSerivceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetBlindChangeSerivceMutation,
    SetBlindChangeSerivceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetBlindChangeSerivceMutation,
    SetBlindChangeSerivceMutationVariables
  >(SetBlindChangeSerivceDocument, options);
}
export type SetBlindChangeSerivceMutationHookResult = ReturnType<
  typeof useSetBlindChangeSerivceMutation
>;
export type SetBlindChangeSerivceMutationResult =
  Apollo.MutationResult<SetBlindChangeSerivceMutation>;
export type SetBlindChangeSerivceMutationOptions = Apollo.BaseMutationOptions<
  SetBlindChangeSerivceMutation,
  SetBlindChangeSerivceMutationVariables
>;
export const SetAddValuesSerivceDocument = gql`
  mutation setAddValuesSerivce(
    $Compliance: Int
    $Fact: Int
    $FactContract: Int
    $CertificationDate: String
    $DealerId: ID
    $UUID: String
  ) {
    ServicesSetter {
      addValues(
        UUID: $UUID
        Compliance: $Compliance
        Fact: $Fact
        FactContract: $FactContract
        CertificationDate: $CertificationDate
        DealerId: $DealerId
      )
    }
  }
`;
export type SetAddValuesSerivceMutationFn = Apollo.MutationFunction<
  SetAddValuesSerivceMutation,
  SetAddValuesSerivceMutationVariables
>;

/**
 * __useSetAddValuesSerivceMutation__
 *
 * To run a mutation, you first call `useSetAddValuesSerivceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAddValuesSerivceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAddValuesSerivceMutation, { data, loading, error }] = useSetAddValuesSerivceMutation({
 *   variables: {
 *      Compliance: // value for 'Compliance'
 *      Fact: // value for 'Fact'
 *      FactContract: // value for 'FactContract'
 *      CertificationDate: // value for 'CertificationDate'
 *      DealerId: // value for 'DealerId'
 *      UUID: // value for 'UUID'
 *   },
 * });
 */
export function useSetAddValuesSerivceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetAddValuesSerivceMutation,
    SetAddValuesSerivceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetAddValuesSerivceMutation,
    SetAddValuesSerivceMutationVariables
  >(SetAddValuesSerivceDocument, options);
}
export type SetAddValuesSerivceMutationHookResult = ReturnType<
  typeof useSetAddValuesSerivceMutation
>;
export type SetAddValuesSerivceMutationResult =
  Apollo.MutationResult<SetAddValuesSerivceMutation>;
export type SetAddValuesSerivceMutationOptions = Apollo.BaseMutationOptions<
  SetAddValuesSerivceMutation,
  SetAddValuesSerivceMutationVariables
>;
export const SetDeleteSerivceDocument = gql`
  mutation setDeleteSerivce($id: ID) {
    ServicesSetter {
      delete(id: $id)
    }
  }
`;
export type SetDeleteSerivceMutationFn = Apollo.MutationFunction<
  SetDeleteSerivceMutation,
  SetDeleteSerivceMutationVariables
>;

/**
 * __useSetDeleteSerivceMutation__
 *
 * To run a mutation, you first call `useSetDeleteSerivceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDeleteSerivceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDeleteSerivceMutation, { data, loading, error }] = useSetDeleteSerivceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetDeleteSerivceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetDeleteSerivceMutation,
    SetDeleteSerivceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetDeleteSerivceMutation,
    SetDeleteSerivceMutationVariables
  >(SetDeleteSerivceDocument, options);
}
export type SetDeleteSerivceMutationHookResult = ReturnType<
  typeof useSetDeleteSerivceMutation
>;
export type SetDeleteSerivceMutationResult =
  Apollo.MutationResult<SetDeleteSerivceMutation>;
export type SetDeleteSerivceMutationOptions = Apollo.BaseMutationOptions<
  SetDeleteSerivceMutation,
  SetDeleteSerivceMutationVariables
>;
export const UploadStaffValuesDocument = gql`
  mutation uploadStaffValues($fileId: ID!) {
    SettingsSetter {
      setStaffFile(fileId: $fileId)
    }
  }
`;
export type UploadStaffValuesMutationFn = Apollo.MutationFunction<
  UploadStaffValuesMutation,
  UploadStaffValuesMutationVariables
>;

/**
 * __useUploadStaffValuesMutation__
 *
 * To run a mutation, you first call `useUploadStaffValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadStaffValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadStaffValuesMutation, { data, loading, error }] = useUploadStaffValuesMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useUploadStaffValuesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UploadStaffValuesMutation,
    UploadStaffValuesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UploadStaffValuesMutation,
    UploadStaffValuesMutationVariables
  >(UploadStaffValuesDocument, options);
}
export type UploadStaffValuesMutationHookResult = ReturnType<
  typeof useUploadStaffValuesMutation
>;
export type UploadStaffValuesMutationResult =
  Apollo.MutationResult<UploadStaffValuesMutation>;
export type UploadStaffValuesMutationOptions = Apollo.BaseMutationOptions<
  UploadStaffValuesMutation,
  UploadStaffValuesMutationVariables
>;
export const SubdivisionCreateDocument = gql`
  mutation SubdivisionCreate(
    $code: String!
    $name: String!
    $status: SubdivisionStatus!
    $parentId: ID
  ) {
    SubdivisionSetter {
      create(code: $code, name: $name, status: $status, parentId: $parentId) {
        id
      }
    }
  }
`;
export type SubdivisionCreateMutationFn = Apollo.MutationFunction<
  SubdivisionCreateMutation,
  SubdivisionCreateMutationVariables
>;

/**
 * __useSubdivisionCreateMutation__
 *
 * To run a mutation, you first call `useSubdivisionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubdivisionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subdivisionCreateMutation, { data, loading, error }] = useSubdivisionCreateMutation({
 *   variables: {
 *      code: // value for 'code'
 *      name: // value for 'name'
 *      status: // value for 'status'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useSubdivisionCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubdivisionCreateMutation,
    SubdivisionCreateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubdivisionCreateMutation,
    SubdivisionCreateMutationVariables
  >(SubdivisionCreateDocument, options);
}
export type SubdivisionCreateMutationHookResult = ReturnType<
  typeof useSubdivisionCreateMutation
>;
export type SubdivisionCreateMutationResult =
  Apollo.MutationResult<SubdivisionCreateMutation>;
export type SubdivisionCreateMutationOptions = Apollo.BaseMutationOptions<
  SubdivisionCreateMutation,
  SubdivisionCreateMutationVariables
>;
export const SubdivisionEditDocument = gql`
  mutation SubdivisionEdit(
    $id: ID!
    $name: String!
    $status: SubdivisionStatus!
    $parentId: ID
  ) {
    SubdivisionSetter {
      edit(id: $id, name: $name, status: $status, parentId: $parentId) {
        id
      }
    }
  }
`;
export type SubdivisionEditMutationFn = Apollo.MutationFunction<
  SubdivisionEditMutation,
  SubdivisionEditMutationVariables
>;

/**
 * __useSubdivisionEditMutation__
 *
 * To run a mutation, you first call `useSubdivisionEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubdivisionEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subdivisionEditMutation, { data, loading, error }] = useSubdivisionEditMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      status: // value for 'status'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useSubdivisionEditMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubdivisionEditMutation,
    SubdivisionEditMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubdivisionEditMutation,
    SubdivisionEditMutationVariables
  >(SubdivisionEditDocument, options);
}
export type SubdivisionEditMutationHookResult = ReturnType<
  typeof useSubdivisionEditMutation
>;
export type SubdivisionEditMutationResult =
  Apollo.MutationResult<SubdivisionEditMutation>;
export type SubdivisionEditMutationOptions = Apollo.BaseMutationOptions<
  SubdivisionEditMutation,
  SubdivisionEditMutationVariables
>;
export const SubdivisionDeleteDocument = gql`
  mutation SubdivisionDelete($id: ID!) {
    SubdivisionSetter {
      delete(id: $id)
    }
  }
`;
export type SubdivisionDeleteMutationFn = Apollo.MutationFunction<
  SubdivisionDeleteMutation,
  SubdivisionDeleteMutationVariables
>;

/**
 * __useSubdivisionDeleteMutation__
 *
 * To run a mutation, you first call `useSubdivisionDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubdivisionDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subdivisionDeleteMutation, { data, loading, error }] = useSubdivisionDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubdivisionDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubdivisionDeleteMutation,
    SubdivisionDeleteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubdivisionDeleteMutation,
    SubdivisionDeleteMutationVariables
  >(SubdivisionDeleteDocument, options);
}
export type SubdivisionDeleteMutationHookResult = ReturnType<
  typeof useSubdivisionDeleteMutation
>;
export type SubdivisionDeleteMutationResult =
  Apollo.MutationResult<SubdivisionDeleteMutation>;
export type SubdivisionDeleteMutationOptions = Apollo.BaseMutationOptions<
  SubdivisionDeleteMutation,
  SubdivisionDeleteMutationVariables
>;
export const SetCreateToolsInsuranceDocument = gql`
  mutation setCreateToolsInsurance(
    $ComplianceIndicator: ID
    $TotalIndicator: ID
    $GroupOne: String
    $GroupTwo: String
    $Number: String
    $Name: String
    $NameEn: String
    $NumberList: String
    $NumberDetail: String
  ) {
    ToolsInsuranceSetter {
      create(
        ComplianceIndicator: $ComplianceIndicator
        TotalIndicator: $TotalIndicator
        Number: $Number
        Name: $Name
        NameEn: $NameEn
        GroupOne: $GroupOne
        GroupTwo: $GroupTwo
        NumberList: $NumberList
        NumberDetail: $NumberDetail
      ) {
        id
      }
    }
  }
`;
export type SetCreateToolsInsuranceMutationFn = Apollo.MutationFunction<
  SetCreateToolsInsuranceMutation,
  SetCreateToolsInsuranceMutationVariables
>;

/**
 * __useSetCreateToolsInsuranceMutation__
 *
 * To run a mutation, you first call `useSetCreateToolsInsuranceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCreateToolsInsuranceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCreateToolsInsuranceMutation, { data, loading, error }] = useSetCreateToolsInsuranceMutation({
 *   variables: {
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      TotalIndicator: // value for 'TotalIndicator'
 *      GroupOne: // value for 'GroupOne'
 *      GroupTwo: // value for 'GroupTwo'
 *      Number: // value for 'Number'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *      NumberList: // value for 'NumberList'
 *      NumberDetail: // value for 'NumberDetail'
 *   },
 * });
 */
export function useSetCreateToolsInsuranceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCreateToolsInsuranceMutation,
    SetCreateToolsInsuranceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetCreateToolsInsuranceMutation,
    SetCreateToolsInsuranceMutationVariables
  >(SetCreateToolsInsuranceDocument, options);
}
export type SetCreateToolsInsuranceMutationHookResult = ReturnType<
  typeof useSetCreateToolsInsuranceMutation
>;
export type SetCreateToolsInsuranceMutationResult =
  Apollo.MutationResult<SetCreateToolsInsuranceMutation>;
export type SetCreateToolsInsuranceMutationOptions = Apollo.BaseMutationOptions<
  SetCreateToolsInsuranceMutation,
  SetCreateToolsInsuranceMutationVariables
>;
export const SetChangeToolsInsuranceDocument = gql`
  mutation setChangeToolsInsurance(
    $id: ID
    $ComplianceIndicator: ID
    $TotalIndicator: ID
    $GroupOne: String
    $GroupTwo: String
    $Number: String
    $Name: String
    $NameEn: String
    $NumberList: String
    $NumberDetail: String
  ) {
    ToolsInsuranceSetter {
      change(
        id: $id
        ComplianceIndicator: $ComplianceIndicator
        TotalIndicator: $TotalIndicator
        Number: $Number
        Name: $Name
        NameEn: $NameEn
        GroupOne: $GroupOne
        GroupTwo: $GroupTwo
        NumberList: $NumberList
        NumberDetail: $NumberDetail
      ) {
        id
      }
    }
  }
`;
export type SetChangeToolsInsuranceMutationFn = Apollo.MutationFunction<
  SetChangeToolsInsuranceMutation,
  SetChangeToolsInsuranceMutationVariables
>;

/**
 * __useSetChangeToolsInsuranceMutation__
 *
 * To run a mutation, you first call `useSetChangeToolsInsuranceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetChangeToolsInsuranceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setChangeToolsInsuranceMutation, { data, loading, error }] = useSetChangeToolsInsuranceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      TotalIndicator: // value for 'TotalIndicator'
 *      GroupOne: // value for 'GroupOne'
 *      GroupTwo: // value for 'GroupTwo'
 *      Number: // value for 'Number'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *      NumberList: // value for 'NumberList'
 *      NumberDetail: // value for 'NumberDetail'
 *   },
 * });
 */
export function useSetChangeToolsInsuranceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetChangeToolsInsuranceMutation,
    SetChangeToolsInsuranceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetChangeToolsInsuranceMutation,
    SetChangeToolsInsuranceMutationVariables
  >(SetChangeToolsInsuranceDocument, options);
}
export type SetChangeToolsInsuranceMutationHookResult = ReturnType<
  typeof useSetChangeToolsInsuranceMutation
>;
export type SetChangeToolsInsuranceMutationResult =
  Apollo.MutationResult<SetChangeToolsInsuranceMutation>;
export type SetChangeToolsInsuranceMutationOptions = Apollo.BaseMutationOptions<
  SetChangeToolsInsuranceMutation,
  SetChangeToolsInsuranceMutationVariables
>;
export const SetBlindChangeToolsInsuranceDocument = gql`
  mutation setBlindChangeToolsInsurance(
    $id: ID
    $ComplianceIndicator: ID
    $TotalIndicator: ID
    $GroupOne: String
    $GroupTwo: String
    $Number: String
    $Name: String
    $NameEn: String
    $NumberList: String
    $NumberDetail: String
  ) {
    ToolsInsuranceSetter {
      blindChange(
        id: $id
        ComplianceIndicator: $ComplianceIndicator
        TotalIndicator: $TotalIndicator
        GroupOne: $GroupOne
        GroupTwo: $GroupTwo
        Number: $Number
        Name: $Name
        NameEn: $NameEn
        NumberList: $NumberList
        NumberDetail: $NumberDetail
      ) {
        id
      }
    }
  }
`;
export type SetBlindChangeToolsInsuranceMutationFn = Apollo.MutationFunction<
  SetBlindChangeToolsInsuranceMutation,
  SetBlindChangeToolsInsuranceMutationVariables
>;

/**
 * __useSetBlindChangeToolsInsuranceMutation__
 *
 * To run a mutation, you first call `useSetBlindChangeToolsInsuranceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBlindChangeToolsInsuranceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBlindChangeToolsInsuranceMutation, { data, loading, error }] = useSetBlindChangeToolsInsuranceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      TotalIndicator: // value for 'TotalIndicator'
 *      GroupOne: // value for 'GroupOne'
 *      GroupTwo: // value for 'GroupTwo'
 *      Number: // value for 'Number'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *      NumberList: // value for 'NumberList'
 *      NumberDetail: // value for 'NumberDetail'
 *   },
 * });
 */
export function useSetBlindChangeToolsInsuranceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetBlindChangeToolsInsuranceMutation,
    SetBlindChangeToolsInsuranceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetBlindChangeToolsInsuranceMutation,
    SetBlindChangeToolsInsuranceMutationVariables
  >(SetBlindChangeToolsInsuranceDocument, options);
}
export type SetBlindChangeToolsInsuranceMutationHookResult = ReturnType<
  typeof useSetBlindChangeToolsInsuranceMutation
>;
export type SetBlindChangeToolsInsuranceMutationResult =
  Apollo.MutationResult<SetBlindChangeToolsInsuranceMutation>;
export type SetBlindChangeToolsInsuranceMutationOptions =
  Apollo.BaseMutationOptions<
    SetBlindChangeToolsInsuranceMutation,
    SetBlindChangeToolsInsuranceMutationVariables
  >;
export const SetAddValuesToolsInsuranceDocument = gql`
  mutation setAddValuesToolsInsurance(
    $Compliance: Int
    $Total: Float
    $DealerId: ID
    $UUID: String
  ) {
    ToolsInsuranceSetter {
      addValues(
        UUID: $UUID
        Compliance: $Compliance
        Total: $Total
        DealerId: $DealerId
      )
    }
  }
`;
export type SetAddValuesToolsInsuranceMutationFn = Apollo.MutationFunction<
  SetAddValuesToolsInsuranceMutation,
  SetAddValuesToolsInsuranceMutationVariables
>;

/**
 * __useSetAddValuesToolsInsuranceMutation__
 *
 * To run a mutation, you first call `useSetAddValuesToolsInsuranceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAddValuesToolsInsuranceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAddValuesToolsInsuranceMutation, { data, loading, error }] = useSetAddValuesToolsInsuranceMutation({
 *   variables: {
 *      Compliance: // value for 'Compliance'
 *      Total: // value for 'Total'
 *      DealerId: // value for 'DealerId'
 *      UUID: // value for 'UUID'
 *   },
 * });
 */
export function useSetAddValuesToolsInsuranceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetAddValuesToolsInsuranceMutation,
    SetAddValuesToolsInsuranceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetAddValuesToolsInsuranceMutation,
    SetAddValuesToolsInsuranceMutationVariables
  >(SetAddValuesToolsInsuranceDocument, options);
}
export type SetAddValuesToolsInsuranceMutationHookResult = ReturnType<
  typeof useSetAddValuesToolsInsuranceMutation
>;
export type SetAddValuesToolsInsuranceMutationResult =
  Apollo.MutationResult<SetAddValuesToolsInsuranceMutation>;
export type SetAddValuesToolsInsuranceMutationOptions =
  Apollo.BaseMutationOptions<
    SetAddValuesToolsInsuranceMutation,
    SetAddValuesToolsInsuranceMutationVariables
  >;
export const SetDeleteToolsInsuranceDocument = gql`
  mutation setDeleteToolsInsurance($id: ID) {
    ToolsInsuranceSetter {
      delete(id: $id)
    }
  }
`;
export type SetDeleteToolsInsuranceMutationFn = Apollo.MutationFunction<
  SetDeleteToolsInsuranceMutation,
  SetDeleteToolsInsuranceMutationVariables
>;

/**
 * __useSetDeleteToolsInsuranceMutation__
 *
 * To run a mutation, you first call `useSetDeleteToolsInsuranceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDeleteToolsInsuranceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDeleteToolsInsuranceMutation, { data, loading, error }] = useSetDeleteToolsInsuranceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetDeleteToolsInsuranceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetDeleteToolsInsuranceMutation,
    SetDeleteToolsInsuranceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetDeleteToolsInsuranceMutation,
    SetDeleteToolsInsuranceMutationVariables
  >(SetDeleteToolsInsuranceDocument, options);
}
export type SetDeleteToolsInsuranceMutationHookResult = ReturnType<
  typeof useSetDeleteToolsInsuranceMutation
>;
export type SetDeleteToolsInsuranceMutationResult =
  Apollo.MutationResult<SetDeleteToolsInsuranceMutation>;
export type SetDeleteToolsInsuranceMutationOptions = Apollo.BaseMutationOptions<
  SetDeleteToolsInsuranceMutation,
  SetDeleteToolsInsuranceMutationVariables
>;
export const SetRenameGroupToolsInsuranceDocument = gql`
  mutation setRenameGroupToolsInsurance(
    $groupType: ZdGroupType
    $newGroup: String
    $oldGroup: String
  ) {
    ToolsInsuranceSetter {
      renameGroup(
        groupType: $groupType
        newGroup: $newGroup
        oldGroup: $oldGroup
      )
    }
  }
`;
export type SetRenameGroupToolsInsuranceMutationFn = Apollo.MutationFunction<
  SetRenameGroupToolsInsuranceMutation,
  SetRenameGroupToolsInsuranceMutationVariables
>;

/**
 * __useSetRenameGroupToolsInsuranceMutation__
 *
 * To run a mutation, you first call `useSetRenameGroupToolsInsuranceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRenameGroupToolsInsuranceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRenameGroupToolsInsuranceMutation, { data, loading, error }] = useSetRenameGroupToolsInsuranceMutation({
 *   variables: {
 *      groupType: // value for 'groupType'
 *      newGroup: // value for 'newGroup'
 *      oldGroup: // value for 'oldGroup'
 *   },
 * });
 */
export function useSetRenameGroupToolsInsuranceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetRenameGroupToolsInsuranceMutation,
    SetRenameGroupToolsInsuranceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetRenameGroupToolsInsuranceMutation,
    SetRenameGroupToolsInsuranceMutationVariables
  >(SetRenameGroupToolsInsuranceDocument, options);
}
export type SetRenameGroupToolsInsuranceMutationHookResult = ReturnType<
  typeof useSetRenameGroupToolsInsuranceMutation
>;
export type SetRenameGroupToolsInsuranceMutationResult =
  Apollo.MutationResult<SetRenameGroupToolsInsuranceMutation>;
export type SetRenameGroupToolsInsuranceMutationOptions =
  Apollo.BaseMutationOptions<
    SetRenameGroupToolsInsuranceMutation,
    SetRenameGroupToolsInsuranceMutationVariables
  >;
export const SetCreateToolsMetrologicalDocument = gql`
  mutation setCreateToolsMetrological(
    $ComplianceIndicator: ID
    $TotalIndicator: ID
    $Number: String
    $Name: String
    $NameEn: String
  ) {
    ToolsMetrologicalSetter {
      create(
        ComplianceIndicator: $ComplianceIndicator
        TotalIndicator: $TotalIndicator
        Number: $Number
        Name: $Name
        NameEn: $NameEn
      ) {
        id
      }
    }
  }
`;
export type SetCreateToolsMetrologicalMutationFn = Apollo.MutationFunction<
  SetCreateToolsMetrologicalMutation,
  SetCreateToolsMetrologicalMutationVariables
>;

/**
 * __useSetCreateToolsMetrologicalMutation__
 *
 * To run a mutation, you first call `useSetCreateToolsMetrologicalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCreateToolsMetrologicalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCreateToolsMetrologicalMutation, { data, loading, error }] = useSetCreateToolsMetrologicalMutation({
 *   variables: {
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      TotalIndicator: // value for 'TotalIndicator'
 *      Number: // value for 'Number'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *   },
 * });
 */
export function useSetCreateToolsMetrologicalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCreateToolsMetrologicalMutation,
    SetCreateToolsMetrologicalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetCreateToolsMetrologicalMutation,
    SetCreateToolsMetrologicalMutationVariables
  >(SetCreateToolsMetrologicalDocument, options);
}
export type SetCreateToolsMetrologicalMutationHookResult = ReturnType<
  typeof useSetCreateToolsMetrologicalMutation
>;
export type SetCreateToolsMetrologicalMutationResult =
  Apollo.MutationResult<SetCreateToolsMetrologicalMutation>;
export type SetCreateToolsMetrologicalMutationOptions =
  Apollo.BaseMutationOptions<
    SetCreateToolsMetrologicalMutation,
    SetCreateToolsMetrologicalMutationVariables
  >;
export const SetChangeToolsMetrologicalDocument = gql`
  mutation setChangeToolsMetrological(
    $id: ID
    $ComplianceIndicator: ID
    $TotalIndicator: ID
    $Number: String
    $Name: String
    $NameEn: String
  ) {
    ToolsMetrologicalSetter {
      change(
        id: $id
        ComplianceIndicator: $ComplianceIndicator
        TotalIndicator: $TotalIndicator
        Number: $Number
        Name: $Name
        NameEn: $NameEn
      ) {
        id
      }
    }
  }
`;
export type SetChangeToolsMetrologicalMutationFn = Apollo.MutationFunction<
  SetChangeToolsMetrologicalMutation,
  SetChangeToolsMetrologicalMutationVariables
>;

/**
 * __useSetChangeToolsMetrologicalMutation__
 *
 * To run a mutation, you first call `useSetChangeToolsMetrologicalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetChangeToolsMetrologicalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setChangeToolsMetrologicalMutation, { data, loading, error }] = useSetChangeToolsMetrologicalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      TotalIndicator: // value for 'TotalIndicator'
 *      Number: // value for 'Number'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *   },
 * });
 */
export function useSetChangeToolsMetrologicalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetChangeToolsMetrologicalMutation,
    SetChangeToolsMetrologicalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetChangeToolsMetrologicalMutation,
    SetChangeToolsMetrologicalMutationVariables
  >(SetChangeToolsMetrologicalDocument, options);
}
export type SetChangeToolsMetrologicalMutationHookResult = ReturnType<
  typeof useSetChangeToolsMetrologicalMutation
>;
export type SetChangeToolsMetrologicalMutationResult =
  Apollo.MutationResult<SetChangeToolsMetrologicalMutation>;
export type SetChangeToolsMetrologicalMutationOptions =
  Apollo.BaseMutationOptions<
    SetChangeToolsMetrologicalMutation,
    SetChangeToolsMetrologicalMutationVariables
  >;
export const SetBlindChangeToolsMetrologicalDocument = gql`
  mutation setBlindChangeToolsMetrological(
    $id: ID
    $ComplianceIndicator: ID
    $TotalIndicator: ID
    $Number: String
    $Name: String
    $NameEn: String
  ) {
    ToolsMetrologicalSetter {
      blindChange(
        id: $id
        ComplianceIndicator: $ComplianceIndicator
        TotalIndicator: $TotalIndicator
        Number: $Number
        Name: $Name
        NameEn: $NameEn
      ) {
        id
      }
    }
  }
`;
export type SetBlindChangeToolsMetrologicalMutationFn = Apollo.MutationFunction<
  SetBlindChangeToolsMetrologicalMutation,
  SetBlindChangeToolsMetrologicalMutationVariables
>;

/**
 * __useSetBlindChangeToolsMetrologicalMutation__
 *
 * To run a mutation, you first call `useSetBlindChangeToolsMetrologicalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBlindChangeToolsMetrologicalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBlindChangeToolsMetrologicalMutation, { data, loading, error }] = useSetBlindChangeToolsMetrologicalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      TotalIndicator: // value for 'TotalIndicator'
 *      Number: // value for 'Number'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *   },
 * });
 */
export function useSetBlindChangeToolsMetrologicalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetBlindChangeToolsMetrologicalMutation,
    SetBlindChangeToolsMetrologicalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetBlindChangeToolsMetrologicalMutation,
    SetBlindChangeToolsMetrologicalMutationVariables
  >(SetBlindChangeToolsMetrologicalDocument, options);
}
export type SetBlindChangeToolsMetrologicalMutationHookResult = ReturnType<
  typeof useSetBlindChangeToolsMetrologicalMutation
>;
export type SetBlindChangeToolsMetrologicalMutationResult =
  Apollo.MutationResult<SetBlindChangeToolsMetrologicalMutation>;
export type SetBlindChangeToolsMetrologicalMutationOptions =
  Apollo.BaseMutationOptions<
    SetBlindChangeToolsMetrologicalMutation,
    SetBlindChangeToolsMetrologicalMutationVariables
  >;
export const SetAddValuesToolsMetrologicalDocument = gql`
  mutation setAddValuesToolsMetrological(
    $Compliance: Int
    $Total: Float
    $DealerId: ID
    $UUID: String
  ) {
    ToolsMetrologicalSetter {
      addValues(
        UUID: $UUID
        Compliance: $Compliance
        Total: $Total
        DealerId: $DealerId
      )
    }
  }
`;
export type SetAddValuesToolsMetrologicalMutationFn = Apollo.MutationFunction<
  SetAddValuesToolsMetrologicalMutation,
  SetAddValuesToolsMetrologicalMutationVariables
>;

/**
 * __useSetAddValuesToolsMetrologicalMutation__
 *
 * To run a mutation, you first call `useSetAddValuesToolsMetrologicalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAddValuesToolsMetrologicalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAddValuesToolsMetrologicalMutation, { data, loading, error }] = useSetAddValuesToolsMetrologicalMutation({
 *   variables: {
 *      Compliance: // value for 'Compliance'
 *      Total: // value for 'Total'
 *      DealerId: // value for 'DealerId'
 *      UUID: // value for 'UUID'
 *   },
 * });
 */
export function useSetAddValuesToolsMetrologicalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetAddValuesToolsMetrologicalMutation,
    SetAddValuesToolsMetrologicalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetAddValuesToolsMetrologicalMutation,
    SetAddValuesToolsMetrologicalMutationVariables
  >(SetAddValuesToolsMetrologicalDocument, options);
}
export type SetAddValuesToolsMetrologicalMutationHookResult = ReturnType<
  typeof useSetAddValuesToolsMetrologicalMutation
>;
export type SetAddValuesToolsMetrologicalMutationResult =
  Apollo.MutationResult<SetAddValuesToolsMetrologicalMutation>;
export type SetAddValuesToolsMetrologicalMutationOptions =
  Apollo.BaseMutationOptions<
    SetAddValuesToolsMetrologicalMutation,
    SetAddValuesToolsMetrologicalMutationVariables
  >;
export const SetDeleteToolsMetrologicalDocument = gql`
  mutation setDeleteToolsMetrological($id: ID) {
    ToolsMetrologicalSetter {
      delete(id: $id)
    }
  }
`;
export type SetDeleteToolsMetrologicalMutationFn = Apollo.MutationFunction<
  SetDeleteToolsMetrologicalMutation,
  SetDeleteToolsMetrologicalMutationVariables
>;

/**
 * __useSetDeleteToolsMetrologicalMutation__
 *
 * To run a mutation, you first call `useSetDeleteToolsMetrologicalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDeleteToolsMetrologicalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDeleteToolsMetrologicalMutation, { data, loading, error }] = useSetDeleteToolsMetrologicalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetDeleteToolsMetrologicalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetDeleteToolsMetrologicalMutation,
    SetDeleteToolsMetrologicalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetDeleteToolsMetrologicalMutation,
    SetDeleteToolsMetrologicalMutationVariables
  >(SetDeleteToolsMetrologicalDocument, options);
}
export type SetDeleteToolsMetrologicalMutationHookResult = ReturnType<
  typeof useSetDeleteToolsMetrologicalMutation
>;
export type SetDeleteToolsMetrologicalMutationResult =
  Apollo.MutationResult<SetDeleteToolsMetrologicalMutation>;
export type SetDeleteToolsMetrologicalMutationOptions =
  Apollo.BaseMutationOptions<
    SetDeleteToolsMetrologicalMutation,
    SetDeleteToolsMetrologicalMutationVariables
  >;
export const SetCreateToolsDocument = gql`
  mutation setCreateTools(
    $ComplianceIndicator: ID
    $TotalIndicator: ID
    $ModelIndicator: ID
    $CountryIndicator: ID
    $YearIndicator: ID
    $NoteIndicator: ID
    $GroupOne: String
    $GroupTwo: String
    $Number: String
    $Name: String
    $NameEn: String
  ) {
    ToolsSetter {
      create(
        ComplianceIndicator: $ComplianceIndicator
        TotalIndicator: $TotalIndicator
        ModelIndicator: $ModelIndicator
        CountryIndicator: $CountryIndicator
        YearIndicator: $YearIndicator
        NoteIndicator: $NoteIndicator
        GroupOne: $GroupOne
        GroupTwo: $GroupTwo
        Number: $Number
        Name: $Name
        NameEn: $NameEn
      ) {
        id
      }
    }
  }
`;
export type SetCreateToolsMutationFn = Apollo.MutationFunction<
  SetCreateToolsMutation,
  SetCreateToolsMutationVariables
>;

/**
 * __useSetCreateToolsMutation__
 *
 * To run a mutation, you first call `useSetCreateToolsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCreateToolsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCreateToolsMutation, { data, loading, error }] = useSetCreateToolsMutation({
 *   variables: {
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      TotalIndicator: // value for 'TotalIndicator'
 *      ModelIndicator: // value for 'ModelIndicator'
 *      CountryIndicator: // value for 'CountryIndicator'
 *      YearIndicator: // value for 'YearIndicator'
 *      NoteIndicator: // value for 'NoteIndicator'
 *      GroupOne: // value for 'GroupOne'
 *      GroupTwo: // value for 'GroupTwo'
 *      Number: // value for 'Number'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *   },
 * });
 */
export function useSetCreateToolsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCreateToolsMutation,
    SetCreateToolsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetCreateToolsMutation,
    SetCreateToolsMutationVariables
  >(SetCreateToolsDocument, options);
}
export type SetCreateToolsMutationHookResult = ReturnType<
  typeof useSetCreateToolsMutation
>;
export type SetCreateToolsMutationResult =
  Apollo.MutationResult<SetCreateToolsMutation>;
export type SetCreateToolsMutationOptions = Apollo.BaseMutationOptions<
  SetCreateToolsMutation,
  SetCreateToolsMutationVariables
>;
export const SetChangeToolsDocument = gql`
  mutation setChangeTools(
    $id: ID
    $ComplianceIndicator: ID
    $TotalIndicator: ID
    $ModelIndicator: ID
    $CountryIndicator: ID
    $YearIndicator: ID
    $NoteIndicator: ID
    $GroupOne: String
    $GroupTwo: String
    $Number: String
    $Name: String
    $NameEn: String
  ) {
    ToolsSetter {
      change(
        id: $id
        ComplianceIndicator: $ComplianceIndicator
        TotalIndicator: $TotalIndicator
        ModelIndicator: $ModelIndicator
        CountryIndicator: $CountryIndicator
        YearIndicator: $YearIndicator
        NoteIndicator: $NoteIndicator
        GroupOne: $GroupOne
        GroupTwo: $GroupTwo
        Number: $Number
        Name: $Name
        NameEn: $NameEn
      ) {
        id
      }
    }
  }
`;
export type SetChangeToolsMutationFn = Apollo.MutationFunction<
  SetChangeToolsMutation,
  SetChangeToolsMutationVariables
>;

/**
 * __useSetChangeToolsMutation__
 *
 * To run a mutation, you first call `useSetChangeToolsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetChangeToolsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setChangeToolsMutation, { data, loading, error }] = useSetChangeToolsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      TotalIndicator: // value for 'TotalIndicator'
 *      ModelIndicator: // value for 'ModelIndicator'
 *      CountryIndicator: // value for 'CountryIndicator'
 *      YearIndicator: // value for 'YearIndicator'
 *      NoteIndicator: // value for 'NoteIndicator'
 *      GroupOne: // value for 'GroupOne'
 *      GroupTwo: // value for 'GroupTwo'
 *      Number: // value for 'Number'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *   },
 * });
 */
export function useSetChangeToolsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetChangeToolsMutation,
    SetChangeToolsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetChangeToolsMutation,
    SetChangeToolsMutationVariables
  >(SetChangeToolsDocument, options);
}
export type SetChangeToolsMutationHookResult = ReturnType<
  typeof useSetChangeToolsMutation
>;
export type SetChangeToolsMutationResult =
  Apollo.MutationResult<SetChangeToolsMutation>;
export type SetChangeToolsMutationOptions = Apollo.BaseMutationOptions<
  SetChangeToolsMutation,
  SetChangeToolsMutationVariables
>;
export const SetBlindChangeToolsDocument = gql`
  mutation setBlindChangeTools(
    $id: ID
    $ComplianceIndicator: ID
    $TotalIndicator: ID
    $ModelIndicator: ID
    $CountryIndicator: ID
    $YearIndicator: ID
    $NoteIndicator: ID
    $GroupOne: String
    $GroupTwo: String
    $Number: String
    $Name: String
    $NameEn: String
  ) {
    ToolsSetter {
      blindChange(
        id: $id
        ComplianceIndicator: $ComplianceIndicator
        TotalIndicator: $TotalIndicator
        ModelIndicator: $ModelIndicator
        CountryIndicator: $CountryIndicator
        YearIndicator: $YearIndicator
        NoteIndicator: $NoteIndicator
        GroupOne: $GroupOne
        GroupTwo: $GroupTwo
        Number: $Number
        Name: $Name
        NameEn: $NameEn
      ) {
        id
      }
    }
  }
`;
export type SetBlindChangeToolsMutationFn = Apollo.MutationFunction<
  SetBlindChangeToolsMutation,
  SetBlindChangeToolsMutationVariables
>;

/**
 * __useSetBlindChangeToolsMutation__
 *
 * To run a mutation, you first call `useSetBlindChangeToolsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBlindChangeToolsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBlindChangeToolsMutation, { data, loading, error }] = useSetBlindChangeToolsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      TotalIndicator: // value for 'TotalIndicator'
 *      ModelIndicator: // value for 'ModelIndicator'
 *      CountryIndicator: // value for 'CountryIndicator'
 *      YearIndicator: // value for 'YearIndicator'
 *      NoteIndicator: // value for 'NoteIndicator'
 *      GroupOne: // value for 'GroupOne'
 *      GroupTwo: // value for 'GroupTwo'
 *      Number: // value for 'Number'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *   },
 * });
 */
export function useSetBlindChangeToolsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetBlindChangeToolsMutation,
    SetBlindChangeToolsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetBlindChangeToolsMutation,
    SetBlindChangeToolsMutationVariables
  >(SetBlindChangeToolsDocument, options);
}
export type SetBlindChangeToolsMutationHookResult = ReturnType<
  typeof useSetBlindChangeToolsMutation
>;
export type SetBlindChangeToolsMutationResult =
  Apollo.MutationResult<SetBlindChangeToolsMutation>;
export type SetBlindChangeToolsMutationOptions = Apollo.BaseMutationOptions<
  SetBlindChangeToolsMutation,
  SetBlindChangeToolsMutationVariables
>;
export const SetAddValuesToolsDocument = gql`
  mutation setAddValuesTools(
    $Compliance: Int
    $Model: String
    $Country: String
    $Note: String
    $Total: Float
    $Year: Int
    $DealerId: ID
    $UUID: String
  ) {
    ToolsSetter {
      addValues(
        UUID: $UUID
        Compliance: $Compliance
        Model: $Model
        Country: $Country
        Note: $Note
        Total: $Total
        Year: $Year
        DealerId: $DealerId
      )
    }
  }
`;
export type SetAddValuesToolsMutationFn = Apollo.MutationFunction<
  SetAddValuesToolsMutation,
  SetAddValuesToolsMutationVariables
>;

/**
 * __useSetAddValuesToolsMutation__
 *
 * To run a mutation, you first call `useSetAddValuesToolsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAddValuesToolsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAddValuesToolsMutation, { data, loading, error }] = useSetAddValuesToolsMutation({
 *   variables: {
 *      Compliance: // value for 'Compliance'
 *      Model: // value for 'Model'
 *      Country: // value for 'Country'
 *      Note: // value for 'Note'
 *      Total: // value for 'Total'
 *      Year: // value for 'Year'
 *      DealerId: // value for 'DealerId'
 *      UUID: // value for 'UUID'
 *   },
 * });
 */
export function useSetAddValuesToolsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetAddValuesToolsMutation,
    SetAddValuesToolsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetAddValuesToolsMutation,
    SetAddValuesToolsMutationVariables
  >(SetAddValuesToolsDocument, options);
}
export type SetAddValuesToolsMutationHookResult = ReturnType<
  typeof useSetAddValuesToolsMutation
>;
export type SetAddValuesToolsMutationResult =
  Apollo.MutationResult<SetAddValuesToolsMutation>;
export type SetAddValuesToolsMutationOptions = Apollo.BaseMutationOptions<
  SetAddValuesToolsMutation,
  SetAddValuesToolsMutationVariables
>;
export const SetDeleteToolsDocument = gql`
  mutation setDeleteTools($id: ID) {
    ToolsSetter {
      delete(id: $id)
    }
  }
`;
export type SetDeleteToolsMutationFn = Apollo.MutationFunction<
  SetDeleteToolsMutation,
  SetDeleteToolsMutationVariables
>;

/**
 * __useSetDeleteToolsMutation__
 *
 * To run a mutation, you first call `useSetDeleteToolsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDeleteToolsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDeleteToolsMutation, { data, loading, error }] = useSetDeleteToolsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetDeleteToolsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetDeleteToolsMutation,
    SetDeleteToolsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetDeleteToolsMutation,
    SetDeleteToolsMutationVariables
  >(SetDeleteToolsDocument, options);
}
export type SetDeleteToolsMutationHookResult = ReturnType<
  typeof useSetDeleteToolsMutation
>;
export type SetDeleteToolsMutationResult =
  Apollo.MutationResult<SetDeleteToolsMutation>;
export type SetDeleteToolsMutationOptions = Apollo.BaseMutationOptions<
  SetDeleteToolsMutation,
  SetDeleteToolsMutationVariables
>;
export const SetDuplicateToolsDocument = gql`
  mutation setDuplicateTools($uuid: String) {
    ToolsSetter {
      duplicate(uuid: $uuid) {
        id
      }
    }
  }
`;
export type SetDuplicateToolsMutationFn = Apollo.MutationFunction<
  SetDuplicateToolsMutation,
  SetDuplicateToolsMutationVariables
>;

/**
 * __useSetDuplicateToolsMutation__
 *
 * To run a mutation, you first call `useSetDuplicateToolsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDuplicateToolsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDuplicateToolsMutation, { data, loading, error }] = useSetDuplicateToolsMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useSetDuplicateToolsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetDuplicateToolsMutation,
    SetDuplicateToolsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetDuplicateToolsMutation,
    SetDuplicateToolsMutationVariables
  >(SetDuplicateToolsDocument, options);
}
export type SetDuplicateToolsMutationHookResult = ReturnType<
  typeof useSetDuplicateToolsMutation
>;
export type SetDuplicateToolsMutationResult =
  Apollo.MutationResult<SetDuplicateToolsMutation>;
export type SetDuplicateToolsMutationOptions = Apollo.BaseMutationOptions<
  SetDuplicateToolsMutation,
  SetDuplicateToolsMutationVariables
>;
export const SetRenameGroupToolsDocument = gql`
  mutation setRenameGroupTools(
    $groupType: ZdGroupType
    $newGroup: String
    $oldGroup: String
  ) {
    ToolsSetter {
      renameGroup(
        groupType: $groupType
        newGroup: $newGroup
        oldGroup: $oldGroup
      )
    }
  }
`;
export type SetRenameGroupToolsMutationFn = Apollo.MutationFunction<
  SetRenameGroupToolsMutation,
  SetRenameGroupToolsMutationVariables
>;

/**
 * __useSetRenameGroupToolsMutation__
 *
 * To run a mutation, you first call `useSetRenameGroupToolsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRenameGroupToolsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRenameGroupToolsMutation, { data, loading, error }] = useSetRenameGroupToolsMutation({
 *   variables: {
 *      groupType: // value for 'groupType'
 *      newGroup: // value for 'newGroup'
 *      oldGroup: // value for 'oldGroup'
 *   },
 * });
 */
export function useSetRenameGroupToolsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetRenameGroupToolsMutation,
    SetRenameGroupToolsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetRenameGroupToolsMutation,
    SetRenameGroupToolsMutationVariables
  >(SetRenameGroupToolsDocument, options);
}
export type SetRenameGroupToolsMutationHookResult = ReturnType<
  typeof useSetRenameGroupToolsMutation
>;
export type SetRenameGroupToolsMutationResult =
  Apollo.MutationResult<SetRenameGroupToolsMutation>;
export type SetRenameGroupToolsMutationOptions = Apollo.BaseMutationOptions<
  SetRenameGroupToolsMutation,
  SetRenameGroupToolsMutationVariables
>;
export const SetSortDocument = gql`
  mutation setSort($sort: Int, $UUID: String!) {
    ToolsSetter {
      setSort(sort: $sort, UUID: $UUID)
    }
  }
`;
export type SetSortMutationFn = Apollo.MutationFunction<
  SetSortMutation,
  SetSortMutationVariables
>;

/**
 * __useSetSortMutation__
 *
 * To run a mutation, you first call `useSetSortMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSortMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSortMutation, { data, loading, error }] = useSetSortMutation({
 *   variables: {
 *      sort: // value for 'sort'
 *      UUID: // value for 'UUID'
 *   },
 * });
 */
export function useSetSortMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetSortMutation,
    SetSortMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetSortMutation, SetSortMutationVariables>(
    SetSortDocument,
    options,
  );
}
export type SetSortMutationHookResult = ReturnType<typeof useSetSortMutation>;
export type SetSortMutationResult = Apollo.MutationResult<SetSortMutation>;
export type SetSortMutationOptions = Apollo.BaseMutationOptions<
  SetSortMutation,
  SetSortMutationVariables
>;
export const SetSortGroupDocument = gql`
  mutation setSortGroup($sort: Int, $group: String!) {
    ToolsSetter {
      setSortGroup(sort: $sort, group: $group)
    }
  }
`;
export type SetSortGroupMutationFn = Apollo.MutationFunction<
  SetSortGroupMutation,
  SetSortGroupMutationVariables
>;

/**
 * __useSetSortGroupMutation__
 *
 * To run a mutation, you first call `useSetSortGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSortGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSortGroupMutation, { data, loading, error }] = useSetSortGroupMutation({
 *   variables: {
 *      sort: // value for 'sort'
 *      group: // value for 'group'
 *   },
 * });
 */
export function useSetSortGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetSortGroupMutation,
    SetSortGroupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetSortGroupMutation,
    SetSortGroupMutationVariables
  >(SetSortGroupDocument, options);
}
export type SetSortGroupMutationHookResult = ReturnType<
  typeof useSetSortGroupMutation
>;
export type SetSortGroupMutationResult =
  Apollo.MutationResult<SetSortGroupMutation>;
export type SetSortGroupMutationOptions = Apollo.BaseMutationOptions<
  SetSortGroupMutation,
  SetSortGroupMutationVariables
>;
export const SetCreateTradePremisesDocument = gql`
  mutation setCreateTradePremises(
    $Name: String
    $NameEn: String
    $forUUID: String
    $isList: Boolean
    $ComplianceIndicator: ID
    $Number: String
    $GroupOne: String
    $AreaIndicator: ID
    $AddressIndicator: ID
  ) {
    TradePremisesSetter {
      create(
        ComplianceIndicator: $ComplianceIndicator
        isList: $isList
        Number: $Number
        Name: $Name
        NameEn: $NameEn
        forUUID: $forUUID
        GroupOne: $GroupOne
        AreaIndicator: $AreaIndicator
        AddressIndicator: $AddressIndicator
      ) {
        id
      }
    }
  }
`;
export type SetCreateTradePremisesMutationFn = Apollo.MutationFunction<
  SetCreateTradePremisesMutation,
  SetCreateTradePremisesMutationVariables
>;

/**
 * __useSetCreateTradePremisesMutation__
 *
 * To run a mutation, you first call `useSetCreateTradePremisesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCreateTradePremisesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCreateTradePremisesMutation, { data, loading, error }] = useSetCreateTradePremisesMutation({
 *   variables: {
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *      forUUID: // value for 'forUUID'
 *      isList: // value for 'isList'
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      Number: // value for 'Number'
 *      GroupOne: // value for 'GroupOne'
 *      AreaIndicator: // value for 'AreaIndicator'
 *      AddressIndicator: // value for 'AddressIndicator'
 *   },
 * });
 */
export function useSetCreateTradePremisesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCreateTradePremisesMutation,
    SetCreateTradePremisesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetCreateTradePremisesMutation,
    SetCreateTradePremisesMutationVariables
  >(SetCreateTradePremisesDocument, options);
}
export type SetCreateTradePremisesMutationHookResult = ReturnType<
  typeof useSetCreateTradePremisesMutation
>;
export type SetCreateTradePremisesMutationResult =
  Apollo.MutationResult<SetCreateTradePremisesMutation>;
export type SetCreateTradePremisesMutationOptions = Apollo.BaseMutationOptions<
  SetCreateTradePremisesMutation,
  SetCreateTradePremisesMutationVariables
>;
export const SetChangeTradePremisesDocument = gql`
  mutation setChangeTradePremises(
    $id: ID
    $Name: String
    $NameEn: String
    $forUUID: String
    $isList: Boolean
    $ComplianceIndicator: ID
    $Number: String
    $GroupOne: String
    $AreaIndicator: ID
    $AddressIndicator: ID
  ) {
    TradePremisesSetter {
      change(
        id: $id
        ComplianceIndicator: $ComplianceIndicator
        isList: $isList
        Number: $Number
        Name: $Name
        NameEn: $NameEn
        forUUID: $forUUID
        GroupOne: $GroupOne
        AreaIndicator: $AreaIndicator
        AddressIndicator: $AddressIndicator
      ) {
        id
      }
    }
  }
`;
export type SetChangeTradePremisesMutationFn = Apollo.MutationFunction<
  SetChangeTradePremisesMutation,
  SetChangeTradePremisesMutationVariables
>;

/**
 * __useSetChangeTradePremisesMutation__
 *
 * To run a mutation, you first call `useSetChangeTradePremisesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetChangeTradePremisesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setChangeTradePremisesMutation, { data, loading, error }] = useSetChangeTradePremisesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *      forUUID: // value for 'forUUID'
 *      isList: // value for 'isList'
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      Number: // value for 'Number'
 *      GroupOne: // value for 'GroupOne'
 *      AreaIndicator: // value for 'AreaIndicator'
 *      AddressIndicator: // value for 'AddressIndicator'
 *   },
 * });
 */
export function useSetChangeTradePremisesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetChangeTradePremisesMutation,
    SetChangeTradePremisesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetChangeTradePremisesMutation,
    SetChangeTradePremisesMutationVariables
  >(SetChangeTradePremisesDocument, options);
}
export type SetChangeTradePremisesMutationHookResult = ReturnType<
  typeof useSetChangeTradePremisesMutation
>;
export type SetChangeTradePremisesMutationResult =
  Apollo.MutationResult<SetChangeTradePremisesMutation>;
export type SetChangeTradePremisesMutationOptions = Apollo.BaseMutationOptions<
  SetChangeTradePremisesMutation,
  SetChangeTradePremisesMutationVariables
>;
export const SetBlindChangeTradePremisesDocument = gql`
  mutation setBlindChangeTradePremises(
    $id: ID
    $Name: String
    $NameEn: String
    $forUUID: String
    $isList: Boolean
    $ComplianceIndicator: ID
    $Number: String
    $GroupOne: String
    $AreaIndicator: ID
    $AddressIndicator: ID
  ) {
    TradePremisesSetter {
      blindChange(
        id: $id
        Name: $Name
        NameEn: $NameEn
        forUUID: $forUUID
        isList: $isList
        ComplianceIndicator: $ComplianceIndicator
        Number: $Number
        GroupOne: $GroupOne
        AreaIndicator: $AreaIndicator
        AddressIndicator: $AddressIndicator
      ) {
        id
      }
    }
  }
`;
export type SetBlindChangeTradePremisesMutationFn = Apollo.MutationFunction<
  SetBlindChangeTradePremisesMutation,
  SetBlindChangeTradePremisesMutationVariables
>;

/**
 * __useSetBlindChangeTradePremisesMutation__
 *
 * To run a mutation, you first call `useSetBlindChangeTradePremisesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBlindChangeTradePremisesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBlindChangeTradePremisesMutation, { data, loading, error }] = useSetBlindChangeTradePremisesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *      forUUID: // value for 'forUUID'
 *      isList: // value for 'isList'
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      Number: // value for 'Number'
 *      GroupOne: // value for 'GroupOne'
 *      AreaIndicator: // value for 'AreaIndicator'
 *      AddressIndicator: // value for 'AddressIndicator'
 *   },
 * });
 */
export function useSetBlindChangeTradePremisesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetBlindChangeTradePremisesMutation,
    SetBlindChangeTradePremisesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetBlindChangeTradePremisesMutation,
    SetBlindChangeTradePremisesMutationVariables
  >(SetBlindChangeTradePremisesDocument, options);
}
export type SetBlindChangeTradePremisesMutationHookResult = ReturnType<
  typeof useSetBlindChangeTradePremisesMutation
>;
export type SetBlindChangeTradePremisesMutationResult =
  Apollo.MutationResult<SetBlindChangeTradePremisesMutation>;
export type SetBlindChangeTradePremisesMutationOptions =
  Apollo.BaseMutationOptions<
    SetBlindChangeTradePremisesMutation,
    SetBlindChangeTradePremisesMutationVariables
  >;
export const SetAddValuesTradePremisesDocument = gql`
  mutation setAddValuesTradePremises(
    $Compliance: Int
    $Area: Float
    $Address: String
    $DealerId: ID
    $UUID: String
  ) {
    TradePremisesSetter {
      addValues(
        UUID: $UUID
        Compliance: $Compliance
        Address: $Address
        Area: $Area
        DealerId: $DealerId
      )
    }
  }
`;
export type SetAddValuesTradePremisesMutationFn = Apollo.MutationFunction<
  SetAddValuesTradePremisesMutation,
  SetAddValuesTradePremisesMutationVariables
>;

/**
 * __useSetAddValuesTradePremisesMutation__
 *
 * To run a mutation, you first call `useSetAddValuesTradePremisesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAddValuesTradePremisesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAddValuesTradePremisesMutation, { data, loading, error }] = useSetAddValuesTradePremisesMutation({
 *   variables: {
 *      Compliance: // value for 'Compliance'
 *      Area: // value for 'Area'
 *      Address: // value for 'Address'
 *      DealerId: // value for 'DealerId'
 *      UUID: // value for 'UUID'
 *   },
 * });
 */
export function useSetAddValuesTradePremisesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetAddValuesTradePremisesMutation,
    SetAddValuesTradePremisesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetAddValuesTradePremisesMutation,
    SetAddValuesTradePremisesMutationVariables
  >(SetAddValuesTradePremisesDocument, options);
}
export type SetAddValuesTradePremisesMutationHookResult = ReturnType<
  typeof useSetAddValuesTradePremisesMutation
>;
export type SetAddValuesTradePremisesMutationResult =
  Apollo.MutationResult<SetAddValuesTradePremisesMutation>;
export type SetAddValuesTradePremisesMutationOptions =
  Apollo.BaseMutationOptions<
    SetAddValuesTradePremisesMutation,
    SetAddValuesTradePremisesMutationVariables
  >;
export const SetDeleteTradePremisesDocument = gql`
  mutation setDeleteTradePremises($id: ID) {
    TradePremisesSetter {
      delete(id: $id)
    }
  }
`;
export type SetDeleteTradePremisesMutationFn = Apollo.MutationFunction<
  SetDeleteTradePremisesMutation,
  SetDeleteTradePremisesMutationVariables
>;

/**
 * __useSetDeleteTradePremisesMutation__
 *
 * To run a mutation, you first call `useSetDeleteTradePremisesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDeleteTradePremisesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDeleteTradePremisesMutation, { data, loading, error }] = useSetDeleteTradePremisesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetDeleteTradePremisesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetDeleteTradePremisesMutation,
    SetDeleteTradePremisesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetDeleteTradePremisesMutation,
    SetDeleteTradePremisesMutationVariables
  >(SetDeleteTradePremisesDocument, options);
}
export type SetDeleteTradePremisesMutationHookResult = ReturnType<
  typeof useSetDeleteTradePremisesMutation
>;
export type SetDeleteTradePremisesMutationResult =
  Apollo.MutationResult<SetDeleteTradePremisesMutation>;
export type SetDeleteTradePremisesMutationOptions = Apollo.BaseMutationOptions<
  SetDeleteTradePremisesMutation,
  SetDeleteTradePremisesMutationVariables
>;
export const UpdateTrustedPersonDocument = gql`
  mutation UpdateTrustedPerson(
    $updateTrustedPersonId: ID!
    $powerOfAttorney: String
    $fio: String
    $shortFio: String
    $descriptionContract: String
    $date: Date
    $endDate: Date
    $active: Boolean
  ) {
    TrustedPersonSetter {
      updateTrustedPerson(
        id: $updateTrustedPersonId
        powerOfAttorney: $powerOfAttorney
        fio: $fio
        shortFio: $shortFio
        descriptionContract: $descriptionContract
        date: $date
        endDate: $endDate
        active: $active
      ) {
        id
        powerOfAttorney
        fio
        shortFio
        descriptionContract
        date
        endDate
        active
      }
    }
  }
`;
export type UpdateTrustedPersonMutationFn = Apollo.MutationFunction<
  UpdateTrustedPersonMutation,
  UpdateTrustedPersonMutationVariables
>;

/**
 * __useUpdateTrustedPersonMutation__
 *
 * To run a mutation, you first call `useUpdateTrustedPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrustedPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrustedPersonMutation, { data, loading, error }] = useUpdateTrustedPersonMutation({
 *   variables: {
 *      updateTrustedPersonId: // value for 'updateTrustedPersonId'
 *      powerOfAttorney: // value for 'powerOfAttorney'
 *      fio: // value for 'fio'
 *      shortFio: // value for 'shortFio'
 *      descriptionContract: // value for 'descriptionContract'
 *      date: // value for 'date'
 *      endDate: // value for 'endDate'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useUpdateTrustedPersonMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTrustedPersonMutation,
    UpdateTrustedPersonMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateTrustedPersonMutation,
    UpdateTrustedPersonMutationVariables
  >(UpdateTrustedPersonDocument, options);
}
export type UpdateTrustedPersonMutationHookResult = ReturnType<
  typeof useUpdateTrustedPersonMutation
>;
export type UpdateTrustedPersonMutationResult =
  Apollo.MutationResult<UpdateTrustedPersonMutation>;
export type UpdateTrustedPersonMutationOptions = Apollo.BaseMutationOptions<
  UpdateTrustedPersonMutation,
  UpdateTrustedPersonMutationVariables
>;
export const CreateTrustedPersonDocument = gql`
  mutation CreateTrustedPerson(
    $powerOfAttorney: String!
    $fio: String!
    $shortFio: String!
    $descriptionContract: String!
    $date: Date!
    $endDate: Date!
    $active: Boolean!
  ) {
    TrustedPersonSetter {
      createTrustedPerson(
        powerOfAttorney: $powerOfAttorney
        fio: $fio
        shortFio: $shortFio
        descriptionContract: $descriptionContract
        date: $date
        endDate: $endDate
        active: $active
      ) {
        id
        powerOfAttorney
        fio
        shortFio
        descriptionContract
        date
        endDate
        active
      }
    }
  }
`;
export type CreateTrustedPersonMutationFn = Apollo.MutationFunction<
  CreateTrustedPersonMutation,
  CreateTrustedPersonMutationVariables
>;

/**
 * __useCreateTrustedPersonMutation__
 *
 * To run a mutation, you first call `useCreateTrustedPersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrustedPersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrustedPersonMutation, { data, loading, error }] = useCreateTrustedPersonMutation({
 *   variables: {
 *      powerOfAttorney: // value for 'powerOfAttorney'
 *      fio: // value for 'fio'
 *      shortFio: // value for 'shortFio'
 *      descriptionContract: // value for 'descriptionContract'
 *      date: // value for 'date'
 *      endDate: // value for 'endDate'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useCreateTrustedPersonMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTrustedPersonMutation,
    CreateTrustedPersonMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateTrustedPersonMutation,
    CreateTrustedPersonMutationVariables
  >(CreateTrustedPersonDocument, options);
}
export type CreateTrustedPersonMutationHookResult = ReturnType<
  typeof useCreateTrustedPersonMutation
>;
export type CreateTrustedPersonMutationResult =
  Apollo.MutationResult<CreateTrustedPersonMutation>;
export type CreateTrustedPersonMutationOptions = Apollo.BaseMutationOptions<
  CreateTrustedPersonMutation,
  CreateTrustedPersonMutationVariables
>;
export const SetGuideFileDocument = gql`
  mutation SetGuideFile($AdminFileId: ID, $UserFileId: ID) {
    UserGuideSetter {
      setGuideFile(AdminFileId: $AdminFileId, UserFileId: $UserFileId) {
        AdminFileId
        UserFileId
      }
    }
  }
`;
export type SetGuideFileMutationFn = Apollo.MutationFunction<
  SetGuideFileMutation,
  SetGuideFileMutationVariables
>;

/**
 * __useSetGuideFileMutation__
 *
 * To run a mutation, you first call `useSetGuideFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGuideFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGuideFileMutation, { data, loading, error }] = useSetGuideFileMutation({
 *   variables: {
 *      AdminFileId: // value for 'AdminFileId'
 *      UserFileId: // value for 'UserFileId'
 *   },
 * });
 */
export function useSetGuideFileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetGuideFileMutation,
    SetGuideFileMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetGuideFileMutation,
    SetGuideFileMutationVariables
  >(SetGuideFileDocument, options);
}
export type SetGuideFileMutationHookResult = ReturnType<
  typeof useSetGuideFileMutation
>;
export type SetGuideFileMutationResult =
  Apollo.MutationResult<SetGuideFileMutation>;
export type SetGuideFileMutationOptions = Apollo.BaseMutationOptions<
  SetGuideFileMutation,
  SetGuideFileMutationVariables
>;
export const ChangeUserDocument = gql`
  mutation changeUser(
    $id: ID!
    $role: String!
    $login: String!
    $fullname: String!
    $email: String!
    $position: String
    $phone: String
    $isEmployeeAccess: Boolean
    $isViolationAccess: Boolean
    $isAnnouncementsAccess: Boolean
    $isTemporaryAccessToAllDealers: Boolean
    $isZdAccess: Boolean
    $isAnnouncementsSend: Boolean
    $isAccountingAccess: Boolean
    $isDocumentsAccess: Boolean
    $isCameraAccess: Boolean
    $isCandidateAccess: Boolean
    $isTrustedPersonAccess: Boolean
    $SubdivisionId: ID
    $ivideonAccess: Boolean
    $dnmAccess: Boolean
  ) {
    UserSetter {
      changeUser(
        id: $id
        role: $role
        login: $login
        fullname: $fullname
        email: $email
        position: $position
        phone: $phone
        isEmployeeAccess: $isEmployeeAccess
        isViolationAccess: $isViolationAccess
        isAnnouncementsAccess: $isAnnouncementsAccess
        isTemporaryAccessToAllDealers: $isTemporaryAccessToAllDealers
        isAccountingAccess: $isAccountingAccess
        isDocumentsAccess: $isDocumentsAccess
        isCameraAccess: $isCameraAccess
        isCandidateAccess: $isCandidateAccess
        isTrustedPersonAccess: $isTrustedPersonAccess
        isZdAccess: $isZdAccess
        isAnnouncementsSend: $isAnnouncementsSend
        SubdivisionId: $SubdivisionId
        ivideon_access: $ivideonAccess
        dnm_access: $dnmAccess
      ) {
        ... on Profile {
          ...fragmentProfile
        }
      }
    }
  }
  ${FragmentProfileFragmentDoc}
`;
export type ChangeUserMutationFn = Apollo.MutationFunction<
  ChangeUserMutation,
  ChangeUserMutationVariables
>;

/**
 * __useChangeUserMutation__
 *
 * To run a mutation, you first call `useChangeUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeUserMutation, { data, loading, error }] = useChangeUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      role: // value for 'role'
 *      login: // value for 'login'
 *      fullname: // value for 'fullname'
 *      email: // value for 'email'
 *      position: // value for 'position'
 *      phone: // value for 'phone'
 *      isEmployeeAccess: // value for 'isEmployeeAccess'
 *      isViolationAccess: // value for 'isViolationAccess'
 *      isAnnouncementsAccess: // value for 'isAnnouncementsAccess'
 *      isTemporaryAccessToAllDealers: // value for 'isTemporaryAccessToAllDealers'
 *      isZdAccess: // value for 'isZdAccess'
 *      isAnnouncementsSend: // value for 'isAnnouncementsSend'
 *      isAccountingAccess: // value for 'isAccountingAccess'
 *      isDocumentsAccess: // value for 'isDocumentsAccess'
 *      isCameraAccess: // value for 'isCameraAccess'
 *      isCandidateAccess: // value for 'isCandidateAccess'
 *      isTrustedPersonAccess: // value for 'isTrustedPersonAccess'
 *      SubdivisionId: // value for 'SubdivisionId'
 *      ivideonAccess: // value for 'ivideonAccess'
 *      dnmAccess: // value for 'dnmAccess'
 *   },
 * });
 */
export function useChangeUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeUserMutation,
    ChangeUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ChangeUserMutation, ChangeUserMutationVariables>(
    ChangeUserDocument,
    options,
  );
}
export type ChangeUserMutationHookResult = ReturnType<
  typeof useChangeUserMutation
>;
export type ChangeUserMutationResult =
  Apollo.MutationResult<ChangeUserMutation>;
export type ChangeUserMutationOptions = Apollo.BaseMutationOptions<
  ChangeUserMutation,
  ChangeUserMutationVariables
>;
export const DeleteUserDocument = gql`
  mutation deleteUser($id: ID!) {
    UserSetter {
      deleteUser(id: $id)
    }
  }
`;
export type DeleteUserMutationFn = Apollo.MutationFunction<
  DeleteUserMutation,
  DeleteUserMutationVariables
>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteUserMutation,
    DeleteUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(
    DeleteUserDocument,
    options,
  );
}
export type DeleteUserMutationHookResult = ReturnType<
  typeof useDeleteUserMutation
>;
export type DeleteUserMutationResult =
  Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<
  DeleteUserMutation,
  DeleteUserMutationVariables
>;
export const RestoreUserDocument = gql`
  mutation restoreUser($id: ID!) {
    UserSetter {
      restoreUser(id: $id)
    }
  }
`;
export type RestoreUserMutationFn = Apollo.MutationFunction<
  RestoreUserMutation,
  RestoreUserMutationVariables
>;

/**
 * __useRestoreUserMutation__
 *
 * To run a mutation, you first call `useRestoreUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreUserMutation, { data, loading, error }] = useRestoreUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RestoreUserMutation,
    RestoreUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RestoreUserMutation, RestoreUserMutationVariables>(
    RestoreUserDocument,
    options,
  );
}
export type RestoreUserMutationHookResult = ReturnType<
  typeof useRestoreUserMutation
>;
export type RestoreUserMutationResult =
  Apollo.MutationResult<RestoreUserMutation>;
export type RestoreUserMutationOptions = Apollo.BaseMutationOptions<
  RestoreUserMutation,
  RestoreUserMutationVariables
>;
export const ImportUserDocument = gql`
  mutation importUser {
    UserSetter {
      importUser
    }
  }
`;
export type ImportUserMutationFn = Apollo.MutationFunction<
  ImportUserMutation,
  ImportUserMutationVariables
>;

/**
 * __useImportUserMutation__
 *
 * To run a mutation, you first call `useImportUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importUserMutation, { data, loading, error }] = useImportUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useImportUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ImportUserMutation,
    ImportUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ImportUserMutation, ImportUserMutationVariables>(
    ImportUserDocument,
    options,
  );
}
export type ImportUserMutationHookResult = ReturnType<
  typeof useImportUserMutation
>;
export type ImportUserMutationResult =
  Apollo.MutationResult<ImportUserMutation>;
export type ImportUserMutationOptions = Apollo.BaseMutationOptions<
  ImportUserMutation,
  ImportUserMutationVariables
>;
export const SetUploadUserToDealerDocument = gql`
  mutation setUploadUserToDealer($fileId: ID!, $quarter: Int, $year: Int) {
    UserSetter {
      uploadUserToDealer(fileId: $fileId, quarter: $quarter, year: $year)
    }
  }
`;
export type SetUploadUserToDealerMutationFn = Apollo.MutationFunction<
  SetUploadUserToDealerMutation,
  SetUploadUserToDealerMutationVariables
>;

/**
 * __useSetUploadUserToDealerMutation__
 *
 * To run a mutation, you first call `useSetUploadUserToDealerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUploadUserToDealerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUploadUserToDealerMutation, { data, loading, error }] = useSetUploadUserToDealerMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      quarter: // value for 'quarter'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useSetUploadUserToDealerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetUploadUserToDealerMutation,
    SetUploadUserToDealerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetUploadUserToDealerMutation,
    SetUploadUserToDealerMutationVariables
  >(SetUploadUserToDealerDocument, options);
}
export type SetUploadUserToDealerMutationHookResult = ReturnType<
  typeof useSetUploadUserToDealerMutation
>;
export type SetUploadUserToDealerMutationResult =
  Apollo.MutationResult<SetUploadUserToDealerMutation>;
export type SetUploadUserToDealerMutationOptions = Apollo.BaseMutationOptions<
  SetUploadUserToDealerMutation,
  SetUploadUserToDealerMutationVariables
>;
export const AcceptUploadUserToDealerValuesDocument = gql`
  mutation acceptUploadUserToDealerValues($IndicatorUploadId: ID!) {
    UserSetter {
      acceptUploadUserToDealer(IndicatorUploadId: $IndicatorUploadId)
    }
  }
`;
export type AcceptUploadUserToDealerValuesMutationFn = Apollo.MutationFunction<
  AcceptUploadUserToDealerValuesMutation,
  AcceptUploadUserToDealerValuesMutationVariables
>;

/**
 * __useAcceptUploadUserToDealerValuesMutation__
 *
 * To run a mutation, you first call `useAcceptUploadUserToDealerValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptUploadUserToDealerValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptUploadUserToDealerValuesMutation, { data, loading, error }] = useAcceptUploadUserToDealerValuesMutation({
 *   variables: {
 *      IndicatorUploadId: // value for 'IndicatorUploadId'
 *   },
 * });
 */
export function useAcceptUploadUserToDealerValuesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptUploadUserToDealerValuesMutation,
    AcceptUploadUserToDealerValuesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AcceptUploadUserToDealerValuesMutation,
    AcceptUploadUserToDealerValuesMutationVariables
  >(AcceptUploadUserToDealerValuesDocument, options);
}
export type AcceptUploadUserToDealerValuesMutationHookResult = ReturnType<
  typeof useAcceptUploadUserToDealerValuesMutation
>;
export type AcceptUploadUserToDealerValuesMutationResult =
  Apollo.MutationResult<AcceptUploadUserToDealerValuesMutation>;
export type AcceptUploadUserToDealerValuesMutationOptions =
  Apollo.BaseMutationOptions<
    AcceptUploadUserToDealerValuesMutation,
    AcceptUploadUserToDealerValuesMutationVariables
  >;
export const CreateViolationDocument = gql`
  mutation CreateViolation(
    $DealerIds: [ID]!
    $ViolationTypesId: ID!
    $fixDeadline: DateTime!
    $description: String!
    $DocNum: String
    $DocDate: DateTime
    $FileId: ID
    $responsibleChecker: ID
  ) {
    ViolationSetter {
      create(
        DealerIds: $DealerIds
        ViolationTypesId: $ViolationTypesId
        fixDeadline: $fixDeadline
        description: $description
        DocNum: $DocNum
        DocDate: $DocDate
        FileId: $FileId
        responsibleChecker: $responsibleChecker
      )
    }
  }
`;
export type CreateViolationMutationFn = Apollo.MutationFunction<
  CreateViolationMutation,
  CreateViolationMutationVariables
>;

/**
 * __useCreateViolationMutation__
 *
 * To run a mutation, you first call `useCreateViolationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateViolationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createViolationMutation, { data, loading, error }] = useCreateViolationMutation({
 *   variables: {
 *      DealerIds: // value for 'DealerIds'
 *      ViolationTypesId: // value for 'ViolationTypesId'
 *      fixDeadline: // value for 'fixDeadline'
 *      description: // value for 'description'
 *      DocNum: // value for 'DocNum'
 *      DocDate: // value for 'DocDate'
 *      FileId: // value for 'FileId'
 *      responsibleChecker: // value for 'responsibleChecker'
 *   },
 * });
 */
export function useCreateViolationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateViolationMutation,
    CreateViolationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateViolationMutation,
    CreateViolationMutationVariables
  >(CreateViolationDocument, options);
}
export type CreateViolationMutationHookResult = ReturnType<
  typeof useCreateViolationMutation
>;
export type CreateViolationMutationResult =
  Apollo.MutationResult<CreateViolationMutation>;
export type CreateViolationMutationOptions = Apollo.BaseMutationOptions<
  CreateViolationMutation,
  CreateViolationMutationVariables
>;
export const EditViolationDocument = gql`
  mutation EditViolation(
    $id: ID!
    $fixDeadline: DateTime!
    $responsibleChecker: ID
    $description: String!
    $DocNum: String
    $DocDate: DateTime
    $DocId: ID
  ) {
    ViolationSetter {
      edit(
        id: $id
        fixDeadline: $fixDeadline
        responsibleChecker: $responsibleChecker
        description: $description
        DocId: $DocId
        DocNum: $DocNum
        DocDate: $DocDate
      )
    }
  }
`;
export type EditViolationMutationFn = Apollo.MutationFunction<
  EditViolationMutation,
  EditViolationMutationVariables
>;

/**
 * __useEditViolationMutation__
 *
 * To run a mutation, you first call `useEditViolationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditViolationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editViolationMutation, { data, loading, error }] = useEditViolationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fixDeadline: // value for 'fixDeadline'
 *      responsibleChecker: // value for 'responsibleChecker'
 *      description: // value for 'description'
 *      DocNum: // value for 'DocNum'
 *      DocDate: // value for 'DocDate'
 *      DocId: // value for 'DocId'
 *   },
 * });
 */
export function useEditViolationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditViolationMutation,
    EditViolationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditViolationMutation,
    EditViolationMutationVariables
  >(EditViolationDocument, options);
}
export type EditViolationMutationHookResult = ReturnType<
  typeof useEditViolationMutation
>;
export type EditViolationMutationResult =
  Apollo.MutationResult<EditViolationMutation>;
export type EditViolationMutationOptions = Apollo.BaseMutationOptions<
  EditViolationMutation,
  EditViolationMutationVariables
>;
export const DeleteViolationDocument = gql`
  mutation DeleteViolation($id: ID!) {
    ViolationSetter {
      delete(id: $id)
    }
  }
`;
export type DeleteViolationMutationFn = Apollo.MutationFunction<
  DeleteViolationMutation,
  DeleteViolationMutationVariables
>;

/**
 * __useDeleteViolationMutation__
 *
 * To run a mutation, you first call `useDeleteViolationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteViolationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteViolationMutation, { data, loading, error }] = useDeleteViolationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteViolationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteViolationMutation,
    DeleteViolationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteViolationMutation,
    DeleteViolationMutationVariables
  >(DeleteViolationDocument, options);
}
export type DeleteViolationMutationHookResult = ReturnType<
  typeof useDeleteViolationMutation
>;
export type DeleteViolationMutationResult =
  Apollo.MutationResult<DeleteViolationMutation>;
export type DeleteViolationMutationOptions = Apollo.BaseMutationOptions<
  DeleteViolationMutation,
  DeleteViolationMutationVariables
>;
export const UnDeleteViolationDocument = gql`
  mutation UnDeleteViolation($id: ID!) {
    ViolationSetter {
      unDelete(id: $id)
    }
  }
`;
export type UnDeleteViolationMutationFn = Apollo.MutationFunction<
  UnDeleteViolationMutation,
  UnDeleteViolationMutationVariables
>;

/**
 * __useUnDeleteViolationMutation__
 *
 * To run a mutation, you first call `useUnDeleteViolationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnDeleteViolationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unDeleteViolationMutation, { data, loading, error }] = useUnDeleteViolationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnDeleteViolationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnDeleteViolationMutation,
    UnDeleteViolationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UnDeleteViolationMutation,
    UnDeleteViolationMutationVariables
  >(UnDeleteViolationDocument, options);
}
export type UnDeleteViolationMutationHookResult = ReturnType<
  typeof useUnDeleteViolationMutation
>;
export type UnDeleteViolationMutationResult =
  Apollo.MutationResult<UnDeleteViolationMutation>;
export type UnDeleteViolationMutationOptions = Apollo.BaseMutationOptions<
  UnDeleteViolationMutation,
  UnDeleteViolationMutationVariables
>;
export const RestoreViolationDocument = gql`
  mutation RestoreViolation($id: ID!) {
    ViolationSetter {
      unDelete(id: $id)
    }
  }
`;
export type RestoreViolationMutationFn = Apollo.MutationFunction<
  RestoreViolationMutation,
  RestoreViolationMutationVariables
>;

/**
 * __useRestoreViolationMutation__
 *
 * To run a mutation, you first call `useRestoreViolationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreViolationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreViolationMutation, { data, loading, error }] = useRestoreViolationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreViolationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RestoreViolationMutation,
    RestoreViolationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RestoreViolationMutation,
    RestoreViolationMutationVariables
  >(RestoreViolationDocument, options);
}
export type RestoreViolationMutationHookResult = ReturnType<
  typeof useRestoreViolationMutation
>;
export type RestoreViolationMutationResult =
  Apollo.MutationResult<RestoreViolationMutation>;
export type RestoreViolationMutationOptions = Apollo.BaseMutationOptions<
  RestoreViolationMutation,
  RestoreViolationMutationVariables
>;
export const RejectViolationDocument = gql`
  mutation RejectViolation($id: ID!, $punishment: String!) {
    ViolationSetter {
      reject(id: $id, punishment: $punishment)
    }
  }
`;
export type RejectViolationMutationFn = Apollo.MutationFunction<
  RejectViolationMutation,
  RejectViolationMutationVariables
>;

/**
 * __useRejectViolationMutation__
 *
 * To run a mutation, you first call `useRejectViolationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectViolationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectViolationMutation, { data, loading, error }] = useRejectViolationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      punishment: // value for 'punishment'
 *   },
 * });
 */
export function useRejectViolationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RejectViolationMutation,
    RejectViolationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RejectViolationMutation,
    RejectViolationMutationVariables
  >(RejectViolationDocument, options);
}
export type RejectViolationMutationHookResult = ReturnType<
  typeof useRejectViolationMutation
>;
export type RejectViolationMutationResult =
  Apollo.MutationResult<RejectViolationMutation>;
export type RejectViolationMutationOptions = Apollo.BaseMutationOptions<
  RejectViolationMutation,
  RejectViolationMutationVariables
>;
export const AddCommentDocument = gql`
  mutation AddComment($id: ID!, $comment: String!, $files: [ID]) {
    ViolationSetter {
      addComment(id: $id, comment: $comment, files: $files)
    }
  }
`;
export type AddCommentMutationFn = Apollo.MutationFunction<
  AddCommentMutation,
  AddCommentMutationVariables
>;

/**
 * __useAddCommentMutation__
 *
 * To run a mutation, you first call `useAddCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommentMutation, { data, loading, error }] = useAddCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      comment: // value for 'comment'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useAddCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddCommentMutation,
    AddCommentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddCommentMutation, AddCommentMutationVariables>(
    AddCommentDocument,
    options,
  );
}
export type AddCommentMutationHookResult = ReturnType<
  typeof useAddCommentMutation
>;
export type AddCommentMutationResult =
  Apollo.MutationResult<AddCommentMutation>;
export type AddCommentMutationOptions = Apollo.BaseMutationOptions<
  AddCommentMutation,
  AddCommentMutationVariables
>;
export const GiveResponseToDealerDocument = gql`
  mutation GiveResponseToDealer($id: ID!, $status: StatusSetResponseToDealer) {
    ViolationSetter {
      giveResponseToDealer(id: $id, status: $status)
    }
  }
`;
export type GiveResponseToDealerMutationFn = Apollo.MutationFunction<
  GiveResponseToDealerMutation,
  GiveResponseToDealerMutationVariables
>;

/**
 * __useGiveResponseToDealerMutation__
 *
 * To run a mutation, you first call `useGiveResponseToDealerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGiveResponseToDealerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [giveResponseToDealerMutation, { data, loading, error }] = useGiveResponseToDealerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGiveResponseToDealerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GiveResponseToDealerMutation,
    GiveResponseToDealerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GiveResponseToDealerMutation,
    GiveResponseToDealerMutationVariables
  >(GiveResponseToDealerDocument, options);
}
export type GiveResponseToDealerMutationHookResult = ReturnType<
  typeof useGiveResponseToDealerMutation
>;
export type GiveResponseToDealerMutationResult =
  Apollo.MutationResult<GiveResponseToDealerMutation>;
export type GiveResponseToDealerMutationOptions = Apollo.BaseMutationOptions<
  GiveResponseToDealerMutation,
  GiveResponseToDealerMutationVariables
>;
export const DealerFixViolationDocument = gql`
  mutation DealerFixViolation($id: ID!) {
    ViolationSetter {
      dealerFix(id: $id)
    }
  }
`;
export type DealerFixViolationMutationFn = Apollo.MutationFunction<
  DealerFixViolationMutation,
  DealerFixViolationMutationVariables
>;

/**
 * __useDealerFixViolationMutation__
 *
 * To run a mutation, you first call `useDealerFixViolationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDealerFixViolationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dealerFixViolationMutation, { data, loading, error }] = useDealerFixViolationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDealerFixViolationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DealerFixViolationMutation,
    DealerFixViolationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DealerFixViolationMutation,
    DealerFixViolationMutationVariables
  >(DealerFixViolationDocument, options);
}
export type DealerFixViolationMutationHookResult = ReturnType<
  typeof useDealerFixViolationMutation
>;
export type DealerFixViolationMutationResult =
  Apollo.MutationResult<DealerFixViolationMutation>;
export type DealerFixViolationMutationOptions = Apollo.BaseMutationOptions<
  DealerFixViolationMutation,
  DealerFixViolationMutationVariables
>;
export const AddViolationTypeDocument = gql`
  mutation AddViolationType(
    $name: String!
    $description: String!
    $howToFixDescription: String!
    $category: ViolationTypeCategory!
    $SubdivisionId: ID!
    $AvgCorrectionDays: Int!
  ) {
    ViolationTypesSetter {
      create(
        name: $name
        description: $description
        howToFixDescription: $howToFixDescription
        category: $category
        SubdivisionId: $SubdivisionId
        AvgCorrectionDays: $AvgCorrectionDays
      ) {
        id
      }
    }
  }
`;
export type AddViolationTypeMutationFn = Apollo.MutationFunction<
  AddViolationTypeMutation,
  AddViolationTypeMutationVariables
>;

/**
 * __useAddViolationTypeMutation__
 *
 * To run a mutation, you first call `useAddViolationTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddViolationTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addViolationTypeMutation, { data, loading, error }] = useAddViolationTypeMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      howToFixDescription: // value for 'howToFixDescription'
 *      category: // value for 'category'
 *      SubdivisionId: // value for 'SubdivisionId'
 *      AvgCorrectionDays: // value for 'AvgCorrectionDays'
 *   },
 * });
 */
export function useAddViolationTypeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddViolationTypeMutation,
    AddViolationTypeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddViolationTypeMutation,
    AddViolationTypeMutationVariables
  >(AddViolationTypeDocument, options);
}
export type AddViolationTypeMutationHookResult = ReturnType<
  typeof useAddViolationTypeMutation
>;
export type AddViolationTypeMutationResult =
  Apollo.MutationResult<AddViolationTypeMutation>;
export type AddViolationTypeMutationOptions = Apollo.BaseMutationOptions<
  AddViolationTypeMutation,
  AddViolationTypeMutationVariables
>;
export const EditViolationTypeDocument = gql`
  mutation EditViolationType(
    $id: ID!
    $name: String!
    $description: String!
    $howToFixDescription: String!
    $category: ViolationTypeCategory!
    $SubdivisionId: ID!
    $AvgCorrectionDays: Int!
  ) {
    ViolationTypesSetter {
      edit(
        id: $id
        name: $name
        description: $description
        howToFixDescription: $howToFixDescription
        category: $category
        SubdivisionId: $SubdivisionId
        AvgCorrectionDays: $AvgCorrectionDays
      ) {
        id
      }
    }
  }
`;
export type EditViolationTypeMutationFn = Apollo.MutationFunction<
  EditViolationTypeMutation,
  EditViolationTypeMutationVariables
>;

/**
 * __useEditViolationTypeMutation__
 *
 * To run a mutation, you first call `useEditViolationTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditViolationTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editViolationTypeMutation, { data, loading, error }] = useEditViolationTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      howToFixDescription: // value for 'howToFixDescription'
 *      category: // value for 'category'
 *      SubdivisionId: // value for 'SubdivisionId'
 *      AvgCorrectionDays: // value for 'AvgCorrectionDays'
 *   },
 * });
 */
export function useEditViolationTypeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditViolationTypeMutation,
    EditViolationTypeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditViolationTypeMutation,
    EditViolationTypeMutationVariables
  >(EditViolationTypeDocument, options);
}
export type EditViolationTypeMutationHookResult = ReturnType<
  typeof useEditViolationTypeMutation
>;
export type EditViolationTypeMutationResult =
  Apollo.MutationResult<EditViolationTypeMutation>;
export type EditViolationTypeMutationOptions = Apollo.BaseMutationOptions<
  EditViolationTypeMutation,
  EditViolationTypeMutationVariables
>;
export const ChangeStatusViolationTypeDocument = gql`
  mutation ChangeStatusViolationType(
    $id: ID!
    $status: ViolationTypeStatusChange!
  ) {
    ViolationTypesSetter {
      changeStatus(id: $id, status: $status) {
        id
      }
    }
  }
`;
export type ChangeStatusViolationTypeMutationFn = Apollo.MutationFunction<
  ChangeStatusViolationTypeMutation,
  ChangeStatusViolationTypeMutationVariables
>;

/**
 * __useChangeStatusViolationTypeMutation__
 *
 * To run a mutation, you first call `useChangeStatusViolationTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeStatusViolationTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeStatusViolationTypeMutation, { data, loading, error }] = useChangeStatusViolationTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useChangeStatusViolationTypeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChangeStatusViolationTypeMutation,
    ChangeStatusViolationTypeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChangeStatusViolationTypeMutation,
    ChangeStatusViolationTypeMutationVariables
  >(ChangeStatusViolationTypeDocument, options);
}
export type ChangeStatusViolationTypeMutationHookResult = ReturnType<
  typeof useChangeStatusViolationTypeMutation
>;
export type ChangeStatusViolationTypeMutationResult =
  Apollo.MutationResult<ChangeStatusViolationTypeMutation>;
export type ChangeStatusViolationTypeMutationOptions =
  Apollo.BaseMutationOptions<
    ChangeStatusViolationTypeMutation,
    ChangeStatusViolationTypeMutationVariables
  >;
export const SetCreateWarehousesDocument = gql`
  mutation setCreateWarehouses(
    $ComplianceIndicator: ID
    $AreaIndicator: ID
    $CombineIndicator: ID
    $Number: String
    $Name: String
    $NameEn: String
  ) {
    WarehousesSetter {
      create(
        ComplianceIndicator: $ComplianceIndicator
        AreaIndicator: $AreaIndicator
        CombineIndicator: $CombineIndicator
        Number: $Number
        Name: $Name
        NameEn: $NameEn
      ) {
        id
      }
    }
  }
`;
export type SetCreateWarehousesMutationFn = Apollo.MutationFunction<
  SetCreateWarehousesMutation,
  SetCreateWarehousesMutationVariables
>;

/**
 * __useSetCreateWarehousesMutation__
 *
 * To run a mutation, you first call `useSetCreateWarehousesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCreateWarehousesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCreateWarehousesMutation, { data, loading, error }] = useSetCreateWarehousesMutation({
 *   variables: {
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      AreaIndicator: // value for 'AreaIndicator'
 *      CombineIndicator: // value for 'CombineIndicator'
 *      Number: // value for 'Number'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *   },
 * });
 */
export function useSetCreateWarehousesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCreateWarehousesMutation,
    SetCreateWarehousesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetCreateWarehousesMutation,
    SetCreateWarehousesMutationVariables
  >(SetCreateWarehousesDocument, options);
}
export type SetCreateWarehousesMutationHookResult = ReturnType<
  typeof useSetCreateWarehousesMutation
>;
export type SetCreateWarehousesMutationResult =
  Apollo.MutationResult<SetCreateWarehousesMutation>;
export type SetCreateWarehousesMutationOptions = Apollo.BaseMutationOptions<
  SetCreateWarehousesMutation,
  SetCreateWarehousesMutationVariables
>;
export const SetChangeWarehousesDocument = gql`
  mutation setChangeWarehouses(
    $id: ID
    $ComplianceIndicator: ID
    $AreaIndicator: ID
    $CombineIndicator: ID
    $Number: String
    $Name: String
    $NameEn: String
  ) {
    WarehousesSetter {
      change(
        id: $id
        ComplianceIndicator: $ComplianceIndicator
        AreaIndicator: $AreaIndicator
        CombineIndicator: $CombineIndicator
        Number: $Number
        Name: $Name
        NameEn: $NameEn
      ) {
        id
      }
    }
  }
`;
export type SetChangeWarehousesMutationFn = Apollo.MutationFunction<
  SetChangeWarehousesMutation,
  SetChangeWarehousesMutationVariables
>;

/**
 * __useSetChangeWarehousesMutation__
 *
 * To run a mutation, you first call `useSetChangeWarehousesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetChangeWarehousesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setChangeWarehousesMutation, { data, loading, error }] = useSetChangeWarehousesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      AreaIndicator: // value for 'AreaIndicator'
 *      CombineIndicator: // value for 'CombineIndicator'
 *      Number: // value for 'Number'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *   },
 * });
 */
export function useSetChangeWarehousesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetChangeWarehousesMutation,
    SetChangeWarehousesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetChangeWarehousesMutation,
    SetChangeWarehousesMutationVariables
  >(SetChangeWarehousesDocument, options);
}
export type SetChangeWarehousesMutationHookResult = ReturnType<
  typeof useSetChangeWarehousesMutation
>;
export type SetChangeWarehousesMutationResult =
  Apollo.MutationResult<SetChangeWarehousesMutation>;
export type SetChangeWarehousesMutationOptions = Apollo.BaseMutationOptions<
  SetChangeWarehousesMutation,
  SetChangeWarehousesMutationVariables
>;
export const SetBlindChangeWarehousesDocument = gql`
  mutation setBlindChangeWarehouses(
    $id: ID
    $ComplianceIndicator: ID
    $AreaIndicator: ID
    $CombineIndicator: ID
    $Number: String
    $Name: String
    $NameEn: String
  ) {
    WarehousesSetter {
      blindChange(
        id: $id
        ComplianceIndicator: $ComplianceIndicator
        AreaIndicator: $AreaIndicator
        CombineIndicator: $CombineIndicator
        Number: $Number
        Name: $Name
        NameEn: $NameEn
      ) {
        id
      }
    }
  }
`;
export type SetBlindChangeWarehousesMutationFn = Apollo.MutationFunction<
  SetBlindChangeWarehousesMutation,
  SetBlindChangeWarehousesMutationVariables
>;

/**
 * __useSetBlindChangeWarehousesMutation__
 *
 * To run a mutation, you first call `useSetBlindChangeWarehousesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBlindChangeWarehousesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBlindChangeWarehousesMutation, { data, loading, error }] = useSetBlindChangeWarehousesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ComplianceIndicator: // value for 'ComplianceIndicator'
 *      AreaIndicator: // value for 'AreaIndicator'
 *      CombineIndicator: // value for 'CombineIndicator'
 *      Number: // value for 'Number'
 *      Name: // value for 'Name'
 *      NameEn: // value for 'NameEn'
 *   },
 * });
 */
export function useSetBlindChangeWarehousesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetBlindChangeWarehousesMutation,
    SetBlindChangeWarehousesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetBlindChangeWarehousesMutation,
    SetBlindChangeWarehousesMutationVariables
  >(SetBlindChangeWarehousesDocument, options);
}
export type SetBlindChangeWarehousesMutationHookResult = ReturnType<
  typeof useSetBlindChangeWarehousesMutation
>;
export type SetBlindChangeWarehousesMutationResult =
  Apollo.MutationResult<SetBlindChangeWarehousesMutation>;
export type SetBlindChangeWarehousesMutationOptions =
  Apollo.BaseMutationOptions<
    SetBlindChangeWarehousesMutation,
    SetBlindChangeWarehousesMutationVariables
  >;
export const SetAddValuesWarehousesDocument = gql`
  mutation setAddValuesWarehouses(
    $Compliance: Int
    $Area: Float
    $Combine: String
    $DealerId: ID
    $UUID: String
  ) {
    WarehousesSetter {
      addValues(
        UUID: $UUID
        Compliance: $Compliance
        Area: $Area
        Combine: $Combine
        DealerId: $DealerId
      )
    }
  }
`;
export type SetAddValuesWarehousesMutationFn = Apollo.MutationFunction<
  SetAddValuesWarehousesMutation,
  SetAddValuesWarehousesMutationVariables
>;

/**
 * __useSetAddValuesWarehousesMutation__
 *
 * To run a mutation, you first call `useSetAddValuesWarehousesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAddValuesWarehousesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAddValuesWarehousesMutation, { data, loading, error }] = useSetAddValuesWarehousesMutation({
 *   variables: {
 *      Compliance: // value for 'Compliance'
 *      Area: // value for 'Area'
 *      Combine: // value for 'Combine'
 *      DealerId: // value for 'DealerId'
 *      UUID: // value for 'UUID'
 *   },
 * });
 */
export function useSetAddValuesWarehousesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetAddValuesWarehousesMutation,
    SetAddValuesWarehousesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetAddValuesWarehousesMutation,
    SetAddValuesWarehousesMutationVariables
  >(SetAddValuesWarehousesDocument, options);
}
export type SetAddValuesWarehousesMutationHookResult = ReturnType<
  typeof useSetAddValuesWarehousesMutation
>;
export type SetAddValuesWarehousesMutationResult =
  Apollo.MutationResult<SetAddValuesWarehousesMutation>;
export type SetAddValuesWarehousesMutationOptions = Apollo.BaseMutationOptions<
  SetAddValuesWarehousesMutation,
  SetAddValuesWarehousesMutationVariables
>;
export const SetDeleteWarehousesDocument = gql`
  mutation setDeleteWarehouses($id: ID) {
    WarehousesSetter {
      delete(id: $id)
    }
  }
`;
export type SetDeleteWarehousesMutationFn = Apollo.MutationFunction<
  SetDeleteWarehousesMutation,
  SetDeleteWarehousesMutationVariables
>;

/**
 * __useSetDeleteWarehousesMutation__
 *
 * To run a mutation, you first call `useSetDeleteWarehousesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDeleteWarehousesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDeleteWarehousesMutation, { data, loading, error }] = useSetDeleteWarehousesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetDeleteWarehousesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetDeleteWarehousesMutation,
    SetDeleteWarehousesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetDeleteWarehousesMutation,
    SetDeleteWarehousesMutationVariables
  >(SetDeleteWarehousesDocument, options);
}
export type SetDeleteWarehousesMutationHookResult = ReturnType<
  typeof useSetDeleteWarehousesMutation
>;
export type SetDeleteWarehousesMutationResult =
  Apollo.MutationResult<SetDeleteWarehousesMutation>;
export type SetDeleteWarehousesMutationOptions = Apollo.BaseMutationOptions<
  SetDeleteWarehousesMutation,
  SetDeleteWarehousesMutationVariables
>;
export const SetDeleteResetDateDocument = gql`
  mutation setDeleteResetDate($id: ID!) {
    ZdCommonSetter {
      deleteResetDate(id: $id)
    }
  }
`;
export type SetDeleteResetDateMutationFn = Apollo.MutationFunction<
  SetDeleteResetDateMutation,
  SetDeleteResetDateMutationVariables
>;

/**
 * __useSetDeleteResetDateMutation__
 *
 * To run a mutation, you first call `useSetDeleteResetDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDeleteResetDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDeleteResetDateMutation, { data, loading, error }] = useSetDeleteResetDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetDeleteResetDateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetDeleteResetDateMutation,
    SetDeleteResetDateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetDeleteResetDateMutation,
    SetDeleteResetDateMutationVariables
  >(SetDeleteResetDateDocument, options);
}
export type SetDeleteResetDateMutationHookResult = ReturnType<
  typeof useSetDeleteResetDateMutation
>;
export type SetDeleteResetDateMutationResult =
  Apollo.MutationResult<SetDeleteResetDateMutation>;
export type SetDeleteResetDateMutationOptions = Apollo.BaseMutationOptions<
  SetDeleteResetDateMutation,
  SetDeleteResetDateMutationVariables
>;
export const SetChangeStatusZdGlobalForDealerDocument = gql`
  mutation setChangeStatusZdGlobalForDealer(
    $DealerId: ID
    $status: ZdGlobalInfoForDealerStatus
    $isPremises: Boolean
  ) {
    ZdCommonSetter {
      changeStatusZdGlobalForDealer(
        status: $status
        DealerId: $DealerId
        isPremises: $isPremises
      )
    }
  }
`;
export type SetChangeStatusZdGlobalForDealerMutationFn =
  Apollo.MutationFunction<
    SetChangeStatusZdGlobalForDealerMutation,
    SetChangeStatusZdGlobalForDealerMutationVariables
  >;

/**
 * __useSetChangeStatusZdGlobalForDealerMutation__
 *
 * To run a mutation, you first call `useSetChangeStatusZdGlobalForDealerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetChangeStatusZdGlobalForDealerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setChangeStatusZdGlobalForDealerMutation, { data, loading, error }] = useSetChangeStatusZdGlobalForDealerMutation({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      status: // value for 'status'
 *      isPremises: // value for 'isPremises'
 *   },
 * });
 */
export function useSetChangeStatusZdGlobalForDealerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetChangeStatusZdGlobalForDealerMutation,
    SetChangeStatusZdGlobalForDealerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetChangeStatusZdGlobalForDealerMutation,
    SetChangeStatusZdGlobalForDealerMutationVariables
  >(SetChangeStatusZdGlobalForDealerDocument, options);
}
export type SetChangeStatusZdGlobalForDealerMutationHookResult = ReturnType<
  typeof useSetChangeStatusZdGlobalForDealerMutation
>;
export type SetChangeStatusZdGlobalForDealerMutationResult =
  Apollo.MutationResult<SetChangeStatusZdGlobalForDealerMutation>;
export type SetChangeStatusZdGlobalForDealerMutationOptions =
  Apollo.BaseMutationOptions<
    SetChangeStatusZdGlobalForDealerMutation,
    SetChangeStatusZdGlobalForDealerMutationVariables
  >;
export const SetCreateResetDateDocument = gql`
  mutation setCreateResetDate(
    $DealerId: ID
    $tableIndex: ZdTableIndex!
    $ZD_UUID: String
  ) {
    ZdCommonSetter {
      createResetDate(
        DealerId: $DealerId
        tableIndex: $tableIndex
        ZD_UUID: $ZD_UUID
      )
    }
  }
`;
export type SetCreateResetDateMutationFn = Apollo.MutationFunction<
  SetCreateResetDateMutation,
  SetCreateResetDateMutationVariables
>;

/**
 * __useSetCreateResetDateMutation__
 *
 * To run a mutation, you first call `useSetCreateResetDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCreateResetDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCreateResetDateMutation, { data, loading, error }] = useSetCreateResetDateMutation({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      tableIndex: // value for 'tableIndex'
 *      ZD_UUID: // value for 'ZD_UUID'
 *   },
 * });
 */
export function useSetCreateResetDateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCreateResetDateMutation,
    SetCreateResetDateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetCreateResetDateMutation,
    SetCreateResetDateMutationVariables
  >(SetCreateResetDateDocument, options);
}
export type SetCreateResetDateMutationHookResult = ReturnType<
  typeof useSetCreateResetDateMutation
>;
export type SetCreateResetDateMutationResult =
  Apollo.MutationResult<SetCreateResetDateMutation>;
export type SetCreateResetDateMutationOptions = Apollo.BaseMutationOptions<
  SetCreateResetDateMutation,
  SetCreateResetDateMutationVariables
>;
export const DeleteLineValueDealerDocument = gql`
  mutation deleteLineValueDealer(
    $DealerId: ID
    $tableIndex: ZdTableIndex!
    $ZD_UUID: String
  ) {
    ZdCommonSetter {
      deleteLineValueDealer(
        DealerId: $DealerId
        tableIndex: $tableIndex
        ZD_UUID: $ZD_UUID
      )
    }
  }
`;
export type DeleteLineValueDealerMutationFn = Apollo.MutationFunction<
  DeleteLineValueDealerMutation,
  DeleteLineValueDealerMutationVariables
>;

/**
 * __useDeleteLineValueDealerMutation__
 *
 * To run a mutation, you first call `useDeleteLineValueDealerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLineValueDealerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLineValueDealerMutation, { data, loading, error }] = useDeleteLineValueDealerMutation({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      tableIndex: // value for 'tableIndex'
 *      ZD_UUID: // value for 'ZD_UUID'
 *   },
 * });
 */
export function useDeleteLineValueDealerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteLineValueDealerMutation,
    DeleteLineValueDealerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteLineValueDealerMutation,
    DeleteLineValueDealerMutationVariables
  >(DeleteLineValueDealerDocument, options);
}
export type DeleteLineValueDealerMutationHookResult = ReturnType<
  typeof useDeleteLineValueDealerMutation
>;
export type DeleteLineValueDealerMutationResult =
  Apollo.MutationResult<DeleteLineValueDealerMutation>;
export type DeleteLineValueDealerMutationOptions = Apollo.BaseMutationOptions<
  DeleteLineValueDealerMutation,
  DeleteLineValueDealerMutationVariables
>;
export const GetAccountingsGettersDocument = gql`
  query GetAccountingsGetters(
    $DealerId: ID
    $ReportPeriodId: ID
    $status: DealerReportStatus
    $dealerName: String
    $sortBy: getDealerReportsSort = DealerName
    $sortType: sortType = ASC
    $page: Int = 0
    $count: Int = 10
  ) {
    AccountingGetter {
      getDealerReports(
        DealerId: $DealerId
        ReportPeriodId: $ReportPeriodId
        sortBy: $sortBy
        sortType: $sortType
        status: $status
        dealerName: $dealerName
        page: $page
        count: $count
      ) {
        items {
          ... on DealerReport {
            ...fragmentAccounting
          }
        }
        total
      }
    }
  }
  ${FragmentAccountingFragmentDoc}
`;

/**
 * __useGetAccountingsGettersQuery__
 *
 * To run a query within a React component, call `useGetAccountingsGettersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountingsGettersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountingsGettersQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      ReportPeriodId: // value for 'ReportPeriodId'
 *      status: // value for 'status'
 *      dealerName: // value for 'dealerName'
 *      sortBy: // value for 'sortBy'
 *      sortType: // value for 'sortType'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetAccountingsGettersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAccountingsGettersQuery,
    GetAccountingsGettersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAccountingsGettersQuery,
    GetAccountingsGettersQueryVariables
  >(GetAccountingsGettersDocument, options);
}
export function useGetAccountingsGettersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccountingsGettersQuery,
    GetAccountingsGettersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccountingsGettersQuery,
    GetAccountingsGettersQueryVariables
  >(GetAccountingsGettersDocument, options);
}
export type GetAccountingsGettersQueryHookResult = ReturnType<
  typeof useGetAccountingsGettersQuery
>;
export type GetAccountingsGettersLazyQueryHookResult = ReturnType<
  typeof useGetAccountingsGettersLazyQuery
>;
export type GetAccountingsGettersQueryResult = Apollo.QueryResult<
  GetAccountingsGettersQuery,
  GetAccountingsGettersQueryVariables
>;
export const GetAccountingsDraftGettersDocument = gql`
  query GetAccountingsDraftGetters(
    $ReportPeriodId: ID
    $status: DealerReportStatus = draft
  ) {
    AccountingGetter {
      getDealerReports(ReportPeriodId: $ReportPeriodId, status: $status) {
        total
      }
    }
  }
`;

/**
 * __useGetAccountingsDraftGettersQuery__
 *
 * To run a query within a React component, call `useGetAccountingsDraftGettersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountingsDraftGettersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountingsDraftGettersQuery({
 *   variables: {
 *      ReportPeriodId: // value for 'ReportPeriodId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetAccountingsDraftGettersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAccountingsDraftGettersQuery,
    GetAccountingsDraftGettersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAccountingsDraftGettersQuery,
    GetAccountingsDraftGettersQueryVariables
  >(GetAccountingsDraftGettersDocument, options);
}
export function useGetAccountingsDraftGettersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccountingsDraftGettersQuery,
    GetAccountingsDraftGettersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccountingsDraftGettersQuery,
    GetAccountingsDraftGettersQueryVariables
  >(GetAccountingsDraftGettersDocument, options);
}
export type GetAccountingsDraftGettersQueryHookResult = ReturnType<
  typeof useGetAccountingsDraftGettersQuery
>;
export type GetAccountingsDraftGettersLazyQueryHookResult = ReturnType<
  typeof useGetAccountingsDraftGettersLazyQuery
>;
export type GetAccountingsDraftGettersQueryResult = Apollo.QueryResult<
  GetAccountingsDraftGettersQuery,
  GetAccountingsDraftGettersQueryVariables
>;
export const GetAccountingsCheckingGettersDocument = gql`
  query GetAccountingsCheckingGetters(
    $ReportPeriodId: ID
    $status: DealerReportStatus = checking
  ) {
    AccountingGetter {
      getDealerReports(ReportPeriodId: $ReportPeriodId, status: $status) {
        total
      }
    }
  }
`;

/**
 * __useGetAccountingsCheckingGettersQuery__
 *
 * To run a query within a React component, call `useGetAccountingsCheckingGettersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountingsCheckingGettersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountingsCheckingGettersQuery({
 *   variables: {
 *      ReportPeriodId: // value for 'ReportPeriodId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetAccountingsCheckingGettersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAccountingsCheckingGettersQuery,
    GetAccountingsCheckingGettersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAccountingsCheckingGettersQuery,
    GetAccountingsCheckingGettersQueryVariables
  >(GetAccountingsCheckingGettersDocument, options);
}
export function useGetAccountingsCheckingGettersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccountingsCheckingGettersQuery,
    GetAccountingsCheckingGettersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccountingsCheckingGettersQuery,
    GetAccountingsCheckingGettersQueryVariables
  >(GetAccountingsCheckingGettersDocument, options);
}
export type GetAccountingsCheckingGettersQueryHookResult = ReturnType<
  typeof useGetAccountingsCheckingGettersQuery
>;
export type GetAccountingsCheckingGettersLazyQueryHookResult = ReturnType<
  typeof useGetAccountingsCheckingGettersLazyQuery
>;
export type GetAccountingsCheckingGettersQueryResult = Apollo.QueryResult<
  GetAccountingsCheckingGettersQuery,
  GetAccountingsCheckingGettersQueryVariables
>;
export const GetAccountingsVerifiedGettersDocument = gql`
  query GetAccountingsVerifiedGetters(
    $ReportPeriodId: ID
    $status: DealerReportStatus = verified
  ) {
    AccountingGetter {
      getDealerReports(ReportPeriodId: $ReportPeriodId, status: $status) {
        total
      }
    }
  }
`;

/**
 * __useGetAccountingsVerifiedGettersQuery__
 *
 * To run a query within a React component, call `useGetAccountingsVerifiedGettersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountingsVerifiedGettersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountingsVerifiedGettersQuery({
 *   variables: {
 *      ReportPeriodId: // value for 'ReportPeriodId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetAccountingsVerifiedGettersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAccountingsVerifiedGettersQuery,
    GetAccountingsVerifiedGettersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAccountingsVerifiedGettersQuery,
    GetAccountingsVerifiedGettersQueryVariables
  >(GetAccountingsVerifiedGettersDocument, options);
}
export function useGetAccountingsVerifiedGettersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccountingsVerifiedGettersQuery,
    GetAccountingsVerifiedGettersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccountingsVerifiedGettersQuery,
    GetAccountingsVerifiedGettersQueryVariables
  >(GetAccountingsVerifiedGettersDocument, options);
}
export type GetAccountingsVerifiedGettersQueryHookResult = ReturnType<
  typeof useGetAccountingsVerifiedGettersQuery
>;
export type GetAccountingsVerifiedGettersLazyQueryHookResult = ReturnType<
  typeof useGetAccountingsVerifiedGettersLazyQuery
>;
export type GetAccountingsVerifiedGettersQueryResult = Apollo.QueryResult<
  GetAccountingsVerifiedGettersQuery,
  GetAccountingsVerifiedGettersQueryVariables
>;
export const GetAccountingsFixingGettersDocument = gql`
  query GetAccountingsFixingGetters(
    $ReportPeriodId: ID
    $status: DealerReportStatus = fixing
  ) {
    AccountingGetter {
      getDealerReports(ReportPeriodId: $ReportPeriodId, status: $status) {
        total
      }
    }
  }
`;

/**
 * __useGetAccountingsFixingGettersQuery__
 *
 * To run a query within a React component, call `useGetAccountingsFixingGettersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountingsFixingGettersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountingsFixingGettersQuery({
 *   variables: {
 *      ReportPeriodId: // value for 'ReportPeriodId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetAccountingsFixingGettersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAccountingsFixingGettersQuery,
    GetAccountingsFixingGettersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAccountingsFixingGettersQuery,
    GetAccountingsFixingGettersQueryVariables
  >(GetAccountingsFixingGettersDocument, options);
}
export function useGetAccountingsFixingGettersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccountingsFixingGettersQuery,
    GetAccountingsFixingGettersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccountingsFixingGettersQuery,
    GetAccountingsFixingGettersQueryVariables
  >(GetAccountingsFixingGettersDocument, options);
}
export type GetAccountingsFixingGettersQueryHookResult = ReturnType<
  typeof useGetAccountingsFixingGettersQuery
>;
export type GetAccountingsFixingGettersLazyQueryHookResult = ReturnType<
  typeof useGetAccountingsFixingGettersLazyQuery
>;
export type GetAccountingsFixingGettersQueryResult = Apollo.QueryResult<
  GetAccountingsFixingGettersQuery,
  GetAccountingsFixingGettersQueryVariables
>;
export const GetAccountingGetterDocument = gql`
  query GetAccountingGetter($ReportId: ID!) {
    AccountingGetter {
      getDealerReport(ReportId: $ReportId) {
        ... on DealerReport {
          ...fragmentAccounting
        }
      }
    }
  }
  ${FragmentAccountingFragmentDoc}
`;

/**
 * __useGetAccountingGetterQuery__
 *
 * To run a query within a React component, call `useGetAccountingGetterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountingGetterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountingGetterQuery({
 *   variables: {
 *      ReportId: // value for 'ReportId'
 *   },
 * });
 */
export function useGetAccountingGetterQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAccountingGetterQuery,
    GetAccountingGetterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAccountingGetterQuery,
    GetAccountingGetterQueryVariables
  >(GetAccountingGetterDocument, options);
}
export function useGetAccountingGetterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccountingGetterQuery,
    GetAccountingGetterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccountingGetterQuery,
    GetAccountingGetterQueryVariables
  >(GetAccountingGetterDocument, options);
}
export type GetAccountingGetterQueryHookResult = ReturnType<
  typeof useGetAccountingGetterQuery
>;
export type GetAccountingGetterLazyQueryHookResult = ReturnType<
  typeof useGetAccountingGetterLazyQuery
>;
export type GetAccountingGetterQueryResult = Apollo.QueryResult<
  GetAccountingGetterQuery,
  GetAccountingGetterQueryVariables
>;
export const GetAccountingPeriodsGetterDocument = gql`
  query GetAccountingPeriodsGetter($page: Int = 0, $count: Int = 10) {
    AccountingGetter {
      getPeriods(page: $page, count: $count) {
        items {
          ... on ReportPeriod {
            ...fragmentAccountingPeriod
          }
        }
        total
      }
    }
  }
  ${FragmentAccountingPeriodFragmentDoc}
`;

/**
 * __useGetAccountingPeriodsGetterQuery__
 *
 * To run a query within a React component, call `useGetAccountingPeriodsGetterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountingPeriodsGetterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountingPeriodsGetterQuery({
 *   variables: {
 *      page: // value for 'page'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetAccountingPeriodsGetterQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAccountingPeriodsGetterQuery,
    GetAccountingPeriodsGetterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAccountingPeriodsGetterQuery,
    GetAccountingPeriodsGetterQueryVariables
  >(GetAccountingPeriodsGetterDocument, options);
}
export function useGetAccountingPeriodsGetterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccountingPeriodsGetterQuery,
    GetAccountingPeriodsGetterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccountingPeriodsGetterQuery,
    GetAccountingPeriodsGetterQueryVariables
  >(GetAccountingPeriodsGetterDocument, options);
}
export type GetAccountingPeriodsGetterQueryHookResult = ReturnType<
  typeof useGetAccountingPeriodsGetterQuery
>;
export type GetAccountingPeriodsGetterLazyQueryHookResult = ReturnType<
  typeof useGetAccountingPeriodsGetterLazyQuery
>;
export type GetAccountingPeriodsGetterQueryResult = Apollo.QueryResult<
  GetAccountingPeriodsGetterQuery,
  GetAccountingPeriodsGetterQueryVariables
>;
export const GetAccountingPeriodGetterDocument = gql`
  query GetAccountingPeriodGetter($Year: Int!, $Quarter: Int!) {
    AccountingGetter {
      getPeriod(Year: $Year, Quarter: $Quarter) {
        ... on ReportPeriod {
          ...fragmentAccountingPeriod
        }
      }
    }
  }
  ${FragmentAccountingPeriodFragmentDoc}
`;

/**
 * __useGetAccountingPeriodGetterQuery__
 *
 * To run a query within a React component, call `useGetAccountingPeriodGetterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountingPeriodGetterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountingPeriodGetterQuery({
 *   variables: {
 *      Year: // value for 'Year'
 *      Quarter: // value for 'Quarter'
 *   },
 * });
 */
export function useGetAccountingPeriodGetterQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAccountingPeriodGetterQuery,
    GetAccountingPeriodGetterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAccountingPeriodGetterQuery,
    GetAccountingPeriodGetterQueryVariables
  >(GetAccountingPeriodGetterDocument, options);
}
export function useGetAccountingPeriodGetterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccountingPeriodGetterQuery,
    GetAccountingPeriodGetterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccountingPeriodGetterQuery,
    GetAccountingPeriodGetterQueryVariables
  >(GetAccountingPeriodGetterDocument, options);
}
export type GetAccountingPeriodGetterQueryHookResult = ReturnType<
  typeof useGetAccountingPeriodGetterQuery
>;
export type GetAccountingPeriodGetterLazyQueryHookResult = ReturnType<
  typeof useGetAccountingPeriodGetterLazyQuery
>;
export type GetAccountingPeriodGetterQueryResult = Apollo.QueryResult<
  GetAccountingPeriodGetterQuery,
  GetAccountingPeriodGetterQueryVariables
>;
export const GetAccountingFileDealerReportDocument = gql`
  query GetAccountingFileDealerReport(
    $DealerId: ID!
    $repType: getFileDealerReportRepType
    $firstPartPeriodId: ID
    $secondPartPeriodId: ID
  ) {
    AccountingGetter {
      getFileDealerReport(
        DealerId: $DealerId
        repType: $repType
        firstPartPeriodId: $firstPartPeriodId
        secondPartPeriodId: $secondPartPeriodId
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetAccountingFileDealerReportQuery__
 *
 * To run a query within a React component, call `useGetAccountingFileDealerReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountingFileDealerReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountingFileDealerReportQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      repType: // value for 'repType'
 *      firstPartPeriodId: // value for 'firstPartPeriodId'
 *      secondPartPeriodId: // value for 'secondPartPeriodId'
 *   },
 * });
 */
export function useGetAccountingFileDealerReportQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAccountingFileDealerReportQuery,
    GetAccountingFileDealerReportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAccountingFileDealerReportQuery,
    GetAccountingFileDealerReportQueryVariables
  >(GetAccountingFileDealerReportDocument, options);
}
export function useGetAccountingFileDealerReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccountingFileDealerReportQuery,
    GetAccountingFileDealerReportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccountingFileDealerReportQuery,
    GetAccountingFileDealerReportQueryVariables
  >(GetAccountingFileDealerReportDocument, options);
}
export type GetAccountingFileDealerReportQueryHookResult = ReturnType<
  typeof useGetAccountingFileDealerReportQuery
>;
export type GetAccountingFileDealerReportLazyQueryHookResult = ReturnType<
  typeof useGetAccountingFileDealerReportLazyQuery
>;
export type GetAccountingFileDealerReportQueryResult = Apollo.QueryResult<
  GetAccountingFileDealerReportQuery,
  GetAccountingFileDealerReportQueryVariables
>;
export const GetAccountingFileDealerMonitoringDocument = gql`
  query GetAccountingFileDealerMonitoring(
    $DealerIds: [ID]
    $toYear: Int
    $fromYear: Int
    $fromQuarter: Int
    $toQuarter: Int
  ) {
    AccountingGetter {
      getFileDealerMonitoring(
        DealerIds: $DealerIds
        toYear: $toYear
        fromYear: $fromYear
        fromQuarter: $fromQuarter
        toQuarter: $toQuarter
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetAccountingFileDealerMonitoringQuery__
 *
 * To run a query within a React component, call `useGetAccountingFileDealerMonitoringQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountingFileDealerMonitoringQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountingFileDealerMonitoringQuery({
 *   variables: {
 *      DealerIds: // value for 'DealerIds'
 *      toYear: // value for 'toYear'
 *      fromYear: // value for 'fromYear'
 *      fromQuarter: // value for 'fromQuarter'
 *      toQuarter: // value for 'toQuarter'
 *   },
 * });
 */
export function useGetAccountingFileDealerMonitoringQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAccountingFileDealerMonitoringQuery,
    GetAccountingFileDealerMonitoringQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAccountingFileDealerMonitoringQuery,
    GetAccountingFileDealerMonitoringQueryVariables
  >(GetAccountingFileDealerMonitoringDocument, options);
}
export function useGetAccountingFileDealerMonitoringLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccountingFileDealerMonitoringQuery,
    GetAccountingFileDealerMonitoringQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccountingFileDealerMonitoringQuery,
    GetAccountingFileDealerMonitoringQueryVariables
  >(GetAccountingFileDealerMonitoringDocument, options);
}
export type GetAccountingFileDealerMonitoringQueryHookResult = ReturnType<
  typeof useGetAccountingFileDealerMonitoringQuery
>;
export type GetAccountingFileDealerMonitoringLazyQueryHookResult = ReturnType<
  typeof useGetAccountingFileDealerMonitoringLazyQuery
>;
export type GetAccountingFileDealerMonitoringQueryResult = Apollo.QueryResult<
  GetAccountingFileDealerMonitoringQuery,
  GetAccountingFileDealerMonitoringQueryVariables
>;
export const GetAccountingConditionsDocument = gql`
  query GetAccountingConditions(
    $DealerIds: [ID]
    $toYear: Int
    $fromYear: Int
    $fromQuarter: Int
    $toQuarter: Int
  ) {
    AccountingGetter {
      getFileDealerConditions(
        DealerIds: $DealerIds
        toYear: $toYear
        fromYear: $fromYear
        fromQuarter: $fromQuarter
        toQuarter: $toQuarter
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetAccountingConditionsQuery__
 *
 * To run a query within a React component, call `useGetAccountingConditionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountingConditionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountingConditionsQuery({
 *   variables: {
 *      DealerIds: // value for 'DealerIds'
 *      toYear: // value for 'toYear'
 *      fromYear: // value for 'fromYear'
 *      fromQuarter: // value for 'fromQuarter'
 *      toQuarter: // value for 'toQuarter'
 *   },
 * });
 */
export function useGetAccountingConditionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAccountingConditionsQuery,
    GetAccountingConditionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAccountingConditionsQuery,
    GetAccountingConditionsQueryVariables
  >(GetAccountingConditionsDocument, options);
}
export function useGetAccountingConditionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccountingConditionsQuery,
    GetAccountingConditionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccountingConditionsQuery,
    GetAccountingConditionsQueryVariables
  >(GetAccountingConditionsDocument, options);
}
export type GetAccountingConditionsQueryHookResult = ReturnType<
  typeof useGetAccountingConditionsQuery
>;
export type GetAccountingConditionsLazyQueryHookResult = ReturnType<
  typeof useGetAccountingConditionsLazyQuery
>;
export type GetAccountingConditionsQueryResult = Apollo.QueryResult<
  GetAccountingConditionsQuery,
  GetAccountingConditionsQueryVariables
>;
export const GetAccountingFileDealerConditionsDocument = gql`
  query GetAccountingFileDealerConditions(
    $DealerIds: [ID]
    $columns: [AccountingReportColumn]
    $PeriodId: ID
  ) {
    AccountingGetter {
      getFileReportFileColumns(
        DealerIds: $DealerIds
        columns: $columns
        PeriodId: $PeriodId
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetAccountingFileDealerConditionsQuery__
 *
 * To run a query within a React component, call `useGetAccountingFileDealerConditionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountingFileDealerConditionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountingFileDealerConditionsQuery({
 *   variables: {
 *      DealerIds: // value for 'DealerIds'
 *      columns: // value for 'columns'
 *      PeriodId: // value for 'PeriodId'
 *   },
 * });
 */
export function useGetAccountingFileDealerConditionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAccountingFileDealerConditionsQuery,
    GetAccountingFileDealerConditionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAccountingFileDealerConditionsQuery,
    GetAccountingFileDealerConditionsQueryVariables
  >(GetAccountingFileDealerConditionsDocument, options);
}
export function useGetAccountingFileDealerConditionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccountingFileDealerConditionsQuery,
    GetAccountingFileDealerConditionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccountingFileDealerConditionsQuery,
    GetAccountingFileDealerConditionsQueryVariables
  >(GetAccountingFileDealerConditionsDocument, options);
}
export type GetAccountingFileDealerConditionsQueryHookResult = ReturnType<
  typeof useGetAccountingFileDealerConditionsQuery
>;
export type GetAccountingFileDealerConditionsLazyQueryHookResult = ReturnType<
  typeof useGetAccountingFileDealerConditionsLazyQuery
>;
export type GetAccountingFileDealerConditionsQueryResult = Apollo.QueryResult<
  GetAccountingFileDealerConditionsQuery,
  GetAccountingFileDealerConditionsQueryVariables
>;
export const GetAnnouncementListDocument = gql`
  query GetAnnouncementList(
    $page: Int
    $count: Int
    $singedBy: String
    $title: String
    $text: String
    $createdAtFrom: DateTime
    $createdAtTo: DateTime
    $importance: String
    $status: AnnouncementStatus
  ) {
    AnnouncementGetter {
      get(
        page: $page
        count: $count
        singedBy: $singedBy
        title: $title
        text: $text
        createdAtFrom: $createdAtFrom
        createdAtTo: $createdAtTo
        importance: $importance
        status: $status
      ) {
        items {
          ... on Announcement {
            ...fragmentAnnouncement
          }
        }
        total
      }
    }
  }
  ${FragmentAnnouncementFragmentDoc}
`;

/**
 * __useGetAnnouncementListQuery__
 *
 * To run a query within a React component, call `useGetAnnouncementListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnouncementListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnouncementListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      singedBy: // value for 'singedBy'
 *      title: // value for 'title'
 *      text: // value for 'text'
 *      createdAtFrom: // value for 'createdAtFrom'
 *      createdAtTo: // value for 'createdAtTo'
 *      importance: // value for 'importance'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetAnnouncementListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAnnouncementListQuery,
    GetAnnouncementListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAnnouncementListQuery,
    GetAnnouncementListQueryVariables
  >(GetAnnouncementListDocument, options);
}
export function useGetAnnouncementListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAnnouncementListQuery,
    GetAnnouncementListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAnnouncementListQuery,
    GetAnnouncementListQueryVariables
  >(GetAnnouncementListDocument, options);
}
export type GetAnnouncementListQueryHookResult = ReturnType<
  typeof useGetAnnouncementListQuery
>;
export type GetAnnouncementListLazyQueryHookResult = ReturnType<
  typeof useGetAnnouncementListLazyQuery
>;
export type GetAnnouncementListQueryResult = Apollo.QueryResult<
  GetAnnouncementListQuery,
  GetAnnouncementListQueryVariables
>;
export const GetAnnouncementGetOneDocument = gql`
  query GetAnnouncementGetOne($id: ID!) {
    AnnouncementGetter {
      getOne(id: $id) {
        ... on Announcement {
          ...fragmentAnnouncement
        }
      }
    }
  }
  ${FragmentAnnouncementFragmentDoc}
`;

/**
 * __useGetAnnouncementGetOneQuery__
 *
 * To run a query within a React component, call `useGetAnnouncementGetOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnouncementGetOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnouncementGetOneQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAnnouncementGetOneQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAnnouncementGetOneQuery,
    GetAnnouncementGetOneQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAnnouncementGetOneQuery,
    GetAnnouncementGetOneQueryVariables
  >(GetAnnouncementGetOneDocument, options);
}
export function useGetAnnouncementGetOneLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAnnouncementGetOneQuery,
    GetAnnouncementGetOneQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAnnouncementGetOneQuery,
    GetAnnouncementGetOneQueryVariables
  >(GetAnnouncementGetOneDocument, options);
}
export type GetAnnouncementGetOneQueryHookResult = ReturnType<
  typeof useGetAnnouncementGetOneQuery
>;
export type GetAnnouncementGetOneLazyQueryHookResult = ReturnType<
  typeof useGetAnnouncementGetOneLazyQuery
>;
export type GetAnnouncementGetOneQueryResult = Apollo.QueryResult<
  GetAnnouncementGetOneQuery,
  GetAnnouncementGetOneQueryVariables
>;
export const GetCameraZonesDocument = gql`
  query GetCameraZones($page: Int, $count: Int, $dealerId: ID) {
    CameraGetter {
      getCameraZones(page: $page, count: $count, dealerId: $dealerId) {
        ...CameraZonesList
      }
    }
  }
  ${CameraZonesListFragmentDoc}
`;

/**
 * __useGetCameraZonesQuery__
 *
 * To run a query within a React component, call `useGetCameraZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCameraZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCameraZonesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      dealerId: // value for 'dealerId'
 *   },
 * });
 */
export function useGetCameraZonesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCameraZonesQuery,
    GetCameraZonesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCameraZonesQuery, GetCameraZonesQueryVariables>(
    GetCameraZonesDocument,
    options,
  );
}
export function useGetCameraZonesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCameraZonesQuery,
    GetCameraZonesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCameraZonesQuery, GetCameraZonesQueryVariables>(
    GetCameraZonesDocument,
    options,
  );
}
export type GetCameraZonesQueryHookResult = ReturnType<
  typeof useGetCameraZonesQuery
>;
export type GetCameraZonesLazyQueryHookResult = ReturnType<
  typeof useGetCameraZonesLazyQuery
>;
export type GetCameraZonesQueryResult = Apollo.QueryResult<
  GetCameraZonesQuery,
  GetCameraZonesQueryVariables
>;
export const GetCameraZoneByIdDocument = gql`
  query GetCameraZoneById($id: ID) {
    CameraGetter {
      getCameraZone(id: $id) {
        ...CameraZone
      }
    }
  }
  ${CameraZoneFragmentDoc}
`;

/**
 * __useGetCameraZoneByIdQuery__
 *
 * To run a query within a React component, call `useGetCameraZoneByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCameraZoneByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCameraZoneByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCameraZoneByIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCameraZoneByIdQuery,
    GetCameraZoneByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCameraZoneByIdQuery,
    GetCameraZoneByIdQueryVariables
  >(GetCameraZoneByIdDocument, options);
}
export function useGetCameraZoneByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCameraZoneByIdQuery,
    GetCameraZoneByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCameraZoneByIdQuery,
    GetCameraZoneByIdQueryVariables
  >(GetCameraZoneByIdDocument, options);
}
export type GetCameraZoneByIdQueryHookResult = ReturnType<
  typeof useGetCameraZoneByIdQuery
>;
export type GetCameraZoneByIdLazyQueryHookResult = ReturnType<
  typeof useGetCameraZoneByIdLazyQuery
>;
export type GetCameraZoneByIdQueryResult = Apollo.QueryResult<
  GetCameraZoneByIdQuery,
  GetCameraZoneByIdQueryVariables
>;
export const GetCameraByIdDocument = gql`
  query GetCameraById($id: ID) {
    CameraGetter {
      getCamera(id: $id) {
        ...Camera
      }
    }
  }
  ${CameraFragmentDoc}
`;

/**
 * __useGetCameraByIdQuery__
 *
 * To run a query within a React component, call `useGetCameraByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCameraByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCameraByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCameraByIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCameraByIdQuery,
    GetCameraByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCameraByIdQuery, GetCameraByIdQueryVariables>(
    GetCameraByIdDocument,
    options,
  );
}
export function useGetCameraByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCameraByIdQuery,
    GetCameraByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCameraByIdQuery, GetCameraByIdQueryVariables>(
    GetCameraByIdDocument,
    options,
  );
}
export type GetCameraByIdQueryHookResult = ReturnType<
  typeof useGetCameraByIdQuery
>;
export type GetCameraByIdLazyQueryHookResult = ReturnType<
  typeof useGetCameraByIdLazyQuery
>;
export type GetCameraByIdQueryResult = Apollo.QueryResult<
  GetCameraByIdQuery,
  GetCameraByIdQueryVariables
>;
export const GetCameraListDocument = gql`
  query GetCameraList(
    $count: Int
    $page: Int
    $cameraZoneId: ID
    $dialerId: ID
  ) {
    CameraGetter {
      getCameras(
        page: $page
        count: $count
        cameraZoneId: $cameraZoneId
        dialerId: $dialerId
      ) {
        items {
          ...Camera
        }
        total
      }
    }
  }
  ${CameraFragmentDoc}
`;

/**
 * __useGetCameraListQuery__
 *
 * To run a query within a React component, call `useGetCameraListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCameraListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCameraListQuery({
 *   variables: {
 *      count: // value for 'count'
 *      page: // value for 'page'
 *      cameraZoneId: // value for 'cameraZoneId'
 *      dialerId: // value for 'dialerId'
 *   },
 * });
 */
export function useGetCameraListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCameraListQuery,
    GetCameraListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCameraListQuery, GetCameraListQueryVariables>(
    GetCameraListDocument,
    options,
  );
}
export function useGetCameraListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCameraListQuery,
    GetCameraListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCameraListQuery, GetCameraListQueryVariables>(
    GetCameraListDocument,
    options,
  );
}
export type GetCameraListQueryHookResult = ReturnType<
  typeof useGetCameraListQuery
>;
export type GetCameraListLazyQueryHookResult = ReturnType<
  typeof useGetCameraListLazyQuery
>;
export type GetCameraListQueryResult = Apollo.QueryResult<
  GetCameraListQuery,
  GetCameraListQueryVariables
>;
export const GetCameraVideoDocument = gql`
  query GetCameraVideo($cameraId: ID) {
    CameraGetter {
      getCameraVideo(cameraId: $cameraId) {
        cameraId
        pid
        url
        type
      }
    }
  }
`;

/**
 * __useGetCameraVideoQuery__
 *
 * To run a query within a React component, call `useGetCameraVideoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCameraVideoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCameraVideoQuery({
 *   variables: {
 *      cameraId: // value for 'cameraId'
 *   },
 * });
 */
export function useGetCameraVideoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCameraVideoQuery,
    GetCameraVideoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCameraVideoQuery, GetCameraVideoQueryVariables>(
    GetCameraVideoDocument,
    options,
  );
}
export function useGetCameraVideoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCameraVideoQuery,
    GetCameraVideoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCameraVideoQuery, GetCameraVideoQueryVariables>(
    GetCameraVideoDocument,
    options,
  );
}
export type GetCameraVideoQueryHookResult = ReturnType<
  typeof useGetCameraVideoQuery
>;
export type GetCameraVideoLazyQueryHookResult = ReturnType<
  typeof useGetCameraVideoLazyQuery
>;
export type GetCameraVideoQueryResult = Apollo.QueryResult<
  GetCameraVideoQuery,
  GetCameraVideoQueryVariables
>;
export const GetCameraCheckListDocument = gql`
  query GetCameraCheckList(
    $cameraId: ID
    $page: Int
    $count: Int
    $status: CameraCheckStatus
  ) {
    CameraGetter {
      getCameraChecks(
        cameraId: $cameraId
        page: $page
        count: $count
        status: $status
      ) {
        total
        items {
          ...CameraCheck
        }
      }
    }
  }
  ${CameraCheckFragmentDoc}
`;

/**
 * __useGetCameraCheckListQuery__
 *
 * To run a query within a React component, call `useGetCameraCheckListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCameraCheckListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCameraCheckListQuery({
 *   variables: {
 *      cameraId: // value for 'cameraId'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetCameraCheckListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCameraCheckListQuery,
    GetCameraCheckListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCameraCheckListQuery,
    GetCameraCheckListQueryVariables
  >(GetCameraCheckListDocument, options);
}
export function useGetCameraCheckListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCameraCheckListQuery,
    GetCameraCheckListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCameraCheckListQuery,
    GetCameraCheckListQueryVariables
  >(GetCameraCheckListDocument, options);
}
export type GetCameraCheckListQueryHookResult = ReturnType<
  typeof useGetCameraCheckListQuery
>;
export type GetCameraCheckListLazyQueryHookResult = ReturnType<
  typeof useGetCameraCheckListLazyQuery
>;
export type GetCameraCheckListQueryResult = Apollo.QueryResult<
  GetCameraCheckListQuery,
  GetCameraCheckListQueryVariables
>;
export const GetCameraCheckByIdDocument = gql`
  query GetCameraCheckById($id: ID) {
    CameraGetter {
      getCameraCheck(id: $id) {
        ...CameraCheck
      }
    }
  }
  ${CameraCheckFragmentDoc}
`;

/**
 * __useGetCameraCheckByIdQuery__
 *
 * To run a query within a React component, call `useGetCameraCheckByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCameraCheckByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCameraCheckByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCameraCheckByIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCameraCheckByIdQuery,
    GetCameraCheckByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCameraCheckByIdQuery,
    GetCameraCheckByIdQueryVariables
  >(GetCameraCheckByIdDocument, options);
}
export function useGetCameraCheckByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCameraCheckByIdQuery,
    GetCameraCheckByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCameraCheckByIdQuery,
    GetCameraCheckByIdQueryVariables
  >(GetCameraCheckByIdDocument, options);
}
export type GetCameraCheckByIdQueryHookResult = ReturnType<
  typeof useGetCameraCheckByIdQuery
>;
export type GetCameraCheckByIdLazyQueryHookResult = ReturnType<
  typeof useGetCameraCheckByIdLazyQuery
>;
export type GetCameraCheckByIdQueryResult = Apollo.QueryResult<
  GetCameraCheckByIdQuery,
  GetCameraCheckByIdQueryVariables
>;
export const CheckListCommentGetterDocument = gql`
  query CheckListCommentGetter($checkListId: ID!) {
    CheckListCommentGetter {
      getCheckListComments(CheckListId: $checkListId) {
        id
        text
        author
        createdAt
        CheckListId
      }
    }
  }
`;

/**
 * __useCheckListCommentGetterQuery__
 *
 * To run a query within a React component, call `useCheckListCommentGetterQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckListCommentGetterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckListCommentGetterQuery({
 *   variables: {
 *      checkListId: // value for 'checkListId'
 *   },
 * });
 */
export function useCheckListCommentGetterQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckListCommentGetterQuery,
    CheckListCommentGetterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CheckListCommentGetterQuery,
    CheckListCommentGetterQueryVariables
  >(CheckListCommentGetterDocument, options);
}
export function useCheckListCommentGetterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckListCommentGetterQuery,
    CheckListCommentGetterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckListCommentGetterQuery,
    CheckListCommentGetterQueryVariables
  >(CheckListCommentGetterDocument, options);
}
export type CheckListCommentGetterQueryHookResult = ReturnType<
  typeof useCheckListCommentGetterQuery
>;
export type CheckListCommentGetterLazyQueryHookResult = ReturnType<
  typeof useCheckListCommentGetterLazyQuery
>;
export type CheckListCommentGetterQueryResult = Apollo.QueryResult<
  CheckListCommentGetterQuery,
  CheckListCommentGetterQueryVariables
>;
export const CheckListGetterDocument = gql`
  query CheckListGetter(
    $dealerAutoCrmid: ID!
    $page: Int
    $count: Int
    $sort: [sortInputType]
    $departmentIds: [ID!]
    $isDeleted: Boolean!
  ) {
    CheckListGetter {
      getCheckLists(
        DealerAutoCRMID: $dealerAutoCrmid
        page: $page
        count: $count
        sort: $sort
        DepartmentIds: $departmentIds
        isDeleted: $isDeleted
      ) {
        total
        pages
        items {
          id
          externalCode
          isDeleted
          name
          overdueTasks
          inWorkTasks
          completedTasks
          actualPoints
          maxPoints
          DealerAutoCRMID
          DepartmentId
          createdAt
          DealerName
          result
          Indicators {
            name
            actualPoints
            maxPoints
            CheckListId
          }
          Comments {
            id
            text
            author
            createdAt
            CheckListId
          }
          result
          actionPlanId
          actionPlanDate
        }
      }
    }
  }
`;

/**
 * __useCheckListGetterQuery__
 *
 * To run a query within a React component, call `useCheckListGetterQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckListGetterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckListGetterQuery({
 *   variables: {
 *      dealerAutoCrmid: // value for 'dealerAutoCrmid'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      sort: // value for 'sort'
 *      departmentIds: // value for 'departmentIds'
 *      isDeleted: // value for 'isDeleted'
 *   },
 * });
 */
export function useCheckListGetterQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckListGetterQuery,
    CheckListGetterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckListGetterQuery, CheckListGetterQueryVariables>(
    CheckListGetterDocument,
    options,
  );
}
export function useCheckListGetterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckListGetterQuery,
    CheckListGetterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckListGetterQuery,
    CheckListGetterQueryVariables
  >(CheckListGetterDocument, options);
}
export type CheckListGetterQueryHookResult = ReturnType<
  typeof useCheckListGetterQuery
>;
export type CheckListGetterLazyQueryHookResult = ReturnType<
  typeof useCheckListGetterLazyQuery
>;
export type CheckListGetterQueryResult = Apollo.QueryResult<
  CheckListGetterQuery,
  CheckListGetterQueryVariables
>;
export const GetCheckListDocument = gql`
  query GetCheckList($getCheckListId: ID!) {
    CheckListGetter {
      getCheckList(id: $getCheckListId) {
        id
        externalCode
        isDeleted
        name
        DepartmentId
        overdueTasks
        inWorkTasks
        completedTasks
        actualPoints
        maxPoints
        DealerAutoCRMID
        createdAt
        DealerName
        Indicators {
          name
          actualPoints
          maxPoints
          CheckListId
        }
        Comments {
          id
          text
          author
          createdAt
          CheckListId
        }
        actionPlanId
      }
    }
  }
`;

/**
 * __useGetCheckListQuery__
 *
 * To run a query within a React component, call `useGetCheckListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckListQuery({
 *   variables: {
 *      getCheckListId: // value for 'getCheckListId'
 *   },
 * });
 */
export function useGetCheckListQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCheckListQuery,
    GetCheckListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCheckListQuery, GetCheckListQueryVariables>(
    GetCheckListDocument,
    options,
  );
}
export function useGetCheckListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCheckListQuery,
    GetCheckListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCheckListQuery, GetCheckListQueryVariables>(
    GetCheckListDocument,
    options,
  );
}
export type GetCheckListQueryHookResult = ReturnType<
  typeof useGetCheckListQuery
>;
export type GetCheckListLazyQueryHookResult = ReturnType<
  typeof useGetCheckListLazyQuery
>;
export type GetCheckListQueryResult = Apollo.QueryResult<
  GetCheckListQuery,
  GetCheckListQueryVariables
>;
export const GetCheckListIndicatorStatsDocument = gql`
  query GetCheckListIndicatorStats(
    $dealerAutoCrmid: ID!
    $departmentIds: [ID!]
  ) {
    CheckListIndicatorGetter {
      getCheckListIndicatorStats(
        DealerAutoCRMID: $dealerAutoCrmid
        DepartmentIds: $departmentIds
      ) {
        name
        value
      }
    }
  }
`;

/**
 * __useGetCheckListIndicatorStatsQuery__
 *
 * To run a query within a React component, call `useGetCheckListIndicatorStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckListIndicatorStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckListIndicatorStatsQuery({
 *   variables: {
 *      dealerAutoCrmid: // value for 'dealerAutoCrmid'
 *      departmentIds: // value for 'departmentIds'
 *   },
 * });
 */
export function useGetCheckListIndicatorStatsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCheckListIndicatorStatsQuery,
    GetCheckListIndicatorStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCheckListIndicatorStatsQuery,
    GetCheckListIndicatorStatsQueryVariables
  >(GetCheckListIndicatorStatsDocument, options);
}
export function useGetCheckListIndicatorStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCheckListIndicatorStatsQuery,
    GetCheckListIndicatorStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCheckListIndicatorStatsQuery,
    GetCheckListIndicatorStatsQueryVariables
  >(GetCheckListIndicatorStatsDocument, options);
}
export type GetCheckListIndicatorStatsQueryHookResult = ReturnType<
  typeof useGetCheckListIndicatorStatsQuery
>;
export type GetCheckListIndicatorStatsLazyQueryHookResult = ReturnType<
  typeof useGetCheckListIndicatorStatsLazyQuery
>;
export type GetCheckListIndicatorStatsQueryResult = Apollo.QueryResult<
  GetCheckListIndicatorStatsQuery,
  GetCheckListIndicatorStatsQueryVariables
>;
export const GetContractTemplatesDocument = gql`
  query GetContractTemplates(
    $page: Int
    $count: Int
    $sort: [sortInputType]
    $isActive: Boolean
  ) {
    ContractTemplateGetter {
      getContractTemplates(
        page: $page
        count: $count
        sort: $sort
        isActive: $isActive
      ) {
        items {
          id
          name
          active
          FileId
          createdAt
          updatedAt
          File {
            id
            name
            link
            mimeType
            createdAt
            type
            hash
          }
        }
        pages
        total
      }
    }
  }
`;

/**
 * __useGetContractTemplatesQuery__
 *
 * To run a query within a React component, call `useGetContractTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractTemplatesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      sort: // value for 'sort'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useGetContractTemplatesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetContractTemplatesQuery,
    GetContractTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetContractTemplatesQuery,
    GetContractTemplatesQueryVariables
  >(GetContractTemplatesDocument, options);
}
export function useGetContractTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetContractTemplatesQuery,
    GetContractTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetContractTemplatesQuery,
    GetContractTemplatesQueryVariables
  >(GetContractTemplatesDocument, options);
}
export type GetContractTemplatesQueryHookResult = ReturnType<
  typeof useGetContractTemplatesQuery
>;
export type GetContractTemplatesLazyQueryHookResult = ReturnType<
  typeof useGetContractTemplatesLazyQuery
>;
export type GetContractTemplatesQueryResult = Apollo.QueryResult<
  GetContractTemplatesQuery,
  GetContractTemplatesQueryVariables
>;
export const GetContractTemplateAllowFieldsDocument = gql`
  query GetContractTemplateAllowFields {
    ContractTemplateGetter {
      getContractTemplateAllowFields {
        field
        comment
      }
    }
  }
`;

/**
 * __useGetContractTemplateAllowFieldsQuery__
 *
 * To run a query within a React component, call `useGetContractTemplateAllowFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractTemplateAllowFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractTemplateAllowFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContractTemplateAllowFieldsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetContractTemplateAllowFieldsQuery,
    GetContractTemplateAllowFieldsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetContractTemplateAllowFieldsQuery,
    GetContractTemplateAllowFieldsQueryVariables
  >(GetContractTemplateAllowFieldsDocument, options);
}
export function useGetContractTemplateAllowFieldsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetContractTemplateAllowFieldsQuery,
    GetContractTemplateAllowFieldsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetContractTemplateAllowFieldsQuery,
    GetContractTemplateAllowFieldsQueryVariables
  >(GetContractTemplateAllowFieldsDocument, options);
}
export type GetContractTemplateAllowFieldsQueryHookResult = ReturnType<
  typeof useGetContractTemplateAllowFieldsQuery
>;
export type GetContractTemplateAllowFieldsLazyQueryHookResult = ReturnType<
  typeof useGetContractTemplateAllowFieldsLazyQuery
>;
export type GetContractTemplateAllowFieldsQueryResult = Apollo.QueryResult<
  GetContractTemplateAllowFieldsQuery,
  GetContractTemplateAllowFieldsQueryVariables
>;
export const GetDealersDocument = gql`
  query GetDealers(
    $page: Int
    $count: Int
    $search: DealerSearch
    $sortField: String
    $sortType: String
    $getAll: Boolean = false
    $archivePeriodId: ID
    $doSearchArchive: Boolean = false
  ) {
    DealerGetter {
      getDealers(
        page: $page
        count: $count
        search: $search
        sortField: $sortField
        sortType: $sortType
        getAll: $getAll
        archivePeriodId: $archivePeriodId
        doSearchArchive: $doSearchArchive
      ) {
        items {
          ... on Dealer {
            ...fragmentDealer
          }
        }
        total
      }
    }
  }
  ${FragmentDealerFragmentDoc}
`;

/**
 * __useGetDealersQuery__
 *
 * To run a query within a React component, call `useGetDealersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      search: // value for 'search'
 *      sortField: // value for 'sortField'
 *      sortType: // value for 'sortType'
 *      getAll: // value for 'getAll'
 *      archivePeriodId: // value for 'archivePeriodId'
 *      doSearchArchive: // value for 'doSearchArchive'
 *   },
 * });
 */
export function useGetDealersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDealersQuery,
    GetDealersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDealersQuery, GetDealersQueryVariables>(
    GetDealersDocument,
    options,
  );
}
export function useGetDealersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDealersQuery,
    GetDealersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDealersQuery, GetDealersQueryVariables>(
    GetDealersDocument,
    options,
  );
}
export type GetDealersQueryHookResult = ReturnType<typeof useGetDealersQuery>;
export type GetDealersLazyQueryHookResult = ReturnType<
  typeof useGetDealersLazyQuery
>;
export type GetDealersQueryResult = Apollo.QueryResult<
  GetDealersQuery,
  GetDealersQueryVariables
>;
export const GetDealersForUserDocument = gql`
  query GetDealersForUser($UserId: ID!, $page: Int, $count: Int) {
    DealerGetter {
      getDealersForUser(page: $page, count: $count, UserId: $UserId) {
        items {
          ... on Dealer {
            ...fragmentDealer
          }
        }
        total
      }
    }
  }
  ${FragmentDealerFragmentDoc}
`;

/**
 * __useGetDealersForUserQuery__
 *
 * To run a query within a React component, call `useGetDealersForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealersForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealersForUserQuery({
 *   variables: {
 *      UserId: // value for 'UserId'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetDealersForUserQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDealersForUserQuery,
    GetDealersForUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDealersForUserQuery,
    GetDealersForUserQueryVariables
  >(GetDealersForUserDocument, options);
}
export function useGetDealersForUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDealersForUserQuery,
    GetDealersForUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDealersForUserQuery,
    GetDealersForUserQueryVariables
  >(GetDealersForUserDocument, options);
}
export type GetDealersForUserQueryHookResult = ReturnType<
  typeof useGetDealersForUserQuery
>;
export type GetDealersForUserLazyQueryHookResult = ReturnType<
  typeof useGetDealersForUserLazyQuery
>;
export type GetDealersForUserQueryResult = Apollo.QueryResult<
  GetDealersForUserQuery,
  GetDealersForUserQueryVariables
>;
export const GetMyDealersDocument = gql`
  query GetMyDealers(
    $page: Int
    $count: Int
    $partName: String
    $FederalArea: String
    $FederalAreaEn: String
    $Region: String
    $RegionEn: String
    $statuses: [DealerStatus]
  ) {
    DealerGetter {
      getMyDealers(
        page: $page
        count: $count
        partName: $partName
        FederalArea: $FederalArea
        FederalAreaEn: $FederalAreaEn
        Region: $Region
        RegionEn: $RegionEn
        statuses: $statuses
      ) {
        items {
          ... on Dealer {
            ...fragmentDealershipsForSelect
          }
        }
      }
    }
  }
  ${FragmentDealershipsForSelectFragmentDoc}
`;

/**
 * __useGetMyDealersQuery__
 *
 * To run a query within a React component, call `useGetMyDealersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyDealersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyDealersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      partName: // value for 'partName'
 *      FederalArea: // value for 'FederalArea'
 *      FederalAreaEn: // value for 'FederalAreaEn'
 *      Region: // value for 'Region'
 *      RegionEn: // value for 'RegionEn'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useGetMyDealersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMyDealersQuery,
    GetMyDealersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMyDealersQuery, GetMyDealersQueryVariables>(
    GetMyDealersDocument,
    options,
  );
}
export function useGetMyDealersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMyDealersQuery,
    GetMyDealersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMyDealersQuery, GetMyDealersQueryVariables>(
    GetMyDealersDocument,
    options,
  );
}
export type GetMyDealersQueryHookResult = ReturnType<
  typeof useGetMyDealersQuery
>;
export type GetMyDealersLazyQueryHookResult = ReturnType<
  typeof useGetMyDealersLazyQuery
>;
export type GetMyDealersQueryResult = Apollo.QueryResult<
  GetMyDealersQuery,
  GetMyDealersQueryVariables
>;
export const GetMyHoldingsDocument = gql`
  query GetMyHoldings(
    $Region: String
    $RegionEn: String
    $FederalArea: String
    $FederalAreaEn: String
    $partName: String
    $status: DealerStatus
    $page: Int = 0
    $count: Int = 10
  ) {
    DealerGetter {
      getMyHoldings(
        Region: $Region
        RegionEn: $RegionEn
        FederalArea: $FederalArea
        FederalAreaEn: $FederalAreaEn
        partName: $partName
        status: $status
        page: $page
        count: $count
      ) {
        items {
          ... on Dealer {
            ...fragmentDealershipsForSelect
          }
        }
      }
    }
  }
  ${FragmentDealershipsForSelectFragmentDoc}
`;

/**
 * __useGetMyHoldingsQuery__
 *
 * To run a query within a React component, call `useGetMyHoldingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyHoldingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyHoldingsQuery({
 *   variables: {
 *      Region: // value for 'Region'
 *      RegionEn: // value for 'RegionEn'
 *      FederalArea: // value for 'FederalArea'
 *      FederalAreaEn: // value for 'FederalAreaEn'
 *      partName: // value for 'partName'
 *      status: // value for 'status'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetMyHoldingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMyHoldingsQuery,
    GetMyHoldingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMyHoldingsQuery, GetMyHoldingsQueryVariables>(
    GetMyHoldingsDocument,
    options,
  );
}
export function useGetMyHoldingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMyHoldingsQuery,
    GetMyHoldingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMyHoldingsQuery, GetMyHoldingsQueryVariables>(
    GetMyHoldingsDocument,
    options,
  );
}
export type GetMyHoldingsQueryHookResult = ReturnType<
  typeof useGetMyHoldingsQuery
>;
export type GetMyHoldingsLazyQueryHookResult = ReturnType<
  typeof useGetMyHoldingsLazyQuery
>;
export type GetMyHoldingsQueryResult = Apollo.QueryResult<
  GetMyHoldingsQuery,
  GetMyHoldingsQueryVariables
>;
export const GetDealershipsForSelectDocument = gql`
  query GetDealershipsForSelect($page: Int, $search: DealerSearch) {
    DealerGetter {
      getDealers(page: $page, count: 25, search: $search) {
        items {
          ... on Dealer {
            ...fragmentDealershipsForSelect
          }
        }
      }
    }
  }
  ${FragmentDealershipsForSelectFragmentDoc}
`;

/**
 * __useGetDealershipsForSelectQuery__
 *
 * To run a query within a React component, call `useGetDealershipsForSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealershipsForSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealershipsForSelectQuery({
 *   variables: {
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetDealershipsForSelectQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDealershipsForSelectQuery,
    GetDealershipsForSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDealershipsForSelectQuery,
    GetDealershipsForSelectQueryVariables
  >(GetDealershipsForSelectDocument, options);
}
export function useGetDealershipsForSelectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDealershipsForSelectQuery,
    GetDealershipsForSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDealershipsForSelectQuery,
    GetDealershipsForSelectQueryVariables
  >(GetDealershipsForSelectDocument, options);
}
export type GetDealershipsForSelectQueryHookResult = ReturnType<
  typeof useGetDealershipsForSelectQuery
>;
export type GetDealershipsForSelectLazyQueryHookResult = ReturnType<
  typeof useGetDealershipsForSelectLazyQuery
>;
export type GetDealershipsForSelectQueryResult = Apollo.QueryResult<
  GetDealershipsForSelectQuery,
  GetDealershipsForSelectQueryVariables
>;
export const GetDealerListToAssignDocument = gql`
  query GetDealerListToAssign($UserId: ID!, $status: DealerStatus) {
    DealerGetter {
      getDealerListToAssign(UserId: $UserId, status: $status) {
        items {
          ... on DealerToAssign {
            ...fragmentDealerToAssign
          }
        }
      }
    }
  }
  ${FragmentDealerToAssignFragmentDoc}
`;

/**
 * __useGetDealerListToAssignQuery__
 *
 * To run a query within a React component, call `useGetDealerListToAssignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealerListToAssignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealerListToAssignQuery({
 *   variables: {
 *      UserId: // value for 'UserId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetDealerListToAssignQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDealerListToAssignQuery,
    GetDealerListToAssignQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDealerListToAssignQuery,
    GetDealerListToAssignQueryVariables
  >(GetDealerListToAssignDocument, options);
}
export function useGetDealerListToAssignLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDealerListToAssignQuery,
    GetDealerListToAssignQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDealerListToAssignQuery,
    GetDealerListToAssignQueryVariables
  >(GetDealerListToAssignDocument, options);
}
export type GetDealerListToAssignQueryHookResult = ReturnType<
  typeof useGetDealerListToAssignQuery
>;
export type GetDealerListToAssignLazyQueryHookResult = ReturnType<
  typeof useGetDealerListToAssignLazyQuery
>;
export type GetDealerListToAssignQueryResult = Apollo.QueryResult<
  GetDealerListToAssignQuery,
  GetDealerListToAssignQueryVariables
>;
export const GetDealerDocument = gql`
  query GetDealer($DealerId: ID!, $ArchivePeriodId: ID) {
    DealerGetter {
      getDealer(DealerId: $DealerId, ArchivePeriodId: $ArchivePeriodId) {
        autoCRMID
        ... on Dealer {
          ...fragmentDealer
        }
      }
    }
  }
  ${FragmentDealerFragmentDoc}
`;

/**
 * __useGetDealerQuery__
 *
 * To run a query within a React component, call `useGetDealerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealerQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      ArchivePeriodId: // value for 'ArchivePeriodId'
 *   },
 * });
 */
export function useGetDealerQuery(
  baseOptions: Apollo.QueryHookOptions<GetDealerQuery, GetDealerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDealerQuery, GetDealerQueryVariables>(
    GetDealerDocument,
    options,
  );
}
export function useGetDealerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDealerQuery,
    GetDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDealerQuery, GetDealerQueryVariables>(
    GetDealerDocument,
    options,
  );
}
export type GetDealerQueryHookResult = ReturnType<typeof useGetDealerQuery>;
export type GetDealerLazyQueryHookResult = ReturnType<
  typeof useGetDealerLazyQuery
>;
export type GetDealerQueryResult = Apollo.QueryResult<
  GetDealerQuery,
  GetDealerQueryVariables
>;
export const GetDealersFederalAreaDocument = gql`
  query GetDealersFederalArea($city: String, $cityEn: String) {
    DealerGetter {
      getDealersFederalArea(city: $city, cityEn: $cityEn) {
        items
        itemsEn
      }
    }
  }
`;

/**
 * __useGetDealersFederalAreaQuery__
 *
 * To run a query within a React component, call `useGetDealersFederalAreaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealersFederalAreaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealersFederalAreaQuery({
 *   variables: {
 *      city: // value for 'city'
 *      cityEn: // value for 'cityEn'
 *   },
 * });
 */
export function useGetDealersFederalAreaQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDealersFederalAreaQuery,
    GetDealersFederalAreaQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDealersFederalAreaQuery,
    GetDealersFederalAreaQueryVariables
  >(GetDealersFederalAreaDocument, options);
}
export function useGetDealersFederalAreaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDealersFederalAreaQuery,
    GetDealersFederalAreaQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDealersFederalAreaQuery,
    GetDealersFederalAreaQueryVariables
  >(GetDealersFederalAreaDocument, options);
}
export type GetDealersFederalAreaQueryHookResult = ReturnType<
  typeof useGetDealersFederalAreaQuery
>;
export type GetDealersFederalAreaLazyQueryHookResult = ReturnType<
  typeof useGetDealersFederalAreaLazyQuery
>;
export type GetDealersFederalAreaQueryResult = Apollo.QueryResult<
  GetDealersFederalAreaQuery,
  GetDealersFederalAreaQueryVariables
>;
export const GetDealersRegionsDocument = gql`
  query GetDealersRegions($status: DealerStatus) {
    DealerGetter {
      getDealersRegions(status: $status) {
        items
        itemsEn
      }
    }
  }
`;

/**
 * __useGetDealersRegionsQuery__
 *
 * To run a query within a React component, call `useGetDealersRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealersRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealersRegionsQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetDealersRegionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDealersRegionsQuery,
    GetDealersRegionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDealersRegionsQuery,
    GetDealersRegionsQueryVariables
  >(GetDealersRegionsDocument, options);
}
export function useGetDealersRegionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDealersRegionsQuery,
    GetDealersRegionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDealersRegionsQuery,
    GetDealersRegionsQueryVariables
  >(GetDealersRegionsDocument, options);
}
export type GetDealersRegionsQueryHookResult = ReturnType<
  typeof useGetDealersRegionsQuery
>;
export type GetDealersRegionsLazyQueryHookResult = ReturnType<
  typeof useGetDealersRegionsLazyQuery
>;
export type GetDealersRegionsQueryResult = Apollo.QueryResult<
  GetDealersRegionsQuery,
  GetDealersRegionsQueryVariables
>;
export const GetDealersCitiesDocument = gql`
  query GetDealersCities($FOEn: String, $FO: String, $status: DealerStatus) {
    DealerGetter {
      getDealersCities(FOEn: $FOEn, FO: $FO, status: $status) {
        items
        itemsEn
      }
    }
  }
`;

/**
 * __useGetDealersCitiesQuery__
 *
 * To run a query within a React component, call `useGetDealersCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealersCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealersCitiesQuery({
 *   variables: {
 *      FOEn: // value for 'FOEn'
 *      FO: // value for 'FO'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetDealersCitiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDealersCitiesQuery,
    GetDealersCitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDealersCitiesQuery, GetDealersCitiesQueryVariables>(
    GetDealersCitiesDocument,
    options,
  );
}
export function useGetDealersCitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDealersCitiesQuery,
    GetDealersCitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDealersCitiesQuery,
    GetDealersCitiesQueryVariables
  >(GetDealersCitiesDocument, options);
}
export type GetDealersCitiesQueryHookResult = ReturnType<
  typeof useGetDealersCitiesQuery
>;
export type GetDealersCitiesLazyQueryHookResult = ReturnType<
  typeof useGetDealersCitiesLazyQuery
>;
export type GetDealersCitiesQueryResult = Apollo.QueryResult<
  GetDealersCitiesQuery,
  GetDealersCitiesQueryVariables
>;
export const GetDealersLocationItemDocument = gql`
  query GetDealersLocationItem(
    $item: DealersLocationItem
    $city: String
    $cityEn: String
    $FOEn: String
    $FO: String
    $subject: String
    $subjectEn: String
    $country: String
    $countryEn: String
  ) {
    DealerGetter {
      getDealersLocationItem(
        item: $item
        FOEn: $FOEn
        FO: $FO
        city: $city
        cityEn: $cityEn
        subject: $subject
        subjectEn: $subjectEn
        country: $country
        countryEn: $countryEn
      ) {
        items
        itemsEn
      }
    }
  }
`;

/**
 * __useGetDealersLocationItemQuery__
 *
 * To run a query within a React component, call `useGetDealersLocationItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealersLocationItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealersLocationItemQuery({
 *   variables: {
 *      item: // value for 'item'
 *      city: // value for 'city'
 *      cityEn: // value for 'cityEn'
 *      FOEn: // value for 'FOEn'
 *      FO: // value for 'FO'
 *      subject: // value for 'subject'
 *      subjectEn: // value for 'subjectEn'
 *      country: // value for 'country'
 *      countryEn: // value for 'countryEn'
 *   },
 * });
 */
export function useGetDealersLocationItemQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDealersLocationItemQuery,
    GetDealersLocationItemQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDealersLocationItemQuery,
    GetDealersLocationItemQueryVariables
  >(GetDealersLocationItemDocument, options);
}
export function useGetDealersLocationItemLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDealersLocationItemQuery,
    GetDealersLocationItemQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDealersLocationItemQuery,
    GetDealersLocationItemQueryVariables
  >(GetDealersLocationItemDocument, options);
}
export type GetDealersLocationItemQueryHookResult = ReturnType<
  typeof useGetDealersLocationItemQuery
>;
export type GetDealersLocationItemLazyQueryHookResult = ReturnType<
  typeof useGetDealersLocationItemLazyQuery
>;
export type GetDealersLocationItemQueryResult = Apollo.QueryResult<
  GetDealersLocationItemQuery,
  GetDealersLocationItemQueryVariables
>;
export const GetDealerPanelDocument = gql`
  query GetDealerPanel($DealerId: ID!) {
    DealerGetter {
      getDealer(DealerId: $DealerId) {
        ... on Dealer {
          ...fragmentDealerPanel
        }
      }
    }
  }
  ${FragmentDealerPanelFragmentDoc}
`;

/**
 * __useGetDealerPanelQuery__
 *
 * To run a query within a React component, call `useGetDealerPanelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealerPanelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealerPanelQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *   },
 * });
 */
export function useGetDealerPanelQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDealerPanelQuery,
    GetDealerPanelQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDealerPanelQuery, GetDealerPanelQueryVariables>(
    GetDealerPanelDocument,
    options,
  );
}
export function useGetDealerPanelLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDealerPanelQuery,
    GetDealerPanelQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDealerPanelQuery, GetDealerPanelQueryVariables>(
    GetDealerPanelDocument,
    options,
  );
}
export type GetDealerPanelQueryHookResult = ReturnType<
  typeof useGetDealerPanelQuery
>;
export type GetDealerPanelLazyQueryHookResult = ReturnType<
  typeof useGetDealerPanelLazyQuery
>;
export type GetDealerPanelQueryResult = Apollo.QueryResult<
  GetDealerPanelQuery,
  GetDealerPanelQueryVariables
>;
export const GetDealerInfoDocument = gql`
  query GetDealerInfo($DealerId: ID!, $ActualOn: DateTime) {
    DealerGetter {
      getAreaDealer(DealerId: $DealerId, ActualOn: $ActualOn) {
        ... on DealerArea {
          ...fragmentDealerArea
        }
      }
    }
  }
  ${FragmentDealerAreaFragmentDoc}
`;

/**
 * __useGetDealerInfoQuery__
 *
 * To run a query within a React component, call `useGetDealerInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealerInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealerInfoQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      ActualOn: // value for 'ActualOn'
 *   },
 * });
 */
export function useGetDealerInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDealerInfoQuery,
    GetDealerInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDealerInfoQuery, GetDealerInfoQueryVariables>(
    GetDealerInfoDocument,
    options,
  );
}
export function useGetDealerInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDealerInfoQuery,
    GetDealerInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDealerInfoQuery, GetDealerInfoQueryVariables>(
    GetDealerInfoDocument,
    options,
  );
}
export type GetDealerInfoQueryHookResult = ReturnType<
  typeof useGetDealerInfoQuery
>;
export type GetDealerInfoLazyQueryHookResult = ReturnType<
  typeof useGetDealerInfoLazyQuery
>;
export type GetDealerInfoQueryResult = Apollo.QueryResult<
  GetDealerInfoQuery,
  GetDealerInfoQueryVariables
>;
export const GetProjectDocumentationDealerDocument = gql`
  query getProjectDocumentationDealer($DealerId: ID!) {
    DealerGetter {
      getProjectDocumentationDealer(DealerId: $DealerId) {
        id
        name
        File {
          id
          name
          link
          mimeType
        }
        ActualFrom
        status
        ActualTo
        createdAt
        updatedAt
      }
    }
  }
`;

/**
 * __useGetProjectDocumentationDealerQuery__
 *
 * To run a query within a React component, call `useGetProjectDocumentationDealerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectDocumentationDealerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectDocumentationDealerQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *   },
 * });
 */
export function useGetProjectDocumentationDealerQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProjectDocumentationDealerQuery,
    GetProjectDocumentationDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetProjectDocumentationDealerQuery,
    GetProjectDocumentationDealerQueryVariables
  >(GetProjectDocumentationDealerDocument, options);
}
export function useGetProjectDocumentationDealerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProjectDocumentationDealerQuery,
    GetProjectDocumentationDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProjectDocumentationDealerQuery,
    GetProjectDocumentationDealerQueryVariables
  >(GetProjectDocumentationDealerDocument, options);
}
export type GetProjectDocumentationDealerQueryHookResult = ReturnType<
  typeof useGetProjectDocumentationDealerQuery
>;
export type GetProjectDocumentationDealerLazyQueryHookResult = ReturnType<
  typeof useGetProjectDocumentationDealerLazyQuery
>;
export type GetProjectDocumentationDealerQueryResult = Apollo.QueryResult<
  GetProjectDocumentationDealerQuery,
  GetProjectDocumentationDealerQueryVariables
>;
export const GetProjectDocumentationsDealerDocument = gql`
  query getProjectDocumentationsDealer($DealerId: ID!) {
    DealerGetter {
      getProjectDocumentationsDealer(DealerId: $DealerId) {
        items {
          id
          name
          File {
            id
            name
            link
            mimeType
          }
          ActualFrom
          ActualTo
          status
          createdAt
          updatedAt
        }
        total
      }
    }
  }
`;

/**
 * __useGetProjectDocumentationsDealerQuery__
 *
 * To run a query within a React component, call `useGetProjectDocumentationsDealerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectDocumentationsDealerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectDocumentationsDealerQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *   },
 * });
 */
export function useGetProjectDocumentationsDealerQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProjectDocumentationsDealerQuery,
    GetProjectDocumentationsDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetProjectDocumentationsDealerQuery,
    GetProjectDocumentationsDealerQueryVariables
  >(GetProjectDocumentationsDealerDocument, options);
}
export function useGetProjectDocumentationsDealerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProjectDocumentationsDealerQuery,
    GetProjectDocumentationsDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProjectDocumentationsDealerQuery,
    GetProjectDocumentationsDealerQueryVariables
  >(GetProjectDocumentationsDealerDocument, options);
}
export type GetProjectDocumentationsDealerQueryHookResult = ReturnType<
  typeof useGetProjectDocumentationsDealerQuery
>;
export type GetProjectDocumentationsDealerLazyQueryHookResult = ReturnType<
  typeof useGetProjectDocumentationsDealerLazyQuery
>;
export type GetProjectDocumentationsDealerQueryResult = Apollo.QueryResult<
  GetProjectDocumentationsDealerQuery,
  GetProjectDocumentationsDealerQueryVariables
>;
export const DownloadDealersValueDocument = gql`
  query downloadDealersValue($DealerIds: [ID], $type: String) {
    DealerGetter {
      downloadDealers(DealerIds: $DealerIds, type: $type) {
        fileHash
      }
    }
  }
`;

/**
 * __useDownloadDealersValueQuery__
 *
 * To run a query within a React component, call `useDownloadDealersValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadDealersValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadDealersValueQuery({
 *   variables: {
 *      DealerIds: // value for 'DealerIds'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useDownloadDealersValueQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DownloadDealersValueQuery,
    DownloadDealersValueQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DownloadDealersValueQuery,
    DownloadDealersValueQueryVariables
  >(DownloadDealersValueDocument, options);
}
export function useDownloadDealersValueLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DownloadDealersValueQuery,
    DownloadDealersValueQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DownloadDealersValueQuery,
    DownloadDealersValueQueryVariables
  >(DownloadDealersValueDocument, options);
}
export type DownloadDealersValueQueryHookResult = ReturnType<
  typeof useDownloadDealersValueQuery
>;
export type DownloadDealersValueLazyQueryHookResult = ReturnType<
  typeof useDownloadDealersValueLazyQuery
>;
export type DownloadDealersValueQueryResult = Apollo.QueryResult<
  DownloadDealersValueQuery,
  DownloadDealersValueQueryVariables
>;
export const GetDealersDomainsDocument = gql`
  query GetDealersDomains($DealersId: [ID]) {
    DealerGetter {
      getDealersDomains(DealersId: $DealersId) {
        ...fragmentGetDealersDomains
      }
    }
  }
  ${FragmentGetDealersDomainsFragmentDoc}
`;

/**
 * __useGetDealersDomainsQuery__
 *
 * To run a query within a React component, call `useGetDealersDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealersDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealersDomainsQuery({
 *   variables: {
 *      DealersId: // value for 'DealersId'
 *   },
 * });
 */
export function useGetDealersDomainsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDealersDomainsQuery,
    GetDealersDomainsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDealersDomainsQuery,
    GetDealersDomainsQueryVariables
  >(GetDealersDomainsDocument, options);
}
export function useGetDealersDomainsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDealersDomainsQuery,
    GetDealersDomainsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDealersDomainsQuery,
    GetDealersDomainsQueryVariables
  >(GetDealersDomainsDocument, options);
}
export type GetDealersDomainsQueryHookResult = ReturnType<
  typeof useGetDealersDomainsQuery
>;
export type GetDealersDomainsLazyQueryHookResult = ReturnType<
  typeof useGetDealersDomainsLazyQuery
>;
export type GetDealersDomainsQueryResult = Apollo.QueryResult<
  GetDealersDomainsQuery,
  GetDealersDomainsQueryVariables
>;
export const GetDealerDomainsDocument = gql`
  query GetDealerDomains($dealerId: ID) {
    DealerGetter {
      getDealerDomains(dealerId: $dealerId) {
        ...fragmentGetDealersDomains
      }
    }
  }
  ${FragmentGetDealersDomainsFragmentDoc}
`;

/**
 * __useGetDealerDomainsQuery__
 *
 * To run a query within a React component, call `useGetDealerDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealerDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealerDomainsQuery({
 *   variables: {
 *      dealerId: // value for 'dealerId'
 *   },
 * });
 */
export function useGetDealerDomainsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDealerDomainsQuery,
    GetDealerDomainsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDealerDomainsQuery, GetDealerDomainsQueryVariables>(
    GetDealerDomainsDocument,
    options,
  );
}
export function useGetDealerDomainsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDealerDomainsQuery,
    GetDealerDomainsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDealerDomainsQuery,
    GetDealerDomainsQueryVariables
  >(GetDealerDomainsDocument, options);
}
export type GetDealerDomainsQueryHookResult = ReturnType<
  typeof useGetDealerDomainsQuery
>;
export type GetDealerDomainsLazyQueryHookResult = ReturnType<
  typeof useGetDealerDomainsLazyQuery
>;
export type GetDealerDomainsQueryResult = Apollo.QueryResult<
  GetDealerDomainsQuery,
  GetDealerDomainsQueryVariables
>;
export const CheckAvailableEmailDocument = gql`
  query CheckAvailableEmail($email: String!, $dealerId: ID) {
    DealerGetter {
      checkAvailableEmail(dealerId: $dealerId, email: $email)
    }
  }
`;

/**
 * __useCheckAvailableEmailQuery__
 *
 * To run a query within a React component, call `useCheckAvailableEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckAvailableEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckAvailableEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *      dealerId: // value for 'dealerId'
 *   },
 * });
 */
export function useCheckAvailableEmailQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckAvailableEmailQuery,
    CheckAvailableEmailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CheckAvailableEmailQuery,
    CheckAvailableEmailQueryVariables
  >(CheckAvailableEmailDocument, options);
}
export function useCheckAvailableEmailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckAvailableEmailQuery,
    CheckAvailableEmailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckAvailableEmailQuery,
    CheckAvailableEmailQueryVariables
  >(CheckAvailableEmailDocument, options);
}
export type CheckAvailableEmailQueryHookResult = ReturnType<
  typeof useCheckAvailableEmailQuery
>;
export type CheckAvailableEmailLazyQueryHookResult = ReturnType<
  typeof useCheckAvailableEmailLazyQuery
>;
export type CheckAvailableEmailQueryResult = Apollo.QueryResult<
  CheckAvailableEmailQuery,
  CheckAvailableEmailQueryVariables
>;
export const GetDealerFieldsDocument = gql`
  query GetDealerFields {
    DealerGetter {
      getDealerFields {
        id
        fieldName
        fieldEnName
        fieldRu
        fieldEn
        fieldRuDescription
        fieldEnDescription
      }
    }
  }
`;

/**
 * __useGetDealerFieldsQuery__
 *
 * To run a query within a React component, call `useGetDealerFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealerFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealerFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDealerFieldsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDealerFieldsQuery,
    GetDealerFieldsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDealerFieldsQuery, GetDealerFieldsQueryVariables>(
    GetDealerFieldsDocument,
    options,
  );
}
export function useGetDealerFieldsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDealerFieldsQuery,
    GetDealerFieldsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDealerFieldsQuery,
    GetDealerFieldsQueryVariables
  >(GetDealerFieldsDocument, options);
}
export type GetDealerFieldsQueryHookResult = ReturnType<
  typeof useGetDealerFieldsQuery
>;
export type GetDealerFieldsLazyQueryHookResult = ReturnType<
  typeof useGetDealerFieldsLazyQuery
>;
export type GetDealerFieldsQueryResult = Apollo.QueryResult<
  GetDealerFieldsQuery,
  GetDealerFieldsQueryVariables
>;
export const DealerPhotoGetterDocument = gql`
  query DealerPhotoGetter($dealerId: ID!, $count: Int, $page: Int) {
    DealerPhotoGetter {
      getDealerPhotos(DealerId: $dealerId, count: $count, page: $page) {
        items {
          id
          originalUrl
          previewUrl
          DealerId
          PhotoGallerySectionId
          createdAt
          PhotoGallerySection {
            description
            createdAt
            id
            title
          }
        }
        pages
        total
      }
    }
  }
`;

/**
 * __useDealerPhotoGetterQuery__
 *
 * To run a query within a React component, call `useDealerPhotoGetterQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealerPhotoGetterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealerPhotoGetterQuery({
 *   variables: {
 *      dealerId: // value for 'dealerId'
 *      count: // value for 'count'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useDealerPhotoGetterQuery(
  baseOptions: Apollo.QueryHookOptions<
    DealerPhotoGetterQuery,
    DealerPhotoGetterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DealerPhotoGetterQuery,
    DealerPhotoGetterQueryVariables
  >(DealerPhotoGetterDocument, options);
}
export function useDealerPhotoGetterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DealerPhotoGetterQuery,
    DealerPhotoGetterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DealerPhotoGetterQuery,
    DealerPhotoGetterQueryVariables
  >(DealerPhotoGetterDocument, options);
}
export type DealerPhotoGetterQueryHookResult = ReturnType<
  typeof useDealerPhotoGetterQuery
>;
export type DealerPhotoGetterLazyQueryHookResult = ReturnType<
  typeof useDealerPhotoGetterLazyQuery
>;
export type DealerPhotoGetterQueryResult = Apollo.QueryResult<
  DealerPhotoGetterQuery,
  DealerPhotoGetterQueryVariables
>;
export const GetArchivePeriodsDocument = gql`
  query GetArchivePeriods(
    $page: Int
    $count: Int
    $fromDate: DateTime
    $toDate: DateTime
    $insideDate: DateTime
  ) {
    DealerRegistryGetter {
      getArchivePeriods(
        page: $page
        count: $count
        fromDate: $fromDate
        toDate: $toDate
        insideDate: $insideDate
      ) {
        items {
          ... on ArchivePeriod {
            ...fragmentGetArchivePeriods
          }
        }
        total
      }
    }
  }
  ${FragmentGetArchivePeriodsFragmentDoc}
`;

/**
 * __useGetArchivePeriodsQuery__
 *
 * To run a query within a React component, call `useGetArchivePeriodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArchivePeriodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArchivePeriodsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      insideDate: // value for 'insideDate'
 *   },
 * });
 */
export function useGetArchivePeriodsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetArchivePeriodsQuery,
    GetArchivePeriodsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetArchivePeriodsQuery,
    GetArchivePeriodsQueryVariables
  >(GetArchivePeriodsDocument, options);
}
export function useGetArchivePeriodsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetArchivePeriodsQuery,
    GetArchivePeriodsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetArchivePeriodsQuery,
    GetArchivePeriodsQueryVariables
  >(GetArchivePeriodsDocument, options);
}
export type GetArchivePeriodsQueryHookResult = ReturnType<
  typeof useGetArchivePeriodsQuery
>;
export type GetArchivePeriodsLazyQueryHookResult = ReturnType<
  typeof useGetArchivePeriodsLazyQuery
>;
export type GetArchivePeriodsQueryResult = Apollo.QueryResult<
  GetArchivePeriodsQuery,
  GetArchivePeriodsQueryVariables
>;
export const GetArchiveDealersInheritanceDocument = gql`
  query GetArchiveDealersInheritance($DealerId: ID) {
    DealerRegistryGetter {
      getArchiveDealersInheritance(DealerId: $DealerId) {
        items {
          ... on DealerWithPeriods {
            ...fragmentDealerWithPeriods
          }
        }
        total
      }
    }
  }
  ${FragmentDealerWithPeriodsFragmentDoc}
`;

/**
 * __useGetArchiveDealersInheritanceQuery__
 *
 * To run a query within a React component, call `useGetArchiveDealersInheritanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArchiveDealersInheritanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArchiveDealersInheritanceQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *   },
 * });
 */
export function useGetArchiveDealersInheritanceQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetArchiveDealersInheritanceQuery,
    GetArchiveDealersInheritanceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetArchiveDealersInheritanceQuery,
    GetArchiveDealersInheritanceQueryVariables
  >(GetArchiveDealersInheritanceDocument, options);
}
export function useGetArchiveDealersInheritanceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetArchiveDealersInheritanceQuery,
    GetArchiveDealersInheritanceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetArchiveDealersInheritanceQuery,
    GetArchiveDealersInheritanceQueryVariables
  >(GetArchiveDealersInheritanceDocument, options);
}
export type GetArchiveDealersInheritanceQueryHookResult = ReturnType<
  typeof useGetArchiveDealersInheritanceQuery
>;
export type GetArchiveDealersInheritanceLazyQueryHookResult = ReturnType<
  typeof useGetArchiveDealersInheritanceLazyQuery
>;
export type GetArchiveDealersInheritanceQueryResult = Apollo.QueryResult<
  GetArchiveDealersInheritanceQuery,
  GetArchiveDealersInheritanceQueryVariables
>;
export const GetTemplatesDocument = gql`
  query GetTemplates(
    $page: Int! = 0
    $count: Int! = 10
    $getAll: Boolean! = false
    $type: ContractType! = Custom
  ) {
    DealerRegistryGetter {
      getTemplates(page: $page, count: $count, getAll: $getAll, type: $type) {
        items {
          ... on DealerContractTemplate {
            ...fragmentGetTemplates
          }
        }
        total
      }
    }
  }
  ${FragmentGetTemplatesFragmentDoc}
`;

/**
 * __useGetTemplatesQuery__
 *
 * To run a query within a React component, call `useGetTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplatesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      getAll: // value for 'getAll'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetTemplatesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTemplatesQuery,
    GetTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(
    GetTemplatesDocument,
    options,
  );
}
export function useGetTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTemplatesQuery,
    GetTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(
    GetTemplatesDocument,
    options,
  );
}
export type GetTemplatesQueryHookResult = ReturnType<
  typeof useGetTemplatesQuery
>;
export type GetTemplatesLazyQueryHookResult = ReturnType<
  typeof useGetTemplatesLazyQuery
>;
export type GetTemplatesQueryResult = Apollo.QueryResult<
  GetTemplatesQuery,
  GetTemplatesQueryVariables
>;
export const GetContractsDocument = gql`
  query GetContracts($DealerId: ID!, $type: ContractType! = Custom) {
    DealerRegistryGetter {
      getContracts(DealerId: $DealerId, type: $type) {
        id
        name
      }
    }
  }
`;

/**
 * __useGetContractsQuery__
 *
 * To run a query within a React component, call `useGetContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractsQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetContractsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetContractsQuery,
    GetContractsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetContractsQuery, GetContractsQueryVariables>(
    GetContractsDocument,
    options,
  );
}
export function useGetContractsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetContractsQuery,
    GetContractsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetContractsQuery, GetContractsQueryVariables>(
    GetContractsDocument,
    options,
  );
}
export type GetContractsQueryHookResult = ReturnType<
  typeof useGetContractsQuery
>;
export type GetContractsLazyQueryHookResult = ReturnType<
  typeof useGetContractsLazyQuery
>;
export type GetContractsQueryResult = Apollo.QueryResult<
  GetContractsQuery,
  GetContractsQueryVariables
>;
export const DownloadContractDocument = gql`
  query DownloadContract($contractId: ID!, $dealerId: ID!) {
    DealerRegistryGetter {
      downloadContract(contractId: $contractId, dealerId: $dealerId) {
        fileHash
      }
    }
  }
`;

/**
 * __useDownloadContractQuery__
 *
 * To run a query within a React component, call `useDownloadContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadContractQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      dealerId: // value for 'dealerId'
 *   },
 * });
 */
export function useDownloadContractQuery(
  baseOptions: Apollo.QueryHookOptions<
    DownloadContractQuery,
    DownloadContractQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DownloadContractQuery, DownloadContractQueryVariables>(
    DownloadContractDocument,
    options,
  );
}
export function useDownloadContractLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DownloadContractQuery,
    DownloadContractQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DownloadContractQuery,
    DownloadContractQueryVariables
  >(DownloadContractDocument, options);
}
export type DownloadContractQueryHookResult = ReturnType<
  typeof useDownloadContractQuery
>;
export type DownloadContractLazyQueryHookResult = ReturnType<
  typeof useDownloadContractLazyQuery
>;
export type DownloadContractQueryResult = Apollo.QueryResult<
  DownloadContractQuery,
  DownloadContractQueryVariables
>;
export const DownloadPeriodInfoDocument = gql`
  query DownloadPeriodInfo($periodId: ID) {
    DealerRegistryGetter {
      downloadPeriodInfo(periodId: $periodId) {
        fileHash
      }
    }
  }
`;

/**
 * __useDownloadPeriodInfoQuery__
 *
 * To run a query within a React component, call `useDownloadPeriodInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadPeriodInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadPeriodInfoQuery({
 *   variables: {
 *      periodId: // value for 'periodId'
 *   },
 * });
 */
export function useDownloadPeriodInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DownloadPeriodInfoQuery,
    DownloadPeriodInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DownloadPeriodInfoQuery,
    DownloadPeriodInfoQueryVariables
  >(DownloadPeriodInfoDocument, options);
}
export function useDownloadPeriodInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DownloadPeriodInfoQuery,
    DownloadPeriodInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DownloadPeriodInfoQuery,
    DownloadPeriodInfoQueryVariables
  >(DownloadPeriodInfoDocument, options);
}
export type DownloadPeriodInfoQueryHookResult = ReturnType<
  typeof useDownloadPeriodInfoQuery
>;
export type DownloadPeriodInfoLazyQueryHookResult = ReturnType<
  typeof useDownloadPeriodInfoLazyQuery
>;
export type DownloadPeriodInfoQueryResult = Apollo.QueryResult<
  DownloadPeriodInfoQuery,
  DownloadPeriodInfoQueryVariables
>;
export const GetCatalogListDocument = gql`
  query GetCatalogList($parentId: ID, $page: Int = 0, $count: Int = 10) {
    DocumentGetter {
      getSections(parentId: $parentId, page: $page, count: $count) {
        total
        items {
          ... on Section {
            ...Catalog
          }
        }
      }
    }
  }
  ${CatalogFragmentDoc}
`;

/**
 * __useGetCatalogListQuery__
 *
 * To run a query within a React component, call `useGetCatalogListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogListQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetCatalogListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCatalogListQuery,
    GetCatalogListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCatalogListQuery, GetCatalogListQueryVariables>(
    GetCatalogListDocument,
    options,
  );
}
export function useGetCatalogListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCatalogListQuery,
    GetCatalogListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCatalogListQuery, GetCatalogListQueryVariables>(
    GetCatalogListDocument,
    options,
  );
}
export type GetCatalogListQueryHookResult = ReturnType<
  typeof useGetCatalogListQuery
>;
export type GetCatalogListLazyQueryHookResult = ReturnType<
  typeof useGetCatalogListLazyQuery
>;
export type GetCatalogListQueryResult = Apollo.QueryResult<
  GetCatalogListQuery,
  GetCatalogListQueryVariables
>;
export const GetCatalogDocument = gql`
  query GetCatalog($id: ID) {
    DocumentGetter {
      getOneSection(id: $id) {
        ... on Section {
          ...Catalog
        }
      }
    }
  }
  ${CatalogFragmentDoc}
`;

/**
 * __useGetCatalogQuery__
 *
 * To run a query within a React component, call `useGetCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCatalogQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCatalogQuery,
    GetCatalogQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCatalogQuery, GetCatalogQueryVariables>(
    GetCatalogDocument,
    options,
  );
}
export function useGetCatalogLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCatalogQuery,
    GetCatalogQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCatalogQuery, GetCatalogQueryVariables>(
    GetCatalogDocument,
    options,
  );
}
export type GetCatalogQueryHookResult = ReturnType<typeof useGetCatalogQuery>;
export type GetCatalogLazyQueryHookResult = ReturnType<
  typeof useGetCatalogLazyQuery
>;
export type GetCatalogQueryResult = Apollo.QueryResult<
  GetCatalogQuery,
  GetCatalogQueryVariables
>;
export const GetDocumentListDocument = gql`
  query GetDocumentList(
    $sectionId: ID
    $name: String
    $description: String
    $status: String
    $importance: String
    $signedBy: String
    $createdAtFrom: DateTime
    $createdAtTo: DateTime
    $page: Int = 0
    $count: Int = 10
  ) {
    DocumentGetter {
      getList(
        sectionId: $sectionId
        name: $name
        description: $description
        status: $status
        importance: $importance
        signedBy: $signedBy
        createdAtFrom: $createdAtFrom
        createdAtTo: $createdAtTo
        page: $page
        count: $count
      ) {
        total
        items {
          ... on Document {
            ...Document
          }
        }
      }
    }
  }
  ${DocumentFragmentDoc}
`;

/**
 * __useGetDocumentListQuery__
 *
 * To run a query within a React component, call `useGetDocumentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentListQuery({
 *   variables: {
 *      sectionId: // value for 'sectionId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      status: // value for 'status'
 *      importance: // value for 'importance'
 *      signedBy: // value for 'signedBy'
 *      createdAtFrom: // value for 'createdAtFrom'
 *      createdAtTo: // value for 'createdAtTo'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetDocumentListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDocumentListQuery,
    GetDocumentListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDocumentListQuery, GetDocumentListQueryVariables>(
    GetDocumentListDocument,
    options,
  );
}
export function useGetDocumentListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDocumentListQuery,
    GetDocumentListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDocumentListQuery,
    GetDocumentListQueryVariables
  >(GetDocumentListDocument, options);
}
export type GetDocumentListQueryHookResult = ReturnType<
  typeof useGetDocumentListQuery
>;
export type GetDocumentListLazyQueryHookResult = ReturnType<
  typeof useGetDocumentListLazyQuery
>;
export type GetDocumentListQueryResult = Apollo.QueryResult<
  GetDocumentListQuery,
  GetDocumentListQueryVariables
>;
export const GetDocumentDocument = gql`
  query GetDocument($id: ID) {
    DocumentGetter {
      getOne(id: $id) {
        ... on Document {
          ...Document
        }
      }
    }
  }
  ${DocumentFragmentDoc}
`;

/**
 * __useGetDocumentQuery__
 *
 * To run a query within a React component, call `useGetDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDocumentQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDocumentQuery,
    GetDocumentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDocumentQuery, GetDocumentQueryVariables>(
    GetDocumentDocument,
    options,
  );
}
export function useGetDocumentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDocumentQuery,
    GetDocumentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDocumentQuery, GetDocumentQueryVariables>(
    GetDocumentDocument,
    options,
  );
}
export type GetDocumentQueryHookResult = ReturnType<typeof useGetDocumentQuery>;
export type GetDocumentLazyQueryHookResult = ReturnType<
  typeof useGetDocumentLazyQuery
>;
export type GetDocumentQueryResult = Apollo.QueryResult<
  GetDocumentQuery,
  GetDocumentQueryVariables
>;
export const GetFolderDocument = gql`
  query getFolder($id: ID) {
    DocumentGetter {
      getFolder(id: $id) {
        total
        items {
          ...FolderList
        }
      }
    }
  }
  ${FolderListFragmentDoc}
`;

/**
 * __useGetFolderQuery__
 *
 * To run a query within a React component, call `useGetFolderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFolderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFolderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFolderQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetFolderQuery,
    GetFolderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFolderQuery, GetFolderQueryVariables>(
    GetFolderDocument,
    options,
  );
}
export function useGetFolderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFolderQuery,
    GetFolderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFolderQuery, GetFolderQueryVariables>(
    GetFolderDocument,
    options,
  );
}
export type GetFolderQueryHookResult = ReturnType<typeof useGetFolderQuery>;
export type GetFolderLazyQueryHookResult = ReturnType<
  typeof useGetFolderLazyQuery
>;
export type GetFolderQueryResult = Apollo.QueryResult<
  GetFolderQuery,
  GetFolderQueryVariables
>;
export const GetCoursesDocument = gql`
  query GetCourses(
    $page: Int
    $count: Int
    $id: ID
    $order: sortType
    $status: CurriculumCourseStatus
    $name: String
    $code: String
    $codeIS: String
    $certificateValidityPeriod: Int
    $level: [ID]
    $orderBy: CourseOrderBy
    $ActualOn: DateTime
  ) {
    EducationGetter {
      getListCourseCurriculum(
        page: $page
        count: $count
        status: $status
        name: $name
        ActualOn: $ActualOn
        id: $id
        code: $code
        codeIS: $codeIS
        certificateValidityPeriod: $certificateValidityPeriod
        LevelIds: $level
        orderBy: $orderBy
        order: $order
      ) {
        items {
          ...FragmentCourses
        }
        total
      }
    }
  }
  ${FragmentCoursesFragmentDoc}
`;

/**
 * __useGetCoursesQuery__
 *
 * To run a query within a React component, call `useGetCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      id: // value for 'id'
 *      order: // value for 'order'
 *      status: // value for 'status'
 *      name: // value for 'name'
 *      code: // value for 'code'
 *      codeIS: // value for 'codeIS'
 *      certificateValidityPeriod: // value for 'certificateValidityPeriod'
 *      level: // value for 'level'
 *      orderBy: // value for 'orderBy'
 *      ActualOn: // value for 'ActualOn'
 *   },
 * });
 */
export function useGetCoursesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetCoursesQuery,
    GetCoursesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCoursesQuery, GetCoursesQueryVariables>(
    GetCoursesDocument,
    options,
  );
}
export function useGetCoursesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCoursesQuery,
    GetCoursesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCoursesQuery, GetCoursesQueryVariables>(
    GetCoursesDocument,
    options,
  );
}
export type GetCoursesQueryHookResult = ReturnType<typeof useGetCoursesQuery>;
export type GetCoursesLazyQueryHookResult = ReturnType<
  typeof useGetCoursesLazyQuery
>;
export type GetCoursesQueryResult = Apollo.QueryResult<
  GetCoursesQuery,
  GetCoursesQueryVariables
>;
export const GetGroupsDocument = gql`
  query GetGroups(
    $id: ID
    $ids: [ID]
    $page: Int
    $count: Int
    $name: String
    $ActualOn: DateTime
    $status: CurriculumGroupStatus
  ) {
    EducationGetter {
      getListGroupCurriculum(
        id: $id
        ids: $ids
        page: $page
        count: $count
        name: $name
        ActualOn: $ActualOn
        status: $status
      ) {
        ...FragmentGroups
        total
      }
    }
  }
  ${FragmentGroupsFragmentDoc}
`;

/**
 * __useGetGroupsQuery__
 *
 * To run a query within a React component, call `useGetGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      ids: // value for 'ids'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      name: // value for 'name'
 *      ActualOn: // value for 'ActualOn'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetGroupsQuery,
    GetGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetGroupsQuery, GetGroupsQueryVariables>(
    GetGroupsDocument,
    options,
  );
}
export function useGetGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGroupsQuery,
    GetGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetGroupsQuery, GetGroupsQueryVariables>(
    GetGroupsDocument,
    options,
  );
}
export type GetGroupsQueryHookResult = ReturnType<typeof useGetGroupsQuery>;
export type GetGroupsLazyQueryHookResult = ReturnType<
  typeof useGetGroupsLazyQuery
>;
export type GetGroupsQueryResult = Apollo.QueryResult<
  GetGroupsQuery,
  GetGroupsQueryVariables
>;
export const GetLevelsDocument = gql`
  query GetLevels(
    $page: Int
    $count: Int
    $status: CurriculumLevelStatus
    $name: String
    $ActualOn: DateTime
  ) {
    EducationGetter {
      getListLevelCurriculum(
        page: $page
        count: $count
        status: $status
        name: $name
        ActualOn: $ActualOn
      ) {
        ...FragmentLevels
        total
      }
    }
  }
  ${FragmentLevelsFragmentDoc}
`;

/**
 * __useGetLevelsQuery__
 *
 * To run a query within a React component, call `useGetLevelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLevelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLevelsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      status: // value for 'status'
 *      name: // value for 'name'
 *      ActualOn: // value for 'ActualOn'
 *   },
 * });
 */
export function useGetLevelsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetLevelsQuery,
    GetLevelsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLevelsQuery, GetLevelsQueryVariables>(
    GetLevelsDocument,
    options,
  );
}
export function useGetLevelsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLevelsQuery,
    GetLevelsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLevelsQuery, GetLevelsQueryVariables>(
    GetLevelsDocument,
    options,
  );
}
export type GetLevelsQueryHookResult = ReturnType<typeof useGetLevelsQuery>;
export type GetLevelsLazyQueryHookResult = ReturnType<
  typeof useGetLevelsLazyQuery
>;
export type GetLevelsQueryResult = Apollo.QueryResult<
  GetLevelsQuery,
  GetLevelsQueryVariables
>;
export const GetGroupCurriculumByIdDocument = gql`
  query GetGroupCurriculumById($id: ID!) {
    EducationGetter {
      getGroupCurriculumById(id: $id) {
        ...FragmentGroup
      }
    }
  }
  ${FragmentGroupFragmentDoc}
`;

/**
 * __useGetGroupCurriculumByIdQuery__
 *
 * To run a query within a React component, call `useGetGroupCurriculumByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupCurriculumByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupCurriculumByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGroupCurriculumByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetGroupCurriculumByIdQuery,
    GetGroupCurriculumByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetGroupCurriculumByIdQuery,
    GetGroupCurriculumByIdQueryVariables
  >(GetGroupCurriculumByIdDocument, options);
}
export function useGetGroupCurriculumByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGroupCurriculumByIdQuery,
    GetGroupCurriculumByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetGroupCurriculumByIdQuery,
    GetGroupCurriculumByIdQueryVariables
  >(GetGroupCurriculumByIdDocument, options);
}
export type GetGroupCurriculumByIdQueryHookResult = ReturnType<
  typeof useGetGroupCurriculumByIdQuery
>;
export type GetGroupCurriculumByIdLazyQueryHookResult = ReturnType<
  typeof useGetGroupCurriculumByIdLazyQuery
>;
export type GetGroupCurriculumByIdQueryResult = Apollo.QueryResult<
  GetGroupCurriculumByIdQuery,
  GetGroupCurriculumByIdQueryVariables
>;
export const GetLevelCurriculumByIdDocument = gql`
  query GetLevelCurriculumById($id: ID!) {
    EducationGetter {
      getLevelCurriculumById(id: $id) {
        ...FragmentLevel
      }
    }
  }
  ${FragmentLevelFragmentDoc}
`;

/**
 * __useGetLevelCurriculumByIdQuery__
 *
 * To run a query within a React component, call `useGetLevelCurriculumByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLevelCurriculumByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLevelCurriculumByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLevelCurriculumByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLevelCurriculumByIdQuery,
    GetLevelCurriculumByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetLevelCurriculumByIdQuery,
    GetLevelCurriculumByIdQueryVariables
  >(GetLevelCurriculumByIdDocument, options);
}
export function useGetLevelCurriculumByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLevelCurriculumByIdQuery,
    GetLevelCurriculumByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLevelCurriculumByIdQuery,
    GetLevelCurriculumByIdQueryVariables
  >(GetLevelCurriculumByIdDocument, options);
}
export type GetLevelCurriculumByIdQueryHookResult = ReturnType<
  typeof useGetLevelCurriculumByIdQuery
>;
export type GetLevelCurriculumByIdLazyQueryHookResult = ReturnType<
  typeof useGetLevelCurriculumByIdLazyQuery
>;
export type GetLevelCurriculumByIdQueryResult = Apollo.QueryResult<
  GetLevelCurriculumByIdQuery,
  GetLevelCurriculumByIdQueryVariables
>;
export const GetCourseCurriculumByIdDocument = gql`
  query GetCourseCurriculumById($id: ID!) {
    EducationGetter {
      getCourseCurriculumById(id: $id) {
        ...FragmentCourse
      }
    }
  }
  ${FragmentCourseFragmentDoc}
`;

/**
 * __useGetCourseCurriculumByIdQuery__
 *
 * To run a query within a React component, call `useGetCourseCurriculumByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseCurriculumByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseCurriculumByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseCurriculumByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCourseCurriculumByIdQuery,
    GetCourseCurriculumByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCourseCurriculumByIdQuery,
    GetCourseCurriculumByIdQueryVariables
  >(GetCourseCurriculumByIdDocument, options);
}
export function useGetCourseCurriculumByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCourseCurriculumByIdQuery,
    GetCourseCurriculumByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCourseCurriculumByIdQuery,
    GetCourseCurriculumByIdQueryVariables
  >(GetCourseCurriculumByIdDocument, options);
}
export type GetCourseCurriculumByIdQueryHookResult = ReturnType<
  typeof useGetCourseCurriculumByIdQuery
>;
export type GetCourseCurriculumByIdLazyQueryHookResult = ReturnType<
  typeof useGetCourseCurriculumByIdLazyQuery
>;
export type GetCourseCurriculumByIdQueryResult = Apollo.QueryResult<
  GetCourseCurriculumByIdQuery,
  GetCourseCurriculumByIdQueryVariables
>;
export const GetPositionIsTheEducationProgramsDocument = gql`
  query GetPositionIsTheEducationPrograms($page: Int, $count: Int) {
    EducationGetter {
      getPositionIsTheEducationPrograms(page: $page, count: $count) {
        ...FragmentPositionIsTheEducationPrograms
      }
    }
  }
  ${FragmentPositionIsTheEducationProgramsFragmentDoc}
`;

/**
 * __useGetPositionIsTheEducationProgramsQuery__
 *
 * To run a query within a React component, call `useGetPositionIsTheEducationProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionIsTheEducationProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionIsTheEducationProgramsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetPositionIsTheEducationProgramsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPositionIsTheEducationProgramsQuery,
    GetPositionIsTheEducationProgramsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPositionIsTheEducationProgramsQuery,
    GetPositionIsTheEducationProgramsQueryVariables
  >(GetPositionIsTheEducationProgramsDocument, options);
}
export function useGetPositionIsTheEducationProgramsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPositionIsTheEducationProgramsQuery,
    GetPositionIsTheEducationProgramsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPositionIsTheEducationProgramsQuery,
    GetPositionIsTheEducationProgramsQueryVariables
  >(GetPositionIsTheEducationProgramsDocument, options);
}
export type GetPositionIsTheEducationProgramsQueryHookResult = ReturnType<
  typeof useGetPositionIsTheEducationProgramsQuery
>;
export type GetPositionIsTheEducationProgramsLazyQueryHookResult = ReturnType<
  typeof useGetPositionIsTheEducationProgramsLazyQuery
>;
export type GetPositionIsTheEducationProgramsQueryResult = Apollo.QueryResult<
  GetPositionIsTheEducationProgramsQuery,
  GetPositionIsTheEducationProgramsQueryVariables
>;
export const GetCompositionPositionProgramsDocument = gql`
  query GetCompositionPositionPrograms(
    $PositionGroupId: ID!
    $ActualOn: DateTime
  ) {
    EducationGetter {
      getCompositionPositionPrograms(
        PositionGroupId: $PositionGroupId
        ActualOn: $ActualOn
      ) {
        ...FragmentCompositionsPositionsProgram
      }
    }
  }
  ${FragmentCompositionsPositionsProgramFragmentDoc}
`;

/**
 * __useGetCompositionPositionProgramsQuery__
 *
 * To run a query within a React component, call `useGetCompositionPositionProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompositionPositionProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompositionPositionProgramsQuery({
 *   variables: {
 *      PositionGroupId: // value for 'PositionGroupId'
 *      ActualOn: // value for 'ActualOn'
 *   },
 * });
 */
export function useGetCompositionPositionProgramsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCompositionPositionProgramsQuery,
    GetCompositionPositionProgramsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCompositionPositionProgramsQuery,
    GetCompositionPositionProgramsQueryVariables
  >(GetCompositionPositionProgramsDocument, options);
}
export function useGetCompositionPositionProgramsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCompositionPositionProgramsQuery,
    GetCompositionPositionProgramsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCompositionPositionProgramsQuery,
    GetCompositionPositionProgramsQueryVariables
  >(GetCompositionPositionProgramsDocument, options);
}
export type GetCompositionPositionProgramsQueryHookResult = ReturnType<
  typeof useGetCompositionPositionProgramsQuery
>;
export type GetCompositionPositionProgramsLazyQueryHookResult = ReturnType<
  typeof useGetCompositionPositionProgramsLazyQuery
>;
export type GetCompositionPositionProgramsQueryResult = Apollo.QueryResult<
  GetCompositionPositionProgramsQuery,
  GetCompositionPositionProgramsQueryVariables
>;
export const GetPositionsInNotEducationProgramsDocument = gql`
  query GetPositionsInNotEducationPrograms(
    $page: Int
    $count: Int
    $name: String
  ) {
    EducationGetter {
      getPositionsInNotEducationPrograms(
        count: $count
        page: $page
        name: $name
      ) {
        ...FragmentPositionsInNotEducationPrograms
      }
    }
  }
  ${FragmentPositionsInNotEducationProgramsFragmentDoc}
`;

/**
 * __useGetPositionsInNotEducationProgramsQuery__
 *
 * To run a query within a React component, call `useGetPositionsInNotEducationProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionsInNotEducationProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionsInNotEducationProgramsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetPositionsInNotEducationProgramsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPositionsInNotEducationProgramsQuery,
    GetPositionsInNotEducationProgramsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPositionsInNotEducationProgramsQuery,
    GetPositionsInNotEducationProgramsQueryVariables
  >(GetPositionsInNotEducationProgramsDocument, options);
}
export function useGetPositionsInNotEducationProgramsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPositionsInNotEducationProgramsQuery,
    GetPositionsInNotEducationProgramsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPositionsInNotEducationProgramsQuery,
    GetPositionsInNotEducationProgramsQueryVariables
  >(GetPositionsInNotEducationProgramsDocument, options);
}
export type GetPositionsInNotEducationProgramsQueryHookResult = ReturnType<
  typeof useGetPositionsInNotEducationProgramsQuery
>;
export type GetPositionsInNotEducationProgramsLazyQueryHookResult = ReturnType<
  typeof useGetPositionsInNotEducationProgramsLazyQuery
>;
export type GetPositionsInNotEducationProgramsQueryResult = Apollo.QueryResult<
  GetPositionsInNotEducationProgramsQuery,
  GetPositionsInNotEducationProgramsQueryVariables
>;
export const GetListCourseBySortLevelIdDocument = gql`
  query GetListCourseBySortLevelId(
    $page: Int
    $count: Int
    $status: CurriculumCourseStatus
    $name: String
    $code: String
    $certificateValidityPeriod: Int
    $order: sortType
    $LevelId: ID!
    $orderBy: CourseOrderBy
    $ActualOn: DateTime
  ) {
    EducationGetter {
      getListCourseBySortLevelId(
        name: $name
        page: $page
        count: $count
        status: $status
        code: $code
        certificateValidityPeriod: $certificateValidityPeriod
        order: $order
        LevelId: $LevelId
        orderBy: $orderBy
        ActualOn: $ActualOn
      ) {
        items {
          ...FragmentGetListCoursesBySortLevelId
        }
        total
      }
    }
  }
  ${FragmentGetListCoursesBySortLevelIdFragmentDoc}
`;

/**
 * __useGetListCourseBySortLevelIdQuery__
 *
 * To run a query within a React component, call `useGetListCourseBySortLevelIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListCourseBySortLevelIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListCourseBySortLevelIdQuery({
 *   variables: {
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      status: // value for 'status'
 *      name: // value for 'name'
 *      code: // value for 'code'
 *      certificateValidityPeriod: // value for 'certificateValidityPeriod'
 *      order: // value for 'order'
 *      LevelId: // value for 'LevelId'
 *      orderBy: // value for 'orderBy'
 *      ActualOn: // value for 'ActualOn'
 *   },
 * });
 */
export function useGetListCourseBySortLevelIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetListCourseBySortLevelIdQuery,
    GetListCourseBySortLevelIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetListCourseBySortLevelIdQuery,
    GetListCourseBySortLevelIdQueryVariables
  >(GetListCourseBySortLevelIdDocument, options);
}
export function useGetListCourseBySortLevelIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetListCourseBySortLevelIdQuery,
    GetListCourseBySortLevelIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetListCourseBySortLevelIdQuery,
    GetListCourseBySortLevelIdQueryVariables
  >(GetListCourseBySortLevelIdDocument, options);
}
export type GetListCourseBySortLevelIdQueryHookResult = ReturnType<
  typeof useGetListCourseBySortLevelIdQuery
>;
export type GetListCourseBySortLevelIdLazyQueryHookResult = ReturnType<
  typeof useGetListCourseBySortLevelIdLazyQuery
>;
export type GetListCourseBySortLevelIdQueryResult = Apollo.QueryResult<
  GetListCourseBySortLevelIdQuery,
  GetListCourseBySortLevelIdQueryVariables
>;
export const GetEmployeeGetListDocument = gql`
  query GetEmployeeGetList(
    $page: Int
    $count: Int
    $DealerIds: [ID]
    $PositionIds: [ID]
    $id: ID
    $surname: String
    $name: String
    $middleName: String
    $personalPhone: String
    $workPhone: String
    $email: String
    $emailVerification: Boolean
    $creationFrom: DateTime
    $creationTo: DateTime
    $lastEditFrom: DateTime
    $lastEditTo: DateTime
    $statuses: [EmployeePositionStatus]
    $ladaAcademiaIds: [ID]
    $order: sortType = ASC
    $orderBy: OrderByColumnInEmployees = id
    $searchText: String
  ) {
    EmployeeGetter {
      getList(
        page: $page
        count: $count
        DealerIds: $DealerIds
        PositionIds: $PositionIds
        id: $id
        surname: $surname
        name: $name
        middleName: $middleName
        personalPhone: $personalPhone
        workPhone: $workPhone
        email: $email
        emailVerification: $emailVerification
        creationFrom: $creationFrom
        creationTo: $creationTo
        lastEditFrom: $lastEditFrom
        lastEditTo: $lastEditTo
        ladaAcademiaIds: $ladaAcademiaIds
        order: $order
        orderBy: $orderBy
        statuses: $statuses
        searchText: $searchText
      ) {
        items {
          EmployeePosition {
            id
            employeesId
            number
            startDate
            startOrderNumber
            endDate
            endOrderNumber
            createdBy
            createdAt
            dealerId
            positionsId
            instanceId
            actualFrom
            actualTo
            email
            emailVerification
            status
            lastStatusUpdateAt
            lastModifiedAt
            lastModifiedBy
            hireBy
            verifyBy
            verifyDate
            fireBy
            recheckRequiredNotified
            lastStatusUpdateBy
            dataConsentId
            recid
            updatedAt
            emailVerificationDate
            positionOrderId
            rejectReason
            __typename
          }
          Position {
            id
            code
            name
            nameEn
            status
            directionId
            expectationId
            createdAt
            updatedAt
            requiredEmail
            instanceId
            actualFrom
            actualTo
            __typename
          }
          Dealer {
            id
            autoCRMID
            type
            typeEn
            ent_id
            dealerName
            dealerNameEn
            tradeDealerName
            tradeDealerNameEn
            legalDealerName
            legalDealerNameEn
            inn
            kPP
            contractEndDate
            iS_Id
            main
            newDealer
            temporaryDecision
            protocolOfIntentions
            logicalType
            extendedForNextYear
            terminated
            hideOnLadaRu
            termOfAuthority
            consumerCode
            corporateEmail
            settlementAccount
            correspondentAccount
            bankName
            responsibleForLadaEmail
            responsibleForLadaFax
            responsibleForLadaPhone
            responsibleForLadaCode
            responsibleForLadaName
            accountantEmail
            accountantFax
            accountantPhone
            accountantCode
            accountantName
            protocolOfTermination
            protocolOfConclusion
            successorCode
            entfCode
            entfSuccessorNo
            entfSuccessorCode
            category
            code
            legalAddress
            legalCityId
            legalHouseId
            postalAddress
            postalCityId
            postalHouseId
            address
            addressEn
            regionCode
            country
            countryEn
            fO
            fOEn
            subject
            subjectEn
            city
            cityEn
            cityId
            houseId
            headFax
            headCode
            headNameGenitive
            headPositionGenitive
            headNameImported
            headFullNameGenitive
            headPositionImported
            headEmailImported
            headPhoneImported
            ePEn
            headName
            headNameEn
            headPhone
            headMobilePhone
            headEmail
            ownerName
            ownerNameEn
            ownerPhone
            ownerMobilePhone
            ownerEmail
            birCode
            beginWorkingDate
            ivideonSublicenseStartAt
            isIvideonActFormed
            contractId
            headCompanyId
            photoDealerCenterId
            photoOwnerId
            photoBossId
            scanOwnerPersonDataId
            scanBossPersonDataId
            scanLadaPersonDataId
            scanAccountantPersonDataId
            organizationalLegalForm
            status
            projectDocumentationId
            updatedAt
            createdAt
            inn
            ep
            ogrn
            egrNumber
            egrSeries
            egrDate
            bik
            xStoPhcode
            xStoPhone
            xStoEmail
            xShopPhcode
            xShopPhone
            xShopEmail
            xShopName
            xShopFlag
            kgaCode
            onecCode
            dealerLadaserv
            __typename
          }
          Employee {
            id
            surname
            name
            middleName
            gender
            email
            personalPhone
            workPhone
            hiredDate
            firedDate
            lastEditDate
            createdBy
            createdAt
            ladaAcademiaId
            firedAt
            firedBy
            lastEditBy
            verifiedAt
            verifiedBy
            status
            lastStatusUpdateAt
            lastStatusUpdateBy
            verifiedInDnm
            __typename
          }
          Direction {
            id
            instanceId
            actualFrom
            actualTo
            name
            status
            createdAt
            updatedAt
            role
          }
        }
        total
      }
    }
  }
`;

/**
 * __useGetEmployeeGetListQuery__
 *
 * To run a query within a React component, call `useGetEmployeeGetListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeGetListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeGetListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      DealerIds: // value for 'DealerIds'
 *      PositionIds: // value for 'PositionIds'
 *      id: // value for 'id'
 *      surname: // value for 'surname'
 *      name: // value for 'name'
 *      middleName: // value for 'middleName'
 *      personalPhone: // value for 'personalPhone'
 *      workPhone: // value for 'workPhone'
 *      email: // value for 'email'
 *      emailVerification: // value for 'emailVerification'
 *      creationFrom: // value for 'creationFrom'
 *      creationTo: // value for 'creationTo'
 *      lastEditFrom: // value for 'lastEditFrom'
 *      lastEditTo: // value for 'lastEditTo'
 *      statuses: // value for 'statuses'
 *      ladaAcademiaIds: // value for 'ladaAcademiaIds'
 *      order: // value for 'order'
 *      orderBy: // value for 'orderBy'
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useGetEmployeeGetListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetEmployeeGetListQuery,
    GetEmployeeGetListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmployeeGetListQuery,
    GetEmployeeGetListQueryVariables
  >(GetEmployeeGetListDocument, options);
}
export function useGetEmployeeGetListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployeeGetListQuery,
    GetEmployeeGetListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmployeeGetListQuery,
    GetEmployeeGetListQueryVariables
  >(GetEmployeeGetListDocument, options);
}
export type GetEmployeeGetListQueryHookResult = ReturnType<
  typeof useGetEmployeeGetListQuery
>;
export type GetEmployeeGetListLazyQueryHookResult = ReturnType<
  typeof useGetEmployeeGetListLazyQuery
>;
export type GetEmployeeGetListQueryResult = Apollo.QueryResult<
  GetEmployeeGetListQuery,
  GetEmployeeGetListQueryVariables
>;
export const GetEmployeeGetDocument = gql`
  query GetEmployeeGet($id: ID!) {
    EmployeeGetter {
      get(id: $id) {
        ... on Employee {
          ...fragmentGet
          Positions {
            ActivePosition {
              Positions {
                positionOrder {
                  id
                  name
                  link
                  mimeType
                  createdAt
                  type
                  hash
                }
                positionOrderId
              }
            }
          }
        }
      }
    }
  }
  ${FragmentGetFragmentDoc}
`;

/**
 * __useGetEmployeeGetQuery__
 *
 * To run a query within a React component, call `useGetEmployeeGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeGetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmployeeGetQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmployeeGetQuery,
    GetEmployeeGetQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmployeeGetQuery, GetEmployeeGetQueryVariables>(
    GetEmployeeGetDocument,
    options,
  );
}
export function useGetEmployeeGetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployeeGetQuery,
    GetEmployeeGetQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEmployeeGetQuery, GetEmployeeGetQueryVariables>(
    GetEmployeeGetDocument,
    options,
  );
}
export type GetEmployeeGetQueryHookResult = ReturnType<
  typeof useGetEmployeeGetQuery
>;
export type GetEmployeeGetLazyQueryHookResult = ReturnType<
  typeof useGetEmployeeGetLazyQuery
>;
export type GetEmployeeGetQueryResult = Apollo.QueryResult<
  GetEmployeeGetQuery,
  GetEmployeeGetQueryVariables
>;
export const GetEmployeeReportDocument = gql`
  query GetEmployeeReport(
    $DealerIds: [ID]
    $PositionIds: [ID]
    $ladaAcademiaIds: [ID]
    $creationFrom: DateTime
    $creationTo: DateTime
    $lastEditFrom: DateTime
    $lastEditTo: DateTime
    $id: ID
    $surname: String
    $name: String
    $middleName: String
    $personalPhone: String
    $workPhone: String
    $email: String
    $statuses: [EmployeePositionStatus]
    $ActualOn: DateTime
    $emailVerification: Boolean
  ) {
    EmployeeGetter {
      getEmployeeReport(
        DealerIds: $DealerIds
        PositionIds: $PositionIds
        ladaAcademiaIds: $ladaAcademiaIds
        creationFrom: $creationFrom
        creationTo: $creationTo
        lastEditFrom: $lastEditFrom
        lastEditTo: $lastEditTo
        id: $id
        surname: $surname
        name: $name
        middleName: $middleName
        personalPhone: $personalPhone
        workPhone: $workPhone
        email: $email
        statuses: $statuses
        ActualOn: $ActualOn
        emailVerification: $emailVerification
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetEmployeeReportQuery__
 *
 * To run a query within a React component, call `useGetEmployeeReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeReportQuery({
 *   variables: {
 *      DealerIds: // value for 'DealerIds'
 *      PositionIds: // value for 'PositionIds'
 *      ladaAcademiaIds: // value for 'ladaAcademiaIds'
 *      creationFrom: // value for 'creationFrom'
 *      creationTo: // value for 'creationTo'
 *      lastEditFrom: // value for 'lastEditFrom'
 *      lastEditTo: // value for 'lastEditTo'
 *      id: // value for 'id'
 *      surname: // value for 'surname'
 *      name: // value for 'name'
 *      middleName: // value for 'middleName'
 *      personalPhone: // value for 'personalPhone'
 *      workPhone: // value for 'workPhone'
 *      email: // value for 'email'
 *      statuses: // value for 'statuses'
 *      ActualOn: // value for 'ActualOn'
 *      emailVerification: // value for 'emailVerification'
 *   },
 * });
 */
export function useGetEmployeeReportQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetEmployeeReportQuery,
    GetEmployeeReportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmployeeReportQuery,
    GetEmployeeReportQueryVariables
  >(GetEmployeeReportDocument, options);
}
export function useGetEmployeeReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployeeReportQuery,
    GetEmployeeReportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmployeeReportQuery,
    GetEmployeeReportQueryVariables
  >(GetEmployeeReportDocument, options);
}
export type GetEmployeeReportQueryHookResult = ReturnType<
  typeof useGetEmployeeReportQuery
>;
export type GetEmployeeReportLazyQueryHookResult = ReturnType<
  typeof useGetEmployeeReportLazyQuery
>;
export type GetEmployeeReportQueryResult = Apollo.QueryResult<
  GetEmployeeReportQuery,
  GetEmployeeReportQueryVariables
>;
export const GetEmployeePositionsDocument = gql`
  query getEmployeePositions($id: ID!) {
    EmployeeGetter {
      getEmployeePositions(id: $id) {
        number
        ActivePosition {
          ...FragmentPosition
          Position {
            DirectionId
          }
        }
        InactivePositions {
          ...FragmentPositions
          Position {
            DirectionId
          }
        }
      }
    }
  }
  ${FragmentPositionFragmentDoc}
  ${FragmentPositionsFragmentDoc}
`;

/**
 * __useGetEmployeePositionsQuery__
 *
 * To run a query within a React component, call `useGetEmployeePositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeePositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeePositionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmployeePositionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmployeePositionsQuery,
    GetEmployeePositionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmployeePositionsQuery,
    GetEmployeePositionsQueryVariables
  >(GetEmployeePositionsDocument, options);
}
export function useGetEmployeePositionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmployeePositionsQuery,
    GetEmployeePositionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmployeePositionsQuery,
    GetEmployeePositionsQueryVariables
  >(GetEmployeePositionsDocument, options);
}
export type GetEmployeePositionsQueryHookResult = ReturnType<
  typeof useGetEmployeePositionsQuery
>;
export type GetEmployeePositionsLazyQueryHookResult = ReturnType<
  typeof useGetEmployeePositionsLazyQuery
>;
export type GetEmployeePositionsQueryResult = Apollo.QueryResult<
  GetEmployeePositionsQuery,
  GetEmployeePositionsQueryVariables
>;
export const CheckEmployeeEmailDocument = gql`
  query checkEmployeeEmail(
    $email: String!
    $EmployeesId: ID
    $DealersId: [ID]
  ) {
    EmployeeGetter {
      CheckEmployeeEmail(
        email: $email
        EmployeesId: $EmployeesId
        DealersId: $DealersId
      )
    }
  }
`;

/**
 * __useCheckEmployeeEmailQuery__
 *
 * To run a query within a React component, call `useCheckEmployeeEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckEmployeeEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckEmployeeEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *      EmployeesId: // value for 'EmployeesId'
 *      DealersId: // value for 'DealersId'
 *   },
 * });
 */
export function useCheckEmployeeEmailQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckEmployeeEmailQuery,
    CheckEmployeeEmailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CheckEmployeeEmailQuery,
    CheckEmployeeEmailQueryVariables
  >(CheckEmployeeEmailDocument, options);
}
export function useCheckEmployeeEmailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckEmployeeEmailQuery,
    CheckEmployeeEmailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckEmployeeEmailQuery,
    CheckEmployeeEmailQueryVariables
  >(CheckEmployeeEmailDocument, options);
}
export type CheckEmployeeEmailQueryHookResult = ReturnType<
  typeof useCheckEmployeeEmailQuery
>;
export type CheckEmployeeEmailLazyQueryHookResult = ReturnType<
  typeof useCheckEmployeeEmailLazyQuery
>;
export type CheckEmployeeEmailQueryResult = Apollo.QueryResult<
  CheckEmployeeEmailQuery,
  CheckEmployeeEmailQueryVariables
>;
export const CheckValidEmailDomainDocument = gql`
  query checkValidEmailDomain(
    $email: String!
    $dealersId: [ID]
    $employeesId: ID
  ) {
    EmployeeGetter {
      checkValidEmailDomain(
        email: $email
        employeesId: $employeesId
        dealersId: $dealersId
      )
    }
  }
`;

/**
 * __useCheckValidEmailDomainQuery__
 *
 * To run a query within a React component, call `useCheckValidEmailDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckValidEmailDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckValidEmailDomainQuery({
 *   variables: {
 *      email: // value for 'email'
 *      dealersId: // value for 'dealersId'
 *      employeesId: // value for 'employeesId'
 *   },
 * });
 */
export function useCheckValidEmailDomainQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckValidEmailDomainQuery,
    CheckValidEmailDomainQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CheckValidEmailDomainQuery,
    CheckValidEmailDomainQueryVariables
  >(CheckValidEmailDomainDocument, options);
}
export function useCheckValidEmailDomainLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckValidEmailDomainQuery,
    CheckValidEmailDomainQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckValidEmailDomainQuery,
    CheckValidEmailDomainQueryVariables
  >(CheckValidEmailDomainDocument, options);
}
export type CheckValidEmailDomainQueryHookResult = ReturnType<
  typeof useCheckValidEmailDomainQuery
>;
export type CheckValidEmailDomainLazyQueryHookResult = ReturnType<
  typeof useCheckValidEmailDomainLazyQuery
>;
export type CheckValidEmailDomainQueryResult = Apollo.QueryResult<
  CheckValidEmailDomainQuery,
  CheckValidEmailDomainQueryVariables
>;
export const GetGroupEducationEmployeeExpectationDocument = gql`
  query getGroupEducationEmployeeExpectation {
    EmployeeGetter {
      getGroupEducationEmployeeExpectation {
        GroupCertificationId
        GroupCertification {
          name
        }
        GroupTrainingId
        GroupTraining {
          name
        }
      }
    }
  }
`;

/**
 * __useGetGroupEducationEmployeeExpectationQuery__
 *
 * To run a query within a React component, call `useGetGroupEducationEmployeeExpectationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupEducationEmployeeExpectationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupEducationEmployeeExpectationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGroupEducationEmployeeExpectationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetGroupEducationEmployeeExpectationQuery,
    GetGroupEducationEmployeeExpectationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetGroupEducationEmployeeExpectationQuery,
    GetGroupEducationEmployeeExpectationQueryVariables
  >(GetGroupEducationEmployeeExpectationDocument, options);
}
export function useGetGroupEducationEmployeeExpectationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGroupEducationEmployeeExpectationQuery,
    GetGroupEducationEmployeeExpectationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetGroupEducationEmployeeExpectationQuery,
    GetGroupEducationEmployeeExpectationQueryVariables
  >(GetGroupEducationEmployeeExpectationDocument, options);
}
export type GetGroupEducationEmployeeExpectationQueryHookResult = ReturnType<
  typeof useGetGroupEducationEmployeeExpectationQuery
>;
export type GetGroupEducationEmployeeExpectationLazyQueryHookResult =
  ReturnType<typeof useGetGroupEducationEmployeeExpectationLazyQuery>;
export type GetGroupEducationEmployeeExpectationQueryResult =
  Apollo.QueryResult<
    GetGroupEducationEmployeeExpectationQuery,
    GetGroupEducationEmployeeExpectationQueryVariables
  >;
export const GetFileCatalogDocument = gql`
  query GetFileCatalog(
    $page: Int
    $count: Int
    $DealerId: ID!
    $catalog: String
    $sortField: String
    $sortType: String
    $UserId: ID
    $dateBegin: DateTime
    $dateEnd: DateTime
    $name: String
  ) {
    FileCatalogGetter {
      getFiles(
        page: $page
        count: $count
        DealerId: $DealerId
        catalog: $catalog
        sortField: $sortField
        sortType: $sortType
        UserId: $UserId
        dateBegin: $dateBegin
        dateEnd: $dateEnd
        name: $name
      ) {
        items {
          ... on File {
            ...fragmentFileCatalog
          }
        }
        total
      }
    }
  }
  ${FragmentFileCatalogFragmentDoc}
`;

/**
 * __useGetFileCatalogQuery__
 *
 * To run a query within a React component, call `useGetFileCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileCatalogQuery({
 *   variables: {
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      DealerId: // value for 'DealerId'
 *      catalog: // value for 'catalog'
 *      sortField: // value for 'sortField'
 *      sortType: // value for 'sortType'
 *      UserId: // value for 'UserId'
 *      dateBegin: // value for 'dateBegin'
 *      dateEnd: // value for 'dateEnd'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetFileCatalogQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetFileCatalogQuery,
    GetFileCatalogQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFileCatalogQuery, GetFileCatalogQueryVariables>(
    GetFileCatalogDocument,
    options,
  );
}
export function useGetFileCatalogLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFileCatalogQuery,
    GetFileCatalogQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFileCatalogQuery, GetFileCatalogQueryVariables>(
    GetFileCatalogDocument,
    options,
  );
}
export type GetFileCatalogQueryHookResult = ReturnType<
  typeof useGetFileCatalogQuery
>;
export type GetFileCatalogLazyQueryHookResult = ReturnType<
  typeof useGetFileCatalogLazyQuery
>;
export type GetFileCatalogQueryResult = Apollo.QueryResult<
  GetFileCatalogQuery,
  GetFileCatalogQueryVariables
>;
export const GetFilesDocument = gql`
  query GetFiles($page: Int, $count: Int) {
    FileGetter {
      getFiles(page: $page, count: $count) {
        items {
          ... on File {
            ...fragmentFile
          }
        }
        total
      }
    }
  }
  ${FragmentFileFragmentDoc}
`;

/**
 * __useGetFilesQuery__
 *
 * To run a query within a React component, call `useGetFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetFilesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetFilesQuery, GetFilesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFilesQuery, GetFilesQueryVariables>(
    GetFilesDocument,
    options,
  );
}
export function useGetFilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFilesQuery,
    GetFilesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFilesQuery, GetFilesQueryVariables>(
    GetFilesDocument,
    options,
  );
}
export type GetFilesQueryHookResult = ReturnType<typeof useGetFilesQuery>;
export type GetFilesLazyQueryHookResult = ReturnType<
  typeof useGetFilesLazyQuery
>;
export type GetFilesQueryResult = Apollo.QueryResult<
  GetFilesQuery,
  GetFilesQueryVariables
>;
export const GetFileDocument = gql`
  query GetFile($id: ID) {
    FileGetter {
      getFile(id: $id) {
        id
        link
        name
        hash
      }
    }
  }
`;

/**
 * __useGetFileQuery__
 *
 * To run a query within a React component, call `useGetFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFileQuery(
  baseOptions?: Apollo.QueryHookOptions<GetFileQuery, GetFileQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFileQuery, GetFileQueryVariables>(
    GetFileDocument,
    options,
  );
}
export function useGetFileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFileQuery,
    GetFileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFileQuery, GetFileQueryVariables>(
    GetFileDocument,
    options,
  );
}
export type GetFileQueryHookResult = ReturnType<typeof useGetFileQuery>;
export type GetFileLazyQueryHookResult = ReturnType<typeof useGetFileLazyQuery>;
export type GetFileQueryResult = Apollo.QueryResult<
  GetFileQuery,
  GetFileQueryVariables
>;
export const GetFileByHashDocument = gql`
  query GetFileByHash($hash: String) {
    FileGetter {
      getFileByHash(hash: $hash) {
        id
        link
        name
        hash
      }
    }
  }
`;

/**
 * __useGetFileByHashQuery__
 *
 * To run a query within a React component, call `useGetFileByHashQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileByHashQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileByHashQuery({
 *   variables: {
 *      hash: // value for 'hash'
 *   },
 * });
 */
export function useGetFileByHashQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetFileByHashQuery,
    GetFileByHashQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFileByHashQuery, GetFileByHashQueryVariables>(
    GetFileByHashDocument,
    options,
  );
}
export function useGetFileByHashLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFileByHashQuery,
    GetFileByHashQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFileByHashQuery, GetFileByHashQueryVariables>(
    GetFileByHashDocument,
    options,
  );
}
export type GetFileByHashQueryHookResult = ReturnType<
  typeof useGetFileByHashQuery
>;
export type GetFileByHashLazyQueryHookResult = ReturnType<
  typeof useGetFileByHashLazyQuery
>;
export type GetFileByHashQueryResult = Apollo.QueryResult<
  GetFileByHashQuery,
  GetFileByHashQueryVariables
>;
export const GeoGetterDocument = gql`
  query GeoGetter(
    $name: String
    $nameEn: String
    $cladrCode: String
    $okatoCode: String
    $type: GeoPlaceType
    $parentId: ID
    $page: Int
    $count: Int
  ) {
    GeoGetter {
      getGeoPlaces(
        name: $name
        nameEn: $nameEn
        cladrCode: $cladrCode
        okatoCode: $okatoCode
        type: $type
        parentId: $parentId
        page: $page
        count: $count
      ) {
        items {
          id
          parentId
          type
          name
          nameEn
          socr
          cladrCode
          okatoCode
          active
          createdAt
          updatedAt
        }
        total
      }
    }
  }
`;

/**
 * __useGeoGetterQuery__
 *
 * To run a query within a React component, call `useGeoGetterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeoGetterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeoGetterQuery({
 *   variables: {
 *      name: // value for 'name'
 *      nameEn: // value for 'nameEn'
 *      cladrCode: // value for 'cladrCode'
 *      okatoCode: // value for 'okatoCode'
 *      type: // value for 'type'
 *      parentId: // value for 'parentId'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGeoGetterQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GeoGetterQuery,
    GeoGetterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GeoGetterQuery, GeoGetterQueryVariables>(
    GeoGetterDocument,
    options,
  );
}
export function useGeoGetterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GeoGetterQuery,
    GeoGetterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GeoGetterQuery, GeoGetterQueryVariables>(
    GeoGetterDocument,
    options,
  );
}
export type GeoGetterQueryHookResult = ReturnType<typeof useGeoGetterQuery>;
export type GeoGetterLazyQueryHookResult = ReturnType<
  typeof useGeoGetterLazyQuery
>;
export type GeoGetterQueryResult = Apollo.QueryResult<
  GeoGetterQuery,
  GeoGetterQueryVariables
>;
export const GetLocationsByIdDocument = gql`
  query GetLocationsById($getLocationsByIdId: ID!) {
    GeoGetter {
      getLocationsById(id: $getLocationsByIdId) {
        countryId
        country
        countryEn
        FOId
        FO
        FOEn
        subjectId
        subject
        subjectEn
        districtId
        district
        districtEn
        cityId
        city
        cityEn
        house
        houseEn
        houseId
        street
        streetEn
        streetId
      }
    }
  }
`;

/**
 * __useGetLocationsByIdQuery__
 *
 * To run a query within a React component, call `useGetLocationsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsByIdQuery({
 *   variables: {
 *      getLocationsByIdId: // value for 'getLocationsByIdId'
 *   },
 * });
 */
export function useGetLocationsByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLocationsByIdQuery,
    GetLocationsByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLocationsByIdQuery, GetLocationsByIdQueryVariables>(
    GetLocationsByIdDocument,
    options,
  );
}
export function useGetLocationsByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLocationsByIdQuery,
    GetLocationsByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLocationsByIdQuery,
    GetLocationsByIdQueryVariables
  >(GetLocationsByIdDocument, options);
}
export type GetLocationsByIdQueryHookResult = ReturnType<
  typeof useGetLocationsByIdQuery
>;
export type GetLocationsByIdLazyQueryHookResult = ReturnType<
  typeof useGetLocationsByIdLazyQuery
>;
export type GetLocationsByIdQueryResult = Apollo.QueryResult<
  GetLocationsByIdQuery,
  GetLocationsByIdQueryVariables
>;
export const GetGeoPlacesByParentIdDocument = gql`
  query GetGeoPlacesByParentId(
    $parentId: ID!
    $name: String
    $nameEn: String
    $type: GeoPlaceType
  ) {
    GeoGetter {
      getGeoPlacesByParentId(
        parentId: $parentId
        name: $name
        nameEn: $nameEn
        type: $type
      ) {
        id
        parentId
        type
        name
        nameEn
        socr
        cladrCode
        okatoCode
        active
        createdAt
        updatedAt
      }
    }
  }
`;

/**
 * __useGetGeoPlacesByParentIdQuery__
 *
 * To run a query within a React component, call `useGetGeoPlacesByParentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeoPlacesByParentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeoPlacesByParentIdQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *      name: // value for 'name'
 *      nameEn: // value for 'nameEn'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetGeoPlacesByParentIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetGeoPlacesByParentIdQuery,
    GetGeoPlacesByParentIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetGeoPlacesByParentIdQuery,
    GetGeoPlacesByParentIdQueryVariables
  >(GetGeoPlacesByParentIdDocument, options);
}
export function useGetGeoPlacesByParentIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGeoPlacesByParentIdQuery,
    GetGeoPlacesByParentIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetGeoPlacesByParentIdQuery,
    GetGeoPlacesByParentIdQueryVariables
  >(GetGeoPlacesByParentIdDocument, options);
}
export type GetGeoPlacesByParentIdQueryHookResult = ReturnType<
  typeof useGetGeoPlacesByParentIdQuery
>;
export type GetGeoPlacesByParentIdLazyQueryHookResult = ReturnType<
  typeof useGetGeoPlacesByParentIdLazyQuery
>;
export type GetGeoPlacesByParentIdQueryResult = Apollo.QueryResult<
  GetGeoPlacesByParentIdQuery,
  GetGeoPlacesByParentIdQueryVariables
>;
export const GetGrVersionsDocument = gql`
  query GetGrVersions {
    GlobalRatingGetter {
      getVersions {
        ... on GlobalRatingVersion {
          ...fragmentGlobalRatingVersionForTable
        }
      }
    }
  }
  ${FragmentGlobalRatingVersionForTableFragmentDoc}
`;

/**
 * __useGetGrVersionsQuery__
 *
 * To run a query within a React component, call `useGetGrVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGrVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGrVersionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGrVersionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetGrVersionsQuery,
    GetGrVersionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetGrVersionsQuery, GetGrVersionsQueryVariables>(
    GetGrVersionsDocument,
    options,
  );
}
export function useGetGrVersionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGrVersionsQuery,
    GetGrVersionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetGrVersionsQuery, GetGrVersionsQueryVariables>(
    GetGrVersionsDocument,
    options,
  );
}
export type GetGrVersionsQueryHookResult = ReturnType<
  typeof useGetGrVersionsQuery
>;
export type GetGrVersionsLazyQueryHookResult = ReturnType<
  typeof useGetGrVersionsLazyQuery
>;
export type GetGrVersionsQueryResult = Apollo.QueryResult<
  GetGrVersionsQuery,
  GetGrVersionsQueryVariables
>;
export const GetGrRatingsDocument = gql`
  query GetGrRatings($RatingsVersionId: ID!) {
    GlobalRatingGetter {
      getRatings(onlyParent: false, RatingsVersionId: $RatingsVersionId) {
        ... on GlobalRating {
          ...fragmentGrRatingForTable
        }
      }
    }
  }
  ${FragmentGrRatingForTableFragmentDoc}
`;

/**
 * __useGetGrRatingsQuery__
 *
 * To run a query within a React component, call `useGetGrRatingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGrRatingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGrRatingsQuery({
 *   variables: {
 *      RatingsVersionId: // value for 'RatingsVersionId'
 *   },
 * });
 */
export function useGetGrRatingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetGrRatingsQuery,
    GetGrRatingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetGrRatingsQuery, GetGrRatingsQueryVariables>(
    GetGrRatingsDocument,
    options,
  );
}
export function useGetGrRatingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGrRatingsQuery,
    GetGrRatingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetGrRatingsQuery, GetGrRatingsQueryVariables>(
    GetGrRatingsDocument,
    options,
  );
}
export type GetGrRatingsQueryHookResult = ReturnType<
  typeof useGetGrRatingsQuery
>;
export type GetGrRatingsLazyQueryHookResult = ReturnType<
  typeof useGetGrRatingsLazyQuery
>;
export type GetGrRatingsQueryResult = Apollo.QueryResult<
  GetGrRatingsQuery,
  GetGrRatingsQueryVariables
>;
export const GetRatingDataQuarter1Document = gql`
  query getRatingDataQuarter1($DealerId: ID!, $year: Int!, $isFull: Boolean!) {
    GlobalRatingGetter {
      getRatingData(DealerId: $DealerId, year: $year, isFull: $isFull) {
        quarter1 {
          ... on GlobalRating {
            ...fragmentGlobalRatingQuarer1
          }
        }
      }
    }
  }
  ${FragmentGlobalRatingQuarer1FragmentDoc}
`;

/**
 * __useGetRatingDataQuarter1Query__
 *
 * To run a query within a React component, call `useGetRatingDataQuarter1Query` and pass it any options that fit your needs.
 * When your component renders, `useGetRatingDataQuarter1Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRatingDataQuarter1Query({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      year: // value for 'year'
 *      isFull: // value for 'isFull'
 *   },
 * });
 */
export function useGetRatingDataQuarter1Query(
  baseOptions: Apollo.QueryHookOptions<
    GetRatingDataQuarter1Query,
    GetRatingDataQuarter1QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetRatingDataQuarter1Query,
    GetRatingDataQuarter1QueryVariables
  >(GetRatingDataQuarter1Document, options);
}
export function useGetRatingDataQuarter1LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRatingDataQuarter1Query,
    GetRatingDataQuarter1QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetRatingDataQuarter1Query,
    GetRatingDataQuarter1QueryVariables
  >(GetRatingDataQuarter1Document, options);
}
export type GetRatingDataQuarter1QueryHookResult = ReturnType<
  typeof useGetRatingDataQuarter1Query
>;
export type GetRatingDataQuarter1LazyQueryHookResult = ReturnType<
  typeof useGetRatingDataQuarter1LazyQuery
>;
export type GetRatingDataQuarter1QueryResult = Apollo.QueryResult<
  GetRatingDataQuarter1Query,
  GetRatingDataQuarter1QueryVariables
>;
export const GetRatingDataQuarter2Document = gql`
  query getRatingDataQuarter2($DealerId: ID!, $year: Int!, $isFull: Boolean!) {
    GlobalRatingGetter {
      getRatingData(DealerId: $DealerId, year: $year, isFull: $isFull) {
        quarter1 {
          ... on GlobalRating {
            ...fragmentGlobalRatingQuarer2
          }
        }
      }
    }
  }
  ${FragmentGlobalRatingQuarer2FragmentDoc}
`;

/**
 * __useGetRatingDataQuarter2Query__
 *
 * To run a query within a React component, call `useGetRatingDataQuarter2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetRatingDataQuarter2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRatingDataQuarter2Query({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      year: // value for 'year'
 *      isFull: // value for 'isFull'
 *   },
 * });
 */
export function useGetRatingDataQuarter2Query(
  baseOptions: Apollo.QueryHookOptions<
    GetRatingDataQuarter2Query,
    GetRatingDataQuarter2QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetRatingDataQuarter2Query,
    GetRatingDataQuarter2QueryVariables
  >(GetRatingDataQuarter2Document, options);
}
export function useGetRatingDataQuarter2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRatingDataQuarter2Query,
    GetRatingDataQuarter2QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetRatingDataQuarter2Query,
    GetRatingDataQuarter2QueryVariables
  >(GetRatingDataQuarter2Document, options);
}
export type GetRatingDataQuarter2QueryHookResult = ReturnType<
  typeof useGetRatingDataQuarter2Query
>;
export type GetRatingDataQuarter2LazyQueryHookResult = ReturnType<
  typeof useGetRatingDataQuarter2LazyQuery
>;
export type GetRatingDataQuarter2QueryResult = Apollo.QueryResult<
  GetRatingDataQuarter2Query,
  GetRatingDataQuarter2QueryVariables
>;
export const GetRatingDataQuarter3Document = gql`
  query getRatingDataQuarter3($DealerId: ID!, $year: Int!, $isFull: Boolean!) {
    GlobalRatingGetter {
      getRatingData(DealerId: $DealerId, year: $year, isFull: $isFull) {
        quarter1 {
          ... on GlobalRating {
            ...fragmentGlobalRatingQuarer3
          }
        }
      }
    }
  }
  ${FragmentGlobalRatingQuarer3FragmentDoc}
`;

/**
 * __useGetRatingDataQuarter3Query__
 *
 * To run a query within a React component, call `useGetRatingDataQuarter3Query` and pass it any options that fit your needs.
 * When your component renders, `useGetRatingDataQuarter3Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRatingDataQuarter3Query({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      year: // value for 'year'
 *      isFull: // value for 'isFull'
 *   },
 * });
 */
export function useGetRatingDataQuarter3Query(
  baseOptions: Apollo.QueryHookOptions<
    GetRatingDataQuarter3Query,
    GetRatingDataQuarter3QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetRatingDataQuarter3Query,
    GetRatingDataQuarter3QueryVariables
  >(GetRatingDataQuarter3Document, options);
}
export function useGetRatingDataQuarter3LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRatingDataQuarter3Query,
    GetRatingDataQuarter3QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetRatingDataQuarter3Query,
    GetRatingDataQuarter3QueryVariables
  >(GetRatingDataQuarter3Document, options);
}
export type GetRatingDataQuarter3QueryHookResult = ReturnType<
  typeof useGetRatingDataQuarter3Query
>;
export type GetRatingDataQuarter3LazyQueryHookResult = ReturnType<
  typeof useGetRatingDataQuarter3LazyQuery
>;
export type GetRatingDataQuarter3QueryResult = Apollo.QueryResult<
  GetRatingDataQuarter3Query,
  GetRatingDataQuarter3QueryVariables
>;
export const GetRatingDataDocument = gql`
  query getRatingData($DealerId: ID!, $year: Int!, $isFull: Boolean!) {
    GlobalRatingGetter {
      getRatingData(DealerId: $DealerId, year: $year, isFull: $isFull) {
        quarter1 {
          ... on GlobalRating {
            ...fragmentGlobalRatingQuarer1
          }
        }
        quarter2 {
          ... on GlobalRating {
            ...fragmentGlobalRatingQuarer2
          }
        }
        quarter3 {
          ... on GlobalRating {
            ...fragmentGlobalRatingQuarer3
          }
        }
        quarter4 {
          ... on GlobalRating {
            ...fragmentGlobalRatingQuarer4
          }
        }
      }
    }
  }
  ${FragmentGlobalRatingQuarer1FragmentDoc}
  ${FragmentGlobalRatingQuarer2FragmentDoc}
  ${FragmentGlobalRatingQuarer3FragmentDoc}
  ${FragmentGlobalRatingQuarer4FragmentDoc}
`;

/**
 * __useGetRatingDataQuery__
 *
 * To run a query within a React component, call `useGetRatingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRatingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRatingDataQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      year: // value for 'year'
 *      isFull: // value for 'isFull'
 *   },
 * });
 */
export function useGetRatingDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetRatingDataQuery,
    GetRatingDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRatingDataQuery, GetRatingDataQueryVariables>(
    GetRatingDataDocument,
    options,
  );
}
export function useGetRatingDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRatingDataQuery,
    GetRatingDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRatingDataQuery, GetRatingDataQueryVariables>(
    GetRatingDataDocument,
    options,
  );
}
export type GetRatingDataQueryHookResult = ReturnType<
  typeof useGetRatingDataQuery
>;
export type GetRatingDataLazyQueryHookResult = ReturnType<
  typeof useGetRatingDataLazyQuery
>;
export type GetRatingDataQueryResult = Apollo.QueryResult<
  GetRatingDataQuery,
  GetRatingDataQueryVariables
>;
export const GetGrFullReportsDocument = gql`
  query GetGrFullReports(
    $DealerId: ID!
    $year: Int!
    $lang: String
    $isFull: Boolean!
  ) {
    GlobalRatingGetter {
      getFullReports(
        DealerId: $DealerId
        year: $year
        isFull: $isFull
        lang: $lang
      ) {
        ... on ReportFile {
          fileHash
        }
      }
    }
  }
`;

/**
 * __useGetGrFullReportsQuery__
 *
 * To run a query within a React component, call `useGetGrFullReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGrFullReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGrFullReportsQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      year: // value for 'year'
 *      lang: // value for 'lang'
 *      isFull: // value for 'isFull'
 *   },
 * });
 */
export function useGetGrFullReportsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetGrFullReportsQuery,
    GetGrFullReportsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetGrFullReportsQuery, GetGrFullReportsQueryVariables>(
    GetGrFullReportsDocument,
    options,
  );
}
export function useGetGrFullReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGrFullReportsQuery,
    GetGrFullReportsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetGrFullReportsQuery,
    GetGrFullReportsQueryVariables
  >(GetGrFullReportsDocument, options);
}
export type GetGrFullReportsQueryHookResult = ReturnType<
  typeof useGetGrFullReportsQuery
>;
export type GetGrFullReportsLazyQueryHookResult = ReturnType<
  typeof useGetGrFullReportsLazyQuery
>;
export type GetGrFullReportsQueryResult = Apollo.QueryResult<
  GetGrFullReportsQuery,
  GetGrFullReportsQueryVariables
>;
export const GetGrRatingsListNameDocument = gql`
  query GetGrRatingsListName(
    $RatingsVersionId: ID
    $RatingsId: ID
    $onlyParent: Boolean!
  ) {
    GlobalRatingGetter {
      getRatingsListName(
        onlyParent: $onlyParent
        RatingsVersionId: $RatingsVersionId
        RatingsId: $RatingsId
      ) {
        ... on GlobalRatingName {
          ...fragmentGrRatingsListName
        }
      }
    }
  }
  ${FragmentGrRatingsListNameFragmentDoc}
`;

/**
 * __useGetGrRatingsListNameQuery__
 *
 * To run a query within a React component, call `useGetGrRatingsListNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGrRatingsListNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGrRatingsListNameQuery({
 *   variables: {
 *      RatingsVersionId: // value for 'RatingsVersionId'
 *      RatingsId: // value for 'RatingsId'
 *      onlyParent: // value for 'onlyParent'
 *   },
 * });
 */
export function useGetGrRatingsListNameQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetGrRatingsListNameQuery,
    GetGrRatingsListNameQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetGrRatingsListNameQuery,
    GetGrRatingsListNameQueryVariables
  >(GetGrRatingsListNameDocument, options);
}
export function useGetGrRatingsListNameLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGrRatingsListNameQuery,
    GetGrRatingsListNameQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetGrRatingsListNameQuery,
    GetGrRatingsListNameQueryVariables
  >(GetGrRatingsListNameDocument, options);
}
export type GetGrRatingsListNameQueryHookResult = ReturnType<
  typeof useGetGrRatingsListNameQuery
>;
export type GetGrRatingsListNameLazyQueryHookResult = ReturnType<
  typeof useGetGrRatingsListNameLazyQuery
>;
export type GetGrRatingsListNameQueryResult = Apollo.QueryResult<
  GetGrRatingsListNameQuery,
  GetGrRatingsListNameQueryVariables
>;
export const GetGrRatingsForChartDocument = gql`
  query GetGrRatingsForChart($DealerId: ID!, $year: Int!) {
    GlobalRatingGetter {
      getRatingData(DealerId: $DealerId, isFull: false, year: $year) {
        quarter1 {
          ... on GlobalRating {
            ...fragmentGrRatingForChart
          }
        }
        quarter2 {
          ... on GlobalRating {
            ...fragmentGrRatingForChart
          }
        }
        quarter3 {
          ... on GlobalRating {
            ...fragmentGrRatingForChart
          }
        }
        quarter4 {
          ... on GlobalRating {
            ...fragmentGrRatingForChart
          }
        }
      }
    }
  }
  ${FragmentGrRatingForChartFragmentDoc}
`;

/**
 * __useGetGrRatingsForChartQuery__
 *
 * To run a query within a React component, call `useGetGrRatingsForChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGrRatingsForChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGrRatingsForChartQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useGetGrRatingsForChartQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetGrRatingsForChartQuery,
    GetGrRatingsForChartQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetGrRatingsForChartQuery,
    GetGrRatingsForChartQueryVariables
  >(GetGrRatingsForChartDocument, options);
}
export function useGetGrRatingsForChartLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGrRatingsForChartQuery,
    GetGrRatingsForChartQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetGrRatingsForChartQuery,
    GetGrRatingsForChartQueryVariables
  >(GetGrRatingsForChartDocument, options);
}
export type GetGrRatingsForChartQueryHookResult = ReturnType<
  typeof useGetGrRatingsForChartQuery
>;
export type GetGrRatingsForChartLazyQueryHookResult = ReturnType<
  typeof useGetGrRatingsForChartLazyQuery
>;
export type GetGrRatingsForChartQueryResult = Apollo.QueryResult<
  GetGrRatingsForChartQuery,
  GetGrRatingsForChartQueryVariables
>;
export const GetIndicatorsDocument = gql`
  query getIndicators(
    $page: Int
    $count: Int
    $searchText: String
    $searchField: String
    $sortField: String
    $sortType: String
  ) {
    IndicatorGetter {
      getIndicators(
        page: $page
        count: $count
        searchText: $searchText
        searchField: $searchField
        sortField: $sortField
        sortType: $sortType
      ) {
        items {
          ... on Indicator {
            ...fragmentIndicatorForTable
          }
        }
        total
      }
    }
  }
  ${FragmentIndicatorForTableFragmentDoc}
`;

/**
 * __useGetIndicatorsQuery__
 *
 * To run a query within a React component, call `useGetIndicatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndicatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndicatorsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      searchText: // value for 'searchText'
 *      searchField: // value for 'searchField'
 *      sortField: // value for 'sortField'
 *      sortType: // value for 'sortType'
 *   },
 * });
 */
export function useGetIndicatorsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetIndicatorsQuery,
    GetIndicatorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetIndicatorsQuery, GetIndicatorsQueryVariables>(
    GetIndicatorsDocument,
    options,
  );
}
export function useGetIndicatorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIndicatorsQuery,
    GetIndicatorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetIndicatorsQuery, GetIndicatorsQueryVariables>(
    GetIndicatorsDocument,
    options,
  );
}
export type GetIndicatorsQueryHookResult = ReturnType<
  typeof useGetIndicatorsQuery
>;
export type GetIndicatorsLazyQueryHookResult = ReturnType<
  typeof useGetIndicatorsLazyQuery
>;
export type GetIndicatorsQueryResult = Apollo.QueryResult<
  GetIndicatorsQuery,
  GetIndicatorsQueryVariables
>;
export const GetIndicatorsForSelectDocument = gql`
  query getIndicatorsForSelect(
    $page: Int
    $searchText: String
    $searchField: String
  ) {
    IndicatorGetter {
      getIndicators(
        page: $page
        count: 25
        searchText: $searchText
        searchField: $searchField
      ) {
        items {
          ... on Indicator {
            ...fragmentIndicatorForSelect
          }
        }
      }
    }
  }
  ${FragmentIndicatorForSelectFragmentDoc}
`;

/**
 * __useGetIndicatorsForSelectQuery__
 *
 * To run a query within a React component, call `useGetIndicatorsForSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndicatorsForSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndicatorsForSelectQuery({
 *   variables: {
 *      page: // value for 'page'
 *      searchText: // value for 'searchText'
 *      searchField: // value for 'searchField'
 *   },
 * });
 */
export function useGetIndicatorsForSelectQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetIndicatorsForSelectQuery,
    GetIndicatorsForSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetIndicatorsForSelectQuery,
    GetIndicatorsForSelectQueryVariables
  >(GetIndicatorsForSelectDocument, options);
}
export function useGetIndicatorsForSelectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIndicatorsForSelectQuery,
    GetIndicatorsForSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetIndicatorsForSelectQuery,
    GetIndicatorsForSelectQueryVariables
  >(GetIndicatorsForSelectDocument, options);
}
export type GetIndicatorsForSelectQueryHookResult = ReturnType<
  typeof useGetIndicatorsForSelectQuery
>;
export type GetIndicatorsForSelectLazyQueryHookResult = ReturnType<
  typeof useGetIndicatorsForSelectLazyQuery
>;
export type GetIndicatorsForSelectQueryResult = Apollo.QueryResult<
  GetIndicatorsForSelectQuery,
  GetIndicatorsForSelectQueryVariables
>;
export const GetIndicatorDocument = gql`
  query getIndicator($id: ID!) {
    IndicatorGetter {
      getIndicator(id: $id) {
        ... on Indicator {
          ...fragmentIndicator
        }
      }
    }
  }
  ${FragmentIndicatorFragmentDoc}
`;

/**
 * __useGetIndicatorQuery__
 *
 * To run a query within a React component, call `useGetIndicatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndicatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndicatorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetIndicatorQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetIndicatorQuery,
    GetIndicatorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetIndicatorQuery, GetIndicatorQueryVariables>(
    GetIndicatorDocument,
    options,
  );
}
export function useGetIndicatorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIndicatorQuery,
    GetIndicatorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetIndicatorQuery, GetIndicatorQueryVariables>(
    GetIndicatorDocument,
    options,
  );
}
export type GetIndicatorQueryHookResult = ReturnType<
  typeof useGetIndicatorQuery
>;
export type GetIndicatorLazyQueryHookResult = ReturnType<
  typeof useGetIndicatorLazyQuery
>;
export type GetIndicatorQueryResult = Apollo.QueryResult<
  GetIndicatorQuery,
  GetIndicatorQueryVariables
>;
export const GetUploadValuesListDocument = gql`
  query getUploadValuesList(
    $page: Int
    $count: Int
    $searchText: String
    $searchField: String
    $sortField: String
    $sortType: String
  ) {
    IndicatorGetter {
      getUploadValuesList(
        page: $page
        count: $count
        searchText: $searchText
        searchField: $searchField
        sortField: $sortField
        sortType: $sortType
      ) {
        items {
          ... on UploadList {
            ...fragmentUploadListForTable
          }
        }
        total
      }
    }
  }
  ${FragmentUploadListForTableFragmentDoc}
`;

/**
 * __useGetUploadValuesListQuery__
 *
 * To run a query within a React component, call `useGetUploadValuesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadValuesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadValuesListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      searchText: // value for 'searchText'
 *      searchField: // value for 'searchField'
 *      sortField: // value for 'sortField'
 *      sortType: // value for 'sortType'
 *   },
 * });
 */
export function useGetUploadValuesListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUploadValuesListQuery,
    GetUploadValuesListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUploadValuesListQuery,
    GetUploadValuesListQueryVariables
  >(GetUploadValuesListDocument, options);
}
export function useGetUploadValuesListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUploadValuesListQuery,
    GetUploadValuesListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUploadValuesListQuery,
    GetUploadValuesListQueryVariables
  >(GetUploadValuesListDocument, options);
}
export type GetUploadValuesListQueryHookResult = ReturnType<
  typeof useGetUploadValuesListQuery
>;
export type GetUploadValuesListLazyQueryHookResult = ReturnType<
  typeof useGetUploadValuesListLazyQuery
>;
export type GetUploadValuesListQueryResult = Apollo.QueryResult<
  GetUploadValuesListQuery,
  GetUploadValuesListQueryVariables
>;
export const GetUploadLogByIdDocument = gql`
  query getUploadLogById($id: ID!) {
    IndicatorGetter {
      getUploadLogById(id: $id) {
        ... on UploadList {
          ...fragmentUploadListForTable
        }
      }
    }
  }
  ${FragmentUploadListForTableFragmentDoc}
`;

/**
 * __useGetUploadLogByIdQuery__
 *
 * To run a query within a React component, call `useGetUploadLogByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadLogByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadLogByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUploadLogByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUploadLogByIdQuery,
    GetUploadLogByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUploadLogByIdQuery, GetUploadLogByIdQueryVariables>(
    GetUploadLogByIdDocument,
    options,
  );
}
export function useGetUploadLogByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUploadLogByIdQuery,
    GetUploadLogByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUploadLogByIdQuery,
    GetUploadLogByIdQueryVariables
  >(GetUploadLogByIdDocument, options);
}
export type GetUploadLogByIdQueryHookResult = ReturnType<
  typeof useGetUploadLogByIdQuery
>;
export type GetUploadLogByIdLazyQueryHookResult = ReturnType<
  typeof useGetUploadLogByIdLazyQuery
>;
export type GetUploadLogByIdQueryResult = Apollo.QueryResult<
  GetUploadLogByIdQuery,
  GetUploadLogByIdQueryVariables
>;
export const DownloadIndicatorsValueDocument = gql`
  query downloadIndicatorsValue(
    $DealerIds: [ID]
    $IndicatorIds: [ID]
    $year: Int
    $dateBegin: DateTime
    $dateEnd: DateTime
  ) {
    IndicatorGetter {
      downloadIndicatorsValue(
        DealerIds: $DealerIds
        IndicatorIds: $IndicatorIds
        year: $year
        dateBegin: $dateBegin
        dateEnd: $dateEnd
      ) {
        ... on ReportFile {
          fileHash
        }
      }
    }
  }
`;

/**
 * __useDownloadIndicatorsValueQuery__
 *
 * To run a query within a React component, call `useDownloadIndicatorsValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadIndicatorsValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadIndicatorsValueQuery({
 *   variables: {
 *      DealerIds: // value for 'DealerIds'
 *      IndicatorIds: // value for 'IndicatorIds'
 *      year: // value for 'year'
 *      dateBegin: // value for 'dateBegin'
 *      dateEnd: // value for 'dateEnd'
 *   },
 * });
 */
export function useDownloadIndicatorsValueQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DownloadIndicatorsValueQuery,
    DownloadIndicatorsValueQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DownloadIndicatorsValueQuery,
    DownloadIndicatorsValueQueryVariables
  >(DownloadIndicatorsValueDocument, options);
}
export function useDownloadIndicatorsValueLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DownloadIndicatorsValueQuery,
    DownloadIndicatorsValueQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DownloadIndicatorsValueQuery,
    DownloadIndicatorsValueQueryVariables
  >(DownloadIndicatorsValueDocument, options);
}
export type DownloadIndicatorsValueQueryHookResult = ReturnType<
  typeof useDownloadIndicatorsValueQuery
>;
export type DownloadIndicatorsValueLazyQueryHookResult = ReturnType<
  typeof useDownloadIndicatorsValueLazyQuery
>;
export type DownloadIndicatorsValueQueryResult = Apollo.QueryResult<
  DownloadIndicatorsValueQuery,
  DownloadIndicatorsValueQueryVariables
>;
export const GetIndicatorReportsDocument = gql`
  query GetIndicatorReports(
    $GroupId: ID!
    $sortField: String
    $sortType: String
    $status: String
    $page: Int = 0
    $count: Int = 10
  ) {
    IndicatorGroupReportGetter {
      getIndicatorReports(
        GroupId: $GroupId
        sortField: $sortField
        sortType: $sortType
        status: $status
        page: $page
        count: $count
      ) {
        items {
          ...fragmentGetIndicatorReports
        }
        total
      }
    }
  }
  ${FragmentGetIndicatorReportsFragmentDoc}
`;

/**
 * __useGetIndicatorReportsQuery__
 *
 * To run a query within a React component, call `useGetIndicatorReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndicatorReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndicatorReportsQuery({
 *   variables: {
 *      GroupId: // value for 'GroupId'
 *      sortField: // value for 'sortField'
 *      sortType: // value for 'sortType'
 *      status: // value for 'status'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetIndicatorReportsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetIndicatorReportsQuery,
    GetIndicatorReportsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetIndicatorReportsQuery,
    GetIndicatorReportsQueryVariables
  >(GetIndicatorReportsDocument, options);
}
export function useGetIndicatorReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIndicatorReportsQuery,
    GetIndicatorReportsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetIndicatorReportsQuery,
    GetIndicatorReportsQueryVariables
  >(GetIndicatorReportsDocument, options);
}
export type GetIndicatorReportsQueryHookResult = ReturnType<
  typeof useGetIndicatorReportsQuery
>;
export type GetIndicatorReportsLazyQueryHookResult = ReturnType<
  typeof useGetIndicatorReportsLazyQuery
>;
export type GetIndicatorReportsQueryResult = Apollo.QueryResult<
  GetIndicatorReportsQuery,
  GetIndicatorReportsQueryVariables
>;
export const GetIndicatorReportDocument = gql`
  query GetIndicatorReport($ReportId: ID!) {
    IndicatorGroupReportGetter {
      getIndicatorReport(ReportId: $ReportId) {
        ...fragmentGetIndicatorReports
      }
    }
  }
  ${FragmentGetIndicatorReportsFragmentDoc}
`;

/**
 * __useGetIndicatorReportQuery__
 *
 * To run a query within a React component, call `useGetIndicatorReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndicatorReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndicatorReportQuery({
 *   variables: {
 *      ReportId: // value for 'ReportId'
 *   },
 * });
 */
export function useGetIndicatorReportQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetIndicatorReportQuery,
    GetIndicatorReportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetIndicatorReportQuery,
    GetIndicatorReportQueryVariables
  >(GetIndicatorReportDocument, options);
}
export function useGetIndicatorReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIndicatorReportQuery,
    GetIndicatorReportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetIndicatorReportQuery,
    GetIndicatorReportQueryVariables
  >(GetIndicatorReportDocument, options);
}
export type GetIndicatorReportQueryHookResult = ReturnType<
  typeof useGetIndicatorReportQuery
>;
export type GetIndicatorReportLazyQueryHookResult = ReturnType<
  typeof useGetIndicatorReportLazyQuery
>;
export type GetIndicatorReportQueryResult = Apollo.QueryResult<
  GetIndicatorReportQuery,
  GetIndicatorReportQueryVariables
>;
export const GetIndicatorReportToViewDocument = gql`
  query GetIndicatorReportToView(
    $ReportId: ID!
    $group: typeGroupDealerIndicatorValues
    $DealerIds: [ID]
    $City: [String]
    $Region: [String]
    $FO: [String]
    $RegMenIds: [ID]
    $HoldingIds: [ID]
    $Country: [ID]
    $quarter: Int
    $year: Int
    $dateBegin: DateTime
    $dateEnd: DateTime
    $lang: String
    $isFull: Boolean = false
    $page: Int = 0
    $count: Int = 10
  ) {
    IndicatorGroupReportGetter {
      getDealerIndicatorValuesReport(
        ReportId: $ReportId
        HoldingIds: $HoldingIds
        group: $group
        DealerIds: $DealerIds
        City: $City
        Region: $Region
        FO: $FO
        RegMenIds: $RegMenIds
        Country: $Country
        quarter: $quarter
        year: $year
        dateBegin: $dateBegin
        dateEnd: $dateEnd
        lang: $lang
        isFull: $isFull
        page: $page
        count: $count
      ) {
        items {
          ...fragmentIndicatorReportToView
        }
        total
        IndicatorReport {
          ...fragmentGetIndicatorReports
        }
        RegMen {
          ...fragmentDealerRegManInfo
        }
      }
    }
  }
  ${FragmentIndicatorReportToViewFragmentDoc}
  ${FragmentGetIndicatorReportsFragmentDoc}
  ${FragmentDealerRegManInfoFragmentDoc}
`;

/**
 * __useGetIndicatorReportToViewQuery__
 *
 * To run a query within a React component, call `useGetIndicatorReportToViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndicatorReportToViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndicatorReportToViewQuery({
 *   variables: {
 *      ReportId: // value for 'ReportId'
 *      group: // value for 'group'
 *      DealerIds: // value for 'DealerIds'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      FO: // value for 'FO'
 *      RegMenIds: // value for 'RegMenIds'
 *      HoldingIds: // value for 'HoldingIds'
 *      Country: // value for 'Country'
 *      quarter: // value for 'quarter'
 *      year: // value for 'year'
 *      dateBegin: // value for 'dateBegin'
 *      dateEnd: // value for 'dateEnd'
 *      lang: // value for 'lang'
 *      isFull: // value for 'isFull'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetIndicatorReportToViewQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetIndicatorReportToViewQuery,
    GetIndicatorReportToViewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetIndicatorReportToViewQuery,
    GetIndicatorReportToViewQueryVariables
  >(GetIndicatorReportToViewDocument, options);
}
export function useGetIndicatorReportToViewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIndicatorReportToViewQuery,
    GetIndicatorReportToViewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetIndicatorReportToViewQuery,
    GetIndicatorReportToViewQueryVariables
  >(GetIndicatorReportToViewDocument, options);
}
export type GetIndicatorReportToViewQueryHookResult = ReturnType<
  typeof useGetIndicatorReportToViewQuery
>;
export type GetIndicatorReportToViewLazyQueryHookResult = ReturnType<
  typeof useGetIndicatorReportToViewLazyQuery
>;
export type GetIndicatorReportToViewQueryResult = Apollo.QueryResult<
  GetIndicatorReportToViewQuery,
  GetIndicatorReportToViewQueryVariables
>;
export const GetIndicatorReportHashDocument = gql`
  query GetIndicatorReportHash(
    $ReportId: ID!
    $group: typeGroupDealerIndicatorValues
    $DealerIds: [ID]
    $HoldingIds: [ID]
    $City: [String]
    $Region: [String]
    $FO: [String]
    $RegMenIds: [ID]
    $Country: [ID]
    $quarter: Int
    $year: Int
    $dateBegin: DateTime
    $dateEnd: DateTime
    $lang: String
    $isFull: Boolean = false
  ) {
    IndicatorGroupReportGetter {
      getDealerIndicatorValuesTableHash(
        ReportId: $ReportId
        group: $group
        DealerIds: $DealerIds
        City: $City
        Region: $Region
        FO: $FO
        RegMenIds: $RegMenIds
        HoldingIds: $HoldingIds
        Country: $Country
        quarter: $quarter
        year: $year
        dateBegin: $dateBegin
        dateEnd: $dateEnd
        lang: $lang
        isFull: $isFull
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetIndicatorReportHashQuery__
 *
 * To run a query within a React component, call `useGetIndicatorReportHashQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndicatorReportHashQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndicatorReportHashQuery({
 *   variables: {
 *      ReportId: // value for 'ReportId'
 *      group: // value for 'group'
 *      DealerIds: // value for 'DealerIds'
 *      HoldingIds: // value for 'HoldingIds'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      FO: // value for 'FO'
 *      RegMenIds: // value for 'RegMenIds'
 *      Country: // value for 'Country'
 *      quarter: // value for 'quarter'
 *      year: // value for 'year'
 *      dateBegin: // value for 'dateBegin'
 *      dateEnd: // value for 'dateEnd'
 *      lang: // value for 'lang'
 *      isFull: // value for 'isFull'
 *   },
 * });
 */
export function useGetIndicatorReportHashQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetIndicatorReportHashQuery,
    GetIndicatorReportHashQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetIndicatorReportHashQuery,
    GetIndicatorReportHashQueryVariables
  >(GetIndicatorReportHashDocument, options);
}
export function useGetIndicatorReportHashLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIndicatorReportHashQuery,
    GetIndicatorReportHashQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetIndicatorReportHashQuery,
    GetIndicatorReportHashQueryVariables
  >(GetIndicatorReportHashDocument, options);
}
export type GetIndicatorReportHashQueryHookResult = ReturnType<
  typeof useGetIndicatorReportHashQuery
>;
export type GetIndicatorReportHashLazyQueryHookResult = ReturnType<
  typeof useGetIndicatorReportHashLazyQuery
>;
export type GetIndicatorReportHashQueryResult = Apollo.QueryResult<
  GetIndicatorReportHashQuery,
  GetIndicatorReportHashQueryVariables
>;
export const GetIndicatorGroupsDocument = gql`
  query GetIndicatorGroups(
    $sortField: String
    $sortType: String
    $status: String
    $page: Int
    $count: Int
  ) {
    IndicatorGroupReportGetter {
      getIndicatorGroups(
        sortField: $sortField
        sortType: $sortType
        status: $status
        page: $page
        count: $count
      ) {
        items {
          ...fragmentIndicatorGroupsItems
        }
        total
      }
    }
  }
  ${FragmentIndicatorGroupsItemsFragmentDoc}
`;

/**
 * __useGetIndicatorGroupsQuery__
 *
 * To run a query within a React component, call `useGetIndicatorGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndicatorGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndicatorGroupsQuery({
 *   variables: {
 *      sortField: // value for 'sortField'
 *      sortType: // value for 'sortType'
 *      status: // value for 'status'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetIndicatorGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetIndicatorGroupsQuery,
    GetIndicatorGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetIndicatorGroupsQuery,
    GetIndicatorGroupsQueryVariables
  >(GetIndicatorGroupsDocument, options);
}
export function useGetIndicatorGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIndicatorGroupsQuery,
    GetIndicatorGroupsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetIndicatorGroupsQuery,
    GetIndicatorGroupsQueryVariables
  >(GetIndicatorGroupsDocument, options);
}
export type GetIndicatorGroupsQueryHookResult = ReturnType<
  typeof useGetIndicatorGroupsQuery
>;
export type GetIndicatorGroupsLazyQueryHookResult = ReturnType<
  typeof useGetIndicatorGroupsLazyQuery
>;
export type GetIndicatorGroupsQueryResult = Apollo.QueryResult<
  GetIndicatorGroupsQuery,
  GetIndicatorGroupsQueryVariables
>;
export const GetIndicatorGroupByIdDocument = gql`
  query GetIndicatorGroupById($GroupId: ID!) {
    IndicatorGroupReportGetter {
      getIndicatorGroup(GroupId: $GroupId) {
        ...fragmentIndicatorGroupsItems
      }
    }
  }
  ${FragmentIndicatorGroupsItemsFragmentDoc}
`;

/**
 * __useGetIndicatorGroupByIdQuery__
 *
 * To run a query within a React component, call `useGetIndicatorGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndicatorGroupByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndicatorGroupByIdQuery({
 *   variables: {
 *      GroupId: // value for 'GroupId'
 *   },
 * });
 */
export function useGetIndicatorGroupByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetIndicatorGroupByIdQuery,
    GetIndicatorGroupByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetIndicatorGroupByIdQuery,
    GetIndicatorGroupByIdQueryVariables
  >(GetIndicatorGroupByIdDocument, options);
}
export function useGetIndicatorGroupByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIndicatorGroupByIdQuery,
    GetIndicatorGroupByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetIndicatorGroupByIdQuery,
    GetIndicatorGroupByIdQueryVariables
  >(GetIndicatorGroupByIdDocument, options);
}
export type GetIndicatorGroupByIdQueryHookResult = ReturnType<
  typeof useGetIndicatorGroupByIdQuery
>;
export type GetIndicatorGroupByIdLazyQueryHookResult = ReturnType<
  typeof useGetIndicatorGroupByIdLazyQuery
>;
export type GetIndicatorGroupByIdQueryResult = Apollo.QueryResult<
  GetIndicatorGroupByIdQuery,
  GetIndicatorGroupByIdQueryVariables
>;
export const GetLogsDocument = gql`
  query getLogs(
    $UserId: ID
    $event: String
    $dateEnd: DateTime
    $dateBegin: DateTime
    $page: Int
    $count: Int
  ) {
    LogGetter {
      getLogs(
        UserId: $UserId
        event: $event
        dateEnd: $dateEnd
        dateBegin: $dateBegin
        page: $page
        count: $count
      ) {
        items {
          id
          User {
            ...fragmentProfile
          }
          data {
            ... on logForEditEducationProgram {
              nextValue {
                ...fragmentCurriculumStudyPrograms
              }
              prevValue {
                ...fragmentCurriculumStudyPrograms
              }
              event
            }
            ... on logForDealer {
              nextValue {
                ...fragmentDealerForLogs
              }
              prevValue {
                ...fragmentDealerForLogs
              }
              event
            }
            ... on logForEditValueStaff {
              nextValue {
                doubleValue
                stringValue
                DealerId
                IndicatorId
                Indicator {
                  ...fragmentIndicatorForLogs
                }
                createdAt
              }
              event
            }
            ... on logForEditStaff {
              nextValue {
                ...fragmentStaffForLogs
              }
              prevValue {
                ...fragmentStaffForLogs
              }
              event
            }
            ... on logAddDealerToUser {
              nextValue {
                UserId
                DealerId
              }
              prevValue {
                UserId
                DealerId
              }
              event
            }
            ... on logForEditGRVersion {
              nextValue {
                quarter
                year
                dateBegin
                IndicatorId
              }
              prevValue {
                quarter
                year
                dateBegin
                IndicatorId
              }
              event
            }
            ... on logForEditGRRow {
              nextValue {
                ...fragmentGrRatingForLogs
              }
              prevValue {
                ...fragmentGrRatingForLogs
              }
              event
            }
            ... on logForEditIndicator {
              nextValue {
                ...fragmentIndicatorForLogs
              }
              prevValue {
                ...fragmentIndicatorForLogs
              }
              event
            }
            ... on logForEditQVersion {
              nextValue {
                ...fragmentQDataForLogs
              }
              prevValue {
                ...fragmentQDataForLogs
              }
              event
            }
            ... on logForEditQRow {
              nextValue {
                ...fragmentQRatingForEditorLogs
              }
              prevValue {
                ...fragmentQRatingForEditorLogs
              }
              event
            }
            ... on logForEditUser {
              nextValue {
                ...fragmentProfileForLogs
              }
              prevValue {
                ...fragmentProfileForLogs
              }
              event
            }
            ... on logForEditEmployee {
              nextValue {
                ...fragmentEmployeeLog
              }
              prevValue {
                ...fragmentEmployeeLog
              }
              event
            }
            ... on logForEditEmployeePosition {
              nextValue {
                ...fragmentEmployeePositionLog
              }
              prevValue {
                ...fragmentEmployeePositionLog
              }
              event
            }
            ... on logForCreateAnnouncement {
              nextValue {
                ...fragmentAnnouncementForLogs
              }
              event
            }
            ... on logForEditAnnouncement {
              nextValue {
                ...fragmentAnnouncementForLogs
              }
              prevValue {
                ...fragmentAnnouncementForLogs
              }
              event
            }
            ... on logForCreateDocument {
              nextValue {
                ...fragmentDocumentForLogs
              }
              event
            }
            ... on logForEditDocument {
              nextValue {
                ...fragmentDocumentForLogs
              }
              prevValue {
                ...fragmentDocumentForLogs
              }
              event
            }
            ... on logForCreateSection {
              nextValue {
                ...fragmentSectionForLogs
              }
              event
            }
            ... on logForEditSection {
              nextValue {
                ...fragmentSectionForLogs
              }
              prevValue {
                ...fragmentSectionForLogs
              }
              event
            }
            ... on logForDeleteSection {
              prevValue {
                ...fragmentSectionForLogs
              }
              event
            }
            ... on logForCreateCamera {
              nextValue {
                ...fragmentCameraForLogs
              }
              event
            }
            ... on logForEditCamera {
              nextValue {
                ...fragmentCameraForLogs
              }
              prevValue {
                ...fragmentCameraForLogs
              }
              event
            }
            ... on logForDeleteCamera {
              prevValue {
                ...fragmentCameraForLogs
              }
              event
            }
            ... on logForCreateCameraCheck {
              nextValue {
                ...fragmentCameraCheckForLogs
              }
              event
            }
            ... on logForEditCameraCheck {
              nextValue {
                ...fragmentCameraCheckForLogs
              }
              prevValue {
                ...fragmentCameraCheckForLogs
              }
              event
            }
            ... on logForCreateCameraZone {
              nextValue {
                ...fragmentCameraZoneForLogs
              }
              event
            }
            ... on logForEditCameraZone {
              nextValue {
                ...fragmentCameraZoneForLogs
              }
              prevValue {
                ...fragmentCameraZoneForLogs
              }
              event
            }
            ... on logForDeleteCameraZone {
              prevValue {
                ...fragmentCameraZoneForLogs
              }
              event
            }
            ... on logForAddIndicatorGroup {
              nextValue {
                ...fragmentIndicatorGroupForLogs
              }
              event
            }
            ... on logForEditIndicatorGroup {
              nextValue {
                ...fragmentIndicatorGroupForLogs
              }
              prevValue {
                ...fragmentIndicatorGroupForLogs
              }
              event
            }
            ... on logForAddIndicatorReport {
              nextValue {
                ...fragmentIndicatorReportForLogs
              }
              event
            }
            ... on logForChangeIndicatorReport {
              prevValue {
                ...fragmentIndicatorReportForLogs
              }
              nextValue {
                ...fragmentIndicatorReportForLogs
              }
              event
            }
            ... on logForAddIndicatorToReport {
              event
            }
            ... on logForDeleteIndicatorToReport {
              prevValue {
                ...fragmentIndicatorAndReport
              }
              nextValue {
                ...fragmentIndicatorAndReport
              }
              event
            }
            ... on logForZdNotes {
              nextValue {
                Image
                Compliance
                UUID
                tableIndex
                name
                nameEn
              }
              prevValue {
                Image
                Compliance
                UUID
                tableIndex
                name
                nameEn
              }
              event
            }
            ... on logForZdServiceZs {
              nextValue {
                UUID
                tableIndex
                name
                nameEn
                CertificationDate
                Fact
                FactContract
                Compliance
              }
              prevValue {
                UUID
                tableIndex
                name
                nameEn
                CertificationDate
                Fact
                FactContract
                Compliance
              }
              event
            }
            ... on logForZdPersonal {
              nextValue {
                UUID
                tableIndex
                name
                nameEn
                PersonName
                Position
                PositionStart
                StudyCertificateDate
                DocName
                Image
                Compliance
              }
              prevValue {
                UUID
                tableIndex
                name
                nameEn
                PersonName
                Position
                PositionStart
                StudyCertificateDate
                DocName
                Image
                Compliance
              }
              event
            }
            ... on logForZdPlacePosts {
              nextValue {
                UUID
                tableIndex
                name
                nameEn
                Total
                Compliance
              }
              prevValue {
                UUID
                tableIndex
                name
                nameEn
                Total
                Compliance
              }
              event
            }
            ... on logForZdPlaces {
              nextValue {
                UUID
                tableIndex
                name
                nameEn
                Area
                PlacesCombine
                Compliance
              }
              prevValue {
                UUID
                tableIndex
                name
                nameEn
                Area
                PlacesCombine
                Compliance
              }
              event
            }
            ... on logForZdRequiredTools {
              nextValue {
                ...fragmentLogForZdRequiredTools
              }
              prevValue {
                ...fragmentLogForZdRequiredTools
              }
              event
            }
            ... on logForZdToolsInsuranceZs {
              nextValue {
                UUID
                tableIndex
                name
                nameEn
                Standard
                Total
                Compliance
              }
              prevValue {
                UUID
                tableIndex
                name
                nameEn
                Standard
                Total
                Compliance
              }
              event
            }
            ... on logForZdToolsMetrologicalZs {
              nextValue {
                UUID
                tableIndex
                name
                nameEn
                Standard
                Total
                Compliance
              }
              prevValue {
                UUID
                tableIndex
                name
                nameEn
                Standard
                Total
                Compliance
              }
              event
            }
            ... on logForZdToolsZs {
              nextValue {
                UUID
                tableIndex
                name
                nameEn
                Model
                Country
                Year
                Note
                Total
                Compliance
              }
              prevValue {
                UUID
                tableIndex
                name
                nameEn
                Model
                Country
                Year
                Note
                Total
                Compliance
              }
              event
            }
            ... on logForZdWarehousesZs {
              nextValue {
                UUID
                tableIndex
                name
                nameEn
                Area
                Combine
                Compliance
              }
              prevValue {
                UUID
                tableIndex
                name
                nameEn
                Area
                Combine
                Compliance
              }
              event
            }
            ... on logForEditFile {
              nextValue {
                User {
                  ...fragmentProfileForLogs
                }
                mimeType
                name
                createdAt
              }
              prevValue {
                User {
                  ...fragmentProfileForLogs
                }
                mimeType
                name
                createdAt
              }
              event
            }
            ... on logForDeleteFile {
              prevValue {
                FileId
                FileName
                catalog
                UserId
                date
              }
              event
            }
            ... on logForUploadFileToCatalog {
              nextValue {
                fileName
                catalog
                UserId
                uploadDate
                Dealer {
                  DealerName
                }
              }
              event
            }
            ... on logDefault {
              event
            }
            ... on logForZdDefinitionServices {
              nextValue {
                Code
                FactIndicator
                CertificationDateIndicator
                FactContractIndicator
                ComplianceIndicator
                UUID
                tableIndex
                name
                nameEn
                sort
                isListed
                forUUID
                ActualTo
                ActualFrom
              }
              prevValue {
                Code
                FactIndicator
                CertificationDateIndicator
                FactContractIndicator
                ComplianceIndicator
                UUID
                tableIndex
                name
                nameEn
                sort
                isListed
                forUUID
                ActualTo
                ActualFrom
              }
              event
            }
            ... on logForZdDefinitionPlaces {
              nextValue {
                Number
                AreaIndicator
                PlacesCombineIndicator
                ComplianceIndicator
                UUID
                tableIndex
                name
                nameEn
                sort
                isListed
                forUUID
                ActualTo
                ActualFrom
              }
              prevValue {
                Number
                AreaIndicator
                PlacesCombineIndicator
                ComplianceIndicator
                UUID
                tableIndex
                name
                nameEn
                sort
                isListed
                forUUID
                ActualTo
                ActualFrom
              }
              event
            }
            ... on logForZdDefinitionPlacePosts {
              nextValue {
                ZD_PlacesId
                TotalIndicator
                ComplianceIndicator
                UUID
                tableIndex
                name
                nameEn
                sort
                isListed
                forUUID
                ActualTo
                ActualFrom
              }
              prevValue {
                ZD_PlacesId
                TotalIndicator
                ComplianceIndicator
                UUID
                tableIndex
                name
                nameEn
                sort
                isListed
                forUUID
                ActualTo
                ActualFrom
              }
              event
            }
            ... on logForZdDefinitionWarehouses {
              nextValue {
                Number
                AreaIndicator
                CombineIndicator
                ComplianceIndicator
                UUID
                tableIndex
                name
                nameEn
                sort
                isListed
                forUUID
                ActualTo
                ActualFrom
              }
              prevValue {
                Number
                AreaIndicator
                CombineIndicator
                ComplianceIndicator
                UUID
                tableIndex
                name
                nameEn
                sort
                isListed
                forUUID
                ActualTo
                ActualFrom
              }
              event
            }
            ... on logForZdDefinitionTools {
              nextValue {
                Number
                GroupOne
                GroupTwo
                TotalIndicator
                ModelIndicator
                CountryIndicator
                YearIndicator
                NoteIndicator
                ComplianceIndicator
                UUID
                tableIndex
                name
                nameEn
                sort
                isListed
                forUUID
                ActualTo
                ActualFrom
              }
              prevValue {
                Number
                GroupOne
                GroupTwo
                TotalIndicator
                ModelIndicator
                CountryIndicator
                YearIndicator
                NoteIndicator
                ComplianceIndicator
                UUID
                tableIndex
                name
                nameEn
                sort
                isListed
                forUUID
                ActualTo
                ActualFrom
              }
              event
            }
            ... on logForZdDefinitionRequiredTools {
              nextValue {
                Number
                ModelIndicator
                TotalIndicator
                CheckedDateIndicator
                ComplianceIndicator
                UUID
                tableIndex
                name
                nameEn
                sort
                isListed
                forUUID
                ActualTo
                ActualFrom
              }
              prevValue {
                Number
                ModelIndicator
                TotalIndicator
                CheckedDateIndicator
                ComplianceIndicator
                UUID
                tableIndex
                name
                nameEn
                sort
                isListed
                forUUID
                ActualTo
                ActualFrom
              }
              event
            }
            ... on logForZdDefinitionPersonal {
              nextValue {
                Number
                DocName
                ComplianceIndicator
                InstanceIdIndicator
                commentIndicator
                planReportIdIndicator
                UUID
                tableIndex
                name
                nameEn
                sort
                isListed
                forUUID
                ActualTo
                ActualFrom
              }
              prevValue {
                Number
                DocName
                ComplianceIndicator
                InstanceIdIndicator
                commentIndicator
                planReportIdIndicator
                UUID
                tableIndex
                name
                nameEn
                sort
                isListed
                forUUID
                ActualTo
                ActualFrom
              }
              event
            }
            ... on logForZdDefinitionToolsInsurance {
              nextValue {
                Number
                GroupOne
                GroupTwo
                NumberList
                NumberDetail
                TotalIndicator
                ComplianceIndicator
                UUID
                tableIndex
                name
                nameEn
                sort
                isListed
                forUUID
                ActualTo
                ActualFrom
              }
              prevValue {
                Number
                GroupOne
                GroupTwo
                NumberList
                NumberDetail
                TotalIndicator
                ComplianceIndicator
                UUID
                tableIndex
                name
                nameEn
                sort
                isListed
                forUUID
                ActualTo
                ActualFrom
              }
              event
            }
            ... on logForZdDefinitionToolsMetrological {
              nextValue {
                Number
                TotalIndicator
                ComplianceIndicator
                UUID
                tableIndex
                name
                nameEn
                sort
                isListed
                forUUID
                ActualTo
                ActualFrom
              }
              prevValue {
                Number
                TotalIndicator
                ComplianceIndicator
                UUID
                tableIndex
                name
                nameEn
                sort
                isListed
                forUUID
                ActualTo
                ActualFrom
              }
              event
            }
            ... on logForZdDefinitionNotes {
              nextValue {
                Number
                ImageIndicator
                ComplianceIndicator
                UUID
                tableIndex
                name
                nameEn
                sort
                isListed
                forUUID
                ActualTo
                ActualFrom
              }
              prevValue {
                Number
                ImageIndicator
                ComplianceIndicator
                UUID
                tableIndex
                name
                nameEn
                sort
                isListed
                forUUID
                ActualTo
                ActualFrom
              }
              event
            }
            ... on logForViolation {
              nextValue {
                id
                DealerId
                ViolationTypesId
                DocId
                DocNum
                DocDate
                description
                fixDeadline
                punishment
                status
                reportedBy
                responsibleChecker
                fixDateAt
                createdAt
              }
              prevValue {
                id
                DealerId
                ViolationTypesId
                DocId
                DocNum
                DocDate
                description
                fixDeadline
                punishment
                status
                reportedBy
                responsibleChecker
                fixDateAt
                createdAt
              }
              event
            }
            ... on logForAccountingPeriod {
              nextValue {
                id
                Year
                Quarter
                lastDate
                reportDate
                createdAt
              }
              prevValue {
                id
                Year
                Quarter
                lastDate
                reportDate
                createdAt
              }
              event
            }
            ... on logForDeleteEducationCatalog {
              nextValue {
                ... on CatalogCurriculum {
                  ...fragmentCatalogCurriculum
                }
              }
              prevValue {
                ... on CatalogCurriculum {
                  ...fragmentCatalogCurriculum
                }
              }
              event
            }
            ... on logForCreatedEducationCatalog {
              nextValue {
                ... on CatalogCurriculum {
                  ...fragmentCatalogCurriculum
                }
              }
              event
            }
            ... on logForEditEducationCourse {
              nextValue {
                ... on CourseCurriculum {
                  ...fragmentCourseCurriculum
                }
              }
              prevValue {
                ... on CourseCurriculum {
                  ...fragmentCourseCurriculum
                }
              }
              event
            }
            ... on logForCreatedEducationCourse {
              nextValue {
                id
                name
                code
                codeIS
                certificateValidityPeriod
                LevelId
                statusCreatedCourse: status
                createdAt
                updatedAt
                Level {
                  id
                  name
                }
                InstanceId
                ActualFrom
                ActualTo
              }
              event
            }
            ... on logForDeleteEducationCourse {
              nextValue {
                id
                name
                code
                codeIS
                certificateValidityPeriod
                LevelId
                statusDeleteEducationCourse: status
                createdAt
                updatedAt
                Level {
                  id
                  name
                }
                InstanceId
                ActualFrom
                ActualTo
              }
              prevValue {
                id
                name
                code
                codeIS
                certificateValidityPeriod
                LevelId
                statusDeleteEducationCourse: status
                createdAt
                updatedAt
                Level {
                  id
                  name
                }
                InstanceId
                ActualFrom
                ActualTo
              }
              event
            }
            ... on logForEditEducationLevel {
              nextValue {
                id
                name
                statusEditEducationLevel: status
                dateActiveStatus
                dateInactiveStatus
                createdAt
                updatedAt
                sequenceNumber
                GroupId
                Group {
                  id
                  name
                }
                InstanceId
                ActualFrom
                ActualTo
              }
              prevValue {
                id
                name
                statusEditEducationLevel: status
                dateActiveStatus
                dateInactiveStatus
                createdAt
                updatedAt
                sequenceNumber
                GroupId
                Group {
                  id
                  name
                }
                InstanceId
                ActualFrom
                ActualTo
              }
              event
            }
            ... on logForCreatedEducationLevel {
              nextValue {
                id
                name
                statusCreatedEducationLevel: status
                dateActiveStatus
                dateInactiveStatus
                createdAt
                updatedAt
                sequenceNumber
                GroupId
                Group {
                  id
                  name
                }
                InstanceId
                ActualFrom
                ActualTo
              }
              event
            }
            ... on logForDeleteEducationLevel {
              nextValue {
                id
                name
                statusDeleteEducationLevel: status
                dateActiveStatus
                dateInactiveStatus
                createdAt
                updatedAt
                sequenceNumber
                GroupId
                Group {
                  id
                  name
                }
                InstanceId
                ActualFrom
                ActualTo
              }
              prevValue {
                id
                name
                statusDeleteEducationLevel: status
                dateActiveStatus
                dateInactiveStatus
                createdAt
                updatedAt
                sequenceNumber
                GroupId
                Group {
                  id
                  name
                }
                InstanceId
                ActualFrom
                ActualTo
              }
              event
            }
            ... on logForEditEducationGroup {
              nextValue {
                id
                name
                statusEditEducationGroup: status
                dateActiveStatus
                dateInactiveStatus
                createdAt
                updatedAt
                sequenceNumber
                InstanceId
                ActualFrom
                ActualTo
              }
              prevValue {
                id
                name
                statusEditEducationGroup: status
                dateActiveStatus
                dateInactiveStatus
                createdAt
                updatedAt
                sequenceNumber
                InstanceId
                ActualFrom
                ActualTo
              }
              event
            }
            ... on logForCreatedEducationGroup {
              nextValue {
                id
                name
                statusCreatedEducationGroup: status
                dateActiveStatus
                dateInactiveStatus
                createdAt
                updatedAt
                sequenceNumber
                InstanceId
                ActualFrom
                ActualTo
              }
              event
            }
            ... on logForDeleteEducationGroup {
              nextValue {
                id
                name
                statusDeleteEducationGroup: status
                dateActiveStatus
                dateInactiveStatus
                createdAt
                updatedAt
                sequenceNumber
                InstanceId
                ActualFrom
                ActualTo
              }
              prevValue {
                id
                name
                statusDeleteEducationGroup: status
                dateActiveStatus
                dateInactiveStatus
                createdAt
                updatedAt
                sequenceNumber
                InstanceId
                ActualFrom
                ActualTo
              }
              event
            }
            ... on logForDeleteEducationProgram {
              nextValue {
                id
                PositionGroupId
                LevelId
                CourseId
                statusDeleteEducationProgram: status
                dateActiveStatus
                dateInactiveStatus
                Positions {
                  id
                  name
                }
                Level {
                  id
                  name
                }
                Course {
                  id
                  name
                }
                ActualFrom
                ActualTo
              }
              prevValue {
                id
                PositionGroupId
                LevelId
                CourseId
                statusDeleteEducationProgram: status
                dateActiveStatus
                dateInactiveStatus
                Positions {
                  id
                  name
                }
                Level {
                  id
                  name
                }
                Course {
                  id
                  name
                }
                ActualFrom
                ActualTo
              }
              event
            }
            ... on logForCreatedEducationProgram {
              nextValue {
                id
                PositionGroupId
                LevelId
                CourseId
                statusCreatedEducationProgram: status
                dateActiveStatus
                dateInactiveStatus
                Positions {
                  id
                  name
                }
                Level {
                  id
                  name
                }
                Course {
                  id
                  name
                }
                ActualFrom
                ActualTo
              }
              event
            }
            ... on logForEditPosition {
              nextValue {
                id
                code
                name
                nameEn
                statusEditPosition: status
                DirectionId
                Direction {
                  id
                  name
                }
                ExpectationId
                createdAt
                updatedAt
                RequiredEmail
                InstanceId
                ActualFrom
                ActualTo
              }
              prevValue {
                id
                code
                name
                nameEn
                statusEditPosition: status
                DirectionId
                Direction {
                  id
                  name
                }
                ExpectationId
                createdAt
                updatedAt
                RequiredEmail
                InstanceId
                ActualFrom
                ActualTo
              }
              event
            }
            ... on logForDeletePosition {
              nextValue {
                id
                code
                name
                nameEn
                statusDeletePosition: status
                DirectionId
                Direction {
                  id
                  name
                }
                ExpectationId
                createdAt
                updatedAt
                RequiredEmail
                InstanceId
                ActualFrom
                ActualTo
              }
              prevValue {
                id
                code
                name
                nameEn
                statusDeletePosition: status
                DirectionId
                Direction {
                  id
                  name
                }
                ExpectationId
                createdAt
                updatedAt
                RequiredEmail
                InstanceId
                ActualFrom
                ActualTo
              }
              event
            }
            ... on logForCreatedPosition {
              nextValue {
                id
                code
                name
                statusCreatedPosition: status
                DirectionId
                Direction {
                  id
                  name
                }
                createdAt
                updatedAt
                RequiredEmail
                InstanceId
                ActualFrom
              }
              event
            }
            ... on logForEditPositionDirection {
              nextValue {
                id
                InstanceId
                ActualFrom
                ActualTo
                name
                statusEditPositionDirection: status
                createdAt
                updatedAt
                roleEditPositionDirection: role
              }
              prevValue {
                id
                InstanceId
                ActualFrom
                ActualTo
                name
                statusEditPositionDirection: status
                createdAt
                updatedAt
                roleEditPositionDirection: role
              }
              event
            }
            ... on logForDeletePositionDirection {
              nextValue {
                id
                InstanceId
                ActualFrom
                ActualTo
                name
                statusDeletePositionDirection: status
                createdAt
                updatedAt
                roleDeletePositionDirection: role
              }
              prevValue {
                id
                InstanceId
                ActualFrom
                ActualTo
                name
                statusDeletePositionDirection: status
                createdAt
                updatedAt
                roleDeletePositionDirection: role
              }
              event
            }
            ... on logForCreatedPositionDirection {
              nextValue {
                id
                InstanceId
                ActualFrom
                ActualTo
                name
                statusCreatedPositionDirection: status
                createdAt
                updatedAt
                roleCreatedPositionDirection: role
              }
              event
            }
          }
          description
          event
          createdAt
        }
        total
      }
    }
  }
  ${FragmentProfileFragmentDoc}
  ${FragmentCurriculumStudyProgramsFragmentDoc}
  ${FragmentDealerForLogsFragmentDoc}
  ${FragmentIndicatorForLogsFragmentDoc}
  ${FragmentStaffForLogsFragmentDoc}
  ${FragmentGrRatingForLogsFragmentDoc}
  ${FragmentQDataForLogsFragmentDoc}
  ${FragmentQRatingForEditorLogsFragmentDoc}
  ${FragmentProfileForLogsFragmentDoc}
  ${FragmentEmployeeLogFragmentDoc}
  ${FragmentEmployeePositionLogFragmentDoc}
  ${FragmentAnnouncementForLogsFragmentDoc}
  ${FragmentDocumentForLogsFragmentDoc}
  ${FragmentSectionForLogsFragmentDoc}
  ${FragmentCameraForLogsFragmentDoc}
  ${FragmentCameraCheckForLogsFragmentDoc}
  ${FragmentCameraZoneForLogsFragmentDoc}
  ${FragmentIndicatorGroupForLogsFragmentDoc}
  ${FragmentIndicatorReportForLogsFragmentDoc}
  ${FragmentIndicatorAndReportFragmentDoc}
  ${FragmentLogForZdRequiredToolsFragmentDoc}
  ${FragmentCatalogCurriculumFragmentDoc}
  ${FragmentCourseCurriculumFragmentDoc}
`;

/**
 * __useGetLogsQuery__
 *
 * To run a query within a React component, call `useGetLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLogsQuery({
 *   variables: {
 *      UserId: // value for 'UserId'
 *      event: // value for 'event'
 *      dateEnd: // value for 'dateEnd'
 *      dateBegin: // value for 'dateBegin'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetLogsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetLogsQuery, GetLogsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLogsQuery, GetLogsQueryVariables>(
    GetLogsDocument,
    options,
  );
}
export function useGetLogsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLogsQuery,
    GetLogsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLogsQuery, GetLogsQueryVariables>(
    GetLogsDocument,
    options,
  );
}
export type GetLogsQueryHookResult = ReturnType<typeof useGetLogsQuery>;
export type GetLogsLazyQueryHookResult = ReturnType<typeof useGetLogsLazyQuery>;
export type GetLogsQueryResult = Apollo.QueryResult<
  GetLogsQuery,
  GetLogsQueryVariables
>;
export const GetEmailLogsListDocument = gql`
  query getEmailLogsList(
    $page: Int
    $count: Int
    $dealerIds: [ID]
    $userIds: [ID]
    $name: String
    $fromDate: DateTime
    $toDate: DateTime
  ) {
    LogGetter {
      getEmailLogs(
        page: $page
        count: $count
        dealerIds: $dealerIds
        userIds: $userIds
        name: $name
        fromDate: $fromDate
        toDate: $toDate
      ) {
        items {
          ... on EmailLogListItem {
            ...fragmentEmailLog
            __typename
          }
          users {
            ... on Profile {
              ...usersFragment
              __typename
            }
          }
          dealers {
            ... on Dealer {
              ...dealersFragment
              __typename
            }
          }
          __typename
        }
        __typename
        total
      }
      __typename
    }
  }
  ${FragmentEmailLogFragmentDoc}
  ${UsersFragmentFragmentDoc}
  ${DealersFragmentFragmentDoc}
`;

/**
 * __useGetEmailLogsListQuery__
 *
 * To run a query within a React component, call `useGetEmailLogsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailLogsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailLogsListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      dealerIds: // value for 'dealerIds'
 *      userIds: // value for 'userIds'
 *      name: // value for 'name'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useGetEmailLogsListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetEmailLogsListQuery,
    GetEmailLogsListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmailLogsListQuery, GetEmailLogsListQueryVariables>(
    GetEmailLogsListDocument,
    options,
  );
}
export function useGetEmailLogsListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmailLogsListQuery,
    GetEmailLogsListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmailLogsListQuery,
    GetEmailLogsListQueryVariables
  >(GetEmailLogsListDocument, options);
}
export type GetEmailLogsListQueryHookResult = ReturnType<
  typeof useGetEmailLogsListQuery
>;
export type GetEmailLogsListLazyQueryHookResult = ReturnType<
  typeof useGetEmailLogsListLazyQuery
>;
export type GetEmailLogsListQueryResult = Apollo.QueryResult<
  GetEmailLogsListQuery,
  GetEmailLogsListQueryVariables
>;
export const GetEmailLogsReportDocument = gql`
  query getEmailLogsReport(
    $fromDate: DateTime!
    $toDate: DateTime!
    $dealerIds: [ID]
    $userIds: [ID]
    $name: String
  ) {
    LogGetter {
      getEmailLogsReport(
        fromDate: $fromDate
        toDate: $toDate
        dealerIds: $dealerIds
        userIds: $userIds
        name: $name
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetEmailLogsReportQuery__
 *
 * To run a query within a React component, call `useGetEmailLogsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailLogsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailLogsReportQuery({
 *   variables: {
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      dealerIds: // value for 'dealerIds'
 *      userIds: // value for 'userIds'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetEmailLogsReportQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetEmailLogsReportQuery,
    GetEmailLogsReportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetEmailLogsReportQuery,
    GetEmailLogsReportQueryVariables
  >(GetEmailLogsReportDocument, options);
}
export function useGetEmailLogsReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEmailLogsReportQuery,
    GetEmailLogsReportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetEmailLogsReportQuery,
    GetEmailLogsReportQueryVariables
  >(GetEmailLogsReportDocument, options);
}
export type GetEmailLogsReportQueryHookResult = ReturnType<
  typeof useGetEmailLogsReportQuery
>;
export type GetEmailLogsReportLazyQueryHookResult = ReturnType<
  typeof useGetEmailLogsReportLazyQuery
>;
export type GetEmailLogsReportQueryResult = Apollo.QueryResult<
  GetEmailLogsReportQuery,
  GetEmailLogsReportQueryVariables
>;
export const GetLogsEmailNamesDocument = gql`
  query getLogsEmailNames {
    LogGetter {
      getEmailNames
    }
  }
`;

/**
 * __useGetLogsEmailNamesQuery__
 *
 * To run a query within a React component, call `useGetLogsEmailNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLogsEmailNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLogsEmailNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLogsEmailNamesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetLogsEmailNamesQuery,
    GetLogsEmailNamesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetLogsEmailNamesQuery,
    GetLogsEmailNamesQueryVariables
  >(GetLogsEmailNamesDocument, options);
}
export function useGetLogsEmailNamesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLogsEmailNamesQuery,
    GetLogsEmailNamesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLogsEmailNamesQuery,
    GetLogsEmailNamesQueryVariables
  >(GetLogsEmailNamesDocument, options);
}
export type GetLogsEmailNamesQueryHookResult = ReturnType<
  typeof useGetLogsEmailNamesQuery
>;
export type GetLogsEmailNamesLazyQueryHookResult = ReturnType<
  typeof useGetLogsEmailNamesLazyQuery
>;
export type GetLogsEmailNamesQueryResult = Apollo.QueryResult<
  GetLogsEmailNamesQuery,
  GetLogsEmailNamesQueryVariables
>;
export const GetAllNotesDocument = gql`
  query GetAllNotes {
    NotesGetter {
      getAll {
        ... on NotesIndicatorTypes {
          ...fragmentNotes
        }
      }
    }
  }
  ${FragmentNotesFragmentDoc}
`;

/**
 * __useGetAllNotesQuery__
 *
 * To run a query within a React component, call `useGetAllNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllNotesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllNotesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllNotesQuery,
    GetAllNotesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAllNotesQuery, GetAllNotesQueryVariables>(
    GetAllNotesDocument,
    options,
  );
}
export function useGetAllNotesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllNotesQuery,
    GetAllNotesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAllNotesQuery, GetAllNotesQueryVariables>(
    GetAllNotesDocument,
    options,
  );
}
export type GetAllNotesQueryHookResult = ReturnType<typeof useGetAllNotesQuery>;
export type GetAllNotesLazyQueryHookResult = ReturnType<
  typeof useGetAllNotesLazyQuery
>;
export type GetAllNotesQueryResult = Apollo.QueryResult<
  GetAllNotesQuery,
  GetAllNotesQueryVariables
>;
export const GetNotesStatusesDocument = gql`
  query GetNotesStatuses($UUID: String, $name: String) {
    NotesGetter {
      getDealerStatuses(UUID: $UUID, name: $name) {
        ... on NotesDealerStatuses {
          ...fragmentNotesDealerStatuses
        }
      }
    }
  }
  ${FragmentNotesDealerStatusesFragmentDoc}
`;

/**
 * __useGetNotesStatusesQuery__
 *
 * To run a query within a React component, call `useGetNotesStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotesStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotesStatusesQuery({
 *   variables: {
 *      UUID: // value for 'UUID'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetNotesStatusesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetNotesStatusesQuery,
    GetNotesStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetNotesStatusesQuery, GetNotesStatusesQueryVariables>(
    GetNotesStatusesDocument,
    options,
  );
}
export function useGetNotesStatusesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNotesStatusesQuery,
    GetNotesStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetNotesStatusesQuery,
    GetNotesStatusesQueryVariables
  >(GetNotesStatusesDocument, options);
}
export type GetNotesStatusesQueryHookResult = ReturnType<
  typeof useGetNotesStatusesQuery
>;
export type GetNotesStatusesLazyQueryHookResult = ReturnType<
  typeof useGetNotesStatusesLazyQuery
>;
export type GetNotesStatusesQueryResult = Apollo.QueryResult<
  GetNotesStatusesQuery,
  GetNotesStatusesQueryVariables
>;
export const GetValuesNotesDocument = gql`
  query GetValuesNotes(
    $DealerId: ID!
    $dateUpTo: DateTime
    $page: Int
    $count: Int
    $name: String
  ) {
    NotesGetter {
      getValues(
        DealerId: $DealerId
        dateUpTo: $dateUpTo
        page: $page
        count: $count
        name: $name
      ) {
        items {
          ... on NotesOneValuesItem {
            ...fragmentNotesValues
          }
        }
        total
      }
    }
  }
  ${FragmentNotesValuesFragmentDoc}
`;

/**
 * __useGetValuesNotesQuery__
 *
 * To run a query within a React component, call `useGetValuesNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValuesNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValuesNotesQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      dateUpTo: // value for 'dateUpTo'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetValuesNotesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetValuesNotesQuery,
    GetValuesNotesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetValuesNotesQuery, GetValuesNotesQueryVariables>(
    GetValuesNotesDocument,
    options,
  );
}
export function useGetValuesNotesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetValuesNotesQuery,
    GetValuesNotesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetValuesNotesQuery, GetValuesNotesQueryVariables>(
    GetValuesNotesDocument,
    options,
  );
}
export type GetValuesNotesQueryHookResult = ReturnType<
  typeof useGetValuesNotesQuery
>;
export type GetValuesNotesLazyQueryHookResult = ReturnType<
  typeof useGetValuesNotesLazyQuery
>;
export type GetValuesNotesQueryResult = Apollo.QueryResult<
  GetValuesNotesQuery,
  GetValuesNotesQueryVariables
>;
export const GetAllPersonalDocument = gql`
  query GetAllPersonal {
    PersonalGetter {
      getAll {
        ... on PersonalIndicatorTypes {
          ...fragmentPersonal
        }
      }
    }
  }
  ${FragmentPersonalFragmentDoc}
`;

/**
 * __useGetAllPersonalQuery__
 *
 * To run a query within a React component, call `useGetAllPersonalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPersonalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPersonalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPersonalQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllPersonalQuery,
    GetAllPersonalQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAllPersonalQuery, GetAllPersonalQueryVariables>(
    GetAllPersonalDocument,
    options,
  );
}
export function useGetAllPersonalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllPersonalQuery,
    GetAllPersonalQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAllPersonalQuery, GetAllPersonalQueryVariables>(
    GetAllPersonalDocument,
    options,
  );
}
export type GetAllPersonalQueryHookResult = ReturnType<
  typeof useGetAllPersonalQuery
>;
export type GetAllPersonalLazyQueryHookResult = ReturnType<
  typeof useGetAllPersonalLazyQuery
>;
export type GetAllPersonalQueryResult = Apollo.QueryResult<
  GetAllPersonalQuery,
  GetAllPersonalQueryVariables
>;
export const GetPersonalStatusesDocument = gql`
  query GetPersonalStatuses($UUID: String, $name: String) {
    PersonalGetter {
      getDealerStatuses(UUID: $UUID, name: $name) {
        ... on PersonalDealerStatuses {
          ...fragmentPersonalDealerStatuses
        }
      }
    }
  }
  ${FragmentPersonalDealerStatusesFragmentDoc}
`;

/**
 * __useGetPersonalStatusesQuery__
 *
 * To run a query within a React component, call `useGetPersonalStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalStatusesQuery({
 *   variables: {
 *      UUID: // value for 'UUID'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetPersonalStatusesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPersonalStatusesQuery,
    GetPersonalStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPersonalStatusesQuery,
    GetPersonalStatusesQueryVariables
  >(GetPersonalStatusesDocument, options);
}
export function useGetPersonalStatusesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPersonalStatusesQuery,
    GetPersonalStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPersonalStatusesQuery,
    GetPersonalStatusesQueryVariables
  >(GetPersonalStatusesDocument, options);
}
export type GetPersonalStatusesQueryHookResult = ReturnType<
  typeof useGetPersonalStatusesQuery
>;
export type GetPersonalStatusesLazyQueryHookResult = ReturnType<
  typeof useGetPersonalStatusesLazyQuery
>;
export type GetPersonalStatusesQueryResult = Apollo.QueryResult<
  GetPersonalStatusesQuery,
  GetPersonalStatusesQueryVariables
>;
export const GetValuesPersonalDocument = gql`
  query GetValuesPersonal(
    $DealerId: ID!
    $dateUpTo: DateTime
    $page: Int
    $count: Int
    $name: String
  ) {
    PersonalGetter {
      getValues(
        DealerId: $DealerId
        dateUpTo: $dateUpTo
        page: $page
        count: $count
        name: $name
      ) {
        items {
          ... on PersonalOneValuesItem {
            ...fragmentPersonalValues
          }
        }
        total
      }
    }
  }
  ${FragmentPersonalValuesFragmentDoc}
`;

/**
 * __useGetValuesPersonalQuery__
 *
 * To run a query within a React component, call `useGetValuesPersonalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValuesPersonalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValuesPersonalQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      dateUpTo: // value for 'dateUpTo'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetValuesPersonalQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetValuesPersonalQuery,
    GetValuesPersonalQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetValuesPersonalQuery,
    GetValuesPersonalQueryVariables
  >(GetValuesPersonalDocument, options);
}
export function useGetValuesPersonalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetValuesPersonalQuery,
    GetValuesPersonalQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetValuesPersonalQuery,
    GetValuesPersonalQueryVariables
  >(GetValuesPersonalDocument, options);
}
export type GetValuesPersonalQueryHookResult = ReturnType<
  typeof useGetValuesPersonalQuery
>;
export type GetValuesPersonalLazyQueryHookResult = ReturnType<
  typeof useGetValuesPersonalLazyQuery
>;
export type GetValuesPersonalQueryResult = Apollo.QueryResult<
  GetValuesPersonalQuery,
  GetValuesPersonalQueryVariables
>;
export const GetGroupsPersonalDocument = gql`
  query getGroupsPersonal($groupType: ZdGroupType) {
    PersonalGetter {
      getGroups(groupType: $groupType)
    }
  }
`;

/**
 * __useGetGroupsPersonalQuery__
 *
 * To run a query within a React component, call `useGetGroupsPersonalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsPersonalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsPersonalQuery({
 *   variables: {
 *      groupType: // value for 'groupType'
 *   },
 * });
 */
export function useGetGroupsPersonalQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetGroupsPersonalQuery,
    GetGroupsPersonalQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetGroupsPersonalQuery,
    GetGroupsPersonalQueryVariables
  >(GetGroupsPersonalDocument, options);
}
export function useGetGroupsPersonalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGroupsPersonalQuery,
    GetGroupsPersonalQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetGroupsPersonalQuery,
    GetGroupsPersonalQueryVariables
  >(GetGroupsPersonalDocument, options);
}
export type GetGroupsPersonalQueryHookResult = ReturnType<
  typeof useGetGroupsPersonalQuery
>;
export type GetGroupsPersonalLazyQueryHookResult = ReturnType<
  typeof useGetGroupsPersonalLazyQuery
>;
export type GetGroupsPersonalQueryResult = Apollo.QueryResult<
  GetGroupsPersonalQuery,
  GetGroupsPersonalQueryVariables
>;
export const GetPhotoGallerySectionListDocument = gql`
  query GetPhotoGallerySectionList($page: Int, $count: Int) {
    PhotoGallerySectionGetter {
      getPhotoGallerySectionList(page: $page, count: $count) {
        items {
          id
          title
          description
          createdAt
        }
        pages
        total
      }
    }
  }
`;

/**
 * __useGetPhotoGallerySectionListQuery__
 *
 * To run a query within a React component, call `useGetPhotoGallerySectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhotoGallerySectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhotoGallerySectionListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetPhotoGallerySectionListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPhotoGallerySectionListQuery,
    GetPhotoGallerySectionListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPhotoGallerySectionListQuery,
    GetPhotoGallerySectionListQueryVariables
  >(GetPhotoGallerySectionListDocument, options);
}
export function useGetPhotoGallerySectionListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPhotoGallerySectionListQuery,
    GetPhotoGallerySectionListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPhotoGallerySectionListQuery,
    GetPhotoGallerySectionListQueryVariables
  >(GetPhotoGallerySectionListDocument, options);
}
export type GetPhotoGallerySectionListQueryHookResult = ReturnType<
  typeof useGetPhotoGallerySectionListQuery
>;
export type GetPhotoGallerySectionListLazyQueryHookResult = ReturnType<
  typeof useGetPhotoGallerySectionListLazyQuery
>;
export type GetPhotoGallerySectionListQueryResult = Apollo.QueryResult<
  GetPhotoGallerySectionListQuery,
  GetPhotoGallerySectionListQueryVariables
>;
export const GetPhotoGallerySectionDocument = gql`
  query GetPhotoGallerySection($getPhotoGallerySectionId: ID!) {
    PhotoGallerySectionGetter {
      getPhotoGallerySection(id: $getPhotoGallerySectionId) {
        id
        title
        description
        createdAt
      }
    }
  }
`;

/**
 * __useGetPhotoGallerySectionQuery__
 *
 * To run a query within a React component, call `useGetPhotoGallerySectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhotoGallerySectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhotoGallerySectionQuery({
 *   variables: {
 *      getPhotoGallerySectionId: // value for 'getPhotoGallerySectionId'
 *   },
 * });
 */
export function useGetPhotoGallerySectionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPhotoGallerySectionQuery,
    GetPhotoGallerySectionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPhotoGallerySectionQuery,
    GetPhotoGallerySectionQueryVariables
  >(GetPhotoGallerySectionDocument, options);
}
export function useGetPhotoGallerySectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPhotoGallerySectionQuery,
    GetPhotoGallerySectionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPhotoGallerySectionQuery,
    GetPhotoGallerySectionQueryVariables
  >(GetPhotoGallerySectionDocument, options);
}
export type GetPhotoGallerySectionQueryHookResult = ReturnType<
  typeof useGetPhotoGallerySectionQuery
>;
export type GetPhotoGallerySectionLazyQueryHookResult = ReturnType<
  typeof useGetPhotoGallerySectionLazyQuery
>;
export type GetPhotoGallerySectionQueryResult = Apollo.QueryResult<
  GetPhotoGallerySectionQuery,
  GetPhotoGallerySectionQueryVariables
>;
export const GetAllPlacePostsDocument = gql`
  query GetAllPlacePosts {
    PlacePostsGetter {
      getAll {
        ... on PlacePostsIndicatorTypes {
          ...fragmentPlacePosts
        }
      }
    }
  }
  ${FragmentPlacePostsFragmentDoc}
`;

/**
 * __useGetAllPlacePostsQuery__
 *
 * To run a query within a React component, call `useGetAllPlacePostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPlacePostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPlacePostsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPlacePostsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllPlacePostsQuery,
    GetAllPlacePostsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAllPlacePostsQuery, GetAllPlacePostsQueryVariables>(
    GetAllPlacePostsDocument,
    options,
  );
}
export function useGetAllPlacePostsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllPlacePostsQuery,
    GetAllPlacePostsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAllPlacePostsQuery,
    GetAllPlacePostsQueryVariables
  >(GetAllPlacePostsDocument, options);
}
export type GetAllPlacePostsQueryHookResult = ReturnType<
  typeof useGetAllPlacePostsQuery
>;
export type GetAllPlacePostsLazyQueryHookResult = ReturnType<
  typeof useGetAllPlacePostsLazyQuery
>;
export type GetAllPlacePostsQueryResult = Apollo.QueryResult<
  GetAllPlacePostsQuery,
  GetAllPlacePostsQueryVariables
>;
export const GetPlacePostsStatusesDocument = gql`
  query GetPlacePostsStatuses($UUID: String, $name: String) {
    PlacePostsGetter {
      getDealerStatuses(UUID: $UUID, name: $name) {
        ... on PlacePostsDealerStatuses {
          ...fragmentPlacePostsDealerStatuses
        }
      }
    }
  }
  ${FragmentPlacePostsDealerStatusesFragmentDoc}
`;

/**
 * __useGetPlacePostsStatusesQuery__
 *
 * To run a query within a React component, call `useGetPlacePostsStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlacePostsStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlacePostsStatusesQuery({
 *   variables: {
 *      UUID: // value for 'UUID'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetPlacePostsStatusesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPlacePostsStatusesQuery,
    GetPlacePostsStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPlacePostsStatusesQuery,
    GetPlacePostsStatusesQueryVariables
  >(GetPlacePostsStatusesDocument, options);
}
export function useGetPlacePostsStatusesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPlacePostsStatusesQuery,
    GetPlacePostsStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPlacePostsStatusesQuery,
    GetPlacePostsStatusesQueryVariables
  >(GetPlacePostsStatusesDocument, options);
}
export type GetPlacePostsStatusesQueryHookResult = ReturnType<
  typeof useGetPlacePostsStatusesQuery
>;
export type GetPlacePostsStatusesLazyQueryHookResult = ReturnType<
  typeof useGetPlacePostsStatusesLazyQuery
>;
export type GetPlacePostsStatusesQueryResult = Apollo.QueryResult<
  GetPlacePostsStatusesQuery,
  GetPlacePostsStatusesQueryVariables
>;
export const GetValuesPlacePostsDocument = gql`
  query GetValuesPlacePosts(
    $DealerId: ID!
    $dateUpTo: DateTime
    $page: Int
    $count: Int
    $name: String
  ) {
    PlacePostsGetter {
      getValues(
        DealerId: $DealerId
        dateUpTo: $dateUpTo
        page: $page
        count: $count
        name: $name
      ) {
        items {
          ... on PlacePostsOneValuesItem {
            ...fragmentPlacePostsValues
          }
        }
        total
      }
    }
  }
  ${FragmentPlacePostsValuesFragmentDoc}
`;

/**
 * __useGetValuesPlacePostsQuery__
 *
 * To run a query within a React component, call `useGetValuesPlacePostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValuesPlacePostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValuesPlacePostsQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      dateUpTo: // value for 'dateUpTo'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetValuesPlacePostsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetValuesPlacePostsQuery,
    GetValuesPlacePostsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetValuesPlacePostsQuery,
    GetValuesPlacePostsQueryVariables
  >(GetValuesPlacePostsDocument, options);
}
export function useGetValuesPlacePostsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetValuesPlacePostsQuery,
    GetValuesPlacePostsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetValuesPlacePostsQuery,
    GetValuesPlacePostsQueryVariables
  >(GetValuesPlacePostsDocument, options);
}
export type GetValuesPlacePostsQueryHookResult = ReturnType<
  typeof useGetValuesPlacePostsQuery
>;
export type GetValuesPlacePostsLazyQueryHookResult = ReturnType<
  typeof useGetValuesPlacePostsLazyQuery
>;
export type GetValuesPlacePostsQueryResult = Apollo.QueryResult<
  GetValuesPlacePostsQuery,
  GetValuesPlacePostsQueryVariables
>;
export const GetAllPlacesDocument = gql`
  query GetAllPlaces {
    PlacesGetter {
      getAll {
        ... on PlacesIndicatorTypes {
          ...fragmentPlaces
        }
      }
    }
  }
  ${FragmentPlacesFragmentDoc}
`;

/**
 * __useGetAllPlacesQuery__
 *
 * To run a query within a React component, call `useGetAllPlacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPlacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPlacesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPlacesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllPlacesQuery,
    GetAllPlacesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAllPlacesQuery, GetAllPlacesQueryVariables>(
    GetAllPlacesDocument,
    options,
  );
}
export function useGetAllPlacesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllPlacesQuery,
    GetAllPlacesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAllPlacesQuery, GetAllPlacesQueryVariables>(
    GetAllPlacesDocument,
    options,
  );
}
export type GetAllPlacesQueryHookResult = ReturnType<
  typeof useGetAllPlacesQuery
>;
export type GetAllPlacesLazyQueryHookResult = ReturnType<
  typeof useGetAllPlacesLazyQuery
>;
export type GetAllPlacesQueryResult = Apollo.QueryResult<
  GetAllPlacesQuery,
  GetAllPlacesQueryVariables
>;
export const GetValuesPlacesDocument = gql`
  query GetValuesPlaces(
    $DealerId: ID!
    $dateUpTo: DateTime
    $page: Int
    $count: Int
    $name: String
    $sortBy: PlacesSortBy = GroupOne
  ) {
    PlacesGetter {
      getValues(
        DealerId: $DealerId
        dateUpTo: $dateUpTo
        page: $page
        count: $count
        sortBy: $sortBy
        name: $name
      ) {
        items {
          ... on PlacesOneValuesItem {
            ...fragmentPlacesValues
          }
        }
        total
      }
    }
  }
  ${FragmentPlacesValuesFragmentDoc}
`;

/**
 * __useGetValuesPlacesQuery__
 *
 * To run a query within a React component, call `useGetValuesPlacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValuesPlacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValuesPlacesQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      dateUpTo: // value for 'dateUpTo'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      name: // value for 'name'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetValuesPlacesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetValuesPlacesQuery,
    GetValuesPlacesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetValuesPlacesQuery, GetValuesPlacesQueryVariables>(
    GetValuesPlacesDocument,
    options,
  );
}
export function useGetValuesPlacesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetValuesPlacesQuery,
    GetValuesPlacesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetValuesPlacesQuery,
    GetValuesPlacesQueryVariables
  >(GetValuesPlacesDocument, options);
}
export type GetValuesPlacesQueryHookResult = ReturnType<
  typeof useGetValuesPlacesQuery
>;
export type GetValuesPlacesLazyQueryHookResult = ReturnType<
  typeof useGetValuesPlacesLazyQuery
>;
export type GetValuesPlacesQueryResult = Apollo.QueryResult<
  GetValuesPlacesQuery,
  GetValuesPlacesQueryVariables
>;
export const GetPlacesStatusesDocument = gql`
  query GetPlacesStatuses($UUID: String, $name: String) {
    PlacesGetter {
      getDealerStatuses(UUID: $UUID, name: $name) {
        ... on PlacesDealerStatuses {
          ...fragmentPlacesDealerStatuses
        }
      }
    }
  }
  ${FragmentPlacesDealerStatusesFragmentDoc}
`;

/**
 * __useGetPlacesStatusesQuery__
 *
 * To run a query within a React component, call `useGetPlacesStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlacesStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlacesStatusesQuery({
 *   variables: {
 *      UUID: // value for 'UUID'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetPlacesStatusesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPlacesStatusesQuery,
    GetPlacesStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPlacesStatusesQuery,
    GetPlacesStatusesQueryVariables
  >(GetPlacesStatusesDocument, options);
}
export function useGetPlacesStatusesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPlacesStatusesQuery,
    GetPlacesStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPlacesStatusesQuery,
    GetPlacesStatusesQueryVariables
  >(GetPlacesStatusesDocument, options);
}
export type GetPlacesStatusesQueryHookResult = ReturnType<
  typeof useGetPlacesStatusesQuery
>;
export type GetPlacesStatusesLazyQueryHookResult = ReturnType<
  typeof useGetPlacesStatusesLazyQuery
>;
export type GetPlacesStatusesQueryResult = Apollo.QueryResult<
  GetPlacesStatusesQuery,
  GetPlacesStatusesQueryVariables
>;
export const GetPlanReportDocument = gql`
  query GetPlanReport(
    $DealerId: ID
    $PlanReportId: ID
    $ZD_UUID: String
    $tableIndex: ZdTableIndex
    $page: Int = 0
    $count: Int = 10
  ) {
    PlanReportGetter {
      getPlanReportRows(
        DealerId: $DealerId
        PlanReportId: $PlanReportId
        ZD_UUID: $ZD_UUID
        tableIndex: $tableIndex
        page: $page
        count: $count
      ) {
        items {
          ... on PlanReportRow {
            ...fragmentPlanReportRow
          }
        }
        total
      }
    }
  }
  ${FragmentPlanReportRowFragmentDoc}
`;

/**
 * __useGetPlanReportQuery__
 *
 * To run a query within a React component, call `useGetPlanReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanReportQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      PlanReportId: // value for 'PlanReportId'
 *      ZD_UUID: // value for 'ZD_UUID'
 *      tableIndex: // value for 'tableIndex'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetPlanReportQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPlanReportQuery,
    GetPlanReportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPlanReportQuery, GetPlanReportQueryVariables>(
    GetPlanReportDocument,
    options,
  );
}
export function useGetPlanReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPlanReportQuery,
    GetPlanReportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPlanReportQuery, GetPlanReportQueryVariables>(
    GetPlanReportDocument,
    options,
  );
}
export type GetPlanReportQueryHookResult = ReturnType<
  typeof useGetPlanReportQuery
>;
export type GetPlanReportLazyQueryHookResult = ReturnType<
  typeof useGetPlanReportLazyQuery
>;
export type GetPlanReportQueryResult = Apollo.QueryResult<
  GetPlanReportQuery,
  GetPlanReportQueryVariables
>;
export const GetPositionsGuideDocument = gql`
  query GetPositionsGuide(
    $page: Int
    $count: Int
    $id: ID
    $code: String
    $name: String
    $nameEn: String
    $searchText: String
    $DirectionId: ID
    $status: PositionStatus
    $createdAtTo: DateTime
    $updatedAtTo: DateTime
    $createdAtFrom: DateTime
    $updatedAtFrom: DateTime
    $order: sortType
    $orderBy: getPositionsOrderBy
    $ActualOn: DateTime
  ) {
    PositionGetter {
      getPositions(
        page: $page
        count: $count
        name: $name
        nameEn: $nameEn
        id: $id
        code: $code
        DirectionId: $DirectionId
        searchText: $searchText
        status: $status
        createdAtTo: $createdAtTo
        createdAtFrom: $createdAtFrom
        updatedAtTo: $updatedAtTo
        updatedAtFrom: $updatedAtFrom
        order: $order
        orderBy: $orderBy
        ActualOn: $ActualOn
      ) {
        ...ListPositions
        total
      }
    }
  }
  ${ListPositionsFragmentDoc}
`;

/**
 * __useGetPositionsGuideQuery__
 *
 * To run a query within a React component, call `useGetPositionsGuideQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionsGuideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionsGuideQuery({
 *   variables: {
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      id: // value for 'id'
 *      code: // value for 'code'
 *      name: // value for 'name'
 *      nameEn: // value for 'nameEn'
 *      searchText: // value for 'searchText'
 *      DirectionId: // value for 'DirectionId'
 *      status: // value for 'status'
 *      createdAtTo: // value for 'createdAtTo'
 *      updatedAtTo: // value for 'updatedAtTo'
 *      createdAtFrom: // value for 'createdAtFrom'
 *      updatedAtFrom: // value for 'updatedAtFrom'
 *      order: // value for 'order'
 *      orderBy: // value for 'orderBy'
 *      ActualOn: // value for 'ActualOn'
 *   },
 * });
 */
export function useGetPositionsGuideQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPositionsGuideQuery,
    GetPositionsGuideQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPositionsGuideQuery,
    GetPositionsGuideQueryVariables
  >(GetPositionsGuideDocument, options);
}
export function useGetPositionsGuideLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPositionsGuideQuery,
    GetPositionsGuideQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPositionsGuideQuery,
    GetPositionsGuideQueryVariables
  >(GetPositionsGuideDocument, options);
}
export type GetPositionsGuideQueryHookResult = ReturnType<
  typeof useGetPositionsGuideQuery
>;
export type GetPositionsGuideLazyQueryHookResult = ReturnType<
  typeof useGetPositionsGuideLazyQuery
>;
export type GetPositionsGuideQueryResult = Apollo.QueryResult<
  GetPositionsGuideQuery,
  GetPositionsGuideQueryVariables
>;
export const GetDirectionsDocument = gql`
  query GetDirections(
    $id: ID
    $name: String
    $ids: [ID]
    $page: Int = 0
    $count: Int = 10
    $ActualOn: DateTime
    $status: PositionDirectionsStatus
  ) {
    PositionGetter {
      getDirections(
        id: $id
        name: $name
        ids: $ids
        page: $page
        count: $count
        ActualOn: $ActualOn
        status: $status
      ) {
        ...ListDirections
        total
      }
    }
  }
  ${ListDirectionsFragmentDoc}
`;

/**
 * __useGetDirectionsQuery__
 *
 * To run a query within a React component, call `useGetDirectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      ids: // value for 'ids'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      ActualOn: // value for 'ActualOn'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetDirectionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDirectionsQuery,
    GetDirectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDirectionsQuery, GetDirectionsQueryVariables>(
    GetDirectionsDocument,
    options,
  );
}
export function useGetDirectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDirectionsQuery,
    GetDirectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDirectionsQuery, GetDirectionsQueryVariables>(
    GetDirectionsDocument,
    options,
  );
}
export type GetDirectionsQueryHookResult = ReturnType<
  typeof useGetDirectionsQuery
>;
export type GetDirectionsLazyQueryHookResult = ReturnType<
  typeof useGetDirectionsLazyQuery
>;
export type GetDirectionsQueryResult = Apollo.QueryResult<
  GetDirectionsQuery,
  GetDirectionsQueryVariables
>;
export const GetPositionDirectionRolesDocument = gql`
  query GetPositionDirectionRoles {
    PositionGetter {
      getPositionDirectionRoles
    }
  }
`;

/**
 * __useGetPositionDirectionRolesQuery__
 *
 * To run a query within a React component, call `useGetPositionDirectionRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionDirectionRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionDirectionRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPositionDirectionRolesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPositionDirectionRolesQuery,
    GetPositionDirectionRolesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPositionDirectionRolesQuery,
    GetPositionDirectionRolesQueryVariables
  >(GetPositionDirectionRolesDocument, options);
}
export function useGetPositionDirectionRolesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPositionDirectionRolesQuery,
    GetPositionDirectionRolesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPositionDirectionRolesQuery,
    GetPositionDirectionRolesQueryVariables
  >(GetPositionDirectionRolesDocument, options);
}
export type GetPositionDirectionRolesQueryHookResult = ReturnType<
  typeof useGetPositionDirectionRolesQuery
>;
export type GetPositionDirectionRolesLazyQueryHookResult = ReturnType<
  typeof useGetPositionDirectionRolesLazyQuery
>;
export type GetPositionDirectionRolesQueryResult = Apollo.QueryResult<
  GetPositionDirectionRolesQuery,
  GetPositionDirectionRolesQueryVariables
>;
export const GetPositionByIdDocument = gql`
  query GetPositionById($id: ID) {
    PositionGetter {
      getPositionById(id: $id) {
        ...FragmentGetPositionById
      }
    }
  }
  ${FragmentGetPositionByIdFragmentDoc}
`;

/**
 * __useGetPositionByIdQuery__
 *
 * To run a query within a React component, call `useGetPositionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPositionByIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPositionByIdQuery,
    GetPositionByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPositionByIdQuery, GetPositionByIdQueryVariables>(
    GetPositionByIdDocument,
    options,
  );
}
export function useGetPositionByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPositionByIdQuery,
    GetPositionByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPositionByIdQuery,
    GetPositionByIdQueryVariables
  >(GetPositionByIdDocument, options);
}
export type GetPositionByIdQueryHookResult = ReturnType<
  typeof useGetPositionByIdQuery
>;
export type GetPositionByIdLazyQueryHookResult = ReturnType<
  typeof useGetPositionByIdLazyQuery
>;
export type GetPositionByIdQueryResult = Apollo.QueryResult<
  GetPositionByIdQuery,
  GetPositionByIdQueryVariables
>;
export const GetPersonalInformationDocument = gql`
  query GetPersonalInformation($name: String, $page: Int, $count: Int) {
    PositionGetter {
      getPersonalInformation(page: $page, count: $count, name: $name) {
        items {
          ...FragmentPersonalInformation
        }
        total
      }
    }
  }
  ${FragmentPersonalInformationFragmentDoc}
`;

/**
 * __useGetPersonalInformationQuery__
 *
 * To run a query within a React component, call `useGetPersonalInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalInformationQuery({
 *   variables: {
 *      name: // value for 'name'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetPersonalInformationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPersonalInformationQuery,
    GetPersonalInformationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPersonalInformationQuery,
    GetPersonalInformationQueryVariables
  >(GetPersonalInformationDocument, options);
}
export function useGetPersonalInformationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPersonalInformationQuery,
    GetPersonalInformationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPersonalInformationQuery,
    GetPersonalInformationQueryVariables
  >(GetPersonalInformationDocument, options);
}
export type GetPersonalInformationQueryHookResult = ReturnType<
  typeof useGetPersonalInformationQuery
>;
export type GetPersonalInformationLazyQueryHookResult = ReturnType<
  typeof useGetPersonalInformationLazyQuery
>;
export type GetPersonalInformationQueryResult = Apollo.QueryResult<
  GetPersonalInformationQuery,
  GetPersonalInformationQueryVariables
>;
export const GetInformationSystemsDocument = gql`
  query GetInformationSystems(
    $name: String
    $page: Int
    $positions: [ID]
    $count: Int
  ) {
    PositionGetter {
      getInformationSystems(
        name: $name
        positions: $positions
        page: $page
        count: $count
      ) {
        items {
          ...FragmentInformationSystems
        }
        total
      }
    }
  }
  ${FragmentInformationSystemsFragmentDoc}
`;

/**
 * __useGetInformationSystemsQuery__
 *
 * To run a query within a React component, call `useGetInformationSystemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInformationSystemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInformationSystemsQuery({
 *   variables: {
 *      name: // value for 'name'
 *      page: // value for 'page'
 *      positions: // value for 'positions'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetInformationSystemsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetInformationSystemsQuery,
    GetInformationSystemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetInformationSystemsQuery,
    GetInformationSystemsQueryVariables
  >(GetInformationSystemsDocument, options);
}
export function useGetInformationSystemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInformationSystemsQuery,
    GetInformationSystemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetInformationSystemsQuery,
    GetInformationSystemsQueryVariables
  >(GetInformationSystemsDocument, options);
}
export type GetInformationSystemsQueryHookResult = ReturnType<
  typeof useGetInformationSystemsQuery
>;
export type GetInformationSystemsLazyQueryHookResult = ReturnType<
  typeof useGetInformationSystemsLazyQuery
>;
export type GetInformationSystemsQueryResult = Apollo.QueryResult<
  GetInformationSystemsQuery,
  GetInformationSystemsQueryVariables
>;
export const GetInformationSystemByIdDocument = gql`
  query GetInformationSystemById($id: ID) {
    PositionGetter {
      getInformationSystemById(id: $id) {
        ...FragmentInformationSystems
      }
    }
  }
  ${FragmentInformationSystemsFragmentDoc}
`;

/**
 * __useGetInformationSystemByIdQuery__
 *
 * To run a query within a React component, call `useGetInformationSystemByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInformationSystemByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInformationSystemByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInformationSystemByIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetInformationSystemByIdQuery,
    GetInformationSystemByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetInformationSystemByIdQuery,
    GetInformationSystemByIdQueryVariables
  >(GetInformationSystemByIdDocument, options);
}
export function useGetInformationSystemByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInformationSystemByIdQuery,
    GetInformationSystemByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetInformationSystemByIdQuery,
    GetInformationSystemByIdQueryVariables
  >(GetInformationSystemByIdDocument, options);
}
export type GetInformationSystemByIdQueryHookResult = ReturnType<
  typeof useGetInformationSystemByIdQuery
>;
export type GetInformationSystemByIdLazyQueryHookResult = ReturnType<
  typeof useGetInformationSystemByIdLazyQuery
>;
export type GetInformationSystemByIdQueryResult = Apollo.QueryResult<
  GetInformationSystemByIdQuery,
  GetInformationSystemByIdQueryVariables
>;
export const GetPersonalInformationByIdDocument = gql`
  query GetPersonalInformationById($id: ID) {
    PositionGetter {
      getPersonalInformationById(id: $id) {
        ...FragmentPersonalInformation
      }
    }
  }
  ${FragmentPersonalInformationFragmentDoc}
`;

/**
 * __useGetPersonalInformationByIdQuery__
 *
 * To run a query within a React component, call `useGetPersonalInformationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalInformationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalInformationByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPersonalInformationByIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetPersonalInformationByIdQuery,
    GetPersonalInformationByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPersonalInformationByIdQuery,
    GetPersonalInformationByIdQueryVariables
  >(GetPersonalInformationByIdDocument, options);
}
export function useGetPersonalInformationByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPersonalInformationByIdQuery,
    GetPersonalInformationByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPersonalInformationByIdQuery,
    GetPersonalInformationByIdQueryVariables
  >(GetPersonalInformationByIdDocument, options);
}
export type GetPersonalInformationByIdQueryHookResult = ReturnType<
  typeof useGetPersonalInformationByIdQuery
>;
export type GetPersonalInformationByIdLazyQueryHookResult = ReturnType<
  typeof useGetPersonalInformationByIdLazyQuery
>;
export type GetPersonalInformationByIdQueryResult = Apollo.QueryResult<
  GetPersonalInformationByIdQuery,
  GetPersonalInformationByIdQueryVariables
>;
export const GetTemplateConsentsDataProcessingDocument = gql`
  query GetTemplateConsentsDataProcessing($positionIds: [ID]) {
    PositionGetter {
      getTemplateConsentsDataProcessing(positionIds: $positionIds) {
        items {
          ...FragmentGetTemplateConsentsDataProcessing
        }
      }
    }
  }
  ${FragmentGetTemplateConsentsDataProcessingFragmentDoc}
`;

/**
 * __useGetTemplateConsentsDataProcessingQuery__
 *
 * To run a query within a React component, call `useGetTemplateConsentsDataProcessingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplateConsentsDataProcessingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplateConsentsDataProcessingQuery({
 *   variables: {
 *      positionIds: // value for 'positionIds'
 *   },
 * });
 */
export function useGetTemplateConsentsDataProcessingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTemplateConsentsDataProcessingQuery,
    GetTemplateConsentsDataProcessingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetTemplateConsentsDataProcessingQuery,
    GetTemplateConsentsDataProcessingQueryVariables
  >(GetTemplateConsentsDataProcessingDocument, options);
}
export function useGetTemplateConsentsDataProcessingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTemplateConsentsDataProcessingQuery,
    GetTemplateConsentsDataProcessingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTemplateConsentsDataProcessingQuery,
    GetTemplateConsentsDataProcessingQueryVariables
  >(GetTemplateConsentsDataProcessingDocument, options);
}
export type GetTemplateConsentsDataProcessingQueryHookResult = ReturnType<
  typeof useGetTemplateConsentsDataProcessingQuery
>;
export type GetTemplateConsentsDataProcessingLazyQueryHookResult = ReturnType<
  typeof useGetTemplateConsentsDataProcessingLazyQuery
>;
export type GetTemplateConsentsDataProcessingQueryResult = Apollo.QueryResult<
  GetTemplateConsentsDataProcessingQuery,
  GetTemplateConsentsDataProcessingQueryVariables
>;
export const GetQVersionsDocument = gql`
  query GetQVersions {
    QuartilesRatingGetter {
      getVersions {
        ... on QuartilesRatingVersion {
          ...fragmentQuartilesRatingVersionForTable
        }
      }
    }
  }
  ${FragmentQuartilesRatingVersionForTableFragmentDoc}
`;

/**
 * __useGetQVersionsQuery__
 *
 * To run a query within a React component, call `useGetQVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQVersionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQVersionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetQVersionsQuery,
    GetQVersionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetQVersionsQuery, GetQVersionsQueryVariables>(
    GetQVersionsDocument,
    options,
  );
}
export function useGetQVersionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetQVersionsQuery,
    GetQVersionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetQVersionsQuery, GetQVersionsQueryVariables>(
    GetQVersionsDocument,
    options,
  );
}
export type GetQVersionsQueryHookResult = ReturnType<
  typeof useGetQVersionsQuery
>;
export type GetQVersionsLazyQueryHookResult = ReturnType<
  typeof useGetQVersionsLazyQuery
>;
export type GetQVersionsQueryResult = Apollo.QueryResult<
  GetQVersionsQuery,
  GetQVersionsQueryVariables
>;
export const GetQRatingsDocument = gql`
  query GetQRatings($RatingsVersionId: ID!) {
    QuartilesRatingGetter {
      getRatings(onlyParent: false, RatingsVersionId: $RatingsVersionId) {
        ... on QuartilesRating {
          ...fragmentQRatingForEditorTable
        }
      }
    }
  }
  ${FragmentQRatingForEditorTableFragmentDoc}
`;

/**
 * __useGetQRatingsQuery__
 *
 * To run a query within a React component, call `useGetQRatingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQRatingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQRatingsQuery({
 *   variables: {
 *      RatingsVersionId: // value for 'RatingsVersionId'
 *   },
 * });
 */
export function useGetQRatingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetQRatingsQuery,
    GetQRatingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetQRatingsQuery, GetQRatingsQueryVariables>(
    GetQRatingsDocument,
    options,
  );
}
export function useGetQRatingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetQRatingsQuery,
    GetQRatingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetQRatingsQuery, GetQRatingsQueryVariables>(
    GetQRatingsDocument,
    options,
  );
}
export type GetQRatingsQueryHookResult = ReturnType<typeof useGetQRatingsQuery>;
export type GetQRatingsLazyQueryHookResult = ReturnType<
  typeof useGetQRatingsLazyQuery
>;
export type GetQRatingsQueryResult = Apollo.QueryResult<
  GetQRatingsQuery,
  GetQRatingsQueryVariables
>;
export const GetQRatingDataDocument = gql`
  query GetQRatingData($DealerId: ID!, $date: DateTime!) {
    QuartilesRatingGetter {
      getRatingData(DealerId: $DealerId, date: $date) {
        Ratings {
          ... on QuartilesRating {
            ...fragmentQRatingForTable
          }
        }
      }
    }
  }
  ${FragmentQRatingForTableFragmentDoc}
`;

/**
 * __useGetQRatingDataQuery__
 *
 * To run a query within a React component, call `useGetQRatingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQRatingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQRatingDataQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetQRatingDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetQRatingDataQuery,
    GetQRatingDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetQRatingDataQuery, GetQRatingDataQueryVariables>(
    GetQRatingDataDocument,
    options,
  );
}
export function useGetQRatingDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetQRatingDataQuery,
    GetQRatingDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetQRatingDataQuery, GetQRatingDataQueryVariables>(
    GetQRatingDataDocument,
    options,
  );
}
export type GetQRatingDataQueryHookResult = ReturnType<
  typeof useGetQRatingDataQuery
>;
export type GetQRatingDataLazyQueryHookResult = ReturnType<
  typeof useGetQRatingDataLazyQuery
>;
export type GetQRatingDataQueryResult = Apollo.QueryResult<
  GetQRatingDataQuery,
  GetQRatingDataQueryVariables
>;
export const GetQDetailingMainIndicatorDocument = gql`
  query GetQDetailingMainIndicator($DealerId: ID!, $date: DateTime!) {
    QuartilesRatingGetter {
      getDetailingMainIndicator(DealerId: $DealerId, date: $date) {
        ... on QuartilesRatingVersion {
          ...fragmentQDataForTable
        }
      }
    }
  }
  ${FragmentQDataForTableFragmentDoc}
`;

/**
 * __useGetQDetailingMainIndicatorQuery__
 *
 * To run a query within a React component, call `useGetQDetailingMainIndicatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQDetailingMainIndicatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQDetailingMainIndicatorQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetQDetailingMainIndicatorQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetQDetailingMainIndicatorQuery,
    GetQDetailingMainIndicatorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetQDetailingMainIndicatorQuery,
    GetQDetailingMainIndicatorQueryVariables
  >(GetQDetailingMainIndicatorDocument, options);
}
export function useGetQDetailingMainIndicatorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetQDetailingMainIndicatorQuery,
    GetQDetailingMainIndicatorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetQDetailingMainIndicatorQuery,
    GetQDetailingMainIndicatorQueryVariables
  >(GetQDetailingMainIndicatorDocument, options);
}
export type GetQDetailingMainIndicatorQueryHookResult = ReturnType<
  typeof useGetQDetailingMainIndicatorQuery
>;
export type GetQDetailingMainIndicatorLazyQueryHookResult = ReturnType<
  typeof useGetQDetailingMainIndicatorLazyQuery
>;
export type GetQDetailingMainIndicatorQueryResult = Apollo.QueryResult<
  GetQDetailingMainIndicatorQuery,
  GetQDetailingMainIndicatorQueryVariables
>;
export const GetQDataByLineDocument = gql`
  query GetQDataByLine(
    $DealerId: ID!
    $QuartilesRatingId: ID!
    $date: DateTime!
  ) {
    QuartilesRatingGetter {
      getRatingDataByLine(
        DealerId: $DealerId
        QuartilesRatingId: $QuartilesRatingId
        date: $date
      ) {
        ... on QuartilesRating {
          ...fragmentQRatingForChart
        }
      }
    }
  }
  ${FragmentQRatingForChartFragmentDoc}
`;

/**
 * __useGetQDataByLineQuery__
 *
 * To run a query within a React component, call `useGetQDataByLineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQDataByLineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQDataByLineQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      QuartilesRatingId: // value for 'QuartilesRatingId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetQDataByLineQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetQDataByLineQuery,
    GetQDataByLineQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetQDataByLineQuery, GetQDataByLineQueryVariables>(
    GetQDataByLineDocument,
    options,
  );
}
export function useGetQDataByLineLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetQDataByLineQuery,
    GetQDataByLineQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetQDataByLineQuery, GetQDataByLineQueryVariables>(
    GetQDataByLineDocument,
    options,
  );
}
export type GetQDataByLineQueryHookResult = ReturnType<
  typeof useGetQDataByLineQuery
>;
export type GetQDataByLineLazyQueryHookResult = ReturnType<
  typeof useGetQDataByLineLazyQuery
>;
export type GetQDataByLineQueryResult = Apollo.QueryResult<
  GetQDataByLineQuery,
  GetQDataByLineQueryVariables
>;
export const GetQFullReportsDocument = gql`
  query GetQFullReports($DealerId: ID!, $date: DateTime!, $lang: String) {
    QuartilesRatingGetter {
      getFullReports(DealerId: $DealerId, date: $date, lang: $lang) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetQFullReportsQuery__
 *
 * To run a query within a React component, call `useGetQFullReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQFullReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQFullReportsQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      date: // value for 'date'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useGetQFullReportsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetQFullReportsQuery,
    GetQFullReportsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetQFullReportsQuery, GetQFullReportsQueryVariables>(
    GetQFullReportsDocument,
    options,
  );
}
export function useGetQFullReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetQFullReportsQuery,
    GetQFullReportsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetQFullReportsQuery,
    GetQFullReportsQueryVariables
  >(GetQFullReportsDocument, options);
}
export type GetQFullReportsQueryHookResult = ReturnType<
  typeof useGetQFullReportsQuery
>;
export type GetQFullReportsLazyQueryHookResult = ReturnType<
  typeof useGetQFullReportsLazyQuery
>;
export type GetQFullReportsQueryResult = Apollo.QueryResult<
  GetQFullReportsQuery,
  GetQFullReportsQueryVariables
>;
export const GetQBeautifulReportsDocument = gql`
  query GetQBeautifulReports($DealerId: ID!, $date: DateTime!, $lang: String) {
    QuartilesRatingGetter {
      getBeautifulReports(DealerId: $DealerId, date: $date, lang: $lang) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetQBeautifulReportsQuery__
 *
 * To run a query within a React component, call `useGetQBeautifulReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQBeautifulReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQBeautifulReportsQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      date: // value for 'date'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useGetQBeautifulReportsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetQBeautifulReportsQuery,
    GetQBeautifulReportsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetQBeautifulReportsQuery,
    GetQBeautifulReportsQueryVariables
  >(GetQBeautifulReportsDocument, options);
}
export function useGetQBeautifulReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetQBeautifulReportsQuery,
    GetQBeautifulReportsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetQBeautifulReportsQuery,
    GetQBeautifulReportsQueryVariables
  >(GetQBeautifulReportsDocument, options);
}
export type GetQBeautifulReportsQueryHookResult = ReturnType<
  typeof useGetQBeautifulReportsQuery
>;
export type GetQBeautifulReportsLazyQueryHookResult = ReturnType<
  typeof useGetQBeautifulReportsLazyQuery
>;
export type GetQBeautifulReportsQueryResult = Apollo.QueryResult<
  GetQBeautifulReportsQuery,
  GetQBeautifulReportsQueryVariables
>;
export const GetQOneRatingReportsDocument = gql`
  query GetQOneRatingReports(
    $DealerId: ID!
    $QuartilesRatingId: ID!
    $date: DateTime!
    $lang: String
  ) {
    QuartilesRatingGetter {
      getReports(
        DealerId: $DealerId
        QuartilesRatingId: $QuartilesRatingId
        date: $date
        count: 12
        lang: $lang
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetQOneRatingReportsQuery__
 *
 * To run a query within a React component, call `useGetQOneRatingReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQOneRatingReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQOneRatingReportsQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      QuartilesRatingId: // value for 'QuartilesRatingId'
 *      date: // value for 'date'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useGetQOneRatingReportsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetQOneRatingReportsQuery,
    GetQOneRatingReportsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetQOneRatingReportsQuery,
    GetQOneRatingReportsQueryVariables
  >(GetQOneRatingReportsDocument, options);
}
export function useGetQOneRatingReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetQOneRatingReportsQuery,
    GetQOneRatingReportsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetQOneRatingReportsQuery,
    GetQOneRatingReportsQueryVariables
  >(GetQOneRatingReportsDocument, options);
}
export type GetQOneRatingReportsQueryHookResult = ReturnType<
  typeof useGetQOneRatingReportsQuery
>;
export type GetQOneRatingReportsLazyQueryHookResult = ReturnType<
  typeof useGetQOneRatingReportsLazyQuery
>;
export type GetQOneRatingReportsQueryResult = Apollo.QueryResult<
  GetQOneRatingReportsQuery,
  GetQOneRatingReportsQueryVariables
>;
export const GetQReportDetailingMainIndicatorDocument = gql`
  query getQReportDetailingMainIndicator(
    $DealerId: ID!
    $date: DateTime!
    $lang: String
  ) {
    QuartilesRatingGetter {
      getReportDetailingMainIndicator(
        DealerId: $DealerId
        date: $date
        lang: $lang
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetQReportDetailingMainIndicatorQuery__
 *
 * To run a query within a React component, call `useGetQReportDetailingMainIndicatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQReportDetailingMainIndicatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQReportDetailingMainIndicatorQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      date: // value for 'date'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useGetQReportDetailingMainIndicatorQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetQReportDetailingMainIndicatorQuery,
    GetQReportDetailingMainIndicatorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetQReportDetailingMainIndicatorQuery,
    GetQReportDetailingMainIndicatorQueryVariables
  >(GetQReportDetailingMainIndicatorDocument, options);
}
export function useGetQReportDetailingMainIndicatorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetQReportDetailingMainIndicatorQuery,
    GetQReportDetailingMainIndicatorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetQReportDetailingMainIndicatorQuery,
    GetQReportDetailingMainIndicatorQueryVariables
  >(GetQReportDetailingMainIndicatorDocument, options);
}
export type GetQReportDetailingMainIndicatorQueryHookResult = ReturnType<
  typeof useGetQReportDetailingMainIndicatorQuery
>;
export type GetQReportDetailingMainIndicatorLazyQueryHookResult = ReturnType<
  typeof useGetQReportDetailingMainIndicatorLazyQuery
>;
export type GetQReportDetailingMainIndicatorQueryResult = Apollo.QueryResult<
  GetQReportDetailingMainIndicatorQuery,
  GetQReportDetailingMainIndicatorQueryVariables
>;
export const GetQRatingsListNameDocument = gql`
  query GetQRatingsListName(
    $RatingsVersionId: ID
    $RatingsId: ID
    $onlyParent: Boolean!
  ) {
    QuartilesRatingGetter {
      getRatingsListName(
        onlyParent: $onlyParent
        RatingsVersionId: $RatingsVersionId
        RatingsId: $RatingsId
      ) {
        ... on QuartilesRatingName {
          ...fragmentRatingsListName
        }
      }
    }
  }
  ${FragmentRatingsListNameFragmentDoc}
`;

/**
 * __useGetQRatingsListNameQuery__
 *
 * To run a query within a React component, call `useGetQRatingsListNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQRatingsListNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQRatingsListNameQuery({
 *   variables: {
 *      RatingsVersionId: // value for 'RatingsVersionId'
 *      RatingsId: // value for 'RatingsId'
 *      onlyParent: // value for 'onlyParent'
 *   },
 * });
 */
export function useGetQRatingsListNameQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetQRatingsListNameQuery,
    GetQRatingsListNameQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetQRatingsListNameQuery,
    GetQRatingsListNameQueryVariables
  >(GetQRatingsListNameDocument, options);
}
export function useGetQRatingsListNameLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetQRatingsListNameQuery,
    GetQRatingsListNameQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetQRatingsListNameQuery,
    GetQRatingsListNameQueryVariables
  >(GetQRatingsListNameDocument, options);
}
export type GetQRatingsListNameQueryHookResult = ReturnType<
  typeof useGetQRatingsListNameQuery
>;
export type GetQRatingsListNameLazyQueryHookResult = ReturnType<
  typeof useGetQRatingsListNameLazyQuery
>;
export type GetQRatingsListNameQueryResult = Apollo.QueryResult<
  GetQRatingsListNameQuery,
  GetQRatingsListNameQueryVariables
>;
export const GetAllowedMonthsForDealerDocument = gql`
  query GetAllowedMonthsForDealer($dealerId: ID!) {
    QuartilesRatingGetter {
      getAllowedMonthsForDealer(DealerId: $dealerId) {
        items {
          month
          year
        }
      }
    }
  }
`;

/**
 * __useGetAllowedMonthsForDealerQuery__
 *
 * To run a query within a React component, call `useGetAllowedMonthsForDealerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllowedMonthsForDealerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllowedMonthsForDealerQuery({
 *   variables: {
 *      dealerId: // value for 'dealerId'
 *   },
 * });
 */
export function useGetAllowedMonthsForDealerQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAllowedMonthsForDealerQuery,
    GetAllowedMonthsForDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAllowedMonthsForDealerQuery,
    GetAllowedMonthsForDealerQueryVariables
  >(GetAllowedMonthsForDealerDocument, options);
}
export function useGetAllowedMonthsForDealerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllowedMonthsForDealerQuery,
    GetAllowedMonthsForDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAllowedMonthsForDealerQuery,
    GetAllowedMonthsForDealerQueryVariables
  >(GetAllowedMonthsForDealerDocument, options);
}
export type GetAllowedMonthsForDealerQueryHookResult = ReturnType<
  typeof useGetAllowedMonthsForDealerQuery
>;
export type GetAllowedMonthsForDealerLazyQueryHookResult = ReturnType<
  typeof useGetAllowedMonthsForDealerLazyQuery
>;
export type GetAllowedMonthsForDealerQueryResult = Apollo.QueryResult<
  GetAllowedMonthsForDealerQuery,
  GetAllowedMonthsForDealerQueryVariables
>;
export const GetAllRequiredToolsDocument = gql`
  query GetAllRequiredTools {
    RequiredToolsGetter {
      getAll {
        ... on RequiredToolsIndicatorTypes {
          ...fragmentRequiredTools
        }
      }
    }
  }
  ${FragmentRequiredToolsFragmentDoc}
`;

/**
 * __useGetAllRequiredToolsQuery__
 *
 * To run a query within a React component, call `useGetAllRequiredToolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRequiredToolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRequiredToolsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllRequiredToolsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllRequiredToolsQuery,
    GetAllRequiredToolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAllRequiredToolsQuery,
    GetAllRequiredToolsQueryVariables
  >(GetAllRequiredToolsDocument, options);
}
export function useGetAllRequiredToolsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllRequiredToolsQuery,
    GetAllRequiredToolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAllRequiredToolsQuery,
    GetAllRequiredToolsQueryVariables
  >(GetAllRequiredToolsDocument, options);
}
export type GetAllRequiredToolsQueryHookResult = ReturnType<
  typeof useGetAllRequiredToolsQuery
>;
export type GetAllRequiredToolsLazyQueryHookResult = ReturnType<
  typeof useGetAllRequiredToolsLazyQuery
>;
export type GetAllRequiredToolsQueryResult = Apollo.QueryResult<
  GetAllRequiredToolsQuery,
  GetAllRequiredToolsQueryVariables
>;
export const GetRequiredToolsStatusesDocument = gql`
  query GetRequiredToolsStatuses($UUID: String, $name: String) {
    RequiredToolsGetter {
      getDealerStatuses(UUID: $UUID, name: $name) {
        ... on RequiredToolsDealerStatuses {
          ...fragmentRequiredToolsDealerStatuses
        }
      }
    }
  }
  ${FragmentRequiredToolsDealerStatusesFragmentDoc}
`;

/**
 * __useGetRequiredToolsStatusesQuery__
 *
 * To run a query within a React component, call `useGetRequiredToolsStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequiredToolsStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequiredToolsStatusesQuery({
 *   variables: {
 *      UUID: // value for 'UUID'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetRequiredToolsStatusesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetRequiredToolsStatusesQuery,
    GetRequiredToolsStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetRequiredToolsStatusesQuery,
    GetRequiredToolsStatusesQueryVariables
  >(GetRequiredToolsStatusesDocument, options);
}
export function useGetRequiredToolsStatusesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRequiredToolsStatusesQuery,
    GetRequiredToolsStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetRequiredToolsStatusesQuery,
    GetRequiredToolsStatusesQueryVariables
  >(GetRequiredToolsStatusesDocument, options);
}
export type GetRequiredToolsStatusesQueryHookResult = ReturnType<
  typeof useGetRequiredToolsStatusesQuery
>;
export type GetRequiredToolsStatusesLazyQueryHookResult = ReturnType<
  typeof useGetRequiredToolsStatusesLazyQuery
>;
export type GetRequiredToolsStatusesQueryResult = Apollo.QueryResult<
  GetRequiredToolsStatusesQuery,
  GetRequiredToolsStatusesQueryVariables
>;
export const GetValuesRequiredToolsDocument = gql`
  query GetValuesRequiredTools(
    $DealerId: ID!
    $dateUpTo: DateTime
    $page: Int
    $count: Int
    $name: String
  ) {
    RequiredToolsGetter {
      getValues(
        DealerId: $DealerId
        dateUpTo: $dateUpTo
        page: $page
        count: $count
        name: $name
      ) {
        items {
          ...fragmentRequiredToolsValues
        }
        total
      }
    }
  }
  ${FragmentRequiredToolsValuesFragmentDoc}
`;

/**
 * __useGetValuesRequiredToolsQuery__
 *
 * To run a query within a React component, call `useGetValuesRequiredToolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValuesRequiredToolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValuesRequiredToolsQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      dateUpTo: // value for 'dateUpTo'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetValuesRequiredToolsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetValuesRequiredToolsQuery,
    GetValuesRequiredToolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetValuesRequiredToolsQuery,
    GetValuesRequiredToolsQueryVariables
  >(GetValuesRequiredToolsDocument, options);
}
export function useGetValuesRequiredToolsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetValuesRequiredToolsQuery,
    GetValuesRequiredToolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetValuesRequiredToolsQuery,
    GetValuesRequiredToolsQueryVariables
  >(GetValuesRequiredToolsDocument, options);
}
export type GetValuesRequiredToolsQueryHookResult = ReturnType<
  typeof useGetValuesRequiredToolsQuery
>;
export type GetValuesRequiredToolsLazyQueryHookResult = ReturnType<
  typeof useGetValuesRequiredToolsLazyQuery
>;
export type GetValuesRequiredToolsQueryResult = Apollo.QueryResult<
  GetValuesRequiredToolsQuery,
  GetValuesRequiredToolsQueryVariables
>;
export const GetReportReturnCarForServiceByMonthDocument = gql`
  query GetReportReturnCarForServiceByMonth(
    $groupReport: typeGroupReportSRR!
    $numberTO: [typeTOReportSRR]
    $salePeriod: Int
    $monthControl: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      reportReturnCarForServiceByMonth(
        groupReport: $groupReport
        numberTO: $numberTO
        salePeriod: $salePeriod
        monthControl: $monthControl
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetReportReturnCarForServiceByMonthQuery__
 *
 * To run a query within a React component, call `useGetReportReturnCarForServiceByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportReturnCarForServiceByMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportReturnCarForServiceByMonthQuery({
 *   variables: {
 *      groupReport: // value for 'groupReport'
 *      numberTO: // value for 'numberTO'
 *      salePeriod: // value for 'salePeriod'
 *      monthControl: // value for 'monthControl'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetReportReturnCarForServiceByMonthQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportReturnCarForServiceByMonthQuery,
    GetReportReturnCarForServiceByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportReturnCarForServiceByMonthQuery,
    GetReportReturnCarForServiceByMonthQueryVariables
  >(GetReportReturnCarForServiceByMonthDocument, options);
}
export function useGetReportReturnCarForServiceByMonthLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportReturnCarForServiceByMonthQuery,
    GetReportReturnCarForServiceByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportReturnCarForServiceByMonthQuery,
    GetReportReturnCarForServiceByMonthQueryVariables
  >(GetReportReturnCarForServiceByMonthDocument, options);
}
export type GetReportReturnCarForServiceByMonthQueryHookResult = ReturnType<
  typeof useGetReportReturnCarForServiceByMonthQuery
>;
export type GetReportReturnCarForServiceByMonthLazyQueryHookResult = ReturnType<
  typeof useGetReportReturnCarForServiceByMonthLazyQuery
>;
export type GetReportReturnCarForServiceByMonthQueryResult = Apollo.QueryResult<
  GetReportReturnCarForServiceByMonthQuery,
  GetReportReturnCarForServiceByMonthQueryVariables
>;
export const GetCarForServiceByMonthDocument = gql`
  query GetCarForServiceByMonth(
    $group: typeGroupReportSRR!
    $numberTO: [typeTOReportSRR]
    $salePeriod: Int
    $monthControl: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      getCarForServiceByMonth(
        group: $group
        numberTO: $numberTO
        salePeriod: $salePeriod
        monthControl: $monthControl
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        ... on CarForServiceByMonth {
          ...fragmentCarForServiceByMonth
        }
      }
    }
  }
  ${FragmentCarForServiceByMonthFragmentDoc}
`;

/**
 * __useGetCarForServiceByMonthQuery__
 *
 * To run a query within a React component, call `useGetCarForServiceByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarForServiceByMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarForServiceByMonthQuery({
 *   variables: {
 *      group: // value for 'group'
 *      numberTO: // value for 'numberTO'
 *      salePeriod: // value for 'salePeriod'
 *      monthControl: // value for 'monthControl'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetCarForServiceByMonthQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCarForServiceByMonthQuery,
    GetCarForServiceByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCarForServiceByMonthQuery,
    GetCarForServiceByMonthQueryVariables
  >(GetCarForServiceByMonthDocument, options);
}
export function useGetCarForServiceByMonthLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCarForServiceByMonthQuery,
    GetCarForServiceByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCarForServiceByMonthQuery,
    GetCarForServiceByMonthQueryVariables
  >(GetCarForServiceByMonthDocument, options);
}
export type GetCarForServiceByMonthQueryHookResult = ReturnType<
  typeof useGetCarForServiceByMonthQuery
>;
export type GetCarForServiceByMonthLazyQueryHookResult = ReturnType<
  typeof useGetCarForServiceByMonthLazyQuery
>;
export type GetCarForServiceByMonthQueryResult = Apollo.QueryResult<
  GetCarForServiceByMonthQuery,
  GetCarForServiceByMonthQueryVariables
>;
export const GetReportReturnCarForeignForServiceByMonthDocument = gql`
  query GetReportReturnCarForeignForServiceByMonth(
    $groupReport: typeGroupReportSRR!
    $numberTO: [typeTOReportSRR]
    $salePeriod: Int
    $monthControl: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      reportReturnCarForeignForServiceByMonth(
        groupReport: $groupReport
        numberTO: $numberTO
        salePeriod: $salePeriod
        monthControl: $monthControl
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetReportReturnCarForeignForServiceByMonthQuery__
 *
 * To run a query within a React component, call `useGetReportReturnCarForeignForServiceByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportReturnCarForeignForServiceByMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportReturnCarForeignForServiceByMonthQuery({
 *   variables: {
 *      groupReport: // value for 'groupReport'
 *      numberTO: // value for 'numberTO'
 *      salePeriod: // value for 'salePeriod'
 *      monthControl: // value for 'monthControl'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetReportReturnCarForeignForServiceByMonthQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportReturnCarForeignForServiceByMonthQuery,
    GetReportReturnCarForeignForServiceByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportReturnCarForeignForServiceByMonthQuery,
    GetReportReturnCarForeignForServiceByMonthQueryVariables
  >(GetReportReturnCarForeignForServiceByMonthDocument, options);
}
export function useGetReportReturnCarForeignForServiceByMonthLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportReturnCarForeignForServiceByMonthQuery,
    GetReportReturnCarForeignForServiceByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportReturnCarForeignForServiceByMonthQuery,
    GetReportReturnCarForeignForServiceByMonthQueryVariables
  >(GetReportReturnCarForeignForServiceByMonthDocument, options);
}
export type GetReportReturnCarForeignForServiceByMonthQueryHookResult =
  ReturnType<typeof useGetReportReturnCarForeignForServiceByMonthQuery>;
export type GetReportReturnCarForeignForServiceByMonthLazyQueryHookResult =
  ReturnType<typeof useGetReportReturnCarForeignForServiceByMonthLazyQuery>;
export type GetReportReturnCarForeignForServiceByMonthQueryResult =
  Apollo.QueryResult<
    GetReportReturnCarForeignForServiceByMonthQuery,
    GetReportReturnCarForeignForServiceByMonthQueryVariables
  >;
export const GetCarForeignForServiceByMonthDocument = gql`
  query GetCarForeignForServiceByMonth(
    $group: typeGroupReportSRR!
    $numberTO: [typeTOReportSRR]
    $salePeriod: Int
    $monthControl: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      getCarForeignForServiceByMonth(
        group: $group
        numberTO: $numberTO
        salePeriod: $salePeriod
        monthControl: $monthControl
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        ... on CarForServiceByMonth {
          ...fragmentCarForServiceByMonth
        }
      }
    }
  }
  ${FragmentCarForServiceByMonthFragmentDoc}
`;

/**
 * __useGetCarForeignForServiceByMonthQuery__
 *
 * To run a query within a React component, call `useGetCarForeignForServiceByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarForeignForServiceByMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarForeignForServiceByMonthQuery({
 *   variables: {
 *      group: // value for 'group'
 *      numberTO: // value for 'numberTO'
 *      salePeriod: // value for 'salePeriod'
 *      monthControl: // value for 'monthControl'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetCarForeignForServiceByMonthQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCarForeignForServiceByMonthQuery,
    GetCarForeignForServiceByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCarForeignForServiceByMonthQuery,
    GetCarForeignForServiceByMonthQueryVariables
  >(GetCarForeignForServiceByMonthDocument, options);
}
export function useGetCarForeignForServiceByMonthLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCarForeignForServiceByMonthQuery,
    GetCarForeignForServiceByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCarForeignForServiceByMonthQuery,
    GetCarForeignForServiceByMonthQueryVariables
  >(GetCarForeignForServiceByMonthDocument, options);
}
export type GetCarForeignForServiceByMonthQueryHookResult = ReturnType<
  typeof useGetCarForeignForServiceByMonthQuery
>;
export type GetCarForeignForServiceByMonthLazyQueryHookResult = ReturnType<
  typeof useGetCarForeignForServiceByMonthLazyQuery
>;
export type GetCarForeignForServiceByMonthQueryResult = Apollo.QueryResult<
  GetCarForeignForServiceByMonthQuery,
  GetCarForeignForServiceByMonthQueryVariables
>;
export const GetReportReturnCarForeignForServiceByMonthByCarModelDocument = gql`
  query GetReportReturnCarForeignForServiceByMonthByCarModel(
    $groupReport: typeGroupReportSRR!
    $numberTO: [typeTOReportSRR]
    $salePeriod: Int
    $monthControl: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $CarModel: [ID]!
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      reportReturnCarForeignForServiceByMonthByCarModel(
        groupReport: $groupReport
        numberTO: $numberTO
        salePeriod: $salePeriod
        monthControl: $monthControl
        typeClient: $typeClient
        CarModel: $CarModel
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetReportReturnCarForeignForServiceByMonthByCarModelQuery__
 *
 * To run a query within a React component, call `useGetReportReturnCarForeignForServiceByMonthByCarModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportReturnCarForeignForServiceByMonthByCarModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportReturnCarForeignForServiceByMonthByCarModelQuery({
 *   variables: {
 *      groupReport: // value for 'groupReport'
 *      numberTO: // value for 'numberTO'
 *      salePeriod: // value for 'salePeriod'
 *      monthControl: // value for 'monthControl'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      CarModel: // value for 'CarModel'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetReportReturnCarForeignForServiceByMonthByCarModelQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportReturnCarForeignForServiceByMonthByCarModelQuery,
    GetReportReturnCarForeignForServiceByMonthByCarModelQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportReturnCarForeignForServiceByMonthByCarModelQuery,
    GetReportReturnCarForeignForServiceByMonthByCarModelQueryVariables
  >(GetReportReturnCarForeignForServiceByMonthByCarModelDocument, options);
}
export function useGetReportReturnCarForeignForServiceByMonthByCarModelLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportReturnCarForeignForServiceByMonthByCarModelQuery,
    GetReportReturnCarForeignForServiceByMonthByCarModelQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportReturnCarForeignForServiceByMonthByCarModelQuery,
    GetReportReturnCarForeignForServiceByMonthByCarModelQueryVariables
  >(GetReportReturnCarForeignForServiceByMonthByCarModelDocument, options);
}
export type GetReportReturnCarForeignForServiceByMonthByCarModelQueryHookResult =
  ReturnType<
    typeof useGetReportReturnCarForeignForServiceByMonthByCarModelQuery
  >;
export type GetReportReturnCarForeignForServiceByMonthByCarModelLazyQueryHookResult =
  ReturnType<
    typeof useGetReportReturnCarForeignForServiceByMonthByCarModelLazyQuery
  >;
export type GetReportReturnCarForeignForServiceByMonthByCarModelQueryResult =
  Apollo.QueryResult<
    GetReportReturnCarForeignForServiceByMonthByCarModelQuery,
    GetReportReturnCarForeignForServiceByMonthByCarModelQueryVariables
  >;
export const GetCarForeignForServiceByMonthByCarModelDocument = gql`
  query GetCarForeignForServiceByMonthByCarModel(
    $groupReport: typeGroupReportSRR!
    $numberTO: [typeTOReportSRR]
    $salePeriod: Int
    $monthControl: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $CarModel: [ID]!
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      getCarForeignForServiceByMonthByCarModel(
        groupReport: $groupReport
        numberTO: $numberTO
        salePeriod: $salePeriod
        monthControl: $monthControl
        typeClient: $typeClient
        CarModel: $CarModel
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        ... on CarForServiceByMonth {
          ...fragmentCarForServiceByMonth
        }
      }
    }
  }
  ${FragmentCarForServiceByMonthFragmentDoc}
`;

/**
 * __useGetCarForeignForServiceByMonthByCarModelQuery__
 *
 * To run a query within a React component, call `useGetCarForeignForServiceByMonthByCarModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarForeignForServiceByMonthByCarModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarForeignForServiceByMonthByCarModelQuery({
 *   variables: {
 *      groupReport: // value for 'groupReport'
 *      numberTO: // value for 'numberTO'
 *      salePeriod: // value for 'salePeriod'
 *      monthControl: // value for 'monthControl'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      CarModel: // value for 'CarModel'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetCarForeignForServiceByMonthByCarModelQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCarForeignForServiceByMonthByCarModelQuery,
    GetCarForeignForServiceByMonthByCarModelQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCarForeignForServiceByMonthByCarModelQuery,
    GetCarForeignForServiceByMonthByCarModelQueryVariables
  >(GetCarForeignForServiceByMonthByCarModelDocument, options);
}
export function useGetCarForeignForServiceByMonthByCarModelLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCarForeignForServiceByMonthByCarModelQuery,
    GetCarForeignForServiceByMonthByCarModelQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCarForeignForServiceByMonthByCarModelQuery,
    GetCarForeignForServiceByMonthByCarModelQueryVariables
  >(GetCarForeignForServiceByMonthByCarModelDocument, options);
}
export type GetCarForeignForServiceByMonthByCarModelQueryHookResult =
  ReturnType<typeof useGetCarForeignForServiceByMonthByCarModelQuery>;
export type GetCarForeignForServiceByMonthByCarModelLazyQueryHookResult =
  ReturnType<typeof useGetCarForeignForServiceByMonthByCarModelLazyQuery>;
export type GetCarForeignForServiceByMonthByCarModelQueryResult =
  Apollo.QueryResult<
    GetCarForeignForServiceByMonthByCarModelQuery,
    GetCarForeignForServiceByMonthByCarModelQueryVariables
  >;
export const GetReportReturnCarForServiceByMonthByCarModelRegionDocument = gql`
  query GetReportReturnCarForServiceByMonthByCarModelRegion(
    $groupReport: typeGroupReportSRR!
    $numberTO: [typeTOReportSRR]
    $salePeriod: Int
    $monthControl: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
    $CarModel: [ID]
  ) {
    SRRGetter {
      reportReturnCarForServiceByMonthByCarModelRegion(
        groupReport: $groupReport
        numberTO: $numberTO
        salePeriod: $salePeriod
        monthControl: $monthControl
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
        CarModel: $CarModel
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetReportReturnCarForServiceByMonthByCarModelRegionQuery__
 *
 * To run a query within a React component, call `useGetReportReturnCarForServiceByMonthByCarModelRegionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportReturnCarForServiceByMonthByCarModelRegionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportReturnCarForServiceByMonthByCarModelRegionQuery({
 *   variables: {
 *      groupReport: // value for 'groupReport'
 *      numberTO: // value for 'numberTO'
 *      salePeriod: // value for 'salePeriod'
 *      monthControl: // value for 'monthControl'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *      CarModel: // value for 'CarModel'
 *   },
 * });
 */
export function useGetReportReturnCarForServiceByMonthByCarModelRegionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportReturnCarForServiceByMonthByCarModelRegionQuery,
    GetReportReturnCarForServiceByMonthByCarModelRegionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportReturnCarForServiceByMonthByCarModelRegionQuery,
    GetReportReturnCarForServiceByMonthByCarModelRegionQueryVariables
  >(GetReportReturnCarForServiceByMonthByCarModelRegionDocument, options);
}
export function useGetReportReturnCarForServiceByMonthByCarModelRegionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportReturnCarForServiceByMonthByCarModelRegionQuery,
    GetReportReturnCarForServiceByMonthByCarModelRegionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportReturnCarForServiceByMonthByCarModelRegionQuery,
    GetReportReturnCarForServiceByMonthByCarModelRegionQueryVariables
  >(GetReportReturnCarForServiceByMonthByCarModelRegionDocument, options);
}
export type GetReportReturnCarForServiceByMonthByCarModelRegionQueryHookResult =
  ReturnType<
    typeof useGetReportReturnCarForServiceByMonthByCarModelRegionQuery
  >;
export type GetReportReturnCarForServiceByMonthByCarModelRegionLazyQueryHookResult =
  ReturnType<
    typeof useGetReportReturnCarForServiceByMonthByCarModelRegionLazyQuery
  >;
export type GetReportReturnCarForServiceByMonthByCarModelRegionQueryResult =
  Apollo.QueryResult<
    GetReportReturnCarForServiceByMonthByCarModelRegionQuery,
    GetReportReturnCarForServiceByMonthByCarModelRegionQueryVariables
  >;
export const GetCarForServiceByMonthByCarModelRegionDocument = gql`
  query GetCarForServiceByMonthByCarModelRegion(
    $groupReport: typeGroupReportSRR!
    $numberTO: [typeTOReportSRR]
    $salePeriod: Int
    $monthControl: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
    $CarModel: [ID]
  ) {
    SRRGetter {
      getCarForServiceByMonthByCarModelRegion(
        groupReport: $groupReport
        numberTO: $numberTO
        salePeriod: $salePeriod
        monthControl: $monthControl
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
        CarModel: $CarModel
      ) {
        ... on CarsForServiceByMonthRegion {
          ...fragmentCarsForServiceByMonthRegion
        }
      }
    }
  }
  ${FragmentCarsForServiceByMonthRegionFragmentDoc}
`;

/**
 * __useGetCarForServiceByMonthByCarModelRegionQuery__
 *
 * To run a query within a React component, call `useGetCarForServiceByMonthByCarModelRegionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarForServiceByMonthByCarModelRegionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarForServiceByMonthByCarModelRegionQuery({
 *   variables: {
 *      groupReport: // value for 'groupReport'
 *      numberTO: // value for 'numberTO'
 *      salePeriod: // value for 'salePeriod'
 *      monthControl: // value for 'monthControl'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *      CarModel: // value for 'CarModel'
 *   },
 * });
 */
export function useGetCarForServiceByMonthByCarModelRegionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCarForServiceByMonthByCarModelRegionQuery,
    GetCarForServiceByMonthByCarModelRegionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCarForServiceByMonthByCarModelRegionQuery,
    GetCarForServiceByMonthByCarModelRegionQueryVariables
  >(GetCarForServiceByMonthByCarModelRegionDocument, options);
}
export function useGetCarForServiceByMonthByCarModelRegionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCarForServiceByMonthByCarModelRegionQuery,
    GetCarForServiceByMonthByCarModelRegionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCarForServiceByMonthByCarModelRegionQuery,
    GetCarForServiceByMonthByCarModelRegionQueryVariables
  >(GetCarForServiceByMonthByCarModelRegionDocument, options);
}
export type GetCarForServiceByMonthByCarModelRegionQueryHookResult = ReturnType<
  typeof useGetCarForServiceByMonthByCarModelRegionQuery
>;
export type GetCarForServiceByMonthByCarModelRegionLazyQueryHookResult =
  ReturnType<typeof useGetCarForServiceByMonthByCarModelRegionLazyQuery>;
export type GetCarForServiceByMonthByCarModelRegionQueryResult =
  Apollo.QueryResult<
    GetCarForServiceByMonthByCarModelRegionQuery,
    GetCarForServiceByMonthByCarModelRegionQueryVariables
  >;
export const GetReportReturnCarForServiceByPeriodDocument = gql`
  query GetReportReturnCarForServiceByPeriod(
    $groupReport: typeGroupReportSRR!
    $numberTO: [typeTOReportSRR]
    $salePeriodStart: DateTime!
    $salePeriodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      reportReturnCarForServiceByPeriod(
        groupReport: $groupReport
        numberTO: $numberTO
        salePeriodStart: $salePeriodStart
        salePeriodEnd: $salePeriodEnd
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetReportReturnCarForServiceByPeriodQuery__
 *
 * To run a query within a React component, call `useGetReportReturnCarForServiceByPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportReturnCarForServiceByPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportReturnCarForServiceByPeriodQuery({
 *   variables: {
 *      groupReport: // value for 'groupReport'
 *      numberTO: // value for 'numberTO'
 *      salePeriodStart: // value for 'salePeriodStart'
 *      salePeriodEnd: // value for 'salePeriodEnd'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetReportReturnCarForServiceByPeriodQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportReturnCarForServiceByPeriodQuery,
    GetReportReturnCarForServiceByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportReturnCarForServiceByPeriodQuery,
    GetReportReturnCarForServiceByPeriodQueryVariables
  >(GetReportReturnCarForServiceByPeriodDocument, options);
}
export function useGetReportReturnCarForServiceByPeriodLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportReturnCarForServiceByPeriodQuery,
    GetReportReturnCarForServiceByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportReturnCarForServiceByPeriodQuery,
    GetReportReturnCarForServiceByPeriodQueryVariables
  >(GetReportReturnCarForServiceByPeriodDocument, options);
}
export type GetReportReturnCarForServiceByPeriodQueryHookResult = ReturnType<
  typeof useGetReportReturnCarForServiceByPeriodQuery
>;
export type GetReportReturnCarForServiceByPeriodLazyQueryHookResult =
  ReturnType<typeof useGetReportReturnCarForServiceByPeriodLazyQuery>;
export type GetReportReturnCarForServiceByPeriodQueryResult =
  Apollo.QueryResult<
    GetReportReturnCarForServiceByPeriodQuery,
    GetReportReturnCarForServiceByPeriodQueryVariables
  >;
export const GetCarForServiceByPeriodDocument = gql`
  query GetCarForServiceByPeriod(
    $groupReport: typeGroupReportSRR
    $group: typeGroupReportSRR
    $numberTO: [typeTOReportSRR]
    $salePeriodStart: DateTime!
    $salePeriodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      getCarForServiceByPeriod(
        groupReport: $groupReport
        group: $group
        numberTO: $numberTO
        salePeriodStart: $salePeriodStart
        salePeriodEnd: $salePeriodEnd
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        ... on CarForServiceByMonth {
          ...fragmentCarForServiceByMonth
        }
      }
    }
  }
  ${FragmentCarForServiceByMonthFragmentDoc}
`;

/**
 * __useGetCarForServiceByPeriodQuery__
 *
 * To run a query within a React component, call `useGetCarForServiceByPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarForServiceByPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarForServiceByPeriodQuery({
 *   variables: {
 *      groupReport: // value for 'groupReport'
 *      group: // value for 'group'
 *      numberTO: // value for 'numberTO'
 *      salePeriodStart: // value for 'salePeriodStart'
 *      salePeriodEnd: // value for 'salePeriodEnd'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetCarForServiceByPeriodQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCarForServiceByPeriodQuery,
    GetCarForServiceByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCarForServiceByPeriodQuery,
    GetCarForServiceByPeriodQueryVariables
  >(GetCarForServiceByPeriodDocument, options);
}
export function useGetCarForServiceByPeriodLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCarForServiceByPeriodQuery,
    GetCarForServiceByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCarForServiceByPeriodQuery,
    GetCarForServiceByPeriodQueryVariables
  >(GetCarForServiceByPeriodDocument, options);
}
export type GetCarForServiceByPeriodQueryHookResult = ReturnType<
  typeof useGetCarForServiceByPeriodQuery
>;
export type GetCarForServiceByPeriodLazyQueryHookResult = ReturnType<
  typeof useGetCarForServiceByPeriodLazyQuery
>;
export type GetCarForServiceByPeriodQueryResult = Apollo.QueryResult<
  GetCarForServiceByPeriodQuery,
  GetCarForServiceByPeriodQueryVariables
>;
export const GetReportReturnCarForeignForServiceByPeriodDocument = gql`
  query GetReportReturnCarForeignForServiceByPeriod(
    $groupReport: typeGroupReportSRR!
    $numberTO: [typeTOReportSRR]
    $salePeriodStart: DateTime!
    $salePeriodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      reportReturnCarForeignForServiceByPeriod(
        groupReport: $groupReport
        numberTO: $numberTO
        salePeriodStart: $salePeriodStart
        salePeriodEnd: $salePeriodEnd
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetReportReturnCarForeignForServiceByPeriodQuery__
 *
 * To run a query within a React component, call `useGetReportReturnCarForeignForServiceByPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportReturnCarForeignForServiceByPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportReturnCarForeignForServiceByPeriodQuery({
 *   variables: {
 *      groupReport: // value for 'groupReport'
 *      numberTO: // value for 'numberTO'
 *      salePeriodStart: // value for 'salePeriodStart'
 *      salePeriodEnd: // value for 'salePeriodEnd'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetReportReturnCarForeignForServiceByPeriodQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportReturnCarForeignForServiceByPeriodQuery,
    GetReportReturnCarForeignForServiceByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportReturnCarForeignForServiceByPeriodQuery,
    GetReportReturnCarForeignForServiceByPeriodQueryVariables
  >(GetReportReturnCarForeignForServiceByPeriodDocument, options);
}
export function useGetReportReturnCarForeignForServiceByPeriodLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportReturnCarForeignForServiceByPeriodQuery,
    GetReportReturnCarForeignForServiceByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportReturnCarForeignForServiceByPeriodQuery,
    GetReportReturnCarForeignForServiceByPeriodQueryVariables
  >(GetReportReturnCarForeignForServiceByPeriodDocument, options);
}
export type GetReportReturnCarForeignForServiceByPeriodQueryHookResult =
  ReturnType<typeof useGetReportReturnCarForeignForServiceByPeriodQuery>;
export type GetReportReturnCarForeignForServiceByPeriodLazyQueryHookResult =
  ReturnType<typeof useGetReportReturnCarForeignForServiceByPeriodLazyQuery>;
export type GetReportReturnCarForeignForServiceByPeriodQueryResult =
  Apollo.QueryResult<
    GetReportReturnCarForeignForServiceByPeriodQuery,
    GetReportReturnCarForeignForServiceByPeriodQueryVariables
  >;
export const GetCarForeignForServiceByPeriodDocument = gql`
  query GetCarForeignForServiceByPeriod(
    $group: typeGroupReportSRR!
    $numberTO: [typeTOReportSRR]
    $salePeriodStart: DateTime!
    $salePeriodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      getCarForeignForServiceByPeriod(
        group: $group
        numberTO: $numberTO
        salePeriodStart: $salePeriodStart
        salePeriodEnd: $salePeriodEnd
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        ... on CarForServiceByMonth {
          ...fragmentCarForServiceByMonth
        }
      }
    }
  }
  ${FragmentCarForServiceByMonthFragmentDoc}
`;

/**
 * __useGetCarForeignForServiceByPeriodQuery__
 *
 * To run a query within a React component, call `useGetCarForeignForServiceByPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarForeignForServiceByPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarForeignForServiceByPeriodQuery({
 *   variables: {
 *      group: // value for 'group'
 *      numberTO: // value for 'numberTO'
 *      salePeriodStart: // value for 'salePeriodStart'
 *      salePeriodEnd: // value for 'salePeriodEnd'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetCarForeignForServiceByPeriodQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCarForeignForServiceByPeriodQuery,
    GetCarForeignForServiceByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCarForeignForServiceByPeriodQuery,
    GetCarForeignForServiceByPeriodQueryVariables
  >(GetCarForeignForServiceByPeriodDocument, options);
}
export function useGetCarForeignForServiceByPeriodLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCarForeignForServiceByPeriodQuery,
    GetCarForeignForServiceByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCarForeignForServiceByPeriodQuery,
    GetCarForeignForServiceByPeriodQueryVariables
  >(GetCarForeignForServiceByPeriodDocument, options);
}
export type GetCarForeignForServiceByPeriodQueryHookResult = ReturnType<
  typeof useGetCarForeignForServiceByPeriodQuery
>;
export type GetCarForeignForServiceByPeriodLazyQueryHookResult = ReturnType<
  typeof useGetCarForeignForServiceByPeriodLazyQuery
>;
export type GetCarForeignForServiceByPeriodQueryResult = Apollo.QueryResult<
  GetCarForeignForServiceByPeriodQuery,
  GetCarForeignForServiceByPeriodQueryVariables
>;
export const GetReportReturnCarForeignForServiceByPeriodByCarModelDocument = gql`
  query GetReportReturnCarForeignForServiceByPeriodByCarModel(
    $groupReport: typeGroupReportSRR!
    $numberTO: [typeTOReportSRR]
    $salePeriodStart: DateTime!
    $salePeriodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
    $CarModel: [ID]!
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      reportReturnCarForeignForServiceByPeriodByCarModel(
        groupReport: $groupReport
        numberTO: $numberTO
        salePeriodStart: $salePeriodStart
        salePeriodEnd: $salePeriodEnd
        CarModel: $CarModel
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetReportReturnCarForeignForServiceByPeriodByCarModelQuery__
 *
 * To run a query within a React component, call `useGetReportReturnCarForeignForServiceByPeriodByCarModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportReturnCarForeignForServiceByPeriodByCarModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportReturnCarForeignForServiceByPeriodByCarModelQuery({
 *   variables: {
 *      groupReport: // value for 'groupReport'
 *      numberTO: // value for 'numberTO'
 *      salePeriodStart: // value for 'salePeriodStart'
 *      salePeriodEnd: // value for 'salePeriodEnd'
 *      typeClient: // value for 'typeClient'
 *      CarModel: // value for 'CarModel'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetReportReturnCarForeignForServiceByPeriodByCarModelQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportReturnCarForeignForServiceByPeriodByCarModelQuery,
    GetReportReturnCarForeignForServiceByPeriodByCarModelQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportReturnCarForeignForServiceByPeriodByCarModelQuery,
    GetReportReturnCarForeignForServiceByPeriodByCarModelQueryVariables
  >(GetReportReturnCarForeignForServiceByPeriodByCarModelDocument, options);
}
export function useGetReportReturnCarForeignForServiceByPeriodByCarModelLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportReturnCarForeignForServiceByPeriodByCarModelQuery,
    GetReportReturnCarForeignForServiceByPeriodByCarModelQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportReturnCarForeignForServiceByPeriodByCarModelQuery,
    GetReportReturnCarForeignForServiceByPeriodByCarModelQueryVariables
  >(GetReportReturnCarForeignForServiceByPeriodByCarModelDocument, options);
}
export type GetReportReturnCarForeignForServiceByPeriodByCarModelQueryHookResult =
  ReturnType<
    typeof useGetReportReturnCarForeignForServiceByPeriodByCarModelQuery
  >;
export type GetReportReturnCarForeignForServiceByPeriodByCarModelLazyQueryHookResult =
  ReturnType<
    typeof useGetReportReturnCarForeignForServiceByPeriodByCarModelLazyQuery
  >;
export type GetReportReturnCarForeignForServiceByPeriodByCarModelQueryResult =
  Apollo.QueryResult<
    GetReportReturnCarForeignForServiceByPeriodByCarModelQuery,
    GetReportReturnCarForeignForServiceByPeriodByCarModelQueryVariables
  >;
export const GetCarForeignForServiceByPeriodByCarModelDocument = gql`
  query GetCarForeignForServiceByPeriodByCarModel(
    $group: typeGroupReportSRR!
    $numberTO: [typeTOReportSRR]
    $salePeriodStart: DateTime!
    $salePeriodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
    $CarModel: [ID]!
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      getCarForeignForServiceByPeriodByCarModel(
        group: $group
        numberTO: $numberTO
        salePeriodStart: $salePeriodStart
        salePeriodEnd: $salePeriodEnd
        CarModel: $CarModel
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        ... on CarForServiceByMonth {
          ...fragmentCarForServiceByMonth
        }
      }
    }
  }
  ${FragmentCarForServiceByMonthFragmentDoc}
`;

/**
 * __useGetCarForeignForServiceByPeriodByCarModelQuery__
 *
 * To run a query within a React component, call `useGetCarForeignForServiceByPeriodByCarModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarForeignForServiceByPeriodByCarModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarForeignForServiceByPeriodByCarModelQuery({
 *   variables: {
 *      group: // value for 'group'
 *      numberTO: // value for 'numberTO'
 *      salePeriodStart: // value for 'salePeriodStart'
 *      salePeriodEnd: // value for 'salePeriodEnd'
 *      typeClient: // value for 'typeClient'
 *      CarModel: // value for 'CarModel'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetCarForeignForServiceByPeriodByCarModelQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCarForeignForServiceByPeriodByCarModelQuery,
    GetCarForeignForServiceByPeriodByCarModelQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCarForeignForServiceByPeriodByCarModelQuery,
    GetCarForeignForServiceByPeriodByCarModelQueryVariables
  >(GetCarForeignForServiceByPeriodByCarModelDocument, options);
}
export function useGetCarForeignForServiceByPeriodByCarModelLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCarForeignForServiceByPeriodByCarModelQuery,
    GetCarForeignForServiceByPeriodByCarModelQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCarForeignForServiceByPeriodByCarModelQuery,
    GetCarForeignForServiceByPeriodByCarModelQueryVariables
  >(GetCarForeignForServiceByPeriodByCarModelDocument, options);
}
export type GetCarForeignForServiceByPeriodByCarModelQueryHookResult =
  ReturnType<typeof useGetCarForeignForServiceByPeriodByCarModelQuery>;
export type GetCarForeignForServiceByPeriodByCarModelLazyQueryHookResult =
  ReturnType<typeof useGetCarForeignForServiceByPeriodByCarModelLazyQuery>;
export type GetCarForeignForServiceByPeriodByCarModelQueryResult =
  Apollo.QueryResult<
    GetCarForeignForServiceByPeriodByCarModelQuery,
    GetCarForeignForServiceByPeriodByCarModelQueryVariables
  >;
export const GetReportReturnCarForServiceByPeriodConsolidatedDocument = gql`
  query GetReportReturnCarForServiceByPeriodConsolidated(
    $group: typeGroupReportSRR!
    $numberTO: [typeTOReportSRR]
    $salePeriodStart: DateTime!
    $salePeriodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
    $CarModel: [ID]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      reportReturnCarForServiceByPeriodConsolidated(
        group: $group
        numberTO: $numberTO
        salePeriodStart: $salePeriodStart
        salePeriodEnd: $salePeriodEnd
        CarModel: $CarModel
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetReportReturnCarForServiceByPeriodConsolidatedQuery__
 *
 * To run a query within a React component, call `useGetReportReturnCarForServiceByPeriodConsolidatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportReturnCarForServiceByPeriodConsolidatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportReturnCarForServiceByPeriodConsolidatedQuery({
 *   variables: {
 *      group: // value for 'group'
 *      numberTO: // value for 'numberTO'
 *      salePeriodStart: // value for 'salePeriodStart'
 *      salePeriodEnd: // value for 'salePeriodEnd'
 *      typeClient: // value for 'typeClient'
 *      CarModel: // value for 'CarModel'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetReportReturnCarForServiceByPeriodConsolidatedQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportReturnCarForServiceByPeriodConsolidatedQuery,
    GetReportReturnCarForServiceByPeriodConsolidatedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportReturnCarForServiceByPeriodConsolidatedQuery,
    GetReportReturnCarForServiceByPeriodConsolidatedQueryVariables
  >(GetReportReturnCarForServiceByPeriodConsolidatedDocument, options);
}
export function useGetReportReturnCarForServiceByPeriodConsolidatedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportReturnCarForServiceByPeriodConsolidatedQuery,
    GetReportReturnCarForServiceByPeriodConsolidatedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportReturnCarForServiceByPeriodConsolidatedQuery,
    GetReportReturnCarForServiceByPeriodConsolidatedQueryVariables
  >(GetReportReturnCarForServiceByPeriodConsolidatedDocument, options);
}
export type GetReportReturnCarForServiceByPeriodConsolidatedQueryHookResult =
  ReturnType<typeof useGetReportReturnCarForServiceByPeriodConsolidatedQuery>;
export type GetReportReturnCarForServiceByPeriodConsolidatedLazyQueryHookResult =
  ReturnType<
    typeof useGetReportReturnCarForServiceByPeriodConsolidatedLazyQuery
  >;
export type GetReportReturnCarForServiceByPeriodConsolidatedQueryResult =
  Apollo.QueryResult<
    GetReportReturnCarForServiceByPeriodConsolidatedQuery,
    GetReportReturnCarForServiceByPeriodConsolidatedQueryVariables
  >;
export const GetCarForServiceByPeriodConsolidatedDocument = gql`
  query GetCarForServiceByPeriodConsolidated(
    $group: typeGroupReportSRR!
    $numberTO: [typeTOReportSRR]
    $salePeriodStart: DateTime!
    $salePeriodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
    $CarModel: [ID]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      getCarForServiceByPeriodConsolidated(
        group: $group
        numberTO: $numberTO
        salePeriodStart: $salePeriodStart
        salePeriodEnd: $salePeriodEnd
        CarModel: $CarModel
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        ... on CarsForServiceByPeriodConsolidated {
          ...fragmentCarsForServiceByPeriodConsolidated
        }
      }
    }
  }
  ${FragmentCarsForServiceByPeriodConsolidatedFragmentDoc}
`;

/**
 * __useGetCarForServiceByPeriodConsolidatedQuery__
 *
 * To run a query within a React component, call `useGetCarForServiceByPeriodConsolidatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarForServiceByPeriodConsolidatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarForServiceByPeriodConsolidatedQuery({
 *   variables: {
 *      group: // value for 'group'
 *      numberTO: // value for 'numberTO'
 *      salePeriodStart: // value for 'salePeriodStart'
 *      salePeriodEnd: // value for 'salePeriodEnd'
 *      typeClient: // value for 'typeClient'
 *      CarModel: // value for 'CarModel'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetCarForServiceByPeriodConsolidatedQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCarForServiceByPeriodConsolidatedQuery,
    GetCarForServiceByPeriodConsolidatedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCarForServiceByPeriodConsolidatedQuery,
    GetCarForServiceByPeriodConsolidatedQueryVariables
  >(GetCarForServiceByPeriodConsolidatedDocument, options);
}
export function useGetCarForServiceByPeriodConsolidatedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCarForServiceByPeriodConsolidatedQuery,
    GetCarForServiceByPeriodConsolidatedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCarForServiceByPeriodConsolidatedQuery,
    GetCarForServiceByPeriodConsolidatedQueryVariables
  >(GetCarForServiceByPeriodConsolidatedDocument, options);
}
export type GetCarForServiceByPeriodConsolidatedQueryHookResult = ReturnType<
  typeof useGetCarForServiceByPeriodConsolidatedQuery
>;
export type GetCarForServiceByPeriodConsolidatedLazyQueryHookResult =
  ReturnType<typeof useGetCarForServiceByPeriodConsolidatedLazyQuery>;
export type GetCarForServiceByPeriodConsolidatedQueryResult =
  Apollo.QueryResult<
    GetCarForServiceByPeriodConsolidatedQuery,
    GetCarForServiceByPeriodConsolidatedQueryVariables
  >;
export const GetReportReturnCarForAgoByMonthDocument = gql`
  query GetReportReturnCarForAGOByMonth(
    $groupReport: typeGroupReportSRR!
    $numberGO: [typeGOReportSRR]
    $salePeriod: Int
    $monthControl: DateTime!
    $lifetime: Int
    $typeClient: [typeClientReportSRR]
    $CarModel: [ID]!
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      reportReturnCarForAGOByMonth(
        groupReport: $groupReport
        numberGO: $numberGO
        salePeriod: $salePeriod
        monthControl: $monthControl
        lifetime: $lifetime
        CarModel: $CarModel
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetReportReturnCarForAgoByMonthQuery__
 *
 * To run a query within a React component, call `useGetReportReturnCarForAgoByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportReturnCarForAgoByMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportReturnCarForAgoByMonthQuery({
 *   variables: {
 *      groupReport: // value for 'groupReport'
 *      numberGO: // value for 'numberGO'
 *      salePeriod: // value for 'salePeriod'
 *      monthControl: // value for 'monthControl'
 *      lifetime: // value for 'lifetime'
 *      typeClient: // value for 'typeClient'
 *      CarModel: // value for 'CarModel'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetReportReturnCarForAgoByMonthQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportReturnCarForAgoByMonthQuery,
    GetReportReturnCarForAgoByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportReturnCarForAgoByMonthQuery,
    GetReportReturnCarForAgoByMonthQueryVariables
  >(GetReportReturnCarForAgoByMonthDocument, options);
}
export function useGetReportReturnCarForAgoByMonthLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportReturnCarForAgoByMonthQuery,
    GetReportReturnCarForAgoByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportReturnCarForAgoByMonthQuery,
    GetReportReturnCarForAgoByMonthQueryVariables
  >(GetReportReturnCarForAgoByMonthDocument, options);
}
export type GetReportReturnCarForAgoByMonthQueryHookResult = ReturnType<
  typeof useGetReportReturnCarForAgoByMonthQuery
>;
export type GetReportReturnCarForAgoByMonthLazyQueryHookResult = ReturnType<
  typeof useGetReportReturnCarForAgoByMonthLazyQuery
>;
export type GetReportReturnCarForAgoByMonthQueryResult = Apollo.QueryResult<
  GetReportReturnCarForAgoByMonthQuery,
  GetReportReturnCarForAgoByMonthQueryVariables
>;
export const GetReturnCarForAgoByMonthDocument = gql`
  query GetReturnCarForAGOByMonth(
    $groupReport: typeGroupReportSRR!
    $numberGO: [typeGOReportSRR]
    $salePeriod: Int
    $monthControl: DateTime!
    $lifetime: Int
    $typeClient: [typeClientReportSRR]
    $CarModel: [ID]!
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      getCarForAGOByMonth(
        groupReport: $groupReport
        numberGO: $numberGO
        salePeriod: $salePeriod
        monthControl: $monthControl
        lifetime: $lifetime
        CarModel: $CarModel
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        ... on CarForAGOByMonth {
          ...fragmentCarForAGOByMonth
        }
      }
    }
  }
  ${FragmentCarForAgoByMonthFragmentDoc}
`;

/**
 * __useGetReturnCarForAgoByMonthQuery__
 *
 * To run a query within a React component, call `useGetReturnCarForAgoByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReturnCarForAgoByMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReturnCarForAgoByMonthQuery({
 *   variables: {
 *      groupReport: // value for 'groupReport'
 *      numberGO: // value for 'numberGO'
 *      salePeriod: // value for 'salePeriod'
 *      monthControl: // value for 'monthControl'
 *      lifetime: // value for 'lifetime'
 *      typeClient: // value for 'typeClient'
 *      CarModel: // value for 'CarModel'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetReturnCarForAgoByMonthQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReturnCarForAgoByMonthQuery,
    GetReturnCarForAgoByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReturnCarForAgoByMonthQuery,
    GetReturnCarForAgoByMonthQueryVariables
  >(GetReturnCarForAgoByMonthDocument, options);
}
export function useGetReturnCarForAgoByMonthLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReturnCarForAgoByMonthQuery,
    GetReturnCarForAgoByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReturnCarForAgoByMonthQuery,
    GetReturnCarForAgoByMonthQueryVariables
  >(GetReturnCarForAgoByMonthDocument, options);
}
export type GetReturnCarForAgoByMonthQueryHookResult = ReturnType<
  typeof useGetReturnCarForAgoByMonthQuery
>;
export type GetReturnCarForAgoByMonthLazyQueryHookResult = ReturnType<
  typeof useGetReturnCarForAgoByMonthLazyQuery
>;
export type GetReturnCarForAgoByMonthQueryResult = Apollo.QueryResult<
  GetReturnCarForAgoByMonthQuery,
  GetReturnCarForAgoByMonthQueryVariables
>;
export const GetReportReturnCarForeignForAgoByMonthDocument = gql`
  query GetReportReturnCarForeignForAGOByMonth(
    $groupReport: typeGroupReportSRR!
    $numberGO: [typeGOReportSRR]
    $salePeriod: Int
    $monthControl: DateTime!
    $lifetime: Int
    $typeClient: [typeClientReportSRR]
    $CarModel: [ID]!
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      reportReturnCarForeignForAGOByMonth(
        group: $groupReport
        groupReport: $groupReport
        numberGO: $numberGO
        salePeriod: $salePeriod
        monthControl: $monthControl
        lifetime: $lifetime
        CarModel: $CarModel
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetReportReturnCarForeignForAgoByMonthQuery__
 *
 * To run a query within a React component, call `useGetReportReturnCarForeignForAgoByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportReturnCarForeignForAgoByMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportReturnCarForeignForAgoByMonthQuery({
 *   variables: {
 *      groupReport: // value for 'groupReport'
 *      numberGO: // value for 'numberGO'
 *      salePeriod: // value for 'salePeriod'
 *      monthControl: // value for 'monthControl'
 *      lifetime: // value for 'lifetime'
 *      typeClient: // value for 'typeClient'
 *      CarModel: // value for 'CarModel'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetReportReturnCarForeignForAgoByMonthQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportReturnCarForeignForAgoByMonthQuery,
    GetReportReturnCarForeignForAgoByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportReturnCarForeignForAgoByMonthQuery,
    GetReportReturnCarForeignForAgoByMonthQueryVariables
  >(GetReportReturnCarForeignForAgoByMonthDocument, options);
}
export function useGetReportReturnCarForeignForAgoByMonthLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportReturnCarForeignForAgoByMonthQuery,
    GetReportReturnCarForeignForAgoByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportReturnCarForeignForAgoByMonthQuery,
    GetReportReturnCarForeignForAgoByMonthQueryVariables
  >(GetReportReturnCarForeignForAgoByMonthDocument, options);
}
export type GetReportReturnCarForeignForAgoByMonthQueryHookResult = ReturnType<
  typeof useGetReportReturnCarForeignForAgoByMonthQuery
>;
export type GetReportReturnCarForeignForAgoByMonthLazyQueryHookResult =
  ReturnType<typeof useGetReportReturnCarForeignForAgoByMonthLazyQuery>;
export type GetReportReturnCarForeignForAgoByMonthQueryResult =
  Apollo.QueryResult<
    GetReportReturnCarForeignForAgoByMonthQuery,
    GetReportReturnCarForeignForAgoByMonthQueryVariables
  >;
export const GetReturnCarForeignForAgoByMonthDocument = gql`
  query GetReturnCarForeignForAGOByMonth(
    $groupReport: typeGroupReportSRR!
    $numberGO: [typeGOReportSRR]
    $salePeriod: Int
    $monthControl: DateTime!
    $lifetime: Int
    $typeClient: [typeClientReportSRR]
    $CarModel: [ID]!
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      getCarForeignForAGOByMonth(
        groupReport: $groupReport
        numberGO: $numberGO
        salePeriod: $salePeriod
        monthControl: $monthControl
        lifetime: $lifetime
        CarModel: $CarModel
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        ... on CarForAGOByMonth {
          ...fragmentCarForAGOByMonth
        }
      }
    }
  }
  ${FragmentCarForAgoByMonthFragmentDoc}
`;

/**
 * __useGetReturnCarForeignForAgoByMonthQuery__
 *
 * To run a query within a React component, call `useGetReturnCarForeignForAgoByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReturnCarForeignForAgoByMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReturnCarForeignForAgoByMonthQuery({
 *   variables: {
 *      groupReport: // value for 'groupReport'
 *      numberGO: // value for 'numberGO'
 *      salePeriod: // value for 'salePeriod'
 *      monthControl: // value for 'monthControl'
 *      lifetime: // value for 'lifetime'
 *      typeClient: // value for 'typeClient'
 *      CarModel: // value for 'CarModel'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetReturnCarForeignForAgoByMonthQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReturnCarForeignForAgoByMonthQuery,
    GetReturnCarForeignForAgoByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReturnCarForeignForAgoByMonthQuery,
    GetReturnCarForeignForAgoByMonthQueryVariables
  >(GetReturnCarForeignForAgoByMonthDocument, options);
}
export function useGetReturnCarForeignForAgoByMonthLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReturnCarForeignForAgoByMonthQuery,
    GetReturnCarForeignForAgoByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReturnCarForeignForAgoByMonthQuery,
    GetReturnCarForeignForAgoByMonthQueryVariables
  >(GetReturnCarForeignForAgoByMonthDocument, options);
}
export type GetReturnCarForeignForAgoByMonthQueryHookResult = ReturnType<
  typeof useGetReturnCarForeignForAgoByMonthQuery
>;
export type GetReturnCarForeignForAgoByMonthLazyQueryHookResult = ReturnType<
  typeof useGetReturnCarForeignForAgoByMonthLazyQuery
>;
export type GetReturnCarForeignForAgoByMonthQueryResult = Apollo.QueryResult<
  GetReturnCarForeignForAgoByMonthQuery,
  GetReturnCarForeignForAgoByMonthQueryVariables
>;
export const GetReportReturnCarServiceDynamicsDocument = gql`
  query GetReportReturnCarServiceDynamics(
    $group: typeGroupReportSRR!
    $periodStart: DateTime!
    $numberTO: [typeTOReportSRR]
    $periodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      reportReturnCarServiceDynamics(
        group: $group
        numberTO: $numberTO
        periodStart: $periodStart
        periodEnd: $periodEnd
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetReportReturnCarServiceDynamicsQuery__
 *
 * To run a query within a React component, call `useGetReportReturnCarServiceDynamicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportReturnCarServiceDynamicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportReturnCarServiceDynamicsQuery({
 *   variables: {
 *      group: // value for 'group'
 *      periodStart: // value for 'periodStart'
 *      numberTO: // value for 'numberTO'
 *      periodEnd: // value for 'periodEnd'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetReportReturnCarServiceDynamicsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportReturnCarServiceDynamicsQuery,
    GetReportReturnCarServiceDynamicsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportReturnCarServiceDynamicsQuery,
    GetReportReturnCarServiceDynamicsQueryVariables
  >(GetReportReturnCarServiceDynamicsDocument, options);
}
export function useGetReportReturnCarServiceDynamicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportReturnCarServiceDynamicsQuery,
    GetReportReturnCarServiceDynamicsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportReturnCarServiceDynamicsQuery,
    GetReportReturnCarServiceDynamicsQueryVariables
  >(GetReportReturnCarServiceDynamicsDocument, options);
}
export type GetReportReturnCarServiceDynamicsQueryHookResult = ReturnType<
  typeof useGetReportReturnCarServiceDynamicsQuery
>;
export type GetReportReturnCarServiceDynamicsLazyQueryHookResult = ReturnType<
  typeof useGetReportReturnCarServiceDynamicsLazyQuery
>;
export type GetReportReturnCarServiceDynamicsQueryResult = Apollo.QueryResult<
  GetReportReturnCarServiceDynamicsQuery,
  GetReportReturnCarServiceDynamicsQueryVariables
>;
export const GetCarServiceDynamicsDocument = gql`
  query GetCarServiceDynamics(
    $group: typeGroupReportSRR!
    $periodStart: DateTime!
    $numberTO: [typeTOReportSRR]
    $periodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      getCarServiceDynamics(
        group: $group
        numberTO: $numberTO
        periodStart: $periodStart
        periodEnd: $periodEnd
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        ... on CarForServiceDynamics {
          ...fragmentCarForServiceDynamics
        }
      }
    }
  }
  ${FragmentCarForServiceDynamicsFragmentDoc}
`;

/**
 * __useGetCarServiceDynamicsQuery__
 *
 * To run a query within a React component, call `useGetCarServiceDynamicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarServiceDynamicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarServiceDynamicsQuery({
 *   variables: {
 *      group: // value for 'group'
 *      periodStart: // value for 'periodStart'
 *      numberTO: // value for 'numberTO'
 *      periodEnd: // value for 'periodEnd'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetCarServiceDynamicsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCarServiceDynamicsQuery,
    GetCarServiceDynamicsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCarServiceDynamicsQuery,
    GetCarServiceDynamicsQueryVariables
  >(GetCarServiceDynamicsDocument, options);
}
export function useGetCarServiceDynamicsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCarServiceDynamicsQuery,
    GetCarServiceDynamicsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCarServiceDynamicsQuery,
    GetCarServiceDynamicsQueryVariables
  >(GetCarServiceDynamicsDocument, options);
}
export type GetCarServiceDynamicsQueryHookResult = ReturnType<
  typeof useGetCarServiceDynamicsQuery
>;
export type GetCarServiceDynamicsLazyQueryHookResult = ReturnType<
  typeof useGetCarServiceDynamicsLazyQuery
>;
export type GetCarServiceDynamicsQueryResult = Apollo.QueryResult<
  GetCarServiceDynamicsQuery,
  GetCarServiceDynamicsQueryVariables
>;
export const GetReportReturnCarServiceByDealerDocument = gql`
  query GetReportReturnCarServiceByDealer(
    $group: typeGroupReportSRR!
    $periodStart: DateTime!
    $numberTO: [typeTOReportSRR]
    $periodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      reportReturnCarServiceByDealer(
        group: $group
        numberTO: $numberTO
        periodStart: $periodStart
        periodEnd: $periodEnd
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetReportReturnCarServiceByDealerQuery__
 *
 * To run a query within a React component, call `useGetReportReturnCarServiceByDealerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportReturnCarServiceByDealerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportReturnCarServiceByDealerQuery({
 *   variables: {
 *      group: // value for 'group'
 *      periodStart: // value for 'periodStart'
 *      numberTO: // value for 'numberTO'
 *      periodEnd: // value for 'periodEnd'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetReportReturnCarServiceByDealerQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportReturnCarServiceByDealerQuery,
    GetReportReturnCarServiceByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportReturnCarServiceByDealerQuery,
    GetReportReturnCarServiceByDealerQueryVariables
  >(GetReportReturnCarServiceByDealerDocument, options);
}
export function useGetReportReturnCarServiceByDealerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportReturnCarServiceByDealerQuery,
    GetReportReturnCarServiceByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportReturnCarServiceByDealerQuery,
    GetReportReturnCarServiceByDealerQueryVariables
  >(GetReportReturnCarServiceByDealerDocument, options);
}
export type GetReportReturnCarServiceByDealerQueryHookResult = ReturnType<
  typeof useGetReportReturnCarServiceByDealerQuery
>;
export type GetReportReturnCarServiceByDealerLazyQueryHookResult = ReturnType<
  typeof useGetReportReturnCarServiceByDealerLazyQuery
>;
export type GetReportReturnCarServiceByDealerQueryResult = Apollo.QueryResult<
  GetReportReturnCarServiceByDealerQuery,
  GetReportReturnCarServiceByDealerQueryVariables
>;
export const GetCarServiceByDealerDocument = gql`
  query GetCarServiceByDealer(
    $group: typeGroupReportSRR!
    $periodStart: DateTime!
    $numberTO: [typeTOReportSRR]
    $periodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      getCarServiceByDealer(
        group: $group
        numberTO: $numberTO
        periodStart: $periodStart
        periodEnd: $periodEnd
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        ... on CarForServiceByDealer {
          ...fragmentCarForServiceByDealer
        }
      }
    }
  }
  ${FragmentCarForServiceByDealerFragmentDoc}
`;

/**
 * __useGetCarServiceByDealerQuery__
 *
 * To run a query within a React component, call `useGetCarServiceByDealerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarServiceByDealerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarServiceByDealerQuery({
 *   variables: {
 *      group: // value for 'group'
 *      periodStart: // value for 'periodStart'
 *      numberTO: // value for 'numberTO'
 *      periodEnd: // value for 'periodEnd'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetCarServiceByDealerQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCarServiceByDealerQuery,
    GetCarServiceByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCarServiceByDealerQuery,
    GetCarServiceByDealerQueryVariables
  >(GetCarServiceByDealerDocument, options);
}
export function useGetCarServiceByDealerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCarServiceByDealerQuery,
    GetCarServiceByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCarServiceByDealerQuery,
    GetCarServiceByDealerQueryVariables
  >(GetCarServiceByDealerDocument, options);
}
export type GetCarServiceByDealerQueryHookResult = ReturnType<
  typeof useGetCarServiceByDealerQuery
>;
export type GetCarServiceByDealerLazyQueryHookResult = ReturnType<
  typeof useGetCarServiceByDealerLazyQuery
>;
export type GetCarServiceByDealerQueryResult = Apollo.QueryResult<
  GetCarServiceByDealerQuery,
  GetCarServiceByDealerQueryVariables
>;
export const GetReportReturnCarAverageDailyMileageByMonthDocument = gql`
  query GetReportReturnCarAverageDailyMileageByMonth(
    $groupReport: typeGroupReportSRR!
    $numberTO: [typeTOReportSRR]
    $familyCar: [ID]
    $salePeriod: Int
    $monthControl: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      reportReturnCarAverageDailyMileageByMonth(
        groupReport: $groupReport
        numberTO: $numberTO
        familyCar: $familyCar
        salePeriod: $salePeriod
        monthControl: $monthControl
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetReportReturnCarAverageDailyMileageByMonthQuery__
 *
 * To run a query within a React component, call `useGetReportReturnCarAverageDailyMileageByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportReturnCarAverageDailyMileageByMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportReturnCarAverageDailyMileageByMonthQuery({
 *   variables: {
 *      groupReport: // value for 'groupReport'
 *      numberTO: // value for 'numberTO'
 *      familyCar: // value for 'familyCar'
 *      salePeriod: // value for 'salePeriod'
 *      monthControl: // value for 'monthControl'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetReportReturnCarAverageDailyMileageByMonthQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportReturnCarAverageDailyMileageByMonthQuery,
    GetReportReturnCarAverageDailyMileageByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportReturnCarAverageDailyMileageByMonthQuery,
    GetReportReturnCarAverageDailyMileageByMonthQueryVariables
  >(GetReportReturnCarAverageDailyMileageByMonthDocument, options);
}
export function useGetReportReturnCarAverageDailyMileageByMonthLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportReturnCarAverageDailyMileageByMonthQuery,
    GetReportReturnCarAverageDailyMileageByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportReturnCarAverageDailyMileageByMonthQuery,
    GetReportReturnCarAverageDailyMileageByMonthQueryVariables
  >(GetReportReturnCarAverageDailyMileageByMonthDocument, options);
}
export type GetReportReturnCarAverageDailyMileageByMonthQueryHookResult =
  ReturnType<typeof useGetReportReturnCarAverageDailyMileageByMonthQuery>;
export type GetReportReturnCarAverageDailyMileageByMonthLazyQueryHookResult =
  ReturnType<typeof useGetReportReturnCarAverageDailyMileageByMonthLazyQuery>;
export type GetReportReturnCarAverageDailyMileageByMonthQueryResult =
  Apollo.QueryResult<
    GetReportReturnCarAverageDailyMileageByMonthQuery,
    GetReportReturnCarAverageDailyMileageByMonthQueryVariables
  >;
export const GetCarAverageDailyMileageByMonthDocument = gql`
  query GetCarAverageDailyMileageByMonth(
    $group: typeGroupReportSRR!
    $numberTO: [typeTOReportSRR]
    $familyCar: [ID]
    $salePeriod: Int
    $monthControl: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      getCarAverageDailyMileageByMonth(
        group: $group
        numberTO: $numberTO
        familyCar: $familyCar
        salePeriod: $salePeriod
        monthControl: $monthControl
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        ... on CarsForAverageDailyMileageByMonth {
          ...fragmentCarsForAverageDailyMileageByMonth
        }
      }
    }
  }
  ${FragmentCarsForAverageDailyMileageByMonthFragmentDoc}
`;

/**
 * __useGetCarAverageDailyMileageByMonthQuery__
 *
 * To run a query within a React component, call `useGetCarAverageDailyMileageByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarAverageDailyMileageByMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarAverageDailyMileageByMonthQuery({
 *   variables: {
 *      group: // value for 'group'
 *      numberTO: // value for 'numberTO'
 *      familyCar: // value for 'familyCar'
 *      salePeriod: // value for 'salePeriod'
 *      monthControl: // value for 'monthControl'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetCarAverageDailyMileageByMonthQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCarAverageDailyMileageByMonthQuery,
    GetCarAverageDailyMileageByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCarAverageDailyMileageByMonthQuery,
    GetCarAverageDailyMileageByMonthQueryVariables
  >(GetCarAverageDailyMileageByMonthDocument, options);
}
export function useGetCarAverageDailyMileageByMonthLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCarAverageDailyMileageByMonthQuery,
    GetCarAverageDailyMileageByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCarAverageDailyMileageByMonthQuery,
    GetCarAverageDailyMileageByMonthQueryVariables
  >(GetCarAverageDailyMileageByMonthDocument, options);
}
export type GetCarAverageDailyMileageByMonthQueryHookResult = ReturnType<
  typeof useGetCarAverageDailyMileageByMonthQuery
>;
export type GetCarAverageDailyMileageByMonthLazyQueryHookResult = ReturnType<
  typeof useGetCarAverageDailyMileageByMonthLazyQuery
>;
export type GetCarAverageDailyMileageByMonthQueryResult = Apollo.QueryResult<
  GetCarAverageDailyMileageByMonthQuery,
  GetCarAverageDailyMileageByMonthQueryVariables
>;
export const GetReportReturnClientsWithoutServiceDocument = gql`
  query GetReportReturnClientsWithoutService(
    $group: typeGroupReportSRR!
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      reportReturnClientsWithoutService(
        group: $group
        periodStart: $periodStart
        periodEnd: $periodEnd
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetReportReturnClientsWithoutServiceQuery__
 *
 * To run a query within a React component, call `useGetReportReturnClientsWithoutServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportReturnClientsWithoutServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportReturnClientsWithoutServiceQuery({
 *   variables: {
 *      group: // value for 'group'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetReportReturnClientsWithoutServiceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportReturnClientsWithoutServiceQuery,
    GetReportReturnClientsWithoutServiceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportReturnClientsWithoutServiceQuery,
    GetReportReturnClientsWithoutServiceQueryVariables
  >(GetReportReturnClientsWithoutServiceDocument, options);
}
export function useGetReportReturnClientsWithoutServiceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportReturnClientsWithoutServiceQuery,
    GetReportReturnClientsWithoutServiceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportReturnClientsWithoutServiceQuery,
    GetReportReturnClientsWithoutServiceQueryVariables
  >(GetReportReturnClientsWithoutServiceDocument, options);
}
export type GetReportReturnClientsWithoutServiceQueryHookResult = ReturnType<
  typeof useGetReportReturnClientsWithoutServiceQuery
>;
export type GetReportReturnClientsWithoutServiceLazyQueryHookResult =
  ReturnType<typeof useGetReportReturnClientsWithoutServiceLazyQuery>;
export type GetReportReturnClientsWithoutServiceQueryResult =
  Apollo.QueryResult<
    GetReportReturnClientsWithoutServiceQuery,
    GetReportReturnClientsWithoutServiceQueryVariables
  >;
export const GetClientsWithoutServiceDocument = gql`
  query GetClientsWithoutService(
    $group: typeGroupReportSRR!
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      getClientsWithoutService(
        group: $group
        periodStart: $periodStart
        periodEnd: $periodEnd
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        ... on ClientsWithoutService {
          ...fragmentClientsWithoutService
        }
      }
    }
  }
  ${FragmentClientsWithoutServiceFragmentDoc}
`;

/**
 * __useGetClientsWithoutServiceQuery__
 *
 * To run a query within a React component, call `useGetClientsWithoutServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsWithoutServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsWithoutServiceQuery({
 *   variables: {
 *      group: // value for 'group'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetClientsWithoutServiceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClientsWithoutServiceQuery,
    GetClientsWithoutServiceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetClientsWithoutServiceQuery,
    GetClientsWithoutServiceQueryVariables
  >(GetClientsWithoutServiceDocument, options);
}
export function useGetClientsWithoutServiceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClientsWithoutServiceQuery,
    GetClientsWithoutServiceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetClientsWithoutServiceQuery,
    GetClientsWithoutServiceQueryVariables
  >(GetClientsWithoutServiceDocument, options);
}
export type GetClientsWithoutServiceQueryHookResult = ReturnType<
  typeof useGetClientsWithoutServiceQuery
>;
export type GetClientsWithoutServiceLazyQueryHookResult = ReturnType<
  typeof useGetClientsWithoutServiceLazyQuery
>;
export type GetClientsWithoutServiceQueryResult = Apollo.QueryResult<
  GetClientsWithoutServiceQuery,
  GetClientsWithoutServiceQueryVariables
>;
export const GetReportReturnSrr3ByDealerDocument = gql`
  query GetReportReturnSRR3ByDealer(
    $monthControl: DateTime!
    $typeClient: [typeClientReportSRR]
  ) {
    SRRGetter {
      reportReturnSRR3ByDealer(
        monthControl: $monthControl
        typeClient: $typeClient
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetReportReturnSrr3ByDealerQuery__
 *
 * To run a query within a React component, call `useGetReportReturnSrr3ByDealerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportReturnSrr3ByDealerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportReturnSrr3ByDealerQuery({
 *   variables: {
 *      monthControl: // value for 'monthControl'
 *      typeClient: // value for 'typeClient'
 *   },
 * });
 */
export function useGetReportReturnSrr3ByDealerQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportReturnSrr3ByDealerQuery,
    GetReportReturnSrr3ByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportReturnSrr3ByDealerQuery,
    GetReportReturnSrr3ByDealerQueryVariables
  >(GetReportReturnSrr3ByDealerDocument, options);
}
export function useGetReportReturnSrr3ByDealerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportReturnSrr3ByDealerQuery,
    GetReportReturnSrr3ByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportReturnSrr3ByDealerQuery,
    GetReportReturnSrr3ByDealerQueryVariables
  >(GetReportReturnSrr3ByDealerDocument, options);
}
export type GetReportReturnSrr3ByDealerQueryHookResult = ReturnType<
  typeof useGetReportReturnSrr3ByDealerQuery
>;
export type GetReportReturnSrr3ByDealerLazyQueryHookResult = ReturnType<
  typeof useGetReportReturnSrr3ByDealerLazyQuery
>;
export type GetReportReturnSrr3ByDealerQueryResult = Apollo.QueryResult<
  GetReportReturnSrr3ByDealerQuery,
  GetReportReturnSrr3ByDealerQueryVariables
>;
export const GetSrr3ByDealerDocument = gql`
  query GetSRR3ByDealer(
    $monthControl: DateTime!
    $typeClient: [typeClientReportSRR]
  ) {
    SRRGetter {
      getSRR3ByDealer(monthControl: $monthControl, typeClient: $typeClient) {
        ... on dealerForServiceByMonth {
          ...fragmentdealerForServiceByMonth
        }
      }
    }
  }
  ${FragmentdealerForServiceByMonthFragmentDoc}
`;

/**
 * __useGetSrr3ByDealerQuery__
 *
 * To run a query within a React component, call `useGetSrr3ByDealerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSrr3ByDealerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSrr3ByDealerQuery({
 *   variables: {
 *      monthControl: // value for 'monthControl'
 *      typeClient: // value for 'typeClient'
 *   },
 * });
 */
export function useGetSrr3ByDealerQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSrr3ByDealerQuery,
    GetSrr3ByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSrr3ByDealerQuery, GetSrr3ByDealerQueryVariables>(
    GetSrr3ByDealerDocument,
    options,
  );
}
export function useGetSrr3ByDealerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSrr3ByDealerQuery,
    GetSrr3ByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSrr3ByDealerQuery,
    GetSrr3ByDealerQueryVariables
  >(GetSrr3ByDealerDocument, options);
}
export type GetSrr3ByDealerQueryHookResult = ReturnType<
  typeof useGetSrr3ByDealerQuery
>;
export type GetSrr3ByDealerLazyQueryHookResult = ReturnType<
  typeof useGetSrr3ByDealerLazyQuery
>;
export type GetSrr3ByDealerQueryResult = Apollo.QueryResult<
  GetSrr3ByDealerQuery,
  GetSrr3ByDealerQueryVariables
>;
export const GetReportReturnSrr3ByPeriodDocument = gql`
  query GetReportReturnSRR3ByPeriod(
    $group: typeGroupReportSRR!
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      reportReturnSRR3ByPeriod(
        group: $group
        periodStart: $periodStart
        periodEnd: $periodEnd
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetReportReturnSrr3ByPeriodQuery__
 *
 * To run a query within a React component, call `useGetReportReturnSrr3ByPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportReturnSrr3ByPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportReturnSrr3ByPeriodQuery({
 *   variables: {
 *      group: // value for 'group'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetReportReturnSrr3ByPeriodQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportReturnSrr3ByPeriodQuery,
    GetReportReturnSrr3ByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportReturnSrr3ByPeriodQuery,
    GetReportReturnSrr3ByPeriodQueryVariables
  >(GetReportReturnSrr3ByPeriodDocument, options);
}
export function useGetReportReturnSrr3ByPeriodLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportReturnSrr3ByPeriodQuery,
    GetReportReturnSrr3ByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportReturnSrr3ByPeriodQuery,
    GetReportReturnSrr3ByPeriodQueryVariables
  >(GetReportReturnSrr3ByPeriodDocument, options);
}
export type GetReportReturnSrr3ByPeriodQueryHookResult = ReturnType<
  typeof useGetReportReturnSrr3ByPeriodQuery
>;
export type GetReportReturnSrr3ByPeriodLazyQueryHookResult = ReturnType<
  typeof useGetReportReturnSrr3ByPeriodLazyQuery
>;
export type GetReportReturnSrr3ByPeriodQueryResult = Apollo.QueryResult<
  GetReportReturnSrr3ByPeriodQuery,
  GetReportReturnSrr3ByPeriodQueryVariables
>;
export const GetSrr3ByPeriodDocument = gql`
  query GetSRR3ByPeriod(
    $group: typeGroupReportSRR!
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      getSRR3ByPeriod(
        group: $group
        periodStart: $periodStart
        periodEnd: $periodEnd
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        ... on CarForSRR3ByPeriod {
          ...fragmentCarForSRR3ByPeriod
        }
      }
    }
  }
  ${FragmentCarForSrr3ByPeriodFragmentDoc}
`;

/**
 * __useGetSrr3ByPeriodQuery__
 *
 * To run a query within a React component, call `useGetSrr3ByPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSrr3ByPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSrr3ByPeriodQuery({
 *   variables: {
 *      group: // value for 'group'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetSrr3ByPeriodQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSrr3ByPeriodQuery,
    GetSrr3ByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSrr3ByPeriodQuery, GetSrr3ByPeriodQueryVariables>(
    GetSrr3ByPeriodDocument,
    options,
  );
}
export function useGetSrr3ByPeriodLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSrr3ByPeriodQuery,
    GetSrr3ByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSrr3ByPeriodQuery,
    GetSrr3ByPeriodQueryVariables
  >(GetSrr3ByPeriodDocument, options);
}
export type GetSrr3ByPeriodQueryHookResult = ReturnType<
  typeof useGetSrr3ByPeriodQuery
>;
export type GetSrr3ByPeriodLazyQueryHookResult = ReturnType<
  typeof useGetSrr3ByPeriodLazyQuery
>;
export type GetSrr3ByPeriodQueryResult = Apollo.QueryResult<
  GetSrr3ByPeriodQuery,
  GetSrr3ByPeriodQueryVariables
>;
export const GetReportReturnSrr3ForPaymentsDocument = gql`
  query GetReportReturnSRR3ForPayments(
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
  ) {
    SRRGetter {
      reportReturnSRR3ForPayments(
        periodStart: $periodStart
        periodEnd: $periodEnd
        typeClient: $typeClient
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetReportReturnSrr3ForPaymentsQuery__
 *
 * To run a query within a React component, call `useGetReportReturnSrr3ForPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportReturnSrr3ForPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportReturnSrr3ForPaymentsQuery({
 *   variables: {
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      typeClient: // value for 'typeClient'
 *   },
 * });
 */
export function useGetReportReturnSrr3ForPaymentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportReturnSrr3ForPaymentsQuery,
    GetReportReturnSrr3ForPaymentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportReturnSrr3ForPaymentsQuery,
    GetReportReturnSrr3ForPaymentsQueryVariables
  >(GetReportReturnSrr3ForPaymentsDocument, options);
}
export function useGetReportReturnSrr3ForPaymentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportReturnSrr3ForPaymentsQuery,
    GetReportReturnSrr3ForPaymentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportReturnSrr3ForPaymentsQuery,
    GetReportReturnSrr3ForPaymentsQueryVariables
  >(GetReportReturnSrr3ForPaymentsDocument, options);
}
export type GetReportReturnSrr3ForPaymentsQueryHookResult = ReturnType<
  typeof useGetReportReturnSrr3ForPaymentsQuery
>;
export type GetReportReturnSrr3ForPaymentsLazyQueryHookResult = ReturnType<
  typeof useGetReportReturnSrr3ForPaymentsLazyQuery
>;
export type GetReportReturnSrr3ForPaymentsQueryResult = Apollo.QueryResult<
  GetReportReturnSrr3ForPaymentsQuery,
  GetReportReturnSrr3ForPaymentsQueryVariables
>;
export const GetSrr3ForPaymentsDocument = gql`
  query GetSRR3ForPayments(
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
  ) {
    SRRGetter {
      getSRR3ForPayments(
        periodStart: $periodStart
        periodEnd: $periodEnd
        typeClient: $typeClient
      ) {
        ... on dealerForPaymentsByDealer {
          ...fragmentDealerForPaymentsByDealer
        }
      }
    }
  }
  ${FragmentDealerForPaymentsByDealerFragmentDoc}
`;

/**
 * __useGetSrr3ForPaymentsQuery__
 *
 * To run a query within a React component, call `useGetSrr3ForPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSrr3ForPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSrr3ForPaymentsQuery({
 *   variables: {
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      typeClient: // value for 'typeClient'
 *   },
 * });
 */
export function useGetSrr3ForPaymentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSrr3ForPaymentsQuery,
    GetSrr3ForPaymentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSrr3ForPaymentsQuery,
    GetSrr3ForPaymentsQueryVariables
  >(GetSrr3ForPaymentsDocument, options);
}
export function useGetSrr3ForPaymentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSrr3ForPaymentsQuery,
    GetSrr3ForPaymentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSrr3ForPaymentsQuery,
    GetSrr3ForPaymentsQueryVariables
  >(GetSrr3ForPaymentsDocument, options);
}
export type GetSrr3ForPaymentsQueryHookResult = ReturnType<
  typeof useGetSrr3ForPaymentsQuery
>;
export type GetSrr3ForPaymentsLazyQueryHookResult = ReturnType<
  typeof useGetSrr3ForPaymentsLazyQuery
>;
export type GetSrr3ForPaymentsQueryResult = Apollo.QueryResult<
  GetSrr3ForPaymentsQuery,
  GetSrr3ForPaymentsQueryVariables
>;
export const GetReportReturnSrr3ByCarDocument = gql`
  query GetReportReturnSRR3ByCar(
    $familyCar: [ID]
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
  ) {
    SRRGetter {
      reportReturnSRR3ByCar(
        familyCar: $familyCar
        periodStart: $periodStart
        periodEnd: $periodEnd
        typeClient: $typeClient
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetReportReturnSrr3ByCarQuery__
 *
 * To run a query within a React component, call `useGetReportReturnSrr3ByCarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportReturnSrr3ByCarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportReturnSrr3ByCarQuery({
 *   variables: {
 *      familyCar: // value for 'familyCar'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      typeClient: // value for 'typeClient'
 *   },
 * });
 */
export function useGetReportReturnSrr3ByCarQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportReturnSrr3ByCarQuery,
    GetReportReturnSrr3ByCarQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportReturnSrr3ByCarQuery,
    GetReportReturnSrr3ByCarQueryVariables
  >(GetReportReturnSrr3ByCarDocument, options);
}
export function useGetReportReturnSrr3ByCarLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportReturnSrr3ByCarQuery,
    GetReportReturnSrr3ByCarQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportReturnSrr3ByCarQuery,
    GetReportReturnSrr3ByCarQueryVariables
  >(GetReportReturnSrr3ByCarDocument, options);
}
export type GetReportReturnSrr3ByCarQueryHookResult = ReturnType<
  typeof useGetReportReturnSrr3ByCarQuery
>;
export type GetReportReturnSrr3ByCarLazyQueryHookResult = ReturnType<
  typeof useGetReportReturnSrr3ByCarLazyQuery
>;
export type GetReportReturnSrr3ByCarQueryResult = Apollo.QueryResult<
  GetReportReturnSrr3ByCarQuery,
  GetReportReturnSrr3ByCarQueryVariables
>;
export const GetSrr3ByCarDocument = gql`
  query GetSRR3ByCar(
    $familyCar: [ID]
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
  ) {
    SRRGetter {
      getSRR3ByCar(
        familyCar: $familyCar
        periodStart: $periodStart
        periodEnd: $periodEnd
        typeClient: $typeClient
      ) {
        ... on dealerByCarByDealer {
          ...fragmentDealerByCarByDealer
        }
      }
    }
  }
  ${FragmentDealerByCarByDealerFragmentDoc}
`;

/**
 * __useGetSrr3ByCarQuery__
 *
 * To run a query within a React component, call `useGetSrr3ByCarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSrr3ByCarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSrr3ByCarQuery({
 *   variables: {
 *      familyCar: // value for 'familyCar'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      typeClient: // value for 'typeClient'
 *   },
 * });
 */
export function useGetSrr3ByCarQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSrr3ByCarQuery,
    GetSrr3ByCarQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSrr3ByCarQuery, GetSrr3ByCarQueryVariables>(
    GetSrr3ByCarDocument,
    options,
  );
}
export function useGetSrr3ByCarLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSrr3ByCarQuery,
    GetSrr3ByCarQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSrr3ByCarQuery, GetSrr3ByCarQueryVariables>(
    GetSrr3ByCarDocument,
    options,
  );
}
export type GetSrr3ByCarQueryHookResult = ReturnType<
  typeof useGetSrr3ByCarQuery
>;
export type GetSrr3ByCarLazyQueryHookResult = ReturnType<
  typeof useGetSrr3ByCarLazyQuery
>;
export type GetSrr3ByCarQueryResult = Apollo.QueryResult<
  GetSrr3ByCarQuery,
  GetSrr3ByCarQueryVariables
>;
export const GetReportReturnSrr3ByVinDocument = gql`
  query GetReportReturnSRR3ByVIN(
    $dealerIds: [ID]
    $monthControl: DateTime!
    $typeClient: [typeClientReportSRR]
  ) {
    SRRGetter {
      reportReturnSRR3ByVIN(
        dealerIds: $dealerIds
        monthControl: $monthControl
        typeClient: $typeClient
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetReportReturnSrr3ByVinQuery__
 *
 * To run a query within a React component, call `useGetReportReturnSrr3ByVinQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportReturnSrr3ByVinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportReturnSrr3ByVinQuery({
 *   variables: {
 *      dealerIds: // value for 'dealerIds'
 *      monthControl: // value for 'monthControl'
 *      typeClient: // value for 'typeClient'
 *   },
 * });
 */
export function useGetReportReturnSrr3ByVinQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportReturnSrr3ByVinQuery,
    GetReportReturnSrr3ByVinQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportReturnSrr3ByVinQuery,
    GetReportReturnSrr3ByVinQueryVariables
  >(GetReportReturnSrr3ByVinDocument, options);
}
export function useGetReportReturnSrr3ByVinLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportReturnSrr3ByVinQuery,
    GetReportReturnSrr3ByVinQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportReturnSrr3ByVinQuery,
    GetReportReturnSrr3ByVinQueryVariables
  >(GetReportReturnSrr3ByVinDocument, options);
}
export type GetReportReturnSrr3ByVinQueryHookResult = ReturnType<
  typeof useGetReportReturnSrr3ByVinQuery
>;
export type GetReportReturnSrr3ByVinLazyQueryHookResult = ReturnType<
  typeof useGetReportReturnSrr3ByVinLazyQuery
>;
export type GetReportReturnSrr3ByVinQueryResult = Apollo.QueryResult<
  GetReportReturnSrr3ByVinQuery,
  GetReportReturnSrr3ByVinQueryVariables
>;
export const GetReportReturnSrr5ByVinDocument = gql`
  query GetReportReturnSRR5ByVIN(
    $dealerIds: [ID]
    $monthControl: DateTime!
    $typeClient: [typeClientReportSRR]
  ) {
    SRRGetter {
      reportReturnSRR5ByVIN(
        dealerIds: $dealerIds
        monthControl: $monthControl
        typeClient: $typeClient
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetReportReturnSrr5ByVinQuery__
 *
 * To run a query within a React component, call `useGetReportReturnSrr5ByVinQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportReturnSrr5ByVinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportReturnSrr5ByVinQuery({
 *   variables: {
 *      dealerIds: // value for 'dealerIds'
 *      monthControl: // value for 'monthControl'
 *      typeClient: // value for 'typeClient'
 *   },
 * });
 */
export function useGetReportReturnSrr5ByVinQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportReturnSrr5ByVinQuery,
    GetReportReturnSrr5ByVinQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportReturnSrr5ByVinQuery,
    GetReportReturnSrr5ByVinQueryVariables
  >(GetReportReturnSrr5ByVinDocument, options);
}
export function useGetReportReturnSrr5ByVinLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportReturnSrr5ByVinQuery,
    GetReportReturnSrr5ByVinQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportReturnSrr5ByVinQuery,
    GetReportReturnSrr5ByVinQueryVariables
  >(GetReportReturnSrr5ByVinDocument, options);
}
export type GetReportReturnSrr5ByVinQueryHookResult = ReturnType<
  typeof useGetReportReturnSrr5ByVinQuery
>;
export type GetReportReturnSrr5ByVinLazyQueryHookResult = ReturnType<
  typeof useGetReportReturnSrr5ByVinLazyQuery
>;
export type GetReportReturnSrr5ByVinQueryResult = Apollo.QueryResult<
  GetReportReturnSrr5ByVinQuery,
  GetReportReturnSrr5ByVinQueryVariables
>;
export const GetSrr3ByVinDocument = gql`
  query GetSRR3ByVIN(
    $dealerIds: [ID]
    $monthControl: DateTime!
    $typeClient: [typeClientReportSRR]
  ) {
    SRRGetter {
      getSRR3ByVIN(
        dealerIds: $dealerIds
        monthControl: $monthControl
        typeClient: $typeClient
      ) {
        ... on dealerByCarByVIN {
          ...fragmentDealerByCarByVIN
        }
      }
    }
  }
  ${FragmentDealerByCarByVinFragmentDoc}
`;

/**
 * __useGetSrr3ByVinQuery__
 *
 * To run a query within a React component, call `useGetSrr3ByVinQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSrr3ByVinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSrr3ByVinQuery({
 *   variables: {
 *      dealerIds: // value for 'dealerIds'
 *      monthControl: // value for 'monthControl'
 *      typeClient: // value for 'typeClient'
 *   },
 * });
 */
export function useGetSrr3ByVinQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSrr3ByVinQuery,
    GetSrr3ByVinQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSrr3ByVinQuery, GetSrr3ByVinQueryVariables>(
    GetSrr3ByVinDocument,
    options,
  );
}
export function useGetSrr3ByVinLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSrr3ByVinQuery,
    GetSrr3ByVinQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSrr3ByVinQuery, GetSrr3ByVinQueryVariables>(
    GetSrr3ByVinDocument,
    options,
  );
}
export type GetSrr3ByVinQueryHookResult = ReturnType<
  typeof useGetSrr3ByVinQuery
>;
export type GetSrr3ByVinLazyQueryHookResult = ReturnType<
  typeof useGetSrr3ByVinLazyQuery
>;
export type GetSrr3ByVinQueryResult = Apollo.QueryResult<
  GetSrr3ByVinQuery,
  GetSrr3ByVinQueryVariables
>;
export const GetSrr5ByVinDocument = gql`
  query GetSRR5ByVIN(
    $dealerIds: [ID]
    $monthControl: DateTime!
    $typeClient: [typeClientReportSRR]
  ) {
    SRRGetter {
      getSRR5ByVIN(
        dealerIds: $dealerIds
        monthControl: $monthControl
        typeClient: $typeClient
      ) {
        ... on dealerByCarByVIN {
          ...fragmentDealerByCarByVIN
          TO4 {
            dateVisit
            dealerName
          }
          TO5 {
            dateVisit
            dealerName
          }
        }
      }
    }
  }
  ${FragmentDealerByCarByVinFragmentDoc}
`;

/**
 * __useGetSrr5ByVinQuery__
 *
 * To run a query within a React component, call `useGetSrr5ByVinQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSrr5ByVinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSrr5ByVinQuery({
 *   variables: {
 *      dealerIds: // value for 'dealerIds'
 *      monthControl: // value for 'monthControl'
 *      typeClient: // value for 'typeClient'
 *   },
 * });
 */
export function useGetSrr5ByVinQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSrr5ByVinQuery,
    GetSrr5ByVinQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSrr5ByVinQuery, GetSrr5ByVinQueryVariables>(
    GetSrr5ByVinDocument,
    options,
  );
}
export function useGetSrr5ByVinLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSrr5ByVinQuery,
    GetSrr5ByVinQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSrr5ByVinQuery, GetSrr5ByVinQueryVariables>(
    GetSrr5ByVinDocument,
    options,
  );
}
export type GetSrr5ByVinQueryHookResult = ReturnType<
  typeof useGetSrr5ByVinQuery
>;
export type GetSrr5ByVinLazyQueryHookResult = ReturnType<
  typeof useGetSrr5ByVinLazyQuery
>;
export type GetSrr5ByVinQueryResult = Apollo.QueryResult<
  GetSrr5ByVinQuery,
  GetSrr5ByVinQueryVariables
>;
export const ReportReturnSrr5ByDealerDocument = gql`
  query ReportReturnSRR5ByDealer(
    $monthControl: DateTime!
    $typeClient: [typeClientReportSRR]
  ) {
    SRRGetter {
      reportReturnSRR5ByDealer(
        monthControl: $monthControl
        typeClient: $typeClient
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useReportReturnSrr5ByDealerQuery__
 *
 * To run a query within a React component, call `useReportReturnSrr5ByDealerQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportReturnSrr5ByDealerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportReturnSrr5ByDealerQuery({
 *   variables: {
 *      monthControl: // value for 'monthControl'
 *      typeClient: // value for 'typeClient'
 *   },
 * });
 */
export function useReportReturnSrr5ByDealerQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReportReturnSrr5ByDealerQuery,
    ReportReturnSrr5ByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ReportReturnSrr5ByDealerQuery,
    ReportReturnSrr5ByDealerQueryVariables
  >(ReportReturnSrr5ByDealerDocument, options);
}
export function useReportReturnSrr5ByDealerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReportReturnSrr5ByDealerQuery,
    ReportReturnSrr5ByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ReportReturnSrr5ByDealerQuery,
    ReportReturnSrr5ByDealerQueryVariables
  >(ReportReturnSrr5ByDealerDocument, options);
}
export type ReportReturnSrr5ByDealerQueryHookResult = ReturnType<
  typeof useReportReturnSrr5ByDealerQuery
>;
export type ReportReturnSrr5ByDealerLazyQueryHookResult = ReturnType<
  typeof useReportReturnSrr5ByDealerLazyQuery
>;
export type ReportReturnSrr5ByDealerQueryResult = Apollo.QueryResult<
  ReportReturnSrr5ByDealerQuery,
  ReportReturnSrr5ByDealerQueryVariables
>;
export const GetSrr5ByDealerDocument = gql`
  query GetSRR5ByDealer(
    $monthControl: DateTime!
    $typeClient: [typeClientReportSRR]
  ) {
    SRRGetter {
      getSRR5ByDealer(monthControl: $monthControl, typeClient: $typeClient) {
        ... on dealerForServiceByMonth {
          ...fragmentdealerForServiceByMonth
        }
      }
    }
  }
  ${FragmentdealerForServiceByMonthFragmentDoc}
`;

/**
 * __useGetSrr5ByDealerQuery__
 *
 * To run a query within a React component, call `useGetSrr5ByDealerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSrr5ByDealerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSrr5ByDealerQuery({
 *   variables: {
 *      monthControl: // value for 'monthControl'
 *      typeClient: // value for 'typeClient'
 *   },
 * });
 */
export function useGetSrr5ByDealerQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSrr5ByDealerQuery,
    GetSrr5ByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSrr5ByDealerQuery, GetSrr5ByDealerQueryVariables>(
    GetSrr5ByDealerDocument,
    options,
  );
}
export function useGetSrr5ByDealerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSrr5ByDealerQuery,
    GetSrr5ByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSrr5ByDealerQuery,
    GetSrr5ByDealerQueryVariables
  >(GetSrr5ByDealerDocument, options);
}
export type GetSrr5ByDealerQueryHookResult = ReturnType<
  typeof useGetSrr5ByDealerQuery
>;
export type GetSrr5ByDealerLazyQueryHookResult = ReturnType<
  typeof useGetSrr5ByDealerLazyQuery
>;
export type GetSrr5ByDealerQueryResult = Apollo.QueryResult<
  GetSrr5ByDealerQuery,
  GetSrr5ByDealerQueryVariables
>;
export const GetReportReturnSrr5ByPeriodDocument = gql`
  query GetReportReturnSRR5ByPeriod(
    $group: typeGroupReportSRR!
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      reportReturnSRR5ByPeriod(
        group: $group
        periodStart: $periodStart
        periodEnd: $periodEnd
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetReportReturnSrr5ByPeriodQuery__
 *
 * To run a query within a React component, call `useGetReportReturnSrr5ByPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportReturnSrr5ByPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportReturnSrr5ByPeriodQuery({
 *   variables: {
 *      group: // value for 'group'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetReportReturnSrr5ByPeriodQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportReturnSrr5ByPeriodQuery,
    GetReportReturnSrr5ByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportReturnSrr5ByPeriodQuery,
    GetReportReturnSrr5ByPeriodQueryVariables
  >(GetReportReturnSrr5ByPeriodDocument, options);
}
export function useGetReportReturnSrr5ByPeriodLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportReturnSrr5ByPeriodQuery,
    GetReportReturnSrr5ByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportReturnSrr5ByPeriodQuery,
    GetReportReturnSrr5ByPeriodQueryVariables
  >(GetReportReturnSrr5ByPeriodDocument, options);
}
export type GetReportReturnSrr5ByPeriodQueryHookResult = ReturnType<
  typeof useGetReportReturnSrr5ByPeriodQuery
>;
export type GetReportReturnSrr5ByPeriodLazyQueryHookResult = ReturnType<
  typeof useGetReportReturnSrr5ByPeriodLazyQuery
>;
export type GetReportReturnSrr5ByPeriodQueryResult = Apollo.QueryResult<
  GetReportReturnSrr5ByPeriodQuery,
  GetReportReturnSrr5ByPeriodQueryVariables
>;
export const GetSrr5ByPeriodDocument = gql`
  query GetSRR5ByPeriod(
    $group: typeGroupReportSRR!
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      getSRR5ByPeriod(
        group: $group
        periodStart: $periodStart
        periodEnd: $periodEnd
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        ... on CarForSRR5ByPeriod {
          ...fragmentCarForSRR5ByPeriod
        }
      }
    }
  }
  ${FragmentCarForSrr5ByPeriodFragmentDoc}
`;

/**
 * __useGetSrr5ByPeriodQuery__
 *
 * To run a query within a React component, call `useGetSrr5ByPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSrr5ByPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSrr5ByPeriodQuery({
 *   variables: {
 *      group: // value for 'group'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetSrr5ByPeriodQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSrr5ByPeriodQuery,
    GetSrr5ByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSrr5ByPeriodQuery, GetSrr5ByPeriodQueryVariables>(
    GetSrr5ByPeriodDocument,
    options,
  );
}
export function useGetSrr5ByPeriodLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSrr5ByPeriodQuery,
    GetSrr5ByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSrr5ByPeriodQuery,
    GetSrr5ByPeriodQueryVariables
  >(GetSrr5ByPeriodDocument, options);
}
export type GetSrr5ByPeriodQueryHookResult = ReturnType<
  typeof useGetSrr5ByPeriodQuery
>;
export type GetSrr5ByPeriodLazyQueryHookResult = ReturnType<
  typeof useGetSrr5ByPeriodLazyQuery
>;
export type GetSrr5ByPeriodQueryResult = Apollo.QueryResult<
  GetSrr5ByPeriodQuery,
  GetSrr5ByPeriodQueryVariables
>;
export const GetReportReturnSrr5ForPaymentsDocument = gql`
  query GetReportReturnSRR5ForPayments(
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
  ) {
    SRRGetter {
      reportReturnSRR5ForPayments(
        periodStart: $periodStart
        periodEnd: $periodEnd
        typeClient: $typeClient
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetReportReturnSrr5ForPaymentsQuery__
 *
 * To run a query within a React component, call `useGetReportReturnSrr5ForPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportReturnSrr5ForPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportReturnSrr5ForPaymentsQuery({
 *   variables: {
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      typeClient: // value for 'typeClient'
 *   },
 * });
 */
export function useGetReportReturnSrr5ForPaymentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportReturnSrr5ForPaymentsQuery,
    GetReportReturnSrr5ForPaymentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportReturnSrr5ForPaymentsQuery,
    GetReportReturnSrr5ForPaymentsQueryVariables
  >(GetReportReturnSrr5ForPaymentsDocument, options);
}
export function useGetReportReturnSrr5ForPaymentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportReturnSrr5ForPaymentsQuery,
    GetReportReturnSrr5ForPaymentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportReturnSrr5ForPaymentsQuery,
    GetReportReturnSrr5ForPaymentsQueryVariables
  >(GetReportReturnSrr5ForPaymentsDocument, options);
}
export type GetReportReturnSrr5ForPaymentsQueryHookResult = ReturnType<
  typeof useGetReportReturnSrr5ForPaymentsQuery
>;
export type GetReportReturnSrr5ForPaymentsLazyQueryHookResult = ReturnType<
  typeof useGetReportReturnSrr5ForPaymentsLazyQuery
>;
export type GetReportReturnSrr5ForPaymentsQueryResult = Apollo.QueryResult<
  GetReportReturnSrr5ForPaymentsQuery,
  GetReportReturnSrr5ForPaymentsQueryVariables
>;
export const GetSrr5ForPaymentsDocument = gql`
  query GetSRR5ForPayments(
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
  ) {
    SRRGetter {
      getSRR5ForPayments(
        periodStart: $periodStart
        periodEnd: $periodEnd
        typeClient: $typeClient
      ) {
        ... on dealerForPaymentsByDealer {
          ...fragmentDealerForPaymentsByDealer
        }
      }
    }
  }
  ${FragmentDealerForPaymentsByDealerFragmentDoc}
`;

/**
 * __useGetSrr5ForPaymentsQuery__
 *
 * To run a query within a React component, call `useGetSrr5ForPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSrr5ForPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSrr5ForPaymentsQuery({
 *   variables: {
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      typeClient: // value for 'typeClient'
 *   },
 * });
 */
export function useGetSrr5ForPaymentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSrr5ForPaymentsQuery,
    GetSrr5ForPaymentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSrr5ForPaymentsQuery,
    GetSrr5ForPaymentsQueryVariables
  >(GetSrr5ForPaymentsDocument, options);
}
export function useGetSrr5ForPaymentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSrr5ForPaymentsQuery,
    GetSrr5ForPaymentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSrr5ForPaymentsQuery,
    GetSrr5ForPaymentsQueryVariables
  >(GetSrr5ForPaymentsDocument, options);
}
export type GetSrr5ForPaymentsQueryHookResult = ReturnType<
  typeof useGetSrr5ForPaymentsQuery
>;
export type GetSrr5ForPaymentsLazyQueryHookResult = ReturnType<
  typeof useGetSrr5ForPaymentsLazyQuery
>;
export type GetSrr5ForPaymentsQueryResult = Apollo.QueryResult<
  GetSrr5ForPaymentsQuery,
  GetSrr5ForPaymentsQueryVariables
>;
export const GetReportReturnSrr5ByCarDocument = gql`
  query GetReportReturnSRR5ByCar(
    $familyCar: [ID]
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
  ) {
    SRRGetter {
      reportReturnSRR5ByCar(
        familyCar: $familyCar
        periodStart: $periodStart
        periodEnd: $periodEnd
        typeClient: $typeClient
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetReportReturnSrr5ByCarQuery__
 *
 * To run a query within a React component, call `useGetReportReturnSrr5ByCarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportReturnSrr5ByCarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportReturnSrr5ByCarQuery({
 *   variables: {
 *      familyCar: // value for 'familyCar'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      typeClient: // value for 'typeClient'
 *   },
 * });
 */
export function useGetReportReturnSrr5ByCarQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportReturnSrr5ByCarQuery,
    GetReportReturnSrr5ByCarQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportReturnSrr5ByCarQuery,
    GetReportReturnSrr5ByCarQueryVariables
  >(GetReportReturnSrr5ByCarDocument, options);
}
export function useGetReportReturnSrr5ByCarLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportReturnSrr5ByCarQuery,
    GetReportReturnSrr5ByCarQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportReturnSrr5ByCarQuery,
    GetReportReturnSrr5ByCarQueryVariables
  >(GetReportReturnSrr5ByCarDocument, options);
}
export type GetReportReturnSrr5ByCarQueryHookResult = ReturnType<
  typeof useGetReportReturnSrr5ByCarQuery
>;
export type GetReportReturnSrr5ByCarLazyQueryHookResult = ReturnType<
  typeof useGetReportReturnSrr5ByCarLazyQuery
>;
export type GetReportReturnSrr5ByCarQueryResult = Apollo.QueryResult<
  GetReportReturnSrr5ByCarQuery,
  GetReportReturnSrr5ByCarQueryVariables
>;
export const GetSrr5ByCarDocument = gql`
  query GetSRR5ByCar(
    $familyCar: [ID]
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
  ) {
    SRRGetter {
      getSRR5ByCar(
        familyCar: $familyCar
        periodStart: $periodStart
        periodEnd: $periodEnd
        typeClient: $typeClient
      ) {
        ... on dealerByCarByDealer {
          ...fragmentDealerByCarByDealer
        }
      }
    }
  }
  ${FragmentDealerByCarByDealerFragmentDoc}
`;

/**
 * __useGetSrr5ByCarQuery__
 *
 * To run a query within a React component, call `useGetSrr5ByCarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSrr5ByCarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSrr5ByCarQuery({
 *   variables: {
 *      familyCar: // value for 'familyCar'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      typeClient: // value for 'typeClient'
 *   },
 * });
 */
export function useGetSrr5ByCarQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSrr5ByCarQuery,
    GetSrr5ByCarQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSrr5ByCarQuery, GetSrr5ByCarQueryVariables>(
    GetSrr5ByCarDocument,
    options,
  );
}
export function useGetSrr5ByCarLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSrr5ByCarQuery,
    GetSrr5ByCarQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSrr5ByCarQuery, GetSrr5ByCarQueryVariables>(
    GetSrr5ByCarDocument,
    options,
  );
}
export type GetSrr5ByCarQueryHookResult = ReturnType<
  typeof useGetSrr5ByCarQuery
>;
export type GetSrr5ByCarLazyQueryHookResult = ReturnType<
  typeof useGetSrr5ByCarLazyQuery
>;
export type GetSrr5ByCarQueryResult = Apollo.QueryResult<
  GetSrr5ByCarQuery,
  GetSrr5ByCarQueryVariables
>;
export const GetReportInviteClientToServiceDocument = gql`
  query GetReportInviteClientToService(
    $dealerIds: [ID]
    $monthControl: DateTime
    $runStart: Int
    $runEnd: Int
    $method: String!
    $numberTO: typeTOReportSRR
    $typeClient: [typeClientReportSRR]
  ) {
    SRRGetter {
      reportInviteClientToService(
        dealerIds: $dealerIds
        monthControl: $monthControl
        runStart: $runStart
        runEnd: $runEnd
        method: $method
        numberTO: $numberTO
        typeClient: $typeClient
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetReportInviteClientToServiceQuery__
 *
 * To run a query within a React component, call `useGetReportInviteClientToServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportInviteClientToServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportInviteClientToServiceQuery({
 *   variables: {
 *      dealerIds: // value for 'dealerIds'
 *      monthControl: // value for 'monthControl'
 *      runStart: // value for 'runStart'
 *      runEnd: // value for 'runEnd'
 *      method: // value for 'method'
 *      numberTO: // value for 'numberTO'
 *      typeClient: // value for 'typeClient'
 *   },
 * });
 */
export function useGetReportInviteClientToServiceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportInviteClientToServiceQuery,
    GetReportInviteClientToServiceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportInviteClientToServiceQuery,
    GetReportInviteClientToServiceQueryVariables
  >(GetReportInviteClientToServiceDocument, options);
}
export function useGetReportInviteClientToServiceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportInviteClientToServiceQuery,
    GetReportInviteClientToServiceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportInviteClientToServiceQuery,
    GetReportInviteClientToServiceQueryVariables
  >(GetReportInviteClientToServiceDocument, options);
}
export type GetReportInviteClientToServiceQueryHookResult = ReturnType<
  typeof useGetReportInviteClientToServiceQuery
>;
export type GetReportInviteClientToServiceLazyQueryHookResult = ReturnType<
  typeof useGetReportInviteClientToServiceLazyQuery
>;
export type GetReportInviteClientToServiceQueryResult = Apollo.QueryResult<
  GetReportInviteClientToServiceQuery,
  GetReportInviteClientToServiceQueryVariables
>;
export const GetInviteClientToServiceDocument = gql`
  query GetInviteClientToService(
    $dealerIds: [ID]
    $monthControl: DateTime
    $method: String!
    $numberTO: typeTOReportSRR
    $typeClient: [typeClientReportSRR]
  ) {
    SRRGetter {
      getInviteClientToService(
        dealerIds: $dealerIds
        monthControl: $monthControl
        method: $method
        numberTO: $numberTO
        typeClient: $typeClient
      ) {
        ... on inviteClientToService {
          ...fragmentInviteClientToService
        }
      }
    }
  }
  ${FragmentInviteClientToServiceFragmentDoc}
`;

/**
 * __useGetInviteClientToServiceQuery__
 *
 * To run a query within a React component, call `useGetInviteClientToServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInviteClientToServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInviteClientToServiceQuery({
 *   variables: {
 *      dealerIds: // value for 'dealerIds'
 *      monthControl: // value for 'monthControl'
 *      method: // value for 'method'
 *      numberTO: // value for 'numberTO'
 *      typeClient: // value for 'typeClient'
 *   },
 * });
 */
export function useGetInviteClientToServiceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInviteClientToServiceQuery,
    GetInviteClientToServiceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetInviteClientToServiceQuery,
    GetInviteClientToServiceQueryVariables
  >(GetInviteClientToServiceDocument, options);
}
export function useGetInviteClientToServiceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInviteClientToServiceQuery,
    GetInviteClientToServiceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetInviteClientToServiceQuery,
    GetInviteClientToServiceQueryVariables
  >(GetInviteClientToServiceDocument, options);
}
export type GetInviteClientToServiceQueryHookResult = ReturnType<
  typeof useGetInviteClientToServiceQuery
>;
export type GetInviteClientToServiceLazyQueryHookResult = ReturnType<
  typeof useGetInviteClientToServiceLazyQuery
>;
export type GetInviteClientToServiceQueryResult = Apollo.QueryResult<
  GetInviteClientToServiceQuery,
  GetInviteClientToServiceQueryVariables
>;
export const GetReportReturnCarForServiceGibddByMonthDocument = gql`
  query GetReportReturnCarForServiceGIBDDByMonth(
    $groupReport: typeGroupReportSRR!
    $numberTO: [typeTOReportSRR]
    $salePeriod: Int
    $monthControl: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      reportReturnCarForServiceGIBDDByMonth(
        groupReport: $groupReport
        numberTO: $numberTO
        salePeriod: $salePeriod
        monthControl: $monthControl
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetReportReturnCarForServiceGibddByMonthQuery__
 *
 * To run a query within a React component, call `useGetReportReturnCarForServiceGibddByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportReturnCarForServiceGibddByMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportReturnCarForServiceGibddByMonthQuery({
 *   variables: {
 *      groupReport: // value for 'groupReport'
 *      numberTO: // value for 'numberTO'
 *      salePeriod: // value for 'salePeriod'
 *      monthControl: // value for 'monthControl'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetReportReturnCarForServiceGibddByMonthQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportReturnCarForServiceGibddByMonthQuery,
    GetReportReturnCarForServiceGibddByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportReturnCarForServiceGibddByMonthQuery,
    GetReportReturnCarForServiceGibddByMonthQueryVariables
  >(GetReportReturnCarForServiceGibddByMonthDocument, options);
}
export function useGetReportReturnCarForServiceGibddByMonthLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportReturnCarForServiceGibddByMonthQuery,
    GetReportReturnCarForServiceGibddByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportReturnCarForServiceGibddByMonthQuery,
    GetReportReturnCarForServiceGibddByMonthQueryVariables
  >(GetReportReturnCarForServiceGibddByMonthDocument, options);
}
export type GetReportReturnCarForServiceGibddByMonthQueryHookResult =
  ReturnType<typeof useGetReportReturnCarForServiceGibddByMonthQuery>;
export type GetReportReturnCarForServiceGibddByMonthLazyQueryHookResult =
  ReturnType<typeof useGetReportReturnCarForServiceGibddByMonthLazyQuery>;
export type GetReportReturnCarForServiceGibddByMonthQueryResult =
  Apollo.QueryResult<
    GetReportReturnCarForServiceGibddByMonthQuery,
    GetReportReturnCarForServiceGibddByMonthQueryVariables
  >;
export const GetCarForServiceGibddByMonthDocument = gql`
  query GetCarForServiceGIBDDByMonth(
    $group: typeGroupReportSRR!
    $numberTO: [typeTOReportSRR]
    $salePeriod: Int
    $monthControl: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      getCarForServiceGIBDDByMonth(
        group: $group
        numberTO: $numberTO
        salePeriod: $salePeriod
        monthControl: $monthControl
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        ... on CarForServiceByMonth {
          ...fragmentCarForServiceByMonth
        }
      }
    }
  }
  ${FragmentCarForServiceByMonthFragmentDoc}
`;

/**
 * __useGetCarForServiceGibddByMonthQuery__
 *
 * To run a query within a React component, call `useGetCarForServiceGibddByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarForServiceGibddByMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarForServiceGibddByMonthQuery({
 *   variables: {
 *      group: // value for 'group'
 *      numberTO: // value for 'numberTO'
 *      salePeriod: // value for 'salePeriod'
 *      monthControl: // value for 'monthControl'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetCarForServiceGibddByMonthQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCarForServiceGibddByMonthQuery,
    GetCarForServiceGibddByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCarForServiceGibddByMonthQuery,
    GetCarForServiceGibddByMonthQueryVariables
  >(GetCarForServiceGibddByMonthDocument, options);
}
export function useGetCarForServiceGibddByMonthLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCarForServiceGibddByMonthQuery,
    GetCarForServiceGibddByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCarForServiceGibddByMonthQuery,
    GetCarForServiceGibddByMonthQueryVariables
  >(GetCarForServiceGibddByMonthDocument, options);
}
export type GetCarForServiceGibddByMonthQueryHookResult = ReturnType<
  typeof useGetCarForServiceGibddByMonthQuery
>;
export type GetCarForServiceGibddByMonthLazyQueryHookResult = ReturnType<
  typeof useGetCarForServiceGibddByMonthLazyQuery
>;
export type GetCarForServiceGibddByMonthQueryResult = Apollo.QueryResult<
  GetCarForServiceGibddByMonthQuery,
  GetCarForServiceGibddByMonthQueryVariables
>;
export const GetReportReturnCarForServiceGibddByPeriodDocument = gql`
  query GetReportReturnCarForServiceGIBDDByPeriod(
    $groupReport: typeGroupReportSRR!
    $numberTO: [typeTOReportSRR]
    $salePeriodStart: DateTime!
    $salePeriodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      reportReturnCarForServiceGIBDDByPeriod(
        groupReport: $groupReport
        numberTO: $numberTO
        salePeriodStart: $salePeriodStart
        salePeriodEnd: $salePeriodEnd
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetReportReturnCarForServiceGibddByPeriodQuery__
 *
 * To run a query within a React component, call `useGetReportReturnCarForServiceGibddByPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportReturnCarForServiceGibddByPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportReturnCarForServiceGibddByPeriodQuery({
 *   variables: {
 *      groupReport: // value for 'groupReport'
 *      numberTO: // value for 'numberTO'
 *      salePeriodStart: // value for 'salePeriodStart'
 *      salePeriodEnd: // value for 'salePeriodEnd'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetReportReturnCarForServiceGibddByPeriodQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportReturnCarForServiceGibddByPeriodQuery,
    GetReportReturnCarForServiceGibddByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportReturnCarForServiceGibddByPeriodQuery,
    GetReportReturnCarForServiceGibddByPeriodQueryVariables
  >(GetReportReturnCarForServiceGibddByPeriodDocument, options);
}
export function useGetReportReturnCarForServiceGibddByPeriodLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportReturnCarForServiceGibddByPeriodQuery,
    GetReportReturnCarForServiceGibddByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportReturnCarForServiceGibddByPeriodQuery,
    GetReportReturnCarForServiceGibddByPeriodQueryVariables
  >(GetReportReturnCarForServiceGibddByPeriodDocument, options);
}
export type GetReportReturnCarForServiceGibddByPeriodQueryHookResult =
  ReturnType<typeof useGetReportReturnCarForServiceGibddByPeriodQuery>;
export type GetReportReturnCarForServiceGibddByPeriodLazyQueryHookResult =
  ReturnType<typeof useGetReportReturnCarForServiceGibddByPeriodLazyQuery>;
export type GetReportReturnCarForServiceGibddByPeriodQueryResult =
  Apollo.QueryResult<
    GetReportReturnCarForServiceGibddByPeriodQuery,
    GetReportReturnCarForServiceGibddByPeriodQueryVariables
  >;
export const GetCarForServiceGibddByPeriodDocument = gql`
  query GetCarForServiceGIBDDByPeriod(
    $group: typeGroupReportSRR!
    $numberTO: [typeTOReportSRR]
    $salePeriodStart: DateTime!
    $salePeriodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      getCarForServiceGIBDDByPeriod(
        group: $group
        numberTO: $numberTO
        salePeriodStart: $salePeriodStart
        salePeriodEnd: $salePeriodEnd
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        ... on CarForServiceByMonth {
          ...fragmentCarForServiceByMonth
        }
      }
    }
  }
  ${FragmentCarForServiceByMonthFragmentDoc}
`;

/**
 * __useGetCarForServiceGibddByPeriodQuery__
 *
 * To run a query within a React component, call `useGetCarForServiceGibddByPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarForServiceGibddByPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarForServiceGibddByPeriodQuery({
 *   variables: {
 *      group: // value for 'group'
 *      numberTO: // value for 'numberTO'
 *      salePeriodStart: // value for 'salePeriodStart'
 *      salePeriodEnd: // value for 'salePeriodEnd'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetCarForServiceGibddByPeriodQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCarForServiceGibddByPeriodQuery,
    GetCarForServiceGibddByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCarForServiceGibddByPeriodQuery,
    GetCarForServiceGibddByPeriodQueryVariables
  >(GetCarForServiceGibddByPeriodDocument, options);
}
export function useGetCarForServiceGibddByPeriodLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCarForServiceGibddByPeriodQuery,
    GetCarForServiceGibddByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCarForServiceGibddByPeriodQuery,
    GetCarForServiceGibddByPeriodQueryVariables
  >(GetCarForServiceGibddByPeriodDocument, options);
}
export type GetCarForServiceGibddByPeriodQueryHookResult = ReturnType<
  typeof useGetCarForServiceGibddByPeriodQuery
>;
export type GetCarForServiceGibddByPeriodLazyQueryHookResult = ReturnType<
  typeof useGetCarForServiceGibddByPeriodLazyQuery
>;
export type GetCarForServiceGibddByPeriodQueryResult = Apollo.QueryResult<
  GetCarForServiceGibddByPeriodQuery,
  GetCarForServiceGibddByPeriodQueryVariables
>;
export const GetReportReturnCarForeignForServiceGibddByMonthDocument = gql`
  query GetReportReturnCarForeignForServiceGIBDDByMonth(
    $groupReport: typeGroupReportSRR!
    $numberTO: [typeTOReportSRR]
    $salePeriod: Int
    $monthControl: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      reportReturnCarForeignForServiceGIBDDByMonth(
        groupReport: $groupReport
        numberTO: $numberTO
        salePeriod: $salePeriod
        monthControl: $monthControl
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetReportReturnCarForeignForServiceGibddByMonthQuery__
 *
 * To run a query within a React component, call `useGetReportReturnCarForeignForServiceGibddByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportReturnCarForeignForServiceGibddByMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportReturnCarForeignForServiceGibddByMonthQuery({
 *   variables: {
 *      groupReport: // value for 'groupReport'
 *      numberTO: // value for 'numberTO'
 *      salePeriod: // value for 'salePeriod'
 *      monthControl: // value for 'monthControl'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetReportReturnCarForeignForServiceGibddByMonthQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportReturnCarForeignForServiceGibddByMonthQuery,
    GetReportReturnCarForeignForServiceGibddByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportReturnCarForeignForServiceGibddByMonthQuery,
    GetReportReturnCarForeignForServiceGibddByMonthQueryVariables
  >(GetReportReturnCarForeignForServiceGibddByMonthDocument, options);
}
export function useGetReportReturnCarForeignForServiceGibddByMonthLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportReturnCarForeignForServiceGibddByMonthQuery,
    GetReportReturnCarForeignForServiceGibddByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportReturnCarForeignForServiceGibddByMonthQuery,
    GetReportReturnCarForeignForServiceGibddByMonthQueryVariables
  >(GetReportReturnCarForeignForServiceGibddByMonthDocument, options);
}
export type GetReportReturnCarForeignForServiceGibddByMonthQueryHookResult =
  ReturnType<typeof useGetReportReturnCarForeignForServiceGibddByMonthQuery>;
export type GetReportReturnCarForeignForServiceGibddByMonthLazyQueryHookResult =
  ReturnType<
    typeof useGetReportReturnCarForeignForServiceGibddByMonthLazyQuery
  >;
export type GetReportReturnCarForeignForServiceGibddByMonthQueryResult =
  Apollo.QueryResult<
    GetReportReturnCarForeignForServiceGibddByMonthQuery,
    GetReportReturnCarForeignForServiceGibddByMonthQueryVariables
  >;
export const GetCarForeignForServiceGibddByMonthDocument = gql`
  query GetCarForeignForServiceGIBDDByMonth(
    $group: typeGroupReportSRR!
    $numberTO: [typeTOReportSRR]
    $salePeriod: Int
    $monthControl: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      getCarForeignForServiceGIBDDByMonth(
        group: $group
        numberTO: $numberTO
        salePeriod: $salePeriod
        monthControl: $monthControl
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        ... on CarForServiceByMonth {
          ...fragmentCarForServiceByMonth
        }
      }
    }
  }
  ${FragmentCarForServiceByMonthFragmentDoc}
`;

/**
 * __useGetCarForeignForServiceGibddByMonthQuery__
 *
 * To run a query within a React component, call `useGetCarForeignForServiceGibddByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarForeignForServiceGibddByMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarForeignForServiceGibddByMonthQuery({
 *   variables: {
 *      group: // value for 'group'
 *      numberTO: // value for 'numberTO'
 *      salePeriod: // value for 'salePeriod'
 *      monthControl: // value for 'monthControl'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetCarForeignForServiceGibddByMonthQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCarForeignForServiceGibddByMonthQuery,
    GetCarForeignForServiceGibddByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCarForeignForServiceGibddByMonthQuery,
    GetCarForeignForServiceGibddByMonthQueryVariables
  >(GetCarForeignForServiceGibddByMonthDocument, options);
}
export function useGetCarForeignForServiceGibddByMonthLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCarForeignForServiceGibddByMonthQuery,
    GetCarForeignForServiceGibddByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCarForeignForServiceGibddByMonthQuery,
    GetCarForeignForServiceGibddByMonthQueryVariables
  >(GetCarForeignForServiceGibddByMonthDocument, options);
}
export type GetCarForeignForServiceGibddByMonthQueryHookResult = ReturnType<
  typeof useGetCarForeignForServiceGibddByMonthQuery
>;
export type GetCarForeignForServiceGibddByMonthLazyQueryHookResult = ReturnType<
  typeof useGetCarForeignForServiceGibddByMonthLazyQuery
>;
export type GetCarForeignForServiceGibddByMonthQueryResult = Apollo.QueryResult<
  GetCarForeignForServiceGibddByMonthQuery,
  GetCarForeignForServiceGibddByMonthQueryVariables
>;
export const GetReportReturnCarForeignForServiceGibddByPeriodDocument = gql`
  query GetReportReturnCarForeignForServiceGIBDDByPeriod(
    $groupReport: typeGroupReportSRR!
    $numberTO: [typeTOReportSRR]
    $salePeriodStart: DateTime!
    $salePeriodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      reportReturnCarForeignForServiceGIBDDByPeriod(
        groupReport: $groupReport
        numberTO: $numberTO
        salePeriodStart: $salePeriodStart
        salePeriodEnd: $salePeriodEnd
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useGetReportReturnCarForeignForServiceGibddByPeriodQuery__
 *
 * To run a query within a React component, call `useGetReportReturnCarForeignForServiceGibddByPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportReturnCarForeignForServiceGibddByPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportReturnCarForeignForServiceGibddByPeriodQuery({
 *   variables: {
 *      groupReport: // value for 'groupReport'
 *      numberTO: // value for 'numberTO'
 *      salePeriodStart: // value for 'salePeriodStart'
 *      salePeriodEnd: // value for 'salePeriodEnd'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetReportReturnCarForeignForServiceGibddByPeriodQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportReturnCarForeignForServiceGibddByPeriodQuery,
    GetReportReturnCarForeignForServiceGibddByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportReturnCarForeignForServiceGibddByPeriodQuery,
    GetReportReturnCarForeignForServiceGibddByPeriodQueryVariables
  >(GetReportReturnCarForeignForServiceGibddByPeriodDocument, options);
}
export function useGetReportReturnCarForeignForServiceGibddByPeriodLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportReturnCarForeignForServiceGibddByPeriodQuery,
    GetReportReturnCarForeignForServiceGibddByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportReturnCarForeignForServiceGibddByPeriodQuery,
    GetReportReturnCarForeignForServiceGibddByPeriodQueryVariables
  >(GetReportReturnCarForeignForServiceGibddByPeriodDocument, options);
}
export type GetReportReturnCarForeignForServiceGibddByPeriodQueryHookResult =
  ReturnType<typeof useGetReportReturnCarForeignForServiceGibddByPeriodQuery>;
export type GetReportReturnCarForeignForServiceGibddByPeriodLazyQueryHookResult =
  ReturnType<
    typeof useGetReportReturnCarForeignForServiceGibddByPeriodLazyQuery
  >;
export type GetReportReturnCarForeignForServiceGibddByPeriodQueryResult =
  Apollo.QueryResult<
    GetReportReturnCarForeignForServiceGibddByPeriodQuery,
    GetReportReturnCarForeignForServiceGibddByPeriodQueryVariables
  >;
export const GetCarForeignForServiceGibddByPeriodDocument = gql`
  query GetCarForeignForServiceGIBDDByPeriod(
    $group: typeGroupReportSRR!
    $numberTO: [typeTOReportSRR]
    $salePeriodStart: DateTime!
    $salePeriodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      getCarForeignForServiceGIBDDByPeriod(
        group: $group
        numberTO: $numberTO
        salePeriodStart: $salePeriodStart
        salePeriodEnd: $salePeriodEnd
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        ... on CarForServiceByMonth {
          ...fragmentCarForServiceByMonth
        }
      }
    }
  }
  ${FragmentCarForServiceByMonthFragmentDoc}
`;

/**
 * __useGetCarForeignForServiceGibddByPeriodQuery__
 *
 * To run a query within a React component, call `useGetCarForeignForServiceGibddByPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarForeignForServiceGibddByPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarForeignForServiceGibddByPeriodQuery({
 *   variables: {
 *      group: // value for 'group'
 *      numberTO: // value for 'numberTO'
 *      salePeriodStart: // value for 'salePeriodStart'
 *      salePeriodEnd: // value for 'salePeriodEnd'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetCarForeignForServiceGibddByPeriodQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCarForeignForServiceGibddByPeriodQuery,
    GetCarForeignForServiceGibddByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCarForeignForServiceGibddByPeriodQuery,
    GetCarForeignForServiceGibddByPeriodQueryVariables
  >(GetCarForeignForServiceGibddByPeriodDocument, options);
}
export function useGetCarForeignForServiceGibddByPeriodLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCarForeignForServiceGibddByPeriodQuery,
    GetCarForeignForServiceGibddByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCarForeignForServiceGibddByPeriodQuery,
    GetCarForeignForServiceGibddByPeriodQueryVariables
  >(GetCarForeignForServiceGibddByPeriodDocument, options);
}
export type GetCarForeignForServiceGibddByPeriodQueryHookResult = ReturnType<
  typeof useGetCarForeignForServiceGibddByPeriodQuery
>;
export type GetCarForeignForServiceGibddByPeriodLazyQueryHookResult =
  ReturnType<typeof useGetCarForeignForServiceGibddByPeriodLazyQuery>;
export type GetCarForeignForServiceGibddByPeriodQueryResult =
  Apollo.QueryResult<
    GetCarForeignForServiceGibddByPeriodQuery,
    GetCarForeignForServiceGibddByPeriodQueryVariables
  >;
export const ReportReturnSrr3GibddByDealerDocument = gql`
  query ReportReturnSRR3GIBDDByDealer(
    $monthControl: DateTime!
    $typeClient: [typeClientReportSRR]
  ) {
    SRRGetter {
      reportReturnSRR3GIBDDByDealer(
        monthControl: $monthControl
        typeClient: $typeClient
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useReportReturnSrr3GibddByDealerQuery__
 *
 * To run a query within a React component, call `useReportReturnSrr3GibddByDealerQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportReturnSrr3GibddByDealerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportReturnSrr3GibddByDealerQuery({
 *   variables: {
 *      monthControl: // value for 'monthControl'
 *      typeClient: // value for 'typeClient'
 *   },
 * });
 */
export function useReportReturnSrr3GibddByDealerQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReportReturnSrr3GibddByDealerQuery,
    ReportReturnSrr3GibddByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ReportReturnSrr3GibddByDealerQuery,
    ReportReturnSrr3GibddByDealerQueryVariables
  >(ReportReturnSrr3GibddByDealerDocument, options);
}
export function useReportReturnSrr3GibddByDealerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReportReturnSrr3GibddByDealerQuery,
    ReportReturnSrr3GibddByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ReportReturnSrr3GibddByDealerQuery,
    ReportReturnSrr3GibddByDealerQueryVariables
  >(ReportReturnSrr3GibddByDealerDocument, options);
}
export type ReportReturnSrr3GibddByDealerQueryHookResult = ReturnType<
  typeof useReportReturnSrr3GibddByDealerQuery
>;
export type ReportReturnSrr3GibddByDealerLazyQueryHookResult = ReturnType<
  typeof useReportReturnSrr3GibddByDealerLazyQuery
>;
export type ReportReturnSrr3GibddByDealerQueryResult = Apollo.QueryResult<
  ReportReturnSrr3GibddByDealerQuery,
  ReportReturnSrr3GibddByDealerQueryVariables
>;
export const GetSrr3GibddByDealerDocument = gql`
  query GetSRR3GIBDDByDealer(
    $monthControl: DateTime!
    $typeClient: [typeClientReportSRR]
  ) {
    SRRGetter {
      getSRR3GIBDDByDealer(
        monthControl: $monthControl
        typeClient: $typeClient
      ) {
        ... on dealerForServiceByMonth {
          ...fragmentdealerForServiceByMonth
        }
      }
    }
  }
  ${FragmentdealerForServiceByMonthFragmentDoc}
`;

/**
 * __useGetSrr3GibddByDealerQuery__
 *
 * To run a query within a React component, call `useGetSrr3GibddByDealerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSrr3GibddByDealerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSrr3GibddByDealerQuery({
 *   variables: {
 *      monthControl: // value for 'monthControl'
 *      typeClient: // value for 'typeClient'
 *   },
 * });
 */
export function useGetSrr3GibddByDealerQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSrr3GibddByDealerQuery,
    GetSrr3GibddByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSrr3GibddByDealerQuery,
    GetSrr3GibddByDealerQueryVariables
  >(GetSrr3GibddByDealerDocument, options);
}
export function useGetSrr3GibddByDealerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSrr3GibddByDealerQuery,
    GetSrr3GibddByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSrr3GibddByDealerQuery,
    GetSrr3GibddByDealerQueryVariables
  >(GetSrr3GibddByDealerDocument, options);
}
export type GetSrr3GibddByDealerQueryHookResult = ReturnType<
  typeof useGetSrr3GibddByDealerQuery
>;
export type GetSrr3GibddByDealerLazyQueryHookResult = ReturnType<
  typeof useGetSrr3GibddByDealerLazyQuery
>;
export type GetSrr3GibddByDealerQueryResult = Apollo.QueryResult<
  GetSrr3GibddByDealerQuery,
  GetSrr3GibddByDealerQueryVariables
>;
export const ReportReturnSrr3GibddByPeriodDocument = gql`
  query ReportReturnSRR3GIBDDByPeriod(
    $group: typeGroupReportSRR!
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      reportReturnSRR3GIBDDByPeriod(
        group: $group
        periodStart: $periodStart
        periodEnd: $periodEnd
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useReportReturnSrr3GibddByPeriodQuery__
 *
 * To run a query within a React component, call `useReportReturnSrr3GibddByPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportReturnSrr3GibddByPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportReturnSrr3GibddByPeriodQuery({
 *   variables: {
 *      group: // value for 'group'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useReportReturnSrr3GibddByPeriodQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReportReturnSrr3GibddByPeriodQuery,
    ReportReturnSrr3GibddByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ReportReturnSrr3GibddByPeriodQuery,
    ReportReturnSrr3GibddByPeriodQueryVariables
  >(ReportReturnSrr3GibddByPeriodDocument, options);
}
export function useReportReturnSrr3GibddByPeriodLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReportReturnSrr3GibddByPeriodQuery,
    ReportReturnSrr3GibddByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ReportReturnSrr3GibddByPeriodQuery,
    ReportReturnSrr3GibddByPeriodQueryVariables
  >(ReportReturnSrr3GibddByPeriodDocument, options);
}
export type ReportReturnSrr3GibddByPeriodQueryHookResult = ReturnType<
  typeof useReportReturnSrr3GibddByPeriodQuery
>;
export type ReportReturnSrr3GibddByPeriodLazyQueryHookResult = ReturnType<
  typeof useReportReturnSrr3GibddByPeriodLazyQuery
>;
export type ReportReturnSrr3GibddByPeriodQueryResult = Apollo.QueryResult<
  ReportReturnSrr3GibddByPeriodQuery,
  ReportReturnSrr3GibddByPeriodQueryVariables
>;
export const GetSrr3GibddByPeriodDocument = gql`
  query GetSRR3GIBDDByPeriod(
    $group: typeGroupReportSRR!
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      getSRR3GIBDDByPeriod(
        group: $group
        periodStart: $periodStart
        periodEnd: $periodEnd
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        ... on CarForSRR3GIBDDByPeriod {
          ...fragmentCarForSRR3GIBDDByPeriod
        }
      }
    }
  }
  ${FragmentCarForSrr3GibddByPeriodFragmentDoc}
`;

/**
 * __useGetSrr3GibddByPeriodQuery__
 *
 * To run a query within a React component, call `useGetSrr3GibddByPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSrr3GibddByPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSrr3GibddByPeriodQuery({
 *   variables: {
 *      group: // value for 'group'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetSrr3GibddByPeriodQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSrr3GibddByPeriodQuery,
    GetSrr3GibddByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSrr3GibddByPeriodQuery,
    GetSrr3GibddByPeriodQueryVariables
  >(GetSrr3GibddByPeriodDocument, options);
}
export function useGetSrr3GibddByPeriodLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSrr3GibddByPeriodQuery,
    GetSrr3GibddByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSrr3GibddByPeriodQuery,
    GetSrr3GibddByPeriodQueryVariables
  >(GetSrr3GibddByPeriodDocument, options);
}
export type GetSrr3GibddByPeriodQueryHookResult = ReturnType<
  typeof useGetSrr3GibddByPeriodQuery
>;
export type GetSrr3GibddByPeriodLazyQueryHookResult = ReturnType<
  typeof useGetSrr3GibddByPeriodLazyQuery
>;
export type GetSrr3GibddByPeriodQueryResult = Apollo.QueryResult<
  GetSrr3GibddByPeriodQuery,
  GetSrr3GibddByPeriodQueryVariables
>;
export const ReportReturnSrr5GibddByDealerDocument = gql`
  query ReportReturnSRR5GIBDDByDealer(
    $monthControl: DateTime!
    $typeClient: [typeClientReportSRR]
  ) {
    SRRGetter {
      reportReturnSRR5GIBDDByDealer(
        monthControl: $monthControl
        typeClient: $typeClient
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useReportReturnSrr5GibddByDealerQuery__
 *
 * To run a query within a React component, call `useReportReturnSrr5GibddByDealerQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportReturnSrr5GibddByDealerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportReturnSrr5GibddByDealerQuery({
 *   variables: {
 *      monthControl: // value for 'monthControl'
 *      typeClient: // value for 'typeClient'
 *   },
 * });
 */
export function useReportReturnSrr5GibddByDealerQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReportReturnSrr5GibddByDealerQuery,
    ReportReturnSrr5GibddByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ReportReturnSrr5GibddByDealerQuery,
    ReportReturnSrr5GibddByDealerQueryVariables
  >(ReportReturnSrr5GibddByDealerDocument, options);
}
export function useReportReturnSrr5GibddByDealerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReportReturnSrr5GibddByDealerQuery,
    ReportReturnSrr5GibddByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ReportReturnSrr5GibddByDealerQuery,
    ReportReturnSrr5GibddByDealerQueryVariables
  >(ReportReturnSrr5GibddByDealerDocument, options);
}
export type ReportReturnSrr5GibddByDealerQueryHookResult = ReturnType<
  typeof useReportReturnSrr5GibddByDealerQuery
>;
export type ReportReturnSrr5GibddByDealerLazyQueryHookResult = ReturnType<
  typeof useReportReturnSrr5GibddByDealerLazyQuery
>;
export type ReportReturnSrr5GibddByDealerQueryResult = Apollo.QueryResult<
  ReportReturnSrr5GibddByDealerQuery,
  ReportReturnSrr5GibddByDealerQueryVariables
>;
export const GetSrr5GibddByDealerDocument = gql`
  query GetSRR5GIBDDByDealer(
    $monthControl: DateTime!
    $typeClient: [typeClientReportSRR]
  ) {
    SRRGetter {
      getSRR5GIBDDByDealer(
        monthControl: $monthControl
        typeClient: $typeClient
      ) {
        ... on dealerForServiceByMonth {
          ...fragmentdealerForServiceByMonth
        }
      }
    }
  }
  ${FragmentdealerForServiceByMonthFragmentDoc}
`;

/**
 * __useGetSrr5GibddByDealerQuery__
 *
 * To run a query within a React component, call `useGetSrr5GibddByDealerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSrr5GibddByDealerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSrr5GibddByDealerQuery({
 *   variables: {
 *      monthControl: // value for 'monthControl'
 *      typeClient: // value for 'typeClient'
 *   },
 * });
 */
export function useGetSrr5GibddByDealerQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSrr5GibddByDealerQuery,
    GetSrr5GibddByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSrr5GibddByDealerQuery,
    GetSrr5GibddByDealerQueryVariables
  >(GetSrr5GibddByDealerDocument, options);
}
export function useGetSrr5GibddByDealerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSrr5GibddByDealerQuery,
    GetSrr5GibddByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSrr5GibddByDealerQuery,
    GetSrr5GibddByDealerQueryVariables
  >(GetSrr5GibddByDealerDocument, options);
}
export type GetSrr5GibddByDealerQueryHookResult = ReturnType<
  typeof useGetSrr5GibddByDealerQuery
>;
export type GetSrr5GibddByDealerLazyQueryHookResult = ReturnType<
  typeof useGetSrr5GibddByDealerLazyQuery
>;
export type GetSrr5GibddByDealerQueryResult = Apollo.QueryResult<
  GetSrr5GibddByDealerQuery,
  GetSrr5GibddByDealerQueryVariables
>;
export const ReportReturnSrr5GibddByPeriodDocument = gql`
  query ReportReturnSRR5GIBDDByPeriod(
    $group: typeGroupReportSRR!
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      reportReturnSRR5GIBDDByPeriod(
        group: $group
        periodStart: $periodStart
        periodEnd: $periodEnd
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useReportReturnSrr5GibddByPeriodQuery__
 *
 * To run a query within a React component, call `useReportReturnSrr5GibddByPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportReturnSrr5GibddByPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportReturnSrr5GibddByPeriodQuery({
 *   variables: {
 *      group: // value for 'group'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useReportReturnSrr5GibddByPeriodQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReportReturnSrr5GibddByPeriodQuery,
    ReportReturnSrr5GibddByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ReportReturnSrr5GibddByPeriodQuery,
    ReportReturnSrr5GibddByPeriodQueryVariables
  >(ReportReturnSrr5GibddByPeriodDocument, options);
}
export function useReportReturnSrr5GibddByPeriodLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReportReturnSrr5GibddByPeriodQuery,
    ReportReturnSrr5GibddByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ReportReturnSrr5GibddByPeriodQuery,
    ReportReturnSrr5GibddByPeriodQueryVariables
  >(ReportReturnSrr5GibddByPeriodDocument, options);
}
export type ReportReturnSrr5GibddByPeriodQueryHookResult = ReturnType<
  typeof useReportReturnSrr5GibddByPeriodQuery
>;
export type ReportReturnSrr5GibddByPeriodLazyQueryHookResult = ReturnType<
  typeof useReportReturnSrr5GibddByPeriodLazyQuery
>;
export type ReportReturnSrr5GibddByPeriodQueryResult = Apollo.QueryResult<
  ReportReturnSrr5GibddByPeriodQuery,
  ReportReturnSrr5GibddByPeriodQueryVariables
>;
export const GetSrr5GibddByPeriodDocument = gql`
  query GetSRR5GIBDDByPeriod(
    $group: typeGroupReportSRR!
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $typeClient: [typeClientReportSRR]
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
  ) {
    SRRGetter {
      getSRR5GIBDDByPeriod(
        group: $group
        periodStart: $periodStart
        periodEnd: $periodEnd
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        ... on CarForSRR5GIBDDByPeriod {
          ...fragmentCarForSRR5GIBDDByPeriod
        }
      }
    }
  }
  ${FragmentCarForSrr5GibddByPeriodFragmentDoc}
`;

/**
 * __useGetSrr5GibddByPeriodQuery__
 *
 * To run a query within a React component, call `useGetSrr5GibddByPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSrr5GibddByPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSrr5GibddByPeriodQuery({
 *   variables: {
 *      group: // value for 'group'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      typeClient: // value for 'typeClient'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *   },
 * });
 */
export function useGetSrr5GibddByPeriodQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSrr5GibddByPeriodQuery,
    GetSrr5GibddByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSrr5GibddByPeriodQuery,
    GetSrr5GibddByPeriodQueryVariables
  >(GetSrr5GibddByPeriodDocument, options);
}
export function useGetSrr5GibddByPeriodLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSrr5GibddByPeriodQuery,
    GetSrr5GibddByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSrr5GibddByPeriodQuery,
    GetSrr5GibddByPeriodQueryVariables
  >(GetSrr5GibddByPeriodDocument, options);
}
export type GetSrr5GibddByPeriodQueryHookResult = ReturnType<
  typeof useGetSrr5GibddByPeriodQuery
>;
export type GetSrr5GibddByPeriodLazyQueryHookResult = ReturnType<
  typeof useGetSrr5GibddByPeriodLazyQuery
>;
export type GetSrr5GibddByPeriodQueryResult = Apollo.QueryResult<
  GetSrr5GibddByPeriodQuery,
  GetSrr5GibddByPeriodQueryVariables
>;
export const GetUniqueServiceDocument = gql`
  query GetUniqueService(
    $group: typeGroupReportSRR!
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
    $kindReport: typeKindReport!
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $familyCar: [ID]
    $kinds: [KindRepair]
    $typeClient: [typeClientReportSRR]
  ) {
    SRRGetter {
      getUniqueService(
        group: $group
        periodStart: $periodStart
        periodEnd: $periodEnd
        kindReport: $kindReport
        familyCar: $familyCar
        kinds: $kinds
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        ... on uniqueService {
          ...fragmentUniqueService
        }
      }
    }
  }
  ${FragmentUniqueServiceFragmentDoc}
`;

/**
 * __useGetUniqueServiceQuery__
 *
 * To run a query within a React component, call `useGetUniqueServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniqueServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniqueServiceQuery({
 *   variables: {
 *      group: // value for 'group'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *      kindReport: // value for 'kindReport'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      familyCar: // value for 'familyCar'
 *      kinds: // value for 'kinds'
 *      typeClient: // value for 'typeClient'
 *   },
 * });
 */
export function useGetUniqueServiceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUniqueServiceQuery,
    GetUniqueServiceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUniqueServiceQuery, GetUniqueServiceQueryVariables>(
    GetUniqueServiceDocument,
    options,
  );
}
export function useGetUniqueServiceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUniqueServiceQuery,
    GetUniqueServiceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUniqueServiceQuery,
    GetUniqueServiceQueryVariables
  >(GetUniqueServiceDocument, options);
}
export type GetUniqueServiceQueryHookResult = ReturnType<
  typeof useGetUniqueServiceQuery
>;
export type GetUniqueServiceLazyQueryHookResult = ReturnType<
  typeof useGetUniqueServiceLazyQuery
>;
export type GetUniqueServiceQueryResult = Apollo.QueryResult<
  GetUniqueServiceQuery,
  GetUniqueServiceQueryVariables
>;
export const GetLoyaltyServiceDocument = gql`
  query GetLoyaltyService(
    $group: typeGroupReportSRR!
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
    $kindReport: typeKindReport!
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $familyCar: [ID]
    $kinds: [KindRepair]
    $typeClient: [typeClientReportSRR]
  ) {
    SRRGetter {
      getLoyaltyService(
        group: $group
        periodStart: $periodStart
        periodEnd: $periodEnd
        kindReport: $kindReport
        familyCar: $familyCar
        kinds: $kinds
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        ... on loyaltyService {
          ...fragmentLoyaltyService
        }
      }
    }
  }
  ${FragmentLoyaltyServiceFragmentDoc}
`;

/**
 * __useGetLoyaltyServiceQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyServiceQuery({
 *   variables: {
 *      group: // value for 'group'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *      kindReport: // value for 'kindReport'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      familyCar: // value for 'familyCar'
 *      kinds: // value for 'kinds'
 *      typeClient: // value for 'typeClient'
 *   },
 * });
 */
export function useGetLoyaltyServiceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLoyaltyServiceQuery,
    GetLoyaltyServiceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetLoyaltyServiceQuery,
    GetLoyaltyServiceQueryVariables
  >(GetLoyaltyServiceDocument, options);
}
export function useGetLoyaltyServiceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLoyaltyServiceQuery,
    GetLoyaltyServiceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLoyaltyServiceQuery,
    GetLoyaltyServiceQueryVariables
  >(GetLoyaltyServiceDocument, options);
}
export type GetLoyaltyServiceQueryHookResult = ReturnType<
  typeof useGetLoyaltyServiceQuery
>;
export type GetLoyaltyServiceLazyQueryHookResult = ReturnType<
  typeof useGetLoyaltyServiceLazyQuery
>;
export type GetLoyaltyServiceQueryResult = Apollo.QueryResult<
  GetLoyaltyServiceQuery,
  GetLoyaltyServiceQueryVariables
>;
export const GetLoyaltyServiceByDealerDocument = gql`
  query GetLoyaltyServiceByDealer(
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $familyCar: [ID]
    $kinds: [KindRepair]
  ) {
    SRRGetter {
      getLoyaltyServiceByDealer(
        periodStart: $periodStart
        periodEnd: $periodEnd
        familyCar: $familyCar
        kinds: $kinds
      ) {
        dealer {
          ... on Dealer {
            ...fragmentDealerForReportReturnLoyaltyServiceByDealer
          }
        }
        periods {
          ... on loyaltyServicePeriod {
            ...fragmentLoyaltyServicePeriod
          }
        }
      }
    }
  }
  ${FragmentDealerForReportReturnLoyaltyServiceByDealerFragmentDoc}
  ${FragmentLoyaltyServicePeriodFragmentDoc}
`;

/**
 * __useGetLoyaltyServiceByDealerQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyServiceByDealerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyServiceByDealerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyServiceByDealerQuery({
 *   variables: {
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      familyCar: // value for 'familyCar'
 *      kinds: // value for 'kinds'
 *   },
 * });
 */
export function useGetLoyaltyServiceByDealerQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLoyaltyServiceByDealerQuery,
    GetLoyaltyServiceByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetLoyaltyServiceByDealerQuery,
    GetLoyaltyServiceByDealerQueryVariables
  >(GetLoyaltyServiceByDealerDocument, options);
}
export function useGetLoyaltyServiceByDealerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLoyaltyServiceByDealerQuery,
    GetLoyaltyServiceByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLoyaltyServiceByDealerQuery,
    GetLoyaltyServiceByDealerQueryVariables
  >(GetLoyaltyServiceByDealerDocument, options);
}
export type GetLoyaltyServiceByDealerQueryHookResult = ReturnType<
  typeof useGetLoyaltyServiceByDealerQuery
>;
export type GetLoyaltyServiceByDealerLazyQueryHookResult = ReturnType<
  typeof useGetLoyaltyServiceByDealerLazyQuery
>;
export type GetLoyaltyServiceByDealerQueryResult = Apollo.QueryResult<
  GetLoyaltyServiceByDealerQuery,
  GetLoyaltyServiceByDealerQueryVariables
>;
export const ReportReturnUniqueServiceDocument = gql`
  query ReportReturnUniqueService(
    $group: typeGroupReportSRR!
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
    $kindReport: typeKindReport!
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $familyCar: [ID]
    $kinds: [KindRepair]
    $typeClient: [typeClientReportSRR]
  ) {
    SRRGetter {
      reportReturnUniqueService(
        group: $group
        periodStart: $periodStart
        periodEnd: $periodEnd
        kindReport: $kindReport
        familyCar: $familyCar
        kinds: $kinds
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useReportReturnUniqueServiceQuery__
 *
 * To run a query within a React component, call `useReportReturnUniqueServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportReturnUniqueServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportReturnUniqueServiceQuery({
 *   variables: {
 *      group: // value for 'group'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *      kindReport: // value for 'kindReport'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      familyCar: // value for 'familyCar'
 *      kinds: // value for 'kinds'
 *      typeClient: // value for 'typeClient'
 *   },
 * });
 */
export function useReportReturnUniqueServiceQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReportReturnUniqueServiceQuery,
    ReportReturnUniqueServiceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ReportReturnUniqueServiceQuery,
    ReportReturnUniqueServiceQueryVariables
  >(ReportReturnUniqueServiceDocument, options);
}
export function useReportReturnUniqueServiceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReportReturnUniqueServiceQuery,
    ReportReturnUniqueServiceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ReportReturnUniqueServiceQuery,
    ReportReturnUniqueServiceQueryVariables
  >(ReportReturnUniqueServiceDocument, options);
}
export type ReportReturnUniqueServiceQueryHookResult = ReturnType<
  typeof useReportReturnUniqueServiceQuery
>;
export type ReportReturnUniqueServiceLazyQueryHookResult = ReturnType<
  typeof useReportReturnUniqueServiceLazyQuery
>;
export type ReportReturnUniqueServiceQueryResult = Apollo.QueryResult<
  ReportReturnUniqueServiceQuery,
  ReportReturnUniqueServiceQueryVariables
>;
export const ReportReturnLoyaltyServiceDocument = gql`
  query ReportReturnLoyaltyService(
    $group: typeGroupReportSRR!
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
    $kindReport: typeKindReport!
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $familyCar: [ID]
    $kinds: [KindRepair]
    $typeClient: [typeClientReportSRR]
  ) {
    SRRGetter {
      reportReturnLoyaltyService(
        group: $group
        periodStart: $periodStart
        periodEnd: $periodEnd
        kindReport: $kindReport
        familyCar: $familyCar
        kinds: $kinds
        typeClient: $typeClient
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useReportReturnLoyaltyServiceQuery__
 *
 * To run a query within a React component, call `useReportReturnLoyaltyServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportReturnLoyaltyServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportReturnLoyaltyServiceQuery({
 *   variables: {
 *      group: // value for 'group'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *      kindReport: // value for 'kindReport'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      familyCar: // value for 'familyCar'
 *      kinds: // value for 'kinds'
 *      typeClient: // value for 'typeClient'
 *   },
 * });
 */
export function useReportReturnLoyaltyServiceQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReportReturnLoyaltyServiceQuery,
    ReportReturnLoyaltyServiceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ReportReturnLoyaltyServiceQuery,
    ReportReturnLoyaltyServiceQueryVariables
  >(ReportReturnLoyaltyServiceDocument, options);
}
export function useReportReturnLoyaltyServiceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReportReturnLoyaltyServiceQuery,
    ReportReturnLoyaltyServiceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ReportReturnLoyaltyServiceQuery,
    ReportReturnLoyaltyServiceQueryVariables
  >(ReportReturnLoyaltyServiceDocument, options);
}
export type ReportReturnLoyaltyServiceQueryHookResult = ReturnType<
  typeof useReportReturnLoyaltyServiceQuery
>;
export type ReportReturnLoyaltyServiceLazyQueryHookResult = ReturnType<
  typeof useReportReturnLoyaltyServiceLazyQuery
>;
export type ReportReturnLoyaltyServiceQueryResult = Apollo.QueryResult<
  ReportReturnLoyaltyServiceQuery,
  ReportReturnLoyaltyServiceQueryVariables
>;
export const ReportReturnLoyaltyServiceByDealerDocument = gql`
  query ReportReturnLoyaltyServiceByDealer(
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $familyCar: [ID]
    $kinds: [KindRepair]
  ) {
    SRRGetter {
      reportReturnLoyaltyServiceByDealer(
        periodStart: $periodStart
        periodEnd: $periodEnd
        familyCar: $familyCar
        kinds: $kinds
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useReportReturnLoyaltyServiceByDealerQuery__
 *
 * To run a query within a React component, call `useReportReturnLoyaltyServiceByDealerQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportReturnLoyaltyServiceByDealerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportReturnLoyaltyServiceByDealerQuery({
 *   variables: {
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      familyCar: // value for 'familyCar'
 *      kinds: // value for 'kinds'
 *   },
 * });
 */
export function useReportReturnLoyaltyServiceByDealerQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReportReturnLoyaltyServiceByDealerQuery,
    ReportReturnLoyaltyServiceByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ReportReturnLoyaltyServiceByDealerQuery,
    ReportReturnLoyaltyServiceByDealerQueryVariables
  >(ReportReturnLoyaltyServiceByDealerDocument, options);
}
export function useReportReturnLoyaltyServiceByDealerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReportReturnLoyaltyServiceByDealerQuery,
    ReportReturnLoyaltyServiceByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ReportReturnLoyaltyServiceByDealerQuery,
    ReportReturnLoyaltyServiceByDealerQueryVariables
  >(ReportReturnLoyaltyServiceByDealerDocument, options);
}
export type ReportReturnLoyaltyServiceByDealerQueryHookResult = ReturnType<
  typeof useReportReturnLoyaltyServiceByDealerQuery
>;
export type ReportReturnLoyaltyServiceByDealerLazyQueryHookResult = ReturnType<
  typeof useReportReturnLoyaltyServiceByDealerLazyQuery
>;
export type ReportReturnLoyaltyServiceByDealerQueryResult = Apollo.QueryResult<
  ReportReturnLoyaltyServiceByDealerQuery,
  ReportReturnLoyaltyServiceByDealerQueryVariables
>;
export const ReportNsByDealerDocument = gql`
  query ReportNSByDealer(
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $group: typeGroupReportSRR!
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
    $NOP: String
    $RMP: String
    $familyCar: [ID]
    $loyaltyType: LoyaltyType = our
    $bonus: Int
    $monthControl: Int
  ) {
    SRRGetter {
      reportNSByDealer(
        periodStart: $periodStart
        periodEnd: $periodEnd
        familyCar: $familyCar
        group: $group
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
        NOP: $NOP
        RMP: $RMP
        loyaltyType: $loyaltyType
        bonus: $bonus
        monthControl: $monthControl
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useReportNsByDealerQuery__
 *
 * To run a query within a React component, call `useReportNsByDealerQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportNsByDealerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportNsByDealerQuery({
 *   variables: {
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      group: // value for 'group'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *      NOP: // value for 'NOP'
 *      RMP: // value for 'RMP'
 *      familyCar: // value for 'familyCar'
 *      loyaltyType: // value for 'loyaltyType'
 *      bonus: // value for 'bonus'
 *      monthControl: // value for 'monthControl'
 *   },
 * });
 */
export function useReportNsByDealerQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReportNsByDealerQuery,
    ReportNsByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReportNsByDealerQuery, ReportNsByDealerQueryVariables>(
    ReportNsByDealerDocument,
    options,
  );
}
export function useReportNsByDealerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReportNsByDealerQuery,
    ReportNsByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ReportNsByDealerQuery,
    ReportNsByDealerQueryVariables
  >(ReportNsByDealerDocument, options);
}
export type ReportNsByDealerQueryHookResult = ReturnType<
  typeof useReportNsByDealerQuery
>;
export type ReportNsByDealerLazyQueryHookResult = ReturnType<
  typeof useReportNsByDealerLazyQuery
>;
export type ReportNsByDealerQueryResult = Apollo.QueryResult<
  ReportNsByDealerQuery,
  ReportNsByDealerQueryVariables
>;
export const GetNsByDealerDocument = gql`
  query GetNSByDealer(
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $group: typeGroupReportSRR!
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
    $NOP: String
    $RMP: String
    $familyCar: [ID]
    $loyaltyType: LoyaltyType = our
    $bonus: Int
    $monthControl: Int
  ) {
    SRRGetter {
      getNSByDealer(
        periodStart: $periodStart
        periodEnd: $periodEnd
        familyCar: $familyCar
        group: $group
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
        NOP: $NOP
        RMP: $RMP
        loyaltyType: $loyaltyType
        bonus: $bonus
        monthControl: $monthControl
      ) {
        dealer {
          ... on Dealer {
            ...fragmentDealer
          }
        }
        FO
        City
        Region
        Country
        NOP
        RMP
        bonusCarCount
        bonusCarMoney
        coefficientAward
        periodsData {
          ... on NSDealerDataPeriodsData {
            ...fragmentNSDealerDataPeriodsData
          }
        }
      }
    }
  }
  ${FragmentDealerFragmentDoc}
  ${FragmentNsDealerDataPeriodsDataFragmentDoc}
`;

/**
 * __useGetNsByDealerQuery__
 *
 * To run a query within a React component, call `useGetNsByDealerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNsByDealerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNsByDealerQuery({
 *   variables: {
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      group: // value for 'group'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *      NOP: // value for 'NOP'
 *      RMP: // value for 'RMP'
 *      familyCar: // value for 'familyCar'
 *      loyaltyType: // value for 'loyaltyType'
 *      bonus: // value for 'bonus'
 *      monthControl: // value for 'monthControl'
 *   },
 * });
 */
export function useGetNsByDealerQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetNsByDealerQuery,
    GetNsByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetNsByDealerQuery, GetNsByDealerQueryVariables>(
    GetNsByDealerDocument,
    options,
  );
}
export function useGetNsByDealerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNsByDealerQuery,
    GetNsByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetNsByDealerQuery, GetNsByDealerQueryVariables>(
    GetNsByDealerDocument,
    options,
  );
}
export type GetNsByDealerQueryHookResult = ReturnType<
  typeof useGetNsByDealerQuery
>;
export type GetNsByDealerLazyQueryHookResult = ReturnType<
  typeof useGetNsByDealerLazyQuery
>;
export type GetNsByDealerQueryResult = Apollo.QueryResult<
  GetNsByDealerQuery,
  GetNsByDealerQueryVariables
>;
export const ReportNsByConsultantDocument = gql`
  query ReportNSByConsultant(
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
    $NOP: String
    $RMP: String
    $familyCar: [ID]
    $loyaltyType: LoyaltyType = our
  ) {
    SRRGetter {
      reportNSByConsultant(
        periodStart: $periodStart
        periodEnd: $periodEnd
        familyCar: $familyCar
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
        NOP: $NOP
        RMP: $RMP
        loyaltyType: $loyaltyType
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useReportNsByConsultantQuery__
 *
 * To run a query within a React component, call `useReportNsByConsultantQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportNsByConsultantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportNsByConsultantQuery({
 *   variables: {
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *      NOP: // value for 'NOP'
 *      RMP: // value for 'RMP'
 *      familyCar: // value for 'familyCar'
 *      loyaltyType: // value for 'loyaltyType'
 *   },
 * });
 */
export function useReportNsByConsultantQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReportNsByConsultantQuery,
    ReportNsByConsultantQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ReportNsByConsultantQuery,
    ReportNsByConsultantQueryVariables
  >(ReportNsByConsultantDocument, options);
}
export function useReportNsByConsultantLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReportNsByConsultantQuery,
    ReportNsByConsultantQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ReportNsByConsultantQuery,
    ReportNsByConsultantQueryVariables
  >(ReportNsByConsultantDocument, options);
}
export type ReportNsByConsultantQueryHookResult = ReturnType<
  typeof useReportNsByConsultantQuery
>;
export type ReportNsByConsultantLazyQueryHookResult = ReturnType<
  typeof useReportNsByConsultantLazyQuery
>;
export type ReportNsByConsultantQueryResult = Apollo.QueryResult<
  ReportNsByConsultantQuery,
  ReportNsByConsultantQueryVariables
>;
export const GetNsByConsultantDocument = gql`
  query GetNSByConsultant(
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
    $NOP: String
    $RMP: String
    $familyCar: [ID]
    $loyaltyType: LoyaltyType = our
  ) {
    SRRGetter {
      getNSByConsultant(
        periodStart: $periodStart
        periodEnd: $periodEnd
        familyCar: $familyCar
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
        NOP: $NOP
        RMP: $RMP
        loyaltyType: $loyaltyType
      ) {
        dealer {
          ... on Dealer {
            ...fragmentDealer
          }
        }
        consultant
        periodsData {
          ... on NSDealerDataPeriodsData {
            ...fragmentNSDealerDataPeriodsData
          }
        }
      }
    }
  }
  ${FragmentDealerFragmentDoc}
  ${FragmentNsDealerDataPeriodsDataFragmentDoc}
`;

/**
 * __useGetNsByConsultantQuery__
 *
 * To run a query within a React component, call `useGetNsByConsultantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNsByConsultantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNsByConsultantQuery({
 *   variables: {
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *      NOP: // value for 'NOP'
 *      RMP: // value for 'RMP'
 *      familyCar: // value for 'familyCar'
 *      loyaltyType: // value for 'loyaltyType'
 *   },
 * });
 */
export function useGetNsByConsultantQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetNsByConsultantQuery,
    GetNsByConsultantQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetNsByConsultantQuery,
    GetNsByConsultantQueryVariables
  >(GetNsByConsultantDocument, options);
}
export function useGetNsByConsultantLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNsByConsultantQuery,
    GetNsByConsultantQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetNsByConsultantQuery,
    GetNsByConsultantQueryVariables
  >(GetNsByConsultantDocument, options);
}
export type GetNsByConsultantQueryHookResult = ReturnType<
  typeof useGetNsByConsultantQuery
>;
export type GetNsByConsultantLazyQueryHookResult = ReturnType<
  typeof useGetNsByConsultantLazyQuery
>;
export type GetNsByConsultantQueryResult = Apollo.QueryResult<
  GetNsByConsultantQuery,
  GetNsByConsultantQueryVariables
>;
export const ReportNsByClientDocument = gql`
  query ReportNSByClient(
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
    $NOP: String
    $RMP: String
    $familyCar: [ID]
    $loyaltyType: LoyaltyType = our
  ) {
    SRRGetter {
      reportNSByClient(
        periodStart: $periodStart
        periodEnd: $periodEnd
        familyCar: $familyCar
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
        NOP: $NOP
        RMP: $RMP
        loyaltyType: $loyaltyType
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useReportNsByClientQuery__
 *
 * To run a query within a React component, call `useReportNsByClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportNsByClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportNsByClientQuery({
 *   variables: {
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *      NOP: // value for 'NOP'
 *      RMP: // value for 'RMP'
 *      familyCar: // value for 'familyCar'
 *      loyaltyType: // value for 'loyaltyType'
 *   },
 * });
 */
export function useReportNsByClientQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReportNsByClientQuery,
    ReportNsByClientQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReportNsByClientQuery, ReportNsByClientQueryVariables>(
    ReportNsByClientDocument,
    options,
  );
}
export function useReportNsByClientLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReportNsByClientQuery,
    ReportNsByClientQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ReportNsByClientQuery,
    ReportNsByClientQueryVariables
  >(ReportNsByClientDocument, options);
}
export type ReportNsByClientQueryHookResult = ReturnType<
  typeof useReportNsByClientQuery
>;
export type ReportNsByClientLazyQueryHookResult = ReturnType<
  typeof useReportNsByClientLazyQuery
>;
export type ReportNsByClientQueryResult = Apollo.QueryResult<
  ReportNsByClientQuery,
  ReportNsByClientQueryVariables
>;
export const GetNsByClientDocument = gql`
  query GetNSByClient(
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
    $NOP: String
    $RMP: String
    $familyCar: [ID]
    $loyaltyType: LoyaltyType = our
  ) {
    SRRGetter {
      getNSByClient(
        periodStart: $periodStart
        periodEnd: $periodEnd
        familyCar: $familyCar
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
        NOP: $NOP
        RMP: $RMP
        loyaltyType: $loyaltyType
      ) {
        dealer {
          ... on Dealer {
            ...fragmentDealer
          }
        }
        clientId
        soldCars {
          ... on SalesCar {
            ...fragmentSalesCar
          }
        }
      }
    }
  }
  ${FragmentDealerFragmentDoc}
  ${FragmentSalesCarFragmentDoc}
`;

/**
 * __useGetNsByClientQuery__
 *
 * To run a query within a React component, call `useGetNsByClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNsByClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNsByClientQuery({
 *   variables: {
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *      NOP: // value for 'NOP'
 *      RMP: // value for 'RMP'
 *      familyCar: // value for 'familyCar'
 *      loyaltyType: // value for 'loyaltyType'
 *   },
 * });
 */
export function useGetNsByClientQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetNsByClientQuery,
    GetNsByClientQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetNsByClientQuery, GetNsByClientQueryVariables>(
    GetNsByClientDocument,
    options,
  );
}
export function useGetNsByClientLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNsByClientQuery,
    GetNsByClientQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetNsByClientQuery, GetNsByClientQueryVariables>(
    GetNsByClientDocument,
    options,
  );
}
export type GetNsByClientQueryHookResult = ReturnType<
  typeof useGetNsByClientQuery
>;
export type GetNsByClientLazyQueryHookResult = ReturnType<
  typeof useGetNsByClientLazyQuery
>;
export type GetNsByClientQueryResult = Apollo.QueryResult<
  GetNsByClientQuery,
  GetNsByClientQueryVariables
>;
export const ReportNsByWarmClientsDocument = gql`
  query ReportNSByWarmClients(
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
    $NOP: String
    $RMP: String
    $familyCar: [ID]
    $loyaltyType: LoyaltyType = our
  ) {
    SRRGetter {
      reportNSByWarmClients(
        periodStart: $periodStart
        periodEnd: $periodEnd
        familyCar: $familyCar
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
        NOP: $NOP
        RMP: $RMP
        loyaltyType: $loyaltyType
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useReportNsByWarmClientsQuery__
 *
 * To run a query within a React component, call `useReportNsByWarmClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportNsByWarmClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportNsByWarmClientsQuery({
 *   variables: {
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *      NOP: // value for 'NOP'
 *      RMP: // value for 'RMP'
 *      familyCar: // value for 'familyCar'
 *      loyaltyType: // value for 'loyaltyType'
 *   },
 * });
 */
export function useReportNsByWarmClientsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReportNsByWarmClientsQuery,
    ReportNsByWarmClientsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ReportNsByWarmClientsQuery,
    ReportNsByWarmClientsQueryVariables
  >(ReportNsByWarmClientsDocument, options);
}
export function useReportNsByWarmClientsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReportNsByWarmClientsQuery,
    ReportNsByWarmClientsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ReportNsByWarmClientsQuery,
    ReportNsByWarmClientsQueryVariables
  >(ReportNsByWarmClientsDocument, options);
}
export type ReportNsByWarmClientsQueryHookResult = ReturnType<
  typeof useReportNsByWarmClientsQuery
>;
export type ReportNsByWarmClientsLazyQueryHookResult = ReturnType<
  typeof useReportNsByWarmClientsLazyQuery
>;
export type ReportNsByWarmClientsQueryResult = Apollo.QueryResult<
  ReportNsByWarmClientsQuery,
  ReportNsByWarmClientsQueryVariables
>;
export const GetNsByWarmClientsDocument = gql`
  query GetNSByWarmClients(
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
    $NOP: String
    $RMP: String
    $familyCar: [ID]
    $loyaltyType: LoyaltyType = our
  ) {
    SRRGetter {
      getNSByWarmClients(
        periodStart: $periodStart
        periodEnd: $periodEnd
        familyCar: $familyCar
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
        NOP: $NOP
        RMP: $RMP
        loyaltyType: $loyaltyType
      ) {
        dealer {
          ... on Dealer {
            ...fragmentDealer
          }
        }
        NOP
        RMP
        client {
          type
          name
          phone
          email
          createdAt
          updatedAt
        }
        vin
        goldenId
        soldDate
        creditDate
        creditEndDate
        warrantyEndDate
        ePlatformDate
      }
    }
  }
  ${FragmentDealerFragmentDoc}
`;

/**
 * __useGetNsByWarmClientsQuery__
 *
 * To run a query within a React component, call `useGetNsByWarmClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNsByWarmClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNsByWarmClientsQuery({
 *   variables: {
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *      NOP: // value for 'NOP'
 *      RMP: // value for 'RMP'
 *      familyCar: // value for 'familyCar'
 *      loyaltyType: // value for 'loyaltyType'
 *   },
 * });
 */
export function useGetNsByWarmClientsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetNsByWarmClientsQuery,
    GetNsByWarmClientsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetNsByWarmClientsQuery,
    GetNsByWarmClientsQueryVariables
  >(GetNsByWarmClientsDocument, options);
}
export function useGetNsByWarmClientsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNsByWarmClientsQuery,
    GetNsByWarmClientsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetNsByWarmClientsQuery,
    GetNsByWarmClientsQueryVariables
  >(GetNsByWarmClientsDocument, options);
}
export type GetNsByWarmClientsQueryHookResult = ReturnType<
  typeof useGetNsByWarmClientsQuery
>;
export type GetNsByWarmClientsLazyQueryHookResult = ReturnType<
  typeof useGetNsByWarmClientsLazyQuery
>;
export type GetNsByWarmClientsQueryResult = Apollo.QueryResult<
  GetNsByWarmClientsQuery,
  GetNsByWarmClientsQueryVariables
>;
export const ReportNsByOldClientsDocument = gql`
  query ReportNSByOldClients(
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
    $NOP: String
    $RMP: String
    $familyCar: [ID]
    $loyaltyType: LoyaltyType = our
  ) {
    SRRGetter {
      reportNSByOldClients(
        periodStart: $periodStart
        periodEnd: $periodEnd
        familyCar: $familyCar
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
        NOP: $NOP
        RMP: $RMP
        loyaltyType: $loyaltyType
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useReportNsByOldClientsQuery__
 *
 * To run a query within a React component, call `useReportNsByOldClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportNsByOldClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportNsByOldClientsQuery({
 *   variables: {
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *      NOP: // value for 'NOP'
 *      RMP: // value for 'RMP'
 *      familyCar: // value for 'familyCar'
 *      loyaltyType: // value for 'loyaltyType'
 *   },
 * });
 */
export function useReportNsByOldClientsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReportNsByOldClientsQuery,
    ReportNsByOldClientsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ReportNsByOldClientsQuery,
    ReportNsByOldClientsQueryVariables
  >(ReportNsByOldClientsDocument, options);
}
export function useReportNsByOldClientsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReportNsByOldClientsQuery,
    ReportNsByOldClientsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ReportNsByOldClientsQuery,
    ReportNsByOldClientsQueryVariables
  >(ReportNsByOldClientsDocument, options);
}
export type ReportNsByOldClientsQueryHookResult = ReturnType<
  typeof useReportNsByOldClientsQuery
>;
export type ReportNsByOldClientsLazyQueryHookResult = ReturnType<
  typeof useReportNsByOldClientsLazyQuery
>;
export type ReportNsByOldClientsQueryResult = Apollo.QueryResult<
  ReportNsByOldClientsQuery,
  ReportNsByOldClientsQueryVariables
>;
export const GetNsByOldClientsDocument = gql`
  query GetNSByOldClients(
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
    $NOP: String
    $RMP: String
    $familyCar: [ID]
    $loyaltyType: LoyaltyType = our
  ) {
    SRRGetter {
      getNSByOldClients(
        periodStart: $periodStart
        periodEnd: $periodEnd
        familyCar: $familyCar
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
        NOP: $NOP
        RMP: $RMP
        loyaltyType: $loyaltyType
      ) {
        ... on NSByOldClientsData {
          ...fragmentNSByOldClientsData
        }
      }
    }
  }
  ${FragmentNsByOldClientsDataFragmentDoc}
`;

/**
 * __useGetNsByOldClientsQuery__
 *
 * To run a query within a React component, call `useGetNsByOldClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNsByOldClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNsByOldClientsQuery({
 *   variables: {
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *      NOP: // value for 'NOP'
 *      RMP: // value for 'RMP'
 *      familyCar: // value for 'familyCar'
 *      loyaltyType: // value for 'loyaltyType'
 *   },
 * });
 */
export function useGetNsByOldClientsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetNsByOldClientsQuery,
    GetNsByOldClientsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetNsByOldClientsQuery,
    GetNsByOldClientsQueryVariables
  >(GetNsByOldClientsDocument, options);
}
export function useGetNsByOldClientsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNsByOldClientsQuery,
    GetNsByOldClientsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetNsByOldClientsQuery,
    GetNsByOldClientsQueryVariables
  >(GetNsByOldClientsDocument, options);
}
export type GetNsByOldClientsQueryHookResult = ReturnType<
  typeof useGetNsByOldClientsQuery
>;
export type GetNsByOldClientsLazyQueryHookResult = ReturnType<
  typeof useGetNsByOldClientsLazyQuery
>;
export type GetNsByOldClientsQueryResult = Apollo.QueryResult<
  GetNsByOldClientsQuery,
  GetNsByOldClientsQueryVariables
>;
export const ReportNsByAverageCarAgeDocument = gql`
  query ReportNSByAverageCarAge(
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $DealerIds: [ID]
    $familyCar: [ID]
  ) {
    SRRGetter {
      reportNSByAverageCarAge(
        periodStart: $periodStart
        periodEnd: $periodEnd
        familyCar: $familyCar
        DealerIds: $DealerIds
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useReportNsByAverageCarAgeQuery__
 *
 * To run a query within a React component, call `useReportNsByAverageCarAgeQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportNsByAverageCarAgeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportNsByAverageCarAgeQuery({
 *   variables: {
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      DealerIds: // value for 'DealerIds'
 *      familyCar: // value for 'familyCar'
 *   },
 * });
 */
export function useReportNsByAverageCarAgeQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReportNsByAverageCarAgeQuery,
    ReportNsByAverageCarAgeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ReportNsByAverageCarAgeQuery,
    ReportNsByAverageCarAgeQueryVariables
  >(ReportNsByAverageCarAgeDocument, options);
}
export function useReportNsByAverageCarAgeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReportNsByAverageCarAgeQuery,
    ReportNsByAverageCarAgeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ReportNsByAverageCarAgeQuery,
    ReportNsByAverageCarAgeQueryVariables
  >(ReportNsByAverageCarAgeDocument, options);
}
export type ReportNsByAverageCarAgeQueryHookResult = ReturnType<
  typeof useReportNsByAverageCarAgeQuery
>;
export type ReportNsByAverageCarAgeLazyQueryHookResult = ReturnType<
  typeof useReportNsByAverageCarAgeLazyQuery
>;
export type ReportNsByAverageCarAgeQueryResult = Apollo.QueryResult<
  ReportNsByAverageCarAgeQuery,
  ReportNsByAverageCarAgeQueryVariables
>;
export const GetNsByAverageCarAgeDocument = gql`
  query GetNSByAverageCarAge(
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $DealerIds: [ID]
    $familyCar: [ID]
  ) {
    SRRGetter {
      getNSByAverageCarAge(
        periodStart: $periodStart
        periodEnd: $periodEnd
        familyCar: $familyCar
        DealerIds: $DealerIds
      ) {
        ... on NSByAverageCarAgeData {
          ...fragmentNSByAverageCarAgeData
        }
      }
    }
  }
  ${FragmentNsByAverageCarAgeDataFragmentDoc}
`;

/**
 * __useGetNsByAverageCarAgeQuery__
 *
 * To run a query within a React component, call `useGetNsByAverageCarAgeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNsByAverageCarAgeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNsByAverageCarAgeQuery({
 *   variables: {
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      DealerIds: // value for 'DealerIds'
 *      familyCar: // value for 'familyCar'
 *   },
 * });
 */
export function useGetNsByAverageCarAgeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetNsByAverageCarAgeQuery,
    GetNsByAverageCarAgeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetNsByAverageCarAgeQuery,
    GetNsByAverageCarAgeQueryVariables
  >(GetNsByAverageCarAgeDocument, options);
}
export function useGetNsByAverageCarAgeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNsByAverageCarAgeQuery,
    GetNsByAverageCarAgeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetNsByAverageCarAgeQuery,
    GetNsByAverageCarAgeQueryVariables
  >(GetNsByAverageCarAgeDocument, options);
}
export type GetNsByAverageCarAgeQueryHookResult = ReturnType<
  typeof useGetNsByAverageCarAgeQuery
>;
export type GetNsByAverageCarAgeLazyQueryHookResult = ReturnType<
  typeof useGetNsByAverageCarAgeLazyQuery
>;
export type GetNsByAverageCarAgeQueryResult = Apollo.QueryResult<
  GetNsByAverageCarAgeQuery,
  GetNsByAverageCarAgeQueryVariables
>;
export const ReportNsByClientCarSaleDocument = gql`
  query ReportNSByClientCarSale(
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
    $NOP: String
    $RMP: String
    $familyCar: [ID]
    $loyaltyType: LoyaltyType = our
  ) {
    SRRGetter {
      reportNSByClientCarSale(
        periodStart: $periodStart
        periodEnd: $periodEnd
        familyCar: $familyCar
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
        NOP: $NOP
        RMP: $RMP
        loyaltyType: $loyaltyType
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useReportNsByClientCarSaleQuery__
 *
 * To run a query within a React component, call `useReportNsByClientCarSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportNsByClientCarSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportNsByClientCarSaleQuery({
 *   variables: {
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *      NOP: // value for 'NOP'
 *      RMP: // value for 'RMP'
 *      familyCar: // value for 'familyCar'
 *      loyaltyType: // value for 'loyaltyType'
 *   },
 * });
 */
export function useReportNsByClientCarSaleQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReportNsByClientCarSaleQuery,
    ReportNsByClientCarSaleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ReportNsByClientCarSaleQuery,
    ReportNsByClientCarSaleQueryVariables
  >(ReportNsByClientCarSaleDocument, options);
}
export function useReportNsByClientCarSaleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReportNsByClientCarSaleQuery,
    ReportNsByClientCarSaleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ReportNsByClientCarSaleQuery,
    ReportNsByClientCarSaleQueryVariables
  >(ReportNsByClientCarSaleDocument, options);
}
export type ReportNsByClientCarSaleQueryHookResult = ReturnType<
  typeof useReportNsByClientCarSaleQuery
>;
export type ReportNsByClientCarSaleLazyQueryHookResult = ReturnType<
  typeof useReportNsByClientCarSaleLazyQuery
>;
export type ReportNsByClientCarSaleQueryResult = Apollo.QueryResult<
  ReportNsByClientCarSaleQuery,
  ReportNsByClientCarSaleQueryVariables
>;
export const GetNsByClientCarSaleDocument = gql`
  query GetNSByClientCarSale(
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
    $NOP: String
    $RMP: String
    $familyCar: [ID]
    $loyaltyType: LoyaltyType = our
  ) {
    SRRGetter {
      getNSByClientCarSale(
        periodStart: $periodStart
        periodEnd: $periodEnd
        familyCar: $familyCar
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
        NOP: $NOP
        RMP: $RMP
        loyaltyType: $loyaltyType
      ) {
        ... on NSByClientCarSaleData {
          ...fragmentNSByClientCarSaleData
        }
      }
    }
  }
  ${FragmentNsByClientCarSaleDataFragmentDoc}
`;

/**
 * __useGetNsByClientCarSaleQuery__
 *
 * To run a query within a React component, call `useGetNsByClientCarSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNsByClientCarSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNsByClientCarSaleQuery({
 *   variables: {
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *      NOP: // value for 'NOP'
 *      RMP: // value for 'RMP'
 *      familyCar: // value for 'familyCar'
 *      loyaltyType: // value for 'loyaltyType'
 *   },
 * });
 */
export function useGetNsByClientCarSaleQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetNsByClientCarSaleQuery,
    GetNsByClientCarSaleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetNsByClientCarSaleQuery,
    GetNsByClientCarSaleQueryVariables
  >(GetNsByClientCarSaleDocument, options);
}
export function useGetNsByClientCarSaleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNsByClientCarSaleQuery,
    GetNsByClientCarSaleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetNsByClientCarSaleQuery,
    GetNsByClientCarSaleQueryVariables
  >(GetNsByClientCarSaleDocument, options);
}
export type GetNsByClientCarSaleQueryHookResult = ReturnType<
  typeof useGetNsByClientCarSaleQuery
>;
export type GetNsByClientCarSaleLazyQueryHookResult = ReturnType<
  typeof useGetNsByClientCarSaleLazyQuery
>;
export type GetNsByClientCarSaleQueryResult = Apollo.QueryResult<
  GetNsByClientCarSaleQuery,
  GetNsByClientCarSaleQueryVariables
>;
export const GetFamilyCarDocument = gql`
  query GetFamilyCar($name: String, $page: Int = 0, $count: Int = 10) {
    SRRGetter {
      getFamilyCar(name: $name, page: $page, count: $count) {
        items {
          ... on familyCar {
            ...fragmentFamilyCar
          }
        }
        total
      }
    }
  }
  ${FragmentFamilyCarFragmentDoc}
`;

/**
 * __useGetFamilyCarQuery__
 *
 * To run a query within a React component, call `useGetFamilyCarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFamilyCarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFamilyCarQuery({
 *   variables: {
 *      name: // value for 'name'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetFamilyCarQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetFamilyCarQuery,
    GetFamilyCarQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFamilyCarQuery, GetFamilyCarQueryVariables>(
    GetFamilyCarDocument,
    options,
  );
}
export function useGetFamilyCarLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFamilyCarQuery,
    GetFamilyCarQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFamilyCarQuery, GetFamilyCarQueryVariables>(
    GetFamilyCarDocument,
    options,
  );
}
export type GetFamilyCarQueryHookResult = ReturnType<
  typeof useGetFamilyCarQuery
>;
export type GetFamilyCarLazyQueryHookResult = ReturnType<
  typeof useGetFamilyCarLazyQuery
>;
export type GetFamilyCarQueryResult = Apollo.QueryResult<
  GetFamilyCarQuery,
  GetFamilyCarQueryVariables
>;
export const ImportCreditDataDocument = gql`
  query ImportCreditData($fileId: ID!) {
    SRRGetter {
      importCreditData(fileId: $fileId)
    }
  }
`;

/**
 * __useImportCreditDataQuery__
 *
 * To run a query within a React component, call `useImportCreditDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportCreditDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportCreditDataQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useImportCreditDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    ImportCreditDataQuery,
    ImportCreditDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ImportCreditDataQuery, ImportCreditDataQueryVariables>(
    ImportCreditDataDocument,
    options,
  );
}
export function useImportCreditDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ImportCreditDataQuery,
    ImportCreditDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ImportCreditDataQuery,
    ImportCreditDataQueryVariables
  >(ImportCreditDataDocument, options);
}
export type ImportCreditDataQueryHookResult = ReturnType<
  typeof useImportCreditDataQuery
>;
export type ImportCreditDataLazyQueryHookResult = ReturnType<
  typeof useImportCreditDataLazyQuery
>;
export type ImportCreditDataQueryResult = Apollo.QueryResult<
  ImportCreditDataQuery,
  ImportCreditDataQueryVariables
>;
export const ImportCarEPlatformDataDocument = gql`
  query ImportCarEPlatformData($fileId: ID!) {
    SRRGetter {
      importCarEPlatformData(fileId: $fileId)
    }
  }
`;

/**
 * __useImportCarEPlatformDataQuery__
 *
 * To run a query within a React component, call `useImportCarEPlatformDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportCarEPlatformDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportCarEPlatformDataQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useImportCarEPlatformDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    ImportCarEPlatformDataQuery,
    ImportCarEPlatformDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ImportCarEPlatformDataQuery,
    ImportCarEPlatformDataQueryVariables
  >(ImportCarEPlatformDataDocument, options);
}
export function useImportCarEPlatformDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ImportCarEPlatformDataQuery,
    ImportCarEPlatformDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ImportCarEPlatformDataQuery,
    ImportCarEPlatformDataQueryVariables
  >(ImportCarEPlatformDataDocument, options);
}
export type ImportCarEPlatformDataQueryHookResult = ReturnType<
  typeof useImportCarEPlatformDataQuery
>;
export type ImportCarEPlatformDataLazyQueryHookResult = ReturnType<
  typeof useImportCarEPlatformDataLazyQuery
>;
export type ImportCarEPlatformDataQueryResult = Apollo.QueryResult<
  ImportCarEPlatformDataQuery,
  ImportCarEPlatformDataQueryVariables
>;
export const GetGibddDocument = gql`
  query GetGIBDD(
    $page: Int = 0
    $count: Int = 10
    $id: ID
    $vin: String
    $dateRegistrationStart: DateTime
    $dateRegistrationEnd: DateTime
    $city: [String]
  ) {
    SRRGetter {
      getGIBDD(
        page: $page
        count: $count
        id: $id
        vin: $vin
        dateRegistrationStart: $dateRegistrationStart
        dateRegistrationEnd: $dateRegistrationEnd
        city: $city
      ) {
        items {
          ... on GIBDDType {
            ...fragmentGIBDDType
          }
        }
        total
      }
    }
  }
  ${FragmentGibddTypeFragmentDoc}
`;

/**
 * __useGetGibddQuery__
 *
 * To run a query within a React component, call `useGetGibddQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGibddQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGibddQuery({
 *   variables: {
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      id: // value for 'id'
 *      vin: // value for 'vin'
 *      dateRegistrationStart: // value for 'dateRegistrationStart'
 *      dateRegistrationEnd: // value for 'dateRegistrationEnd'
 *      city: // value for 'city'
 *   },
 * });
 */
export function useGetGibddQuery(
  baseOptions?: Apollo.QueryHookOptions<GetGibddQuery, GetGibddQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetGibddQuery, GetGibddQueryVariables>(
    GetGibddDocument,
    options,
  );
}
export function useGetGibddLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGibddQuery,
    GetGibddQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetGibddQuery, GetGibddQueryVariables>(
    GetGibddDocument,
    options,
  );
}
export type GetGibddQueryHookResult = ReturnType<typeof useGetGibddQuery>;
export type GetGibddLazyQueryHookResult = ReturnType<
  typeof useGetGibddLazyQuery
>;
export type GetGibddQueryResult = Apollo.QueryResult<
  GetGibddQuery,
  GetGibddQueryVariables
>;
export const ReportAverageReceiptToDocument = gql`
  query ReportAverageReceiptTO(
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $group: typeGroupReportSRR!
  ) {
    SRRGetter {
      reportAverageReceiptTO(
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
        periodStart: $periodStart
        periodEnd: $periodEnd
        group: $group
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useReportAverageReceiptToQuery__
 *
 * To run a query within a React component, call `useReportAverageReceiptToQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportAverageReceiptToQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportAverageReceiptToQuery({
 *   variables: {
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      group: // value for 'group'
 *   },
 * });
 */
export function useReportAverageReceiptToQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReportAverageReceiptToQuery,
    ReportAverageReceiptToQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ReportAverageReceiptToQuery,
    ReportAverageReceiptToQueryVariables
  >(ReportAverageReceiptToDocument, options);
}
export function useReportAverageReceiptToLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReportAverageReceiptToQuery,
    ReportAverageReceiptToQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ReportAverageReceiptToQuery,
    ReportAverageReceiptToQueryVariables
  >(ReportAverageReceiptToDocument, options);
}
export type ReportAverageReceiptToQueryHookResult = ReturnType<
  typeof useReportAverageReceiptToQuery
>;
export type ReportAverageReceiptToLazyQueryHookResult = ReturnType<
  typeof useReportAverageReceiptToLazyQuery
>;
export type ReportAverageReceiptToQueryResult = Apollo.QueryResult<
  ReportAverageReceiptToQuery,
  ReportAverageReceiptToQueryVariables
>;
export const GetAverageReceiptToDocument = gql`
  query GetAverageReceiptTO(
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $group: typeGroupReportSRR!
  ) {
    SRRGetter {
      getAverageReceiptTO(
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
        periodStart: $periodStart
        periodEnd: $periodEnd
        group: $group
      ) {
        dealer {
          DealerName
          INN
          code: entfCode
        }
        FO
        City
        Region
        Country
        carsTotal
        moneyTotal
        averageReceipt
      }
    }
  }
`;

/**
 * __useGetAverageReceiptToQuery__
 *
 * To run a query within a React component, call `useGetAverageReceiptToQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAverageReceiptToQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAverageReceiptToQuery({
 *   variables: {
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      group: // value for 'group'
 *   },
 * });
 */
export function useGetAverageReceiptToQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAverageReceiptToQuery,
    GetAverageReceiptToQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAverageReceiptToQuery,
    GetAverageReceiptToQueryVariables
  >(GetAverageReceiptToDocument, options);
}
export function useGetAverageReceiptToLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAverageReceiptToQuery,
    GetAverageReceiptToQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAverageReceiptToQuery,
    GetAverageReceiptToQueryVariables
  >(GetAverageReceiptToDocument, options);
}
export type GetAverageReceiptToQueryHookResult = ReturnType<
  typeof useGetAverageReceiptToQuery
>;
export type GetAverageReceiptToLazyQueryHookResult = ReturnType<
  typeof useGetAverageReceiptToLazyQuery
>;
export type GetAverageReceiptToQueryResult = Apollo.QueryResult<
  GetAverageReceiptToQuery,
  GetAverageReceiptToQueryVariables
>;
export const ReportAverageReceiptAkcDocument = gql`
  query ReportAverageReceiptAKC(
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $group: typeGroupReportSRR!
  ) {
    SRRGetter {
      reportAverageReceiptAKC(
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
        periodStart: $periodStart
        periodEnd: $periodEnd
        group: $group
      ) {
        fileHash
      }
    }
  }
`;

/**
 * __useReportAverageReceiptAkcQuery__
 *
 * To run a query within a React component, call `useReportAverageReceiptAkcQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportAverageReceiptAkcQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportAverageReceiptAkcQuery({
 *   variables: {
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      group: // value for 'group'
 *   },
 * });
 */
export function useReportAverageReceiptAkcQuery(
  baseOptions: Apollo.QueryHookOptions<
    ReportAverageReceiptAkcQuery,
    ReportAverageReceiptAkcQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ReportAverageReceiptAkcQuery,
    ReportAverageReceiptAkcQueryVariables
  >(ReportAverageReceiptAkcDocument, options);
}
export function useReportAverageReceiptAkcLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReportAverageReceiptAkcQuery,
    ReportAverageReceiptAkcQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ReportAverageReceiptAkcQuery,
    ReportAverageReceiptAkcQueryVariables
  >(ReportAverageReceiptAkcDocument, options);
}
export type ReportAverageReceiptAkcQueryHookResult = ReturnType<
  typeof useReportAverageReceiptAkcQuery
>;
export type ReportAverageReceiptAkcLazyQueryHookResult = ReturnType<
  typeof useReportAverageReceiptAkcLazyQuery
>;
export type ReportAverageReceiptAkcQueryResult = Apollo.QueryResult<
  ReportAverageReceiptAkcQuery,
  ReportAverageReceiptAkcQueryVariables
>;
export const GetAverageReceiptAkcDocument = gql`
  query GetAverageReceiptAKC(
    $FO: [String]
    $City: [String]
    $Region: [String]
    $DealerIds: [ID]
    $periodStart: DateTime!
    $periodEnd: DateTime!
    $group: typeGroupReportSRR!
  ) {
    SRRGetter {
      getAverageReceiptAKC(
        FO: $FO
        City: $City
        Region: $Region
        DealerIds: $DealerIds
        periodStart: $periodStart
        periodEnd: $periodEnd
        group: $group
      ) {
        dealer {
          DealerName
          INN
          code: entfCode
        }
        FO
        City
        Region
        Country
        carsTotal
        moneyTotal
        averageReceipt
      }
    }
  }
`;

/**
 * __useGetAverageReceiptAkcQuery__
 *
 * To run a query within a React component, call `useGetAverageReceiptAkcQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAverageReceiptAkcQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAverageReceiptAkcQuery({
 *   variables: {
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Region: // value for 'Region'
 *      DealerIds: // value for 'DealerIds'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      group: // value for 'group'
 *   },
 * });
 */
export function useGetAverageReceiptAkcQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAverageReceiptAkcQuery,
    GetAverageReceiptAkcQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAverageReceiptAkcQuery,
    GetAverageReceiptAkcQueryVariables
  >(GetAverageReceiptAkcDocument, options);
}
export function useGetAverageReceiptAkcLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAverageReceiptAkcQuery,
    GetAverageReceiptAkcQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAverageReceiptAkcQuery,
    GetAverageReceiptAkcQueryVariables
  >(GetAverageReceiptAkcDocument, options);
}
export type GetAverageReceiptAkcQueryHookResult = ReturnType<
  typeof useGetAverageReceiptAkcQuery
>;
export type GetAverageReceiptAkcLazyQueryHookResult = ReturnType<
  typeof useGetAverageReceiptAkcLazyQuery
>;
export type GetAverageReceiptAkcQueryResult = Apollo.QueryResult<
  GetAverageReceiptAkcQuery,
  GetAverageReceiptAkcQueryVariables
>;
export const GetTargetDealerByMonthDocument = gql`
  query GetTargetDealerByMonth(
    $DealerId: ID
    $Month: DateTime
    $page: Int = 0
    $count: Int = 10
  ) {
    SRRGetter {
      getTargetDealerByMonth(
        DealerId: $DealerId
        Month: $Month
        page: $page
        count: $count
      ) {
        items {
          DealerId
          Month
          Dealer {
            DealerName
            DealerNameEn
          }
          Target
        }
        total
      }
    }
  }
`;

/**
 * __useGetTargetDealerByMonthQuery__
 *
 * To run a query within a React component, call `useGetTargetDealerByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTargetDealerByMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTargetDealerByMonthQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      Month: // value for 'Month'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetTargetDealerByMonthQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTargetDealerByMonthQuery,
    GetTargetDealerByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetTargetDealerByMonthQuery,
    GetTargetDealerByMonthQueryVariables
  >(GetTargetDealerByMonthDocument, options);
}
export function useGetTargetDealerByMonthLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTargetDealerByMonthQuery,
    GetTargetDealerByMonthQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTargetDealerByMonthQuery,
    GetTargetDealerByMonthQueryVariables
  >(GetTargetDealerByMonthDocument, options);
}
export type GetTargetDealerByMonthQueryHookResult = ReturnType<
  typeof useGetTargetDealerByMonthQuery
>;
export type GetTargetDealerByMonthLazyQueryHookResult = ReturnType<
  typeof useGetTargetDealerByMonthLazyQuery
>;
export type GetTargetDealerByMonthQueryResult = Apollo.QueryResult<
  GetTargetDealerByMonthQuery,
  GetTargetDealerByMonthQueryVariables
>;
export const GetServiceDocument = gql`
  query GetService($id: ID) {
    ServicesGetter {
      getById(id: $id) {
        ... on ServicesIndicatorTypes {
          ...fragmentServices
        }
      }
    }
  }
  ${FragmentServicesFragmentDoc}
`;

/**
 * __useGetServiceQuery__
 *
 * To run a query within a React component, call `useGetServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetServiceQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetServiceQuery,
    GetServiceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetServiceQuery, GetServiceQueryVariables>(
    GetServiceDocument,
    options,
  );
}
export function useGetServiceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetServiceQuery,
    GetServiceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetServiceQuery, GetServiceQueryVariables>(
    GetServiceDocument,
    options,
  );
}
export type GetServiceQueryHookResult = ReturnType<typeof useGetServiceQuery>;
export type GetServiceLazyQueryHookResult = ReturnType<
  typeof useGetServiceLazyQuery
>;
export type GetServiceQueryResult = Apollo.QueryResult<
  GetServiceQuery,
  GetServiceQueryVariables
>;
export const GetServiceStatusesDocument = gql`
  query GetServiceStatuses($UUID: String, $name: String) {
    ServicesGetter {
      getDealerStatuses(UUID: $UUID, name: $name) {
        ... on ServicesDealerStatuses {
          ...fragmentServicesDealerStatuses
        }
      }
    }
  }
  ${FragmentServicesDealerStatusesFragmentDoc}
`;

/**
 * __useGetServiceStatusesQuery__
 *
 * To run a query within a React component, call `useGetServiceStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceStatusesQuery({
 *   variables: {
 *      UUID: // value for 'UUID'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetServiceStatusesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetServiceStatusesQuery,
    GetServiceStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetServiceStatusesQuery,
    GetServiceStatusesQueryVariables
  >(GetServiceStatusesDocument, options);
}
export function useGetServiceStatusesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetServiceStatusesQuery,
    GetServiceStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetServiceStatusesQuery,
    GetServiceStatusesQueryVariables
  >(GetServiceStatusesDocument, options);
}
export type GetServiceStatusesQueryHookResult = ReturnType<
  typeof useGetServiceStatusesQuery
>;
export type GetServiceStatusesLazyQueryHookResult = ReturnType<
  typeof useGetServiceStatusesLazyQuery
>;
export type GetServiceStatusesQueryResult = Apollo.QueryResult<
  GetServiceStatusesQuery,
  GetServiceStatusesQueryVariables
>;
export const GetAllServicesDocument = gql`
  query GetAllServices {
    ServicesGetter {
      getAll {
        ... on ServicesIndicatorTypes {
          ...fragmentServices
        }
      }
    }
  }
  ${FragmentServicesFragmentDoc}
`;

/**
 * __useGetAllServicesQuery__
 *
 * To run a query within a React component, call `useGetAllServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllServicesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllServicesQuery,
    GetAllServicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAllServicesQuery, GetAllServicesQueryVariables>(
    GetAllServicesDocument,
    options,
  );
}
export function useGetAllServicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllServicesQuery,
    GetAllServicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAllServicesQuery, GetAllServicesQueryVariables>(
    GetAllServicesDocument,
    options,
  );
}
export type GetAllServicesQueryHookResult = ReturnType<
  typeof useGetAllServicesQuery
>;
export type GetAllServicesLazyQueryHookResult = ReturnType<
  typeof useGetAllServicesLazyQuery
>;
export type GetAllServicesQueryResult = Apollo.QueryResult<
  GetAllServicesQuery,
  GetAllServicesQueryVariables
>;
export const GetValuesServicesDocument = gql`
  query GetValuesServices(
    $DealerId: ID!
    $dateUpTo: DateTime
    $page: Int
    $count: Int
    $name: String
  ) {
    ServicesGetter {
      getValues(
        DealerId: $DealerId
        dateUpTo: $dateUpTo
        page: $page
        count: $count
        name: $name
      ) {
        items {
          ... on ServicesOneValuesItem {
            ...fragmentServicesValues
          }
        }
        total
      }
    }
  }
  ${FragmentServicesValuesFragmentDoc}
`;

/**
 * __useGetValuesServicesQuery__
 *
 * To run a query within a React component, call `useGetValuesServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValuesServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValuesServicesQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      dateUpTo: // value for 'dateUpTo'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetValuesServicesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetValuesServicesQuery,
    GetValuesServicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetValuesServicesQuery,
    GetValuesServicesQueryVariables
  >(GetValuesServicesDocument, options);
}
export function useGetValuesServicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetValuesServicesQuery,
    GetValuesServicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetValuesServicesQuery,
    GetValuesServicesQueryVariables
  >(GetValuesServicesDocument, options);
}
export type GetValuesServicesQueryHookResult = ReturnType<
  typeof useGetValuesServicesQuery
>;
export type GetValuesServicesLazyQueryHookResult = ReturnType<
  typeof useGetValuesServicesLazyQuery
>;
export type GetValuesServicesQueryResult = Apollo.QueryResult<
  GetValuesServicesQuery,
  GetValuesServicesQueryVariables
>;
export const GetSettingsDocument = gql`
  query getSettings($StaffFile: Boolean!) {
    SettingsGetter {
      getSettings(StaffFile: $StaffFile) {
        StaffFile {
          ... on File {
            ...fragmentFileLink
          }
        }
      }
    }
  }
  ${FragmentFileLinkFragmentDoc}
`;

/**
 * __useGetSettingsQuery__
 *
 * To run a query within a React component, call `useGetSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettingsQuery({
 *   variables: {
 *      StaffFile: // value for 'StaffFile'
 *   },
 * });
 */
export function useGetSettingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSettingsQuery,
    GetSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSettingsQuery, GetSettingsQueryVariables>(
    GetSettingsDocument,
    options,
  );
}
export function useGetSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSettingsQuery,
    GetSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSettingsQuery, GetSettingsQueryVariables>(
    GetSettingsDocument,
    options,
  );
}
export type GetSettingsQueryHookResult = ReturnType<typeof useGetSettingsQuery>;
export type GetSettingsLazyQueryHookResult = ReturnType<
  typeof useGetSettingsLazyQuery
>;
export type GetSettingsQueryResult = Apollo.QueryResult<
  GetSettingsQuery,
  GetSettingsQueryVariables
>;
export const GetSubdivisionDocument = gql`
  query GetSubdivision(
    $code: String
    $name: String
    $status: String
    $parentId: ID
    $page: Int = 0
    $count: Int = 10
  ) {
    SubdivisionGetter {
      get(
        code: $code
        name: $name
        status: $status
        parentId: $parentId
        page: $page
        count: $count
      ) {
        items {
          ... on Subdivision {
            ...fragmentSubdivision
          }
        }
        total
      }
    }
  }
  ${FragmentSubdivisionFragmentDoc}
`;

/**
 * __useGetSubdivisionQuery__
 *
 * To run a query within a React component, call `useGetSubdivisionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubdivisionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubdivisionQuery({
 *   variables: {
 *      code: // value for 'code'
 *      name: // value for 'name'
 *      status: // value for 'status'
 *      parentId: // value for 'parentId'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetSubdivisionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSubdivisionQuery,
    GetSubdivisionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSubdivisionQuery, GetSubdivisionQueryVariables>(
    GetSubdivisionDocument,
    options,
  );
}
export function useGetSubdivisionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSubdivisionQuery,
    GetSubdivisionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSubdivisionQuery, GetSubdivisionQueryVariables>(
    GetSubdivisionDocument,
    options,
  );
}
export type GetSubdivisionQueryHookResult = ReturnType<
  typeof useGetSubdivisionQuery
>;
export type GetSubdivisionLazyQueryHookResult = ReturnType<
  typeof useGetSubdivisionLazyQuery
>;
export type GetSubdivisionQueryResult = Apollo.QueryResult<
  GetSubdivisionQuery,
  GetSubdivisionQueryVariables
>;
export const GetSubdivisionNamesForSelectDocument = gql`
  query GetSubdivisionNamesForSelect(
    $page: Int = 0
    $count: Int = 25
    $name: String
  ) {
    SubdivisionGetter {
      get(page: $page, count: $count, name: $name) {
        items {
          ... on Subdivision {
            ...fragmentSubdivisionForSelect
          }
        }
      }
    }
  }
  ${FragmentSubdivisionForSelectFragmentDoc}
`;

/**
 * __useGetSubdivisionNamesForSelectQuery__
 *
 * To run a query within a React component, call `useGetSubdivisionNamesForSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubdivisionNamesForSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubdivisionNamesForSelectQuery({
 *   variables: {
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetSubdivisionNamesForSelectQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetSubdivisionNamesForSelectQuery,
    GetSubdivisionNamesForSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSubdivisionNamesForSelectQuery,
    GetSubdivisionNamesForSelectQueryVariables
  >(GetSubdivisionNamesForSelectDocument, options);
}
export function useGetSubdivisionNamesForSelectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSubdivisionNamesForSelectQuery,
    GetSubdivisionNamesForSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSubdivisionNamesForSelectQuery,
    GetSubdivisionNamesForSelectQueryVariables
  >(GetSubdivisionNamesForSelectDocument, options);
}
export type GetSubdivisionNamesForSelectQueryHookResult = ReturnType<
  typeof useGetSubdivisionNamesForSelectQuery
>;
export type GetSubdivisionNamesForSelectLazyQueryHookResult = ReturnType<
  typeof useGetSubdivisionNamesForSelectLazyQuery
>;
export type GetSubdivisionNamesForSelectQueryResult = Apollo.QueryResult<
  GetSubdivisionNamesForSelectQuery,
  GetSubdivisionNamesForSelectQueryVariables
>;
export const GetAllToolsDocument = gql`
  query GetAllTools {
    ToolsGetter {
      getAll {
        ... on ToolsIndicatorTypes {
          ...fragmentTools
        }
      }
    }
  }
  ${FragmentToolsFragmentDoc}
`;

/**
 * __useGetAllToolsQuery__
 *
 * To run a query within a React component, call `useGetAllToolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllToolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllToolsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllToolsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllToolsQuery,
    GetAllToolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAllToolsQuery, GetAllToolsQueryVariables>(
    GetAllToolsDocument,
    options,
  );
}
export function useGetAllToolsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllToolsQuery,
    GetAllToolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAllToolsQuery, GetAllToolsQueryVariables>(
    GetAllToolsDocument,
    options,
  );
}
export type GetAllToolsQueryHookResult = ReturnType<typeof useGetAllToolsQuery>;
export type GetAllToolsLazyQueryHookResult = ReturnType<
  typeof useGetAllToolsLazyQuery
>;
export type GetAllToolsQueryResult = Apollo.QueryResult<
  GetAllToolsQuery,
  GetAllToolsQueryVariables
>;
export const GetAllToolsParentDocument = gql`
  query GetAllToolsParent {
    ToolsGetter {
      getAll {
        ... on ToolsIndicatorTypes {
          ...fragmentTools
        }
      }
    }
  }
  ${FragmentToolsFragmentDoc}
`;

/**
 * __useGetAllToolsParentQuery__
 *
 * To run a query within a React component, call `useGetAllToolsParentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllToolsParentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllToolsParentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllToolsParentQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllToolsParentQuery,
    GetAllToolsParentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAllToolsParentQuery,
    GetAllToolsParentQueryVariables
  >(GetAllToolsParentDocument, options);
}
export function useGetAllToolsParentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllToolsParentQuery,
    GetAllToolsParentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAllToolsParentQuery,
    GetAllToolsParentQueryVariables
  >(GetAllToolsParentDocument, options);
}
export type GetAllToolsParentQueryHookResult = ReturnType<
  typeof useGetAllToolsParentQuery
>;
export type GetAllToolsParentLazyQueryHookResult = ReturnType<
  typeof useGetAllToolsParentLazyQuery
>;
export type GetAllToolsParentQueryResult = Apollo.QueryResult<
  GetAllToolsParentQuery,
  GetAllToolsParentQueryVariables
>;
export const GetToolsStatusesDocument = gql`
  query GetToolsStatuses($UUID: String, $name: String) {
    ToolsGetter {
      getDealerStatuses(UUID: $UUID, name: $name) {
        ... on ToolsDealerStatuses {
          ...fragmentToolsDealerStatuses
        }
      }
    }
  }
  ${FragmentToolsDealerStatusesFragmentDoc}
`;

/**
 * __useGetToolsStatusesQuery__
 *
 * To run a query within a React component, call `useGetToolsStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetToolsStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetToolsStatusesQuery({
 *   variables: {
 *      UUID: // value for 'UUID'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetToolsStatusesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetToolsStatusesQuery,
    GetToolsStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetToolsStatusesQuery, GetToolsStatusesQueryVariables>(
    GetToolsStatusesDocument,
    options,
  );
}
export function useGetToolsStatusesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetToolsStatusesQuery,
    GetToolsStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetToolsStatusesQuery,
    GetToolsStatusesQueryVariables
  >(GetToolsStatusesDocument, options);
}
export type GetToolsStatusesQueryHookResult = ReturnType<
  typeof useGetToolsStatusesQuery
>;
export type GetToolsStatusesLazyQueryHookResult = ReturnType<
  typeof useGetToolsStatusesLazyQuery
>;
export type GetToolsStatusesQueryResult = Apollo.QueryResult<
  GetToolsStatusesQuery,
  GetToolsStatusesQueryVariables
>;
export const GetValuesToolsDocument = gql`
  query GetValuesTools(
    $DealerId: ID!
    $dateUpTo: DateTime
    $page: Int
    $count: Int
    $name: String
  ) {
    ToolsGetter {
      getValues(
        DealerId: $DealerId
        dateUpTo: $dateUpTo
        page: $page
        count: $count
        name: $name
      ) {
        items {
          ... on ToolsOneValuesItem {
            ...fragmentValuesTools
          }
        }
        total
      }
    }
  }
  ${FragmentValuesToolsFragmentDoc}
`;

/**
 * __useGetValuesToolsQuery__
 *
 * To run a query within a React component, call `useGetValuesToolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValuesToolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValuesToolsQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      dateUpTo: // value for 'dateUpTo'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetValuesToolsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetValuesToolsQuery,
    GetValuesToolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetValuesToolsQuery, GetValuesToolsQueryVariables>(
    GetValuesToolsDocument,
    options,
  );
}
export function useGetValuesToolsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetValuesToolsQuery,
    GetValuesToolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetValuesToolsQuery, GetValuesToolsQueryVariables>(
    GetValuesToolsDocument,
    options,
  );
}
export type GetValuesToolsQueryHookResult = ReturnType<
  typeof useGetValuesToolsQuery
>;
export type GetValuesToolsLazyQueryHookResult = ReturnType<
  typeof useGetValuesToolsLazyQuery
>;
export type GetValuesToolsQueryResult = Apollo.QueryResult<
  GetValuesToolsQuery,
  GetValuesToolsQueryVariables
>;
export const GetGroupsToolsDocument = gql`
  query getGroupsTools($groupType: ZdGroupType) {
    ToolsGetter {
      getGroups(groupType: $groupType)
    }
  }
`;

/**
 * __useGetGroupsToolsQuery__
 *
 * To run a query within a React component, call `useGetGroupsToolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsToolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsToolsQuery({
 *   variables: {
 *      groupType: // value for 'groupType'
 *   },
 * });
 */
export function useGetGroupsToolsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetGroupsToolsQuery,
    GetGroupsToolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetGroupsToolsQuery, GetGroupsToolsQueryVariables>(
    GetGroupsToolsDocument,
    options,
  );
}
export function useGetGroupsToolsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGroupsToolsQuery,
    GetGroupsToolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetGroupsToolsQuery, GetGroupsToolsQueryVariables>(
    GetGroupsToolsDocument,
    options,
  );
}
export type GetGroupsToolsQueryHookResult = ReturnType<
  typeof useGetGroupsToolsQuery
>;
export type GetGroupsToolsLazyQueryHookResult = ReturnType<
  typeof useGetGroupsToolsLazyQuery
>;
export type GetGroupsToolsQueryResult = Apollo.QueryResult<
  GetGroupsToolsQuery,
  GetGroupsToolsQueryVariables
>;
export const GetAllToolsInsuranceDocument = gql`
  query GetAllToolsInsurance {
    ToolsInsuranceGetter {
      getAll {
        ... on ToolsInsuranceIndicatorTypes {
          ...fragmentToolsInsurance
        }
      }
    }
  }
  ${FragmentToolsInsuranceFragmentDoc}
`;

/**
 * __useGetAllToolsInsuranceQuery__
 *
 * To run a query within a React component, call `useGetAllToolsInsuranceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllToolsInsuranceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllToolsInsuranceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllToolsInsuranceQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllToolsInsuranceQuery,
    GetAllToolsInsuranceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAllToolsInsuranceQuery,
    GetAllToolsInsuranceQueryVariables
  >(GetAllToolsInsuranceDocument, options);
}
export function useGetAllToolsInsuranceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllToolsInsuranceQuery,
    GetAllToolsInsuranceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAllToolsInsuranceQuery,
    GetAllToolsInsuranceQueryVariables
  >(GetAllToolsInsuranceDocument, options);
}
export type GetAllToolsInsuranceQueryHookResult = ReturnType<
  typeof useGetAllToolsInsuranceQuery
>;
export type GetAllToolsInsuranceLazyQueryHookResult = ReturnType<
  typeof useGetAllToolsInsuranceLazyQuery
>;
export type GetAllToolsInsuranceQueryResult = Apollo.QueryResult<
  GetAllToolsInsuranceQuery,
  GetAllToolsInsuranceQueryVariables
>;
export const GetAllToolsInsuranceParentDocument = gql`
  query GetAllToolsInsuranceParent {
    ToolsInsuranceGetter {
      getAll {
        ... on ToolsInsuranceIndicatorTypes {
          ...fragmentToolsInsurance
        }
      }
    }
  }
  ${FragmentToolsInsuranceFragmentDoc}
`;

/**
 * __useGetAllToolsInsuranceParentQuery__
 *
 * To run a query within a React component, call `useGetAllToolsInsuranceParentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllToolsInsuranceParentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllToolsInsuranceParentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllToolsInsuranceParentQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllToolsInsuranceParentQuery,
    GetAllToolsInsuranceParentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAllToolsInsuranceParentQuery,
    GetAllToolsInsuranceParentQueryVariables
  >(GetAllToolsInsuranceParentDocument, options);
}
export function useGetAllToolsInsuranceParentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllToolsInsuranceParentQuery,
    GetAllToolsInsuranceParentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAllToolsInsuranceParentQuery,
    GetAllToolsInsuranceParentQueryVariables
  >(GetAllToolsInsuranceParentDocument, options);
}
export type GetAllToolsInsuranceParentQueryHookResult = ReturnType<
  typeof useGetAllToolsInsuranceParentQuery
>;
export type GetAllToolsInsuranceParentLazyQueryHookResult = ReturnType<
  typeof useGetAllToolsInsuranceParentLazyQuery
>;
export type GetAllToolsInsuranceParentQueryResult = Apollo.QueryResult<
  GetAllToolsInsuranceParentQuery,
  GetAllToolsInsuranceParentQueryVariables
>;
export const GetGroupsToolsInsuranceDocument = gql`
  query getGroupsToolsInsurance($groupType: ZdGroupType) {
    ToolsInsuranceGetter {
      getGroups(groupType: $groupType)
    }
  }
`;

/**
 * __useGetGroupsToolsInsuranceQuery__
 *
 * To run a query within a React component, call `useGetGroupsToolsInsuranceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsToolsInsuranceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsToolsInsuranceQuery({
 *   variables: {
 *      groupType: // value for 'groupType'
 *   },
 * });
 */
export function useGetGroupsToolsInsuranceQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetGroupsToolsInsuranceQuery,
    GetGroupsToolsInsuranceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetGroupsToolsInsuranceQuery,
    GetGroupsToolsInsuranceQueryVariables
  >(GetGroupsToolsInsuranceDocument, options);
}
export function useGetGroupsToolsInsuranceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGroupsToolsInsuranceQuery,
    GetGroupsToolsInsuranceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetGroupsToolsInsuranceQuery,
    GetGroupsToolsInsuranceQueryVariables
  >(GetGroupsToolsInsuranceDocument, options);
}
export type GetGroupsToolsInsuranceQueryHookResult = ReturnType<
  typeof useGetGroupsToolsInsuranceQuery
>;
export type GetGroupsToolsInsuranceLazyQueryHookResult = ReturnType<
  typeof useGetGroupsToolsInsuranceLazyQuery
>;
export type GetGroupsToolsInsuranceQueryResult = Apollo.QueryResult<
  GetGroupsToolsInsuranceQuery,
  GetGroupsToolsInsuranceQueryVariables
>;
export const GetToolsInsuranceStatusesDocument = gql`
  query GetToolsInsuranceStatuses($UUID: String, $name: String) {
    ToolsInsuranceGetter {
      getDealerStatuses(UUID: $UUID, name: $name) {
        ... on ToolsInsuranceDealerStatuses {
          ...fragmentToolsInsuranceDealerStatuses
        }
      }
    }
  }
  ${FragmentToolsInsuranceDealerStatusesFragmentDoc}
`;

/**
 * __useGetToolsInsuranceStatusesQuery__
 *
 * To run a query within a React component, call `useGetToolsInsuranceStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetToolsInsuranceStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetToolsInsuranceStatusesQuery({
 *   variables: {
 *      UUID: // value for 'UUID'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetToolsInsuranceStatusesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetToolsInsuranceStatusesQuery,
    GetToolsInsuranceStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetToolsInsuranceStatusesQuery,
    GetToolsInsuranceStatusesQueryVariables
  >(GetToolsInsuranceStatusesDocument, options);
}
export function useGetToolsInsuranceStatusesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetToolsInsuranceStatusesQuery,
    GetToolsInsuranceStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetToolsInsuranceStatusesQuery,
    GetToolsInsuranceStatusesQueryVariables
  >(GetToolsInsuranceStatusesDocument, options);
}
export type GetToolsInsuranceStatusesQueryHookResult = ReturnType<
  typeof useGetToolsInsuranceStatusesQuery
>;
export type GetToolsInsuranceStatusesLazyQueryHookResult = ReturnType<
  typeof useGetToolsInsuranceStatusesLazyQuery
>;
export type GetToolsInsuranceStatusesQueryResult = Apollo.QueryResult<
  GetToolsInsuranceStatusesQuery,
  GetToolsInsuranceStatusesQueryVariables
>;
export const GetValuesToolsInsuranceDocument = gql`
  query GetValuesToolsInsurance(
    $DealerId: ID!
    $dateUpTo: DateTime
    $page: Int
    $count: Int
    $name: String
  ) {
    ToolsInsuranceGetter {
      getValues(
        DealerId: $DealerId
        dateUpTo: $dateUpTo
        page: $page
        count: $count
        name: $name
      ) {
        items {
          ... on ToolsInsuranceOneValuesItem {
            ...fragmentValuesToolsInsurance
          }
        }
        total
      }
    }
  }
  ${FragmentValuesToolsInsuranceFragmentDoc}
`;

/**
 * __useGetValuesToolsInsuranceQuery__
 *
 * To run a query within a React component, call `useGetValuesToolsInsuranceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValuesToolsInsuranceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValuesToolsInsuranceQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      dateUpTo: // value for 'dateUpTo'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetValuesToolsInsuranceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetValuesToolsInsuranceQuery,
    GetValuesToolsInsuranceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetValuesToolsInsuranceQuery,
    GetValuesToolsInsuranceQueryVariables
  >(GetValuesToolsInsuranceDocument, options);
}
export function useGetValuesToolsInsuranceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetValuesToolsInsuranceQuery,
    GetValuesToolsInsuranceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetValuesToolsInsuranceQuery,
    GetValuesToolsInsuranceQueryVariables
  >(GetValuesToolsInsuranceDocument, options);
}
export type GetValuesToolsInsuranceQueryHookResult = ReturnType<
  typeof useGetValuesToolsInsuranceQuery
>;
export type GetValuesToolsInsuranceLazyQueryHookResult = ReturnType<
  typeof useGetValuesToolsInsuranceLazyQuery
>;
export type GetValuesToolsInsuranceQueryResult = Apollo.QueryResult<
  GetValuesToolsInsuranceQuery,
  GetValuesToolsInsuranceQueryVariables
>;
export const GetAllToolsMetrologicalDocument = gql`
  query GetAllToolsMetrological {
    ToolsMetrologicalGetter {
      getAll {
        ... on ToolsMetrologicalIndicatorTypes {
          ...fragmentToolsMetrological
        }
      }
    }
  }
  ${FragmentToolsMetrologicalFragmentDoc}
`;

/**
 * __useGetAllToolsMetrologicalQuery__
 *
 * To run a query within a React component, call `useGetAllToolsMetrologicalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllToolsMetrologicalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllToolsMetrologicalQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllToolsMetrologicalQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllToolsMetrologicalQuery,
    GetAllToolsMetrologicalQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAllToolsMetrologicalQuery,
    GetAllToolsMetrologicalQueryVariables
  >(GetAllToolsMetrologicalDocument, options);
}
export function useGetAllToolsMetrologicalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllToolsMetrologicalQuery,
    GetAllToolsMetrologicalQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAllToolsMetrologicalQuery,
    GetAllToolsMetrologicalQueryVariables
  >(GetAllToolsMetrologicalDocument, options);
}
export type GetAllToolsMetrologicalQueryHookResult = ReturnType<
  typeof useGetAllToolsMetrologicalQuery
>;
export type GetAllToolsMetrologicalLazyQueryHookResult = ReturnType<
  typeof useGetAllToolsMetrologicalLazyQuery
>;
export type GetAllToolsMetrologicalQueryResult = Apollo.QueryResult<
  GetAllToolsMetrologicalQuery,
  GetAllToolsMetrologicalQueryVariables
>;
export const GetToolsMetrologicalStatusesDocument = gql`
  query GetToolsMetrologicalStatuses($UUID: String, $name: String) {
    ToolsMetrologicalGetter {
      getDealerStatuses(UUID: $UUID, name: $name) {
        ... on ToolsMetrologicalDealerStatuses {
          ...fragmentToolsMetrologicalDealerStatuses
        }
      }
    }
  }
  ${FragmentToolsMetrologicalDealerStatusesFragmentDoc}
`;

/**
 * __useGetToolsMetrologicalStatusesQuery__
 *
 * To run a query within a React component, call `useGetToolsMetrologicalStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetToolsMetrologicalStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetToolsMetrologicalStatusesQuery({
 *   variables: {
 *      UUID: // value for 'UUID'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetToolsMetrologicalStatusesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetToolsMetrologicalStatusesQuery,
    GetToolsMetrologicalStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetToolsMetrologicalStatusesQuery,
    GetToolsMetrologicalStatusesQueryVariables
  >(GetToolsMetrologicalStatusesDocument, options);
}
export function useGetToolsMetrologicalStatusesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetToolsMetrologicalStatusesQuery,
    GetToolsMetrologicalStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetToolsMetrologicalStatusesQuery,
    GetToolsMetrologicalStatusesQueryVariables
  >(GetToolsMetrologicalStatusesDocument, options);
}
export type GetToolsMetrologicalStatusesQueryHookResult = ReturnType<
  typeof useGetToolsMetrologicalStatusesQuery
>;
export type GetToolsMetrologicalStatusesLazyQueryHookResult = ReturnType<
  typeof useGetToolsMetrologicalStatusesLazyQuery
>;
export type GetToolsMetrologicalStatusesQueryResult = Apollo.QueryResult<
  GetToolsMetrologicalStatusesQuery,
  GetToolsMetrologicalStatusesQueryVariables
>;
export const GetValuesToolsMetrologicalDocument = gql`
  query GetValuesToolsMetrological(
    $DealerId: ID!
    $dateUpTo: DateTime
    $page: Int
    $count: Int
    $name: String
  ) {
    ToolsMetrologicalGetter {
      getValues(
        DealerId: $DealerId
        dateUpTo: $dateUpTo
        page: $page
        count: $count
        name: $name
      ) {
        items {
          ... on ToolsMetrologicalOneValuesItem {
            ...fragmentValuesToolsMetrological
          }
        }
        total
      }
    }
  }
  ${FragmentValuesToolsMetrologicalFragmentDoc}
`;

/**
 * __useGetValuesToolsMetrologicalQuery__
 *
 * To run a query within a React component, call `useGetValuesToolsMetrologicalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValuesToolsMetrologicalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValuesToolsMetrologicalQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      dateUpTo: // value for 'dateUpTo'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetValuesToolsMetrologicalQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetValuesToolsMetrologicalQuery,
    GetValuesToolsMetrologicalQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetValuesToolsMetrologicalQuery,
    GetValuesToolsMetrologicalQueryVariables
  >(GetValuesToolsMetrologicalDocument, options);
}
export function useGetValuesToolsMetrologicalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetValuesToolsMetrologicalQuery,
    GetValuesToolsMetrologicalQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetValuesToolsMetrologicalQuery,
    GetValuesToolsMetrologicalQueryVariables
  >(GetValuesToolsMetrologicalDocument, options);
}
export type GetValuesToolsMetrologicalQueryHookResult = ReturnType<
  typeof useGetValuesToolsMetrologicalQuery
>;
export type GetValuesToolsMetrologicalLazyQueryHookResult = ReturnType<
  typeof useGetValuesToolsMetrologicalLazyQuery
>;
export type GetValuesToolsMetrologicalQueryResult = Apollo.QueryResult<
  GetValuesToolsMetrologicalQuery,
  GetValuesToolsMetrologicalQueryVariables
>;
export const GetAllTradePremisesDocument = gql`
  query GetAllTradePremises {
    TradePremisesGetter {
      getAll {
        ... on TradePremisesIndicatorTypes {
          ...fragmentTradePremisesIndicatorTypes
        }
      }
    }
  }
  ${FragmentTradePremisesIndicatorTypesFragmentDoc}
`;

/**
 * __useGetAllTradePremisesQuery__
 *
 * To run a query within a React component, call `useGetAllTradePremisesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTradePremisesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTradePremisesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllTradePremisesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllTradePremisesQuery,
    GetAllTradePremisesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAllTradePremisesQuery,
    GetAllTradePremisesQueryVariables
  >(GetAllTradePremisesDocument, options);
}
export function useGetAllTradePremisesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllTradePremisesQuery,
    GetAllTradePremisesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAllTradePremisesQuery,
    GetAllTradePremisesQueryVariables
  >(GetAllTradePremisesDocument, options);
}
export type GetAllTradePremisesQueryHookResult = ReturnType<
  typeof useGetAllTradePremisesQuery
>;
export type GetAllTradePremisesLazyQueryHookResult = ReturnType<
  typeof useGetAllTradePremisesLazyQuery
>;
export type GetAllTradePremisesQueryResult = Apollo.QueryResult<
  GetAllTradePremisesQuery,
  GetAllTradePremisesQueryVariables
>;
export const GetDealerStatusesTradePremisesDocument = gql`
  query GetDealerStatusesTradePremises($UUID: String, $name: String) {
    TradePremisesGetter {
      getDealerStatuses(UUID: $UUID, name: $name) {
        ... on TradePremisesDealerStatuses {
          ...fragmentTradePremisesDealerStatuses
        }
      }
    }
  }
  ${FragmentTradePremisesDealerStatusesFragmentDoc}
`;

/**
 * __useGetDealerStatusesTradePremisesQuery__
 *
 * To run a query within a React component, call `useGetDealerStatusesTradePremisesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealerStatusesTradePremisesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealerStatusesTradePremisesQuery({
 *   variables: {
 *      UUID: // value for 'UUID'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetDealerStatusesTradePremisesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDealerStatusesTradePremisesQuery,
    GetDealerStatusesTradePremisesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDealerStatusesTradePremisesQuery,
    GetDealerStatusesTradePremisesQueryVariables
  >(GetDealerStatusesTradePremisesDocument, options);
}
export function useGetDealerStatusesTradePremisesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDealerStatusesTradePremisesQuery,
    GetDealerStatusesTradePremisesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDealerStatusesTradePremisesQuery,
    GetDealerStatusesTradePremisesQueryVariables
  >(GetDealerStatusesTradePremisesDocument, options);
}
export type GetDealerStatusesTradePremisesQueryHookResult = ReturnType<
  typeof useGetDealerStatusesTradePremisesQuery
>;
export type GetDealerStatusesTradePremisesLazyQueryHookResult = ReturnType<
  typeof useGetDealerStatusesTradePremisesLazyQuery
>;
export type GetDealerStatusesTradePremisesQueryResult = Apollo.QueryResult<
  GetDealerStatusesTradePremisesQuery,
  GetDealerStatusesTradePremisesQueryVariables
>;
export const GetValuesTradePremisesDocument = gql`
  query GetValuesTradePremises(
    $DealerId: ID!
    $dateUpTo: DateTime
    $page: Int
    $count: Int
    $name: String
    $sortBy: TradePremisesSortBy = GroupOne
  ) {
    TradePremisesGetter {
      getValues(
        DealerId: $DealerId
        dateUpTo: $dateUpTo
        page: $page
        count: $count
        sortBy: $sortBy
        name: $name
      ) {
        items {
          ... on TradePremisesOneValuesItem {
            ...fragmentTradePremisesOneValuesItem
          }
        }
        total
      }
    }
  }
  ${FragmentTradePremisesOneValuesItemFragmentDoc}
`;

/**
 * __useGetValuesTradePremisesQuery__
 *
 * To run a query within a React component, call `useGetValuesTradePremisesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValuesTradePremisesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValuesTradePremisesQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      dateUpTo: // value for 'dateUpTo'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      name: // value for 'name'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetValuesTradePremisesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetValuesTradePremisesQuery,
    GetValuesTradePremisesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetValuesTradePremisesQuery,
    GetValuesTradePremisesQueryVariables
  >(GetValuesTradePremisesDocument, options);
}
export function useGetValuesTradePremisesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetValuesTradePremisesQuery,
    GetValuesTradePremisesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetValuesTradePremisesQuery,
    GetValuesTradePremisesQueryVariables
  >(GetValuesTradePremisesDocument, options);
}
export type GetValuesTradePremisesQueryHookResult = ReturnType<
  typeof useGetValuesTradePremisesQuery
>;
export type GetValuesTradePremisesLazyQueryHookResult = ReturnType<
  typeof useGetValuesTradePremisesLazyQuery
>;
export type GetValuesTradePremisesQueryResult = Apollo.QueryResult<
  GetValuesTradePremisesQuery,
  GetValuesTradePremisesQueryVariables
>;
export const GetTrustedPersonsDocument = gql`
  query GetTrustedPersons {
    TrustedPersonGetter {
      getTrustedPersons {
        id
        powerOfAttorney
        fio
        shortFio
        descriptionContract
        date
        endDate
        active
      }
    }
  }
`;

/**
 * __useGetTrustedPersonsQuery__
 *
 * To run a query within a React component, call `useGetTrustedPersonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrustedPersonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrustedPersonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTrustedPersonsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetTrustedPersonsQuery,
    GetTrustedPersonsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetTrustedPersonsQuery,
    GetTrustedPersonsQueryVariables
  >(GetTrustedPersonsDocument, options);
}
export function useGetTrustedPersonsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTrustedPersonsQuery,
    GetTrustedPersonsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTrustedPersonsQuery,
    GetTrustedPersonsQueryVariables
  >(GetTrustedPersonsDocument, options);
}
export type GetTrustedPersonsQueryHookResult = ReturnType<
  typeof useGetTrustedPersonsQuery
>;
export type GetTrustedPersonsLazyQueryHookResult = ReturnType<
  typeof useGetTrustedPersonsLazyQuery
>;
export type GetTrustedPersonsQueryResult = Apollo.QueryResult<
  GetTrustedPersonsQuery,
  GetTrustedPersonsQueryVariables
>;
export const GetTrustedPersonByIdDocument = gql`
  query GetTrustedPersonById($getTrustedPersonByIdId: ID!) {
    TrustedPersonGetter {
      getTrustedPersonById(id: $getTrustedPersonByIdId) {
        id
        powerOfAttorney
        fio
        shortFio
        descriptionContract
        date
        endDate
        active
      }
    }
  }
`;

/**
 * __useGetTrustedPersonByIdQuery__
 *
 * To run a query within a React component, call `useGetTrustedPersonByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrustedPersonByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrustedPersonByIdQuery({
 *   variables: {
 *      getTrustedPersonByIdId: // value for 'getTrustedPersonByIdId'
 *   },
 * });
 */
export function useGetTrustedPersonByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTrustedPersonByIdQuery,
    GetTrustedPersonByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetTrustedPersonByIdQuery,
    GetTrustedPersonByIdQueryVariables
  >(GetTrustedPersonByIdDocument, options);
}
export function useGetTrustedPersonByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTrustedPersonByIdQuery,
    GetTrustedPersonByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetTrustedPersonByIdQuery,
    GetTrustedPersonByIdQueryVariables
  >(GetTrustedPersonByIdDocument, options);
}
export type GetTrustedPersonByIdQueryHookResult = ReturnType<
  typeof useGetTrustedPersonByIdQuery
>;
export type GetTrustedPersonByIdLazyQueryHookResult = ReturnType<
  typeof useGetTrustedPersonByIdLazyQuery
>;
export type GetTrustedPersonByIdQueryResult = Apollo.QueryResult<
  GetTrustedPersonByIdQuery,
  GetTrustedPersonByIdQueryVariables
>;
export const GetUsersDocument = gql`
  query GetUsers(
    $searchField: String
    $searchText: String
    $sortField: String
    $sortType: String
    $catalog: String
    $DealerId: ID
    $SubdivisionId: ID
    $ViolationAccess: Boolean
    $EmployeeAccess: Boolean
    $AnnouncementsAccess: Boolean
    $AnnouncementsSend: Boolean
    $ZdAccess: Boolean
    $page: Int
    $count: Int = 25
  ) {
    UserGetter {
      getUsers(
        searchField: $searchField
        searchText: $searchText
        sortField: $sortField
        sortType: $sortType
        catalog: $catalog
        DealerId: $DealerId
        SubdivisionId: $SubdivisionId
        ViolationAccess: $ViolationAccess
        EmployeeAccess: $EmployeeAccess
        AnnouncementsSend: $AnnouncementsSend
        AnnouncementsAccess: $AnnouncementsAccess
        ZdAccess: $ZdAccess
        page: $page
        count: $count
      ) {
        items {
          ... on Profile {
            ...fragmentProfileForTable
          }
        }
        total
      }
    }
  }
  ${FragmentProfileForTableFragmentDoc}
`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      searchField: // value for 'searchField'
 *      searchText: // value for 'searchText'
 *      sortField: // value for 'sortField'
 *      sortType: // value for 'sortType'
 *      catalog: // value for 'catalog'
 *      DealerId: // value for 'DealerId'
 *      SubdivisionId: // value for 'SubdivisionId'
 *      ViolationAccess: // value for 'ViolationAccess'
 *      EmployeeAccess: // value for 'EmployeeAccess'
 *      AnnouncementsAccess: // value for 'AnnouncementsAccess'
 *      AnnouncementsSend: // value for 'AnnouncementsSend'
 *      ZdAccess: // value for 'ZdAccess'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(
    GetUsersDocument,
    options,
  );
}
export function useGetUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUsersQuery,
    GetUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(
    GetUsersDocument,
    options,
  );
}
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<
  typeof useGetUsersLazyQuery
>;
export type GetUsersQueryResult = Apollo.QueryResult<
  GetUsersQuery,
  GetUsersQueryVariables
>;
export const GetFileLinksDocument = gql`
  query GetFileLinks(
    $DealerId: ID
    $catalog: String
    $page: Int
    $count: Int
    $searchText: String
    $searchField: String
    $sortField: String
    $sortType: String
  ) {
    UserGetter {
      getUsers(
        page: $page
        count: $count
        DealerId: $DealerId
        catalog: $catalog
        searchText: $searchText
        searchField: $searchField
        sortField: $sortField
        sortType: $sortType
      ) {
        items {
          id
          fullname
        }
      }
    }
  }
`;

/**
 * __useGetFileLinksQuery__
 *
 * To run a query within a React component, call `useGetFileLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileLinksQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      catalog: // value for 'catalog'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      searchText: // value for 'searchText'
 *      searchField: // value for 'searchField'
 *      sortField: // value for 'sortField'
 *      sortType: // value for 'sortType'
 *   },
 * });
 */
export function useGetFileLinksQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetFileLinksQuery,
    GetFileLinksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFileLinksQuery, GetFileLinksQueryVariables>(
    GetFileLinksDocument,
    options,
  );
}
export function useGetFileLinksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFileLinksQuery,
    GetFileLinksQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFileLinksQuery, GetFileLinksQueryVariables>(
    GetFileLinksDocument,
    options,
  );
}
export type GetFileLinksQueryHookResult = ReturnType<
  typeof useGetFileLinksQuery
>;
export type GetFileLinksLazyQueryHookResult = ReturnType<
  typeof useGetFileLinksLazyQuery
>;
export type GetFileLinksQueryResult = Apollo.QueryResult<
  GetFileLinksQuery,
  GetFileLinksQueryVariables
>;
export const GetProfileDocument = gql`
  query GetProfile($id: ID) {
    UserGetter {
      getProfile(id: $id) {
        ... on Profile {
          ...fragmentProfileForHeader
        }
      }
    }
  }
  ${FragmentProfileForHeaderFragmentDoc}
`;

/**
 * __useGetProfileQuery__
 *
 * To run a query within a React component, call `useGetProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProfileQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetProfileQuery,
    GetProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProfileQuery, GetProfileQueryVariables>(
    GetProfileDocument,
    options,
  );
}
export function useGetProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProfileQuery,
    GetProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProfileQuery, GetProfileQueryVariables>(
    GetProfileDocument,
    options,
  );
}
export type GetProfileQueryHookResult = ReturnType<typeof useGetProfileQuery>;
export type GetProfileLazyQueryHookResult = ReturnType<
  typeof useGetProfileLazyQuery
>;
export type GetProfileQueryResult = Apollo.QueryResult<
  GetProfileQuery,
  GetProfileQueryVariables
>;
export const GetReportRegMenByDealerByPeriodDocument = gql`
  query GetReportRegMenByDealerByPeriod($quarter: Int, $year: Int) {
    UserGetter {
      getReportRegMenByDealerByPeriod(quarter: $quarter, year: $year) {
        ... on ReportRegMenByDealerByPeriod {
          ...fragmentReportRegMenByDealerByPeriod
        }
      }
    }
  }
  ${FragmentReportRegMenByDealerByPeriodFragmentDoc}
`;

/**
 * __useGetReportRegMenByDealerByPeriodQuery__
 *
 * To run a query within a React component, call `useGetReportRegMenByDealerByPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportRegMenByDealerByPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportRegMenByDealerByPeriodQuery({
 *   variables: {
 *      quarter: // value for 'quarter'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useGetReportRegMenByDealerByPeriodQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetReportRegMenByDealerByPeriodQuery,
    GetReportRegMenByDealerByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportRegMenByDealerByPeriodQuery,
    GetReportRegMenByDealerByPeriodQueryVariables
  >(GetReportRegMenByDealerByPeriodDocument, options);
}
export function useGetReportRegMenByDealerByPeriodLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportRegMenByDealerByPeriodQuery,
    GetReportRegMenByDealerByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportRegMenByDealerByPeriodQuery,
    GetReportRegMenByDealerByPeriodQueryVariables
  >(GetReportRegMenByDealerByPeriodDocument, options);
}
export type GetReportRegMenByDealerByPeriodQueryHookResult = ReturnType<
  typeof useGetReportRegMenByDealerByPeriodQuery
>;
export type GetReportRegMenByDealerByPeriodLazyQueryHookResult = ReturnType<
  typeof useGetReportRegMenByDealerByPeriodLazyQuery
>;
export type GetReportRegMenByDealerByPeriodQueryResult = Apollo.QueryResult<
  GetReportRegMenByDealerByPeriodQuery,
  GetReportRegMenByDealerByPeriodQueryVariables
>;
export const GetReportFileRegMenByDealerByPeriodDocument = gql`
  query GetReportFileRegMenByDealerByPeriod($quarter: Int, $year: Int) {
    UserGetter {
      getReportFileRegMenByDealerByPeriod(quarter: $quarter, year: $year) {
        ... on ReportFile {
          fileHash
        }
      }
    }
  }
`;

/**
 * __useGetReportFileRegMenByDealerByPeriodQuery__
 *
 * To run a query within a React component, call `useGetReportFileRegMenByDealerByPeriodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportFileRegMenByDealerByPeriodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportFileRegMenByDealerByPeriodQuery({
 *   variables: {
 *      quarter: // value for 'quarter'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useGetReportFileRegMenByDealerByPeriodQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetReportFileRegMenByDealerByPeriodQuery,
    GetReportFileRegMenByDealerByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportFileRegMenByDealerByPeriodQuery,
    GetReportFileRegMenByDealerByPeriodQueryVariables
  >(GetReportFileRegMenByDealerByPeriodDocument, options);
}
export function useGetReportFileRegMenByDealerByPeriodLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportFileRegMenByDealerByPeriodQuery,
    GetReportFileRegMenByDealerByPeriodQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportFileRegMenByDealerByPeriodQuery,
    GetReportFileRegMenByDealerByPeriodQueryVariables
  >(GetReportFileRegMenByDealerByPeriodDocument, options);
}
export type GetReportFileRegMenByDealerByPeriodQueryHookResult = ReturnType<
  typeof useGetReportFileRegMenByDealerByPeriodQuery
>;
export type GetReportFileRegMenByDealerByPeriodLazyQueryHookResult = ReturnType<
  typeof useGetReportFileRegMenByDealerByPeriodLazyQuery
>;
export type GetReportFileRegMenByDealerByPeriodQueryResult = Apollo.QueryResult<
  GetReportFileRegMenByDealerByPeriodQuery,
  GetReportFileRegMenByDealerByPeriodQueryVariables
>;
export const GetReportRegMenByDealerByDealerDocument = gql`
  query GetReportRegMenByDealerByDealer($dealerId: ID) {
    UserGetter {
      getReportRegMenByDealerByDealer(dealerId: $dealerId) {
        ... on ReportRegMenByDealerByDealer {
          ...fragmentReportRegMenByDealerByDealer
        }
      }
    }
  }
  ${FragmentReportRegMenByDealerByDealerFragmentDoc}
`;

/**
 * __useGetReportRegMenByDealerByDealerQuery__
 *
 * To run a query within a React component, call `useGetReportRegMenByDealerByDealerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportRegMenByDealerByDealerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportRegMenByDealerByDealerQuery({
 *   variables: {
 *      dealerId: // value for 'dealerId'
 *   },
 * });
 */
export function useGetReportRegMenByDealerByDealerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetReportRegMenByDealerByDealerQuery,
    GetReportRegMenByDealerByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportRegMenByDealerByDealerQuery,
    GetReportRegMenByDealerByDealerQueryVariables
  >(GetReportRegMenByDealerByDealerDocument, options);
}
export function useGetReportRegMenByDealerByDealerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportRegMenByDealerByDealerQuery,
    GetReportRegMenByDealerByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportRegMenByDealerByDealerQuery,
    GetReportRegMenByDealerByDealerQueryVariables
  >(GetReportRegMenByDealerByDealerDocument, options);
}
export type GetReportRegMenByDealerByDealerQueryHookResult = ReturnType<
  typeof useGetReportRegMenByDealerByDealerQuery
>;
export type GetReportRegMenByDealerByDealerLazyQueryHookResult = ReturnType<
  typeof useGetReportRegMenByDealerByDealerLazyQuery
>;
export type GetReportRegMenByDealerByDealerQueryResult = Apollo.QueryResult<
  GetReportRegMenByDealerByDealerQuery,
  GetReportRegMenByDealerByDealerQueryVariables
>;
export const GetReportFileRegMenByDealerByDealerDocument = gql`
  query GetReportFileRegMenByDealerByDealer($dealerId: ID) {
    UserGetter {
      getReportFileRegMenByDealerByDealer(dealerId: $dealerId) {
        ... on ReportFile {
          fileHash
        }
      }
    }
  }
`;

/**
 * __useGetReportFileRegMenByDealerByDealerQuery__
 *
 * To run a query within a React component, call `useGetReportFileRegMenByDealerByDealerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportFileRegMenByDealerByDealerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportFileRegMenByDealerByDealerQuery({
 *   variables: {
 *      dealerId: // value for 'dealerId'
 *   },
 * });
 */
export function useGetReportFileRegMenByDealerByDealerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetReportFileRegMenByDealerByDealerQuery,
    GetReportFileRegMenByDealerByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportFileRegMenByDealerByDealerQuery,
    GetReportFileRegMenByDealerByDealerQueryVariables
  >(GetReportFileRegMenByDealerByDealerDocument, options);
}
export function useGetReportFileRegMenByDealerByDealerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportFileRegMenByDealerByDealerQuery,
    GetReportFileRegMenByDealerByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportFileRegMenByDealerByDealerQuery,
    GetReportFileRegMenByDealerByDealerQueryVariables
  >(GetReportFileRegMenByDealerByDealerDocument, options);
}
export type GetReportFileRegMenByDealerByDealerQueryHookResult = ReturnType<
  typeof useGetReportFileRegMenByDealerByDealerQuery
>;
export type GetReportFileRegMenByDealerByDealerLazyQueryHookResult = ReturnType<
  typeof useGetReportFileRegMenByDealerByDealerLazyQuery
>;
export type GetReportFileRegMenByDealerByDealerQueryResult = Apollo.QueryResult<
  GetReportFileRegMenByDealerByDealerQuery,
  GetReportFileRegMenByDealerByDealerQueryVariables
>;
export const GetReportRegMenByDealerConsolidateDocument = gql`
  query GetReportRegMenByDealerConsolidate {
    UserGetter {
      getReportRegMenByDealerConsolidate {
        ... on ReportRegMenByDealerConsolidate {
          ...fragmentReportRegMenByDealerConsolidate
        }
      }
    }
  }
  ${FragmentReportRegMenByDealerConsolidateFragmentDoc}
`;

/**
 * __useGetReportRegMenByDealerConsolidateQuery__
 *
 * To run a query within a React component, call `useGetReportRegMenByDealerConsolidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportRegMenByDealerConsolidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportRegMenByDealerConsolidateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReportRegMenByDealerConsolidateQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetReportRegMenByDealerConsolidateQuery,
    GetReportRegMenByDealerConsolidateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportRegMenByDealerConsolidateQuery,
    GetReportRegMenByDealerConsolidateQueryVariables
  >(GetReportRegMenByDealerConsolidateDocument, options);
}
export function useGetReportRegMenByDealerConsolidateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportRegMenByDealerConsolidateQuery,
    GetReportRegMenByDealerConsolidateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportRegMenByDealerConsolidateQuery,
    GetReportRegMenByDealerConsolidateQueryVariables
  >(GetReportRegMenByDealerConsolidateDocument, options);
}
export type GetReportRegMenByDealerConsolidateQueryHookResult = ReturnType<
  typeof useGetReportRegMenByDealerConsolidateQuery
>;
export type GetReportRegMenByDealerConsolidateLazyQueryHookResult = ReturnType<
  typeof useGetReportRegMenByDealerConsolidateLazyQuery
>;
export type GetReportRegMenByDealerConsolidateQueryResult = Apollo.QueryResult<
  GetReportRegMenByDealerConsolidateQuery,
  GetReportRegMenByDealerConsolidateQueryVariables
>;
export const GetReportFileRegMenByDealerConsolidateDocument = gql`
  query GetReportFileRegMenByDealerConsolidate {
    UserGetter {
      getReportFileRegMenByDealerConsolidate {
        ... on ReportFile {
          fileHash
        }
      }
    }
  }
`;

/**
 * __useGetReportFileRegMenByDealerConsolidateQuery__
 *
 * To run a query within a React component, call `useGetReportFileRegMenByDealerConsolidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportFileRegMenByDealerConsolidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportFileRegMenByDealerConsolidateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReportFileRegMenByDealerConsolidateQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetReportFileRegMenByDealerConsolidateQuery,
    GetReportFileRegMenByDealerConsolidateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportFileRegMenByDealerConsolidateQuery,
    GetReportFileRegMenByDealerConsolidateQueryVariables
  >(GetReportFileRegMenByDealerConsolidateDocument, options);
}
export function useGetReportFileRegMenByDealerConsolidateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportFileRegMenByDealerConsolidateQuery,
    GetReportFileRegMenByDealerConsolidateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportFileRegMenByDealerConsolidateQuery,
    GetReportFileRegMenByDealerConsolidateQueryVariables
  >(GetReportFileRegMenByDealerConsolidateDocument, options);
}
export type GetReportFileRegMenByDealerConsolidateQueryHookResult = ReturnType<
  typeof useGetReportFileRegMenByDealerConsolidateQuery
>;
export type GetReportFileRegMenByDealerConsolidateLazyQueryHookResult =
  ReturnType<typeof useGetReportFileRegMenByDealerConsolidateLazyQuery>;
export type GetReportFileRegMenByDealerConsolidateQueryResult =
  Apollo.QueryResult<
    GetReportFileRegMenByDealerConsolidateQuery,
    GetReportFileRegMenByDealerConsolidateQueryVariables
  >;
export const GetReportFileRegMenByDealerByRegMenDocument = gql`
  query GetReportFileRegMenByDealerByRegMen($userId: ID) {
    UserGetter {
      getReportFileRegMenByDealerByRegMen(userId: $userId) {
        ... on ReportFile {
          fileHash
        }
      }
    }
  }
`;

/**
 * __useGetReportFileRegMenByDealerByRegMenQuery__
 *
 * To run a query within a React component, call `useGetReportFileRegMenByDealerByRegMenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportFileRegMenByDealerByRegMenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportFileRegMenByDealerByRegMenQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetReportFileRegMenByDealerByRegMenQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetReportFileRegMenByDealerByRegMenQuery,
    GetReportFileRegMenByDealerByRegMenQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportFileRegMenByDealerByRegMenQuery,
    GetReportFileRegMenByDealerByRegMenQueryVariables
  >(GetReportFileRegMenByDealerByRegMenDocument, options);
}
export function useGetReportFileRegMenByDealerByRegMenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportFileRegMenByDealerByRegMenQuery,
    GetReportFileRegMenByDealerByRegMenQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportFileRegMenByDealerByRegMenQuery,
    GetReportFileRegMenByDealerByRegMenQueryVariables
  >(GetReportFileRegMenByDealerByRegMenDocument, options);
}
export type GetReportFileRegMenByDealerByRegMenQueryHookResult = ReturnType<
  typeof useGetReportFileRegMenByDealerByRegMenQuery
>;
export type GetReportFileRegMenByDealerByRegMenLazyQueryHookResult = ReturnType<
  typeof useGetReportFileRegMenByDealerByRegMenLazyQuery
>;
export type GetReportFileRegMenByDealerByRegMenQueryResult = Apollo.QueryResult<
  GetReportFileRegMenByDealerByRegMenQuery,
  GetReportFileRegMenByDealerByRegMenQueryVariables
>;
export const GetReportRegMenByDealerByRegMenDocument = gql`
  query GetReportRegMenByDealerByRegMen($userId: ID) {
    UserGetter {
      getReportRegMenByDealerByRegMen(userId: $userId) {
        ... on ReportRegMenByDealerByRegMen {
          ...fragmentReportRegMenByDealerByRegMen
        }
      }
    }
  }
  ${FragmentReportRegMenByDealerByRegMenFragmentDoc}
`;

/**
 * __useGetReportRegMenByDealerByRegMenQuery__
 *
 * To run a query within a React component, call `useGetReportRegMenByDealerByRegMenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportRegMenByDealerByRegMenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportRegMenByDealerByRegMenQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetReportRegMenByDealerByRegMenQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetReportRegMenByDealerByRegMenQuery,
    GetReportRegMenByDealerByRegMenQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportRegMenByDealerByRegMenQuery,
    GetReportRegMenByDealerByRegMenQueryVariables
  >(GetReportRegMenByDealerByRegMenDocument, options);
}
export function useGetReportRegMenByDealerByRegMenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportRegMenByDealerByRegMenQuery,
    GetReportRegMenByDealerByRegMenQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportRegMenByDealerByRegMenQuery,
    GetReportRegMenByDealerByRegMenQueryVariables
  >(GetReportRegMenByDealerByRegMenDocument, options);
}
export type GetReportRegMenByDealerByRegMenQueryHookResult = ReturnType<
  typeof useGetReportRegMenByDealerByRegMenQuery
>;
export type GetReportRegMenByDealerByRegMenLazyQueryHookResult = ReturnType<
  typeof useGetReportRegMenByDealerByRegMenLazyQuery
>;
export type GetReportRegMenByDealerByRegMenQueryResult = Apollo.QueryResult<
  GetReportRegMenByDealerByRegMenQuery,
  GetReportRegMenByDealerByRegMenQueryVariables
>;
export const GetRegMensDocument = gql`
  query GetRegMens(
    $searchField: String
    $searchText: String
    $sortField: String
    $sortType: String
    $page: Int = 0
    $count: Int = 10
  ) {
    UserGetter {
      getRegMens(
        searchText: $searchText
        searchField: $searchField
        sortField: $sortField
        sortType: $sortType
        page: $page
        count: $count
      ) {
        items {
          ... on RegMens {
            id
            fullname
            fullnameEn
            roleRu
            roleEn
          }
        }
      }
    }
  }
`;

/**
 * __useGetRegMensQuery__
 *
 * To run a query within a React component, call `useGetRegMensQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegMensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegMensQuery({
 *   variables: {
 *      searchField: // value for 'searchField'
 *      searchText: // value for 'searchText'
 *      sortField: // value for 'sortField'
 *      sortType: // value for 'sortType'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetRegMensQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetRegMensQuery,
    GetRegMensQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRegMensQuery, GetRegMensQueryVariables>(
    GetRegMensDocument,
    options,
  );
}
export function useGetRegMensLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRegMensQuery,
    GetRegMensQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRegMensQuery, GetRegMensQueryVariables>(
    GetRegMensDocument,
    options,
  );
}
export type GetRegMensQueryHookResult = ReturnType<typeof useGetRegMensQuery>;
export type GetRegMensLazyQueryHookResult = ReturnType<
  typeof useGetRegMensLazyQuery
>;
export type GetRegMensQueryResult = Apollo.QueryResult<
  GetRegMensQuery,
  GetRegMensQueryVariables
>;
export const GetDataProfileDocument = gql`
  query GetDataProfile($id: ID) {
    UserGetter {
      getProfile(id: $id) {
        id
        login
        fullname
        phone
        position
        email
        role
        roleRu
      }
    }
  }
`;

/**
 * __useGetDataProfileQuery__
 *
 * To run a query within a React component, call `useGetDataProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDataProfileQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDataProfileQuery,
    GetDataProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDataProfileQuery, GetDataProfileQueryVariables>(
    GetDataProfileDocument,
    options,
  );
}
export function useGetDataProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDataProfileQuery,
    GetDataProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDataProfileQuery, GetDataProfileQueryVariables>(
    GetDataProfileDocument,
    options,
  );
}
export type GetDataProfileQueryHookResult = ReturnType<
  typeof useGetDataProfileQuery
>;
export type GetDataProfileLazyQueryHookResult = ReturnType<
  typeof useGetDataProfileLazyQuery
>;
export type GetDataProfileQueryResult = Apollo.QueryResult<
  GetDataProfileQuery,
  GetDataProfileQueryVariables
>;
export const GetGuideFileDocument = gql`
  query GetGuideFile {
    UserGuideGetter {
      getGuideFile {
        AdminFileId
        AdminFile {
          id
          User {
            id
            login
            email
            fullname
            role
          }
          name
          link
          mimeType
          createdAt
          type
          hash
        }
        UserFileId
        UserFile {
          id
          User {
            id
            login
            email
            fullname
            role
          }
          name
          link
          mimeType
          createdAt
          type
          hash
        }
      }
    }
  }
`;

/**
 * __useGetGuideFileQuery__
 *
 * To run a query within a React component, call `useGetGuideFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuideFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuideFileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGuideFileQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetGuideFileQuery,
    GetGuideFileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetGuideFileQuery, GetGuideFileQueryVariables>(
    GetGuideFileDocument,
    options,
  );
}
export function useGetGuideFileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGuideFileQuery,
    GetGuideFileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetGuideFileQuery, GetGuideFileQueryVariables>(
    GetGuideFileDocument,
    options,
  );
}
export type GetGuideFileQueryHookResult = ReturnType<
  typeof useGetGuideFileQuery
>;
export type GetGuideFileLazyQueryHookResult = ReturnType<
  typeof useGetGuideFileLazyQuery
>;
export type GetGuideFileQueryResult = Apollo.QueryResult<
  GetGuideFileQuery,
  GetGuideFileQueryVariables
>;
export const GetViolationsAllDocument = gql`
  query GetViolationsAll(
    $order: sortType = DESC
    $orderBy: OrderByColumnInViolation = createdAt
    $statusFilter: ViolationStatus
    $FoFilter: String
    $regionFilter: String
    $documentFilter: filterExistenceType
    $dealerCandidate: String
    $dealerIdFilter: ID
    $fromFilter: DateTime
    $fromCreatedAt: DateTime
    $toFilter: DateTime
    $toCreatedAt: DateTime
    $violationTypesIdFilter: ID
    $subdivisionIdFilter: ID
    $categoryFilter: ViolationTypeCategory
    $page: Int
    $count: Int
  ) {
    ViolationGetter {
      getAll(
        order: $order
        orderBy: $orderBy
        statusFilter: $statusFilter
        FoFilter: $FoFilter
        documentFilter: $documentFilter
        regionFilter: $regionFilter
        dealerIdFilter: $dealerIdFilter
        dealerCandidate: $dealerCandidate
        fromFilter: $fromFilter
        fromCreatedAt: $fromCreatedAt
        toFilter: $toFilter
        toCreatedAt: $toCreatedAt
        violationTypesIdFilter: $violationTypesIdFilter
        subdivisionIdFilter: $subdivisionIdFilter
        categoryFilter: $categoryFilter
        page: $page
        count: $count
      ) {
        items {
          ... on ViolationInclude {
            ...fragmentGetViolation
          }
        }
        total
      }
    }
  }
  ${FragmentGetViolationFragmentDoc}
`;

/**
 * __useGetViolationsAllQuery__
 *
 * To run a query within a React component, call `useGetViolationsAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViolationsAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViolationsAllQuery({
 *   variables: {
 *      order: // value for 'order'
 *      orderBy: // value for 'orderBy'
 *      statusFilter: // value for 'statusFilter'
 *      FoFilter: // value for 'FoFilter'
 *      regionFilter: // value for 'regionFilter'
 *      documentFilter: // value for 'documentFilter'
 *      dealerCandidate: // value for 'dealerCandidate'
 *      dealerIdFilter: // value for 'dealerIdFilter'
 *      fromFilter: // value for 'fromFilter'
 *      fromCreatedAt: // value for 'fromCreatedAt'
 *      toFilter: // value for 'toFilter'
 *      toCreatedAt: // value for 'toCreatedAt'
 *      violationTypesIdFilter: // value for 'violationTypesIdFilter'
 *      subdivisionIdFilter: // value for 'subdivisionIdFilter'
 *      categoryFilter: // value for 'categoryFilter'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetViolationsAllQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetViolationsAllQuery,
    GetViolationsAllQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetViolationsAllQuery, GetViolationsAllQueryVariables>(
    GetViolationsAllDocument,
    options,
  );
}
export function useGetViolationsAllLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetViolationsAllQuery,
    GetViolationsAllQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetViolationsAllQuery,
    GetViolationsAllQueryVariables
  >(GetViolationsAllDocument, options);
}
export type GetViolationsAllQueryHookResult = ReturnType<
  typeof useGetViolationsAllQuery
>;
export type GetViolationsAllLazyQueryHookResult = ReturnType<
  typeof useGetViolationsAllLazyQuery
>;
export type GetViolationsAllQueryResult = Apollo.QueryResult<
  GetViolationsAllQuery,
  GetViolationsAllQueryVariables
>;
export const GetViolationByIdDocument = gql`
  query GetViolationById($id: ID) {
    ViolationGetter {
      getById(id: $id) {
        ... on ViolationInclude {
          ...fragmentGetViolation
        }
      }
    }
  }
  ${FragmentGetViolationFragmentDoc}
`;

/**
 * __useGetViolationByIdQuery__
 *
 * To run a query within a React component, call `useGetViolationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViolationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViolationByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetViolationByIdQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetViolationByIdQuery,
    GetViolationByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetViolationByIdQuery, GetViolationByIdQueryVariables>(
    GetViolationByIdDocument,
    options,
  );
}
export function useGetViolationByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetViolationByIdQuery,
    GetViolationByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetViolationByIdQuery,
    GetViolationByIdQueryVariables
  >(GetViolationByIdDocument, options);
}
export type GetViolationByIdQueryHookResult = ReturnType<
  typeof useGetViolationByIdQuery
>;
export type GetViolationByIdLazyQueryHookResult = ReturnType<
  typeof useGetViolationByIdLazyQuery
>;
export type GetViolationByIdQueryResult = Apollo.QueryResult<
  GetViolationByIdQuery,
  GetViolationByIdQueryVariables
>;
export const GetViolationCommentsDocument = gql`
  query GetViolationComments($id: ID, $page: Int = 0, $count: Int = 10) {
    ViolationGetter {
      getComments(id: $id, page: $page, count: $count) {
        items {
          ... on ViolationComment {
            ...fragmentGetViolationComment
          }
        }
        total
      }
    }
  }
  ${FragmentGetViolationCommentFragmentDoc}
`;

/**
 * __useGetViolationCommentsQuery__
 *
 * To run a query within a React component, call `useGetViolationCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViolationCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViolationCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetViolationCommentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetViolationCommentsQuery,
    GetViolationCommentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetViolationCommentsQuery,
    GetViolationCommentsQueryVariables
  >(GetViolationCommentsDocument, options);
}
export function useGetViolationCommentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetViolationCommentsQuery,
    GetViolationCommentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetViolationCommentsQuery,
    GetViolationCommentsQueryVariables
  >(GetViolationCommentsDocument, options);
}
export type GetViolationCommentsQueryHookResult = ReturnType<
  typeof useGetViolationCommentsQuery
>;
export type GetViolationCommentsLazyQueryHookResult = ReturnType<
  typeof useGetViolationCommentsLazyQuery
>;
export type GetViolationCommentsQueryResult = Apollo.QueryResult<
  GetViolationCommentsQuery,
  GetViolationCommentsQueryVariables
>;
export const GetReportByDealerDocument = gql`
  query GetReportByDealer(
    $dateBegin: DateTime
    $dateEnd: DateTime
    $dealerCandidate: String
  ) {
    ViolationGetter {
      getReportByDealer(
        dateBegin: $dateBegin
        dateEnd: $dateEnd
        dealerCandidate: $dealerCandidate
      ) {
        ... on ReportFile {
          fileHash
        }
      }
    }
  }
`;

/**
 * __useGetReportByDealerQuery__
 *
 * To run a query within a React component, call `useGetReportByDealerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportByDealerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportByDealerQuery({
 *   variables: {
 *      dateBegin: // value for 'dateBegin'
 *      dateEnd: // value for 'dateEnd'
 *      dealerCandidate: // value for 'dealerCandidate'
 *   },
 * });
 */
export function useGetReportByDealerQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetReportByDealerQuery,
    GetReportByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportByDealerQuery,
    GetReportByDealerQueryVariables
  >(GetReportByDealerDocument, options);
}
export function useGetReportByDealerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportByDealerQuery,
    GetReportByDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportByDealerQuery,
    GetReportByDealerQueryVariables
  >(GetReportByDealerDocument, options);
}
export type GetReportByDealerQueryHookResult = ReturnType<
  typeof useGetReportByDealerQuery
>;
export type GetReportByDealerLazyQueryHookResult = ReturnType<
  typeof useGetReportByDealerLazyQuery
>;
export type GetReportByDealerQueryResult = Apollo.QueryResult<
  GetReportByDealerQuery,
  GetReportByDealerQueryVariables
>;
export const GetAllReportViolationsDocument = gql`
  query GetAllReportViolations(
    $documentFilter: filterExistenceType
    $statusFilter: ViolationStatus
    $FoFilter: String
    $regionFilter: String
    $dealerIdFilter: ID
    $dealerCandidate: String
    $fromFilter: DateTime
    $toFilter: DateTime
    $fromCreatedAt: DateTime
    $toCreatedAt: DateTime
    $violationTypesIdFilter: ID
    $subdivisionIdFilter: ID
    $categoryFilter: ViolationTypeCategory
  ) {
    ViolationGetter {
      getAllReport(
        documentFilter: $documentFilter
        statusFilter: $statusFilter
        FoFilter: $FoFilter
        regionFilter: $regionFilter
        dealerIdFilter: $dealerIdFilter
        dealerCandidate: $dealerCandidate
        fromFilter: $fromFilter
        toFilter: $toFilter
        fromCreatedAt: $fromCreatedAt
        toCreatedAt: $toCreatedAt
        violationTypesIdFilter: $violationTypesIdFilter
        subdivisionIdFilter: $subdivisionIdFilter
        categoryFilter: $categoryFilter
      ) {
        ... on ReportFile {
          fileHash
        }
      }
    }
  }
`;

/**
 * __useGetAllReportViolationsQuery__
 *
 * To run a query within a React component, call `useGetAllReportViolationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllReportViolationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllReportViolationsQuery({
 *   variables: {
 *      documentFilter: // value for 'documentFilter'
 *      statusFilter: // value for 'statusFilter'
 *      FoFilter: // value for 'FoFilter'
 *      regionFilter: // value for 'regionFilter'
 *      dealerIdFilter: // value for 'dealerIdFilter'
 *      dealerCandidate: // value for 'dealerCandidate'
 *      fromFilter: // value for 'fromFilter'
 *      toFilter: // value for 'toFilter'
 *      fromCreatedAt: // value for 'fromCreatedAt'
 *      toCreatedAt: // value for 'toCreatedAt'
 *      violationTypesIdFilter: // value for 'violationTypesIdFilter'
 *      subdivisionIdFilter: // value for 'subdivisionIdFilter'
 *      categoryFilter: // value for 'categoryFilter'
 *   },
 * });
 */
export function useGetAllReportViolationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllReportViolationsQuery,
    GetAllReportViolationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAllReportViolationsQuery,
    GetAllReportViolationsQueryVariables
  >(GetAllReportViolationsDocument, options);
}
export function useGetAllReportViolationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllReportViolationsQuery,
    GetAllReportViolationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAllReportViolationsQuery,
    GetAllReportViolationsQueryVariables
  >(GetAllReportViolationsDocument, options);
}
export type GetAllReportViolationsQueryHookResult = ReturnType<
  typeof useGetAllReportViolationsQuery
>;
export type GetAllReportViolationsLazyQueryHookResult = ReturnType<
  typeof useGetAllReportViolationsLazyQuery
>;
export type GetAllReportViolationsQueryResult = Apollo.QueryResult<
  GetAllReportViolationsQuery,
  GetAllReportViolationsQueryVariables
>;
export const GetViolationTypesDocument = gql`
  query GetViolationTypes(
    $order: sortType = ASC
    $orderBy: OrderByColumnInViolationTypes = id
    $status: ViolationStatusType
    $name: String
    $SubdivisionId: ID
    $category: ViolationTypeCategory
    $page: Int = 0
    $count: Int = 10
  ) {
    ViolationTypesGetter {
      get(
        order: $order
        orderBy: $orderBy
        status: $status
        name: $name
        SubdivisionId: $SubdivisionId
        category: $category
        page: $page
        count: $count
      ) {
        items {
          ... on ViolationType {
            ...fragmentViolationType
          }
        }
        total
      }
    }
  }
  ${FragmentViolationTypeFragmentDoc}
`;

/**
 * __useGetViolationTypesQuery__
 *
 * To run a query within a React component, call `useGetViolationTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViolationTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViolationTypesQuery({
 *   variables: {
 *      order: // value for 'order'
 *      orderBy: // value for 'orderBy'
 *      status: // value for 'status'
 *      name: // value for 'name'
 *      SubdivisionId: // value for 'SubdivisionId'
 *      category: // value for 'category'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetViolationTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetViolationTypesQuery,
    GetViolationTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetViolationTypesQuery,
    GetViolationTypesQueryVariables
  >(GetViolationTypesDocument, options);
}
export function useGetViolationTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetViolationTypesQuery,
    GetViolationTypesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetViolationTypesQuery,
    GetViolationTypesQueryVariables
  >(GetViolationTypesDocument, options);
}
export type GetViolationTypesQueryHookResult = ReturnType<
  typeof useGetViolationTypesQuery
>;
export type GetViolationTypesLazyQueryHookResult = ReturnType<
  typeof useGetViolationTypesLazyQuery
>;
export type GetViolationTypesQueryResult = Apollo.QueryResult<
  GetViolationTypesQuery,
  GetViolationTypesQueryVariables
>;
export const GetViolationTypesDeleteDocument = gql`
  query GetViolationTypesDelete($id: ID) {
    ViolationTypesGetter {
      delete(id: $id)
    }
  }
`;

/**
 * __useGetViolationTypesDeleteQuery__
 *
 * To run a query within a React component, call `useGetViolationTypesDeleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViolationTypesDeleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViolationTypesDeleteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetViolationTypesDeleteQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetViolationTypesDeleteQuery,
    GetViolationTypesDeleteQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetViolationTypesDeleteQuery,
    GetViolationTypesDeleteQueryVariables
  >(GetViolationTypesDeleteDocument, options);
}
export function useGetViolationTypesDeleteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetViolationTypesDeleteQuery,
    GetViolationTypesDeleteQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetViolationTypesDeleteQuery,
    GetViolationTypesDeleteQueryVariables
  >(GetViolationTypesDeleteDocument, options);
}
export type GetViolationTypesDeleteQueryHookResult = ReturnType<
  typeof useGetViolationTypesDeleteQuery
>;
export type GetViolationTypesDeleteLazyQueryHookResult = ReturnType<
  typeof useGetViolationTypesDeleteLazyQuery
>;
export type GetViolationTypesDeleteQueryResult = Apollo.QueryResult<
  GetViolationTypesDeleteQuery,
  GetViolationTypesDeleteQueryVariables
>;
export const GetViolationTypesForSelectDocument = gql`
  query GetViolationTypesForSelect(
    $page: Int
    $name: String
    $count: Int = 10
    $status: ViolationStatusType
  ) {
    ViolationTypesGetter {
      get(page: $page, name: $name, count: $count, status: $status) {
        items {
          ... on ViolationType {
            ...fragmentViolationTypeForSelect
          }
        }
      }
    }
  }
  ${FragmentViolationTypeForSelectFragmentDoc}
`;

/**
 * __useGetViolationTypesForSelectQuery__
 *
 * To run a query within a React component, call `useGetViolationTypesForSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViolationTypesForSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViolationTypesForSelectQuery({
 *   variables: {
 *      page: // value for 'page'
 *      name: // value for 'name'
 *      count: // value for 'count'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetViolationTypesForSelectQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetViolationTypesForSelectQuery,
    GetViolationTypesForSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetViolationTypesForSelectQuery,
    GetViolationTypesForSelectQueryVariables
  >(GetViolationTypesForSelectDocument, options);
}
export function useGetViolationTypesForSelectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetViolationTypesForSelectQuery,
    GetViolationTypesForSelectQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetViolationTypesForSelectQuery,
    GetViolationTypesForSelectQueryVariables
  >(GetViolationTypesForSelectDocument, options);
}
export type GetViolationTypesForSelectQueryHookResult = ReturnType<
  typeof useGetViolationTypesForSelectQuery
>;
export type GetViolationTypesForSelectLazyQueryHookResult = ReturnType<
  typeof useGetViolationTypesForSelectLazyQuery
>;
export type GetViolationTypesForSelectQueryResult = Apollo.QueryResult<
  GetViolationTypesForSelectQuery,
  GetViolationTypesForSelectQueryVariables
>;
export const GetAllWarehousesDocument = gql`
  query GetAllWarehouses {
    WarehousesGetter {
      getAll {
        ... on WarehousesIndicatorTypes {
          ...fragmentWarehouses
        }
      }
    }
  }
  ${FragmentWarehousesFragmentDoc}
`;

/**
 * __useGetAllWarehousesQuery__
 *
 * To run a query within a React component, call `useGetAllWarehousesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllWarehousesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllWarehousesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllWarehousesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllWarehousesQuery,
    GetAllWarehousesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAllWarehousesQuery, GetAllWarehousesQueryVariables>(
    GetAllWarehousesDocument,
    options,
  );
}
export function useGetAllWarehousesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllWarehousesQuery,
    GetAllWarehousesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAllWarehousesQuery,
    GetAllWarehousesQueryVariables
  >(GetAllWarehousesDocument, options);
}
export type GetAllWarehousesQueryHookResult = ReturnType<
  typeof useGetAllWarehousesQuery
>;
export type GetAllWarehousesLazyQueryHookResult = ReturnType<
  typeof useGetAllWarehousesLazyQuery
>;
export type GetAllWarehousesQueryResult = Apollo.QueryResult<
  GetAllWarehousesQuery,
  GetAllWarehousesQueryVariables
>;
export const GetWarehousesStatusesDocument = gql`
  query GetWarehousesStatuses($UUID: String, $name: String) {
    WarehousesGetter {
      getDealerStatuses(UUID: $UUID, name: $name) {
        ... on WarehousesDealerStatuses {
          ...fragmentWarehousesDealerStatuses
        }
      }
    }
  }
  ${FragmentWarehousesDealerStatusesFragmentDoc}
`;

/**
 * __useGetWarehousesStatusesQuery__
 *
 * To run a query within a React component, call `useGetWarehousesStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWarehousesStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWarehousesStatusesQuery({
 *   variables: {
 *      UUID: // value for 'UUID'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetWarehousesStatusesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetWarehousesStatusesQuery,
    GetWarehousesStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWarehousesStatusesQuery,
    GetWarehousesStatusesQueryVariables
  >(GetWarehousesStatusesDocument, options);
}
export function useGetWarehousesStatusesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWarehousesStatusesQuery,
    GetWarehousesStatusesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWarehousesStatusesQuery,
    GetWarehousesStatusesQueryVariables
  >(GetWarehousesStatusesDocument, options);
}
export type GetWarehousesStatusesQueryHookResult = ReturnType<
  typeof useGetWarehousesStatusesQuery
>;
export type GetWarehousesStatusesLazyQueryHookResult = ReturnType<
  typeof useGetWarehousesStatusesLazyQuery
>;
export type GetWarehousesStatusesQueryResult = Apollo.QueryResult<
  GetWarehousesStatusesQuery,
  GetWarehousesStatusesQueryVariables
>;
export const GetValuesWarehousesDocument = gql`
  query GetValuesWarehouses(
    $DealerId: ID!
    $dateUpTo: DateTime
    $page: Int
    $count: Int
    $name: String
  ) {
    WarehousesGetter {
      getValues(
        DealerId: $DealerId
        dateUpTo: $dateUpTo
        page: $page
        count: $count
        name: $name
      ) {
        items {
          ... on WarehousesOneValuesItem {
            ...fragmentValuesWarehouses
          }
        }
        total
      }
    }
  }
  ${FragmentValuesWarehousesFragmentDoc}
`;

/**
 * __useGetValuesWarehousesQuery__
 *
 * To run a query within a React component, call `useGetValuesWarehousesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValuesWarehousesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValuesWarehousesQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      dateUpTo: // value for 'dateUpTo'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetValuesWarehousesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetValuesWarehousesQuery,
    GetValuesWarehousesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetValuesWarehousesQuery,
    GetValuesWarehousesQueryVariables
  >(GetValuesWarehousesDocument, options);
}
export function useGetValuesWarehousesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetValuesWarehousesQuery,
    GetValuesWarehousesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetValuesWarehousesQuery,
    GetValuesWarehousesQueryVariables
  >(GetValuesWarehousesDocument, options);
}
export type GetValuesWarehousesQueryHookResult = ReturnType<
  typeof useGetValuesWarehousesQuery
>;
export type GetValuesWarehousesLazyQueryHookResult = ReturnType<
  typeof useGetValuesWarehousesLazyQuery
>;
export type GetValuesWarehousesQueryResult = Apollo.QueryResult<
  GetValuesWarehousesQuery,
  GetValuesWarehousesQueryVariables
>;
export const GetWorkSpaceDealershipDocument = gql`
  query GetWorkSpaceDealership($DealerId: ID!) {
    WorkSpaceGetter {
      getDealerShip(DealerId: $DealerId) {
        dealer {
          ... on Dealer {
            ...fragmentDealerShip
          }
        }
      }
    }
  }
  ${FragmentDealerShipFragmentDoc}
`;

/**
 * __useGetWorkSpaceDealershipQuery__
 *
 * To run a query within a React component, call `useGetWorkSpaceDealershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkSpaceDealershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkSpaceDealershipQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *   },
 * });
 */
export function useGetWorkSpaceDealershipQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkSpaceDealershipQuery,
    GetWorkSpaceDealershipQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkSpaceDealershipQuery,
    GetWorkSpaceDealershipQueryVariables
  >(GetWorkSpaceDealershipDocument, options);
}
export function useGetWorkSpaceDealershipLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkSpaceDealershipQuery,
    GetWorkSpaceDealershipQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkSpaceDealershipQuery,
    GetWorkSpaceDealershipQueryVariables
  >(GetWorkSpaceDealershipDocument, options);
}
export type GetWorkSpaceDealershipQueryHookResult = ReturnType<
  typeof useGetWorkSpaceDealershipQuery
>;
export type GetWorkSpaceDealershipLazyQueryHookResult = ReturnType<
  typeof useGetWorkSpaceDealershipLazyQuery
>;
export type GetWorkSpaceDealershipQueryResult = Apollo.QueryResult<
  GetWorkSpaceDealershipQuery,
  GetWorkSpaceDealershipQueryVariables
>;
export const GetWorkSpaceDealershipManagerDocument = gql`
  query GetWorkSpaceDealershipManager($DealerId: ID!) {
    WorkSpaceGetter {
      getDealerShip(DealerId: $DealerId) {
        dealer {
          ... on Dealer {
            ...fragmentDealerShipManager
          }
        }
      }
    }
  }
  ${FragmentDealerShipManagerFragmentDoc}
`;

/**
 * __useGetWorkSpaceDealershipManagerQuery__
 *
 * To run a query within a React component, call `useGetWorkSpaceDealershipManagerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkSpaceDealershipManagerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkSpaceDealershipManagerQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *   },
 * });
 */
export function useGetWorkSpaceDealershipManagerQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkSpaceDealershipManagerQuery,
    GetWorkSpaceDealershipManagerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkSpaceDealershipManagerQuery,
    GetWorkSpaceDealershipManagerQueryVariables
  >(GetWorkSpaceDealershipManagerDocument, options);
}
export function useGetWorkSpaceDealershipManagerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkSpaceDealershipManagerQuery,
    GetWorkSpaceDealershipManagerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkSpaceDealershipManagerQuery,
    GetWorkSpaceDealershipManagerQueryVariables
  >(GetWorkSpaceDealershipManagerDocument, options);
}
export type GetWorkSpaceDealershipManagerQueryHookResult = ReturnType<
  typeof useGetWorkSpaceDealershipManagerQuery
>;
export type GetWorkSpaceDealershipManagerLazyQueryHookResult = ReturnType<
  typeof useGetWorkSpaceDealershipManagerLazyQuery
>;
export type GetWorkSpaceDealershipManagerQueryResult = Apollo.QueryResult<
  GetWorkSpaceDealershipManagerQuery,
  GetWorkSpaceDealershipManagerQueryVariables
>;
export const GetWorkSpaceDealerQDocument = gql`
  query GetWorkSpaceDealerQ($DealerId: ID!, $date: DateTime) {
    WorkSpaceGetter {
      getQ(DealerId: $DealerId, date: $date) {
        Indicator {
          ...fragmentIndicatorForRating
        }
        IndicatorGroup {
          ...fragmentIndicatorForRating
        }
      }
    }
  }
  ${FragmentIndicatorForRatingFragmentDoc}
`;

/**
 * __useGetWorkSpaceDealerQQuery__
 *
 * To run a query within a React component, call `useGetWorkSpaceDealerQQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkSpaceDealerQQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkSpaceDealerQQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetWorkSpaceDealerQQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkSpaceDealerQQuery,
    GetWorkSpaceDealerQQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkSpaceDealerQQuery,
    GetWorkSpaceDealerQQueryVariables
  >(GetWorkSpaceDealerQDocument, options);
}
export function useGetWorkSpaceDealerQLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkSpaceDealerQQuery,
    GetWorkSpaceDealerQQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkSpaceDealerQQuery,
    GetWorkSpaceDealerQQueryVariables
  >(GetWorkSpaceDealerQDocument, options);
}
export type GetWorkSpaceDealerQQueryHookResult = ReturnType<
  typeof useGetWorkSpaceDealerQQuery
>;
export type GetWorkSpaceDealerQLazyQueryHookResult = ReturnType<
  typeof useGetWorkSpaceDealerQLazyQuery
>;
export type GetWorkSpaceDealerQQueryResult = Apollo.QueryResult<
  GetWorkSpaceDealerQQuery,
  GetWorkSpaceDealerQQueryVariables
>;
export const GetWorkSpaceRnBankRatingDocument = gql`
  query GetWorkSpaceRnBankRating($DealerId: ID!) {
    WorkSpaceGetter {
      getRnBankRating(DealerId: $DealerId) {
        ... on IndicatorValue {
          ...fragmentRnBankRating
        }
      }
    }
  }
  ${FragmentRnBankRatingFragmentDoc}
`;

/**
 * __useGetWorkSpaceRnBankRatingQuery__
 *
 * To run a query within a React component, call `useGetWorkSpaceRnBankRatingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkSpaceRnBankRatingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkSpaceRnBankRatingQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *   },
 * });
 */
export function useGetWorkSpaceRnBankRatingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkSpaceRnBankRatingQuery,
    GetWorkSpaceRnBankRatingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkSpaceRnBankRatingQuery,
    GetWorkSpaceRnBankRatingQueryVariables
  >(GetWorkSpaceRnBankRatingDocument, options);
}
export function useGetWorkSpaceRnBankRatingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkSpaceRnBankRatingQuery,
    GetWorkSpaceRnBankRatingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkSpaceRnBankRatingQuery,
    GetWorkSpaceRnBankRatingQueryVariables
  >(GetWorkSpaceRnBankRatingDocument, options);
}
export type GetWorkSpaceRnBankRatingQueryHookResult = ReturnType<
  typeof useGetWorkSpaceRnBankRatingQuery
>;
export type GetWorkSpaceRnBankRatingLazyQueryHookResult = ReturnType<
  typeof useGetWorkSpaceRnBankRatingLazyQuery
>;
export type GetWorkSpaceRnBankRatingQueryResult = Apollo.QueryResult<
  GetWorkSpaceRnBankRatingQuery,
  GetWorkSpaceRnBankRatingQueryVariables
>;
export const GetWorkSpaceNewVehicleDocument = gql`
  query GetWorkSpaceNewVehicle($DealerId: ID!) {
    WorkSpaceGetter {
      getNewVehicle(DealerId: $DealerId) {
        i101 {
          ... on IndicatorValue {
            ...fragmentNewVehicle
          }
        }
        i103 {
          ... on IndicatorValue {
            ...fragmentNewVehicle
          }
        }
        i104 {
          ... on IndicatorValue {
            ...fragmentNewVehicle
          }
        }
        i105 {
          ... on IndicatorValue {
            ...fragmentNewVehicle
          }
        }
        i106 {
          ... on IndicatorValue {
            ...fragmentNewVehicle
          }
        }
      }
    }
  }
  ${FragmentNewVehicleFragmentDoc}
`;

/**
 * __useGetWorkSpaceNewVehicleQuery__
 *
 * To run a query within a React component, call `useGetWorkSpaceNewVehicleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkSpaceNewVehicleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkSpaceNewVehicleQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *   },
 * });
 */
export function useGetWorkSpaceNewVehicleQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkSpaceNewVehicleQuery,
    GetWorkSpaceNewVehicleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkSpaceNewVehicleQuery,
    GetWorkSpaceNewVehicleQueryVariables
  >(GetWorkSpaceNewVehicleDocument, options);
}
export function useGetWorkSpaceNewVehicleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkSpaceNewVehicleQuery,
    GetWorkSpaceNewVehicleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkSpaceNewVehicleQuery,
    GetWorkSpaceNewVehicleQueryVariables
  >(GetWorkSpaceNewVehicleDocument, options);
}
export type GetWorkSpaceNewVehicleQueryHookResult = ReturnType<
  typeof useGetWorkSpaceNewVehicleQuery
>;
export type GetWorkSpaceNewVehicleLazyQueryHookResult = ReturnType<
  typeof useGetWorkSpaceNewVehicleLazyQuery
>;
export type GetWorkSpaceNewVehicleQueryResult = Apollo.QueryResult<
  GetWorkSpaceNewVehicleQuery,
  GetWorkSpaceNewVehicleQueryVariables
>;
export const GetWorkSpaceAfterSalesDocument = gql`
  query GetWorkSpaceAfterSales($DealerId: ID!) {
    WorkSpaceGetter {
      getAfterSales(DealerId: $DealerId) {
        i300 {
          ... on IndicatorValue {
            ...fragmentAfterSales
          }
        }
        i301 {
          ... on IndicatorValue {
            ...fragmentAfterSales
          }
        }
        i302 {
          ... on IndicatorValue {
            ...fragmentAfterSales
          }
        }
        i303 {
          ... on IndicatorValue {
            ...fragmentAfterSales
          }
        }
        i400 {
          ... on IndicatorValue {
            ...fragmentAfterSales
          }
        }
        i401 {
          ... on IndicatorValue {
            ...fragmentAfterSales
          }
        }
        i502 {
          ... on IndicatorValue {
            ...fragmentAfterSales
          }
        }
      }
    }
  }
  ${FragmentAfterSalesFragmentDoc}
`;

/**
 * __useGetWorkSpaceAfterSalesQuery__
 *
 * To run a query within a React component, call `useGetWorkSpaceAfterSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkSpaceAfterSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkSpaceAfterSalesQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *   },
 * });
 */
export function useGetWorkSpaceAfterSalesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkSpaceAfterSalesQuery,
    GetWorkSpaceAfterSalesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkSpaceAfterSalesQuery,
    GetWorkSpaceAfterSalesQueryVariables
  >(GetWorkSpaceAfterSalesDocument, options);
}
export function useGetWorkSpaceAfterSalesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkSpaceAfterSalesQuery,
    GetWorkSpaceAfterSalesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkSpaceAfterSalesQuery,
    GetWorkSpaceAfterSalesQueryVariables
  >(GetWorkSpaceAfterSalesDocument, options);
}
export type GetWorkSpaceAfterSalesQueryHookResult = ReturnType<
  typeof useGetWorkSpaceAfterSalesQuery
>;
export type GetWorkSpaceAfterSalesLazyQueryHookResult = ReturnType<
  typeof useGetWorkSpaceAfterSalesLazyQuery
>;
export type GetWorkSpaceAfterSalesQueryResult = Apollo.QueryResult<
  GetWorkSpaceAfterSalesQuery,
  GetWorkSpaceAfterSalesQueryVariables
>;
export const GetWorkSpaceQualityDocument = gql`
  query GetWorkSpaceQuality($DealerId: ID!) {
    WorkSpaceGetter {
      getQuality(DealerId: $DealerId) {
        ... on Quality {
          ...fragmentWorkSpaceQuality
        }
      }
    }
  }
  ${FragmentWorkSpaceQualityFragmentDoc}
`;

/**
 * __useGetWorkSpaceQualityQuery__
 *
 * To run a query within a React component, call `useGetWorkSpaceQualityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkSpaceQualityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkSpaceQualityQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *   },
 * });
 */
export function useGetWorkSpaceQualityQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkSpaceQualityQuery,
    GetWorkSpaceQualityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkSpaceQualityQuery,
    GetWorkSpaceQualityQueryVariables
  >(GetWorkSpaceQualityDocument, options);
}
export function useGetWorkSpaceQualityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkSpaceQualityQuery,
    GetWorkSpaceQualityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkSpaceQualityQuery,
    GetWorkSpaceQualityQueryVariables
  >(GetWorkSpaceQualityDocument, options);
}
export type GetWorkSpaceQualityQueryHookResult = ReturnType<
  typeof useGetWorkSpaceQualityQuery
>;
export type GetWorkSpaceQualityLazyQueryHookResult = ReturnType<
  typeof useGetWorkSpaceQualityLazyQuery
>;
export type GetWorkSpaceQualityQueryResult = Apollo.QueryResult<
  GetWorkSpaceQualityQuery,
  GetWorkSpaceQualityQueryVariables
>;
export const GetWorkSpaceProfitabilityDocument = gql`
  query GetWorkSpaceProfitability($DealerId: ID!) {
    WorkSpaceGetter {
      getProfitability(DealerId: $DealerId) {
        i600 {
          ... on IndicatorValue {
            ...fragmentProfitability
          }
        }
        i601 {
          ... on IndicatorValue {
            ...fragmentProfitability
          }
        }
        i602 {
          ... on IndicatorValue {
            ...fragmentProfitability
          }
        }
        i603 {
          ... on IndicatorValue {
            ...fragmentProfitability
          }
        }
        i604 {
          ... on IndicatorValue {
            ...fragmentProfitability
          }
        }
        i605 {
          ... on IndicatorValue {
            ...fragmentProfitability
          }
        }
      }
    }
  }
  ${FragmentProfitabilityFragmentDoc}
`;

/**
 * __useGetWorkSpaceProfitabilityQuery__
 *
 * To run a query within a React component, call `useGetWorkSpaceProfitabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkSpaceProfitabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkSpaceProfitabilityQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *   },
 * });
 */
export function useGetWorkSpaceProfitabilityQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkSpaceProfitabilityQuery,
    GetWorkSpaceProfitabilityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkSpaceProfitabilityQuery,
    GetWorkSpaceProfitabilityQueryVariables
  >(GetWorkSpaceProfitabilityDocument, options);
}
export function useGetWorkSpaceProfitabilityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkSpaceProfitabilityQuery,
    GetWorkSpaceProfitabilityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkSpaceProfitabilityQuery,
    GetWorkSpaceProfitabilityQueryVariables
  >(GetWorkSpaceProfitabilityDocument, options);
}
export type GetWorkSpaceProfitabilityQueryHookResult = ReturnType<
  typeof useGetWorkSpaceProfitabilityQuery
>;
export type GetWorkSpaceProfitabilityLazyQueryHookResult = ReturnType<
  typeof useGetWorkSpaceProfitabilityLazyQuery
>;
export type GetWorkSpaceProfitabilityQueryResult = Apollo.QueryResult<
  GetWorkSpaceProfitabilityQuery,
  GetWorkSpaceProfitabilityQueryVariables
>;
export const GetSalesUsedCarDocument = gql`
  query GetSalesUsedCar($dealerId: ID!) {
    WorkSpaceGetter {
      getSalesUsedCar(DealerId: $dealerId) {
        doubleValue
        avgSales
        createdAt
        updatedAt
      }
    }
  }
`;

/**
 * __useGetSalesUsedCarQuery__
 *
 * To run a query within a React component, call `useGetSalesUsedCarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesUsedCarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesUsedCarQuery({
 *   variables: {
 *      dealerId: // value for 'dealerId'
 *   },
 * });
 */
export function useGetSalesUsedCarQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSalesUsedCarQuery,
    GetSalesUsedCarQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSalesUsedCarQuery, GetSalesUsedCarQueryVariables>(
    GetSalesUsedCarDocument,
    options,
  );
}
export function useGetSalesUsedCarLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSalesUsedCarQuery,
    GetSalesUsedCarQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSalesUsedCarQuery,
    GetSalesUsedCarQueryVariables
  >(GetSalesUsedCarDocument, options);
}
export type GetSalesUsedCarQueryHookResult = ReturnType<
  typeof useGetSalesUsedCarQuery
>;
export type GetSalesUsedCarLazyQueryHookResult = ReturnType<
  typeof useGetSalesUsedCarLazyQuery
>;
export type GetSalesUsedCarQueryResult = Apollo.QueryResult<
  GetSalesUsedCarQuery,
  GetSalesUsedCarQueryVariables
>;
export const GetAllZdUsuoDocument = gql`
  query GetAllZdUsuo($page: Int = 0, $count: Int = 10, $name: String) {
    ZdCommonGetter {
      getZdGlobalInfoForDealers(count: $count, page: $page, name: $name) {
        items {
          ... on ZdGlobalInfoForDealer {
            ...fragmentZdGlobalInfoForDealer
          }
        }
        total
      }
    }
  }
  ${FragmentZdGlobalInfoForDealerFragmentDoc}
`;

/**
 * __useGetAllZdUsuoQuery__
 *
 * To run a query within a React component, call `useGetAllZdUsuoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllZdUsuoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllZdUsuoQuery({
 *   variables: {
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetAllZdUsuoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAllZdUsuoQuery,
    GetAllZdUsuoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAllZdUsuoQuery, GetAllZdUsuoQueryVariables>(
    GetAllZdUsuoDocument,
    options,
  );
}
export function useGetAllZdUsuoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllZdUsuoQuery,
    GetAllZdUsuoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAllZdUsuoQuery, GetAllZdUsuoQueryVariables>(
    GetAllZdUsuoDocument,
    options,
  );
}
export type GetAllZdUsuoQueryHookResult = ReturnType<
  typeof useGetAllZdUsuoQuery
>;
export type GetAllZdUsuoLazyQueryHookResult = ReturnType<
  typeof useGetAllZdUsuoLazyQuery
>;
export type GetAllZdUsuoQueryResult = Apollo.QueryResult<
  GetAllZdUsuoQuery,
  GetAllZdUsuoQueryVariables
>;
export const GetAllZdDealerDocument = gql`
  query GetAllZdDealer($DealerId: ID!) {
    ZdCommonGetter {
      getForDealerTablesStatuses(DealerId: $DealerId) {
        tableIndex
        lastChangeByDealer
        lastChangeByDealerChecker
      }
    }
  }
`;

/**
 * __useGetAllZdDealerQuery__
 *
 * To run a query within a React component, call `useGetAllZdDealerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllZdDealerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllZdDealerQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *   },
 * });
 */
export function useGetAllZdDealerQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAllZdDealerQuery,
    GetAllZdDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAllZdDealerQuery, GetAllZdDealerQueryVariables>(
    GetAllZdDealerDocument,
    options,
  );
}
export function useGetAllZdDealerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllZdDealerQuery,
    GetAllZdDealerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAllZdDealerQuery, GetAllZdDealerQueryVariables>(
    GetAllZdDealerDocument,
    options,
  );
}
export type GetAllZdDealerQueryHookResult = ReturnType<
  typeof useGetAllZdDealerQuery
>;
export type GetAllZdDealerLazyQueryHookResult = ReturnType<
  typeof useGetAllZdDealerLazyQuery
>;
export type GetAllZdDealerQueryResult = Apollo.QueryResult<
  GetAllZdDealerQuery,
  GetAllZdDealerQueryVariables
>;
export const GetZdDealerOneDocument = gql`
  query GetZdDealerOne($DealerId: ID!) {
    ZdCommonGetter {
      getZdGlobalInfoForDealer(DealerId: $DealerId) {
        ... on ZdGlobalInformationForDealerResponse {
          ...fragmentZdGlobalInfoForDealerOne
        }
      }
    }
  }
  ${FragmentZdGlobalInfoForDealerOneFragmentDoc}
`;

/**
 * __useGetZdDealerOneQuery__
 *
 * To run a query within a React component, call `useGetZdDealerOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZdDealerOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZdDealerOneQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *   },
 * });
 */
export function useGetZdDealerOneQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetZdDealerOneQuery,
    GetZdDealerOneQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetZdDealerOneQuery, GetZdDealerOneQueryVariables>(
    GetZdDealerOneDocument,
    options,
  );
}
export function useGetZdDealerOneLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetZdDealerOneQuery,
    GetZdDealerOneQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetZdDealerOneQuery, GetZdDealerOneQueryVariables>(
    GetZdDealerOneDocument,
    options,
  );
}
export type GetZdDealerOneQueryHookResult = ReturnType<
  typeof useGetZdDealerOneQuery
>;
export type GetZdDealerOneLazyQueryHookResult = ReturnType<
  typeof useGetZdDealerOneLazyQuery
>;
export type GetZdDealerOneQueryResult = Apollo.QueryResult<
  GetZdDealerOneQuery,
  GetZdDealerOneQueryVariables
>;
export const GetReportServiceDocument = gql`
  query GetReportService(
    $UUIDs: [String]
    $DealerIds: [ID]
    $Name: String
    $Type: ReportType!
    $lang: LangType!
    $FO: String
    $City: String
    $Russia: Boolean
  ) {
    ZdReportsGetter {
      ServiceById(
        UUIDs: $UUIDs
        DealerIds: $DealerIds
        Name: $Name
        Type: $Type
        lang: $lang
        City: $City
        FO: $FO
        Russia: $Russia
      ) {
        ... on ReportFile {
          fileHash
        }
      }
    }
  }
`;

/**
 * __useGetReportServiceQuery__
 *
 * To run a query within a React component, call `useGetReportServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportServiceQuery({
 *   variables: {
 *      UUIDs: // value for 'UUIDs'
 *      DealerIds: // value for 'DealerIds'
 *      Name: // value for 'Name'
 *      Type: // value for 'Type'
 *      lang: // value for 'lang'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Russia: // value for 'Russia'
 *   },
 * });
 */
export function useGetReportServiceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportServiceQuery,
    GetReportServiceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetReportServiceQuery, GetReportServiceQueryVariables>(
    GetReportServiceDocument,
    options,
  );
}
export function useGetReportServiceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportServiceQuery,
    GetReportServiceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportServiceQuery,
    GetReportServiceQueryVariables
  >(GetReportServiceDocument, options);
}
export type GetReportServiceQueryHookResult = ReturnType<
  typeof useGetReportServiceQuery
>;
export type GetReportServiceLazyQueryHookResult = ReturnType<
  typeof useGetReportServiceLazyQuery
>;
export type GetReportServiceQueryResult = Apollo.QueryResult<
  GetReportServiceQuery,
  GetReportServiceQueryVariables
>;
export const GetReportTradePremisesByIdDocument = gql`
  query GetReportTradePremisesById(
    $UUIDs: [String]
    $DealerIds: [ID]
    $Name: String
    $Type: ReportType!
    $lang: LangType!
    $FO: String
    $City: String
    $Russia: Boolean
  ) {
    ZdReportsGetter {
      TradePremisesById(
        UUIDs: $UUIDs
        DealerIds: $DealerIds
        Name: $Name
        Type: $Type
        lang: $lang
        City: $City
        FO: $FO
        Russia: $Russia
      ) {
        ... on ReportFile {
          fileHash
        }
      }
    }
  }
`;

/**
 * __useGetReportTradePremisesByIdQuery__
 *
 * To run a query within a React component, call `useGetReportTradePremisesByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportTradePremisesByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportTradePremisesByIdQuery({
 *   variables: {
 *      UUIDs: // value for 'UUIDs'
 *      DealerIds: // value for 'DealerIds'
 *      Name: // value for 'Name'
 *      Type: // value for 'Type'
 *      lang: // value for 'lang'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Russia: // value for 'Russia'
 *   },
 * });
 */
export function useGetReportTradePremisesByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportTradePremisesByIdQuery,
    GetReportTradePremisesByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportTradePremisesByIdQuery,
    GetReportTradePremisesByIdQueryVariables
  >(GetReportTradePremisesByIdDocument, options);
}
export function useGetReportTradePremisesByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportTradePremisesByIdQuery,
    GetReportTradePremisesByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportTradePremisesByIdQuery,
    GetReportTradePremisesByIdQueryVariables
  >(GetReportTradePremisesByIdDocument, options);
}
export type GetReportTradePremisesByIdQueryHookResult = ReturnType<
  typeof useGetReportTradePremisesByIdQuery
>;
export type GetReportTradePremisesByIdLazyQueryHookResult = ReturnType<
  typeof useGetReportTradePremisesByIdLazyQuery
>;
export type GetReportTradePremisesByIdQueryResult = Apollo.QueryResult<
  GetReportTradePremisesByIdQuery,
  GetReportTradePremisesByIdQueryVariables
>;
export const GetReportPlaceDocument = gql`
  query GetReportPlace(
    $UUIDs: [String]
    $DealerIds: [ID]
    $Name: String
    $Type: ReportType!
    $lang: LangType!
    $FO: String
    $City: String
    $Russia: Boolean
  ) {
    ZdReportsGetter {
      PlaceById(
        UUIDs: $UUIDs
        DealerIds: $DealerIds
        Name: $Name
        Type: $Type
        lang: $lang
        City: $City
        FO: $FO
        Russia: $Russia
      ) {
        ... on ReportFile {
          fileHash
        }
      }
    }
  }
`;

/**
 * __useGetReportPlaceQuery__
 *
 * To run a query within a React component, call `useGetReportPlaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportPlaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportPlaceQuery({
 *   variables: {
 *      UUIDs: // value for 'UUIDs'
 *      DealerIds: // value for 'DealerIds'
 *      Name: // value for 'Name'
 *      Type: // value for 'Type'
 *      lang: // value for 'lang'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Russia: // value for 'Russia'
 *   },
 * });
 */
export function useGetReportPlaceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportPlaceQuery,
    GetReportPlaceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetReportPlaceQuery, GetReportPlaceQueryVariables>(
    GetReportPlaceDocument,
    options,
  );
}
export function useGetReportPlaceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportPlaceQuery,
    GetReportPlaceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetReportPlaceQuery, GetReportPlaceQueryVariables>(
    GetReportPlaceDocument,
    options,
  );
}
export type GetReportPlaceQueryHookResult = ReturnType<
  typeof useGetReportPlaceQuery
>;
export type GetReportPlaceLazyQueryHookResult = ReturnType<
  typeof useGetReportPlaceLazyQuery
>;
export type GetReportPlaceQueryResult = Apollo.QueryResult<
  GetReportPlaceQuery,
  GetReportPlaceQueryVariables
>;
export const GetReportPlaceByLocationDocument = gql`
  query GetReportPlaceByLocation(
    $FO: String
    $City: String
    $Russia: Boolean
    $Type: ReportType!
    $lang: LangType!
  ) {
    ZdReportsGetter {
      PlaceByLocation(
        City: $City
        FO: $FO
        Russia: $Russia
        Type: $Type
        lang: $lang
      ) {
        ... on ReportFile {
          fileHash
        }
      }
    }
  }
`;

/**
 * __useGetReportPlaceByLocationQuery__
 *
 * To run a query within a React component, call `useGetReportPlaceByLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportPlaceByLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportPlaceByLocationQuery({
 *   variables: {
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Russia: // value for 'Russia'
 *      Type: // value for 'Type'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useGetReportPlaceByLocationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportPlaceByLocationQuery,
    GetReportPlaceByLocationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportPlaceByLocationQuery,
    GetReportPlaceByLocationQueryVariables
  >(GetReportPlaceByLocationDocument, options);
}
export function useGetReportPlaceByLocationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportPlaceByLocationQuery,
    GetReportPlaceByLocationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportPlaceByLocationQuery,
    GetReportPlaceByLocationQueryVariables
  >(GetReportPlaceByLocationDocument, options);
}
export type GetReportPlaceByLocationQueryHookResult = ReturnType<
  typeof useGetReportPlaceByLocationQuery
>;
export type GetReportPlaceByLocationLazyQueryHookResult = ReturnType<
  typeof useGetReportPlaceByLocationLazyQuery
>;
export type GetReportPlaceByLocationQueryResult = Apollo.QueryResult<
  GetReportPlaceByLocationQuery,
  GetReportPlaceByLocationQueryVariables
>;
export const GetReportToolsDocument = gql`
  query GetReportTools(
    $UUIDs: [String]
    $groupOne: String
    $groupTwo: String
    $Type: ReportType!
    $lang: LangType!
    $FO: String
    $City: String
    $Russia: Boolean
  ) {
    ZdReportsGetter {
      ToolsById(
        UUIDs: $UUIDs
        groupOne: $groupOne
        groupTwo: $groupTwo
        Type: $Type
        lang: $lang
        City: $City
        FO: $FO
        Russia: $Russia
      ) {
        ... on ReportFile {
          fileHash
        }
      }
    }
  }
`;

/**
 * __useGetReportToolsQuery__
 *
 * To run a query within a React component, call `useGetReportToolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportToolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportToolsQuery({
 *   variables: {
 *      UUIDs: // value for 'UUIDs'
 *      groupOne: // value for 'groupOne'
 *      groupTwo: // value for 'groupTwo'
 *      Type: // value for 'Type'
 *      lang: // value for 'lang'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Russia: // value for 'Russia'
 *   },
 * });
 */
export function useGetReportToolsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportToolsQuery,
    GetReportToolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetReportToolsQuery, GetReportToolsQueryVariables>(
    GetReportToolsDocument,
    options,
  );
}
export function useGetReportToolsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportToolsQuery,
    GetReportToolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetReportToolsQuery, GetReportToolsQueryVariables>(
    GetReportToolsDocument,
    options,
  );
}
export type GetReportToolsQueryHookResult = ReturnType<
  typeof useGetReportToolsQuery
>;
export type GetReportToolsLazyQueryHookResult = ReturnType<
  typeof useGetReportToolsLazyQuery
>;
export type GetReportToolsQueryResult = Apollo.QueryResult<
  GetReportToolsQuery,
  GetReportToolsQueryVariables
>;
export const GetReportPostsByPlaceDocument = gql`
  query GetReportPostsByPlace(
    $UUIDs: [String]
    $DealerIds: [ID]
    $Name: String
    $Type: ReportType!
    $lang: LangType!
    $FO: String
    $City: String
    $Russia: Boolean
  ) {
    ZdReportsGetter {
      PostByPlaceIds(
        UUIDs: $UUIDs
        DealerIds: $DealerIds
        Name: $Name
        Type: $Type
        lang: $lang
        City: $City
        FO: $FO
        Russia: $Russia
      ) {
        ... on ReportFile {
          fileHash
        }
      }
    }
  }
`;

/**
 * __useGetReportPostsByPlaceQuery__
 *
 * To run a query within a React component, call `useGetReportPostsByPlaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportPostsByPlaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportPostsByPlaceQuery({
 *   variables: {
 *      UUIDs: // value for 'UUIDs'
 *      DealerIds: // value for 'DealerIds'
 *      Name: // value for 'Name'
 *      Type: // value for 'Type'
 *      lang: // value for 'lang'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Russia: // value for 'Russia'
 *   },
 * });
 */
export function useGetReportPostsByPlaceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportPostsByPlaceQuery,
    GetReportPostsByPlaceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportPostsByPlaceQuery,
    GetReportPostsByPlaceQueryVariables
  >(GetReportPostsByPlaceDocument, options);
}
export function useGetReportPostsByPlaceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportPostsByPlaceQuery,
    GetReportPostsByPlaceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportPostsByPlaceQuery,
    GetReportPostsByPlaceQueryVariables
  >(GetReportPostsByPlaceDocument, options);
}
export type GetReportPostsByPlaceQueryHookResult = ReturnType<
  typeof useGetReportPostsByPlaceQuery
>;
export type GetReportPostsByPlaceLazyQueryHookResult = ReturnType<
  typeof useGetReportPostsByPlaceLazyQuery
>;
export type GetReportPostsByPlaceQueryResult = Apollo.QueryResult<
  GetReportPostsByPlaceQuery,
  GetReportPostsByPlaceQueryVariables
>;
export const GetReportPostByPostDocument = gql`
  query GetReportPostByPost(
    $UUIDs: [String]
    $DealerIds: [ID]
    $Name: String
    $Type: ReportType!
    $lang: LangType!
    $FO: String
    $City: String
    $Russia: Boolean
  ) {
    ZdReportsGetter {
      Posts(
        UUIDs: $UUIDs
        DealerIds: $DealerIds
        Name: $Name
        Type: $Type
        lang: $lang
        City: $City
        FO: $FO
        Russia: $Russia
      ) {
        ... on ReportFile {
          fileHash
        }
      }
    }
  }
`;

/**
 * __useGetReportPostByPostQuery__
 *
 * To run a query within a React component, call `useGetReportPostByPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportPostByPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportPostByPostQuery({
 *   variables: {
 *      UUIDs: // value for 'UUIDs'
 *      DealerIds: // value for 'DealerIds'
 *      Name: // value for 'Name'
 *      Type: // value for 'Type'
 *      lang: // value for 'lang'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Russia: // value for 'Russia'
 *   },
 * });
 */
export function useGetReportPostByPostQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportPostByPostQuery,
    GetReportPostByPostQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportPostByPostQuery,
    GetReportPostByPostQueryVariables
  >(GetReportPostByPostDocument, options);
}
export function useGetReportPostByPostLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportPostByPostQuery,
    GetReportPostByPostQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportPostByPostQuery,
    GetReportPostByPostQueryVariables
  >(GetReportPostByPostDocument, options);
}
export type GetReportPostByPostQueryHookResult = ReturnType<
  typeof useGetReportPostByPostQuery
>;
export type GetReportPostByPostLazyQueryHookResult = ReturnType<
  typeof useGetReportPostByPostLazyQuery
>;
export type GetReportPostByPostQueryResult = Apollo.QueryResult<
  GetReportPostByPostQuery,
  GetReportPostByPostQueryVariables
>;
export const GetReportWarehouseDocument = gql`
  query GetReportWarehouse(
    $UUIDs: [String]
    $DealerIds: [ID]
    $Name: String
    $Type: ReportType!
    $lang: LangType!
    $FO: String
    $City: String
    $Russia: Boolean
  ) {
    ZdReportsGetter {
      WarehouseById(
        UUIDs: $UUIDs
        DealerIds: $DealerIds
        Name: $Name
        Type: $Type
        lang: $lang
        City: $City
        FO: $FO
        Russia: $Russia
      ) {
        ... on ReportFile {
          fileHash
        }
      }
    }
  }
`;

/**
 * __useGetReportWarehouseQuery__
 *
 * To run a query within a React component, call `useGetReportWarehouseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportWarehouseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportWarehouseQuery({
 *   variables: {
 *      UUIDs: // value for 'UUIDs'
 *      DealerIds: // value for 'DealerIds'
 *      Name: // value for 'Name'
 *      Type: // value for 'Type'
 *      lang: // value for 'lang'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Russia: // value for 'Russia'
 *   },
 * });
 */
export function useGetReportWarehouseQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportWarehouseQuery,
    GetReportWarehouseQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportWarehouseQuery,
    GetReportWarehouseQueryVariables
  >(GetReportWarehouseDocument, options);
}
export function useGetReportWarehouseLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportWarehouseQuery,
    GetReportWarehouseQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportWarehouseQuery,
    GetReportWarehouseQueryVariables
  >(GetReportWarehouseDocument, options);
}
export type GetReportWarehouseQueryHookResult = ReturnType<
  typeof useGetReportWarehouseQuery
>;
export type GetReportWarehouseLazyQueryHookResult = ReturnType<
  typeof useGetReportWarehouseLazyQuery
>;
export type GetReportWarehouseQueryResult = Apollo.QueryResult<
  GetReportWarehouseQuery,
  GetReportWarehouseQueryVariables
>;
export const GetReportRequiredToolsDocument = gql`
  query GetReportRequiredTools(
    $UUIDs: [String]
    $DealerIds: [ID]
    $Name: String
    $Type: ReportType!
    $lang: LangType!
    $FO: String
    $City: String
    $Russia: Boolean
  ) {
    ZdReportsGetter {
      RequiredToolsById(
        UUIDs: $UUIDs
        DealerIds: $DealerIds
        Name: $Name
        Type: $Type
        lang: $lang
        City: $City
        FO: $FO
        Russia: $Russia
      ) {
        ... on ReportFile {
          fileHash
        }
      }
    }
  }
`;

/**
 * __useGetReportRequiredToolsQuery__
 *
 * To run a query within a React component, call `useGetReportRequiredToolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportRequiredToolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportRequiredToolsQuery({
 *   variables: {
 *      UUIDs: // value for 'UUIDs'
 *      DealerIds: // value for 'DealerIds'
 *      Name: // value for 'Name'
 *      Type: // value for 'Type'
 *      lang: // value for 'lang'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Russia: // value for 'Russia'
 *   },
 * });
 */
export function useGetReportRequiredToolsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportRequiredToolsQuery,
    GetReportRequiredToolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportRequiredToolsQuery,
    GetReportRequiredToolsQueryVariables
  >(GetReportRequiredToolsDocument, options);
}
export function useGetReportRequiredToolsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportRequiredToolsQuery,
    GetReportRequiredToolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportRequiredToolsQuery,
    GetReportRequiredToolsQueryVariables
  >(GetReportRequiredToolsDocument, options);
}
export type GetReportRequiredToolsQueryHookResult = ReturnType<
  typeof useGetReportRequiredToolsQuery
>;
export type GetReportRequiredToolsLazyQueryHookResult = ReturnType<
  typeof useGetReportRequiredToolsLazyQuery
>;
export type GetReportRequiredToolsQueryResult = Apollo.QueryResult<
  GetReportRequiredToolsQuery,
  GetReportRequiredToolsQueryVariables
>;
export const GetReportRequiredsToolsDocument = gql`
  query GetReportRequiredsTools(
    $UUIDs: [String]
    $DealerIds: [ID]
    $Name: String
    $Type: ReportType!
    $lang: LangType!
    $FO: String
    $City: String
    $Russia: Boolean
  ) {
    ZdReportsGetter {
      RequiredToolsByIds(
        UUIDs: $UUIDs
        DealerIds: $DealerIds
        Name: $Name
        Type: $Type
        lang: $lang
        City: $City
        FO: $FO
        Russia: $Russia
      ) {
        ... on ReportFile {
          fileHash
        }
      }
    }
  }
`;

/**
 * __useGetReportRequiredsToolsQuery__
 *
 * To run a query within a React component, call `useGetReportRequiredsToolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportRequiredsToolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportRequiredsToolsQuery({
 *   variables: {
 *      UUIDs: // value for 'UUIDs'
 *      DealerIds: // value for 'DealerIds'
 *      Name: // value for 'Name'
 *      Type: // value for 'Type'
 *      lang: // value for 'lang'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Russia: // value for 'Russia'
 *   },
 * });
 */
export function useGetReportRequiredsToolsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportRequiredsToolsQuery,
    GetReportRequiredsToolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportRequiredsToolsQuery,
    GetReportRequiredsToolsQueryVariables
  >(GetReportRequiredsToolsDocument, options);
}
export function useGetReportRequiredsToolsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportRequiredsToolsQuery,
    GetReportRequiredsToolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportRequiredsToolsQuery,
    GetReportRequiredsToolsQueryVariables
  >(GetReportRequiredsToolsDocument, options);
}
export type GetReportRequiredsToolsQueryHookResult = ReturnType<
  typeof useGetReportRequiredsToolsQuery
>;
export type GetReportRequiredsToolsLazyQueryHookResult = ReturnType<
  typeof useGetReportRequiredsToolsLazyQuery
>;
export type GetReportRequiredsToolsQueryResult = Apollo.QueryResult<
  GetReportRequiredsToolsQuery,
  GetReportRequiredsToolsQueryVariables
>;
export const GetReportToolsInsuranceByIdDocument = gql`
  query GetReportToolsInsuranceById(
    $UUIDs: [String]
    $groupOne: String
    $groupTwo: String
    $Type: ReportType!
    $lang: LangType!
    $FO: String
    $City: String
    $Russia: Boolean
  ) {
    ZdReportsGetter {
      ToolsInsuranceById(
        UUIDs: $UUIDs
        groupOne: $groupOne
        groupTwo: $groupTwo
        Type: $Type
        lang: $lang
        City: $City
        FO: $FO
        Russia: $Russia
      ) {
        ... on ReportFile {
          fileHash
        }
      }
    }
  }
`;

/**
 * __useGetReportToolsInsuranceByIdQuery__
 *
 * To run a query within a React component, call `useGetReportToolsInsuranceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportToolsInsuranceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportToolsInsuranceByIdQuery({
 *   variables: {
 *      UUIDs: // value for 'UUIDs'
 *      groupOne: // value for 'groupOne'
 *      groupTwo: // value for 'groupTwo'
 *      Type: // value for 'Type'
 *      lang: // value for 'lang'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Russia: // value for 'Russia'
 *   },
 * });
 */
export function useGetReportToolsInsuranceByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportToolsInsuranceByIdQuery,
    GetReportToolsInsuranceByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportToolsInsuranceByIdQuery,
    GetReportToolsInsuranceByIdQueryVariables
  >(GetReportToolsInsuranceByIdDocument, options);
}
export function useGetReportToolsInsuranceByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportToolsInsuranceByIdQuery,
    GetReportToolsInsuranceByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportToolsInsuranceByIdQuery,
    GetReportToolsInsuranceByIdQueryVariables
  >(GetReportToolsInsuranceByIdDocument, options);
}
export type GetReportToolsInsuranceByIdQueryHookResult = ReturnType<
  typeof useGetReportToolsInsuranceByIdQuery
>;
export type GetReportToolsInsuranceByIdLazyQueryHookResult = ReturnType<
  typeof useGetReportToolsInsuranceByIdLazyQuery
>;
export type GetReportToolsInsuranceByIdQueryResult = Apollo.QueryResult<
  GetReportToolsInsuranceByIdQuery,
  GetReportToolsInsuranceByIdQueryVariables
>;
export const GetReportToolsInsuranceDocument = gql`
  query GetReportToolsInsurance(
    $FO: String
    $City: String
    $Russia: Boolean
    $Type: ReportType!
    $lang: LangType!
  ) {
    ZdReportsGetter {
      ToolsInsuranceByPlace(
        City: $City
        FO: $FO
        Russia: $Russia
        Type: $Type
        lang: $lang
      ) {
        ... on ReportFile {
          fileHash
        }
      }
    }
  }
`;

/**
 * __useGetReportToolsInsuranceQuery__
 *
 * To run a query within a React component, call `useGetReportToolsInsuranceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportToolsInsuranceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportToolsInsuranceQuery({
 *   variables: {
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Russia: // value for 'Russia'
 *      Type: // value for 'Type'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useGetReportToolsInsuranceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportToolsInsuranceQuery,
    GetReportToolsInsuranceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportToolsInsuranceQuery,
    GetReportToolsInsuranceQueryVariables
  >(GetReportToolsInsuranceDocument, options);
}
export function useGetReportToolsInsuranceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportToolsInsuranceQuery,
    GetReportToolsInsuranceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportToolsInsuranceQuery,
    GetReportToolsInsuranceQueryVariables
  >(GetReportToolsInsuranceDocument, options);
}
export type GetReportToolsInsuranceQueryHookResult = ReturnType<
  typeof useGetReportToolsInsuranceQuery
>;
export type GetReportToolsInsuranceLazyQueryHookResult = ReturnType<
  typeof useGetReportToolsInsuranceLazyQuery
>;
export type GetReportToolsInsuranceQueryResult = Apollo.QueryResult<
  GetReportToolsInsuranceQuery,
  GetReportToolsInsuranceQueryVariables
>;
export const GetReportPersonalDocument = gql`
  query GetReportPersonal(
    $UUIDs: [String]
    $DealerIds: [ID]
    $groupOne: String
    $FO: String
    $City: String
    $Russia: Boolean
    $Type: ReportType!
    $lang: LangType!
  ) {
    ZdReportsGetter {
      Personal(
        UUIDs: $UUIDs
        DealerIds: $DealerIds
        groupOne: $groupOne
        City: $City
        FO: $FO
        Russia: $Russia
        Type: $Type
        lang: $lang
      ) {
        ... on ReportFile {
          fileHash
        }
      }
    }
  }
`;

/**
 * __useGetReportPersonalQuery__
 *
 * To run a query within a React component, call `useGetReportPersonalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportPersonalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportPersonalQuery({
 *   variables: {
 *      UUIDs: // value for 'UUIDs'
 *      DealerIds: // value for 'DealerIds'
 *      groupOne: // value for 'groupOne'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Russia: // value for 'Russia'
 *      Type: // value for 'Type'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useGetReportPersonalQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportPersonalQuery,
    GetReportPersonalQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportPersonalQuery,
    GetReportPersonalQueryVariables
  >(GetReportPersonalDocument, options);
}
export function useGetReportPersonalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportPersonalQuery,
    GetReportPersonalQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportPersonalQuery,
    GetReportPersonalQueryVariables
  >(GetReportPersonalDocument, options);
}
export type GetReportPersonalQueryHookResult = ReturnType<
  typeof useGetReportPersonalQuery
>;
export type GetReportPersonalLazyQueryHookResult = ReturnType<
  typeof useGetReportPersonalLazyQuery
>;
export type GetReportPersonalQueryResult = Apollo.QueryResult<
  GetReportPersonalQuery,
  GetReportPersonalQueryVariables
>;
export const GetReportToolsMetrologicalDocument = gql`
  query GetReportToolsMetrological(
    $UUIDs: [String]
    $DealerIds: [ID]
    $Name: String
    $Type: ReportType!
    $lang: LangType!
    $FO: String
    $City: String
    $Russia: Boolean
  ) {
    ZdReportsGetter {
      ToolsMetrologicalById(
        UUIDs: $UUIDs
        DealerIds: $DealerIds
        Name: $Name
        Type: $Type
        lang: $lang
        City: $City
        FO: $FO
        Russia: $Russia
      ) {
        ... on ReportFile {
          fileHash
        }
      }
    }
  }
`;

/**
 * __useGetReportToolsMetrologicalQuery__
 *
 * To run a query within a React component, call `useGetReportToolsMetrologicalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportToolsMetrologicalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportToolsMetrologicalQuery({
 *   variables: {
 *      UUIDs: // value for 'UUIDs'
 *      DealerIds: // value for 'DealerIds'
 *      Name: // value for 'Name'
 *      Type: // value for 'Type'
 *      lang: // value for 'lang'
 *      FO: // value for 'FO'
 *      City: // value for 'City'
 *      Russia: // value for 'Russia'
 *   },
 * });
 */
export function useGetReportToolsMetrologicalQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportToolsMetrologicalQuery,
    GetReportToolsMetrologicalQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportToolsMetrologicalQuery,
    GetReportToolsMetrologicalQueryVariables
  >(GetReportToolsMetrologicalDocument, options);
}
export function useGetReportToolsMetrologicalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportToolsMetrologicalQuery,
    GetReportToolsMetrologicalQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportToolsMetrologicalQuery,
    GetReportToolsMetrologicalQueryVariables
  >(GetReportToolsMetrologicalDocument, options);
}
export type GetReportToolsMetrologicalQueryHookResult = ReturnType<
  typeof useGetReportToolsMetrologicalQuery
>;
export type GetReportToolsMetrologicalLazyQueryHookResult = ReturnType<
  typeof useGetReportToolsMetrologicalLazyQuery
>;
export type GetReportToolsMetrologicalQueryResult = Apollo.QueryResult<
  GetReportToolsMetrologicalQuery,
  GetReportToolsMetrologicalQueryVariables
>;
export const GetReportAllZdDocument = gql`
  query GetReportAllZd($Type: ReportType!) {
    ZdReportsGetter {
      ZdStatus(Type: $Type) {
        ... on ReportFile {
          fileHash
        }
      }
    }
  }
`;

/**
 * __useGetReportAllZdQuery__
 *
 * To run a query within a React component, call `useGetReportAllZdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportAllZdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportAllZdQuery({
 *   variables: {
 *      Type: // value for 'Type'
 *   },
 * });
 */
export function useGetReportAllZdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportAllZdQuery,
    GetReportAllZdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetReportAllZdQuery, GetReportAllZdQueryVariables>(
    GetReportAllZdDocument,
    options,
  );
}
export function useGetReportAllZdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportAllZdQuery,
    GetReportAllZdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetReportAllZdQuery, GetReportAllZdQueryVariables>(
    GetReportAllZdDocument,
    options,
  );
}
export type GetReportAllZdQueryHookResult = ReturnType<
  typeof useGetReportAllZdQuery
>;
export type GetReportAllZdLazyQueryHookResult = ReturnType<
  typeof useGetReportAllZdLazyQuery
>;
export type GetReportAllZdQueryResult = Apollo.QueryResult<
  GetReportAllZdQuery,
  GetReportAllZdQueryVariables
>;
export const GetDealerPlanReportDocument = gql`
  query GetDealerPlanReport($DealerId: ID!) {
    ZdReportsGetter {
      PlanReport(DealerId: $DealerId) {
        ... on ReportFile {
          fileHash
        }
      }
    }
  }
`;

/**
 * __useGetDealerPlanReportQuery__
 *
 * To run a query within a React component, call `useGetDealerPlanReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealerPlanReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealerPlanReportQuery({
 *   variables: {
 *      DealerId: // value for 'DealerId'
 *   },
 * });
 */
export function useGetDealerPlanReportQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDealerPlanReportQuery,
    GetDealerPlanReportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDealerPlanReportQuery,
    GetDealerPlanReportQueryVariables
  >(GetDealerPlanReportDocument, options);
}
export function useGetDealerPlanReportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDealerPlanReportQuery,
    GetDealerPlanReportQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDealerPlanReportQuery,
    GetDealerPlanReportQueryVariables
  >(GetDealerPlanReportDocument, options);
}
export type GetDealerPlanReportQueryHookResult = ReturnType<
  typeof useGetDealerPlanReportQuery
>;
export type GetDealerPlanReportLazyQueryHookResult = ReturnType<
  typeof useGetDealerPlanReportLazyQuery
>;
export type GetDealerPlanReportQueryResult = Apollo.QueryResult<
  GetDealerPlanReportQuery,
  GetDealerPlanReportQueryVariables
>;
export const GetZdDealersActualDocument = gql`
  query GetZdDealersActual {
    ZdReportsGetter {
      ZdDealersActual {
        ... on ReportFile {
          fileHash
        }
      }
    }
  }
`;

/**
 * __useGetZdDealersActualQuery__
 *
 * To run a query within a React component, call `useGetZdDealersActualQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZdDealersActualQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZdDealersActualQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetZdDealersActualQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetZdDealersActualQuery,
    GetZdDealersActualQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetZdDealersActualQuery,
    GetZdDealersActualQueryVariables
  >(GetZdDealersActualDocument, options);
}
export function useGetZdDealersActualLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetZdDealersActualQuery,
    GetZdDealersActualQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetZdDealersActualQuery,
    GetZdDealersActualQueryVariables
  >(GetZdDealersActualDocument, options);
}
export type GetZdDealersActualQueryHookResult = ReturnType<
  typeof useGetZdDealersActualQuery
>;
export type GetZdDealersActualLazyQueryHookResult = ReturnType<
  typeof useGetZdDealersActualLazyQuery
>;
export type GetZdDealersActualQueryResult = Apollo.QueryResult<
  GetZdDealersActualQuery,
  GetZdDealersActualQueryVariables
>;

export interface IntrospectionResultData {
  __schema: {
    types: {
      kind: string;
      name: string;
      possibleTypes: {
        name: string;
      }[];
    }[];
  };
}
const result: IntrospectionResultData = {
  __schema: {
    types: [
      {
        kind: "UNION",
        name: "LogElement",
        possibleTypes: [
          {
            name: "logForDealer",
          },
          {
            name: "logForEditStaffEducationGroup",
          },
          {
            name: "logForImportDealerPhotos",
          },
          {
            name: "logForImportDealerCheckLists",
          },
          {
            name: "logForEditValueStaff",
          },
          {
            name: "logForEditStaff",
          },
          {
            name: "logAddDealerToUser",
          },
          {
            name: "logForEditGRVersion",
          },
          {
            name: "logForEditGRRow",
          },
          {
            name: "logForEditIndicator",
          },
          {
            name: "logForEditQVersion",
          },
          {
            name: "logForEditQRow",
          },
          {
            name: "logForEditUser",
          },
          {
            name: "logForEditFile",
          },
          {
            name: "logForDeleteFile",
          },
          {
            name: "logDefault",
          },
          {
            name: "logForUploadFileToCatalog",
          },
          {
            name: "logForEditEmployee",
          },
          {
            name: "logForEditEmployeePosition",
          },
          {
            name: "logForCreateAnnouncement",
          },
          {
            name: "logForEditAnnouncement",
          },
          {
            name: "logForViolation",
          },
          {
            name: "logForAccountingPeriod",
          },
          {
            name: "logForZdNotes",
          },
          {
            name: "logForZdPersonal",
          },
          {
            name: "logForZdPlacePosts",
          },
          {
            name: "logForZdPlaces",
          },
          {
            name: "logForZdTradePremises",
          },
          {
            name: "logForZdRequiredTools",
          },
          {
            name: "logForZdServiceZs",
          },
          {
            name: "logForZdToolsInsuranceZs",
          },
          {
            name: "logForZdToolsMetrologicalZs",
          },
          {
            name: "logForZdToolsZs",
          },
          {
            name: "logForZdWarehousesZs",
          },
          {
            name: "logForCreatedEducationCatalog",
          },
          {
            name: "logForDeleteEducationCatalog",
          },
          {
            name: "logForCreatedEducationCourse",
          },
          {
            name: "logForEditEducationCourse",
          },
          {
            name: "logForDeleteEducationCourse",
          },
          {
            name: "logForCreatedEducationLevel",
          },
          {
            name: "logForEditEducationLevel",
          },
          {
            name: "logForDeleteEducationLevel",
          },
          {
            name: "logForCreatedEducationGroup",
          },
          {
            name: "logForEditEducationGroup",
          },
          {
            name: "logForDeleteEducationGroup",
          },
          {
            name: "logForCreatedEducationProgram",
          },
          {
            name: "logForDeleteEducationProgram",
          },
          {
            name: "logForEditEducationProgram",
          },
          {
            name: "logForDeletePositionGroupEducationProgram",
          },
          {
            name: "logForAddPositionGroupEducationProgram",
          },
          {
            name: "logForCreatedPosition",
          },
          {
            name: "logForEditPosition",
          },
          {
            name: "logForDeletePosition",
          },
          {
            name: "logForEditPositionDirection",
          },
          {
            name: "logForDeletePositionDirection",
          },
          {
            name: "logForCreatedPositionDirection",
          },
          {
            name: "logForZdDefinitionServices",
          },
          {
            name: "logForZdDefinitionPlaces",
          },
          {
            name: "logForZdDefinitionPlacePosts",
          },
          {
            name: "logForZdDefinitionWarehouses",
          },
          {
            name: "logForZdDefinitionTools",
          },
          {
            name: "logForZdDefinitionRequiredTools",
          },
          {
            name: "logForZdDefinitionPersonal",
          },
          {
            name: "logForZdDefinitionToolsInsurance",
          },
          {
            name: "logForZdDefinitionToolsMetrological",
          },
          {
            name: "logForZdDefinitionNotes",
          },
          {
            name: "logForZdDefinitionTradePremises",
          },
          {
            name: "logForCreateDocument",
          },
          {
            name: "logForEditDocument",
          },
          {
            name: "logForCreateSection",
          },
          {
            name: "logForEditSection",
          },
          {
            name: "logForDeleteSection",
          },
          {
            name: "logForCreateCamera",
          },
          {
            name: "logForEditCamera",
          },
          {
            name: "logForDeleteCamera",
          },
          {
            name: "logForCreateCameraCheck",
          },
          {
            name: "logForEditCameraCheck",
          },
          {
            name: "logForCreateCameraZone",
          },
          {
            name: "logForEditCameraZone",
          },
          {
            name: "logForDeleteCameraZone",
          },
          {
            name: "logForAddIndicatorGroup",
          },
          {
            name: "logForEditIndicatorGroup",
          },
          {
            name: "logForAddIndicatorReport",
          },
          {
            name: "logForChangeIndicatorReport",
          },
          {
            name: "logForAddIndicatorToReport",
          },
          {
            name: "logForDeleteIndicatorToReport",
          },
        ],
      },
    ],
  },
};
export default result;
